
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8tTPf", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $62cc55f3d3d024da$export$ffb0004e005737fa; }, function (v) { return $62cc55f3d3d024da$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $62cc55f3d3d024da$export$34b9dba7ce09269b; }, function (v) { return $62cc55f3d3d024da$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $62cc55f3d3d024da$export$25062201e9e25d76; }, function (v) { return $62cc55f3d3d024da$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $62cc55f3d3d024da$export$ffb0004e005737fa;
var $62cc55f3d3d024da$export$34b9dba7ce09269b;
var $62cc55f3d3d024da$export$25062201e9e25d76;
"use strict";

var $2hDQc = parcelRequire("2hDQc");
var $62cc55f3d3d024da$var$k = Symbol.for("react.element"), $62cc55f3d3d024da$var$l = Symbol.for("react.fragment"), $62cc55f3d3d024da$var$m = Object.prototype.hasOwnProperty, $62cc55f3d3d024da$var$n = $2hDQc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $62cc55f3d3d024da$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $62cc55f3d3d024da$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$62cc55f3d3d024da$var$m.call(a, b) && !$62cc55f3d3d024da$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $62cc55f3d3d024da$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $62cc55f3d3d024da$var$n.current
    };
}
$62cc55f3d3d024da$export$ffb0004e005737fa = $62cc55f3d3d024da$var$l;
$62cc55f3d3d024da$export$34b9dba7ce09269b = $62cc55f3d3d024da$var$q;
$62cc55f3d3d024da$export$25062201e9e25d76 = $62cc55f3d3d024da$var$q;

});
parcelRegister("2hDQc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8dvOe"));

});
parcelRegister("8dvOe", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $5fb83641aa8e7270$export$dca3b0875bd9a954; }, function (v) { return $5fb83641aa8e7270$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5fb83641aa8e7270$export$16fa2f45be04daa8; }, function (v) { return $5fb83641aa8e7270$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5fb83641aa8e7270$export$ffb0004e005737fa; }, function (v) { return $5fb83641aa8e7270$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5fb83641aa8e7270$export$e2c29f18771995cb; }, function (v) { return $5fb83641aa8e7270$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5fb83641aa8e7270$export$221d75b3f55bb0bd; }, function (v) { return $5fb83641aa8e7270$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5fb83641aa8e7270$export$5f8d39834fd61797; }, function (v) { return $5fb83641aa8e7270$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5fb83641aa8e7270$export$74bf444e3cd11ea5; }, function (v) { return $5fb83641aa8e7270$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5fb83641aa8e7270$export$ae55be85d98224ed; }, function (v) { return $5fb83641aa8e7270$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5fb83641aa8e7270$export$e530037191fcd5d7; }, function (v) { return $5fb83641aa8e7270$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5fb83641aa8e7270$export$fd42f52fd3ae1109; }, function (v) { return $5fb83641aa8e7270$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5fb83641aa8e7270$export$c8a8987d4410bf2d; }, function (v) { return $5fb83641aa8e7270$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $5fb83641aa8e7270$export$d38cd72104c1f0e9; }, function (v) { return $5fb83641aa8e7270$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $5fb83641aa8e7270$export$7d1e3a5e95ceca43; }, function (v) { return $5fb83641aa8e7270$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5fb83641aa8e7270$export$257a8862b851cb5b; }, function (v) { return $5fb83641aa8e7270$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5fb83641aa8e7270$export$a8257692ac88316c; }, function (v) { return $5fb83641aa8e7270$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5fb83641aa8e7270$export$488013bae63b21da; }, function (v) { return $5fb83641aa8e7270$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5fb83641aa8e7270$export$7c73462e0d25e514; }, function (v) { return $5fb83641aa8e7270$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5fb83641aa8e7270$export$7568632d0d33d16d; }, function (v) { return $5fb83641aa8e7270$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $5fb83641aa8e7270$export$88948ce120ea2619; }, function (v) { return $5fb83641aa8e7270$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5fb83641aa8e7270$export$35808ee640e87ca7; }, function (v) { return $5fb83641aa8e7270$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5fb83641aa8e7270$export$fae74005e78b1a27; }, function (v) { return $5fb83641aa8e7270$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5fb83641aa8e7270$export$dc8fbce3eb94dc1e; }, function (v) { return $5fb83641aa8e7270$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5fb83641aa8e7270$export$6a7bc4e911dc01cf; }, function (v) { return $5fb83641aa8e7270$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5fb83641aa8e7270$export$6d9c69b0de29b591; }, function (v) { return $5fb83641aa8e7270$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $5fb83641aa8e7270$export$f680877a34711e37; }, function (v) { return $5fb83641aa8e7270$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5fb83641aa8e7270$export$d5a552a76deda3c2; }, function (v) { return $5fb83641aa8e7270$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5fb83641aa8e7270$export$aaabe4eda9ed9969; }, function (v) { return $5fb83641aa8e7270$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5fb83641aa8e7270$export$e5c5a5f917a5871c; }, function (v) { return $5fb83641aa8e7270$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5fb83641aa8e7270$export$1538c33de8887b59; }, function (v) { return $5fb83641aa8e7270$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $5fb83641aa8e7270$export$13e3392192263954; }, function (v) { return $5fb83641aa8e7270$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5fb83641aa8e7270$export$b8f5890fc79d6aca; }, function (v) { return $5fb83641aa8e7270$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5fb83641aa8e7270$export$60241385465d0a34; }, function (v) { return $5fb83641aa8e7270$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5fb83641aa8e7270$export$306c0aa65ff9ec16; }, function (v) { return $5fb83641aa8e7270$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5fb83641aa8e7270$export$7b286972b8d8ccbf; }, function (v) { return $5fb83641aa8e7270$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5fb83641aa8e7270$export$83d89fbfd8236492; }, function (v) { return $5fb83641aa8e7270$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5fb83641aa8e7270$export$dca3b0875bd9a954;
var $5fb83641aa8e7270$export$16fa2f45be04daa8;
var $5fb83641aa8e7270$export$ffb0004e005737fa;
var $5fb83641aa8e7270$export$e2c29f18771995cb;
var $5fb83641aa8e7270$export$221d75b3f55bb0bd;
var $5fb83641aa8e7270$export$5f8d39834fd61797;
var $5fb83641aa8e7270$export$74bf444e3cd11ea5;
var $5fb83641aa8e7270$export$ae55be85d98224ed;
var $5fb83641aa8e7270$export$e530037191fcd5d7;
var $5fb83641aa8e7270$export$fd42f52fd3ae1109;
var $5fb83641aa8e7270$export$c8a8987d4410bf2d;
var $5fb83641aa8e7270$export$d38cd72104c1f0e9;
var $5fb83641aa8e7270$export$7d1e3a5e95ceca43;
var $5fb83641aa8e7270$export$257a8862b851cb5b;
var $5fb83641aa8e7270$export$a8257692ac88316c;
var $5fb83641aa8e7270$export$488013bae63b21da;
var $5fb83641aa8e7270$export$7c73462e0d25e514;
var $5fb83641aa8e7270$export$7568632d0d33d16d;
var $5fb83641aa8e7270$export$88948ce120ea2619;
var $5fb83641aa8e7270$export$35808ee640e87ca7;
var $5fb83641aa8e7270$export$fae74005e78b1a27;
var $5fb83641aa8e7270$export$dc8fbce3eb94dc1e;
var $5fb83641aa8e7270$export$6a7bc4e911dc01cf;
var $5fb83641aa8e7270$export$6d9c69b0de29b591;
var $5fb83641aa8e7270$export$f680877a34711e37;
var $5fb83641aa8e7270$export$d5a552a76deda3c2;
var $5fb83641aa8e7270$export$aaabe4eda9ed9969;
var $5fb83641aa8e7270$export$e5c5a5f917a5871c;
var $5fb83641aa8e7270$export$1538c33de8887b59;
var $5fb83641aa8e7270$export$13e3392192263954;
var $5fb83641aa8e7270$export$b8f5890fc79d6aca;
var $5fb83641aa8e7270$export$60241385465d0a34;
var $5fb83641aa8e7270$export$306c0aa65ff9ec16;
var $5fb83641aa8e7270$export$7b286972b8d8ccbf;
var $5fb83641aa8e7270$export$83d89fbfd8236492;
"use strict";
var $5fb83641aa8e7270$var$l = Symbol.for("react.element"), $5fb83641aa8e7270$var$n = Symbol.for("react.portal"), $5fb83641aa8e7270$var$p = Symbol.for("react.fragment"), $5fb83641aa8e7270$var$q = Symbol.for("react.strict_mode"), $5fb83641aa8e7270$var$r = Symbol.for("react.profiler"), $5fb83641aa8e7270$var$t = Symbol.for("react.provider"), $5fb83641aa8e7270$var$u = Symbol.for("react.context"), $5fb83641aa8e7270$var$v = Symbol.for("react.forward_ref"), $5fb83641aa8e7270$var$w = Symbol.for("react.suspense"), $5fb83641aa8e7270$var$x = Symbol.for("react.memo"), $5fb83641aa8e7270$var$y = Symbol.for("react.lazy"), $5fb83641aa8e7270$var$z = Symbol.iterator;
function $5fb83641aa8e7270$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5fb83641aa8e7270$var$z && a[$5fb83641aa8e7270$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5fb83641aa8e7270$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5fb83641aa8e7270$var$C = Object.assign, $5fb83641aa8e7270$var$D = {};
function $5fb83641aa8e7270$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5fb83641aa8e7270$var$D;
    this.updater = e || $5fb83641aa8e7270$var$B;
}
$5fb83641aa8e7270$var$E.prototype.isReactComponent = {};
$5fb83641aa8e7270$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5fb83641aa8e7270$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5fb83641aa8e7270$var$F() {}
$5fb83641aa8e7270$var$F.prototype = $5fb83641aa8e7270$var$E.prototype;
function $5fb83641aa8e7270$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5fb83641aa8e7270$var$D;
    this.updater = e || $5fb83641aa8e7270$var$B;
}
var $5fb83641aa8e7270$var$H = $5fb83641aa8e7270$var$G.prototype = new $5fb83641aa8e7270$var$F;
$5fb83641aa8e7270$var$H.constructor = $5fb83641aa8e7270$var$G;
$5fb83641aa8e7270$var$C($5fb83641aa8e7270$var$H, $5fb83641aa8e7270$var$E.prototype);
$5fb83641aa8e7270$var$H.isPureReactComponent = !0;
var $5fb83641aa8e7270$var$I = Array.isArray, $5fb83641aa8e7270$var$J = Object.prototype.hasOwnProperty, $5fb83641aa8e7270$var$K = {
    current: null
}, $5fb83641aa8e7270$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5fb83641aa8e7270$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5fb83641aa8e7270$var$J.call(b, d) && !$5fb83641aa8e7270$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5fb83641aa8e7270$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5fb83641aa8e7270$var$K.current
    };
}
function $5fb83641aa8e7270$var$N(a, b) {
    return {
        $$typeof: $5fb83641aa8e7270$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5fb83641aa8e7270$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5fb83641aa8e7270$var$l;
}
function $5fb83641aa8e7270$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5fb83641aa8e7270$var$P = /\/+/g;
function $5fb83641aa8e7270$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5fb83641aa8e7270$var$escape("" + a.key) : b.toString(36);
}
function $5fb83641aa8e7270$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5fb83641aa8e7270$var$l:
                case $5fb83641aa8e7270$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5fb83641aa8e7270$var$Q(h, 0) : d, $5fb83641aa8e7270$var$I(c) ? (e = "", null != a && (e = a.replace($5fb83641aa8e7270$var$P, "$&/") + "/"), $5fb83641aa8e7270$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5fb83641aa8e7270$var$O(c) && (c = $5fb83641aa8e7270$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5fb83641aa8e7270$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5fb83641aa8e7270$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5fb83641aa8e7270$var$Q(k, g);
        h += $5fb83641aa8e7270$var$R(k, b, e, f, c);
    }
    else if (f = $5fb83641aa8e7270$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5fb83641aa8e7270$var$Q(k, g++), h += $5fb83641aa8e7270$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5fb83641aa8e7270$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5fb83641aa8e7270$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5fb83641aa8e7270$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5fb83641aa8e7270$var$U = {
    current: null
}, $5fb83641aa8e7270$var$V = {
    transition: null
}, $5fb83641aa8e7270$var$W = {
    ReactCurrentDispatcher: $5fb83641aa8e7270$var$U,
    ReactCurrentBatchConfig: $5fb83641aa8e7270$var$V,
    ReactCurrentOwner: $5fb83641aa8e7270$var$K
};
$5fb83641aa8e7270$export$dca3b0875bd9a954 = {
    map: $5fb83641aa8e7270$var$S,
    forEach: function(a, b, e) {
        $5fb83641aa8e7270$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $5fb83641aa8e7270$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5fb83641aa8e7270$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5fb83641aa8e7270$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5fb83641aa8e7270$export$16fa2f45be04daa8 = $5fb83641aa8e7270$var$E;
$5fb83641aa8e7270$export$ffb0004e005737fa = $5fb83641aa8e7270$var$p;
$5fb83641aa8e7270$export$e2c29f18771995cb = $5fb83641aa8e7270$var$r;
$5fb83641aa8e7270$export$221d75b3f55bb0bd = $5fb83641aa8e7270$var$G;
$5fb83641aa8e7270$export$5f8d39834fd61797 = $5fb83641aa8e7270$var$q;
$5fb83641aa8e7270$export$74bf444e3cd11ea5 = $5fb83641aa8e7270$var$w;
$5fb83641aa8e7270$export$ae55be85d98224ed = $5fb83641aa8e7270$var$W;
$5fb83641aa8e7270$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5fb83641aa8e7270$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5fb83641aa8e7270$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5fb83641aa8e7270$var$J.call(b, f) && !$5fb83641aa8e7270$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5fb83641aa8e7270$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5fb83641aa8e7270$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5fb83641aa8e7270$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5fb83641aa8e7270$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5fb83641aa8e7270$export$c8a8987d4410bf2d = $5fb83641aa8e7270$var$M;
$5fb83641aa8e7270$export$d38cd72104c1f0e9 = function(a) {
    var b = $5fb83641aa8e7270$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5fb83641aa8e7270$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5fb83641aa8e7270$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5fb83641aa8e7270$var$v,
        render: a
    };
};
$5fb83641aa8e7270$export$a8257692ac88316c = $5fb83641aa8e7270$var$O;
$5fb83641aa8e7270$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5fb83641aa8e7270$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5fb83641aa8e7270$var$T
    };
};
$5fb83641aa8e7270$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5fb83641aa8e7270$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5fb83641aa8e7270$export$7568632d0d33d16d = function(a) {
    var b = $5fb83641aa8e7270$var$V.transition;
    $5fb83641aa8e7270$var$V.transition = {};
    try {
        a();
    } finally{
        $5fb83641aa8e7270$var$V.transition = b;
    }
};
$5fb83641aa8e7270$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$5fb83641aa8e7270$export$35808ee640e87ca7 = function(a, b) {
    return $5fb83641aa8e7270$var$U.current.useCallback(a, b);
};
$5fb83641aa8e7270$export$fae74005e78b1a27 = function(a) {
    return $5fb83641aa8e7270$var$U.current.useContext(a);
};
$5fb83641aa8e7270$export$dc8fbce3eb94dc1e = function() {};
$5fb83641aa8e7270$export$6a7bc4e911dc01cf = function(a) {
    return $5fb83641aa8e7270$var$U.current.useDeferredValue(a);
};
$5fb83641aa8e7270$export$6d9c69b0de29b591 = function(a, b) {
    return $5fb83641aa8e7270$var$U.current.useEffect(a, b);
};
$5fb83641aa8e7270$export$f680877a34711e37 = function() {
    return $5fb83641aa8e7270$var$U.current.useId();
};
$5fb83641aa8e7270$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5fb83641aa8e7270$var$U.current.useImperativeHandle(a, b, e);
};
$5fb83641aa8e7270$export$aaabe4eda9ed9969 = function(a, b) {
    return $5fb83641aa8e7270$var$U.current.useInsertionEffect(a, b);
};
$5fb83641aa8e7270$export$e5c5a5f917a5871c = function(a, b) {
    return $5fb83641aa8e7270$var$U.current.useLayoutEffect(a, b);
};
$5fb83641aa8e7270$export$1538c33de8887b59 = function(a, b) {
    return $5fb83641aa8e7270$var$U.current.useMemo(a, b);
};
$5fb83641aa8e7270$export$13e3392192263954 = function(a, b, e) {
    return $5fb83641aa8e7270$var$U.current.useReducer(a, b, e);
};
$5fb83641aa8e7270$export$b8f5890fc79d6aca = function(a) {
    return $5fb83641aa8e7270$var$U.current.useRef(a);
};
$5fb83641aa8e7270$export$60241385465d0a34 = function(a) {
    return $5fb83641aa8e7270$var$U.current.useState(a);
};
$5fb83641aa8e7270$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5fb83641aa8e7270$var$U.current.useSyncExternalStore(a, b, e);
};
$5fb83641aa8e7270$export$7b286972b8d8ccbf = function() {
    return $5fb83641aa8e7270$var$U.current.useTransition();
};
$5fb83641aa8e7270$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("16YfO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aeBUn = parcelRequire("aeBUn");
function $0cf5172cc1cce171$var$emptyFunction() {}
function $0cf5172cc1cce171$var$emptyFunctionWithReset() {}
$0cf5172cc1cce171$var$emptyFunctionWithReset.resetWarningCache = $0cf5172cc1cce171$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aeBUn) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $0cf5172cc1cce171$var$emptyFunctionWithReset,
        resetWarningCache: $0cf5172cc1cce171$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aeBUn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $77389e03939e8cd3$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $77389e03939e8cd3$var$ReactPropTypesSecret;

});


parcelRegister("8FL51", function(module, exports) {
"use strict";

var $jy66G = parcelRequire("jy66G");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $6506ac27a174cdb1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $6506ac27a174cdb1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $6506ac27a174cdb1$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $6506ac27a174cdb1$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $6506ac27a174cdb1$var$TYPE_STATICS = {};
$6506ac27a174cdb1$var$TYPE_STATICS[$jy66G.ForwardRef] = $6506ac27a174cdb1$var$FORWARD_REF_STATICS;
$6506ac27a174cdb1$var$TYPE_STATICS[$jy66G.Memo] = $6506ac27a174cdb1$var$MEMO_STATICS;
function $6506ac27a174cdb1$var$getStatics(component) {
    // React v16.11 and below
    if ($jy66G.isMemo(component)) return $6506ac27a174cdb1$var$MEMO_STATICS;
     // React v16.12 and above
    return $6506ac27a174cdb1$var$TYPE_STATICS[component["$$typeof"]] || $6506ac27a174cdb1$var$REACT_STATICS;
}
var $6506ac27a174cdb1$var$defineProperty = Object.defineProperty;
var $6506ac27a174cdb1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $6506ac27a174cdb1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6506ac27a174cdb1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6506ac27a174cdb1$var$getPrototypeOf = Object.getPrototypeOf;
var $6506ac27a174cdb1$var$objectPrototype = Object.prototype;
function $6506ac27a174cdb1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($6506ac27a174cdb1$var$objectPrototype) {
            var inheritedComponent = $6506ac27a174cdb1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6506ac27a174cdb1$var$objectPrototype) $6506ac27a174cdb1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $6506ac27a174cdb1$var$getOwnPropertyNames(sourceComponent);
        if ($6506ac27a174cdb1$var$getOwnPropertySymbols) keys = keys.concat($6506ac27a174cdb1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $6506ac27a174cdb1$var$getStatics(targetComponent);
        var sourceStatics = $6506ac27a174cdb1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$6506ac27a174cdb1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $6506ac27a174cdb1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $6506ac27a174cdb1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $6506ac27a174cdb1$var$hoistNonReactStatics;

});
parcelRegister("jy66G", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a5UKC"));

});
parcelRegister("a5UKC", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $759664958dfcc4e1$export$2b8d127b894957b9; }, function (v) { return $759664958dfcc4e1$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $759664958dfcc4e1$export$cea3a54a6425200c; }, function (v) { return $759664958dfcc4e1$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $759664958dfcc4e1$export$a7c73072b1a182ae; }, function (v) { return $759664958dfcc4e1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $759664958dfcc4e1$export$9f27bc3417b4524d; }, function (v) { return $759664958dfcc4e1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $759664958dfcc4e1$export$db77ccec0bb4ccac; }, function (v) { return $759664958dfcc4e1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $759664958dfcc4e1$export$8392c0c9d3dcbd35; }, function (v) { return $759664958dfcc4e1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $759664958dfcc4e1$export$ffb0004e005737fa; }, function (v) { return $759664958dfcc4e1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $759664958dfcc4e1$export$b624eff549462981; }, function (v) { return $759664958dfcc4e1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $759664958dfcc4e1$export$7897aa7841a5380c; }, function (v) { return $759664958dfcc4e1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $759664958dfcc4e1$export$602eac185826482c; }, function (v) { return $759664958dfcc4e1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $759664958dfcc4e1$export$e2c29f18771995cb; }, function (v) { return $759664958dfcc4e1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $759664958dfcc4e1$export$5f8d39834fd61797; }, function (v) { return $759664958dfcc4e1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $759664958dfcc4e1$export$74bf444e3cd11ea5; }, function (v) { return $759664958dfcc4e1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $759664958dfcc4e1$export$92387174baf9b227; }, function (v) { return $759664958dfcc4e1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $759664958dfcc4e1$export$ec112efeb987d9c6; }, function (v) { return $759664958dfcc4e1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $759664958dfcc4e1$export$b706b080d889d2c9; }, function (v) { return $759664958dfcc4e1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $759664958dfcc4e1$export$5be5a87408f70ddc; }, function (v) { return $759664958dfcc4e1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $759664958dfcc4e1$export$45a5e7f76e0caa8d; }, function (v) { return $759664958dfcc4e1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $759664958dfcc4e1$export$455c2e768291efa6; }, function (v) { return $759664958dfcc4e1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $759664958dfcc4e1$export$9522e17588c12572; }, function (v) { return $759664958dfcc4e1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $759664958dfcc4e1$export$2110ac352bb060b9; }, function (v) { return $759664958dfcc4e1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $759664958dfcc4e1$export$56885ab8b9c456ab; }, function (v) { return $759664958dfcc4e1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $759664958dfcc4e1$export$d927fcb6adf8f9de; }, function (v) { return $759664958dfcc4e1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $759664958dfcc4e1$export$b82d16f27459e05a; }, function (v) { return $759664958dfcc4e1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $759664958dfcc4e1$export$522c17b4f5e123e8; }, function (v) { return $759664958dfcc4e1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $759664958dfcc4e1$export$1aabd8a0274ecfd6; }, function (v) { return $759664958dfcc4e1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $759664958dfcc4e1$export$9b621391a187a31a; }, function (v) { return $759664958dfcc4e1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $759664958dfcc4e1$export$f5bbd400c2f4426f; }, function (v) { return $759664958dfcc4e1$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $759664958dfcc4e1$export$2b8d127b894957b9;
var $759664958dfcc4e1$export$cea3a54a6425200c;
var $759664958dfcc4e1$export$a7c73072b1a182ae;
var $759664958dfcc4e1$export$9f27bc3417b4524d;
var $759664958dfcc4e1$export$db77ccec0bb4ccac;
var $759664958dfcc4e1$export$8392c0c9d3dcbd35;
var $759664958dfcc4e1$export$ffb0004e005737fa;
var $759664958dfcc4e1$export$b624eff549462981;
var $759664958dfcc4e1$export$7897aa7841a5380c;
var $759664958dfcc4e1$export$602eac185826482c;
var $759664958dfcc4e1$export$e2c29f18771995cb;
var $759664958dfcc4e1$export$5f8d39834fd61797;
var $759664958dfcc4e1$export$74bf444e3cd11ea5;
var $759664958dfcc4e1$export$92387174baf9b227;
var $759664958dfcc4e1$export$ec112efeb987d9c6;
var $759664958dfcc4e1$export$b706b080d889d2c9;
var $759664958dfcc4e1$export$5be5a87408f70ddc;
var $759664958dfcc4e1$export$45a5e7f76e0caa8d;
var $759664958dfcc4e1$export$455c2e768291efa6;
var $759664958dfcc4e1$export$9522e17588c12572;
var $759664958dfcc4e1$export$2110ac352bb060b9;
var $759664958dfcc4e1$export$56885ab8b9c456ab;
var $759664958dfcc4e1$export$d927fcb6adf8f9de;
var $759664958dfcc4e1$export$b82d16f27459e05a;
var $759664958dfcc4e1$export$522c17b4f5e123e8;
var $759664958dfcc4e1$export$1aabd8a0274ecfd6;
var $759664958dfcc4e1$export$9b621391a187a31a;
var $759664958dfcc4e1$export$f5bbd400c2f4426f;
"use strict";
var $759664958dfcc4e1$var$b = "function" === typeof Symbol && Symbol.for, $759664958dfcc4e1$var$c = $759664958dfcc4e1$var$b ? Symbol.for("react.element") : 60103, $759664958dfcc4e1$var$d = $759664958dfcc4e1$var$b ? Symbol.for("react.portal") : 60106, $759664958dfcc4e1$var$e = $759664958dfcc4e1$var$b ? Symbol.for("react.fragment") : 60107, $759664958dfcc4e1$var$f = $759664958dfcc4e1$var$b ? Symbol.for("react.strict_mode") : 60108, $759664958dfcc4e1$var$g = $759664958dfcc4e1$var$b ? Symbol.for("react.profiler") : 60114, $759664958dfcc4e1$var$h = $759664958dfcc4e1$var$b ? Symbol.for("react.provider") : 60109, $759664958dfcc4e1$var$k = $759664958dfcc4e1$var$b ? Symbol.for("react.context") : 60110, $759664958dfcc4e1$var$l = $759664958dfcc4e1$var$b ? Symbol.for("react.async_mode") : 60111, $759664958dfcc4e1$var$m = $759664958dfcc4e1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $759664958dfcc4e1$var$n = $759664958dfcc4e1$var$b ? Symbol.for("react.forward_ref") : 60112, $759664958dfcc4e1$var$p = $759664958dfcc4e1$var$b ? Symbol.for("react.suspense") : 60113, $759664958dfcc4e1$var$q = $759664958dfcc4e1$var$b ? Symbol.for("react.suspense_list") : 60120, $759664958dfcc4e1$var$r = $759664958dfcc4e1$var$b ? Symbol.for("react.memo") : 60115, $759664958dfcc4e1$var$t = $759664958dfcc4e1$var$b ? Symbol.for("react.lazy") : 60116, $759664958dfcc4e1$var$v = $759664958dfcc4e1$var$b ? Symbol.for("react.block") : 60121, $759664958dfcc4e1$var$w = $759664958dfcc4e1$var$b ? Symbol.for("react.fundamental") : 60117, $759664958dfcc4e1$var$x = $759664958dfcc4e1$var$b ? Symbol.for("react.responder") : 60118, $759664958dfcc4e1$var$y = $759664958dfcc4e1$var$b ? Symbol.for("react.scope") : 60119;
function $759664958dfcc4e1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $759664958dfcc4e1$var$c:
                switch(a = a.type, a){
                    case $759664958dfcc4e1$var$l:
                    case $759664958dfcc4e1$var$m:
                    case $759664958dfcc4e1$var$e:
                    case $759664958dfcc4e1$var$g:
                    case $759664958dfcc4e1$var$f:
                    case $759664958dfcc4e1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $759664958dfcc4e1$var$k:
                            case $759664958dfcc4e1$var$n:
                            case $759664958dfcc4e1$var$t:
                            case $759664958dfcc4e1$var$r:
                            case $759664958dfcc4e1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $759664958dfcc4e1$var$d:
                return u;
        }
    }
}
function $759664958dfcc4e1$var$A(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$m;
}
$759664958dfcc4e1$export$2b8d127b894957b9 = $759664958dfcc4e1$var$l;
$759664958dfcc4e1$export$cea3a54a6425200c = $759664958dfcc4e1$var$m;
$759664958dfcc4e1$export$a7c73072b1a182ae = $759664958dfcc4e1$var$k;
$759664958dfcc4e1$export$9f27bc3417b4524d = $759664958dfcc4e1$var$h;
$759664958dfcc4e1$export$db77ccec0bb4ccac = $759664958dfcc4e1$var$c;
$759664958dfcc4e1$export$8392c0c9d3dcbd35 = $759664958dfcc4e1$var$n;
$759664958dfcc4e1$export$ffb0004e005737fa = $759664958dfcc4e1$var$e;
$759664958dfcc4e1$export$b624eff549462981 = $759664958dfcc4e1$var$t;
$759664958dfcc4e1$export$7897aa7841a5380c = $759664958dfcc4e1$var$r;
$759664958dfcc4e1$export$602eac185826482c = $759664958dfcc4e1$var$d;
$759664958dfcc4e1$export$e2c29f18771995cb = $759664958dfcc4e1$var$g;
$759664958dfcc4e1$export$5f8d39834fd61797 = $759664958dfcc4e1$var$f;
$759664958dfcc4e1$export$74bf444e3cd11ea5 = $759664958dfcc4e1$var$p;
$759664958dfcc4e1$export$92387174baf9b227 = function(a) {
    return $759664958dfcc4e1$var$A(a) || $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$l;
};
$759664958dfcc4e1$export$ec112efeb987d9c6 = $759664958dfcc4e1$var$A;
$759664958dfcc4e1$export$b706b080d889d2c9 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$k;
};
$759664958dfcc4e1$export$5be5a87408f70ddc = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$h;
};
$759664958dfcc4e1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $759664958dfcc4e1$var$c;
};
$759664958dfcc4e1$export$455c2e768291efa6 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$n;
};
$759664958dfcc4e1$export$9522e17588c12572 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$e;
};
$759664958dfcc4e1$export$2110ac352bb060b9 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$t;
};
$759664958dfcc4e1$export$56885ab8b9c456ab = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$r;
};
$759664958dfcc4e1$export$d927fcb6adf8f9de = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$d;
};
$759664958dfcc4e1$export$b82d16f27459e05a = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$g;
};
$759664958dfcc4e1$export$522c17b4f5e123e8 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$f;
};
$759664958dfcc4e1$export$1aabd8a0274ecfd6 = function(a) {
    return $759664958dfcc4e1$var$z(a) === $759664958dfcc4e1$var$p;
};
$759664958dfcc4e1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $759664958dfcc4e1$var$e || a === $759664958dfcc4e1$var$m || a === $759664958dfcc4e1$var$g || a === $759664958dfcc4e1$var$f || a === $759664958dfcc4e1$var$p || a === $759664958dfcc4e1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $759664958dfcc4e1$var$t || a.$$typeof === $759664958dfcc4e1$var$r || a.$$typeof === $759664958dfcc4e1$var$h || a.$$typeof === $759664958dfcc4e1$var$k || a.$$typeof === $759664958dfcc4e1$var$n || a.$$typeof === $759664958dfcc4e1$var$w || a.$$typeof === $759664958dfcc4e1$var$x || a.$$typeof === $759664958dfcc4e1$var$y || a.$$typeof === $759664958dfcc4e1$var$v);
};
$759664958dfcc4e1$export$f5bbd400c2f4426f = $759664958dfcc4e1$var$z;

});



parcelRegister("dvUFh", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9d6a2010e454caac$export$ae55be85d98224ed; }, function (v) { return $9d6a2010e454caac$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9d6a2010e454caac$export$d39a5bbd09211389; }, function (v) { return $9d6a2010e454caac$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9d6a2010e454caac$export$882461b6382ed46c; }, function (v) { return $9d6a2010e454caac$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9d6a2010e454caac$export$466bfc07425424d5; }, function (v) { return $9d6a2010e454caac$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9d6a2010e454caac$export$cd75ccfd720a3cd4; }, function (v) { return $9d6a2010e454caac$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9d6a2010e454caac$export$fa8d919ba61d84db; }, function (v) { return $9d6a2010e454caac$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9d6a2010e454caac$export$757ceba2d55c277e; }, function (v) { return $9d6a2010e454caac$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9d6a2010e454caac$export$b3890eb0ae9dca99; }, function (v) { return $9d6a2010e454caac$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9d6a2010e454caac$export$502457920280e6be; }, function (v) { return $9d6a2010e454caac$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9d6a2010e454caac$export$c78a37762a8d58e1; }, function (v) { return $9d6a2010e454caac$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9d6a2010e454caac$export$dc54d992c10e8a18; }, function (v) { return $9d6a2010e454caac$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9d6a2010e454caac$export$83d89fbfd8236492; }, function (v) { return $9d6a2010e454caac$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9d6a2010e454caac$export$ae55be85d98224ed;
var $9d6a2010e454caac$export$d39a5bbd09211389;
var $9d6a2010e454caac$export$882461b6382ed46c;
var $9d6a2010e454caac$export$466bfc07425424d5;
var $9d6a2010e454caac$export$cd75ccfd720a3cd4;
var $9d6a2010e454caac$export$fa8d919ba61d84db;
var $9d6a2010e454caac$export$757ceba2d55c277e;
var $9d6a2010e454caac$export$b3890eb0ae9dca99;
var $9d6a2010e454caac$export$502457920280e6be;
var $9d6a2010e454caac$export$c78a37762a8d58e1;
var $9d6a2010e454caac$export$dc54d992c10e8a18;
var $9d6a2010e454caac$export$83d89fbfd8236492;
"use strict";

var $2hDQc = parcelRequire("2hDQc");

var $jz6aq = parcelRequire("jz6aq");
function $9d6a2010e454caac$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9d6a2010e454caac$var$da = new Set, $9d6a2010e454caac$var$ea = {};
function $9d6a2010e454caac$var$fa(a, b) {
    $9d6a2010e454caac$var$ha(a, b);
    $9d6a2010e454caac$var$ha(a + "Capture", b);
}
function $9d6a2010e454caac$var$ha(a, b) {
    $9d6a2010e454caac$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9d6a2010e454caac$var$da.add(b[a]);
}
var $9d6a2010e454caac$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9d6a2010e454caac$var$ja = Object.prototype.hasOwnProperty, $9d6a2010e454caac$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9d6a2010e454caac$var$la = {}, $9d6a2010e454caac$var$ma = {};
function $9d6a2010e454caac$var$oa(a) {
    if ($9d6a2010e454caac$var$ja.call($9d6a2010e454caac$var$ma, a)) return !0;
    if ($9d6a2010e454caac$var$ja.call($9d6a2010e454caac$var$la, a)) return !1;
    if ($9d6a2010e454caac$var$ka.test(a)) return $9d6a2010e454caac$var$ma[a] = !0;
    $9d6a2010e454caac$var$la[a] = !0;
    return !1;
}
function $9d6a2010e454caac$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9d6a2010e454caac$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9d6a2010e454caac$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9d6a2010e454caac$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9d6a2010e454caac$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9d6a2010e454caac$var$z[b] = new $9d6a2010e454caac$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9d6a2010e454caac$var$ra = /[\-:]([a-z])/g;
function $9d6a2010e454caac$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9d6a2010e454caac$var$ra, $9d6a2010e454caac$var$sa);
    $9d6a2010e454caac$var$z[b] = new $9d6a2010e454caac$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9d6a2010e454caac$var$ra, $9d6a2010e454caac$var$sa);
    $9d6a2010e454caac$var$z[b] = new $9d6a2010e454caac$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9d6a2010e454caac$var$ra, $9d6a2010e454caac$var$sa);
    $9d6a2010e454caac$var$z[b] = new $9d6a2010e454caac$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9d6a2010e454caac$var$z.xlinkHref = new $9d6a2010e454caac$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9d6a2010e454caac$var$z[a] = new $9d6a2010e454caac$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9d6a2010e454caac$var$ta(a, b, c, d) {
    var e = $9d6a2010e454caac$var$z.hasOwnProperty(b) ? $9d6a2010e454caac$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9d6a2010e454caac$var$qa(b, c, e, d) && (c = null), d || null === e ? $9d6a2010e454caac$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9d6a2010e454caac$var$ua = $2hDQc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9d6a2010e454caac$var$va = Symbol.for("react.element"), $9d6a2010e454caac$var$wa = Symbol.for("react.portal"), $9d6a2010e454caac$var$ya = Symbol.for("react.fragment"), $9d6a2010e454caac$var$za = Symbol.for("react.strict_mode"), $9d6a2010e454caac$var$Aa = Symbol.for("react.profiler"), $9d6a2010e454caac$var$Ba = Symbol.for("react.provider"), $9d6a2010e454caac$var$Ca = Symbol.for("react.context"), $9d6a2010e454caac$var$Da = Symbol.for("react.forward_ref"), $9d6a2010e454caac$var$Ea = Symbol.for("react.suspense"), $9d6a2010e454caac$var$Fa = Symbol.for("react.suspense_list"), $9d6a2010e454caac$var$Ga = Symbol.for("react.memo"), $9d6a2010e454caac$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9d6a2010e454caac$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9d6a2010e454caac$var$Ja = Symbol.iterator;
function $9d6a2010e454caac$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9d6a2010e454caac$var$Ja && a[$9d6a2010e454caac$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9d6a2010e454caac$var$A = Object.assign, $9d6a2010e454caac$var$La;
function $9d6a2010e454caac$var$Ma(a) {
    if (void 0 === $9d6a2010e454caac$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9d6a2010e454caac$var$La = b && b[1] || "";
    }
    return "\n" + $9d6a2010e454caac$var$La + a;
}
var $9d6a2010e454caac$var$Na = !1;
function $9d6a2010e454caac$var$Oa(a, b) {
    if (!a || $9d6a2010e454caac$var$Na) return "";
    $9d6a2010e454caac$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9d6a2010e454caac$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9d6a2010e454caac$var$Ma(a) : "";
}
function $9d6a2010e454caac$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9d6a2010e454caac$var$Ma(a.type);
        case 16:
            return $9d6a2010e454caac$var$Ma("Lazy");
        case 13:
            return $9d6a2010e454caac$var$Ma("Suspense");
        case 19:
            return $9d6a2010e454caac$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9d6a2010e454caac$var$Oa(a.type, !1), a;
        case 11:
            return a = $9d6a2010e454caac$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9d6a2010e454caac$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9d6a2010e454caac$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9d6a2010e454caac$var$ya:
            return "Fragment";
        case $9d6a2010e454caac$var$wa:
            return "Portal";
        case $9d6a2010e454caac$var$Aa:
            return "Profiler";
        case $9d6a2010e454caac$var$za:
            return "StrictMode";
        case $9d6a2010e454caac$var$Ea:
            return "Suspense";
        case $9d6a2010e454caac$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9d6a2010e454caac$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9d6a2010e454caac$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9d6a2010e454caac$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9d6a2010e454caac$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9d6a2010e454caac$var$Qa(a.type) || "Memo";
        case $9d6a2010e454caac$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9d6a2010e454caac$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9d6a2010e454caac$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9d6a2010e454caac$var$Qa(b);
        case 8:
            return b === $9d6a2010e454caac$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9d6a2010e454caac$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9d6a2010e454caac$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9d6a2010e454caac$var$Ua(a) {
    var b = $9d6a2010e454caac$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9d6a2010e454caac$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9d6a2010e454caac$var$Ua(a));
}
function $9d6a2010e454caac$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9d6a2010e454caac$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9d6a2010e454caac$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9d6a2010e454caac$var$Ya(a, b) {
    var c = b.checked;
    return $9d6a2010e454caac$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9d6a2010e454caac$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9d6a2010e454caac$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9d6a2010e454caac$var$ab(a, b) {
    b = b.checked;
    null != b && $9d6a2010e454caac$var$ta(a, "checked", b, !1);
}
function $9d6a2010e454caac$var$bb(a, b) {
    $9d6a2010e454caac$var$ab(a, b);
    var c = $9d6a2010e454caac$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9d6a2010e454caac$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9d6a2010e454caac$var$cb(a, b.type, $9d6a2010e454caac$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9d6a2010e454caac$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9d6a2010e454caac$var$cb(a, b, c) {
    if ("number" !== b || $9d6a2010e454caac$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9d6a2010e454caac$var$eb = Array.isArray;
function $9d6a2010e454caac$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9d6a2010e454caac$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9d6a2010e454caac$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9d6a2010e454caac$var$p(91));
    return $9d6a2010e454caac$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9d6a2010e454caac$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9d6a2010e454caac$var$p(92));
            if ($9d6a2010e454caac$var$eb(c)) {
                if (1 < c.length) throw Error($9d6a2010e454caac$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9d6a2010e454caac$var$Sa(c)
    };
}
function $9d6a2010e454caac$var$ib(a, b) {
    var c = $9d6a2010e454caac$var$Sa(b.value), d = $9d6a2010e454caac$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9d6a2010e454caac$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9d6a2010e454caac$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9d6a2010e454caac$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9d6a2010e454caac$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9d6a2010e454caac$var$mb, $9d6a2010e454caac$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9d6a2010e454caac$var$mb = $9d6a2010e454caac$var$mb || document.createElement("div");
        $9d6a2010e454caac$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9d6a2010e454caac$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9d6a2010e454caac$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9d6a2010e454caac$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9d6a2010e454caac$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9d6a2010e454caac$var$pb).forEach(function(a) {
    $9d6a2010e454caac$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9d6a2010e454caac$var$pb[b] = $9d6a2010e454caac$var$pb[a];
    });
});
function $9d6a2010e454caac$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9d6a2010e454caac$var$pb.hasOwnProperty(a) && $9d6a2010e454caac$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9d6a2010e454caac$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9d6a2010e454caac$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9d6a2010e454caac$var$tb = $9d6a2010e454caac$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9d6a2010e454caac$var$ub(a, b) {
    if (b) {
        if ($9d6a2010e454caac$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9d6a2010e454caac$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9d6a2010e454caac$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9d6a2010e454caac$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9d6a2010e454caac$var$p(62));
    }
}
function $9d6a2010e454caac$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9d6a2010e454caac$var$wb = null;
function $9d6a2010e454caac$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9d6a2010e454caac$var$yb = null, $9d6a2010e454caac$var$zb = null, $9d6a2010e454caac$var$Ab = null;
function $9d6a2010e454caac$var$Bb(a) {
    if (a = $9d6a2010e454caac$var$Cb(a)) {
        if ("function" !== typeof $9d6a2010e454caac$var$yb) throw Error($9d6a2010e454caac$var$p(280));
        var b = a.stateNode;
        b && (b = $9d6a2010e454caac$var$Db(b), $9d6a2010e454caac$var$yb(a.stateNode, a.type, b));
    }
}
function $9d6a2010e454caac$var$Eb(a) {
    $9d6a2010e454caac$var$zb ? $9d6a2010e454caac$var$Ab ? $9d6a2010e454caac$var$Ab.push(a) : $9d6a2010e454caac$var$Ab = [
        a
    ] : $9d6a2010e454caac$var$zb = a;
}
function $9d6a2010e454caac$var$Fb() {
    if ($9d6a2010e454caac$var$zb) {
        var a = $9d6a2010e454caac$var$zb, b = $9d6a2010e454caac$var$Ab;
        $9d6a2010e454caac$var$Ab = $9d6a2010e454caac$var$zb = null;
        $9d6a2010e454caac$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9d6a2010e454caac$var$Bb(b[a]);
    }
}
function $9d6a2010e454caac$var$Gb(a, b) {
    return a(b);
}
function $9d6a2010e454caac$var$Hb() {}
var $9d6a2010e454caac$var$Ib = !1;
function $9d6a2010e454caac$var$Jb(a, b, c) {
    if ($9d6a2010e454caac$var$Ib) return a(b, c);
    $9d6a2010e454caac$var$Ib = !0;
    try {
        return $9d6a2010e454caac$var$Gb(a, b, c);
    } finally{
        if ($9d6a2010e454caac$var$Ib = !1, null !== $9d6a2010e454caac$var$zb || null !== $9d6a2010e454caac$var$Ab) $9d6a2010e454caac$var$Hb(), $9d6a2010e454caac$var$Fb();
    }
}
function $9d6a2010e454caac$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9d6a2010e454caac$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9d6a2010e454caac$var$p(231, b, typeof c));
    return c;
}
var $9d6a2010e454caac$var$Lb = !1;
if ($9d6a2010e454caac$var$ia) try {
    var $9d6a2010e454caac$var$Mb = {};
    Object.defineProperty($9d6a2010e454caac$var$Mb, "passive", {
        get: function() {
            $9d6a2010e454caac$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9d6a2010e454caac$var$Mb, $9d6a2010e454caac$var$Mb);
    window.removeEventListener("test", $9d6a2010e454caac$var$Mb, $9d6a2010e454caac$var$Mb);
} catch (a) {
    $9d6a2010e454caac$var$Lb = !1;
}
function $9d6a2010e454caac$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9d6a2010e454caac$var$Ob = !1, $9d6a2010e454caac$var$Pb = null, $9d6a2010e454caac$var$Qb = !1, $9d6a2010e454caac$var$Rb = null, $9d6a2010e454caac$var$Sb = {
    onError: function(a) {
        $9d6a2010e454caac$var$Ob = !0;
        $9d6a2010e454caac$var$Pb = a;
    }
};
function $9d6a2010e454caac$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9d6a2010e454caac$var$Ob = !1;
    $9d6a2010e454caac$var$Pb = null;
    $9d6a2010e454caac$var$Nb.apply($9d6a2010e454caac$var$Sb, arguments);
}
function $9d6a2010e454caac$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9d6a2010e454caac$var$Tb.apply(this, arguments);
    if ($9d6a2010e454caac$var$Ob) {
        if ($9d6a2010e454caac$var$Ob) {
            var l = $9d6a2010e454caac$var$Pb;
            $9d6a2010e454caac$var$Ob = !1;
            $9d6a2010e454caac$var$Pb = null;
        } else throw Error($9d6a2010e454caac$var$p(198));
        $9d6a2010e454caac$var$Qb || ($9d6a2010e454caac$var$Qb = !0, $9d6a2010e454caac$var$Rb = l);
    }
}
function $9d6a2010e454caac$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9d6a2010e454caac$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9d6a2010e454caac$var$Xb(a) {
    if ($9d6a2010e454caac$var$Vb(a) !== a) throw Error($9d6a2010e454caac$var$p(188));
}
function $9d6a2010e454caac$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9d6a2010e454caac$var$Vb(a);
        if (null === b) throw Error($9d6a2010e454caac$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9d6a2010e454caac$var$Xb(e), a;
                if (f === d) return $9d6a2010e454caac$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9d6a2010e454caac$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9d6a2010e454caac$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9d6a2010e454caac$var$p(190));
    }
    if (3 !== c.tag) throw Error($9d6a2010e454caac$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9d6a2010e454caac$var$Zb(a) {
    a = $9d6a2010e454caac$var$Yb(a);
    return null !== a ? $9d6a2010e454caac$var$$b(a) : null;
}
function $9d6a2010e454caac$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9d6a2010e454caac$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9d6a2010e454caac$var$ac = $jz6aq.unstable_scheduleCallback, $9d6a2010e454caac$var$bc = $jz6aq.unstable_cancelCallback, $9d6a2010e454caac$var$cc = $jz6aq.unstable_shouldYield, $9d6a2010e454caac$var$dc = $jz6aq.unstable_requestPaint, $9d6a2010e454caac$var$B = $jz6aq.unstable_now, $9d6a2010e454caac$var$ec = $jz6aq.unstable_getCurrentPriorityLevel, $9d6a2010e454caac$var$fc = $jz6aq.unstable_ImmediatePriority, $9d6a2010e454caac$var$gc = $jz6aq.unstable_UserBlockingPriority, $9d6a2010e454caac$var$hc = $jz6aq.unstable_NormalPriority, $9d6a2010e454caac$var$ic = $jz6aq.unstable_LowPriority, $9d6a2010e454caac$var$jc = $jz6aq.unstable_IdlePriority, $9d6a2010e454caac$var$kc = null, $9d6a2010e454caac$var$lc = null;
function $9d6a2010e454caac$var$mc(a) {
    if ($9d6a2010e454caac$var$lc && "function" === typeof $9d6a2010e454caac$var$lc.onCommitFiberRoot) try {
        $9d6a2010e454caac$var$lc.onCommitFiberRoot($9d6a2010e454caac$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9d6a2010e454caac$var$oc = Math.clz32 ? Math.clz32 : $9d6a2010e454caac$var$nc, $9d6a2010e454caac$var$pc = Math.log, $9d6a2010e454caac$var$qc = Math.LN2;
function $9d6a2010e454caac$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9d6a2010e454caac$var$pc(a) / $9d6a2010e454caac$var$qc | 0) | 0;
}
var $9d6a2010e454caac$var$rc = 64, $9d6a2010e454caac$var$sc = 4194304;
function $9d6a2010e454caac$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9d6a2010e454caac$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9d6a2010e454caac$var$tc(h) : (f &= g, 0 !== f && (d = $9d6a2010e454caac$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9d6a2010e454caac$var$tc(g) : 0 !== f && (d = $9d6a2010e454caac$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9d6a2010e454caac$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9d6a2010e454caac$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9d6a2010e454caac$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9d6a2010e454caac$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9d6a2010e454caac$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9d6a2010e454caac$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9d6a2010e454caac$var$yc() {
    var a = $9d6a2010e454caac$var$rc;
    $9d6a2010e454caac$var$rc <<= 1;
    0 === ($9d6a2010e454caac$var$rc & 4194240) && ($9d6a2010e454caac$var$rc = 64);
    return a;
}
function $9d6a2010e454caac$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9d6a2010e454caac$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9d6a2010e454caac$var$oc(b);
    a[b] = c;
}
function $9d6a2010e454caac$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9d6a2010e454caac$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9d6a2010e454caac$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9d6a2010e454caac$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9d6a2010e454caac$var$C = 0;
function $9d6a2010e454caac$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9d6a2010e454caac$var$Ec, $9d6a2010e454caac$var$Fc, $9d6a2010e454caac$var$Gc, $9d6a2010e454caac$var$Hc, $9d6a2010e454caac$var$Ic, $9d6a2010e454caac$var$Jc = !1, $9d6a2010e454caac$var$Kc = [], $9d6a2010e454caac$var$Lc = null, $9d6a2010e454caac$var$Mc = null, $9d6a2010e454caac$var$Nc = null, $9d6a2010e454caac$var$Oc = new Map, $9d6a2010e454caac$var$Pc = new Map, $9d6a2010e454caac$var$Qc = [], $9d6a2010e454caac$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9d6a2010e454caac$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9d6a2010e454caac$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9d6a2010e454caac$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9d6a2010e454caac$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9d6a2010e454caac$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9d6a2010e454caac$var$Pc.delete(b.pointerId);
    }
}
function $9d6a2010e454caac$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9d6a2010e454caac$var$Cb(b), null !== b && $9d6a2010e454caac$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9d6a2010e454caac$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9d6a2010e454caac$var$Lc = $9d6a2010e454caac$var$Tc($9d6a2010e454caac$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9d6a2010e454caac$var$Mc = $9d6a2010e454caac$var$Tc($9d6a2010e454caac$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9d6a2010e454caac$var$Nc = $9d6a2010e454caac$var$Tc($9d6a2010e454caac$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9d6a2010e454caac$var$Oc.set(f, $9d6a2010e454caac$var$Tc($9d6a2010e454caac$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9d6a2010e454caac$var$Pc.set(f, $9d6a2010e454caac$var$Tc($9d6a2010e454caac$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9d6a2010e454caac$var$Vc(a) {
    var b = $9d6a2010e454caac$var$Wc(a.target);
    if (null !== b) {
        var c = $9d6a2010e454caac$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9d6a2010e454caac$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9d6a2010e454caac$var$Ic(a.priority, function() {
                        $9d6a2010e454caac$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9d6a2010e454caac$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9d6a2010e454caac$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9d6a2010e454caac$var$wb = d;
            c.target.dispatchEvent(d);
            $9d6a2010e454caac$var$wb = null;
        } else return b = $9d6a2010e454caac$var$Cb(c), null !== b && $9d6a2010e454caac$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9d6a2010e454caac$var$Zc(a, b, c) {
    $9d6a2010e454caac$var$Xc(a) && c.delete(b);
}
function $9d6a2010e454caac$var$$c() {
    $9d6a2010e454caac$var$Jc = !1;
    null !== $9d6a2010e454caac$var$Lc && $9d6a2010e454caac$var$Xc($9d6a2010e454caac$var$Lc) && ($9d6a2010e454caac$var$Lc = null);
    null !== $9d6a2010e454caac$var$Mc && $9d6a2010e454caac$var$Xc($9d6a2010e454caac$var$Mc) && ($9d6a2010e454caac$var$Mc = null);
    null !== $9d6a2010e454caac$var$Nc && $9d6a2010e454caac$var$Xc($9d6a2010e454caac$var$Nc) && ($9d6a2010e454caac$var$Nc = null);
    $9d6a2010e454caac$var$Oc.forEach($9d6a2010e454caac$var$Zc);
    $9d6a2010e454caac$var$Pc.forEach($9d6a2010e454caac$var$Zc);
}
function $9d6a2010e454caac$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9d6a2010e454caac$var$Jc || ($9d6a2010e454caac$var$Jc = !0, $jz6aq.unstable_scheduleCallback($jz6aq.unstable_NormalPriority, $9d6a2010e454caac$var$$c)));
}
function $9d6a2010e454caac$var$bd(a) {
    function b(b) {
        return $9d6a2010e454caac$var$ad(b, a);
    }
    if (0 < $9d6a2010e454caac$var$Kc.length) {
        $9d6a2010e454caac$var$ad($9d6a2010e454caac$var$Kc[0], a);
        for(var c = 1; c < $9d6a2010e454caac$var$Kc.length; c++){
            var d = $9d6a2010e454caac$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9d6a2010e454caac$var$Lc && $9d6a2010e454caac$var$ad($9d6a2010e454caac$var$Lc, a);
    null !== $9d6a2010e454caac$var$Mc && $9d6a2010e454caac$var$ad($9d6a2010e454caac$var$Mc, a);
    null !== $9d6a2010e454caac$var$Nc && $9d6a2010e454caac$var$ad($9d6a2010e454caac$var$Nc, a);
    $9d6a2010e454caac$var$Oc.forEach(b);
    $9d6a2010e454caac$var$Pc.forEach(b);
    for(c = 0; c < $9d6a2010e454caac$var$Qc.length; c++)d = $9d6a2010e454caac$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9d6a2010e454caac$var$Qc.length && (c = $9d6a2010e454caac$var$Qc[0], null === c.blockedOn);)$9d6a2010e454caac$var$Vc(c), null === c.blockedOn && $9d6a2010e454caac$var$Qc.shift();
}
var $9d6a2010e454caac$var$cd = $9d6a2010e454caac$var$ua.ReactCurrentBatchConfig, $9d6a2010e454caac$var$dd = !0;
function $9d6a2010e454caac$var$ed(a, b, c, d) {
    var e = $9d6a2010e454caac$var$C, f = $9d6a2010e454caac$var$cd.transition;
    $9d6a2010e454caac$var$cd.transition = null;
    try {
        $9d6a2010e454caac$var$C = 1, $9d6a2010e454caac$var$fd(a, b, c, d);
    } finally{
        $9d6a2010e454caac$var$C = e, $9d6a2010e454caac$var$cd.transition = f;
    }
}
function $9d6a2010e454caac$var$gd(a, b, c, d) {
    var e = $9d6a2010e454caac$var$C, f = $9d6a2010e454caac$var$cd.transition;
    $9d6a2010e454caac$var$cd.transition = null;
    try {
        $9d6a2010e454caac$var$C = 4, $9d6a2010e454caac$var$fd(a, b, c, d);
    } finally{
        $9d6a2010e454caac$var$C = e, $9d6a2010e454caac$var$cd.transition = f;
    }
}
function $9d6a2010e454caac$var$fd(a, b, c, d) {
    if ($9d6a2010e454caac$var$dd) {
        var e = $9d6a2010e454caac$var$Yc(a, b, c, d);
        if (null === e) $9d6a2010e454caac$var$hd(a, b, d, $9d6a2010e454caac$var$id, c), $9d6a2010e454caac$var$Sc(a, d);
        else if ($9d6a2010e454caac$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9d6a2010e454caac$var$Sc(a, d), b & 4 && -1 < $9d6a2010e454caac$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9d6a2010e454caac$var$Cb(e);
                null !== f && $9d6a2010e454caac$var$Ec(f);
                f = $9d6a2010e454caac$var$Yc(a, b, c, d);
                null === f && $9d6a2010e454caac$var$hd(a, b, d, $9d6a2010e454caac$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9d6a2010e454caac$var$hd(a, b, d, null, c);
    }
}
var $9d6a2010e454caac$var$id = null;
function $9d6a2010e454caac$var$Yc(a, b, c, d) {
    $9d6a2010e454caac$var$id = null;
    a = $9d6a2010e454caac$var$xb(d);
    a = $9d6a2010e454caac$var$Wc(a);
    if (null !== a) {
        if (b = $9d6a2010e454caac$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9d6a2010e454caac$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9d6a2010e454caac$var$id = a;
    return null;
}
function $9d6a2010e454caac$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9d6a2010e454caac$var$ec()){
                case $9d6a2010e454caac$var$fc:
                    return 1;
                case $9d6a2010e454caac$var$gc:
                    return 4;
                case $9d6a2010e454caac$var$hc:
                case $9d6a2010e454caac$var$ic:
                    return 16;
                case $9d6a2010e454caac$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9d6a2010e454caac$var$kd = null, $9d6a2010e454caac$var$ld = null, $9d6a2010e454caac$var$md = null;
function $9d6a2010e454caac$var$nd() {
    if ($9d6a2010e454caac$var$md) return $9d6a2010e454caac$var$md;
    var a, b = $9d6a2010e454caac$var$ld, c = b.length, d, e = "value" in $9d6a2010e454caac$var$kd ? $9d6a2010e454caac$var$kd.value : $9d6a2010e454caac$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9d6a2010e454caac$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9d6a2010e454caac$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9d6a2010e454caac$var$pd() {
    return !0;
}
function $9d6a2010e454caac$var$qd() {
    return !1;
}
function $9d6a2010e454caac$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9d6a2010e454caac$var$pd : $9d6a2010e454caac$var$qd;
        this.isPropagationStopped = $9d6a2010e454caac$var$qd;
        return this;
    }
    $9d6a2010e454caac$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9d6a2010e454caac$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9d6a2010e454caac$var$pd);
        },
        persist: function() {},
        isPersistent: $9d6a2010e454caac$var$pd
    });
    return b;
}
var $9d6a2010e454caac$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9d6a2010e454caac$var$td = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$sd), $9d6a2010e454caac$var$ud = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$sd, {
    view: 0,
    detail: 0
}), $9d6a2010e454caac$var$vd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$ud), $9d6a2010e454caac$var$wd, $9d6a2010e454caac$var$xd, $9d6a2010e454caac$var$yd, $9d6a2010e454caac$var$Ad = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9d6a2010e454caac$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9d6a2010e454caac$var$yd && ($9d6a2010e454caac$var$yd && "mousemove" === a.type ? ($9d6a2010e454caac$var$wd = a.screenX - $9d6a2010e454caac$var$yd.screenX, $9d6a2010e454caac$var$xd = a.screenY - $9d6a2010e454caac$var$yd.screenY) : $9d6a2010e454caac$var$xd = $9d6a2010e454caac$var$wd = 0, $9d6a2010e454caac$var$yd = a);
        return $9d6a2010e454caac$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9d6a2010e454caac$var$xd;
    }
}), $9d6a2010e454caac$var$Bd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Ad), $9d6a2010e454caac$var$Cd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$Ad, {
    dataTransfer: 0
}), $9d6a2010e454caac$var$Dd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Cd), $9d6a2010e454caac$var$Ed = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$ud, {
    relatedTarget: 0
}), $9d6a2010e454caac$var$Fd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Ed), $9d6a2010e454caac$var$Gd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9d6a2010e454caac$var$Hd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Gd), $9d6a2010e454caac$var$Id = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9d6a2010e454caac$var$Jd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Id), $9d6a2010e454caac$var$Kd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$sd, {
    data: 0
}), $9d6a2010e454caac$var$Ld = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Kd), $9d6a2010e454caac$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9d6a2010e454caac$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9d6a2010e454caac$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9d6a2010e454caac$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9d6a2010e454caac$var$Od[a]) ? !!b[a] : !1;
}
function $9d6a2010e454caac$var$zd() {
    return $9d6a2010e454caac$var$Pd;
}
var $9d6a2010e454caac$var$Qd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9d6a2010e454caac$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9d6a2010e454caac$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9d6a2010e454caac$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9d6a2010e454caac$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9d6a2010e454caac$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9d6a2010e454caac$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9d6a2010e454caac$var$Rd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Qd), $9d6a2010e454caac$var$Sd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9d6a2010e454caac$var$Td = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Sd), $9d6a2010e454caac$var$Ud = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9d6a2010e454caac$var$zd
}), $9d6a2010e454caac$var$Vd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Ud), $9d6a2010e454caac$var$Wd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9d6a2010e454caac$var$Xd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Wd), $9d6a2010e454caac$var$Yd = $9d6a2010e454caac$var$A({}, $9d6a2010e454caac$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9d6a2010e454caac$var$Zd = $9d6a2010e454caac$var$rd($9d6a2010e454caac$var$Yd), $9d6a2010e454caac$var$$d = [
    9,
    13,
    27,
    32
], $9d6a2010e454caac$var$ae = $9d6a2010e454caac$var$ia && "CompositionEvent" in window, $9d6a2010e454caac$var$be = null;
$9d6a2010e454caac$var$ia && "documentMode" in document && ($9d6a2010e454caac$var$be = document.documentMode);
var $9d6a2010e454caac$var$ce = $9d6a2010e454caac$var$ia && "TextEvent" in window && !$9d6a2010e454caac$var$be, $9d6a2010e454caac$var$de = $9d6a2010e454caac$var$ia && (!$9d6a2010e454caac$var$ae || $9d6a2010e454caac$var$be && 8 < $9d6a2010e454caac$var$be && 11 >= $9d6a2010e454caac$var$be), $9d6a2010e454caac$var$ee = String.fromCharCode(32), $9d6a2010e454caac$var$fe = !1;
function $9d6a2010e454caac$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9d6a2010e454caac$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9d6a2010e454caac$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9d6a2010e454caac$var$ie = !1;
function $9d6a2010e454caac$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9d6a2010e454caac$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9d6a2010e454caac$var$fe = !0;
            return $9d6a2010e454caac$var$ee;
        case "textInput":
            return a = b.data, a === $9d6a2010e454caac$var$ee && $9d6a2010e454caac$var$fe ? null : a;
        default:
            return null;
    }
}
function $9d6a2010e454caac$var$ke(a, b) {
    if ($9d6a2010e454caac$var$ie) return "compositionend" === a || !$9d6a2010e454caac$var$ae && $9d6a2010e454caac$var$ge(a, b) ? (a = $9d6a2010e454caac$var$nd(), $9d6a2010e454caac$var$md = $9d6a2010e454caac$var$ld = $9d6a2010e454caac$var$kd = null, $9d6a2010e454caac$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9d6a2010e454caac$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9d6a2010e454caac$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9d6a2010e454caac$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9d6a2010e454caac$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9d6a2010e454caac$var$ne(a, b, c, d) {
    $9d6a2010e454caac$var$Eb(d);
    b = $9d6a2010e454caac$var$oe(b, "onChange");
    0 < b.length && (c = new $9d6a2010e454caac$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9d6a2010e454caac$var$pe = null, $9d6a2010e454caac$var$qe = null;
function $9d6a2010e454caac$var$re(a) {
    $9d6a2010e454caac$var$se(a, 0);
}
function $9d6a2010e454caac$var$te(a) {
    var b = $9d6a2010e454caac$var$ue(a);
    if ($9d6a2010e454caac$var$Wa(b)) return a;
}
function $9d6a2010e454caac$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9d6a2010e454caac$var$we = !1;
if ($9d6a2010e454caac$var$ia) {
    var $9d6a2010e454caac$var$xe;
    if ($9d6a2010e454caac$var$ia) {
        var $9d6a2010e454caac$var$ye = "oninput" in document;
        if (!$9d6a2010e454caac$var$ye) {
            var $9d6a2010e454caac$var$ze = document.createElement("div");
            $9d6a2010e454caac$var$ze.setAttribute("oninput", "return;");
            $9d6a2010e454caac$var$ye = "function" === typeof $9d6a2010e454caac$var$ze.oninput;
        }
        $9d6a2010e454caac$var$xe = $9d6a2010e454caac$var$ye;
    } else $9d6a2010e454caac$var$xe = !1;
    $9d6a2010e454caac$var$we = $9d6a2010e454caac$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9d6a2010e454caac$var$Ae() {
    $9d6a2010e454caac$var$pe && ($9d6a2010e454caac$var$pe.detachEvent("onpropertychange", $9d6a2010e454caac$var$Be), $9d6a2010e454caac$var$qe = $9d6a2010e454caac$var$pe = null);
}
function $9d6a2010e454caac$var$Be(a) {
    if ("value" === a.propertyName && $9d6a2010e454caac$var$te($9d6a2010e454caac$var$qe)) {
        var b = [];
        $9d6a2010e454caac$var$ne(b, $9d6a2010e454caac$var$qe, a, $9d6a2010e454caac$var$xb(a));
        $9d6a2010e454caac$var$Jb($9d6a2010e454caac$var$re, b);
    }
}
function $9d6a2010e454caac$var$Ce(a, b, c) {
    "focusin" === a ? ($9d6a2010e454caac$var$Ae(), $9d6a2010e454caac$var$pe = b, $9d6a2010e454caac$var$qe = c, $9d6a2010e454caac$var$pe.attachEvent("onpropertychange", $9d6a2010e454caac$var$Be)) : "focusout" === a && $9d6a2010e454caac$var$Ae();
}
function $9d6a2010e454caac$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9d6a2010e454caac$var$te($9d6a2010e454caac$var$qe);
}
function $9d6a2010e454caac$var$Ee(a, b) {
    if ("click" === a) return $9d6a2010e454caac$var$te(b);
}
function $9d6a2010e454caac$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9d6a2010e454caac$var$te(b);
}
function $9d6a2010e454caac$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9d6a2010e454caac$var$He = "function" === typeof Object.is ? Object.is : $9d6a2010e454caac$var$Ge;
function $9d6a2010e454caac$var$Ie(a, b) {
    if ($9d6a2010e454caac$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9d6a2010e454caac$var$ja.call(b, e) || !$9d6a2010e454caac$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9d6a2010e454caac$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9d6a2010e454caac$var$Ke(a, b) {
    var c = $9d6a2010e454caac$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9d6a2010e454caac$var$Je(c);
    }
}
function $9d6a2010e454caac$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9d6a2010e454caac$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9d6a2010e454caac$var$Me() {
    for(var a = window, b = $9d6a2010e454caac$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9d6a2010e454caac$var$Xa(a.document);
    }
    return b;
}
function $9d6a2010e454caac$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9d6a2010e454caac$var$Oe(a) {
    var b = $9d6a2010e454caac$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9d6a2010e454caac$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9d6a2010e454caac$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9d6a2010e454caac$var$Ke(c, f);
                var g = $9d6a2010e454caac$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9d6a2010e454caac$var$Pe = $9d6a2010e454caac$var$ia && "documentMode" in document && 11 >= document.documentMode, $9d6a2010e454caac$var$Qe = null, $9d6a2010e454caac$var$Re = null, $9d6a2010e454caac$var$Se = null, $9d6a2010e454caac$var$Te = !1;
function $9d6a2010e454caac$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9d6a2010e454caac$var$Te || null == $9d6a2010e454caac$var$Qe || $9d6a2010e454caac$var$Qe !== $9d6a2010e454caac$var$Xa(d) || (d = $9d6a2010e454caac$var$Qe, "selectionStart" in d && $9d6a2010e454caac$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9d6a2010e454caac$var$Se && $9d6a2010e454caac$var$Ie($9d6a2010e454caac$var$Se, d) || ($9d6a2010e454caac$var$Se = d, d = $9d6a2010e454caac$var$oe($9d6a2010e454caac$var$Re, "onSelect"), 0 < d.length && (b = new $9d6a2010e454caac$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9d6a2010e454caac$var$Qe)));
}
function $9d6a2010e454caac$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9d6a2010e454caac$var$We = {
    animationend: $9d6a2010e454caac$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9d6a2010e454caac$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9d6a2010e454caac$var$Ve("Animation", "AnimationStart"),
    transitionend: $9d6a2010e454caac$var$Ve("Transition", "TransitionEnd")
}, $9d6a2010e454caac$var$Xe = {}, $9d6a2010e454caac$var$Ye = {};
$9d6a2010e454caac$var$ia && ($9d6a2010e454caac$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9d6a2010e454caac$var$We.animationend.animation, delete $9d6a2010e454caac$var$We.animationiteration.animation, delete $9d6a2010e454caac$var$We.animationstart.animation), "TransitionEvent" in window || delete $9d6a2010e454caac$var$We.transitionend.transition);
function $9d6a2010e454caac$var$Ze(a) {
    if ($9d6a2010e454caac$var$Xe[a]) return $9d6a2010e454caac$var$Xe[a];
    if (!$9d6a2010e454caac$var$We[a]) return a;
    var b = $9d6a2010e454caac$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9d6a2010e454caac$var$Ye) return $9d6a2010e454caac$var$Xe[a] = b[c];
    return a;
}
var $9d6a2010e454caac$var$$e = $9d6a2010e454caac$var$Ze("animationend"), $9d6a2010e454caac$var$af = $9d6a2010e454caac$var$Ze("animationiteration"), $9d6a2010e454caac$var$bf = $9d6a2010e454caac$var$Ze("animationstart"), $9d6a2010e454caac$var$cf = $9d6a2010e454caac$var$Ze("transitionend"), $9d6a2010e454caac$var$df = new Map, $9d6a2010e454caac$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9d6a2010e454caac$var$ff(a, b) {
    $9d6a2010e454caac$var$df.set(a, b);
    $9d6a2010e454caac$var$fa(b, [
        a
    ]);
}
for(var $9d6a2010e454caac$var$gf = 0; $9d6a2010e454caac$var$gf < $9d6a2010e454caac$var$ef.length; $9d6a2010e454caac$var$gf++){
    var $9d6a2010e454caac$var$hf = $9d6a2010e454caac$var$ef[$9d6a2010e454caac$var$gf], $9d6a2010e454caac$var$jf = $9d6a2010e454caac$var$hf.toLowerCase(), $9d6a2010e454caac$var$kf = $9d6a2010e454caac$var$hf[0].toUpperCase() + $9d6a2010e454caac$var$hf.slice(1);
    $9d6a2010e454caac$var$ff($9d6a2010e454caac$var$jf, "on" + $9d6a2010e454caac$var$kf);
}
$9d6a2010e454caac$var$ff($9d6a2010e454caac$var$$e, "onAnimationEnd");
$9d6a2010e454caac$var$ff($9d6a2010e454caac$var$af, "onAnimationIteration");
$9d6a2010e454caac$var$ff($9d6a2010e454caac$var$bf, "onAnimationStart");
$9d6a2010e454caac$var$ff("dblclick", "onDoubleClick");
$9d6a2010e454caac$var$ff("focusin", "onFocus");
$9d6a2010e454caac$var$ff("focusout", "onBlur");
$9d6a2010e454caac$var$ff($9d6a2010e454caac$var$cf, "onTransitionEnd");
$9d6a2010e454caac$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9d6a2010e454caac$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9d6a2010e454caac$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9d6a2010e454caac$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9d6a2010e454caac$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9d6a2010e454caac$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9d6a2010e454caac$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9d6a2010e454caac$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9d6a2010e454caac$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9d6a2010e454caac$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9d6a2010e454caac$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9d6a2010e454caac$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9d6a2010e454caac$var$lf));
function $9d6a2010e454caac$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9d6a2010e454caac$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9d6a2010e454caac$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9d6a2010e454caac$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9d6a2010e454caac$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9d6a2010e454caac$var$Qb) throw a = $9d6a2010e454caac$var$Rb, $9d6a2010e454caac$var$Qb = !1, $9d6a2010e454caac$var$Rb = null, a;
}
function $9d6a2010e454caac$var$D(a, b) {
    var c = b[$9d6a2010e454caac$var$of];
    void 0 === c && (c = b[$9d6a2010e454caac$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9d6a2010e454caac$var$pf(b, a, 2, !1), c.add(d));
}
function $9d6a2010e454caac$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9d6a2010e454caac$var$pf(c, a, d, b);
}
var $9d6a2010e454caac$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9d6a2010e454caac$var$sf(a) {
    if (!a[$9d6a2010e454caac$var$rf]) {
        a[$9d6a2010e454caac$var$rf] = !0;
        $9d6a2010e454caac$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9d6a2010e454caac$var$mf.has(b) || $9d6a2010e454caac$var$qf(b, !1, a), $9d6a2010e454caac$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9d6a2010e454caac$var$rf] || (b[$9d6a2010e454caac$var$rf] = !0, $9d6a2010e454caac$var$qf("selectionchange", !1, b));
    }
}
function $9d6a2010e454caac$var$pf(a, b, c, d) {
    switch($9d6a2010e454caac$var$jd(b)){
        case 1:
            var e = $9d6a2010e454caac$var$ed;
            break;
        case 4:
            e = $9d6a2010e454caac$var$gd;
            break;
        default:
            e = $9d6a2010e454caac$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9d6a2010e454caac$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9d6a2010e454caac$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9d6a2010e454caac$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9d6a2010e454caac$var$Jb(function() {
        var d = f, e = $9d6a2010e454caac$var$xb(c), g = [];
        a: {
            var h = $9d6a2010e454caac$var$df.get(a);
            if (void 0 !== h) {
                var k = $9d6a2010e454caac$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9d6a2010e454caac$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9d6a2010e454caac$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9d6a2010e454caac$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9d6a2010e454caac$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9d6a2010e454caac$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9d6a2010e454caac$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9d6a2010e454caac$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9d6a2010e454caac$var$Vd;
                        break;
                    case $9d6a2010e454caac$var$$e:
                    case $9d6a2010e454caac$var$af:
                    case $9d6a2010e454caac$var$bf:
                        k = $9d6a2010e454caac$var$Hd;
                        break;
                    case $9d6a2010e454caac$var$cf:
                        k = $9d6a2010e454caac$var$Xd;
                        break;
                    case "scroll":
                        k = $9d6a2010e454caac$var$vd;
                        break;
                    case "wheel":
                        k = $9d6a2010e454caac$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9d6a2010e454caac$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9d6a2010e454caac$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9d6a2010e454caac$var$Kb(w, x), null != F && t.push($9d6a2010e454caac$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9d6a2010e454caac$var$wb && (n = c.relatedTarget || c.fromElement) && ($9d6a2010e454caac$var$Wc(n) || n[$9d6a2010e454caac$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9d6a2010e454caac$var$Wc(n) : null, null !== n && (J = $9d6a2010e454caac$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9d6a2010e454caac$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9d6a2010e454caac$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9d6a2010e454caac$var$ue(k);
                        u = null == n ? h : $9d6a2010e454caac$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9d6a2010e454caac$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9d6a2010e454caac$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9d6a2010e454caac$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9d6a2010e454caac$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9d6a2010e454caac$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9d6a2010e454caac$var$vf(t);
                                x = $9d6a2010e454caac$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9d6a2010e454caac$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9d6a2010e454caac$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9d6a2010e454caac$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9d6a2010e454caac$var$ve;
                else if ($9d6a2010e454caac$var$me(h)) {
                    if ($9d6a2010e454caac$var$we) na = $9d6a2010e454caac$var$Fe;
                    else {
                        na = $9d6a2010e454caac$var$De;
                        var xa = $9d6a2010e454caac$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9d6a2010e454caac$var$Ee);
                if (na && (na = na(a, d))) {
                    $9d6a2010e454caac$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9d6a2010e454caac$var$cb(h, "number", h.value);
            }
            xa = d ? $9d6a2010e454caac$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9d6a2010e454caac$var$me(xa) || "true" === xa.contentEditable) $9d6a2010e454caac$var$Qe = xa, $9d6a2010e454caac$var$Re = d, $9d6a2010e454caac$var$Se = null;
                    break;
                case "focusout":
                    $9d6a2010e454caac$var$Se = $9d6a2010e454caac$var$Re = $9d6a2010e454caac$var$Qe = null;
                    break;
                case "mousedown":
                    $9d6a2010e454caac$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9d6a2010e454caac$var$Te = !1;
                    $9d6a2010e454caac$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9d6a2010e454caac$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9d6a2010e454caac$var$Ue(g, c, e);
            }
            var $a;
            if ($9d6a2010e454caac$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9d6a2010e454caac$var$ie ? $9d6a2010e454caac$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9d6a2010e454caac$var$de && "ko" !== c.locale && ($9d6a2010e454caac$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9d6a2010e454caac$var$ie && ($a = $9d6a2010e454caac$var$nd()) : ($9d6a2010e454caac$var$kd = e, $9d6a2010e454caac$var$ld = "value" in $9d6a2010e454caac$var$kd ? $9d6a2010e454caac$var$kd.value : $9d6a2010e454caac$var$kd.textContent, $9d6a2010e454caac$var$ie = !0)), xa = $9d6a2010e454caac$var$oe(d, ba), 0 < xa.length && (ba = new $9d6a2010e454caac$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9d6a2010e454caac$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9d6a2010e454caac$var$ce ? $9d6a2010e454caac$var$je(a, c) : $9d6a2010e454caac$var$ke(a, c)) d = $9d6a2010e454caac$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9d6a2010e454caac$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9d6a2010e454caac$var$se(g, b);
    });
}
function $9d6a2010e454caac$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9d6a2010e454caac$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9d6a2010e454caac$var$Kb(a, c), null != f && d.unshift($9d6a2010e454caac$var$tf(a, f, e)), f = $9d6a2010e454caac$var$Kb(a, b), null != f && d.push($9d6a2010e454caac$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9d6a2010e454caac$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9d6a2010e454caac$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9d6a2010e454caac$var$Kb(c, f), null != k && g.unshift($9d6a2010e454caac$var$tf(c, k, h))) : e || (k = $9d6a2010e454caac$var$Kb(c, f), null != k && g.push($9d6a2010e454caac$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9d6a2010e454caac$var$xf = /\r\n?/g, $9d6a2010e454caac$var$yf = /\u0000|\uFFFD/g;
function $9d6a2010e454caac$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9d6a2010e454caac$var$xf, "\n").replace($9d6a2010e454caac$var$yf, "");
}
function $9d6a2010e454caac$var$Af(a, b, c) {
    b = $9d6a2010e454caac$var$zf(b);
    if ($9d6a2010e454caac$var$zf(a) !== b && c) throw Error($9d6a2010e454caac$var$p(425));
}
function $9d6a2010e454caac$var$Bf() {}
var $9d6a2010e454caac$var$Cf = null, $9d6a2010e454caac$var$Df = null;
function $9d6a2010e454caac$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9d6a2010e454caac$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9d6a2010e454caac$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9d6a2010e454caac$var$Hf = "function" === typeof Promise ? Promise : void 0, $9d6a2010e454caac$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9d6a2010e454caac$var$Hf ? function(a) {
    return $9d6a2010e454caac$var$Hf.resolve(null).then(a).catch($9d6a2010e454caac$var$If);
} : $9d6a2010e454caac$var$Ff;
function $9d6a2010e454caac$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9d6a2010e454caac$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9d6a2010e454caac$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9d6a2010e454caac$var$bd(b);
}
function $9d6a2010e454caac$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9d6a2010e454caac$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9d6a2010e454caac$var$Nf = Math.random().toString(36).slice(2), $9d6a2010e454caac$var$Of = "__reactFiber$" + $9d6a2010e454caac$var$Nf, $9d6a2010e454caac$var$Pf = "__reactProps$" + $9d6a2010e454caac$var$Nf, $9d6a2010e454caac$var$uf = "__reactContainer$" + $9d6a2010e454caac$var$Nf, $9d6a2010e454caac$var$of = "__reactEvents$" + $9d6a2010e454caac$var$Nf, $9d6a2010e454caac$var$Qf = "__reactListeners$" + $9d6a2010e454caac$var$Nf, $9d6a2010e454caac$var$Rf = "__reactHandles$" + $9d6a2010e454caac$var$Nf;
function $9d6a2010e454caac$var$Wc(a) {
    var b = a[$9d6a2010e454caac$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9d6a2010e454caac$var$uf] || c[$9d6a2010e454caac$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9d6a2010e454caac$var$Mf(a); null !== a;){
                if (c = a[$9d6a2010e454caac$var$Of]) return c;
                a = $9d6a2010e454caac$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9d6a2010e454caac$var$Cb(a) {
    a = a[$9d6a2010e454caac$var$Of] || a[$9d6a2010e454caac$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9d6a2010e454caac$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9d6a2010e454caac$var$p(33));
}
function $9d6a2010e454caac$var$Db(a) {
    return a[$9d6a2010e454caac$var$Pf] || null;
}
var $9d6a2010e454caac$var$Sf = [], $9d6a2010e454caac$var$Tf = -1;
function $9d6a2010e454caac$var$Uf(a) {
    return {
        current: a
    };
}
function $9d6a2010e454caac$var$E(a) {
    0 > $9d6a2010e454caac$var$Tf || (a.current = $9d6a2010e454caac$var$Sf[$9d6a2010e454caac$var$Tf], $9d6a2010e454caac$var$Sf[$9d6a2010e454caac$var$Tf] = null, $9d6a2010e454caac$var$Tf--);
}
function $9d6a2010e454caac$var$G(a, b) {
    $9d6a2010e454caac$var$Tf++;
    $9d6a2010e454caac$var$Sf[$9d6a2010e454caac$var$Tf] = a.current;
    a.current = b;
}
var $9d6a2010e454caac$var$Vf = {}, $9d6a2010e454caac$var$H = $9d6a2010e454caac$var$Uf($9d6a2010e454caac$var$Vf), $9d6a2010e454caac$var$Wf = $9d6a2010e454caac$var$Uf(!1), $9d6a2010e454caac$var$Xf = $9d6a2010e454caac$var$Vf;
function $9d6a2010e454caac$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9d6a2010e454caac$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9d6a2010e454caac$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9d6a2010e454caac$var$$f() {
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Wf);
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$H);
}
function $9d6a2010e454caac$var$ag(a, b, c) {
    if ($9d6a2010e454caac$var$H.current !== $9d6a2010e454caac$var$Vf) throw Error($9d6a2010e454caac$var$p(168));
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$H, b);
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Wf, c);
}
function $9d6a2010e454caac$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9d6a2010e454caac$var$p(108, $9d6a2010e454caac$var$Ra(a) || "Unknown", e));
    return $9d6a2010e454caac$var$A({}, c, d);
}
function $9d6a2010e454caac$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9d6a2010e454caac$var$Vf;
    $9d6a2010e454caac$var$Xf = $9d6a2010e454caac$var$H.current;
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$H, a);
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Wf, $9d6a2010e454caac$var$Wf.current);
    return !0;
}
function $9d6a2010e454caac$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9d6a2010e454caac$var$p(169));
    c ? (a = $9d6a2010e454caac$var$bg(a, b, $9d6a2010e454caac$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Wf), $9d6a2010e454caac$var$E($9d6a2010e454caac$var$H), $9d6a2010e454caac$var$G($9d6a2010e454caac$var$H, a)) : $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Wf);
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Wf, c);
}
var $9d6a2010e454caac$var$eg = null, $9d6a2010e454caac$var$fg = !1, $9d6a2010e454caac$var$gg = !1;
function $9d6a2010e454caac$var$hg(a) {
    null === $9d6a2010e454caac$var$eg ? $9d6a2010e454caac$var$eg = [
        a
    ] : $9d6a2010e454caac$var$eg.push(a);
}
function $9d6a2010e454caac$var$ig(a) {
    $9d6a2010e454caac$var$fg = !0;
    $9d6a2010e454caac$var$hg(a);
}
function $9d6a2010e454caac$var$jg() {
    if (!$9d6a2010e454caac$var$gg && null !== $9d6a2010e454caac$var$eg) {
        $9d6a2010e454caac$var$gg = !0;
        var a = 0, b = $9d6a2010e454caac$var$C;
        try {
            var c = $9d6a2010e454caac$var$eg;
            for($9d6a2010e454caac$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9d6a2010e454caac$var$eg = null;
            $9d6a2010e454caac$var$fg = !1;
        } catch (e) {
            throw null !== $9d6a2010e454caac$var$eg && ($9d6a2010e454caac$var$eg = $9d6a2010e454caac$var$eg.slice(a + 1)), $9d6a2010e454caac$var$ac($9d6a2010e454caac$var$fc, $9d6a2010e454caac$var$jg), e;
        } finally{
            $9d6a2010e454caac$var$C = b, $9d6a2010e454caac$var$gg = !1;
        }
    }
    return null;
}
var $9d6a2010e454caac$var$kg = [], $9d6a2010e454caac$var$lg = 0, $9d6a2010e454caac$var$mg = null, $9d6a2010e454caac$var$ng = 0, $9d6a2010e454caac$var$og = [], $9d6a2010e454caac$var$pg = 0, $9d6a2010e454caac$var$qg = null, $9d6a2010e454caac$var$rg = 1, $9d6a2010e454caac$var$sg = "";
function $9d6a2010e454caac$var$tg(a, b) {
    $9d6a2010e454caac$var$kg[$9d6a2010e454caac$var$lg++] = $9d6a2010e454caac$var$ng;
    $9d6a2010e454caac$var$kg[$9d6a2010e454caac$var$lg++] = $9d6a2010e454caac$var$mg;
    $9d6a2010e454caac$var$mg = a;
    $9d6a2010e454caac$var$ng = b;
}
function $9d6a2010e454caac$var$ug(a, b, c) {
    $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg++] = $9d6a2010e454caac$var$rg;
    $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg++] = $9d6a2010e454caac$var$sg;
    $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg++] = $9d6a2010e454caac$var$qg;
    $9d6a2010e454caac$var$qg = a;
    var d = $9d6a2010e454caac$var$rg;
    a = $9d6a2010e454caac$var$sg;
    var e = 32 - $9d6a2010e454caac$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9d6a2010e454caac$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9d6a2010e454caac$var$rg = 1 << 32 - $9d6a2010e454caac$var$oc(b) + e | c << e | d;
        $9d6a2010e454caac$var$sg = f + a;
    } else $9d6a2010e454caac$var$rg = 1 << f | c << e | d, $9d6a2010e454caac$var$sg = a;
}
function $9d6a2010e454caac$var$vg(a) {
    null !== a.return && ($9d6a2010e454caac$var$tg(a, 1), $9d6a2010e454caac$var$ug(a, 1, 0));
}
function $9d6a2010e454caac$var$wg(a) {
    for(; a === $9d6a2010e454caac$var$mg;)$9d6a2010e454caac$var$mg = $9d6a2010e454caac$var$kg[--$9d6a2010e454caac$var$lg], $9d6a2010e454caac$var$kg[$9d6a2010e454caac$var$lg] = null, $9d6a2010e454caac$var$ng = $9d6a2010e454caac$var$kg[--$9d6a2010e454caac$var$lg], $9d6a2010e454caac$var$kg[$9d6a2010e454caac$var$lg] = null;
    for(; a === $9d6a2010e454caac$var$qg;)$9d6a2010e454caac$var$qg = $9d6a2010e454caac$var$og[--$9d6a2010e454caac$var$pg], $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg] = null, $9d6a2010e454caac$var$sg = $9d6a2010e454caac$var$og[--$9d6a2010e454caac$var$pg], $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg] = null, $9d6a2010e454caac$var$rg = $9d6a2010e454caac$var$og[--$9d6a2010e454caac$var$pg], $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg] = null;
}
var $9d6a2010e454caac$var$xg = null, $9d6a2010e454caac$var$yg = null, $9d6a2010e454caac$var$I = !1, $9d6a2010e454caac$var$zg = null;
function $9d6a2010e454caac$var$Ag(a, b) {
    var c = $9d6a2010e454caac$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9d6a2010e454caac$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9d6a2010e454caac$var$xg = a, $9d6a2010e454caac$var$yg = $9d6a2010e454caac$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9d6a2010e454caac$var$xg = a, $9d6a2010e454caac$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9d6a2010e454caac$var$qg ? {
                id: $9d6a2010e454caac$var$rg,
                overflow: $9d6a2010e454caac$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9d6a2010e454caac$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9d6a2010e454caac$var$xg = a, $9d6a2010e454caac$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9d6a2010e454caac$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9d6a2010e454caac$var$Eg(a) {
    if ($9d6a2010e454caac$var$I) {
        var b = $9d6a2010e454caac$var$yg;
        if (b) {
            var c = b;
            if (!$9d6a2010e454caac$var$Cg(a, b)) {
                if ($9d6a2010e454caac$var$Dg(a)) throw Error($9d6a2010e454caac$var$p(418));
                b = $9d6a2010e454caac$var$Lf(c.nextSibling);
                var d = $9d6a2010e454caac$var$xg;
                b && $9d6a2010e454caac$var$Cg(a, b) ? $9d6a2010e454caac$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9d6a2010e454caac$var$I = !1, $9d6a2010e454caac$var$xg = a);
            }
        } else {
            if ($9d6a2010e454caac$var$Dg(a)) throw Error($9d6a2010e454caac$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9d6a2010e454caac$var$I = !1;
            $9d6a2010e454caac$var$xg = a;
        }
    }
}
function $9d6a2010e454caac$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9d6a2010e454caac$var$xg = a;
}
function $9d6a2010e454caac$var$Gg(a) {
    if (a !== $9d6a2010e454caac$var$xg) return !1;
    if (!$9d6a2010e454caac$var$I) return $9d6a2010e454caac$var$Fg(a), $9d6a2010e454caac$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9d6a2010e454caac$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9d6a2010e454caac$var$yg)) {
        if ($9d6a2010e454caac$var$Dg(a)) throw $9d6a2010e454caac$var$Hg(), Error($9d6a2010e454caac$var$p(418));
        for(; b;)$9d6a2010e454caac$var$Ag(a, b), b = $9d6a2010e454caac$var$Lf(b.nextSibling);
    }
    $9d6a2010e454caac$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9d6a2010e454caac$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9d6a2010e454caac$var$yg = $9d6a2010e454caac$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9d6a2010e454caac$var$yg = null;
        }
    } else $9d6a2010e454caac$var$yg = $9d6a2010e454caac$var$xg ? $9d6a2010e454caac$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9d6a2010e454caac$var$Hg() {
    for(var a = $9d6a2010e454caac$var$yg; a;)a = $9d6a2010e454caac$var$Lf(a.nextSibling);
}
function $9d6a2010e454caac$var$Ig() {
    $9d6a2010e454caac$var$yg = $9d6a2010e454caac$var$xg = null;
    $9d6a2010e454caac$var$I = !1;
}
function $9d6a2010e454caac$var$Jg(a) {
    null === $9d6a2010e454caac$var$zg ? $9d6a2010e454caac$var$zg = [
        a
    ] : $9d6a2010e454caac$var$zg.push(a);
}
var $9d6a2010e454caac$var$Kg = $9d6a2010e454caac$var$ua.ReactCurrentBatchConfig;
function $9d6a2010e454caac$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $9d6a2010e454caac$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $9d6a2010e454caac$var$Mg = $9d6a2010e454caac$var$Uf(null), $9d6a2010e454caac$var$Ng = null, $9d6a2010e454caac$var$Og = null, $9d6a2010e454caac$var$Pg = null;
function $9d6a2010e454caac$var$Qg() {
    $9d6a2010e454caac$var$Pg = $9d6a2010e454caac$var$Og = $9d6a2010e454caac$var$Ng = null;
}
function $9d6a2010e454caac$var$Rg(a) {
    var b = $9d6a2010e454caac$var$Mg.current;
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Mg);
    a._currentValue = b;
}
function $9d6a2010e454caac$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9d6a2010e454caac$var$Tg(a, b) {
    $9d6a2010e454caac$var$Ng = a;
    $9d6a2010e454caac$var$Pg = $9d6a2010e454caac$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9d6a2010e454caac$var$Ug = !0), a.firstContext = null);
}
function $9d6a2010e454caac$var$Vg(a) {
    var b = a._currentValue;
    if ($9d6a2010e454caac$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9d6a2010e454caac$var$Og) {
            if (null === $9d6a2010e454caac$var$Ng) throw Error($9d6a2010e454caac$var$p(308));
            $9d6a2010e454caac$var$Og = a;
            $9d6a2010e454caac$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9d6a2010e454caac$var$Og = $9d6a2010e454caac$var$Og.next = a;
    }
    return b;
}
var $9d6a2010e454caac$var$Wg = null;
function $9d6a2010e454caac$var$Xg(a) {
    null === $9d6a2010e454caac$var$Wg ? $9d6a2010e454caac$var$Wg = [
        a
    ] : $9d6a2010e454caac$var$Wg.push(a);
}
function $9d6a2010e454caac$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9d6a2010e454caac$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9d6a2010e454caac$var$Zg(a, d);
}
function $9d6a2010e454caac$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9d6a2010e454caac$var$$g = !1;
function $9d6a2010e454caac$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9d6a2010e454caac$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9d6a2010e454caac$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9d6a2010e454caac$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9d6a2010e454caac$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9d6a2010e454caac$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9d6a2010e454caac$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9d6a2010e454caac$var$Zg(a, c);
}
function $9d6a2010e454caac$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9d6a2010e454caac$var$Cc(a, c);
    }
}
function $9d6a2010e454caac$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9d6a2010e454caac$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $9d6a2010e454caac$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9d6a2010e454caac$var$A({}, q, r);
                            break a;
                        case 2:
                            $9d6a2010e454caac$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9d6a2010e454caac$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9d6a2010e454caac$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9d6a2010e454caac$var$p(191, e));
            e.call(d);
        }
    }
}
var $9d6a2010e454caac$var$jh = (new $2hDQc.Component).refs;
function $9d6a2010e454caac$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9d6a2010e454caac$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9d6a2010e454caac$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9d6a2010e454caac$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9d6a2010e454caac$var$L(), e = $9d6a2010e454caac$var$lh(a), f = $9d6a2010e454caac$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9d6a2010e454caac$var$dh(a, f, e);
        null !== b && ($9d6a2010e454caac$var$mh(b, a, e, d), $9d6a2010e454caac$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9d6a2010e454caac$var$L(), e = $9d6a2010e454caac$var$lh(a), f = $9d6a2010e454caac$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9d6a2010e454caac$var$dh(a, f, e);
        null !== b && ($9d6a2010e454caac$var$mh(b, a, e, d), $9d6a2010e454caac$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9d6a2010e454caac$var$L(), d = $9d6a2010e454caac$var$lh(a), e = $9d6a2010e454caac$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9d6a2010e454caac$var$dh(a, e, d);
        null !== b && ($9d6a2010e454caac$var$mh(b, a, d, c), $9d6a2010e454caac$var$eh(b, a, d));
    }
};
function $9d6a2010e454caac$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9d6a2010e454caac$var$Ie(c, d) || !$9d6a2010e454caac$var$Ie(e, f) : !0;
}
function $9d6a2010e454caac$var$ph(a, b, c) {
    var d = !1, e = $9d6a2010e454caac$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9d6a2010e454caac$var$Vg(f) : (e = $9d6a2010e454caac$var$Zf(b) ? $9d6a2010e454caac$var$Xf : $9d6a2010e454caac$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9d6a2010e454caac$var$Yf(a, e) : $9d6a2010e454caac$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9d6a2010e454caac$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9d6a2010e454caac$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9d6a2010e454caac$var$nh.enqueueReplaceState(b, b.state, null);
}
function $9d6a2010e454caac$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $9d6a2010e454caac$var$jh;
    $9d6a2010e454caac$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9d6a2010e454caac$var$Vg(f) : (f = $9d6a2010e454caac$var$Zf(b) ? $9d6a2010e454caac$var$Xf : $9d6a2010e454caac$var$H.current, e.context = $9d6a2010e454caac$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9d6a2010e454caac$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9d6a2010e454caac$var$nh.enqueueReplaceState(e, e.state, null), $9d6a2010e454caac$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9d6a2010e454caac$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9d6a2010e454caac$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9d6a2010e454caac$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $9d6a2010e454caac$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9d6a2010e454caac$var$p(284));
        if (!c._owner) throw Error($9d6a2010e454caac$var$p(290, a));
    }
    return a;
}
function $9d6a2010e454caac$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9d6a2010e454caac$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9d6a2010e454caac$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $9d6a2010e454caac$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9d6a2010e454caac$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9d6a2010e454caac$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9d6a2010e454caac$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9d6a2010e454caac$var$Ha && $9d6a2010e454caac$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $9d6a2010e454caac$var$sh(a, b, c), d.return = a, d;
        d = $9d6a2010e454caac$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9d6a2010e454caac$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9d6a2010e454caac$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9d6a2010e454caac$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9d6a2010e454caac$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9d6a2010e454caac$var$va:
                    return c = $9d6a2010e454caac$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $9d6a2010e454caac$var$sh(a, null, b), c.return = a, c;
                case $9d6a2010e454caac$var$wa:
                    return b = $9d6a2010e454caac$var$zh(b, a.mode, c), b.return = a, b;
                case $9d6a2010e454caac$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9d6a2010e454caac$var$eb(b) || $9d6a2010e454caac$var$Ka(b)) return b = $9d6a2010e454caac$var$Ah(b, a.mode, c, null), b.return = a, b;
            $9d6a2010e454caac$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9d6a2010e454caac$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9d6a2010e454caac$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9d6a2010e454caac$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9d6a2010e454caac$var$eb(c) || $9d6a2010e454caac$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9d6a2010e454caac$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9d6a2010e454caac$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9d6a2010e454caac$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9d6a2010e454caac$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9d6a2010e454caac$var$eb(d) || $9d6a2010e454caac$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9d6a2010e454caac$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9d6a2010e454caac$var$I && $9d6a2010e454caac$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9d6a2010e454caac$var$I && $9d6a2010e454caac$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9d6a2010e454caac$var$I && $9d6a2010e454caac$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9d6a2010e454caac$var$Ka(h);
        if ("function" !== typeof l) throw Error($9d6a2010e454caac$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9d6a2010e454caac$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9d6a2010e454caac$var$I && $9d6a2010e454caac$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9d6a2010e454caac$var$I && $9d6a2010e454caac$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9d6a2010e454caac$var$I && $9d6a2010e454caac$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9d6a2010e454caac$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9d6a2010e454caac$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9d6a2010e454caac$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9d6a2010e454caac$var$Ha && $9d6a2010e454caac$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9d6a2010e454caac$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9d6a2010e454caac$var$ya ? (d = $9d6a2010e454caac$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9d6a2010e454caac$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $9d6a2010e454caac$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9d6a2010e454caac$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9d6a2010e454caac$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9d6a2010e454caac$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9d6a2010e454caac$var$eb(f)) return n(a, d, f, h);
            if ($9d6a2010e454caac$var$Ka(f)) return t(a, d, f, h);
            $9d6a2010e454caac$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9d6a2010e454caac$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9d6a2010e454caac$var$Bh = $9d6a2010e454caac$var$vh(!0), $9d6a2010e454caac$var$Ch = $9d6a2010e454caac$var$vh(!1), $9d6a2010e454caac$var$Dh = {}, $9d6a2010e454caac$var$Eh = $9d6a2010e454caac$var$Uf($9d6a2010e454caac$var$Dh), $9d6a2010e454caac$var$Fh = $9d6a2010e454caac$var$Uf($9d6a2010e454caac$var$Dh), $9d6a2010e454caac$var$Gh = $9d6a2010e454caac$var$Uf($9d6a2010e454caac$var$Dh);
function $9d6a2010e454caac$var$Hh(a) {
    if (a === $9d6a2010e454caac$var$Dh) throw Error($9d6a2010e454caac$var$p(174));
    return a;
}
function $9d6a2010e454caac$var$Ih(a, b) {
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Gh, b);
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Fh, a);
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Eh, $9d6a2010e454caac$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9d6a2010e454caac$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9d6a2010e454caac$var$lb(b, a);
    }
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Eh);
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Eh, b);
}
function $9d6a2010e454caac$var$Jh() {
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Eh);
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Fh);
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Gh);
}
function $9d6a2010e454caac$var$Kh(a) {
    $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Gh.current);
    var b = $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Eh.current);
    var c = $9d6a2010e454caac$var$lb(b, a.type);
    b !== c && ($9d6a2010e454caac$var$G($9d6a2010e454caac$var$Fh, a), $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Eh, c));
}
function $9d6a2010e454caac$var$Lh(a) {
    $9d6a2010e454caac$var$Fh.current === a && ($9d6a2010e454caac$var$E($9d6a2010e454caac$var$Eh), $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Fh));
}
var $9d6a2010e454caac$var$M = $9d6a2010e454caac$var$Uf(0);
function $9d6a2010e454caac$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9d6a2010e454caac$var$Nh = [];
function $9d6a2010e454caac$var$Oh() {
    for(var a = 0; a < $9d6a2010e454caac$var$Nh.length; a++)$9d6a2010e454caac$var$Nh[a]._workInProgressVersionPrimary = null;
    $9d6a2010e454caac$var$Nh.length = 0;
}
var $9d6a2010e454caac$var$Ph = $9d6a2010e454caac$var$ua.ReactCurrentDispatcher, $9d6a2010e454caac$var$Qh = $9d6a2010e454caac$var$ua.ReactCurrentBatchConfig, $9d6a2010e454caac$var$Rh = 0, $9d6a2010e454caac$var$N = null, $9d6a2010e454caac$var$O = null, $9d6a2010e454caac$var$P = null, $9d6a2010e454caac$var$Sh = !1, $9d6a2010e454caac$var$Th = !1, $9d6a2010e454caac$var$Uh = 0, $9d6a2010e454caac$var$Vh = 0;
function $9d6a2010e454caac$var$Q() {
    throw Error($9d6a2010e454caac$var$p(321));
}
function $9d6a2010e454caac$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9d6a2010e454caac$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9d6a2010e454caac$var$Xh(a, b, c, d, e, f) {
    $9d6a2010e454caac$var$Rh = f;
    $9d6a2010e454caac$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9d6a2010e454caac$var$Ph.current = null === a || null === a.memoizedState ? $9d6a2010e454caac$var$Yh : $9d6a2010e454caac$var$Zh;
    a = c(d, e);
    if ($9d6a2010e454caac$var$Th) {
        f = 0;
        do {
            $9d6a2010e454caac$var$Th = !1;
            $9d6a2010e454caac$var$Uh = 0;
            if (25 <= f) throw Error($9d6a2010e454caac$var$p(301));
            f += 1;
            $9d6a2010e454caac$var$P = $9d6a2010e454caac$var$O = null;
            b.updateQueue = null;
            $9d6a2010e454caac$var$Ph.current = $9d6a2010e454caac$var$$h;
            a = c(d, e);
        }while ($9d6a2010e454caac$var$Th);
    }
    $9d6a2010e454caac$var$Ph.current = $9d6a2010e454caac$var$ai;
    b = null !== $9d6a2010e454caac$var$O && null !== $9d6a2010e454caac$var$O.next;
    $9d6a2010e454caac$var$Rh = 0;
    $9d6a2010e454caac$var$P = $9d6a2010e454caac$var$O = $9d6a2010e454caac$var$N = null;
    $9d6a2010e454caac$var$Sh = !1;
    if (b) throw Error($9d6a2010e454caac$var$p(300));
    return a;
}
function $9d6a2010e454caac$var$bi() {
    var a = 0 !== $9d6a2010e454caac$var$Uh;
    $9d6a2010e454caac$var$Uh = 0;
    return a;
}
function $9d6a2010e454caac$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9d6a2010e454caac$var$P ? $9d6a2010e454caac$var$N.memoizedState = $9d6a2010e454caac$var$P = a : $9d6a2010e454caac$var$P = $9d6a2010e454caac$var$P.next = a;
    return $9d6a2010e454caac$var$P;
}
function $9d6a2010e454caac$var$di() {
    if (null === $9d6a2010e454caac$var$O) {
        var a = $9d6a2010e454caac$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9d6a2010e454caac$var$O.next;
    var b = null === $9d6a2010e454caac$var$P ? $9d6a2010e454caac$var$N.memoizedState : $9d6a2010e454caac$var$P.next;
    if (null !== b) $9d6a2010e454caac$var$P = b, $9d6a2010e454caac$var$O = a;
    else {
        if (null === a) throw Error($9d6a2010e454caac$var$p(310));
        $9d6a2010e454caac$var$O = a;
        a = {
            memoizedState: $9d6a2010e454caac$var$O.memoizedState,
            baseState: $9d6a2010e454caac$var$O.baseState,
            baseQueue: $9d6a2010e454caac$var$O.baseQueue,
            queue: $9d6a2010e454caac$var$O.queue,
            next: null
        };
        null === $9d6a2010e454caac$var$P ? $9d6a2010e454caac$var$N.memoizedState = $9d6a2010e454caac$var$P = a : $9d6a2010e454caac$var$P = $9d6a2010e454caac$var$P.next = a;
    }
    return $9d6a2010e454caac$var$P;
}
function $9d6a2010e454caac$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9d6a2010e454caac$var$fi(a) {
    var b = $9d6a2010e454caac$var$di(), c = b.queue;
    if (null === c) throw Error($9d6a2010e454caac$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9d6a2010e454caac$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9d6a2010e454caac$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9d6a2010e454caac$var$N.lanes |= m;
                $9d6a2010e454caac$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9d6a2010e454caac$var$He(d, b.memoizedState) || ($9d6a2010e454caac$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9d6a2010e454caac$var$N.lanes |= f, $9d6a2010e454caac$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9d6a2010e454caac$var$gi(a) {
    var b = $9d6a2010e454caac$var$di(), c = b.queue;
    if (null === c) throw Error($9d6a2010e454caac$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9d6a2010e454caac$var$He(f, b.memoizedState) || ($9d6a2010e454caac$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9d6a2010e454caac$var$hi() {}
function $9d6a2010e454caac$var$ii(a, b) {
    var c = $9d6a2010e454caac$var$N, d = $9d6a2010e454caac$var$di(), e = b(), f = !$9d6a2010e454caac$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9d6a2010e454caac$var$Ug = !0);
    d = d.queue;
    $9d6a2010e454caac$var$ji($9d6a2010e454caac$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9d6a2010e454caac$var$P && $9d6a2010e454caac$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9d6a2010e454caac$var$li(9, $9d6a2010e454caac$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $9d6a2010e454caac$var$R) throw Error($9d6a2010e454caac$var$p(349));
        0 !== ($9d6a2010e454caac$var$Rh & 30) || $9d6a2010e454caac$var$ni(c, b, e);
    }
    return e;
}
function $9d6a2010e454caac$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9d6a2010e454caac$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9d6a2010e454caac$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9d6a2010e454caac$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9d6a2010e454caac$var$oi(b) && $9d6a2010e454caac$var$pi(a);
}
function $9d6a2010e454caac$var$ki(a, b, c) {
    return c(function() {
        $9d6a2010e454caac$var$oi(b) && $9d6a2010e454caac$var$pi(a);
    });
}
function $9d6a2010e454caac$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9d6a2010e454caac$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9d6a2010e454caac$var$pi(a) {
    var b = $9d6a2010e454caac$var$Zg(a, 1);
    null !== b && $9d6a2010e454caac$var$mh(b, a, 1, -1);
}
function $9d6a2010e454caac$var$qi(a) {
    var b = $9d6a2010e454caac$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9d6a2010e454caac$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9d6a2010e454caac$var$ri.bind(null, $9d6a2010e454caac$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9d6a2010e454caac$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9d6a2010e454caac$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9d6a2010e454caac$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9d6a2010e454caac$var$si() {
    return $9d6a2010e454caac$var$di().memoizedState;
}
function $9d6a2010e454caac$var$ti(a, b, c, d) {
    var e = $9d6a2010e454caac$var$ci();
    $9d6a2010e454caac$var$N.flags |= a;
    e.memoizedState = $9d6a2010e454caac$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9d6a2010e454caac$var$ui(a, b, c, d) {
    var e = $9d6a2010e454caac$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9d6a2010e454caac$var$O) {
        var g = $9d6a2010e454caac$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $9d6a2010e454caac$var$Wh(d, g.deps)) {
            e.memoizedState = $9d6a2010e454caac$var$li(b, c, f, d);
            return;
        }
    }
    $9d6a2010e454caac$var$N.flags |= a;
    e.memoizedState = $9d6a2010e454caac$var$li(1 | b, c, f, d);
}
function $9d6a2010e454caac$var$vi(a, b) {
    return $9d6a2010e454caac$var$ti(8390656, 8, a, b);
}
function $9d6a2010e454caac$var$ji(a, b) {
    return $9d6a2010e454caac$var$ui(2048, 8, a, b);
}
function $9d6a2010e454caac$var$wi(a, b) {
    return $9d6a2010e454caac$var$ui(4, 2, a, b);
}
function $9d6a2010e454caac$var$xi(a, b) {
    return $9d6a2010e454caac$var$ui(4, 4, a, b);
}
function $9d6a2010e454caac$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9d6a2010e454caac$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9d6a2010e454caac$var$ui(4, 4, $9d6a2010e454caac$var$yi.bind(null, b, a), c);
}
function $9d6a2010e454caac$var$Ai() {}
function $9d6a2010e454caac$var$Bi(a, b) {
    var c = $9d6a2010e454caac$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9d6a2010e454caac$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9d6a2010e454caac$var$Ci(a, b) {
    var c = $9d6a2010e454caac$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9d6a2010e454caac$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9d6a2010e454caac$var$Di(a, b, c) {
    if (0 === ($9d6a2010e454caac$var$Rh & 21)) return a.baseState && (a.baseState = !1, $9d6a2010e454caac$var$Ug = !0), a.memoizedState = c;
    $9d6a2010e454caac$var$He(c, b) || (c = $9d6a2010e454caac$var$yc(), $9d6a2010e454caac$var$N.lanes |= c, $9d6a2010e454caac$var$hh |= c, a.baseState = !0);
    return b;
}
function $9d6a2010e454caac$var$Ei(a, b) {
    var c = $9d6a2010e454caac$var$C;
    $9d6a2010e454caac$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9d6a2010e454caac$var$Qh.transition;
    $9d6a2010e454caac$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9d6a2010e454caac$var$C = c, $9d6a2010e454caac$var$Qh.transition = d;
    }
}
function $9d6a2010e454caac$var$Fi() {
    return $9d6a2010e454caac$var$di().memoizedState;
}
function $9d6a2010e454caac$var$Gi(a, b, c) {
    var d = $9d6a2010e454caac$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9d6a2010e454caac$var$Hi(a)) $9d6a2010e454caac$var$Ii(b, c);
    else if (c = $9d6a2010e454caac$var$Yg(a, b, c, d), null !== c) {
        var e = $9d6a2010e454caac$var$L();
        $9d6a2010e454caac$var$mh(c, a, d, e);
        $9d6a2010e454caac$var$Ji(c, b, d);
    }
}
function $9d6a2010e454caac$var$ri(a, b, c) {
    var d = $9d6a2010e454caac$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9d6a2010e454caac$var$Hi(a)) $9d6a2010e454caac$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9d6a2010e454caac$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9d6a2010e454caac$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9d6a2010e454caac$var$Yg(a, b, e, d);
        null !== c && (e = $9d6a2010e454caac$var$L(), $9d6a2010e454caac$var$mh(c, a, d, e), $9d6a2010e454caac$var$Ji(c, b, d));
    }
}
function $9d6a2010e454caac$var$Hi(a) {
    var b = a.alternate;
    return a === $9d6a2010e454caac$var$N || null !== b && b === $9d6a2010e454caac$var$N;
}
function $9d6a2010e454caac$var$Ii(a, b) {
    $9d6a2010e454caac$var$Th = $9d6a2010e454caac$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9d6a2010e454caac$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9d6a2010e454caac$var$Cc(a, c);
    }
}
var $9d6a2010e454caac$var$ai = {
    readContext: $9d6a2010e454caac$var$Vg,
    useCallback: $9d6a2010e454caac$var$Q,
    useContext: $9d6a2010e454caac$var$Q,
    useEffect: $9d6a2010e454caac$var$Q,
    useImperativeHandle: $9d6a2010e454caac$var$Q,
    useInsertionEffect: $9d6a2010e454caac$var$Q,
    useLayoutEffect: $9d6a2010e454caac$var$Q,
    useMemo: $9d6a2010e454caac$var$Q,
    useReducer: $9d6a2010e454caac$var$Q,
    useRef: $9d6a2010e454caac$var$Q,
    useState: $9d6a2010e454caac$var$Q,
    useDebugValue: $9d6a2010e454caac$var$Q,
    useDeferredValue: $9d6a2010e454caac$var$Q,
    useTransition: $9d6a2010e454caac$var$Q,
    useMutableSource: $9d6a2010e454caac$var$Q,
    useSyncExternalStore: $9d6a2010e454caac$var$Q,
    useId: $9d6a2010e454caac$var$Q,
    unstable_isNewReconciler: !1
}, $9d6a2010e454caac$var$Yh = {
    readContext: $9d6a2010e454caac$var$Vg,
    useCallback: function(a, b) {
        $9d6a2010e454caac$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9d6a2010e454caac$var$Vg,
    useEffect: $9d6a2010e454caac$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9d6a2010e454caac$var$ti(4194308, 4, $9d6a2010e454caac$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9d6a2010e454caac$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9d6a2010e454caac$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9d6a2010e454caac$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9d6a2010e454caac$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9d6a2010e454caac$var$Gi.bind(null, $9d6a2010e454caac$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9d6a2010e454caac$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9d6a2010e454caac$var$qi,
    useDebugValue: $9d6a2010e454caac$var$Ai,
    useDeferredValue: function(a) {
        return $9d6a2010e454caac$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $9d6a2010e454caac$var$qi(!1), b = a[0];
        a = $9d6a2010e454caac$var$Ei.bind(null, a[1]);
        $9d6a2010e454caac$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9d6a2010e454caac$var$N, e = $9d6a2010e454caac$var$ci();
        if ($9d6a2010e454caac$var$I) {
            if (void 0 === c) throw Error($9d6a2010e454caac$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9d6a2010e454caac$var$R) throw Error($9d6a2010e454caac$var$p(349));
            0 !== ($9d6a2010e454caac$var$Rh & 30) || $9d6a2010e454caac$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9d6a2010e454caac$var$vi($9d6a2010e454caac$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9d6a2010e454caac$var$li(9, $9d6a2010e454caac$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9d6a2010e454caac$var$ci(), b = $9d6a2010e454caac$var$R.identifierPrefix;
        if ($9d6a2010e454caac$var$I) {
            var c = $9d6a2010e454caac$var$sg;
            var d = $9d6a2010e454caac$var$rg;
            c = (d & ~(1 << 32 - $9d6a2010e454caac$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9d6a2010e454caac$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9d6a2010e454caac$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9d6a2010e454caac$var$Zh = {
    readContext: $9d6a2010e454caac$var$Vg,
    useCallback: $9d6a2010e454caac$var$Bi,
    useContext: $9d6a2010e454caac$var$Vg,
    useEffect: $9d6a2010e454caac$var$ji,
    useImperativeHandle: $9d6a2010e454caac$var$zi,
    useInsertionEffect: $9d6a2010e454caac$var$wi,
    useLayoutEffect: $9d6a2010e454caac$var$xi,
    useMemo: $9d6a2010e454caac$var$Ci,
    useReducer: $9d6a2010e454caac$var$fi,
    useRef: $9d6a2010e454caac$var$si,
    useState: function() {
        return $9d6a2010e454caac$var$fi($9d6a2010e454caac$var$ei);
    },
    useDebugValue: $9d6a2010e454caac$var$Ai,
    useDeferredValue: function(a) {
        var b = $9d6a2010e454caac$var$di();
        return $9d6a2010e454caac$var$Di(b, $9d6a2010e454caac$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9d6a2010e454caac$var$fi($9d6a2010e454caac$var$ei)[0], b = $9d6a2010e454caac$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9d6a2010e454caac$var$hi,
    useSyncExternalStore: $9d6a2010e454caac$var$ii,
    useId: $9d6a2010e454caac$var$Fi,
    unstable_isNewReconciler: !1
}, $9d6a2010e454caac$var$$h = {
    readContext: $9d6a2010e454caac$var$Vg,
    useCallback: $9d6a2010e454caac$var$Bi,
    useContext: $9d6a2010e454caac$var$Vg,
    useEffect: $9d6a2010e454caac$var$ji,
    useImperativeHandle: $9d6a2010e454caac$var$zi,
    useInsertionEffect: $9d6a2010e454caac$var$wi,
    useLayoutEffect: $9d6a2010e454caac$var$xi,
    useMemo: $9d6a2010e454caac$var$Ci,
    useReducer: $9d6a2010e454caac$var$gi,
    useRef: $9d6a2010e454caac$var$si,
    useState: function() {
        return $9d6a2010e454caac$var$gi($9d6a2010e454caac$var$ei);
    },
    useDebugValue: $9d6a2010e454caac$var$Ai,
    useDeferredValue: function(a) {
        var b = $9d6a2010e454caac$var$di();
        return null === $9d6a2010e454caac$var$O ? b.memoizedState = a : $9d6a2010e454caac$var$Di(b, $9d6a2010e454caac$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9d6a2010e454caac$var$gi($9d6a2010e454caac$var$ei)[0], b = $9d6a2010e454caac$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9d6a2010e454caac$var$hi,
    useSyncExternalStore: $9d6a2010e454caac$var$ii,
    useId: $9d6a2010e454caac$var$Fi,
    unstable_isNewReconciler: !1
};
function $9d6a2010e454caac$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $9d6a2010e454caac$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9d6a2010e454caac$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9d6a2010e454caac$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9d6a2010e454caac$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $9d6a2010e454caac$var$Oi(a, b, c) {
    c = $9d6a2010e454caac$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9d6a2010e454caac$var$Pi || ($9d6a2010e454caac$var$Pi = !0, $9d6a2010e454caac$var$Qi = d);
        $9d6a2010e454caac$var$Mi(a, b);
    };
    return c;
}
function $9d6a2010e454caac$var$Ri(a, b, c) {
    c = $9d6a2010e454caac$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9d6a2010e454caac$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9d6a2010e454caac$var$Mi(a, b);
        "function" !== typeof d && (null === $9d6a2010e454caac$var$Si ? $9d6a2010e454caac$var$Si = new Set([
            this
        ]) : $9d6a2010e454caac$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9d6a2010e454caac$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9d6a2010e454caac$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9d6a2010e454caac$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $9d6a2010e454caac$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9d6a2010e454caac$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9d6a2010e454caac$var$ch(-1, 1), b.tag = 2, $9d6a2010e454caac$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9d6a2010e454caac$var$Xi = $9d6a2010e454caac$var$ua.ReactCurrentOwner, $9d6a2010e454caac$var$Ug = !1;
function $9d6a2010e454caac$var$Yi(a, b, c, d) {
    b.child = null === a ? $9d6a2010e454caac$var$Ch(b, null, c, d) : $9d6a2010e454caac$var$Bh(b, a.child, c, d);
}
function $9d6a2010e454caac$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9d6a2010e454caac$var$Tg(b, e);
    d = $9d6a2010e454caac$var$Xh(a, b, c, d, f, e);
    c = $9d6a2010e454caac$var$bi();
    if (null !== a && !$9d6a2010e454caac$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9d6a2010e454caac$var$$i(a, b, e);
    $9d6a2010e454caac$var$I && c && $9d6a2010e454caac$var$vg(b);
    b.flags |= 1;
    $9d6a2010e454caac$var$Yi(a, b, d, e);
    return b.child;
}
function $9d6a2010e454caac$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9d6a2010e454caac$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9d6a2010e454caac$var$cj(a, b, f, d, e);
        a = $9d6a2010e454caac$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9d6a2010e454caac$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9d6a2010e454caac$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $9d6a2010e454caac$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9d6a2010e454caac$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9d6a2010e454caac$var$Ie(f, d) && a.ref === b.ref) {
            if ($9d6a2010e454caac$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9d6a2010e454caac$var$Ug = !0);
            else return b.lanes = a.lanes, $9d6a2010e454caac$var$$i(a, b, e);
        }
    }
    return $9d6a2010e454caac$var$dj(a, b, c, d, e);
}
function $9d6a2010e454caac$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9d6a2010e454caac$var$G($9d6a2010e454caac$var$fj, $9d6a2010e454caac$var$gj), $9d6a2010e454caac$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9d6a2010e454caac$var$G($9d6a2010e454caac$var$fj, $9d6a2010e454caac$var$gj), $9d6a2010e454caac$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9d6a2010e454caac$var$G($9d6a2010e454caac$var$fj, $9d6a2010e454caac$var$gj);
            $9d6a2010e454caac$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9d6a2010e454caac$var$G($9d6a2010e454caac$var$fj, $9d6a2010e454caac$var$gj), $9d6a2010e454caac$var$gj |= d;
    $9d6a2010e454caac$var$Yi(a, b, e, c);
    return b.child;
}
function $9d6a2010e454caac$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9d6a2010e454caac$var$dj(a, b, c, d, e) {
    var f = $9d6a2010e454caac$var$Zf(c) ? $9d6a2010e454caac$var$Xf : $9d6a2010e454caac$var$H.current;
    f = $9d6a2010e454caac$var$Yf(b, f);
    $9d6a2010e454caac$var$Tg(b, e);
    c = $9d6a2010e454caac$var$Xh(a, b, c, d, f, e);
    d = $9d6a2010e454caac$var$bi();
    if (null !== a && !$9d6a2010e454caac$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9d6a2010e454caac$var$$i(a, b, e);
    $9d6a2010e454caac$var$I && d && $9d6a2010e454caac$var$vg(b);
    b.flags |= 1;
    $9d6a2010e454caac$var$Yi(a, b, c, e);
    return b.child;
}
function $9d6a2010e454caac$var$ij(a, b, c, d, e) {
    if ($9d6a2010e454caac$var$Zf(c)) {
        var f = !0;
        $9d6a2010e454caac$var$cg(b);
    } else f = !1;
    $9d6a2010e454caac$var$Tg(b, e);
    if (null === b.stateNode) $9d6a2010e454caac$var$jj(a, b), $9d6a2010e454caac$var$ph(b, c, d), $9d6a2010e454caac$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9d6a2010e454caac$var$Vg(l) : (l = $9d6a2010e454caac$var$Zf(c) ? $9d6a2010e454caac$var$Xf : $9d6a2010e454caac$var$H.current, l = $9d6a2010e454caac$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9d6a2010e454caac$var$qh(b, g, d, l);
        $9d6a2010e454caac$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $9d6a2010e454caac$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9d6a2010e454caac$var$Wf.current || $9d6a2010e454caac$var$$g ? ("function" === typeof m && ($9d6a2010e454caac$var$kh(b, c, m, d), k = b.memoizedState), (h = $9d6a2010e454caac$var$$g || $9d6a2010e454caac$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9d6a2010e454caac$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9d6a2010e454caac$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9d6a2010e454caac$var$Vg(k) : (k = $9d6a2010e454caac$var$Zf(c) ? $9d6a2010e454caac$var$Xf : $9d6a2010e454caac$var$H.current, k = $9d6a2010e454caac$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9d6a2010e454caac$var$qh(b, g, d, k);
        $9d6a2010e454caac$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $9d6a2010e454caac$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9d6a2010e454caac$var$Wf.current || $9d6a2010e454caac$var$$g ? ("function" === typeof y && ($9d6a2010e454caac$var$kh(b, c, y, d), n = b.memoizedState), (l = $9d6a2010e454caac$var$$g || $9d6a2010e454caac$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9d6a2010e454caac$var$kj(a, b, c, d, f, e);
}
function $9d6a2010e454caac$var$kj(a, b, c, d, e, f) {
    $9d6a2010e454caac$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9d6a2010e454caac$var$dg(b, c, !1), $9d6a2010e454caac$var$$i(a, b, f);
    d = b.stateNode;
    $9d6a2010e454caac$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9d6a2010e454caac$var$Bh(b, a.child, null, f), b.child = $9d6a2010e454caac$var$Bh(b, null, h, f)) : $9d6a2010e454caac$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9d6a2010e454caac$var$dg(b, c, !0);
    return b.child;
}
function $9d6a2010e454caac$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9d6a2010e454caac$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9d6a2010e454caac$var$ag(a, b.context, !1);
    $9d6a2010e454caac$var$Ih(a, b.containerInfo);
}
function $9d6a2010e454caac$var$mj(a, b, c, d, e) {
    $9d6a2010e454caac$var$Ig();
    $9d6a2010e454caac$var$Jg(e);
    b.flags |= 256;
    $9d6a2010e454caac$var$Yi(a, b, c, d);
    return b.child;
}
var $9d6a2010e454caac$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9d6a2010e454caac$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9d6a2010e454caac$var$pj(a, b, c) {
    var d = b.pendingProps, e = $9d6a2010e454caac$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, e & 1);
    if (null === a) {
        $9d6a2010e454caac$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9d6a2010e454caac$var$qj(g, d, 0, null), a = $9d6a2010e454caac$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9d6a2010e454caac$var$oj(c), b.memoizedState = $9d6a2010e454caac$var$nj, a) : $9d6a2010e454caac$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9d6a2010e454caac$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9d6a2010e454caac$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9d6a2010e454caac$var$wh(h, f) : (f = $9d6a2010e454caac$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9d6a2010e454caac$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9d6a2010e454caac$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9d6a2010e454caac$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9d6a2010e454caac$var$rj(a, b) {
    b = $9d6a2010e454caac$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9d6a2010e454caac$var$tj(a, b, c, d) {
    null !== d && $9d6a2010e454caac$var$Jg(d);
    $9d6a2010e454caac$var$Bh(b, a.child, null, c);
    a = $9d6a2010e454caac$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9d6a2010e454caac$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9d6a2010e454caac$var$Li(Error($9d6a2010e454caac$var$p(422))), $9d6a2010e454caac$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9d6a2010e454caac$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9d6a2010e454caac$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9d6a2010e454caac$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $9d6a2010e454caac$var$oj(g);
        b.memoizedState = $9d6a2010e454caac$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9d6a2010e454caac$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9d6a2010e454caac$var$p(419));
        d = $9d6a2010e454caac$var$Li(f, d, void 0);
        return $9d6a2010e454caac$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9d6a2010e454caac$var$Ug || h) {
        d = $9d6a2010e454caac$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9d6a2010e454caac$var$Zg(a, e), $9d6a2010e454caac$var$mh(d, a, e, -1));
        }
        $9d6a2010e454caac$var$uj();
        d = $9d6a2010e454caac$var$Li(Error($9d6a2010e454caac$var$p(421)));
        return $9d6a2010e454caac$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9d6a2010e454caac$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9d6a2010e454caac$var$yg = $9d6a2010e454caac$var$Lf(e.nextSibling);
    $9d6a2010e454caac$var$xg = b;
    $9d6a2010e454caac$var$I = !0;
    $9d6a2010e454caac$var$zg = null;
    null !== a && ($9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg++] = $9d6a2010e454caac$var$rg, $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg++] = $9d6a2010e454caac$var$sg, $9d6a2010e454caac$var$og[$9d6a2010e454caac$var$pg++] = $9d6a2010e454caac$var$qg, $9d6a2010e454caac$var$rg = a.id, $9d6a2010e454caac$var$sg = a.overflow, $9d6a2010e454caac$var$qg = b);
    b = $9d6a2010e454caac$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9d6a2010e454caac$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9d6a2010e454caac$var$Sg(a.return, b, c);
}
function $9d6a2010e454caac$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9d6a2010e454caac$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9d6a2010e454caac$var$Yi(a, b, d.children, c);
    d = $9d6a2010e454caac$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9d6a2010e454caac$var$wj(a, c, b);
            else if (19 === a.tag) $9d6a2010e454caac$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9d6a2010e454caac$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9d6a2010e454caac$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9d6a2010e454caac$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9d6a2010e454caac$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $9d6a2010e454caac$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9d6a2010e454caac$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9d6a2010e454caac$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9d6a2010e454caac$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9d6a2010e454caac$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9d6a2010e454caac$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9d6a2010e454caac$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9d6a2010e454caac$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $9d6a2010e454caac$var$lj(b);
            $9d6a2010e454caac$var$Ig();
            break;
        case 5:
            $9d6a2010e454caac$var$Kh(b);
            break;
        case 1:
            $9d6a2010e454caac$var$Zf(b.type) && $9d6a2010e454caac$var$cg(b);
            break;
        case 4:
            $9d6a2010e454caac$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, $9d6a2010e454caac$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9d6a2010e454caac$var$pj(a, b, c);
                $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, $9d6a2010e454caac$var$M.current & 1);
                a = $9d6a2010e454caac$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, $9d6a2010e454caac$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9d6a2010e454caac$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, $9d6a2010e454caac$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9d6a2010e454caac$var$ej(a, b, c);
    }
    return $9d6a2010e454caac$var$$i(a, b, c);
}
var $9d6a2010e454caac$var$Aj, $9d6a2010e454caac$var$Bj, $9d6a2010e454caac$var$Cj, $9d6a2010e454caac$var$Dj;
$9d6a2010e454caac$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9d6a2010e454caac$var$Bj = function() {};
$9d6a2010e454caac$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9d6a2010e454caac$var$Ya(a, e);
                d = $9d6a2010e454caac$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9d6a2010e454caac$var$A({}, e, {
                    value: void 0
                });
                d = $9d6a2010e454caac$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9d6a2010e454caac$var$gb(a, e);
                d = $9d6a2010e454caac$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9d6a2010e454caac$var$Bf);
        }
        $9d6a2010e454caac$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9d6a2010e454caac$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9d6a2010e454caac$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9d6a2010e454caac$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9d6a2010e454caac$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9d6a2010e454caac$var$Ej(a, b) {
    if (!$9d6a2010e454caac$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9d6a2010e454caac$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9d6a2010e454caac$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $9d6a2010e454caac$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9d6a2010e454caac$var$S(b), null;
        case 1:
            return $9d6a2010e454caac$var$Zf(b.type) && $9d6a2010e454caac$var$$f(), $9d6a2010e454caac$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9d6a2010e454caac$var$Jh();
            $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Wf);
            $9d6a2010e454caac$var$E($9d6a2010e454caac$var$H);
            $9d6a2010e454caac$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9d6a2010e454caac$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9d6a2010e454caac$var$zg && ($9d6a2010e454caac$var$Gj($9d6a2010e454caac$var$zg), $9d6a2010e454caac$var$zg = null));
            $9d6a2010e454caac$var$Bj(a, b);
            $9d6a2010e454caac$var$S(b);
            return null;
        case 5:
            $9d6a2010e454caac$var$Lh(b);
            var e = $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9d6a2010e454caac$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9d6a2010e454caac$var$p(166));
                    $9d6a2010e454caac$var$S(b);
                    return null;
                }
                a = $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Eh.current);
                if ($9d6a2010e454caac$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9d6a2010e454caac$var$Of] = b;
                    d[$9d6a2010e454caac$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9d6a2010e454caac$var$D("cancel", d);
                            $9d6a2010e454caac$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9d6a2010e454caac$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9d6a2010e454caac$var$lf.length; e++)$9d6a2010e454caac$var$D($9d6a2010e454caac$var$lf[e], d);
                            break;
                        case "source":
                            $9d6a2010e454caac$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9d6a2010e454caac$var$D("error", d);
                            $9d6a2010e454caac$var$D("load", d);
                            break;
                        case "details":
                            $9d6a2010e454caac$var$D("toggle", d);
                            break;
                        case "input":
                            $9d6a2010e454caac$var$Za(d, f);
                            $9d6a2010e454caac$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9d6a2010e454caac$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9d6a2010e454caac$var$hb(d, f), $9d6a2010e454caac$var$D("invalid", d);
                    }
                    $9d6a2010e454caac$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9d6a2010e454caac$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9d6a2010e454caac$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9d6a2010e454caac$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9d6a2010e454caac$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9d6a2010e454caac$var$Va(d);
                            $9d6a2010e454caac$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9d6a2010e454caac$var$Va(d);
                            $9d6a2010e454caac$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9d6a2010e454caac$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9d6a2010e454caac$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9d6a2010e454caac$var$Of] = b;
                    a[$9d6a2010e454caac$var$Pf] = d;
                    $9d6a2010e454caac$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9d6a2010e454caac$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9d6a2010e454caac$var$D("cancel", a);
                                $9d6a2010e454caac$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9d6a2010e454caac$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9d6a2010e454caac$var$lf.length; e++)$9d6a2010e454caac$var$D($9d6a2010e454caac$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9d6a2010e454caac$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9d6a2010e454caac$var$D("error", a);
                                $9d6a2010e454caac$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9d6a2010e454caac$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9d6a2010e454caac$var$Za(a, d);
                                e = $9d6a2010e454caac$var$Ya(a, d);
                                $9d6a2010e454caac$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9d6a2010e454caac$var$A({}, d, {
                                    value: void 0
                                });
                                $9d6a2010e454caac$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9d6a2010e454caac$var$hb(a, d);
                                e = $9d6a2010e454caac$var$gb(a, d);
                                $9d6a2010e454caac$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9d6a2010e454caac$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9d6a2010e454caac$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9d6a2010e454caac$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9d6a2010e454caac$var$ob(a, k) : "number" === typeof k && $9d6a2010e454caac$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9d6a2010e454caac$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9d6a2010e454caac$var$D("scroll", a) : null != k && $9d6a2010e454caac$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9d6a2010e454caac$var$Va(a);
                                $9d6a2010e454caac$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9d6a2010e454caac$var$Va(a);
                                $9d6a2010e454caac$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9d6a2010e454caac$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9d6a2010e454caac$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9d6a2010e454caac$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9d6a2010e454caac$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9d6a2010e454caac$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9d6a2010e454caac$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9d6a2010e454caac$var$p(166));
                c = $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Gh.current);
                $9d6a2010e454caac$var$Hh($9d6a2010e454caac$var$Eh.current);
                if ($9d6a2010e454caac$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9d6a2010e454caac$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9d6a2010e454caac$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9d6a2010e454caac$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9d6a2010e454caac$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9d6a2010e454caac$var$Of] = b, b.stateNode = d;
            }
            $9d6a2010e454caac$var$S(b);
            return null;
        case 13:
            $9d6a2010e454caac$var$E($9d6a2010e454caac$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9d6a2010e454caac$var$I && null !== $9d6a2010e454caac$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9d6a2010e454caac$var$Hg(), $9d6a2010e454caac$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9d6a2010e454caac$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9d6a2010e454caac$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9d6a2010e454caac$var$p(317));
                        f[$9d6a2010e454caac$var$Of] = b;
                    } else $9d6a2010e454caac$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9d6a2010e454caac$var$S(b);
                    f = !1;
                } else null !== $9d6a2010e454caac$var$zg && ($9d6a2010e454caac$var$Gj($9d6a2010e454caac$var$zg), $9d6a2010e454caac$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9d6a2010e454caac$var$M.current & 1) ? 0 === $9d6a2010e454caac$var$T && ($9d6a2010e454caac$var$T = 3) : $9d6a2010e454caac$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9d6a2010e454caac$var$S(b);
            return null;
        case 4:
            return $9d6a2010e454caac$var$Jh(), $9d6a2010e454caac$var$Bj(a, b), null === a && $9d6a2010e454caac$var$sf(b.stateNode.containerInfo), $9d6a2010e454caac$var$S(b), null;
        case 10:
            return $9d6a2010e454caac$var$Rg(b.type._context), $9d6a2010e454caac$var$S(b), null;
        case 17:
            return $9d6a2010e454caac$var$Zf(b.type) && $9d6a2010e454caac$var$$f(), $9d6a2010e454caac$var$S(b), null;
        case 19:
            $9d6a2010e454caac$var$E($9d6a2010e454caac$var$M);
            f = b.memoizedState;
            if (null === f) return $9d6a2010e454caac$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9d6a2010e454caac$var$Ej(f, !1);
                else {
                    if (0 !== $9d6a2010e454caac$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9d6a2010e454caac$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9d6a2010e454caac$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, $9d6a2010e454caac$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9d6a2010e454caac$var$B() > $9d6a2010e454caac$var$Hj && (b.flags |= 128, d = !0, $9d6a2010e454caac$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9d6a2010e454caac$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9d6a2010e454caac$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9d6a2010e454caac$var$I) return $9d6a2010e454caac$var$S(b), null;
                    } else 2 * $9d6a2010e454caac$var$B() - f.renderingStartTime > $9d6a2010e454caac$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $9d6a2010e454caac$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9d6a2010e454caac$var$B(), b.sibling = null, c = $9d6a2010e454caac$var$M.current, $9d6a2010e454caac$var$G($9d6a2010e454caac$var$M, d ? c & 1 | 2 : c & 1), b;
            $9d6a2010e454caac$var$S(b);
            return null;
        case 22:
        case 23:
            return $9d6a2010e454caac$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9d6a2010e454caac$var$gj & 1073741824) && ($9d6a2010e454caac$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9d6a2010e454caac$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9d6a2010e454caac$var$p(156, b.tag));
}
function $9d6a2010e454caac$var$Jj(a, b) {
    $9d6a2010e454caac$var$wg(b);
    switch(b.tag){
        case 1:
            return $9d6a2010e454caac$var$Zf(b.type) && $9d6a2010e454caac$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9d6a2010e454caac$var$Jh(), $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Wf), $9d6a2010e454caac$var$E($9d6a2010e454caac$var$H), $9d6a2010e454caac$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9d6a2010e454caac$var$Lh(b), null;
        case 13:
            $9d6a2010e454caac$var$E($9d6a2010e454caac$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9d6a2010e454caac$var$p(340));
                $9d6a2010e454caac$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9d6a2010e454caac$var$E($9d6a2010e454caac$var$M), null;
        case 4:
            return $9d6a2010e454caac$var$Jh(), null;
        case 10:
            return $9d6a2010e454caac$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $9d6a2010e454caac$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9d6a2010e454caac$var$Kj = !1, $9d6a2010e454caac$var$U = !1, $9d6a2010e454caac$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $9d6a2010e454caac$var$V = null;
function $9d6a2010e454caac$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9d6a2010e454caac$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9d6a2010e454caac$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9d6a2010e454caac$var$W(a, b, d);
    }
}
var $9d6a2010e454caac$var$Oj = !1;
function $9d6a2010e454caac$var$Pj(a, b) {
    $9d6a2010e454caac$var$Cf = $9d6a2010e454caac$var$dd;
    a = $9d6a2010e454caac$var$Me();
    if ($9d6a2010e454caac$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9d6a2010e454caac$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9d6a2010e454caac$var$dd = !1;
    for($9d6a2010e454caac$var$V = b; null !== $9d6a2010e454caac$var$V;)if (b = $9d6a2010e454caac$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9d6a2010e454caac$var$V = a;
    else for(; null !== $9d6a2010e454caac$var$V;){
        b = $9d6a2010e454caac$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9d6a2010e454caac$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9d6a2010e454caac$var$p(163));
            }
        } catch (F) {
            $9d6a2010e454caac$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9d6a2010e454caac$var$V = a;
            break;
        }
        $9d6a2010e454caac$var$V = b.return;
    }
    n = $9d6a2010e454caac$var$Oj;
    $9d6a2010e454caac$var$Oj = !1;
    return n;
}
function $9d6a2010e454caac$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9d6a2010e454caac$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9d6a2010e454caac$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9d6a2010e454caac$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9d6a2010e454caac$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9d6a2010e454caac$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9d6a2010e454caac$var$Of], delete b[$9d6a2010e454caac$var$Pf], delete b[$9d6a2010e454caac$var$of], delete b[$9d6a2010e454caac$var$Qf], delete b[$9d6a2010e454caac$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9d6a2010e454caac$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9d6a2010e454caac$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9d6a2010e454caac$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9d6a2010e454caac$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9d6a2010e454caac$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9d6a2010e454caac$var$Wj(a, b, c), a = a.sibling; null !== a;)$9d6a2010e454caac$var$Wj(a, b, c), a = a.sibling;
}
function $9d6a2010e454caac$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9d6a2010e454caac$var$Xj(a, b, c), a = a.sibling; null !== a;)$9d6a2010e454caac$var$Xj(a, b, c), a = a.sibling;
}
var $9d6a2010e454caac$var$X = null, $9d6a2010e454caac$var$Yj = !1;
function $9d6a2010e454caac$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$9d6a2010e454caac$var$ak(a, b, c), c = c.sibling;
}
function $9d6a2010e454caac$var$ak(a, b, c) {
    if ($9d6a2010e454caac$var$lc && "function" === typeof $9d6a2010e454caac$var$lc.onCommitFiberUnmount) try {
        $9d6a2010e454caac$var$lc.onCommitFiberUnmount($9d6a2010e454caac$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9d6a2010e454caac$var$U || $9d6a2010e454caac$var$Mj(c, b);
        case 6:
            var d = $9d6a2010e454caac$var$X, e = $9d6a2010e454caac$var$Yj;
            $9d6a2010e454caac$var$X = null;
            $9d6a2010e454caac$var$Zj(a, b, c);
            $9d6a2010e454caac$var$X = d;
            $9d6a2010e454caac$var$Yj = e;
            null !== $9d6a2010e454caac$var$X && ($9d6a2010e454caac$var$Yj ? (a = $9d6a2010e454caac$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9d6a2010e454caac$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9d6a2010e454caac$var$X && ($9d6a2010e454caac$var$Yj ? (a = $9d6a2010e454caac$var$X, c = c.stateNode, 8 === a.nodeType ? $9d6a2010e454caac$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9d6a2010e454caac$var$Kf(a, c), $9d6a2010e454caac$var$bd(a)) : $9d6a2010e454caac$var$Kf($9d6a2010e454caac$var$X, c.stateNode));
            break;
        case 4:
            d = $9d6a2010e454caac$var$X;
            e = $9d6a2010e454caac$var$Yj;
            $9d6a2010e454caac$var$X = c.stateNode.containerInfo;
            $9d6a2010e454caac$var$Yj = !0;
            $9d6a2010e454caac$var$Zj(a, b, c);
            $9d6a2010e454caac$var$X = d;
            $9d6a2010e454caac$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9d6a2010e454caac$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9d6a2010e454caac$var$Nj(c, b, g) : 0 !== (f & 4) && $9d6a2010e454caac$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9d6a2010e454caac$var$Zj(a, b, c);
            break;
        case 1:
            if (!$9d6a2010e454caac$var$U && ($9d6a2010e454caac$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9d6a2010e454caac$var$W(c, b, h);
            }
            $9d6a2010e454caac$var$Zj(a, b, c);
            break;
        case 21:
            $9d6a2010e454caac$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9d6a2010e454caac$var$U = (d = $9d6a2010e454caac$var$U) || null !== c.memoizedState, $9d6a2010e454caac$var$Zj(a, b, c), $9d6a2010e454caac$var$U = d) : $9d6a2010e454caac$var$Zj(a, b, c);
            break;
        default:
            $9d6a2010e454caac$var$Zj(a, b, c);
    }
}
function $9d6a2010e454caac$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9d6a2010e454caac$var$Lj);
        b.forEach(function(b) {
            var d = $9d6a2010e454caac$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9d6a2010e454caac$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9d6a2010e454caac$var$X = h.stateNode;
                        $9d6a2010e454caac$var$Yj = !1;
                        break a;
                    case 3:
                        $9d6a2010e454caac$var$X = h.stateNode.containerInfo;
                        $9d6a2010e454caac$var$Yj = !0;
                        break a;
                    case 4:
                        $9d6a2010e454caac$var$X = h.stateNode.containerInfo;
                        $9d6a2010e454caac$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9d6a2010e454caac$var$X) throw Error($9d6a2010e454caac$var$p(160));
            $9d6a2010e454caac$var$ak(f, g, e);
            $9d6a2010e454caac$var$X = null;
            $9d6a2010e454caac$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9d6a2010e454caac$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9d6a2010e454caac$var$ek(b, a), b = b.sibling;
}
function $9d6a2010e454caac$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            if (d & 4) {
                try {
                    $9d6a2010e454caac$var$Qj(3, a, a.return), $9d6a2010e454caac$var$Rj(3, a);
                } catch (t) {
                    $9d6a2010e454caac$var$W(a, a.return, t);
                }
                try {
                    $9d6a2010e454caac$var$Qj(5, a, a.return);
                } catch (t) {
                    $9d6a2010e454caac$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            d & 512 && null !== c && $9d6a2010e454caac$var$Mj(c, c.return);
            break;
        case 5:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            d & 512 && null !== c && $9d6a2010e454caac$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9d6a2010e454caac$var$ob(e, "");
                } catch (t) {
                    $9d6a2010e454caac$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9d6a2010e454caac$var$ab(e, f);
                    $9d6a2010e454caac$var$vb(h, g);
                    var l = $9d6a2010e454caac$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9d6a2010e454caac$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9d6a2010e454caac$var$nb(e, q) : "children" === m ? $9d6a2010e454caac$var$ob(e, q) : $9d6a2010e454caac$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9d6a2010e454caac$var$bb(e, f);
                            break;
                        case "textarea":
                            $9d6a2010e454caac$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9d6a2010e454caac$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9d6a2010e454caac$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9d6a2010e454caac$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9d6a2010e454caac$var$Pf] = f;
                } catch (t) {
                    $9d6a2010e454caac$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9d6a2010e454caac$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9d6a2010e454caac$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9d6a2010e454caac$var$bd(b.containerInfo);
            } catch (t) {
                $9d6a2010e454caac$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            break;
        case 13:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9d6a2010e454caac$var$gk = $9d6a2010e454caac$var$B()));
            d & 4 && $9d6a2010e454caac$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9d6a2010e454caac$var$U = (l = $9d6a2010e454caac$var$U) || m, $9d6a2010e454caac$var$dk(b, a), $9d6a2010e454caac$var$U = l) : $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9d6a2010e454caac$var$V = a, m = a.child; null !== m;){
                    for(q = $9d6a2010e454caac$var$V = m; null !== $9d6a2010e454caac$var$V;){
                        r = $9d6a2010e454caac$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9d6a2010e454caac$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $9d6a2010e454caac$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9d6a2010e454caac$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9d6a2010e454caac$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9d6a2010e454caac$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9d6a2010e454caac$var$V = y) : $9d6a2010e454caac$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9d6a2010e454caac$var$rb("display", g));
                            } catch (t) {
                                $9d6a2010e454caac$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9d6a2010e454caac$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9d6a2010e454caac$var$dk(b, a);
            $9d6a2010e454caac$var$fk(a);
            d & 4 && $9d6a2010e454caac$var$bk(a);
            break;
        case 21:
            break;
        default:
            $9d6a2010e454caac$var$dk(b, a), $9d6a2010e454caac$var$fk(a);
    }
}
function $9d6a2010e454caac$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9d6a2010e454caac$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9d6a2010e454caac$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9d6a2010e454caac$var$ob(e, ""), d.flags &= -33);
                    var f = $9d6a2010e454caac$var$Vj(a);
                    $9d6a2010e454caac$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9d6a2010e454caac$var$Vj(a);
                    $9d6a2010e454caac$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($9d6a2010e454caac$var$p(161));
            }
        } catch (k) {
            $9d6a2010e454caac$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9d6a2010e454caac$var$ik(a, b, c) {
    $9d6a2010e454caac$var$V = a;
    $9d6a2010e454caac$var$jk(a, b, c);
}
function $9d6a2010e454caac$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9d6a2010e454caac$var$V;){
        var e = $9d6a2010e454caac$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9d6a2010e454caac$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9d6a2010e454caac$var$U;
                h = $9d6a2010e454caac$var$Kj;
                var l = $9d6a2010e454caac$var$U;
                $9d6a2010e454caac$var$Kj = g;
                if (($9d6a2010e454caac$var$U = k) && !l) for($9d6a2010e454caac$var$V = e; null !== $9d6a2010e454caac$var$V;)g = $9d6a2010e454caac$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9d6a2010e454caac$var$kk(e) : null !== k ? (k.return = g, $9d6a2010e454caac$var$V = k) : $9d6a2010e454caac$var$kk(e);
                for(; null !== f;)$9d6a2010e454caac$var$V = f, $9d6a2010e454caac$var$jk(f, b, c), f = f.sibling;
                $9d6a2010e454caac$var$V = e;
                $9d6a2010e454caac$var$Kj = h;
                $9d6a2010e454caac$var$U = l;
            }
            $9d6a2010e454caac$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9d6a2010e454caac$var$V = f) : $9d6a2010e454caac$var$lk(a, b, c);
    }
}
function $9d6a2010e454caac$var$lk(a) {
    for(; null !== $9d6a2010e454caac$var$V;){
        var b = $9d6a2010e454caac$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9d6a2010e454caac$var$U || $9d6a2010e454caac$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9d6a2010e454caac$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9d6a2010e454caac$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9d6a2010e454caac$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9d6a2010e454caac$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9d6a2010e454caac$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9d6a2010e454caac$var$p(163));
                }
                $9d6a2010e454caac$var$U || b.flags & 512 && $9d6a2010e454caac$var$Sj(b);
            } catch (r) {
                $9d6a2010e454caac$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9d6a2010e454caac$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9d6a2010e454caac$var$V = c;
            break;
        }
        $9d6a2010e454caac$var$V = b.return;
    }
}
function $9d6a2010e454caac$var$hk(a) {
    for(; null !== $9d6a2010e454caac$var$V;){
        var b = $9d6a2010e454caac$var$V;
        if (b === a) {
            $9d6a2010e454caac$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9d6a2010e454caac$var$V = c;
            break;
        }
        $9d6a2010e454caac$var$V = b.return;
    }
}
function $9d6a2010e454caac$var$kk(a) {
    for(; null !== $9d6a2010e454caac$var$V;){
        var b = $9d6a2010e454caac$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9d6a2010e454caac$var$Rj(4, b);
                    } catch (k) {
                        $9d6a2010e454caac$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9d6a2010e454caac$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9d6a2010e454caac$var$Sj(b);
                    } catch (k) {
                        $9d6a2010e454caac$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9d6a2010e454caac$var$Sj(b);
                    } catch (k) {
                        $9d6a2010e454caac$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9d6a2010e454caac$var$W(b, b.return, k);
        }
        if (b === a) {
            $9d6a2010e454caac$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9d6a2010e454caac$var$V = h;
            break;
        }
        $9d6a2010e454caac$var$V = b.return;
    }
}
var $9d6a2010e454caac$var$mk = Math.ceil, $9d6a2010e454caac$var$nk = $9d6a2010e454caac$var$ua.ReactCurrentDispatcher, $9d6a2010e454caac$var$ok = $9d6a2010e454caac$var$ua.ReactCurrentOwner, $9d6a2010e454caac$var$pk = $9d6a2010e454caac$var$ua.ReactCurrentBatchConfig, $9d6a2010e454caac$var$K = 0, $9d6a2010e454caac$var$R = null, $9d6a2010e454caac$var$Y = null, $9d6a2010e454caac$var$Z = 0, $9d6a2010e454caac$var$gj = 0, $9d6a2010e454caac$var$fj = $9d6a2010e454caac$var$Uf(0), $9d6a2010e454caac$var$T = 0, $9d6a2010e454caac$var$qk = null, $9d6a2010e454caac$var$hh = 0, $9d6a2010e454caac$var$rk = 0, $9d6a2010e454caac$var$sk = 0, $9d6a2010e454caac$var$tk = null, $9d6a2010e454caac$var$uk = null, $9d6a2010e454caac$var$gk = 0, $9d6a2010e454caac$var$Hj = Infinity, $9d6a2010e454caac$var$vk = null, $9d6a2010e454caac$var$Pi = !1, $9d6a2010e454caac$var$Qi = null, $9d6a2010e454caac$var$Si = null, $9d6a2010e454caac$var$wk = !1, $9d6a2010e454caac$var$xk = null, $9d6a2010e454caac$var$yk = 0, $9d6a2010e454caac$var$zk = 0, $9d6a2010e454caac$var$Ak = null, $9d6a2010e454caac$var$Bk = -1, $9d6a2010e454caac$var$Ck = 0;
function $9d6a2010e454caac$var$L() {
    return 0 !== ($9d6a2010e454caac$var$K & 6) ? $9d6a2010e454caac$var$B() : -1 !== $9d6a2010e454caac$var$Bk ? $9d6a2010e454caac$var$Bk : $9d6a2010e454caac$var$Bk = $9d6a2010e454caac$var$B();
}
function $9d6a2010e454caac$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9d6a2010e454caac$var$K & 2) && 0 !== $9d6a2010e454caac$var$Z) return $9d6a2010e454caac$var$Z & -$9d6a2010e454caac$var$Z;
    if (null !== $9d6a2010e454caac$var$Kg.transition) return 0 === $9d6a2010e454caac$var$Ck && ($9d6a2010e454caac$var$Ck = $9d6a2010e454caac$var$yc()), $9d6a2010e454caac$var$Ck;
    a = $9d6a2010e454caac$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9d6a2010e454caac$var$jd(a.type);
    return a;
}
function $9d6a2010e454caac$var$mh(a, b, c, d) {
    if (50 < $9d6a2010e454caac$var$zk) throw $9d6a2010e454caac$var$zk = 0, $9d6a2010e454caac$var$Ak = null, Error($9d6a2010e454caac$var$p(185));
    $9d6a2010e454caac$var$Ac(a, c, d);
    if (0 === ($9d6a2010e454caac$var$K & 2) || a !== $9d6a2010e454caac$var$R) a === $9d6a2010e454caac$var$R && (0 === ($9d6a2010e454caac$var$K & 2) && ($9d6a2010e454caac$var$rk |= c), 4 === $9d6a2010e454caac$var$T && $9d6a2010e454caac$var$Dk(a, $9d6a2010e454caac$var$Z)), $9d6a2010e454caac$var$Ek(a, d), 1 === c && 0 === $9d6a2010e454caac$var$K && 0 === (b.mode & 1) && ($9d6a2010e454caac$var$Hj = $9d6a2010e454caac$var$B() + 500, $9d6a2010e454caac$var$fg && $9d6a2010e454caac$var$jg());
}
function $9d6a2010e454caac$var$Ek(a, b) {
    var c = a.callbackNode;
    $9d6a2010e454caac$var$wc(a, b);
    var d = $9d6a2010e454caac$var$uc(a, a === $9d6a2010e454caac$var$R ? $9d6a2010e454caac$var$Z : 0);
    if (0 === d) null !== c && $9d6a2010e454caac$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9d6a2010e454caac$var$bc(c);
        if (1 === b) 0 === a.tag ? $9d6a2010e454caac$var$ig($9d6a2010e454caac$var$Fk.bind(null, a)) : $9d6a2010e454caac$var$hg($9d6a2010e454caac$var$Fk.bind(null, a)), $9d6a2010e454caac$var$Jf(function() {
            0 === ($9d6a2010e454caac$var$K & 6) && $9d6a2010e454caac$var$jg();
        }), c = null;
        else {
            switch($9d6a2010e454caac$var$Dc(d)){
                case 1:
                    c = $9d6a2010e454caac$var$fc;
                    break;
                case 4:
                    c = $9d6a2010e454caac$var$gc;
                    break;
                case 16:
                    c = $9d6a2010e454caac$var$hc;
                    break;
                case 536870912:
                    c = $9d6a2010e454caac$var$jc;
                    break;
                default:
                    c = $9d6a2010e454caac$var$hc;
            }
            c = $9d6a2010e454caac$var$Gk(c, $9d6a2010e454caac$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9d6a2010e454caac$var$Hk(a, b) {
    $9d6a2010e454caac$var$Bk = -1;
    $9d6a2010e454caac$var$Ck = 0;
    if (0 !== ($9d6a2010e454caac$var$K & 6)) throw Error($9d6a2010e454caac$var$p(327));
    var c = a.callbackNode;
    if ($9d6a2010e454caac$var$Ik() && a.callbackNode !== c) return null;
    var d = $9d6a2010e454caac$var$uc(a, a === $9d6a2010e454caac$var$R ? $9d6a2010e454caac$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9d6a2010e454caac$var$Jk(a, d);
    else {
        b = d;
        var e = $9d6a2010e454caac$var$K;
        $9d6a2010e454caac$var$K |= 2;
        var f = $9d6a2010e454caac$var$Kk();
        if ($9d6a2010e454caac$var$R !== a || $9d6a2010e454caac$var$Z !== b) $9d6a2010e454caac$var$vk = null, $9d6a2010e454caac$var$Hj = $9d6a2010e454caac$var$B() + 500, $9d6a2010e454caac$var$Lk(a, b);
        for(;;)try {
            $9d6a2010e454caac$var$Mk();
            break;
        } catch (h) {
            $9d6a2010e454caac$var$Nk(a, h);
        }
        $9d6a2010e454caac$var$Qg();
        $9d6a2010e454caac$var$nk.current = f;
        $9d6a2010e454caac$var$K = e;
        null !== $9d6a2010e454caac$var$Y ? b = 0 : ($9d6a2010e454caac$var$R = null, $9d6a2010e454caac$var$Z = 0, b = $9d6a2010e454caac$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9d6a2010e454caac$var$xc(a), 0 !== e && (d = e, b = $9d6a2010e454caac$var$Ok(a, e)));
        if (1 === b) throw c = $9d6a2010e454caac$var$qk, $9d6a2010e454caac$var$Lk(a, 0), $9d6a2010e454caac$var$Dk(a, d), $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B()), c;
        if (6 === b) $9d6a2010e454caac$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9d6a2010e454caac$var$Pk(e) && (b = $9d6a2010e454caac$var$Jk(a, d), 2 === b && (f = $9d6a2010e454caac$var$xc(a), 0 !== f && (d = f, b = $9d6a2010e454caac$var$Ok(a, f))), 1 === b)) throw c = $9d6a2010e454caac$var$qk, $9d6a2010e454caac$var$Lk(a, 0), $9d6a2010e454caac$var$Dk(a, d), $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9d6a2010e454caac$var$p(345));
                case 2:
                    $9d6a2010e454caac$var$Qk(a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk);
                    break;
                case 3:
                    $9d6a2010e454caac$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $9d6a2010e454caac$var$gk + 500 - $9d6a2010e454caac$var$B(), 10 < b)) {
                        if (0 !== $9d6a2010e454caac$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9d6a2010e454caac$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9d6a2010e454caac$var$Ff($9d6a2010e454caac$var$Qk.bind(null, a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk), b);
                        break;
                    }
                    $9d6a2010e454caac$var$Qk(a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk);
                    break;
                case 4:
                    $9d6a2010e454caac$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9d6a2010e454caac$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9d6a2010e454caac$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9d6a2010e454caac$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9d6a2010e454caac$var$Ff($9d6a2010e454caac$var$Qk.bind(null, a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk), d);
                        break;
                    }
                    $9d6a2010e454caac$var$Qk(a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk);
                    break;
                case 5:
                    $9d6a2010e454caac$var$Qk(a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk);
                    break;
                default:
                    throw Error($9d6a2010e454caac$var$p(329));
            }
        }
    }
    $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B());
    return a.callbackNode === c ? $9d6a2010e454caac$var$Hk.bind(null, a) : null;
}
function $9d6a2010e454caac$var$Ok(a, b) {
    var c = $9d6a2010e454caac$var$tk;
    a.current.memoizedState.isDehydrated && ($9d6a2010e454caac$var$Lk(a, b).flags |= 256);
    a = $9d6a2010e454caac$var$Jk(a, b);
    2 !== a && (b = $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$uk = c, null !== b && $9d6a2010e454caac$var$Gj(b));
    return a;
}
function $9d6a2010e454caac$var$Gj(a) {
    null === $9d6a2010e454caac$var$uk ? $9d6a2010e454caac$var$uk = a : $9d6a2010e454caac$var$uk.push.apply($9d6a2010e454caac$var$uk, a);
}
function $9d6a2010e454caac$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9d6a2010e454caac$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9d6a2010e454caac$var$Dk(a, b) {
    b &= ~$9d6a2010e454caac$var$sk;
    b &= ~$9d6a2010e454caac$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9d6a2010e454caac$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9d6a2010e454caac$var$Fk(a) {
    if (0 !== ($9d6a2010e454caac$var$K & 6)) throw Error($9d6a2010e454caac$var$p(327));
    $9d6a2010e454caac$var$Ik();
    var b = $9d6a2010e454caac$var$uc(a, 0);
    if (0 === (b & 1)) return $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B()), null;
    var c = $9d6a2010e454caac$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9d6a2010e454caac$var$xc(a);
        0 !== d && (b = d, c = $9d6a2010e454caac$var$Ok(a, d));
    }
    if (1 === c) throw c = $9d6a2010e454caac$var$qk, $9d6a2010e454caac$var$Lk(a, 0), $9d6a2010e454caac$var$Dk(a, b), $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B()), c;
    if (6 === c) throw Error($9d6a2010e454caac$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9d6a2010e454caac$var$Qk(a, $9d6a2010e454caac$var$uk, $9d6a2010e454caac$var$vk);
    $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B());
    return null;
}
function $9d6a2010e454caac$var$Rk(a, b) {
    var c = $9d6a2010e454caac$var$K;
    $9d6a2010e454caac$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9d6a2010e454caac$var$K = c, 0 === $9d6a2010e454caac$var$K && ($9d6a2010e454caac$var$Hj = $9d6a2010e454caac$var$B() + 500, $9d6a2010e454caac$var$fg && $9d6a2010e454caac$var$jg());
    }
}
function $9d6a2010e454caac$var$Sk(a) {
    null !== $9d6a2010e454caac$var$xk && 0 === $9d6a2010e454caac$var$xk.tag && 0 === ($9d6a2010e454caac$var$K & 6) && $9d6a2010e454caac$var$Ik();
    var b = $9d6a2010e454caac$var$K;
    $9d6a2010e454caac$var$K |= 1;
    var c = $9d6a2010e454caac$var$pk.transition, d = $9d6a2010e454caac$var$C;
    try {
        if ($9d6a2010e454caac$var$pk.transition = null, $9d6a2010e454caac$var$C = 1, a) return a();
    } finally{
        $9d6a2010e454caac$var$C = d, $9d6a2010e454caac$var$pk.transition = c, $9d6a2010e454caac$var$K = b, 0 === ($9d6a2010e454caac$var$K & 6) && $9d6a2010e454caac$var$jg();
    }
}
function $9d6a2010e454caac$var$Ij() {
    $9d6a2010e454caac$var$gj = $9d6a2010e454caac$var$fj.current;
    $9d6a2010e454caac$var$E($9d6a2010e454caac$var$fj);
}
function $9d6a2010e454caac$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9d6a2010e454caac$var$Gf(c));
    if (null !== $9d6a2010e454caac$var$Y) for(c = $9d6a2010e454caac$var$Y.return; null !== c;){
        var d = c;
        $9d6a2010e454caac$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9d6a2010e454caac$var$$f();
                break;
            case 3:
                $9d6a2010e454caac$var$Jh();
                $9d6a2010e454caac$var$E($9d6a2010e454caac$var$Wf);
                $9d6a2010e454caac$var$E($9d6a2010e454caac$var$H);
                $9d6a2010e454caac$var$Oh();
                break;
            case 5:
                $9d6a2010e454caac$var$Lh(d);
                break;
            case 4:
                $9d6a2010e454caac$var$Jh();
                break;
            case 13:
                $9d6a2010e454caac$var$E($9d6a2010e454caac$var$M);
                break;
            case 19:
                $9d6a2010e454caac$var$E($9d6a2010e454caac$var$M);
                break;
            case 10:
                $9d6a2010e454caac$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $9d6a2010e454caac$var$Ij();
        }
        c = c.return;
    }
    $9d6a2010e454caac$var$R = a;
    $9d6a2010e454caac$var$Y = a = $9d6a2010e454caac$var$wh(a.current, null);
    $9d6a2010e454caac$var$Z = $9d6a2010e454caac$var$gj = b;
    $9d6a2010e454caac$var$T = 0;
    $9d6a2010e454caac$var$qk = null;
    $9d6a2010e454caac$var$sk = $9d6a2010e454caac$var$rk = $9d6a2010e454caac$var$hh = 0;
    $9d6a2010e454caac$var$uk = $9d6a2010e454caac$var$tk = null;
    if (null !== $9d6a2010e454caac$var$Wg) {
        for(b = 0; b < $9d6a2010e454caac$var$Wg.length; b++)if (c = $9d6a2010e454caac$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9d6a2010e454caac$var$Wg = null;
    }
    return a;
}
function $9d6a2010e454caac$var$Nk(a, b) {
    do {
        var c = $9d6a2010e454caac$var$Y;
        try {
            $9d6a2010e454caac$var$Qg();
            $9d6a2010e454caac$var$Ph.current = $9d6a2010e454caac$var$ai;
            if ($9d6a2010e454caac$var$Sh) {
                for(var d = $9d6a2010e454caac$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9d6a2010e454caac$var$Sh = !1;
            }
            $9d6a2010e454caac$var$Rh = 0;
            $9d6a2010e454caac$var$P = $9d6a2010e454caac$var$O = $9d6a2010e454caac$var$N = null;
            $9d6a2010e454caac$var$Th = !1;
            $9d6a2010e454caac$var$Uh = 0;
            $9d6a2010e454caac$var$ok.current = null;
            if (null === c || null === c.return) {
                $9d6a2010e454caac$var$T = 1;
                $9d6a2010e454caac$var$qk = b;
                $9d6a2010e454caac$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9d6a2010e454caac$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9d6a2010e454caac$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9d6a2010e454caac$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $9d6a2010e454caac$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9d6a2010e454caac$var$Ti(f, l, b);
                            $9d6a2010e454caac$var$uj();
                            break a;
                        }
                        k = Error($9d6a2010e454caac$var$p(426));
                    }
                } else if ($9d6a2010e454caac$var$I && h.mode & 1) {
                    var J = $9d6a2010e454caac$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9d6a2010e454caac$var$Wi(J, g, h, f, b);
                        $9d6a2010e454caac$var$Jg($9d6a2010e454caac$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $9d6a2010e454caac$var$Ki(k, h);
                4 !== $9d6a2010e454caac$var$T && ($9d6a2010e454caac$var$T = 2);
                null === $9d6a2010e454caac$var$tk ? $9d6a2010e454caac$var$tk = [
                    f
                ] : $9d6a2010e454caac$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9d6a2010e454caac$var$Oi(f, k, b);
                            $9d6a2010e454caac$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9d6a2010e454caac$var$Si || !$9d6a2010e454caac$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9d6a2010e454caac$var$Ri(f, h, b);
                                $9d6a2010e454caac$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9d6a2010e454caac$var$Tk(c);
        } catch (na) {
            b = na;
            $9d6a2010e454caac$var$Y === c && null !== c && ($9d6a2010e454caac$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9d6a2010e454caac$var$Kk() {
    var a = $9d6a2010e454caac$var$nk.current;
    $9d6a2010e454caac$var$nk.current = $9d6a2010e454caac$var$ai;
    return null === a ? $9d6a2010e454caac$var$ai : a;
}
function $9d6a2010e454caac$var$uj() {
    if (0 === $9d6a2010e454caac$var$T || 3 === $9d6a2010e454caac$var$T || 2 === $9d6a2010e454caac$var$T) $9d6a2010e454caac$var$T = 4;
    null === $9d6a2010e454caac$var$R || 0 === ($9d6a2010e454caac$var$hh & 268435455) && 0 === ($9d6a2010e454caac$var$rk & 268435455) || $9d6a2010e454caac$var$Dk($9d6a2010e454caac$var$R, $9d6a2010e454caac$var$Z);
}
function $9d6a2010e454caac$var$Jk(a, b) {
    var c = $9d6a2010e454caac$var$K;
    $9d6a2010e454caac$var$K |= 2;
    var d = $9d6a2010e454caac$var$Kk();
    if ($9d6a2010e454caac$var$R !== a || $9d6a2010e454caac$var$Z !== b) $9d6a2010e454caac$var$vk = null, $9d6a2010e454caac$var$Lk(a, b);
    for(;;)try {
        $9d6a2010e454caac$var$Uk();
        break;
    } catch (e) {
        $9d6a2010e454caac$var$Nk(a, e);
    }
    $9d6a2010e454caac$var$Qg();
    $9d6a2010e454caac$var$K = c;
    $9d6a2010e454caac$var$nk.current = d;
    if (null !== $9d6a2010e454caac$var$Y) throw Error($9d6a2010e454caac$var$p(261));
    $9d6a2010e454caac$var$R = null;
    $9d6a2010e454caac$var$Z = 0;
    return $9d6a2010e454caac$var$T;
}
function $9d6a2010e454caac$var$Uk() {
    for(; null !== $9d6a2010e454caac$var$Y;)$9d6a2010e454caac$var$Vk($9d6a2010e454caac$var$Y);
}
function $9d6a2010e454caac$var$Mk() {
    for(; null !== $9d6a2010e454caac$var$Y && !$9d6a2010e454caac$var$cc();)$9d6a2010e454caac$var$Vk($9d6a2010e454caac$var$Y);
}
function $9d6a2010e454caac$var$Vk(a) {
    var b = $9d6a2010e454caac$var$Wk(a.alternate, a, $9d6a2010e454caac$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9d6a2010e454caac$var$Tk(a) : $9d6a2010e454caac$var$Y = b;
    $9d6a2010e454caac$var$ok.current = null;
}
function $9d6a2010e454caac$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9d6a2010e454caac$var$Fj(c, b, $9d6a2010e454caac$var$gj), null !== c) {
                $9d6a2010e454caac$var$Y = c;
                return;
            }
        } else {
            c = $9d6a2010e454caac$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9d6a2010e454caac$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9d6a2010e454caac$var$T = 6;
                $9d6a2010e454caac$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9d6a2010e454caac$var$Y = b;
            return;
        }
        $9d6a2010e454caac$var$Y = b = a;
    }while (null !== b);
    0 === $9d6a2010e454caac$var$T && ($9d6a2010e454caac$var$T = 5);
}
function $9d6a2010e454caac$var$Qk(a, b, c) {
    var d = $9d6a2010e454caac$var$C, e = $9d6a2010e454caac$var$pk.transition;
    try {
        $9d6a2010e454caac$var$pk.transition = null, $9d6a2010e454caac$var$C = 1, $9d6a2010e454caac$var$Xk(a, b, c, d);
    } finally{
        $9d6a2010e454caac$var$pk.transition = e, $9d6a2010e454caac$var$C = d;
    }
    return null;
}
function $9d6a2010e454caac$var$Xk(a, b, c, d) {
    do $9d6a2010e454caac$var$Ik();
    while (null !== $9d6a2010e454caac$var$xk);
    if (0 !== ($9d6a2010e454caac$var$K & 6)) throw Error($9d6a2010e454caac$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9d6a2010e454caac$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9d6a2010e454caac$var$Bc(a, f);
    a === $9d6a2010e454caac$var$R && ($9d6a2010e454caac$var$Y = $9d6a2010e454caac$var$R = null, $9d6a2010e454caac$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9d6a2010e454caac$var$wk || ($9d6a2010e454caac$var$wk = !0, $9d6a2010e454caac$var$Gk($9d6a2010e454caac$var$hc, function() {
        $9d6a2010e454caac$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9d6a2010e454caac$var$pk.transition;
        $9d6a2010e454caac$var$pk.transition = null;
        var g = $9d6a2010e454caac$var$C;
        $9d6a2010e454caac$var$C = 1;
        var h = $9d6a2010e454caac$var$K;
        $9d6a2010e454caac$var$K |= 4;
        $9d6a2010e454caac$var$ok.current = null;
        $9d6a2010e454caac$var$Pj(a, c);
        $9d6a2010e454caac$var$ek(c, a);
        $9d6a2010e454caac$var$Oe($9d6a2010e454caac$var$Df);
        $9d6a2010e454caac$var$dd = !!$9d6a2010e454caac$var$Cf;
        $9d6a2010e454caac$var$Df = $9d6a2010e454caac$var$Cf = null;
        a.current = c;
        $9d6a2010e454caac$var$ik(c, a, e);
        $9d6a2010e454caac$var$dc();
        $9d6a2010e454caac$var$K = h;
        $9d6a2010e454caac$var$C = g;
        $9d6a2010e454caac$var$pk.transition = f;
    } else a.current = c;
    $9d6a2010e454caac$var$wk && ($9d6a2010e454caac$var$wk = !1, $9d6a2010e454caac$var$xk = a, $9d6a2010e454caac$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($9d6a2010e454caac$var$Si = null);
    $9d6a2010e454caac$var$mc(c.stateNode, d);
    $9d6a2010e454caac$var$Ek(a, $9d6a2010e454caac$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9d6a2010e454caac$var$Pi) throw $9d6a2010e454caac$var$Pi = !1, a = $9d6a2010e454caac$var$Qi, $9d6a2010e454caac$var$Qi = null, a;
    0 !== ($9d6a2010e454caac$var$yk & 1) && 0 !== a.tag && $9d6a2010e454caac$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9d6a2010e454caac$var$Ak ? $9d6a2010e454caac$var$zk++ : ($9d6a2010e454caac$var$zk = 0, $9d6a2010e454caac$var$Ak = a) : $9d6a2010e454caac$var$zk = 0;
    $9d6a2010e454caac$var$jg();
    return null;
}
function $9d6a2010e454caac$var$Ik() {
    if (null !== $9d6a2010e454caac$var$xk) {
        var a = $9d6a2010e454caac$var$Dc($9d6a2010e454caac$var$yk), b = $9d6a2010e454caac$var$pk.transition, c = $9d6a2010e454caac$var$C;
        try {
            $9d6a2010e454caac$var$pk.transition = null;
            $9d6a2010e454caac$var$C = 16 > a ? 16 : a;
            if (null === $9d6a2010e454caac$var$xk) var d = !1;
            else {
                a = $9d6a2010e454caac$var$xk;
                $9d6a2010e454caac$var$xk = null;
                $9d6a2010e454caac$var$yk = 0;
                if (0 !== ($9d6a2010e454caac$var$K & 6)) throw Error($9d6a2010e454caac$var$p(331));
                var e = $9d6a2010e454caac$var$K;
                $9d6a2010e454caac$var$K |= 4;
                for($9d6a2010e454caac$var$V = a.current; null !== $9d6a2010e454caac$var$V;){
                    var f = $9d6a2010e454caac$var$V, g = f.child;
                    if (0 !== ($9d6a2010e454caac$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9d6a2010e454caac$var$V = l; null !== $9d6a2010e454caac$var$V;){
                                    var m = $9d6a2010e454caac$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9d6a2010e454caac$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9d6a2010e454caac$var$V = q;
                                    else for(; null !== $9d6a2010e454caac$var$V;){
                                        m = $9d6a2010e454caac$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9d6a2010e454caac$var$Tj(m);
                                        if (m === l) {
                                            $9d6a2010e454caac$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9d6a2010e454caac$var$V = r;
                                            break;
                                        }
                                        $9d6a2010e454caac$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9d6a2010e454caac$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9d6a2010e454caac$var$V = g;
                    else b: for(; null !== $9d6a2010e454caac$var$V;){
                        f = $9d6a2010e454caac$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9d6a2010e454caac$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9d6a2010e454caac$var$V = x;
                            break b;
                        }
                        $9d6a2010e454caac$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9d6a2010e454caac$var$V = w; null !== $9d6a2010e454caac$var$V;){
                    g = $9d6a2010e454caac$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9d6a2010e454caac$var$V = u;
                    else b: for(g = w; null !== $9d6a2010e454caac$var$V;){
                        h = $9d6a2010e454caac$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9d6a2010e454caac$var$Rj(9, h);
                            }
                        } catch (na) {
                            $9d6a2010e454caac$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9d6a2010e454caac$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9d6a2010e454caac$var$V = F;
                            break b;
                        }
                        $9d6a2010e454caac$var$V = h.return;
                    }
                }
                $9d6a2010e454caac$var$K = e;
                $9d6a2010e454caac$var$jg();
                if ($9d6a2010e454caac$var$lc && "function" === typeof $9d6a2010e454caac$var$lc.onPostCommitFiberRoot) try {
                    $9d6a2010e454caac$var$lc.onPostCommitFiberRoot($9d6a2010e454caac$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9d6a2010e454caac$var$C = c, $9d6a2010e454caac$var$pk.transition = b;
        }
    }
    return !1;
}
function $9d6a2010e454caac$var$Yk(a, b, c) {
    b = $9d6a2010e454caac$var$Ki(c, b);
    b = $9d6a2010e454caac$var$Oi(a, b, 1);
    a = $9d6a2010e454caac$var$dh(a, b, 1);
    b = $9d6a2010e454caac$var$L();
    null !== a && ($9d6a2010e454caac$var$Ac(a, 1, b), $9d6a2010e454caac$var$Ek(a, b));
}
function $9d6a2010e454caac$var$W(a, b, c) {
    if (3 === a.tag) $9d6a2010e454caac$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9d6a2010e454caac$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9d6a2010e454caac$var$Si || !$9d6a2010e454caac$var$Si.has(d))) {
                a = $9d6a2010e454caac$var$Ki(c, a);
                a = $9d6a2010e454caac$var$Ri(b, a, 1);
                b = $9d6a2010e454caac$var$dh(b, a, 1);
                a = $9d6a2010e454caac$var$L();
                null !== b && ($9d6a2010e454caac$var$Ac(b, 1, a), $9d6a2010e454caac$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9d6a2010e454caac$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9d6a2010e454caac$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $9d6a2010e454caac$var$R === a && ($9d6a2010e454caac$var$Z & c) === c && (4 === $9d6a2010e454caac$var$T || 3 === $9d6a2010e454caac$var$T && ($9d6a2010e454caac$var$Z & 130023424) === $9d6a2010e454caac$var$Z && 500 > $9d6a2010e454caac$var$B() - $9d6a2010e454caac$var$gk ? $9d6a2010e454caac$var$Lk(a, 0) : $9d6a2010e454caac$var$sk |= c);
    $9d6a2010e454caac$var$Ek(a, b);
}
function $9d6a2010e454caac$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9d6a2010e454caac$var$sc, $9d6a2010e454caac$var$sc <<= 1, 0 === ($9d6a2010e454caac$var$sc & 130023424) && ($9d6a2010e454caac$var$sc = 4194304)));
    var c = $9d6a2010e454caac$var$L();
    a = $9d6a2010e454caac$var$Zg(a, b);
    null !== a && ($9d6a2010e454caac$var$Ac(a, b, c), $9d6a2010e454caac$var$Ek(a, c));
}
function $9d6a2010e454caac$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9d6a2010e454caac$var$Zk(a, c);
}
function $9d6a2010e454caac$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9d6a2010e454caac$var$p(314));
    }
    null !== d && d.delete(b);
    $9d6a2010e454caac$var$Zk(a, c);
}
var $9d6a2010e454caac$var$Wk;
$9d6a2010e454caac$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9d6a2010e454caac$var$Wf.current) $9d6a2010e454caac$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9d6a2010e454caac$var$Ug = !1, $9d6a2010e454caac$var$zj(a, b, c);
            $9d6a2010e454caac$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9d6a2010e454caac$var$Ug = !1, $9d6a2010e454caac$var$I && 0 !== (b.flags & 1048576) && $9d6a2010e454caac$var$ug(b, $9d6a2010e454caac$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9d6a2010e454caac$var$jj(a, b);
            a = b.pendingProps;
            var e = $9d6a2010e454caac$var$Yf(b, $9d6a2010e454caac$var$H.current);
            $9d6a2010e454caac$var$Tg(b, c);
            e = $9d6a2010e454caac$var$Xh(null, b, d, a, e, c);
            var f = $9d6a2010e454caac$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9d6a2010e454caac$var$Zf(d) ? (f = !0, $9d6a2010e454caac$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9d6a2010e454caac$var$ah(b), e.updater = $9d6a2010e454caac$var$nh, b.stateNode = e, e._reactInternals = b, $9d6a2010e454caac$var$rh(b, d, a, c), b = $9d6a2010e454caac$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $9d6a2010e454caac$var$I && f && $9d6a2010e454caac$var$vg(b), $9d6a2010e454caac$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9d6a2010e454caac$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9d6a2010e454caac$var$$k(d);
                a = $9d6a2010e454caac$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $9d6a2010e454caac$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9d6a2010e454caac$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9d6a2010e454caac$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9d6a2010e454caac$var$aj(null, b, d, $9d6a2010e454caac$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($9d6a2010e454caac$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d6a2010e454caac$var$Lg(d, e), $9d6a2010e454caac$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d6a2010e454caac$var$Lg(d, e), $9d6a2010e454caac$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $9d6a2010e454caac$var$lj(b);
                if (null === a) throw Error($9d6a2010e454caac$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9d6a2010e454caac$var$bh(a, b);
                $9d6a2010e454caac$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9d6a2010e454caac$var$Ki(Error($9d6a2010e454caac$var$p(423)), b);
                        b = $9d6a2010e454caac$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9d6a2010e454caac$var$Ki(Error($9d6a2010e454caac$var$p(424)), b);
                        b = $9d6a2010e454caac$var$mj(a, b, d, c, e);
                        break a;
                    } else for($9d6a2010e454caac$var$yg = $9d6a2010e454caac$var$Lf(b.stateNode.containerInfo.firstChild), $9d6a2010e454caac$var$xg = b, $9d6a2010e454caac$var$I = !0, $9d6a2010e454caac$var$zg = null, c = $9d6a2010e454caac$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9d6a2010e454caac$var$Ig();
                    if (d === e) {
                        b = $9d6a2010e454caac$var$$i(a, b, c);
                        break a;
                    }
                    $9d6a2010e454caac$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9d6a2010e454caac$var$Kh(b), null === a && $9d6a2010e454caac$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9d6a2010e454caac$var$Ef(d, e) ? g = null : null !== f && $9d6a2010e454caac$var$Ef(d, f) && (b.flags |= 32), $9d6a2010e454caac$var$hj(a, b), $9d6a2010e454caac$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $9d6a2010e454caac$var$Eg(b), null;
        case 13:
            return $9d6a2010e454caac$var$pj(a, b, c);
        case 4:
            return $9d6a2010e454caac$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9d6a2010e454caac$var$Bh(b, null, d, c) : $9d6a2010e454caac$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d6a2010e454caac$var$Lg(d, e), $9d6a2010e454caac$var$Zi(a, b, d, e, c);
        case 7:
            return $9d6a2010e454caac$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9d6a2010e454caac$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9d6a2010e454caac$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9d6a2010e454caac$var$G($9d6a2010e454caac$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9d6a2010e454caac$var$He(f.value, g)) {
                        if (f.children === e.children && !$9d6a2010e454caac$var$Wf.current) {
                            b = $9d6a2010e454caac$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9d6a2010e454caac$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9d6a2010e454caac$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9d6a2010e454caac$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9d6a2010e454caac$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9d6a2010e454caac$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9d6a2010e454caac$var$Tg(b, c), e = $9d6a2010e454caac$var$Vg(e), d = d(e), b.flags |= 1, $9d6a2010e454caac$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9d6a2010e454caac$var$Lg(d, b.pendingProps), e = $9d6a2010e454caac$var$Lg(d.type, e), $9d6a2010e454caac$var$aj(a, b, d, e, c);
        case 15:
            return $9d6a2010e454caac$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d6a2010e454caac$var$Lg(d, e), $9d6a2010e454caac$var$jj(a, b), b.tag = 1, $9d6a2010e454caac$var$Zf(d) ? (a = !0, $9d6a2010e454caac$var$cg(b)) : a = !1, $9d6a2010e454caac$var$Tg(b, c), $9d6a2010e454caac$var$ph(b, d, e), $9d6a2010e454caac$var$rh(b, d, e, c), $9d6a2010e454caac$var$kj(null, b, d, !0, a, c);
        case 19:
            return $9d6a2010e454caac$var$yj(a, b, c);
        case 22:
            return $9d6a2010e454caac$var$ej(a, b, c);
    }
    throw Error($9d6a2010e454caac$var$p(156, b.tag));
};
function $9d6a2010e454caac$var$Gk(a, b) {
    return $9d6a2010e454caac$var$ac(a, b);
}
function $9d6a2010e454caac$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9d6a2010e454caac$var$Bg(a, b, c, d) {
    return new $9d6a2010e454caac$var$al(a, b, c, d);
}
function $9d6a2010e454caac$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9d6a2010e454caac$var$$k(a) {
    if ("function" === typeof a) return $9d6a2010e454caac$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9d6a2010e454caac$var$Da) return 11;
        if (a === $9d6a2010e454caac$var$Ga) return 14;
    }
    return 2;
}
function $9d6a2010e454caac$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $9d6a2010e454caac$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9d6a2010e454caac$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9d6a2010e454caac$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9d6a2010e454caac$var$ya:
            return $9d6a2010e454caac$var$Ah(c.children, e, f, b);
        case $9d6a2010e454caac$var$za:
            g = 8;
            e |= 8;
            break;
        case $9d6a2010e454caac$var$Aa:
            return a = $9d6a2010e454caac$var$Bg(12, c, b, e | 2), a.elementType = $9d6a2010e454caac$var$Aa, a.lanes = f, a;
        case $9d6a2010e454caac$var$Ea:
            return a = $9d6a2010e454caac$var$Bg(13, c, b, e), a.elementType = $9d6a2010e454caac$var$Ea, a.lanes = f, a;
        case $9d6a2010e454caac$var$Fa:
            return a = $9d6a2010e454caac$var$Bg(19, c, b, e), a.elementType = $9d6a2010e454caac$var$Fa, a.lanes = f, a;
        case $9d6a2010e454caac$var$Ia:
            return $9d6a2010e454caac$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9d6a2010e454caac$var$Ba:
                    g = 10;
                    break a;
                case $9d6a2010e454caac$var$Ca:
                    g = 9;
                    break a;
                case $9d6a2010e454caac$var$Da:
                    g = 11;
                    break a;
                case $9d6a2010e454caac$var$Ga:
                    g = 14;
                    break a;
                case $9d6a2010e454caac$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9d6a2010e454caac$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9d6a2010e454caac$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9d6a2010e454caac$var$Ah(a, b, c, d) {
    a = $9d6a2010e454caac$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9d6a2010e454caac$var$qj(a, b, c, d) {
    a = $9d6a2010e454caac$var$Bg(22, a, d, b);
    a.elementType = $9d6a2010e454caac$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9d6a2010e454caac$var$xh(a, b, c) {
    a = $9d6a2010e454caac$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9d6a2010e454caac$var$zh(a, b, c) {
    b = $9d6a2010e454caac$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9d6a2010e454caac$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9d6a2010e454caac$var$zc(0);
    this.expirationTimes = $9d6a2010e454caac$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9d6a2010e454caac$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9d6a2010e454caac$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $9d6a2010e454caac$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9d6a2010e454caac$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9d6a2010e454caac$var$ah(f);
    return a;
}
function $9d6a2010e454caac$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9d6a2010e454caac$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9d6a2010e454caac$var$el(a) {
    if (!a) return $9d6a2010e454caac$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9d6a2010e454caac$var$Vb(a) !== a || 1 !== a.tag) throw Error($9d6a2010e454caac$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9d6a2010e454caac$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9d6a2010e454caac$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9d6a2010e454caac$var$Zf(c)) return $9d6a2010e454caac$var$bg(a, c, b);
    }
    return b;
}
function $9d6a2010e454caac$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $9d6a2010e454caac$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $9d6a2010e454caac$var$el(null);
    c = a.current;
    d = $9d6a2010e454caac$var$L();
    e = $9d6a2010e454caac$var$lh(c);
    f = $9d6a2010e454caac$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9d6a2010e454caac$var$dh(c, f, e);
    a.current.lanes = e;
    $9d6a2010e454caac$var$Ac(a, e, d);
    $9d6a2010e454caac$var$Ek(a, d);
    return a;
}
function $9d6a2010e454caac$var$gl(a, b, c, d) {
    var e = b.current, f = $9d6a2010e454caac$var$L(), g = $9d6a2010e454caac$var$lh(e);
    c = $9d6a2010e454caac$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9d6a2010e454caac$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9d6a2010e454caac$var$dh(e, b, g);
    null !== a && ($9d6a2010e454caac$var$mh(a, e, g, f), $9d6a2010e454caac$var$eh(a, e, g));
    return g;
}
function $9d6a2010e454caac$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9d6a2010e454caac$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9d6a2010e454caac$var$jl(a, b) {
    $9d6a2010e454caac$var$il(a, b);
    (a = a.alternate) && $9d6a2010e454caac$var$il(a, b);
}
function $9d6a2010e454caac$var$kl() {
    return null;
}
var $9d6a2010e454caac$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9d6a2010e454caac$var$ml(a) {
    this._internalRoot = a;
}
$9d6a2010e454caac$var$nl.prototype.render = $9d6a2010e454caac$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9d6a2010e454caac$var$p(409));
    $9d6a2010e454caac$var$gl(a, b, null, null);
};
$9d6a2010e454caac$var$nl.prototype.unmount = $9d6a2010e454caac$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9d6a2010e454caac$var$Sk(function() {
            $9d6a2010e454caac$var$gl(null, a, null, null);
        });
        b[$9d6a2010e454caac$var$uf] = null;
    }
};
function $9d6a2010e454caac$var$nl(a) {
    this._internalRoot = a;
}
$9d6a2010e454caac$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9d6a2010e454caac$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9d6a2010e454caac$var$Qc.length && 0 !== b && b < $9d6a2010e454caac$var$Qc[c].priority; c++);
        $9d6a2010e454caac$var$Qc.splice(c, 0, a);
        0 === c && $9d6a2010e454caac$var$Vc(a);
    }
};
function $9d6a2010e454caac$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9d6a2010e454caac$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9d6a2010e454caac$var$ql() {}
function $9d6a2010e454caac$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9d6a2010e454caac$var$hl(g);
                f.call(a);
            };
        }
        var g = $9d6a2010e454caac$var$fl(b, d, a, 0, null, !1, !1, "", $9d6a2010e454caac$var$ql);
        a._reactRootContainer = g;
        a[$9d6a2010e454caac$var$uf] = g.current;
        $9d6a2010e454caac$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9d6a2010e454caac$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9d6a2010e454caac$var$hl(k);
            h.call(a);
        };
    }
    var k = $9d6a2010e454caac$var$cl(a, 0, !1, null, null, !1, !1, "", $9d6a2010e454caac$var$ql);
    a._reactRootContainer = k;
    a[$9d6a2010e454caac$var$uf] = k.current;
    $9d6a2010e454caac$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9d6a2010e454caac$var$Sk(function() {
        $9d6a2010e454caac$var$gl(b, k, c, d);
    });
    return k;
}
function $9d6a2010e454caac$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9d6a2010e454caac$var$hl(g);
                h.call(a);
            };
        }
        $9d6a2010e454caac$var$gl(b, g, a, e);
    } else g = $9d6a2010e454caac$var$rl(c, b, a, e, d);
    return $9d6a2010e454caac$var$hl(g);
}
$9d6a2010e454caac$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9d6a2010e454caac$var$tc(b.pendingLanes);
                0 !== c && ($9d6a2010e454caac$var$Cc(b, c | 1), $9d6a2010e454caac$var$Ek(b, $9d6a2010e454caac$var$B()), 0 === ($9d6a2010e454caac$var$K & 6) && ($9d6a2010e454caac$var$Hj = $9d6a2010e454caac$var$B() + 500, $9d6a2010e454caac$var$jg()));
            }
            break;
        case 13:
            $9d6a2010e454caac$var$Sk(function() {
                var b = $9d6a2010e454caac$var$Zg(a, 1);
                if (null !== b) {
                    var c = $9d6a2010e454caac$var$L();
                    $9d6a2010e454caac$var$mh(b, a, 1, c);
                }
            }), $9d6a2010e454caac$var$jl(a, 1);
    }
};
$9d6a2010e454caac$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9d6a2010e454caac$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $9d6a2010e454caac$var$L();
            $9d6a2010e454caac$var$mh(b, a, 134217728, c);
        }
        $9d6a2010e454caac$var$jl(a, 134217728);
    }
};
$9d6a2010e454caac$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9d6a2010e454caac$var$lh(a), c = $9d6a2010e454caac$var$Zg(a, b);
        if (null !== c) {
            var d = $9d6a2010e454caac$var$L();
            $9d6a2010e454caac$var$mh(c, a, b, d);
        }
        $9d6a2010e454caac$var$jl(a, b);
    }
};
$9d6a2010e454caac$var$Hc = function() {
    return $9d6a2010e454caac$var$C;
};
$9d6a2010e454caac$var$Ic = function(a, b) {
    var c = $9d6a2010e454caac$var$C;
    try {
        return $9d6a2010e454caac$var$C = a, b();
    } finally{
        $9d6a2010e454caac$var$C = c;
    }
};
$9d6a2010e454caac$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9d6a2010e454caac$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9d6a2010e454caac$var$Db(d);
                        if (!e) throw Error($9d6a2010e454caac$var$p(90));
                        $9d6a2010e454caac$var$Wa(d);
                        $9d6a2010e454caac$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9d6a2010e454caac$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9d6a2010e454caac$var$fb(a, !!c.multiple, b, !1);
    }
};
$9d6a2010e454caac$var$Gb = $9d6a2010e454caac$var$Rk;
$9d6a2010e454caac$var$Hb = $9d6a2010e454caac$var$Sk;
var $9d6a2010e454caac$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $9d6a2010e454caac$var$Cb,
        $9d6a2010e454caac$var$ue,
        $9d6a2010e454caac$var$Db,
        $9d6a2010e454caac$var$Eb,
        $9d6a2010e454caac$var$Fb,
        $9d6a2010e454caac$var$Rk
    ]
}, $9d6a2010e454caac$var$ul = {
    findFiberByHostInstance: $9d6a2010e454caac$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $9d6a2010e454caac$var$vl = {
    bundleType: $9d6a2010e454caac$var$ul.bundleType,
    version: $9d6a2010e454caac$var$ul.version,
    rendererPackageName: $9d6a2010e454caac$var$ul.rendererPackageName,
    rendererConfig: $9d6a2010e454caac$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9d6a2010e454caac$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9d6a2010e454caac$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9d6a2010e454caac$var$ul.findFiberByHostInstance || $9d6a2010e454caac$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9d6a2010e454caac$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9d6a2010e454caac$var$wl.isDisabled && $9d6a2010e454caac$var$wl.supportsFiber) try {
        $9d6a2010e454caac$var$kc = $9d6a2010e454caac$var$wl.inject($9d6a2010e454caac$var$vl), $9d6a2010e454caac$var$lc = $9d6a2010e454caac$var$wl;
    } catch (a) {}
}
$9d6a2010e454caac$export$ae55be85d98224ed = $9d6a2010e454caac$var$tl;
$9d6a2010e454caac$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9d6a2010e454caac$var$ol(b)) throw Error($9d6a2010e454caac$var$p(200));
    return $9d6a2010e454caac$var$dl(a, b, null, c);
};
$9d6a2010e454caac$export$882461b6382ed46c = function(a, b) {
    if (!$9d6a2010e454caac$var$ol(a)) throw Error($9d6a2010e454caac$var$p(299));
    var c = !1, d = "", e = $9d6a2010e454caac$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9d6a2010e454caac$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$9d6a2010e454caac$var$uf] = b.current;
    $9d6a2010e454caac$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9d6a2010e454caac$var$ml(b);
};
$9d6a2010e454caac$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9d6a2010e454caac$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9d6a2010e454caac$var$p(268, a));
    }
    a = $9d6a2010e454caac$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9d6a2010e454caac$export$cd75ccfd720a3cd4 = function(a) {
    return $9d6a2010e454caac$var$Sk(a);
};
$9d6a2010e454caac$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9d6a2010e454caac$var$pl(b)) throw Error($9d6a2010e454caac$var$p(200));
    return $9d6a2010e454caac$var$sl(null, a, b, !0, c);
};
$9d6a2010e454caac$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9d6a2010e454caac$var$ol(a)) throw Error($9d6a2010e454caac$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9d6a2010e454caac$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9d6a2010e454caac$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9d6a2010e454caac$var$uf] = b.current;
    $9d6a2010e454caac$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9d6a2010e454caac$var$nl(b);
};
$9d6a2010e454caac$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9d6a2010e454caac$var$pl(b)) throw Error($9d6a2010e454caac$var$p(200));
    return $9d6a2010e454caac$var$sl(null, a, b, !1, c);
};
$9d6a2010e454caac$export$502457920280e6be = function(a) {
    if (!$9d6a2010e454caac$var$pl(a)) throw Error($9d6a2010e454caac$var$p(40));
    return a._reactRootContainer ? ($9d6a2010e454caac$var$Sk(function() {
        $9d6a2010e454caac$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9d6a2010e454caac$var$uf] = null;
        });
    }), !0) : !1;
};
$9d6a2010e454caac$export$c78a37762a8d58e1 = $9d6a2010e454caac$var$Rk;
$9d6a2010e454caac$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9d6a2010e454caac$var$pl(c)) throw Error($9d6a2010e454caac$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9d6a2010e454caac$var$p(38));
    return $9d6a2010e454caac$var$sl(a, b, c, !1, d);
};
$9d6a2010e454caac$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("jz6aq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kwLUN"));

});
parcelRegister("kwLUN", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ef1bf6ba268377d9$export$c4744153514ff05d; }, function (v) { return $ef1bf6ba268377d9$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ef1bf6ba268377d9$export$3e506c1ccc9cc1a7; }, function (v) { return $ef1bf6ba268377d9$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ef1bf6ba268377d9$export$e26fe2ed2fa76875; }, function (v) { return $ef1bf6ba268377d9$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ef1bf6ba268377d9$export$502329bbf4b505b1; }, function (v) { return $ef1bf6ba268377d9$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ef1bf6ba268377d9$export$6e3807111c4874c4; }, function (v) { return $ef1bf6ba268377d9$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ef1bf6ba268377d9$export$c27134553091fb3a; }, function (v) { return $ef1bf6ba268377d9$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ef1bf6ba268377d9$export$33ee1acdc04fd2a2; }, function (v) { return $ef1bf6ba268377d9$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ef1bf6ba268377d9$export$b00a404bbd5edef2; }, function (v) { return $ef1bf6ba268377d9$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ef1bf6ba268377d9$export$8352ce38b91d0c62; }, function (v) { return $ef1bf6ba268377d9$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ef1bf6ba268377d9$export$d66a1c1c77bd778b; }, function (v) { return $ef1bf6ba268377d9$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ef1bf6ba268377d9$export$d3dfb8e4810cb555; }, function (v) { return $ef1bf6ba268377d9$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ef1bf6ba268377d9$export$839f9183b0465a69; }, function (v) { return $ef1bf6ba268377d9$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ef1bf6ba268377d9$export$72fdf0e06517287b; }, function (v) { return $ef1bf6ba268377d9$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ef1bf6ba268377d9$export$4b844e58a3e414b4; }, function (v) { return $ef1bf6ba268377d9$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ef1bf6ba268377d9$export$816d2913ae6b83b1; }, function (v) { return $ef1bf6ba268377d9$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ef1bf6ba268377d9$export$61bcfe829111a1d0; }, function (v) { return $ef1bf6ba268377d9$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ef1bf6ba268377d9$export$7ee8c9beb337bc3f; }, function (v) { return $ef1bf6ba268377d9$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ef1bf6ba268377d9$export$b5836b71941fa3ed; }, function (v) { return $ef1bf6ba268377d9$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ef1bf6ba268377d9$export$cf845f2c119da08a; }, function (v) { return $ef1bf6ba268377d9$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef1bf6ba268377d9$export$c4744153514ff05d;
var $ef1bf6ba268377d9$export$3e506c1ccc9cc1a7;
var $ef1bf6ba268377d9$export$e26fe2ed2fa76875;
var $ef1bf6ba268377d9$export$502329bbf4b505b1;
var $ef1bf6ba268377d9$export$6e3807111c4874c4;
var $ef1bf6ba268377d9$export$c27134553091fb3a;
var $ef1bf6ba268377d9$export$33ee1acdc04fd2a2;
var $ef1bf6ba268377d9$export$b00a404bbd5edef2;
var $ef1bf6ba268377d9$export$8352ce38b91d0c62;
var $ef1bf6ba268377d9$export$d66a1c1c77bd778b;
var $ef1bf6ba268377d9$export$d3dfb8e4810cb555;
var $ef1bf6ba268377d9$export$839f9183b0465a69;
var $ef1bf6ba268377d9$export$72fdf0e06517287b;
var $ef1bf6ba268377d9$export$4b844e58a3e414b4;
var $ef1bf6ba268377d9$export$816d2913ae6b83b1;
var $ef1bf6ba268377d9$export$61bcfe829111a1d0;
var $ef1bf6ba268377d9$export$7ee8c9beb337bc3f;
var $ef1bf6ba268377d9$export$b5836b71941fa3ed;
var $ef1bf6ba268377d9$export$cf845f2c119da08a;
"use strict";
function $ef1bf6ba268377d9$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ef1bf6ba268377d9$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ef1bf6ba268377d9$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ef1bf6ba268377d9$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ef1bf6ba268377d9$var$g(C, c)) n < e && 0 > $ef1bf6ba268377d9$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ef1bf6ba268377d9$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ef1bf6ba268377d9$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ef1bf6ba268377d9$var$l = performance;
    $ef1bf6ba268377d9$export$c4744153514ff05d = function() {
        return $ef1bf6ba268377d9$var$l.now();
    };
} else {
    var $ef1bf6ba268377d9$var$p = Date, $ef1bf6ba268377d9$var$q = $ef1bf6ba268377d9$var$p.now();
    $ef1bf6ba268377d9$export$c4744153514ff05d = function() {
        return $ef1bf6ba268377d9$var$p.now() - $ef1bf6ba268377d9$var$q;
    };
}
var $ef1bf6ba268377d9$var$r = [], $ef1bf6ba268377d9$var$t = [], $ef1bf6ba268377d9$var$u = 1, $ef1bf6ba268377d9$var$v = null, $ef1bf6ba268377d9$var$y = 3, $ef1bf6ba268377d9$var$z = !1, $ef1bf6ba268377d9$var$A = !1, $ef1bf6ba268377d9$var$B = !1, $ef1bf6ba268377d9$var$D = "function" === typeof setTimeout ? setTimeout : null, $ef1bf6ba268377d9$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ef1bf6ba268377d9$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ef1bf6ba268377d9$var$G(a) {
    for(var b = $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$t); null !== b;){
        if (null === b.callback) $ef1bf6ba268377d9$var$k($ef1bf6ba268377d9$var$t);
        else if (b.startTime <= a) $ef1bf6ba268377d9$var$k($ef1bf6ba268377d9$var$t), b.sortIndex = b.expirationTime, $ef1bf6ba268377d9$var$f($ef1bf6ba268377d9$var$r, b);
        else break;
        b = $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$t);
    }
}
function $ef1bf6ba268377d9$var$H(a) {
    $ef1bf6ba268377d9$var$B = !1;
    $ef1bf6ba268377d9$var$G(a);
    if (!$ef1bf6ba268377d9$var$A) {
        if (null !== $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$r)) $ef1bf6ba268377d9$var$A = !0, $ef1bf6ba268377d9$var$I($ef1bf6ba268377d9$var$J);
        else {
            var b = $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$t);
            null !== b && $ef1bf6ba268377d9$var$K($ef1bf6ba268377d9$var$H, b.startTime - a);
        }
    }
}
function $ef1bf6ba268377d9$var$J(a, b) {
    $ef1bf6ba268377d9$var$A = !1;
    $ef1bf6ba268377d9$var$B && ($ef1bf6ba268377d9$var$B = !1, $ef1bf6ba268377d9$var$E($ef1bf6ba268377d9$var$L), $ef1bf6ba268377d9$var$L = -1);
    $ef1bf6ba268377d9$var$z = !0;
    var c = $ef1bf6ba268377d9$var$y;
    try {
        $ef1bf6ba268377d9$var$G(b);
        for($ef1bf6ba268377d9$var$v = $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$r); null !== $ef1bf6ba268377d9$var$v && (!($ef1bf6ba268377d9$var$v.expirationTime > b) || a && !$ef1bf6ba268377d9$var$M());){
            var d = $ef1bf6ba268377d9$var$v.callback;
            if ("function" === typeof d) {
                $ef1bf6ba268377d9$var$v.callback = null;
                $ef1bf6ba268377d9$var$y = $ef1bf6ba268377d9$var$v.priorityLevel;
                var e = d($ef1bf6ba268377d9$var$v.expirationTime <= b);
                b = $ef1bf6ba268377d9$export$c4744153514ff05d();
                "function" === typeof e ? $ef1bf6ba268377d9$var$v.callback = e : $ef1bf6ba268377d9$var$v === $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$r) && $ef1bf6ba268377d9$var$k($ef1bf6ba268377d9$var$r);
                $ef1bf6ba268377d9$var$G(b);
            } else $ef1bf6ba268377d9$var$k($ef1bf6ba268377d9$var$r);
            $ef1bf6ba268377d9$var$v = $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$r);
        }
        if (null !== $ef1bf6ba268377d9$var$v) var w = !0;
        else {
            var m = $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$t);
            null !== m && $ef1bf6ba268377d9$var$K($ef1bf6ba268377d9$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ef1bf6ba268377d9$var$v = null, $ef1bf6ba268377d9$var$y = c, $ef1bf6ba268377d9$var$z = !1;
    }
}
var $ef1bf6ba268377d9$var$N = !1, $ef1bf6ba268377d9$var$O = null, $ef1bf6ba268377d9$var$L = -1, $ef1bf6ba268377d9$var$P = 5, $ef1bf6ba268377d9$var$Q = -1;
function $ef1bf6ba268377d9$var$M() {
    return $ef1bf6ba268377d9$export$c4744153514ff05d() - $ef1bf6ba268377d9$var$Q < $ef1bf6ba268377d9$var$P ? !1 : !0;
}
function $ef1bf6ba268377d9$var$R() {
    if (null !== $ef1bf6ba268377d9$var$O) {
        var a = $ef1bf6ba268377d9$export$c4744153514ff05d();
        $ef1bf6ba268377d9$var$Q = a;
        var b = !0;
        try {
            b = $ef1bf6ba268377d9$var$O(!0, a);
        } finally{
            b ? $ef1bf6ba268377d9$var$S() : ($ef1bf6ba268377d9$var$N = !1, $ef1bf6ba268377d9$var$O = null);
        }
    } else $ef1bf6ba268377d9$var$N = !1;
}
var $ef1bf6ba268377d9$var$S;
if ("function" === typeof $ef1bf6ba268377d9$var$F) $ef1bf6ba268377d9$var$S = function() {
    $ef1bf6ba268377d9$var$F($ef1bf6ba268377d9$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ef1bf6ba268377d9$var$T = new MessageChannel, $ef1bf6ba268377d9$var$U = $ef1bf6ba268377d9$var$T.port2;
    $ef1bf6ba268377d9$var$T.port1.onmessage = $ef1bf6ba268377d9$var$R;
    $ef1bf6ba268377d9$var$S = function() {
        $ef1bf6ba268377d9$var$U.postMessage(null);
    };
} else $ef1bf6ba268377d9$var$S = function() {
    $ef1bf6ba268377d9$var$D($ef1bf6ba268377d9$var$R, 0);
};
function $ef1bf6ba268377d9$var$I(a) {
    $ef1bf6ba268377d9$var$O = a;
    $ef1bf6ba268377d9$var$N || ($ef1bf6ba268377d9$var$N = !0, $ef1bf6ba268377d9$var$S());
}
function $ef1bf6ba268377d9$var$K(a, b) {
    $ef1bf6ba268377d9$var$L = $ef1bf6ba268377d9$var$D(function() {
        a($ef1bf6ba268377d9$export$c4744153514ff05d());
    }, b);
}
$ef1bf6ba268377d9$export$3e506c1ccc9cc1a7 = 5;
$ef1bf6ba268377d9$export$e26fe2ed2fa76875 = 1;
$ef1bf6ba268377d9$export$502329bbf4b505b1 = 4;
$ef1bf6ba268377d9$export$6e3807111c4874c4 = 3;
$ef1bf6ba268377d9$export$c27134553091fb3a = null;
$ef1bf6ba268377d9$export$33ee1acdc04fd2a2 = 2;
$ef1bf6ba268377d9$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ef1bf6ba268377d9$export$8352ce38b91d0c62 = function() {
    $ef1bf6ba268377d9$var$A || $ef1bf6ba268377d9$var$z || ($ef1bf6ba268377d9$var$A = !0, $ef1bf6ba268377d9$var$I($ef1bf6ba268377d9$var$J));
};
$ef1bf6ba268377d9$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ef1bf6ba268377d9$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ef1bf6ba268377d9$export$d3dfb8e4810cb555 = function() {
    return $ef1bf6ba268377d9$var$y;
};
$ef1bf6ba268377d9$export$839f9183b0465a69 = function() {
    return $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$r);
};
$ef1bf6ba268377d9$export$72fdf0e06517287b = function(a) {
    switch($ef1bf6ba268377d9$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ef1bf6ba268377d9$var$y;
    }
    var c = $ef1bf6ba268377d9$var$y;
    $ef1bf6ba268377d9$var$y = b;
    try {
        return a();
    } finally{
        $ef1bf6ba268377d9$var$y = c;
    }
};
$ef1bf6ba268377d9$export$4b844e58a3e414b4 = function() {};
$ef1bf6ba268377d9$export$816d2913ae6b83b1 = function() {};
$ef1bf6ba268377d9$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ef1bf6ba268377d9$var$y;
    $ef1bf6ba268377d9$var$y = a;
    try {
        return b();
    } finally{
        $ef1bf6ba268377d9$var$y = c;
    }
};
$ef1bf6ba268377d9$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ef1bf6ba268377d9$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ef1bf6ba268377d9$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ef1bf6ba268377d9$var$f($ef1bf6ba268377d9$var$t, a), null === $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$r) && a === $ef1bf6ba268377d9$var$h($ef1bf6ba268377d9$var$t) && ($ef1bf6ba268377d9$var$B ? ($ef1bf6ba268377d9$var$E($ef1bf6ba268377d9$var$L), $ef1bf6ba268377d9$var$L = -1) : $ef1bf6ba268377d9$var$B = !0, $ef1bf6ba268377d9$var$K($ef1bf6ba268377d9$var$H, c - d))) : (a.sortIndex = e, $ef1bf6ba268377d9$var$f($ef1bf6ba268377d9$var$r, a), $ef1bf6ba268377d9$var$A || $ef1bf6ba268377d9$var$z || ($ef1bf6ba268377d9$var$A = !0, $ef1bf6ba268377d9$var$I($ef1bf6ba268377d9$var$J)));
    return a;
};
$ef1bf6ba268377d9$export$b5836b71941fa3ed = $ef1bf6ba268377d9$var$M;
$ef1bf6ba268377d9$export$cf845f2c119da08a = function(a) {
    var b = $ef1bf6ba268377d9$var$y;
    return function() {
        var c = $ef1bf6ba268377d9$var$y;
        $ef1bf6ba268377d9$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ef1bf6ba268377d9$var$y = c;
        }
    };
};

});



parcelRegister("4opbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");

var $332cef67673435e6$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $jri4r = parcelRequire("jri4r");

var $celCa = parcelRequire("celCa");
function $332cef67673435e6$var$useIntl() {
    var intl = $332cef67673435e6$var$React.useContext($jri4r.Context);
    (0, $celCa.invariantIntlContext)(intl);
    return intl;
}
module.exports.default = $332cef67673435e6$var$useIntl;

});
parcelRegister("4UZnF", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $394c014f9626093e$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $394c014f9626093e$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $394c014f9626093e$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $394c014f9626093e$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $394c014f9626093e$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $394c014f9626093e$export$f33643c0debef087; });
$parcel$export(module.exports, "__spreadArray", function () { return $394c014f9626093e$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importStar", function () { return $394c014f9626093e$export$c21735bcef00d192; });
$parcel$export(module.exports, "__importDefault", function () { return $394c014f9626093e$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $394c014f9626093e$var$extendStatics = function(d, b) {
    $394c014f9626093e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $394c014f9626093e$var$extendStatics(d, b);
};
function $394c014f9626093e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $394c014f9626093e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $394c014f9626093e$export$18ce0697a983be9b = function() {
    $394c014f9626093e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $394c014f9626093e$export$18ce0697a983be9b.apply(this, arguments);
};
function $394c014f9626093e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $394c014f9626093e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $394c014f9626093e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $394c014f9626093e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $394c014f9626093e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $394c014f9626093e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $394c014f9626093e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $394c014f9626093e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $394c014f9626093e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $394c014f9626093e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $394c014f9626093e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $394c014f9626093e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $394c014f9626093e$export$45d3717a4c69092e(o, m, p);
}
function $394c014f9626093e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $394c014f9626093e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $394c014f9626093e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($394c014f9626093e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $394c014f9626093e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $394c014f9626093e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $394c014f9626093e$export$10c90e4f7922046c(v) {
    return this instanceof $394c014f9626093e$export$10c90e4f7922046c ? (this.v = v, this) : new $394c014f9626093e$export$10c90e4f7922046c(v);
}
function $394c014f9626093e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $394c014f9626093e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $394c014f9626093e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $394c014f9626093e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $394c014f9626093e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $394c014f9626093e$export$19a8beecd37a4c45 === "function" ? $394c014f9626093e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $394c014f9626093e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $394c014f9626093e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $394c014f9626093e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $394c014f9626093e$export$45d3717a4c69092e(result, mod, k);
    }
    $394c014f9626093e$var$__setModuleDefault(result, mod);
    return result;
}
function $394c014f9626093e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $394c014f9626093e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $394c014f9626093e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $394c014f9626093e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $394c014f9626093e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $394c014f9626093e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $394c014f9626093e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $394c014f9626093e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $394c014f9626093e$export$2e2bcd8739ae039 = {
    __extends: $394c014f9626093e$export$a8ba968b8961cb8a,
    __assign: $394c014f9626093e$export$18ce0697a983be9b,
    __rest: $394c014f9626093e$export$3c9a16f847548506,
    __decorate: $394c014f9626093e$export$29e00dfd3077644b,
    __param: $394c014f9626093e$export$d5ad3fd78186038f,
    __metadata: $394c014f9626093e$export$f1db080c865becb9,
    __awaiter: $394c014f9626093e$export$1050f835b63b671e,
    __generator: $394c014f9626093e$export$67ebef60e6f28a6,
    __createBinding: $394c014f9626093e$export$45d3717a4c69092e,
    __exportStar: $394c014f9626093e$export$f33643c0debef087,
    __values: $394c014f9626093e$export$19a8beecd37a4c45,
    __read: $394c014f9626093e$export$8d051b38c9118094,
    __spread: $394c014f9626093e$export$afc72e2116322959,
    __spreadArrays: $394c014f9626093e$export$6388937ca91ccae8,
    __spreadArray: $394c014f9626093e$export$1216008129fb82ed,
    __await: $394c014f9626093e$export$10c90e4f7922046c,
    __asyncGenerator: $394c014f9626093e$export$e427f37a30a4de9b,
    __asyncDelegator: $394c014f9626093e$export$bbd80228419bb833,
    __asyncValues: $394c014f9626093e$export$e3b29a3d6162315f,
    __makeTemplateObject: $394c014f9626093e$export$4fb47efe1390b86f,
    __importStar: $394c014f9626093e$export$c21735bcef00d192,
    __importDefault: $394c014f9626093e$export$da59b14a69baef04,
    __classPrivateFieldGet: $394c014f9626093e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $394c014f9626093e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $394c014f9626093e$export$81fdc39f203e4e04,
    __addDisposableResource: $394c014f9626093e$export$88ac25d8e944e405,
    __disposeResources: $394c014f9626093e$export$8f076105dc360e92
};

});

parcelRegister("jri4r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Context = module.exports.Provider = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $e26e8e63b5aa82f6$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $e26e8e63b5aa82f6$var$hoist_non_react_statics_1 = $4UZnF.__importDefault((parcelRequire("8FL51")));

var $celCa = parcelRequire("celCa");
function $e26e8e63b5aa82f6$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $e26e8e63b5aa82f6$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $e26e8e63b5aa82f6$var$React.createContext(null)) : $e26e8e63b5aa82f6$var$React.createContext(null);
var $e26e8e63b5aa82f6$var$IntlConsumer = $e26e8e63b5aa82f6$var$IntlContext.Consumer, $e26e8e63b5aa82f6$var$IntlProvider = $e26e8e63b5aa82f6$var$IntlContext.Provider;
module.exports.Provider = $e26e8e63b5aa82f6$var$IntlProvider;
module.exports.Context = $e26e8e63b5aa82f6$var$IntlContext;
function $e26e8e63b5aa82f6$var$injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $e26e8e63b5aa82f6$var$React.createElement($e26e8e63b5aa82f6$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $celCa.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $e26e8e63b5aa82f6$var$React.createElement(WrappedComponent, $4UZnF.__assign({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($e26e8e63b5aa82f6$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, $e26e8e63b5aa82f6$var$hoist_non_react_statics_1.default)($e26e8e63b5aa82f6$var$React.forwardRef(function(props, ref) {
        return $e26e8e63b5aa82f6$var$React.createElement(WithIntl, $4UZnF.__assign({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, $e26e8e63b5aa82f6$var$hoist_non_react_statics_1.default)(WithIntl, WrappedComponent);
}
module.exports.default = $e26e8e63b5aa82f6$var$injectIntl;

});
parcelRegister("celCa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shallowEqual = module.exports.assignUniqueKeysToParts = module.exports.DEFAULT_INTL_CONFIG = module.exports.invariantIntlContext = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $8e778f0dd2b8938a$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $ekYZ8 = parcelRequire("ekYZ8");

var $1Bl6Z = parcelRequire("1Bl6Z");
function $8e778f0dd2b8938a$var$invariantIntlContext(intl) {
    (0, $ekYZ8.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
module.exports.invariantIntlContext = $8e778f0dd2b8938a$var$invariantIntlContext;
module.exports.DEFAULT_INTL_CONFIG = $4UZnF.__assign($4UZnF.__assign({}, $1Bl6Z.DEFAULT_INTL_CONFIG), {
    textComponent: $8e778f0dd2b8938a$var$React.Fragment
});
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ function $8e778f0dd2b8938a$var$assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($8e778f0dd2b8938a$var$React.Children.toArray(parts));
    };
}
module.exports.assignUniqueKeysToParts = $8e778f0dd2b8938a$var$assignUniqueKeysToParts;
function $8e778f0dd2b8938a$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
module.exports.shallowEqual = $8e778f0dd2b8938a$var$shallowEqual;

});
parcelRegister("ekYZ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.isMissingLocaleDataError = module.exports.defineProperty = module.exports.getMagnitude = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports._formatToParts = void 0;

var $4UZnF = parcelRequire("4UZnF");

$4UZnF.__exportStar((parcelRequire("i9u1J")), module.exports);

$4UZnF.__exportStar((parcelRequire("iIRfp")), module.exports);

$4UZnF.__exportStar((parcelRequire("g0hCv")), module.exports);

$4UZnF.__exportStar((parcelRequire("kvrN2")), module.exports);

$4UZnF.__exportStar((parcelRequire("rTD91")), module.exports);

$4UZnF.__exportStar((parcelRequire("dn7hJ")), module.exports);

$4UZnF.__exportStar((parcelRequire("5SuUV")), module.exports);

$4UZnF.__exportStar((parcelRequire("j0bw7")), module.exports);

$4UZnF.__exportStar((parcelRequire("gIk6D")), module.exports);

$4UZnF.__exportStar((parcelRequire("atvAh")), module.exports);

$4UZnF.__exportStar((parcelRequire("4EAEx")), module.exports);

$4UZnF.__exportStar((parcelRequire("5zVMy")), module.exports);

$4UZnF.__exportStar((parcelRequire("1Zs0r")), module.exports);

$4UZnF.__exportStar((parcelRequire("jItnS")), module.exports);

$4UZnF.__exportStar((parcelRequire("cB3aE")), module.exports);

$4UZnF.__exportStar((parcelRequire("7s5DV")), module.exports);

$4UZnF.__exportStar((parcelRequire("19vN0")), module.exports);

$4UZnF.__exportStar((parcelRequire("8LEhW")), module.exports);

$4UZnF.__exportStar((parcelRequire("hGtnW")), module.exports);

$4UZnF.__exportStar((parcelRequire("amR5t")), module.exports);

$4UZnF.__exportStar((parcelRequire("koIzO")), module.exports);

$4UZnF.__exportStar((parcelRequire("ko0U0")), module.exports);

$4UZnF.__exportStar((parcelRequire("e2aOi")), module.exports);

$4UZnF.__exportStar((parcelRequire("lwxMS")), module.exports);

$4UZnF.__exportStar((parcelRequire("9Mz4z")), module.exports);

$4UZnF.__exportStar((parcelRequire("jOD6q")), module.exports);

$4UZnF.__exportStar((parcelRequire("2YEFp")), module.exports);

$4UZnF.__exportStar((parcelRequire("h3j5k")), module.exports);

$4UZnF.__exportStar((parcelRequire("hhTpf")), module.exports);

var $hjjlN = parcelRequire("hjjlN");
Object.defineProperty(module.exports, "_formatToParts", {
    enumerable: true,
    get: function() {
        return $4UZnF.__importDefault($hjjlN).default;
    }
});

$4UZnF.__exportStar((parcelRequire("71hGi")), module.exports);

$4UZnF.__exportStar((parcelRequire("afaf6")), module.exports);

var $jSW1Z = parcelRequire("jSW1Z");
Object.defineProperty(module.exports, "getInternalSlot", {
    enumerable: true,
    get: function() {
        return $jSW1Z.getInternalSlot;
    }
});
Object.defineProperty(module.exports, "getMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $jSW1Z.getMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "isLiteralPart", {
    enumerable: true,
    get: function() {
        return $jSW1Z.isLiteralPart;
    }
});
Object.defineProperty(module.exports, "setInternalSlot", {
    enumerable: true,
    get: function() {
        return $jSW1Z.setInternalSlot;
    }
});
Object.defineProperty(module.exports, "setMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $jSW1Z.setMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "getMagnitude", {
    enumerable: true,
    get: function() {
        return $jSW1Z.getMagnitude;
    }
});
Object.defineProperty(module.exports, "defineProperty", {
    enumerable: true,
    get: function() {
        return $jSW1Z.defineProperty;
    }
});

var $7V4jZ = parcelRequire("7V4jZ");
Object.defineProperty(module.exports, "isMissingLocaleDataError", {
    enumerable: true,
    get: function() {
        return $7V4jZ.isMissingLocaleDataError;
    }
});

$4UZnF.__exportStar((parcelRequire("KkLWa")), module.exports);

$4UZnF.__exportStar((parcelRequire("hFt3l")), module.exports);

$4UZnF.__exportStar((parcelRequire("2EjUK")), module.exports);

$4UZnF.__exportStar((parcelRequire("moXUL")), module.exports);

$4UZnF.__exportStar((parcelRequire("XRUya")), module.exports);

$4UZnF.__exportStar((parcelRequire("k1j0e")), module.exports);

var $jSW1Z = parcelRequire("jSW1Z");
Object.defineProperty(module.exports, "invariant", {
    enumerable: true,
    get: function() {
        return $jSW1Z.invariant;
    }
});

$4UZnF.__exportStar((parcelRequire("lOKID")), module.exports);

});
parcelRegister("i9u1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $d3705bf72597d241$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $d3705bf72597d241$var$CanonicalizeLocaleList;

});

parcelRegister("iIRfp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
 * @param tz
 */ function $da15a3ede1c4a52e$var$CanonicalizeTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var uppercasedZones = Object.keys(tzData).reduce(function(all, z) {
        all[z.toUpperCase()] = z;
        return all;
    }, {});
    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
    if (ianaTimeZone === "Etc/UTC" || ianaTimeZone === "Etc/GMT") return "UTC";
    return ianaTimeZone;
}
module.exports.CanonicalizeTimeZoneName = $da15a3ede1c4a52e$var$CanonicalizeTimeZoneName;

});

parcelRegister("g0hCv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoerceOptionsToObject = void 0;

var $lOKID = parcelRequire("lOKID");
/**
 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
 * @param options
 * @returns
 */ function $ba6a506db01944ad$var$CoerceOptionsToObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    return (0, $lOKID.ToObject)(options);
}
module.exports.CoerceOptionsToObject = $ba6a506db01944ad$var$CoerceOptionsToObject;

});
parcelRegister("lOKID", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msFromTime = module.exports.OrdinaryHasInstance = module.exports.SecFromTime = module.exports.MinFromTime = module.exports.HourFromTime = module.exports.DateFromTime = module.exports.MonthFromTime = module.exports.InLeapYear = module.exports.DayWithinYear = module.exports.DaysInYear = module.exports.YearFromTime = module.exports.TimeFromYear = module.exports.DayFromYear = module.exports.WeekDay = module.exports.Day = module.exports.Type = module.exports.HasOwnProperty = module.exports.ArrayCreate = module.exports.SameValue = module.exports.ToObject = module.exports.TimeClip = module.exports.ToNumber = module.exports.ToString = void 0;
/**
 * https://tc39.es/ecma262/#sec-tostring
 */ function $fe2281e426f27f51$var$ToString(o) {
    // Only symbol is irregular...
    if (typeof o === "symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return String(o);
}
module.exports.ToString = $fe2281e426f27f51$var$ToString;
/**
 * https://tc39.es/ecma262/#sec-tonumber
 * @param val
 */ function $fe2281e426f27f51$var$ToNumber(val) {
    if (val === undefined) return NaN;
    if (val === null) return 0;
    if (typeof val === "boolean") return val ? 1 : 0;
    if (typeof val === "number") return val;
    if (typeof val === "symbol" || typeof val === "bigint") throw new TypeError("Cannot convert symbol/bigint to number");
    return Number(val);
}
module.exports.ToNumber = $fe2281e426f27f51$var$ToNumber;
/**
 * https://tc39.es/ecma262/#sec-tointeger
 * @param n
 */ function $fe2281e426f27f51$var$ToInteger(n) {
    var number = $fe2281e426f27f51$var$ToNumber(n);
    if (isNaN(number) || $fe2281e426f27f51$var$SameValue(number, -0)) return 0;
    if (isFinite(number)) return number;
    var integer = Math.floor(Math.abs(number));
    if (number < 0) integer = -integer;
    if ($fe2281e426f27f51$var$SameValue(integer, -0)) return 0;
    return integer;
}
/**
 * https://tc39.es/ecma262/#sec-timeclip
 * @param time
 */ function $fe2281e426f27f51$var$TimeClip(time) {
    if (!isFinite(time)) return NaN;
    if (Math.abs(time) > 8.64 * 1e15) return NaN;
    return $fe2281e426f27f51$var$ToInteger(time);
}
module.exports.TimeClip = $fe2281e426f27f51$var$TimeClip;
/**
 * https://tc39.es/ecma262/#sec-toobject
 * @param arg
 */ function $fe2281e426f27f51$var$ToObject(arg) {
    if (arg == null) throw new TypeError("undefined/null cannot be converted to object");
    return Object(arg);
}
module.exports.ToObject = $fe2281e426f27f51$var$ToObject;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
 * @param x
 * @param y
 */ function $fe2281e426f27f51$var$SameValue(x, y) {
    if (Object.is) return Object.is(x, y);
    // SameValue algorithm
    if (x === y) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
module.exports.SameValue = $fe2281e426f27f51$var$SameValue;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
 * @param len
 */ function $fe2281e426f27f51$var$ArrayCreate(len) {
    return new Array(len);
}
module.exports.ArrayCreate = $fe2281e426f27f51$var$ArrayCreate;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
 * @param o
 * @param prop
 */ function $fe2281e426f27f51$var$HasOwnProperty(o, prop) {
    return Object.prototype.hasOwnProperty.call(o, prop);
}
module.exports.HasOwnProperty = $fe2281e426f27f51$var$HasOwnProperty;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
 * @param x
 */ function $fe2281e426f27f51$var$Type(x) {
    if (x === null) return "Null";
    if (typeof x === "undefined") return "Undefined";
    if (typeof x === "function" || typeof x === "object") return "Object";
    if (typeof x === "number") return "Number";
    if (typeof x === "boolean") return "Boolean";
    if (typeof x === "string") return "String";
    if (typeof x === "symbol") return "Symbol";
    if (typeof x === "bigint") return "BigInt";
}
module.exports.Type = $fe2281e426f27f51$var$Type;
var $fe2281e426f27f51$var$MS_PER_DAY = 86400000;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
 * @param x
 * @param y
 * @return k of the same sign as y
 */ function $fe2281e426f27f51$var$mod(x, y) {
    return x - Math.floor(x / y) * y;
}
/**
 * https://tc39.es/ecma262/#eqn-Day
 * @param t
 */ function $fe2281e426f27f51$var$Day(t) {
    return Math.floor(t / $fe2281e426f27f51$var$MS_PER_DAY);
}
module.exports.Day = $fe2281e426f27f51$var$Day;
/**
 * https://tc39.es/ecma262/#sec-week-day
 * @param t
 */ function $fe2281e426f27f51$var$WeekDay(t) {
    return $fe2281e426f27f51$var$mod($fe2281e426f27f51$var$Day(t) + 4, 7);
}
module.exports.WeekDay = $fe2281e426f27f51$var$WeekDay;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $fe2281e426f27f51$var$DayFromYear(y) {
    return Date.UTC(y, 0) / $fe2281e426f27f51$var$MS_PER_DAY;
}
module.exports.DayFromYear = $fe2281e426f27f51$var$DayFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $fe2281e426f27f51$var$TimeFromYear(y) {
    return Date.UTC(y, 0);
}
module.exports.TimeFromYear = $fe2281e426f27f51$var$TimeFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param t
 */ function $fe2281e426f27f51$var$YearFromTime(t) {
    return new Date(t).getUTCFullYear();
}
module.exports.YearFromTime = $fe2281e426f27f51$var$YearFromTime;
function $fe2281e426f27f51$var$DaysInYear(y) {
    if (y % 4 !== 0) return 365;
    if (y % 100 !== 0) return 366;
    if (y % 400 !== 0) return 365;
    return 366;
}
module.exports.DaysInYear = $fe2281e426f27f51$var$DaysInYear;
function $fe2281e426f27f51$var$DayWithinYear(t) {
    return $fe2281e426f27f51$var$Day(t) - $fe2281e426f27f51$var$DayFromYear($fe2281e426f27f51$var$YearFromTime(t));
}
module.exports.DayWithinYear = $fe2281e426f27f51$var$DayWithinYear;
function $fe2281e426f27f51$var$InLeapYear(t) {
    return $fe2281e426f27f51$var$DaysInYear($fe2281e426f27f51$var$YearFromTime(t)) === 365 ? 0 : 1;
}
module.exports.InLeapYear = $fe2281e426f27f51$var$InLeapYear;
/**
 * https://tc39.es/ecma262/#sec-month-number
 * @param t
 */ function $fe2281e426f27f51$var$MonthFromTime(t) {
    var dwy = $fe2281e426f27f51$var$DayWithinYear(t);
    var leap = $fe2281e426f27f51$var$InLeapYear(t);
    if (dwy >= 0 && dwy < 31) return 0;
    if (dwy < 59 + leap) return 1;
    if (dwy < 90 + leap) return 2;
    if (dwy < 120 + leap) return 3;
    if (dwy < 151 + leap) return 4;
    if (dwy < 181 + leap) return 5;
    if (dwy < 212 + leap) return 6;
    if (dwy < 243 + leap) return 7;
    if (dwy < 273 + leap) return 8;
    if (dwy < 304 + leap) return 9;
    if (dwy < 334 + leap) return 10;
    if (dwy < 365 + leap) return 11;
    throw new Error("Invalid time");
}
module.exports.MonthFromTime = $fe2281e426f27f51$var$MonthFromTime;
function $fe2281e426f27f51$var$DateFromTime(t) {
    var dwy = $fe2281e426f27f51$var$DayWithinYear(t);
    var mft = $fe2281e426f27f51$var$MonthFromTime(t);
    var leap = $fe2281e426f27f51$var$InLeapYear(t);
    if (mft === 0) return dwy + 1;
    if (mft === 1) return dwy - 30;
    if (mft === 2) return dwy - 58 - leap;
    if (mft === 3) return dwy - 89 - leap;
    if (mft === 4) return dwy - 119 - leap;
    if (mft === 5) return dwy - 150 - leap;
    if (mft === 6) return dwy - 180 - leap;
    if (mft === 7) return dwy - 211 - leap;
    if (mft === 8) return dwy - 242 - leap;
    if (mft === 9) return dwy - 272 - leap;
    if (mft === 10) return dwy - 303 - leap;
    if (mft === 11) return dwy - 333 - leap;
    throw new Error("Invalid time");
}
module.exports.DateFromTime = $fe2281e426f27f51$var$DateFromTime;
var $fe2281e426f27f51$var$HOURS_PER_DAY = 24;
var $fe2281e426f27f51$var$MINUTES_PER_HOUR = 60;
var $fe2281e426f27f51$var$SECONDS_PER_MINUTE = 60;
var $fe2281e426f27f51$var$MS_PER_SECOND = 1e3;
var $fe2281e426f27f51$var$MS_PER_MINUTE = $fe2281e426f27f51$var$MS_PER_SECOND * $fe2281e426f27f51$var$SECONDS_PER_MINUTE;
var $fe2281e426f27f51$var$MS_PER_HOUR = $fe2281e426f27f51$var$MS_PER_MINUTE * $fe2281e426f27f51$var$MINUTES_PER_HOUR;
function $fe2281e426f27f51$var$HourFromTime(t) {
    return $fe2281e426f27f51$var$mod(Math.floor(t / $fe2281e426f27f51$var$MS_PER_HOUR), $fe2281e426f27f51$var$HOURS_PER_DAY);
}
module.exports.HourFromTime = $fe2281e426f27f51$var$HourFromTime;
function $fe2281e426f27f51$var$MinFromTime(t) {
    return $fe2281e426f27f51$var$mod(Math.floor(t / $fe2281e426f27f51$var$MS_PER_MINUTE), $fe2281e426f27f51$var$MINUTES_PER_HOUR);
}
module.exports.MinFromTime = $fe2281e426f27f51$var$MinFromTime;
function $fe2281e426f27f51$var$SecFromTime(t) {
    return $fe2281e426f27f51$var$mod(Math.floor(t / $fe2281e426f27f51$var$MS_PER_SECOND), $fe2281e426f27f51$var$SECONDS_PER_MINUTE);
}
module.exports.SecFromTime = $fe2281e426f27f51$var$SecFromTime;
function $fe2281e426f27f51$var$IsCallable(fn) {
    return typeof fn === "function";
}
/**
 * The abstract operation OrdinaryHasInstance implements
 * the default algorithm for determining if an object O
 * inherits from the instance object inheritance path
 * provided by constructor C.
 * @param C class
 * @param O object
 * @param internalSlots internalSlots
 */ function $fe2281e426f27f51$var$OrdinaryHasInstance(C, O, internalSlots) {
    if (!$fe2281e426f27f51$var$IsCallable(C)) return false;
    if (internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction) {
        var BC = internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction;
        return O instanceof BC;
    }
    if (typeof O !== "object") return false;
    var P = C.prototype;
    if (typeof P !== "object") throw new TypeError("OrdinaryHasInstance called on an object with an invalid prototype property.");
    return Object.prototype.isPrototypeOf.call(P, O);
}
module.exports.OrdinaryHasInstance = $fe2281e426f27f51$var$OrdinaryHasInstance;
function $fe2281e426f27f51$var$msFromTime(t) {
    return $fe2281e426f27f51$var$mod(t, $fe2281e426f27f51$var$MS_PER_SECOND);
}
module.exports.msFromTime = $fe2281e426f27f51$var$msFromTime;

});


parcelRegister("kvrN2", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getnumberoption
 * @param options
 * @param property
 * @param min
 * @param max
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetNumberOption = void 0;

var $3jLgT = parcelRequire("3jLgT");
function $eedc426545ef8e7f$var$GetNumberOption(options, property, minimum, maximum, fallback) {
    var val = options[property];
    // @ts-expect-error
    return (0, $3jLgT.DefaultNumberOption)(val, minimum, maximum, fallback);
}
module.exports.GetNumberOption = $eedc426545ef8e7f$var$GetNumberOption;

});
parcelRegister("3jLgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultNumberOption = void 0;
function $26a7d08fa037dc37$var$DefaultNumberOption(val, min, max, fallback) {
    if (val !== undefined) {
        val = Number(val);
        if (isNaN(val) || val < min || val > max) throw new RangeError("".concat(val, " is outside of range [").concat(min, ", ").concat(max, "]"));
        return Math.floor(val);
    }
    return fallback;
}
module.exports.DefaultNumberOption = $26a7d08fa037dc37$var$DefaultNumberOption;

});


parcelRegister("rTD91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOption = void 0;

var $lOKID = parcelRequire("lOKID");
/**
 * https://tc39.es/ecma402/#sec-getoption
 * @param opts
 * @param prop
 * @param type
 * @param values
 * @param fallback
 */ function $053dacc31a7b472b$var$GetOption(opts, prop, type, values, fallback) {
    if (typeof opts !== "object") throw new TypeError("Options must be an object");
    var value = opts[prop];
    if (value !== undefined) {
        if (type !== "boolean" && type !== "string") throw new TypeError("invalid type");
        if (type === "boolean") value = Boolean(value);
        if (type === "string") value = (0, $lOKID.ToString)(value);
        if (values !== undefined && !values.filter(function(val) {
            return val == value;
        }).length) throw new RangeError("".concat(value, " is not within ").concat(values.join(", ")));
        return value;
    }
    return fallback;
}
module.exports.GetOption = $053dacc31a7b472b$var$GetOption;

});

parcelRegister("dn7hJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOptionsObject = void 0;
/**
 * https://tc39.es/ecma402/#sec-getoptionsobject
 * @param options
 * @returns
 */ function $9bc312fa38fc244c$var$GetOptionsObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    if (typeof options === "object") return options;
    throw new TypeError("Options must be an object");
}
module.exports.GetOptionsObject = $9bc312fa38fc244c$var$GetOptionsObject;

});

parcelRegister("5SuUV", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getstringorbooleanoption
 * @param opts
 * @param prop
 * @param values
 * @param trueValue
 * @param falsyValue
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetStringOrBooleanOption = void 0;

var $lOKID = parcelRequire("lOKID");
function $4479fa6bd7313764$var$GetStringOrBooleanOption(opts, prop, values, trueValue, falsyValue, fallback) {
    var value = opts[prop];
    if (value === undefined) return fallback;
    if (value === true) return trueValue;
    var valueBoolean = Boolean(value);
    if (valueBoolean === false) return falsyValue;
    value = (0, $lOKID.ToString)(value);
    if (value === "true" || value === "false") return fallback;
    if ((values || []).indexOf(value) === -1) throw new RangeError("Invalid value ".concat(value));
    return value;
}
module.exports.GetStringOrBooleanOption = $4479fa6bd7313764$var$GetStringOrBooleanOption;

});

parcelRegister("j0bw7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsSanctionedSimpleUnitIdentifier = module.exports.SIMPLE_UNITS = module.exports.removeUnitNamespace = module.exports.SANCTIONED_UNITS = void 0;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SANCTIONED_UNITS = [
    "angle-degree",
    "area-acre",
    "area-hectare",
    "concentr-percent",
    "digital-bit",
    "digital-byte",
    "digital-gigabit",
    "digital-gigabyte",
    "digital-kilobit",
    "digital-kilobyte",
    "digital-megabit",
    "digital-megabyte",
    "digital-petabyte",
    "digital-terabit",
    "digital-terabyte",
    "duration-day",
    "duration-hour",
    "duration-millisecond",
    "duration-minute",
    "duration-month",
    "duration-second",
    "duration-week",
    "duration-year",
    "length-centimeter",
    "length-foot",
    "length-inch",
    "length-kilometer",
    "length-meter",
    "length-mile-scandinavian",
    "length-mile",
    "length-millimeter",
    "length-yard",
    "mass-gram",
    "mass-kilogram",
    "mass-ounce",
    "mass-pound",
    "mass-stone",
    "temperature-celsius",
    "temperature-fahrenheit",
    "volume-fluid-ounce",
    "volume-gallon",
    "volume-liter",
    "volume-milliliter"
];
// In CLDR, the unit name always follows the form `namespace-unit` pattern.
// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
function $dd56f370a07f8164$var$removeUnitNamespace(unit) {
    return unit.slice(unit.indexOf("-") + 1);
}
module.exports.removeUnitNamespace = $dd56f370a07f8164$var$removeUnitNamespace;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SIMPLE_UNITS = module.exports.SANCTIONED_UNITS.map($dd56f370a07f8164$var$removeUnitNamespace);
/**
 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
 */ function $dd56f370a07f8164$var$IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
    return module.exports.SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
}
module.exports.IsSanctionedSimpleUnitIdentifier = $dd56f370a07f8164$var$IsSanctionedSimpleUnitIdentifier;

});

parcelRegister("gIk6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsValidTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-isvalidtimezonename
 * @param tz
 * @param implDetails implementation details
 */ function $c2b05a0e982173ab$var$IsValidTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var zoneNames = new Set();
    var linkNames = new Set();
    Object.keys(tzData).map(function(z) {
        return z.toUpperCase();
    }).forEach(function(z) {
        return zoneNames.add(z);
    });
    Object.keys(uppercaseLinks).forEach(function(linkName) {
        linkNames.add(linkName.toUpperCase());
        zoneNames.add(uppercaseLinks[linkName].toUpperCase());
    });
    return zoneNames.has(uppercasedTz) || linkNames.has(uppercasedTz);
}
module.exports.IsValidTimeZoneName = $c2b05a0e982173ab$var$IsValidTimeZoneName;

});

parcelRegister("atvAh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedCurrencyCode = void 0;
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $7a051cc1dedc32a1$var$toUpperCase(str) {
    return str.replace(/([a-z])/g, function(_, c) {
        return c.toUpperCase();
    });
}
var $7a051cc1dedc32a1$var$NOT_A_Z_REGEX = /[^A-Z]/;
/**
 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
 */ function $7a051cc1dedc32a1$var$IsWellFormedCurrencyCode(currency) {
    currency = $7a051cc1dedc32a1$var$toUpperCase(currency);
    if (currency.length !== 3) return false;
    if ($7a051cc1dedc32a1$var$NOT_A_Z_REGEX.test(currency)) return false;
    return true;
}
module.exports.IsWellFormedCurrencyCode = $7a051cc1dedc32a1$var$IsWellFormedCurrencyCode;

});

parcelRegister("4EAEx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedUnitIdentifier = void 0;

var $j0bw7 = parcelRequire("j0bw7");
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $3637545201f3fde0$var$toLowerCase(str) {
    return str.replace(/([A-Z])/g, function(_, c) {
        return c.toLowerCase();
    });
}
/**
 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
 * @param unit
 */ function $3637545201f3fde0$var$IsWellFormedUnitIdentifier(unit) {
    unit = $3637545201f3fde0$var$toLowerCase(unit);
    if ((0, $j0bw7.IsSanctionedSimpleUnitIdentifier)(unit)) return true;
    var units = unit.split("-per-");
    if (units.length !== 2) return false;
    var numerator = units[0], denominator = units[1];
    if (!(0, $j0bw7.IsSanctionedSimpleUnitIdentifier)(numerator) || !(0, $j0bw7.IsSanctionedSimpleUnitIdentifier)(denominator)) return false;
    return true;
}
module.exports.IsWellFormedUnitIdentifier = $3637545201f3fde0$var$IsWellFormedUnitIdentifier;

});

parcelRegister("5zVMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApplyUnsignedRoundingMode = void 0;
function $40fd0af777543237$var$ApplyUnsignedRoundingMode(x, r1, r2, unsignedRoundingMode) {
    if (x === r1) return r1;
    if (unsignedRoundingMode === undefined) throw new Error("unsignedRoundingMode is mandatory");
    if (unsignedRoundingMode === "zero") return r1;
    if (unsignedRoundingMode === "infinity") return r2;
    var d1 = x - r1;
    var d2 = r2 - x;
    if (d1 < d2) return r1;
    if (d2 < d1) return r2;
    if (d1 !== d2) throw new Error("Unexpected error");
    if (unsignedRoundingMode === "half-zero") return r1;
    if (unsignedRoundingMode === "half-infinity") return r2;
    if (unsignedRoundingMode !== "half-even") throw new Error("Unexpected value for unsignedRoundingMode: ".concat(unsignedRoundingMode));
    var cardinality = r1 / (r2 - r1) % 2;
    if (cardinality === 0) return r1;
    return r2;
}
module.exports.ApplyUnsignedRoundingMode = $40fd0af777543237$var$ApplyUnsignedRoundingMode;

});

parcelRegister("1Zs0r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollapseNumberRange = void 0;
/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */ function $17313667b1a54631$var$CollapseNumberRange(result) {
    return result;
}
module.exports.CollapseNumberRange = $17313667b1a54631$var$CollapseNumberRange;

});

parcelRegister("jItnS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponent = void 0;

var $jSW1Z = parcelRequire("jSW1Z");

var $cB3aE = parcelRequire("cB3aE");

var $koIzO = parcelRequire("koIzO");
/**
 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
 * requiring a different exponent.
 *
 * NOT IN SPEC: it returns [exponent, magnitude].
 */ function $e5a8eb735f827639$var$ComputeExponent(numberFormat, x, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (x === 0) return [
        0,
        0
    ];
    if (x < 0) x = -x;
    var magnitude = (0, $jSW1Z.getMagnitude)(x);
    var exponent = (0, $cB3aE.ComputeExponentForMagnitude)(numberFormat, magnitude, {
        getInternalSlots: getInternalSlots
    });
    // Preserve more precision by doing multiplication when exponent is negative.
    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
    var formatNumberResult = (0, $koIzO.FormatNumericToString)(getInternalSlots(numberFormat), x);
    if (formatNumberResult.roundedNumber === 0) return [
        exponent,
        magnitude
    ];
    var newMagnitude = (0, $jSW1Z.getMagnitude)(formatNumberResult.roundedNumber);
    if (newMagnitude === magnitude - exponent) return [
        exponent,
        magnitude
    ];
    return [
        (0, $cB3aE.ComputeExponentForMagnitude)(numberFormat, magnitude + 1, {
            getInternalSlots: getInternalSlots
        }),
        magnitude + 1
    ];
}
module.exports.ComputeExponent = $e5a8eb735f827639$var$ComputeExponent;

});
parcelRegister("jSW1Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = module.exports.defineProperty = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.repeat = module.exports.getMagnitude = void 0;
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $e7a013375cd75efa$var$getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
module.exports.getMagnitude = $e7a013375cd75efa$var$getMagnitude;
function $e7a013375cd75efa$var$repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
module.exports.repeat = $e7a013375cd75efa$var$repeat;
function $e7a013375cd75efa$var$setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
module.exports.setInternalSlot = $e7a013375cd75efa$var$setInternalSlot;
function $e7a013375cd75efa$var$setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $e7a013375cd75efa$var$setInternalSlot(map, pl, k, props[k]);
    }
}
module.exports.setMultiInternalSlots = $e7a013375cd75efa$var$setMultiInternalSlots;
function $e7a013375cd75efa$var$getInternalSlot(map, pl, field) {
    return $e7a013375cd75efa$var$getMultiInternalSlots(map, pl, field)[field];
}
module.exports.getInternalSlot = $e7a013375cd75efa$var$getInternalSlot;
function $e7a013375cd75efa$var$getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
module.exports.getMultiInternalSlots = $e7a013375cd75efa$var$getMultiInternalSlots;
function $e7a013375cd75efa$var$isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
module.exports.isLiteralPart = $e7a013375cd75efa$var$isLiteralPart;
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ function $e7a013375cd75efa$var$defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
module.exports.defineProperty = $e7a013375cd75efa$var$defineProperty;
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $e7a013375cd75efa$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $e7a013375cd75efa$var$invariant;

});

parcelRegister("cB3aE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponentForMagnitude = void 0;
/**
 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
 * number of the given magnitude (power of ten of the most significant digit) according to the
 * locale and the desired notation (scientific, engineering, or compact).
 */ function $92bb6663034c35b2$var$ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    switch(notation){
        case "standard":
            return 0;
        case "scientific":
            return magnitude;
        case "engineering":
            return Math.floor(magnitude / 3) * 3;
        default:
            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
            // number of the given magnitude in compact notation for the current locale.
            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
            var thresholdMap = void 0;
            if (style === "currency" && currencyDisplay !== "name") {
                var currency = dataLocaleData.numbers.currency[numberingSystem] || dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
                thresholdMap = currency.short;
            } else {
                var decimal = dataLocaleData.numbers.decimal[numberingSystem] || dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
                thresholdMap = compactDisplay === "long" ? decimal.long : decimal.short;
            }
            if (!thresholdMap) return 0;
            var num = String(Math.pow(10, magnitude));
            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
            if (num < thresholds[0]) return 0;
            if (num > thresholds[thresholds.length - 1]) return thresholds[thresholds.length - 1].length - 1;
            var i = thresholds.indexOf(num);
            if (i === -1) return 0;
            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
            // Special handling if the pattern is precisely `0`.
            var magnitudeKey = thresholds[i];
            // TODO: do we need to handle plural here?
            var compactPattern = thresholdMap[magnitudeKey].other;
            if (compactPattern === "0") return 0;
            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
            return magnitudeKey.length - thresholdMap[magnitudeKey].other.match(/0+/)[0].length;
    }
}
module.exports.ComputeExponentForMagnitude = $92bb6663034c35b2$var$ComputeExponentForMagnitude;

});

parcelRegister("koIzO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToString = void 0;

var $lOKID = parcelRequire("lOKID");

var $hhTpf = parcelRequire("hhTpf");

var $jSW1Z = parcelRequire("jSW1Z");

var $h3j5k = parcelRequire("h3j5k");
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $ed98a083c5e95c01$var$FormatNumericToString(intlObject, x) {
    var isNegative = x < 0 || (0, $lOKID.SameValue)(x, -0);
    if (isNegative) x = -x;
    var result;
    var rourndingType = intlObject.roundingType;
    switch(rourndingType){
        case "significantDigits":
            result = (0, $hhTpf.ToRawPrecision)(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
            break;
        case "fractionDigits":
            result = (0, $h3j5k.ToRawFixed)(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
            break;
        default:
            result = (0, $hhTpf.ToRawPrecision)(x, 1, 2);
            if (result.integerDigitsCount > 1) result = (0, $h3j5k.ToRawFixed)(x, 0, 0);
            break;
    }
    x = result.roundedNumber;
    var string = result.formattedString;
    var int = result.integerDigitsCount;
    var minInteger = intlObject.minimumIntegerDigits;
    if (int < minInteger) {
        var forwardZeros = (0, $jSW1Z.repeat)("0", minInteger - int);
        string = forwardZeros + string;
    }
    if (isNegative) x = -x;
    return {
        roundedNumber: x,
        formattedString: string
    };
}
module.exports.FormatNumericToString = $ed98a083c5e95c01$var$FormatNumericToString;

});
parcelRegister("hhTpf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawPrecision = void 0;

var $jSW1Z = parcelRequire("jSW1Z");
function $c95f00b5df9c731d$var$ToRawPrecision(x, minPrecision, maxPrecision) {
    var p = maxPrecision;
    var m;
    var e;
    var xFinal;
    if (x === 0) {
        m = (0, $jSW1Z.repeat)("0", p);
        e = 0;
        xFinal = 0;
    } else {
        var xToString = x.toString();
        // If xToString is formatted as scientific notation, the number is either very small or very
        // large. If the precision of the formatted string is lower that requested max precision, we
        // should still infer them from the formatted string, otherwise the formatted result might have
        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
        var xToStringExponentIndex = xToString.indexOf("e");
        var _a = xToString.split("e"), xToStringMantissa = _a[0], xToStringExponent = _a[1];
        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace(".", "");
        if (xToStringExponentIndex >= 0 && xToStringMantissaWithoutDecimalPoint.length <= p) {
            e = +xToStringExponent;
            m = xToStringMantissaWithoutDecimalPoint + (0, $jSW1Z.repeat)("0", p - xToStringMantissaWithoutDecimalPoint.length);
            xFinal = x;
        } else {
            e = (0, $jSW1Z.getMagnitude)(x);
            var decimalPlaceOffset = e - p + 1;
            // n is the integer containing the required precision digits. To derive the formatted string,
            // we will adjust its decimal place in the logic below.
            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
            // The rounding caused the change of magnitude, so we should increment `e` by 1.
            if (adjustDecimalPlace(n, p - 1) >= 10) {
                e = e + 1;
                // Divide n by 10 to swallow one precision.
                n = Math.floor(n / 10);
            }
            m = n.toString();
            // Equivalent of n * 10 ** (e - p + 1)
            xFinal = adjustDecimalPlace(n, p - 1 - e);
        }
    }
    var int;
    if (e >= p - 1) {
        m = m + (0, $jSW1Z.repeat)("0", e - p + 1);
        int = e + 1;
    } else if (e >= 0) {
        m = "".concat(m.slice(0, e + 1), ".").concat(m.slice(e + 1));
        int = e + 1;
    } else {
        m = "0.".concat((0, $jSW1Z.repeat)("0", -e - 1)).concat(m);
        int = 1;
    }
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        var cut = maxPrecision - minPrecision;
        while(cut > 0 && m[m.length - 1] === "0"){
            m = m.slice(0, -1);
            cut--;
        }
        if (m[m.length - 1] === ".") m = m.slice(0, -1);
    }
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
    function adjustDecimalPlace(x, magnitude) {
        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
    }
}
module.exports.ToRawPrecision = $c95f00b5df9c731d$var$ToRawPrecision;

});

parcelRegister("h3j5k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawFixed = void 0;

var $jSW1Z = parcelRequire("jSW1Z");
/**
 * TODO: dedup with intl-pluralrules and support BigInt
 * https://tc39.es/ecma402/#sec-torawfixed
 * @param x a finite non-negative Number or BigInt
 * @param minFraction and integer between 0 and 20
 * @param maxFraction and integer between 0 and 20
 */ function $c6a1855a0cffde52$var$ToRawFixed(x, minFraction, maxFraction) {
    var f = maxFraction;
    var n = Math.round(x * Math.pow(10, f));
    var xFinal = n / Math.pow(10, f);
    // n is a positive integer, but it is possible to be greater than 1e21.
    // In such case we will go the slow path.
    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
    var m;
    if (n < 1e21) m = n.toString();
    else {
        m = n.toString();
        var _a = m.split("e"), mantissa = _a[0], exponent = _a[1];
        m = mantissa.replace(".", "");
        m = m + (0, $jSW1Z.repeat)("0", Math.max(+exponent - m.length + 1, 0));
    }
    var int;
    if (f !== 0) {
        var k = m.length;
        if (k <= f) {
            var z = (0, $jSW1Z.repeat)("0", f + 1 - k);
            m = z + m;
            k = f + 1;
        }
        var a = m.slice(0, k - f);
        var b = m.slice(k - f);
        m = "".concat(a, ".").concat(b);
        int = a.length;
    } else int = m.length;
    var cut = maxFraction - minFraction;
    while(cut > 0 && m[m.length - 1] === "0"){
        m = m.slice(0, -1);
        cut--;
    }
    if (m[m.length - 1] === ".") m = m.slice(0, -1);
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
}
module.exports.ToRawFixed = $c6a1855a0cffde52$var$ToRawFixed;

});



parcelRegister("7s5DV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CurrencyDigits = void 0;

var $lOKID = parcelRequire("lOKID");
/**
 * https://tc39.es/ecma402/#sec-currencydigits
 */ function $56cf86813cf9ca2d$var$CurrencyDigits(c, _a) {
    var currencyDigitsData = _a.currencyDigitsData;
    return (0, $lOKID.HasOwnProperty)(currencyDigitsData, c) ? currencyDigitsData[c] : 2;
}
module.exports.CurrencyDigits = $56cf86813cf9ca2d$var$CurrencyDigits;

});

parcelRegister("19vN0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatApproximately = void 0;
/**
 * https://tc39.es/ecma402/#sec-formatapproximately
 */ function $0d6f4a71c096a7fd$var$FormatApproximately(numberFormat, result, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    var approximatelySign = symbols.approximatelySign;
    result.push({
        type: "approximatelySign",
        value: approximatelySign
    });
    return result;
}
module.exports.FormatApproximately = $0d6f4a71c096a7fd$var$FormatApproximately;

});

parcelRegister("8LEhW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRange = void 0;

var $9Mz4z = parcelRequire("9Mz4z");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrange
 */ function $6621f6f0ebf6d41b$var$FormatNumericRange(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $9Mz4z.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part) {
        return part.value;
    }).join("");
}
module.exports.FormatNumericRange = $6621f6f0ebf6d41b$var$FormatNumericRange;

});
parcelRegister("9Mz4z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberRangePattern = void 0;

var $lwxMS = parcelRequire("lwxMS");

var $1Zs0r = parcelRequire("1Zs0r");

var $19vN0 = parcelRequire("19vN0");
/**
 * https://tc39.es/ecma402/#sec-partitionnumberrangepattern
 */ function $71f3cd7bba475d72$var$PartitionNumberRangePattern(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (isNaN(x) || isNaN(y)) throw new RangeError("Input must be a number");
    var result = [];
    var xResult = (0, $lwxMS.PartitionNumberPattern)(numberFormat, x, {
        getInternalSlots: getInternalSlots
    });
    var yResult = (0, $lwxMS.PartitionNumberPattern)(numberFormat, y, {
        getInternalSlots: getInternalSlots
    });
    if (xResult === yResult) return (0, $19vN0.FormatApproximately)(numberFormat, xResult, {
        getInternalSlots: getInternalSlots
    });
    for(var _i = 0, xResult_1 = xResult; _i < xResult_1.length; _i++){
        var r = xResult_1[_i];
        r.source = "startRange";
    }
    result = result.concat(xResult);
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    result.push({
        type: "literal",
        value: symbols.rangeSign,
        source: "shared"
    });
    for(var _b = 0, yResult_1 = yResult; _b < yResult_1.length; _b++){
        var r = yResult_1[_b];
        r.source = "endRange";
    }
    result = result.concat(yResult);
    return (0, $1Zs0r.CollapseNumberRange)(result);
}
module.exports.PartitionNumberRangePattern = $71f3cd7bba475d72$var$PartitionNumberRangePattern;

});
parcelRegister("lwxMS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberPattern = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $koIzO = parcelRequire("koIzO");

var $lOKID = parcelRequire("lOKID");

var $jItnS = parcelRequire("jItnS");

var $fab6cb91ab45d2d2$var$format_to_parts_1 = $4UZnF.__importDefault((parcelRequire("hjjlN")));
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $fab6cb91ab45d2d2$var$PartitionNumberPattern(numberFormat, x, _a) {
    var _b;
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    var symbols = dataLocaleData.numbers.symbols[numberingSystem] || dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
    var magnitude = 0;
    var exponent = 0;
    var n;
    if (isNaN(x)) n = symbols.nan;
    else if (x == Number.POSITIVE_INFINITY || x == Number.NEGATIVE_INFINITY) n = symbols.infinity;
    else {
        if (!(0, $lOKID.SameValue)(x, -0)) {
            if (!isFinite(x)) throw new Error("Input must be a mathematical value");
            if (internalSlots.style == "percent") x *= 100;
            _b = (0, $jItnS.ComputeExponent)(numberFormat, x, {
                getInternalSlots: getInternalSlots
            }), exponent = _b[0], magnitude = _b[1];
            // Preserve more precision by doing multiplication when exponent is negative.
            x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
        }
        var formatNumberResult = (0, $koIzO.FormatNumericToString)(internalSlots, x);
        n = formatNumberResult.formattedString;
        x = formatNumberResult.roundedNumber;
    }
    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
    // We need to do this before `x` is rounded.
    var sign;
    var signDisplay = internalSlots.signDisplay;
    switch(signDisplay){
        case "never":
            sign = 0;
            break;
        case "auto":
            if ((0, $lOKID.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 0;
            else sign = -1;
            break;
        case "always":
            if ((0, $lOKID.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 1;
            else sign = -1;
            break;
        default:
            // x === 0 -> x is 0 or x is -0
            if (x === 0 || isNaN(x)) sign = 0;
            else if (x > 0) sign = 1;
            else sign = -1;
    }
    return (0, $fab6cb91ab45d2d2$var$format_to_parts_1.default)({
        roundedNumber: x,
        formattedString: n,
        exponent: exponent,
        magnitude: magnitude,
        sign: sign
    }, internalSlots.dataLocaleData, pl, internalSlots);
}
module.exports.PartitionNumberPattern = $fab6cb91ab45d2d2$var$PartitionNumberPattern;

});
parcelRegister("hjjlN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h3j5k = parcelRequire("h3j5k");

var $8W7bJ = parcelRequire("8W7bJ");

var $jxpT5 = parcelRequire("jxpT5");
// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
// /^\p{S}/u
var $c9a338a8a223a320$var$CARET_S_UNICODE_REGEX = new RegExp("^".concat($jxpT5.S_UNICODE_REGEX.source));
// /\p{S}$/u
var $c9a338a8a223a320$var$S_DOLLAR_UNICODE_REGEX = new RegExp("".concat($jxpT5.S_UNICODE_REGEX.source, "$"));
var $c9a338a8a223a320$var$CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
function $c9a338a8a223a320$var$formatToParts(numberResult, data, pl, options) {
    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
    var defaultNumberingSystem = data.numbers.nu[0];
    // #region Part 1: partition and interpolate the CLDR number pattern.
    // ----------------------------------------------------------
    var compactNumberPattern = null;
    if (notation === "compact" && magnitude) compactNumberPattern = $c9a338a8a223a320$var$getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
    // This is used multiple times
    var nonNameCurrencyPart;
    if (style === "currency" && options.currencyDisplay !== "name") {
        var byCurrencyDisplay = data.currencies[options.currency];
        if (byCurrencyDisplay) switch(options.currencyDisplay){
            case "code":
                nonNameCurrencyPart = options.currency;
                break;
            case "symbol":
                nonNameCurrencyPart = byCurrencyDisplay.symbol;
                break;
            default:
                nonNameCurrencyPart = byCurrencyDisplay.narrow;
                break;
        }
        else // Fallback for unknown currency
        nonNameCurrencyPart = options.currency;
    }
    var numberPattern;
    if (!compactNumberPattern) {
        // Note: if the style is unit, or is currency and the currency display is name,
        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
        if (style === "decimal" || style === "unit" || style === "currency" && options.currencyDisplay === "name") {
            // Shortcut for decimal
            var decimalData = data.numbers.decimal[numberingSystem] || data.numbers.decimal[defaultNumberingSystem];
            numberPattern = $c9a338a8a223a320$var$getPatternForSign(decimalData.standard, sign);
        } else if (style === "currency") {
            var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
            // We replace number pattern part with `0` for easier postprocessing.
            numberPattern = $c9a338a8a223a320$var$getPatternForSign(currencyData[options.currencySign], sign);
        } else {
            // percent
            var percentPattern = data.numbers.percent[numberingSystem] || data.numbers.percent[defaultNumberingSystem];
            numberPattern = $c9a338a8a223a320$var$getPatternForSign(percentPattern, sign);
        }
    } else numberPattern = compactNumberPattern;
    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
    // used to infer decimal group sizes.
    var decimalNumberPattern = $c9a338a8a223a320$var$CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
    // Now we start to substitute patterns
    // 1. replace strings like `0` and `#,##0.00` with `{0}`
    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
    numberPattern = numberPattern.replace($c9a338a8a223a320$var$CLDR_NUMBER_PATTERN, "{0}").replace(/'(.)'/g, "$1");
    // Handle currency spacing (both compact and non-compact).
    if (style === "currency" && options.currencyDisplay !== "name") {
        var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
        // See `currencySpacing` substitution rule in TR-35.
        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
        //
        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
        // "US$" and "[:digit:]" matches the latn numbering system digits.
        //
        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
        // and number, because `$` does not match "[:^S:]".
        //
        // Implementation note: here we do the best effort to infer the insertion.
        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
        if (afterCurrency && !$c9a338a8a223a320$var$S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("\xa4{0}", "\xa4".concat(afterCurrency, "{0}"));
        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
        if (beforeCurrency && !$c9a338a8a223a320$var$CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("{0}\xa4", "{0}".concat(beforeCurrency, "\xa4"));
    }
    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
    var numberParts = [];
    var symbols = data.numbers.symbols[numberingSystem] || data.numbers.symbols[defaultNumberingSystem];
    for(var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++){
        var part = numberPatternParts_1[_i];
        if (!part) continue;
        switch(part){
            case "{0}":
                // We only need to handle scientific and engineering notation here.
                numberParts.push.apply(numberParts, $c9a338a8a223a320$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, // If compact number pattern exists, do not insert group separators.
                !compactNumberPattern && Boolean(options.useGrouping), decimalNumberPattern));
                break;
            case "-":
                numberParts.push({
                    type: "minusSign",
                    value: symbols.minusSign
                });
                break;
            case "+":
                numberParts.push({
                    type: "plusSign",
                    value: symbols.plusSign
                });
                break;
            case "%":
                numberParts.push({
                    type: "percentSign",
                    value: symbols.percentSign
                });
                break;
            case "\xa4":
                // Computed above when handling currency spacing.
                numberParts.push({
                    type: "currency",
                    value: nonNameCurrencyPart
                });
                break;
            default:
                if (/^\{c:/.test(part)) numberParts.push({
                    type: "compact",
                    value: part.substring(3, part.length - 1)
                });
                else // literal
                numberParts.push({
                    type: "literal",
                    value: part
                });
                break;
        }
    }
    // #endregion
    // #region Part 2: interpolate unit pattern if necessary.
    // ----------------------------------------------
    switch(style){
        case "currency":
            // `currencyDisplay: 'name'` has similar pattern handling as units.
            if (options.currencyDisplay === "name") {
                var unitPattern = (data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem]).unitPattern;
                // Select plural
                var unitName = void 0;
                var currencyNameData = data.currencies[options.currency];
                if (currencyNameData) unitName = $c9a338a8a223a320$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
                else // Fallback for unknown currency
                unitName = options.currency;
                // Do {0} and {1} substitution
                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
                var result = [];
                for(var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++){
                    var part = unitPatternParts_1[_a];
                    switch(part){
                        case "{0}":
                            result.push.apply(result, numberParts);
                            break;
                        case "{1}":
                            result.push({
                                type: "currency",
                                value: unitName
                            });
                            break;
                        default:
                            if (part) result.push({
                                type: "literal",
                                value: part
                            });
                            break;
                    }
                }
                return result;
            } else return numberParts;
        case "unit":
            var unit = options.unit, unitDisplay = options.unitDisplay;
            var unitData = data.units.simple[unit];
            var unitPattern = void 0;
            if (unitData) // Simple unit pattern
            unitPattern = $c9a338a8a223a320$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
            else {
                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
                // Implementation note: we are not following TR-35 here because we need to format to parts!
                var _b = unit.split("-per-"), numeratorUnit = _b[0], denominatorUnit = _b[1];
                unitData = data.units.simple[numeratorUnit];
                var numeratorUnitPattern = $c9a338a8a223a320$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
                if (perUnitPattern) // perUnitPattern exists, combine it with numeratorUnitPattern
                unitPattern = perUnitPattern.replace("{0}", numeratorUnitPattern);
                else {
                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
                    // the denominator pattern in singular form.
                    var perPattern = data.units.compound.per[unitDisplay];
                    var denominatorPattern = $c9a338a8a223a320$var$selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
                    unitPattern = unitPattern = perPattern.replace("{0}", numeratorUnitPattern).replace("{1}", denominatorPattern.replace("{0}", ""));
                }
            }
            var result = [];
            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
            for(var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++){
                var part = _d[_c];
                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
                if (interpolateMatch) {
                    // Space before "{0}"
                    if (interpolateMatch[1]) result.push({
                        type: "literal",
                        value: interpolateMatch[1]
                    });
                    // "{0}" itself
                    result.push.apply(result, numberParts);
                    // Space after "{0}"
                    if (interpolateMatch[2]) result.push({
                        type: "literal",
                        value: interpolateMatch[2]
                    });
                } else if (part) result.push({
                    type: "unit",
                    value: part
                });
            }
            return result;
        default:
            return numberParts;
    }
// #endregion
}
module.exports.default = $c9a338a8a223a320$var$formatToParts;
// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
// Plus the exponent parts handling.
function $c9a338a8a223a320$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, /**
 * This is the decimal number pattern without signs or symbols.
 * It is used to infer the group size when `useGrouping` is true.
 *
 * A typical value looks like "#,##0.00" (primary group size is 3).
 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
 */ decimalNumberPattern) {
    var result = [];
    // eslint-disable-next-line prefer-const
    var n = numberResult.formattedString, x = numberResult.roundedNumber;
    if (isNaN(x)) return [
        {
            type: "nan",
            value: n
        }
    ];
    else if (!isFinite(x)) return [
        {
            type: "infinity",
            value: n
        }
    ];
    var digitReplacementTable = $8W7bJ.digitMapping[numberingSystem];
    if (digitReplacementTable) n = n.replace(/\d/g, function(digit) {
        return digitReplacementTable[+digit] || digit;
    });
    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
    // representation of n in the given numbering system.
    var decimalSepIndex = n.indexOf(".");
    var integer;
    var fraction;
    if (decimalSepIndex > 0) {
        integer = n.slice(0, decimalSepIndex);
        fraction = n.slice(decimalSepIndex + 1);
    } else integer = n;
    // #region Grouping integer digits
    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
    // unless the rounded number is greater than 10000:
    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
    //   NumberFormat('de').format(1234) //=> "1.234"
    if (useGrouping && (notation !== "compact" || x >= 10000)) {
        var groupSepSymbol = symbols.group;
        var groups = [];
        // > There may be two different grouping sizes: The primary grouping size used for the least
        // > significant integer group, and the secondary grouping size used for more significant groups.
        // > If a pattern contains multiple grouping separators, the interval between the last one and the
        // > end of the integer defines the primary grouping size, and the interval between the last two
        // > defines the secondary grouping size. All others are ignored.
        var integerNumberPattern = decimalNumberPattern.split(".")[0];
        var patternGroups = integerNumberPattern.split(",");
        var primaryGroupingSize = 3;
        var secondaryGroupingSize = 3;
        if (patternGroups.length > 1) primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
        if (patternGroups.length > 2) secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
        var i = integer.length - primaryGroupingSize;
        if (i > 0) {
            // Slice the least significant integer group
            groups.push(integer.slice(i, i + primaryGroupingSize));
            // Then iteratively push the more signicant groups
            // TODO: handle surrogate pairs in some numbering system digits
            for(i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize)groups.push(integer.slice(i, i + secondaryGroupingSize));
            groups.push(integer.slice(0, i + secondaryGroupingSize));
        } else groups.push(integer);
        while(groups.length > 0){
            var integerGroup = groups.pop();
            result.push({
                type: "integer",
                value: integerGroup
            });
            if (groups.length > 0) result.push({
                type: "group",
                value: groupSepSymbol
            });
        }
    } else result.push({
        type: "integer",
        value: integer
    });
    // #endregion
    if (fraction !== undefined) result.push({
        type: "decimal",
        value: symbols.decimal
    }, {
        type: "fraction",
        value: fraction
    });
    if ((notation === "scientific" || notation === "engineering") && isFinite(x)) {
        result.push({
            type: "exponentSeparator",
            value: symbols.exponential
        });
        if (exponent < 0) {
            result.push({
                type: "exponentMinusSign",
                value: symbols.minusSign
            });
            exponent = -exponent;
        }
        var exponentResult = (0, $h3j5k.ToRawFixed)(exponent, 0, 0);
        result.push({
            type: "exponentInteger",
            value: exponentResult.formattedString
        });
    }
    return result;
}
function $c9a338a8a223a320$var$getPatternForSign(pattern, sign) {
    if (pattern.indexOf(";") < 0) pattern = "".concat(pattern, ";-").concat(pattern);
    var _a = pattern.split(";"), zeroPattern = _a[0], negativePattern = _a[1];
    switch(sign){
        case 0:
            return zeroPattern;
        case -1:
            return negativePattern;
        default:
            return negativePattern.indexOf("-") >= 0 ? negativePattern.replace(/-/g, "+") : "+".concat(zeroPattern);
    }
}
// Find the CLDR pattern for compact notation based on the magnitude of data and style.
//
// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
// - Notice the `{c:...}` token that wraps the compact literal.
// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
//
// Returning null means the compact display pattern cannot be found.
function $c9a338a8a223a320$var$getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
    var _a;
    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
    var magnitudeKey = String(Math.pow(10, magnitude));
    var defaultNumberingSystem = data.numbers.nu[0];
    var pattern;
    if (style === "currency" && currencyDisplay !== "name") {
        var byNumberingSystem = data.numbers.currency;
        var currencyData = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        // NOTE: compact notation ignores currencySign!
        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
        if (!compactPluralRules) return null;
        pattern = $c9a338a8a223a320$var$selectPlural(pl, roundedNumber, compactPluralRules);
    } else {
        var byNumberingSystem = data.numbers.decimal;
        var byCompactDisplay = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
        if (!compactPlaralRule) return null;
        pattern = $c9a338a8a223a320$var$selectPlural(pl, roundedNumber, compactPlaralRule);
    }
    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
    // > pattern for that sort of object is supplied.
    if (pattern === "0") return null;
    pattern = $c9a338a8a223a320$var$getPatternForSign(pattern, sign)// Extract compact literal from the pattern
    .replace(/([^\s;\-\+\d¤]+)/g, "{c:$1}")// We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
    .replace(/0+/, "0");
    return pattern;
}
function $c9a338a8a223a320$var$selectPlural(pl, x, rules) {
    return rules[pl.select(x)] || rules.other;
}

});
parcelRegister("8W7bJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.digitMapping = void 0;
module.exports.digitMapping = {
    "adlm": [
        "\uD83A\uDD50",
        "\uD83A\uDD51",
        "\uD83A\uDD52",
        "\uD83A\uDD53",
        "\uD83A\uDD54",
        "\uD83A\uDD55",
        "\uD83A\uDD56",
        "\uD83A\uDD57",
        "\uD83A\uDD58",
        "\uD83A\uDD59"
    ],
    "ahom": [
        "\uD805\uDF30",
        "\uD805\uDF31",
        "\uD805\uDF32",
        "\uD805\uDF33",
        "\uD805\uDF34",
        "\uD805\uDF35",
        "\uD805\uDF36",
        "\uD805\uDF37",
        "\uD805\uDF38",
        "\uD805\uDF39"
    ],
    "arab": [
        "\u0660",
        "\u0661",
        "\u0662",
        "\u0663",
        "\u0664",
        "\u0665",
        "\u0666",
        "\u0667",
        "\u0668",
        "\u0669"
    ],
    "arabext": [
        "\u06F0",
        "\u06F1",
        "\u06F2",
        "\u06F3",
        "\u06F4",
        "\u06F5",
        "\u06F6",
        "\u06F7",
        "\u06F8",
        "\u06F9"
    ],
    "bali": [
        "\u1B50",
        "\u1B51",
        "\u1B52",
        "\u1B53",
        "\u1B54",
        "\u1B55",
        "\u1B56",
        "\u1B57",
        "\u1B58",
        "\u1B59"
    ],
    "beng": [
        "\u09E6",
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA",
        "\u09EB",
        "\u09EC",
        "\u09ED",
        "\u09EE",
        "\u09EF"
    ],
    "bhks": [
        "\uD807\uDC50",
        "\uD807\uDC51",
        "\uD807\uDC52",
        "\uD807\uDC53",
        "\uD807\uDC54",
        "\uD807\uDC55",
        "\uD807\uDC56",
        "\uD807\uDC57",
        "\uD807\uDC58",
        "\uD807\uDC59"
    ],
    "brah": [
        "\uD804\uDC66",
        "\uD804\uDC67",
        "\uD804\uDC68",
        "\uD804\uDC69",
        "\uD804\uDC6A",
        "\uD804\uDC6B",
        "\uD804\uDC6C",
        "\uD804\uDC6D",
        "\uD804\uDC6E",
        "\uD804\uDC6F"
    ],
    "cakm": [
        "\uD804\uDD36",
        "\uD804\uDD37",
        "\uD804\uDD38",
        "\uD804\uDD39",
        "\uD804\uDD3A",
        "\uD804\uDD3B",
        "\uD804\uDD3C",
        "\uD804\uDD3D",
        "\uD804\uDD3E",
        "\uD804\uDD3F"
    ],
    "cham": [
        "\uAA50",
        "\uAA51",
        "\uAA52",
        "\uAA53",
        "\uAA54",
        "\uAA55",
        "\uAA56",
        "\uAA57",
        "\uAA58",
        "\uAA59"
    ],
    "deva": [
        "\u0966",
        "\u0967",
        "\u0968",
        "\u0969",
        "\u096A",
        "\u096B",
        "\u096C",
        "\u096D",
        "\u096E",
        "\u096F"
    ],
    "diak": [
        "\uD806\uDD50",
        "\uD806\uDD51",
        "\uD806\uDD52",
        "\uD806\uDD53",
        "\uD806\uDD54",
        "\uD806\uDD55",
        "\uD806\uDD56",
        "\uD806\uDD57",
        "\uD806\uDD58",
        "\uD806\uDD59"
    ],
    "fullwide": [
        "\uFF10",
        "\uFF11",
        "\uFF12",
        "\uFF13",
        "\uFF14",
        "\uFF15",
        "\uFF16",
        "\uFF17",
        "\uFF18",
        "\uFF19"
    ],
    "gong": [
        "\uD807\uDDA0",
        "\uD807\uDDA1",
        "\uD807\uDDA2",
        "\uD807\uDDA3",
        "\uD807\uDDA4",
        "\uD807\uDDA5",
        "\uD807\uDDA6",
        "\uD807\uDDA7",
        "\uD807\uDDA8",
        "\uD807\uDDA9"
    ],
    "gonm": [
        "\uD807\uDD50",
        "\uD807\uDD51",
        "\uD807\uDD52",
        "\uD807\uDD53",
        "\uD807\uDD54",
        "\uD807\uDD55",
        "\uD807\uDD56",
        "\uD807\uDD57",
        "\uD807\uDD58",
        "\uD807\uDD59"
    ],
    "gujr": [
        "\u0AE6",
        "\u0AE7",
        "\u0AE8",
        "\u0AE9",
        "\u0AEA",
        "\u0AEB",
        "\u0AEC",
        "\u0AED",
        "\u0AEE",
        "\u0AEF"
    ],
    "guru": [
        "\u0A66",
        "\u0A67",
        "\u0A68",
        "\u0A69",
        "\u0A6A",
        "\u0A6B",
        "\u0A6C",
        "\u0A6D",
        "\u0A6E",
        "\u0A6F"
    ],
    "hanidec": [
        "\u3007",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D"
    ],
    "hmng": [
        "\uD81A\uDF50",
        "\uD81A\uDF51",
        "\uD81A\uDF52",
        "\uD81A\uDF53",
        "\uD81A\uDF54",
        "\uD81A\uDF55",
        "\uD81A\uDF56",
        "\uD81A\uDF57",
        "\uD81A\uDF58",
        "\uD81A\uDF59"
    ],
    "hmnp": [
        "\uD838\uDD40",
        "\uD838\uDD41",
        "\uD838\uDD42",
        "\uD838\uDD43",
        "\uD838\uDD44",
        "\uD838\uDD45",
        "\uD838\uDD46",
        "\uD838\uDD47",
        "\uD838\uDD48",
        "\uD838\uDD49"
    ],
    "java": [
        "\uA9D0",
        "\uA9D1",
        "\uA9D2",
        "\uA9D3",
        "\uA9D4",
        "\uA9D5",
        "\uA9D6",
        "\uA9D7",
        "\uA9D8",
        "\uA9D9"
    ],
    "kali": [
        "\uA900",
        "\uA901",
        "\uA902",
        "\uA903",
        "\uA904",
        "\uA905",
        "\uA906",
        "\uA907",
        "\uA908",
        "\uA909"
    ],
    "khmr": [
        "\u17E0",
        "\u17E1",
        "\u17E2",
        "\u17E3",
        "\u17E4",
        "\u17E5",
        "\u17E6",
        "\u17E7",
        "\u17E8",
        "\u17E9"
    ],
    "knda": [
        "\u0CE6",
        "\u0CE7",
        "\u0CE8",
        "\u0CE9",
        "\u0CEA",
        "\u0CEB",
        "\u0CEC",
        "\u0CED",
        "\u0CEE",
        "\u0CEF"
    ],
    "lana": [
        "\u1A80",
        "\u1A81",
        "\u1A82",
        "\u1A83",
        "\u1A84",
        "\u1A85",
        "\u1A86",
        "\u1A87",
        "\u1A88",
        "\u1A89"
    ],
    "lanatham": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "laoo": [
        "\u0ED0",
        "\u0ED1",
        "\u0ED2",
        "\u0ED3",
        "\u0ED4",
        "\u0ED5",
        "\u0ED6",
        "\u0ED7",
        "\u0ED8",
        "\u0ED9"
    ],
    "lepc": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "limb": [
        "\u1946",
        "\u1947",
        "\u1948",
        "\u1949",
        "\u194A",
        "\u194B",
        "\u194C",
        "\u194D",
        "\u194E",
        "\u194F"
    ],
    "mathbold": [
        "\uD835\uDFCE",
        "\uD835\uDFCF",
        "\uD835\uDFD0",
        "\uD835\uDFD1",
        "\uD835\uDFD2",
        "\uD835\uDFD3",
        "\uD835\uDFD4",
        "\uD835\uDFD5",
        "\uD835\uDFD6",
        "\uD835\uDFD7"
    ],
    "mathdbl": [
        "\uD835\uDFD8",
        "\uD835\uDFD9",
        "\uD835\uDFDA",
        "\uD835\uDFDB",
        "\uD835\uDFDC",
        "\uD835\uDFDD",
        "\uD835\uDFDE",
        "\uD835\uDFDF",
        "\uD835\uDFE0",
        "\uD835\uDFE1"
    ],
    "mathmono": [
        "\uD835\uDFF6",
        "\uD835\uDFF7",
        "\uD835\uDFF8",
        "\uD835\uDFF9",
        "\uD835\uDFFA",
        "\uD835\uDFFB",
        "\uD835\uDFFC",
        "\uD835\uDFFD",
        "\uD835\uDFFE",
        "\uD835\uDFFF"
    ],
    "mathsanb": [
        "\uD835\uDFEC",
        "\uD835\uDFED",
        "\uD835\uDFEE",
        "\uD835\uDFEF",
        "\uD835\uDFF0",
        "\uD835\uDFF1",
        "\uD835\uDFF2",
        "\uD835\uDFF3",
        "\uD835\uDFF4",
        "\uD835\uDFF5"
    ],
    "mathsans": [
        "\uD835\uDFE2",
        "\uD835\uDFE3",
        "\uD835\uDFE4",
        "\uD835\uDFE5",
        "\uD835\uDFE6",
        "\uD835\uDFE7",
        "\uD835\uDFE8",
        "\uD835\uDFE9",
        "\uD835\uDFEA",
        "\uD835\uDFEB"
    ],
    "mlym": [
        "\u0D66",
        "\u0D67",
        "\u0D68",
        "\u0D69",
        "\u0D6A",
        "\u0D6B",
        "\u0D6C",
        "\u0D6D",
        "\u0D6E",
        "\u0D6F"
    ],
    "modi": [
        "\uD805\uDE50",
        "\uD805\uDE51",
        "\uD805\uDE52",
        "\uD805\uDE53",
        "\uD805\uDE54",
        "\uD805\uDE55",
        "\uD805\uDE56",
        "\uD805\uDE57",
        "\uD805\uDE58",
        "\uD805\uDE59"
    ],
    "mong": [
        "\u1810",
        "\u1811",
        "\u1812",
        "\u1813",
        "\u1814",
        "\u1815",
        "\u1816",
        "\u1817",
        "\u1818",
        "\u1819"
    ],
    "mroo": [
        "\uD81A\uDE60",
        "\uD81A\uDE61",
        "\uD81A\uDE62",
        "\uD81A\uDE63",
        "\uD81A\uDE64",
        "\uD81A\uDE65",
        "\uD81A\uDE66",
        "\uD81A\uDE67",
        "\uD81A\uDE68",
        "\uD81A\uDE69"
    ],
    "mtei": [
        "\uABF0",
        "\uABF1",
        "\uABF2",
        "\uABF3",
        "\uABF4",
        "\uABF5",
        "\uABF6",
        "\uABF7",
        "\uABF8",
        "\uABF9"
    ],
    "mymr": [
        "\u1040",
        "\u1041",
        "\u1042",
        "\u1043",
        "\u1044",
        "\u1045",
        "\u1046",
        "\u1047",
        "\u1048",
        "\u1049"
    ],
    "mymrshan": [
        "\u1090",
        "\u1091",
        "\u1092",
        "\u1093",
        "\u1094",
        "\u1095",
        "\u1096",
        "\u1097",
        "\u1098",
        "\u1099"
    ],
    "mymrtlng": [
        "\uA9F0",
        "\uA9F1",
        "\uA9F2",
        "\uA9F3",
        "\uA9F4",
        "\uA9F5",
        "\uA9F6",
        "\uA9F7",
        "\uA9F8",
        "\uA9F9"
    ],
    "newa": [
        "\uD805\uDC50",
        "\uD805\uDC51",
        "\uD805\uDC52",
        "\uD805\uDC53",
        "\uD805\uDC54",
        "\uD805\uDC55",
        "\uD805\uDC56",
        "\uD805\uDC57",
        "\uD805\uDC58",
        "\uD805\uDC59"
    ],
    "nkoo": [
        "\u07C0",
        "\u07C1",
        "\u07C2",
        "\u07C3",
        "\u07C4",
        "\u07C5",
        "\u07C6",
        "\u07C7",
        "\u07C8",
        "\u07C9"
    ],
    "olck": [
        "\u1C50",
        "\u1C51",
        "\u1C52",
        "\u1C53",
        "\u1C54",
        "\u1C55",
        "\u1C56",
        "\u1C57",
        "\u1C58",
        "\u1C59"
    ],
    "orya": [
        "\u0B66",
        "\u0B67",
        "\u0B68",
        "\u0B69",
        "\u0B6A",
        "\u0B6B",
        "\u0B6C",
        "\u0B6D",
        "\u0B6E",
        "\u0B6F"
    ],
    "osma": [
        "\uD801\uDCA0",
        "\uD801\uDCA1",
        "\uD801\uDCA2",
        "\uD801\uDCA3",
        "\uD801\uDCA4",
        "\uD801\uDCA5",
        "\uD801\uDCA6",
        "\uD801\uDCA7",
        "\uD801\uDCA8",
        "\uD801\uDCA9"
    ],
    "rohg": [
        "\uD803\uDD30",
        "\uD803\uDD31",
        "\uD803\uDD32",
        "\uD803\uDD33",
        "\uD803\uDD34",
        "\uD803\uDD35",
        "\uD803\uDD36",
        "\uD803\uDD37",
        "\uD803\uDD38",
        "\uD803\uDD39"
    ],
    "saur": [
        "\uA8D0",
        "\uA8D1",
        "\uA8D2",
        "\uA8D3",
        "\uA8D4",
        "\uA8D5",
        "\uA8D6",
        "\uA8D7",
        "\uA8D8",
        "\uA8D9"
    ],
    "segment": [
        "\uD83E\uDFF0",
        "\uD83E\uDFF1",
        "\uD83E\uDFF2",
        "\uD83E\uDFF3",
        "\uD83E\uDFF4",
        "\uD83E\uDFF5",
        "\uD83E\uDFF6",
        "\uD83E\uDFF7",
        "\uD83E\uDFF8",
        "\uD83E\uDFF9"
    ],
    "shrd": [
        "\uD804\uDDD0",
        "\uD804\uDDD1",
        "\uD804\uDDD2",
        "\uD804\uDDD3",
        "\uD804\uDDD4",
        "\uD804\uDDD5",
        "\uD804\uDDD6",
        "\uD804\uDDD7",
        "\uD804\uDDD8",
        "\uD804\uDDD9"
    ],
    "sind": [
        "\uD804\uDEF0",
        "\uD804\uDEF1",
        "\uD804\uDEF2",
        "\uD804\uDEF3",
        "\uD804\uDEF4",
        "\uD804\uDEF5",
        "\uD804\uDEF6",
        "\uD804\uDEF7",
        "\uD804\uDEF8",
        "\uD804\uDEF9"
    ],
    "sinh": [
        "\u0DE6",
        "\u0DE7",
        "\u0DE8",
        "\u0DE9",
        "\u0DEA",
        "\u0DEB",
        "\u0DEC",
        "\u0DED",
        "\u0DEE",
        "\u0DEF"
    ],
    "sora": [
        "\uD804\uDCF0",
        "\uD804\uDCF1",
        "\uD804\uDCF2",
        "\uD804\uDCF3",
        "\uD804\uDCF4",
        "\uD804\uDCF5",
        "\uD804\uDCF6",
        "\uD804\uDCF7",
        "\uD804\uDCF8",
        "\uD804\uDCF9"
    ],
    "sund": [
        "\u1BB0",
        "\u1BB1",
        "\u1BB2",
        "\u1BB3",
        "\u1BB4",
        "\u1BB5",
        "\u1BB6",
        "\u1BB7",
        "\u1BB8",
        "\u1BB9"
    ],
    "takr": [
        "\uD805\uDEC0",
        "\uD805\uDEC1",
        "\uD805\uDEC2",
        "\uD805\uDEC3",
        "\uD805\uDEC4",
        "\uD805\uDEC5",
        "\uD805\uDEC6",
        "\uD805\uDEC7",
        "\uD805\uDEC8",
        "\uD805\uDEC9"
    ],
    "talu": [
        "\u19D0",
        "\u19D1",
        "\u19D2",
        "\u19D3",
        "\u19D4",
        "\u19D5",
        "\u19D6",
        "\u19D7",
        "\u19D8",
        "\u19D9"
    ],
    "tamldec": [
        "\u0BE6",
        "\u0BE7",
        "\u0BE8",
        "\u0BE9",
        "\u0BEA",
        "\u0BEB",
        "\u0BEC",
        "\u0BED",
        "\u0BEE",
        "\u0BEF"
    ],
    "telu": [
        "\u0C66",
        "\u0C67",
        "\u0C68",
        "\u0C69",
        "\u0C6A",
        "\u0C6B",
        "\u0C6C",
        "\u0C6D",
        "\u0C6E",
        "\u0C6F"
    ],
    "thai": [
        "\u0E50",
        "\u0E51",
        "\u0E52",
        "\u0E53",
        "\u0E54",
        "\u0E55",
        "\u0E56",
        "\u0E57",
        "\u0E58",
        "\u0E59"
    ],
    "tibt": [
        "\u0F20",
        "\u0F21",
        "\u0F22",
        "\u0F23",
        "\u0F24",
        "\u0F25",
        "\u0F26",
        "\u0F27",
        "\u0F28",
        "\u0F29"
    ],
    "tirh": [
        "\uD805\uDCD0",
        "\uD805\uDCD1",
        "\uD805\uDCD2",
        "\uD805\uDCD3",
        "\uD805\uDCD4",
        "\uD805\uDCD5",
        "\uD805\uDCD6",
        "\uD805\uDCD7",
        "\uD805\uDCD8",
        "\uD805\uDCD9"
    ],
    "vaii": [
        "\u1620",
        "\u1621",
        "\u1622",
        "\u1623",
        "\u1624",
        "\u1625",
        "\u1626",
        "\u1627",
        "\u1628",
        "\u1629"
    ],
    "wara": [
        "\uD806\uDCE0",
        "\uD806\uDCE1",
        "\uD806\uDCE2",
        "\uD806\uDCE3",
        "\uD806\uDCE4",
        "\uD806\uDCE5",
        "\uD806\uDCE6",
        "\uD806\uDCE7",
        "\uD806\uDCE8",
        "\uD806\uDCE9"
    ],
    "wcho": [
        "\uD838\uDEF0",
        "\uD838\uDEF1",
        "\uD838\uDEF2",
        "\uD838\uDEF3",
        "\uD838\uDEF4",
        "\uD838\uDEF5",
        "\uD838\uDEF6",
        "\uD838\uDEF7",
        "\uD838\uDEF8",
        "\uD838\uDEF9"
    ]
};

});

parcelRegister("jxpT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.S_UNICODE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;

});





parcelRegister("hGtnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRangeToParts = void 0;

var $9Mz4z = parcelRequire("9Mz4z");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrangetoparts
 */ function $cdfd272ff4e2d767$var$FormatNumericRangeToParts(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $9Mz4z.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part, index) {
        return {
            type: part.type,
            value: part.value,
            source: part.source,
            result: index.toString()
        };
    });
}
module.exports.FormatNumericRangeToParts = $cdfd272ff4e2d767$var$FormatNumericRangeToParts;

});

parcelRegister("amR5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToParts = void 0;

var $lwxMS = parcelRequire("lwxMS");

var $lOKID = parcelRequire("lOKID");
function $78c523786b6880b6$var$FormatNumericToParts(nf, x, implDetails) {
    var parts = (0, $lwxMS.PartitionNumberPattern)(nf, x, implDetails);
    var result = (0, $lOKID.ArrayCreate)(0);
    for(var _i = 0, parts_1 = parts; _i < parts_1.length; _i++){
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}
module.exports.FormatNumericToParts = $78c523786b6880b6$var$FormatNumericToParts;

});

parcelRegister("ko0U0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetUnsignedRoundingMode = void 0;
var $ed76bfba86f12d22$var$negativeMapping = {
    ceil: "zero",
    floor: "infinity",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-zero",
    halfFloor: "half-infinity",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
var $ed76bfba86f12d22$var$positiveMapping = {
    ceil: "infinity",
    floor: "zero",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-infinity",
    halfFloor: "half-zero",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
function $ed76bfba86f12d22$var$GetUnsignedRoundingMode(roundingMode, isNegative) {
    if (isNegative) return $ed76bfba86f12d22$var$negativeMapping[roundingMode];
    return $ed76bfba86f12d22$var$positiveMapping[roundingMode];
}
module.exports.GetUnsignedRoundingMode = $ed76bfba86f12d22$var$GetUnsignedRoundingMode;

});

parcelRegister("e2aOi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InitializeNumberFormat = void 0;

var $dJ73k = parcelRequire("dJ73k");

var $i9u1J = parcelRequire("i9u1J");

var $g0hCv = parcelRequire("g0hCv");

var $kvrN2 = parcelRequire("kvrN2");

var $rTD91 = parcelRequire("rTD91");

var $5SuUV = parcelRequire("5SuUV");

var $jSW1Z = parcelRequire("jSW1Z");

var $7s5DV = parcelRequire("7s5DV");

var $jOD6q = parcelRequire("jOD6q");

var $2YEFp = parcelRequire("2YEFp");
var $a379a3433c36211a$var$VALID_ROUND_INCREMENT_VALUES = [
    1,
    2,
    5,
    10,
    20,
    25,
    50,
    100,
    200,
    250,
    500,
    1000,
    2000
];
/**
 * https://tc39.es/ecma402/#sec-initializenumberformat
 */ function $a379a3433c36211a$var$InitializeNumberFormat(nf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
    // @ts-ignore
    var requestedLocales = (0, $i9u1J.CanonicalizeLocaleList)(locales);
    var options = (0, $g0hCv.CoerceOptionsToObject)(opts);
    var opt = Object.create(null);
    var matcher = (0, $rTD91.GetOption)(options, "localeMatcher", "string", [
        "lookup",
        "best fit"
    ], "best fit");
    opt.localeMatcher = matcher;
    var numberingSystem = (0, $rTD91.GetOption)(options, "numberingSystem", "string", undefined, undefined);
    if (numberingSystem !== undefined && numberingSystemNames.indexOf(numberingSystem) < 0) // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
    // throw a RangeError exception.
    throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
    opt.nu = numberingSystem;
    var r = (0, $dJ73k.ResolveLocale)(Array.from(availableLocales), requestedLocales, opt, // [[RelevantExtensionKeys]] slot, which is a constant
    [
        "nu"
    ], localeData, getDefaultLocale);
    var dataLocaleData = localeData[r.dataLocale];
    (0, $jSW1Z.invariant)(!!dataLocaleData, "Missing locale data for ".concat(r.dataLocale));
    var internalSlots = getInternalSlots(nf);
    internalSlots.locale = r.locale;
    internalSlots.dataLocale = r.dataLocale;
    internalSlots.numberingSystem = r.nu;
    internalSlots.dataLocaleData = dataLocaleData;
    (0, $2YEFp.SetNumberFormatUnitOptions)(nf, options, {
        getInternalSlots: getInternalSlots
    });
    var style = internalSlots.style;
    var mnfdDefault;
    var mxfdDefault;
    if (style === "currency") {
        var currency = internalSlots.currency;
        var cDigits = (0, $7s5DV.CurrencyDigits)(currency, {
            currencyDigitsData: currencyDigitsData
        });
        mnfdDefault = cDigits;
        mxfdDefault = cDigits;
    } else {
        mnfdDefault = 0;
        mxfdDefault = style === "percent" ? 0 : 3;
    }
    var notation = (0, $rTD91.GetOption)(options, "notation", "string", [
        "standard",
        "scientific",
        "engineering",
        "compact"
    ], "standard");
    internalSlots.notation = notation;
    (0, $jOD6q.SetNumberFormatDigitOptions)(internalSlots, options, mnfdDefault, mxfdDefault, notation);
    var roundingIncrement = (0, $kvrN2.GetNumberOption)(options, "roundingIncrement", 1, 5000, 1);
    if ($a379a3433c36211a$var$VALID_ROUND_INCREMENT_VALUES.indexOf(roundingIncrement) === -1) throw new RangeError("Invalid rounding increment value: ".concat(roundingIncrement, ".\nValid values are ").concat($a379a3433c36211a$var$VALID_ROUND_INCREMENT_VALUES, "."));
    if (roundingIncrement !== 1 && internalSlots.roundingType !== "fractionDigits") throw new TypeError("For roundingIncrement > 1 only fractionDigits is a valid roundingType");
    if (roundingIncrement !== 1 && internalSlots.maximumFractionDigits !== internalSlots.minimumFractionDigits) throw new RangeError("With roundingIncrement > 1, maximumFractionDigits and minimumFractionDigits must be equal.");
    internalSlots.roundingIncrement = roundingIncrement;
    var trailingZeroDisplay = (0, $rTD91.GetOption)(options, "trailingZeroDisplay", "string", [
        "auto",
        "stripIfInteger"
    ], "auto");
    internalSlots.trailingZeroDisplay = trailingZeroDisplay;
    var compactDisplay = (0, $rTD91.GetOption)(options, "compactDisplay", "string", [
        "short",
        "long"
    ], "short");
    var defaultUseGrouping = "auto";
    if (notation === "compact") {
        internalSlots.compactDisplay = compactDisplay;
        defaultUseGrouping = "min2";
    }
    internalSlots.useGrouping = (0, $5SuUV.GetStringOrBooleanOption)(options, "useGrouping", [
        "min2",
        "auto",
        "always"
    ], "always", false, defaultUseGrouping);
    internalSlots.signDisplay = (0, $rTD91.GetOption)(options, "signDisplay", "string", [
        "auto",
        "never",
        "always",
        "exceptZero",
        "negative"
    ], "auto");
    internalSlots.roundingMode = (0, $rTD91.GetOption)(options, "roundingMode", "string", [
        "ceil",
        "floor",
        "expand",
        "trunc",
        "halfCeil",
        "halfFloor",
        "halfExpand",
        "halfTrunc",
        "halfEven"
    ], "halfExpand");
    return nf;
}
module.exports.InitializeNumberFormat = $a379a3433c36211a$var$InitializeNumberFormat;

});
parcelRegister("dJ73k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = module.exports.LookupSupportedLocales = module.exports.match = void 0;

var $97waq = parcelRequire("97waq");

var $7Blop = parcelRequire("7Blop");
function $9fe4f2d2a355f90d$var$match(requestedLocales, availableLocales, defaultLocale, opts) {
    return (0, $7Blop.ResolveLocale)(availableLocales, (0, $97waq.CanonicalizeLocaleList)(requestedLocales), {
        localeMatcher: (opts === null || opts === void 0 ? void 0 : opts.algorithm) || "best fit"
    }, [], {}, function() {
        return defaultLocale;
    }).locale;
}
module.exports.match = $9fe4f2d2a355f90d$var$match;

var $iNDS5 = parcelRequire("iNDS5");
Object.defineProperty(module.exports, "LookupSupportedLocales", {
    enumerable: true,
    get: function() {
        return $iNDS5.LookupSupportedLocales;
    }
});

var $7Blop = parcelRequire("7Blop");
Object.defineProperty(module.exports, "ResolveLocale", {
    enumerable: true,
    get: function() {
        return $7Blop.ResolveLocale;
    }
});

});
parcelRegister("97waq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $6a3db83bb1e0dd9b$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $6a3db83bb1e0dd9b$var$CanonicalizeLocaleList;

});

parcelRegister("7Blop", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = void 0;

var $2fhX1 = parcelRequire("2fhX1");

var $ZHhL4 = parcelRequire("ZHhL4");

var $cG0uD = parcelRequire("cG0uD");

var $gFwC2 = parcelRequire("gFwC2");
/**
 * https://tc39.es/ecma402/#sec-resolvelocale
 */ function $588c953d261ef867$var$ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var matcher = options.localeMatcher;
    var r;
    if (matcher === "lookup") r = (0, $ZHhL4.LookupMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    else r = (0, $2fhX1.BestFitMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    var foundLocale = r.locale;
    var result = {
        locale: "",
        dataLocale: foundLocale
    };
    var supportedExtension = "-u";
    for(var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++){
        var key = relevantExtensionKeys_1[_i];
        (0, $gFwC2.invariant)(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
        var foundLocaleData = localeData[foundLocale];
        (0, $gFwC2.invariant)(typeof foundLocaleData === "object" && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
        var keyLocaleData = foundLocaleData[key];
        (0, $gFwC2.invariant)(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
        var value = keyLocaleData[0];
        (0, $gFwC2.invariant)(typeof value === "string" || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
        var supportedExtensionAddition = "";
        if (r.extension) {
            var requestedValue = (0, $cG0uD.UnicodeExtensionValue)(r.extension, key);
            if (requestedValue !== undefined) {
                if (requestedValue !== "") {
                    if (~keyLocaleData.indexOf(requestedValue)) {
                        value = requestedValue;
                        supportedExtensionAddition = "-".concat(key, "-").concat(value);
                    }
                } else if (~requestedValue.indexOf("true")) {
                    value = "true";
                    supportedExtensionAddition = "-".concat(key);
                }
            }
        }
        if (key in options) {
            var optionsValue = options[key];
            (0, $gFwC2.invariant)(typeof optionsValue === "string" || typeof optionsValue === "undefined" || optionsValue === null, "optionsValue must be String, Undefined or Null");
            if (~keyLocaleData.indexOf(optionsValue)) {
                if (optionsValue !== value) {
                    value = optionsValue;
                    supportedExtensionAddition = "";
                }
            }
        }
        result[key] = value;
        supportedExtension += supportedExtensionAddition;
    }
    if (supportedExtension.length > 2) {
        var privateIndex = foundLocale.indexOf("-x-");
        if (privateIndex === -1) foundLocale = foundLocale + supportedExtension;
        else {
            var preExtension = foundLocale.slice(0, privateIndex);
            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
            foundLocale = preExtension + supportedExtension + postExtension;
        }
        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
    }
    result.locale = foundLocale;
    return result;
}
module.exports.ResolveLocale = $588c953d261ef867$var$ResolveLocale;

});
parcelRegister("2fhX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestFitMatcher = void 0;

var $gFwC2 = parcelRequire("gFwC2");
/**
 * https://tc39.es/ecma402/#sec-bestfitmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $1a2ae82733c2750f$var$BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var foundLocale;
    var extension;
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var l = requestedLocales_1[_i];
        var matchedLocale = (0, $gFwC2.findBestMatch)(l.replace($gFwC2.UNICODE_EXTENSION_SEQUENCE_REGEX, ""), availableLocales);
        if (matchedLocale) {
            foundLocale = matchedLocale;
            var noExtensionLocale = l.replace($gFwC2.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
            extension = l.slice(noExtensionLocale.length, l.length) || undefined;
            break;
        }
    }
    if (!foundLocale) return {
        locale: getDefaultLocale()
    };
    return {
        locale: foundLocale,
        extension: extension
    };
}
module.exports.BestFitMatcher = $1a2ae82733c2750f$var$BestFitMatcher;

});
parcelRegister("gFwC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findBestMatch = module.exports.findMatchingDistance = module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $idgiX = parcelRequire("idgiX");

var $e9Pzd = parcelRequire("e9Pzd");
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $c229c5d49e3b60be$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $c229c5d49e3b60be$var$invariant;
// This is effectively 2 languages in 2 different regions not even in the same cluster
var $c229c5d49e3b60be$var$DEFAULT_MATCHING_THRESHOLD = 840;
var $c229c5d49e3b60be$var$PROCESSED_DATA;
function $c229c5d49e3b60be$var$processData() {
    var _a, _b;
    if (!$c229c5d49e3b60be$var$PROCESSED_DATA) {
        var paradigmLocales = (_b = (_a = $idgiX.data.supplemental.languageMatching["written-new"][0]) === null || _a === void 0 ? void 0 : _a.paradigmLocales) === null || _b === void 0 ? void 0 : _b._locales.split(" ");
        var matchVariables = $idgiX.data.supplemental.languageMatching["written-new"].slice(1, 5);
        var data = $idgiX.data.supplemental.languageMatching["written-new"].slice(5);
        var matches = data.map(function(d) {
            var key = Object.keys(d)[0];
            var value = d[key];
            return {
                supported: key,
                desired: value._desired,
                distance: +value._distance,
                oneway: value.oneway === "true" ? true : false
            };
        }, {});
        $c229c5d49e3b60be$var$PROCESSED_DATA = {
            matches: matches,
            matchVariables: matchVariables.reduce(function(all, d) {
                var key = Object.keys(d)[0];
                var value = d[key];
                all[key.slice(1)] = value._value.split("+");
                return all;
            }, {}),
            paradigmLocales: $4UZnF.__spreadArray($4UZnF.__spreadArray([], paradigmLocales, true), paradigmLocales.map(function(l) {
                return new Intl.Locale(l.replace(/_/g, "-")).maximize().toString();
            }), true)
        };
    }
    return $c229c5d49e3b60be$var$PROCESSED_DATA;
}
function $c229c5d49e3b60be$var$isMatched(locale, languageMatchInfoLocale, matchVariables) {
    var _a = languageMatchInfoLocale.split("-"), language = _a[0], script = _a[1], region = _a[2];
    var matches = true;
    if (region && region[0] === "$") {
        var shouldInclude = region[1] !== "!";
        var matchRegions = shouldInclude ? matchVariables[region.slice(1)] : matchVariables[region.slice(2)];
        var expandedMatchedRegions = matchRegions.map(function(r) {
            return $e9Pzd.regions[r] || [
                r
            ];
        }).reduce(function(all, list) {
            return $4UZnF.__spreadArray($4UZnF.__spreadArray([], all, true), list, true);
        }, []);
        matches && (matches = !(expandedMatchedRegions.indexOf(locale.region || "") > 1 != shouldInclude));
    } else matches && (matches = locale.region ? region === "*" || region === locale.region : true);
    matches && (matches = locale.script ? script === "*" || script === locale.script : true);
    matches && (matches = locale.language ? language === "*" || language === locale.language : true);
    return matches;
}
function $c229c5d49e3b60be$var$serializeLSR(lsr) {
    return [
        lsr.language,
        lsr.script,
        lsr.region
    ].filter(Boolean).join("-");
}
function $c229c5d49e3b60be$var$findMatchingDistanceForLSR(desired, supported, data) {
    for(var _i = 0, _a = data.matches; _i < _a.length; _i++){
        var d = _a[_i];
        var matches = $c229c5d49e3b60be$var$isMatched(desired, d.desired, data.matchVariables) && $c229c5d49e3b60be$var$isMatched(supported, d.supported, data.matchVariables);
        if (!d.oneway && !matches) matches = $c229c5d49e3b60be$var$isMatched(desired, d.supported, data.matchVariables) && $c229c5d49e3b60be$var$isMatched(supported, d.desired, data.matchVariables);
        if (matches) {
            var distance = d.distance * 10;
            if (data.paradigmLocales.indexOf($c229c5d49e3b60be$var$serializeLSR(desired)) > -1 != data.paradigmLocales.indexOf($c229c5d49e3b60be$var$serializeLSR(supported)) > -1) return distance - 1;
            return distance;
        }
    }
    throw new Error("No matching distance found");
}
function $c229c5d49e3b60be$var$findMatchingDistance(desired, supported) {
    var desiredLocale = new Intl.Locale(desired).maximize();
    var supportedLocale = new Intl.Locale(supported).maximize();
    var desiredLSR = {
        language: desiredLocale.language,
        script: desiredLocale.script || "",
        region: desiredLocale.region || ""
    };
    var supportedLSR = {
        language: supportedLocale.language,
        script: supportedLocale.script || "",
        region: supportedLocale.region || ""
    };
    var matchingDistance = 0;
    var data = $c229c5d49e3b60be$var$processData();
    if (desiredLSR.language !== supportedLSR.language) matchingDistance += $c229c5d49e3b60be$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: "",
        region: ""
    }, {
        language: supportedLocale.language,
        script: "",
        region: ""
    }, data);
    if (desiredLSR.script !== supportedLSR.script) matchingDistance += $c229c5d49e3b60be$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: desiredLSR.script,
        region: ""
    }, {
        language: supportedLocale.language,
        script: desiredLSR.script,
        region: ""
    }, data);
    if (desiredLSR.region !== supportedLSR.region) matchingDistance += $c229c5d49e3b60be$var$findMatchingDistanceForLSR(desiredLSR, supportedLSR, data);
    return matchingDistance;
}
module.exports.findMatchingDistance = $c229c5d49e3b60be$var$findMatchingDistance;
function $c229c5d49e3b60be$var$findBestMatch(desired, supportedLocales, threshold) {
    if (threshold === void 0) threshold = $c229c5d49e3b60be$var$DEFAULT_MATCHING_THRESHOLD;
    var bestMatch = undefined;
    var lowestDistance = Infinity;
    supportedLocales.forEach(function(supported, i) {
        // Add some weight to the distance based on the order of the supported locales
        var distance = $c229c5d49e3b60be$var$findMatchingDistance(desired, supported) + i;
        if (distance < lowestDistance) {
            lowestDistance = distance;
            bestMatch = supported;
        }
    });
    if (lowestDistance >= threshold) return;
    return bestMatch;
}
module.exports.findBestMatch = $c229c5d49e3b60be$var$findBestMatch;

});
parcelRegister("idgiX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.data = void 0;
module.exports.data = {
    supplemental: {
        languageMatching: {
            "written-new": [
                {
                    paradigmLocales: {
                        _locales: "en en_GB es es_419 pt_BR pt_PT"
                    }
                },
                {
                    $enUS: {
                        _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
                    }
                },
                {
                    $cnsar: {
                        _value: "HK+MO"
                    }
                },
                {
                    $americas: {
                        _value: "019"
                    }
                },
                {
                    $maghreb: {
                        _value: "MA+DZ+TN+LY+MR+EH"
                    }
                },
                {
                    no: {
                        _desired: "nb",
                        _distance: "1"
                    }
                },
                {
                    bs: {
                        _desired: "hr",
                        _distance: "4"
                    }
                },
                {
                    bs: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    hr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    sr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    aa: {
                        _desired: "ssy",
                        _distance: "4"
                    }
                },
                {
                    de: {
                        _desired: "gsw",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "lb",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    no: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    nb: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    ru: {
                        _desired: "ab",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ach",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "af",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ak",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "am",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ay",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "az",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ur: {
                        _desired: "bal",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "be",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bem",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "bh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "bo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "br",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ca",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fil: {
                        _desired: "ceb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "chr",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ckb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "co",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "crs",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    sk: {
                        _desired: "cs",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "cy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ee",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "eo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "eu",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    da: {
                        _desired: "fo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "fy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ga",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gaa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gd",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gl",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "gu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ha",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "haw",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ht",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "hy",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ia",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ig",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "is",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "jv",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ka",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "kg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "kk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "km",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kri",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    tr: {
                        _desired: "ku",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "ky",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    it: {
                        _desired: "la",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ln",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "loz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "lua",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mai",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mfe",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "mg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mi",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ml",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "mn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mr",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "ms",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "my",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ne",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nb: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    no: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "nso",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ny",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "nyn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "oc",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "om",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "or",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pcm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ps",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "qu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "rm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "rn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "rw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "sa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sd",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "si",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "so",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sq",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "st",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "su",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ta",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "te",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ti",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tlh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "to",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tum",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "ug",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uk",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ur",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "wo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "xh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yi",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "za",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "zu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aao",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "adf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aeb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "afb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ajp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ars",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ary",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "auz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "avl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "bbz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "pga",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "shu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ssh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    az: {
                        _desired: "azb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    et: {
                        _desired: "vro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "ffm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gnw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gun",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "nhd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    iu: {
                        _desired: "ikt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "enb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "eyo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "niq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "oki",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "pko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "sgc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tuy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kok: {
                        _desired: "gom",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kpe: {
                        _desired: "gkp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "ida",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lkb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lks",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lri",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lrm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lsm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lto",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lts",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lwg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nle",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nyd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "rag",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    lv: {
                        _desired: "ltg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bhr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bjq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bzc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "msh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "skg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tdx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tkg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "txy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mn: {
                        _desired: "mvf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bjn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "btj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bvu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "coa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "dup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "hji",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "id",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kxd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lce",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lcf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "liw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "max",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "meo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "min",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mqg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "msi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "orn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "ors",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pel",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pse",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "tmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "urk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "xmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zlm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zmi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ne: {
                        _desired: "dty",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "gax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "hae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "orc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    or: {
                        _desired: "spv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pbt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pst",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qud",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qug",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qul",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qur",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qus",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qux",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qws",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aat",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aln",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    syr: {
                        _desired: "aii",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    uz: {
                        _desired: "uzs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    yi: {
                        _desired: "yih",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cdo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cjy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cpx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "gan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hsn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "lzh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "mnp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "nan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "wuu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "yue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "*": {
                        _desired: "*",
                        _distance: "80"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "am-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "az-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "bn-Beng",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "bo-Tibt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "hy-Armn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ka-Geor",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "km-Khmr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "kn-Knda",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "lo-Laoo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ml-Mlym",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "my-Mymr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ne-Deva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "or-Orya",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "pa-Guru",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ps-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "sd-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "si-Sinh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ta-Taml",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "te-Telu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ti-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "tk-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ur-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "uz-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "yi-Hebr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "sr-Cyrl": {
                        _desired: "sr-Latn",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "za-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hant": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ar-Arab": {
                        _desired: "ar-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "bn-Beng": {
                        _desired: "bn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "gu-Gujr": {
                        _desired: "gu-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "hi-Deva": {
                        _desired: "hi-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "kn-Knda": {
                        _desired: "kn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ml-Mlym": {
                        _desired: "ml-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "mr-Deva": {
                        _desired: "mr-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ta-Taml": {
                        _desired: "ta-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "te-Telu": {
                        _desired: "te-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Latn",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hrkt",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hang",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Hang": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "*-*": {
                        _desired: "*-*",
                        _distance: "50"
                    }
                },
                {
                    "ar-*-$maghreb": {
                        _desired: "ar-*-$maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-$!maghreb": {
                        _desired: "ar-*-$!maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-*": {
                        _desired: "ar-*-*",
                        _distance: "5"
                    }
                },
                {
                    "en-*-$enUS": {
                        _desired: "en-*-$enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-GB": {
                        _desired: "en-*-$!enUS",
                        _distance: "3"
                    }
                },
                {
                    "en-*-$!enUS": {
                        _desired: "en-*-$!enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-*": {
                        _desired: "en-*-*",
                        _distance: "5"
                    }
                },
                {
                    "es-*-$americas": {
                        _desired: "es-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-$!americas": {
                        _desired: "es-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-*": {
                        _desired: "es-*-*",
                        _distance: "5"
                    }
                },
                {
                    "pt-*-$americas": {
                        _desired: "pt-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-$!americas": {
                        _desired: "pt-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-*": {
                        _desired: "pt-*-*",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hant-$cnsar": {
                        _desired: "zh-Hant-$cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-$!cnsar": {
                        _desired: "zh-Hant-$!cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-*": {
                        _desired: "zh-Hant-*",
                        _distance: "5"
                    }
                },
                {
                    "*-*-*": {
                        _desired: "*-*-*",
                        _distance: "4"
                    }
                }
            ]
        }
    }
};

});

parcelRegister("e9Pzd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regions = void 0;
// This file is generated from regions-gen.ts
module.exports.regions = {
    "001": [
        "001",
        "001-status-grouping",
        "002",
        "005",
        "009",
        "011",
        "013",
        "014",
        "015",
        "017",
        "018",
        "019",
        "021",
        "029",
        "030",
        "034",
        "035",
        "039",
        "053",
        "054",
        "057",
        "061",
        "142",
        "143",
        "145",
        "150",
        "151",
        "154",
        "155",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BV",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CP",
        "CQ",
        "CR",
        "CU",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DG",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EA",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "EU",
        "EZ",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GG",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GS",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HM",
        "HN",
        "HR",
        "HT",
        "HU",
        "IC",
        "ID",
        "IE",
        "IL",
        "IM",
        "IN",
        "IO",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JE",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "QO",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SY",
        "SZ",
        "TA",
        "TC",
        "TD",
        "TF",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UA",
        "UG",
        "UM",
        "UN",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VE",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "XK",
        "YE",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "002": [
        "002",
        "002-status-grouping",
        "011",
        "014",
        "015",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EA",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IC",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "003": [
        "003",
        "013",
        "021",
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    "005": [
        "005",
        "AR",
        "BO",
        "BR",
        "BV",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GS",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    "009": [
        "009",
        "053",
        "054",
        "057",
        "061",
        "AC",
        "AQ",
        "AS",
        "AU",
        "CC",
        "CK",
        "CP",
        "CX",
        "DG",
        "FJ",
        "FM",
        "GU",
        "HM",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PN",
        "PW",
        "QO",
        "SB",
        "TA",
        "TK",
        "TO",
        "TV",
        "UM",
        "VU",
        "WF",
        "WS"
    ],
    "011": [
        "011",
        "BF",
        "BJ",
        "CI",
        "CV",
        "GH",
        "GM",
        "GN",
        "GW",
        "LR",
        "ML",
        "MR",
        "NE",
        "NG",
        "SH",
        "SL",
        "SN",
        "TG"
    ],
    "013": [
        "013",
        "BZ",
        "CR",
        "GT",
        "HN",
        "MX",
        "NI",
        "PA",
        "SV"
    ],
    "014": [
        "014",
        "BI",
        "DJ",
        "ER",
        "ET",
        "IO",
        "KE",
        "KM",
        "MG",
        "MU",
        "MW",
        "MZ",
        "RE",
        "RW",
        "SC",
        "SO",
        "SS",
        "TF",
        "TZ",
        "UG",
        "YT",
        "ZM",
        "ZW"
    ],
    "015": [
        "015",
        "DZ",
        "EA",
        "EG",
        "EH",
        "IC",
        "LY",
        "MA",
        "SD",
        "TN"
    ],
    "017": [
        "017",
        "AO",
        "CD",
        "CF",
        "CG",
        "CM",
        "GA",
        "GQ",
        "ST",
        "TD"
    ],
    "018": [
        "018",
        "BW",
        "LS",
        "NA",
        "SZ",
        "ZA"
    ],
    "019": [
        "003",
        "005",
        "013",
        "019",
        "019-status-grouping",
        "021",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BM",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CA",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GL",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PM",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "021": [
        "021",
        "BM",
        "CA",
        "GL",
        "PM",
        "US"
    ],
    "029": [
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BQ",
        "BS",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GP",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "PR",
        "SX",
        "TC",
        "TT",
        "VC",
        "VG",
        "VI"
    ],
    "030": [
        "030",
        "CN",
        "HK",
        "JP",
        "KP",
        "KR",
        "MN",
        "MO",
        "TW"
    ],
    "034": [
        "034",
        "AF",
        "BD",
        "BT",
        "IN",
        "IR",
        "LK",
        "MV",
        "NP",
        "PK"
    ],
    "035": [
        "035",
        "BN",
        "ID",
        "KH",
        "LA",
        "MM",
        "MY",
        "PH",
        "SG",
        "TH",
        "TL",
        "VN"
    ],
    "039": [
        "039",
        "AD",
        "AL",
        "BA",
        "ES",
        "GI",
        "GR",
        "HR",
        "IT",
        "ME",
        "MK",
        "MT",
        "PT",
        "RS",
        "SI",
        "SM",
        "VA",
        "XK"
    ],
    "053": [
        "053",
        "AU",
        "CC",
        "CX",
        "HM",
        "NF",
        "NZ"
    ],
    "054": [
        "054",
        "FJ",
        "NC",
        "PG",
        "SB",
        "VU"
    ],
    "057": [
        "057",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NR",
        "PW",
        "UM"
    ],
    "061": [
        "061",
        "AS",
        "CK",
        "NU",
        "PF",
        "PN",
        "TK",
        "TO",
        "TV",
        "WF",
        "WS"
    ],
    "142": [
        "030",
        "034",
        "035",
        "142",
        "143",
        "145",
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CN",
        "CY",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    "143": [
        "143",
        "KG",
        "KZ",
        "TJ",
        "TM",
        "UZ"
    ],
    "145": [
        "145",
        "AE",
        "AM",
        "AZ",
        "BH",
        "CY",
        "GE",
        "IL",
        "IQ",
        "JO",
        "KW",
        "LB",
        "OM",
        "PS",
        "QA",
        "SA",
        "SY",
        "TR",
        "YE"
    ],
    "150": [
        "039",
        "150",
        "151",
        "154",
        "155",
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CQ",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    "151": [
        "151",
        "BG",
        "BY",
        "CZ",
        "HU",
        "MD",
        "PL",
        "RO",
        "RU",
        "SK",
        "UA"
    ],
    "154": [
        "154",
        "AX",
        "CQ",
        "DK",
        "EE",
        "FI",
        "FO",
        "GB",
        "GG",
        "IE",
        "IM",
        "IS",
        "JE",
        "LT",
        "LV",
        "NO",
        "SE",
        "SJ"
    ],
    "155": [
        "155",
        "AT",
        "BE",
        "CH",
        "DE",
        "FR",
        "LI",
        "LU",
        "MC",
        "NL"
    ],
    "202": [
        "011",
        "014",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "419": [
        "005",
        "013",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "EU": [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "EU",
        "FI",
        "FR",
        "GR",
        "HR",
        "HU",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SE",
        "SI",
        "SK"
    ],
    "EZ": [
        "AT",
        "BE",
        "CY",
        "DE",
        "EE",
        "ES",
        "EZ",
        "FI",
        "FR",
        "GR",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PT",
        "SI",
        "SK"
    ],
    "QO": [
        "AC",
        "AQ",
        "CP",
        "DG",
        "QO",
        "TA"
    ],
    "UN": [
        "AD",
        "AE",
        "AF",
        "AG",
        "AL",
        "AM",
        "AO",
        "AR",
        "AT",
        "AU",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BN",
        "BO",
        "BR",
        "BS",
        "BT",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CU",
        "CV",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FM",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GR",
        "GT",
        "GW",
        "GY",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MR",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NE",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PG",
        "PH",
        "PK",
        "PL",
        "PT",
        "PW",
        "PY",
        "QA",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SI",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SY",
        "SZ",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TZ",
        "UA",
        "UG",
        "UN",
        "US",
        "UY",
        "UZ",
        "VC",
        "VE",
        "VN",
        "VU",
        "WS",
        "YE",
        "ZA",
        "ZM",
        "ZW"
    ]
};

});



parcelRegister("ZHhL4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupMatcher = void 0;

var $7s0FV = parcelRequire("7s0FV");

var $gFwC2 = parcelRequire("gFwC2");
/**
 * https://tc39.es/ecma402/#sec-lookupmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $0b974633ec6ee0ae$var$LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var result = {
        locale: ""
    };
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($gFwC2.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $7s0FV.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) result.extension = locale.slice(noExtensionLocale.length, locale.length);
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}
module.exports.LookupMatcher = $0b974633ec6ee0ae$var$LookupMatcher;

});
parcelRegister("7s0FV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestAvailableLocale = void 0;
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */ function $56cbac08f4ae1c68$var$BestAvailableLocale(availableLocales, locale) {
    var candidate = locale;
    while(true){
        if (availableLocales.indexOf(candidate) > -1) return candidate;
        var pos = candidate.lastIndexOf("-");
        if (!~pos) return undefined;
        if (pos >= 2 && candidate[pos - 2] === "-") pos -= 2;
        candidate = candidate.slice(0, pos);
    }
}
module.exports.BestAvailableLocale = $56cbac08f4ae1c68$var$BestAvailableLocale;

});


parcelRegister("cG0uD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnicodeExtensionValue = void 0;

var $gFwC2 = parcelRequire("gFwC2");
/**
 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
 * @param extension
 * @param key
 */ function $93a9ca343d02a81d$var$UnicodeExtensionValue(extension, key) {
    (0, $gFwC2.invariant)(key.length === 2, "key must have 2 elements");
    var size = extension.length;
    var searchValue = "-".concat(key, "-");
    var pos = extension.indexOf(searchValue);
    if (pos !== -1) {
        var start = pos + 4;
        var end = start;
        var k = start;
        var done = false;
        while(!done){
            var e = extension.indexOf("-", k);
            var len = void 0;
            if (e === -1) len = size - k;
            else len = e - k;
            if (len === 2) done = true;
            else if (e === -1) {
                end = size;
                done = true;
            } else {
                end = e;
                k = e + 1;
            }
        }
        return extension.slice(start, end);
    }
    searchValue = "-".concat(key);
    pos = extension.indexOf(searchValue);
    if (pos !== -1 && pos + 3 === size) return "";
    return undefined;
}
module.exports.UnicodeExtensionValue = $93a9ca343d02a81d$var$UnicodeExtensionValue;

});


parcelRegister("iNDS5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupSupportedLocales = void 0;

var $7s0FV = parcelRequire("7s0FV");

var $gFwC2 = parcelRequire("gFwC2");
/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */ function $dafbbb33808aa388$var$LookupSupportedLocales(availableLocales, requestedLocales) {
    var subset = [];
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($gFwC2.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $7s0FV.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) subset.push(availableLocale);
    }
    return subset;
}
module.exports.LookupSupportedLocales = $dafbbb33808aa388$var$LookupSupportedLocales;

});


parcelRegister("jOD6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatDigitOptions = void 0;

var $kvrN2 = parcelRequire("kvrN2");

var $3jLgT = parcelRequire("3jLgT");

var $rTD91 = parcelRequire("rTD91");
/**
 * https://tc39.es/ecma402/#sec-setnfdigitoptions
 */ function $e6d104cd877dfbfa$var$SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
    var mnid = (0, $kvrN2.GetNumberOption)(opts, "minimumIntegerDigits", 1, 21, 1);
    var mnfd = opts.minimumFractionDigits;
    var mxfd = opts.maximumFractionDigits;
    var mnsd = opts.minimumSignificantDigits;
    var mxsd = opts.maximumSignificantDigits;
    internalSlots.minimumIntegerDigits = mnid;
    var roundingPriority = (0, $rTD91.GetOption)(opts, "roundingPriority", "string", [
        "auto",
        "morePrecision",
        "lessPrecision"
    ], "auto");
    var hasSd = mnsd !== undefined || mxsd !== undefined;
    var hasFd = mnfd !== undefined || mxfd !== undefined;
    var needSd = true;
    var needFd = true;
    if (roundingPriority === "auto") {
        needSd = hasSd;
        if (hasSd || !hasFd && notation === "compact") needFd = false;
    }
    if (needSd) {
        if (hasSd) {
            mnsd = (0, $3jLgT.DefaultNumberOption)(mnsd, 1, 21, 1);
            mxsd = (0, $3jLgT.DefaultNumberOption)(mxsd, mnsd, 21, 21);
            internalSlots.minimumSignificantDigits = mnsd;
            internalSlots.maximumSignificantDigits = mxsd;
        } else {
            internalSlots.minimumSignificantDigits = 1;
            internalSlots.maximumSignificantDigits = 21;
        }
    }
    if (needFd) {
        if (hasFd) {
            // @ts-expect-error
            mnfd = (0, $3jLgT.DefaultNumberOption)(mnfd, 0, 20, undefined);
            // @ts-expect-error
            mxfd = (0, $3jLgT.DefaultNumberOption)(mxfd, 0, 20, undefined);
            if (mnfd === undefined) mnfd = Math.min(mnfdDefault, mxfd);
            else if (mxfd === undefined) mxfd = Math.max(mxfdDefault, mnfd);
            else if (mnfd > mxfd) throw new RangeError("Invalid range, ".concat(mnfd, " > ").concat(mxfd));
            internalSlots.minimumFractionDigits = mnfd;
            internalSlots.maximumFractionDigits = mxfd;
        } else {
            internalSlots.minimumFractionDigits = mnfdDefault;
            internalSlots.maximumFractionDigits = mxfdDefault;
        }
    }
    if (needSd || needFd) {
        if (roundingPriority === "morePrecision") internalSlots.roundingType = "morePrecision";
        else if (roundingPriority === "lessPrecision") internalSlots.roundingType = "lessPrecision";
        else if (hasSd) internalSlots.roundingType = "significantDigits";
        else internalSlots.roundingType = "fractionDigits";
    } else {
        internalSlots.roundingType = "morePrecision";
        internalSlots.minimumFractionDigits = 0;
        internalSlots.maximumFractionDigits = 0;
        internalSlots.minimumSignificantDigits = 1;
        internalSlots.maximumSignificantDigits = 2;
    }
}
module.exports.SetNumberFormatDigitOptions = $e6d104cd877dfbfa$var$SetNumberFormatDigitOptions;

});

parcelRegister("2YEFp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatUnitOptions = void 0;

var $rTD91 = parcelRequire("rTD91");

var $atvAh = parcelRequire("atvAh");

var $4EAEx = parcelRequire("4EAEx");
/**
 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
 */ function $22b0baf89b591bdf$var$SetNumberFormatUnitOptions(nf, options, _a) {
    if (options === void 0) options = Object.create(null);
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(nf);
    var style = (0, $rTD91.GetOption)(options, "style", "string", [
        "decimal",
        "percent",
        "currency",
        "unit"
    ], "decimal");
    internalSlots.style = style;
    var currency = (0, $rTD91.GetOption)(options, "currency", "string", undefined, undefined);
    if (currency !== undefined && !(0, $atvAh.IsWellFormedCurrencyCode)(currency)) throw RangeError("Malformed currency code");
    if (style === "currency" && currency === undefined) throw TypeError("currency cannot be undefined");
    var currencyDisplay = (0, $rTD91.GetOption)(options, "currencyDisplay", "string", [
        "code",
        "symbol",
        "narrowSymbol",
        "name"
    ], "symbol");
    var currencySign = (0, $rTD91.GetOption)(options, "currencySign", "string", [
        "standard",
        "accounting"
    ], "standard");
    var unit = (0, $rTD91.GetOption)(options, "unit", "string", undefined, undefined);
    if (unit !== undefined && !(0, $4EAEx.IsWellFormedUnitIdentifier)(unit)) throw RangeError("Invalid unit argument for Intl.NumberFormat()");
    if (style === "unit" && unit === undefined) throw TypeError("unit cannot be undefined");
    var unitDisplay = (0, $rTD91.GetOption)(options, "unitDisplay", "string", [
        "short",
        "narrow",
        "long"
    ], "short");
    if (style === "currency") {
        internalSlots.currency = currency.toUpperCase();
        internalSlots.currencyDisplay = currencyDisplay;
        internalSlots.currencySign = currencySign;
    }
    if (style === "unit") {
        internalSlots.unit = unit;
        internalSlots.unitDisplay = unitDisplay;
    }
}
module.exports.SetNumberFormatUnitOptions = $22b0baf89b591bdf$var$SetNumberFormatUnitOptions;

});


parcelRegister("71hGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionPattern = void 0;

var $jSW1Z = parcelRequire("jSW1Z");
/**
 * https://tc39.es/ecma402/#sec-partitionpattern
 * @param pattern
 */ function $51c65780fdc666e9$var$PartitionPattern(pattern) {
    var result = [];
    var beginIndex = pattern.indexOf("{");
    var endIndex = 0;
    var nextIndex = 0;
    var length = pattern.length;
    while(beginIndex < pattern.length && beginIndex > -1){
        endIndex = pattern.indexOf("}", beginIndex);
        (0, $jSW1Z.invariant)(endIndex > beginIndex, "Invalid pattern ".concat(pattern));
        if (beginIndex > nextIndex) result.push({
            type: "literal",
            value: pattern.substring(nextIndex, beginIndex)
        });
        result.push({
            type: pattern.substring(beginIndex + 1, endIndex),
            value: undefined
        });
        nextIndex = endIndex + 1;
        beginIndex = pattern.indexOf("{", nextIndex);
    }
    if (nextIndex < length) result.push({
        type: "literal",
        value: pattern.substring(nextIndex, length)
    });
    return result;
}
module.exports.PartitionPattern = $51c65780fdc666e9$var$PartitionPattern;

});

parcelRegister("afaf6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SupportedLocales = void 0;

var $dJ73k = parcelRequire("dJ73k");

var $lOKID = parcelRequire("lOKID");

var $rTD91 = parcelRequire("rTD91");
/**
 * https://tc39.es/ecma402/#sec-supportedlocales
 * @param availableLocales
 * @param requestedLocales
 * @param options
 */ function $7753401204cdc83f$var$SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = "best fit";
    if (options !== undefined) {
        options = (0, $lOKID.ToObject)(options);
        matcher = (0, $rTD91.GetOption)(options, "localeMatcher", "string", [
            "lookup",
            "best fit"
        ], "best fit");
    }
    if (matcher === "best fit") return (0, $dJ73k.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
    return (0, $dJ73k.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
}
module.exports.SupportedLocales = $7753401204cdc83f$var$SupportedLocales;

});

parcelRegister("7V4jZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMissingLocaleDataError = void 0;

var $4UZnF = parcelRequire("4UZnF");
var $5c413568f504276f$var$MissingLocaleDataError = /** @class */ function(_super) {
    $4UZnF.__extends(MissingLocaleDataError, _super);
    function MissingLocaleDataError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "MISSING_LOCALE_DATA";
        return _this;
    }
    return MissingLocaleDataError;
}(Error);
function $5c413568f504276f$var$isMissingLocaleDataError(e) {
    return e.type === "MISSING_LOCALE_DATA";
}
module.exports.isMissingLocaleDataError = $5c413568f504276f$var$isMissingLocaleDataError;

});

parcelRegister("KkLWa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hFt3l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangePatternType = void 0;
var $cdcccd52a925d841$var$RangePatternType;
(function(RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})($cdcccd52a925d841$var$RangePatternType || (module.exports.RangePatternType = $cdcccd52a925d841$var$RangePatternType = {}));

});

parcelRegister("2EjUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("moXUL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("XRUya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("k1j0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("1Bl6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = module.exports.formatNumberToParts = module.exports.formatNumber = module.exports.formatRelativeTime = module.exports.formatPlural = module.exports.formatList = module.exports.formatDisplayName = module.exports.formatTimeToParts = module.exports.formatTime = module.exports.formatDateToParts = module.exports.formatDate = module.exports.formatMessage = module.exports.getNamedFormat = module.exports.createFormatters = module.exports.DEFAULT_INTL_CONFIG = module.exports.filterProps = module.exports.createIntlCache = module.exports.defineMessage = module.exports.defineMessages = void 0;

var $4UZnF = parcelRequire("4UZnF");

$4UZnF.__exportStar((parcelRequire("iv9pB")), module.exports);
function $12a99f7d0002b556$var$defineMessages(msgs) {
    return msgs;
}
module.exports.defineMessages = $12a99f7d0002b556$var$defineMessages;
function $12a99f7d0002b556$var$defineMessage(msg) {
    return msg;
}
module.exports.defineMessage = $12a99f7d0002b556$var$defineMessage;

var $kVDLB = parcelRequire("kVDLB");
Object.defineProperty(module.exports, "createIntlCache", {
    enumerable: true,
    get: function() {
        return $kVDLB.createIntlCache;
    }
});
Object.defineProperty(module.exports, "filterProps", {
    enumerable: true,
    get: function() {
        return $kVDLB.filterProps;
    }
});
Object.defineProperty(module.exports, "DEFAULT_INTL_CONFIG", {
    enumerable: true,
    get: function() {
        return $kVDLB.DEFAULT_INTL_CONFIG;
    }
});
Object.defineProperty(module.exports, "createFormatters", {
    enumerable: true,
    get: function() {
        return $kVDLB.createFormatters;
    }
});
Object.defineProperty(module.exports, "getNamedFormat", {
    enumerable: true,
    get: function() {
        return $kVDLB.getNamedFormat;
    }
});

$4UZnF.__exportStar((parcelRequire("3r8Lq")), module.exports);

var $2AWRE = parcelRequire("2AWRE");
Object.defineProperty(module.exports, "formatMessage", {
    enumerable: true,
    get: function() {
        return $2AWRE.formatMessage;
    }
});

var $8Q76r = parcelRequire("8Q76r");
Object.defineProperty(module.exports, "formatDate", {
    enumerable: true,
    get: function() {
        return $8Q76r.formatDate;
    }
});
Object.defineProperty(module.exports, "formatDateToParts", {
    enumerable: true,
    get: function() {
        return $8Q76r.formatDateToParts;
    }
});
Object.defineProperty(module.exports, "formatTime", {
    enumerable: true,
    get: function() {
        return $8Q76r.formatTime;
    }
});
Object.defineProperty(module.exports, "formatTimeToParts", {
    enumerable: true,
    get: function() {
        return $8Q76r.formatTimeToParts;
    }
});

var $ecm3j = parcelRequire("ecm3j");
Object.defineProperty(module.exports, "formatDisplayName", {
    enumerable: true,
    get: function() {
        return $ecm3j.formatDisplayName;
    }
});

var $kBQmV = parcelRequire("kBQmV");
Object.defineProperty(module.exports, "formatList", {
    enumerable: true,
    get: function() {
        return $kBQmV.formatList;
    }
});

var $c4qid = parcelRequire("c4qid");
Object.defineProperty(module.exports, "formatPlural", {
    enumerable: true,
    get: function() {
        return $c4qid.formatPlural;
    }
});

var $j6Rqd = parcelRequire("j6Rqd");
Object.defineProperty(module.exports, "formatRelativeTime", {
    enumerable: true,
    get: function() {
        return $j6Rqd.formatRelativeTime;
    }
});

var $33T8J = parcelRequire("33T8J");
Object.defineProperty(module.exports, "formatNumber", {
    enumerable: true,
    get: function() {
        return $33T8J.formatNumber;
    }
});
Object.defineProperty(module.exports, "formatNumberToParts", {
    enumerable: true,
    get: function() {
        return $33T8J.formatNumberToParts;
    }
});

var $iauDb = parcelRequire("iauDb");
Object.defineProperty(module.exports, "createIntl", {
    enumerable: true,
    get: function() {
        return $iauDb.createIntl;
    }
});

});
parcelRegister("iv9pB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kVDLB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNamedFormat = module.exports.createFormatters = module.exports.createIntlCache = module.exports.DEFAULT_INTL_CONFIG = module.exports.filterProps = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $97fJg = parcelRequire("97fJg");

var $6rma0 = parcelRequire("6rma0");

var $3r8Lq = parcelRequire("3r8Lq");
function $f3c7fa62882cc897$var$filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
module.exports.filterProps = $f3c7fa62882cc897$var$filterProps;
var $f3c7fa62882cc897$var$defaultErrorHandler = function(error) {};
var $f3c7fa62882cc897$var$defaultWarnHandler = function(warning) {};
module.exports.DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $f3c7fa62882cc897$var$defaultErrorHandler,
    onWarn: $f3c7fa62882cc897$var$defaultWarnHandler
};
function $f3c7fa62882cc897$var$createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
module.exports.createIntlCache = $f3c7fa62882cc897$var$createIntlCache;
function $f3c7fa62882cc897$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ function $f3c7fa62882cc897$var$createFormatters(cache) {
    if (cache === void 0) cache = $f3c7fa62882cc897$var$createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $6rma0.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $4UZnF.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.dateTime),
        strategy: $6rma0.strategies.variadic
    });
    var getNumberFormat = (0, $6rma0.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, $4UZnF.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.number),
        strategy: $6rma0.strategies.variadic
    });
    var getPluralRules = (0, $6rma0.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, $4UZnF.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.pluralRules),
        strategy: $6rma0.strategies.variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $6rma0.memoize)(function(message, locales, overrideFormats, opts) {
            return new $97fJg.IntlMessageFormat(message, locales, overrideFormats, $4UZnF.__assign({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.message),
            strategy: $6rma0.strategies.variadic
        }),
        getRelativeTimeFormat: (0, $6rma0.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, $4UZnF.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.relativeTime),
            strategy: $6rma0.strategies.variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $6rma0.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, $4UZnF.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.list),
            strategy: $6rma0.strategies.variadic
        }),
        getDisplayNames: (0, $6rma0.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, $4UZnF.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $f3c7fa62882cc897$var$createFastMemoizeCache(cache.displayNames),
            strategy: $6rma0.strategies.variadic
        })
    };
}
module.exports.createFormatters = $f3c7fa62882cc897$var$createFormatters;
function $f3c7fa62882cc897$var$getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new $3r8Lq.UnsupportedFormatterError("No ".concat(type, " format named: ").concat(name)));
}
module.exports.getNamedFormat = $f3c7fa62882cc897$var$getNamedFormat;

});
parcelRegister("97fJg", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");


$4UZnF.__exportStar((parcelRequire("1p93S")), module.exports);

$4UZnF.__exportStar((parcelRequire("eCbW1")), module.exports);

$4UZnF.__exportStar((parcelRequire("517aS")), module.exports);
module.exports.default = (parcelRequire("eCbW1")).IntlMessageFormat;

});
parcelRegister("eCbW1", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntlMessageFormat = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $jIW5g = parcelRequire("jIW5g");

var $6rma0 = parcelRequire("6rma0");

var $1p93S = parcelRequire("1p93S");
// -- MessageFormat --------------------------------------------------------
function $aa3ddf488c3d10b4$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return $4UZnF.__assign($4UZnF.__assign($4UZnF.__assign({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = $4UZnF.__assign($4UZnF.__assign({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $aa3ddf488c3d10b4$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $aa3ddf488c3d10b4$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, $4UZnF.__assign({}, defaultConfig));
}
function $aa3ddf488c3d10b4$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $aa3ddf488c3d10b4$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $6rma0.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, $4UZnF.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $aa3ddf488c3d10b4$var$createFastMemoizeCache(cache.number),
            strategy: $6rma0.strategies.variadic
        }),
        getDateTimeFormat: (0, $6rma0.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $4UZnF.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $aa3ddf488c3d10b4$var$createFastMemoizeCache(cache.dateTime),
            strategy: $6rma0.strategies.variadic
        }),
        getPluralRules: (0, $6rma0.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, $4UZnF.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $aa3ddf488c3d10b4$var$createFastMemoizeCache(cache.pluralRules),
            strategy: $6rma0.strategies.variadic
        })
    };
}
var $aa3ddf488c3d10b4$var$IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== $1p93S.PART_TYPE.literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $1p93S.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = $4UZnF.__rest(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, $4UZnF.__assign($4UZnF.__assign({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $aa3ddf488c3d10b4$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $aa3ddf488c3d10b4$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = $jIW5g.parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports.IntlMessageFormat = $aa3ddf488c3d10b4$var$IntlMessageFormat;

});
parcelRegister("jIW5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._Parser = module.exports.parse = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $hAiCs = parcelRequire("hAiCs");

var $1Da1k = parcelRequire("1Da1k");

function $e5bf2ea5943a14c5$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, (parcelRequire("eQqmo")).isSelectElement)(el) || (0, (parcelRequire("eQqmo")).isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $e5bf2ea5943a14c5$var$pruneLocation(el.options[k].value);
        }
        else if ((0, (parcelRequire("eQqmo")).isNumberElement)(el) && (0, (parcelRequire("eQqmo")).isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, (parcelRequire("eQqmo")).isDateElement)(el) || (0, (parcelRequire("eQqmo")).isTimeElement)(el)) && (0, (parcelRequire("eQqmo")).isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, (parcelRequire("eQqmo")).isTagElement)(el)) $e5bf2ea5943a14c5$var$pruneLocation(el.children);
    });
}
function $e5bf2ea5943a14c5$var$parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = $4UZnF.__assign({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new $1Da1k.Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError($hAiCs.ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $e5bf2ea5943a14c5$var$pruneLocation(result.val);
    return result.val;
}
module.exports.parse = $e5bf2ea5943a14c5$var$parse;

$4UZnF.__exportStar((parcelRequire("eQqmo")), module.exports);
// only for testing
module.exports._Parser = $1Da1k.Parser;

});
parcelRegister("hAiCs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorKind = void 0;
var $ccd43dd8effda690$var$ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($ccd43dd8effda690$var$ErrorKind || (module.exports.ErrorKind = $ccd43dd8effda690$var$ErrorKind = {}));

});

parcelRegister("1Da1k", function(module, exports) {
"use strict";
var $130134d3ded67d01$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $hAiCs = parcelRequire("hAiCs");

var $eQqmo = parcelRequire("eQqmo");

var $5FfaU = parcelRequire("5FfaU");

var $cjxS0 = parcelRequire("cjxS0");

var $jjGDW = parcelRequire("jjGDW");
var $130134d3ded67d01$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat($5FfaU.SPACE_SEPARATOR_REGEX.source, "*"));
var $130134d3ded67d01$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat($5FfaU.SPACE_SEPARATOR_REGEX.source, "*$"));
function $130134d3ded67d01$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $130134d3ded67d01$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $130134d3ded67d01$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $130134d3ded67d01$var$hasNativeFromEntries = !!Object.fromEntries;
var $130134d3ded67d01$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $130134d3ded67d01$var$hasTrimStart = !!String.prototype.trimStart;
var $130134d3ded67d01$var$hasTrimEnd = !!String.prototype.trimEnd;
var $130134d3ded67d01$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $130134d3ded67d01$var$isSafeInteger = $130134d3ded67d01$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $130134d3ded67d01$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $130134d3ded67d01$var$re = $130134d3ded67d01$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $130134d3ded67d01$var$REGEX_SUPPORTS_U_AND_Y = (($130134d3ded67d01$var$_a = $130134d3ded67d01$var$re.exec("a")) === null || $130134d3ded67d01$var$_a === void 0 ? void 0 : $130134d3ded67d01$var$_a[0]) === "a";
} catch (_) {
    $130134d3ded67d01$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $130134d3ded67d01$var$startsWith = $130134d3ded67d01$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $130134d3ded67d01$var$fromCodePoint = $130134d3ded67d01$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $130134d3ded67d01$var$fromEntries = // native
$130134d3ded67d01$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $130134d3ded67d01$var$codePointAt = $130134d3ded67d01$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $130134d3ded67d01$var$trimStart = $130134d3ded67d01$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($130134d3ded67d01$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $130134d3ded67d01$var$trimEnd = $130134d3ded67d01$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($130134d3ded67d01$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $130134d3ded67d01$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $130134d3ded67d01$var$matchIdentifierAtIndex;
if ($130134d3ded67d01$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $130134d3ded67d01$var$IDENTIFIER_PREFIX_RE_1 = $130134d3ded67d01$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $130134d3ded67d01$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $130134d3ded67d01$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $130134d3ded67d01$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$130134d3ded67d01$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $130134d3ded67d01$var$codePointAt(s, index);
        if (c === undefined || $130134d3ded67d01$var$_isWhiteSpace(c) || $130134d3ded67d01$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $130134d3ded67d01$var$fromCodePoint.apply(void 0, match);
};
var $130134d3ded67d01$var$Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: $eQqmo.TYPE.pound,
                    location: $130134d3ded67d01$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error($hAiCs.ErrorKind.UNMATCHED_CLOSING_TAG, $130134d3ded67d01$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $130134d3ded67d01$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: $eQqmo.TYPE.literal,
                value: "<".concat(tagName, "/>"),
                location: $130134d3ded67d01$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$130134d3ded67d01$var$_isAlpha(this.char())) return this.error($hAiCs.ErrorKind.INVALID_TAG, $130134d3ded67d01$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error($hAiCs.ErrorKind.UNMATCHED_CLOSING_TAG, $130134d3ded67d01$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error($hAiCs.ErrorKind.INVALID_TAG, $130134d3ded67d01$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: $eQqmo.TYPE.tag,
                        value: tagName,
                        children: children,
                        location: $130134d3ded67d01$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error($hAiCs.ErrorKind.UNCLOSED_TAG, $130134d3ded67d01$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error($hAiCs.ErrorKind.INVALID_TAG, $130134d3ded67d01$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $130134d3ded67d01$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $130134d3ded67d01$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: $eQqmo.TYPE.literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$130134d3ded67d01$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $130134d3ded67d01$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $130134d3ded67d01$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error($hAiCs.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error($hAiCs.ErrorKind.EMPTY_ARGUMENT, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error($hAiCs.ErrorKind.MALFORMED_ARGUMENT, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error($hAiCs.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: $eQqmo.TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error($hAiCs.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error($hAiCs.ErrorKind.MALFORMED_ARGUMENT, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $130134d3ded67d01$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $130134d3ded67d01$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error($hAiCs.ErrorKind.EXPECT_ARGUMENT_TYPE, $130134d3ded67d01$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $130134d3ded67d01$var$trimEnd(result.val);
                    if (style.length === 0) return this.error($hAiCs.ErrorKind.EXPECT_ARGUMENT_STYLE, $130134d3ded67d01$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $130134d3ded67d01$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $130134d3ded67d01$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $130134d3ded67d01$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: $eQqmo.TYPE.number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error($hAiCs.ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $jjGDW.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: $eQqmo.SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $cjxS0.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? $eQqmo.TYPE.date : $eQqmo.TYPE.time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? $eQqmo.TYPE.number : argType === "date" ? $eQqmo.TYPE.date : $eQqmo.TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error($hAiCs.ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, $130134d3ded67d01$var$createLocation(typeEndPosition_1, $4UZnF.__assign({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error($hAiCs.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $130134d3ded67d01$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger($hAiCs.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $hAiCs.ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: $eQqmo.TYPE.select,
                        value: value,
                        options: $130134d3ded67d01$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: $eQqmo.TYPE.plural,
                        value: value,
                        options: $130134d3ded67d01$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error($hAiCs.ErrorKind.INVALID_ARGUMENT_TYPE, $130134d3ded67d01$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error($hAiCs.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error($hAiCs.ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $130134d3ded67d01$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $cjxS0.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error($hAiCs.ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: $eQqmo.SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $cjxS0.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger($hAiCs.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $hAiCs.ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $130134d3ded67d01$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? $hAiCs.ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR : $hAiCs.ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? $hAiCs.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : $hAiCs.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $130134d3ded67d01$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $130134d3ded67d01$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? $hAiCs.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR : $hAiCs.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $130134d3ded67d01$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error($hAiCs.ErrorKind.MISSING_OTHER_CLAUSE, $130134d3ded67d01$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $130134d3ded67d01$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$130134d3ded67d01$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $130134d3ded67d01$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($130134d3ded67d01$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $130134d3ded67d01$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
module.exports.Parser = $130134d3ded67d01$var$Parser;
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $130134d3ded67d01$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $130134d3ded67d01$var$_isAlphaOrSlash(codepoint) {
    return $130134d3ded67d01$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $130134d3ded67d01$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $130134d3ded67d01$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $130134d3ded67d01$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("eQqmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNumberElement = module.exports.createLiteralElement = module.exports.isDateTimeSkeleton = module.exports.isNumberSkeleton = module.exports.isTagElement = module.exports.isPoundElement = module.exports.isPluralElement = module.exports.isSelectElement = module.exports.isTimeElement = module.exports.isDateElement = module.exports.isNumberElement = module.exports.isArgumentElement = module.exports.isLiteralElement = module.exports.SKELETON_TYPE = module.exports.TYPE = void 0;
var $acea5e936a624067$var$TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($acea5e936a624067$var$TYPE || (module.exports.TYPE = $acea5e936a624067$var$TYPE = {}));
var $acea5e936a624067$var$SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($acea5e936a624067$var$SKELETON_TYPE || (module.exports.SKELETON_TYPE = $acea5e936a624067$var$SKELETON_TYPE = {}));
/**
 * Type Guards
 */ function $acea5e936a624067$var$isLiteralElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.literal;
}
module.exports.isLiteralElement = $acea5e936a624067$var$isLiteralElement;
function $acea5e936a624067$var$isArgumentElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.argument;
}
module.exports.isArgumentElement = $acea5e936a624067$var$isArgumentElement;
function $acea5e936a624067$var$isNumberElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.number;
}
module.exports.isNumberElement = $acea5e936a624067$var$isNumberElement;
function $acea5e936a624067$var$isDateElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.date;
}
module.exports.isDateElement = $acea5e936a624067$var$isDateElement;
function $acea5e936a624067$var$isTimeElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.time;
}
module.exports.isTimeElement = $acea5e936a624067$var$isTimeElement;
function $acea5e936a624067$var$isSelectElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.select;
}
module.exports.isSelectElement = $acea5e936a624067$var$isSelectElement;
function $acea5e936a624067$var$isPluralElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.plural;
}
module.exports.isPluralElement = $acea5e936a624067$var$isPluralElement;
function $acea5e936a624067$var$isPoundElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.pound;
}
module.exports.isPoundElement = $acea5e936a624067$var$isPoundElement;
function $acea5e936a624067$var$isTagElement(el) {
    return el.type === $acea5e936a624067$var$TYPE.tag;
}
module.exports.isTagElement = $acea5e936a624067$var$isTagElement;
function $acea5e936a624067$var$isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $acea5e936a624067$var$SKELETON_TYPE.number);
}
module.exports.isNumberSkeleton = $acea5e936a624067$var$isNumberSkeleton;
function $acea5e936a624067$var$isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $acea5e936a624067$var$SKELETON_TYPE.dateTime);
}
module.exports.isDateTimeSkeleton = $acea5e936a624067$var$isDateTimeSkeleton;
function $acea5e936a624067$var$createLiteralElement(value) {
    return {
        type: $acea5e936a624067$var$TYPE.literal,
        value: value
    };
}
module.exports.createLiteralElement = $acea5e936a624067$var$createLiteralElement;
function $acea5e936a624067$var$createNumberElement(value, style) {
    return {
        type: $acea5e936a624067$var$TYPE.number,
        value: value,
        style: style
    };
}
module.exports.createNumberElement = $acea5e936a624067$var$createNumberElement;

});

parcelRegister("5FfaU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = module.exports.SPACE_SEPARATOR_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("cjxS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");

$4UZnF.__exportStar((parcelRequire("blqbw")), module.exports);

$4UZnF.__exportStar((parcelRequire("gkyNT")), module.exports);

});
parcelRegister("blqbw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDateTimeSkeleton = void 0;
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $8425f79e3e300491$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ function $8425f79e3e300491$var$parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace($8425f79e3e300491$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}
module.exports.parseDateTimeSkeleton = $8425f79e3e300491$var$parseDateTimeSkeleton;

});

parcelRegister("gkyNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNumberSkeleton = module.exports.parseNumberSkeletonFromString = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $jIFA4 = parcelRequire("jIFA4");
function $be3982e87e55614a$var$parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split($jIFA4.WHITE_SPACE_REGEX).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
module.exports.parseNumberSkeletonFromString = $be3982e87e55614a$var$parseNumberSkeletonFromString;
function $be3982e87e55614a$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $be3982e87e55614a$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $be3982e87e55614a$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $be3982e87e55614a$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $be3982e87e55614a$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $be3982e87e55614a$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($be3982e87e55614a$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $be3982e87e55614a$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $be3982e87e55614a$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$be3982e87e55614a$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $be3982e87e55614a$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $be3982e87e55614a$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ function $be3982e87e55614a$var$parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $be3982e87e55614a$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = $4UZnF.__assign($4UZnF.__assign($4UZnF.__assign({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return $4UZnF.__assign($4UZnF.__assign({}, all), $be3982e87e55614a$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = $4UZnF.__assign($4UZnF.__assign($4UZnF.__assign({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return $4UZnF.__assign($4UZnF.__assign({}, all), $be3982e87e55614a$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($be3982e87e55614a$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($be3982e87e55614a$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($be3982e87e55614a$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($be3982e87e55614a$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = $4UZnF.__assign($4UZnF.__assign({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = $4UZnF.__assign($4UZnF.__assign({}, result), $be3982e87e55614a$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($be3982e87e55614a$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = $4UZnF.__assign($4UZnF.__assign({}, result), $be3982e87e55614a$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $be3982e87e55614a$var$parseSign(token.stem);
        if (signOpts) result = $4UZnF.__assign($4UZnF.__assign({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $be3982e87e55614a$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = $4UZnF.__assign($4UZnF.__assign({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}
module.exports.parseNumberSkeleton = $be3982e87e55614a$var$parseNumberSkeleton;

});
parcelRegister("jIFA4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("jjGDW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBestPattern = void 0;

var $cwrHR = parcelRequire("cwrHR");
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ function $e100debd26f82cb1$var$getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $e100debd26f82cb1$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
module.exports.getBestPattern = $e100debd26f82cb1$var$getBestPattern;
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $e100debd26f82cb1$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = $cwrHR.timeData[regionTag || ""] || $cwrHR.timeData[languageTag || ""] || $cwrHR.timeData["".concat(languageTag, "-001")] || $cwrHR.timeData["001"];
    return hourCycles[0];
}

});
parcelRegister("cwrHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeData = void 0;
// @generated from time-data-gen.ts
// prettier-ignore  
module.exports.timeData = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("6rma0", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $4b0674458aa16a51$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $4b0674458aa16a51$export$c5491a8691a23b9e; });
//
// Main
//
function $4b0674458aa16a51$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $4b0674458aa16a51$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $4b0674458aa16a51$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $4b0674458aa16a51$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $4b0674458aa16a51$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $4b0674458aa16a51$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $4b0674458aa16a51$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4b0674458aa16a51$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4b0674458aa16a51$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $4b0674458aa16a51$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $4b0674458aa16a51$var$monadic : $4b0674458aa16a51$var$variadic;
    return $4b0674458aa16a51$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $4b0674458aa16a51$var$strategyVariadic(fn, options) {
    return $4b0674458aa16a51$var$assemble(fn, this, $4b0674458aa16a51$var$variadic, options.cache.create(), options.serializer);
}
function $4b0674458aa16a51$var$strategyMonadic(fn, options) {
    return $4b0674458aa16a51$var$assemble(fn, this, $4b0674458aa16a51$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $4b0674458aa16a51$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $4b0674458aa16a51$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$4b0674458aa16a51$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$4b0674458aa16a51$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $4b0674458aa16a51$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $4b0674458aa16a51$var$ObjectWithoutPrototypeCache();
    }
};
var $4b0674458aa16a51$export$c5491a8691a23b9e = {
    variadic: $4b0674458aa16a51$var$strategyVariadic,
    monadic: $4b0674458aa16a51$var$strategyMonadic
};

});

parcelRegister("1p93S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatToParts = module.exports.isFormatXMLElementFn = module.exports.PART_TYPE = void 0;

var $jIW5g = parcelRequire("jIW5g");

var $517aS = parcelRequire("517aS");
var $105f27b1d8c71bbe$var$PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($105f27b1d8c71bbe$var$PART_TYPE || (module.exports.PART_TYPE = $105f27b1d8c71bbe$var$PART_TYPE = {}));
function $105f27b1d8c71bbe$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $105f27b1d8c71bbe$var$PART_TYPE.literal || part.type !== $105f27b1d8c71bbe$var$PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $105f27b1d8c71bbe$var$isFormatXMLElementFn(el) {
    return typeof el === "function";
}
module.exports.isFormatXMLElementFn = $105f27b1d8c71bbe$var$isFormatXMLElementFn;
// TODO(skeleton): add skeleton support
function $105f27b1d8c71bbe$var$formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jIW5g.isLiteralElement)(els[0])) return [
        {
            type: $105f27b1d8c71bbe$var$PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jIW5g.isLiteralElement)(el)) {
            result.push({
                type: $105f27b1d8c71bbe$var$PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jIW5g.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $105f27b1d8c71bbe$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new $517aS.MissingValueError(varName, originalMessage);
        var value = values[varName];
        if ((0, $jIW5g.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $105f27b1d8c71bbe$var$PART_TYPE.literal : $105f27b1d8c71bbe$var$PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jIW5g.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $jIW5g.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $105f27b1d8c71bbe$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jIW5g.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $jIW5g.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $105f27b1d8c71bbe$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jIW5g.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $jIW5g.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $105f27b1d8c71bbe$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jIW5g.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$105f27b1d8c71bbe$var$isFormatXMLElementFn(formatFn)) throw new $517aS.InvalidValueTypeError(value_1, "function", originalMessage);
            var parts = $105f27b1d8c71bbe$var$formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $105f27b1d8c71bbe$var$PART_TYPE.literal : $105f27b1d8c71bbe$var$PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, $jIW5g.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new $517aS.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $105f27b1d8c71bbe$var$formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jIW5g.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new $517aS.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $517aS.ErrorCode.MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new $517aS.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $105f27b1d8c71bbe$var$formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $105f27b1d8c71bbe$var$mergeLiteral(result);
}
module.exports.formatToParts = $105f27b1d8c71bbe$var$formatToParts;

});
parcelRegister("517aS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingValueError = module.exports.InvalidValueTypeError = module.exports.InvalidValueError = module.exports.FormatError = module.exports.ErrorCode = void 0;

var $4UZnF = parcelRequire("4UZnF");
var $3a729c70b70fb21b$var$ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($3a729c70b70fb21b$var$ErrorCode || (module.exports.ErrorCode = $3a729c70b70fb21b$var$ErrorCode = {}));
var $3a729c70b70fb21b$var$FormatError = /** @class */ function(_super) {
    $4UZnF.__extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
module.exports.FormatError = $3a729c70b70fb21b$var$FormatError;
var $3a729c70b70fb21b$var$InvalidValueError = /** @class */ function(_super) {
    $4UZnF.__extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $3a729c70b70fb21b$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($3a729c70b70fb21b$var$FormatError);
module.exports.InvalidValueError = $3a729c70b70fb21b$var$InvalidValueError;
var $3a729c70b70fb21b$var$InvalidValueTypeError = /** @class */ function(_super) {
    $4UZnF.__extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $3a729c70b70fb21b$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($3a729c70b70fb21b$var$FormatError);
module.exports.InvalidValueTypeError = $3a729c70b70fb21b$var$InvalidValueTypeError;
var $3a729c70b70fb21b$var$MissingValueError = /** @class */ function(_super) {
    $4UZnF.__extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $3a729c70b70fb21b$var$ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($3a729c70b70fb21b$var$FormatError);
module.exports.MissingValueError = $3a729c70b70fb21b$var$MissingValueError;

});




parcelRegister("3r8Lq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingTranslationError = module.exports.MessageFormatError = module.exports.IntlFormatError = module.exports.MissingDataError = module.exports.InvalidConfigError = module.exports.UnsupportedFormatterError = module.exports.IntlError = module.exports.IntlErrorCode = void 0;

var $4UZnF = parcelRequire("4UZnF");
var $280ab10f500c8f81$var$IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($280ab10f500c8f81$var$IntlErrorCode || (module.exports.IntlErrorCode = $280ab10f500c8f81$var$IntlErrorCode = {}));
var $280ab10f500c8f81$var$IntlError = /** @class */ function(_super) {
    $4UZnF.__extends(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
module.exports.IntlError = $280ab10f500c8f81$var$IntlError;
var $280ab10f500c8f81$var$UnsupportedFormatterError = /** @class */ function(_super) {
    $4UZnF.__extends(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $280ab10f500c8f81$var$IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($280ab10f500c8f81$var$IntlError);
module.exports.UnsupportedFormatterError = $280ab10f500c8f81$var$UnsupportedFormatterError;
var $280ab10f500c8f81$var$InvalidConfigError = /** @class */ function(_super) {
    $4UZnF.__extends(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $280ab10f500c8f81$var$IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($280ab10f500c8f81$var$IntlError);
module.exports.InvalidConfigError = $280ab10f500c8f81$var$InvalidConfigError;
var $280ab10f500c8f81$var$MissingDataError = /** @class */ function(_super) {
    $4UZnF.__extends(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $280ab10f500c8f81$var$IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($280ab10f500c8f81$var$IntlError);
module.exports.MissingDataError = $280ab10f500c8f81$var$MissingDataError;
var $280ab10f500c8f81$var$IntlFormatError = /** @class */ function(_super) {
    $4UZnF.__extends(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $280ab10f500c8f81$var$IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($280ab10f500c8f81$var$IntlError);
module.exports.IntlFormatError = $280ab10f500c8f81$var$IntlFormatError;
var $280ab10f500c8f81$var$MessageFormatError = /** @class */ function(_super) {
    $4UZnF.__extends(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($280ab10f500c8f81$var$IntlFormatError);
module.exports.MessageFormatError = $280ab10f500c8f81$var$MessageFormatError;
var $280ab10f500c8f81$var$MissingTranslationError = /** @class */ function(_super) {
    $4UZnF.__extends(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $280ab10f500c8f81$var$IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($280ab10f500c8f81$var$IntlError);
module.exports.MissingTranslationError = $280ab10f500c8f81$var$MissingTranslationError;

});


parcelRegister("2AWRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatMessage = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $ekYZ8 = parcelRequire("ekYZ8");

var $97fJg = parcelRequire("97fJg");

var $3r8Lq = parcelRequire("3r8Lq");

var $jIW5g = parcelRequire("jIW5g");
function $1e3c9accc6671773$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = $4UZnF.__assign({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $1e3c9accc6671773$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys($4UZnF.__assign($4UZnF.__assign({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = $4UZnF.__assign($4UZnF.__assign({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $1e3c9accc6671773$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = $97fJg.IntlMessageFormat.formats;
    return $4UZnF.__assign($4UZnF.__assign($4UZnF.__assign({}, mfFormats), f1), {
        date: $1e3c9accc6671773$var$deepMergeOptions($1e3c9accc6671773$var$setTimeZoneInOptions(mfFormats.date, timeZone), $1e3c9accc6671773$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $1e3c9accc6671773$var$deepMergeOptions($1e3c9accc6671773$var$setTimeZoneInOptions(mfFormats.time, timeZone), $1e3c9accc6671773$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $1e3c9accc6671773$var$formatMessage = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $ekYZ8.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === $jIW5g.TYPE.literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = $4UZnF.__assign($4UZnF.__assign({}, defaultRichTextElements), values || {});
    formats = $1e3c9accc6671773$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $1e3c9accc6671773$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new $3r8Lq.MissingTranslationError(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new $3r8Lq.MessageFormatError('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, $4UZnF.__assign({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new $3r8Lq.MessageFormatError('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new $3r8Lq.MessageFormatError('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};
module.exports.formatMessage = $1e3c9accc6671773$var$formatMessage;

});

parcelRegister("8Q76r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatTimeToParts = module.exports.formatDateToParts = module.exports.formatDateTimeRange = module.exports.formatTime = module.exports.formatDate = module.exports.getFormatter = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $kVDLB = parcelRequire("kVDLB");

var $3r8Lq = parcelRequire("3r8Lq");
var $66f8b086ed148306$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $66f8b086ed148306$var$getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = $4UZnF.__assign($4UZnF.__assign({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $kVDLB.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $kVDLB.filterProps)(options, $66f8b086ed148306$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = $4UZnF.__assign($4UZnF.__assign({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
module.exports.getFormatter = $66f8b086ed148306$var$getFormatter;
function $66f8b086ed148306$var$formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $66f8b086ed148306$var$getFormatter(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting date.", config.locale, e));
    }
    return String(date);
}
module.exports.formatDate = $66f8b086ed148306$var$formatDate;
function $66f8b086ed148306$var$formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $66f8b086ed148306$var$getFormatter(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting time.", config.locale, e));
    }
    return String(date);
}
module.exports.formatTime = $66f8b086ed148306$var$formatTime;
function $66f8b086ed148306$var$formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $kVDLB.filterProps)(options, $66f8b086ed148306$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new $3r8Lq.IntlFormatError("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
module.exports.formatDateTimeRange = $66f8b086ed148306$var$formatDateTimeRange;
function $66f8b086ed148306$var$formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $66f8b086ed148306$var$getFormatter(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting date.", config.locale, e));
    }
    return [];
}
module.exports.formatDateToParts = $66f8b086ed148306$var$formatDateToParts;
function $66f8b086ed148306$var$formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $66f8b086ed148306$var$getFormatter(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting time.", config.locale, e));
    }
    return [];
}
module.exports.formatTimeToParts = $66f8b086ed148306$var$formatTimeToParts;

});

parcelRegister("ecm3j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDisplayName = void 0;

var $kVDLB = parcelRequire("kVDLB");

var $97fJg = parcelRequire("97fJg");

var $3r8Lq = parcelRequire("3r8Lq");
var $a5634ad31a0888f8$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $a5634ad31a0888f8$var$formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new $97fJg.FormatError('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', $97fJg.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $kVDLB.filterProps)(options, $a5634ad31a0888f8$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new $3r8Lq.IntlFormatError("Error formatting display name.", locale, e));
    }
}
module.exports.formatDisplayName = $a5634ad31a0888f8$var$formatDisplayName;

});

parcelRegister("kBQmV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatListToParts = module.exports.formatList = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $kVDLB = parcelRequire("kVDLB");

var $97fJg = parcelRequire("97fJg");

var $3r8Lq = parcelRequire("3r8Lq");
var $f00fe2af11bb267d$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $f00fe2af11bb267d$var$now = Date.now();
function $f00fe2af11bb267d$var$generateToken(i) {
    return "".concat($f00fe2af11bb267d$var$now, "_").concat(i, "_").concat($f00fe2af11bb267d$var$now);
}
function $f00fe2af11bb267d$var$formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $f00fe2af11bb267d$var$formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
module.exports.formatList = $f00fe2af11bb267d$var$formatList;
function $f00fe2af11bb267d$var$formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new $97fJg.FormatError('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', $97fJg.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $kVDLB.filterProps)(options, $f00fe2af11bb267d$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $f00fe2af11bb267d$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : $4UZnF.__assign($4UZnF.__assign({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new $3r8Lq.IntlFormatError("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}
module.exports.formatListToParts = $f00fe2af11bb267d$var$formatListToParts;

});

parcelRegister("c4qid", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatPlural = void 0;

var $kVDLB = parcelRequire("kVDLB");

var $3r8Lq = parcelRequire("3r8Lq");

var $97fJg = parcelRequire("97fJg");
var $8c9a40f65033d5a0$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $8c9a40f65033d5a0$var$formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new $97fJg.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $97fJg.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $kVDLB.filterProps)(options, $8c9a40f65033d5a0$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new $3r8Lq.IntlFormatError("Error formatting plural.", locale, e));
    }
    return "other";
}
module.exports.formatPlural = $8c9a40f65033d5a0$var$formatPlural;

});

parcelRegister("j6Rqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatRelativeTime = void 0;

var $kVDLB = parcelRequire("kVDLB");

var $97fJg = parcelRequire("97fJg");

var $3r8Lq = parcelRequire("3r8Lq");
var $de98044ef650905e$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $de98044ef650905e$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $kVDLB.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $kVDLB.filterProps)(options, $de98044ef650905e$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $de98044ef650905e$var$formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new $97fJg.FormatError('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', $97fJg.ErrorCode.MISSING_INTL_API));
    try {
        return $de98044ef650905e$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}
module.exports.formatRelativeTime = $de98044ef650905e$var$formatRelativeTime;

});

parcelRegister("33T8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNumberToParts = module.exports.formatNumber = module.exports.getFormatter = void 0;

var $kVDLB = parcelRequire("kVDLB");

var $3r8Lq = parcelRequire("3r8Lq");
var $23ac6c8a471a4ffd$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $23ac6c8a471a4ffd$var$getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $kVDLB.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $kVDLB.filterProps)(options, $23ac6c8a471a4ffd$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
module.exports.getFormatter = $23ac6c8a471a4ffd$var$getFormatter;
function $23ac6c8a471a4ffd$var$formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $23ac6c8a471a4ffd$var$getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting number.", config.locale, e));
    }
    return String(value);
}
module.exports.formatNumber = $23ac6c8a471a4ffd$var$formatNumber;
function $23ac6c8a471a4ffd$var$formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $23ac6c8a471a4ffd$var$getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new $3r8Lq.IntlFormatError("Error formatting number.", config.locale, e));
    }
    return [];
}
module.exports.formatNumberToParts = $23ac6c8a471a4ffd$var$formatNumberToParts;

});

parcelRegister("iauDb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $kVDLB = parcelRequire("kVDLB");

var $3r8Lq = parcelRequire("3r8Lq");

var $33T8J = parcelRequire("33T8J");

var $j6Rqd = parcelRequire("j6Rqd");

var $8Q76r = parcelRequire("8Q76r");

var $c4qid = parcelRequire("c4qid");

var $2AWRE = parcelRequire("2AWRE");

var $kBQmV = parcelRequire("kBQmV");

var $ecm3j = parcelRequire("ecm3j");
function $d3a0ebd4b2f4f1fd$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $d3a0ebd4b2f4f1fd$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $d3a0ebd4b2f4f1fd$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ function $d3a0ebd4b2f4f1fd$var$createIntl(config, cache) {
    var formatters = (0, $kVDLB.createFormatters)(cache);
    var resolvedConfig = $4UZnF.__assign($4UZnF.__assign({}, $kVDLB.DEFAULT_INTL_CONFIG), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new $3r8Lq.InvalidConfigError('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new $3r8Lq.MissingDataError('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new $3r8Lq.MissingDataError('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $d3a0ebd4b2f4f1fd$var$verifyConfigMessages(resolvedConfig);
    return $4UZnF.__assign($4UZnF.__assign({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: $33T8J.formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: $33T8J.formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: $j6Rqd.formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: $8Q76r.formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: $8Q76r.formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: $8Q76r.formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: $8Q76r.formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: $8Q76r.formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: $c4qid.formatPlural.bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: $2AWRE.formatMessage.bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: $2AWRE.formatMessage.bind(null, resolvedConfig, formatters),
        formatList: $kBQmV.formatList.bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: $kBQmV.formatListToParts.bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: $ecm3j.formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}
module.exports.createIntl = $d3a0ebd4b2f4f1fd$var$createIntl;

});





parcelRegister("dPr95", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $1Bl6Z = parcelRequire("1Bl6Z");

var $a115184d0b3a088d$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $celCa = parcelRequire("celCa");

var $jri4r = parcelRequire("jri4r");

var $97fJg = parcelRequire("97fJg");
function $a115184d0b3a088d$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $a115184d0b3a088d$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $97fJg.isFormatXMLElementFn)(v) ? (0, $celCa.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $a115184d0b3a088d$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $a115184d0b3a088d$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = $1Bl6Z.formatMessage.apply(void 0, $4UZnF.__spreadArray([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $a115184d0b3a088d$var$React.Children.toArray(chunks);
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ var $a115184d0b3a088d$var$createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = $4UZnF.__rest(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $a115184d0b3a088d$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $1Bl6Z.createIntl)($4UZnF.__assign($4UZnF.__assign($4UZnF.__assign({}, $celCa.DEFAULT_INTL_CONFIG), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return $4UZnF.__assign($4UZnF.__assign({}, coreIntl), {
        formatMessage: $a115184d0b3a088d$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $a115184d0b3a088d$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
module.exports.createIntl = $a115184d0b3a088d$var$createIntl;
var $a115184d0b3a088d$var$IntlProvider = /** @class */ function(_super) {
    $4UZnF.__extends(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $1Bl6Z.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, module.exports.createIntl)($a115184d0b3a088d$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $a115184d0b3a088d$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $a115184d0b3a088d$var$processIntlConfig(props);
        if (!(0, $celCa.shallowEqual)(prevConfig, config)) return {
            intl: (0, module.exports.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $celCa.invariantIntlContext)(this.state.intl);
        return $a115184d0b3a088d$var$React.createElement($jri4r.Provider, {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = $celCa.DEFAULT_INTL_CONFIG;
    return IntlProvider;
}($a115184d0b3a088d$var$React.PureComponent);
module.exports.default = $a115184d0b3a088d$var$IntlProvider;

});

parcelRegister("d86l4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $98f0f07f2252a3fc$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $ekYZ8 = parcelRequire("ekYZ8");

var $98f0f07f2252a3fc$var$useIntl_1 = $4UZnF.__importDefault((parcelRequire("4opbb")));
var $98f0f07f2252a3fc$var$MINUTE = 60;
var $98f0f07f2252a3fc$var$HOUR = 3600;
var $98f0f07f2252a3fc$var$DAY = 86400;
function $98f0f07f2252a3fc$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $98f0f07f2252a3fc$var$MINUTE) return "second";
    if (absValue < $98f0f07f2252a3fc$var$HOUR) return "minute";
    if (absValue < $98f0f07f2252a3fc$var$DAY) return "hour";
    return "day";
}
function $98f0f07f2252a3fc$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $98f0f07f2252a3fc$var$MINUTE;
        case "hour":
            return $98f0f07f2252a3fc$var$HOUR;
        default:
            return $98f0f07f2252a3fc$var$DAY;
    }
}
function $98f0f07f2252a3fc$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $98f0f07f2252a3fc$var$MINUTE;
        default:
            return value * $98f0f07f2252a3fc$var$HOUR;
    }
}
var $98f0f07f2252a3fc$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $98f0f07f2252a3fc$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $98f0f07f2252a3fc$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $98f0f07f2252a3fc$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $98f0f07f2252a3fc$var$useIntl_1.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = $4UZnF.__rest(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $98f0f07f2252a3fc$var$React.createElement(Text, null, formattedRelativeTime);
    return $98f0f07f2252a3fc$var$React.createElement($98f0f07f2252a3fc$var$React.Fragment, null, formattedRelativeTime);
};
var $98f0f07f2252a3fc$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = $4UZnF.__rest(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $ekYZ8.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $98f0f07f2252a3fc$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $98f0f07f2252a3fc$var$React.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $98f0f07f2252a3fc$var$React.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $98f0f07f2252a3fc$var$React.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($98f0f07f2252a3fc$var$canIncrement(unit) ? $98f0f07f2252a3fc$var$valueToSeconds(value, unit) : 0);
    }
    $98f0f07f2252a3fc$var$React.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$98f0f07f2252a3fc$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $98f0f07f2252a3fc$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $98f0f07f2252a3fc$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($98f0f07f2252a3fc$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $98f0f07f2252a3fc$var$selectUnit(currentValueInSeconds);
        var unitDuration = $98f0f07f2252a3fc$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $98f0f07f2252a3fc$var$React.createElement($98f0f07f2252a3fc$var$SimpleFormattedRelativeTime, $4UZnF.__assign({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$98f0f07f2252a3fc$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$98f0f07f2252a3fc$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
module.exports.default = $98f0f07f2252a3fc$var$FormattedRelativeTime;

});

parcelRegister("bUUY0", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");

var $8ad11d165cc82f57$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $8ad11d165cc82f57$var$useIntl_1 = $4UZnF.__importDefault((parcelRequire("4opbb")));
var $8ad11d165cc82f57$var$FormattedPlural = function(props) {
    var _a = (0, $8ad11d165cc82f57$var$useIntl_1.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $8ad11d165cc82f57$var$React.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$8ad11d165cc82f57$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$8ad11d165cc82f57$var$FormattedPlural.displayName = "FormattedPlural";
module.exports.default = $8ad11d165cc82f57$var$FormattedPlural;

});

parcelRegister("9eRn6", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");

var $6b9ed25e570882d1$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $6b9ed25e570882d1$var$useIntl_1 = $4UZnF.__importDefault((parcelRequire("4opbb")));

var $celCa = parcelRequire("celCa");
function $6b9ed25e570882d1$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = $4UZnF.__rest(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = $4UZnF.__rest(nextProps, [
        "values"
    ]);
    return (0, $celCa.shallowEqual)(nextValues, values) && (0, $celCa.shallowEqual)(otherProps, nextOtherProps);
}
function $6b9ed25e570882d1$var$FormattedMessage(props) {
    var intl = (0, $6b9ed25e570882d1$var$useIntl_1.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $6b9ed25e570882d1$var$React.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $6b9ed25e570882d1$var$React.createElement(Component, null, $6b9ed25e570882d1$var$React.Children.toArray(nodes));
    return $6b9ed25e570882d1$var$React.createElement($6b9ed25e570882d1$var$React.Fragment, null, nodes);
}
$6b9ed25e570882d1$var$FormattedMessage.displayName = "FormattedMessage";
var $6b9ed25e570882d1$var$MemoizedFormattedMessage = $6b9ed25e570882d1$var$React.memo($6b9ed25e570882d1$var$FormattedMessage, $6b9ed25e570882d1$var$areEqual);
$6b9ed25e570882d1$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
module.exports.default = $6b9ed25e570882d1$var$MemoizedFormattedMessage;

});

parcelRegister("iUOSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UZnF = parcelRequire("4UZnF");

var $dc54ed590f5ce8fc$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $dc54ed590f5ce8fc$var$useIntl_1 = $4UZnF.__importDefault((parcelRequire("4opbb")));
var $dc54ed590f5ce8fc$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $dc54ed590f5ce8fc$var$useIntl_1.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = $4UZnF.__rest(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $dc54ed590f5ce8fc$var$React.Fragment;
    return $dc54ed590f5ce8fc$var$React.createElement(Text, null, formattedValue);
};
$dc54ed590f5ce8fc$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
module.exports.default = $dc54ed590f5ce8fc$var$FormattedDateTimeRange;

});

parcelRegister("5pzCu", function(module, exports) {

$parcel$export(module.exports, "isInteger", function () { return isInteger; });
$parcel$export(module.exports, "Formik", function () { return Formik; });

var $80Td8 = parcelRequire("80Td8");

var $l5A6B = parcelRequire("l5A6B");

var $2hDQc = parcelRequire("2hDQc");

var $8xxO0 = parcelRequire("8xxO0");

var $3JyNw = parcelRequire("3JyNw");

var $gEJ4F = parcelRequire("gEJ4F");

var $lHNrF = parcelRequire("lHNrF");

var $8FL51 = parcelRequire("8FL51");

var $lMELy = parcelRequire("lMELy");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $2hDQc.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $2hDQc.useContext)(FormikContext);
    !!!formik && (0, $3JyNw.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $2hDQc.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $lHNrF.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $gEJ4F.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $lHNrF.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $gEJ4F.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $2hDQc.useRef)(props.initialValues);
    var initialErrors = (0, $2hDQc.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $2hDQc.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $2hDQc.useRef)(props.initialStatus);
    var isMounted = (0, $2hDQc.useRef)(false);
    var fieldRegistry = (0, $2hDQc.useRef)({});
    (0, $2hDQc.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $2hDQc.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $2hDQc.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $2hDQc.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $2hDQc.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $2hDQc.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $2hDQc.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $2hDQc.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $2hDQc.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $80Td8.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $2hDQc.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $2hDQc.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $2hDQc.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $2hDQc.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $2hDQc.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $2hDQc.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $2hDQc.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $2hDQc.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $2hDQc.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $2hDQc.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $2hDQc.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $2hDQc.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $2hDQc.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $2hDQc.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $2hDQc.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $2hDQc.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $2hDQc.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $2hDQc.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $2hDQc.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $2hDQc.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $2hDQc.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $2hDQc.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $2hDQc.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $2hDQc.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $l5A6B.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $l5A6B.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $80Td8.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $80Td8.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $2hDQc.useLayoutEffect) : (0, $2hDQc.useEffect);
function useEventCallback(fn) {
    var ref = (0, $2hDQc.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $2hDQc.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $2hDQc.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $3JyNw.default)(false);
    var fieldHelpers = (0, $2hDQc.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $2hDQc.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $2hDQc.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $2hDQc.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $2hDQc.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $2hDQc.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $2hDQc.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $2hDQc.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $2hDQc.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $2hDQc.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $2hDQc.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $2hDQc.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $3JyNw.default)(false);
            return (0, $2hDQc.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $lMELy.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($8xxO0)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $2hDQc.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $2hDQc.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $2hDQc.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $2hDQc.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $2hDQc.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $3JyNw.default)(false);
        !!(component && render) && (0, $3JyNw.default)(false);
        !!(is && children && isFunction(children)) && (0, $3JyNw.default)(false);
        !!(component && children && isFunction(children)) && (0, $3JyNw.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $3JyNw.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $2hDQc.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $2hDQc.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $2hDQc.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $2hDQc.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $2hDQc.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("80Td8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d59268bb6326a3a$export$2e2bcd8739ae039; });
var $5d59268bb6326a3a$var$isMergeableObject = function isMergeableObject(value) {
    return $5d59268bb6326a3a$var$isNonNullObject(value) && !$5d59268bb6326a3a$var$isSpecial(value);
};
function $5d59268bb6326a3a$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $5d59268bb6326a3a$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $5d59268bb6326a3a$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $5d59268bb6326a3a$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $5d59268bb6326a3a$var$REACT_ELEMENT_TYPE = $5d59268bb6326a3a$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $5d59268bb6326a3a$var$isReactElement(value) {
    return value.$$typeof === $5d59268bb6326a3a$var$REACT_ELEMENT_TYPE;
}
function $5d59268bb6326a3a$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $5d59268bb6326a3a$var$deepmerge($5d59268bb6326a3a$var$emptyTarget(value), value, options) : value;
}
function $5d59268bb6326a3a$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $5d59268bb6326a3a$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $5d59268bb6326a3a$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $5d59268bb6326a3a$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $5d59268bb6326a3a$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $5d59268bb6326a3a$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $5d59268bb6326a3a$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $5d59268bb6326a3a$var$mergeObject(target, source, options);
}
$5d59268bb6326a3a$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $5d59268bb6326a3a$var$deepmerge(prev, next, options);
    }, {});
};
var $5d59268bb6326a3a$var$deepmerge_1 = $5d59268bb6326a3a$var$deepmerge;
var $5d59268bb6326a3a$export$2e2bcd8739ae039 = $5d59268bb6326a3a$var$deepmerge_1;

});

parcelRegister("l5A6B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a61267ac9c9829$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $FgAoP = parcelRequire("FgAoP");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $f5a61267ac9c9829$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f5a61267ac9c9829$var$funcProto = Function.prototype, $f5a61267ac9c9829$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f5a61267ac9c9829$var$funcToString = $f5a61267ac9c9829$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f5a61267ac9c9829$var$hasOwnProperty = $f5a61267ac9c9829$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f5a61267ac9c9829$var$objectCtorString = $f5a61267ac9c9829$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f5a61267ac9c9829$var$isPlainObject(value) {
    if (!(0, $QTaGs.default)(value) || (0, $8ypmi.default)(value) != $f5a61267ac9c9829$var$objectTag) return false;
    var proto = (0, $FgAoP.default)(value);
    if (proto === null) return true;
    var Ctor = $f5a61267ac9c9829$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $f5a61267ac9c9829$var$funcToString.call(Ctor) == $f5a61267ac9c9829$var$objectCtorString;
}
var $f5a61267ac9c9829$export$2e2bcd8739ae039 = $f5a61267ac9c9829$var$isPlainObject;

});
parcelRegister("8ypmi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63a52b63e860451f$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");

var $lgbdJ = parcelRequire("lgbdJ");

var $5FaXM = parcelRequire("5FaXM");
/** `Object#toString` result references. */ var $63a52b63e860451f$var$nullTag = "[object Null]", $63a52b63e860451f$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $63a52b63e860451f$var$symToStringTag = (0, $iQXmk.default) ? (0, $iQXmk.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $63a52b63e860451f$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $63a52b63e860451f$var$undefinedTag : $63a52b63e860451f$var$nullTag;
    return $63a52b63e860451f$var$symToStringTag && $63a52b63e860451f$var$symToStringTag in Object(value) ? (0, $lgbdJ.default)(value) : (0, $5FaXM.default)(value);
}
var $63a52b63e860451f$export$2e2bcd8739ae039 = $63a52b63e860451f$var$baseGetTag;

});
parcelRegister("iQXmk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db9b20cc76d3f8d1$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Built-in value references. */ var $db9b20cc76d3f8d1$var$Symbol = (0, $65KY2.default).Symbol;
var $db9b20cc76d3f8d1$export$2e2bcd8739ae039 = $db9b20cc76d3f8d1$var$Symbol;

});
parcelRegister("65KY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f7a4759b73d162$export$2e2bcd8739ae039; });

var $h1ybm = parcelRequire("h1ybm");
/** Detect free variable `self`. */ var $46f7a4759b73d162$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $46f7a4759b73d162$var$root = (0, $h1ybm.default) || $46f7a4759b73d162$var$freeSelf || Function("return this")();
var $46f7a4759b73d162$export$2e2bcd8739ae039 = $46f7a4759b73d162$var$root;

});
parcelRegister("h1ybm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c64d0b90181ed9dd$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $c64d0b90181ed9dd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $c64d0b90181ed9dd$export$2e2bcd8739ae039 = $c64d0b90181ed9dd$var$freeGlobal;

});



parcelRegister("lgbdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a3cbbfb80b5519$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");
/** Used for built-in method references. */ var $f7a3cbbfb80b5519$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7a3cbbfb80b5519$var$hasOwnProperty = $f7a3cbbfb80b5519$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f7a3cbbfb80b5519$var$nativeObjectToString = $f7a3cbbfb80b5519$var$objectProto.toString;
/** Built-in value references. */ var $f7a3cbbfb80b5519$var$symToStringTag = (0, $iQXmk.default) ? (0, $iQXmk.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f7a3cbbfb80b5519$var$getRawTag(value) {
    var isOwn = $f7a3cbbfb80b5519$var$hasOwnProperty.call(value, $f7a3cbbfb80b5519$var$symToStringTag), tag = value[$f7a3cbbfb80b5519$var$symToStringTag];
    try {
        value[$f7a3cbbfb80b5519$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f7a3cbbfb80b5519$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f7a3cbbfb80b5519$var$symToStringTag] = tag;
        else delete value[$f7a3cbbfb80b5519$var$symToStringTag];
    }
    return result;
}
var $f7a3cbbfb80b5519$export$2e2bcd8739ae039 = $f7a3cbbfb80b5519$var$getRawTag;

});

parcelRegister("5FaXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41f94924c3cd05fa$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $41f94924c3cd05fa$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41f94924c3cd05fa$var$nativeObjectToString = $41f94924c3cd05fa$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $41f94924c3cd05fa$var$objectToString(value) {
    return $41f94924c3cd05fa$var$nativeObjectToString.call(value);
}
var $41f94924c3cd05fa$export$2e2bcd8739ae039 = $41f94924c3cd05fa$var$objectToString;

});


parcelRegister("FgAoP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07c0b21a19a53df8$export$2e2bcd8739ae039; });

var $63r4t = parcelRequire("63r4t");
/** Built-in value references. */ var $07c0b21a19a53df8$var$getPrototype = (0, $63r4t.default)(Object.getPrototypeOf, Object);
var $07c0b21a19a53df8$export$2e2bcd8739ae039 = $07c0b21a19a53df8$var$getPrototype;

});
parcelRegister("63r4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468805a22d2bea69$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $468805a22d2bea69$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $468805a22d2bea69$export$2e2bcd8739ae039 = $468805a22d2bea69$var$overArg;

});


parcelRegister("QTaGs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09efa7518ff2ecd8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $09efa7518ff2ecd8$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $09efa7518ff2ecd8$export$2e2bcd8739ae039 = $09efa7518ff2ecd8$var$isObjectLike;

});


parcelRegister("8xxO0", function(module, exports) {
"use strict";
var $637ba0e11ea98061$var$isArray = Array.isArray;
var $637ba0e11ea98061$var$keyList = Object.keys;
var $637ba0e11ea98061$var$hasProp = Object.prototype.hasOwnProperty;
var $637ba0e11ea98061$var$hasElementType = typeof Element !== "undefined";
function $637ba0e11ea98061$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $637ba0e11ea98061$var$isArray(a), arrB = $637ba0e11ea98061$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$637ba0e11ea98061$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $637ba0e11ea98061$var$keyList(a);
        length = keys.length;
        if (length !== $637ba0e11ea98061$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$637ba0e11ea98061$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($637ba0e11ea98061$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$637ba0e11ea98061$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $637ba0e11ea98061$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("3JyNw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b809129929fa9d8$export$2e2bcd8739ae039; });
var $2b809129929fa9d8$var$isProduction = true;
function $2b809129929fa9d8$var$warning(condition, message) {
    if (!$2b809129929fa9d8$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $2b809129929fa9d8$export$2e2bcd8739ae039 = $2b809129929fa9d8$var$warning;

});

parcelRegister("gEJ4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2035893aa4572bf$export$2e2bcd8739ae039; });

var $jIw7K = parcelRequire("jIw7K");
/** Used to compose bitmasks for cloning. */ var $c2035893aa4572bf$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $c2035893aa4572bf$var$clone(value) {
    return (0, $jIw7K.default)(value, $c2035893aa4572bf$var$CLONE_SYMBOLS_FLAG);
}
var $c2035893aa4572bf$export$2e2bcd8739ae039 = $c2035893aa4572bf$var$clone;

});
parcelRegister("jIw7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5ab0b88c071b93d$export$2e2bcd8739ae039; });

var $30gur = parcelRequire("30gur");

var $i89nt = parcelRequire("i89nt");

var $hEH8C = parcelRequire("hEH8C");

var $lcedB = parcelRequire("lcedB");

var $4oQTa = parcelRequire("4oQTa");

var $hD9Sw = parcelRequire("hD9Sw");

var $cbaxU = parcelRequire("cbaxU");

var $g5knF = parcelRequire("g5knF");

var $gi8Nh = parcelRequire("gi8Nh");

var $6CWdP = parcelRequire("6CWdP");

var $05fLa = parcelRequire("05fLa");

var $bdaH3 = parcelRequire("bdaH3");

var $aJAyC = parcelRequire("aJAyC");

var $eMOhO = parcelRequire("eMOhO");

var $eeWvl = parcelRequire("eeWvl");

var $cvQ90 = parcelRequire("cvQ90");

var $lTJlI = parcelRequire("lTJlI");

var $9cm4a = parcelRequire("9cm4a");

var $6vN6O = parcelRequire("6vN6O");

var $kO458 = parcelRequire("kO458");

var $bCEuG = parcelRequire("bCEuG");

var $5QaB6 = parcelRequire("5QaB6");
/** Used to compose bitmasks for cloning. */ var $e5ab0b88c071b93d$var$CLONE_DEEP_FLAG = 1, $e5ab0b88c071b93d$var$CLONE_FLAT_FLAG = 2, $e5ab0b88c071b93d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e5ab0b88c071b93d$var$argsTag = "[object Arguments]", $e5ab0b88c071b93d$var$arrayTag = "[object Array]", $e5ab0b88c071b93d$var$boolTag = "[object Boolean]", $e5ab0b88c071b93d$var$dateTag = "[object Date]", $e5ab0b88c071b93d$var$errorTag = "[object Error]", $e5ab0b88c071b93d$var$funcTag = "[object Function]", $e5ab0b88c071b93d$var$genTag = "[object GeneratorFunction]", $e5ab0b88c071b93d$var$mapTag = "[object Map]", $e5ab0b88c071b93d$var$numberTag = "[object Number]", $e5ab0b88c071b93d$var$objectTag = "[object Object]", $e5ab0b88c071b93d$var$regexpTag = "[object RegExp]", $e5ab0b88c071b93d$var$setTag = "[object Set]", $e5ab0b88c071b93d$var$stringTag = "[object String]", $e5ab0b88c071b93d$var$symbolTag = "[object Symbol]", $e5ab0b88c071b93d$var$weakMapTag = "[object WeakMap]";
var $e5ab0b88c071b93d$var$arrayBufferTag = "[object ArrayBuffer]", $e5ab0b88c071b93d$var$dataViewTag = "[object DataView]", $e5ab0b88c071b93d$var$float32Tag = "[object Float32Array]", $e5ab0b88c071b93d$var$float64Tag = "[object Float64Array]", $e5ab0b88c071b93d$var$int8Tag = "[object Int8Array]", $e5ab0b88c071b93d$var$int16Tag = "[object Int16Array]", $e5ab0b88c071b93d$var$int32Tag = "[object Int32Array]", $e5ab0b88c071b93d$var$uint8Tag = "[object Uint8Array]", $e5ab0b88c071b93d$var$uint8ClampedTag = "[object Uint8ClampedArray]", $e5ab0b88c071b93d$var$uint16Tag = "[object Uint16Array]", $e5ab0b88c071b93d$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e5ab0b88c071b93d$var$cloneableTags = {};
$e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$argsTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$arrayTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$arrayBufferTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$dataViewTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$boolTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$dateTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$float32Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$float64Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$int8Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$int16Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$int32Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$mapTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$numberTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$objectTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$regexpTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$setTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$stringTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$symbolTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint8Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint8ClampedTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint16Tag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$uint32Tag] = true;
$e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$errorTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$funcTag] = $e5ab0b88c071b93d$var$cloneableTags[$e5ab0b88c071b93d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e5ab0b88c071b93d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e5ab0b88c071b93d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e5ab0b88c071b93d$var$CLONE_FLAT_FLAG, isFull = bitmask & $e5ab0b88c071b93d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $6vN6O.default)(value)) return value;
    var isArr = (0, $cvQ90.default)(value);
    if (isArr) {
        result = (0, $aJAyC.default)(value);
        if (!isDeep) return (0, $cbaxU.default)(value, result);
    } else {
        var tag = (0, $bdaH3.default)(value), isFunc = tag == $e5ab0b88c071b93d$var$funcTag || tag == $e5ab0b88c071b93d$var$genTag;
        if ((0, $lTJlI.default)(value)) return (0, $hD9Sw.default)(value, isDeep);
        if (tag == $e5ab0b88c071b93d$var$objectTag || tag == $e5ab0b88c071b93d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $eeWvl.default)(value);
            if (!isDeep) return isFlat ? (0, $gi8Nh.default)(value, (0, $4oQTa.default)(result, value)) : (0, $g5knF.default)(value, (0, $lcedB.default)(result, value));
        } else {
            if (!$e5ab0b88c071b93d$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $eMOhO.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $30gur.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $kO458.default)(value)) value.forEach(function(subValue) {
        result.add($e5ab0b88c071b93d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $9cm4a.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $e5ab0b88c071b93d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $05fLa.default) : (0, $6CWdP.default) : isFlat ? (0, $5QaB6.default) : (0, $bCEuG.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $i89nt.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $hEH8C.default)(result, key, $e5ab0b88c071b93d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $e5ab0b88c071b93d$export$2e2bcd8739ae039 = $e5ab0b88c071b93d$var$baseClone;

});
parcelRegister("30gur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22fe29c2a1ce14bf$export$2e2bcd8739ae039; });

var $1L7Vn = parcelRequire("1L7Vn");

var $kvs60 = parcelRequire("kvs60");

var $gwr4T = parcelRequire("gwr4T");

var $hBE2d = parcelRequire("hBE2d");

var $b3VB6 = parcelRequire("b3VB6");

var $kJtaZ = parcelRequire("kJtaZ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $22fe29c2a1ce14bf$var$Stack(entries) {
    var data = this.__data__ = new (0, $1L7Vn.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$22fe29c2a1ce14bf$var$Stack.prototype.clear = (0, $kvs60.default);
$22fe29c2a1ce14bf$var$Stack.prototype["delete"] = (0, $gwr4T.default);
$22fe29c2a1ce14bf$var$Stack.prototype.get = (0, $hBE2d.default);
$22fe29c2a1ce14bf$var$Stack.prototype.has = (0, $b3VB6.default);
$22fe29c2a1ce14bf$var$Stack.prototype.set = (0, $kJtaZ.default);
var $22fe29c2a1ce14bf$export$2e2bcd8739ae039 = $22fe29c2a1ce14bf$var$Stack;

});
parcelRegister("1L7Vn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $148053d706dae3be$export$2e2bcd8739ae039; });

var $d2x9T = parcelRequire("d2x9T");

var $arBmH = parcelRequire("arBmH");

var $hmWkL = parcelRequire("hmWkL");

var $dy3DT = parcelRequire("dy3DT");

var $8jgMB = parcelRequire("8jgMB");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $148053d706dae3be$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$148053d706dae3be$var$ListCache.prototype.clear = (0, $d2x9T.default);
$148053d706dae3be$var$ListCache.prototype["delete"] = (0, $arBmH.default);
$148053d706dae3be$var$ListCache.prototype.get = (0, $hmWkL.default);
$148053d706dae3be$var$ListCache.prototype.has = (0, $dy3DT.default);
$148053d706dae3be$var$ListCache.prototype.set = (0, $8jgMB.default);
var $148053d706dae3be$export$2e2bcd8739ae039 = $148053d706dae3be$var$ListCache;

});
parcelRegister("d2x9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97e52edc99c01de6$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $97e52edc99c01de6$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $97e52edc99c01de6$export$2e2bcd8739ae039 = $97e52edc99c01de6$var$listCacheClear;

});

parcelRegister("arBmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a968ea83f562e0$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/** Used for built-in method references. */ var $79a968ea83f562e0$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $79a968ea83f562e0$var$splice = $79a968ea83f562e0$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $79a968ea83f562e0$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ewK8y.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $79a968ea83f562e0$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $79a968ea83f562e0$export$2e2bcd8739ae039 = $79a968ea83f562e0$var$listCacheDelete;

});
parcelRegister("ewK8y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a937d7aa975253b2$export$2e2bcd8739ae039; });

var $35xIW = parcelRequire("35xIW");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a937d7aa975253b2$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $35xIW.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a937d7aa975253b2$export$2e2bcd8739ae039 = $a937d7aa975253b2$var$assocIndexOf;

});
parcelRegister("35xIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fbff934cae5a70$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $23fbff934cae5a70$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $23fbff934cae5a70$export$2e2bcd8739ae039 = $23fbff934cae5a70$var$eq;

});



parcelRegister("hmWkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca51bd9dd2622a2d$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ca51bd9dd2622a2d$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ewK8y.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $ca51bd9dd2622a2d$export$2e2bcd8739ae039 = $ca51bd9dd2622a2d$var$listCacheGet;

});

parcelRegister("dy3DT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dd146acabb673e8$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9dd146acabb673e8$var$listCacheHas(key) {
    return (0, $ewK8y.default)(this.__data__, key) > -1;
}
var $9dd146acabb673e8$export$2e2bcd8739ae039 = $9dd146acabb673e8$var$listCacheHas;

});

parcelRegister("8jgMB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60cd1dce32e03f61$export$2e2bcd8739ae039; });

var $ewK8y = parcelRequire("ewK8y");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $60cd1dce32e03f61$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ewK8y.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $60cd1dce32e03f61$export$2e2bcd8739ae039 = $60cd1dce32e03f61$var$listCacheSet;

});


parcelRegister("kvs60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eedc7f2b4cad253b$export$2e2bcd8739ae039; });

var $1L7Vn = parcelRequire("1L7Vn");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $eedc7f2b4cad253b$var$stackClear() {
    this.__data__ = new (0, $1L7Vn.default);
    this.size = 0;
}
var $eedc7f2b4cad253b$export$2e2bcd8739ae039 = $eedc7f2b4cad253b$var$stackClear;

});

parcelRegister("gwr4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c074a3a094dc6d0c$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c074a3a094dc6d0c$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $c074a3a094dc6d0c$export$2e2bcd8739ae039 = $c074a3a094dc6d0c$var$stackDelete;

});

parcelRegister("hBE2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd14f26d860e5f74$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cd14f26d860e5f74$var$stackGet(key) {
    return this.__data__.get(key);
}
var $cd14f26d860e5f74$export$2e2bcd8739ae039 = $cd14f26d860e5f74$var$stackGet;

});

parcelRegister("b3VB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80dca729546eb3d4$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $80dca729546eb3d4$var$stackHas(key) {
    return this.__data__.has(key);
}
var $80dca729546eb3d4$export$2e2bcd8739ae039 = $80dca729546eb3d4$var$stackHas;

});

parcelRegister("kJtaZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f17ea46ee6873b72$export$2e2bcd8739ae039; });

var $1L7Vn = parcelRequire("1L7Vn");

var $fnuNy = parcelRequire("fnuNy");

var $jitcP = parcelRequire("jitcP");
/** Used as the size to enable large array optimizations. */ var $f17ea46ee6873b72$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f17ea46ee6873b72$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $1L7Vn.default)) {
        var pairs = data.__data__;
        if (!(0, $fnuNy.default) || pairs.length < $f17ea46ee6873b72$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $jitcP.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $f17ea46ee6873b72$export$2e2bcd8739ae039 = $f17ea46ee6873b72$var$stackSet;

});
parcelRegister("fnuNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b320e4e562772a7d$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $b320e4e562772a7d$var$Map = (0, $97o2V.default)((0, $65KY2.default), "Map");
var $b320e4e562772a7d$export$2e2bcd8739ae039 = $b320e4e562772a7d$var$Map;

});
parcelRegister("97o2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a376b8c868c04d4$export$2e2bcd8739ae039; });

var $jlIsA = parcelRequire("jlIsA");

var $bLvsx = parcelRequire("bLvsx");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6a376b8c868c04d4$var$getNative(object, key) {
    var value = (0, $bLvsx.default)(object, key);
    return (0, $jlIsA.default)(value) ? value : undefined;
}
var $6a376b8c868c04d4$export$2e2bcd8739ae039 = $6a376b8c868c04d4$var$getNative;

});
parcelRegister("jlIsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e16277573605e2c0$export$2e2bcd8739ae039; });

var $5OjsN = parcelRequire("5OjsN");

var $cSLZ6 = parcelRequire("cSLZ6");

var $6vN6O = parcelRequire("6vN6O");

var $jZH4M = parcelRequire("jZH4M");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e16277573605e2c0$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e16277573605e2c0$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $e16277573605e2c0$var$funcProto = Function.prototype, $e16277573605e2c0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e16277573605e2c0$var$funcToString = $e16277573605e2c0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e16277573605e2c0$var$hasOwnProperty = $e16277573605e2c0$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $e16277573605e2c0$var$reIsNative = RegExp("^" + $e16277573605e2c0$var$funcToString.call($e16277573605e2c0$var$hasOwnProperty).replace($e16277573605e2c0$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e16277573605e2c0$var$baseIsNative(value) {
    if (!(0, $6vN6O.default)(value) || (0, $cSLZ6.default)(value)) return false;
    var pattern = (0, $5OjsN.default)(value) ? $e16277573605e2c0$var$reIsNative : $e16277573605e2c0$var$reIsHostCtor;
    return pattern.test((0, $jZH4M.default)(value));
}
var $e16277573605e2c0$export$2e2bcd8739ae039 = $e16277573605e2c0$var$baseIsNative;

});
parcelRegister("5OjsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b0b84809e47192$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $6vN6O = parcelRequire("6vN6O");
/** `Object#toString` result references. */ var $43b0b84809e47192$var$asyncTag = "[object AsyncFunction]", $43b0b84809e47192$var$funcTag = "[object Function]", $43b0b84809e47192$var$genTag = "[object GeneratorFunction]", $43b0b84809e47192$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $43b0b84809e47192$var$isFunction(value) {
    if (!(0, $6vN6O.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $8ypmi.default)(value);
    return tag == $43b0b84809e47192$var$funcTag || tag == $43b0b84809e47192$var$genTag || tag == $43b0b84809e47192$var$asyncTag || tag == $43b0b84809e47192$var$proxyTag;
}
var $43b0b84809e47192$export$2e2bcd8739ae039 = $43b0b84809e47192$var$isFunction;

});
parcelRegister("6vN6O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bdbbb59fcac0bb9$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4bdbbb59fcac0bb9$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $4bdbbb59fcac0bb9$export$2e2bcd8739ae039 = $4bdbbb59fcac0bb9$var$isObject;

});


parcelRegister("cSLZ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $960fbfeca0df1e98$export$2e2bcd8739ae039; });

var $4Qwdl = parcelRequire("4Qwdl");
/** Used to detect methods masquerading as native. */ var $960fbfeca0df1e98$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $4Qwdl.default) && (0, $4Qwdl.default).keys && (0, $4Qwdl.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $960fbfeca0df1e98$var$isMasked(func) {
    return !!$960fbfeca0df1e98$var$maskSrcKey && $960fbfeca0df1e98$var$maskSrcKey in func;
}
var $960fbfeca0df1e98$export$2e2bcd8739ae039 = $960fbfeca0df1e98$var$isMasked;

});
parcelRegister("4Qwdl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $387501cfb4f5ac43$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Used to detect overreaching core-js shims. */ var $387501cfb4f5ac43$var$coreJsData = (0, $65KY2.default)["__core-js_shared__"];
var $387501cfb4f5ac43$export$2e2bcd8739ae039 = $387501cfb4f5ac43$var$coreJsData;

});


parcelRegister("jZH4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e520d4fbabdba0$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $e8e520d4fbabdba0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e8e520d4fbabdba0$var$funcToString = $e8e520d4fbabdba0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e8e520d4fbabdba0$var$toSource(func) {
    if (func != null) {
        try {
            return $e8e520d4fbabdba0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $e8e520d4fbabdba0$export$2e2bcd8739ae039 = $e8e520d4fbabdba0$var$toSource;

});


parcelRegister("bLvsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890c7ca478ff16a5$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $890c7ca478ff16a5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $890c7ca478ff16a5$export$2e2bcd8739ae039 = $890c7ca478ff16a5$var$getValue;

});



parcelRegister("jitcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0c65a6c1121d798$export$2e2bcd8739ae039; });

var $j2egd = parcelRequire("j2egd");

var $6BjDB = parcelRequire("6BjDB");

var $dcq99 = parcelRequire("dcq99");

var $lJWNS = parcelRequire("lJWNS");

var $dwmFA = parcelRequire("dwmFA");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e0c65a6c1121d798$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$e0c65a6c1121d798$var$MapCache.prototype.clear = (0, $j2egd.default);
$e0c65a6c1121d798$var$MapCache.prototype["delete"] = (0, $6BjDB.default);
$e0c65a6c1121d798$var$MapCache.prototype.get = (0, $dcq99.default);
$e0c65a6c1121d798$var$MapCache.prototype.has = (0, $lJWNS.default);
$e0c65a6c1121d798$var$MapCache.prototype.set = (0, $dwmFA.default);
var $e0c65a6c1121d798$export$2e2bcd8739ae039 = $e0c65a6c1121d798$var$MapCache;

});
parcelRegister("j2egd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb94410cedd2612$export$2e2bcd8739ae039; });

var $hgwaz = parcelRequire("hgwaz");

var $1L7Vn = parcelRequire("1L7Vn");

var $fnuNy = parcelRequire("fnuNy");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ddb94410cedd2612$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $hgwaz.default),
        "map": new ((0, $fnuNy.default) || (0, $1L7Vn.default)),
        "string": new (0, $hgwaz.default)
    };
}
var $ddb94410cedd2612$export$2e2bcd8739ae039 = $ddb94410cedd2612$var$mapCacheClear;

});
parcelRegister("hgwaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c91ce27793a3f4a7$export$2e2bcd8739ae039; });

var $4Tz9g = parcelRequire("4Tz9g");

var $17d5X = parcelRequire("17d5X");

var $kG6qk = parcelRequire("kG6qk");

var $vHhnq = parcelRequire("vHhnq");

var $bK942 = parcelRequire("bK942");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c91ce27793a3f4a7$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$c91ce27793a3f4a7$var$Hash.prototype.clear = (0, $4Tz9g.default);
$c91ce27793a3f4a7$var$Hash.prototype["delete"] = (0, $17d5X.default);
$c91ce27793a3f4a7$var$Hash.prototype.get = (0, $kG6qk.default);
$c91ce27793a3f4a7$var$Hash.prototype.has = (0, $vHhnq.default);
$c91ce27793a3f4a7$var$Hash.prototype.set = (0, $bK942.default);
var $c91ce27793a3f4a7$export$2e2bcd8739ae039 = $c91ce27793a3f4a7$var$Hash;

});
parcelRegister("4Tz9g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39079039e378aa63$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $39079039e378aa63$var$hashClear() {
    this.__data__ = (0, $1WnQP.default) ? (0, $1WnQP.default)(null) : {};
    this.size = 0;
}
var $39079039e378aa63$export$2e2bcd8739ae039 = $39079039e378aa63$var$hashClear;

});
parcelRegister("1WnQP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $169db58942102db8$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");
/* Built-in method references that are verified to be native. */ var $169db58942102db8$var$nativeCreate = (0, $97o2V.default)(Object, "create");
var $169db58942102db8$export$2e2bcd8739ae039 = $169db58942102db8$var$nativeCreate;

});


parcelRegister("17d5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d009a4cf800ead6$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0d009a4cf800ead6$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $0d009a4cf800ead6$export$2e2bcd8739ae039 = $0d009a4cf800ead6$var$hashDelete;

});

parcelRegister("kG6qk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0dcb67fbe65ee1c$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/** Used to stand-in for `undefined` hash values. */ var $f0dcb67fbe65ee1c$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $f0dcb67fbe65ee1c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0dcb67fbe65ee1c$var$hasOwnProperty = $f0dcb67fbe65ee1c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f0dcb67fbe65ee1c$var$hashGet(key) {
    var data = this.__data__;
    if (0, $1WnQP.default) {
        var result = data[key];
        return result === $f0dcb67fbe65ee1c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f0dcb67fbe65ee1c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $f0dcb67fbe65ee1c$export$2e2bcd8739ae039 = $f0dcb67fbe65ee1c$var$hashGet;

});

parcelRegister("vHhnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f477b9fa072c51$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/** Used for built-in method references. */ var $05f477b9fa072c51$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $05f477b9fa072c51$var$hasOwnProperty = $05f477b9fa072c51$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $05f477b9fa072c51$var$hashHas(key) {
    var data = this.__data__;
    return (0, $1WnQP.default) ? data[key] !== undefined : $05f477b9fa072c51$var$hasOwnProperty.call(data, key);
}
var $05f477b9fa072c51$export$2e2bcd8739ae039 = $05f477b9fa072c51$var$hashHas;

});

parcelRegister("bK942", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88cb05871b91c14d$export$2e2bcd8739ae039; });

var $1WnQP = parcelRequire("1WnQP");
/** Used to stand-in for `undefined` hash values. */ var $88cb05871b91c14d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $88cb05871b91c14d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $1WnQP.default) && value === undefined ? $88cb05871b91c14d$var$HASH_UNDEFINED : value;
    return this;
}
var $88cb05871b91c14d$export$2e2bcd8739ae039 = $88cb05871b91c14d$var$hashSet;

});



parcelRegister("6BjDB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce56e6ccf07c43c$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4ce56e6ccf07c43c$var$mapCacheDelete(key) {
    var result = (0, $j83NR.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $4ce56e6ccf07c43c$export$2e2bcd8739ae039 = $4ce56e6ccf07c43c$var$mapCacheDelete;

});
parcelRegister("j83NR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ded1b6e67eb9cd5e$export$2e2bcd8739ae039; });

var $fn6OQ = parcelRequire("fn6OQ");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ded1b6e67eb9cd5e$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $fn6OQ.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $ded1b6e67eb9cd5e$export$2e2bcd8739ae039 = $ded1b6e67eb9cd5e$var$getMapData;

});
parcelRegister("fn6OQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30e4b19acaf09db$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b30e4b19acaf09db$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $b30e4b19acaf09db$export$2e2bcd8739ae039 = $b30e4b19acaf09db$var$isKeyable;

});



parcelRegister("dcq99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99c0ad843ce73a05$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $99c0ad843ce73a05$var$mapCacheGet(key) {
    return (0, $j83NR.default)(this, key).get(key);
}
var $99c0ad843ce73a05$export$2e2bcd8739ae039 = $99c0ad843ce73a05$var$mapCacheGet;

});

parcelRegister("lJWNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3b6a1c9c42a9be$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fd3b6a1c9c42a9be$var$mapCacheHas(key) {
    return (0, $j83NR.default)(this, key).has(key);
}
var $fd3b6a1c9c42a9be$export$2e2bcd8739ae039 = $fd3b6a1c9c42a9be$var$mapCacheHas;

});

parcelRegister("dwmFA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d7fd9419dffa8dc$export$2e2bcd8739ae039; });

var $j83NR = parcelRequire("j83NR");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $9d7fd9419dffa8dc$var$mapCacheSet(key, value) {
    var data = (0, $j83NR.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $9d7fd9419dffa8dc$export$2e2bcd8739ae039 = $9d7fd9419dffa8dc$var$mapCacheSet;

});




parcelRegister("i89nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3303f8f23d7dec4$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d3303f8f23d7dec4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d3303f8f23d7dec4$export$2e2bcd8739ae039 = $d3303f8f23d7dec4$var$arrayEach;

});

parcelRegister("hEH8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cda7a26dc04cf3b8$export$2e2bcd8739ae039; });

var $kMRMD = parcelRequire("kMRMD");

var $35xIW = parcelRequire("35xIW");
/** Used for built-in method references. */ var $cda7a26dc04cf3b8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cda7a26dc04cf3b8$var$hasOwnProperty = $cda7a26dc04cf3b8$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $cda7a26dc04cf3b8$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($cda7a26dc04cf3b8$var$hasOwnProperty.call(object, key) && (0, $35xIW.default)(objValue, value)) || value === undefined && !(key in object)) (0, $kMRMD.default)(object, key, value);
}
var $cda7a26dc04cf3b8$export$2e2bcd8739ae039 = $cda7a26dc04cf3b8$var$assignValue;

});
parcelRegister("kMRMD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f22202a2476a3e43$export$2e2bcd8739ae039; });

var $hBQ41 = parcelRequire("hBQ41");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f22202a2476a3e43$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $hBQ41.default)) (0, $hBQ41.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $f22202a2476a3e43$export$2e2bcd8739ae039 = $f22202a2476a3e43$var$baseAssignValue;

});
parcelRegister("hBQ41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd1e4729ed176eb2$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");
var $cd1e4729ed176eb2$var$defineProperty = function() {
    try {
        var func = (0, $97o2V.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $cd1e4729ed176eb2$export$2e2bcd8739ae039 = $cd1e4729ed176eb2$var$defineProperty;

});



parcelRegister("lcedB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e5bf6a4098ca74$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $bCEuG = parcelRequire("bCEuG");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f6e5bf6a4098ca74$var$baseAssign(object, source) {
    return object && (0, $Dfje1.default)(source, (0, $bCEuG.default)(source), object);
}
var $f6e5bf6a4098ca74$export$2e2bcd8739ae039 = $f6e5bf6a4098ca74$var$baseAssign;

});
parcelRegister("Dfje1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075f84b29e1e8a43$export$2e2bcd8739ae039; });

var $hEH8C = parcelRequire("hEH8C");

var $kMRMD = parcelRequire("kMRMD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $075f84b29e1e8a43$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $kMRMD.default)(object, key, newValue);
        else (0, $hEH8C.default)(object, key, newValue);
    }
    return object;
}
var $075f84b29e1e8a43$export$2e2bcd8739ae039 = $075f84b29e1e8a43$var$copyObject;

});

parcelRegister("bCEuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8762a7899474a5a1$export$2e2bcd8739ae039; });

var $lXa20 = parcelRequire("lXa20");

var $1DpxM = parcelRequire("1DpxM");

var $fvRYU = parcelRequire("fvRYU");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $8762a7899474a5a1$var$keys(object) {
    return (0, $fvRYU.default)(object) ? (0, $lXa20.default)(object) : (0, $1DpxM.default)(object);
}
var $8762a7899474a5a1$export$2e2bcd8739ae039 = $8762a7899474a5a1$var$keys;

});
parcelRegister("lXa20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffb6e3ab89e890ad$export$2e2bcd8739ae039; });

var $c8nkI = parcelRequire("c8nkI");

var $ifZOn = parcelRequire("ifZOn");

var $cvQ90 = parcelRequire("cvQ90");

var $lTJlI = parcelRequire("lTJlI");

var $dNzbj = parcelRequire("dNzbj");

var $frOPg = parcelRequire("frOPg");
/** Used for built-in method references. */ var $ffb6e3ab89e890ad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ffb6e3ab89e890ad$var$hasOwnProperty = $ffb6e3ab89e890ad$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ffb6e3ab89e890ad$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $cvQ90.default)(value), isArg = !isArr && (0, $ifZOn.default)(value), isBuff = !isArr && !isArg && (0, $lTJlI.default)(value), isType = !isArr && !isArg && !isBuff && (0, $frOPg.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $c8nkI.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $ffb6e3ab89e890ad$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $dNzbj.default)(key, length)))) result.push(key);
    return result;
}
var $ffb6e3ab89e890ad$export$2e2bcd8739ae039 = $ffb6e3ab89e890ad$var$arrayLikeKeys;

});
parcelRegister("c8nkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d5854ddc9992a89$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $8d5854ddc9992a89$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $8d5854ddc9992a89$export$2e2bcd8739ae039 = $8d5854ddc9992a89$var$baseTimes;

});

parcelRegister("ifZOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a993307951c51d$export$2e2bcd8739ae039; });

var $eKgoA = parcelRequire("eKgoA");

var $QTaGs = parcelRequire("QTaGs");
/** Used for built-in method references. */ var $d4a993307951c51d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4a993307951c51d$var$hasOwnProperty = $d4a993307951c51d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d4a993307951c51d$var$propertyIsEnumerable = $d4a993307951c51d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d4a993307951c51d$var$isArguments = (0, $eKgoA.default)(function() {
    return arguments;
}()) ? (0, $eKgoA.default) : function(value) {
    return (0, $QTaGs.default)(value) && $d4a993307951c51d$var$hasOwnProperty.call(value, "callee") && !$d4a993307951c51d$var$propertyIsEnumerable.call(value, "callee");
};
var $d4a993307951c51d$export$2e2bcd8739ae039 = $d4a993307951c51d$var$isArguments;

});
parcelRegister("eKgoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc214687dd47254$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $abc214687dd47254$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $abc214687dd47254$var$baseIsArguments(value) {
    return (0, $QTaGs.default)(value) && (0, $8ypmi.default)(value) == $abc214687dd47254$var$argsTag;
}
var $abc214687dd47254$export$2e2bcd8739ae039 = $abc214687dd47254$var$baseIsArguments;

});


parcelRegister("cvQ90", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91c0d410801941b9$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $91c0d410801941b9$var$isArray = Array.isArray;
var $91c0d410801941b9$export$2e2bcd8739ae039 = $91c0d410801941b9$var$isArray;

});

parcelRegister("lTJlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff11e9736a78ec75$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");

var $kvkj9 = parcelRequire("kvkj9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $65KY2.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kvkj9.default);
var $ff11e9736a78ec75$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kvkj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eed674a4f8c075c0$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eed674a4f8c075c0$var$stubFalse() {
    return false;
}
var $eed674a4f8c075c0$export$2e2bcd8739ae039 = $eed674a4f8c075c0$var$stubFalse;

});


parcelRegister("dNzbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0bb24454cd32991$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $a0bb24454cd32991$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a0bb24454cd32991$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a0bb24454cd32991$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a0bb24454cd32991$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $a0bb24454cd32991$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $a0bb24454cd32991$export$2e2bcd8739ae039 = $a0bb24454cd32991$var$isIndex;

});

parcelRegister("frOPg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f0cd9b908e9acf$export$2e2bcd8739ae039; });

var $3uwJ4 = parcelRequire("3uwJ4");

var $gSwe7 = parcelRequire("gSwe7");

var $eihh9 = parcelRequire("eihh9");
/* Node.js helper references. */ var $b3f0cd9b908e9acf$var$nodeIsTypedArray = (0, $eihh9.default) && (0, $eihh9.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b3f0cd9b908e9acf$var$isTypedArray = $b3f0cd9b908e9acf$var$nodeIsTypedArray ? (0, $gSwe7.default)($b3f0cd9b908e9acf$var$nodeIsTypedArray) : (0, $3uwJ4.default);
var $b3f0cd9b908e9acf$export$2e2bcd8739ae039 = $b3f0cd9b908e9acf$var$isTypedArray;

});
parcelRegister("3uwJ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ad8f27d88dc9a8$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $d0v4T = parcelRequire("d0v4T");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $28ad8f27d88dc9a8$var$argsTag = "[object Arguments]", $28ad8f27d88dc9a8$var$arrayTag = "[object Array]", $28ad8f27d88dc9a8$var$boolTag = "[object Boolean]", $28ad8f27d88dc9a8$var$dateTag = "[object Date]", $28ad8f27d88dc9a8$var$errorTag = "[object Error]", $28ad8f27d88dc9a8$var$funcTag = "[object Function]", $28ad8f27d88dc9a8$var$mapTag = "[object Map]", $28ad8f27d88dc9a8$var$numberTag = "[object Number]", $28ad8f27d88dc9a8$var$objectTag = "[object Object]", $28ad8f27d88dc9a8$var$regexpTag = "[object RegExp]", $28ad8f27d88dc9a8$var$setTag = "[object Set]", $28ad8f27d88dc9a8$var$stringTag = "[object String]", $28ad8f27d88dc9a8$var$weakMapTag = "[object WeakMap]";
var $28ad8f27d88dc9a8$var$arrayBufferTag = "[object ArrayBuffer]", $28ad8f27d88dc9a8$var$dataViewTag = "[object DataView]", $28ad8f27d88dc9a8$var$float32Tag = "[object Float32Array]", $28ad8f27d88dc9a8$var$float64Tag = "[object Float64Array]", $28ad8f27d88dc9a8$var$int8Tag = "[object Int8Array]", $28ad8f27d88dc9a8$var$int16Tag = "[object Int16Array]", $28ad8f27d88dc9a8$var$int32Tag = "[object Int32Array]", $28ad8f27d88dc9a8$var$uint8Tag = "[object Uint8Array]", $28ad8f27d88dc9a8$var$uint8ClampedTag = "[object Uint8ClampedArray]", $28ad8f27d88dc9a8$var$uint16Tag = "[object Uint16Array]", $28ad8f27d88dc9a8$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $28ad8f27d88dc9a8$var$typedArrayTags = {};
$28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$float32Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$float64Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$int8Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$int16Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$int32Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint8Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint8ClampedTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint16Tag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$uint32Tag] = true;
$28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$argsTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$arrayTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$arrayBufferTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$boolTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$dataViewTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$dateTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$errorTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$funcTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$mapTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$numberTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$objectTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$regexpTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$setTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$stringTag] = $28ad8f27d88dc9a8$var$typedArrayTags[$28ad8f27d88dc9a8$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $28ad8f27d88dc9a8$var$baseIsTypedArray(value) {
    return (0, $QTaGs.default)(value) && (0, $d0v4T.default)(value.length) && !!$28ad8f27d88dc9a8$var$typedArrayTags[(0, $8ypmi.default)(value)];
}
var $28ad8f27d88dc9a8$export$2e2bcd8739ae039 = $28ad8f27d88dc9a8$var$baseIsTypedArray;

});
parcelRegister("d0v4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $978361e70025a850$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $978361e70025a850$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $978361e70025a850$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $978361e70025a850$var$MAX_SAFE_INTEGER;
}
var $978361e70025a850$export$2e2bcd8739ae039 = $978361e70025a850$var$isLength;

});


parcelRegister("gSwe7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c49ab00fcf3c802b$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c49ab00fcf3c802b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c49ab00fcf3c802b$export$2e2bcd8739ae039 = $c49ab00fcf3c802b$var$baseUnary;

});

parcelRegister("eihh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68025b785011fda$export$2e2bcd8739ae039; });

var $h1ybm = parcelRequire("h1ybm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $h1ybm.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $a68025b785011fda$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("1DpxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130d3f6d5fcfb49d$export$2e2bcd8739ae039; });

var $i2xGO = parcelRequire("i2xGO");

var $48Rgc = parcelRequire("48Rgc");
/** Used for built-in method references. */ var $130d3f6d5fcfb49d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $130d3f6d5fcfb49d$var$hasOwnProperty = $130d3f6d5fcfb49d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $130d3f6d5fcfb49d$var$baseKeys(object) {
    if (!(0, $i2xGO.default)(object)) return (0, $48Rgc.default)(object);
    var result = [];
    for(var key in Object(object))if ($130d3f6d5fcfb49d$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $130d3f6d5fcfb49d$export$2e2bcd8739ae039 = $130d3f6d5fcfb49d$var$baseKeys;

});
parcelRegister("i2xGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2228bf424def2e3$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $d2228bf424def2e3$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d2228bf424def2e3$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $d2228bf424def2e3$var$objectProto;
    return value === proto;
}
var $d2228bf424def2e3$export$2e2bcd8739ae039 = $d2228bf424def2e3$var$isPrototype;

});

parcelRegister("48Rgc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $304139292d97c286$export$2e2bcd8739ae039; });

var $63r4t = parcelRequire("63r4t");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $304139292d97c286$var$nativeKeys = (0, $63r4t.default)(Object.keys, Object);
var $304139292d97c286$export$2e2bcd8739ae039 = $304139292d97c286$var$nativeKeys;

});


parcelRegister("fvRYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4b39fd2c5d56ee0$export$2e2bcd8739ae039; });

var $5OjsN = parcelRequire("5OjsN");

var $d0v4T = parcelRequire("d0v4T");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b4b39fd2c5d56ee0$var$isArrayLike(value) {
    return value != null && (0, $d0v4T.default)(value.length) && !(0, $5OjsN.default)(value);
}
var $b4b39fd2c5d56ee0$export$2e2bcd8739ae039 = $b4b39fd2c5d56ee0$var$isArrayLike;

});



parcelRegister("4oQTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33426debf32a14f9$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $5QaB6 = parcelRequire("5QaB6");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $33426debf32a14f9$var$baseAssignIn(object, source) {
    return object && (0, $Dfje1.default)(source, (0, $5QaB6.default)(source), object);
}
var $33426debf32a14f9$export$2e2bcd8739ae039 = $33426debf32a14f9$var$baseAssignIn;

});
parcelRegister("5QaB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440a078352bf8aef$export$2e2bcd8739ae039; });

var $lXa20 = parcelRequire("lXa20");

var $30s94 = parcelRequire("30s94");

var $fvRYU = parcelRequire("fvRYU");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $440a078352bf8aef$var$keysIn(object) {
    return (0, $fvRYU.default)(object) ? (0, $lXa20.default)(object, true) : (0, $30s94.default)(object);
}
var $440a078352bf8aef$export$2e2bcd8739ae039 = $440a078352bf8aef$var$keysIn;

});
parcelRegister("30s94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $230734409484894d$export$2e2bcd8739ae039; });

var $6vN6O = parcelRequire("6vN6O");

var $i2xGO = parcelRequire("i2xGO");

var $8HiE1 = parcelRequire("8HiE1");
/** Used for built-in method references. */ var $230734409484894d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $230734409484894d$var$hasOwnProperty = $230734409484894d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $230734409484894d$var$baseKeysIn(object) {
    if (!(0, $6vN6O.default)(object)) return (0, $8HiE1.default)(object);
    var isProto = (0, $i2xGO.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$230734409484894d$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $230734409484894d$export$2e2bcd8739ae039 = $230734409484894d$var$baseKeysIn;

});
parcelRegister("8HiE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6550cd4dba1e9966$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6550cd4dba1e9966$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $6550cd4dba1e9966$export$2e2bcd8739ae039 = $6550cd4dba1e9966$var$nativeKeysIn;

});




parcelRegister("hD9Sw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd5dbdcf361efd09$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $65KY2.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $cd5dbdcf361efd09$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("cbaxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ddeb14e1f96ad8d$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $8ddeb14e1f96ad8d$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $8ddeb14e1f96ad8d$export$2e2bcd8739ae039 = $8ddeb14e1f96ad8d$var$copyArray;

});

parcelRegister("g5knF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5cec2c62d3f705$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $ewGbf = parcelRequire("ewGbf");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $bb5cec2c62d3f705$var$copySymbols(source, object) {
    return (0, $Dfje1.default)(source, (0, $ewGbf.default)(source), object);
}
var $bb5cec2c62d3f705$export$2e2bcd8739ae039 = $bb5cec2c62d3f705$var$copySymbols;

});
parcelRegister("ewGbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a934c5fb1d6cb594$export$2e2bcd8739ae039; });

var $9U6p2 = parcelRequire("9U6p2");

var $jSInV = parcelRequire("jSInV");
/** Used for built-in method references. */ var $a934c5fb1d6cb594$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a934c5fb1d6cb594$var$propertyIsEnumerable = $a934c5fb1d6cb594$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a934c5fb1d6cb594$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a934c5fb1d6cb594$var$getSymbols = !$a934c5fb1d6cb594$var$nativeGetSymbols ? (0, $jSInV.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $9U6p2.default)($a934c5fb1d6cb594$var$nativeGetSymbols(object), function(symbol) {
        return $a934c5fb1d6cb594$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $a934c5fb1d6cb594$export$2e2bcd8739ae039 = $a934c5fb1d6cb594$var$getSymbols;

});
parcelRegister("9U6p2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735e4f7c31b4a331$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $735e4f7c31b4a331$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $735e4f7c31b4a331$export$2e2bcd8739ae039 = $735e4f7c31b4a331$var$arrayFilter;

});

parcelRegister("jSInV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7957d5ed38c1122$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e7957d5ed38c1122$var$stubArray() {
    return [];
}
var $e7957d5ed38c1122$export$2e2bcd8739ae039 = $e7957d5ed38c1122$var$stubArray;

});



parcelRegister("gi8Nh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc5261438d3c3d8$export$2e2bcd8739ae039; });

var $Dfje1 = parcelRequire("Dfje1");

var $75AvF = parcelRequire("75AvF");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $bdc5261438d3c3d8$var$copySymbolsIn(source, object) {
    return (0, $Dfje1.default)(source, (0, $75AvF.default)(source), object);
}
var $bdc5261438d3c3d8$export$2e2bcd8739ae039 = $bdc5261438d3c3d8$var$copySymbolsIn;

});
parcelRegister("75AvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52955219533c6ca2$export$2e2bcd8739ae039; });

var $4zeHU = parcelRequire("4zeHU");

var $FgAoP = parcelRequire("FgAoP");

var $ewGbf = parcelRequire("ewGbf");

var $jSInV = parcelRequire("jSInV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $52955219533c6ca2$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $52955219533c6ca2$var$getSymbolsIn = !$52955219533c6ca2$var$nativeGetSymbols ? (0, $jSInV.default) : function(object) {
    var result = [];
    while(object){
        (0, $4zeHU.default)(result, (0, $ewGbf.default)(object));
        object = (0, $FgAoP.default)(object);
    }
    return result;
};
var $52955219533c6ca2$export$2e2bcd8739ae039 = $52955219533c6ca2$var$getSymbolsIn;

});
parcelRegister("4zeHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3535d6d94cb04303$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3535d6d94cb04303$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $3535d6d94cb04303$export$2e2bcd8739ae039 = $3535d6d94cb04303$var$arrayPush;

});



parcelRegister("6CWdP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d337459fb5c1052$export$2e2bcd8739ae039; });

var $fnNfE = parcelRequire("fnNfE");

var $ewGbf = parcelRequire("ewGbf");

var $bCEuG = parcelRequire("bCEuG");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4d337459fb5c1052$var$getAllKeys(object) {
    return (0, $fnNfE.default)(object, (0, $bCEuG.default), (0, $ewGbf.default));
}
var $4d337459fb5c1052$export$2e2bcd8739ae039 = $4d337459fb5c1052$var$getAllKeys;

});
parcelRegister("fnNfE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b32f354f1e6224ec$export$2e2bcd8739ae039; });

var $4zeHU = parcelRequire("4zeHU");

var $cvQ90 = parcelRequire("cvQ90");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b32f354f1e6224ec$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $cvQ90.default)(object) ? result : (0, $4zeHU.default)(result, symbolsFunc(object));
}
var $b32f354f1e6224ec$export$2e2bcd8739ae039 = $b32f354f1e6224ec$var$baseGetAllKeys;

});


parcelRegister("05fLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00fcb14bfd3f213c$export$2e2bcd8739ae039; });

var $fnNfE = parcelRequire("fnNfE");

var $75AvF = parcelRequire("75AvF");

var $5QaB6 = parcelRequire("5QaB6");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $00fcb14bfd3f213c$var$getAllKeysIn(object) {
    return (0, $fnNfE.default)(object, (0, $5QaB6.default), (0, $75AvF.default));
}
var $00fcb14bfd3f213c$export$2e2bcd8739ae039 = $00fcb14bfd3f213c$var$getAllKeysIn;

});

parcelRegister("bdaH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8299341a43cd6d3e$export$2e2bcd8739ae039; });

var $e1rvy = parcelRequire("e1rvy");

var $fnuNy = parcelRequire("fnuNy");

var $OK9qR = parcelRequire("OK9qR");

var $iuRXK = parcelRequire("iuRXK");

var $dmGEQ = parcelRequire("dmGEQ");

var $8ypmi = parcelRequire("8ypmi");

var $jZH4M = parcelRequire("jZH4M");
/** `Object#toString` result references. */ var $8299341a43cd6d3e$var$mapTag = "[object Map]", $8299341a43cd6d3e$var$objectTag = "[object Object]", $8299341a43cd6d3e$var$promiseTag = "[object Promise]", $8299341a43cd6d3e$var$setTag = "[object Set]", $8299341a43cd6d3e$var$weakMapTag = "[object WeakMap]";
var $8299341a43cd6d3e$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $8299341a43cd6d3e$var$dataViewCtorString = (0, $jZH4M.default)((0, $e1rvy.default)), $8299341a43cd6d3e$var$mapCtorString = (0, $jZH4M.default)((0, $fnuNy.default)), $8299341a43cd6d3e$var$promiseCtorString = (0, $jZH4M.default)((0, $OK9qR.default)), $8299341a43cd6d3e$var$setCtorString = (0, $jZH4M.default)((0, $iuRXK.default)), $8299341a43cd6d3e$var$weakMapCtorString = (0, $jZH4M.default)((0, $dmGEQ.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $8299341a43cd6d3e$var$getTag = (0, $8ypmi.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $e1rvy.default) && $8299341a43cd6d3e$var$getTag(new (0, $e1rvy.default)(new ArrayBuffer(1))) != $8299341a43cd6d3e$var$dataViewTag || (0, $fnuNy.default) && $8299341a43cd6d3e$var$getTag(new (0, $fnuNy.default)) != $8299341a43cd6d3e$var$mapTag || (0, $OK9qR.default) && $8299341a43cd6d3e$var$getTag((0, $OK9qR.default).resolve()) != $8299341a43cd6d3e$var$promiseTag || (0, $iuRXK.default) && $8299341a43cd6d3e$var$getTag(new (0, $iuRXK.default)) != $8299341a43cd6d3e$var$setTag || (0, $dmGEQ.default) && $8299341a43cd6d3e$var$getTag(new (0, $dmGEQ.default)) != $8299341a43cd6d3e$var$weakMapTag) $8299341a43cd6d3e$var$getTag = function(value) {
    var result = (0, $8ypmi.default)(value), Ctor = result == $8299341a43cd6d3e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $jZH4M.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $8299341a43cd6d3e$var$dataViewCtorString:
            return $8299341a43cd6d3e$var$dataViewTag;
        case $8299341a43cd6d3e$var$mapCtorString:
            return $8299341a43cd6d3e$var$mapTag;
        case $8299341a43cd6d3e$var$promiseCtorString:
            return $8299341a43cd6d3e$var$promiseTag;
        case $8299341a43cd6d3e$var$setCtorString:
            return $8299341a43cd6d3e$var$setTag;
        case $8299341a43cd6d3e$var$weakMapCtorString:
            return $8299341a43cd6d3e$var$weakMapTag;
    }
    return result;
};
var $8299341a43cd6d3e$export$2e2bcd8739ae039 = $8299341a43cd6d3e$var$getTag;

});
parcelRegister("e1rvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3567f36c33d9e2d$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $a3567f36c33d9e2d$var$DataView = (0, $97o2V.default)((0, $65KY2.default), "DataView");
var $a3567f36c33d9e2d$export$2e2bcd8739ae039 = $a3567f36c33d9e2d$var$DataView;

});

parcelRegister("OK9qR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09887847a84b5580$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $09887847a84b5580$var$Promise = (0, $97o2V.default)((0, $65KY2.default), "Promise");
var $09887847a84b5580$export$2e2bcd8739ae039 = $09887847a84b5580$var$Promise;

});

parcelRegister("iuRXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d774e33558987876$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $d774e33558987876$var$Set = (0, $97o2V.default)((0, $65KY2.default), "Set");
var $d774e33558987876$export$2e2bcd8739ae039 = $d774e33558987876$var$Set;

});

parcelRegister("dmGEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0282d02f0d6f9c7e$export$2e2bcd8739ae039; });

var $97o2V = parcelRequire("97o2V");

var $65KY2 = parcelRequire("65KY2");
/* Built-in method references that are verified to be native. */ var $0282d02f0d6f9c7e$var$WeakMap = (0, $97o2V.default)((0, $65KY2.default), "WeakMap");
var $0282d02f0d6f9c7e$export$2e2bcd8739ae039 = $0282d02f0d6f9c7e$var$WeakMap;

});


parcelRegister("aJAyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d0a76e18a841f2d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7d0a76e18a841f2d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0a76e18a841f2d$var$hasOwnProperty = $7d0a76e18a841f2d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7d0a76e18a841f2d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7d0a76e18a841f2d$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7d0a76e18a841f2d$export$2e2bcd8739ae039 = $7d0a76e18a841f2d$var$initCloneArray;

});

parcelRegister("eMOhO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac3c8e36b2de35e0$export$2e2bcd8739ae039; });

var $hSyFY = parcelRequire("hSyFY");

var $eowSB = parcelRequire("eowSB");

var $hEgyA = parcelRequire("hEgyA");

var $7JoCD = parcelRequire("7JoCD");

var $7RyYF = parcelRequire("7RyYF");
/** `Object#toString` result references. */ var $ac3c8e36b2de35e0$var$boolTag = "[object Boolean]", $ac3c8e36b2de35e0$var$dateTag = "[object Date]", $ac3c8e36b2de35e0$var$mapTag = "[object Map]", $ac3c8e36b2de35e0$var$numberTag = "[object Number]", $ac3c8e36b2de35e0$var$regexpTag = "[object RegExp]", $ac3c8e36b2de35e0$var$setTag = "[object Set]", $ac3c8e36b2de35e0$var$stringTag = "[object String]", $ac3c8e36b2de35e0$var$symbolTag = "[object Symbol]";
var $ac3c8e36b2de35e0$var$arrayBufferTag = "[object ArrayBuffer]", $ac3c8e36b2de35e0$var$dataViewTag = "[object DataView]", $ac3c8e36b2de35e0$var$float32Tag = "[object Float32Array]", $ac3c8e36b2de35e0$var$float64Tag = "[object Float64Array]", $ac3c8e36b2de35e0$var$int8Tag = "[object Int8Array]", $ac3c8e36b2de35e0$var$int16Tag = "[object Int16Array]", $ac3c8e36b2de35e0$var$int32Tag = "[object Int32Array]", $ac3c8e36b2de35e0$var$uint8Tag = "[object Uint8Array]", $ac3c8e36b2de35e0$var$uint8ClampedTag = "[object Uint8ClampedArray]", $ac3c8e36b2de35e0$var$uint16Tag = "[object Uint16Array]", $ac3c8e36b2de35e0$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ac3c8e36b2de35e0$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ac3c8e36b2de35e0$var$arrayBufferTag:
            return (0, $hSyFY.default)(object);
        case $ac3c8e36b2de35e0$var$boolTag:
        case $ac3c8e36b2de35e0$var$dateTag:
            return new Ctor(+object);
        case $ac3c8e36b2de35e0$var$dataViewTag:
            return (0, $eowSB.default)(object, isDeep);
        case $ac3c8e36b2de35e0$var$float32Tag:
        case $ac3c8e36b2de35e0$var$float64Tag:
        case $ac3c8e36b2de35e0$var$int8Tag:
        case $ac3c8e36b2de35e0$var$int16Tag:
        case $ac3c8e36b2de35e0$var$int32Tag:
        case $ac3c8e36b2de35e0$var$uint8Tag:
        case $ac3c8e36b2de35e0$var$uint8ClampedTag:
        case $ac3c8e36b2de35e0$var$uint16Tag:
        case $ac3c8e36b2de35e0$var$uint32Tag:
            return (0, $7RyYF.default)(object, isDeep);
        case $ac3c8e36b2de35e0$var$mapTag:
            return new Ctor;
        case $ac3c8e36b2de35e0$var$numberTag:
        case $ac3c8e36b2de35e0$var$stringTag:
            return new Ctor(object);
        case $ac3c8e36b2de35e0$var$regexpTag:
            return (0, $hEgyA.default)(object);
        case $ac3c8e36b2de35e0$var$setTag:
            return new Ctor;
        case $ac3c8e36b2de35e0$var$symbolTag:
            return (0, $7JoCD.default)(object);
    }
}
var $ac3c8e36b2de35e0$export$2e2bcd8739ae039 = $ac3c8e36b2de35e0$var$initCloneByTag;

});
parcelRegister("hSyFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d04260c33ae98149$export$2e2bcd8739ae039; });

var $jVSWw = parcelRequire("jVSWw");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $d04260c33ae98149$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $jVSWw.default)(result).set(new (0, $jVSWw.default)(arrayBuffer));
    return result;
}
var $d04260c33ae98149$export$2e2bcd8739ae039 = $d04260c33ae98149$var$cloneArrayBuffer;

});
parcelRegister("jVSWw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82df5b1e3d4b099$export$2e2bcd8739ae039; });

var $65KY2 = parcelRequire("65KY2");
/** Built-in value references. */ var $e82df5b1e3d4b099$var$Uint8Array = (0, $65KY2.default).Uint8Array;
var $e82df5b1e3d4b099$export$2e2bcd8739ae039 = $e82df5b1e3d4b099$var$Uint8Array;

});


parcelRegister("eowSB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7accfcc40fc8b6a$export$2e2bcd8739ae039; });

var $hSyFY = parcelRequire("hSyFY");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $a7accfcc40fc8b6a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $hSyFY.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $a7accfcc40fc8b6a$export$2e2bcd8739ae039 = $a7accfcc40fc8b6a$var$cloneDataView;

});

parcelRegister("hEgyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd9303eda60c4c86$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $cd9303eda60c4c86$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $cd9303eda60c4c86$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $cd9303eda60c4c86$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $cd9303eda60c4c86$export$2e2bcd8739ae039 = $cd9303eda60c4c86$var$cloneRegExp;

});

parcelRegister("7JoCD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a0fd5cb61fe70d3$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");
/** Used to convert symbols to primitives and strings. */ var $5a0fd5cb61fe70d3$var$symbolProto = (0, $iQXmk.default) ? (0, $iQXmk.default).prototype : undefined, $5a0fd5cb61fe70d3$var$symbolValueOf = $5a0fd5cb61fe70d3$var$symbolProto ? $5a0fd5cb61fe70d3$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $5a0fd5cb61fe70d3$var$cloneSymbol(symbol) {
    return $5a0fd5cb61fe70d3$var$symbolValueOf ? Object($5a0fd5cb61fe70d3$var$symbolValueOf.call(symbol)) : {};
}
var $5a0fd5cb61fe70d3$export$2e2bcd8739ae039 = $5a0fd5cb61fe70d3$var$cloneSymbol;

});

parcelRegister("7RyYF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b989d76a094b295$export$2e2bcd8739ae039; });

var $hSyFY = parcelRequire("hSyFY");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $5b989d76a094b295$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $hSyFY.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $5b989d76a094b295$export$2e2bcd8739ae039 = $5b989d76a094b295$var$cloneTypedArray;

});


parcelRegister("eeWvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5dfc147ac5bfff3$export$2e2bcd8739ae039; });

var $fO4gT = parcelRequire("fO4gT");

var $FgAoP = parcelRequire("FgAoP");

var $i2xGO = parcelRequire("i2xGO");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $a5dfc147ac5bfff3$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $i2xGO.default)(object) ? (0, $fO4gT.default)((0, $FgAoP.default)(object)) : {};
}
var $a5dfc147ac5bfff3$export$2e2bcd8739ae039 = $a5dfc147ac5bfff3$var$initCloneObject;

});
parcelRegister("fO4gT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b81ed6c69e9fef27$export$2e2bcd8739ae039; });

var $6vN6O = parcelRequire("6vN6O");
/** Built-in value references. */ var $b81ed6c69e9fef27$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $b81ed6c69e9fef27$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $6vN6O.default)(proto)) return {};
        if ($b81ed6c69e9fef27$var$objectCreate) return $b81ed6c69e9fef27$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $b81ed6c69e9fef27$export$2e2bcd8739ae039 = $b81ed6c69e9fef27$var$baseCreate;

});


parcelRegister("9cm4a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b2659ef0ef28770$export$2e2bcd8739ae039; });

var $bTm70 = parcelRequire("bTm70");

var $gSwe7 = parcelRequire("gSwe7");

var $eihh9 = parcelRequire("eihh9");
/* Node.js helper references. */ var $6b2659ef0ef28770$var$nodeIsMap = (0, $eihh9.default) && (0, $eihh9.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6b2659ef0ef28770$var$isMap = $6b2659ef0ef28770$var$nodeIsMap ? (0, $gSwe7.default)($6b2659ef0ef28770$var$nodeIsMap) : (0, $bTm70.default);
var $6b2659ef0ef28770$export$2e2bcd8739ae039 = $6b2659ef0ef28770$var$isMap;

});
parcelRegister("bTm70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a85fbc1b2d0f641$export$2e2bcd8739ae039; });

var $bdaH3 = parcelRequire("bdaH3");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $8a85fbc1b2d0f641$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $8a85fbc1b2d0f641$var$baseIsMap(value) {
    return (0, $QTaGs.default)(value) && (0, $bdaH3.default)(value) == $8a85fbc1b2d0f641$var$mapTag;
}
var $8a85fbc1b2d0f641$export$2e2bcd8739ae039 = $8a85fbc1b2d0f641$var$baseIsMap;

});


parcelRegister("kO458", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f25ba4bd6d1cdd4c$export$2e2bcd8739ae039; });

var $j5r63 = parcelRequire("j5r63");

var $gSwe7 = parcelRequire("gSwe7");

var $eihh9 = parcelRequire("eihh9");
/* Node.js helper references. */ var $f25ba4bd6d1cdd4c$var$nodeIsSet = (0, $eihh9.default) && (0, $eihh9.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $f25ba4bd6d1cdd4c$var$isSet = $f25ba4bd6d1cdd4c$var$nodeIsSet ? (0, $gSwe7.default)($f25ba4bd6d1cdd4c$var$nodeIsSet) : (0, $j5r63.default);
var $f25ba4bd6d1cdd4c$export$2e2bcd8739ae039 = $f25ba4bd6d1cdd4c$var$isSet;

});
parcelRegister("j5r63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de5380ccaae8ec54$export$2e2bcd8739ae039; });

var $bdaH3 = parcelRequire("bdaH3");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $de5380ccaae8ec54$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $de5380ccaae8ec54$var$baseIsSet(value) {
    return (0, $QTaGs.default)(value) && (0, $bdaH3.default)(value) == $de5380ccaae8ec54$var$setTag;
}
var $de5380ccaae8ec54$export$2e2bcd8739ae039 = $de5380ccaae8ec54$var$baseIsSet;

});




parcelRegister("lHNrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd3f7ee507255b4$export$2e2bcd8739ae039; });

var $cs7E8 = parcelRequire("cs7E8");

var $cbaxU = parcelRequire("cbaxU");

var $cvQ90 = parcelRequire("cvQ90");

var $3sgYV = parcelRequire("3sgYV");

var $ce37V = parcelRequire("ce37V");

var $afrUq = parcelRequire("afrUq");

var $aElJT = parcelRequire("aElJT");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $fcd3f7ee507255b4$var$toPath(value) {
    if ((0, $cvQ90.default)(value)) return (0, $cs7E8.default)(value, (0, $afrUq.default));
    return (0, $3sgYV.default)(value) ? [
        value
    ] : (0, $cbaxU.default)((0, $ce37V.default)((0, $aElJT.default)(value)));
}
var $fcd3f7ee507255b4$export$2e2bcd8739ae039 = $fcd3f7ee507255b4$var$toPath;

});
parcelRegister("cs7E8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $910e07f21d96dc9b$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $910e07f21d96dc9b$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $910e07f21d96dc9b$export$2e2bcd8739ae039 = $910e07f21d96dc9b$var$arrayMap;

});

parcelRegister("3sgYV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $284128cf79457634$export$2e2bcd8739ae039; });

var $8ypmi = parcelRequire("8ypmi");

var $QTaGs = parcelRequire("QTaGs");
/** `Object#toString` result references. */ var $284128cf79457634$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $284128cf79457634$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $QTaGs.default)(value) && (0, $8ypmi.default)(value) == $284128cf79457634$var$symbolTag;
}
var $284128cf79457634$export$2e2bcd8739ae039 = $284128cf79457634$var$isSymbol;

});

parcelRegister("ce37V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e6937bf5472b58a$export$2e2bcd8739ae039; });

var $f6RQn = parcelRequire("f6RQn");
/** Used to match property names within property paths. */ var $8e6937bf5472b58a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8e6937bf5472b58a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8e6937bf5472b58a$var$stringToPath = (0, $f6RQn.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($8e6937bf5472b58a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8e6937bf5472b58a$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $8e6937bf5472b58a$export$2e2bcd8739ae039 = $8e6937bf5472b58a$var$stringToPath;

});
parcelRegister("f6RQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0012ecce009d07d$export$2e2bcd8739ae039; });

var $5TWsc = parcelRequire("5TWsc");
/** Used as the maximum memoize cache size. */ var $b0012ecce009d07d$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b0012ecce009d07d$var$memoizeCapped(func) {
    var result = (0, $5TWsc.default)(func, function(key) {
        if (cache.size === $b0012ecce009d07d$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $b0012ecce009d07d$export$2e2bcd8739ae039 = $b0012ecce009d07d$var$memoizeCapped;

});
parcelRegister("5TWsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44bf6e88affd91e5$export$2e2bcd8739ae039; });

var $jitcP = parcelRequire("jitcP");
/** Error message constants. */ var $44bf6e88affd91e5$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $44bf6e88affd91e5$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($44bf6e88affd91e5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($44bf6e88affd91e5$var$memoize.Cache || (0, $jitcP.default));
    return memoized;
}
// Expose `MapCache`.
$44bf6e88affd91e5$var$memoize.Cache = (0, $jitcP.default);
var $44bf6e88affd91e5$export$2e2bcd8739ae039 = $44bf6e88affd91e5$var$memoize;

});



parcelRegister("afrUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7760f4479642e2ed$export$2e2bcd8739ae039; });

var $3sgYV = parcelRequire("3sgYV");
/** Used as references for various `Number` constants. */ var $7760f4479642e2ed$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $7760f4479642e2ed$var$toKey(value) {
    if (typeof value == "string" || (0, $3sgYV.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$7760f4479642e2ed$var$INFINITY ? "-0" : result;
}
var $7760f4479642e2ed$export$2e2bcd8739ae039 = $7760f4479642e2ed$var$toKey;

});

parcelRegister("aElJT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c0e80c9a14886dc$export$2e2bcd8739ae039; });

var $cWZLF = parcelRequire("cWZLF");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7c0e80c9a14886dc$var$toString(value) {
    return value == null ? "" : (0, $cWZLF.default)(value);
}
var $7c0e80c9a14886dc$export$2e2bcd8739ae039 = $7c0e80c9a14886dc$var$toString;

});
parcelRegister("cWZLF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96dad0a003234232$export$2e2bcd8739ae039; });

var $iQXmk = parcelRequire("iQXmk");

var $cs7E8 = parcelRequire("cs7E8");

var $cvQ90 = parcelRequire("cvQ90");

var $3sgYV = parcelRequire("3sgYV");
/** Used as references for various `Number` constants. */ var $96dad0a003234232$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $96dad0a003234232$var$symbolProto = (0, $iQXmk.default) ? (0, $iQXmk.default).prototype : undefined, $96dad0a003234232$var$symbolToString = $96dad0a003234232$var$symbolProto ? $96dad0a003234232$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $96dad0a003234232$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $cvQ90.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $cs7E8.default)(value, $96dad0a003234232$var$baseToString) + "";
    if ((0, $3sgYV.default)(value)) return $96dad0a003234232$var$symbolToString ? $96dad0a003234232$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$96dad0a003234232$var$INFINITY ? "-0" : result;
}
var $96dad0a003234232$export$2e2bcd8739ae039 = $96dad0a003234232$var$baseToString;

});



parcelRegister("lMELy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdbdb3f7bd8930f0$export$2e2bcd8739ae039; });

var $jIw7K = parcelRequire("jIw7K");
/** Used to compose bitmasks for cloning. */ var $fdbdb3f7bd8930f0$var$CLONE_DEEP_FLAG = 1, $fdbdb3f7bd8930f0$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $fdbdb3f7bd8930f0$var$cloneDeep(value) {
    return (0, $jIw7K.default)(value, $fdbdb3f7bd8930f0$var$CLONE_DEEP_FLAG | $fdbdb3f7bd8930f0$var$CLONE_SYMBOLS_FLAG);
}
var $fdbdb3f7bd8930f0$export$2e2bcd8739ae039 = $fdbdb3f7bd8930f0$var$cloneDeep;

});


parcelRegister("34JBo", function(module, exports) {
"use strict";

});

parcelRegister("jW2oE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $fSuOO = parcelRequire("fSuOO");

var $1RTqt = parcelRequire("1RTqt");

var $8THuz = parcelRequire("8THuz");

var $99pOQ = parcelRequire("99pOQ");
var $e8354b08a44678db$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $8THuz.RawSha256();
        if (secret) {
            this.outer = new $8THuz.RawSha256();
            var inner = $e8354b08a44678db$var$bufferFromSecret(secret);
            var outer = new Uint8Array($1RTqt.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $1RTqt.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $99pOQ.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $99pOQ.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $fSuOO.__awaiter)(this, void 0, void 0, function() {
            return (0, $fSuOO.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $e8354b08a44678db$var$Sha256;
function $e8354b08a44678db$var$bufferFromSecret(secret) {
    var input = (0, $99pOQ.convertToBuffer)(secret);
    if (input.byteLength > $1RTqt.BLOCK_SIZE) {
        var bufferHash = new $8THuz.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($1RTqt.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("fSuOO", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $b8f3ce17fad48502$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $b8f3ce17fad48502$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $b8f3ce17fad48502$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b8f3ce17fad48502$var$extendStatics = function(d, b) {
    $b8f3ce17fad48502$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b8f3ce17fad48502$var$extendStatics(d, b);
};
function $b8f3ce17fad48502$export$a8ba968b8961cb8a(d, b) {
    $b8f3ce17fad48502$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b8f3ce17fad48502$export$18ce0697a983be9b = function() {
    $b8f3ce17fad48502$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8f3ce17fad48502$export$18ce0697a983be9b.apply(this, arguments);
};
function $b8f3ce17fad48502$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b8f3ce17fad48502$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b8f3ce17fad48502$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b8f3ce17fad48502$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b8f3ce17fad48502$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b8f3ce17fad48502$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b8f3ce17fad48502$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b8f3ce17fad48502$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b8f3ce17fad48502$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b8f3ce17fad48502$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b8f3ce17fad48502$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b8f3ce17fad48502$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b8f3ce17fad48502$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b8f3ce17fad48502$export$10c90e4f7922046c(v) {
    return this instanceof $b8f3ce17fad48502$export$10c90e4f7922046c ? (this.v = v, this) : new $b8f3ce17fad48502$export$10c90e4f7922046c(v);
}
function $b8f3ce17fad48502$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b8f3ce17fad48502$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b8f3ce17fad48502$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b8f3ce17fad48502$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b8f3ce17fad48502$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b8f3ce17fad48502$export$19a8beecd37a4c45 === "function" ? $b8f3ce17fad48502$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b8f3ce17fad48502$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b8f3ce17fad48502$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b8f3ce17fad48502$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b8f3ce17fad48502$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b8f3ce17fad48502$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("1RTqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("8THuz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $1RTqt = parcelRequire("1RTqt");
/**
 * @internal
 */ var $67a5326227a03a75$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($1RTqt.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $1RTqt.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $1RTqt.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $1RTqt.BLOCK_SIZE >= $1RTqt.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $1RTqt.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $1RTqt.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($1RTqt.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($1RTqt.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($1RTqt.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $1RTqt.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($1RTqt.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $67a5326227a03a75$var$RawSha256;

});

parcelRegister("99pOQ", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $8PcJ1 = parcelRequire("8PcJ1");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $8PcJ1.convertToBuffer;
    }
});

var $9vYgw = parcelRequire("9vYgw");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $9vYgw.isEmptyData;
    }
});

var $kgHji = parcelRequire("kgHji");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $kgHji.numToUint8;
    }
});

var $9HUa3 = parcelRequire("9HUa3");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $9HUa3.uint32ArrayFrom;
    }
});

});
parcelRegister("8PcJ1", function(module, exports) {

var $43wp1 = parcelRequire("43wp1");
var $66ccf51b89a53eda$require$Buffer = $43wp1.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $3GLPq = parcelRequire("3GLPq");
// Quick polyfill
var $66ccf51b89a53eda$var$fromUtf8 = typeof $66ccf51b89a53eda$require$Buffer !== "undefined" && $66ccf51b89a53eda$require$Buffer.from ? function(input) {
    return $66ccf51b89a53eda$require$Buffer.from(input, "utf8");
} : $3GLPq.fromUtf8;
function $66ccf51b89a53eda$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $66ccf51b89a53eda$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $66ccf51b89a53eda$var$convertToBuffer;

});
parcelRegister("43wp1", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $2f4093b97fdc053e$export$a143d493d941bafc; }, function (v) { return $2f4093b97fdc053e$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $2f4093b97fdc053e$export$e4cf37d7f6fb9e0a; }, function (v) { return $2f4093b97fdc053e$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $2f4093b97fdc053e$export$f99ded8fe4b79145; }, function (v) { return $2f4093b97fdc053e$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $2f4093b97fdc053e$export$599f31c3813fae4d; }, function (v) { return $2f4093b97fdc053e$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $2f4093b97fdc053e$export$a143d493d941bafc;
var $2f4093b97fdc053e$export$e4cf37d7f6fb9e0a;
var $2f4093b97fdc053e$export$f99ded8fe4b79145;
var $2f4093b97fdc053e$export$599f31c3813fae4d;
"use strict";

var $gzGF9 = parcelRequire("gzGF9");

var $ZhBnF = parcelRequire("ZhBnF");
const $2f4093b97fdc053e$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$2f4093b97fdc053e$export$a143d493d941bafc = $2f4093b97fdc053e$var$Buffer;
$2f4093b97fdc053e$export$e4cf37d7f6fb9e0a = $2f4093b97fdc053e$var$SlowBuffer;
$2f4093b97fdc053e$export$f99ded8fe4b79145 = 50;
const $2f4093b97fdc053e$var$K_MAX_LENGTH = 0x7fffffff;
$2f4093b97fdc053e$export$599f31c3813fae4d = $2f4093b97fdc053e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $2f4093b97fdc053e$var$Buffer.TYPED_ARRAY_SUPPORT = $2f4093b97fdc053e$var$typedArraySupport();
if (!$2f4093b97fdc053e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $2f4093b97fdc053e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($2f4093b97fdc053e$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$2f4093b97fdc053e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($2f4093b97fdc053e$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$2f4093b97fdc053e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $2f4093b97fdc053e$var$createBuffer(length) {
    if (length > $2f4093b97fdc053e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $2f4093b97fdc053e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $2f4093b97fdc053e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $2f4093b97fdc053e$var$allocUnsafe(arg);
    }
    return $2f4093b97fdc053e$var$from(arg, encodingOrOffset, length);
}
$2f4093b97fdc053e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $2f4093b97fdc053e$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $2f4093b97fdc053e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $2f4093b97fdc053e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($2f4093b97fdc053e$var$isInstance(value, ArrayBuffer) || value && $2f4093b97fdc053e$var$isInstance(value.buffer, ArrayBuffer)) return $2f4093b97fdc053e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($2f4093b97fdc053e$var$isInstance(value, SharedArrayBuffer) || value && $2f4093b97fdc053e$var$isInstance(value.buffer, SharedArrayBuffer))) return $2f4093b97fdc053e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $2f4093b97fdc053e$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $2f4093b97fdc053e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $2f4093b97fdc053e$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $2f4093b97fdc053e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $2f4093b97fdc053e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($2f4093b97fdc053e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($2f4093b97fdc053e$var$Buffer, Uint8Array);
function $2f4093b97fdc053e$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $2f4093b97fdc053e$var$alloc(size, fill, encoding) {
    $2f4093b97fdc053e$var$assertSize(size);
    if (size <= 0) return $2f4093b97fdc053e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $2f4093b97fdc053e$var$createBuffer(size).fill(fill, encoding) : $2f4093b97fdc053e$var$createBuffer(size).fill(fill);
    return $2f4093b97fdc053e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $2f4093b97fdc053e$var$Buffer.alloc = function(size, fill, encoding) {
    return $2f4093b97fdc053e$var$alloc(size, fill, encoding);
};
function $2f4093b97fdc053e$var$allocUnsafe(size) {
    $2f4093b97fdc053e$var$assertSize(size);
    return $2f4093b97fdc053e$var$createBuffer(size < 0 ? 0 : $2f4093b97fdc053e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $2f4093b97fdc053e$var$Buffer.allocUnsafe = function(size) {
    return $2f4093b97fdc053e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $2f4093b97fdc053e$var$Buffer.allocUnsafeSlow = function(size) {
    return $2f4093b97fdc053e$var$allocUnsafe(size);
};
function $2f4093b97fdc053e$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$2f4093b97fdc053e$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $2f4093b97fdc053e$var$byteLength(string, encoding) | 0;
    let buf = $2f4093b97fdc053e$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $2f4093b97fdc053e$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $2f4093b97fdc053e$var$checked(array.length) | 0;
    const buf = $2f4093b97fdc053e$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $2f4093b97fdc053e$var$fromArrayView(arrayView) {
    if ($2f4093b97fdc053e$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $2f4093b97fdc053e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $2f4093b97fdc053e$var$fromArrayLike(arrayView);
}
function $2f4093b97fdc053e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $2f4093b97fdc053e$var$Buffer.prototype);
    return buf;
}
function $2f4093b97fdc053e$var$fromObject(obj) {
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(obj)) {
        const len = $2f4093b97fdc053e$var$checked(obj.length) | 0;
        const buf = $2f4093b97fdc053e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $2f4093b97fdc053e$var$numberIsNaN(obj.length)) return $2f4093b97fdc053e$var$createBuffer(0);
        return $2f4093b97fdc053e$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $2f4093b97fdc053e$var$fromArrayLike(obj.data);
}
function $2f4093b97fdc053e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $2f4093b97fdc053e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $2f4093b97fdc053e$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $2f4093b97fdc053e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $2f4093b97fdc053e$var$Buffer.alloc(+length);
}
$2f4093b97fdc053e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $2f4093b97fdc053e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$2f4093b97fdc053e$var$Buffer.compare = function compare(a, b) {
    if ($2f4093b97fdc053e$var$isInstance(a, Uint8Array)) a = $2f4093b97fdc053e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($2f4093b97fdc053e$var$isInstance(b, Uint8Array)) b = $2f4093b97fdc053e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(a) || !$2f4093b97fdc053e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$2f4093b97fdc053e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$2f4093b97fdc053e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $2f4093b97fdc053e$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $2f4093b97fdc053e$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($2f4093b97fdc053e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) buf = $2f4093b97fdc053e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $2f4093b97fdc053e$var$byteLength(string, encoding) {
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $2f4093b97fdc053e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $2f4093b97fdc053e$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $2f4093b97fdc053e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $2f4093b97fdc053e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$2f4093b97fdc053e$var$Buffer.byteLength = $2f4093b97fdc053e$var$byteLength;
function $2f4093b97fdc053e$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $2f4093b97fdc053e$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $2f4093b97fdc053e$var$utf8Slice(this, start, end);
        case "ascii":
            return $2f4093b97fdc053e$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $2f4093b97fdc053e$var$latin1Slice(this, start, end);
        case "base64":
            return $2f4093b97fdc053e$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $2f4093b97fdc053e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$2f4093b97fdc053e$var$Buffer.prototype._isBuffer = true;
function $2f4093b97fdc053e$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$2f4093b97fdc053e$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$2f4093b97fdc053e$var$swap(this, i, i + 1);
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $2f4093b97fdc053e$var$swap(this, i, i + 3);
        $2f4093b97fdc053e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $2f4093b97fdc053e$var$swap(this, i, i + 7);
        $2f4093b97fdc053e$var$swap(this, i + 1, i + 6);
        $2f4093b97fdc053e$var$swap(this, i + 2, i + 5);
        $2f4093b97fdc053e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $2f4093b97fdc053e$var$utf8Slice(this, 0, length);
    return $2f4093b97fdc053e$var$slowToString.apply(this, arguments);
};
$2f4093b97fdc053e$var$Buffer.prototype.toLocaleString = $2f4093b97fdc053e$var$Buffer.prototype.toString;
$2f4093b97fdc053e$var$Buffer.prototype.equals = function equals(b) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $2f4093b97fdc053e$var$Buffer.compare(this, b) === 0;
};
$2f4093b97fdc053e$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $2f4093b97fdc053e$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($2f4093b97fdc053e$var$customInspectSymbol) $2f4093b97fdc053e$var$Buffer.prototype[$2f4093b97fdc053e$var$customInspectSymbol] = $2f4093b97fdc053e$var$Buffer.prototype.inspect;
$2f4093b97fdc053e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($2f4093b97fdc053e$var$isInstance(target, Uint8Array)) target = $2f4093b97fdc053e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $2f4093b97fdc053e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($2f4093b97fdc053e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $2f4093b97fdc053e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $2f4093b97fdc053e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $2f4093b97fdc053e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $2f4093b97fdc053e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$2f4093b97fdc053e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$2f4093b97fdc053e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $2f4093b97fdc053e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$2f4093b97fdc053e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $2f4093b97fdc053e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $2f4093b97fdc053e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($2f4093b97fdc053e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $2f4093b97fdc053e$var$utf8Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $2f4093b97fdc053e$var$asciiWrite(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$asciiToBytes(string), buf, offset, length);
}
function $2f4093b97fdc053e$var$base64Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$base64ToBytes(string), buf, offset, length);
}
function $2f4093b97fdc053e$var$ucs2Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$2f4093b97fdc053e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $2f4093b97fdc053e$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $2f4093b97fdc053e$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $2f4093b97fdc053e$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $2f4093b97fdc053e$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $2f4093b97fdc053e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$2f4093b97fdc053e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $2f4093b97fdc053e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gzGF9.fromByteArray(buf);
    else return $gzGF9.fromByteArray(buf.slice(start, end));
}
function $2f4093b97fdc053e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $2f4093b97fdc053e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $2f4093b97fdc053e$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $2f4093b97fdc053e$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $2f4093b97fdc053e$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $2f4093b97fdc053e$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $2f4093b97fdc053e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $2f4093b97fdc053e$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$2f4093b97fdc053e$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $2f4093b97fdc053e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $2f4093b97fdc053e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$2f4093b97fdc053e$var$Buffer.prototype.readUintLE = $2f4093b97fdc053e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUintBE = $2f4093b97fdc053e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint8 = $2f4093b97fdc053e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint16LE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint16BE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint32LE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint32BE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$2f4093b97fdc053e$var$Buffer.prototype.readBigUInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$2f4093b97fdc053e$var$Buffer.prototype.readBigUInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$2f4093b97fdc053e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$2f4093b97fdc053e$var$Buffer.prototype.readBigInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$2f4093b97fdc053e$var$Buffer.prototype.readBigInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$2f4093b97fdc053e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return $ZhBnF.read(this, offset, true, 23, 4);
};
$2f4093b97fdc053e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return $ZhBnF.read(this, offset, false, 23, 4);
};
$2f4093b97fdc053e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 8, this.length);
    return $ZhBnF.read(this, offset, true, 52, 8);
};
$2f4093b97fdc053e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 8, this.length);
    return $ZhBnF.read(this, offset, false, 52, 8);
};
function $2f4093b97fdc053e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$2f4093b97fdc053e$var$Buffer.prototype.writeUintLE = $2f4093b97fdc053e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUintBE = $2f4093b97fdc053e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint8 = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint16LE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint16BE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint32LE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint32BE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $2f4093b97fdc053e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $2f4093b97fdc053e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeBigUInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeBigUInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeBigInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeBigInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $2f4093b97fdc053e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ZhBnF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeFloat(this, value, offset, true, noAssert);
};
$2f4093b97fdc053e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeFloat(this, value, offset, false, noAssert);
};
function $2f4093b97fdc053e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ZhBnF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeDouble(this, value, offset, true, noAssert);
};
$2f4093b97fdc053e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$2f4093b97fdc053e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$2f4093b97fdc053e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$2f4093b97fdc053e$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $2f4093b97fdc053e$var$Buffer.isBuffer(val) ? val : $2f4093b97fdc053e$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $2f4093b97fdc053e$var$errors = {};
function $2f4093b97fdc053e$var$E(sym, getMessage, Base) {
    $2f4093b97fdc053e$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$2f4093b97fdc053e$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$2f4093b97fdc053e$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$2f4093b97fdc053e$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $2f4093b97fdc053e$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $2f4093b97fdc053e$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $2f4093b97fdc053e$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $2f4093b97fdc053e$var$checkBounds(buf, offset, byteLength) {
    $2f4093b97fdc053e$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $2f4093b97fdc053e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $2f4093b97fdc053e$var$checkBounds(buf, offset, byteLength);
}
function $2f4093b97fdc053e$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $2f4093b97fdc053e$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $2f4093b97fdc053e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $2f4093b97fdc053e$var$validateNumber(value, type);
        throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $2f4093b97fdc053e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $2f4093b97fdc053e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $2f4093b97fdc053e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($2f4093b97fdc053e$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $2f4093b97fdc053e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $2f4093b97fdc053e$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $2f4093b97fdc053e$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $2f4093b97fdc053e$var$base64ToBytes(str) {
    return $gzGF9.toByteArray($2f4093b97fdc053e$var$base64clean(str));
}
function $2f4093b97fdc053e$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $2f4093b97fdc053e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $2f4093b97fdc053e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $2f4093b97fdc053e$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $2f4093b97fdc053e$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $2f4093b97fdc053e$var$BufferBigIntNotDefined : fn;
}
function $2f4093b97fdc053e$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("gzGF9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $c1110228c8ce65d7$export$d622b2ad8d90c771; }, function (v) { return $c1110228c8ce65d7$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $c1110228c8ce65d7$export$6100ba28696e12de; }, function (v) { return $c1110228c8ce65d7$export$6100ba28696e12de = v; });
var $c1110228c8ce65d7$export$a48f0734ac7c2329;
var $c1110228c8ce65d7$export$d622b2ad8d90c771;
var $c1110228c8ce65d7$export$6100ba28696e12de;
"use strict";
$c1110228c8ce65d7$export$a48f0734ac7c2329 = $c1110228c8ce65d7$var$byteLength;
$c1110228c8ce65d7$export$d622b2ad8d90c771 = $c1110228c8ce65d7$var$toByteArray;
$c1110228c8ce65d7$export$6100ba28696e12de = $c1110228c8ce65d7$var$fromByteArray;
var $c1110228c8ce65d7$var$lookup = [];
var $c1110228c8ce65d7$var$revLookup = [];
var $c1110228c8ce65d7$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $c1110228c8ce65d7$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $c1110228c8ce65d7$var$i = 0, $c1110228c8ce65d7$var$len = $c1110228c8ce65d7$var$code.length; $c1110228c8ce65d7$var$i < $c1110228c8ce65d7$var$len; ++$c1110228c8ce65d7$var$i){
    $c1110228c8ce65d7$var$lookup[$c1110228c8ce65d7$var$i] = $c1110228c8ce65d7$var$code[$c1110228c8ce65d7$var$i];
    $c1110228c8ce65d7$var$revLookup[$c1110228c8ce65d7$var$code.charCodeAt($c1110228c8ce65d7$var$i)] = $c1110228c8ce65d7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c1110228c8ce65d7$var$revLookup["-".charCodeAt(0)] = 62;
$c1110228c8ce65d7$var$revLookup["_".charCodeAt(0)] = 63;
function $c1110228c8ce65d7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c1110228c8ce65d7$var$byteLength(b64) {
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$toByteArray(b64) {
    var tmp;
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c1110228c8ce65d7$var$Arr($c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 18 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 2 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 10 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c1110228c8ce65d7$var$tripletToBase64(num) {
    return $c1110228c8ce65d7$var$lookup[num >> 18 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 12 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 6 & 0x3F] + $c1110228c8ce65d7$var$lookup[num & 0x3F];
}
function $c1110228c8ce65d7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c1110228c8ce65d7$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $c1110228c8ce65d7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c1110228c8ce65d7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 2] + $c1110228c8ce65d7$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 10] + $c1110228c8ce65d7$var$lookup[tmp >> 4 & 0x3F] + $c1110228c8ce65d7$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("ZhBnF", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $0b8359fe6fd9cd49$export$aafa59e2e03f2942; }, function (v) { return $0b8359fe6fd9cd49$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $0b8359fe6fd9cd49$export$68d8715fc104d294; }, function (v) { return $0b8359fe6fd9cd49$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $0b8359fe6fd9cd49$export$aafa59e2e03f2942;
var $0b8359fe6fd9cd49$export$68d8715fc104d294;
$0b8359fe6fd9cd49$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$0b8359fe6fd9cd49$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3GLPq", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $2afa650c5f0cb534$export$c7c5cef950a4d2fc; });

var $koztH = parcelRequire("koztH");

var $adejQ = parcelRequire("adejQ");
const $2afa650c5f0cb534$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $adejQ.fromUtf8)(input) : (0, $koztH.fromUtf8)(input);
const $2afa650c5f0cb534$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $adejQ.toUtf8)(input) : (0, $koztH.toUtf8)(input);

});
parcelRegister("koztH", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $ed9191b63f3ecc04$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $ed9191b63f3ecc04$export$b4b216764bb846eb; });
const $ed9191b63f3ecc04$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $ed9191b63f3ecc04$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("adejQ", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $76f639bcb3f750d9$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $76f639bcb3f750d9$export$b4b216764bb846eb; });
function $76f639bcb3f750d9$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $76f639bcb3f750d9$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("9vYgw", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $6ed5c1ca2b6e925b$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $6ed5c1ca2b6e925b$var$isEmptyData;

});

parcelRegister("kgHji", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $ec16e5cae40e7c1c$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $ec16e5cae40e7c1c$var$numToUint8;

});

parcelRegister("9HUa3", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $01d2e5f65106c0e3$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $01d2e5f65106c0e3$var$uint32ArrayFrom;

});



parcelRegister("hdWZo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c8a16896c229eb2e$export$2e2bcd8739ae039; });
function $c8a16896c229eb2e$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("gy0H7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0c05c3653aedcf3$var$assertString;
function $c0c05c3653aedcf3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c0c05c3653aedcf3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c0c05c3653aedcf3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c0c05c3653aedcf3$var$_typeof(obj);
}
function $c0c05c3653aedcf3$var$assertString(input) {
    var isString = typeof input === "string" || input instanceof String;
    if (!isString) {
        var invalidType = $c0c05c3653aedcf3$var$_typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ii6fL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d50ec22d462d6928$var$isByteLength;

var $d50ec22d462d6928$var$_assertString = $d50ec22d462d6928$var$_interopRequireDefault((parcelRequire("gy0H7")));
function $d50ec22d462d6928$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d50ec22d462d6928$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d50ec22d462d6928$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d50ec22d462d6928$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d50ec22d462d6928$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $d50ec22d462d6928$var$isByteLength(str, options) {
    (0, $d50ec22d462d6928$var$_assertString.default)(str);
    var min;
    var max;
    if ($d50ec22d462d6928$var$_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === "undefined" || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bk0Dc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83e20d52ffed2cd0$var$isFQDN;

var $83e20d52ffed2cd0$var$_assertString = $83e20d52ffed2cd0$var$_interopRequireDefault((parcelRequire("gy0H7")));

var $83e20d52ffed2cd0$var$_merge = $83e20d52ffed2cd0$var$_interopRequireDefault((parcelRequire("9Yb7c")));
function $83e20d52ffed2cd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $83e20d52ffed2cd0$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $83e20d52ffed2cd0$var$isFQDN(str, options) {
    (0, $83e20d52ffed2cd0$var$_assertString.default)(str);
    options = (0, $83e20d52ffed2cd0$var$_merge.default)(options, $83e20d52ffed2cd0$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === ".") str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf("*.") === 0) str = str.substring(2);
    var parts = str.split(".");
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
         // disallow spaces
        if (/\s/.test(tld)) return false;
    } // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
         // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
         // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("9Yb7c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $742256e6aee8e0df$var$merge;
function $742256e6aee8e0df$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === "undefined") obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("jKz62", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e60d899855a159fc$var$isIP;

var $e60d899855a159fc$var$_assertString = $e60d899855a159fc$var$_interopRequireDefault((parcelRequire("gy0H7")));
function $e60d899855a159fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $e60d899855a159fc$var$IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var $e60d899855a159fc$var$IPv4AddressFormat = "(".concat($e60d899855a159fc$var$IPv4SegmentFormat, "[.]){3}").concat($e60d899855a159fc$var$IPv4SegmentFormat);
var $e60d899855a159fc$var$IPv4AddressRegExp = new RegExp("^".concat($e60d899855a159fc$var$IPv4AddressFormat, "$"));
var $e60d899855a159fc$var$IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var $e60d899855a159fc$var$IPv6AddressRegExp = new RegExp("^(" + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){7}(?:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){6}(?:").concat($e60d899855a159fc$var$IPv4AddressFormat, "|:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){5}(?::").concat($e60d899855a159fc$var$IPv4AddressFormat, "|(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){4}(?:(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){0,1}:").concat($e60d899855a159fc$var$IPv4AddressFormat, "|(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){3}(?:(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){0,2}:").concat($e60d899855a159fc$var$IPv4AddressFormat, "|(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){2}(?:(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){0,3}:").concat($e60d899855a159fc$var$IPv4AddressFormat, "|(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($e60d899855a159fc$var$IPv6SegmentFormat, ":){1}(?:(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){0,4}:").concat($e60d899855a159fc$var$IPv4AddressFormat, "|(:").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($e60d899855a159fc$var$IPv6SegmentFormat, "){0,5}:").concat($e60d899855a159fc$var$IPv4AddressFormat, "|(?::").concat($e60d899855a159fc$var$IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
function $e60d899855a159fc$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    (0, $e60d899855a159fc$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $e60d899855a159fc$var$isIP(str, 4) || $e60d899855a159fc$var$isIP(str, 6);
    if (version === "4") return $e60d899855a159fc$var$IPv4AddressRegExp.test(str);
    if (version === "6") return $e60d899855a159fc$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("57utv", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $3ba53eda535cc01a$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $3ba53eda535cc01a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("izE7b", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $d85a9cd50fc7884f$export$306c0aa65ff9ec16; }, function (v) { return $d85a9cd50fc7884f$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d85a9cd50fc7884f$export$306c0aa65ff9ec16;
"use strict";

var $2hDQc = parcelRequire("2hDQc");
function $d85a9cd50fc7884f$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d85a9cd50fc7884f$var$k = "function" === typeof Object.is ? Object.is : $d85a9cd50fc7884f$var$h, $d85a9cd50fc7884f$var$l = $2hDQc.useState, $d85a9cd50fc7884f$var$m = $2hDQc.useEffect, $d85a9cd50fc7884f$var$n = $2hDQc.useLayoutEffect, $d85a9cd50fc7884f$var$p = $2hDQc.useDebugValue;
function $d85a9cd50fc7884f$var$q(a, b) {
    var d = b(), f = $d85a9cd50fc7884f$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $d85a9cd50fc7884f$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $d85a9cd50fc7884f$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $d85a9cd50fc7884f$var$m(function() {
        $d85a9cd50fc7884f$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $d85a9cd50fc7884f$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $d85a9cd50fc7884f$var$p(d);
    return d;
}
function $d85a9cd50fc7884f$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$d85a9cd50fc7884f$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $d85a9cd50fc7884f$var$t(a, b) {
    return b();
}
var $d85a9cd50fc7884f$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $d85a9cd50fc7884f$var$t : $d85a9cd50fc7884f$var$q;
$d85a9cd50fc7884f$export$306c0aa65ff9ec16 = void 0 !== $2hDQc.useSyncExternalStore ? $2hDQc.useSyncExternalStore : $d85a9cd50fc7884f$var$u;

});

parcelRegister("33A3K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $239d9f95e6f36690$export$bf730a2d8bf68b42; }, function (v) { return $239d9f95e6f36690$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $239d9f95e6f36690$export$bf730a2d8bf68b42;
"use strict";

var $2hDQc = parcelRequire("2hDQc");

var $6vtlW = parcelRequire("6vtlW");
function $239d9f95e6f36690$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $239d9f95e6f36690$var$q = "function" === typeof Object.is ? Object.is : $239d9f95e6f36690$var$p, $239d9f95e6f36690$var$r = $6vtlW.useSyncExternalStore, $239d9f95e6f36690$var$t = $2hDQc.useRef, $239d9f95e6f36690$var$u = $2hDQc.useEffect, $239d9f95e6f36690$var$v = $2hDQc.useMemo, $239d9f95e6f36690$var$w = $2hDQc.useDebugValue;
$239d9f95e6f36690$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $239d9f95e6f36690$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $239d9f95e6f36690$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($239d9f95e6f36690$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $239d9f95e6f36690$var$r(a, c[0], c[1]);
    $239d9f95e6f36690$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $239d9f95e6f36690$var$w(d);
    return d;
};

});
parcelRegister("6vtlW", function(module, exports) {
"use strict";

module.exports = (parcelRequire("izE7b"));

});


parcelRegister("5fK8z", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $3d32245c44598ff5$export$a7c73072b1a182ae; }, function (v) { return $3d32245c44598ff5$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $3d32245c44598ff5$export$9f27bc3417b4524d; }, function (v) { return $3d32245c44598ff5$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $3d32245c44598ff5$export$db77ccec0bb4ccac; }, function (v) { return $3d32245c44598ff5$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $3d32245c44598ff5$export$8392c0c9d3dcbd35; }, function (v) { return $3d32245c44598ff5$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3d32245c44598ff5$export$ffb0004e005737fa; }, function (v) { return $3d32245c44598ff5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $3d32245c44598ff5$export$b624eff549462981; }, function (v) { return $3d32245c44598ff5$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $3d32245c44598ff5$export$7897aa7841a5380c; }, function (v) { return $3d32245c44598ff5$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $3d32245c44598ff5$export$602eac185826482c; }, function (v) { return $3d32245c44598ff5$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $3d32245c44598ff5$export$e2c29f18771995cb; }, function (v) { return $3d32245c44598ff5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3d32245c44598ff5$export$5f8d39834fd61797; }, function (v) { return $3d32245c44598ff5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3d32245c44598ff5$export$74bf444e3cd11ea5; }, function (v) { return $3d32245c44598ff5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $3d32245c44598ff5$export$998bcd577473dd93; }, function (v) { return $3d32245c44598ff5$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $3d32245c44598ff5$export$92387174baf9b227; }, function (v) { return $3d32245c44598ff5$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $3d32245c44598ff5$export$ec112efeb987d9c6; }, function (v) { return $3d32245c44598ff5$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $3d32245c44598ff5$export$b706b080d889d2c9; }, function (v) { return $3d32245c44598ff5$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $3d32245c44598ff5$export$5be5a87408f70ddc; }, function (v) { return $3d32245c44598ff5$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $3d32245c44598ff5$export$45a5e7f76e0caa8d; }, function (v) { return $3d32245c44598ff5$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $3d32245c44598ff5$export$455c2e768291efa6; }, function (v) { return $3d32245c44598ff5$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $3d32245c44598ff5$export$9522e17588c12572; }, function (v) { return $3d32245c44598ff5$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $3d32245c44598ff5$export$2110ac352bb060b9; }, function (v) { return $3d32245c44598ff5$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $3d32245c44598ff5$export$56885ab8b9c456ab; }, function (v) { return $3d32245c44598ff5$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $3d32245c44598ff5$export$d927fcb6adf8f9de; }, function (v) { return $3d32245c44598ff5$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $3d32245c44598ff5$export$b82d16f27459e05a; }, function (v) { return $3d32245c44598ff5$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $3d32245c44598ff5$export$522c17b4f5e123e8; }, function (v) { return $3d32245c44598ff5$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $3d32245c44598ff5$export$1aabd8a0274ecfd6; }, function (v) { return $3d32245c44598ff5$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $3d32245c44598ff5$export$3d6c20d97e46b957; }, function (v) { return $3d32245c44598ff5$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $3d32245c44598ff5$export$9b621391a187a31a; }, function (v) { return $3d32245c44598ff5$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $3d32245c44598ff5$export$f5bbd400c2f4426f; }, function (v) { return $3d32245c44598ff5$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d32245c44598ff5$export$a7c73072b1a182ae;
var $3d32245c44598ff5$export$9f27bc3417b4524d;
var $3d32245c44598ff5$export$db77ccec0bb4ccac;
var $3d32245c44598ff5$export$8392c0c9d3dcbd35;
var $3d32245c44598ff5$export$ffb0004e005737fa;
var $3d32245c44598ff5$export$b624eff549462981;
var $3d32245c44598ff5$export$7897aa7841a5380c;
var $3d32245c44598ff5$export$602eac185826482c;
var $3d32245c44598ff5$export$e2c29f18771995cb;
var $3d32245c44598ff5$export$5f8d39834fd61797;
var $3d32245c44598ff5$export$74bf444e3cd11ea5;
var $3d32245c44598ff5$export$998bcd577473dd93;
var $3d32245c44598ff5$export$92387174baf9b227;
var $3d32245c44598ff5$export$ec112efeb987d9c6;
var $3d32245c44598ff5$export$b706b080d889d2c9;
var $3d32245c44598ff5$export$5be5a87408f70ddc;
var $3d32245c44598ff5$export$45a5e7f76e0caa8d;
var $3d32245c44598ff5$export$455c2e768291efa6;
var $3d32245c44598ff5$export$9522e17588c12572;
var $3d32245c44598ff5$export$2110ac352bb060b9;
var $3d32245c44598ff5$export$56885ab8b9c456ab;
var $3d32245c44598ff5$export$d927fcb6adf8f9de;
var $3d32245c44598ff5$export$b82d16f27459e05a;
var $3d32245c44598ff5$export$522c17b4f5e123e8;
var $3d32245c44598ff5$export$1aabd8a0274ecfd6;
var $3d32245c44598ff5$export$3d6c20d97e46b957;
var $3d32245c44598ff5$export$9b621391a187a31a;
var $3d32245c44598ff5$export$f5bbd400c2f4426f;
"use strict";
var $3d32245c44598ff5$var$b = Symbol.for("react.element"), $3d32245c44598ff5$var$c = Symbol.for("react.portal"), $3d32245c44598ff5$var$d = Symbol.for("react.fragment"), $3d32245c44598ff5$var$e = Symbol.for("react.strict_mode"), $3d32245c44598ff5$var$f = Symbol.for("react.profiler"), $3d32245c44598ff5$var$g = Symbol.for("react.provider"), $3d32245c44598ff5$var$h = Symbol.for("react.context"), $3d32245c44598ff5$var$k = Symbol.for("react.server_context"), $3d32245c44598ff5$var$l = Symbol.for("react.forward_ref"), $3d32245c44598ff5$var$m = Symbol.for("react.suspense"), $3d32245c44598ff5$var$n = Symbol.for("react.suspense_list"), $3d32245c44598ff5$var$p = Symbol.for("react.memo"), $3d32245c44598ff5$var$q = Symbol.for("react.lazy"), $3d32245c44598ff5$var$t = Symbol.for("react.offscreen"), $3d32245c44598ff5$var$u;
$3d32245c44598ff5$var$u = Symbol.for("react.module.reference");
function $3d32245c44598ff5$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $3d32245c44598ff5$var$b:
                switch(a = a.type, a){
                    case $3d32245c44598ff5$var$d:
                    case $3d32245c44598ff5$var$f:
                    case $3d32245c44598ff5$var$e:
                    case $3d32245c44598ff5$var$m:
                    case $3d32245c44598ff5$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3d32245c44598ff5$var$k:
                            case $3d32245c44598ff5$var$h:
                            case $3d32245c44598ff5$var$l:
                            case $3d32245c44598ff5$var$q:
                            case $3d32245c44598ff5$var$p:
                            case $3d32245c44598ff5$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $3d32245c44598ff5$var$c:
                return r;
        }
    }
}
$3d32245c44598ff5$export$a7c73072b1a182ae = $3d32245c44598ff5$var$h;
$3d32245c44598ff5$export$9f27bc3417b4524d = $3d32245c44598ff5$var$g;
$3d32245c44598ff5$export$db77ccec0bb4ccac = $3d32245c44598ff5$var$b;
$3d32245c44598ff5$export$8392c0c9d3dcbd35 = $3d32245c44598ff5$var$l;
$3d32245c44598ff5$export$ffb0004e005737fa = $3d32245c44598ff5$var$d;
$3d32245c44598ff5$export$b624eff549462981 = $3d32245c44598ff5$var$q;
$3d32245c44598ff5$export$7897aa7841a5380c = $3d32245c44598ff5$var$p;
$3d32245c44598ff5$export$602eac185826482c = $3d32245c44598ff5$var$c;
$3d32245c44598ff5$export$e2c29f18771995cb = $3d32245c44598ff5$var$f;
$3d32245c44598ff5$export$5f8d39834fd61797 = $3d32245c44598ff5$var$e;
$3d32245c44598ff5$export$74bf444e3cd11ea5 = $3d32245c44598ff5$var$m;
$3d32245c44598ff5$export$998bcd577473dd93 = $3d32245c44598ff5$var$n;
$3d32245c44598ff5$export$92387174baf9b227 = function() {
    return !1;
};
$3d32245c44598ff5$export$ec112efeb987d9c6 = function() {
    return !1;
};
$3d32245c44598ff5$export$b706b080d889d2c9 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$h;
};
$3d32245c44598ff5$export$5be5a87408f70ddc = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$g;
};
$3d32245c44598ff5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3d32245c44598ff5$var$b;
};
$3d32245c44598ff5$export$455c2e768291efa6 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$l;
};
$3d32245c44598ff5$export$9522e17588c12572 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$d;
};
$3d32245c44598ff5$export$2110ac352bb060b9 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$q;
};
$3d32245c44598ff5$export$56885ab8b9c456ab = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$p;
};
$3d32245c44598ff5$export$d927fcb6adf8f9de = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$c;
};
$3d32245c44598ff5$export$b82d16f27459e05a = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$f;
};
$3d32245c44598ff5$export$522c17b4f5e123e8 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$e;
};
$3d32245c44598ff5$export$1aabd8a0274ecfd6 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$m;
};
$3d32245c44598ff5$export$3d6c20d97e46b957 = function(a) {
    return $3d32245c44598ff5$var$v(a) === $3d32245c44598ff5$var$n;
};
$3d32245c44598ff5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3d32245c44598ff5$var$d || a === $3d32245c44598ff5$var$f || a === $3d32245c44598ff5$var$e || a === $3d32245c44598ff5$var$m || a === $3d32245c44598ff5$var$n || a === $3d32245c44598ff5$var$t || "object" === typeof a && null !== a && (a.$$typeof === $3d32245c44598ff5$var$q || a.$$typeof === $3d32245c44598ff5$var$p || a.$$typeof === $3d32245c44598ff5$var$g || a.$$typeof === $3d32245c44598ff5$var$h || a.$$typeof === $3d32245c44598ff5$var$l || a.$$typeof === $3d32245c44598ff5$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$3d32245c44598ff5$export$f5bbd400c2f4426f = $3d32245c44598ff5$var$v;

});

parcelRegister("kNG5d", function(module, exports) {

var $90DZ0 = parcelRequire("90DZ0");

var $8HDCV = parcelRequire("8HDCV");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $90DZ0.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8HDCV;
module.exports = isBuffer;

});
parcelRegister("90DZ0", function(module, exports) {

var $209Wz = parcelRequire("209Wz");
/** Detect free variable `self`. */ var $68f320efee199526$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $68f320efee199526$var$root = $209Wz || $68f320efee199526$var$freeSelf || Function("return this")();
module.exports = $68f320efee199526$var$root;

});
parcelRegister("209Wz", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $17534b7afc6b7691$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $17534b7afc6b7691$var$freeGlobal;

});


parcelRegister("8HDCV", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $656113ec6f9cb300$var$stubFalse() {
    return false;
}
module.exports = $656113ec6f9cb300$var$stubFalse;

});


parcelRegister("61667", function(module, exports) {

var $209Wz = parcelRequire("209Wz");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $209Wz.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("assjx", function(module, exports) {

var $90DZ0 = parcelRequire("90DZ0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $90DZ0.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("hAnjf", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $koHCo.default;
    }
});

var $koHCo = parcelRequire("koHCo");

});
parcelRegister("koHCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed97e2318a549ed6$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");

var $iOTXZ = parcelRequire("iOTXZ");

var $592Nh = parcelRequire("592Nh");
"use client";
function $ed97e2318a549ed6$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $iOTXZ.default), (0, $kxIgO.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $iOTXZ.default).muiName;
    return /*#__PURE__*/ $2hDQc.memo(/*#__PURE__*/ $2hDQc.forwardRef(Component));
}

});
parcelRegister("kxIgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef493adc5391b9a9$export$2e2bcd8739ae039; });
function $ef493adc5391b9a9$export$2e2bcd8739ae039() {
    $ef493adc5391b9a9$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef493adc5391b9a9$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("iOTXZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db384f4ce3666395$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $lfMLv = parcelRequire("lfMLv");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $k1xdp = parcelRequire("k1xdp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $db384f4ce3666395$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $db384f4ce3666395$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $lfMLv.default)(color)}`,
            `fontSize${(0, $lfMLv.default)(fontSize)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $k1xdp.getSvgIconUtilityClass), classes);
};
const $db384f4ce3666395$var$SvgIconRoot = (0, $fhlQp.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $lfMLv.default)(ownerState.color)}`],
            styles[`fontSize${(0, $lfMLv.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $db384f4ce3666395$var$SvgIcon = /*#__PURE__*/ $2hDQc.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $gZOiq.default)(props, $db384f4ce3666395$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $2hDQc.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $db384f4ce3666395$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($db384f4ce3666395$var$SvgIconRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $592Nh.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$db384f4ce3666395$var$SvgIcon.muiName = "SvgIcon";
var $db384f4ce3666395$export$2e2bcd8739ae039 = $db384f4ce3666395$var$SvgIcon;

});
parcelRegister("gZOiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5f95b9a7f6886f6$export$2e2bcd8739ae039; });
function $c5f95b9a7f6886f6$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("fLRFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70dd49141157ded8$export$2e2bcd8739ae039; });
function $70dd49141157ded8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $70dd49141157ded8$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $70dd49141157ded8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $70dd49141157ded8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $70dd49141157ded8$export$2e2bcd8739ae039 = $70dd49141157ded8$export$4f5d2d50c9deca37;

});

parcelRegister("dJnC1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ff1cb35b54d3184$export$2e2bcd8739ae039; });
function $9ff1cb35b54d3184$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("lfMLv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f790d36c27271a34$export$2e2bcd8739ae039; });

var $cgn0z = parcelRequire("cgn0z");
var $f790d36c27271a34$export$2e2bcd8739ae039 = (0, $cgn0z.default);

});
parcelRegister("cgn0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ed8d397863e9583$export$2e2bcd8739ae039; });

var $e79HO = parcelRequire("e79HO");
function $8ed8d397863e9583$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $e79HO.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("e79HO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4693f7af2ee0826$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui-internal/babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $a4693f7af2ee0826$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("afHYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $776d6ba347ab4caf$export$2e2bcd8739ae039; });

var $lEYqa = parcelRequire("lEYqa");

var $7D60m = parcelRequire("7D60m");

var $3apk9 = parcelRequire("3apk9");
"use client";
function $776d6ba347ab4caf$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $lEYqa.default)({
        props: props,
        name: name,
        defaultTheme: $7D60m.default,
        themeId: (0, $3apk9.default)
    });
}

});
parcelRegister("lEYqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc4c33bddfe21121$export$2e2bcd8739ae039; });

var $l6gEk = parcelRequire("l6gEk");

var $cQwLz = parcelRequire("cQwLz");
"use client";
function $fc4c33bddfe21121$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $cQwLz.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $l6gEk.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("l6gEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c712c0dae3bcee$export$2e2bcd8739ae039; });

var $dfmyc = parcelRequire("dfmyc");
function $f5c712c0dae3bcee$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $dfmyc.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("dfmyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a4e2b2223c1774e$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");
function $9a4e2b2223c1774e$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kxIgO.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kxIgO.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kxIgO.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $9a4e2b2223c1774e$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("cQwLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95a3c212553f23b7$export$2e2bcd8739ae039; });

var $l1ZeQ = parcelRequire("l1ZeQ");

var $hixEE = parcelRequire("hixEE");
"use client";
const $95a3c212553f23b7$export$35e57303dbd8a66 = (0, $l1ZeQ.default)();
function $95a3c212553f23b7$var$useTheme(defaultTheme = $95a3c212553f23b7$export$35e57303dbd8a66) {
    return (0, $hixEE.default)(defaultTheme);
}
var $95a3c212553f23b7$export$2e2bcd8739ae039 = $95a3c212553f23b7$var$useTheme;

});
parcelRegister("l1ZeQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4f931a742ec43dd$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $lCJj0 = parcelRequire("lCJj0");

var $l6yQZ = parcelRequire("l6yQZ");

var $5BVw4 = parcelRequire("5BVw4");

var $2sqBo = parcelRequire("2sqBo");

var $fZq7u = parcelRequire("fZq7u");

var $870HA = parcelRequire("870HA");

var $hAMUg = parcelRequire("hAMUg");
const $f4f931a742ec43dd$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $f4f931a742ec43dd$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $gZOiq.default)(options, $f4f931a742ec43dd$var$_excluded);
    const breakpoints = (0, $l6yQZ.default)(breakpointsInput);
    const spacing = (0, $2sqBo.default)(spacingInput);
    let muiTheme = (0, $lCJj0.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $kxIgO.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kxIgO.default)({}, (0, $5BVw4.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $hAMUg.default);
    muiTheme = args.reduce((acc, argument)=>(0, $lCJj0.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kxIgO.default)({}, (0, $870HA.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $fZq7u.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $f4f931a742ec43dd$export$2e2bcd8739ae039 = $f4f931a742ec43dd$var$createTheme;

});
parcelRegister("lCJj0", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $fbe04a55c266d32b$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $fbe04a55c266d32b$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");
function $fbe04a55c266d32b$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $fbe04a55c266d32b$var$deepClone(source) {
    if (!$fbe04a55c266d32b$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $fbe04a55c266d32b$var$deepClone(source[key]);
    });
    return output;
}
function $fbe04a55c266d32b$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kxIgO.default)({}, target) : target;
    if ($fbe04a55c266d32b$export$53b83ca8eaab0383(target) && $fbe04a55c266d32b$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($fbe04a55c266d32b$export$53b83ca8eaab0383(source[key]) && key in target && $fbe04a55c266d32b$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $fbe04a55c266d32b$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $fbe04a55c266d32b$export$53b83ca8eaab0383(source[key]) ? $fbe04a55c266d32b$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("l6yQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5d531b3c2fd4da5$export$2e2bcd8739ae039; });

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");
const $f5d531b3c2fd4da5$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $f5d531b3c2fd4da5$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $f5d531b3c2fd4da5$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kxIgO.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $f5d531b3c2fd4da5$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $gZOiq.default)(breakpoints, $f5d531b3c2fd4da5$var$_excluded);
    const sortedValues = $f5d531b3c2fd4da5$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $kxIgO.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("5BVw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $415d05fc312ef203$export$2e2bcd8739ae039; });
const $415d05fc312ef203$var$shape = {
    borderRadius: 4
};
var $415d05fc312ef203$export$2e2bcd8739ae039 = $415d05fc312ef203$var$shape;

});

parcelRegister("2sqBo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca2d4f20a0590fb$export$2e2bcd8739ae039; });

var $fDcTc = parcelRequire("fDcTc");
function $1ca2d4f20a0590fb$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fDcTc.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fDcTc", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $b6147f18cd3bb366$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $b6147f18cd3bb366$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $b6147f18cd3bb366$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $b6147f18cd3bb366$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $b6147f18cd3bb366$export$6f98e8eaf0be1996; });


var $koNI7 = parcelRequire("koNI7");

var $85voO = parcelRequire("85voO");

var $cL1Mr = parcelRequire("cL1Mr");

var $2GdUx = parcelRequire("2GdUx");
const $b6147f18cd3bb366$var$properties = {
    m: "margin",
    p: "padding"
};
const $b6147f18cd3bb366$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $b6147f18cd3bb366$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b6147f18cd3bb366$var$getCssProperties = (0, $2GdUx.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b6147f18cd3bb366$var$aliases[prop]) prop = $b6147f18cd3bb366$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $b6147f18cd3bb366$var$properties[a];
    const direction = $b6147f18cd3bb366$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b6147f18cd3bb366$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $b6147f18cd3bb366$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $b6147f18cd3bb366$var$spacingKeys = [
    ...$b6147f18cd3bb366$export$aab52a0dde05ad8a,
    ...$b6147f18cd3bb366$export$f8397d44f03ab6ad
];
function $b6147f18cd3bb366$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $85voO.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $b6147f18cd3bb366$export$1def6f833384e3d1(theme) {
    return $b6147f18cd3bb366$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $b6147f18cd3bb366$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $b6147f18cd3bb366$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b6147f18cd3bb366$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b6147f18cd3bb366$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b6147f18cd3bb366$var$getCssProperties(prop);
    const styleFromPropValue = $b6147f18cd3bb366$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $koNI7.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b6147f18cd3bb366$var$style(props, keys) {
    const transformer = $b6147f18cd3bb366$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b6147f18cd3bb366$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $cL1Mr.default), {});
}
function $b6147f18cd3bb366$export$7ede87f9b603dd3c(props) {
    return $b6147f18cd3bb366$var$style(props, $b6147f18cd3bb366$export$aab52a0dde05ad8a);
}
$b6147f18cd3bb366$export$7ede87f9b603dd3c.propTypes = {};
$b6147f18cd3bb366$export$7ede87f9b603dd3c.filterProps = $b6147f18cd3bb366$export$aab52a0dde05ad8a;
function $b6147f18cd3bb366$export$6f98e8eaf0be1996(props) {
    return $b6147f18cd3bb366$var$style(props, $b6147f18cd3bb366$export$f8397d44f03ab6ad);
}
$b6147f18cd3bb366$export$6f98e8eaf0be1996.propTypes = {};
$b6147f18cd3bb366$export$6f98e8eaf0be1996.filterProps = $b6147f18cd3bb366$export$f8397d44f03ab6ad;
function $b6147f18cd3bb366$var$spacing(props) {
    return $b6147f18cd3bb366$var$style(props, $b6147f18cd3bb366$var$spacingKeys);
}
$b6147f18cd3bb366$var$spacing.propTypes = {};
$b6147f18cd3bb366$var$spacing.filterProps = $b6147f18cd3bb366$var$spacingKeys;
var $b6147f18cd3bb366$export$2e2bcd8739ae039 = $b6147f18cd3bb366$var$spacing;

});
parcelRegister("koNI7", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $ed9c9c08459e92db$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $ed9c9c08459e92db$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $ed9c9c08459e92db$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $ed9c9c08459e92db$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $ed9c9c08459e92db$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $ed9c9c08459e92db$export$980e6a259d807490; });

var $kxIgO = parcelRequire("kxIgO");


var $lCJj0 = parcelRequire("lCJj0");

var $cL1Mr = parcelRequire("cL1Mr");
const $ed9c9c08459e92db$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ed9c9c08459e92db$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$ed9c9c08459e92db$export$68c286be0e7e55b7[key]}px)`
};
function $ed9c9c08459e92db$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ed9c9c08459e92db$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $ed9c9c08459e92db$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $ed9c9c08459e92db$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ed9c9c08459e92db$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ed9c9c08459e92db$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kxIgO.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $cL1Mr.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ed9c9c08459e92db$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ed9c9c08459e92db$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ed9c9c08459e92db$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ed9c9c08459e92db$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $lCJj0.default)(prev, next), {});
    return $ed9c9c08459e92db$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ed9c9c08459e92db$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ed9c9c08459e92db$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ed9c9c08459e92db$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ed9c9c08459e92db$export$2e2bcd8739ae039 = $ed9c9c08459e92db$var$breakpoints;

});
parcelRegister("cL1Mr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $949b4160d0ca1248$export$2e2bcd8739ae039; });

var $lCJj0 = parcelRequire("lCJj0");
function $949b4160d0ca1248$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $lCJj0.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $949b4160d0ca1248$export$2e2bcd8739ae039 = $949b4160d0ca1248$var$merge;

});


parcelRegister("85voO", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $5e37259b470bb96a$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $5e37259b470bb96a$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $5e37259b470bb96a$export$2e2bcd8739ae039; });

var $cgn0z = parcelRequire("cgn0z");


var $koNI7 = parcelRequire("koNI7");
function $5e37259b470bb96a$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $5e37259b470bb96a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $5e37259b470bb96a$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $5e37259b470bb96a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $5e37259b470bb96a$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $5e37259b470bb96a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $5e37259b470bb96a$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $cgn0z.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $koNI7.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $5e37259b470bb96a$export$2e2bcd8739ae039 = $5e37259b470bb96a$var$style;

});

parcelRegister("2GdUx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f3a4b6e6026b30e$export$2e2bcd8739ae039; });
function $1f3a4b6e6026b30e$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("fZq7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba40d05f5c559b3f$export$2e2bcd8739ae039; });

var $cgn0z = parcelRequire("cgn0z");

var $cL1Mr = parcelRequire("cL1Mr");

var $85voO = parcelRequire("85voO");

var $koNI7 = parcelRequire("koNI7");

var $870HA = parcelRequire("870HA");
function $ba40d05f5c559b3f$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $ba40d05f5c559b3f$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $ba40d05f5c559b3f$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $85voO.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $85voO.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $85voO.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $cgn0z.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $koNI7.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $870HA.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $koNI7.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $ba40d05f5c559b3f$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $cL1Mr.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $koNI7.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($ba40d05f5c559b3f$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $cL1Mr.default)(css, breakpointsValues);
                        }
                    } else css = (0, $cL1Mr.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $koNI7.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $ba40d05f5c559b3f$var$styleFunctionSx = $ba40d05f5c559b3f$export$7d53d8bf2911e013();
$ba40d05f5c559b3f$var$styleFunctionSx.filterProps = [
    "sx"
];
var $ba40d05f5c559b3f$export$2e2bcd8739ae039 = $ba40d05f5c559b3f$var$styleFunctionSx;

});
parcelRegister("870HA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e7f858f546e70ff$export$2e2bcd8739ae039; });

var $fDcTc = parcelRequire("fDcTc");

var $hs6oM = parcelRequire("hs6oM");

var $8bHiU = parcelRequire("8bHiU");

var $ds57Z = parcelRequire("ds57Z");

var $envHJ = parcelRequire("envHJ");
const $5e7f858f546e70ff$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $hs6oM.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $hs6oM.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $hs6oM.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $hs6oM.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $hs6oM.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $hs6oM.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $hs6oM.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $ds57Z.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $ds57Z.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $ds57Z.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fDcTc.padding)
    },
    pt: {
        style: (0, $fDcTc.padding)
    },
    pr: {
        style: (0, $fDcTc.padding)
    },
    pb: {
        style: (0, $fDcTc.padding)
    },
    pl: {
        style: (0, $fDcTc.padding)
    },
    px: {
        style: (0, $fDcTc.padding)
    },
    py: {
        style: (0, $fDcTc.padding)
    },
    padding: {
        style: (0, $fDcTc.padding)
    },
    paddingTop: {
        style: (0, $fDcTc.padding)
    },
    paddingRight: {
        style: (0, $fDcTc.padding)
    },
    paddingBottom: {
        style: (0, $fDcTc.padding)
    },
    paddingLeft: {
        style: (0, $fDcTc.padding)
    },
    paddingX: {
        style: (0, $fDcTc.padding)
    },
    paddingY: {
        style: (0, $fDcTc.padding)
    },
    paddingInline: {
        style: (0, $fDcTc.padding)
    },
    paddingInlineStart: {
        style: (0, $fDcTc.padding)
    },
    paddingInlineEnd: {
        style: (0, $fDcTc.padding)
    },
    paddingBlock: {
        style: (0, $fDcTc.padding)
    },
    paddingBlockStart: {
        style: (0, $fDcTc.padding)
    },
    paddingBlockEnd: {
        style: (0, $fDcTc.padding)
    },
    m: {
        style: (0, $fDcTc.margin)
    },
    mt: {
        style: (0, $fDcTc.margin)
    },
    mr: {
        style: (0, $fDcTc.margin)
    },
    mb: {
        style: (0, $fDcTc.margin)
    },
    ml: {
        style: (0, $fDcTc.margin)
    },
    mx: {
        style: (0, $fDcTc.margin)
    },
    my: {
        style: (0, $fDcTc.margin)
    },
    margin: {
        style: (0, $fDcTc.margin)
    },
    marginTop: {
        style: (0, $fDcTc.margin)
    },
    marginRight: {
        style: (0, $fDcTc.margin)
    },
    marginBottom: {
        style: (0, $fDcTc.margin)
    },
    marginLeft: {
        style: (0, $fDcTc.margin)
    },
    marginX: {
        style: (0, $fDcTc.margin)
    },
    marginY: {
        style: (0, $fDcTc.margin)
    },
    marginInline: {
        style: (0, $fDcTc.margin)
    },
    marginInlineStart: {
        style: (0, $fDcTc.margin)
    },
    marginInlineEnd: {
        style: (0, $fDcTc.margin)
    },
    marginBlock: {
        style: (0, $fDcTc.margin)
    },
    marginBlockStart: {
        style: (0, $fDcTc.margin)
    },
    marginBlockEnd: {
        style: (0, $fDcTc.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $8bHiU.gap)
    },
    rowGap: {
        style: (0, $8bHiU.rowGap)
    },
    columnGap: {
        style: (0, $8bHiU.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $envHJ.sizingTransform)
    },
    maxWidth: {
        style: (0, $envHJ.maxWidth)
    },
    minWidth: {
        transform: (0, $envHJ.sizingTransform)
    },
    height: {
        transform: (0, $envHJ.sizingTransform)
    },
    maxHeight: {
        transform: (0, $envHJ.sizingTransform)
    },
    minHeight: {
        transform: (0, $envHJ.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $5e7f858f546e70ff$export$2e2bcd8739ae039 = $5e7f858f546e70ff$var$defaultSxConfig;

});
parcelRegister("hs6oM", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $cb4a03d6e7ccbd9c$export$7a57f79000377ca2; });


var $85voO = parcelRequire("85voO");

var $epkTP = parcelRequire("epkTP");

var $fDcTc = parcelRequire("fDcTc");

var $koNI7 = parcelRequire("koNI7");
function $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $cb4a03d6e7ccbd9c$var$createBorderStyle(prop, transform) {
    return (0, $85voO.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $cb4a03d6e7ccbd9c$export$1edee58a52776cd9 = $cb4a03d6e7ccbd9c$var$createBorderStyle("border", $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc);
const $cb4a03d6e7ccbd9c$export$f9a7b6bd24892946 = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderTop", $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc);
const $cb4a03d6e7ccbd9c$export$5abca33e6be905d2 = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderRight", $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc);
const $cb4a03d6e7ccbd9c$export$e2ce9f12a980a822 = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderBottom", $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc);
const $cb4a03d6e7ccbd9c$export$47658cca1a909427 = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderLeft", $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc);
const $cb4a03d6e7ccbd9c$export$e7fb0694ba2404fc = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderColor");
const $cb4a03d6e7ccbd9c$export$126a92c968acdb85 = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderTopColor");
const $cb4a03d6e7ccbd9c$export$85cc51cb8fbb8c0e = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderRightColor");
const $cb4a03d6e7ccbd9c$export$340b0327727f6d1a = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderBottomColor");
const $cb4a03d6e7ccbd9c$export$60beef91a985b4bf = $cb4a03d6e7ccbd9c$var$createBorderStyle("borderLeftColor");
const $cb4a03d6e7ccbd9c$export$f9258c55612cbed7 = $cb4a03d6e7ccbd9c$var$createBorderStyle("outline", $cb4a03d6e7ccbd9c$export$34e2febe53ae29cc);
const $cb4a03d6e7ccbd9c$export$621fe586efeb64b9 = $cb4a03d6e7ccbd9c$var$createBorderStyle("outlineColor");
const $cb4a03d6e7ccbd9c$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fDcTc.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fDcTc.getValue)(transformer, propValue)
            });
        return (0, $koNI7.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$cb4a03d6e7ccbd9c$export$7a57f79000377ca2.propTypes = {};
$cb4a03d6e7ccbd9c$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $cb4a03d6e7ccbd9c$var$borders = (0, $epkTP.default)($cb4a03d6e7ccbd9c$export$1edee58a52776cd9, $cb4a03d6e7ccbd9c$export$f9a7b6bd24892946, $cb4a03d6e7ccbd9c$export$5abca33e6be905d2, $cb4a03d6e7ccbd9c$export$e2ce9f12a980a822, $cb4a03d6e7ccbd9c$export$47658cca1a909427, $cb4a03d6e7ccbd9c$export$e7fb0694ba2404fc, $cb4a03d6e7ccbd9c$export$126a92c968acdb85, $cb4a03d6e7ccbd9c$export$85cc51cb8fbb8c0e, $cb4a03d6e7ccbd9c$export$340b0327727f6d1a, $cb4a03d6e7ccbd9c$export$60beef91a985b4bf, $cb4a03d6e7ccbd9c$export$7a57f79000377ca2, $cb4a03d6e7ccbd9c$export$f9258c55612cbed7, $cb4a03d6e7ccbd9c$export$621fe586efeb64b9);
var $cb4a03d6e7ccbd9c$export$2e2bcd8739ae039 = $cb4a03d6e7ccbd9c$var$borders;

});
parcelRegister("epkTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7d39cb240f641e7$export$2e2bcd8739ae039; });

var $cL1Mr = parcelRequire("cL1Mr");
function $a7d39cb240f641e7$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $cL1Mr.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $a7d39cb240f641e7$export$2e2bcd8739ae039 = $a7d39cb240f641e7$var$compose;

});


parcelRegister("8bHiU", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $5f60f1173eeff578$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $5f60f1173eeff578$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $5f60f1173eeff578$export$8a833ffa5f5dbeda; });

var $85voO = parcelRequire("85voO");

var $epkTP = parcelRequire("epkTP");

var $fDcTc = parcelRequire("fDcTc");

var $koNI7 = parcelRequire("koNI7");

const $5f60f1173eeff578$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fDcTc.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fDcTc.getValue)(transformer, propValue)
            });
        return (0, $koNI7.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$5f60f1173eeff578$export$5df9adcb0db95e1e.propTypes = {};
$5f60f1173eeff578$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $5f60f1173eeff578$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fDcTc.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fDcTc.getValue)(transformer, propValue)
            });
        return (0, $koNI7.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$5f60f1173eeff578$export$ec60d70ff941a580.propTypes = {};
$5f60f1173eeff578$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $5f60f1173eeff578$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fDcTc.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fDcTc.getValue)(transformer, propValue)
            });
        return (0, $koNI7.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$5f60f1173eeff578$export$8a833ffa5f5dbeda.propTypes = {};
$5f60f1173eeff578$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $5f60f1173eeff578$export$baf44164ca3a34e8 = (0, $85voO.default)({
    prop: "gridColumn"
});
const $5f60f1173eeff578$export$8f7213a1cd01e832 = (0, $85voO.default)({
    prop: "gridRow"
});
const $5f60f1173eeff578$export$b0e0abbc49ba668 = (0, $85voO.default)({
    prop: "gridAutoFlow"
});
const $5f60f1173eeff578$export$bcd8b929d4b4142 = (0, $85voO.default)({
    prop: "gridAutoColumns"
});
const $5f60f1173eeff578$export$e5039a674e14c828 = (0, $85voO.default)({
    prop: "gridAutoRows"
});
const $5f60f1173eeff578$export$42bd9088661ffb03 = (0, $85voO.default)({
    prop: "gridTemplateColumns"
});
const $5f60f1173eeff578$export$920682ae05b999bc = (0, $85voO.default)({
    prop: "gridTemplateRows"
});
const $5f60f1173eeff578$export$1b88fbdd482fd33a = (0, $85voO.default)({
    prop: "gridTemplateAreas"
});
const $5f60f1173eeff578$export$bdb486e40d52d26f = (0, $85voO.default)({
    prop: "gridArea"
});
const $5f60f1173eeff578$var$grid = (0, $epkTP.default)($5f60f1173eeff578$export$5df9adcb0db95e1e, $5f60f1173eeff578$export$ec60d70ff941a580, $5f60f1173eeff578$export$8a833ffa5f5dbeda, $5f60f1173eeff578$export$baf44164ca3a34e8, $5f60f1173eeff578$export$8f7213a1cd01e832, $5f60f1173eeff578$export$b0e0abbc49ba668, $5f60f1173eeff578$export$bcd8b929d4b4142, $5f60f1173eeff578$export$e5039a674e14c828, $5f60f1173eeff578$export$42bd9088661ffb03, $5f60f1173eeff578$export$920682ae05b999bc, $5f60f1173eeff578$export$1b88fbdd482fd33a, $5f60f1173eeff578$export$bdb486e40d52d26f);
var $5f60f1173eeff578$export$2e2bcd8739ae039 = $5f60f1173eeff578$var$grid;

});

parcelRegister("ds57Z", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $9cb1de2f42e8bc5e$export$dbaffd4420ea0ac6; });

var $85voO = parcelRequire("85voO");

var $epkTP = parcelRequire("epkTP");
function $9cb1de2f42e8bc5e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $9cb1de2f42e8bc5e$export$35e9368ef982300f = (0, $85voO.default)({
    prop: "color",
    themeKey: "palette",
    transform: $9cb1de2f42e8bc5e$export$dbaffd4420ea0ac6
});
const $9cb1de2f42e8bc5e$export$2506f56c10355b33 = (0, $85voO.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $9cb1de2f42e8bc5e$export$dbaffd4420ea0ac6
});
const $9cb1de2f42e8bc5e$export$8c5a050822fd698c = (0, $85voO.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $9cb1de2f42e8bc5e$export$dbaffd4420ea0ac6
});
const $9cb1de2f42e8bc5e$var$palette = (0, $epkTP.default)($9cb1de2f42e8bc5e$export$35e9368ef982300f, $9cb1de2f42e8bc5e$export$2506f56c10355b33, $9cb1de2f42e8bc5e$export$8c5a050822fd698c);
var $9cb1de2f42e8bc5e$export$2e2bcd8739ae039 = $9cb1de2f42e8bc5e$var$palette;

});

parcelRegister("envHJ", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $a77bce7fcb5283c7$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $a77bce7fcb5283c7$export$488fda99655ff65a; });

var $85voO = parcelRequire("85voO");

var $epkTP = parcelRequire("epkTP");

var $koNI7 = parcelRequire("koNI7");
function $a77bce7fcb5283c7$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a77bce7fcb5283c7$export$7e3df82ee760448c = (0, $85voO.default)({
    prop: "width",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $koNI7.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $a77bce7fcb5283c7$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $koNI7.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a77bce7fcb5283c7$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $a77bce7fcb5283c7$export$ee148fbbe8357dd2 = (0, $85voO.default)({
    prop: "minWidth",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$ac607276a8fe9f0a = (0, $85voO.default)({
    prop: "height",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$dc0d8bd0b94f8570 = (0, $85voO.default)({
    prop: "maxHeight",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$a43cf604e12f3b17 = (0, $85voO.default)({
    prop: "minHeight",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$ffed9f14fb65e276 = (0, $85voO.default)({
    prop: "size",
    cssProperty: "width",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$905076ed6620e671 = (0, $85voO.default)({
    prop: "size",
    cssProperty: "height",
    transform: $a77bce7fcb5283c7$export$8afece71750ec241
});
const $a77bce7fcb5283c7$export$6ccc93f785106a58 = (0, $85voO.default)({
    prop: "boxSizing"
});
const $a77bce7fcb5283c7$var$sizing = (0, $epkTP.default)($a77bce7fcb5283c7$export$7e3df82ee760448c, $a77bce7fcb5283c7$export$488fda99655ff65a, $a77bce7fcb5283c7$export$ee148fbbe8357dd2, $a77bce7fcb5283c7$export$ac607276a8fe9f0a, $a77bce7fcb5283c7$export$dc0d8bd0b94f8570, $a77bce7fcb5283c7$export$a43cf604e12f3b17, $a77bce7fcb5283c7$export$6ccc93f785106a58);
var $a77bce7fcb5283c7$export$2e2bcd8739ae039 = $a77bce7fcb5283c7$var$sizing;

});



parcelRegister("hAMUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccebbc4954c587c0$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $ccebbc4954c587c0$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("hixEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c97e39395c8af84b$export$2e2bcd8739ae039; });

var $2hDQc = parcelRequire("2hDQc");
parcelRequire("3NAKi");
var $9INUU = parcelRequire("9INUU");
"use client";
function $c97e39395c8af84b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $c97e39395c8af84b$var$useTheme(defaultTheme = null) {
    const contextTheme = $2hDQc.useContext((0, $9INUU.T));
    return !contextTheme || $c97e39395c8af84b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $c97e39395c8af84b$export$2e2bcd8739ae039 = $c97e39395c8af84b$var$useTheme;

});
parcelRegister("3NAKi", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $2c4273a83d992d8c$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $2c4273a83d992d8c$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $2c4273a83d992d8c$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("9INUU")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("9INUU")).w; });

var $9INUU = parcelRequire("9INUU");

var $2hDQc = parcelRequire("2hDQc");

var $fborQ = parcelRequire("fborQ");

var $bvyRs = parcelRequire("bvyRs");

var $j0ym9 = parcelRequire("j0ym9");
parcelRequire("kuR1K");
parcelRequire("7vVRg");
parcelRequire("bs9D3");

parcelRequire("8FL51");
var $2c4273a83d992d8c$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $2c4273a83d992d8c$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $9INUU.h).call(props, "css")) // $FlowFixMe
    return $2hDQc.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $9INUU.E);
    createElementArgArray[1] = (0, $9INUU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $2hDQc.createElement.apply(null, createElementArgArray);
};
var $2c4273a83d992d8c$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $2c4273a83d992d8c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $9INUU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $j0ym9.serializeStyles)([
        styles
    ], undefined, $2hDQc.useContext((0, $9INUU.T)));
    if (!(0, $9INUU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $2hDQc.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $2hDQc.useRef();
    (0, $bvyRs.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $bvyRs.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $fborQ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $2c4273a83d992d8c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $j0ym9.serializeStyles)(args);
}
var $2c4273a83d992d8c$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $2c4273a83d992d8c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $2c4273a83d992d8c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $2c4273a83d992d8c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $fborQ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $2c4273a83d992d8c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $bvyRs.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $fborQ.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $2c4273a83d992d8c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $9INUU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $j0ym9.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $fborQ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $2c4273a83d992d8c$var$merge(cache.registered, css, $2c4273a83d992d8c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $2hDQc.useContext((0, $9INUU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, /*#__PURE__*/ $2hDQc.createElement($2c4273a83d992d8c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $2c4273a83d992d8c$var$isBrowser, $2c4273a83d992d8c$var$isTestEnv, $2c4273a83d992d8c$var$globalContext, $2c4273a83d992d8c$var$globalKey;

});
parcelRegister("9INUU", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $713ef198599fed0c$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $713ef198599fed0c$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $713ef198599fed0c$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $713ef198599fed0c$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $713ef198599fed0c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $713ef198599fed0c$export$a9c23c6ac3fc3eca; });

var $2hDQc = parcelRequire("2hDQc");

var $kuR1K = parcelRequire("kuR1K");

var $J0KCN = parcelRequire("J0KCN");

var $bs9D3 = parcelRequire("bs9D3");

var $apDar = parcelRequire("apDar");

var $fborQ = parcelRequire("fborQ");

var $j0ym9 = parcelRequire("j0ym9");

var $bvyRs = parcelRequire("bvyRs");
var $713ef198599fed0c$export$23f2a1d2818174ef = true;
var $713ef198599fed0c$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $713ef198599fed0c$var$EmotionCacheContext = /* #__PURE__ */ $2hDQc.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $kuR1K.default)({
    key: "css"
}) : null);
var $713ef198599fed0c$export$e7094788287c5e9b = $713ef198599fed0c$var$EmotionCacheContext.Provider;
var $713ef198599fed0c$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $2hDQc.useContext)($713ef198599fed0c$var$EmotionCacheContext);
};
var $713ef198599fed0c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $2hDQc.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $2hDQc.useContext)($713ef198599fed0c$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$713ef198599fed0c$export$23f2a1d2818174ef) $713ef198599fed0c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $2hDQc.useContext)($713ef198599fed0c$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $kuR1K.default)({
                key: "css"
            });
            return /*#__PURE__*/ $2hDQc.createElement($713ef198599fed0c$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $713ef198599fed0c$export$971d5caa766a69d7 = /* #__PURE__ */ $2hDQc.createContext({});
var $713ef198599fed0c$export$3b14a55fb2447963 = function useTheme() {
    return $2hDQc.useContext($713ef198599fed0c$export$971d5caa766a69d7);
};
var $713ef198599fed0c$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $J0KCN.default)({}, outerTheme, theme);
};
var $713ef198599fed0c$var$createCacheWithTheme = /* #__PURE__ */ (0, $bs9D3.default)(function(outerTheme) {
    return (0, $bs9D3.default)(function(theme) {
        return $713ef198599fed0c$var$getTheme(outerTheme, theme);
    });
});
var $713ef198599fed0c$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $2hDQc.useContext($713ef198599fed0c$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $713ef198599fed0c$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $2hDQc.createElement($713ef198599fed0c$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $713ef198599fed0c$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $2hDQc.useContext($713ef198599fed0c$export$971d5caa766a69d7);
        return /*#__PURE__*/ $2hDQc.createElement(Component, (0, $J0KCN.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $2hDQc.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDar.default)(WithTheme, Component);
}
var $713ef198599fed0c$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $713ef198599fed0c$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $713ef198599fed0c$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $713ef198599fed0c$var$getLastPart(match[1]);
    return undefined;
};
var $713ef198599fed0c$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $713ef198599fed0c$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $713ef198599fed0c$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $713ef198599fed0c$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($713ef198599fed0c$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $713ef198599fed0c$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $713ef198599fed0c$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $713ef198599fed0c$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $713ef198599fed0c$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($713ef198599fed0c$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$713ef198599fed0c$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $713ef198599fed0c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fborQ.registerStyles)(cache, serialized, isStringTag);
    (0, $bvyRs.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fborQ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $713ef198599fed0c$var$Emotion = /* #__PURE__ */ $713ef198599fed0c$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$713ef198599fed0c$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $fborQ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $j0ym9.serializeStyles)(registeredStyles, undefined, $2hDQc.useContext($713ef198599fed0c$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($713ef198599fed0c$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $713ef198599fed0c$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, /*#__PURE__*/ $2hDQc.createElement($713ef198599fed0c$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $2hDQc.createElement(WrappedComponent, newProps));
});
var $713ef198599fed0c$export$a9c23c6ac3fc3eca = $713ef198599fed0c$var$Emotion;

});
parcelRegister("kuR1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eebfbe1b727f8e6d$export$2e2bcd8739ae039; });

var $d71tT = parcelRequire("d71tT");

var $dttdf = parcelRequire("dttdf");
parcelRequire("bs9D3");
parcelRequire("lA0nP");
var $eebfbe1b727f8e6d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $dttdf.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $dttdf.token)(character)) break;
        (0, $dttdf.next)();
    }
    return (0, $dttdf.slice)(begin, (0, $dttdf.position));
};
var $eebfbe1b727f8e6d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $dttdf.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $dttdf.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $eebfbe1b727f8e6d$var$identifierWithPointTracking((0, $dttdf.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $dttdf.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $dttdf.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $dttdf.from)(character);
    }
    while (character = (0, $dttdf.next)());
    return parsed;
};
var $eebfbe1b727f8e6d$var$getRules = function getRules(value, points) {
    return (0, $dttdf.dealloc)($eebfbe1b727f8e6d$var$toRules((0, $dttdf.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $eebfbe1b727f8e6d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $eebfbe1b727f8e6d$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$eebfbe1b727f8e6d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $eebfbe1b727f8e6d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $eebfbe1b727f8e6d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $eebfbe1b727f8e6d$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $eebfbe1b727f8e6d$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $eebfbe1b727f8e6d$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($eebfbe1b727f8e6d$var$ignoreFlag) > -1;
};
var $eebfbe1b727f8e6d$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($eebfbe1b727f8e6d$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $eebfbe1b727f8e6d$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $eebfbe1b727f8e6d$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$eebfbe1b727f8e6d$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $eebfbe1b727f8e6d$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $eebfbe1b727f8e6d$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$eebfbe1b727f8e6d$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $eebfbe1b727f8e6d$var$nullifyElement(element);
    } else if ($eebfbe1b727f8e6d$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $eebfbe1b727f8e6d$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $eebfbe1b727f8e6d$var$prefix(value, length) {
    switch((0, $dttdf.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $dttdf.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $dttdf.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MOZ) + value + (0, $dttdf.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + value + value;
        // order
        case 6165:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.replace)(value, /(\w+).+(:[^]+)/, (0, $dttdf.WEBKIT) + "box-$1$2" + (0, $dttdf.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + "flex-item-" + (0, $dttdf.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + "flex-line-pack" + (0, $dttdf.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $dttdf.WEBKIT) + "box-" + (0, $dttdf.replace)(value, "-grow", "") + (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $dttdf.WEBKIT) + (0, $dttdf.replace)(value, /([^-])(transform)/g, "$1" + (0, $dttdf.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $dttdf.replace)((0, $dttdf.replace)((0, $dttdf.replace)(value, /(zoom-|grab)/, (0, $dttdf.WEBKIT) + "$1"), /(image-set)/, (0, $dttdf.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $dttdf.replace)(value, /(image-set\([^]*)/, (0, $dttdf.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $dttdf.replace)((0, $dttdf.replace)(value, /(.+:)(flex-)?(.*)/, (0, $dttdf.WEBKIT) + "box-pack:$3" + (0, $dttdf.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $dttdf.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $dttdf.replace)(value, /(.+)-inline(.+)/, (0, $dttdf.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $dttdf.strlen)(value) - 1 - length > 6) switch((0, $dttdf.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $dttdf.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $dttdf.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $dttdf.WEBKIT) + "$2-$3" + "$1" + (0, $dttdf.MOZ) + ((0, $dttdf.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $dttdf.indexof)(value, "stretch") ? $eebfbe1b727f8e6d$var$prefix((0, $dttdf.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $dttdf.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $dttdf.charat)(value, (0, $dttdf.strlen)(value) - 3 - (~(0, $dttdf.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $dttdf.replace)(value, ":", ":" + (0, $dttdf.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $dttdf.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $dttdf.WEBKIT) + ((0, $dttdf.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $dttdf.WEBKIT) + "$2$3" + "$1" + (0, $dttdf.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $dttdf.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + (0, $dttdf.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $dttdf.WEBKIT) + value + (0, $dttdf.MS) + value + value;
    }
    return value;
}
var $eebfbe1b727f8e6d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $dttdf.DECLARATION:
                element["return"] = $eebfbe1b727f8e6d$var$prefix(element.value, element.length);
                break;
            case 0, $dttdf.KEYFRAMES:
                return (0, $dttdf.serialize)([
                    (0, $dttdf.copy)(element, {
                        value: (0, $dttdf.replace)(element.value, "@", "@" + (0, $dttdf.WEBKIT))
                    })
                ], callback);
            case 0, $dttdf.RULESET:
                if (element.length) return (0, $dttdf.combine)(element.props, function(value) {
                    switch((0, $dttdf.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $dttdf.serialize)([
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(read-\w+)/, ":" + (0, $dttdf.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $dttdf.serialize)([
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(plac\w+)/, ":" + (0, $dttdf.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(plac\w+)/, ":" + (0, $dttdf.MOZ) + "$1")
                                    ]
                                }),
                                (0, $dttdf.copy)(element, {
                                    props: [
                                        (0, $dttdf.replace)(value, /:(plac\w+)/, (0, $dttdf.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $eebfbe1b727f8e6d$var$defaultStylisPlugins = [
    $eebfbe1b727f8e6d$var$prefixer
];
var $eebfbe1b727f8e6d$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $eebfbe1b727f8e6d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $eebfbe1b727f8e6d$var$compat,
        $eebfbe1b727f8e6d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $dttdf.stringify),
        (0, $dttdf.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $dttdf.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $dttdf.serialize)((0, $dttdf.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $d71tT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("d71tT", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $98bd13eda92d0ed8$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $98bd13eda92d0ed8$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $98bd13eda92d0ed8$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $98bd13eda92d0ed8$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($98bd13eda92d0ed8$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $98bd13eda92d0ed8$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("dttdf", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $045d360cdc2debe1$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $045d360cdc2debe1$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $045d360cdc2debe1$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $045d360cdc2debe1$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $045d360cdc2debe1$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $045d360cdc2debe1$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $045d360cdc2debe1$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $045d360cdc2debe1$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $045d360cdc2debe1$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $045d360cdc2debe1$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $045d360cdc2debe1$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $045d360cdc2debe1$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $045d360cdc2debe1$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $045d360cdc2debe1$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $045d360cdc2debe1$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $045d360cdc2debe1$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $045d360cdc2debe1$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $045d360cdc2debe1$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $045d360cdc2debe1$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $045d360cdc2debe1$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $045d360cdc2debe1$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $045d360cdc2debe1$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $045d360cdc2debe1$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $045d360cdc2debe1$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $045d360cdc2debe1$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $045d360cdc2debe1$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $045d360cdc2debe1$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $045d360cdc2debe1$export$38bcb760f1d4871c; });
var $045d360cdc2debe1$export$71ad59f2e432cfe8 = "-ms-";
var $045d360cdc2debe1$export$2c0f367103c8d01c = "-moz-";
var $045d360cdc2debe1$export$39dfd62a25e0fe93 = "-webkit-";
var $045d360cdc2debe1$export$a29989082612d0d9 = "comm";
var $045d360cdc2debe1$export$aa3a2e812ca8570d = "rule";
var $045d360cdc2debe1$export$527d108ccf083c2b = "decl";
var $045d360cdc2debe1$export$d3d35020fa5b54f0 = "@page";
var $045d360cdc2debe1$export$500415a86c544f73 = "@media";
var $045d360cdc2debe1$export$a763edbf796b780a = "@import";
var $045d360cdc2debe1$export$2790aeb8b4e5c826 = "@charset";
var $045d360cdc2debe1$export$1cc683e23b84b133 = "@viewport";
var $045d360cdc2debe1$export$9447a5efea57e862 = "@supports";
var $045d360cdc2debe1$export$ef011b4e114b1fba = "@document";
var $045d360cdc2debe1$export$6aad947bda0f3f46 = "@namespace";
var $045d360cdc2debe1$export$b44a8529a35fcb60 = "@keyframes";
var $045d360cdc2debe1$export$2c16de31893252e6 = "@font-face";
var $045d360cdc2debe1$export$3d846dd52e150c6f = "@counter-style";
var $045d360cdc2debe1$export$22314bfbb57653fe = "@font-feature-values";
var $045d360cdc2debe1$export$d773506282b3cfe6 = "@layer";
var $045d360cdc2debe1$export$2335f513bbd82c6d = Math.abs;
var $045d360cdc2debe1$export$6788812c4e6611e6 = String.fromCharCode;
var $045d360cdc2debe1$export$e6e34fd1f2686227 = Object.assign;
function $045d360cdc2debe1$export$d6af199866bfb566(e, r) {
    return $045d360cdc2debe1$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 0)) << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 1)) << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 2)) << 2 ^ $045d360cdc2debe1$export$a9db5e087081082d(e, 3) : 0;
}
function $045d360cdc2debe1$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $045d360cdc2debe1$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $045d360cdc2debe1$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $045d360cdc2debe1$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $045d360cdc2debe1$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $045d360cdc2debe1$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $045d360cdc2debe1$export$36776f635604f274(e) {
    return e.length;
}
function $045d360cdc2debe1$export$f9084667e487ed46(e) {
    return e.length;
}
function $045d360cdc2debe1$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $045d360cdc2debe1$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $045d360cdc2debe1$export$53f1d5ea8de3d7c = 1;
var $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1;
var $045d360cdc2debe1$export$f24224f1c91d8156 = 0;
var $045d360cdc2debe1$export$5880b8b5730aff45 = 0;
var $045d360cdc2debe1$export$c0306caf338ac095 = 0;
var $045d360cdc2debe1$export$30a86d91af8ff6e6 = "";
function $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $045d360cdc2debe1$export$53f1d5ea8de3d7c,
        column: $045d360cdc2debe1$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $045d360cdc2debe1$export$784d13d8ee351f07(e, r) {
    return $045d360cdc2debe1$export$e6e34fd1f2686227($045d360cdc2debe1$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $045d360cdc2debe1$export$eba6f6f03b0a92e7() {
    return $045d360cdc2debe1$export$c0306caf338ac095;
}
function $045d360cdc2debe1$export$232faf9add678146() {
    $045d360cdc2debe1$export$c0306caf338ac095 = $045d360cdc2debe1$export$5880b8b5730aff45 > 0 ? $045d360cdc2debe1$export$a9db5e087081082d($045d360cdc2debe1$export$30a86d91af8ff6e6, --$045d360cdc2debe1$export$5880b8b5730aff45) : 0;
    if ($045d360cdc2debe1$export$4e0c71f277ca26b3--, $045d360cdc2debe1$export$c0306caf338ac095 === 10) $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1, $045d360cdc2debe1$export$53f1d5ea8de3d7c--;
    return $045d360cdc2debe1$export$c0306caf338ac095;
}
function $045d360cdc2debe1$export$48cfd1e771a65c4f() {
    $045d360cdc2debe1$export$c0306caf338ac095 = $045d360cdc2debe1$export$5880b8b5730aff45 < $045d360cdc2debe1$export$f24224f1c91d8156 ? $045d360cdc2debe1$export$a9db5e087081082d($045d360cdc2debe1$export$30a86d91af8ff6e6, $045d360cdc2debe1$export$5880b8b5730aff45++) : 0;
    if ($045d360cdc2debe1$export$4e0c71f277ca26b3++, $045d360cdc2debe1$export$c0306caf338ac095 === 10) $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1, $045d360cdc2debe1$export$53f1d5ea8de3d7c++;
    return $045d360cdc2debe1$export$c0306caf338ac095;
}
function $045d360cdc2debe1$export$4d3fb11e950abb9e() {
    return $045d360cdc2debe1$export$a9db5e087081082d($045d360cdc2debe1$export$30a86d91af8ff6e6, $045d360cdc2debe1$export$5880b8b5730aff45);
}
function $045d360cdc2debe1$export$e88cb2efb12ae807() {
    return $045d360cdc2debe1$export$5880b8b5730aff45;
}
function $045d360cdc2debe1$export$58adb3bec8346d0f(e, r) {
    return $045d360cdc2debe1$export$2f35ab04d2335697($045d360cdc2debe1$export$30a86d91af8ff6e6, e, r);
}
function $045d360cdc2debe1$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $045d360cdc2debe1$export$2de70f21292aac9e(e) {
    return $045d360cdc2debe1$export$53f1d5ea8de3d7c = $045d360cdc2debe1$export$4e0c71f277ca26b3 = 1, $045d360cdc2debe1$export$f24224f1c91d8156 = $045d360cdc2debe1$export$36776f635604f274($045d360cdc2debe1$export$30a86d91af8ff6e6 = e), $045d360cdc2debe1$export$5880b8b5730aff45 = 0, [];
}
function $045d360cdc2debe1$export$45918ac1574455b1(e) {
    return $045d360cdc2debe1$export$30a86d91af8ff6e6 = "", e;
}
function $045d360cdc2debe1$export$410ac95b9ec204b8(e) {
    return $045d360cdc2debe1$export$87c2784dc9fc4ab($045d360cdc2debe1$export$58adb3bec8346d0f($045d360cdc2debe1$export$5880b8b5730aff45 - 1, $045d360cdc2debe1$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $045d360cdc2debe1$export$660b2ee2d4fb4eff(e) {
    return $045d360cdc2debe1$export$45918ac1574455b1($045d360cdc2debe1$export$5f8c09e3ae6f64e1($045d360cdc2debe1$export$2de70f21292aac9e(e)));
}
function $045d360cdc2debe1$export$7af1228ff777d175(e) {
    while($045d360cdc2debe1$export$c0306caf338ac095 = $045d360cdc2debe1$export$4d3fb11e950abb9e())if ($045d360cdc2debe1$export$c0306caf338ac095 < 33) $045d360cdc2debe1$export$48cfd1e771a65c4f();
    else break;
    return $045d360cdc2debe1$export$9e1725a4cfeada27(e) > 2 || $045d360cdc2debe1$export$9e1725a4cfeada27($045d360cdc2debe1$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $045d360cdc2debe1$export$5f8c09e3ae6f64e1(e) {
    while($045d360cdc2debe1$export$48cfd1e771a65c4f())switch($045d360cdc2debe1$export$9e1725a4cfeada27($045d360cdc2debe1$export$c0306caf338ac095)){
        case 0:
            $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$c2ab62c7bf24634($045d360cdc2debe1$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$410ac95b9ec204b8($045d360cdc2debe1$export$c0306caf338ac095), e);
            break;
        default:
            $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$6788812c4e6611e6($045d360cdc2debe1$export$c0306caf338ac095), e);
    }
    return e;
}
function $045d360cdc2debe1$export$955ba06d119e085e(e, r) {
    while(--r && $045d360cdc2debe1$export$48cfd1e771a65c4f())if ($045d360cdc2debe1$export$c0306caf338ac095 < 48 || $045d360cdc2debe1$export$c0306caf338ac095 > 102 || $045d360cdc2debe1$export$c0306caf338ac095 > 57 && $045d360cdc2debe1$export$c0306caf338ac095 < 65 || $045d360cdc2debe1$export$c0306caf338ac095 > 70 && $045d360cdc2debe1$export$c0306caf338ac095 < 97) break;
    return $045d360cdc2debe1$export$58adb3bec8346d0f(e, $045d360cdc2debe1$export$e88cb2efb12ae807() + (r < 6 && $045d360cdc2debe1$export$4d3fb11e950abb9e() == 32 && $045d360cdc2debe1$export$48cfd1e771a65c4f() == 32));
}
function $045d360cdc2debe1$export$c889f2fcc19dbf12(e) {
    while($045d360cdc2debe1$export$48cfd1e771a65c4f())switch($045d360cdc2debe1$export$c0306caf338ac095){
        case e:
            return $045d360cdc2debe1$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $045d360cdc2debe1$export$c889f2fcc19dbf12($045d360cdc2debe1$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $045d360cdc2debe1$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $045d360cdc2debe1$export$48cfd1e771a65c4f();
            break;
    }
    return $045d360cdc2debe1$export$5880b8b5730aff45;
}
function $045d360cdc2debe1$export$4254d4e2b3745c4c(e, r) {
    while($045d360cdc2debe1$export$48cfd1e771a65c4f())if (e + $045d360cdc2debe1$export$c0306caf338ac095 === 57) break;
    else if (e + $045d360cdc2debe1$export$c0306caf338ac095 === 84 && $045d360cdc2debe1$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $045d360cdc2debe1$export$58adb3bec8346d0f(r, $045d360cdc2debe1$export$5880b8b5730aff45 - 1) + "*" + $045d360cdc2debe1$export$6788812c4e6611e6(e === 47 ? e : $045d360cdc2debe1$export$48cfd1e771a65c4f());
}
function $045d360cdc2debe1$export$c2ab62c7bf24634(e) {
    while(!$045d360cdc2debe1$export$9e1725a4cfeada27($045d360cdc2debe1$export$4d3fb11e950abb9e()))$045d360cdc2debe1$export$48cfd1e771a65c4f();
    return $045d360cdc2debe1$export$58adb3bec8346d0f(e, $045d360cdc2debe1$export$5880b8b5730aff45);
}
function $045d360cdc2debe1$export$ef7acd7185315e22(e) {
    return $045d360cdc2debe1$export$45918ac1574455b1($045d360cdc2debe1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $045d360cdc2debe1$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $045d360cdc2debe1$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $045d360cdc2debe1$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $045d360cdc2debe1$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($045d360cdc2debe1$export$f8e21b1e77979a08(j += $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $045d360cdc2debe1$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $045d360cdc2debe1$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $045d360cdc2debe1$export$955ba06d119e085e($045d360cdc2debe1$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($045d360cdc2debe1$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$4a34f930e789283c($045d360cdc2debe1$export$4254d4e2b3745c4c($045d360cdc2debe1$export$48cfd1e771a65c4f(), $045d360cdc2debe1$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $045d360cdc2debe1$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $045d360cdc2debe1$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $045d360cdc2debe1$export$36776f635604f274(j) - l) $045d360cdc2debe1$export$10d8903dec122b9d(p > 32 ? $045d360cdc2debe1$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $045d360cdc2debe1$export$f8483753829ec8f3($045d360cdc2debe1$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $045d360cdc2debe1$export$10d8903dec122b9d(y = $045d360cdc2debe1$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $045d360cdc2debe1$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $045d360cdc2debe1$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $045d360cdc2debe1$export$98e6a39c04603d36(e, y, y, n && $045d360cdc2debe1$export$10d8903dec122b9d($045d360cdc2debe1$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $045d360cdc2debe1$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $045d360cdc2debe1$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $045d360cdc2debe1$export$232faf9add678146() == 125) continue;
            }
            switch(j += $045d360cdc2debe1$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($045d360cdc2debe1$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($045d360cdc2debe1$export$4d3fb11e950abb9e() === 45) j += $045d360cdc2debe1$export$410ac95b9ec204b8($045d360cdc2debe1$export$48cfd1e771a65c4f());
                    v = $045d360cdc2debe1$export$4d3fb11e950abb9e(), o = l = $045d360cdc2debe1$export$36776f635604f274(g = j += $045d360cdc2debe1$export$c2ab62c7bf24634($045d360cdc2debe1$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $045d360cdc2debe1$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $045d360cdc2debe1$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $045d360cdc2debe1$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $045d360cdc2debe1$export$2f35ab04d2335697(e, v + 1, v = $045d360cdc2debe1$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $045d360cdc2debe1$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $045d360cdc2debe1$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, s === 0 ? $045d360cdc2debe1$export$aa3a2e812ca8570d : i, f, o, l);
}
function $045d360cdc2debe1$export$4a34f930e789283c(e, r, a) {
    return $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, $045d360cdc2debe1$export$a29989082612d0d9, $045d360cdc2debe1$export$6788812c4e6611e6($045d360cdc2debe1$export$eba6f6f03b0a92e7()), $045d360cdc2debe1$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $045d360cdc2debe1$export$f8483753829ec8f3(e, r, a, n) {
    return $045d360cdc2debe1$export$35059013cd4a06db(e, r, a, $045d360cdc2debe1$export$527d108ccf083c2b, $045d360cdc2debe1$export$2f35ab04d2335697(e, 0, n), $045d360cdc2debe1$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $045d360cdc2debe1$export$82e9f45cca5ba907(n, c, s) {
    switch($045d360cdc2debe1$export$d6af199866bfb566(n, c)){
        case 5103:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $045d360cdc2debe1$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$2c0f367103c8d01c + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($045d360cdc2debe1$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "box-$1$2" + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-item-" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$045d360cdc2debe1$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $045d360cdc2debe1$export$71ad59f2e432cfe8 + "grid-row-" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-line-pack" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + "box-" + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-grow", "") + $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $045d360cdc2debe1$export$39dfd62a25e0fe93 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "box-pack:$3" + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $045d360cdc2debe1$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$045d360cdc2debe1$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $045d360cdc2debe1$export$71ad59f2e432cfe8 + "grid-column-align" + $045d360cdc2debe1$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $045d360cdc2debe1$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$045d360cdc2debe1$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$045d360cdc2debe1$export$f8e21b1e77979a08(s, "span") ? $045d360cdc2debe1$export$4659b591c19bdf3d(s, /\d+/) : +$045d360cdc2debe1$export$4659b591c19bdf3d(s, /\d+/) - +$045d360cdc2debe1$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $045d360cdc2debe1$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $045d360cdc2debe1$export$71ad59f2e432cfe8 + $045d360cdc2debe1$export$77ad94ebf1c2b9ed($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($045d360cdc2debe1$export$36776f635604f274(n) - 1 - c > 6) switch($045d360cdc2debe1$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($045d360cdc2debe1$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $045d360cdc2debe1$export$2c0f367103c8d01c + ($045d360cdc2debe1$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$045d360cdc2debe1$export$f8e21b1e77979a08(n, "stretch") ? $045d360cdc2debe1$export$82e9f45cca5ba907($045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $045d360cdc2debe1$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $045d360cdc2debe1$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($045d360cdc2debe1$export$a9db5e087081082d(n, c + 6) === 121) return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, ":", ":" + $045d360cdc2debe1$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($045d360cdc2debe1$export$a9db5e087081082d(n, $045d360cdc2debe1$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + ($045d360cdc2debe1$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $045d360cdc2debe1$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, ":", ":" + $045d360cdc2debe1$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $045d360cdc2debe1$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $045d360cdc2debe1$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $045d360cdc2debe1$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $045d360cdc2debe1$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $045d360cdc2debe1$export$a763edbf796b780a:
        case $045d360cdc2debe1$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $045d360cdc2debe1$export$a29989082612d0d9:
            return "";
        case $045d360cdc2debe1$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $045d360cdc2debe1$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $045d360cdc2debe1$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $045d360cdc2debe1$export$36776f635604f274(a = $045d360cdc2debe1$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $045d360cdc2debe1$export$5a7767152ae0305f(e) {
    var r = $045d360cdc2debe1$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $045d360cdc2debe1$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $045d360cdc2debe1$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $045d360cdc2debe1$export$527d108ccf083c2b:
                n.return = $045d360cdc2debe1$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $045d360cdc2debe1$export$b44a8529a35fcb60:
                return $045d360cdc2debe1$export$dfdc1655ccc5b9cb([
                    $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                        value: $045d360cdc2debe1$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $045d360cdc2debe1$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $045d360cdc2debe1$export$aa3a2e812ca8570d:
                if (n.length) return $045d360cdc2debe1$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($045d360cdc2debe1$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $045d360cdc2debe1$export$dfdc1655ccc5b9cb([
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $045d360cdc2debe1$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $045d360cdc2debe1$export$dfdc1655ccc5b9cb([
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $045d360cdc2debe1$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $045d360cdc2debe1$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $045d360cdc2debe1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $045d360cdc2debe1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $045d360cdc2debe1$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $045d360cdc2debe1$export$76a88f7de6507443(e) {
    switch(e.type){
        case $045d360cdc2debe1$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $045d360cdc2debe1$export$1be1fc439b849fdf($045d360cdc2debe1$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($045d360cdc2debe1$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $045d360cdc2debe1$export$2f35ab04d2335697(r, 1, $045d360cdc2debe1$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $045d360cdc2debe1$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $045d360cdc2debe1$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $045d360cdc2debe1$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("bs9D3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8569c751e5c9eed6$export$2e2bcd8739ae039; });
var $8569c751e5c9eed6$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("lA0nP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb5d41e6175b745c$export$2e2bcd8739ae039; });
function $fb5d41e6175b745c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("J0KCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0874c9382bfef3bb$export$2e2bcd8739ae039; });
function $0874c9382bfef3bb$export$2e2bcd8739ae039() {
    $0874c9382bfef3bb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0874c9382bfef3bb$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("apDar", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $794a9f0310c3e9bf$export$2e2bcd8739ae039; });

var $8FL51 = parcelRequire("8FL51");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794a9f0310c3e9bf$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(targetComponent, sourceComponent);
};

});

parcelRegister("fborQ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $b0dad8fed0d47d73$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $b0dad8fed0d47d73$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $b0dad8fed0d47d73$export$6f077d94b33a01aa; });
var $b0dad8fed0d47d73$var$isBrowser = true;
function $b0dad8fed0d47d73$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $b0dad8fed0d47d73$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b0dad8fed0d47d73$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $b0dad8fed0d47d73$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $b0dad8fed0d47d73$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("j0ym9", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $dd68aada5bebf58f$export$6321afa313b251b5; });

var $21UQ8 = parcelRequire("21UQ8");

var $84bKf = parcelRequire("84bKf");

var $lA0nP = parcelRequire("lA0nP");
var $dd68aada5bebf58f$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $dd68aada5bebf58f$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $dd68aada5bebf58f$var$hyphenateRegex = /[A-Z]|^ms/g;
var $dd68aada5bebf58f$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $dd68aada5bebf58f$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $dd68aada5bebf58f$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $dd68aada5bebf58f$var$processStyleName = /* #__PURE__ */ (0, $lA0nP.default)(function(styleName) {
    return $dd68aada5bebf58f$var$isCustomProperty(styleName) ? styleName : styleName.replace($dd68aada5bebf58f$var$hyphenateRegex, "-$&").toLowerCase();
});
var $dd68aada5bebf58f$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($dd68aada5bebf58f$var$animationRegex, function(match, p1, p2) {
                $dd68aada5bebf58f$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $dd68aada5bebf58f$var$cursor
                };
                return p1;
            });
    }
    if ((0, $84bKf.default)[key] !== 1 && !$dd68aada5bebf58f$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $dd68aada5bebf58f$var$contentValuePattern, $dd68aada5bebf58f$var$contentValues, $dd68aada5bebf58f$var$oldProcessStyleValue, $dd68aada5bebf58f$var$msPattern, $dd68aada5bebf58f$var$hyphenPattern, $dd68aada5bebf58f$var$hyphenatedCache;
var $dd68aada5bebf58f$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $dd68aada5bebf58f$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $dd68aada5bebf58f$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $dd68aada5bebf58f$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $dd68aada5bebf58f$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $dd68aada5bebf58f$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $dd68aada5bebf58f$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $dd68aada5bebf58f$var$cursor;
                var result = interpolation(mergedProps);
                $dd68aada5bebf58f$var$cursor = previousCursor;
                return $dd68aada5bebf58f$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $dd68aada5bebf58f$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $dd68aada5bebf58f$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($dd68aada5bebf58f$var$isProcessableValue(value)) string += $dd68aada5bebf58f$var$processStyleName(_key) + ":" + $dd68aada5bebf58f$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($dd68aada5bebf58f$var$isProcessableValue(value[_i])) string += $dd68aada5bebf58f$var$processStyleName(_key) + ":" + $dd68aada5bebf58f$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $dd68aada5bebf58f$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $dd68aada5bebf58f$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $dd68aada5bebf58f$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $dd68aada5bebf58f$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $dd68aada5bebf58f$var$cursor;
var $dd68aada5bebf58f$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $dd68aada5bebf58f$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $dd68aada5bebf58f$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $dd68aada5bebf58f$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $dd68aada5bebf58f$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $dd68aada5bebf58f$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $21UQ8.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $dd68aada5bebf58f$var$cursor
    };
};

});
parcelRegister("21UQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a7c3fd280e2212$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $17a7c3fd280e2212$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("84bKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5df7cec1bea51045$export$2e2bcd8739ae039; });
var $5df7cec1bea51045$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("bvyRs", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $860da1a7a1e566ac$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $860da1a7a1e566ac$export$811a713a7276cb9d; });

var $2hDQc = parcelRequire("2hDQc");
var $860da1a7a1e566ac$var$syncFallback = function syncFallback(create) {
    return create();
};
var $860da1a7a1e566ac$var$useInsertionEffect = $2hDQc.useInsertionEffect ? $2hDQc.useInsertionEffect : false;
var $860da1a7a1e566ac$export$db21c7ffa21794e7 = $860da1a7a1e566ac$var$useInsertionEffect || $860da1a7a1e566ac$var$syncFallback;
var $860da1a7a1e566ac$export$811a713a7276cb9d = $860da1a7a1e566ac$var$useInsertionEffect || $2hDQc.useLayoutEffect;

});


parcelRegister("7vVRg", function(module, exports) {
function $57884f128b84af78$var$_extends() {
    module.exports = $57884f128b84af78$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $57884f128b84af78$var$_extends.apply(this, arguments);
}
module.exports = $57884f128b84af78$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("7D60m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e0d55d9cceed97$export$2e2bcd8739ae039; });

var $gWoNj = parcelRequire("gWoNj");
"use client";
const $58e0d55d9cceed97$var$defaultTheme = (0, $gWoNj.default)();
var $58e0d55d9cceed97$export$2e2bcd8739ae039 = $58e0d55d9cceed97$var$defaultTheme;

});
parcelRegister("gWoNj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5554bbfd3c8e1ea$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $e79HO = parcelRequire("e79HO");

var $lCJj0 = parcelRequire("lCJj0");

var $l1ZeQ = parcelRequire("l1ZeQ");
var $870HA = parcelRequire("870HA");
var $fZq7u = parcelRequire("fZq7u");


var $iFDDw = parcelRequire("iFDDw");

var $7dztz = parcelRequire("7dztz");

var $cnd82 = parcelRequire("cnd82");

var $fWfYB = parcelRequire("fWfYB");

var $8xjDP = parcelRequire("8xjDP");

var $5xc4L = parcelRequire("5xc4L");
const $c5554bbfd3c8e1ea$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $c5554bbfd3c8e1ea$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $gZOiq.default)(options, $c5554bbfd3c8e1ea$var$_excluded);
    if (options.vars) throw new Error((0, $e79HO.default)(18));
    const palette = (0, $7dztz.default)(paletteInput);
    const systemTheme = (0, $l1ZeQ.default)(options);
    let muiTheme = (0, $lCJj0.default)(systemTheme, {
        mixins: (0, $iFDDw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $fWfYB.default).slice(),
        typography: (0, $cnd82.default)(palette, typographyInput),
        transitions: (0, $8xjDP.default)(transitionsInput),
        zIndex: (0, $kxIgO.default)({}, (0, $5xc4L.default))
    });
    muiTheme = (0, $lCJj0.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $lCJj0.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kxIgO.default)({}, (0, $870HA.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $fZq7u.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $c5554bbfd3c8e1ea$var$warnedOnce = false;
function $c5554bbfd3c8e1ea$export$c469355549431d9b(...args) {
    return $c5554bbfd3c8e1ea$var$createTheme(...args);
}
var $c5554bbfd3c8e1ea$export$2e2bcd8739ae039 = $c5554bbfd3c8e1ea$var$createTheme;

});
parcelRegister("iFDDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d97acd4f56ef46a7$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");
function $d97acd4f56ef46a7$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kxIgO.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("7dztz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54154414c731d4b5$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $e79HO = parcelRequire("e79HO");

var $lCJj0 = parcelRequire("lCJj0");

var $6KAST = parcelRequire("6KAST");

var $dxnEX = parcelRequire("dxnEX");

var $iMY5u = parcelRequire("iMY5u");

var $8aqst = parcelRequire("8aqst");

var $ko7Lm = parcelRequire("ko7Lm");

var $c3ICA = parcelRequire("c3ICA");

var $lArej = parcelRequire("lArej");

var $bcP5F = parcelRequire("bcP5F");

var $dwciD = parcelRequire("dwciD");
const $54154414c731d4b5$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $54154414c731d4b5$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dxnEX.default).white,
        default: (0, $dxnEX.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $54154414c731d4b5$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dxnEX.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $dxnEX.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $54154414c731d4b5$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $6KAST.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $6KAST.darken)(intent.main, tonalOffsetDark);
    }
}
function $54154414c731d4b5$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $lArej.default)[200],
        light: (0, $lArej.default)[50],
        dark: (0, $lArej.default)[400]
    };
    return {
        main: (0, $lArej.default)[700],
        light: (0, $lArej.default)[400],
        dark: (0, $lArej.default)[800]
    };
}
function $54154414c731d4b5$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8aqst.default)[200],
        light: (0, $8aqst.default)[50],
        dark: (0, $8aqst.default)[400]
    };
    return {
        main: (0, $8aqst.default)[500],
        light: (0, $8aqst.default)[300],
        dark: (0, $8aqst.default)[700]
    };
}
function $54154414c731d4b5$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ko7Lm.default)[500],
        light: (0, $ko7Lm.default)[300],
        dark: (0, $ko7Lm.default)[700]
    };
    return {
        main: (0, $ko7Lm.default)[700],
        light: (0, $ko7Lm.default)[400],
        dark: (0, $ko7Lm.default)[800]
    };
}
function $54154414c731d4b5$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bcP5F.default)[400],
        light: (0, $bcP5F.default)[300],
        dark: (0, $bcP5F.default)[700]
    };
    return {
        main: (0, $bcP5F.default)[700],
        light: (0, $bcP5F.default)[500],
        dark: (0, $bcP5F.default)[900]
    };
}
function $54154414c731d4b5$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dwciD.default)[400],
        light: (0, $dwciD.default)[300],
        dark: (0, $dwciD.default)[700]
    };
    return {
        main: (0, $dwciD.default)[800],
        light: (0, $dwciD.default)[500],
        dark: (0, $dwciD.default)[900]
    };
}
function $54154414c731d4b5$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $c3ICA.default)[400],
        light: (0, $c3ICA.default)[300],
        dark: (0, $c3ICA.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $c3ICA.default)[500],
        dark: (0, $c3ICA.default)[900]
    };
}
function $54154414c731d4b5$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $gZOiq.default)(palette, $54154414c731d4b5$var$_excluded);
    const primary = palette.primary || $54154414c731d4b5$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $54154414c731d4b5$var$getDefaultSecondary(mode);
    const error = palette.error || $54154414c731d4b5$var$getDefaultError(mode);
    const info = palette.info || $54154414c731d4b5$var$getDefaultInfo(mode);
    const success = palette.success || $54154414c731d4b5$var$getDefaultSuccess(mode);
    const warning = palette.warning || $54154414c731d4b5$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $6KAST.getContrastRatio)(background, $54154414c731d4b5$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $54154414c731d4b5$export$55ce6f3a06c59543.text.primary : $54154414c731d4b5$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kxIgO.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $e79HO.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $e79HO.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $54154414c731d4b5$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $54154414c731d4b5$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $54154414c731d4b5$export$55ce6f3a06c59543,
        light: $54154414c731d4b5$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $lCJj0.default)((0, $kxIgO.default)({
        // A collection of common colors.
        common: (0, $kxIgO.default)({}, (0, $dxnEX.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $iMY5u.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("6KAST", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $4ea3a667af6e7cb9$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $4ea3a667af6e7cb9$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $4ea3a667af6e7cb9$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $4ea3a667af6e7cb9$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $4ea3a667af6e7cb9$export$e665714f76e581fd; });

var $e79HO = parcelRequire("e79HO");

var $e2jgl = parcelRequire("e2jgl");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $4ea3a667af6e7cb9$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $e2jgl.default)(value, min, max);
}
function $4ea3a667af6e7cb9$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $4ea3a667af6e7cb9$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $4ea3a667af6e7cb9$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $4ea3a667af6e7cb9$export$677b39864803984e($4ea3a667af6e7cb9$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $e79HO.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $e79HO.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $4ea3a667af6e7cb9$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $4ea3a667af6e7cb9$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $4ea3a667af6e7cb9$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $4ea3a667af6e7cb9$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $4ea3a667af6e7cb9$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$4ea3a667af6e7cb9$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $4ea3a667af6e7cb9$export$29fb7152bd3f781a(color) {
    color = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $4ea3a667af6e7cb9$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $4ea3a667af6e7cb9$export$c852d90bf7403b62(color) {
    color = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $4ea3a667af6e7cb9$export$677b39864803984e($4ea3a667af6e7cb9$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $4ea3a667af6e7cb9$export$d061e26956a60b0a(foreground, background) {
    const lumA = $4ea3a667af6e7cb9$export$c852d90bf7403b62(foreground);
    const lumB = $4ea3a667af6e7cb9$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $4ea3a667af6e7cb9$export$58f0f39f63f3cf42(color, value) {
    color = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    value = $4ea3a667af6e7cb9$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $4ea3a667af6e7cb9$export$211a73f2b8c10ce4(color);
}
function $4ea3a667af6e7cb9$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $4ea3a667af6e7cb9$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $4ea3a667af6e7cb9$export$4b073707ff63303(color, coefficient) {
    color = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    coefficient = $4ea3a667af6e7cb9$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $4ea3a667af6e7cb9$export$211a73f2b8c10ce4(color);
}
function $4ea3a667af6e7cb9$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $4ea3a667af6e7cb9$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4ea3a667af6e7cb9$export$c0816ed86df316af(color, coefficient) {
    color = $4ea3a667af6e7cb9$export$677b39864803984e(color);
    coefficient = $4ea3a667af6e7cb9$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $4ea3a667af6e7cb9$export$211a73f2b8c10ce4(color);
}
function $4ea3a667af6e7cb9$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $4ea3a667af6e7cb9$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4ea3a667af6e7cb9$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $4ea3a667af6e7cb9$export$c852d90bf7403b62(color) > 0.5 ? $4ea3a667af6e7cb9$export$4b073707ff63303(color, coefficient) : $4ea3a667af6e7cb9$export$c0816ed86df316af(color, coefficient);
}
function $4ea3a667af6e7cb9$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $4ea3a667af6e7cb9$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});
parcelRegister("e2jgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a38031c4432b61b4$export$2e2bcd8739ae039; });
function $a38031c4432b61b4$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $a38031c4432b61b4$export$2e2bcd8739ae039 = $a38031c4432b61b4$var$clamp;

});


parcelRegister("dxnEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db0b5c0d9cb302d$export$2e2bcd8739ae039; });
const $9db0b5c0d9cb302d$var$common = {
    black: "#000",
    white: "#fff"
};
var $9db0b5c0d9cb302d$export$2e2bcd8739ae039 = $9db0b5c0d9cb302d$var$common;

});

parcelRegister("iMY5u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dadb51d227319471$export$2e2bcd8739ae039; });
const $dadb51d227319471$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $dadb51d227319471$export$2e2bcd8739ae039 = $dadb51d227319471$var$grey;

});

parcelRegister("8aqst", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f23c7f234a08ee9$export$2e2bcd8739ae039; });
const $5f23c7f234a08ee9$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $5f23c7f234a08ee9$export$2e2bcd8739ae039 = $5f23c7f234a08ee9$var$purple;

});

parcelRegister("ko7Lm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed7c12111a138f1a$export$2e2bcd8739ae039; });
const $ed7c12111a138f1a$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $ed7c12111a138f1a$export$2e2bcd8739ae039 = $ed7c12111a138f1a$var$red;

});

parcelRegister("c3ICA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7860ba439d21e3$export$2e2bcd8739ae039; });
const $8c7860ba439d21e3$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $8c7860ba439d21e3$export$2e2bcd8739ae039 = $8c7860ba439d21e3$var$orange;

});

parcelRegister("lArej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb7215121538ca45$export$2e2bcd8739ae039; });
const $fb7215121538ca45$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $fb7215121538ca45$export$2e2bcd8739ae039 = $fb7215121538ca45$var$blue;

});

parcelRegister("bcP5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8288723048c378af$export$2e2bcd8739ae039; });
const $8288723048c378af$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $8288723048c378af$export$2e2bcd8739ae039 = $8288723048c378af$var$lightBlue;

});

parcelRegister("dwciD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d77cdf55c4c768e$export$2e2bcd8739ae039; });
const $9d77cdf55c4c768e$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $9d77cdf55c4c768e$export$2e2bcd8739ae039 = $9d77cdf55c4c768e$var$green;

});


parcelRegister("cnd82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9021d1160b8f719a$export$2e2bcd8739ae039; });

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $lCJj0 = parcelRequire("lCJj0");
const $9021d1160b8f719a$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $9021d1160b8f719a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $9021d1160b8f719a$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $9021d1160b8f719a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $9021d1160b8f719a$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $9021d1160b8f719a$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $gZOiq.default)(_ref, $9021d1160b8f719a$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kxIgO.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $9021d1160b8f719a$var$defaultFontFamily ? {
            letterSpacing: `${$9021d1160b8f719a$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $9021d1160b8f719a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $9021d1160b8f719a$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $lCJj0.default)((0, $kxIgO.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("fWfYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a8aa5ff1c417fb$export$2e2bcd8739ae039; });
const $b9a8aa5ff1c417fb$var$shadowKeyUmbraOpacity = 0.2;
const $b9a8aa5ff1c417fb$var$shadowKeyPenumbraOpacity = 0.14;
const $b9a8aa5ff1c417fb$var$shadowAmbientShadowOpacity = 0.12;
function $b9a8aa5ff1c417fb$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$b9a8aa5ff1c417fb$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$b9a8aa5ff1c417fb$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$b9a8aa5ff1c417fb$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $b9a8aa5ff1c417fb$var$shadows = [
    "none",
    $b9a8aa5ff1c417fb$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $b9a8aa5ff1c417fb$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $b9a8aa5ff1c417fb$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $b9a8aa5ff1c417fb$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $b9a8aa5ff1c417fb$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $b9a8aa5ff1c417fb$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $b9a8aa5ff1c417fb$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $b9a8aa5ff1c417fb$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $b9a8aa5ff1c417fb$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $b9a8aa5ff1c417fb$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $b9a8aa5ff1c417fb$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $b9a8aa5ff1c417fb$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $b9a8aa5ff1c417fb$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $b9a8aa5ff1c417fb$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $b9a8aa5ff1c417fb$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $b9a8aa5ff1c417fb$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $b9a8aa5ff1c417fb$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $b9a8aa5ff1c417fb$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $b9a8aa5ff1c417fb$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $b9a8aa5ff1c417fb$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $b9a8aa5ff1c417fb$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $b9a8aa5ff1c417fb$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $b9a8aa5ff1c417fb$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $b9a8aa5ff1c417fb$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $b9a8aa5ff1c417fb$export$2e2bcd8739ae039 = $b9a8aa5ff1c417fb$var$shadows;

});

parcelRegister("8xjDP", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $6370a42bdcc5b0d5$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $6370a42bdcc5b0d5$export$2e2bcd8739ae039; });

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");
const $6370a42bdcc5b0d5$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $6370a42bdcc5b0d5$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $6370a42bdcc5b0d5$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $6370a42bdcc5b0d5$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $6370a42bdcc5b0d5$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $6370a42bdcc5b0d5$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kxIgO.default)({}, $6370a42bdcc5b0d5$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kxIgO.default)({}, $6370a42bdcc5b0d5$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $gZOiq.default)(options, $6370a42bdcc5b0d5$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $6370a42bdcc5b0d5$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $6370a42bdcc5b0d5$var$formatMs(delay)}`).join(",");
    };
    return (0, $kxIgO.default)({
        getAutoHeightDuration: $6370a42bdcc5b0d5$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("5xc4L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $407966d094382585$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $407966d094382585$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $407966d094382585$export$2e2bcd8739ae039 = $407966d094382585$var$zIndex;

});



parcelRegister("3apk9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e5f316396b93f0$export$2e2bcd8739ae039; });
var $24e5f316396b93f0$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("fhlQp", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $b1f9635eb034f42f$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $b1f9635eb034f42f$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $b1f9635eb034f42f$export$2e2bcd8739ae039; });

var $dnmSH = parcelRequire("dnmSH");

var $7D60m = parcelRequire("7D60m");

var $3apk9 = parcelRequire("3apk9");
"use client";
const $b1f9635eb034f42f$export$effb20ecdbf4d6aa = (prop)=>(0, $dnmSH.shouldForwardProp)(prop) && prop !== "classes";
const $b1f9635eb034f42f$export$f10c5a10d27438e5 = (0, $dnmSH.shouldForwardProp);
const $b1f9635eb034f42f$var$styled = (0, $dnmSH.default)({
    themeId: (0, $3apk9.default),
    defaultTheme: $7D60m.default,
    rootShouldForwardProp: $b1f9635eb034f42f$export$effb20ecdbf4d6aa
});
var $b1f9635eb034f42f$export$2e2bcd8739ae039 = $b1f9635eb034f42f$var$styled;

});
parcelRegister("dnmSH", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $9bcf2c187d02e925$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $9bcf2c187d02e925$export$2e2bcd8739ae039; });

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $lxfp9 = parcelRequire("lxfp9");

var $lCJj0 = parcelRequire("lCJj0");

var $l1ZeQ = parcelRequire("l1ZeQ");

var $hU9J0 = parcelRequire("hU9J0");

var $fZq7u = parcelRequire("fZq7u");
const $9bcf2c187d02e925$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $9bcf2c187d02e925$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9bcf2c187d02e925$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $9bcf2c187d02e925$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $9bcf2c187d02e925$var$transformVariants = (variants)=>{
    let numOfCallbacks = 0;
    const variantsStyles = {};
    if (variants) variants.forEach((definition)=>{
        let key = "";
        if (typeof definition.props === "function") {
            key = `callback${numOfCallbacks}`;
            numOfCallbacks += 1;
        } else key = (0, $hU9J0.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $9bcf2c187d02e925$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    return $9bcf2c187d02e925$var$transformVariants(variants);
};
const $9bcf2c187d02e925$var$variantsResolver = (props, styles, variants)=>{
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    let numOfCallbacks = 0;
    if (variants) variants.forEach((variant)=>{
        let isMatch = true;
        if (typeof variant.props === "function") {
            const propsToCheck = (0, $kxIgO.default)({}, props, ownerState);
            isMatch = variant.props(propsToCheck);
        } else Object.keys(variant.props).forEach((key)=>{
            if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
        });
        if (isMatch) {
            if (typeof variant.props === "function") variantsStyles.push(styles[`callback${numOfCallbacks}`]);
            else variantsStyles.push(styles[(0, $hU9J0.default)(variant.props)]);
        }
        if (typeof variant.props === "function") numOfCallbacks += 1;
    });
    return variantsStyles;
};
const $9bcf2c187d02e925$var$themeVariantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    return $9bcf2c187d02e925$var$variantsResolver(props, styles, themeVariants);
};
function $9bcf2c187d02e925$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $9bcf2c187d02e925$export$35e57303dbd8a66 = (0, $l1ZeQ.default)();
const $9bcf2c187d02e925$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $9bcf2c187d02e925$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $9bcf2c187d02e925$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $9bcf2c187d02e925$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
const $9bcf2c187d02e925$var$muiStyledFunctionResolver = ({ styledArg: styledArg, props: props, defaultTheme: defaultTheme, themeId: themeId })=>{
    const resolvedStyles = styledArg((0, $kxIgO.default)({}, props, {
        theme: $9bcf2c187d02e925$var$resolveTheme((0, $kxIgO.default)({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
        }))
    }));
    let optionalVariants;
    if (resolvedStyles && resolvedStyles.variants) {
        optionalVariants = resolvedStyles.variants;
        delete resolvedStyles.variants;
    }
    if (optionalVariants) {
        const variantsStyles = $9bcf2c187d02e925$var$variantsResolver(props, $9bcf2c187d02e925$var$transformVariants(optionalVariants), optionalVariants);
        return [
            resolvedStyles,
            ...variantsStyles
        ];
    }
    return resolvedStyles;
};
function $9bcf2c187d02e925$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9bcf2c187d02e925$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9bcf2c187d02e925$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9bcf2c187d02e925$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $fZq7u.default)((0, $kxIgO.default)({}, props, {
            theme: $9bcf2c187d02e925$var$resolveTheme((0, $kxIgO.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $lxfp9.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9bcf2c187d02e925$var$defaultOverridesResolver($9bcf2c187d02e925$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $gZOiq.default)(inputOptions, $9bcf2c187d02e925$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $9bcf2c187d02e925$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9bcf2c187d02e925$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $lxfp9.default)(tag, (0, $kxIgO.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg) return (props)=>$9bcf2c187d02e925$var$muiStyledFunctionResolver({
                        styledArg: stylesArg,
                        props: props,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    });
                if ((0, $lCJj0.isPlainObject)(stylesArg)) {
                    let transformedStylesArg = stylesArg;
                    let styledArgVariants;
                    if (stylesArg && stylesArg.variants) {
                        styledArgVariants = stylesArg.variants;
                        delete transformedStylesArg.variants;
                        transformedStylesArg = (props)=>{
                            let result = stylesArg;
                            const variantStyles = $9bcf2c187d02e925$var$variantsResolver(props, $9bcf2c187d02e925$var$transformVariants(styledArgVariants), styledArgVariants);
                            variantStyles.forEach((variantStyle)=>{
                                result = (0, $lCJj0.default)(result, variantStyle);
                            });
                            return result;
                        };
                    }
                    return transformedStylesArg;
                }
                return stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if ((0, $lCJj0.isPlainObject)(styleArg)) {
                let styledArgVariants;
                if (styleArg && styleArg.variants) {
                    styledArgVariants = styleArg.variants;
                    delete transformedStyleArg.variants;
                    transformedStyleArg = (props)=>{
                        let result = styleArg;
                        const variantStyles = $9bcf2c187d02e925$var$variantsResolver(props, $9bcf2c187d02e925$var$transformVariants(styledArgVariants), styledArgVariants);
                        variantStyles.forEach((variantStyle)=>{
                            result = (0, $lCJj0.default)(result, variantStyle);
                        });
                        return result;
                    };
                }
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>$9bcf2c187d02e925$var$muiStyledFunctionResolver({
                    styledArg: styleArg,
                    props: props,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $9bcf2c187d02e925$var$resolveTheme((0, $kxIgO.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $9bcf2c187d02e925$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $kxIgO.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $9bcf2c187d02e925$var$resolveTheme((0, $kxIgO.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $9bcf2c187d02e925$var$themeVariantsResolver(props, $9bcf2c187d02e925$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("lxfp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fad8a1188513a4f2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $fad8a1188513a4f2$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.15.7
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $jFevA = parcelRequire("jFevA");

var $3NAKi = parcelRequire("3NAKi");
var $9INUU = parcelRequire("9INUU");


var $gfsZE = parcelRequire("gfsZE");
"use client";
function $fad8a1188513a4f2$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $jFevA.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $fad8a1188513a4f2$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("jFevA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e50d19beca222062$export$2e2bcd8739ae039; });

var $8yGE3 = parcelRequire("8yGE3");
parcelRequire("7vVRg");
parcelRequire("2hDQc");
parcelRequire("1TWqN");

parcelRequire("fborQ");
parcelRequire("j0ym9");
parcelRequire("bvyRs");
var $e50d19beca222062$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $e50d19beca222062$export$2e2bcd8739ae039 = (0, $8yGE3.default).bind();
$e50d19beca222062$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $e50d19beca222062$export$2e2bcd8739ae039[tagName] = $e50d19beca222062$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("8yGE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b2941ad35c68e5$export$2e2bcd8739ae039; });

var $J0KCN = parcelRequire("J0KCN");

var $2hDQc = parcelRequire("2hDQc");

var $1TWqN = parcelRequire("1TWqN");
parcelRequire("3NAKi");
var $9INUU = parcelRequire("9INUU");

var $fborQ = parcelRequire("fborQ");

var $j0ym9 = parcelRequire("j0ym9");

var $bvyRs = parcelRequire("bvyRs");
var $63b2941ad35c68e5$var$testOmitPropsOnStringTag = (0, $1TWqN.default);
var $63b2941ad35c68e5$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $63b2941ad35c68e5$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $63b2941ad35c68e5$var$testOmitPropsOnStringTag : $63b2941ad35c68e5$var$testOmitPropsOnComponent;
};
var $63b2941ad35c68e5$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $63b2941ad35c68e5$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $63b2941ad35c68e5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fborQ.registerStyles)(cache, serialized, isStringTag);
    (0, $bvyRs.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fborQ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $63b2941ad35c68e5$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $63b2941ad35c68e5$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $63b2941ad35c68e5$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $9INUU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $2hDQc.useContext((0, $9INUU.T));
            }
            if (typeof props.className === "string") className = (0, $fborQ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $j0ym9.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $63b2941ad35c68e5$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, /*#__PURE__*/ $2hDQc.createElement($63b2941ad35c68e5$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $2hDQc.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $J0KCN.default)({}, options, nextOptions, {
                shouldForwardProp: $63b2941ad35c68e5$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("1TWqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $162840bc4487c2d8$export$2e2bcd8739ae039; });

var $lA0nP = parcelRequire("lA0nP");
var $162840bc4487c2d8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $162840bc4487c2d8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $lA0nP.default)(function(prop) {
    return $162840bc4487c2d8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("gfsZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd448989ac664bd9$export$2e2bcd8739ae039; });
parcelRequire("2hDQc");


var $3NAKi = parcelRequire("3NAKi");

var $592Nh = parcelRequire("592Nh");
"use client";
function $bd448989ac664bd9$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $bd448989ac664bd9$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($bd448989ac664bd9$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $3NAKi.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("592Nh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8tTPf"));

});



parcelRegister("hU9J0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d08f35c83dea0054$export$2e2bcd8739ae039; });

var $gZOiq = parcelRequire("gZOiq");

var $cgn0z = parcelRequire("cgn0z");
const $d08f35c83dea0054$var$_excluded = [
    "variant"
];
function $d08f35c83dea0054$var$isEmpty(string) {
    return string.length === 0;
}
function $d08f35c83dea0054$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $gZOiq.default)(props, $d08f35c83dea0054$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $d08f35c83dea0054$var$isEmpty(classKey) ? props[key] : (0, $cgn0z.default)(props[key]);
        else classKey += `${$d08f35c83dea0054$var$isEmpty(classKey) ? key : (0, $cgn0z.default)(key)}${(0, $cgn0z.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRegister("k1xdp", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $e93daa817952d006$export$c7c50641356bdfa5; });

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $e93daa817952d006$export$c7c50641356bdfa5(slot) {
    return (0, $01COD.default)("MuiSvgIcon", slot);
}
const $e93daa817952d006$var$svgIconClasses = (0, $eLydt.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $e93daa817952d006$export$2e2bcd8739ae039 = $e93daa817952d006$var$svgIconClasses;

});
parcelRegister("eLydt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abffff23bc1eb517$export$2e2bcd8739ae039; });

var $01COD = parcelRequire("01COD");
function $abffff23bc1eb517$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $01COD.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("01COD", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $004e3419d28d5f62$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $004e3419d28d5f62$export$2e2bcd8739ae039; });

var $4WSmP = parcelRequire("4WSmP");
const $004e3419d28d5f62$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $004e3419d28d5f62$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $004e3419d28d5f62$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $4WSmP.default).generate(componentName)}-${slot}`;
}
function $004e3419d28d5f62$export$34c0130b1f3e8ae3(slot) {
    return $004e3419d28d5f62$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("4WSmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a6c068128d0fe4$export$2e2bcd8739ae039; });
const $39a6c068128d0fe4$var$defaultGenerator = (componentName)=>componentName;
const $39a6c068128d0fe4$var$createClassNameGenerator = ()=>{
    let generate = $39a6c068128d0fe4$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $39a6c068128d0fe4$var$defaultGenerator;
        }
    };
};
const $39a6c068128d0fe4$var$ClassNameGenerator = $39a6c068128d0fe4$var$createClassNameGenerator();
var $39a6c068128d0fe4$export$2e2bcd8739ae039 = $39a6c068128d0fe4$var$ClassNameGenerator;

});







parcelRegister("iCWoj", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d8f911d802dd94a5$export$a7c73072b1a182ae; }, function (v) { return $d8f911d802dd94a5$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d8f911d802dd94a5$export$9f27bc3417b4524d; }, function (v) { return $d8f911d802dd94a5$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d8f911d802dd94a5$export$db77ccec0bb4ccac; }, function (v) { return $d8f911d802dd94a5$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d8f911d802dd94a5$export$8392c0c9d3dcbd35; }, function (v) { return $d8f911d802dd94a5$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d8f911d802dd94a5$export$ffb0004e005737fa; }, function (v) { return $d8f911d802dd94a5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d8f911d802dd94a5$export$b624eff549462981; }, function (v) { return $d8f911d802dd94a5$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d8f911d802dd94a5$export$7897aa7841a5380c; }, function (v) { return $d8f911d802dd94a5$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d8f911d802dd94a5$export$602eac185826482c; }, function (v) { return $d8f911d802dd94a5$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d8f911d802dd94a5$export$e2c29f18771995cb; }, function (v) { return $d8f911d802dd94a5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d8f911d802dd94a5$export$5f8d39834fd61797; }, function (v) { return $d8f911d802dd94a5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d8f911d802dd94a5$export$74bf444e3cd11ea5; }, function (v) { return $d8f911d802dd94a5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d8f911d802dd94a5$export$998bcd577473dd93; }, function (v) { return $d8f911d802dd94a5$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d8f911d802dd94a5$export$92387174baf9b227; }, function (v) { return $d8f911d802dd94a5$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d8f911d802dd94a5$export$ec112efeb987d9c6; }, function (v) { return $d8f911d802dd94a5$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d8f911d802dd94a5$export$b706b080d889d2c9; }, function (v) { return $d8f911d802dd94a5$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d8f911d802dd94a5$export$5be5a87408f70ddc; }, function (v) { return $d8f911d802dd94a5$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d8f911d802dd94a5$export$45a5e7f76e0caa8d; }, function (v) { return $d8f911d802dd94a5$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d8f911d802dd94a5$export$455c2e768291efa6; }, function (v) { return $d8f911d802dd94a5$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d8f911d802dd94a5$export$9522e17588c12572; }, function (v) { return $d8f911d802dd94a5$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d8f911d802dd94a5$export$2110ac352bb060b9; }, function (v) { return $d8f911d802dd94a5$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d8f911d802dd94a5$export$56885ab8b9c456ab; }, function (v) { return $d8f911d802dd94a5$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d8f911d802dd94a5$export$d927fcb6adf8f9de; }, function (v) { return $d8f911d802dd94a5$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d8f911d802dd94a5$export$b82d16f27459e05a; }, function (v) { return $d8f911d802dd94a5$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d8f911d802dd94a5$export$522c17b4f5e123e8; }, function (v) { return $d8f911d802dd94a5$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d8f911d802dd94a5$export$1aabd8a0274ecfd6; }, function (v) { return $d8f911d802dd94a5$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d8f911d802dd94a5$export$3d6c20d97e46b957; }, function (v) { return $d8f911d802dd94a5$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d8f911d802dd94a5$export$9b621391a187a31a; }, function (v) { return $d8f911d802dd94a5$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d8f911d802dd94a5$export$f5bbd400c2f4426f; }, function (v) { return $d8f911d802dd94a5$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d8f911d802dd94a5$export$a7c73072b1a182ae;
var $d8f911d802dd94a5$export$9f27bc3417b4524d;
var $d8f911d802dd94a5$export$db77ccec0bb4ccac;
var $d8f911d802dd94a5$export$8392c0c9d3dcbd35;
var $d8f911d802dd94a5$export$ffb0004e005737fa;
var $d8f911d802dd94a5$export$b624eff549462981;
var $d8f911d802dd94a5$export$7897aa7841a5380c;
var $d8f911d802dd94a5$export$602eac185826482c;
var $d8f911d802dd94a5$export$e2c29f18771995cb;
var $d8f911d802dd94a5$export$5f8d39834fd61797;
var $d8f911d802dd94a5$export$74bf444e3cd11ea5;
var $d8f911d802dd94a5$export$998bcd577473dd93;
var $d8f911d802dd94a5$export$92387174baf9b227;
var $d8f911d802dd94a5$export$ec112efeb987d9c6;
var $d8f911d802dd94a5$export$b706b080d889d2c9;
var $d8f911d802dd94a5$export$5be5a87408f70ddc;
var $d8f911d802dd94a5$export$45a5e7f76e0caa8d;
var $d8f911d802dd94a5$export$455c2e768291efa6;
var $d8f911d802dd94a5$export$9522e17588c12572;
var $d8f911d802dd94a5$export$2110ac352bb060b9;
var $d8f911d802dd94a5$export$56885ab8b9c456ab;
var $d8f911d802dd94a5$export$d927fcb6adf8f9de;
var $d8f911d802dd94a5$export$b82d16f27459e05a;
var $d8f911d802dd94a5$export$522c17b4f5e123e8;
var $d8f911d802dd94a5$export$1aabd8a0274ecfd6;
var $d8f911d802dd94a5$export$3d6c20d97e46b957;
var $d8f911d802dd94a5$export$9b621391a187a31a;
var $d8f911d802dd94a5$export$f5bbd400c2f4426f;
"use strict";
var $d8f911d802dd94a5$var$b = Symbol.for("react.element"), $d8f911d802dd94a5$var$c = Symbol.for("react.portal"), $d8f911d802dd94a5$var$d = Symbol.for("react.fragment"), $d8f911d802dd94a5$var$e = Symbol.for("react.strict_mode"), $d8f911d802dd94a5$var$f = Symbol.for("react.profiler"), $d8f911d802dd94a5$var$g = Symbol.for("react.provider"), $d8f911d802dd94a5$var$h = Symbol.for("react.context"), $d8f911d802dd94a5$var$k = Symbol.for("react.server_context"), $d8f911d802dd94a5$var$l = Symbol.for("react.forward_ref"), $d8f911d802dd94a5$var$m = Symbol.for("react.suspense"), $d8f911d802dd94a5$var$n = Symbol.for("react.suspense_list"), $d8f911d802dd94a5$var$p = Symbol.for("react.memo"), $d8f911d802dd94a5$var$q = Symbol.for("react.lazy"), $d8f911d802dd94a5$var$t = Symbol.for("react.offscreen"), $d8f911d802dd94a5$var$u;
$d8f911d802dd94a5$var$u = Symbol.for("react.module.reference");
function $d8f911d802dd94a5$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d8f911d802dd94a5$var$b:
                switch(a = a.type, a){
                    case $d8f911d802dd94a5$var$d:
                    case $d8f911d802dd94a5$var$f:
                    case $d8f911d802dd94a5$var$e:
                    case $d8f911d802dd94a5$var$m:
                    case $d8f911d802dd94a5$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d8f911d802dd94a5$var$k:
                            case $d8f911d802dd94a5$var$h:
                            case $d8f911d802dd94a5$var$l:
                            case $d8f911d802dd94a5$var$q:
                            case $d8f911d802dd94a5$var$p:
                            case $d8f911d802dd94a5$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d8f911d802dd94a5$var$c:
                return r;
        }
    }
}
$d8f911d802dd94a5$export$a7c73072b1a182ae = $d8f911d802dd94a5$var$h;
$d8f911d802dd94a5$export$9f27bc3417b4524d = $d8f911d802dd94a5$var$g;
$d8f911d802dd94a5$export$db77ccec0bb4ccac = $d8f911d802dd94a5$var$b;
$d8f911d802dd94a5$export$8392c0c9d3dcbd35 = $d8f911d802dd94a5$var$l;
$d8f911d802dd94a5$export$ffb0004e005737fa = $d8f911d802dd94a5$var$d;
$d8f911d802dd94a5$export$b624eff549462981 = $d8f911d802dd94a5$var$q;
$d8f911d802dd94a5$export$7897aa7841a5380c = $d8f911d802dd94a5$var$p;
$d8f911d802dd94a5$export$602eac185826482c = $d8f911d802dd94a5$var$c;
$d8f911d802dd94a5$export$e2c29f18771995cb = $d8f911d802dd94a5$var$f;
$d8f911d802dd94a5$export$5f8d39834fd61797 = $d8f911d802dd94a5$var$e;
$d8f911d802dd94a5$export$74bf444e3cd11ea5 = $d8f911d802dd94a5$var$m;
$d8f911d802dd94a5$export$998bcd577473dd93 = $d8f911d802dd94a5$var$n;
$d8f911d802dd94a5$export$92387174baf9b227 = function() {
    return !1;
};
$d8f911d802dd94a5$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d8f911d802dd94a5$export$b706b080d889d2c9 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$h;
};
$d8f911d802dd94a5$export$5be5a87408f70ddc = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$g;
};
$d8f911d802dd94a5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d8f911d802dd94a5$var$b;
};
$d8f911d802dd94a5$export$455c2e768291efa6 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$l;
};
$d8f911d802dd94a5$export$9522e17588c12572 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$d;
};
$d8f911d802dd94a5$export$2110ac352bb060b9 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$q;
};
$d8f911d802dd94a5$export$56885ab8b9c456ab = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$p;
};
$d8f911d802dd94a5$export$d927fcb6adf8f9de = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$c;
};
$d8f911d802dd94a5$export$b82d16f27459e05a = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$f;
};
$d8f911d802dd94a5$export$522c17b4f5e123e8 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$e;
};
$d8f911d802dd94a5$export$1aabd8a0274ecfd6 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$m;
};
$d8f911d802dd94a5$export$3d6c20d97e46b957 = function(a) {
    return $d8f911d802dd94a5$var$v(a) === $d8f911d802dd94a5$var$n;
};
$d8f911d802dd94a5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d8f911d802dd94a5$var$d || a === $d8f911d802dd94a5$var$f || a === $d8f911d802dd94a5$var$e || a === $d8f911d802dd94a5$var$m || a === $d8f911d802dd94a5$var$n || a === $d8f911d802dd94a5$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d8f911d802dd94a5$var$q || a.$$typeof === $d8f911d802dd94a5$var$p || a.$$typeof === $d8f911d802dd94a5$var$g || a.$$typeof === $d8f911d802dd94a5$var$h || a.$$typeof === $d8f911d802dd94a5$var$l || a.$$typeof === $d8f911d802dd94a5$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d8f911d802dd94a5$export$f5bbd400c2f4426f = $d8f911d802dd94a5$var$v;

});

parcelRegister("gKvxL", function(module, exports) {

$parcel$export(module.exports, "EOL", function () { return $c319691c394179e6$export$266d3b9babd1fc45; }, function (v) { return $c319691c394179e6$export$266d3b9babd1fc45 = v; });
var $c319691c394179e6$export$edf525f30916fbb8;
var $c319691c394179e6$export$640106f6dc7d2706;
var $c319691c394179e6$export$3ea386628068cf62;
var $c319691c394179e6$export$749d472264fad440;
var $c319691c394179e6$export$8b931a48d9488767;
var $c319691c394179e6$export$9123f37609399513;
var $c319691c394179e6$export$9b60beb643db4d69;
var $c319691c394179e6$export$bf9fb029d174d554;
var $c319691c394179e6$export$23d3fad09dc44362;
var $c319691c394179e6$export$d2f3c2f7e0c7dcf5;
var $c319691c394179e6$export$3bf7c33313eba0fe;
var $c319691c394179e6$export$7925d89f138dad5b;
var $c319691c394179e6$export$722a64dea1b767dc;
var $c319691c394179e6$export$9e6c06a7d47f9af7;
var $c319691c394179e6$export$6b76988456c0292f;
var $c319691c394179e6$export$266d3b9babd1fc45;
var $c319691c394179e6$export$c1d46b5ea6262c0b;
$c319691c394179e6$export$edf525f30916fbb8 = function() {
    return "LE";
};
$c319691c394179e6$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$c319691c394179e6$export$3ea386628068cf62 = function() {
    return [];
};
$c319691c394179e6$export$749d472264fad440 = function() {
    return 0;
};
$c319691c394179e6$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$c319691c394179e6$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$c319691c394179e6$export$9b60beb643db4d69 = function() {
    return [];
};
$c319691c394179e6$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$c319691c394179e6$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$c319691c394179e6$export$d2f3c2f7e0c7dcf5 = $c319691c394179e6$export$3bf7c33313eba0fe = function() {
    return {};
};
$c319691c394179e6$export$7925d89f138dad5b = function() {
    return "javascript";
};
$c319691c394179e6$export$722a64dea1b767dc = function() {
    return "browser";
};
$c319691c394179e6$export$9e6c06a7d47f9af7 = $c319691c394179e6$export$6b76988456c0292f = function() {
    return "/tmp";
};
$c319691c394179e6$export$266d3b9babd1fc45 = "\n";
$c319691c394179e6$export$c1d46b5ea6262c0b = function() {
    return "/";
};

});

parcelRegister("64BeW", function(module, exports) {
/* jshint node:true */ "use strict";
// Escape the textDelimiters contained in the field
/*(https://tools.ietf.org/html/rfc4180)
   7.  If double-quotes are used to enclose fields, then a double-quote
   appearing inside a field must be escaped by preceding it with
   another double quote.
   For example: "aaa","b""bb","ccc"
*/ module.exports = function escapedDelimiters(textDelimiter, rowDelimiter, forceTextDelimiter) {
    let endOfLine = "\n";
    if (typeof textDelimiter !== "string") throw new TypeError('Invalid param "textDelimiter", must be a string.');
    if (typeof rowDelimiter !== "string") throw new TypeError('Invalid param "rowDelimiter", must be a string.');
    let textDelimiterRegex = new RegExp("\\" + textDelimiter, "g");
    let escapedDelimiter = textDelimiter + textDelimiter;
    const enclosingCondition = textDelimiter === '"' ? (value)=>value.indexOf(rowDelimiter) >= 0 || value.indexOf(endOfLine) >= 0 || value.indexOf('"') >= 0 : (value)=>value.indexOf(rowDelimiter) >= 0 || value.indexOf(endOfLine) >= 0;
    return function(value) {
        if (forceTextDelimiter) value = "" + value;
        if (!value.replace) return value;
        // Escape the textDelimiters contained in the field
        value = value.replace(textDelimiterRegex, escapedDelimiter);
        // Escape the whole field if it contains a rowDelimiter or a linebreak or double quote
        if (forceTextDelimiter || enclosingCondition(value)) value = textDelimiter + value + textDelimiter;
        return value;
    };
};

});

parcelRegister("61zqF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $462e5193348320df$var$R = typeof Reflect === "object" ? Reflect : null;
var $462e5193348320df$var$ReflectApply = $462e5193348320df$var$R && typeof $462e5193348320df$var$R.apply === "function" ? $462e5193348320df$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $462e5193348320df$var$ReflectOwnKeys;
if ($462e5193348320df$var$R && typeof $462e5193348320df$var$R.ownKeys === "function") $462e5193348320df$var$ReflectOwnKeys = $462e5193348320df$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $462e5193348320df$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $462e5193348320df$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $462e5193348320df$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $462e5193348320df$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $462e5193348320df$var$EventEmitter() {
    $462e5193348320df$var$EventEmitter.init.call(this);
}
module.exports = $462e5193348320df$var$EventEmitter;
module.exports.once = $462e5193348320df$var$once;
// Backwards-compat with node 0.10.x
$462e5193348320df$var$EventEmitter.EventEmitter = $462e5193348320df$var$EventEmitter;
$462e5193348320df$var$EventEmitter.prototype._events = undefined;
$462e5193348320df$var$EventEmitter.prototype._eventsCount = 0;
$462e5193348320df$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $462e5193348320df$var$defaultMaxListeners = 10;
function $462e5193348320df$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($462e5193348320df$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $462e5193348320df$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $462e5193348320df$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $462e5193348320df$var$defaultMaxListeners = arg;
    }
});
$462e5193348320df$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$462e5193348320df$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $462e5193348320df$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $462e5193348320df$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $462e5193348320df$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$462e5193348320df$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $462e5193348320df$var$_getMaxListeners(this);
};
$462e5193348320df$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $462e5193348320df$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $462e5193348320df$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$462e5193348320df$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $462e5193348320df$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $462e5193348320df$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $462e5193348320df$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $462e5193348320df$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$462e5193348320df$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $462e5193348320df$var$_addListener(this, type, listener, false);
};
$462e5193348320df$var$EventEmitter.prototype.on = $462e5193348320df$var$EventEmitter.prototype.addListener;
$462e5193348320df$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $462e5193348320df$var$_addListener(this, type, listener, true);
};
function $462e5193348320df$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $462e5193348320df$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $462e5193348320df$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$462e5193348320df$var$EventEmitter.prototype.once = function once(type, listener) {
    $462e5193348320df$var$checkListener(listener);
    this.on(type, $462e5193348320df$var$_onceWrap(this, type, listener));
    return this;
};
$462e5193348320df$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $462e5193348320df$var$checkListener(listener);
    this.prependListener(type, $462e5193348320df$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$462e5193348320df$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $462e5193348320df$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $462e5193348320df$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$462e5193348320df$var$EventEmitter.prototype.off = $462e5193348320df$var$EventEmitter.prototype.removeListener;
$462e5193348320df$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $462e5193348320df$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $462e5193348320df$var$unwrapListeners(evlistener) : $462e5193348320df$var$arrayClone(evlistener, evlistener.length);
}
$462e5193348320df$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $462e5193348320df$var$_listeners(this, type, true);
};
$462e5193348320df$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $462e5193348320df$var$_listeners(this, type, false);
};
$462e5193348320df$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $462e5193348320df$var$listenerCount.call(emitter, type);
};
$462e5193348320df$var$EventEmitter.prototype.listenerCount = $462e5193348320df$var$listenerCount;
function $462e5193348320df$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$462e5193348320df$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $462e5193348320df$var$ReflectOwnKeys(this._events) : [];
};
function $462e5193348320df$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $462e5193348320df$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $462e5193348320df$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $462e5193348320df$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $462e5193348320df$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $462e5193348320df$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $462e5193348320df$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $462e5193348320df$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $462e5193348320df$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("6a1gD", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("lIilJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $54X9E = parcelRequire("54X9E");
"use strict";
module.exports = $fcebf0e1c673f97a$var$Readable;
/*<replacement>*/ var $fcebf0e1c673f97a$var$Duplex;
/*</replacement>*/ $fcebf0e1c673f97a$var$Readable.ReadableState = $fcebf0e1c673f97a$var$ReadableState;

var $61zqF = parcelRequire("61zqF");
var $fcebf0e1c673f97a$require$EE = $61zqF.EventEmitter;
var $fcebf0e1c673f97a$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $x9Htm = parcelRequire("x9Htm");

var $43wp1 = parcelRequire("43wp1");
var $fcebf0e1c673f97a$require$Buffer = $43wp1.Buffer;
var $fcebf0e1c673f97a$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $fcebf0e1c673f97a$var$_uint8ArrayToBuffer(chunk) {
    return $fcebf0e1c673f97a$require$Buffer.from(chunk);
}
function $fcebf0e1c673f97a$var$_isUint8Array(obj) {
    return $fcebf0e1c673f97a$require$Buffer.isBuffer(obj) || obj instanceof $fcebf0e1c673f97a$var$OurUint8Array;
}

var $34JBo = parcelRequire("34JBo");
var $fcebf0e1c673f97a$var$debug;
if ($34JBo && $34JBo.debuglog) $fcebf0e1c673f97a$var$debug = $34JBo.debuglog("stream");
else $fcebf0e1c673f97a$var$debug = function debug() {};

var $iLeb8 = parcelRequire("iLeb8");

var $icoFg = parcelRequire("icoFg");

var $7U2uE = parcelRequire("7U2uE");
var $fcebf0e1c673f97a$var$getHighWaterMark = $7U2uE.getHighWaterMark;

var $5K3jZ = parcelRequire("5K3jZ");
var $fcebf0e1c673f97a$require$_require$codes = $5K3jZ.codes;
var $fcebf0e1c673f97a$var$ERR_INVALID_ARG_TYPE = $fcebf0e1c673f97a$require$_require$codes.ERR_INVALID_ARG_TYPE, $fcebf0e1c673f97a$var$ERR_STREAM_PUSH_AFTER_EOF = $fcebf0e1c673f97a$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $fcebf0e1c673f97a$var$ERR_METHOD_NOT_IMPLEMENTED = $fcebf0e1c673f97a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $fcebf0e1c673f97a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $fcebf0e1c673f97a$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $fcebf0e1c673f97a$var$StringDecoder;
var $fcebf0e1c673f97a$var$createReadableStreamAsyncIterator;
var $fcebf0e1c673f97a$var$from;

(parcelRequire("6a1gD"))($fcebf0e1c673f97a$var$Readable, $x9Htm);
var $fcebf0e1c673f97a$var$errorOrDestroy = $icoFg.errorOrDestroy;
var $fcebf0e1c673f97a$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $fcebf0e1c673f97a$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $fcebf0e1c673f97a$var$ReadableState(options, stream, isDuplex) {
    $fcebf0e1c673f97a$var$Duplex = $fcebf0e1c673f97a$var$Duplex || (parcelRequire("bKtym"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $fcebf0e1c673f97a$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $fcebf0e1c673f97a$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $iLeb8();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$fcebf0e1c673f97a$var$StringDecoder) $fcebf0e1c673f97a$var$StringDecoder = (parcelRequire("kdzLU")).StringDecoder;
        this.decoder = new $fcebf0e1c673f97a$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $fcebf0e1c673f97a$var$Readable(options) {
    $fcebf0e1c673f97a$var$Duplex = $fcebf0e1c673f97a$var$Duplex || (parcelRequire("bKtym"));
    if (!(this instanceof $fcebf0e1c673f97a$var$Readable)) return new $fcebf0e1c673f97a$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $fcebf0e1c673f97a$var$Duplex;
    this._readableState = new $fcebf0e1c673f97a$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $x9Htm.call(this);
}
Object.defineProperty($fcebf0e1c673f97a$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$fcebf0e1c673f97a$var$Readable.prototype.destroy = $icoFg.destroy;
$fcebf0e1c673f97a$var$Readable.prototype._undestroy = $icoFg.undestroy;
$fcebf0e1c673f97a$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$fcebf0e1c673f97a$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $fcebf0e1c673f97a$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $fcebf0e1c673f97a$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$fcebf0e1c673f97a$var$Readable.prototype.unshift = function(chunk) {
    return $fcebf0e1c673f97a$var$readableAddChunk(this, chunk, null, true, false);
};
function $fcebf0e1c673f97a$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $fcebf0e1c673f97a$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $fcebf0e1c673f97a$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $fcebf0e1c673f97a$var$chunkInvalid(state, chunk);
        if (er) $fcebf0e1c673f97a$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $fcebf0e1c673f97a$require$Buffer.prototype) chunk = $fcebf0e1c673f97a$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $fcebf0e1c673f97a$var$errorOrDestroy(stream, new $fcebf0e1c673f97a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $fcebf0e1c673f97a$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $fcebf0e1c673f97a$var$errorOrDestroy(stream, new $fcebf0e1c673f97a$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $fcebf0e1c673f97a$var$addChunk(stream, state, chunk, false);
                    else $fcebf0e1c673f97a$var$maybeReadMore(stream, state);
                } else $fcebf0e1c673f97a$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $fcebf0e1c673f97a$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $fcebf0e1c673f97a$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $fcebf0e1c673f97a$var$emitReadable(stream);
    }
    $fcebf0e1c673f97a$var$maybeReadMore(stream, state);
}
function $fcebf0e1c673f97a$var$chunkInvalid(state, chunk) {
    var er;
    if (!$fcebf0e1c673f97a$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $fcebf0e1c673f97a$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$fcebf0e1c673f97a$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$fcebf0e1c673f97a$var$Readable.prototype.setEncoding = function(enc) {
    if (!$fcebf0e1c673f97a$var$StringDecoder) $fcebf0e1c673f97a$var$StringDecoder = (parcelRequire("kdzLU")).StringDecoder;
    var decoder = new $fcebf0e1c673f97a$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $fcebf0e1c673f97a$var$MAX_HWM = 0x40000000;
function $fcebf0e1c673f97a$var$computeNewHighWaterMark(n) {
    if (n >= $fcebf0e1c673f97a$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $fcebf0e1c673f97a$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $fcebf0e1c673f97a$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $fcebf0e1c673f97a$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$fcebf0e1c673f97a$var$Readable.prototype.read = function(n) {
    $fcebf0e1c673f97a$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $fcebf0e1c673f97a$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $fcebf0e1c673f97a$var$endReadable(this);
        else $fcebf0e1c673f97a$var$emitReadable(this);
        return null;
    }
    n = $fcebf0e1c673f97a$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $fcebf0e1c673f97a$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $fcebf0e1c673f97a$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $fcebf0e1c673f97a$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $fcebf0e1c673f97a$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $fcebf0e1c673f97a$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $fcebf0e1c673f97a$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $fcebf0e1c673f97a$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $fcebf0e1c673f97a$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $fcebf0e1c673f97a$var$onEofChunk(stream, state) {
    $fcebf0e1c673f97a$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $fcebf0e1c673f97a$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $fcebf0e1c673f97a$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $fcebf0e1c673f97a$var$emitReadable(stream) {
    var state = stream._readableState;
    $fcebf0e1c673f97a$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $fcebf0e1c673f97a$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $54X9E.nextTick($fcebf0e1c673f97a$var$emitReadable_, stream);
    }
}
function $fcebf0e1c673f97a$var$emitReadable_(stream) {
    var state = stream._readableState;
    $fcebf0e1c673f97a$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $fcebf0e1c673f97a$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $fcebf0e1c673f97a$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $54X9E.nextTick($fcebf0e1c673f97a$var$maybeReadMore_, stream, state);
    }
}
function $fcebf0e1c673f97a$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $fcebf0e1c673f97a$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$fcebf0e1c673f97a$var$Readable.prototype._read = function(n) {
    $fcebf0e1c673f97a$var$errorOrDestroy(this, new $fcebf0e1c673f97a$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$fcebf0e1c673f97a$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $fcebf0e1c673f97a$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $54X9E.stdout && dest !== $54X9E.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $54X9E.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $fcebf0e1c673f97a$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $fcebf0e1c673f97a$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $fcebf0e1c673f97a$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $fcebf0e1c673f97a$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $fcebf0e1c673f97a$var$debug("ondata");
        var ret = dest.write(chunk);
        $fcebf0e1c673f97a$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $fcebf0e1c673f97a$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $fcebf0e1c673f97a$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $fcebf0e1c673f97a$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($fcebf0e1c673f97a$var$EElistenerCount(dest, "error") === 0) $fcebf0e1c673f97a$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $fcebf0e1c673f97a$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $fcebf0e1c673f97a$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $fcebf0e1c673f97a$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $fcebf0e1c673f97a$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $fcebf0e1c673f97a$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $fcebf0e1c673f97a$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $fcebf0e1c673f97a$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $fcebf0e1c673f97a$var$flow(src);
        }
    };
}
$fcebf0e1c673f97a$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $fcebf0e1c673f97a$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$fcebf0e1c673f97a$var$Readable.prototype.on = function(ev, fn) {
    var res = $x9Htm.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $fcebf0e1c673f97a$var$debug("on readable", state.length, state.reading);
            if (state.length) $fcebf0e1c673f97a$var$emitReadable(this);
            else if (!state.reading) $54X9E.nextTick($fcebf0e1c673f97a$var$nReadingNextTick, this);
        }
    }
    return res;
};
$fcebf0e1c673f97a$var$Readable.prototype.addListener = $fcebf0e1c673f97a$var$Readable.prototype.on;
$fcebf0e1c673f97a$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $x9Htm.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $54X9E.nextTick($fcebf0e1c673f97a$var$updateReadableListening, this);
    return res;
};
$fcebf0e1c673f97a$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $x9Htm.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $54X9E.nextTick($fcebf0e1c673f97a$var$updateReadableListening, this);
    return res;
};
function $fcebf0e1c673f97a$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $fcebf0e1c673f97a$var$nReadingNextTick(self1) {
    $fcebf0e1c673f97a$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$fcebf0e1c673f97a$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $fcebf0e1c673f97a$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $fcebf0e1c673f97a$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $fcebf0e1c673f97a$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $54X9E.nextTick($fcebf0e1c673f97a$var$resume_, stream, state);
    }
}
function $fcebf0e1c673f97a$var$resume_(stream, state) {
    $fcebf0e1c673f97a$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $fcebf0e1c673f97a$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$fcebf0e1c673f97a$var$Readable.prototype.pause = function() {
    $fcebf0e1c673f97a$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $fcebf0e1c673f97a$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $fcebf0e1c673f97a$var$flow(stream) {
    var state = stream._readableState;
    $fcebf0e1c673f97a$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$fcebf0e1c673f97a$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $fcebf0e1c673f97a$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $fcebf0e1c673f97a$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $fcebf0e1c673f97a$var$kProxyEvents.length; n++)stream.on($fcebf0e1c673f97a$var$kProxyEvents[n], this.emit.bind(this, $fcebf0e1c673f97a$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $fcebf0e1c673f97a$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $fcebf0e1c673f97a$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($fcebf0e1c673f97a$var$createReadableStreamAsyncIterator === undefined) $fcebf0e1c673f97a$var$createReadableStreamAsyncIterator = (parcelRequire("6aLZo"));
    return $fcebf0e1c673f97a$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($fcebf0e1c673f97a$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($fcebf0e1c673f97a$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($fcebf0e1c673f97a$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$fcebf0e1c673f97a$var$Readable._fromList = $fcebf0e1c673f97a$var$fromList;
Object.defineProperty($fcebf0e1c673f97a$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $fcebf0e1c673f97a$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $fcebf0e1c673f97a$var$endReadable(stream) {
    var state = stream._readableState;
    $fcebf0e1c673f97a$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $54X9E.nextTick($fcebf0e1c673f97a$var$endReadableNT, state, stream);
    }
}
function $fcebf0e1c673f97a$var$endReadableNT(state, stream) {
    $fcebf0e1c673f97a$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $fcebf0e1c673f97a$var$Readable.from = function(iterable, opts) {
    if ($fcebf0e1c673f97a$var$from === undefined) $fcebf0e1c673f97a$var$from = (parcelRequire("f77Mx"));
    return $fcebf0e1c673f97a$var$from($fcebf0e1c673f97a$var$Readable, iterable, opts);
};
function $fcebf0e1c673f97a$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("54X9E", function(module, exports) {
// shim for using process in browser
var $3b2b36599051fe09$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3b2b36599051fe09$var$cachedSetTimeout;
var $3b2b36599051fe09$var$cachedClearTimeout;
function $3b2b36599051fe09$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3b2b36599051fe09$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3b2b36599051fe09$var$cachedSetTimeout = setTimeout;
        else $3b2b36599051fe09$var$cachedSetTimeout = $3b2b36599051fe09$var$defaultSetTimout;
    } catch (e) {
        $3b2b36599051fe09$var$cachedSetTimeout = $3b2b36599051fe09$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3b2b36599051fe09$var$cachedClearTimeout = clearTimeout;
        else $3b2b36599051fe09$var$cachedClearTimeout = $3b2b36599051fe09$var$defaultClearTimeout;
    } catch (e) {
        $3b2b36599051fe09$var$cachedClearTimeout = $3b2b36599051fe09$var$defaultClearTimeout;
    }
})();
function $3b2b36599051fe09$var$runTimeout(fun) {
    if ($3b2b36599051fe09$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3b2b36599051fe09$var$cachedSetTimeout === $3b2b36599051fe09$var$defaultSetTimout || !$3b2b36599051fe09$var$cachedSetTimeout) && setTimeout) {
        $3b2b36599051fe09$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3b2b36599051fe09$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3b2b36599051fe09$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3b2b36599051fe09$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3b2b36599051fe09$var$runClearTimeout(marker) {
    if ($3b2b36599051fe09$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3b2b36599051fe09$var$cachedClearTimeout === $3b2b36599051fe09$var$defaultClearTimeout || !$3b2b36599051fe09$var$cachedClearTimeout) && clearTimeout) {
        $3b2b36599051fe09$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3b2b36599051fe09$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3b2b36599051fe09$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3b2b36599051fe09$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3b2b36599051fe09$var$queue = [];
var $3b2b36599051fe09$var$draining = false;
var $3b2b36599051fe09$var$currentQueue;
var $3b2b36599051fe09$var$queueIndex = -1;
function $3b2b36599051fe09$var$cleanUpNextTick() {
    if (!$3b2b36599051fe09$var$draining || !$3b2b36599051fe09$var$currentQueue) return;
    $3b2b36599051fe09$var$draining = false;
    if ($3b2b36599051fe09$var$currentQueue.length) $3b2b36599051fe09$var$queue = $3b2b36599051fe09$var$currentQueue.concat($3b2b36599051fe09$var$queue);
    else $3b2b36599051fe09$var$queueIndex = -1;
    if ($3b2b36599051fe09$var$queue.length) $3b2b36599051fe09$var$drainQueue();
}
function $3b2b36599051fe09$var$drainQueue() {
    if ($3b2b36599051fe09$var$draining) return;
    var timeout = $3b2b36599051fe09$var$runTimeout($3b2b36599051fe09$var$cleanUpNextTick);
    $3b2b36599051fe09$var$draining = true;
    var len = $3b2b36599051fe09$var$queue.length;
    while(len){
        $3b2b36599051fe09$var$currentQueue = $3b2b36599051fe09$var$queue;
        $3b2b36599051fe09$var$queue = [];
        while(++$3b2b36599051fe09$var$queueIndex < len)if ($3b2b36599051fe09$var$currentQueue) $3b2b36599051fe09$var$currentQueue[$3b2b36599051fe09$var$queueIndex].run();
        $3b2b36599051fe09$var$queueIndex = -1;
        len = $3b2b36599051fe09$var$queue.length;
    }
    $3b2b36599051fe09$var$currentQueue = null;
    $3b2b36599051fe09$var$draining = false;
    $3b2b36599051fe09$var$runClearTimeout(timeout);
}
$3b2b36599051fe09$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3b2b36599051fe09$var$queue.push(new $3b2b36599051fe09$var$Item(fun, args));
    if ($3b2b36599051fe09$var$queue.length === 1 && !$3b2b36599051fe09$var$draining) $3b2b36599051fe09$var$runTimeout($3b2b36599051fe09$var$drainQueue);
};
// v8 likes predictible objects
function $3b2b36599051fe09$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3b2b36599051fe09$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3b2b36599051fe09$var$process.title = "browser";
$3b2b36599051fe09$var$process.browser = true;
$3b2b36599051fe09$var$process.env = {};
$3b2b36599051fe09$var$process.argv = [];
$3b2b36599051fe09$var$process.version = ""; // empty string to avoid regexp issues
$3b2b36599051fe09$var$process.versions = {};
function $3b2b36599051fe09$var$noop() {}
$3b2b36599051fe09$var$process.on = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.addListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.once = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.off = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.removeListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.removeAllListeners = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.emit = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.prependListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.prependOnceListener = $3b2b36599051fe09$var$noop;
$3b2b36599051fe09$var$process.listeners = function(name) {
    return [];
};
$3b2b36599051fe09$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3b2b36599051fe09$var$process.cwd = function() {
    return "/";
};
$3b2b36599051fe09$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3b2b36599051fe09$var$process.umask = function() {
    return 0;
};

});

parcelRegister("x9Htm", function(module, exports) {

module.exports = (parcelRequire("61zqF")).EventEmitter;

});

parcelRegister("iLeb8", function(module, exports) {
"use strict";
function $da879d57c9f6cf8d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $da879d57c9f6cf8d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $da879d57c9f6cf8d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $da879d57c9f6cf8d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $da879d57c9f6cf8d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $da879d57c9f6cf8d$var$_defineProperty(obj, key, value) {
    key = $da879d57c9f6cf8d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da879d57c9f6cf8d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $da879d57c9f6cf8d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $da879d57c9f6cf8d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $da879d57c9f6cf8d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $da879d57c9f6cf8d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $da879d57c9f6cf8d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $da879d57c9f6cf8d$var$_toPropertyKey(arg) {
    var key = $da879d57c9f6cf8d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $da879d57c9f6cf8d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $43wp1 = parcelRequire("43wp1");
var $da879d57c9f6cf8d$var$Buffer = $43wp1.Buffer;

var $34JBo = parcelRequire("34JBo");
var $da879d57c9f6cf8d$var$inspect = $34JBo.inspect;
var $da879d57c9f6cf8d$var$custom = $da879d57c9f6cf8d$var$inspect && $da879d57c9f6cf8d$var$inspect.custom || "inspect";
function $da879d57c9f6cf8d$var$copyBuffer(src, target, offset) {
    $da879d57c9f6cf8d$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $da879d57c9f6cf8d$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $da879d57c9f6cf8d$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $da879d57c9f6cf8d$var$Buffer.alloc(0);
                var ret = $da879d57c9f6cf8d$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $da879d57c9f6cf8d$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $da879d57c9f6cf8d$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $da879d57c9f6cf8d$var$custom,
            value: function value(_, options) {
                return $da879d57c9f6cf8d$var$inspect(this, $da879d57c9f6cf8d$var$_objectSpread($da879d57c9f6cf8d$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("icoFg", function(module, exports) {

var $54X9E = parcelRequire("54X9E");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $d3fc7adeb704ea31$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $54X9E.nextTick($d3fc7adeb704ea31$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $54X9E.nextTick($d3fc7adeb704ea31$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $54X9E.nextTick($d3fc7adeb704ea31$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $54X9E.nextTick($d3fc7adeb704ea31$var$emitErrorAndCloseNT, _this, err);
            } else $54X9E.nextTick($d3fc7adeb704ea31$var$emitCloseNT, _this);
        } else if (cb) {
            $54X9E.nextTick($d3fc7adeb704ea31$var$emitCloseNT, _this);
            cb(err);
        } else $54X9E.nextTick($d3fc7adeb704ea31$var$emitCloseNT, _this);
    });
    return this;
}
function $d3fc7adeb704ea31$var$emitErrorAndCloseNT(self, err) {
    $d3fc7adeb704ea31$var$emitErrorNT(self, err);
    $d3fc7adeb704ea31$var$emitCloseNT(self);
}
function $d3fc7adeb704ea31$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $d3fc7adeb704ea31$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $d3fc7adeb704ea31$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $d3fc7adeb704ea31$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $d3fc7adeb704ea31$var$destroy,
    undestroy: $d3fc7adeb704ea31$var$undestroy,
    errorOrDestroy: $d3fc7adeb704ea31$var$errorOrDestroy
};

});

parcelRegister("7U2uE", function(module, exports) {
"use strict";

var $5c0fb28321fefc8e$var$ERR_INVALID_OPT_VALUE = (parcelRequire("5K3jZ")).codes.ERR_INVALID_OPT_VALUE;
function $5c0fb28321fefc8e$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $5c0fb28321fefc8e$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $5c0fb28321fefc8e$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $5c0fb28321fefc8e$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $5c0fb28321fefc8e$var$getHighWaterMark
};

});
parcelRegister("5K3jZ", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $42e3d32f0529f920$export$e45cb6485273080e; }, function (v) { return $42e3d32f0529f920$export$e45cb6485273080e = v; });
var $42e3d32f0529f920$export$e45cb6485273080e;
"use strict";
function $42e3d32f0529f920$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $42e3d32f0529f920$var$codes = {};
function $42e3d32f0529f920$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $42e3d32f0529f920$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $42e3d32f0529f920$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $42e3d32f0529f920$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $42e3d32f0529f920$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $42e3d32f0529f920$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $42e3d32f0529f920$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$42e3d32f0529f920$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$42e3d32f0529f920$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $42e3d32f0529f920$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($42e3d32f0529f920$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($42e3d32f0529f920$var$oneOf(expected, "type"));
    else {
        var type = $42e3d32f0529f920$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($42e3d32f0529f920$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$42e3d32f0529f920$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$42e3d32f0529f920$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$42e3d32f0529f920$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$42e3d32f0529f920$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$42e3d32f0529f920$export$e45cb6485273080e = $42e3d32f0529f920$var$codes;

});


parcelRegister("bKtym", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $54X9E = parcelRequire("54X9E");
"use strict";
/*<replacement>*/ var $88daea3cbe76352e$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $88daea3cbe76352e$var$Duplex;

var $lIilJ = parcelRequire("lIilJ");

var $jee39 = parcelRequire("jee39");

(parcelRequire("6a1gD"))($88daea3cbe76352e$var$Duplex, $lIilJ);
// Allow the keys array to be GC'ed.
var $88daea3cbe76352e$var$keys = $88daea3cbe76352e$var$objectKeys($jee39.prototype);
for(var $88daea3cbe76352e$var$v = 0; $88daea3cbe76352e$var$v < $88daea3cbe76352e$var$keys.length; $88daea3cbe76352e$var$v++){
    var $88daea3cbe76352e$var$method = $88daea3cbe76352e$var$keys[$88daea3cbe76352e$var$v];
    if (!$88daea3cbe76352e$var$Duplex.prototype[$88daea3cbe76352e$var$method]) $88daea3cbe76352e$var$Duplex.prototype[$88daea3cbe76352e$var$method] = $jee39.prototype[$88daea3cbe76352e$var$method];
}
function $88daea3cbe76352e$var$Duplex(options) {
    if (!(this instanceof $88daea3cbe76352e$var$Duplex)) return new $88daea3cbe76352e$var$Duplex(options);
    $lIilJ.call(this, options);
    $jee39.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $88daea3cbe76352e$var$onend);
        }
    }
}
Object.defineProperty($88daea3cbe76352e$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($88daea3cbe76352e$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($88daea3cbe76352e$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $88daea3cbe76352e$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $54X9E.nextTick($88daea3cbe76352e$var$onEndNT, this);
}
function $88daea3cbe76352e$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($88daea3cbe76352e$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("jee39", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $54X9E = parcelRequire("54X9E");
"use strict";
module.exports = $dffa391b5c57148d$var$Writable;
/* <replacement> */ function $dffa391b5c57148d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $dffa391b5c57148d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $dffa391b5c57148d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $dffa391b5c57148d$var$Duplex;
/*</replacement>*/ $dffa391b5c57148d$var$Writable.WritableState = $dffa391b5c57148d$var$WritableState;

/*<replacement>*/ var $dffa391b5c57148d$var$internalUtil = {
    deprecate: (parcelRequire("ds8Vx"))
};

var $x9Htm = parcelRequire("x9Htm");

var $43wp1 = parcelRequire("43wp1");
var $dffa391b5c57148d$require$Buffer = $43wp1.Buffer;
var $dffa391b5c57148d$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $dffa391b5c57148d$var$_uint8ArrayToBuffer(chunk) {
    return $dffa391b5c57148d$require$Buffer.from(chunk);
}
function $dffa391b5c57148d$var$_isUint8Array(obj) {
    return $dffa391b5c57148d$require$Buffer.isBuffer(obj) || obj instanceof $dffa391b5c57148d$var$OurUint8Array;
}

var $icoFg = parcelRequire("icoFg");

var $7U2uE = parcelRequire("7U2uE");
var $dffa391b5c57148d$var$getHighWaterMark = $7U2uE.getHighWaterMark;

var $5K3jZ = parcelRequire("5K3jZ");
var $dffa391b5c57148d$require$_require$codes = $5K3jZ.codes;
var $dffa391b5c57148d$var$ERR_INVALID_ARG_TYPE = $dffa391b5c57148d$require$_require$codes.ERR_INVALID_ARG_TYPE, $dffa391b5c57148d$var$ERR_METHOD_NOT_IMPLEMENTED = $dffa391b5c57148d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $dffa391b5c57148d$var$ERR_MULTIPLE_CALLBACK = $dffa391b5c57148d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $dffa391b5c57148d$var$ERR_STREAM_CANNOT_PIPE = $dffa391b5c57148d$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $dffa391b5c57148d$var$ERR_STREAM_DESTROYED = $dffa391b5c57148d$require$_require$codes.ERR_STREAM_DESTROYED, $dffa391b5c57148d$var$ERR_STREAM_NULL_VALUES = $dffa391b5c57148d$require$_require$codes.ERR_STREAM_NULL_VALUES, $dffa391b5c57148d$var$ERR_STREAM_WRITE_AFTER_END = $dffa391b5c57148d$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $dffa391b5c57148d$var$ERR_UNKNOWN_ENCODING = $dffa391b5c57148d$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $dffa391b5c57148d$var$errorOrDestroy = $icoFg.errorOrDestroy;

(parcelRequire("6a1gD"))($dffa391b5c57148d$var$Writable, $x9Htm);
function $dffa391b5c57148d$var$nop() {}

function $dffa391b5c57148d$var$WritableState(options, stream, isDuplex) {
    $dffa391b5c57148d$var$Duplex = $dffa391b5c57148d$var$Duplex || (parcelRequire("bKtym"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $dffa391b5c57148d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $dffa391b5c57148d$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $dffa391b5c57148d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $dffa391b5c57148d$var$CorkedRequest(this);
}
$dffa391b5c57148d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($dffa391b5c57148d$var$WritableState.prototype, "buffer", {
            get: $dffa391b5c57148d$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $dffa391b5c57148d$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $dffa391b5c57148d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($dffa391b5c57148d$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($dffa391b5c57148d$var$realHasInstance.call(this, object)) return true;
            if (this !== $dffa391b5c57148d$var$Writable) return false;
            return object && object._writableState instanceof $dffa391b5c57148d$var$WritableState;
        }
    });
} else $dffa391b5c57148d$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $dffa391b5c57148d$var$Writable(options) {
    $dffa391b5c57148d$var$Duplex = $dffa391b5c57148d$var$Duplex || (parcelRequire("bKtym"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $dffa391b5c57148d$var$Duplex;
    if (!isDuplex && !$dffa391b5c57148d$var$realHasInstance.call($dffa391b5c57148d$var$Writable, this)) return new $dffa391b5c57148d$var$Writable(options);
    this._writableState = new $dffa391b5c57148d$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $x9Htm.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$dffa391b5c57148d$var$Writable.prototype.pipe = function() {
    $dffa391b5c57148d$var$errorOrDestroy(this, new $dffa391b5c57148d$var$ERR_STREAM_CANNOT_PIPE());
};
function $dffa391b5c57148d$var$writeAfterEnd(stream, cb) {
    var er = new $dffa391b5c57148d$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $dffa391b5c57148d$var$errorOrDestroy(stream, er);
    $54X9E.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $dffa391b5c57148d$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $dffa391b5c57148d$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $dffa391b5c57148d$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $dffa391b5c57148d$var$errorOrDestroy(stream, er);
        $54X9E.nextTick(cb, er);
        return false;
    }
    return true;
}
$dffa391b5c57148d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $dffa391b5c57148d$var$_isUint8Array(chunk);
    if (isBuf && !$dffa391b5c57148d$require$Buffer.isBuffer(chunk)) chunk = $dffa391b5c57148d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $dffa391b5c57148d$var$nop;
    if (state.ending) $dffa391b5c57148d$var$writeAfterEnd(this, cb);
    else if (isBuf || $dffa391b5c57148d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $dffa391b5c57148d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$dffa391b5c57148d$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$dffa391b5c57148d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $dffa391b5c57148d$var$clearBuffer(this, state);
    }
};
$dffa391b5c57148d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $dffa391b5c57148d$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($dffa391b5c57148d$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $dffa391b5c57148d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $dffa391b5c57148d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($dffa391b5c57148d$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $dffa391b5c57148d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $dffa391b5c57148d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $dffa391b5c57148d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $dffa391b5c57148d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $dffa391b5c57148d$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $dffa391b5c57148d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $54X9E.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $54X9E.nextTick($dffa391b5c57148d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $dffa391b5c57148d$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $dffa391b5c57148d$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $dffa391b5c57148d$var$finishMaybe(stream, state);
    }
}
function $dffa391b5c57148d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $dffa391b5c57148d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $dffa391b5c57148d$var$ERR_MULTIPLE_CALLBACK();
    $dffa391b5c57148d$var$onwriteStateUpdate(state);
    if (er) $dffa391b5c57148d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $dffa391b5c57148d$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $dffa391b5c57148d$var$clearBuffer(stream, state);
        if (sync) $54X9E.nextTick($dffa391b5c57148d$var$afterWrite, stream, state, finished, cb);
        else $dffa391b5c57148d$var$afterWrite(stream, state, finished, cb);
    }
}
function $dffa391b5c57148d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $dffa391b5c57148d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $dffa391b5c57148d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $dffa391b5c57148d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $dffa391b5c57148d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $dffa391b5c57148d$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $dffa391b5c57148d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $dffa391b5c57148d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$dffa391b5c57148d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $dffa391b5c57148d$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$dffa391b5c57148d$var$Writable.prototype._writev = null;
$dffa391b5c57148d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $dffa391b5c57148d$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($dffa391b5c57148d$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $dffa391b5c57148d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $dffa391b5c57148d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $dffa391b5c57148d$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $dffa391b5c57148d$var$finishMaybe(stream, state);
    });
}
function $dffa391b5c57148d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $54X9E.nextTick($dffa391b5c57148d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $dffa391b5c57148d$var$finishMaybe(stream, state) {
    var need = $dffa391b5c57148d$var$needFinish(state);
    if (need) {
        $dffa391b5c57148d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $dffa391b5c57148d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $dffa391b5c57148d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $54X9E.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $dffa391b5c57148d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($dffa391b5c57148d$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$dffa391b5c57148d$var$Writable.prototype.destroy = $icoFg.destroy;
$dffa391b5c57148d$var$Writable.prototype._undestroy = $icoFg.undestroy;
$dffa391b5c57148d$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("ds8Vx", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $9cb4d099e50dbd91$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $9cb4d099e50dbd91$var$deprecate(fn, msg) {
    if ($9cb4d099e50dbd91$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($9cb4d099e50dbd91$var$config("throwDeprecation")) throw new Error(msg);
            else if ($9cb4d099e50dbd91$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $9cb4d099e50dbd91$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("kdzLU", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $eb80c5112f8e72a1$export$63a7aa211a91ed69; }, function (v) { return $eb80c5112f8e72a1$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $eb80c5112f8e72a1$export$63a7aa211a91ed69;
"use strict";

var $f6uf2 = parcelRequire("f6uf2");
var $eb80c5112f8e72a1$require$Buffer = $f6uf2.Buffer;
/*</replacement>*/ var $eb80c5112f8e72a1$var$isEncoding = $eb80c5112f8e72a1$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $eb80c5112f8e72a1$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $eb80c5112f8e72a1$var$normalizeEncoding(enc) {
    var nenc = $eb80c5112f8e72a1$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($eb80c5112f8e72a1$require$Buffer.isEncoding === $eb80c5112f8e72a1$var$isEncoding || !$eb80c5112f8e72a1$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$eb80c5112f8e72a1$export$63a7aa211a91ed69 = $eb80c5112f8e72a1$var$StringDecoder;
function $eb80c5112f8e72a1$var$StringDecoder(encoding) {
    this.encoding = $eb80c5112f8e72a1$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $eb80c5112f8e72a1$var$utf16Text;
            this.end = $eb80c5112f8e72a1$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $eb80c5112f8e72a1$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $eb80c5112f8e72a1$var$base64Text;
            this.end = $eb80c5112f8e72a1$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $eb80c5112f8e72a1$var$simpleWrite;
            this.end = $eb80c5112f8e72a1$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $eb80c5112f8e72a1$require$Buffer.allocUnsafe(nb);
}
$eb80c5112f8e72a1$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$eb80c5112f8e72a1$var$StringDecoder.prototype.end = $eb80c5112f8e72a1$var$utf8End;
// Returns only complete characters in a Buffer
$eb80c5112f8e72a1$var$StringDecoder.prototype.text = $eb80c5112f8e72a1$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$eb80c5112f8e72a1$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $eb80c5112f8e72a1$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $eb80c5112f8e72a1$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $eb80c5112f8e72a1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $eb80c5112f8e72a1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $eb80c5112f8e72a1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $eb80c5112f8e72a1$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $eb80c5112f8e72a1$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $eb80c5112f8e72a1$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $eb80c5112f8e72a1$var$utf8Text(buf, i) {
    var total = $eb80c5112f8e72a1$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $eb80c5112f8e72a1$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $eb80c5112f8e72a1$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $eb80c5112f8e72a1$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $eb80c5112f8e72a1$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $eb80c5112f8e72a1$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $eb80c5112f8e72a1$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $eb80c5112f8e72a1$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("f6uf2", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $43wp1 = parcelRequire("43wp1");
var $afeedfe9926e5189$var$Buffer = $43wp1.Buffer;
// alternative to using Object.keys for old browsers
function $afeedfe9926e5189$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($afeedfe9926e5189$var$Buffer.from && $afeedfe9926e5189$var$Buffer.alloc && $afeedfe9926e5189$var$Buffer.allocUnsafe && $afeedfe9926e5189$var$Buffer.allocUnsafeSlow) module.exports = $43wp1;
else {
    // Copy properties from require('buffer')
    $afeedfe9926e5189$var$copyProps($43wp1, module.exports);
    module.exports.Buffer = $afeedfe9926e5189$var$SafeBuffer;
}
function $afeedfe9926e5189$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $afeedfe9926e5189$var$Buffer(arg, encodingOrOffset, length);
}
$afeedfe9926e5189$var$SafeBuffer.prototype = Object.create($afeedfe9926e5189$var$Buffer.prototype);
// Copy static methods from Buffer
$afeedfe9926e5189$var$copyProps($afeedfe9926e5189$var$Buffer, $afeedfe9926e5189$var$SafeBuffer);
$afeedfe9926e5189$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $afeedfe9926e5189$var$Buffer(arg, encodingOrOffset, length);
};
$afeedfe9926e5189$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $afeedfe9926e5189$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$afeedfe9926e5189$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $afeedfe9926e5189$var$Buffer(size);
};
$afeedfe9926e5189$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $43wp1.SlowBuffer(size);
};

});


parcelRegister("6aLZo", function(module, exports) {

var $54X9E = parcelRequire("54X9E");
"use strict";
var $47e8e6eb23f3f6fe$var$_Object$setPrototypeO;
function $47e8e6eb23f3f6fe$var$_defineProperty(obj, key, value) {
    key = $47e8e6eb23f3f6fe$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e8e6eb23f3f6fe$var$_toPropertyKey(arg) {
    var key = $47e8e6eb23f3f6fe$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e8e6eb23f3f6fe$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $c48Is = parcelRequire("c48Is");
var $47e8e6eb23f3f6fe$var$kLastResolve = Symbol("lastResolve");
var $47e8e6eb23f3f6fe$var$kLastReject = Symbol("lastReject");
var $47e8e6eb23f3f6fe$var$kError = Symbol("error");
var $47e8e6eb23f3f6fe$var$kEnded = Symbol("ended");
var $47e8e6eb23f3f6fe$var$kLastPromise = Symbol("lastPromise");
var $47e8e6eb23f3f6fe$var$kHandlePromise = Symbol("handlePromise");
var $47e8e6eb23f3f6fe$var$kStream = Symbol("stream");
function $47e8e6eb23f3f6fe$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $47e8e6eb23f3f6fe$var$readAndResolve(iter) {
    var resolve = iter[$47e8e6eb23f3f6fe$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$47e8e6eb23f3f6fe$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$47e8e6eb23f3f6fe$var$kLastPromise] = null;
            iter[$47e8e6eb23f3f6fe$var$kLastResolve] = null;
            iter[$47e8e6eb23f3f6fe$var$kLastReject] = null;
            resolve($47e8e6eb23f3f6fe$var$createIterResult(data, false));
        }
    }
}
function $47e8e6eb23f3f6fe$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $54X9E.nextTick($47e8e6eb23f3f6fe$var$readAndResolve, iter);
}
function $47e8e6eb23f3f6fe$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$47e8e6eb23f3f6fe$var$kEnded]) {
                resolve($47e8e6eb23f3f6fe$var$createIterResult(undefined, true));
                return;
            }
            iter[$47e8e6eb23f3f6fe$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $47e8e6eb23f3f6fe$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $47e8e6eb23f3f6fe$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($47e8e6eb23f3f6fe$var$_Object$setPrototypeO = {
    get stream () {
        return this[$47e8e6eb23f3f6fe$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$47e8e6eb23f3f6fe$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$47e8e6eb23f3f6fe$var$kEnded]) return Promise.resolve($47e8e6eb23f3f6fe$var$createIterResult(undefined, true));
        if (this[$47e8e6eb23f3f6fe$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $54X9E.nextTick(function() {
                if (_this[$47e8e6eb23f3f6fe$var$kError]) reject(_this[$47e8e6eb23f3f6fe$var$kError]);
                else resolve($47e8e6eb23f3f6fe$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$47e8e6eb23f3f6fe$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($47e8e6eb23f3f6fe$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$47e8e6eb23f3f6fe$var$kStream].read();
            if (data !== null) return Promise.resolve($47e8e6eb23f3f6fe$var$createIterResult(data, false));
            promise = new Promise(this[$47e8e6eb23f3f6fe$var$kHandlePromise]);
        }
        this[$47e8e6eb23f3f6fe$var$kLastPromise] = promise;
        return promise;
    }
}, $47e8e6eb23f3f6fe$var$_defineProperty($47e8e6eb23f3f6fe$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $47e8e6eb23f3f6fe$var$_defineProperty($47e8e6eb23f3f6fe$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$47e8e6eb23f3f6fe$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($47e8e6eb23f3f6fe$var$createIterResult(undefined, true));
        });
    });
}), $47e8e6eb23f3f6fe$var$_Object$setPrototypeO), $47e8e6eb23f3f6fe$var$AsyncIteratorPrototype);
var $47e8e6eb23f3f6fe$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($47e8e6eb23f3f6fe$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $47e8e6eb23f3f6fe$var$_defineProperty(_Object$create, $47e8e6eb23f3f6fe$var$kStream, {
        value: stream,
        writable: true
    }), $47e8e6eb23f3f6fe$var$_defineProperty(_Object$create, $47e8e6eb23f3f6fe$var$kLastResolve, {
        value: null,
        writable: true
    }), $47e8e6eb23f3f6fe$var$_defineProperty(_Object$create, $47e8e6eb23f3f6fe$var$kLastReject, {
        value: null,
        writable: true
    }), $47e8e6eb23f3f6fe$var$_defineProperty(_Object$create, $47e8e6eb23f3f6fe$var$kError, {
        value: null,
        writable: true
    }), $47e8e6eb23f3f6fe$var$_defineProperty(_Object$create, $47e8e6eb23f3f6fe$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $47e8e6eb23f3f6fe$var$_defineProperty(_Object$create, $47e8e6eb23f3f6fe$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$47e8e6eb23f3f6fe$var$kStream].read();
            if (data) {
                iterator[$47e8e6eb23f3f6fe$var$kLastPromise] = null;
                iterator[$47e8e6eb23f3f6fe$var$kLastResolve] = null;
                iterator[$47e8e6eb23f3f6fe$var$kLastReject] = null;
                resolve($47e8e6eb23f3f6fe$var$createIterResult(data, false));
            } else {
                iterator[$47e8e6eb23f3f6fe$var$kLastResolve] = resolve;
                iterator[$47e8e6eb23f3f6fe$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$47e8e6eb23f3f6fe$var$kLastPromise] = null;
    $c48Is(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$47e8e6eb23f3f6fe$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$47e8e6eb23f3f6fe$var$kLastPromise] = null;
                iterator[$47e8e6eb23f3f6fe$var$kLastResolve] = null;
                iterator[$47e8e6eb23f3f6fe$var$kLastReject] = null;
                reject(err);
            }
            iterator[$47e8e6eb23f3f6fe$var$kError] = err;
            return;
        }
        var resolve = iterator[$47e8e6eb23f3f6fe$var$kLastResolve];
        if (resolve !== null) {
            iterator[$47e8e6eb23f3f6fe$var$kLastPromise] = null;
            iterator[$47e8e6eb23f3f6fe$var$kLastResolve] = null;
            iterator[$47e8e6eb23f3f6fe$var$kLastReject] = null;
            resolve($47e8e6eb23f3f6fe$var$createIterResult(undefined, true));
        }
        iterator[$47e8e6eb23f3f6fe$var$kEnded] = true;
    });
    stream.on("readable", $47e8e6eb23f3f6fe$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $47e8e6eb23f3f6fe$var$createReadableStreamAsyncIterator;

});
parcelRegister("c48Is", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $8c8c9e95643544b2$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("5K3jZ")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $8c8c9e95643544b2$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $8c8c9e95643544b2$var$noop() {}
function $8c8c9e95643544b2$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $8c8c9e95643544b2$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $8c8c9e95643544b2$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $8c8c9e95643544b2$var$once(callback || $8c8c9e95643544b2$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $8c8c9e95643544b2$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $8c8c9e95643544b2$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($8c8c9e95643544b2$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $8c8c9e95643544b2$var$eos;

});


parcelRegister("f77Mx", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("gULOi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $c506f66c979b81af$var$Transform;

var $5K3jZ = parcelRequire("5K3jZ");
var $c506f66c979b81af$require$_require$codes = $5K3jZ.codes;
var $c506f66c979b81af$var$ERR_METHOD_NOT_IMPLEMENTED = $c506f66c979b81af$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c506f66c979b81af$var$ERR_MULTIPLE_CALLBACK = $c506f66c979b81af$require$_require$codes.ERR_MULTIPLE_CALLBACK, $c506f66c979b81af$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $c506f66c979b81af$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $c506f66c979b81af$var$ERR_TRANSFORM_WITH_LENGTH_0 = $c506f66c979b81af$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $bKtym = parcelRequire("bKtym");

(parcelRequire("6a1gD"))($c506f66c979b81af$var$Transform, $bKtym);
function $c506f66c979b81af$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $c506f66c979b81af$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $c506f66c979b81af$var$Transform(options) {
    if (!(this instanceof $c506f66c979b81af$var$Transform)) return new $c506f66c979b81af$var$Transform(options);
    $bKtym.call(this, options);
    this._transformState = {
        afterTransform: $c506f66c979b81af$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $c506f66c979b81af$var$prefinish);
}
function $c506f66c979b81af$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $c506f66c979b81af$var$done(_this, er, data);
    });
    else $c506f66c979b81af$var$done(this, null, null);
}
$c506f66c979b81af$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $bKtym.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$c506f66c979b81af$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $c506f66c979b81af$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$c506f66c979b81af$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$c506f66c979b81af$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$c506f66c979b81af$var$Transform.prototype._destroy = function(err, cb) {
    $bKtym.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $c506f66c979b81af$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $c506f66c979b81af$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $c506f66c979b81af$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("bjyQX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $83cc812b2e96e148$var$PassThrough;

var $gULOi = parcelRequire("gULOi");

(parcelRequire("6a1gD"))($83cc812b2e96e148$var$PassThrough, $gULOi);
function $83cc812b2e96e148$var$PassThrough(options) {
    if (!(this instanceof $83cc812b2e96e148$var$PassThrough)) return new $83cc812b2e96e148$var$PassThrough(options);
    $gULOi.call(this, options);
}
$83cc812b2e96e148$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("fNxwk", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $b8056f126a1c1257$var$eos;
function $b8056f126a1c1257$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $5K3jZ = parcelRequire("5K3jZ");
var $b8056f126a1c1257$require$_require$codes = $5K3jZ.codes;
var $b8056f126a1c1257$var$ERR_MISSING_ARGS = $b8056f126a1c1257$require$_require$codes.ERR_MISSING_ARGS, $b8056f126a1c1257$var$ERR_STREAM_DESTROYED = $b8056f126a1c1257$require$_require$codes.ERR_STREAM_DESTROYED;
function $b8056f126a1c1257$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $b8056f126a1c1257$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $b8056f126a1c1257$var$destroyer(stream, reading, writing, callback) {
    callback = $b8056f126a1c1257$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($b8056f126a1c1257$var$eos === undefined) $b8056f126a1c1257$var$eos = (parcelRequire("c48Is"));
    $b8056f126a1c1257$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($b8056f126a1c1257$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $b8056f126a1c1257$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $b8056f126a1c1257$var$call(fn) {
    fn();
}
function $b8056f126a1c1257$var$pipe(from, to) {
    return from.pipe(to);
}
function $b8056f126a1c1257$var$popCallback(streams) {
    if (!streams.length) return $b8056f126a1c1257$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $b8056f126a1c1257$var$noop;
    return streams.pop();
}
function $b8056f126a1c1257$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $b8056f126a1c1257$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $b8056f126a1c1257$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $b8056f126a1c1257$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($b8056f126a1c1257$var$call);
            if (reading) return;
            destroys.forEach($b8056f126a1c1257$var$call);
            callback(error);
        });
    });
    return streams.reduce($b8056f126a1c1257$var$pipe);
}
module.exports = $b8056f126a1c1257$var$pipeline;

});

parcelRegister("dJovV", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $lIfzS = parcelRequire("lIfzS");

var $54X9E = parcelRequire("54X9E");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $lIfzS.isBrowserBundle)() && Object.prototype.toString.call(typeof $54X9E !== "undefined" ? $54X9E : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("lIfzS", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $fce9ca7474285826$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $fce9ca7474285826$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $fce9ca7474285826$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $fce9ca7474285826$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("bZSVP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bc0008288327973$var$ReactIs, $8bc0008288327973$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("16YfO"))();

});


var $592Nh = parcelRequire("592Nh");


const $0f0149b7a0f9f5b2$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $0f0149b7a0f9f5b2$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $0f0149b7a0f9f5b2$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $0f0149b7a0f9f5b2$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $0f0149b7a0f9f5b2$var$Logger(this.logger, options);
    }
}
var $0f0149b7a0f9f5b2$var$baseLogger = new $0f0149b7a0f9f5b2$var$Logger();
class $0f0149b7a0f9f5b2$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $0f0149b7a0f9f5b2$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $0f0149b7a0f9f5b2$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $0f0149b7a0f9f5b2$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $0f0149b7a0f9f5b2$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $0f0149b7a0f9f5b2$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $0f0149b7a0f9f5b2$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $0f0149b7a0f9f5b2$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $0f0149b7a0f9f5b2$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $0f0149b7a0f9f5b2$var$getPath(object, path) {
    const { obj: obj, k: k } = $0f0149b7a0f9f5b2$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $0f0149b7a0f9f5b2$var$getPathWithDefaults(data, defaultData, key) {
    const value = $0f0149b7a0f9f5b2$var$getPath(data, key);
    if (value !== undefined) return value;
    return $0f0149b7a0f9f5b2$var$getPath(defaultData, key);
}
function $0f0149b7a0f9f5b2$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $0f0149b7a0f9f5b2$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $0f0149b7a0f9f5b2$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $0f0149b7a0f9f5b2$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $0f0149b7a0f9f5b2$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$0f0149b7a0f9f5b2$var$_entityMap[s]);
    return data;
}
const $0f0149b7a0f9f5b2$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $0f0149b7a0f9f5b2$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $0f0149b7a0f9f5b2$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $0f0149b7a0f9f5b2$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $0f0149b7a0f9f5b2$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $0f0149b7a0f9f5b2$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $0f0149b7a0f9f5b2$var$ResourceStore extends $0f0149b7a0f9f5b2$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $0f0149b7a0f9f5b2$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $0f0149b7a0f9f5b2$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $0f0149b7a0f9f5b2$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $0f0149b7a0f9f5b2$var$getPath(this.data, path) || {};
        if (deep) $0f0149b7a0f9f5b2$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $0f0149b7a0f9f5b2$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $0f0149b7a0f9f5b2$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $0f0149b7a0f9f5b2$var$checkedLoadedFor = {};
class $0f0149b7a0f9f5b2$var$Translator extends $0f0149b7a0f9f5b2$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $0f0149b7a0f9f5b2$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$0f0149b7a0f9f5b2$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $0f0149b7a0f9f5b2$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $0f0149b7a0f9f5b2$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$0f0149b7a0f9f5b2$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $0f0149b7a0f9f5b2$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $0f0149b7a0f9f5b2$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $0f0149b7a0f9f5b2$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $0f0149b7a0f9f5b2$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $0f0149b7a0f9f5b2$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $0f0149b7a0f9f5b2$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $0f0149b7a0f9f5b2$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $0f0149b7a0f9f5b2$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $0f0149b7a0f9f5b2$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $0f0149b7a0f9f5b2$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $0f0149b7a0f9f5b2$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $0f0149b7a0f9f5b2$var$intlVersions = [
    "v4"
];
const $0f0149b7a0f9f5b2$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $0f0149b7a0f9f5b2$var$createRules() {
    const rules = {};
    $0f0149b7a0f9f5b2$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $0f0149b7a0f9f5b2$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $0f0149b7a0f9f5b2$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $0f0149b7a0f9f5b2$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $0f0149b7a0f9f5b2$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($0f0149b7a0f9f5b2$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$0f0149b7a0f9f5b2$var$suffixesOrder[pluralCategory1] - $0f0149b7a0f9f5b2$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$0f0149b7a0f9f5b2$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $0f0149b7a0f9f5b2$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $0f0149b7a0f9f5b2$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $0f0149b7a0f9f5b2$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $0f0149b7a0f9f5b2$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $0f0149b7a0f9f5b2$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $0f0149b7a0f9f5b2$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $0f0149b7a0f9f5b2$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $0f0149b7a0f9f5b2$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $0f0149b7a0f9f5b2$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $0f0149b7a0f9f5b2$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $0f0149b7a0f9f5b2$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $0f0149b7a0f9f5b2$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $0f0149b7a0f9f5b2$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($0f0149b7a0f9f5b2$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $0f0149b7a0f9f5b2$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $0f0149b7a0f9f5b2$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $0f0149b7a0f9f5b2$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $0f0149b7a0f9f5b2$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($0f0149b7a0f9f5b2$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $0f0149b7a0f9f5b2$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $0f0149b7a0f9f5b2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $0f0149b7a0f9f5b2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $0f0149b7a0f9f5b2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $0f0149b7a0f9f5b2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $0f0149b7a0f9f5b2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $0f0149b7a0f9f5b2$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $0f0149b7a0f9f5b2$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $0f0149b7a0f9f5b2$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $0f0149b7a0f9f5b2$var$Connector extends $0f0149b7a0f9f5b2$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $0f0149b7a0f9f5b2$var$pushPath(q.loaded, [
                lng
            ], ns);
            $0f0149b7a0f9f5b2$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $0f0149b7a0f9f5b2$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $0f0149b7a0f9f5b2$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $0f0149b7a0f9f5b2$var$noop() {}
function $0f0149b7a0f9f5b2$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $0f0149b7a0f9f5b2$var$I18n extends $0f0149b7a0f9f5b2$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $0f0149b7a0f9f5b2$var$transformOptions(options);
        this.services = {};
        this.logger = $0f0149b7a0f9f5b2$var$baseLogger;
        this.modules = {
            external: []
        };
        $0f0149b7a0f9f5b2$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $0f0149b7a0f9f5b2$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$0f0149b7a0f9f5b2$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $0f0149b7a0f9f5b2$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $0f0149b7a0f9f5b2$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $0f0149b7a0f9f5b2$var$Formatter;
            const lu = new $0f0149b7a0f9f5b2$var$LanguageUtil(this.options);
            this.store = new $0f0149b7a0f9f5b2$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $0f0149b7a0f9f5b2$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $0f0149b7a0f9f5b2$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $0f0149b7a0f9f5b2$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $0f0149b7a0f9f5b2$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $0f0149b7a0f9f5b2$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $0f0149b7a0f9f5b2$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $0f0149b7a0f9f5b2$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0f0149b7a0f9f5b2$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $0f0149b7a0f9f5b2$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $0f0149b7a0f9f5b2$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $0f0149b7a0f9f5b2$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $0f0149b7a0f9f5b2$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $0f0149b7a0f9f5b2$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $0f0149b7a0f9f5b2$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $0f0149b7a0f9f5b2$var$LanguageUtil($0f0149b7a0f9f5b2$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $0f0149b7a0f9f5b2$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0f0149b7a0f9f5b2$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $0f0149b7a0f9f5b2$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $0f0149b7a0f9f5b2$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $0f0149b7a0f9f5b2$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $0f0149b7a0f9f5b2$export$2e2bcd8739ae039 = $0f0149b7a0f9f5b2$var$I18n.createInstance();
$0f0149b7a0f9f5b2$export$2e2bcd8739ae039.createInstance = $0f0149b7a0f9f5b2$var$I18n.createInstance;
const $0f0149b7a0f9f5b2$export$99152e8d49ca4e7d = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.createInstance;
const $0f0149b7a0f9f5b2$export$147ec2801e896265 = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.dir;
const $0f0149b7a0f9f5b2$export$2cd8252107eb640b = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.init;
const $0f0149b7a0f9f5b2$export$d3d08d944062d7e = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.loadResources;
const $0f0149b7a0f9f5b2$export$a5d9bf5d83fcab09 = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.reloadResources;
const $0f0149b7a0f9f5b2$export$1f96ae73734a86cc = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.use;
const $0f0149b7a0f9f5b2$export$61465194746e7fd2 = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.changeLanguage;
const $0f0149b7a0f9f5b2$export$f90d180fc7da3b3b = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.getFixedT;
const $0f0149b7a0f9f5b2$export$625550452a3fa3ec = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.t;
const $0f0149b7a0f9f5b2$export$f7e9f41ea797a17 = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.exists;
const $0f0149b7a0f9f5b2$export$2b4b218e406d2d00 = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.setDefaultNamespace;
const $0f0149b7a0f9f5b2$export$93d9ee97c1ad3f31 = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.hasLoadedNamespace;
const $0f0149b7a0f9f5b2$export$83be934b53fff43b = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.loadNamespaces;
const $0f0149b7a0f9f5b2$export$8cd7e7a54fa865bc = $0f0149b7a0f9f5b2$export$2e2bcd8739ae039.loadLanguages;



var $2hDQc = parcelRequire("2hDQc");

var $7vVRg = parcelRequire("7vVRg");

var $2hDQc = parcelRequire("2hDQc");
var $de4b3f03ee106e77$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $de4b3f03ee106e77$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $d73cbeccb42e8979$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $d73cbeccb42e8979$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($de4b3f03ee106e77$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($d73cbeccb42e8979$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $d73cbeccb42e8979$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $d73cbeccb42e8979$var$i = /^\s*$/, $d73cbeccb42e8979$var$s = Object.create(null);
function $d73cbeccb42e8979$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($d73cbeccb42e8979$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $d73cbeccb42e8979$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $d73cbeccb42e8979$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($d73cbeccb42e8979$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $d73cbeccb42e8979$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $d73cbeccb42e8979$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $d73cbeccb42e8979$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $d73cbeccb42e8979$var$a("", t);
        }, "");
    }
};
var $d73cbeccb42e8979$export$2e2bcd8739ae039 = $d73cbeccb42e8979$var$c;


function $10d1d9221cbfa304$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $10d1d9221cbfa304$var$alreadyWarned = {};
function $10d1d9221cbfa304$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $10d1d9221cbfa304$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $10d1d9221cbfa304$var$alreadyWarned[args[0]] = new Date();
    $10d1d9221cbfa304$export$c106dd0671a0fc2d(...args);
}
const $10d1d9221cbfa304$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $10d1d9221cbfa304$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $10d1d9221cbfa304$var$loadedClb(i18n, cb));
}
function $10d1d9221cbfa304$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $10d1d9221cbfa304$var$loadedClb(i18n, cb));
}
function $10d1d9221cbfa304$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $10d1d9221cbfa304$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $10d1d9221cbfa304$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $10d1d9221cbfa304$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $10d1d9221cbfa304$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $14312a78d110efab$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $14312a78d110efab$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $14312a78d110efab$var$unescapeHtmlEntity = (m)=>$14312a78d110efab$var$htmlEntities[m];
const $14312a78d110efab$export$e8bacd2802a88316 = (text)=>text.replace($14312a78d110efab$var$matchHtmlEntity, $14312a78d110efab$var$unescapeHtmlEntity);


let $3cef56318ecf8fa7$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $14312a78d110efab$export$e8bacd2802a88316
};
function $3cef56318ecf8fa7$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $3cef56318ecf8fa7$var$defaultOptions = {
        ...$3cef56318ecf8fa7$var$defaultOptions,
        ...options
    };
}
function $3cef56318ecf8fa7$export$212bb2fc580a90a8() {
    return $3cef56318ecf8fa7$var$defaultOptions;
}


let $296607ae9dc47fbb$var$i18nInstance;
function $296607ae9dc47fbb$export$a039134f2fc7e0(instance) {
    $296607ae9dc47fbb$var$i18nInstance = instance;
}
function $296607ae9dc47fbb$export$64af334f494c2f47() {
    return $296607ae9dc47fbb$var$i18nInstance;
}


function $eb58dd833c84cb05$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $eb58dd833c84cb05$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $eb58dd833c84cb05$var$getAsArray(children) : children;
}
function $eb58dd833c84cb05$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $2hDQc.isValidElement)(child));
}
function $eb58dd833c84cb05$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $eb58dd833c84cb05$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $eb58dd833c84cb05$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $eb58dd833c84cb05$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $2hDQc.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $eb58dd833c84cb05$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $10d1d9221cbfa304$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $10d1d9221cbfa304$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $10d1d9221cbfa304$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $eb58dd833c84cb05$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $eb58dd833c84cb05$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($eb58dd833c84cb05$var$hasChildren(child)) getData($eb58dd833c84cb05$var$getChildren(child));
            else if (typeof child === "object" && !(0, $2hDQc.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $d73cbeccb42e8979$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $eb58dd833c84cb05$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $eb58dd833c84cb05$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $2hDQc.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $2hDQc.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($7vVRg)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $eb58dd833c84cb05$var$getAsArray(reactNode);
        const astNodes = $eb58dd833c84cb05$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $eb58dd833c84cb05$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $2hDQc.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $eb58dd833c84cb05$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($eb58dd833c84cb05$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $2hDQc.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $2hDQc.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $2hDQc.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $eb58dd833c84cb05$var$getAsArray(children || []));
    return $eb58dd833c84cb05$var$getChildren(result[0]);
}
function $eb58dd833c84cb05$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $296607ae9dc47fbb$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $10d1d9221cbfa304$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $3cef56318ecf8fa7$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $eb58dd833c84cb05$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $eb58dd833c84cb05$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $2hDQc.createElement)(useAsParent, additionalProps, content) : content;
}



var $2hDQc = parcelRequire("2hDQc");




const $9a01e7501dac985c$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $3cef56318ecf8fa7$export$2e2366488d12e20d)(instance.options.react);
        (0, $296607ae9dc47fbb$export$a039134f2fc7e0)(instance);
    }
};


const $dde1460c4de011e3$export$5603ab5ced17ce64 = (0, $2hDQc.createContext)();
class $dde1460c4de011e3$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $dde1460c4de011e3$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $dde1460c4de011e3$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $dde1460c4de011e3$export$704200e5d0b9e8f() {
    const i18n = (0, $296607ae9dc47fbb$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $defe451bc5ae94de$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $2hDQc.useContext)((0, $dde1460c4de011e3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $296607ae9dc47fbb$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $eb58dd833c84cb05$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $2hDQc = parcelRequire("2hDQc");


const $098733de52381e7c$var$usePrevious = (value, ignore)=>{
    const ref = (0, $2hDQc.useRef)();
    (0, $2hDQc.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $098733de52381e7c$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $2hDQc.useContext)((0, $dde1460c4de011e3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $296607ae9dc47fbb$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $dde1460c4de011e3$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $10d1d9221cbfa304$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $10d1d9221cbfa304$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $3cef56318ecf8fa7$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $10d1d9221cbfa304$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $2hDQc.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $098733de52381e7c$var$usePrevious(joinedNS);
    const isMounted = (0, $2hDQc.useRef)(true);
    (0, $2hDQc.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $10d1d9221cbfa304$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $10d1d9221cbfa304$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $2hDQc.useRef)(true);
    (0, $2hDQc.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $10d1d9221cbfa304$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $10d1d9221cbfa304$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $2hDQc = parcelRequire("2hDQc");


function $2e24f014ca267758$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $098733de52381e7c$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $2hDQc.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $10d1d9221cbfa304$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $2hDQc.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $2hDQc.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $c2b3c91763f40a0a$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $098733de52381e7c$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $2hDQc = parcelRequire("2hDQc");

function $22feb9a8f4ec0f3e$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $2hDQc.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $2hDQc.createElement)((0, $dde1460c4de011e3$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");

function $718fc30b87edb21e$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $2hDQc.useContext)((0, $dde1460c4de011e3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $296607ae9dc47fbb$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $4b4a90bb7f77b36a$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $718fc30b87edb21e$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $2hDQc.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $dde1460c4de011e3$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $10d1d9221cbfa304$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $e493845c91cdfae9$export$324d90190a8b822a = ()=>"";
const $e493845c91cdfae9$export$2da9be4cfdb689b1 = ()=>"";
const $e493845c91cdfae9$export$98e628dec113755e = ()=>"";
const $e493845c91cdfae9$export$2e6c959c16ff56b8 = ()=>"";
const $e493845c91cdfae9$export$4e35d5c922a95490 = ()=>"";
const $e493845c91cdfae9$export$720a3b9db04b7a0f = ()=>"";


var $7132ad9939508af6$exports = {};
$7132ad9939508af6$exports = JSON.parse('{"common.yes":"yes","common.no":"no","common.ok":"ok","common.buttons.yes":"Yes","common.buttons.add":"Add","common.buttons.save":"Save","common.buttons.edit":"Edit","common.buttons.next":"Next","common.buttons.complete":"Compelete","common.buttons.cancel":"Cancel","common.buttons.remove":"Remove","common.buttons.update":"Update","common.buttons.terminate":"Terminate","common.buttons.back":"Back","common.buttons.clear":"Clear","common.actions.error":"An error occurred","common.actions.add.error":"Adding failed","common.actions.update.error":"Updating failed","common.actions.get.error":"Failed to get data","common.actions.remove.error":"Failed to remove data","common.form.errors.empty":"The field cannot be empty.","common.form.errors.email":"Enter a valid email.","common.form.errors.phoneNumber":"Enter a valid phone number with country code.","common.form.errors.licensePlate":"Enter a valid vehicle license plate.","common.form.errors.businessId":"Enter a valid Business ID.","common.form.errors.number":"Only numbers can be entered in the field.","common.form.errors.invalidDateTime":"Enter a valid date and time","common.text.licensePlate":"License plate","common.text.email":"Email","common.text.project":"Project","common.text.costCenter":"Cost center","common.text.validityStart":"Start","common.text.validityEnd":"End","menu.invitations":"Invite a customer","menu.allPlaces":"All locations","menu.places":"Location & Rights","menu.customer":"Customer details","menu.reports":"Reports","menu.user.detail":"Own details","menu.user.logout":"Sign out","menu.user.fi":"In Finnish","menu.user.en":"In English","menu.subHeader.moovyAdmin":"Moovy Admin","appMenuTop.button.menu":"Menu","appMenuTop.button.closeMenu":"Close menu","validation.code.NOT_EMPTY":"{field, plural, one {Field cannot be empty.} other {{field} field cannot be empty.}}","validation.code.MAX_LENGTH":"{field, plural, one {Too many characters} other {There are too many characters in the field {field}.}}","validation.code.MIN_LENGTH":"{field, plural, one {There are no enough characters.} other {There are no enough characters in the field {field}.}}","validation.code.BUSINESS_ID_FORMAT":"{field, plural, one {Input content is not in a valid format.} other {The field {field} content is not a valid format.}}","validation.code.generic":"Filled values are not valid. Please check them.","validation.field.name":"Name","validation.field.streetAddress":"Address","validation.field.city":"City","validation.field.postalCode":"Postal code","validation.field.businessId":"Business ID","validation.field.costCenter":"Cost center","validation.field.project":"Project","sort.PLACES.NAME":"Name","sort.PLACES.CITY":"City","sort.PLACES.CAPACITY":"Capacity","sort.PLACES.CUSTOMER_ID":"Customer","sort.INVITATIONS.NAME":"Name","sort.INVITATIONS.EMAIL":"Email","sort.INVITATIONS.CREATED_AT":"Invited","sort.INVITATIONS.USED":"Registered in","sort.ACTIVE_RIGHTS.INDIVIDUAL":"Name","sort.ACTIVE_RIGHTS.VEHICLE":"License plate","sort.ACTIVE_RIGHTS.VALIDITY_START":"Valid from","sort.ACTIVE_RIGHTS.VALIDITY_END":"Valid until","sort.CATALOGUES.CUSTOMER_ID":"Customer","sort.CATALOGUES.CREATED_AT":"Created","sort.CATALOGUES.UPDATED_AT":"Updated","sort.CATALOGUES.AMOUNT":"Amount","api.error.code.OFFERING_AMOUNT_EXCEEDED_ERROR":"The offering must be at least the number of distributed rights.","api.error.code.CUSTOMER_ALREADY_EXISTS":"A customer with the same name already exists in the system.","api.error.code.INVITATION_ALREADY_EXISTS":"An invitation already exists for the same person.","api.error.code.CATALOGUE_AMOUNT_EXCEEDED":"The amount is too large. The number of rights to be granted may not exceed the total number of rights for the product.","api.error.code.CATALOGUE_AMOUNT_TOO_SMALL":"The amount is too small. The number of rights to be granted must be at least the same as the number of rights distributed.","api.error.code.CATALOGUE_DOES_NOT_ALLOW_VEHICLE_GRANTING":"Catalogue doesn\'t allow granting rights to vehicles","api.error.code.EMAIL_ALREADY_TAKEN":"The email is already in use.","api.error.code.TOO_MANY_CATALOGUES_IN_REPORT":"The report includes too many catalogues. Change search filters and try again.","api.error.code.TOO_MANY_RIGHTS_IN_REPORT":"The report includes too many rights. Change search filters and try again.","api.error.code.RIGHT_HOLDER_EXCEEDS_CATALOGUE_AMOUNT":"Number of requested rights plus number of existing active rights must not exceed catalogue\'s limit","api.error.code.generic":"An error occurred","moovyErrorPage.oops":"Oops!","moovyErrorPage.message":"Sorry, an unexpected error has occurred. Please, check the url and try to refresh the view again.","components.modalSubPlace.actions.error.added":"Failed to add the location","components.modalSubPlace.actions.added":"The location has been added.","components.modalSubPlace.title":"Add sublocation","components.modalSubPlace.button.add":"Add sublocation","components.tableSubPlaces.header.name":"Name","components.tableSubPlaces.header.customer":"Customer","components.tableSubPlaces.header.streetAddress":"Street address","components.tableSubPlaces.header.postalCode":"Postal code","components.tableSubPlaces.header.city":"City","components.tableSubPlaces.header.capacity":"Capacity","components.tableSubPlaces.action.empty":"There are no locations","components.tableSubPlaces.action.failed":"Failed to get locations","page.steps.bar.landlord.title":"Landlord details","page.steps.bar.landlord.description":"Fill landlord details","page.steps.bar.place.title":"Location details","page.steps.bar.place.description":"Fill location details","page.steps.landlord.title":"Landlord details","page.steps.landlord.info":"Create a company in Moovy by entering the company information. Company and its representatives are responsible for the parking facility to be created.","page.steps.landlord.actions.added":"The landlord {name} has been added.","page.steps.place.title":"Location details","page.steps.place.info":"Please fill in the basic information of the object. The information is mandatory, as it is used in Moovy, for example, to manage parking permits. You can later change and complete the item\'s information","page.steps.place.actions.added":"The location {name} has been added.","page.steps.noRights.header":"User account has no rights to use Lupapalvelu","page.steps.noRights.content":"To use Lupapalvelu you need to have rights to manage locations.","page.invitations.modalAddInvitation.landlord.title":"Invite a customer","page.invitations.modalAddInvitation.tenant.title":"Add and invite an administrator","page.invitations.invitation.actions.updated":"Invitation link {name} has been updated.","page.invitations.formInvitation.label.firstName":"First name","page.invitations.formInvitation.label.lastName":"Last name","page.invitations.list.button.landlord.newInvitation":"Invite a customer","page.invitations.list.button.tenant.newInvitation":"Invite an administrator","page.invitations.list.button.remove":"Remove invitation","page.invitations.list.title":"Invite new customers","page.invitations.list.actions.added":"New invitation {name} has been added.","page.invitations.list.actions.removed":"The invitation {name} has been removed.","page.invitations.list.table.header.name":"Name","page.invitations.list.table.header.invited":"Invited","page.invitations.list.table.header.registeredIn":"Registered in","page.invitations.list.table.action.empty":"There are no invitation links.","page.invitations.list.table.action.failed":"Failed to get invitation links.","page.invitations.list.card.header.registeredIn":"Registered in","page.invitations.modalRemove.header":"Remove the invitation?","page.invitations.modalRemove.content":"Are you sure you want to remove the invitation from the user {name}?","page.catalogues.modalAddRightHolder.title":"Add right holder","page.catalogues.modalAddRightHolder.button.add":"Add right holder","page.catalogues.modalAddRightHolder.steps.bar.email":"Email","page.catalogues.modalAddRightHolder.steps.bar.rightHolder":"Right holder details","page.catalogues.modalAddVehicleRightHolder.title":"Add vehicle","page.catalogues.tabCatalogue.formIndividualRightHolder.label.customerDetails":"Customer details","page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName":"First name","page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName":"Last name","page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber":"Phone number","page.catalogues.tabCatalogue.formIndividualRightHolder.label.productDetails":"Product details","page.catalogues.tabCatalogue.formIndividualRightHolder.label.licensePlateDetails":"A vehicle license plate","page.catalogues.tabCatalogue.formIndividualRightHolder.label.validity":"Validity","page.catalogues.tabCatalogue.modalFindRightHolder.info":"Enter an email address to create a new right holder or to check if the right holder already has a Moovy account.","page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email":"Email","page.catalogues.tabCatalogue.modalFindRightHolder.actions.added":"New right holder {name} has been added.","page.catalogues.tabCatalogue.formVehicleRightHolder.label.vehicleDetails":"A license plate of the vehicle","page.catalogues.tabCatalogue.formVehicleRightHolder.label.validity":"Right validity","page.catalogues.tabCatalogue.title.rightHolder":"Right holders","page.catalogues.tabCatalogue.search.label":"Search right holders","page.catalogues.tabCatalogue.search.invalid":"Please enter at least 3 characters","page.catalogues.tabCatalogue.button.addIndividual":"Add a right holder","page.catalogues.tabCatalogue.button.addVehicle":"Add a vehicle","page.catalogues.tabCatalogue.rightHolders.card.header.place":"Location","page.catalogues.tabCatalogue.rightHolders.card.header.validUntil":"Valid until","page.catalogues.tabCatalogue.rightHolders.table.header.name":"Name","page.catalogues.tabCatalogue.rightHolders.table.header.place":"Location","page.catalogues.tabCatalogue.rightHolders.table.header.validFrom":"Valid from","page.catalogues.tabCatalogue.rightHolders.table.header.validUntil":"Valid until","page.catalogues.tabCatalogue.rightHolders.table.action.empty":"There are no right holders here.","page.catalogues.tabCatalogue.rightHolders.table.action.failed":"Failed to read right holders.","page.rightHolders.rightHolder.title":"Right holder details","page.rightHolders.rightHolder.button.edit":"Edit right holder","page.rightHolders.rightHolder.modalEditRightHolder.title.individual":"Edit right holder","page.rightHolders.rightHolder.modalEditRightHolder.title.vehicle":"Edit license plate","page.rightHolders.rightHolder.modalEditRightHolder.actions.update":"Right holder {name} has been updated.","page.rightHolders.rightHolder.formEditRightHolder.label.firstName":"First name","page.rightHolders.rightHolder.formEditRightHolder.label.lastName":"Last name","page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber":"Phone number","page.rightHolders.rightHolder.formEditRightHolder.info.product":"A parking permit is automatically added to the user:","page.rightHolders.rightHolder.tab.rightsAndVehicles.title":"Rights and vehicles","page.rightHolders.rightHolder.tab.vehicles.table.header.createdAt":"Created","page.rightHolders.rightHolder.tab.vehicles.table.header.right":"Right","page.rightHolders.rightHolder.tab.vehicles.table.header.place":"Location","page.rightHolders.rightHolder.tab.vehicles.table.header.validFrom":"Valid from","page.rightHolders.rightHolder.tab.vehicles.table.header.validUntil":"Valid until","page.rightHolders.rightHolder.tab.vehicles.table.item.permanent":"Permanent","page.rightHolders.rightHolder.tab.vehicles.table.action.empty":"There are no vehicles here.","page.rightHolders.rightHolder.tab.vehicles.table.action.failed":"Failed to read vehicles.","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.location":"Location:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.right":"Right:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.startRight":"Valid from:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.endRight":"Valid until:","page.places.modalAddPlace.title":"Add location","page.places.modalAddPlace.button.add":"Add location","page.places.formPlace.contentTitle":"Location details","page.places.formPlace.label.customer":"Customer","page.places.formPlace.label.name":"Name","page.places.formPlace.label.streetAddress":"Street address","page.places.formPlace.label.postalCode":"Postal code","page.places.formPlace.label.city":"City","page.places.formPlace.label.capacity":"Capacity","page.places.list.button.newPlace":"New location","page.places.list.title":"Locations","page.places.list.actions.added":"The new location {name} has been added.","page.places.list.table.header.name":"Name","page.places.list.table.header.streetAddress":"Street address","page.places.list.table.header.postalCode":"Postal code","page.places.list.table.header.city":"City","page.places.list.table.header.capacity":"Capacity","page.places.list.table.header.customer":"Customer","page.places.list.table.action.empty":"There are no locations.","page.places.list.table.action.failed":"Failed to get locations.","page.places.catalogueTabs.catalogue.header":"Rights","page.places.catalogueTabs.invitations.header":"Invitations","page.places.catalogueTabs.administrators.header":"Administrators","page.catalogues.tabCatalogue.cataloguePlaceInfo.title":"Location details","page.catalogues.tabCatalogue.cataloguePlaceInfo.name":"Name","page.catalogues.tabCatalogue.cataloguePlaceInfo.street":"Street address","page.catalogues.tabCatalogue.cataloguePlaceInfo.capacity":"Spots","page.catalogues.tabCatalogue.catalogueStatusInfo.title":"Snapshot","page.catalogues.tabCatalogue.catalogueStatusInfo.grantAmount":"Rights to be granted","page.catalogues.tabCatalogue.catalogueStatusInfo.grantedAmount":"Granted rights","page.catalogues.tabCatalogue.catalogueStatusInfo.costCenter":"Cost center","page.catalogues.tabCatalogue.catalogueStatusInfo.project":"Project","page.place.offeringsTab.header":"Rights","page.place.offeringsTab.infoText1":"The table shows offerings overview.","page.place.offeringsTab.table.empty":"Place has no offerings","page.place.offeringsTab.table.error":"Failed to load offerings.","page.place.offeringsTab.table.overview":"Overview","page.place.offeringsTab.table.timestamps":"Timestamps","page.place.offeringsTab.table.product":"Product","page.place.offeringsTab.table.catalogue.amount":"Rights granted:","page.place.offeringsTab.table.offering.edit":"Edit offering","page.place.actions.updated":"The location {name} has been updated.","page.place.modalEditPlace.title":"Edit location","page.placeRights.placeInformation.header":"Location Details","page.placeRights.placeInformation.button.edit":"Edit location","page.placeRights.placeInformation.address":"Address","page.placeRights.placeInformation.capacity":"Capacity","page.placeRights.placeInformation.offeringAmount":"Total rights","page.placeRights.situationOverview.header":"Situation Overview","page.placeRights.situationOverview.totalAmount":"Granted to customers","page.placeRights.situationOverview.parkingEnforcement":"Parking enforcement","page.customer.formSubPlace.title.location":"Location details","page.customer.formSubPlace.title.space":"Amount of parking spots","page.customer.formSubPlace.label.name":"Location name","page.customer.formSubPlace.label.spots":"Amount of spots","page.customer.formSubPlace.label.city":"City","page.customer.formSubPlace.label.postalCode":"Postal code","page.customer.formSubPlace.label.streetAddress":"Street address","page.customers.formCustomer.contentTitle":"Customer details","page.customers.formCustomer.label.name":"Customer name","page.customers.formCustomer.label.businessId":"Finnish business ID","page.customers.formCustomer.label.streetAddress":"Street address","page.customers.formCustomer.label.postalCode":"Postal code","page.customers.formCustomer.label.city":"City","page.customers.formCustomer.errors.businessId":"The field has to contain a valid Finnish business ID.","page.customers.customersInformation.name":"Name","page.customers.customersInformation.streetAddress":"Street address","page.customers.customersInformation.postalCodeAndCity":"Postal code and post office","page.customers.customersInformation.businessId":"Finnish business ID","page.customers.customersInformation.customerNumber":"Customer number","page.customers.tabAdministrators.infoText":"Add organisation admin.","page.customers.tabAdministrators.button.newAdminInvitation":"Add and invite admin","page.customers.tabAdministrators.actions.added":"New invitation {name} has been added.","page.customers.tabAdministrators.invitationsOngoing.link":"{count, plural, one {One waiting invitation.} other {{count} waiting invitations.}}","page.customers.tabAdministrators.tableAdministrators.header.name":"Name","page.customers.tabAdministrators.tableAdministrators.header.registeredIn":"Registered in","page.customers.tabAdministrators.tableAdministrators.button.remove":"Remove admin","page.customers.tabAdministrators.tableAdministrators.action.empty":"There are no other admins in this account.","page.customers.tabAdministrators.tableAdministrators.action.failed":"Failed to get admins.","page.customers.tabAdministrators.modalAdminInvitations.title":"Awaiting invitations","page.customers.tabAdministrators.modalRemove.header":"Remove admin?","page.customers.tabAdministrators.modalRemove.content":"Do you want to remove admin {name}?","page.customers.tabAdministrators.modalRemove.actions.removed":"Admin has been removed.","page.customer.actions.updated":"The customer {name} has been updated.","page.customer.title":"Organization details","page.customer.button.edit":"Edit customer","page.customer.modalEditCustomer.title":"Edit customer","page.customer.customerTabs.locations.header":"Locations","page.customer.customerTabs.admins.header":"Admins","page.offering.button.edit":"Edit offering","page.offering.cataloguesTab.table.error":"Failed to load catalogues","page.offering.cataloguesTab.header":"Catalogues","page.offering.cataloguesTab.infoText1":"The table shows the total number of permits issued for the location.","page.offering.cataloguesTab.infoText2":"You can issue permits to new customers by clicking on the \\"Create catalogue\\" button.","page.offering.cataloguesTab.createCatalogue":"Create catalogue","page.offering.cataloguesTab.table.catalogue.edit":"Edit catalogue","page.offering.cataloguesTab.table.name":"Name","page.offering.cataloguesTab.table.customer":"Customer","page.offering.cataloguesTab.table.overview":"Overview","page.offering.cataloguesTab.table.timestamps":"Timestamps","page.offering.cataloguesTab.table.empty":"There are no catalogues there.","page.offering.rightHoldersTab.header":"Search from catalogues","page.offering.rightHoldersTab.table.search.empty":"Please input search term","page.offering.rightHoldersTab.table.empty":"No right holders found","page.offering.rightHoldersTab.table.error":"Failed to load right holders","page.offering.rightHoldersTab.table.header.customer":"Customer","page.offering.offeringInfo.title":"Details","page.offering.offeringInfo.name":"Permit","page.offering.offeringInfo.location":"Location","page.offering.offeringInfo.catalogues.amount":"Granted permits for customers","page.offering.offeringInfo.maximumAmount":"Maximum permits","page.offering.offeringInfo.ignoreAmountLimits":"Unlimited","page.reports.title":"Reports","page.reports.type.radioGroup.title":"Choose report type","page.reports.type.radioGroup.landlord":"Catalogues","page.reports.type.radioGroup.tenant":"Rights","page.reports.customer.title":"Choose customer","page.reports.customer.label":"Customer","page.reports.customer.all":"All","page.reports.range.title":"Choose date range","page.reports.submit.button":"Download CSV report","page.reports.toast.error.emptyReport":"No report found by search criteria.","page.reports.toast.error.csvFailed":"Failed to generate report.","page.reports.daterange.start":"Start","page.reports.daterange.end":"End","page.users.title":"User","page.users.button.edit":"Edit user","page.users.label.user":"Logged user","page.users.label.emailConfirmed":"Email confirmed","page.users.modalChangePassword.title":"Update password","page.users.modalChangePassword.button.add":"Update","page.users.modalChangePassword.action.changed":"The password has been updated.","page.users.formPassword.errors.password":"New and confirmed passwords need to be the same.","page.users.formPassword.label.oldPassword":"Current password","page.users.formPassword.label.newPassword":"New password","page.users.formPassword.label.confirmNewPassword":"Confirm new password","moovyParkingEnforcementStatus.yes":"Enforced","moovyParkingEnforcementStatus.no":"Not enforced","timeStampItems.createdAt":"Created at:","timeStampItems.updatedAt":"Updated at:","page.offering.modalCreateCatalogue.title":"Create catalogue","page.offering.modalCreateCatalogue.grantedTo":"Who are rights granted to?","page.offering.modalCreateCatalogue.grantedTo.customer":"Customer","page.offering.modalCreateCatalogue.grantedTo.self":"Own company","page.offering.modalCreateCatalogue.customerLabel":"Customer information","page.offering.modalCreateCatalogue.customerName":"Organization name","page.offering.modalCreateCatalogue.businessId":"Business ID","page.offering.modalCreateCatalogue.project":"Project","page.offering.modalCreateCatalogue.costCenter":"Cost center","page.offering.modalCreateCatalogue.streetAddress":"Street address","page.offering.modalCreateCatalogue.postalCode":"Postal code","page.offering.modalCreateCatalogue.city":"City","page.offering.modalCreateCatalogue.offering":"Granted offering","page.offering.modalCreateCatalogue.catalogueName":"Catalogue name","page.offering.modalCreateCatalogue.name":"Name","page.offering.modalCreateCatalogue.amount":"Amount","page.offering.modalCreateCatalogue.amount.minimum":"Amount must be 0 or greater","page.offering.modalCreateCatalogue.allowVehicleGrant":"Allow to grant permission for vehicles","page.offering.modalCreateCatalogue.mutation.success":"Catalogue creation succeeded","page.offering.modalCreateCatalogue.mutation.conflict":"The number of granted rights cannot exceed the total number of rights for the product.","page.offering.modalEditOffering.title":"Edit offering","page.offering.modalEditOffering.product":"Product","page.offering.modalEditOffering.amountLabel":"Amount","page.offering.modalEditOffering.amount.minimum":"Amount must be 0 or greater","page.offering.modalEditOffering.mutation.success":"Offering update succeeded","page.offering.modalEditCatalogue.title":"Edit catalogue","page.offering.modalEditCatalogue.catalogueName":"Catalogue name","page.offering.modalEditCatalogue.customer":"Customer","page.offering.modalEditCatalogue.offering":"Granted offering","page.offering.modalEditCatalogue.amountLabel":"Amount of rights to grant","page.offering.modalEditCatalogue.amount.minimum":"Amount must be 0 or greater","page.offering.modalEditCatalogue.mutation.success":"Catalogue update succeeded","modalEditVehicle.title":"Edit the vehicle\'s parking right","modalEditVehicle.webshopWarning":"Parking right cannot be edited for webshop catalogues","modalEditVehicle.actions.change":"The vehicle license plate has been changed.","modalEditVehicle.actions.rightEnded":"The right has been terminated.","modalEditVehicle.actions.error.end":"Failed to terminate the right.","modalEditVehicle.modalRemove.header":"Terminate right?","modalEditVehicle.modalRemove.content":"Are you sure you want to terminate the right from the vehicle {licensePlate}?","modalEditVehicle.modalRemove.content.endReason":"Reason","modalEditVehicle.modalRemove.content.endReason.placeholder":"Reason for termination","moovySortAndFilter.sortingCriteria":"Sort","allocatedRights.available":"Available:","allocatedRights.rightsGranted":"Rights granted:","allocatedRights.rightsShared":"Rights shared:","allocatedRights.rightsTotal":"Total rights:","page.right.title":"Right","page.right.container.title":"Right information","page.right.start":"Start","page.right.end":"End","page.right.licensePlate":"License plate","page.right.place":"Place","page.right.catalogue":"Catalogue","page.right.individual":"Individual","page.right.costCenter":"Cost center","page.right.project":"Project","page.right.endReason":"End reason","page.right.active":"Active"}');


var $b93d046c1c5f0949$exports = {};
$b93d046c1c5f0949$exports = JSON.parse('{"common.yes":"kyll\xe4","common.no":"ei","common.ok":"ok","common.buttons.yes":"Kyll\xe4","common.buttons.add":"Lis\xe4\xe4","common.buttons.save":"Tallenna","common.buttons.edit":"Muokkaa","common.buttons.next":"Seuraava","common.buttons.complete":"Valmis","common.buttons.cancel":"Peruuta","common.buttons.remove":"Poista","common.buttons.update":"P\xe4ivit\xe4","common.buttons.terminate":"Irtisano","common.buttons.back":"Takaisin","common.buttons.clear":"Tyhjenn\xe4","common.actions.error":"Tapahtui virhe","common.actions.add.error":"Lis\xe4ys ep\xe4onnistui","common.actions.update.error":"P\xe4ivitys ep\xe4onnistui","common.actions.get.error":"Tietojen haku ep\xe4onnistui","common.actions.remove.error":"Poisto ep\xe4onnistui","common.form.errors.empty":"Kentt\xe4 ei voi olla tyhj\xe4.","common.form.errors.email":"Sy\xf6t\xe4 kelvollinen s\xe4hk\xf6postiosoite.","common.form.errors.phoneNumber":"Sy\xf6t\xe4 kelvollinen puhelinnumero maatunnuksella.","common.form.errors.licensePlate":"Sy\xf6t\xe4 kelvollinen ajoneuvon rekisteritunnus.","common.form.errors.businessId":"Sy\xf6t\xe4 kelvollinen Y-tunnus.","common.form.errors.number":"Kentt\xe4\xe4n voi sy\xf6tt\xe4\xe4 vain numeroita.","common.form.errors.invalidDateTime":"Sy\xf6t\xe4 kelvollinen p\xe4iv\xe4m\xe4\xe4r\xe4 sek\xe4 aika","common.text.licensePlate":"Rekisteritunnus","common.text.email":"S\xe4hk\xf6posti","common.text.project":"Projekti","common.text.costCenter":"Kustannuspaikka","common.text.validityStart":"Alkaa","common.text.validityEnd":"P\xe4\xe4ttyy","menu.invitations":"Kutsu asiakas","menu.allPlaces":"Kohdelistaus","menu.places":"Kohde & Luvat","menu.customer":"Omistajan tiedot","menu.reports":"Raportit","menu.user.detail":"Omat tiedot","menu.user.logout":"Kirjaudu ulos","menu.user.fi":"Suomeksi","menu.user.en":"Englanniksi","menu.subHeader.moovyAdmin":"Moovy Admin","appMenuTop.button.menu":"Valikko","appMenuTop.button.closeMenu":"Sulje menu","validation.code.NOT_EMPTY":"{field, plural, one {Kentt\xe4 ei voi olla tyhj\xe4.} other {{field}-kentt\xe4 ei voi olla tyhj\xe4.}}","validation.code.MAX_LENGTH":"{field, plural, one {Merkkej\xe4 on liikaa.} other {{field}-kent\xe4ss\xe4 on liikaa merkkej\xe4.}}","validation.code.MIN_LENGTH":"{field, plural, one {Sy\xf6tetty merkkim\xe4\xe4r\xe4 ei ole riitt\xe4v\xe4.} other {{field}-kent\xe4ss\xe4 ei ole riitt\xe4v\xe4sti merkkej\xe4.}}","validation.code.BUSINESS_ID_FORMAT":"{field, plural, one {Sy\xf6tteen muoto on virheellinen.} other {{field}-kent\xe4n sy\xf6te on virheellisess\xe4 muodossa.}}","validation.code.generic":"Tarkista sy\xf6tt\xe4m\xe4si arvot.","validation.field.name":"Nimi","validation.field.streetAddress":"Osoite","validation.field.city":"Kaupunki","validation.field.postalCode":"Postinumero","validation.field.businessId":"Y-tunnus","validation.field.costCenter":"Kustannuspaikka","validation.field.project":"Projekti","sort.PLACES.NAME":"Nimi","sort.PLACES.CITY":"Postitoimipaikka","sort.PLACES.CAPACITY":"Ruutujen m\xe4\xe4r\xe4","sort.PLACES.CUSTOMER_ID":"Asiakas","sort.INVITATIONS.NAME":"Nimi","sort.INVITATIONS.EMAIL":"S\xe4hk\xf6posti","sort.INVITATIONS.CREATED_AT":"Kutsuttu","sort.INVITATIONS.USED":"Rekister\xf6itynyt","sort.ACTIVE_RIGHTS.INDIVIDUAL":"Nimi","sort.ACTIVE_RIGHTS.VEHICLE":"Rekisteritunnus","sort.ACTIVE_RIGHTS.VALIDITY_START":"Voimassa alkaen","sort.ACTIVE_RIGHTS.VALIDITY_END":"P\xe4\xe4ttyy","sort.CATALOGUES.CUSTOMER_ID":"Asiakas","sort.CATALOGUES.CREATED_AT":"Luotu","sort.CATALOGUES.UPDATED_AT":"P\xe4ivitetty","sort.CATALOGUES.AMOUNT":"M\xe4\xe4r\xe4","api.error.code.OFFERING_AMOUNT_EXCEEDED_ERROR":"Tarjooman pit\xe4\xe4 olla v\xe4hint\xe4\xe4n jaettujen lupien m\xe4\xe4r\xe4.","api.error.code.CUSTOMER_ALREADY_EXISTS":"Samanniminen asiakas on jo j\xe4rjestelm\xe4ss\xe4.","api.error.code.INVITATION_ALREADY_EXISTS":"Kutsu on jo olemassa samalle henkil\xf6lle.","api.error.code.CATALOGUE_AMOUNT_EXCEEDED":"Lupam\xe4\xe4r\xe4 liian suuri. My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 ei saa ylitt\xe4\xe4 tuotteen lupien kokonaism\xe4\xe4r\xe4\xe4.","api.error.code.CATALOGUE_AMOUNT_TOO_SMALL":"Lupam\xe4\xe4r\xe4 liian pieni. My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 t\xe4ytyy olla v\xe4hint\xe4\xe4n sama kuin jaettujen lupien m\xe4\xe4r\xe4.","api.error.code.CATALOGUE_DOES_NOT_ALLOW_VEHICLE_GRANTING":"Lupasopimus ei salli lupien my\xf6nt\xe4mist\xe4 ajoneuvolle.","api.error.code.EMAIL_ALREADY_TAKEN":"S\xe4hk\xf6postiosoite on jo k\xe4yt\xf6ss\xe4.","api.error.code.TOO_MANY_CATALOGUES_IN_REPORT":"Raporttiin sis\xe4ltyy liian monta lupasopimusta. Vaihda hakukriteereit\xe4 ja yrit\xe4 uudelleen.","api.error.code.TOO_MANY_RIGHTS_IN_REPORT":"Raporttiin sis\xe4ltyy liian monta lupaa. Vaihda hakukriteereit\xe4 ja yrit\xe4 uudelleen.","api.error.code.RIGHT_HOLDER_EXCEEDS_CATALOGUE_AMOUNT":"Lupam\xe4\xe4r\xe4 liian suuri. My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 ei saa ylitt\xe4\xe4 lupasopimuksen lupien kokonaism\xe4\xe4r\xe4\xe4.","api.error.code.generic":"Tapahtui virhe","moovyErrorPage.oops":"Hups!","moovyErrorPage.message":"Pahoittelut, sivua ei voi ladata. Tarkista osoite ja yrit\xe4 ladata sivu uudestaan.","components.modalSubPlace.actions.error.added":"Asiakaskohteen lis\xe4ys ep\xe4onnistui","components.modalSubPlace.actions.added":"Asiakaskohteen lis\xe4ys onnistui","components.modalSubPlace.title":"Lis\xe4\xe4 asiakaskohde","components.modalSubPlace.button.add":"Lis\xe4\xe4 asiakaskohde","components.tableSubPlaces.header.name":"Nimi","components.tableSubPlaces.header.customer":"Asiakas","components.tableSubPlaces.header.streetAddress":"Postiosoite","components.tableSubPlaces.header.postalCode":"Postinumero","components.tableSubPlaces.header.city":"Postitoimipaikka","components.tableSubPlaces.header.capacity":"Ruutujen m\xe4\xe4r\xe4","components.tableSubPlaces.action.empty":"Kohteita ei ole","components.tableSubPlaces.action.failed":"Kohteiden haku ep\xe4onnistui","page.steps.bar.landlord.title":"Kohteen omistajan tiedot","page.steps.bar.landlord.description":"T\xe4yt\xe4 omistajan tiedot","page.steps.bar.place.title":"Kohteen tiedot","page.steps.bar.place.description":"T\xe4yt\xe4 kohteen tarvittavat tiedot","page.steps.landlord.title":"Kohteen omistajan tiedot","page.steps.landlord.info":"Perusta Moovyn organisaatiosi, sy\xf6tt\xe4m\xe4ll\xe4 vaaditut tiedot. Organisaatio ja sen edustajat ovat vastuussa luotavasta pys\xe4k\xf6intikohteesta.","page.steps.landlord.actions.added":"Uusi yritys {name} lis\xe4tty.","page.steps.place.title":"Kohteen tiedot","page.steps.place.info":"Ole hyv\xe4 ja t\xe4yt\xe4 kohteen perustiedot. Tiedot ovat pakollisia, sill\xe4 niit\xe4 k\xe4ytet\xe4\xe4n Moovyssa esimerkiksi pys\xe4k\xf6intilupien hallintaan. Voit my\xf6hemmin muuttaa ja t\xe4ydent\xe4\xe4 kohteen tietoja","page.steps.place.actions.added":"Uusi kohde {name} lis\xe4tty.","page.steps.noRights.header":"K\xe4ytt\xe4j\xe4tunnuksella ei ole hallinnointioikeuksia Lupapalvelun k\xe4ytt\xf6\xf6n","page.steps.noRights.content":"Lupapalvelun k\xe4ytt\xf6\xf6n tarvitset oikeuden hallinnoida kohteita.","page.invitations.modalAddInvitation.landlord.title":"Kutsu asiakas","page.invitations.modalAddInvitation.tenant.title":"Lis\xe4\xe4 ja kutsu hallinnoija","page.invitations.invitation.actions.updated":"Kutsulinkki {name} p\xe4ivitetty.","page.invitations.formInvitation.label.firstName":"Etunimi","page.invitations.formInvitation.label.lastName":"Sukunimi","page.invitations.list.button.landlord.newInvitation":"Kutsu asiakas","page.invitations.list.button.tenant.newInvitation":"Kutsu hallinnoija","page.invitations.list.button.remove":"Poista kutsu","page.invitations.list.title":"Kutsu uusia asiakkaita","page.invitations.list.actions.added":"Uusi kutsu {name} lis\xe4tty.","page.invitations.list.actions.removed":"Kutsu {name} poistettu.","page.invitations.list.table.header.name":"Nimi","page.invitations.list.table.header.invited":"Kutsuttu","page.invitations.list.table.header.registeredIn":"Rekister\xf6itynyt","page.invitations.list.table.action.empty":"Kutsulinkkej\xe4 ei ole","page.invitations.list.table.action.failed":"Kutsulinkkien haku ep\xe4onnistui","page.invitations.list.card.header.registeredIn":"Rekister\xf6itynyt","page.invitations.modalRemove.header":"Poista kutsu?","page.invitations.modalRemove.content":"Haluatko varmasti poistaa kutsun k\xe4ytt\xe4j\xe4lt\xe4 {name}?","page.catalogues.modalAddRightHolder.title":"Lis\xe4\xe4 luvanhaltija","page.catalogues.modalAddRightHolder.button.add":"Lis\xe4\xe4 luvanhaltija","page.catalogues.modalAddRightHolder.steps.bar.email":"S\xe4hk\xf6postiosoite","page.catalogues.modalAddRightHolder.steps.bar.rightHolder":"Luvanhaltijan tiedot","page.catalogues.modalAddVehicleRightHolder.title":"Lis\xe4\xe4 ajoneuvo","page.catalogues.tabCatalogue.formIndividualRightHolder.label.customerDetails":"Asiakkaan tiedot","page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName":"Etunimi","page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName":"Sukunimi","page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber":"Puhelinnumero","page.catalogues.tabCatalogue.formIndividualRightHolder.label.productDetails":"My\xf6nnett\xe4v\xe4 lupatuote","page.catalogues.tabCatalogue.formIndividualRightHolder.label.licensePlateDetails":"Ajoneuvon rekisteritunnus","page.catalogues.tabCatalogue.formIndividualRightHolder.label.validity":"Voimassaoloaika","page.catalogues.tabCatalogue.modalFindRightHolder.info":"Kirjoita s\xe4hk\xf6postiosoite luodaksesi uuden luvanhaltijan tai tarkistaaksesi l\xf6ytyyk\xf6 luvanhaltijalta jo Moovy-tili.","page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email":"S\xe4hk\xf6postiosoite","page.catalogues.tabCatalogue.modalFindRightHolder.actions.added":"Uusi luvanhaltija {name} lis\xe4tty.","page.catalogues.tabCatalogue.formVehicleRightHolder.label.vehicleDetails":"Ajoneuvon rekisteritunnus","page.catalogues.tabCatalogue.formVehicleRightHolder.label.validity":"Luvan voimassaoloaika","page.catalogues.tabCatalogue.title.rightHolder":"Luvanhaltijat","page.catalogues.tabCatalogue.search.label":"Hae luvanhaltijoita","page.catalogues.tabCatalogue.search.invalid":"Sy\xf6t\xe4 v\xe4hint\xe4\xe4n kolme merkki\xe4","page.catalogues.tabCatalogue.button.addIndividual":"Lis\xe4\xe4 luvanhaltija","page.catalogues.tabCatalogue.button.addVehicle":"Lis\xe4\xe4 ajoneuvo","page.catalogues.tabCatalogue.rightHolders.card.header.place":"Kohde","page.catalogues.tabCatalogue.rightHolders.card.header.validUntil":"P\xe4\xe4ttyy","page.catalogues.tabCatalogue.rightHolders.table.header.name":"Nimi","page.catalogues.tabCatalogue.rightHolders.table.header.place":"Kohde","page.catalogues.tabCatalogue.rightHolders.table.header.validFrom":"Voimassa alkaen","page.catalogues.tabCatalogue.rightHolders.table.header.validUntil":"P\xe4\xe4ttyy","page.catalogues.tabCatalogue.rightHolders.table.action.empty":"Luvanhaltijoita ei ole","page.catalogues.tabCatalogue.rightHolders.table.action.failed":"Luvanhaltijoiden haku ep\xe4onnistui","page.rightHolders.rightHolder.title":"Luvanhaltijan tiedot","page.rightHolders.rightHolder.button.edit":"Muokkaa luvanhaltijaa","page.rightHolders.rightHolder.modalEditRightHolder.title.individual":"Muokkaa luvanhaltijaa","page.rightHolders.rightHolder.modalEditRightHolder.title.vehicle":"Muokkaa rekisteritunnusta","page.rightHolders.rightHolder.modalEditRightHolder.actions.update":"Luvanhaltija {name} p\xe4ivitetty.","page.rightHolders.rightHolder.formEditRightHolder.label.firstName":"Etunimi","page.rightHolders.rightHolder.formEditRightHolder.label.lastName":"Sukunimi","page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber":"Puhelinnumero","page.rightHolders.rightHolder.formEditRightHolder.info.product":"K\xe4ytt\xe4j\xe4lle lis\xe4t\xe4\xe4n automaattisesti pys\xe4k\xf6intilupa:","page.rightHolders.rightHolder.tab.rightsAndVehicles.title":"Ajoneuvot ja luvat","page.rightHolders.rightHolder.tab.vehicles.table.header.createdAt":"Luotu","page.rightHolders.rightHolder.tab.vehicles.table.header.right":"Lupa","page.rightHolders.rightHolder.tab.vehicles.table.header.place":"Kohde","page.rightHolders.rightHolder.tab.vehicles.table.header.validFrom":"Voimassa alkaen","page.rightHolders.rightHolder.tab.vehicles.table.header.validUntil":"P\xe4\xe4ttyy","page.rightHolders.rightHolder.tab.vehicles.table.item.permanent":"Toistaiseksi","page.rightHolders.rightHolder.tab.vehicles.table.action.empty":"Ajoneuvoja ei ole","page.rightHolders.rightHolder.tab.vehicles.table.action.failed":"Ajoneuvojen haku ep\xe4onnistui.","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.location":"Kohde:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.right":"Lupa:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.startRight":"Alkaen:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.endRight":"P\xe4\xe4ttyy:","page.places.modalAddPlace.title":"Lis\xe4\xe4 kohde","page.places.modalAddPlace.button.add":"Lis\xe4\xe4 kohde","page.places.formPlace.contentTitle":"Kohteen tiedot","page.places.formPlace.label.customer":"Asiakas","page.places.formPlace.label.name":"Nimi","page.places.formPlace.label.streetAddress":"Postiosoite","page.places.formPlace.label.postalCode":"Postinumero","page.places.formPlace.label.city":"Postitoimipaikka","page.places.formPlace.label.capacity":"Ruutujen m\xe4\xe4r\xe4","page.places.list.button.newPlace":"Uusi kohde","page.places.list.title":"Kohteet","page.places.list.actions.added":"Uusi kohde {name} lis\xe4tty.","page.places.list.table.header.name":"Nimi","page.places.list.table.header.streetAddress":"Postiosoite","page.places.list.table.header.postalCode":"Postinumero","page.places.list.table.header.city":"Postitoimipaikka","page.places.list.table.header.capacity":"Ruutujen m\xe4\xe4r\xe4","page.places.list.table.header.customer":"Asiakas","page.places.list.table.action.empty":"Kohteita ei ole","page.places.list.table.action.failed":"Kohteiden haku ep\xe4onnistui","page.places.catalogueTabs.catalogue.header":"Luvat","page.places.catalogueTabs.invitations.header":"Kutsut","page.places.catalogueTabs.administrators.header":"Hallinnoijat","page.catalogues.tabCatalogue.cataloguePlaceInfo.title":"Kohteen tiedot","page.catalogues.tabCatalogue.cataloguePlaceInfo.name":"Nimi","page.catalogues.tabCatalogue.cataloguePlaceInfo.street":"Osoite","page.catalogues.tabCatalogue.cataloguePlaceInfo.capacity":"Ruudut","page.catalogues.tabCatalogue.catalogueStatusInfo.title":"Tilannekuva","page.catalogues.tabCatalogue.catalogueStatusInfo.grantAmount":"Jaettavien lupien m\xe4\xe4r\xe4","page.catalogues.tabCatalogue.catalogueStatusInfo.grantedAmount":"Lupia jaettu","page.catalogues.tabCatalogue.catalogueStatusInfo.costCenter":"Kustannuspaikka","page.catalogues.tabCatalogue.catalogueStatusInfo.project":"Projekti","page.place.offeringsTab.header":"Luvat","page.place.offeringsTab.infoText1":"Taulukosta n\xe4et kohteen lupien kokonaiskuvan.","page.place.offeringsTab.table.empty":"Kohteella ei ole tarjoomaa","page.place.offeringsTab.table.error":"Lupasopimusten lataamisessa tapahtui virhe.","page.place.offeringsTab.table.overview":"Tilannekuva","page.place.offeringsTab.table.timestamps":"Aikaleimat","page.place.offeringsTab.table.product":"Tuote","page.place.offeringsTab.table.catalogue.amount":"Lupia my\xf6nnetty:","page.place.offeringsTab.table.offering.edit":"Muokkaa tarjoomaa","page.place.actions.updated":"Kohde {name} p\xe4ivitetty.","page.place.modalEditPlace.title":"Muokkaa kohdetta","page.placeRights.placeInformation.header":"Kohteen tiedot","page.placeRights.placeInformation.button.edit":"Muokkaa kohdetta","page.placeRights.placeInformation.address":"Osoite","page.placeRights.placeInformation.capacity":"Ruutujen m\xe4\xe4r\xe4","page.placeRights.placeInformation.offeringAmount":"Lupia yhteens\xe4","page.placeRights.situationOverview.header":"Tilannekuva","page.placeRights.situationOverview.totalAmount":"Asiakkaille my\xf6nnetyt luvat","page.placeRights.situationOverview.parkingEnforcement":"Pys\xe4k\xf6inninvalvonta","page.customer.formSubPlace.title.location":"Kohteen tiedot","page.customer.formSubPlace.title.space":"My\xf6nnett\xe4vien pys\xe4k\xf6intiruutujen m\xe4\xe4r\xe4","page.customer.formSubPlace.label.name":"Kohteen nimi","page.customer.formSubPlace.label.spots":"Ruutujen m\xe4\xe4r\xe4","page.customer.formSubPlace.label.city":"Postitoimipaikka","page.customer.formSubPlace.label.postalCode":"Postinumero","page.customer.formSubPlace.label.streetAddress":"Postiosoite","page.customers.formCustomer.contentTitle":"Asiakkaan tiedot","page.customers.formCustomer.label.name":"Organisaation nimi","page.customers.formCustomer.label.businessId":"Y-tunnus","page.customers.formCustomer.label.streetAddress":"Postiosoite","page.customers.formCustomer.label.postalCode":"Postinumero","page.customers.formCustomer.label.city":"Postitoimipaikka","page.customers.formCustomer.errors.businessId":"Kent\xe4n t\xe4ytyy sis\xe4lt\xe4\xe4 oikea Y-tunnus.","page.customers.customersInformation.name":"Nimi","page.customers.customersInformation.streetAddress":"Osoite","page.customers.customersInformation.postalCodeAndCity":"Postinumero ja -toimipaikka","page.customers.customersInformation.businessId":"Y-tunnus","page.customers.customersInformation.customerNumber":"Asiakasnumero","page.customers.tabAdministrators.infoText":"Lis\xe4\xe4 organisaation hallinnoija.","page.customers.tabAdministrators.button.newAdminInvitation":"Lis\xe4\xe4 ja kutsu hallinnoija","page.customers.tabAdministrators.actions.added":"Uusi kutsu {name} lis\xe4tty.","page.customers.tabAdministrators.invitationsOngoing.link":"{count, plural, one {Yksi odottava kutsu.} other {{count} odottavaa kutsua.}}","page.customers.tabAdministrators.tableAdministrators.header.name":"Nimi","page.customers.tabAdministrators.tableAdministrators.header.registeredIn":"Rekister\xf6itynyt","page.customers.tabAdministrators.tableAdministrators.button.remove":"Poista hallinnoija","page.customers.tabAdministrators.tableAdministrators.action.empty":"Tilill\xe4 ei ole muita hallinnoijia.","page.customers.tabAdministrators.tableAdministrators.action.failed":"Tilin hallinnoijien haku ep\xe4onnistui.","page.customers.tabAdministrators.modalAdminInvitations.title":"Odottavat kutsut","page.customers.tabAdministrators.modalRemove.header":"Poista hallinnoija?","page.customers.tabAdministrators.modalRemove.content":"Haluatko poistaa hallinnoijan {name}?","page.customers.tabAdministrators.modalRemove.actions.removed":"Hallinnoija poistettu.","page.customer.actions.updated":"Asiakas {name} p\xe4ivitetty.","page.customer.title":"Organisaation tiedot","page.customer.button.edit":"Muokkaa asiakasta","page.customer.modalEditCustomer.title":"Muokkaa asiakasta","page.customer.customerTabs.locations.header":"Kohteet","page.customer.customerTabs.admins.header":"Hallinnoijat","page.offering.button.edit":"Muokkaa lupaa","page.offering.cataloguesTab.table.error":"Katalogien lataamisessa tapahtui virhe","page.offering.cataloguesTab.header":"Lupasopimukset","page.offering.cataloguesTab.infoText1":"Taulukosta n\xe4et kohteen lupien kokonaiskuvan my\xf6nnettyjen lupien osalta.","page.offering.cataloguesTab.infoText2":"Voit my\xf6nt\xe4\xe4 lupia uusille asiakkaille painikkeesta \\"Luo lupasopimus\\".","page.offering.cataloguesTab.createCatalogue":"Luo lupasopimus","page.offering.cataloguesTab.table.catalogue.edit":"Muokkaa sopimusta","page.offering.cataloguesTab.table.name":"Nimi","page.offering.cataloguesTab.table.customer":"Asiakas","page.offering.cataloguesTab.table.overview":"Tilannekuva","page.offering.cataloguesTab.table.timestamps":"Aikaleimat","page.offering.cataloguesTab.table.empty":"Lupasopimuksia ei ole.","page.offering.rightHoldersTab.header":"Hae lupasopimuksista","page.offering.rightHoldersTab.table.search.empty":"Sy\xf6t\xe4 ensin hakuehto","page.offering.rightHoldersTab.table.empty":"Ei tuloksia","page.offering.rightHoldersTab.table.error":"Lupien haku ep\xe4onnistui","page.offering.rightHoldersTab.table.header.customer":"Asiakas","page.offering.offeringInfo.title":"Luvan tiedot","page.offering.offeringInfo.name":"Lupa","page.offering.offeringInfo.location":"Kohde","page.offering.offeringInfo.catalogues.amount":"Asiakkaille my\xf6nnetyt luvat","page.offering.offeringInfo.maximumAmount":"Lupien maksimim\xe4\xe4r\xe4","page.offering.offeringInfo.ignoreAmountLimits":"Rajoittamaton","page.reports.title":"Raportit","page.reports.type.radioGroup.title":"Valitse raporttityyppi","page.reports.type.radioGroup.landlord":"Lupasopimukset","page.reports.type.radioGroup.tenant":"Luvat","page.reports.customer.title":"Valitse asiakas","page.reports.customer.label":"Asiakas","page.reports.customer.all":"Kaikki","page.reports.range.title":"Valitse aikav\xe4li","page.reports.submit.button":"Lataa CSV-raportti","page.reports.toast.error.emptyReport":"Raporttia ei l\xf6ydy valituilla hakuehdoilla.","page.reports.toast.error.csvFailed":"Raportin muodostus ep\xe4onnistui.","page.reports.daterange.start":"Alku","page.reports.daterange.end":"Loppu","page.users.title":"K\xe4ytt\xe4j\xe4","page.users.button.edit":"Muokkaa k\xe4ytt\xe4j\xe4\xe4","page.users.label.user":"Kirjautunut k\xe4ytt\xe4j\xe4","page.users.label.emailConfirmed":"S\xe4hk\xf6posti vahvistettu","page.users.modalChangePassword.title":"Vaihda salasana","page.users.modalChangePassword.button.add":"Vaihda","page.users.modalChangePassword.action.changed":"Salasana vaihdettu.","page.users.formPassword.errors.password":"Uusi ja vahvistettu salasana pit\xe4\xe4 olla sama.","page.users.formPassword.label.oldPassword":"Nykyinen salasana","page.users.formPassword.label.newPassword":"Uusi salasana","page.users.formPassword.label.confirmNewPassword":"Vahvista uusi salasana","moovyParkingEnforcementStatus.no":"Ei valvontaa","moovyParkingEnforcementStatus.yes":"Valvonnan piiriss\xe4","timeStampItems.createdAt":"Luotu:","timeStampItems.updatedAt":"P\xe4ivitetty:","page.offering.modalCreateCatalogue.title":"Luo lupasopimus","page.offering.modalCreateCatalogue.grantedTo":"Kenelle luvat my\xf6nnet\xe4\xe4n?","page.offering.modalCreateCatalogue.grantedTo.customer":"Asiakkaalle","page.offering.modalCreateCatalogue.grantedTo.self":"Omalle yritykselle","page.offering.modalCreateCatalogue.customerLabel":"Asiakkaan tiedot","page.offering.modalCreateCatalogue.customerName":"Organisaation nimi","page.offering.modalCreateCatalogue.businessId":"Y-tunnus","page.offering.modalCreateCatalogue.project":"Projekti","page.offering.modalCreateCatalogue.costCenter":"Kustannuspaikka","page.offering.modalCreateCatalogue.streetAddress":"Postiosoite","page.offering.modalCreateCatalogue.postalCode":"Postinumero","page.offering.modalCreateCatalogue.city":"Postitoimipaikka","page.offering.modalCreateCatalogue.offering":"My\xf6nnett\xe4v\xe4 lupatuote","page.offering.modalCreateCatalogue.catalogueName":"Lupasopimuksen nimi","page.offering.modalCreateCatalogue.name":"Nimi","page.offering.modalCreateCatalogue.amount":"M\xe4\xe4r\xe4","page.offering.modalCreateCatalogue.amount.minimum":"Arvon on oltava 0 tai suurempi","page.offering.modalCreateCatalogue.allowVehicleGrant":"Salli luvan my\xf6nt\xe4minen ajoneuvoille","page.offering.modalCreateCatalogue.mutation.success":"Lupasopimuksen lis\xe4ys onnistui","page.offering.modalCreateCatalogue.mutation.conflict":"My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 ei voi ylitt\xe4\xe4 tuotteen kokonaislupam\xe4\xe4r\xe4\xe4.","page.offering.modalEditOffering.title":"Muokkaa tarjoomaa","page.offering.modalEditOffering.product":"Tuote","page.offering.modalEditOffering.amountLabel":"Tarjooma yhteens\xe4","page.offering.modalEditOffering.amount.minimum":"Arvon on oltava 0 tai suurempi","page.offering.modalEditOffering.mutation.success":"Tarjooman p\xe4ivitys onnistui","page.offering.modalEditCatalogue.title":"Muokkaa sopimusta","page.offering.modalEditCatalogue.catalogueName":"Lupasopimuksen nimi","page.offering.modalEditCatalogue.customer":"Asiakas","page.offering.modalEditCatalogue.offering":"My\xf6nnett\xe4v\xe4 lupatuote","page.offering.modalEditCatalogue.amountLabel":"My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4","page.offering.modalEditCatalogue.amount.minimum":"Arvon on oltava 0 tai suurempi","page.offering.modalEditCatalogue.mutation.success":"Sopimuksen p\xe4ivitys onnistui","modalEditVehicle.title":"Muokkaa luvan ajoneuvoa","modalEditVehicle.webshopWarning":"Verkkokauppasopimuksen lupaa ei voi muokata","modalEditVehicle.actions.change":"Ajoneuvon rekisteritunnus vaihdettu","modalEditVehicle.actions.rightEnded":"Lupa irtisanottu","modalEditVehicle.actions.error.end":"Irtisanominen ep\xe4onnistui","modalEditVehicle.modalRemove.header":"Irtisano lupa?","modalEditVehicle.modalRemove.content":"Haluatko varmasti irtisanoa luvan ajoneuvolta {licensePlate}?","modalEditVehicle.modalRemove.content.endReason":"Kommentti","modalEditVehicle.modalRemove.content.endReason.placeholder":"Kommentti irtisanomisen syyst\xe4","moovySortAndFilter.sortingCriteria":"Lajittele","allocatedRights.available":"My\xf6nnett\xe4viss\xe4:","allocatedRights.rightsGranted":"Lupia my\xf6nnetty:","allocatedRights.rightsShared":"Lupia jaettu:","allocatedRights.rightsTotal":"Lupia yhteens\xe4:","page.right.title":"Pys\xe4k\xf6intilupa","page.right.container.title":"Luvan tiedot","page.right.start":"Alkoi","page.right.end":"P\xe4\xe4ttyi","page.right.licensePlate":"Rekisteritunnus","page.right.place":"Kohde","page.right.catalogue":"Lupasopimus","page.right.individual":"Luvanhaltija","page.right.costCenter":"Kustannuspaikka","page.right.project":"Projekti","page.right.endReason":"Irtisanomisen kommentti","page.right.active":"Aktiivinen"}');


var $905cfe57ac473b61$exports = {};
$905cfe57ac473b61$exports = JSON.parse('{"Account recovery requires verified contact information":"Account recovery requires verified contact information","Add your Profile":"Add your Profile","Add your Website":"Add your Website","Back to Sign In":"Back to Sign In","Change Password":"Change Password","Changing":"Changing","Code":"Code","Confirm Password":"Confirm Password","Confirm Sign Up":"Confirm Sign Up","Confirm SMS Code":"Confirm SMS Code","Confirm TOTP Code":"Confirm TOTP Code","Confirm":"Confirm","Confirmation Code":"Confirmation Code","Confirming":"Confirming","Create a new account":"Create a new account","Create Account":"Create Account","Creating Account":"Creating Account","Dismiss alert":"Dismiss alert","Given Name":"First Name","Family Name":"Last Name","Name":"Name","Email":"Email","Enter your Birthdate":"Enter your Birthdate","Enter your code":"Enter your code","Enter your Confirmation Code":"Enter your Confirmation Code","Enter your Email":"Enter your Email","Enter your Family Name":"Enter your Family Name","Enter your Given Name":"Enter your Given Name","Enter your Middle Name":"Enter your Middle Name","Enter your Name":"Enter your Name","Enter your Nickname":"Enter your Nickname","Enter your Password":"Enter your Password","Enter your phone number":"Enter your phone number","Enter your Preferred Username":"Enter your Preferred Username","Enter your username":"Enter your username","Forgot password?":"Forgot password?","Forgot your password?":"Forgot your password?","Hide password":"Hide password","It may take a minute to arrive":"It may take a minute to arrive","Loading":"Loading","New password":"New password","New Password":"New Password","or":"or","Password":"Password","Phone Number":"Phone Number","Please confirm your Password":"Please confirm your Password","Resend Code":"Resend Code","Reset your password":"Reset your password","Reset your Password":"Reset your Password","Reset Password":"Reset password","Enter your email":"Enter your email","Code *":"Code *","Send code":"Send code","Send Code":"Send Code","Sending":"Sending","Setup TOTP":"Setup TOTP","Show password":"Show password","Sign in to your account":"Sign in to your account","Sign In with Amazon":"Sign In with Amazon","Sign In with Apple":"Sign In with Apple","Sign In with Facebook":"Sign In with Facebook","Sign In with Google":"Sign In with Google","Sign in":"Sign in","Sign In":"Sign in","Signing in":"Signing in","Skip":"Skip","Submit":"Submit","Submitting":"Submitting","Username":"Username","Verify Contact":"Verify Contact","Verify":"Verify","We Emailed You":"We Emailed You","We Sent A Code":"We Sent A Code","We Texted You":"We Texted You","Your code is on the way. To log in, enter the code we emailed to":"Your code is on the way. To log in, enter the code we emailed to","Your code is on the way. To log in, enter the code we sent you":"Your code is on the way. To log in, enter the code we sent you","Your code is on the way. To log in, enter the code we texted to":"Your code is on the way. To log in, enter the code we texted to","User does not exist.":"User does not exist.","Incorrect username or password.":"Incorrect username or password.","Your passwords must match":"Your passwords must match.","Password must have at least 8 characters":"Password must have at least 8 characters.","An account with the given email already exists.":"An account with the given email already exists.","Invalid verification code provided, please try again.":"Invalid verification code provided, please try again.","Password does not conform to policy: Password must have uppercase characters":"Password does not conform to policy: Password must have uppercase characters.","Attempt limit exceeded, please try after some time.":"Attempt limit exceeded, please try after some time.","Username/client id combination not found.":"Username or password is invalid."}');


var $4f92fe4a94069444$exports = {};
$4f92fe4a94069444$exports = JSON.parse('{"Account recovery requires verified contact information":"Tilin palauttaminen vaatii vahvistetut yhteystiedot","Add your Profile":"Lis\xe4\xe4 profiili","Add your Website":"Lis\xe4\xe4 www-sivu","Back to Sign In":"Takaisin kirjautumiseen","Change Password":"Vaihda salasana","Changing":"Vaihdetaan","Code":"Koodi","Confirm Password":"Vahvista salasana","Confirm Sign Up":"Vahvista tilin luonti","Confirm SMS Code":"Vahvista SMS -koodi","Confirm TOTP Code":"Vahvista TOTP -koodi","Confirm":"Vahvista","Confirmation Code":"Vahvistuskoodi","Confirming":"Vahvistetaan","Create a new account":"Luo uusi tili","Create Account":"Luo tili","Creating Account":"Tili\xe4 luodaan","Dismiss alert":"Hylk\xe4\xe4 ilmoitukset","Given Name":"Etunimi","Family Name":"Sukunimi","Name":"Nimi","Email":"S\xe4hk\xf6posti","Enter your Birthdate":"Sy\xf6t\xe4 syntym\xe4p\xe4iv\xe4","Enter your code":"Sy\xf6t\xe4 koodi","Enter your Confirmation Code":"Sy\xf6t\xe4 vahvistuskoodi","Enter your Email":"Sy\xf6t\xe4 s\xe4hk\xf6posti","Enter your Family Name":"Sy\xf6t\xe4 sukunimi","Enter your Given Name":"Sy\xf6t\xe4 nimi","Enter your Middle Name":"Sy\xf6t\xe4 toinen nimi","Enter your Name":"Sy\xf6t\xe4 nimi","Enter your Nickname":"Sy\xf6t\xe4 lempinimi","Enter your Password":"Sy\xf6t\xe4 salasana","Enter your phone number":"Sy\xf6t\xe4 puhelinnumero","Enter your Preferred Username":"Sy\xf6t\xe4 ensisijainen k\xe4ytt\xe4j\xe4nimi","Enter your username":"Sy\xf6t\xe4 k\xe4ytt\xe4j\xe4nimi","Forgot password?":"Unohtuiko salasana?","Forgot your password?":"Unohtuiko salasana?","Hide password":"Piilota salasana","It may take a minute to arrive":"Saapuminen voi kest\xe4\xe4 minuutin","Loading":"Ladataan","New password":"Uusi salasana","New Password":"Uusi salasana","or":"tai","Password":"Salasana","Phone Number":"Puhelinnumero","Please confirm your Password":"Vahvista salasana","Resend Code":"L\xe4het\xe4 koodi uudestaan","Reset your password":"Nollaa salasana","Reset your Password":"Nollaa salasana","Reset Password":"Nollaa salasana","Enter your email":"Sy\xf6t\xe4 s\xe4hk\xf6postiosoite","Code *":"Koodi *","Send code":"L\xe4het\xe4 koodi","Send Code":"L\xe4het\xe4 koodi","Sending":"L\xe4hetet\xe4\xe4n","Setup TOTP":"Aseta TOTP","Show password":"N\xe4yt\xe4 salasana","Sign in to your account":"Kirjaudu tiliin","Sign In with Amazon":"Kirjaudu Amazon -tilill\xe4","Sign In with Apple":"Kirjaudu Apple -tilill\xe4","Sign In with Facebook":"Kirjaudu Facebook -tilill\xe4","Sign In with Google":"Kirjaudu Google -tilill\xe4","Sign in":"Kirjaudu sis\xe4\xe4n","Sign In":"Kirjaudu sis\xe4\xe4n","Signing in":"Kirjaudutaan sis\xe4\xe4n","Skip":"Ohita","Submit":"Hyv\xe4ksy","Submitting":"Hyv\xe4ksyt\xe4\xe4n","Username":"K\xe4ytt\xe4j\xe4nimi","Verify Contact":"Vahvista yhteystieto","Verify":"Vahvista","We Emailed You":"L\xe4hetimme sinulle s\xe4hk\xf6postia","We Sent A Code":"L\xe4hetimme sinulle koodin","We Texted You":"L\xe4hetimme sinulle viestin","Your code is on the way. To log in, enter the code we emailed to":"Koodisi on matkalla sinulle. Kirjaudu sis\xe4\xe4n s\xe4hk\xf6postiisi l\xe4hetetyll\xe4 koodilla","Your code is on the way. To log in, enter the code we sent you":"Koodisi on matkalla sinulle. Kirjaudu sis\xe4\xe4n sinulle l\xe4hetetyll\xe4 koodilla","Your code is on the way. To log in, enter the code we texted to":"Koodisi on matkalla sinulle. Kirjaudu sis\xe4\xe4n sinulle l\xe4hetetyll\xe4 koodilla","User does not exist.":"K\xe4ytt\xe4j\xe4\xe4 ei ole olemassa.","Incorrect username or password.":"Virheellinen k\xe4ytt\xe4j\xe4nimi tai salasana.","Your passwords must match":"Salasanojen pit\xe4\xe4 olla samoja.","Password must have at least 8 characters":"Salasanassa pit\xe4\xe4 olla v\xe4hint\xe4\xe4n 8 merkki\xe4.","An account with the given email already exists.":"Samalla s\xe4hk\xf6postilla on jo tili olemassa.","Invalid verification code provided, please try again.":"Virheellinen vahvistuskoodi, yrit\xe4 uudelleen.","Password does not conform to policy: Password must have uppercase characters":"Salasana ei t\xe4yt\xe4 vaatimuksia. Salasanassa on oltava erikoismerkkej\xe4.","Attempt limit exceeded, please try after some time.":"Maksimim\xe4\xe4r\xe4 yrityksi\xe4 saavutettu, yrit\xe4 uudelleen hetken kuluttua.","Username/client id combination not found.":"K\xe4ytt\xe4j\xe4nimi tai salasana on virheellinen."}');


const $d30a5fdc49293dc0$export$bc99aaabaf7b70a7 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($7132ad9939508af6$exports)))
    },
    fi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($b93d046c1c5f0949$exports)))
    }
};
const $d30a5fdc49293dc0$export$d2223424998443a9 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($905cfe57ac473b61$exports)))
    },
    fi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($4f92fe4a94069444$exports)))
    }
};
const $d30a5fdc49293dc0$var$localizationResources = {
    resources: $d30a5fdc49293dc0$export$bc99aaabaf7b70a7,
    loginResources: $d30a5fdc49293dc0$export$d2223424998443a9
};
var $d30a5fdc49293dc0$export$2e2bcd8739ae039 = $d30a5fdc49293dc0$var$localizationResources;


const $086351014303c4b8$export$864b6a9fa5df87b6 = "moovyLocale";
const $086351014303c4b8$export$cb43794bb023e720 = "moovyAuthToken";
const $086351014303c4b8$export$85978fd627e990d0 = "moovyType";
const $086351014303c4b8$export$464bac997a211baf = "moovyCustomerInit";
const $086351014303c4b8$export$fbb0f21f223dce54 = "moovyCustomerId";
const $086351014303c4b8$export$ad6b2753bfb86074 = "moovyCustomerName";
const $086351014303c4b8$export$7590792a37b51514 = "moovyPlaceId";
const $086351014303c4b8$export$fa52eabe6f966a70 = "moovyPlaceName";
const $086351014303c4b8$export$738e7ce102bdae66 = "moovyCatalogueId";


// Use same localStorage key as Redux to ensure consistent initialization
const $2e2f998e72251dab$var$storedLocale = localStorage.getItem((0, $086351014303c4b8$export$864b6a9fa5df87b6)) || "fi";
(0, $0f0149b7a0f9f5b2$export$2e2bcd8739ae039).use((0, $9a01e7501dac985c$export$ae7e14d40d89f296)).init({
    debug: false,
    lng: $2e2f998e72251dab$var$storedLocale,
    fallbackLng: "fi",
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    },
    resources: $d30a5fdc49293dc0$export$bc99aaabaf7b70a7
});
var $2e2f998e72251dab$export$2e2bcd8739ae039 = (0, $0f0149b7a0f9f5b2$export$2e2bcd8739ae039);


function $f94f9cce0c4db259$export$b007d77a962aa175({ expiresAt: expiresAt, clockDrift: clockDrift }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $f94f9cce0c4db259$export$eeff9d1a8b8c057b {
    constructor(){}
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    async fetchAuthSession(options = {}) {
        let tokens;
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        if (this.authOptions?.credentialsProvider) return await this.authOptions.credentialsProvider.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $280ea0d75c530720$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
})($280ea0d75c530720$export$a0472aa3a356446c || ($280ea0d75c530720$export$a0472aa3a356446c = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $7362059d750d76ac$export$13470c6f1642bbce = "Logging";
const $7362059d750d76ac$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $7362059d750d76ac$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5a5ccf3b282369bb$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ class $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $280ea0d75c530720$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let logger_level_name = this.level;
        if ($5a5ccf3b282369bb$export$ba6a9c7ac8291f7f.LOG_LEVEL) logger_level_name = $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        const logger_level = $5a5ccf3b282369bb$var$LOG_LEVELS[logger_level_name];
        const type_level = $5a5ccf3b282369bb$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $280ea0d75c530720$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $280ea0d75c530720$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $280ea0d75c530720$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $280ea0d75c530720$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $280ea0d75c530720$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $280ea0d75c530720$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $280ea0d75c530720$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $280ea0d75c530720$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $7362059d750d76ac$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$5a5ccf3b282369bb$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $3caf5c41ef04ef89$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message, name: name, recoverySuggestion: recoverySuggestion, underlyingError: underlyingError }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $3caf5c41ef04ef89$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $3caf5c41ef04ef89$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b47473e783336341$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $b47473e783336341$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("Hub");
class $b47473e783336341$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $b47473e783336341$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $b47473e783336341$export$aadf71dd9875dd20;
            if (!hasAccess) $b47473e783336341$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $b47473e783336341$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $3caf5c41ef04ef89$export$37321a6dace1881c)({
            name: (0, $7362059d750d76ac$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel, payload: payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $b47473e783336341$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $b47473e783336341$var$logger.error(e);
            }
        });
    }
}
/*We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events.*/ const $b47473e783336341$export$8c41bb232f1008b1 = new $b47473e783336341$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $b47473e783336341$export$45dde0743a4c8d6e = new $b47473e783336341$export$6b38ef2be9abbbb9("internal-hub");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0b5a421e5a4a21d9$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $0b5a421e5a4a21d9$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    LAMBDA: "lambda"
};
/**
 * This utility converts the `aws-exports.js` file generated by the Amplify CLI into a {@link ResourcesConfig} object
 * consumable by Amplify.
 *
 * @param config A configuration object from `aws-exports.js`.
 *
 * @returns A {@link ResourcesConfig} object.
 */ const $0b5a421e5a4a21d9$export$1ef2e9c2da492d = (config = {})=>{
    const { aws_appsync_apiKey: aws_appsync_apiKey, aws_appsync_authenticationType: aws_appsync_authenticationType, aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint, aws_appsync_region: aws_appsync_region, aws_bots: aws_bots, aws_bots_config: aws_bots_config, aws_cognito_identity_pool_id: aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration: aws_cognito_mfa_configuration, aws_cognito_mfa_types: aws_cognito_mfa_types, aws_cognito_password_protection_settings: aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms, aws_cognito_signup_attributes: aws_cognito_signup_attributes, aws_cognito_social_providers: aws_cognito_social_providers, aws_cognito_username_attributes: aws_cognito_username_attributes, aws_mandatory_sign_in: aws_mandatory_sign_in, aws_mobile_analytics_app_id: aws_mobile_analytics_app_id, aws_mobile_analytics_app_region: aws_mobile_analytics_app_region, aws_user_files_s3_bucket: aws_user_files_s3_bucket, aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id: aws_user_pools_id, aws_user_pools_web_client_id: aws_user_pools_web_client_id, geo: geo, oauth: oauth, predictions: predictions, aws_cloud_logic_custom: aws_cloud_logic_custom, Notifications: Notifications, modelIntrospection: modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging, Push: Push } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId, region: region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId, region: region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $0b5a421e5a4a21d9$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $0b5a421e5a4a21d9$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributesConfig = mergedUserAttributes.map((s)=>({
            [s.toLowerCase()]: {
                required: true
            }
        }));
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributesConfig,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: loginWithEmailEnabled || loginWithPhoneEnabled ? false : true,
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$0b5a421e5a4a21d9$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $0b5a421e5a4a21d9$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service } = geo;
        amplifyConfig.Geo = amazon_location_service ? {
            LocationService: {
                ...amazon_location_service,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        } : {
            ...geo
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name, endpoint: endpoint, region: region, service: service } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $0b5a421e5a4a21d9$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $0b5a421e5a4a21d9$var$getOAuthConfig = ({ domain: domain, scope: scope, redirectSignIn: redirectSignIn, redirectSignOut: redirectSignOut, responseType: responseType })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $0b5a421e5a4a21d9$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $0b5a421e5a4a21d9$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $0b5a421e5a4a21d9$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a741f0e3a47bdf20$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $a741f0e3a47bdf20$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $53e4c01d7e03bcc8$export$b412d755cfa0136 {
    constructor(){
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $f94f9cce0c4db259$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourcesConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $0b5a421e5a4a21d9$export$1ef2e9c2da492d)(resourcesConfig);
        else resolvedResourceConfig = resourcesConfig;
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $a741f0e3a47bdf20$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: resourcesConfig
        }, "Configure", (0, $b47473e783336341$export$aadf71dd9875dd20));
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` is responsible for orchestrating cross-category communication within the library.
 */ const $53e4c01d7e03bcc8$export$a3858a9a153cffc7 = new $53e4c01d7e03bcc8$export$b412d755cfa0136();

var $43b3efac978fe307$exports = {};
(function(global, factory) {
    $43b3efac978fe307$exports = factory();
})($43b3efac978fe307$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $82b492d800c240d2$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path, domain: domain, expires: expires, sameSite: sameSite, secure: secure } = data;
        this.domain = domain;
        this.path = path ? path : "/";
        this.expires = data.hasOwnProperty("expires") ? expires : 365;
        this.secure = data.hasOwnProperty("secure") ? secure : true;
        if (data.hasOwnProperty("sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($43b3efac978fe307$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($43b3efac978fe307$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($43b3efac978fe307$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($43b3efac978fe307$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $28ee0152febf9d08$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
})($28ee0152febf9d08$export$4e712df6b850c8d0 || ($28ee0152febf9d08$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $151da93b435293a5$export$f5362e8a6666a455 extends (0, $3caf5c41ef04ef89$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $28ee0152febf9d08$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $ccd29c85066ee806$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $151da93b435293a5$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $151da93b435293a5$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $151da93b435293a5$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $151da93b435293a5$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $94f10b816f73642f$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $1f1bde3cc8559e8d$export$5d9abaf8ff62cd65 = ()=>typeof window !== "undefined" && window.localStorage ? window.localStorage : new (0, $94f10b816f73642f$export$e4315e25b840a0ea)();
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $1f1bde3cc8559e8d$export$518dcc1598f87b = ()=>typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : new (0, $94f10b816f73642f$export$e4315e25b840a0ea)();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $7e4d51d9bc566ac2$export$bec45e7703e93690 extends (0, $ccd29c85066ee806$export$8536778e426ddf92) {
    constructor(){
        super((0, $1f1bde3cc8559e8d$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $7b83e7b959d98985$export$2c4b17e1c2e0931 extends (0, $ccd29c85066ee806$export$8536778e426ddf92) {
    constructor(){
        super((0, $1f1bde3cc8559e8d$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $54aa5b1883c07459$export$586b30dcaeecb901 = new (0, $7e4d51d9bc566ac2$export$bec45e7703e93690)();
const $54aa5b1883c07459$export$f119d83aa936d634 = new (0, $7b83e7b959d98985$export$2c4b17e1c2e0931)();
const $54aa5b1883c07459$export$41feb988b3a84f03 = new (0, $ccd29c85066ee806$export$8536778e426ddf92)(new (0, $94f10b816f73642f$export$e4315e25b840a0ea)());





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c683ae836e700a37$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $3caf5c41ef04ef89$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message, recoverySuggestion: recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $bf9b7db391de5d2e$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($bf9b7db391de5d2e$export$7b5c8b570ea8407 || ($bf9b7db391de5d2e$export$7b5c8b570ea8407 = {}));
const $bf9b7db391de5d2e$var$authConfigurationErrorMap = {
    [$bf9b7db391de5d2e$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$bf9b7db391de5d2e$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$bf9b7db391de5d2e$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$bf9b7db391de5d2e$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$bf9b7db391de5d2e$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $bf9b7db391de5d2e$export$a7a9523472993e97 = (0, $c683ae836e700a37$export$5cb8fc27ccbe9d40)($bf9b7db391de5d2e$var$authConfigurationErrorMap);





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cc2669c14dc942e5$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $3caf5c41ef04ef89$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $cc2669c14dc942e5$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $3caf5c41ef04ef89$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $cc2669c14dc942e5$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $3caf5c41ef04ef89$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9647d74a451fedae$export$1e303d38dab7b376 = {
    convert (input) {
        return (0, $cc2669c14dc942e5$export$ea737e7700106b27)()(input);
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $1373aa7f126ca50c$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    return (0, $bf9b7db391de5d2e$export$a7a9523472993e97)(assertionValid, (0, $bf9b7db391de5d2e$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $1373aa7f126ca50c$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    return (0, $bf9b7db391de5d2e$export$a7a9523472993e97)(validOAuthConfig, (0, $bf9b7db391de5d2e$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $1373aa7f126ca50c$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    return (0, $bf9b7db391de5d2e$export$a7a9523472993e97)(validConfig, (0, $bf9b7db391de5d2e$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
function $1373aa7f126ca50c$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $9647d74a451fedae$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e947dd588a7be625$export$dad1700b96c3a835 = {
    identityId: "identityId"
};



const $59ed6e8238168e95$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $cb87c343b3a92609$export$145273558d58e0ac extends (0, $3caf5c41ef04ef89$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $cb87c343b3a92609$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $cb87c343b3a92609$export$145273558d58e0ac.prototype);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $22bc28bc912b6f7a$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($22bc28bc912b6f7a$export$cc5909720f29144 || ($22bc28bc912b6f7a$export$cc5909720f29144 = {}));
const $22bc28bc912b6f7a$var$tokenValidationErrorMap = {
    [$22bc28bc912b6f7a$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $22bc28bc912b6f7a$export$a7a9523472993e97 = (0, $c683ae836e700a37$export$5cb8fc27ccbe9d40)($22bc28bc912b6f7a$var$tokenValidationErrorMap);


class $91e101dfd31622f4$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $22bc28bc912b6f7a$export$a7a9523472993e97)(tokens !== undefined, (0, $22bc28bc912b6f7a$export$cc5909720f29144).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (!!tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (!!tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (!!tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (!!tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return !!randomPassword ? {
            deviceKey: deviceKey ?? undefined,
            deviceGroupKey: deviceGroupKey ?? undefined,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $91e101dfd31622f4$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
}
const $91e101dfd31622f4$export$4647c72f6828a74d = (provider, identifier)=>{
    return $91e101dfd31622f4$export$dfb8da757ca62eed((0, $59ed6e8238168e95$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $91e101dfd31622f4$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8ab29bba641e1aa7$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $8ab29bba641e1aa7$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $1373aa7f126ca50c$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $8ab29bba641e1aa7$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
        return;
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $1373aa7f126ca50c$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (!!this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (!!storedIdentityId) return {
                    id: storedIdentityId,
                    type: "guest"
                };
                return null;
            }
        } catch (err) {
            $8ab29bba641e1aa7$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $1373aa7f126ca50c$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            this.keyValueStorage.removeItem(this._authKeys.identityId);
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $8ab29bba641e1aa7$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $91e101dfd31622f4$export$dfb8da757ca62eed)((0, $e947dd588a7be625$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $7dac0d083817dcc2$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $7dac0d083817dcc2$export$d7c12af0c0f12206 = {
    partitions: [
        $7dac0d083817dcc2$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $b8c8463a58029846$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions } = (0, $7dac0d083817dcc2$export$d7c12af0c0f12206);
    for (const { regions: regions, outputs: outputs, regionRegex: regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $7dac0d083817dcc2$export$72f3cee421ee8a74).outputs.dnsSuffix;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2265321dfd9df7d0$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $2265321dfd9df7d0$export$a3922aa5f87bae85 = ({ maxAttempts: maxAttempts = $2265321dfd9df7d0$var$DEFAULT_RETRY_ATTEMPTS, retryDecider: retryDecider, computeDelay: computeDelay, abortSignal: abortSignal })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $2265321dfd9df7d0$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $2265321dfd9df7d0$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                if (await retryDecider(response, error)) {
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $2265321dfd9df7d0$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $2265321dfd9df7d0$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $2265321dfd9df7d0$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = {
        ...nextHandlerOutput["$metadata"] ?? {},
        attempts: attempts
    };
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $428348b2a6ab2ad2$export$62c460923941c0b0 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent", userAgentValue: userAgentValue = "" })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $be1e978a08efd132$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (request)=>coreHandler(request, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $78434289af0c1231$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $73da0fffbd7f56eb$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $73da0fffbd7f56eb$export$d2573baf35521e4c = async ({ url: url, method: method, headers: headers, body: body }, { abortSignal: abortSignal, cache: cache, withCrossDomainCredentials: withCrossDomainCredentials })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $73da0fffbd7f56eb$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        // TODO: needs to revise error handling in v6
        // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
        // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
        if (e instanceof TypeError) throw new Error("Network error");
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $78434289af0c1231$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $78434289af0c1231$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $78434289af0c1231$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $22b639b242361e1a$export$ed7e1ccf00f39c4a = (0, $be1e978a08efd132$export$f074d76e52925468)((0, $73da0fffbd7f56eb$export$d2573baf35521e4c), [
    (0, $428348b2a6ab2ad2$export$62c460923941c0b0),
    (0, $2265321dfd9df7d0$export$a3922aa5f87bae85)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2ed1d4d906c8583e$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $8c520dd5105fb14b$export$caea50bde345f648(maxDelayMs = (0, $2ed1d4d906c8583e$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $067f0b9e8d98c862$var$DEFAULT_MAX_DELAY_MS = 300000;
const $067f0b9e8d98c862$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $8c520dd5105fb14b$export$caea50bde345f648)($067f0b9e8d98c862$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $067f0b9e8d98c862$var$DEFAULT_MAX_DELAY_MS : delay;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $21ab699efde58086$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $21ab699efde58086$export$7b87435661177a94 = (errorCode)=>!!errorCode && $21ab699efde58086$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $5d9229da81a51f48$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.["code"];
        const statusCode = response?.statusCode;
        return $5d9229da81a51f48$var$isConnectionError(error) || $5d9229da81a51f48$var$isThrottlingError(statusCode, errorCode) || (0, $21ab699efde58086$export$7b87435661177a94)(errorCode) || $5d9229da81a51f48$var$isServerSideError(statusCode, errorCode);
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $5d9229da81a51f48$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $5d9229da81a51f48$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $5d9229da81a51f48$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $5d9229da81a51f48$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $5d9229da81a51f48$var$isConnectionError = (error)=>error?.["name"] === "Network error";
const $5d9229da81a51f48$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $5d9229da81a51f48$var$TIMEOUT_ERROR_CODES.includes(errorCode);



var $4UZnF = parcelRequire("4UZnF");
/**
 * @internal
 */ var $cb4f239e6d8a44a5$export$b2e3d6d444266a5c = 64;
var $cb4f239e6d8a44a5$export$d7bd469488748c5f = 32;
var $cb4f239e6d8a44a5$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $cb4f239e6d8a44a5$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $cb4f239e6d8a44a5$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $1dde649109002423$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $cb4f239e6d8a44a5$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $cb4f239e6d8a44a5$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c) >= (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $cb4f239e6d8a44a5$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $cb4f239e6d8a44a5$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $860c60396e5241e6$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $6ab5929adbabd887$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $860c60396e5241e6$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $c1dd87e9a825728e$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);





var $43wp1 = parcelRequire("43wp1");
var $ea30d10e7388d9f9$require$Buffer = $43wp1.Buffer;
// Quick polyfill
var $ea30d10e7388d9f9$var$fromUtf8 = typeof $ea30d10e7388d9f9$require$Buffer !== "undefined" && $ea30d10e7388d9f9$require$Buffer.from ? function(input) {
    return $ea30d10e7388d9f9$require$Buffer.from(input, "utf8");
} : (0, $860c60396e5241e6$export$c7c5cef950a4d2fc);
function $ea30d10e7388d9f9$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $ea30d10e7388d9f9$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $202af70d18dececb$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $fef9d54f77639189$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $217b7a0d5b70d003$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $8246c1244c79bb13$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $1dde649109002423$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $202af70d18dececb$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $ea30d10e7388d9f9$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $4UZnF.__awaiter)(this, void 0, void 0, function() {
            return (0, $4UZnF.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $1dde649109002423$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $1dde649109002423$export$aab6bc1ad3c77a42)();
            var inner = $8246c1244c79bb13$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $8246c1244c79bb13$var$bufferFromSecret(secret) {
    var input = (0, $ea30d10e7388d9f9$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $1dde649109002423$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $cb4f239e6d8a44a5$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $519a0144fcdf26c9$var$SHORT_TO_HEX = {};
const $519a0144fcdf26c9$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $519a0144fcdf26c9$var$SHORT_TO_HEX[i] = encodedByte;
    $519a0144fcdf26c9$var$HEX_TO_SHORT[encodedByte] = i;
}
function $519a0144fcdf26c9$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $519a0144fcdf26c9$var$HEX_TO_SHORT) out[i / 2] = $519a0144fcdf26c9$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $519a0144fcdf26c9$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $519a0144fcdf26c9$var$SHORT_TO_HEX[bytes[i]];
    return out;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2b8867449626b446$export$beb82d9d9136c16e = URL;
const $2b8867449626b446$export$4ea7bbdac595b5fb = URLSearchParams;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $56c45587d1ef1971$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers, statusCode: statusCode } = response;
    return {
        ...$56c45587d1ef1971$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $56c45587d1ef1971$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $ee7f0eff5582f16f$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $ee7f0eff5582f16f$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[\,\:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $56c45587d1ef1971$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $ee7f0eff5582f16f$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $56c45587d1ef1971$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9d643ce80023347d$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($9d643ce80023347d$export$638889172ebce0c4 || ($9d643ce80023347d$export$638889172ebce0c4 = {}));
var $9d643ce80023347d$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($9d643ce80023347d$export$3a8840c5b2ecf003 || ($9d643ce80023347d$export$3a8840c5b2ecf003 = {}));
var $9d643ce80023347d$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($9d643ce80023347d$export$30c16f5c43437fd7 || ($9d643ce80023347d$export$30c16f5c43437fd7 = {}));
var $9d643ce80023347d$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($9d643ce80023347d$export$126e20fdc0f0d34b || ($9d643ce80023347d$export$126e20fdc0f0d34b = {}));
var $9d643ce80023347d$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
})($9d643ce80023347d$export$900b1436d7e65f4 || ($9d643ce80023347d$export$900b1436d7e65f4 = {}));
var $9d643ce80023347d$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($9d643ce80023347d$export$2f5a715aba4cde93 || ($9d643ce80023347d$export$2f5a715aba4cde93 = {}));
var $9d643ce80023347d$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($9d643ce80023347d$export$afafab3eb8fc6fef || ($9d643ce80023347d$export$afafab3eb8fc6fef = {}));
var $9d643ce80023347d$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($9d643ce80023347d$export$c01a8c16ffda791e || ($9d643ce80023347d$export$c01a8c16ffda791e = {}));
var $9d643ce80023347d$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($9d643ce80023347d$export$68e0695a774ab7fa || ($9d643ce80023347d$export$68e0695a774ab7fa = {}));
var $9d643ce80023347d$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($9d643ce80023347d$export$aa89b4c447a07cee || ($9d643ce80023347d$export$aa89b4c447a07cee = {}));
var $9d643ce80023347d$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($9d643ce80023347d$export$ade48b30f1e78672 || ($9d643ce80023347d$export$ade48b30f1e78672 = {}));
var $9d643ce80023347d$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($9d643ce80023347d$export$2c5ee06ab9fa5040 || ($9d643ce80023347d$export$2c5ee06ab9fa5040 = {}));
var $9d643ce80023347d$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
})($9d643ce80023347d$export$d4f3c54b808b00ce || ($9d643ce80023347d$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $072b4a5c5ad04ab9$export$83d89fbfd8236492 = "6.0.5";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $54X9E = parcelRequire("54X9E");
const $1daa8c6a1ecd7916$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $1daa8c6a1ecd7916$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $1daa8c6a1ecd7916$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $1daa8c6a1ecd7916$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $1daa8c6a1ecd7916$export$ba10401363d0f7f6 = ()=>{
    return typeof $54X9E !== "undefined";
};
const $1daa8c6a1ecd7916$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



var $54X9E = parcelRequire("54X9E");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $412ba062759ca1ff$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $1daa8c6a1ecd7916$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $412ba062759ca1ff$export$86269c582305790() {
    return (0, $1daa8c6a1ecd7916$export$ba10401363d0f7f6)() && typeof $54X9E.env !== "undefined" && !!Object.keys($54X9E.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $b1b0a75a0e6753a1$export$d91d90d62b78936d() {
    return (0, $1daa8c6a1ecd7916$export$daba2802a1a41c1f)() && (0, $1daa8c6a1ecd7916$export$252f88727cff70c7)(window, "__VUE");
}
function $b1b0a75a0e6753a1$export$257a4c0f8294a101() {
    return (0, $1daa8c6a1ecd7916$export$a15eed0e463030a9)() && (0, $1daa8c6a1ecd7916$export$252f88727cff70c7)($parcel$global, "__VUE");
}




var $54X9E = parcelRequire("54X9E");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $8e046deb77e32828$export$6dafc32a94edaed3() {
    return (0, $1daa8c6a1ecd7916$export$daba2802a1a41c1f)() && (0, $1daa8c6a1ecd7916$export$252f88727cff70c7)(window, "__SVELTE");
}
function $8e046deb77e32828$export$819dcb7fe144d8b0() {
    return (0, $1daa8c6a1ecd7916$export$ba10401363d0f7f6)() && typeof $54X9E.env !== "undefined" && !!Object.keys($54X9E.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $7ea08be5fece3355$export$f8462bcf03110eff() {
    // @ts-ignore
    return (0, $1daa8c6a1ecd7916$export$daba2802a1a41c1f)() && window["next"] && typeof window["next"] === "object";
}
function $7ea08be5fece3355$export$61c08ed144a5d4ca() {
    return (0, $1daa8c6a1ecd7916$export$a15eed0e463030a9)() && ((0, $1daa8c6a1ecd7916$export$252f88727cff70c7)($parcel$global, "__next") || (0, $1daa8c6a1ecd7916$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $aece9930f8dd4cc6$export$bed54a4e6d9d25fb() {
    return (0, $1daa8c6a1ecd7916$export$daba2802a1a41c1f)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function $aece9930f8dd4cc6$export$fb3ce982948d27e8() {
    // @ts-ignore
    return (0, $1daa8c6a1ecd7916$export$a15eed0e463030a9)() && typeof $parcel$global["__NUXT_PATHS__"] !== "undefined";
}




var $54X9E = parcelRequire("54X9E");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $a40399a6dd93dba5$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $1daa8c6a1ecd7916$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean(// @ts-ignore
    (0, $1daa8c6a1ecd7916$export$daba2802a1a41c1f)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $a40399a6dd93dba5$export$8ab518c8987c870f() {
    return (0, $1daa8c6a1ecd7916$export$ba10401363d0f7f6)() && typeof $54X9E.env === "object" && undefined?.startsWith("ng ") || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $fb5fb4aaf36bde88$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $275a9c4fb94795c2$export$85fd46d5e29a4f7e() {
    // @ts-ignore
    return (0, $1daa8c6a1ecd7916$export$a15eed0e463030a9)() && typeof $parcel$global["expo"] !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $866fc98f45ed071c$export$41b1270b988065fb() {
    return (0, $1daa8c6a1ecd7916$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $db8437854cdb387e$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $275a9c4fb94795c2$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $fb5fb4aaf36bde88$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $7ea08be5fece3355$export$f8462bcf03110eff)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $aece9930f8dd4cc6$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $a40399a6dd93dba5$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).React,
        detectionMethod: (0, $412ba062759ca1ff$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $b1b0a75a0e6753a1$export$d91d90d62b78936d)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $8e046deb77e32828$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $866fc98f45ed071c$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $7ea08be5fece3355$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $aece9930f8dd4cc6$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $412ba062759ca1ff$export$86269c582305790)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $b1b0a75a0e6753a1$export$257a4c0f8294a101)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $a40399a6dd93dba5$export$8ab518c8987c870f)
    },
    {
        platform: (0, $9d643ce80023347d$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $8e046deb77e32828$export$819dcb7fe144d8b0)
    }
];
function $db8437854cdb387e$export$17b446b869dad473() {
    return $db8437854cdb387e$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $9d643ce80023347d$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $f93b85cd5c2d771f$var$frameworkCache;
const $f93b85cd5c2d771f$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $f93b85cd5c2d771f$var$resetTriggered = false;
const $f93b85cd5c2d771f$var$SSR_RESET_TIMEOUT = 10; // ms
const $f93b85cd5c2d771f$var$WEB_RESET_TIMEOUT = 10; // ms
const $f93b85cd5c2d771f$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $f93b85cd5c2d771f$export$9ce73e459ec93b6a = ()=>{
    if (!$f93b85cd5c2d771f$var$frameworkCache) {
        $f93b85cd5c2d771f$var$frameworkCache = (0, $db8437854cdb387e$export$17b446b869dad473)();
        if ($f93b85cd5c2d771f$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($f93b85cd5c2d771f$export$d56891f33aa26edc.length)$f93b85cd5c2d771f$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $f93b85cd5c2d771f$export$d56891f33aa26edc.forEach((fcn)=>fcn());
        // Retry once for either Unknown type after a delay (explained below)
        $f93b85cd5c2d771f$var$resetTimeout((0, $9d643ce80023347d$export$638889172ebce0c4).ServerSideUnknown, $f93b85cd5c2d771f$var$SSR_RESET_TIMEOUT);
        $f93b85cd5c2d771f$var$resetTimeout((0, $9d643ce80023347d$export$638889172ebce0c4).WebUnknown, $f93b85cd5c2d771f$var$WEB_RESET_TIMEOUT);
    }
    return $f93b85cd5c2d771f$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $f93b85cd5c2d771f$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($f93b85cd5c2d771f$var$resetTriggered) return;
    $f93b85cd5c2d771f$export$d56891f33aa26edc.push(fcn);
};
function $f93b85cd5c2d771f$export$d2adf65b87e47523() {
    $f93b85cd5c2d771f$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $f93b85cd5c2d771f$var$resetTimeout(framework, delay) {
    if ($f93b85cd5c2d771f$var$frameworkCache === framework && !$f93b85cd5c2d771f$var$resetTriggered) setTimeout(()=>{
        $f93b85cd5c2d771f$export$d2adf65b87e47523();
        $f93b85cd5c2d771f$var$resetTriggered = true;
        setTimeout($f93b85cd5c2d771f$export$9ce73e459ec93b6a, $f93b85cd5c2d771f$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $2d7a577398a8ac08$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $2d7a577398a8ac08$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $2d7a577398a8ac08$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $2d7a577398a8ac08$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $2d7a577398a8ac08$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $2d7a577398a8ac08$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $2d7a577398a8ac08$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($2d7a577398a8ac08$var$customUserAgentState[input.category]).length) delete $2d7a577398a8ac08$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $2d7a577398a8ac08$export$e399dbcfd99a2928 = (category, api)=>$2d7a577398a8ac08$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2655623d514a11e7$var$BASE_USER_AGENT = `aws-amplify`;
class $2655623d514a11e7$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$2655623d514a11e7$var$BASE_USER_AGENT}/${0, $072b4a5c5ad04ab9$export$83d89fbfd8236492}`;
    }
    get framework() {
        return (0, $f93b85cd5c2d771f$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $9d643ce80023347d$export$638889172ebce0c4).ReactNative || this.framework === (0, $9d643ce80023347d$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $f93b85cd5c2d771f$export$5d5c467ce0b213f)(fcn);
    }
}
const $2655623d514a11e7$export$2dffd0b5373a4389 = new $2655623d514a11e7$var$PlatformBuilder();
const $2655623d514a11e7$export$7d201307d8979e21 = ({ category: category, action: action, framework: framework } = {})=>{
    const userAgent = [
        [
            $2655623d514a11e7$var$BASE_USER_AGENT,
            (0, $072b4a5c5ad04ab9$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $f93b85cd5c2d771f$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $2d7a577398a8ac08$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $2655623d514a11e7$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $2655623d514a11e7$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $c1dc6d63957cd850$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $c1dc6d63957cd850$var$endpointResolver = ({ region: region })=>({
        url: new (0, $2b8867449626b446$export$beb82d9d9136c16e)(`https://cognito-identity.${region}.${(0, $b8c8463a58029846$export$1c28e37cdcc37f6d)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $c1dc6d63957cd850$var$disableCacheMiddleware = ()=>(next, context)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $c1dc6d63957cd850$export$8029646671d2c482 = (0, $be1e978a08efd132$export$f074d76e52925468)((0, $22b639b242361e1a$export$ed7e1ccf00f39c4a), [
    $c1dc6d63957cd850$var$disableCacheMiddleware
]);
/**
 * @internal
 */ const $c1dc6d63957cd850$export$f84bd70098573c5c = {
    service: $c1dc6d63957cd850$var$SERVICE_NAME,
    endpointResolver: $c1dc6d63957cd850$var$endpointResolver,
    retryDecider: (0, $5d9229da81a51f48$export$b919d98317a7685f)((0, $ee7f0eff5582f16f$export$be467dfcc0538e25)),
    computeDelay: (0, $067f0b9e8d98c862$export$caea50bde345f648),
    userAgentValue: (0, $2655623d514a11e7$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
(0, $f93b85cd5c2d771f$export$5d5c467ce0b213f)(()=>{
    $c1dc6d63957cd850$export$f84bd70098573c5c.userAgentValue = (0, $2655623d514a11e7$export$ede38edb26c0bfdf)();
});
/**
 * @internal
 */ const $c1dc6d63957cd850$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $c1dc6d63957cd850$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $199ba08f8ccd9f93$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We may want to allow different endpoints from given config(other than region) and input.
        // Currently S3 supports additional `useAccelerateEndpoint` option to use accelerate endpoint.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return await deserializer(response);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $87b563bc8f4cd207$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $c1dc6d63957cd850$export$a46bbeaba09f7285)("GetId");
    const body = JSON.stringify(input);
    return (0, $c1dc6d63957cd850$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $87b563bc8f4cd207$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $ee7f0eff5582f16f$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $ee7f0eff5582f16f$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $56c45587d1ef1971$export$978f9418fe0cb26c)(response)
        };
    }
};
/**
 * @internal
 */ const $87b563bc8f4cd207$export$218c8c3169c024d2 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $c1dc6d63957cd850$export$8029646671d2c482), $87b563bc8f4cd207$var$getIdSerializer, $87b563bc8f4cd207$var$getIdDeserializer, (0, $c1dc6d63957cd850$export$f84bd70098573c5c));




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3d2f8329dc39998b$export$d4a625cede2da71b(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $3d2f8329dc39998b$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7e14d8f3401119ab$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    let domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5f05af5d589ea561$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration excpetions: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service excpetions: {@link GetIdException }
 */ async function $5f05af5d589ea561$export$7c3e576630d5e301({ tokens: tokens, authConfig: authConfig, identityIdStore: identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $7e14d8f3401119ab$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $5f05af5d589ea561$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $5f05af5d589ea561$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $5f05af5d589ea561$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $5f05af5d589ea561$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $3d2f8329dc39998b$export$8fb32fba519c460)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $87b563bc8f4cd207$export$218c8c3169c024d2)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $eb994edfd9cd2c9c$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $c1dc6d63957cd850$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $c1dc6d63957cd850$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $eb994edfd9cd2c9c$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $ee7f0eff5582f16f$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $ee7f0eff5582f16f$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $eb994edfd9cd2c9c$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $56c45587d1ef1971$export$978f9418fe0cb26c)(response)
        };
    }
};
const $eb994edfd9cd2c9c$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId, SecretKey: SecretKey, SessionToken: SessionToken, Expiration: Expiration } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $eb994edfd9cd2c9c$export$a49c1c173ab96b58 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $c1dc6d63957cd850$export$8029646671d2c482), $eb994edfd9cd2c9c$var$getCredentialsForIdentitySerializer, $eb994edfd9cd2c9c$var$getCredentialsForIdentityDeserializer, (0, $c1dc6d63957cd850$export$f84bd70098573c5c));







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0927f39e1da098a6$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $0927f39e1da098a6$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $0927f39e1da098a6$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $0927f39e1da098a6$export$fe46a12932d2550a = "AutoSignInException";
const $0927f39e1da098a6$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $0927f39e1da098a6$export$60b68b138a52e5ae = new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
    name: $0927f39e1da098a6$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $0927f39e1da098a6$export$27ddc47447101bcf = "InvalidOriginException";
const $0927f39e1da098a6$export$c01b4acd6291e035 = new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
    name: $0927f39e1da098a6$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $0927f39e1da098a6$export$625255707e22459c = "OAuthSignOutException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $de2f10f4a648aec0$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $de2f10f4a648aec0$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $0927f39e1da098a6$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $de2f10f4a648aec0$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $0927f39e1da098a6$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $de2f10f4a648aec0$export$be38b2d22222d505(tokens) {
    if (!tokens || !tokens.accessToken || !tokens.refreshToken) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $0927f39e1da098a6$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $de2f10f4a648aec0$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $0927f39e1da098a6$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $de2f10f4a648aec0$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $09b338f7c57a396f$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $09b338f7c57a396f$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $09b338f7c57a396f$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $09b338f7c57a396f$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $09b338f7c57a396f$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const tokens = getCredentialsOptions.tokens;
        const authConfig = getCredentialsOptions.authConfig;
        try {
            (0, $1373aa7f126ca50c$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const forceRefresh = getCredentialsOptions.forceRefresh;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $5f05af5d589ea561$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $de2f10f4a648aec0$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $09b338f7c57a396f$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $3d2f8329dc39998b$export$8fb32fba519c460)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $eb994edfd9cd2c9c$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $09b338f7c57a396f$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $09b338f7c57a396f$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $7e14d8f3401119ab$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $3d2f8329dc39998b$export$8fb32fba519c460)(authConfig.identityPoolId);
        const clientResult = await (0, $eb994edfd9cd2c9c$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $09b338f7c57a396f$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $019d0ef5bf17babb$export$be43b753aec531e2 = new (0, $09b338f7c57a396f$export$be6550e37264dc26)(new (0, $8ab29bba641e1aa7$export$3e97b78667a539a0)((0, $54aa5b1883c07459$export$586b30dcaeecb901)));








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $a956ce33293a1ed5$var$SERVICE_NAME = "cognito-idp";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $a956ce33293a1ed5$var$endpointResolver = ({ region: region })=>{
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const customURL = authConfig?.userPoolEndpoint;
    const defaultURL = new (0, $2b8867449626b446$export$beb82d9d9136c16e)(`https://${$a956ce33293a1ed5$var$SERVICE_NAME}.${region}.${(0, $b8c8463a58029846$export$1c28e37cdcc37f6d)(region)}`);
    return {
        url: customURL ? new (0, $2b8867449626b446$export$beb82d9d9136c16e)(customURL) : defaultURL
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $a956ce33293a1ed5$var$disableCacheMiddleware = ()=>(next, context)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $a956ce33293a1ed5$export$10f11e95d7a96f7b = (0, $be1e978a08efd132$export$f074d76e52925468)((0, $22b639b242361e1a$export$ed7e1ccf00f39c4a), [
    $a956ce33293a1ed5$var$disableCacheMiddleware
]);
/**
 * @internal
 */ const $a956ce33293a1ed5$export$f84bd70098573c5c = {
    service: $a956ce33293a1ed5$var$SERVICE_NAME,
    endpointResolver: $a956ce33293a1ed5$var$endpointResolver,
    retryDecider: (0, $5d9229da81a51f48$export$b919d98317a7685f)((0, $ee7f0eff5582f16f$export$be467dfcc0538e25)),
    computeDelay: (0, $067f0b9e8d98c862$export$caea50bde345f648),
    userAgentValue: (0, $2655623d514a11e7$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
/**
 * @internal
 */ const $a956ce33293a1ed5$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
/**
 * @internal
 */ const $a956ce33293a1ed5$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f37be53782e2980b$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $28ee0152febf9d08$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has ocurred.",
        underlyingError: error
    });
}



const $03c131ae6cab815c$var$buildUserPoolSerializer = (operation)=>(input, endpoint)=>{
        const headers = (0, $a956ce33293a1ed5$export$a46bbeaba09f7285)(operation);
        const body = JSON.stringify(input);
        return (0, $a956ce33293a1ed5$export$a692bdb7eb624f96)(endpoint, headers, body);
    };
const $03c131ae6cab815c$var$buildUserPoolDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $ee7f0eff5582f16f$export$be467dfcc0538e25)(response);
            (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
            throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else {
            const body = await (0, $ee7f0eff5582f16f$export$759bcb35b0d1bf81)(response);
            return body;
        }
    };
};
const $03c131ae6cab815c$var$handleEmptyResponseDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $ee7f0eff5582f16f$export$be467dfcc0538e25)(response);
            (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
            throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else return undefined;
    };
};
const $03c131ae6cab815c$export$567b0d5ec943f827 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("InitiateAuth"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$2428f6ba65615593 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("RevokeToken"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$cf64224bcd829024 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("SignUp"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$2ce39ab6662e8c24 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ConfirmSignUp"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$66791fb2cfeec3e = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ForgotPassword"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$c7a5d0826ce3a2b2 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ConfirmForgotPassword"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$b196467a22b300ec = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("RespondToAuthChallenge"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$f24137cafeaef1a1 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ResendConfirmationCode"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$72b1124e126ff51c = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("VerifySoftwareToken"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$4531a27964554be8 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("AssociateSoftwareToken"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$b6a1b2cc7e7e6b1e = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("SetUserMFAPreference"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$7cbf767827cd68ba = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("GetUser"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$99d837dc30eb1ef7 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ChangePassword"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$3a7ad63dc35b752f = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ConfirmDevice"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$d0b7632b5e5fb312 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ForgetDevice"), $03c131ae6cab815c$var$handleEmptyResponseDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$7d0f10f273c0438a = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("DeleteUser"), $03c131ae6cab815c$var$handleEmptyResponseDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$3a9721eaccd0e7b3 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("GetUserAttributeVerificationCode"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$a92c2ab9b6303723 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("GlobalSignOut"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$16ff8cb4f547be0 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("UpdateUserAttributes"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$40fc6c986f86e9a5 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("VerifyUserAttribute"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$e1c4af6b7c9755a8 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("UpdateDeviceStatus"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$11154f886a75108 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("ListDevices"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));
const $03c131ae6cab815c$export$a97f0f1c87d00e1 = (0, $199ba08f8ccd9f93$export$880429a8ae983d4d)((0, $a956ce33293a1ed5$export$10f11e95d7a96f7b), $03c131ae6cab815c$var$buildUserPoolSerializer("DeleteUserAttributes"), $03c131ae6cab815c$var$buildUserPoolDeserializer(), (0, $a956ce33293a1ed5$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $b1bc599c96d5eaef$export$b6e6cdd1f90faa62({ username: username, userPoolId: userPoolId, userPoolClientId: userPoolClientId }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $22be0dd60f0ddfe9$export$ab413c2cb4a135d9 = async ({ tokens: tokens, authConfig: authConfig, username: username })=>{
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig?.Cognito);
    const region = (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.Cognito.userPoolId);
    (0, $de2f10f4a648aec0$export$be38b2d22222d505)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters["DEVICE_KEY"] = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: authConfig.Cognito.userPoolId,
        userPoolClientId: authConfig.Cognito.userPoolClientId
    });
    const { AuthenticationResult: AuthenticationResult } = await (0, $03c131ae6cab815c$export$567b0d5ec943f827)({
        region: region
    }, {
        ClientId: authConfig?.Cognito?.userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const iat = accessToken.payload.iat;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $7b14c7bf57a04511$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = async ()=>{};
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    setWaitForInflightOAuth(waitForInflightOAuth) {
        this.waitForInflightOAuth = waitForInflightOAuth;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $f94f9cce0c4db259$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $f94f9cce0c4db259$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens, username: username }) {
        try {
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            await this.setTokens({
                tokens: newTokens
            });
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $f37be53782e2980b$export$5b3890f50cd4853f)(err);
        if (err.message !== "Network error") // TODO(v6): Check errors on client
        this.clearTokens();
        if (err.name.startsWith("NotAuthorizedException")) return null;
        else {
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh_failure"
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            throw err;
        }
    }
    async setTokens({ tokens: tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $4398d957ad502806$var$CognitoUserPoolsTokenProviderClass {
    constructor(){
        this.authTokenStore = new (0, $91e101dfd31622f4$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $54aa5b1883c07459$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $7b14c7bf57a04511$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $22be0dd60f0ddfe9$export$ab413c2cb4a135d9));
    }
    getTokens({ forceRefresh: forceRefresh } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setWaitForInflightOAuth(waitForInflightOAuth) {
        this.tokenOrchestrator.setWaitForInflightOAuth(waitForInflightOAuth);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}
const $4398d957ad502806$export$18e158b80aac31a7 = new $4398d957ad502806$var$CognitoUserPoolsTokenProviderClass();
const $4398d957ad502806$export$66561e66d62991d0 = $4398d957ad502806$export$18e158b80aac31a7.tokenOrchestrator;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $730e5f1eab7dc7cb$export$11ac3725994bec7b = {
    configure (resourceConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourceConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $0b5a421e5a4a21d9$export$1ef2e9c2da492d)(resourceConfig);
        else resolvedResourceConfig = resourceConfig;
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) return (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) return (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $4398d957ad502806$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $4398d957ad502806$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $82b492d800c240d2$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $54aa5b1883c07459$export$586b30dcaeecb901));
            return (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $4398d957ad502806$export$18e158b80aac31a7),
                    credentialsProvider: (0, $019d0ef5bf17babb$export$be43b753aec531e2)
                }
            });
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $4398d957ad502806$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $82b492d800c240d2$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $54aa5b1883c07459$export$586b30dcaeecb901));
            return (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                Auth: (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).libraryOptions.Auth,
                ...libraryOptions
            });
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    getConfig () {
        return (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig();
    }
};



var $592Nh = parcelRequire("592Nh");


var $53be88aa100c8649$export$f86ab2f69f02b2d9;
(function(MoovyPalette) {
    MoovyPalette.primaryMain = "#0098d8";
    MoovyPalette.secondaryMain = "#085171";
    MoovyPalette.errorMain = "#ff4848";
    MoovyPalette.warningMain = "#E0732C";
    MoovyPalette.infoMain = MoovyPalette.primaryMain;
    MoovyPalette.successMain = "#0BCD61";
    MoovyPalette.commonBlue = "#555";
    MoovyPalette.commonBlack = "#555";
    MoovyPalette.commonWhite = "white";
    MoovyPalette.commonRed = "#ff4848";
    // TODO Antti: Should be change to be used via theme instead?
    MoovyPalette.colorMainBackground = "#f9fafb";
    MoovyPalette.colorTableHeader = "#efefef";
    // TODO Antti: Should be change to be used via theme instead?
    MoovyPalette.colorMenuUnderline = MoovyPalette.commonWhite;
    // TODO Antti: Should be change to be used via theme instead?
    MoovyPalette.progressBlockContentColor = "white";
    MoovyPalette.colorMenuBackgroundGradient = "linear-gradient(135deg, #08cbef 0%, #0098d8 99.43%);";
})($53be88aa100c8649$export$f86ab2f69f02b2d9 || ($53be88aa100c8649$export$f86ab2f69f02b2d9 = {}));
var $53be88aa100c8649$export$6039b89271c3de71;
(function(MoovyStyle) {
    MoovyStyle.fontFamily = "Fira Sans, sans-serif";
    MoovyStyle.menuFontSize = "17px";
    MoovyStyle.menuFontWeight = 500;
    MoovyStyle.buttonFontWeight = 700;
    MoovyStyle.tableHeadFontWeight = 700;
})($53be88aa100c8649$export$6039b89271c3de71 || ($53be88aa100c8649$export$6039b89271c3de71 = {}));


var $c3affd701a8324c3$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $c3affd701a8324c3$export$18a094aefa070634 = (obj, member, getter)=>{
    $c3affd701a8324c3$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $c3affd701a8324c3$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $c3affd701a8324c3$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $c3affd701a8324c3$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $c3affd701a8324c3$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $c3affd701a8324c3$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $c3affd701a8324c3$export$18a094aefa070634(obj, member, getter);
        }
    });
var $c3affd701a8324c3$export$fa92d15b718fce20 = (obj, member, method)=>{
    $c3affd701a8324c3$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $8299f902fbe20788$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $8299f902fbe20788$export$8793edee2d425525() {
    return void 0;
}
function $8299f902fbe20788$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $8299f902fbe20788$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $8299f902fbe20788$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $8299f902fbe20788$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $8299f902fbe20788$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$8299f902fbe20788$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $8299f902fbe20788$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($8299f902fbe20788$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $8299f902fbe20788$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$8299f902fbe20788$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $8299f902fbe20788$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $8299f902fbe20788$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $8299f902fbe20788$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$8299f902fbe20788$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $8299f902fbe20788$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$8299f902fbe20788$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $8299f902fbe20788$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $8299f902fbe20788$export$7a8558113332b71e(a) && $8299f902fbe20788$export$7a8558113332b71e(b);
    if (array || $8299f902fbe20788$export$53b83ca8eaab0383(a) && $8299f902fbe20788$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if (!array && a[key] === void 0 && b[key] === void 0 && aItems.includes(key)) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $8299f902fbe20788$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $8299f902fbe20788$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $8299f902fbe20788$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $8299f902fbe20788$export$53b83ca8eaab0383(o) {
    if (!$8299f902fbe20788$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$8299f902fbe20788$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $8299f902fbe20788$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $8299f902fbe20788$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $8299f902fbe20788$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $8299f902fbe20788$export$77a71fc411098696(prevData, data);
    return data;
}
function $8299f902fbe20788$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $8299f902fbe20788$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $8299f902fbe20788$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}







// src/notifyManager.ts
function $8d52467732f2e0e5$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $8d52467732f2e0e5$export$520687f44db6e1ab = $8d52467732f2e0e5$export$316a8efd03cd1458();





// src/subscribable.ts
var $cd2d669aebb9a53c$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $0f2c5acf39adb8a1$var$_focused, $0f2c5acf39adb8a1$var$_cleanup, $0f2c5acf39adb8a1$var$_setup;
var $0f2c5acf39adb8a1$export$86f1af424b2ca4de = class extends (0, $cd2d669aebb9a53c$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $0f2c5acf39adb8a1$var$_focused, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $0f2c5acf39adb8a1$var$_cleanup, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $0f2c5acf39adb8a1$var$_setup, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $0f2c5acf39adb8a1$var$_setup, (onFocus)=>{
            if (!(0, $8299f902fbe20788$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_cleanup)) this.setEventListener((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_cleanup)) == null || _a.call(this);
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $0f2c5acf39adb8a1$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $0f2c5acf39adb8a1$var$_setup, setup);
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_cleanup)) == null || _a.call(this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $0f2c5acf39adb8a1$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_focused) !== focused;
        if (changed) {
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $0f2c5acf39adb8a1$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_focused) === "boolean") return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $0f2c5acf39adb8a1$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$0f2c5acf39adb8a1$var$_focused = new WeakMap();
$0f2c5acf39adb8a1$var$_cleanup = new WeakMap();
$0f2c5acf39adb8a1$var$_setup = new WeakMap();
var $0f2c5acf39adb8a1$export$6bf54661be5b02cf = new $0f2c5acf39adb8a1$export$86f1af424b2ca4de();





var $818043d0434c3a93$var$_online, $818043d0434c3a93$var$_cleanup, $818043d0434c3a93$var$_setup;
var $818043d0434c3a93$export$58774fb55d5ff7fc = class extends (0, $cd2d669aebb9a53c$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $818043d0434c3a93$var$_online, true);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $818043d0434c3a93$var$_cleanup, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $818043d0434c3a93$var$_setup, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $818043d0434c3a93$var$_setup, (onOnline)=>{
            if (!(0, $8299f902fbe20788$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $818043d0434c3a93$var$_cleanup)) this.setEventListener((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $818043d0434c3a93$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $818043d0434c3a93$var$_cleanup)) == null || _a.call(this);
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $818043d0434c3a93$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $818043d0434c3a93$var$_setup, setup);
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $818043d0434c3a93$var$_cleanup)) == null || _a.call(this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $818043d0434c3a93$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $818043d0434c3a93$var$_online) !== online;
        if (changed) {
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $818043d0434c3a93$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $818043d0434c3a93$var$_online);
    }
};
$818043d0434c3a93$var$_online = new WeakMap();
$818043d0434c3a93$var$_cleanup = new WeakMap();
$818043d0434c3a93$var$_setup = new WeakMap();
var $818043d0434c3a93$export$b113e788b2dd3fdc = new $818043d0434c3a93$export$58774fb55d5ff7fc();



function $7bad956f3d5bc591$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $7bad956f3d5bc591$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $818043d0434c3a93$export$b113e788b2dd3fdc).isOnline() : true;
}
var $7bad956f3d5bc591$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $7bad956f3d5bc591$export$986cc6445c1d323(value) {
    return value instanceof $7bad956f3d5bc591$export$a8430ed4188f35a9;
}
function $7bad956f3d5bc591$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $7bad956f3d5bc591$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $0f2c5acf39adb8a1$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $818043d0434c3a93$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $8299f902fbe20788$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $7bad956f3d5bc591$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $8299f902fbe20788$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($7bad956f3d5bc591$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}




var $ab0a37c55d07197c$var$_gcTimeout;
var $ab0a37c55d07197c$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $ab0a37c55d07197c$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $8299f902fbe20788$export$e539f754e934e270)(this.gcTime)) (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $ab0a37c55d07197c$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $8299f902fbe20788$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $ab0a37c55d07197c$var$_gcTimeout)) {
            clearTimeout((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $ab0a37c55d07197c$var$_gcTimeout));
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $ab0a37c55d07197c$var$_gcTimeout, void 0);
        }
    }
};
$ab0a37c55d07197c$var$_gcTimeout = new WeakMap();


var $7027a7c85c40134a$var$_initialState, $7027a7c85c40134a$var$_revertState, $7027a7c85c40134a$var$_cache, $7027a7c85c40134a$var$_promise, $7027a7c85c40134a$var$_retryer, $7027a7c85c40134a$var$_observers, $7027a7c85c40134a$var$_defaultOptions, $7027a7c85c40134a$var$_abortSignalConsumed, $7027a7c85c40134a$var$_setOptions, $7027a7c85c40134a$var$setOptions_fn, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn;
var $7027a7c85c40134a$export$62297b13309008b2 = class extends (0, $ab0a37c55d07197c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_setOptions);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_dispatch);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_initialState, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_revertState, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_cache, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_promise, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_retryer, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_observers, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_defaultOptions, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $7027a7c85c40134a$var$_abortSignalConsumed, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_abortSignalConsumed, false);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_defaultOptions, config.defaultOptions);
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_setOptions, $7027a7c85c40134a$var$setOptions_fn).call(this, config.options);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_observers, []);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_initialState, config.state || $7027a7c85c40134a$var$getDefaultState(this.options));
        this.state = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    optionalRemove() {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).length && this.state.fetchStatus === "idle") (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $8299f902fbe20788$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a;
        const promise = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_promise);
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer)) == null || _a.cancel(options);
        return promise ? promise.then((0, $8299f902fbe20788$export$8793edee2d425525)).catch((0, $8299f902fbe20788$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_initialState));
    }
    isActive() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $8299f902fbe20788$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).includes(observer)) {
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).includes(observer)) {
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_observers, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).filter((x)=>x !== observer));
            if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).length) {
                if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer)) {
                    if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_abortSignalConsumed)) (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c, _d;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_promise)) {
                (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer)) == null || _a.continueRetry();
                return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_promise);
            }
        }
        if (options) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_setOptions, $7027a7c85c40134a$var$setOptions_fn).call(this, options);
        if (!this.options.queryFn) {
            const observer = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).find((x)=>x.options.queryFn);
            if (observer) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_setOptions, $7027a7c85c40134a$var$setOptions_fn).call(this, observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d2;
            if (!((0, $7bad956f3d5bc591$export$986cc6445c1d323)(error) && error.silent)) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $7bad956f3d5bc591$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d2 = (_c2 = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).config).onSettled) == null || _d2.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_retryer, (0, $7bad956f3d5bc591$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d2;
                if (typeof data === "undefined") {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d2 = (_c2 = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).config).onSettled) == null || _d2.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $7027a7c85c40134a$var$_dispatch, $7027a7c85c40134a$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $7027a7c85c40134a$var$_promise, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_retryer).promise);
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_promise);
    }
};
$7027a7c85c40134a$var$_initialState = new WeakMap();
$7027a7c85c40134a$var$_revertState = new WeakMap();
$7027a7c85c40134a$var$_cache = new WeakMap();
$7027a7c85c40134a$var$_promise = new WeakMap();
$7027a7c85c40134a$var$_retryer = new WeakMap();
$7027a7c85c40134a$var$_observers = new WeakMap();
$7027a7c85c40134a$var$_defaultOptions = new WeakMap();
$7027a7c85c40134a$var$_abortSignalConsumed = new WeakMap();
$7027a7c85c40134a$var$_setOptions = new WeakSet();
$7027a7c85c40134a$var$setOptions_fn = function(options) {
    this.options = {
        ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_defaultOptions),
        ...options
    };
    this.updateGcTime(this.options.gcTime);
};
$7027a7c85c40134a$var$_dispatch = new WeakSet();
$7027a7c85c40134a$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    fetchFailureCount: 0,
                    fetchFailureReason: null,
                    fetchMeta: action.meta ?? null,
                    fetchStatus: (0, $7bad956f3d5bc591$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                    ...!state.dataUpdatedAt && {
                        error: null,
                        status: "pending"
                    }
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $7bad956f3d5bc591$export$986cc6445c1d323)(error) && error.revert && (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_revertState)) return {
                    ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $7027a7c85c40134a$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $7027a7c85c40134a$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $3974709410e648d8$var$_queries;
var $3974709410e648d8$export$5dde0cd941da8468 = class extends (0, $cd2d669aebb9a53c$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $3974709410e648d8$var$_queries, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $3974709410e648d8$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $8299f902fbe20788$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $7027a7c85c40134a$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $3974709410e648d8$var$_queries).has(query.queryHash)) {
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $3974709410e648d8$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $3974709410e648d8$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $3974709410e648d8$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $3974709410e648d8$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $3974709410e648d8$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $8299f902fbe20788$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $8299f902fbe20788$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$3974709410e648d8$var$_queries = new WeakMap();








var $f0d32793e98a6b8a$var$_observers, $f0d32793e98a6b8a$var$_defaultOptions, $f0d32793e98a6b8a$var$_mutationCache, $f0d32793e98a6b8a$var$_retryer, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn;
var $f0d32793e98a6b8a$export$17b8b19c814bcf56 = class extends (0, $ab0a37c55d07197c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $f0d32793e98a6b8a$var$_dispatch);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $f0d32793e98a6b8a$var$_observers, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $f0d32793e98a6b8a$var$_defaultOptions, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $f0d32793e98a6b8a$var$_mutationCache, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $f0d32793e98a6b8a$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $f0d32793e98a6b8a$var$_defaultOptions, config.defaultOptions);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $f0d32793e98a6b8a$var$_mutationCache, config.mutationCache);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $f0d32793e98a6b8a$var$_observers, []);
        this.state = config.state || $f0d32793e98a6b8a$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_observers).includes(observer)) {
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $f0d32793e98a6b8a$var$_observers, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $f0d32793e98a6b8a$var$_retryer, (0, $7bad956f3d5bc591$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $f0d32793e98a6b8a$var$_dispatch, $f0d32793e98a6b8a$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$f0d32793e98a6b8a$var$_observers = new WeakMap();
$f0d32793e98a6b8a$var$_defaultOptions = new WeakMap();
$f0d32793e98a6b8a$var$_mutationCache = new WeakMap();
$f0d32793e98a6b8a$var$_retryer = new WeakMap();
$f0d32793e98a6b8a$var$_dispatch = new WeakSet();
$f0d32793e98a6b8a$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $7bad956f3d5bc591$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $f0d32793e98a6b8a$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $f0d32793e98a6b8a$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $03cf6a5f523bb73b$var$_mutations, $03cf6a5f523bb73b$var$_mutationId, $03cf6a5f523bb73b$var$_resuming;
var $03cf6a5f523bb73b$export$1fcfd9a244434844 = class extends (0, $cd2d669aebb9a53c$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $03cf6a5f523bb73b$var$_mutations, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $03cf6a5f523bb73b$var$_mutationId, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $03cf6a5f523bb73b$var$_resuming, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $03cf6a5f523bb73b$var$_mutations, []);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $03cf6a5f523bb73b$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $f0d32793e98a6b8a$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $c3affd701a8324c3$export$b1fe7cbb4502036b)(this, $03cf6a5f523bb73b$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $03cf6a5f523bb73b$var$_mutations, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations).find((mutation)=>(0, $8299f902fbe20788$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations).filter((mutation)=>(0, $8299f902fbe20788$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $03cf6a5f523bb73b$var$_resuming, ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $8299f902fbe20788$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $03cf6a5f523bb73b$var$_resuming, void 0);
        }));
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $03cf6a5f523bb73b$var$_resuming);
    }
};
$03cf6a5f523bb73b$var$_mutations = new WeakMap();
$03cf6a5f523bb73b$var$_mutationId = new WeakMap();
$03cf6a5f523bb73b$var$_resuming = new WeakMap();







function $f2b71afd279b8398$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn || (()=>Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`)));
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $8299f902fbe20788$export$8c6246b73dd61f4a) : (0, $8299f902fbe20788$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $f2b71afd279b8398$var$getPreviousPageParam : $f2b71afd279b8398$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $f2b71afd279b8398$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $f2b71afd279b8398$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $f2b71afd279b8398$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $f2b71afd279b8398$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $f2b71afd279b8398$var$getNextPageParam(options, data) != null;
}
function $f2b71afd279b8398$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $f2b71afd279b8398$var$getPreviousPageParam(options, data) != null;
}


var $4357da78055da784$var$_queryCache, $4357da78055da784$var$_mutationCache, $4357da78055da784$var$_defaultOptions, $4357da78055da784$var$_queryDefaults, $4357da78055da784$var$_mutationDefaults, $4357da78055da784$var$_mountCount, $4357da78055da784$var$_unsubscribeFocus, $4357da78055da784$var$_unsubscribeOnline;
var $4357da78055da784$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_queryCache, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_mutationCache, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_defaultOptions, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_queryDefaults, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_mutationDefaults, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_mountCount, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_unsubscribeFocus, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $4357da78055da784$var$_unsubscribeOnline, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_queryCache, config.queryCache || new (0, $3974709410e648d8$export$5dde0cd941da8468)());
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_mutationCache, config.mutationCache || new (0, $03cf6a5f523bb73b$export$1fcfd9a244434844)());
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_defaultOptions, config.defaultOptions || {});
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_mountCount, 0);
    }
    mount() {
        (0, $c3affd701a8324c3$export$b1fe7cbb4502036b)(this, $4357da78055da784$var$_mountCount)._++;
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mountCount) !== 1) return;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_unsubscribeFocus, (0, $0f2c5acf39adb8a1$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $0f2c5acf39adb8a1$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).onFocus();
            }
        }));
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_unsubscribeOnline, (0, $818043d0434c3a93$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $818043d0434c3a93$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $c3affd701a8324c3$export$b1fe7cbb4502036b)(this, $4357da78055da784$var$_mountCount)._--;
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mountCount) !== 0) return;
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_unsubscribeFocus, void 0);
        (_b = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        return (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        return cachedData !== void 0 ? Promise.resolve(cachedData) : this.fetchQuery(options);
    }
    getQueriesData(filters) {
        return this.getQueryCache().findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).find({
            queryKey: queryKey
        });
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $8299f902fbe20788$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return void 0;
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        return (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache);
        (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $8299f902fbe20788$export$8793edee2d425525)).catch((0, $8299f902fbe20788$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $8299f902fbe20788$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $8299f902fbe20788$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $8299f902fbe20788$export$8793edee2d425525)).catch((0, $8299f902fbe20788$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $f2b71afd279b8398$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $8299f902fbe20788$export$8793edee2d425525)).catch((0, $8299f902fbe20788$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mutationCache).resumePausedMutations();
    }
    getQueryCache() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache);
    }
    getMutationCache() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $4357da78055da784$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryDefaults).set((0, $8299f902fbe20788$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $8299f902fbe20788$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mutationDefaults).set((0, $8299f902fbe20788$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $8299f902fbe20788$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_defaultOptions).queries,
            ...(options == null ? void 0 : options.queryKey) && this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $8299f902fbe20788$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.throwOnError === "undefined") defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (typeof defaultedOptions.networkMode === "undefined" && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_queryCache).clear();
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $4357da78055da784$var$_mutationCache).clear();
    }
};
$4357da78055da784$var$_queryCache = new WeakMap();
$4357da78055da784$var$_mutationCache = new WeakMap();
$4357da78055da784$var$_defaultOptions = new WeakMap();
$4357da78055da784$var$_queryDefaults = new WeakMap();
$4357da78055da784$var$_mutationDefaults = new WeakMap();
$4357da78055da784$var$_mountCount = new WeakMap();
$4357da78055da784$var$_unsubscribeFocus = new WeakMap();
$4357da78055da784$var$_unsubscribeOnline = new WeakMap();


var $2hDQc = parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");
"use client";
var $97855a2dd31730f4$export$da112d31b0149f31 = $2hDQc.createContext(void 0);
var $97855a2dd31730f4$export$22e77b9572c4fded = (queryClient)=>{
    const client = $2hDQc.useContext($97855a2dd31730f4$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $97855a2dd31730f4$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $2hDQc.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $592Nh.jsx)($97855a2dd31730f4$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $2hDQc = parcelRequire("2hDQc");

var $gWoNj = parcelRequire("gWoNj");
var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");
parcelRequire("2hDQc");


var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");
const $4d6621ab3b67b01b$var$ThemeContext = /*#__PURE__*/ $2hDQc.createContext(null);
var $4d6621ab3b67b01b$export$2e2bcd8739ae039 = $4d6621ab3b67b01b$var$ThemeContext;



var $2hDQc = parcelRequire("2hDQc");

function $7edd3af832bda87b$export$2e2bcd8739ae039() {
    const theme = $2hDQc.useContext((0, $4d6621ab3b67b01b$export$2e2bcd8739ae039));
    return theme;
}


const $fcc7b7f736385fd6$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $fcc7b7f736385fd6$export$2e2bcd8739ae039 = $fcc7b7f736385fd6$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $592Nh = parcelRequire("592Nh");
function $4f81ade18b7213a0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kxIgO.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $4f81ade18b7213a0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $7edd3af832bda87b$export$2e2bcd8739ae039)();
    const theme = $2hDQc.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $4f81ade18b7213a0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $fcc7b7f736385fd6$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $4d6621ab3b67b01b$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $4f81ade18b7213a0$export$2e2bcd8739ae039 = $4f81ade18b7213a0$var$ThemeProvider;



parcelRequire("3NAKi");
var $9INUU = parcelRequire("9INUU");

var $hixEE = parcelRequire("hixEE");

var $592Nh = parcelRequire("592Nh");
"use client";
const $8ff2f3644543fa73$var$EMPTY_THEME = {};
function $8ff2f3644543fa73$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2hDQc.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kxIgO.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kxIgO.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kxIgO.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $8ff2f3644543fa73$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $hixEE.default)($8ff2f3644543fa73$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $7edd3af832bda87b$export$2e2bcd8739ae039)() || $8ff2f3644543fa73$var$EMPTY_THEME;
    const engineTheme = $8ff2f3644543fa73$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $8ff2f3644543fa73$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $4f81ade18b7213a0$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $9INUU.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $8ff2f3644543fa73$export$2e2bcd8739ae039 = $8ff2f3644543fa73$var$ThemeProvider;



var $3apk9 = parcelRequire("3apk9");

var $592Nh = parcelRequire("592Nh");
"use client";
const $475d001d26d8ffa6$var$_excluded = [
    "theme"
];
function $475d001d26d8ffa6$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $gZOiq.default)(_ref, $475d001d26d8ffa6$var$_excluded);
    const scopedTheme = themeInput[0, $3apk9.default];
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8ff2f3644543fa73$export$2e2bcd8739ae039), (0, $kxIgO.default)({}, props, {
        themeId: scopedTheme ? (0, $3apk9.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



function $9773b6a5491c527c$export$2e2bcd8739ae039() {
    return $9773b6a5491c527c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9773b6a5491c527c$export$2e2bcd8739ae039.apply(null, arguments);
}


var $f65046485b965c63$exports = {};
"use strict";
Object.defineProperty($f65046485b965c63$exports, "__esModule", {
    value: true
});
function $f65046485b965c63$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f65046485b965c63$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f65046485b965c63$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f65046485b965c63$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f65046485b965c63$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f65046485b965c63$var$_extends() {
    $f65046485b965c63$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f65046485b965c63$var$_extends.apply(this, arguments);
}
function $f65046485b965c63$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $f65046485b965c63$var$_setPrototypeOf(subClass, superClass);
}
function $f65046485b965c63$var$_getPrototypeOf(o) {
    $f65046485b965c63$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f65046485b965c63$var$_getPrototypeOf(o);
}
function $f65046485b965c63$var$_setPrototypeOf(o, p) {
    $f65046485b965c63$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f65046485b965c63$var$_setPrototypeOf(o, p);
}
function $f65046485b965c63$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f65046485b965c63$var$_construct(Parent, args, Class) {
    if ($f65046485b965c63$var$_isNativeReflectConstruct()) $f65046485b965c63$var$_construct = Reflect.construct.bind();
    else $f65046485b965c63$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $f65046485b965c63$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $f65046485b965c63$var$_construct.apply(null, arguments);
}
function $f65046485b965c63$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $f65046485b965c63$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $f65046485b965c63$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$f65046485b965c63$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $f65046485b965c63$var$_construct(Class, arguments, $f65046485b965c63$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $f65046485b965c63$var$_setPrototypeOf(Wrapper, Class);
    };
    return $f65046485b965c63$var$_wrapNativeSuper(Class);
}
function $f65046485b965c63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f65046485b965c63$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f65046485b965c63$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f65046485b965c63$var$_arrayLikeToArray(o, minLen);
}
function $f65046485b965c63$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f65046485b965c63$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f65046485b965c63$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f65046485b965c63$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f65046485b965c63$var$_toPropertyKey(arg) {
    var key = $f65046485b965c63$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $f65046485b965c63$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $f65046485b965c63$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $f65046485b965c63$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $f65046485b965c63$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $f65046485b965c63$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $f65046485b965c63$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $f65046485b965c63$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $f65046485b965c63$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $f65046485b965c63$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $f65046485b965c63$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $f65046485b965c63$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($f65046485b965c63$var$LuxonError);
/**
 * @private
 */ var $f65046485b965c63$var$n = "numeric", $f65046485b965c63$var$s = "short", $f65046485b965c63$var$l = "long";
var $f65046485b965c63$var$DATE_SHORT = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$n,
    day: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATE_MED = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$s,
    day: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATE_MED_WITH_WEEKDAY = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$s,
    day: $f65046485b965c63$var$n,
    weekday: $f65046485b965c63$var$s
};
var $f65046485b965c63$var$DATE_FULL = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$l,
    day: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATE_HUGE = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$l,
    day: $f65046485b965c63$var$n,
    weekday: $f65046485b965c63$var$l
};
var $f65046485b965c63$var$TIME_SIMPLE = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$TIME_WITH_SECONDS = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$TIME_WITH_SHORT_OFFSET = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    timeZoneName: $f65046485b965c63$var$s
};
var $f65046485b965c63$var$TIME_WITH_LONG_OFFSET = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    timeZoneName: $f65046485b965c63$var$l
};
var $f65046485b965c63$var$TIME_24_SIMPLE = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    hourCycle: "h23"
};
var $f65046485b965c63$var$TIME_24_WITH_SECONDS = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    hourCycle: "h23"
};
var $f65046485b965c63$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    hourCycle: "h23",
    timeZoneName: $f65046485b965c63$var$s
};
var $f65046485b965c63$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    hourCycle: "h23",
    timeZoneName: $f65046485b965c63$var$l
};
var $f65046485b965c63$var$DATETIME_SHORT = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$n,
    day: $f65046485b965c63$var$n,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$n,
    day: $f65046485b965c63$var$n,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATETIME_MED = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$s,
    day: $f65046485b965c63$var$n,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATETIME_MED_WITH_SECONDS = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$s,
    day: $f65046485b965c63$var$n,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$s,
    day: $f65046485b965c63$var$n,
    weekday: $f65046485b965c63$var$s,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n
};
var $f65046485b965c63$var$DATETIME_FULL = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$l,
    day: $f65046485b965c63$var$n,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    timeZoneName: $f65046485b965c63$var$s
};
var $f65046485b965c63$var$DATETIME_FULL_WITH_SECONDS = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$l,
    day: $f65046485b965c63$var$n,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    timeZoneName: $f65046485b965c63$var$s
};
var $f65046485b965c63$var$DATETIME_HUGE = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$l,
    day: $f65046485b965c63$var$n,
    weekday: $f65046485b965c63$var$l,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    timeZoneName: $f65046485b965c63$var$l
};
var $f65046485b965c63$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $f65046485b965c63$var$n,
    month: $f65046485b965c63$var$l,
    day: $f65046485b965c63$var$n,
    weekday: $f65046485b965c63$var$l,
    hour: $f65046485b965c63$var$n,
    minute: $f65046485b965c63$var$n,
    second: $f65046485b965c63$var$n,
    timeZoneName: $f65046485b965c63$var$l
};
/**
 * @interface
 */ var $f65046485b965c63$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $f65046485b965c63$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $f65046485b965c63$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $f65046485b965c63$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $f65046485b965c63$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $f65046485b965c63$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $f65046485b965c63$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $f65046485b965c63$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $f65046485b965c63$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $f65046485b965c63$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $f65046485b965c63$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $f65046485b965c63$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $f65046485b965c63$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $f65046485b965c63$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $f65046485b965c63$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $f65046485b965c63$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($f65046485b965c63$var$singleton$1 === null) $f65046485b965c63$var$singleton$1 = new SystemZone();
                return $f65046485b965c63$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($f65046485b965c63$var$Zone);
var $f65046485b965c63$var$dtfCache = {};
function $f65046485b965c63$var$makeDTF(zone) {
    if (!$f65046485b965c63$var$dtfCache[zone]) $f65046485b965c63$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $f65046485b965c63$var$dtfCache[zone];
}
var $f65046485b965c63$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $f65046485b965c63$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $f65046485b965c63$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $f65046485b965c63$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$f65046485b965c63$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $f65046485b965c63$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $f65046485b965c63$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $f65046485b965c63$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$f65046485b965c63$var$ianaZoneCache[name]) $f65046485b965c63$var$ianaZoneCache[name] = new IANAZone(name);
        return $f65046485b965c63$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $f65046485b965c63$var$ianaZoneCache = {};
        $f65046485b965c63$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $f65046485b965c63$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $f65046485b965c63$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $f65046485b965c63$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $f65046485b965c63$var$partsOffset(dtf, date) : $f65046485b965c63$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $f65046485b965c63$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $f65046485b965c63$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($f65046485b965c63$var$Zone);
var $f65046485b965c63$var$_excluded = [
    "base"
], $f65046485b965c63$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $f65046485b965c63$var$intlLFCache = {};
function $f65046485b965c63$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $f65046485b965c63$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $f65046485b965c63$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $f65046485b965c63$var$intlDTCache = {};
function $f65046485b965c63$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $f65046485b965c63$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $f65046485b965c63$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $f65046485b965c63$var$intlNumCache = {};
function $f65046485b965c63$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $f65046485b965c63$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $f65046485b965c63$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $f65046485b965c63$var$intlRelCache = {};
function $f65046485b965c63$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $f65046485b965c63$var$_objectWithoutPropertiesLoose(_opts, $f65046485b965c63$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $f65046485b965c63$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $f65046485b965c63$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $f65046485b965c63$var$sysLocaleCache = null;
function $f65046485b965c63$var$systemLocale() {
    if ($f65046485b965c63$var$sysLocaleCache) return $f65046485b965c63$var$sysLocaleCache;
    else {
        $f65046485b965c63$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $f65046485b965c63$var$sysLocaleCache;
    }
}
function $f65046485b965c63$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $f65046485b965c63$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $f65046485b965c63$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $f65046485b965c63$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $f65046485b965c63$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $f65046485b965c63$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $f65046485b965c63$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $f65046485b965c63$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $f65046485b965c63$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $f65046485b965c63$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $f65046485b965c63$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $f65046485b965c63$var$_objectWithoutPropertiesLoose(opts, $f65046485b965c63$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $f65046485b965c63$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $f65046485b965c63$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $f65046485b965c63$var$roundTo(i, 3);
            return $f65046485b965c63$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $f65046485b965c63$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $f65046485b965c63$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $f65046485b965c63$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $f65046485b965c63$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $f65046485b965c63$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $f65046485b965c63$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $f65046485b965c63$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $f65046485b965c63$var$hasRelative()) this.rtf = $f65046485b965c63$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $f65046485b965c63$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $f65046485b965c63$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $f65046485b965c63$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $f65046485b965c63$var$systemLocale());
        var numberingSystemR = numberingSystem || $f65046485b965c63$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $f65046485b965c63$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $f65046485b965c63$var$sysLocaleCache = null;
        $f65046485b965c63$var$intlDTCache = {};
        $f65046485b965c63$var$intlNumCache = {};
        $f65046485b965c63$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $f65046485b965c63$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $f65046485b965c63$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($f65046485b965c63$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($f65046485b965c63$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $f65046485b965c63$var$listStuff(this, length, $f65046485b965c63$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $f65046485b965c63$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $f65046485b965c63$var$listStuff(this, length, $f65046485b965c63$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $f65046485b965c63$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $f65046485b965c63$var$listStuff(this, undefined, function() {
            return $f65046485b965c63$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $f65046485b965c63$var$DateTime.utc(2016, 11, 13, 9),
                    $f65046485b965c63$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $f65046485b965c63$var$listStuff(this, length, $f65046485b965c63$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $f65046485b965c63$var$DateTime.utc(-40, 1, 1),
                $f65046485b965c63$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $f65046485b965c63$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $f65046485b965c63$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $f65046485b965c63$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $f65046485b965c63$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $f65046485b965c63$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $f65046485b965c63$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $f65046485b965c63$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $f65046485b965c63$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $f65046485b965c63$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($f65046485b965c63$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $f65046485b965c63$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $f65046485b965c63$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $f65046485b965c63$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $f65046485b965c63$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($f65046485b965c63$var$singleton === null) $f65046485b965c63$var$singleton = new FixedOffsetZone(0);
                return $f65046485b965c63$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($f65046485b965c63$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $f65046485b965c63$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $f65046485b965c63$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $f65046485b965c63$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($f65046485b965c63$var$Zone);
/**
 * @private
 */ function $f65046485b965c63$var$normalizeZone(input, defaultZone) {
    if ($f65046485b965c63$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $f65046485b965c63$var$Zone) return input;
    else if ($f65046485b965c63$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $f65046485b965c63$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $f65046485b965c63$var$FixedOffsetZone.utcInstance;
        else return $f65046485b965c63$var$FixedOffsetZone.parseSpecifier(lowered) || $f65046485b965c63$var$IANAZone.create(input);
    } else if ($f65046485b965c63$var$isNumber(input)) return $f65046485b965c63$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $f65046485b965c63$var$InvalidZone(input);
}
var $f65046485b965c63$var$now = function now() {
    return Date.now();
}, $f65046485b965c63$var$defaultZone = "system", $f65046485b965c63$var$defaultLocale = null, $f65046485b965c63$var$defaultNumberingSystem = null, $f65046485b965c63$var$defaultOutputCalendar = null, $f65046485b965c63$var$twoDigitCutoffYear = 60, $f65046485b965c63$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $f65046485b965c63$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $f65046485b965c63$var$Locale.resetCache();
        $f65046485b965c63$var$IANAZone.resetCache();
    };
    $f65046485b965c63$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $f65046485b965c63$var$now;
            },
            set: function set(n) {
                $f65046485b965c63$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $f65046485b965c63$var$normalizeZone($f65046485b965c63$var$defaultZone, $f65046485b965c63$var$SystemZone.instance);
            },
            set: function set(zone) {
                $f65046485b965c63$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $f65046485b965c63$var$defaultLocale;
            },
            set: function set(locale) {
                $f65046485b965c63$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $f65046485b965c63$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $f65046485b965c63$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $f65046485b965c63$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $f65046485b965c63$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $f65046485b965c63$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $f65046485b965c63$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $f65046485b965c63$var$throwOnInvalid;
            },
            set: function set(t) {
                $f65046485b965c63$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
/**
 * @private
 */ // TYPES
function $f65046485b965c63$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $f65046485b965c63$var$isNumber(o) {
    return typeof o === "number";
}
function $f65046485b965c63$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $f65046485b965c63$var$isString(o) {
    return typeof o === "string";
}
function $f65046485b965c63$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $f65046485b965c63$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $f65046485b965c63$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $f65046485b965c63$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $f65046485b965c63$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $f65046485b965c63$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
// NUMBERS AND STRINGS
function $f65046485b965c63$var$integerBetween(thing, bottom, top) {
    return $f65046485b965c63$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $f65046485b965c63$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $f65046485b965c63$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $f65046485b965c63$var$parseInteger(string) {
    if ($f65046485b965c63$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $f65046485b965c63$var$parseFloating(string) {
    if ($f65046485b965c63$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $f65046485b965c63$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($f65046485b965c63$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $f65046485b965c63$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $f65046485b965c63$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $f65046485b965c63$var$daysInYear(year) {
    return $f65046485b965c63$var$isLeapYear(year) ? 366 : 365;
}
function $f65046485b965c63$var$daysInMonth(year, month) {
    var modMonth = $f65046485b965c63$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $f65046485b965c63$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $f65046485b965c63$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
function $f65046485b965c63$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $f65046485b965c63$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $f65046485b965c63$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $f65046485b965c63$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $f65046485b965c63$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $f65046485b965c63$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $f65046485b965c63$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $f65046485b965c63$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $f65046485b965c63$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($f65046485b965c63$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $f65046485b965c63$var$asNumber(v);
    }
    return normalized;
}
function $f65046485b965c63$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $f65046485b965c63$var$padStart(hours, 2) + ":" + $f65046485b965c63$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $f65046485b965c63$var$padStart(hours, 2) + $f65046485b965c63$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $f65046485b965c63$var$timeObject(obj) {
    return $f65046485b965c63$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $f65046485b965c63$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $f65046485b965c63$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $f65046485b965c63$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $f65046485b965c63$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($f65046485b965c63$var$monthsNarrow);
        case "short":
            return [].concat($f65046485b965c63$var$monthsShort);
        case "long":
            return [].concat($f65046485b965c63$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $f65046485b965c63$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $f65046485b965c63$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $f65046485b965c63$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $f65046485b965c63$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($f65046485b965c63$var$weekdaysNarrow);
        case "short":
            return [].concat($f65046485b965c63$var$weekdaysShort);
        case "long":
            return [].concat($f65046485b965c63$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $f65046485b965c63$var$meridiems = [
    "AM",
    "PM"
];
var $f65046485b965c63$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $f65046485b965c63$var$erasShort = [
    "BC",
    "AD"
];
var $f65046485b965c63$var$erasNarrow = [
    "B",
    "A"
];
function $f65046485b965c63$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($f65046485b965c63$var$erasNarrow);
        case "short":
            return [].concat($f65046485b965c63$var$erasShort);
        case "long":
            return [].concat($f65046485b965c63$var$erasLong);
        default:
            return null;
    }
}
function $f65046485b965c63$var$meridiemForDateTime(dt) {
    return $f65046485b965c63$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $f65046485b965c63$var$weekdayForDateTime(dt, length) {
    return $f65046485b965c63$var$weekdays(length)[dt.weekday - 1];
}
function $f65046485b965c63$var$monthForDateTime(dt, length) {
    return $f65046485b965c63$var$months(length)[dt.month - 1];
}
function $f65046485b965c63$var$eraForDateTime(dt, length) {
    return $f65046485b965c63$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $f65046485b965c63$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $f65046485b965c63$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $f65046485b965c63$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $f65046485b965c63$var$_macroTokenToFormatOpts = {
    D: $f65046485b965c63$var$DATE_SHORT,
    DD: $f65046485b965c63$var$DATE_MED,
    DDD: $f65046485b965c63$var$DATE_FULL,
    DDDD: $f65046485b965c63$var$DATE_HUGE,
    t: $f65046485b965c63$var$TIME_SIMPLE,
    tt: $f65046485b965c63$var$TIME_WITH_SECONDS,
    ttt: $f65046485b965c63$var$TIME_WITH_SHORT_OFFSET,
    tttt: $f65046485b965c63$var$TIME_WITH_LONG_OFFSET,
    T: $f65046485b965c63$var$TIME_24_SIMPLE,
    TT: $f65046485b965c63$var$TIME_24_WITH_SECONDS,
    TTT: $f65046485b965c63$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $f65046485b965c63$var$TIME_24_WITH_LONG_OFFSET,
    f: $f65046485b965c63$var$DATETIME_SHORT,
    ff: $f65046485b965c63$var$DATETIME_MED,
    fff: $f65046485b965c63$var$DATETIME_FULL,
    ffff: $f65046485b965c63$var$DATETIME_HUGE,
    F: $f65046485b965c63$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $f65046485b965c63$var$DATETIME_MED_WITH_SECONDS,
    FFF: $f65046485b965c63$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $f65046485b965c63$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $f65046485b965c63$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $f65046485b965c63$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $f65046485b965c63$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $f65046485b965c63$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $f65046485b965c63$var$padStart(n, p);
        var opts = $f65046485b965c63$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $f65046485b965c63$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $f65046485b965c63$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $f65046485b965c63$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $f65046485b965c63$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $f65046485b965c63$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $f65046485b965c63$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $f65046485b965c63$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $f65046485b965c63$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $f65046485b965c63$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $f65046485b965c63$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $f65046485b965c63$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $f65046485b965c63$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $f65046485b965c63$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $f65046485b965c63$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $f65046485b965c63$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $f65046485b965c63$var$isoExtendedZone = "(?:" + $f65046485b965c63$var$offsetRegex.source + "?(?:\\[(" + $f65046485b965c63$var$ianaRegex.source + ")\\])?)?";
var $f65046485b965c63$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $f65046485b965c63$var$isoTimeRegex = RegExp("" + $f65046485b965c63$var$isoTimeBaseRegex.source + $f65046485b965c63$var$isoExtendedZone);
var $f65046485b965c63$var$isoTimeExtensionRegex = RegExp("(?:T" + $f65046485b965c63$var$isoTimeRegex.source + ")?");
var $f65046485b965c63$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $f65046485b965c63$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $f65046485b965c63$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $f65046485b965c63$var$extractISOWeekData = $f65046485b965c63$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $f65046485b965c63$var$extractISOOrdinalData = $f65046485b965c63$var$simpleParse("year", "ordinal");
var $f65046485b965c63$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $f65046485b965c63$var$sqlTimeRegex = RegExp($f65046485b965c63$var$isoTimeBaseRegex.source + " ?(?:" + $f65046485b965c63$var$offsetRegex.source + "|(" + $f65046485b965c63$var$ianaRegex.source + "))?");
var $f65046485b965c63$var$sqlTimeExtensionRegex = RegExp("(?: " + $f65046485b965c63$var$sqlTimeRegex.source + ")?");
function $f65046485b965c63$var$int(match, pos, fallback) {
    var m = match[pos];
    return $f65046485b965c63$var$isUndefined(m) ? fallback : $f65046485b965c63$var$parseInteger(m);
}
function $f65046485b965c63$var$extractISOYmd(match, cursor) {
    var item = {
        year: $f65046485b965c63$var$int(match, cursor),
        month: $f65046485b965c63$var$int(match, cursor + 1, 1),
        day: $f65046485b965c63$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $f65046485b965c63$var$extractISOTime(match, cursor) {
    var item = {
        hours: $f65046485b965c63$var$int(match, cursor, 0),
        minutes: $f65046485b965c63$var$int(match, cursor + 1, 0),
        seconds: $f65046485b965c63$var$int(match, cursor + 2, 0),
        milliseconds: $f65046485b965c63$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $f65046485b965c63$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $f65046485b965c63$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $f65046485b965c63$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $f65046485b965c63$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $f65046485b965c63$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $f65046485b965c63$var$isoTimeOnly = RegExp("^T?" + $f65046485b965c63$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $f65046485b965c63$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $f65046485b965c63$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($f65046485b965c63$var$parseFloating(yearStr)),
            months: maybeNegate($f65046485b965c63$var$parseFloating(monthStr)),
            weeks: maybeNegate($f65046485b965c63$var$parseFloating(weekStr)),
            days: maybeNegate($f65046485b965c63$var$parseFloating(dayStr)),
            hours: maybeNegate($f65046485b965c63$var$parseFloating(hourStr)),
            minutes: maybeNegate($f65046485b965c63$var$parseFloating(minuteStr)),
            seconds: maybeNegate($f65046485b965c63$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($f65046485b965c63$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $f65046485b965c63$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $f65046485b965c63$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $f65046485b965c63$var$untruncateYear($f65046485b965c63$var$parseInteger(yearStr)) : $f65046485b965c63$var$parseInteger(yearStr),
        month: $f65046485b965c63$var$monthsShort.indexOf(monthStr) + 1,
        day: $f65046485b965c63$var$parseInteger(dayStr),
        hour: $f65046485b965c63$var$parseInteger(hourStr),
        minute: $f65046485b965c63$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $f65046485b965c63$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $f65046485b965c63$var$weekdaysLong.indexOf(weekdayStr) + 1 : $f65046485b965c63$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $f65046485b965c63$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $f65046485b965c63$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $f65046485b965c63$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $f65046485b965c63$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $f65046485b965c63$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $f65046485b965c63$var$FixedOffsetZone(offset)
    ];
}
function $f65046485b965c63$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $f65046485b965c63$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $f65046485b965c63$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $f65046485b965c63$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $f65046485b965c63$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $f65046485b965c63$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $f65046485b965c63$var$FixedOffsetZone.utcInstance
    ];
}
function $f65046485b965c63$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $f65046485b965c63$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $f65046485b965c63$var$FixedOffsetZone.utcInstance
    ];
}
var $f65046485b965c63$var$isoYmdWithTimeExtensionRegex = $f65046485b965c63$var$combineRegexes($f65046485b965c63$var$isoYmdRegex, $f65046485b965c63$var$isoTimeExtensionRegex);
var $f65046485b965c63$var$isoWeekWithTimeExtensionRegex = $f65046485b965c63$var$combineRegexes($f65046485b965c63$var$isoWeekRegex, $f65046485b965c63$var$isoTimeExtensionRegex);
var $f65046485b965c63$var$isoOrdinalWithTimeExtensionRegex = $f65046485b965c63$var$combineRegexes($f65046485b965c63$var$isoOrdinalRegex, $f65046485b965c63$var$isoTimeExtensionRegex);
var $f65046485b965c63$var$isoTimeCombinedRegex = $f65046485b965c63$var$combineRegexes($f65046485b965c63$var$isoTimeRegex);
var $f65046485b965c63$var$extractISOYmdTimeAndOffset = $f65046485b965c63$var$combineExtractors($f65046485b965c63$var$extractISOYmd, $f65046485b965c63$var$extractISOTime, $f65046485b965c63$var$extractISOOffset, $f65046485b965c63$var$extractIANAZone);
var $f65046485b965c63$var$extractISOWeekTimeAndOffset = $f65046485b965c63$var$combineExtractors($f65046485b965c63$var$extractISOWeekData, $f65046485b965c63$var$extractISOTime, $f65046485b965c63$var$extractISOOffset, $f65046485b965c63$var$extractIANAZone);
var $f65046485b965c63$var$extractISOOrdinalDateAndTime = $f65046485b965c63$var$combineExtractors($f65046485b965c63$var$extractISOOrdinalData, $f65046485b965c63$var$extractISOTime, $f65046485b965c63$var$extractISOOffset, $f65046485b965c63$var$extractIANAZone);
var $f65046485b965c63$var$extractISOTimeAndOffset = $f65046485b965c63$var$combineExtractors($f65046485b965c63$var$extractISOTime, $f65046485b965c63$var$extractISOOffset, $f65046485b965c63$var$extractIANAZone);
/*
 * @private
 */ function $f65046485b965c63$var$parseISODate(s) {
    return $f65046485b965c63$var$parse(s, [
        $f65046485b965c63$var$isoYmdWithTimeExtensionRegex,
        $f65046485b965c63$var$extractISOYmdTimeAndOffset
    ], [
        $f65046485b965c63$var$isoWeekWithTimeExtensionRegex,
        $f65046485b965c63$var$extractISOWeekTimeAndOffset
    ], [
        $f65046485b965c63$var$isoOrdinalWithTimeExtensionRegex,
        $f65046485b965c63$var$extractISOOrdinalDateAndTime
    ], [
        $f65046485b965c63$var$isoTimeCombinedRegex,
        $f65046485b965c63$var$extractISOTimeAndOffset
    ]);
}
function $f65046485b965c63$var$parseRFC2822Date(s) {
    return $f65046485b965c63$var$parse($f65046485b965c63$var$preprocessRFC2822(s), [
        $f65046485b965c63$var$rfc2822,
        $f65046485b965c63$var$extractRFC2822
    ]);
}
function $f65046485b965c63$var$parseHTTPDate(s) {
    return $f65046485b965c63$var$parse(s, [
        $f65046485b965c63$var$rfc1123,
        $f65046485b965c63$var$extractRFC1123Or850
    ], [
        $f65046485b965c63$var$rfc850,
        $f65046485b965c63$var$extractRFC1123Or850
    ], [
        $f65046485b965c63$var$ascii,
        $f65046485b965c63$var$extractASCII
    ]);
}
function $f65046485b965c63$var$parseISODuration(s) {
    return $f65046485b965c63$var$parse(s, [
        $f65046485b965c63$var$isoDuration,
        $f65046485b965c63$var$extractISODuration
    ]);
}
var $f65046485b965c63$var$extractISOTimeOnly = $f65046485b965c63$var$combineExtractors($f65046485b965c63$var$extractISOTime);
function $f65046485b965c63$var$parseISOTimeOnly(s) {
    return $f65046485b965c63$var$parse(s, [
        $f65046485b965c63$var$isoTimeOnly,
        $f65046485b965c63$var$extractISOTimeOnly
    ]);
}
var $f65046485b965c63$var$sqlYmdWithTimeExtensionRegex = $f65046485b965c63$var$combineRegexes($f65046485b965c63$var$sqlYmdRegex, $f65046485b965c63$var$sqlTimeExtensionRegex);
var $f65046485b965c63$var$sqlTimeCombinedRegex = $f65046485b965c63$var$combineRegexes($f65046485b965c63$var$sqlTimeRegex);
var $f65046485b965c63$var$extractISOTimeOffsetAndIANAZone = $f65046485b965c63$var$combineExtractors($f65046485b965c63$var$extractISOTime, $f65046485b965c63$var$extractISOOffset, $f65046485b965c63$var$extractIANAZone);
function $f65046485b965c63$var$parseSQL(s) {
    return $f65046485b965c63$var$parse(s, [
        $f65046485b965c63$var$sqlYmdWithTimeExtensionRegex,
        $f65046485b965c63$var$extractISOYmdTimeAndOffset
    ], [
        $f65046485b965c63$var$sqlTimeCombinedRegex,
        $f65046485b965c63$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $f65046485b965c63$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $f65046485b965c63$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $f65046485b965c63$var$casualMatrix = $f65046485b965c63$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $f65046485b965c63$var$lowOrderMatrix), $f65046485b965c63$var$daysInYearAccurate = 365.2425, $f65046485b965c63$var$daysInMonthAccurate = 30.436875, $f65046485b965c63$var$accurateMatrix = $f65046485b965c63$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $f65046485b965c63$var$daysInYearAccurate / 7,
        days: $f65046485b965c63$var$daysInYearAccurate,
        hours: $f65046485b965c63$var$daysInYearAccurate * 24,
        minutes: $f65046485b965c63$var$daysInYearAccurate * 1440,
        seconds: $f65046485b965c63$var$daysInYearAccurate * 86400,
        milliseconds: $f65046485b965c63$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $f65046485b965c63$var$daysInYearAccurate / 28,
        days: $f65046485b965c63$var$daysInYearAccurate / 4,
        hours: $f65046485b965c63$var$daysInYearAccurate * 24 / 4,
        minutes: $f65046485b965c63$var$daysInYearAccurate * 1440 / 4,
        seconds: $f65046485b965c63$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $f65046485b965c63$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $f65046485b965c63$var$daysInMonthAccurate / 7,
        days: $f65046485b965c63$var$daysInMonthAccurate,
        hours: $f65046485b965c63$var$daysInMonthAccurate * 24,
        minutes: $f65046485b965c63$var$daysInMonthAccurate * 1440,
        seconds: $f65046485b965c63$var$daysInMonthAccurate * 86400,
        milliseconds: $f65046485b965c63$var$daysInMonthAccurate * 86400000
    }
}, $f65046485b965c63$var$lowOrderMatrix);
// units ordered by size
var $f65046485b965c63$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $f65046485b965c63$var$reverseUnits = $f65046485b965c63$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $f65046485b965c63$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $f65046485b965c63$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $f65046485b965c63$var$Duration(conf);
}
function $f65046485b965c63$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $f65046485b965c63$var$_createForOfIteratorHelperLoose($f65046485b965c63$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $f65046485b965c63$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $f65046485b965c63$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $f65046485b965c63$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$f65046485b965c63$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $f65046485b965c63$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$f65046485b965c63$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $f65046485b965c63$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $f65046485b965c63$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $f65046485b965c63$var$accurateMatrix : $f65046485b965c63$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $f65046485b965c63$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $f65046485b965c63$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $f65046485b965c63$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $f65046485b965c63$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($f65046485b965c63$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $f65046485b965c63$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $f65046485b965c63$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $f65046485b965c63$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $f65046485b965c63$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $f65046485b965c63$var$Invalid ? reason : new $f65046485b965c63$var$Invalid(reason, explanation);
        if ($f65046485b965c63$var$Settings.throwOnInvalid) throw new $f65046485b965c63$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $f65046485b965c63$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $f65046485b965c63$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $f65046485b965c63$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $f65046485b965c63$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $f65046485b965c63$var$INVALID$2;
        var l = $f65046485b965c63$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($f65046485b965c63$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($f65046485b965c63$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($f65046485b965c63$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $f65046485b965c63$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $f65046485b965c63$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $f65046485b965c63$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $f65046485b965c63$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $f65046485b965c63$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $f65046485b965c63$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($f65046485b965c63$var$hasOwnProperty(dur.values, k) || $f65046485b965c63$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $f65046485b965c63$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $f65046485b965c63$var$asNumber(fn(this.values[k], k));
        }
        return $f65046485b965c63$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $f65046485b965c63$var$_extends({}, this.values, $f65046485b965c63$var$normalizeObject(values, Duration.normalizeUnit));
        return $f65046485b965c63$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $f65046485b965c63$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see second example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $f65046485b965c63$var$normalizeValues(this.matrix, vals);
        return $f65046485b965c63$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $f65046485b965c63$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $f65046485b965c63$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $f65046485b965c63$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($f65046485b965c63$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($f65046485b965c63$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $f65046485b965c63$var$normalizeValues(this.matrix, built);
        return $f65046485b965c63$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $f65046485b965c63$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $f65046485b965c63$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $f65046485b965c63$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $f65046485b965c63$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $f65046485b965c63$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $f65046485b965c63$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $f65046485b965c63$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $f65046485b965c63$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $f65046485b965c63$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $f65046485b965c63$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $f65046485b965c63$var$Invalid ? reason : new $f65046485b965c63$var$Invalid(reason, explanation);
        if ($f65046485b965c63$var$Settings.throwOnInvalid) throw new $f65046485b965c63$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $f65046485b965c63$var$friendlyDateTime(start), builtEnd = $f65046485b965c63$var$friendlyDateTime(end);
        var validateError = $f65046485b965c63$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $f65046485b965c63$var$Duration.fromDurationLike(duration), dt = $f65046485b965c63$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $f65046485b965c63$var$Duration.fromDurationLike(duration), dt = $f65046485b965c63$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $f65046485b965c63$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $f65046485b965c63$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $f65046485b965c63$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $f65046485b965c63$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */ ;
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($f65046485b965c63$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $f65046485b965c63$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $f65046485b965c63$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $f65046485b965c63$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $f65046485b965c63$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $f65046485b965c63$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $f65046485b965c63$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $f65046485b965c63$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $f65046485b965c63$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $f65046485b965c63$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $f65046485b965c63$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $f65046485b965c63$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $f65046485b965c63$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $f65046485b965c63$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $f65046485b965c63$var$Settings.defaultZone;
        var proto = $f65046485b965c63$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $f65046485b965c63$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $f65046485b965c63$var$normalizeZone(input, $f65046485b965c63$var$Settings.defaultZone);
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $f65046485b965c63$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $f65046485b965c63$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $f65046485b965c63$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $f65046485b965c63$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $f65046485b965c63$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $f65046485b965c63$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $f65046485b965c63$var$hasRelative()
        };
    };
    return Info;
}();
function $f65046485b965c63$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($f65046485b965c63$var$Duration.fromMillis(ms).as("days"));
}
function $f65046485b965c63$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $f65046485b965c63$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $f65046485b965c63$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $f65046485b965c63$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $f65046485b965c63$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $f65046485b965c63$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $f65046485b965c63$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $f65046485b965c63$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $f65046485b965c63$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $f65046485b965c63$var$hanidecChars = $f65046485b965c63$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $f65046485b965c63$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($f65046485b965c63$var$numberingSystems.hanidec) !== -1) value += $f65046485b965c63$var$hanidecChars.indexOf(str[i]);
            else for(var key in $f65046485b965c63$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $f65046485b965c63$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $f65046485b965c63$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $f65046485b965c63$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $f65046485b965c63$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $f65046485b965c63$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($f65046485b965c63$var$parseDigits(s));
        }
    };
}
var $f65046485b965c63$var$NBSP = String.fromCharCode(160);
var $f65046485b965c63$var$spaceOrNBSP = "[ " + $f65046485b965c63$var$NBSP + "]";
var $f65046485b965c63$var$spaceOrNBSPRegExp = new RegExp($f65046485b965c63$var$spaceOrNBSP, "g");
function $f65046485b965c63$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($f65046485b965c63$var$spaceOrNBSPRegExp, $f65046485b965c63$var$spaceOrNBSP);
}
function $f65046485b965c63$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($f65046485b965c63$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $f65046485b965c63$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($f65046485b965c63$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $f65046485b965c63$var$stripInsensitivities(s) === $f65046485b965c63$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $f65046485b965c63$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $f65046485b965c63$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $f65046485b965c63$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $f65046485b965c63$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $f65046485b965c63$var$unitForToken(token, loc) {
    var one = $f65046485b965c63$var$digitRegex(loc), two = $f65046485b965c63$var$digitRegex(loc, "{2}"), three = $f65046485b965c63$var$digitRegex(loc, "{3}"), four = $f65046485b965c63$var$digitRegex(loc, "{4}"), six = $f65046485b965c63$var$digitRegex(loc, "{6}"), oneOrTwo = $f65046485b965c63$var$digitRegex(loc, "{1,2}"), oneToThree = $f65046485b965c63$var$digitRegex(loc, "{1,3}"), oneToSix = $f65046485b965c63$var$digitRegex(loc, "{1,6}"), oneToNine = $f65046485b965c63$var$digitRegex(loc, "{1,9}"), twoToFour = $f65046485b965c63$var$digitRegex(loc, "{2,4}"), fourToSix = $f65046485b965c63$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($f65046485b965c63$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $f65046485b965c63$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $f65046485b965c63$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $f65046485b965c63$var$intUnit(oneToSix);
            case "yy":
                return $f65046485b965c63$var$intUnit(twoToFour, $f65046485b965c63$var$untruncateYear);
            case "yyyy":
                return $f65046485b965c63$var$intUnit(four);
            case "yyyyy":
                return $f65046485b965c63$var$intUnit(fourToSix);
            case "yyyyyy":
                return $f65046485b965c63$var$intUnit(six);
            // months
            case "M":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "MM":
                return $f65046485b965c63$var$intUnit(two);
            case "MMM":
                return $f65046485b965c63$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $f65046485b965c63$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "LL":
                return $f65046485b965c63$var$intUnit(two);
            case "LLL":
                return $f65046485b965c63$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $f65046485b965c63$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "dd":
                return $f65046485b965c63$var$intUnit(two);
            // ordinals
            case "o":
                return $f65046485b965c63$var$intUnit(oneToThree);
            case "ooo":
                return $f65046485b965c63$var$intUnit(three);
            // time
            case "HH":
                return $f65046485b965c63$var$intUnit(two);
            case "H":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "hh":
                return $f65046485b965c63$var$intUnit(two);
            case "h":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "mm":
                return $f65046485b965c63$var$intUnit(two);
            case "m":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "q":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "qq":
                return $f65046485b965c63$var$intUnit(two);
            case "s":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "ss":
                return $f65046485b965c63$var$intUnit(two);
            case "S":
                return $f65046485b965c63$var$intUnit(oneToThree);
            case "SSS":
                return $f65046485b965c63$var$intUnit(three);
            case "u":
                return $f65046485b965c63$var$simple(oneToNine);
            case "uu":
                return $f65046485b965c63$var$simple(oneOrTwo);
            case "uuu":
                return $f65046485b965c63$var$intUnit(one);
            // meridiem
            case "a":
                return $f65046485b965c63$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $f65046485b965c63$var$intUnit(four);
            case "kk":
                return $f65046485b965c63$var$intUnit(twoToFour, $f65046485b965c63$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $f65046485b965c63$var$intUnit(oneOrTwo);
            case "WW":
                return $f65046485b965c63$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $f65046485b965c63$var$intUnit(one);
            case "EEE":
                return $f65046485b965c63$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $f65046485b965c63$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $f65046485b965c63$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $f65046485b965c63$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $f65046485b965c63$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $f65046485b965c63$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $f65046485b965c63$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $f65046485b965c63$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $f65046485b965c63$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $f65046485b965c63$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $f65046485b965c63$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $f65046485b965c63$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $f65046485b965c63$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $f65046485b965c63$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($f65046485b965c63$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $f65046485b965c63$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$f65046485b965c63$var$isUndefined(matches.z)) zone = $f65046485b965c63$var$IANAZone.create(matches.z);
    if (!$f65046485b965c63$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $f65046485b965c63$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$f65046485b965c63$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$f65046485b965c63$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$f65046485b965c63$var$isUndefined(matches.u)) matches.S = $f65046485b965c63$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $f65046485b965c63$var$dummyDateTimeCache = null;
function $f65046485b965c63$var$getDummyDateTime() {
    if (!$f65046485b965c63$var$dummyDateTimeCache) $f65046485b965c63$var$dummyDateTimeCache = $f65046485b965c63$var$DateTime.fromMillis(1555555555555);
    return $f65046485b965c63$var$dummyDateTimeCache;
}
function $f65046485b965c63$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $f65046485b965c63$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $f65046485b965c63$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $f65046485b965c63$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $f65046485b965c63$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $f65046485b965c63$var$explainFromTokens(locale, input, format) {
    var tokens = $f65046485b965c63$var$expandMacroTokens($f65046485b965c63$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $f65046485b965c63$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $f65046485b965c63$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $f65046485b965c63$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $f65046485b965c63$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($f65046485b965c63$var$hasOwnProperty(matches, "a") && $f65046485b965c63$var$hasOwnProperty(matches, "H")) throw new $f65046485b965c63$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $f65046485b965c63$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $f65046485b965c63$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $f65046485b965c63$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $f65046485b965c63$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($f65046485b965c63$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $f65046485b965c63$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $f65046485b965c63$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $f65046485b965c63$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $f65046485b965c63$var$unitOutOfRange(unit, value) {
    return new $f65046485b965c63$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $f65046485b965c63$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $f65046485b965c63$var$computeOrdinal(year, month, day) {
    return day + ($f65046485b965c63$var$isLeapYear(year) ? $f65046485b965c63$var$leapLadder : $f65046485b965c63$var$nonLeapLadder)[month - 1];
}
function $f65046485b965c63$var$uncomputeOrdinal(year, ordinal) {
    var table = $f65046485b965c63$var$isLeapYear(year) ? $f65046485b965c63$var$leapLadder : $f65046485b965c63$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $f65046485b965c63$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $f65046485b965c63$var$computeOrdinal(year, month, day), weekday = $f65046485b965c63$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $f65046485b965c63$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $f65046485b965c63$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $f65046485b965c63$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $f65046485b965c63$var$timeObject(gregObj));
}
function $f65046485b965c63$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $f65046485b965c63$var$dayOfWeek(weekYear, 1, 4), yearInDays = $f65046485b965c63$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $f65046485b965c63$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $f65046485b965c63$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $f65046485b965c63$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $f65046485b965c63$var$_extends({
        year: year,
        month: month,
        day: day
    }, $f65046485b965c63$var$timeObject(weekData));
}
function $f65046485b965c63$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $f65046485b965c63$var$computeOrdinal(year, month, day);
    return $f65046485b965c63$var$_extends({
        year: year,
        ordinal: ordinal
    }, $f65046485b965c63$var$timeObject(gregData));
}
function $f65046485b965c63$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $f65046485b965c63$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $f65046485b965c63$var$_extends({
        year: year,
        month: month,
        day: day
    }, $f65046485b965c63$var$timeObject(ordinalData));
}
function $f65046485b965c63$var$hasInvalidWeekData(obj) {
    var validYear = $f65046485b965c63$var$isInteger(obj.weekYear), validWeek = $f65046485b965c63$var$integerBetween(obj.weekNumber, 1, $f65046485b965c63$var$weeksInWeekYear(obj.weekYear)), validWeekday = $f65046485b965c63$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $f65046485b965c63$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $f65046485b965c63$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $f65046485b965c63$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $f65046485b965c63$var$hasInvalidOrdinalData(obj) {
    var validYear = $f65046485b965c63$var$isInteger(obj.year), validOrdinal = $f65046485b965c63$var$integerBetween(obj.ordinal, 1, $f65046485b965c63$var$daysInYear(obj.year));
    if (!validYear) return $f65046485b965c63$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $f65046485b965c63$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $f65046485b965c63$var$hasInvalidGregorianData(obj) {
    var validYear = $f65046485b965c63$var$isInteger(obj.year), validMonth = $f65046485b965c63$var$integerBetween(obj.month, 1, 12), validDay = $f65046485b965c63$var$integerBetween(obj.day, 1, $f65046485b965c63$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $f65046485b965c63$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $f65046485b965c63$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $f65046485b965c63$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $f65046485b965c63$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $f65046485b965c63$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $f65046485b965c63$var$integerBetween(minute, 0, 59), validSecond = $f65046485b965c63$var$integerBetween(second, 0, 59), validMillisecond = $f65046485b965c63$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $f65046485b965c63$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $f65046485b965c63$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $f65046485b965c63$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $f65046485b965c63$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $f65046485b965c63$var$INVALID = "Invalid DateTime";
var $f65046485b965c63$var$MAX_DATE = 8.64e15;
function $f65046485b965c63$var$unsupportedZone(zone) {
    return new $f65046485b965c63$var$Invalid("unsupported zone", 'the zone "' + zone.name + '" is not supported');
}
// we cache week data on the DT object and this intermediates the cache
function $f65046485b965c63$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $f65046485b965c63$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $f65046485b965c63$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $f65046485b965c63$var$DateTime($f65046485b965c63$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $f65046485b965c63$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $f65046485b965c63$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $f65046485b965c63$var$objToTS(obj, offset, zone) {
    return $f65046485b965c63$var$fixOffset($f65046485b965c63$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $f65046485b965c63$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $f65046485b965c63$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $f65046485b965c63$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $f65046485b965c63$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $f65046485b965c63$var$objToLocalTS(c);
    var _fixOffset = $f65046485b965c63$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $f65046485b965c63$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $f65046485b965c63$var$DateTime.fromObject(parsed, $f65046485b965c63$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $f65046485b965c63$var$DateTime.invalid(new $f65046485b965c63$var$Invalid("unparsable", 'the input "' + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $f65046485b965c63$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $f65046485b965c63$var$Formatter.create($f65046485b965c63$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $f65046485b965c63$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $f65046485b965c63$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $f65046485b965c63$var$padStart(o.c.month);
        c += "-";
        c += $f65046485b965c63$var$padStart(o.c.day);
    } else {
        c += $f65046485b965c63$var$padStart(o.c.month);
        c += $f65046485b965c63$var$padStart(o.c.day);
    }
    return c;
}
function $f65046485b965c63$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $f65046485b965c63$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $f65046485b965c63$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $f65046485b965c63$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $f65046485b965c63$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $f65046485b965c63$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $f65046485b965c63$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $f65046485b965c63$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $f65046485b965c63$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $f65046485b965c63$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $f65046485b965c63$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $f65046485b965c63$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $f65046485b965c63$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $f65046485b965c63$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $f65046485b965c63$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $f65046485b965c63$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $f65046485b965c63$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $f65046485b965c63$var$InvalidUnitError(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $f65046485b965c63$var$quickDT(obj, opts) {
    var zone = $f65046485b965c63$var$normalizeZone(opts.zone, $f65046485b965c63$var$Settings.defaultZone), loc = $f65046485b965c63$var$Locale.fromObject(opts), tsNow = $f65046485b965c63$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$f65046485b965c63$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $f65046485b965c63$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($f65046485b965c63$var$isUndefined(obj[u])) obj[u] = $f65046485b965c63$var$defaultUnitValues[u];
        }
        var invalid = $f65046485b965c63$var$hasInvalidGregorianData(obj) || $f65046485b965c63$var$hasInvalidTimeData(obj);
        if (invalid) return $f65046485b965c63$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $f65046485b965c63$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $f65046485b965c63$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $f65046485b965c63$var$diffRelative(start, end, opts) {
    var round = $f65046485b965c63$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $f65046485b965c63$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $f65046485b965c63$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $f65046485b965c63$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $f65046485b965c63$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $f65046485b965c63$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $f65046485b965c63$var$Invalid("invalid input") : null) || (!zone.isValid ? $f65046485b965c63$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $f65046485b965c63$var$isUndefined(config.ts) ? $f65046485b965c63$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $f65046485b965c63$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $f65046485b965c63$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $f65046485b965c63$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $f65046485b965c63$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $f65046485b965c63$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $f65046485b965c63$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $f65046485b965c63$var$FixedOffsetZone.utcInstance;
        return $f65046485b965c63$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $f65046485b965c63$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $f65046485b965c63$var$normalizeZone(options.zone, $f65046485b965c63$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($f65046485b965c63$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $f65046485b965c63$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$f65046485b965c63$var$isNumber(milliseconds)) throw new $f65046485b965c63$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$f65046485b965c63$var$MAX_DATE || milliseconds > $f65046485b965c63$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $f65046485b965c63$var$normalizeZone(options.zone, $f65046485b965c63$var$Settings.defaultZone),
            loc: $f65046485b965c63$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$f65046485b965c63$var$isNumber(seconds)) throw new $f65046485b965c63$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $f65046485b965c63$var$normalizeZone(options.zone, $f65046485b965c63$var$Settings.defaultZone),
            loc: $f65046485b965c63$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $f65046485b965c63$var$normalizeZone(opts.zone, $f65046485b965c63$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($f65046485b965c63$var$unsupportedZone(zoneToUse));
        var tsNow = $f65046485b965c63$var$Settings.now(), offsetProvis = !$f65046485b965c63$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $f65046485b965c63$var$normalizeObject(obj, $f65046485b965c63$var$normalizeUnit), containsOrdinal = !$f65046485b965c63$var$isUndefined(normalized.ordinal), containsGregorYear = !$f65046485b965c63$var$isUndefined(normalized.year), containsGregorMD = !$f65046485b965c63$var$isUndefined(normalized.month) || !$f65046485b965c63$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $f65046485b965c63$var$Locale.fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $f65046485b965c63$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $f65046485b965c63$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $f65046485b965c63$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $f65046485b965c63$var$orderedWeekUnits;
            defaultValues = $f65046485b965c63$var$defaultWeekUnitValues;
            objNow = $f65046485b965c63$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $f65046485b965c63$var$orderedOrdinalUnits;
            defaultValues = $f65046485b965c63$var$defaultOrdinalUnitValues;
            objNow = $f65046485b965c63$var$gregorianToOrdinal(objNow);
        } else {
            units = $f65046485b965c63$var$orderedUnits;
            defaultValues = $f65046485b965c63$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $f65046485b965c63$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$f65046485b965c63$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $f65046485b965c63$var$hasInvalidWeekData(normalized) : containsOrdinal ? $f65046485b965c63$var$hasInvalidOrdinalData(normalized) : $f65046485b965c63$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $f65046485b965c63$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $f65046485b965c63$var$weekToGregorian(normalized) : containsOrdinal ? $f65046485b965c63$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $f65046485b965c63$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $f65046485b965c63$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $f65046485b965c63$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $f65046485b965c63$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $f65046485b965c63$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $f65046485b965c63$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $f65046485b965c63$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($f65046485b965c63$var$isUndefined(text) || $f65046485b965c63$var$isUndefined(fmt)) throw new $f65046485b965c63$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $f65046485b965c63$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $f65046485b965c63$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $f65046485b965c63$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $f65046485b965c63$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $f65046485b965c63$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $f65046485b965c63$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $f65046485b965c63$var$Invalid ? reason : new $f65046485b965c63$var$Invalid(reason, explanation);
        if ($f65046485b965c63$var$Settings.throwOnInvalid) throw new $f65046485b965c63$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $f65046485b965c63$var$formatOptsToTokens(formatOpts, $f65046485b965c63$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $f65046485b965c63$var$expandMacroTokens($f65046485b965c63$var$Formatter.parseFormat(fmt), $f65046485b965c63$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $f65046485b965c63$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $f65046485b965c63$var$tsToObj(ts1, o1);
        var c2 = $f65046485b965c63$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $f65046485b965c63$var$clone(this, {
                ts: ts1
            }),
            $f65046485b965c63$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $f65046485b965c63$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($f65046485b965c63$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($f65046485b965c63$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $f65046485b965c63$var$normalizeZone(zone, $f65046485b965c63$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($f65046485b965c63$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $f65046485b965c63$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $f65046485b965c63$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $f65046485b965c63$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $f65046485b965c63$var$normalizeObject(values, $f65046485b965c63$var$normalizeUnit), settingWeekStuff = !$f65046485b965c63$var$isUndefined(normalized.weekYear) || !$f65046485b965c63$var$isUndefined(normalized.weekNumber) || !$f65046485b965c63$var$isUndefined(normalized.weekday), containsOrdinal = !$f65046485b965c63$var$isUndefined(normalized.ordinal), containsGregorYear = !$f65046485b965c63$var$isUndefined(normalized.year), containsGregorMD = !$f65046485b965c63$var$isUndefined(normalized.month) || !$f65046485b965c63$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $f65046485b965c63$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $f65046485b965c63$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $f65046485b965c63$var$weekToGregorian($f65046485b965c63$var$_extends({}, $f65046485b965c63$var$gregorianToWeek(this.c), normalized));
        else if (!$f65046485b965c63$var$isUndefined(normalized.ordinal)) mixed = $f65046485b965c63$var$ordinalToGregorian($f65046485b965c63$var$_extends({}, $f65046485b965c63$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $f65046485b965c63$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($f65046485b965c63$var$isUndefined(normalized.day)) mixed.day = Math.min($f65046485b965c63$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $f65046485b965c63$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $f65046485b965c63$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $f65046485b965c63$var$Duration.fromDurationLike(duration);
        return $f65046485b965c63$var$clone(this, $f65046485b965c63$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $f65046485b965c63$var$Duration.fromDurationLike(duration).negate();
        return $f65046485b965c63$var$clone(this, $f65046485b965c63$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $f65046485b965c63$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $f65046485b965c63$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $f65046485b965c63$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $f65046485b965c63$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $f65046485b965c63$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $f65046485b965c63$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $f65046485b965c63$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $f65046485b965c63$var$_toISODate(this, ext);
        c += "T";
        c += $f65046485b965c63$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $f65046485b965c63$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $f65046485b965c63$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $f65046485b965c63$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $f65046485b965c63$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $f65046485b965c63$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $f65046485b965c63$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $f65046485b965c63$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $f65046485b965c63$var$INVALID;
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $f65046485b965c63$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $f65046485b965c63$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $f65046485b965c63$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $f65046485b965c63$var$maybeArray(unit).map($f65046485b965c63$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $f65046485b965c63$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $f65046485b965c63$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $f65046485b965c63$var$diffRelative(base, this.plus(padding), $f65046485b965c63$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $f65046485b965c63$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $f65046485b965c63$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $f65046485b965c63$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $f65046485b965c63$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $f65046485b965c63$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $f65046485b965c63$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $f65046485b965c63$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $f65046485b965c63$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $f65046485b965c63$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $f65046485b965c63$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $f65046485b965c63$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $f65046485b965c63$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $f65046485b965c63$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $f65046485b965c63$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $f65046485b965c63$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $f65046485b965c63$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $f65046485b965c63$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $f65046485b965c63$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $f65046485b965c63$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $f65046485b965c63$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $f65046485b965c63$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $f65046485b965c63$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $f65046485b965c63$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $f65046485b965c63$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $f65046485b965c63$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $f65046485b965c63$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $f65046485b965c63$var$friendlyDateTime(dateTimeish) {
    if ($f65046485b965c63$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $f65046485b965c63$var$isNumber(dateTimeish.valueOf())) return $f65046485b965c63$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $f65046485b965c63$var$DateTime.fromObject(dateTimeish);
    else throw new $f65046485b965c63$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $f65046485b965c63$var$VERSION = "3.4.3";
$f65046485b965c63$exports.DateTime = $f65046485b965c63$var$DateTime;
$f65046485b965c63$exports.Duration = $f65046485b965c63$var$Duration;
$f65046485b965c63$exports.FixedOffsetZone = $f65046485b965c63$var$FixedOffsetZone;
$f65046485b965c63$exports.IANAZone = $f65046485b965c63$var$IANAZone;
$f65046485b965c63$exports.Info = $f65046485b965c63$var$Info;
$f65046485b965c63$exports.Interval = $f65046485b965c63$var$Interval;
$f65046485b965c63$exports.InvalidZone = $f65046485b965c63$var$InvalidZone;
$f65046485b965c63$exports.Settings = $f65046485b965c63$var$Settings;
$f65046485b965c63$exports.SystemZone = $f65046485b965c63$var$SystemZone;
$f65046485b965c63$exports.VERSION = $f65046485b965c63$var$VERSION;
$f65046485b965c63$exports.Zone = $f65046485b965c63$var$Zone;


const $4576ab8f9f2fa9de$var$formatTokenMap = {
    // Year
    y: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    yy: "year",
    yyyy: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    // Month
    L: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    LL: "month",
    LLL: {
        sectionType: "month",
        contentType: "letter"
    },
    LLLL: {
        sectionType: "month",
        contentType: "letter"
    },
    M: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    MM: "month",
    MMM: {
        sectionType: "month",
        contentType: "letter"
    },
    MMMM: {
        sectionType: "month",
        contentType: "letter"
    },
    // Day of the month
    d: {
        sectionType: "day",
        contentType: "digit",
        maxLength: 2
    },
    dd: "day",
    // Day of the week
    c: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    ccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    cccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    E: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 2
    },
    EEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    // Meridiem
    a: "meridiem",
    // Hours
    H: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    HH: "hours",
    h: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    hh: "hours",
    // Minutes
    m: {
        sectionType: "minutes",
        contentType: "digit",
        maxLength: 2
    },
    mm: "minutes",
    // Seconds
    s: {
        sectionType: "seconds",
        contentType: "digit",
        maxLength: 2
    },
    ss: "seconds"
};
const $4576ab8f9f2fa9de$var$defaultFormats = {
    year: "yyyy",
    month: "LLLL",
    monthShort: "MMM",
    dayOfMonth: "d",
    // Full day of the month format (i.e. 3rd) is not supported
    // Falling back to regular format
    dayOfMonthFull: "d",
    weekday: "cccc",
    weekdayShort: "ccccc",
    hours24h: "HH",
    hours12h: "hh",
    meridiem: "a",
    minutes: "mm",
    seconds: "ss",
    fullDate: "DD",
    keyboardDate: "D",
    shortDate: "MMM d",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    fullTime: "t",
    fullTime12h: "hh:mm a",
    fullTime24h: "HH:mm",
    keyboardDateTime: "D t",
    keyboardDateTime12h: "D hh:mm a",
    keyboardDateTime24h: "D T"
};
class $4576ab8f9f2fa9de$export$e130a45610e3b3b2 {
    constructor({ locale: locale, formats: formats } = {}){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = "luxon";
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.formatTokenMap = $4576ab8f9f2fa9de$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale) return value;
            return value.setLocale(expectedLocale);
        };
        this.date = (value, timezone = "default")=>{
            if (value === null) return null;
            if (typeof value === "undefined") // @ts-ignore
            return (0, $f65046485b965c63$exports.DateTime).fromJSDate(new Date(), {
                locale: this.locale,
                zone: timezone
            });
            // @ts-ignore
            return (0, $f65046485b965c63$exports.DateTime).fromISO(value, {
                locale: this.locale,
                zone: timezone
            });
        };
        this.getInvalidDate = ()=>(0, $f65046485b965c63$exports.DateTime).fromJSDate(new Date("Invalid Date"));
        this.getTimezone = (value)=>{
            // When using the system zone, we want to return "system", not something like "Europe/Paris"
            if (value.zone.type === "system") return "system";
            return value.zoneName;
        };
        this.setTimezone = (value, timezone)=>{
            if (!value.zone.equals((0, $f65046485b965c63$exports.Info).normalizeZone(timezone))) return value.setZone(timezone);
            return value;
        };
        this.toJsDate = (value)=>{
            return value.toJSDate();
        };
        this.parse = (value, formatString)=>{
            if (value === "") return null;
            return (0, $f65046485b965c63$exports.DateTime).fromFormat(value, formatString, {
                locale: this.locale
            });
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale;
        };
        /* istanbul ignore next */ this.is12HourCycleInCurrentLocale = ()=>{
            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") return true; // Luxon defaults to en-US if Intl not found
            return Boolean(new Intl.DateTimeFormat(this.locale, {
                hour: "numeric"
            })?.resolvedOptions()?.hour12);
        };
        this.expandFormat = (format)=>{
            // Extract escaped section to avoid extending them
            const catchEscapedSectionsRegexp = /''|'(''|[^'])+('|$)|[^']*/g;
            // This RegExp tests if a string is only mad of supported tokens
            const validTokens = [
                ...Object.keys(this.formatTokenMap),
                "yyyyy"
            ];
            const isWordComposedOfTokens = new RegExp(`^(${validTokens.join("|")})+$`);
            // Extract words to test if they are a token or a word to escape.
            const catchWordsRegexp = /(?:^|[^a-z])([a-z]+)(?:[^a-z]|$)|([a-z]+)/gi;
            return format.match(catchEscapedSectionsRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "'") return token;
                const expandedToken = (0, $f65046485b965c63$exports.DateTime).expandFormat(token, {
                    locale: this.locale
                });
                return expandedToken.replace(catchWordsRegexp, (substring, g1, g2)=>{
                    const word = g1 || g2; // words are either in group 1 or group 2
                    if (isWordComposedOfTokens.test(word)) return substring;
                    return `'${substring}'`;
                });
            }).join("")// The returned format can contain `yyyyy` which means year between 4 and 6 digits.
            // This value is supported by luxon parser but not luxon formatter.
            // To avoid conflicts, we replace it by 4 digits which is enough for most use-cases.
            .replace("yyyyy", "yyyy");
        };
        this.isValid = (value)=>{
            if (value === null) return false;
            return value.isValid;
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, format)=>{
            return value.setLocale(this.locale).toFormat(format);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return +value === +comparing;
        };
        this.isSameYear = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "year");
        };
        this.isSameMonth = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "month");
        };
        this.isSameDay = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "day");
        };
        this.isSameHour = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "hour");
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.endOfYear(comparingInValueTimezone), "years").toObject();
            return diff.years > 0;
        };
        this.isAfterDay = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.endOfDay(comparingInValueTimezone), "days").toObject();
            return diff.days > 0;
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.startOfYear(comparingInValueTimezone), "years").toObject();
            return diff.years < 0;
        };
        this.isBeforeDay = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.startOfDay(comparingInValueTimezone), "days").toObject();
            return diff.days < 0;
        };
        this.isWithinRange = (value, [start, end])=>{
            return this.isEqual(value, start) || this.isEqual(value, end) || this.isAfter(value, start) && this.isBefore(value, end);
        };
        this.startOfYear = (value)=>{
            return value.startOf("year");
        };
        this.startOfMonth = (value)=>{
            return value.startOf("month");
        };
        this.startOfWeek = (value)=>{
            return this.setLocaleToValue(value).startOf("week", {
                useLocaleWeeks: true
            });
        };
        this.startOfDay = (value)=>{
            return value.startOf("day");
        };
        this.endOfYear = (value)=>{
            return value.endOf("year");
        };
        this.endOfMonth = (value)=>{
            return value.endOf("month");
        };
        this.endOfWeek = (value)=>{
            return this.setLocaleToValue(value).endOf("week", {
                useLocaleWeeks: true
            });
        };
        this.endOfDay = (value)=>{
            return value.endOf("day");
        };
        this.addYears = (value, amount)=>{
            return value.plus({
                years: amount
            });
        };
        this.addMonths = (value, amount)=>{
            return value.plus({
                months: amount
            });
        };
        this.addWeeks = (value, amount)=>{
            return value.plus({
                weeks: amount
            });
        };
        this.addDays = (value, amount)=>{
            return value.plus({
                days: amount
            });
        };
        this.addHours = (value, amount)=>{
            return value.plus({
                hours: amount
            });
        };
        this.addMinutes = (value, amount)=>{
            return value.plus({
                minutes: amount
            });
        };
        this.addSeconds = (value, amount)=>{
            return value.plus({
                seconds: amount
            });
        };
        this.getYear = (value)=>{
            return value.get("year");
        };
        this.getMonth = (value)=>{
            // See https://github.com/moment/luxon/blob/master/docs/moment.md#major-functional-differences
            return value.get("month") - 1;
        };
        this.getDate = (value)=>{
            return value.get("day");
        };
        this.getHours = (value)=>{
            return value.get("hour");
        };
        this.getMinutes = (value)=>{
            return value.get("minute");
        };
        this.getSeconds = (value)=>{
            return value.get("second");
        };
        this.getMilliseconds = (value)=>{
            return value.get("millisecond");
        };
        this.setYear = (value, year)=>{
            return value.set({
                year: year
            });
        };
        this.setMonth = (value, month)=>{
            return value.set({
                month: month + 1
            });
        };
        this.setDate = (value, date)=>{
            return value.set({
                day: date
            });
        };
        this.setHours = (value, hours)=>{
            return value.set({
                hour: hours
            });
        };
        this.setMinutes = (value, minutes)=>{
            return value.set({
                minute: minutes
            });
        };
        this.setSeconds = (value, seconds)=>{
            return value.set({
                second: seconds
            });
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return value.set({
                millisecond: milliseconds
            });
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth;
        };
        this.getWeekArray = (value)=>{
            const firstDay = this.startOfWeek(this.startOfMonth(value));
            const lastDay = this.endOfWeek(this.endOfMonth(value));
            const { days: days } = lastDay.diff(firstDay, "days").toObject();
            const weeks = [];
            new Array(Math.round(days)).fill(0).map((_, i)=>i).map((day)=>firstDay.plus({
                    days: day
                })).forEach((v, i)=>{
                if (i === 0 || i % 7 === 0 && i > 6) {
                    weeks.push([
                        v
                    ]);
                    return;
                }
                weeks[weeks.length - 1].push(v);
            });
            return weeks;
        };
        this.getWeekNumber = (value)=>{
            /* istanbul ignore next */ return value.localWeekNumber ?? value.weekNumber;
        };
        this.getDayOfWeek = (value)=>{
            return value.weekday;
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.locale = locale || "en-US";
        this.formats = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $4576ab8f9f2fa9de$var$defaultFormats, formats);
    }
}



var $592Nh = parcelRequire("592Nh");
/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2hDQc = parcelRequire("2hDQc");
var $b36a61f25d8b4314$exports = {};
"use strict";
function $b36a61f25d8b4314$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b36a61f25d8b4314$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b36a61f25d8b4314$var$checkDCE();

$b36a61f25d8b4314$exports = (parcelRequire("dvUFh"));


/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $df0c76e4858f6b9a$var$_extends() {
    $df0c76e4858f6b9a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $df0c76e4858f6b9a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $df0c76e4858f6b9a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($df0c76e4858f6b9a$export$e19cd5f9376f8cee || ($df0c76e4858f6b9a$export$e19cd5f9376f8cee = {}));
const $df0c76e4858f6b9a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $df0c76e4858f6b9a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $df0c76e4858f6b9a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $df0c76e4858f6b9a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $df0c76e4858f6b9a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $df0c76e4858f6b9a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $df0c76e4858f6b9a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $df0c76e4858f6b9a$export$fe53371bee54353d(to);
    }
    return $df0c76e4858f6b9a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $df0c76e4858f6b9a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $df0c76e4858f6b9a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $df0c76e4858f6b9a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $df0c76e4858f6b9a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $df0c76e4858f6b9a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $df0c76e4858f6b9a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $df0c76e4858f6b9a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $df0c76e4858f6b9a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $df0c76e4858f6b9a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $df0c76e4858f6b9a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $df0c76e4858f6b9a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $df0c76e4858f6b9a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $df0c76e4858f6b9a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $df0c76e4858f6b9a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $df0c76e4858f6b9a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $df0c76e4858f6b9a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($df0c76e4858f6b9a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Push;
        let location = $df0c76e4858f6b9a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $df0c76e4858f6b9a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Replace;
        let location = $df0c76e4858f6b9a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $df0c76e4858f6b9a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $df0c76e4858f6b9a$export$fe53371bee54353d(to);
        $df0c76e4858f6b9a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($df0c76e4858f6b9a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($df0c76e4858f6b9a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $df0c76e4858f6b9a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($df0c76e4858f6b9a$var$ResultType || ($df0c76e4858f6b9a$var$ResultType = {}));
const $df0c76e4858f6b9a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $df0c76e4858f6b9a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $df0c76e4858f6b9a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $df0c76e4858f6b9a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $df0c76e4858f6b9a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($df0c76e4858f6b9a$var$isIndexRoute(route)) {
            let indexRoute = $df0c76e4858f6b9a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $df0c76e4858f6b9a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $df0c76e4858f6b9a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $df0c76e4858f6b9a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $df0c76e4858f6b9a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $df0c76e4858f6b9a$var$flattenRoutes(routes);
    $df0c76e4858f6b9a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $df0c76e4858f6b9a$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $df0c76e4858f6b9a$var$safelyDecodeURI(pathname));
    return matches;
}
function $df0c76e4858f6b9a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $df0c76e4858f6b9a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $df0c76e4858f6b9a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $df0c76e4858f6b9a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $df0c76e4858f6b9a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $df0c76e4858f6b9a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $df0c76e4858f6b9a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $df0c76e4858f6b9a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $df0c76e4858f6b9a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $df0c76e4858f6b9a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $df0c76e4858f6b9a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $df0c76e4858f6b9a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $df0c76e4858f6b9a$var$paramRe = /^:[\w-]+$/;
const $df0c76e4858f6b9a$var$dynamicSegmentValue = 3;
const $df0c76e4858f6b9a$var$indexRouteValue = 2;
const $df0c76e4858f6b9a$var$emptySegmentValue = 1;
const $df0c76e4858f6b9a$var$staticSegmentValue = 10;
const $df0c76e4858f6b9a$var$splatPenalty = -2;
const $df0c76e4858f6b9a$var$isSplat = (s)=>s === "*";
function $df0c76e4858f6b9a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($df0c76e4858f6b9a$var$isSplat)) initialScore += $df0c76e4858f6b9a$var$splatPenalty;
    if (index) initialScore += $df0c76e4858f6b9a$var$indexRouteValue;
    return segments.filter((s)=>!$df0c76e4858f6b9a$var$isSplat(s)).reduce((score, segment)=>score + ($df0c76e4858f6b9a$var$paramRe.test(segment) ? $df0c76e4858f6b9a$var$dynamicSegmentValue : segment === "" ? $df0c76e4858f6b9a$var$emptySegmentValue : $df0c76e4858f6b9a$var$staticSegmentValue), initialScore);
}
function $df0c76e4858f6b9a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $df0c76e4858f6b9a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $df0c76e4858f6b9a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $df0c76e4858f6b9a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $df0c76e4858f6b9a$export$a5c6d149b50c1d86($df0c76e4858f6b9a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $df0c76e4858f6b9a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $df0c76e4858f6b9a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $df0c76e4858f6b9a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $df0c76e4858f6b9a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $df0c76e4858f6b9a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $df0c76e4858f6b9a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $df0c76e4858f6b9a$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $df0c76e4858f6b9a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $df0c76e4858f6b9a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $df0c76e4858f6b9a$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $df0c76e4858f6b9a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $df0c76e4858f6b9a$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $df0c76e4858f6b9a$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $df0c76e4858f6b9a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $df0c76e4858f6b9a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $df0c76e4858f6b9a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $df0c76e4858f6b9a$var$normalizeSearch(search),
        hash: $df0c76e4858f6b9a$var$normalizeHash(hash)
    };
}
function $df0c76e4858f6b9a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $df0c76e4858f6b9a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $df0c76e4858f6b9a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $df0c76e4858f6b9a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $df0c76e4858f6b9a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $df0c76e4858f6b9a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $df0c76e4858f6b9a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $df0c76e4858f6b9a$var$_extends({}, toArg);
        $df0c76e4858f6b9a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $df0c76e4858f6b9a$var$getInvalidPathError("?", "pathname", "search", to));
        $df0c76e4858f6b9a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $df0c76e4858f6b9a$var$getInvalidPathError("#", "pathname", "hash", to));
        $df0c76e4858f6b9a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $df0c76e4858f6b9a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $df0c76e4858f6b9a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $df0c76e4858f6b9a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $df0c76e4858f6b9a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $df0c76e4858f6b9a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $df0c76e4858f6b9a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $df0c76e4858f6b9a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $df0c76e4858f6b9a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $df0c76e4858f6b9a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $df0c76e4858f6b9a$export$42a99a7a4bc0e76a extends Error {
}
class $df0c76e4858f6b9a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $df0c76e4858f6b9a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $df0c76e4858f6b9a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $df0c76e4858f6b9a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $df0c76e4858f6b9a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $df0c76e4858f6b9a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $df0c76e4858f6b9a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $df0c76e4858f6b9a$var$unwrapTrackedPromise(value) {
    if (!$df0c76e4858f6b9a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $df0c76e4858f6b9a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $df0c76e4858f6b9a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $df0c76e4858f6b9a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $df0c76e4858f6b9a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $df0c76e4858f6b9a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $df0c76e4858f6b9a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $df0c76e4858f6b9a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $df0c76e4858f6b9a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $df0c76e4858f6b9a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $df0c76e4858f6b9a$var$validMutationMethods = new Set($df0c76e4858f6b9a$var$validMutationMethodsArr);
const $df0c76e4858f6b9a$var$validRequestMethodsArr = [
    "get",
    ...$df0c76e4858f6b9a$var$validMutationMethodsArr
];
const $df0c76e4858f6b9a$var$validRequestMethods = new Set($df0c76e4858f6b9a$var$validRequestMethodsArr);
const $df0c76e4858f6b9a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $df0c76e4858f6b9a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $df0c76e4858f6b9a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $df0c76e4858f6b9a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $df0c76e4858f6b9a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $df0c76e4858f6b9a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $df0c76e4858f6b9a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $df0c76e4858f6b9a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $df0c76e4858f6b9a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $df0c76e4858f6b9a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $df0c76e4858f6b9a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $df0c76e4858f6b9a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $df0c76e4858f6b9a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $df0c76e4858f6b9a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $df0c76e4858f6b9a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $df0c76e4858f6b9a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $df0c76e4858f6b9a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $df0c76e4858f6b9a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $df0c76e4858f6b9a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $df0c76e4858f6b9a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$df0c76e4858f6b9a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $df0c76e4858f6b9a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $df0c76e4858f6b9a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $df0c76e4858f6b9a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $df0c76e4858f6b9a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $df0c76e4858f6b9a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($df0c76e4858f6b9a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $df0c76e4858f6b9a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $df0c76e4858f6b9a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $df0c76e4858f6b9a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $df0c76e4858f6b9a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $df0c76e4858f6b9a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $df0c76e4858f6b9a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $df0c76e4858f6b9a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $df0c76e4858f6b9a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $df0c76e4858f6b9a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $df0c76e4858f6b9a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $df0c76e4858f6b9a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $df0c76e4858f6b9a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $df0c76e4858f6b9a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$df0c76e4858f6b9a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $df0c76e4858f6b9a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $df0c76e4858f6b9a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $df0c76e4858f6b9a$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $df0c76e4858f6b9a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $df0c76e4858f6b9a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $df0c76e4858f6b9a$var$ResultType.error,
            error: $df0c76e4858f6b9a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $df0c76e4858f6b9a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($df0c76e4858f6b9a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($df0c76e4858f6b9a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $df0c76e4858f6b9a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($df0c76e4858f6b9a$var$isDeferredResult(result)) throw $df0c76e4858f6b9a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $df0c76e4858f6b9a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $df0c76e4858f6b9a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $df0c76e4858f6b9a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $df0c76e4858f6b9a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $df0c76e4858f6b9a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($df0c76e4858f6b9a$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $df0c76e4858f6b9a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $df0c76e4858f6b9a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $df0c76e4858f6b9a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $df0c76e4858f6b9a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $df0c76e4858f6b9a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $df0c76e4858f6b9a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $df0c76e4858f6b9a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $df0c76e4858f6b9a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $df0c76e4858f6b9a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $df0c76e4858f6b9a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $df0c76e4858f6b9a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $df0c76e4858f6b9a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $df0c76e4858f6b9a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($df0c76e4858f6b9a$var$isRedirectResult(actionResult) || $df0c76e4858f6b9a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $df0c76e4858f6b9a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($df0c76e4858f6b9a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $df0c76e4858f6b9a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $df0c76e4858f6b9a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($df0c76e4858f6b9a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($df0c76e4858f6b9a$var$isDeferredResult(actionResult)) throw $df0c76e4858f6b9a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $df0c76e4858f6b9a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $df0c76e4858f6b9a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $df0c76e4858f6b9a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $df0c76e4858f6b9a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $df0c76e4858f6b9a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $df0c76e4858f6b9a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $df0c76e4858f6b9a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $df0c76e4858f6b9a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $df0c76e4858f6b9a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $df0c76e4858f6b9a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $df0c76e4858f6b9a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $df0c76e4858f6b9a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $df0c76e4858f6b9a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $df0c76e4858f6b9a$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($df0c76e4858f6b9a$var$isDeferredResult(result)) result = await $df0c76e4858f6b9a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $df0c76e4858f6b9a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($df0c76e4858f6b9a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $df0c76e4858f6b9a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($df0c76e4858f6b9a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $df0c76e4858f6b9a$export$3e9cee6b33872309(!$df0c76e4858f6b9a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $df0c76e4858f6b9a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $df0c76e4858f6b9a$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $df0c76e4858f6b9a$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($df0c76e4858f6b9a$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $df0c76e4858f6b9a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Replace : $df0c76e4858f6b9a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $df0c76e4858f6b9a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($df0c76e4858f6b9a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $df0c76e4858f6b9a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $df0c76e4858f6b9a$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $df0c76e4858f6b9a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$df0c76e4858f6b9a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $df0c76e4858f6b9a$var$callLoaderOrAction("loader", $df0c76e4858f6b9a$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $df0c76e4858f6b9a$var$ResultType.error,
                        error: $df0c76e4858f6b9a$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $df0c76e4858f6b9a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $df0c76e4858f6b9a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $df0c76e4858f6b9a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $df0c76e4858f6b9a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $df0c76e4858f6b9a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $df0c76e4858f6b9a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $df0c76e4858f6b9a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $df0c76e4858f6b9a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $df0c76e4858f6b9a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $df0c76e4858f6b9a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $df0c76e4858f6b9a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $df0c76e4858f6b9a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $df0c76e4858f6b9a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$df0c76e4858f6b9a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $df0c76e4858f6b9a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $df0c76e4858f6b9a$export$4d0306f8f6a4585b = Symbol("deferred");
function $df0c76e4858f6b9a$export$3336b097a6fbc59a(routes, opts) {
    $df0c76e4858f6b9a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $df0c76e4858f6b9a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $df0c76e4858f6b9a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $df0c76e4858f6b9a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $df0c76e4858f6b9a$var$createLocation("", $df0c76e4858f6b9a$export$fe53371bee54353d(url), null, "default");
        let matches = $df0c76e4858f6b9a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$df0c76e4858f6b9a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $df0c76e4858f6b9a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $df0c76e4858f6b9a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $df0c76e4858f6b9a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $df0c76e4858f6b9a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($df0c76e4858f6b9a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $df0c76e4858f6b9a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $df0c76e4858f6b9a$var$createLocation("", $df0c76e4858f6b9a$export$fe53371bee54353d(url), null, "default");
        let matches = $df0c76e4858f6b9a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$df0c76e4858f6b9a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $df0c76e4858f6b9a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $df0c76e4858f6b9a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $df0c76e4858f6b9a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $df0c76e4858f6b9a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $df0c76e4858f6b9a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($df0c76e4858f6b9a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$df0c76e4858f6b9a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $df0c76e4858f6b9a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($df0c76e4858f6b9a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $df0c76e4858f6b9a$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $df0c76e4858f6b9a$var$isResponse(result) ? result : $df0c76e4858f6b9a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($df0c76e4858f6b9a$var$isQueryRouteResponse(e)) {
                if (e.type === $df0c76e4858f6b9a$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($df0c76e4858f6b9a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $df0c76e4858f6b9a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $df0c76e4858f6b9a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $df0c76e4858f6b9a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $df0c76e4858f6b9a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($df0c76e4858f6b9a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($df0c76e4858f6b9a$var$isDeferredResult(result)) {
            let error = $df0c76e4858f6b9a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $df0c76e4858f6b9a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($df0c76e4858f6b9a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($df0c76e4858f6b9a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $df0c76e4858f6b9a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $df0c76e4858f6b9a$var$_extends({}, context, {
                statusCode: $df0c76e4858f6b9a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $df0c76e4858f6b9a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $df0c76e4858f6b9a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $df0c76e4858f6b9a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $df0c76e4858f6b9a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $df0c76e4858f6b9a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$df0c76e4858f6b9a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $df0c76e4858f6b9a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $df0c76e4858f6b9a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $df0c76e4858f6b9a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $df0c76e4858f6b9a$export$fec11da027c70692(routes, context, error) {
    let newContext = $df0c76e4858f6b9a$var$_extends({}, context, {
        statusCode: $df0c76e4858f6b9a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $df0c76e4858f6b9a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $df0c76e4858f6b9a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $df0c76e4858f6b9a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $df0c76e4858f6b9a$export$cae722b0cc860f13(to ? to : ".", $df0c76e4858f6b9a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $df0c76e4858f6b9a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$df0c76e4858f6b9a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $df0c76e4858f6b9a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $df0c76e4858f6b9a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $df0c76e4858f6b9a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$df0c76e4858f6b9a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$df0c76e4858f6b9a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $df0c76e4858f6b9a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $df0c76e4858f6b9a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $df0c76e4858f6b9a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$df0c76e4858f6b9a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$df0c76e4858f6b9a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $df0c76e4858f6b9a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $df0c76e4858f6b9a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $df0c76e4858f6b9a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $df0c76e4858f6b9a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $df0c76e4858f6b9a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($df0c76e4858f6b9a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $df0c76e4858f6b9a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $df0c76e4858f6b9a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $df0c76e4858f6b9a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $df0c76e4858f6b9a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $df0c76e4858f6b9a$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $df0c76e4858f6b9a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($df0c76e4858f6b9a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $df0c76e4858f6b9a$var$shouldRevalidateLoader(match, $df0c76e4858f6b9a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $df0c76e4858f6b9a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $df0c76e4858f6b9a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $df0c76e4858f6b9a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $df0c76e4858f6b9a$var$shouldRevalidateLoader(fetcherMatch, $df0c76e4858f6b9a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $df0c76e4858f6b9a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $df0c76e4858f6b9a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $df0c76e4858f6b9a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $df0c76e4858f6b9a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $df0c76e4858f6b9a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $df0c76e4858f6b9a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$df0c76e4858f6b9a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $df0c76e4858f6b9a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $df0c76e4858f6b9a$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $df0c76e4858f6b9a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $df0c76e4858f6b9a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $df0c76e4858f6b9a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $df0c76e4858f6b9a$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $df0c76e4858f6b9a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $df0c76e4858f6b9a$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $df0c76e4858f6b9a$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($df0c76e4858f6b9a$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($df0c76e4858f6b9a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $df0c76e4858f6b9a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$df0c76e4858f6b9a$var$ABSOLUTE_URL_REGEX.test(location)) location = $df0c76e4858f6b9a$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $df0c76e4858f6b9a$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $df0c76e4858f6b9a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $df0c76e4858f6b9a$var$ResultType.error ? $df0c76e4858f6b9a$var$ResultType.error : $df0c76e4858f6b9a$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $df0c76e4858f6b9a$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $df0c76e4858f6b9a$var$ResultType.error) return {
            type: resultType,
            error: new $df0c76e4858f6b9a$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $df0c76e4858f6b9a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $df0c76e4858f6b9a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($df0c76e4858f6b9a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $df0c76e4858f6b9a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $df0c76e4858f6b9a$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $df0c76e4858f6b9a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($df0c76e4858f6b9a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $df0c76e4858f6b9a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $df0c76e4858f6b9a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $df0c76e4858f6b9a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $df0c76e4858f6b9a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $df0c76e4858f6b9a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $df0c76e4858f6b9a$export$3e9cee6b33872309(!$df0c76e4858f6b9a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($df0c76e4858f6b9a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $df0c76e4858f6b9a$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $df0c76e4858f6b9a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($df0c76e4858f6b9a$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $df0c76e4858f6b9a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $df0c76e4858f6b9a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $df0c76e4858f6b9a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($df0c76e4858f6b9a$var$isErrorResult(result)) {
            let boundaryMatch = $df0c76e4858f6b9a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $df0c76e4858f6b9a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($df0c76e4858f6b9a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $df0c76e4858f6b9a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($df0c76e4858f6b9a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $df0c76e4858f6b9a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $df0c76e4858f6b9a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $df0c76e4858f6b9a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $df0c76e4858f6b9a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $df0c76e4858f6b9a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $df0c76e4858f6b9a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $df0c76e4858f6b9a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $df0c76e4858f6b9a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $df0c76e4858f6b9a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($df0c76e4858f6b9a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $df0c76e4858f6b9a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(path) : path;
    return $df0c76e4858f6b9a$export$fe53371bee54353d($df0c76e4858f6b9a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $df0c76e4858f6b9a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $df0c76e4858f6b9a$var$isDeferredResult(result) {
    return result.type === $df0c76e4858f6b9a$var$ResultType.deferred;
}
function $df0c76e4858f6b9a$var$isErrorResult(result) {
    return result.type === $df0c76e4858f6b9a$var$ResultType.error;
}
function $df0c76e4858f6b9a$var$isRedirectResult(result) {
    return (result && result.type) === $df0c76e4858f6b9a$var$ResultType.redirect;
}
function $df0c76e4858f6b9a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $df0c76e4858f6b9a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $df0c76e4858f6b9a$var$isRedirectResponse(result) {
    if (!$df0c76e4858f6b9a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $df0c76e4858f6b9a$var$isQueryRouteResponse(obj) {
    return obj && $df0c76e4858f6b9a$var$isResponse(obj.response) && (obj.type === $df0c76e4858f6b9a$var$ResultType.data || obj.type === $df0c76e4858f6b9a$var$ResultType.error);
}
function $df0c76e4858f6b9a$var$isValidMethod(method) {
    return $df0c76e4858f6b9a$var$validRequestMethods.has(method.toLowerCase());
}
function $df0c76e4858f6b9a$var$isMutationMethod(method) {
    return $df0c76e4858f6b9a$var$validMutationMethods.has(method.toLowerCase());
}
async function $df0c76e4858f6b9a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$df0c76e4858f6b9a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($df0c76e4858f6b9a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $df0c76e4858f6b9a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $df0c76e4858f6b9a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $df0c76e4858f6b9a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $df0c76e4858f6b9a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $df0c76e4858f6b9a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $df0c76e4858f6b9a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $df0c76e4858f6b9a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $df0c76e4858f6b9a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $df0c76e4858f6b9a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $df0c76e4858f6b9a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $df0c76e4858f6b9a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $df0c76e4858f6b9a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $df0c76e4858f6b9a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $df0c76e4858f6b9a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $df0c76e4858f6b9a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $df0c76e4858f6b9a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $df0c76e4858f6b9a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $df0c76e4858f6b9a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($df0c76e4858f6b9a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $df0c76e4858f6b9a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($df0c76e4858f6b9a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $df0c76e4858f6b9a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2hDQc = parcelRequire("2hDQc");

function $86f6846c59d1b386$var$_extends() {
    $86f6846c59d1b386$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $86f6846c59d1b386$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $86f6846c59d1b386$export$3add0d5dce533e2e = /*#__PURE__*/ $2hDQc.createContext(null);
const $86f6846c59d1b386$export$145dfa71566a64dc = /*#__PURE__*/ $2hDQc.createContext(null);
const $86f6846c59d1b386$var$AwaitContext = /*#__PURE__*/ $2hDQc.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $86f6846c59d1b386$export$26749e8557646306 = /*#__PURE__*/ $2hDQc.createContext(null);
const $86f6846c59d1b386$export$c7914228fb69b0f5 = /*#__PURE__*/ $2hDQc.createContext(null);
const $86f6846c59d1b386$export$9072aa6dd1f93057 = /*#__PURE__*/ $2hDQc.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $86f6846c59d1b386$var$RouteErrorContext = /*#__PURE__*/ $2hDQc.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $86f6846c59d1b386$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $2hDQc.useContext($86f6846c59d1b386$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $86f6846c59d1b386$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $df0c76e4858f6b9a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $86f6846c59d1b386$export$9c954a9d03d32f4a() {
    return $2hDQc.useContext($86f6846c59d1b386$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $86f6846c59d1b386$export$45d76561a5302f2b() {
    !$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return $2hDQc.useContext($86f6846c59d1b386$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $86f6846c59d1b386$export$1b3f31771c5d07c() {
    return $2hDQc.useContext($86f6846c59d1b386$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $86f6846c59d1b386$export$6c330e8992e8a295(pattern) {
    !$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $86f6846c59d1b386$export$45d76561a5302f2b();
    return $2hDQc.useMemo(()=>(0, $df0c76e4858f6b9a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $86f6846c59d1b386$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $86f6846c59d1b386$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $2hDQc.useContext($86f6846c59d1b386$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2hDQc.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $86f6846c59d1b386$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $86f6846c59d1b386$var$useNavigateStable() : $86f6846c59d1b386$var$useNavigateUnstable();
}
function $86f6846c59d1b386$var$useNavigateUnstable() {
    !$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $2hDQc.useContext($86f6846c59d1b386$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $2hDQc.useContext($86f6846c59d1b386$export$26749e8557646306);
    let { matches: matches } = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $86f6846c59d1b386$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $df0c76e4858f6b9a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $2hDQc.useRef(false);
    $86f6846c59d1b386$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2hDQc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $df0c76e4858f6b9a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $df0c76e4858f6b9a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $86f6846c59d1b386$var$OutletContext = /*#__PURE__*/ $2hDQc.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $86f6846c59d1b386$export$4138103a3ae699cc() {
    return $2hDQc.useContext($86f6846c59d1b386$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $86f6846c59d1b386$export$a3be3530d8e40d0b(context) {
    let outlet = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $86f6846c59d1b386$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $86f6846c59d1b386$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $2hDQc.useContext($86f6846c59d1b386$export$26749e8557646306);
    let { matches: matches } = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $86f6846c59d1b386$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $df0c76e4858f6b9a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $2hDQc.useMemo(()=>(0, $df0c76e4858f6b9a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $86f6846c59d1b386$export$5d3fca4a98652595(routes, locationArg) {
    return $86f6846c59d1b386$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $86f6846c59d1b386$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $2hDQc.useContext($86f6846c59d1b386$export$26749e8557646306);
    let { matches: parentMatches } = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $86f6846c59d1b386$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $df0c76e4858f6b9a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $df0c76e4858f6b9a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $86f6846c59d1b386$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $df0c76e4858f6b9a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $df0c76e4858f6b9a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $86f6846c59d1b386$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $df0c76e4858f6b9a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $86f6846c59d1b386$var$DefaultErrorComponent() {
    let error = $86f6846c59d1b386$export$ed527bf60f6e05f2();
    let message = (0, $df0c76e4858f6b9a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, /*#__PURE__*/ $2hDQc.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $2hDQc.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $2hDQc.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $86f6846c59d1b386$var$defaultErrorElement = /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$DefaultErrorComponent, null);
class $86f6846c59d1b386$var$RenderErrorBoundary extends $2hDQc.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $86f6846c59d1b386$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $2hDQc.useContext($86f6846c59d1b386$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $86f6846c59d1b386$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $86f6846c59d1b386$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $86f6846c59d1b386$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $2hDQc.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $86f6846c59d1b386$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($86f6846c59d1b386$var$DataRouterHook || {});
var $86f6846c59d1b386$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($86f6846c59d1b386$var$DataRouterStateHook || {});
function $86f6846c59d1b386$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $86f6846c59d1b386$var$useDataRouterContext(hookName) {
    let ctx = $2hDQc.useContext($86f6846c59d1b386$export$3add0d5dce533e2e);
    !ctx && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $86f6846c59d1b386$var$useDataRouterState(hookName) {
    let state = $2hDQc.useContext($86f6846c59d1b386$export$145dfa71566a64dc);
    !state && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return state;
}
function $86f6846c59d1b386$var$useRouteContext(hookName) {
    let route = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    !route && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $86f6846c59d1b386$var$useCurrentRouteId(hookName) {
    let route = $86f6846c59d1b386$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $86f6846c59d1b386$export$5fc8298006ad9e58() {
    return $86f6846c59d1b386$var$useCurrentRouteId($86f6846c59d1b386$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $86f6846c59d1b386$export$d0fd4b7106de2769() {
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $86f6846c59d1b386$export$600dc272ed516c15() {
    let dataRouterContext = $86f6846c59d1b386$var$useDataRouterContext($86f6846c59d1b386$var$DataRouterHook.UseRevalidator);
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseRevalidator);
    return $2hDQc.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $86f6846c59d1b386$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseMatches);
    return $2hDQc.useMemo(()=>matches.map((m)=>(0, $df0c76e4858f6b9a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $86f6846c59d1b386$export$1448a5050d252c4d() {
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseLoaderData);
    let routeId = $86f6846c59d1b386$var$useCurrentRouteId($86f6846c59d1b386$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $86f6846c59d1b386$export$fd5d37484eab868d(routeId) {
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $86f6846c59d1b386$export$fdc00f3f26066d5e() {
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseActionData);
    let routeId = $86f6846c59d1b386$var$useCurrentRouteId($86f6846c59d1b386$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $86f6846c59d1b386$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $2hDQc.useContext($86f6846c59d1b386$var$RouteErrorContext);
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseRouteError);
    let routeId = $86f6846c59d1b386$var$useCurrentRouteId($86f6846c59d1b386$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $86f6846c59d1b386$export$78a72ddb39bdd145() {
    let value = $2hDQc.useContext($86f6846c59d1b386$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $86f6846c59d1b386$export$17f53340677d5831() {
    let value = $2hDQc.useContext($86f6846c59d1b386$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $86f6846c59d1b386$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $86f6846c59d1b386$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $86f6846c59d1b386$var$useDataRouterContext($86f6846c59d1b386$var$DataRouterHook.UseBlocker);
    let state = $86f6846c59d1b386$var$useDataRouterState($86f6846c59d1b386$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $2hDQc.useState("");
    let blockerFunction = $2hDQc.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $86f6846c59d1b386$var$_extends({}, currentLocation, {
                pathname: (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $86f6846c59d1b386$var$_extends({}, nextLocation, {
                pathname: (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $2hDQc.useEffect(()=>{
        let key = String(++$86f6846c59d1b386$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $2hDQc.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $df0c76e4858f6b9a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $86f6846c59d1b386$var$useNavigateStable() {
    let { router: router } = $86f6846c59d1b386$var$useDataRouterContext($86f6846c59d1b386$var$DataRouterHook.UseNavigateStable);
    let id = $86f6846c59d1b386$var$useCurrentRouteId($86f6846c59d1b386$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $2hDQc.useRef(false);
    $86f6846c59d1b386$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2hDQc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $86f6846c59d1b386$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $86f6846c59d1b386$var$alreadyWarned = {};
function $86f6846c59d1b386$var$warningOnce(key, cond, message) {
    if (!cond && !$86f6846c59d1b386$var$alreadyWarned[key]) $86f6846c59d1b386$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $86f6846c59d1b386$var$START_TRANSITION = "startTransition";
const $86f6846c59d1b386$var$startTransitionImpl = $2hDQc[$86f6846c59d1b386$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $86f6846c59d1b386$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $2hDQc.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2hDQc.useCallback((newState)=>{
        if (v7_startTransition && $86f6846c59d1b386$var$startTransitionImpl) $86f6846c59d1b386$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $2hDQc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $2hDQc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $2hDQc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2hDQc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $86f6846c59d1b386$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $86f6846c59d1b386$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $86f6846c59d1b386$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $2hDQc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $df0c76e4858f6b9a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2hDQc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2hDQc.useCallback((newState)=>{
        v7_startTransition && $86f6846c59d1b386$var$startTransitionImpl ? $86f6846c59d1b386$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2hDQc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $86f6846c59d1b386$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $2hDQc.useContext($86f6846c59d1b386$export$26749e8557646306);
    let { matches: matches } = $2hDQc.useContext($86f6846c59d1b386$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $86f6846c59d1b386$export$45d76561a5302f2b();
    let navigate = $86f6846c59d1b386$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $df0c76e4858f6b9a$export$cae722b0cc860f13)(to, (0, $df0c76e4858f6b9a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $2hDQc.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $86f6846c59d1b386$export$910ae8079b2c2852(props) {
    return $86f6846c59d1b386$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $86f6846c59d1b386$export$e7b0ac011bb776c6(_props) {
    (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $86f6846c59d1b386$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $df0c76e4858f6b9a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$86f6846c59d1b386$export$9c954a9d03d32f4a() && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $2hDQc.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $86f6846c59d1b386$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $df0c76e4858f6b9a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $2hDQc.useMemo(()=>{
        let trailingPathname = (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $86f6846c59d1b386$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $86f6846c59d1b386$export$5d3fca4a98652595($86f6846c59d1b386$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $86f6846c59d1b386$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$ResolveAwait, null, children));
}
var $86f6846c59d1b386$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($86f6846c59d1b386$var$AwaitRenderStatus || {});
const $86f6846c59d1b386$var$neverSettledPromise = new Promise(()=>{});
class $86f6846c59d1b386$var$AwaitErrorBoundary extends $2hDQc.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $86f6846c59d1b386$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $86f6846c59d1b386$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $86f6846c59d1b386$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $86f6846c59d1b386$var$AwaitRenderStatus.error : promise._data !== undefined ? $86f6846c59d1b386$var$AwaitRenderStatus.success : $86f6846c59d1b386$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $86f6846c59d1b386$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $86f6846c59d1b386$var$AwaitRenderStatus.error && promise._error instanceof (0, $df0c76e4858f6b9a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $86f6846c59d1b386$var$neverSettledPromise;
        if (status === $86f6846c59d1b386$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $86f6846c59d1b386$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $86f6846c59d1b386$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $2hDQc.createElement($86f6846c59d1b386$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $86f6846c59d1b386$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $86f6846c59d1b386$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $86f6846c59d1b386$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $2hDQc.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $2hDQc.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $2hDQc.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $86f6846c59d1b386$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $86f6846c59d1b386$export$e7b0ac011bb776c6) && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $86f6846c59d1b386$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $86f6846c59d1b386$export$daf73786167a7f72(matches) {
    return $86f6846c59d1b386$var$_renderMatches(matches);
}
function $86f6846c59d1b386$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $2hDQc.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $2hDQc.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $2hDQc.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $86f6846c59d1b386$export$f30f7e456d254e83(routes, opts) {
    return (0, $df0c76e4858f6b9a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $86f6846c59d1b386$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $df0c76e4858f6b9a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $86f6846c59d1b386$export$52b333d321859367
    }).initialize();
}



function $944912ac1928e04f$var$_extends() {
    $944912ac1928e04f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $944912ac1928e04f$var$_extends.apply(this, arguments);
}
function $944912ac1928e04f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $944912ac1928e04f$var$defaultMethod = "get";
const $944912ac1928e04f$var$defaultEncType = "application/x-www-form-urlencoded";
function $944912ac1928e04f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $944912ac1928e04f$var$isButtonElement(object) {
    return $944912ac1928e04f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $944912ac1928e04f$var$isFormElement(object) {
    return $944912ac1928e04f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $944912ac1928e04f$var$isInputElement(object) {
    return $944912ac1928e04f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $944912ac1928e04f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $944912ac1928e04f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$944912ac1928e04f$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $944912ac1928e04f$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $944912ac1928e04f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $944912ac1928e04f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $944912ac1928e04f$var$_formDataSupportsSubmitter = null;
function $944912ac1928e04f$var$isFormDataSubmitterSupported() {
    if ($944912ac1928e04f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $944912ac1928e04f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $944912ac1928e04f$var$_formDataSupportsSubmitter = true;
    }
    return $944912ac1928e04f$var$_formDataSupportsSubmitter;
}
const $944912ac1928e04f$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $944912ac1928e04f$var$getFormEncType(encType) {
    if (encType != null && !$944912ac1928e04f$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $944912ac1928e04f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($944912ac1928e04f$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $944912ac1928e04f$var$defaultMethod;
        encType = $944912ac1928e04f$var$getFormEncType(target.getAttribute("enctype")) || $944912ac1928e04f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($944912ac1928e04f$var$isButtonElement(target) || $944912ac1928e04f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $944912ac1928e04f$var$defaultMethod;
        encType = $944912ac1928e04f$var$getFormEncType(target.getAttribute("formenctype")) || $944912ac1928e04f$var$getFormEncType(form.getAttribute("enctype")) || $944912ac1928e04f$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$944912ac1928e04f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($944912ac1928e04f$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $944912ac1928e04f$var$defaultMethod;
        action = null;
        encType = $944912ac1928e04f$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $944912ac1928e04f$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $944912ac1928e04f$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $944912ac1928e04f$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $944912ac1928e04f$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $944912ac1928e04f$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $944912ac1928e04f$export$1f3f55432a00e06d(routes, opts) {
    return (0, $df0c76e4858f6b9a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $944912ac1928e04f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $df0c76e4858f6b9a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $944912ac1928e04f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $86f6846c59d1b386$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $944912ac1928e04f$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $df0c76e4858f6b9a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $944912ac1928e04f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $df0c76e4858f6b9a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $944912ac1928e04f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $86f6846c59d1b386$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $944912ac1928e04f$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $944912ac1928e04f$var$_extends({}, state, {
        errors: $944912ac1928e04f$var$deserializeErrors(state.errors)
    });
    return state;
}
function $944912ac1928e04f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $df0c76e4858f6b9a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $944912ac1928e04f$export$7ad602f0e94e62d1 = /*#__PURE__*/ $2hDQc.createContext({
    isTransitioning: false
});
const $944912ac1928e04f$export$148fd98d095596d4 = /*#__PURE__*/ $2hDQc.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $944912ac1928e04f$var$START_TRANSITION = "startTransition";
const $944912ac1928e04f$var$startTransitionImpl = $2hDQc[$944912ac1928e04f$var$START_TRANSITION];
const $944912ac1928e04f$var$FLUSH_SYNC = "flushSync";
const $944912ac1928e04f$var$flushSyncImpl = $b36a61f25d8b4314$exports[$944912ac1928e04f$var$FLUSH_SYNC];
const $944912ac1928e04f$var$USE_ID = "useId";
const $944912ac1928e04f$var$useIdImpl = $2hDQc[$944912ac1928e04f$var$USE_ID];
function $944912ac1928e04f$var$startTransitionSafe(cb) {
    if ($944912ac1928e04f$var$startTransitionImpl) $944912ac1928e04f$var$startTransitionImpl(cb);
    else cb();
}
function $944912ac1928e04f$var$flushSyncSafe(cb) {
    if ($944912ac1928e04f$var$flushSyncImpl) $944912ac1928e04f$var$flushSyncImpl(cb);
    else cb();
}
class $944912ac1928e04f$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $944912ac1928e04f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $2hDQc.useState(router.state);
    let [pendingState, setPendingState] = $2hDQc.useState();
    let [vtContext, setVtContext] = $2hDQc.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $2hDQc.useState();
    let [transition, setTransition] = $2hDQc.useState();
    let [interruption, setInterruption] = $2hDQc.useState();
    let fetcherData = $2hDQc.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $2hDQc.useCallback((cb)=>{
        if (v7_startTransition) $944912ac1928e04f$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $2hDQc.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $944912ac1928e04f$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $944912ac1928e04f$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $944912ac1928e04f$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $944912ac1928e04f$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $944912ac1928e04f$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $2hDQc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $2hDQc.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $944912ac1928e04f$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $2hDQc.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $2hDQc.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $2hDQc.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $2hDQc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $2hDQc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2hDQc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2hDQc.createElement($2hDQc.Fragment, null, /*#__PURE__*/ $2hDQc.createElement((0, $86f6846c59d1b386$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2hDQc.createElement((0, $86f6846c59d1b386$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $2hDQc.createElement($944912ac1928e04f$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $2hDQc.createElement($944912ac1928e04f$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $2hDQc.createElement((0, $86f6846c59d1b386$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $2hDQc.createElement($944912ac1928e04f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $944912ac1928e04f$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $86f6846c59d1b386$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $944912ac1928e04f$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $2hDQc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $df0c76e4858f6b9a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2hDQc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2hDQc.useCallback((newState)=>{
        v7_startTransition && $944912ac1928e04f$var$startTransitionImpl ? $944912ac1928e04f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2hDQc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $2hDQc.createElement((0, $86f6846c59d1b386$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $944912ac1928e04f$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $2hDQc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $df0c76e4858f6b9a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2hDQc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2hDQc.useCallback((newState)=>{
        v7_startTransition && $944912ac1928e04f$var$startTransitionImpl ? $944912ac1928e04f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2hDQc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $2hDQc.createElement((0, $86f6846c59d1b386$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $944912ac1928e04f$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $2hDQc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2hDQc.useCallback((newState)=>{
        v7_startTransition && $944912ac1928e04f$var$startTransitionImpl ? $944912ac1928e04f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2hDQc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $2hDQc.createElement((0, $86f6846c59d1b386$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $944912ac1928e04f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $944912ac1928e04f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $944912ac1928e04f$export$a6c7ac8248d6e38a = /*#__PURE__*/ $2hDQc.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $944912ac1928e04f$var$_objectWithoutPropertiesLoose(_ref7, $944912ac1928e04f$var$_excluded);
    let { basename: basename } = $2hDQc.useContext((0, $86f6846c59d1b386$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $944912ac1928e04f$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($944912ac1928e04f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $86f6846c59d1b386$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $944912ac1928e04f$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $2hDQc.createElement("a", $944912ac1928e04f$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $944912ac1928e04f$export$b0d92dbee9b5b60d = /*#__PURE__*/ $2hDQc.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $944912ac1928e04f$var$_objectWithoutPropertiesLoose(_ref8, $944912ac1928e04f$var$_excluded2);
    let path = (0, $86f6846c59d1b386$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $86f6846c59d1b386$export$45d76561a5302f2b)();
    let routerState = $2hDQc.useContext((0, $86f6846c59d1b386$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $2hDQc.useContext((0, $86f6846c59d1b386$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $944912ac1928e04f$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $2hDQc.createElement($944912ac1928e04f$export$a6c7ac8248d6e38a, $944912ac1928e04f$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $944912ac1928e04f$export$a7fed597f4b8afd8 = /*#__PURE__*/ $2hDQc.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $944912ac1928e04f$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $944912ac1928e04f$var$_objectWithoutPropertiesLoose(_ref9, $944912ac1928e04f$var$_excluded3);
    let submit = $944912ac1928e04f$export$47c85c6e3a081d3();
    let formAction = $944912ac1928e04f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $2hDQc.createElement("form", $944912ac1928e04f$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $944912ac1928e04f$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $944912ac1928e04f$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $944912ac1928e04f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($944912ac1928e04f$var$DataRouterHook || ($944912ac1928e04f$var$DataRouterHook = {}));
var $944912ac1928e04f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($944912ac1928e04f$var$DataRouterStateHook || ($944912ac1928e04f$var$DataRouterStateHook = {}));
// Internal hooks
function $944912ac1928e04f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $944912ac1928e04f$var$useDataRouterContext(hookName) {
    let ctx = $2hDQc.useContext((0, $86f6846c59d1b386$export$3add0d5dce533e2e));
    !ctx && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $944912ac1928e04f$var$useDataRouterState(hookName) {
    let state = $2hDQc.useContext((0, $86f6846c59d1b386$export$145dfa71566a64dc));
    !state && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $944912ac1928e04f$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    let location = (0, $86f6846c59d1b386$export$45d76561a5302f2b)();
    let path = (0, $86f6846c59d1b386$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $2hDQc.useCallback((event)=>{
        if ($944912ac1928e04f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $df0c76e4858f6b9a$export$fe53371bee54353d)(location) === (0, $df0c76e4858f6b9a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $944912ac1928e04f$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $2hDQc.useRef($944912ac1928e04f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $2hDQc.useRef(false);
    let location = (0, $86f6846c59d1b386$export$45d76561a5302f2b)();
    let searchParams = $2hDQc.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $944912ac1928e04f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    let setSearchParams = $2hDQc.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $944912ac1928e04f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $944912ac1928e04f$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $944912ac1928e04f$var$fetcherId = 0;
let $944912ac1928e04f$var$getUniqueFetcherId = ()=>"__" + String(++$944912ac1928e04f$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $944912ac1928e04f$export$47c85c6e3a081d3() {
    let { router: router } = $944912ac1928e04f$var$useDataRouterContext($944912ac1928e04f$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $2hDQc.useContext((0, $86f6846c59d1b386$export$26749e8557646306));
    let currentRouteId = (0, $86f6846c59d1b386$export$5fc8298006ad9e58)();
    return $2hDQc.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $944912ac1928e04f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $944912ac1928e04f$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $944912ac1928e04f$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $944912ac1928e04f$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $2hDQc.useContext((0, $86f6846c59d1b386$export$26749e8557646306));
    let routeContext = $2hDQc.useContext((0, $86f6846c59d1b386$export$9072aa6dd1f93057));
    !routeContext && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $944912ac1928e04f$var$_extends({}, (0, $86f6846c59d1b386$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $86f6846c59d1b386$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $df0c76e4858f6b9a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $df0c76e4858f6b9a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $944912ac1928e04f$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $944912ac1928e04f$var$useDataRouterContext($944912ac1928e04f$var$DataRouterHook.UseFetcher);
    let state = $944912ac1928e04f$var$useDataRouterState($944912ac1928e04f$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $2hDQc.useContext($944912ac1928e04f$export$148fd98d095596d4);
    let route = $2hDQc.useContext((0, $86f6846c59d1b386$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    !route && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $944912ac1928e04f$var$useIdImpl ? $944912ac1928e04f$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $2hDQc.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($944912ac1928e04f$var$getUniqueFetcherId());
    // Registration/cleanup
    $2hDQc.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $2hDQc.useCallback((href, opts)=>{
        !routeId && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $944912ac1928e04f$export$47c85c6e3a081d3();
    let submit = $2hDQc.useCallback((target, opts)=>{
        submitImpl(target, $944912ac1928e04f$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $2hDQc.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $2hDQc.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $2hDQc.createElement($944912ac1928e04f$export$a7fed597f4b8afd8, $944912ac1928e04f$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $df0c76e4858f6b9a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $2hDQc.useMemo(()=>$944912ac1928e04f$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $944912ac1928e04f$export$fa996778a3a31087() {
    let state = $944912ac1928e04f$var$useDataRouterState($944912ac1928e04f$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $944912ac1928e04f$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $944912ac1928e04f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $944912ac1928e04f$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $944912ac1928e04f$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $944912ac1928e04f$var$useDataRouterContext($944912ac1928e04f$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $944912ac1928e04f$var$useDataRouterState($944912ac1928e04f$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $2hDQc.useContext((0, $86f6846c59d1b386$export$26749e8557646306));
    let location = (0, $86f6846c59d1b386$export$45d76561a5302f2b)();
    let matches = (0, $86f6846c59d1b386$export$2378eb7f5ff86053)();
    let navigation = (0, $86f6846c59d1b386$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $2hDQc.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $944912ac1928e04f$var$usePageHide($2hDQc.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $944912ac1928e04f$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $944912ac1928e04f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($944912ac1928e04f$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2hDQc.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $944912ac1928e04f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $944912ac1928e04f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2hDQc.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($944912ac1928e04f$var$_extends({}, location, {
                    pathname: (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($944912ac1928e04f$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2hDQc.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $944912ac1928e04f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $2hDQc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $944912ac1928e04f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $2hDQc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $944912ac1928e04f$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $86f6846c59d1b386$export$b273b3273281a049)(when);
    $2hDQc.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $2hDQc.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $944912ac1928e04f$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $2hDQc.useContext($944912ac1928e04f$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $df0c76e4858f6b9a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $944912ac1928e04f$var$useDataRouterContext($944912ac1928e04f$var$DataRouterHook.useViewTransitionState);
    let path = (0, $86f6846c59d1b386$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $df0c76e4858f6b9a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $df0c76e4858f6b9a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $df0c76e4858f6b9a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $592Nh = parcelRequire("592Nh");

var $592Nh = parcelRequire("592Nh");
var $a8df4d8b672eba1c$exports = {};
"use strict";
Object.defineProperty($a8df4d8b672eba1c$exports, "__esModule", {
    value: true
});
$a8df4d8b672eba1c$exports.FormattedListParts = $a8df4d8b672eba1c$exports.FormattedNumberParts = $a8df4d8b672eba1c$exports.FormattedTimeParts = $a8df4d8b672eba1c$exports.FormattedDateParts = $a8df4d8b672eba1c$exports.FormattedDisplayName = $a8df4d8b672eba1c$exports.FormattedList = $a8df4d8b672eba1c$exports.FormattedNumber = $a8df4d8b672eba1c$exports.FormattedTime = $a8df4d8b672eba1c$exports.FormattedDate = $a8df4d8b672eba1c$exports.defineMessage = $a8df4d8b672eba1c$exports.defineMessages = $a8df4d8b672eba1c$exports.ReactIntlError = $a8df4d8b672eba1c$exports.ReactIntlErrorCode = $a8df4d8b672eba1c$exports.MissingTranslationError = $a8df4d8b672eba1c$exports.MessageFormatError = $a8df4d8b672eba1c$exports.MissingDataError = $a8df4d8b672eba1c$exports.InvalidConfigError = $a8df4d8b672eba1c$exports.UnsupportedFormatterError = $a8df4d8b672eba1c$exports.createIntlCache = $a8df4d8b672eba1c$exports.useIntl = $a8df4d8b672eba1c$exports.injectIntl = $a8df4d8b672eba1c$exports.createIntl = $a8df4d8b672eba1c$exports.RawIntlProvider = $a8df4d8b672eba1c$exports.IntlProvider = $a8df4d8b672eba1c$exports.IntlContext = $a8df4d8b672eba1c$exports.FormattedRelativeTime = $a8df4d8b672eba1c$exports.FormattedPlural = $a8df4d8b672eba1c$exports.FormattedMessage = $a8df4d8b672eba1c$exports.FormattedDateTimeRange = void 0;

var $4UZnF = parcelRequire("4UZnF");
var $a56f75904bdf68d1$exports = {};
"use strict";
Object.defineProperty($a56f75904bdf68d1$exports, "__esModule", {
    value: true
});
$a56f75904bdf68d1$exports.createFormattedComponent = $a56f75904bdf68d1$exports.createFormattedDateTimePartsComponent = $a56f75904bdf68d1$exports.FormattedListParts = $a56f75904bdf68d1$exports.FormattedNumberParts = void 0;

var $4UZnF = parcelRequire("4UZnF");

var $a56f75904bdf68d1$var$React = $4UZnF.__importStar((parcelRequire("2hDQc")));

var $a56f75904bdf68d1$var$useIntl_1 = $4UZnF.__importDefault((parcelRequire("4opbb")));
var $a56f75904bdf68d1$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($a56f75904bdf68d1$var$DisplayName || ($a56f75904bdf68d1$var$DisplayName = {}));
var $a56f75904bdf68d1$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($a56f75904bdf68d1$var$DisplayNameParts || ($a56f75904bdf68d1$var$DisplayNameParts = {}));
var $a56f75904bdf68d1$var$FormattedNumberParts = function(props) {
    var intl = (0, $a56f75904bdf68d1$var$useIntl_1.default)();
    var value = props.value, children = props.children, formatProps = $4UZnF.__rest(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$a56f75904bdf68d1$exports.FormattedNumberParts = $a56f75904bdf68d1$var$FormattedNumberParts;
$a56f75904bdf68d1$exports.FormattedNumberParts.displayName = "FormattedNumberParts";
var $a56f75904bdf68d1$var$FormattedListParts = function(props) {
    var intl = (0, $a56f75904bdf68d1$var$useIntl_1.default)();
    var value = props.value, children = props.children, formatProps = $4UZnF.__rest(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$a56f75904bdf68d1$exports.FormattedListParts = $a56f75904bdf68d1$var$FormattedListParts;
$a56f75904bdf68d1$exports.FormattedNumberParts.displayName = "FormattedNumberParts";
function $a56f75904bdf68d1$var$createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, $a56f75904bdf68d1$var$useIntl_1.default)();
        var value = props.value, children = props.children, formatProps = $4UZnF.__rest(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $a56f75904bdf68d1$var$DisplayNameParts[name];
    return ComponentParts;
}
$a56f75904bdf68d1$exports.createFormattedDateTimePartsComponent = $a56f75904bdf68d1$var$createFormattedDateTimePartsComponent;
function $a56f75904bdf68d1$var$createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, $a56f75904bdf68d1$var$useIntl_1.default)();
        var value = props.value, children = props.children, formatProps = $4UZnF.__rest(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $a56f75904bdf68d1$var$React.Fragment;
        return $a56f75904bdf68d1$var$React.createElement(Text, null, formattedValue);
    };
    Component.displayName = $a56f75904bdf68d1$var$DisplayName[name];
    return Component;
}
$a56f75904bdf68d1$exports.createFormattedComponent = $a56f75904bdf68d1$var$createFormattedComponent;



var $a8df4d8b672eba1c$var$injectIntl_1 = $4UZnF.__importStar((parcelRequire("jri4r")));
$a8df4d8b672eba1c$exports.injectIntl = $a8df4d8b672eba1c$var$injectIntl_1.default;
Object.defineProperty($a8df4d8b672eba1c$exports, "RawIntlProvider", {
    enumerable: true,
    get: function() {
        return $a8df4d8b672eba1c$var$injectIntl_1.Provider;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "IntlContext", {
    enumerable: true,
    get: function() {
        return $a8df4d8b672eba1c$var$injectIntl_1.Context;
    }
});

var $a8df4d8b672eba1c$var$useIntl_1 = $4UZnF.__importDefault((parcelRequire("4opbb")));
$a8df4d8b672eba1c$exports.useIntl = $a8df4d8b672eba1c$var$useIntl_1.default;

var $a8df4d8b672eba1c$var$provider_1 = $4UZnF.__importStar((parcelRequire("dPr95")));
$a8df4d8b672eba1c$exports.IntlProvider = $a8df4d8b672eba1c$var$provider_1.default;
Object.defineProperty($a8df4d8b672eba1c$exports, "createIntl", {
    enumerable: true,
    get: function() {
        return $a8df4d8b672eba1c$var$provider_1.createIntl;
    }
});

var $a8df4d8b672eba1c$var$relative_1 = $4UZnF.__importDefault((parcelRequire("d86l4")));
$a8df4d8b672eba1c$exports.FormattedRelativeTime = $a8df4d8b672eba1c$var$relative_1.default;

var $a8df4d8b672eba1c$var$plural_1 = $4UZnF.__importDefault((parcelRequire("bUUY0")));
$a8df4d8b672eba1c$exports.FormattedPlural = $a8df4d8b672eba1c$var$plural_1.default;

var $a8df4d8b672eba1c$var$message_1 = $4UZnF.__importDefault((parcelRequire("9eRn6")));
$a8df4d8b672eba1c$exports.FormattedMessage = $a8df4d8b672eba1c$var$message_1.default;

var $a8df4d8b672eba1c$var$dateTimeRange_1 = $4UZnF.__importDefault((parcelRequire("iUOSP")));
$a8df4d8b672eba1c$exports.FormattedDateTimeRange = $a8df4d8b672eba1c$var$dateTimeRange_1.default;

var $1Bl6Z = parcelRequire("1Bl6Z");
Object.defineProperty($a8df4d8b672eba1c$exports, "createIntlCache", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.createIntlCache;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "UnsupportedFormatterError", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.UnsupportedFormatterError;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "InvalidConfigError", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.InvalidConfigError;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "MissingDataError", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.MissingDataError;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "MessageFormatError", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.MessageFormatError;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "MissingTranslationError", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.MissingTranslationError;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "ReactIntlErrorCode", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.IntlErrorCode;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "ReactIntlError", {
    enumerable: true,
    get: function() {
        return $1Bl6Z.IntlError;
    }
});
function $a8df4d8b672eba1c$var$defineMessages(msgs) {
    return msgs;
}
$a8df4d8b672eba1c$exports.defineMessages = $a8df4d8b672eba1c$var$defineMessages;
function $a8df4d8b672eba1c$var$defineMessage(msg) {
    return msg;
}
$a8df4d8b672eba1c$exports.defineMessage = $a8df4d8b672eba1c$var$defineMessage;
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
$a8df4d8b672eba1c$exports.FormattedDate = (0, $a56f75904bdf68d1$exports.createFormattedComponent)("formatDate");
$a8df4d8b672eba1c$exports.FormattedTime = (0, $a56f75904bdf68d1$exports.createFormattedComponent)("formatTime");
$a8df4d8b672eba1c$exports.FormattedNumber = (0, $a56f75904bdf68d1$exports.createFormattedComponent)("formatNumber");
$a8df4d8b672eba1c$exports.FormattedList = (0, $a56f75904bdf68d1$exports.createFormattedComponent)("formatList");
$a8df4d8b672eba1c$exports.FormattedDisplayName = (0, $a56f75904bdf68d1$exports.createFormattedComponent)("formatDisplayName");
$a8df4d8b672eba1c$exports.FormattedDateParts = (0, $a56f75904bdf68d1$exports.createFormattedDateTimePartsComponent)("formatDate");
$a8df4d8b672eba1c$exports.FormattedTimeParts = (0, $a56f75904bdf68d1$exports.createFormattedDateTimePartsComponent)("formatTime");

Object.defineProperty($a8df4d8b672eba1c$exports, "FormattedNumberParts", {
    enumerable: true,
    get: function() {
        return $a56f75904bdf68d1$exports.FormattedNumberParts;
    }
});
Object.defineProperty($a8df4d8b672eba1c$exports, "FormattedListParts", {
    enumerable: true,
    get: function() {
        return $a56f75904bdf68d1$exports.FormattedListParts;
    }
});



var $fhlQp = parcelRequire("fhlQp");
const $ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0 = ({ labelText: labelText, value: value, color: color })=>{
    const ColoredValue = (0, $fhlQp.default)("span")(({ theme: theme })=>`
    font-weight: bold;
    ${color === "GREEN" ? `color: ${theme.palette.success.main};` : ""}
    ${color === "RED" ? `color: ${theme.palette.error.main};` : ""}
  `);
    const Item = (0, $fhlQp.default)("span")`
    display: block;
    margin: 0;
  `;
    const Value = (0, $fhlQp.default)("span")`
    font-weight: bold;
  `;
    const StyledLabel = (0, $fhlQp.default)("span")`
    margin-right: 0.3rem;
  `;
    return /*#__PURE__*/ (0, $592Nh.jsxs)(Item, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)(StyledLabel, {
                children: labelText
            }),
            color ? /*#__PURE__*/ (0, $592Nh.jsx)(ColoredValue, {
                children: value
            }) : /*#__PURE__*/ (0, $592Nh.jsx)(Value, {
                children: value
            })
        ]
    });
};
const $ac59c0458c13eb62$export$5fc72c219969b0e6 = ({ amount: amount, activeRights: activeRights })=>{
    const availableRights = activeRights;
    const percentage = availableRights > 0 && amount > 0 ? Math.round(availableRights / amount * 100) : 0;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "allocatedRights.rightsGranted"
                }),
                value: amount
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)($ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "allocatedRights.rightsShared"
                }),
                value: `${availableRights > 0 ? availableRights : 0} (${percentage} %)`,
                color: percentage > 100 ? "RED" : undefined
            })
        ]
    });
};
const $ac59c0458c13eb62$export$4421fe64f84f2e51 = ({ offering: offering })=>{
    if (offering.type === "WHITELIST") return /*#__PURE__*/ (0, $592Nh.jsx)($ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0, {
        labelText: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.place.offeringsTab.table.catalogue.amount"
        }),
        value: offering.summary.activeRights
    });
    if (offering.ignoreAmountForCatalogue) {
        const { activeRights: activeRights, cataloguesTotalAmount: cataloguesTotalAmount } = offering.summary;
        const availableRights = cataloguesTotalAmount - activeRights;
        const percentage = availableRights > 0 && cataloguesTotalAmount > 0 ? Math.round(availableRights / cataloguesTotalAmount * 100) : 0;
        const valueText = `${activeRights} / ${cataloguesTotalAmount}  (${100 - percentage} %)`;
        return /*#__PURE__*/ (0, $592Nh.jsx)($ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0, {
            labelText: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "allocatedRights.rightsGranted"
            }),
            value: valueText
        });
    }
    const amount = offering.ignoreAmountForCatalogue ? offering.summary.cataloguesTotalAmount : offering.amount;
    const activeRights = offering.ignoreAmountForCatalogue ? offering.summary.activeRights : offering.summary.cataloguesTotalAmount;
    const availableRights = amount - activeRights;
    const percentage = availableRights > 0 && amount > 0 ? Math.round(availableRights / amount * 100) : 0;
    const greenText = percentage && percentage <= 100;
    const redText = availableRights <= 0;
    const availableText = `${availableRights > 0 ? availableRights : 0} (${percentage} %)`;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "allocatedRights.rightsTotal"
                }),
                value: amount
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)($ac59c0458c13eb62$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "allocatedRights.available"
                }),
                value: availableText,
                color: greenText || redText ? greenText ? "GREEN" : "RED" : undefined
            })
        ]
    });
};



var $592Nh = parcelRequire("592Nh");
const $1a19893cc26bc20f$export$55bcc68ad4a40abc = 300000;
const $1a19893cc26bc20f$export$136d5c9516c6d4cd = "getAuthSession";
const $1a19893cc26bc20f$export$93e1682d8eaccc31 = "getCataloguesByRef";
const $1a19893cc26bc20f$export$5ff0e82f48d2f8dc = "getCatalogues";
const $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d = "getCataloguesByOffering";
const $1a19893cc26bc20f$export$90904af181961b2 = "getCataloguesForLogin";
const $1a19893cc26bc20f$export$e94a35ab41f6d829 = "getCataloguesActiveRights";
const $1a19893cc26bc20f$export$6efe1800fcda6819 = "getCustomers";
const $1a19893cc26bc20f$export$b3c26f5832e8795f = "getCustomerByRef";
const $1a19893cc26bc20f$export$248423ad5d5be84a = "getIndividuals";
const $1a19893cc26bc20f$export$9f074a658d5580d = "getIndividualsByEmail";
const $1a19893cc26bc20f$export$96f07f442214aab = "getAdminInvitationsById";
const $1a19893cc26bc20f$export$7a161aff508d2cb1 = "getLandlordInvitationsById";
const $1a19893cc26bc20f$export$415ddc16ccdc9af1 = "getTenantInvitationsById";
const $1a19893cc26bc20f$export$a10de6d4556ab62e = "getUserInvitations";
const $1a19893cc26bc20f$export$a8e0fd0e2c725bd = "getLandlordsForLogin";
const $1a19893cc26bc20f$export$70a73d059c6beff0 = "getOfferingsByPlace";
const $1a19893cc26bc20f$export$79b5a04d4c49a4e2 = "getOfferingsById";
const $1a19893cc26bc20f$export$d6da98a467d609dc = "getPlaces";
const $1a19893cc26bc20f$export$823cd27a3f5f229e = "getPlaceByRef";
const $1a19893cc26bc20f$export$9e8d1e7efde0f0d3 = "getPlacesForLogin";
const $1a19893cc26bc20f$export$995d68b6ebb26447 = "getPlacesByCustomer";
const $1a19893cc26bc20f$export$475c1d76a7297be4 = "getRightHolderByRef";
const $1a19893cc26bc20f$export$d1676135628eec72 = "getRightByRef";
const $1a19893cc26bc20f$export$6d14da40fa4f1ffe = "getAdminUsersByRef";
const $1a19893cc26bc20f$export$9eb9aa3283b45cff = "getOfferingRightHolders";
const $1a19893cc26bc20f$export$9512f33c9b8e71c5 = "moovyOfferingRightHoldersPaging";
const $1a19893cc26bc20f$export$209a8ef612aeedd2 = "moovyOfferingRightHoldersSorting";





var $592Nh = parcelRequire("592Nh");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");

var $fLRFO = parcelRequire("fLRFO");

var $lxfp9 = parcelRequire("lxfp9");

var $fZq7u = parcelRequire("fZq7u");
var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $lCJj0 = parcelRequire("lCJj0");

var $870HA = parcelRequire("870HA");
const $5fa628c4a09d9d65$var$_excluded = [
    "sx"
];
const $5fa628c4a09d9d65$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $870HA.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $5fa628c4a09d9d65$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $gZOiq.default)(props, $5fa628c4a09d9d65$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $5fa628c4a09d9d65$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $lCJj0.isPlainObject)(result)) return systemProps;
        return (0, $kxIgO.default)({}, systemProps, result);
    };
    else finalSx = (0, $kxIgO.default)({}, systemProps, inSx);
    return (0, $kxIgO.default)({}, otherProps, {
        sx: finalSx
    });
}



var $cQwLz = parcelRequire("cQwLz");

var $592Nh = parcelRequire("592Nh");
"use client";
const $dbd1eea2e4f94e10$var$_excluded = [
    "className",
    "component"
];
function $dbd1eea2e4f94e10$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $lxfp9.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $fZq7u.default));
    const Box = /*#__PURE__*/ $2hDQc.forwardRef(function Box(inProps, ref) {
        const theme = (0, $cQwLz.default)(defaultTheme);
        const _extendSxProp = (0, $5fa628c4a09d9d65$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $gZOiq.default)(_extendSxProp, $dbd1eea2e4f94e10$var$_excluded);
        return /*#__PURE__*/ (0, $592Nh.jsx)(BoxRoot, (0, $kxIgO.default)({
            as: component,
            ref: ref,
            className: (0, $fLRFO.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $4WSmP = parcelRequire("4WSmP");

var $gWoNj = parcelRequire("gWoNj");

var $3apk9 = parcelRequire("3apk9");

var $eLydt = parcelRequire("eLydt");
const $f80a2d99fbb124ed$var$boxClasses = (0, $eLydt.default)("MuiBox", [
    "root"
]);
var $f80a2d99fbb124ed$export$2e2bcd8739ae039 = $f80a2d99fbb124ed$var$boxClasses;


"use client";
const $a0431259ffdfa92f$var$defaultTheme = (0, $gWoNj.default)();
const $a0431259ffdfa92f$var$Box = (0, $dbd1eea2e4f94e10$export$2e2bcd8739ae039)({
    themeId: (0, $3apk9.default),
    defaultTheme: $a0431259ffdfa92f$var$defaultTheme,
    defaultClassName: (0, $f80a2d99fbb124ed$export$2e2bcd8739ae039).root,
    generateClassName: (0, $4WSmP.default).generate
});
var $a0431259ffdfa92f$export$2e2bcd8739ae039 = $a0431259ffdfa92f$var$Box;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $koNI7 = parcelRequire("koNI7");

var $dJnC1 = parcelRequire("dJnC1");


var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");
parcelRequire("2hDQc");

var $cQwLz = parcelRequire("cQwLz");

var $7D60m = parcelRequire("7D60m");

var $3apk9 = parcelRequire("3apk9");
"use client";
function $6d5944649970f6ea$export$2e2bcd8739ae039() {
    const theme = (0, $cQwLz.default)((0, $7D60m.default));
    return theme[0, $3apk9.default] || theme;
}



var $2hDQc = parcelRequire("2hDQc");
"use client";
/**
 * @ignore - internal component.
 */ const $6d9aeb3e7a9b8603$var$GridContext = /*#__PURE__*/ $2hDQc.createContext();
var $6d9aeb3e7a9b8603$export$2e2bcd8739ae039 = $6d9aeb3e7a9b8603$var$GridContext;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $6611dcbe1b21dfb8$export$9973ac5fd0181f33(slot) {
    return (0, $01COD.default)("MuiGrid", slot);
}
const $6611dcbe1b21dfb8$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $6611dcbe1b21dfb8$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $6611dcbe1b21dfb8$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $6611dcbe1b21dfb8$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $6611dcbe1b21dfb8$var$gridClasses = (0, $eLydt.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$6611dcbe1b21dfb8$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$6611dcbe1b21dfb8$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$6611dcbe1b21dfb8$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$6611dcbe1b21dfb8$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$6611dcbe1b21dfb8$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$6611dcbe1b21dfb8$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$6611dcbe1b21dfb8$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$6611dcbe1b21dfb8$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $6611dcbe1b21dfb8$export$2e2bcd8739ae039 = $6611dcbe1b21dfb8$var$gridClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $15071aa7586bdd58$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $15071aa7586bdd58$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $15071aa7586bdd58$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $koNI7.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$15071aa7586bdd58$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $kxIgO.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $15071aa7586bdd58$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $koNI7.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $koNI7.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $6611dcbe1b21dfb8$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $15071aa7586bdd58$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $15071aa7586bdd58$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $koNI7.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $15071aa7586bdd58$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $koNI7.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$15071aa7586bdd58$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $6611dcbe1b21dfb8$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $15071aa7586bdd58$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $6611dcbe1b21dfb8$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $15071aa7586bdd58$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $koNI7.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $15071aa7586bdd58$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $koNI7.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$15071aa7586bdd58$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$15071aa7586bdd58$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $6611dcbe1b21dfb8$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $15071aa7586bdd58$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $6611dcbe1b21dfb8$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $15071aa7586bdd58$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $15071aa7586bdd58$var$GridRoot = (0, $fhlQp.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $15071aa7586bdd58$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $15071aa7586bdd58$export$71d4225eeb1bc13e, $15071aa7586bdd58$export$380604d7c79f9e8f, $15071aa7586bdd58$export$4315fba5128fb4a1, $15071aa7586bdd58$export$ca2a698f6020fda);
function $15071aa7586bdd58$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $15071aa7586bdd58$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $15071aa7586bdd58$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $6611dcbe1b21dfb8$export$9973ac5fd0181f33), classes);
};
const $15071aa7586bdd58$var$Grid = /*#__PURE__*/ $2hDQc.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $afHYP.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const props = (0, $5fa628c4a09d9d65$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $gZOiq.default)(props, $15071aa7586bdd58$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $2hDQc.useContext((0, $6d9aeb3e7a9b8603$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $kxIgO.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $15071aa7586bdd58$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $6d9aeb3e7a9b8603$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($15071aa7586bdd58$var$GridRoot, (0, $kxIgO.default)({
            ownerState: ownerState,
            className: (0, $fLRFO.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $15071aa7586bdd58$export$2e2bcd8739ae039 = $15071aa7586bdd58$var$Grid;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $7fbb0f478038477e$export$427f1c1e2e839f85(slot) {
    return (0, $01COD.default)("MuiPagination", slot);
}
const $7fbb0f478038477e$var$paginationClasses = (0, $eLydt.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
var $7fbb0f478038477e$export$2e2bcd8739ae039 = $7fbb0f478038477e$var$paginationClasses;



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");
"use client";
function $e6fa6f6bfcc49892$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $2hDQc.useRef(controlled !== undefined);
    const [valueState, setValue] = $2hDQc.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $2hDQc.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
const $5266e6da9531d147$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $5266e6da9531d147$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = "usePagination", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $gZOiq.default)(props, $5266e6da9531d147$var$_excluded);
    const [page, setPageState] = (0, $e6fa6f6bfcc49892$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $kxIgO.default)({
        items: items
    }, other);
}



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $13beb939d6e12be9$export$e4ce0a775adf2f74(slot) {
    return (0, $01COD.default)("MuiPaginationItem", slot);
}
const $13beb939d6e12be9$var$paginationItemClasses = (0, $eLydt.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
var $13beb939d6e12be9$export$2e2bcd8739ae039 = $13beb939d6e12be9$var$paginationItemClasses;




var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $2hDQc = parcelRequire("2hDQc");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $bf8564c56950a7db$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $b737a795d4422d4b$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $2hDQc.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $bf8564c56950a7db$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $699b323bc31c9932$export$2e2bcd8739ae039 = (0, $b737a795d4422d4b$export$2e2bcd8739ae039);



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $126d93cc939ed77e$var$useEnhancedEffect = typeof window !== "undefined" ? $2hDQc.useLayoutEffect : $2hDQc.useEffect;
var $126d93cc939ed77e$export$2e2bcd8739ae039 = $126d93cc939ed77e$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $09890193466d3518$var$useEventCallback(fn) {
    const ref = $2hDQc.useRef(fn);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $2hDQc.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $09890193466d3518$export$2e2bcd8739ae039 = $09890193466d3518$var$useEventCallback;


"use client";
var $5f74bea4646b1b07$export$2e2bcd8739ae039 = (0, $09890193466d3518$export$2e2bcd8739ae039);



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
"use client";
const $1f8fb7ce8c03c4e0$var$UNINITIALIZED = {};
function $1f8fb7ce8c03c4e0$export$2e2bcd8739ae039(init, initArg) {
    const ref = $2hDQc.useRef($1f8fb7ce8c03c4e0$var$UNINITIALIZED);
    if (ref.current === $1f8fb7ce8c03c4e0$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $2hDQc = parcelRequire("2hDQc");
"use client";
const $510275819374c967$var$EMPTY = [];
function $510275819374c967$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $2hDQc.useEffect(fn, $510275819374c967$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $15f15456097d008b$export$786b4da70f00938b {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $15f15456097d008b$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
}
function $15f15456097d008b$export$2e2bcd8739ae039() {
    const timeout = (0, $1f8fb7ce8c03c4e0$export$2e2bcd8739ae039)($15f15456097d008b$export$786b4da70f00938b.create).current;
    (0, $510275819374c967$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $b99b368f532f0e73$var$hadKeyboardEvent = true;
let $b99b368f532f0e73$var$hadFocusVisibleRecently = false;
const $b99b368f532f0e73$var$hadFocusVisibleRecentlyTimeout = new (0, $15f15456097d008b$export$786b4da70f00938b)();
const $b99b368f532f0e73$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $b99b368f532f0e73$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $b99b368f532f0e73$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $b99b368f532f0e73$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $b99b368f532f0e73$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $b99b368f532f0e73$var$handlePointerDown() {
    $b99b368f532f0e73$var$hadKeyboardEvent = false;
}
function $b99b368f532f0e73$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($b99b368f532f0e73$var$hadFocusVisibleRecently) $b99b368f532f0e73$var$hadKeyboardEvent = true;
    }
}
function $b99b368f532f0e73$var$prepare(doc) {
    doc.addEventListener("keydown", $b99b368f532f0e73$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $b99b368f532f0e73$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $b99b368f532f0e73$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $b99b368f532f0e73$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $b99b368f532f0e73$var$handleVisibilityChange, true);
}
function $b99b368f532f0e73$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $b99b368f532f0e73$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $b99b368f532f0e73$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $b99b368f532f0e73$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $b99b368f532f0e73$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $b99b368f532f0e73$var$handleVisibilityChange, true);
}
function $b99b368f532f0e73$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $b99b368f532f0e73$var$hadKeyboardEvent || $b99b368f532f0e73$var$focusTriggersKeyboardModality(target);
}
function $b99b368f532f0e73$export$2e2bcd8739ae039() {
    const ref = $2hDQc.useCallback((node)=>{
        if (node != null) $b99b368f532f0e73$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $2hDQc.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $b99b368f532f0e73$var$hadFocusVisibleRecently = true;
            $b99b368f532f0e73$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $b99b368f532f0e73$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($b99b368f532f0e73$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $d9607cff52dbd157$export$2e2bcd8739ae039 = (0, $b99b368f532f0e73$export$2e2bcd8739ae039);



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");
function $271fbe739d47e6d6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $e11610c2275b6ad2$export$2e2bcd8739ae039(o, p) {
    $e11610c2275b6ad2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e11610c2275b6ad2$export$2e2bcd8739ae039(o, p);
}


function $dfdff6b428ca04e3$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $e11610c2275b6ad2$export$2e2bcd8739ae039)(subClass, superClass);
}




var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
var $fe107dad5725a895$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createContext(null);



var $2hDQc = parcelRequire("2hDQc");
function $c7219f86a0cb5195$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $2hDQc.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $2hDQc.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c7219f86a0cb5195$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c7219f86a0cb5195$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c7219f86a0cb5195$export$fa71e2345c31d7a2(props, onExited) {
    return $c7219f86a0cb5195$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $2hDQc.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $c7219f86a0cb5195$var$getProp(child, "appear", props),
            enter: $c7219f86a0cb5195$var$getProp(child, "enter", props),
            exit: $c7219f86a0cb5195$var$getProp(child, "exit", props)
        });
    });
}
function $c7219f86a0cb5195$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c7219f86a0cb5195$export$bbc8a025727ea824(nextProps.children);
    var children = $c7219f86a0cb5195$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $2hDQc.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $2hDQc.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $2hDQc.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $c7219f86a0cb5195$var$getProp(child, "exit", nextProps),
            enter: $c7219f86a0cb5195$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $2hDQc.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $2hDQc.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $2hDQc.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $c7219f86a0cb5195$var$getProp(child, "exit", nextProps),
            enter: $c7219f86a0cb5195$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $1eae365b5beaad76$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $1eae365b5beaad76$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $1eae365b5beaad76$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $dfdff6b428ca04e3$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $271fbe739d47e6d6$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $c7219f86a0cb5195$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $c7219f86a0cb5195$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $c7219f86a0cb5195$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kxIgO.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $gZOiq.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $1eae365b5beaad76$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $fe107dad5725a895$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $fe107dad5725a895$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Component);
$1eae365b5beaad76$var$TransitionGroup.propTypes = {};
$1eae365b5beaad76$var$TransitionGroup.defaultProps = $1eae365b5beaad76$var$defaultProps;
var $1eae365b5beaad76$export$2e2bcd8739ae039 = $1eae365b5beaad76$var$TransitionGroup;



var $fLRFO = parcelRequire("fLRFO");

var $3NAKi = parcelRequire("3NAKi");


var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $592Nh = parcelRequire("592Nh");
"use client";
function $8e0d2b89727d4b50$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $2hDQc.useState(false);
    const rippleClassName = (0, $fLRFO.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fLRFO.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $2hDQc.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $592Nh.jsx)("span", {
            className: childClassName
        })
    });
}
var $8e0d2b89727d4b50$export$2e2bcd8739ae039 = $8e0d2b89727d4b50$var$Ripple;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $cc4df76bf2ef82f7$export$b464606f735ab902(slot) {
    return (0, $01COD.default)("MuiTouchRipple", slot);
}
const $cc4df76bf2ef82f7$var$touchRippleClasses = (0, $eLydt.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $cc4df76bf2ef82f7$export$2e2bcd8739ae039 = $cc4df76bf2ef82f7$var$touchRippleClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $2301b7c89f8b3a08$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $2301b7c89f8b3a08$var$_ = (t)=>t, $2301b7c89f8b3a08$var$_t, $2301b7c89f8b3a08$var$_t2, $2301b7c89f8b3a08$var$_t3, $2301b7c89f8b3a08$var$_t4;
const $2301b7c89f8b3a08$var$DURATION = 550;
const $2301b7c89f8b3a08$export$95d0c9356b2231a3 = 80;
const $2301b7c89f8b3a08$var$enterKeyframe = (0, $3NAKi.keyframes)($2301b7c89f8b3a08$var$_t || ($2301b7c89f8b3a08$var$_t = $2301b7c89f8b3a08$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $2301b7c89f8b3a08$var$exitKeyframe = (0, $3NAKi.keyframes)($2301b7c89f8b3a08$var$_t2 || ($2301b7c89f8b3a08$var$_t2 = $2301b7c89f8b3a08$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $2301b7c89f8b3a08$var$pulsateKeyframe = (0, $3NAKi.keyframes)($2301b7c89f8b3a08$var$_t3 || ($2301b7c89f8b3a08$var$_t3 = $2301b7c89f8b3a08$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $2301b7c89f8b3a08$export$f6b7418508c72c25 = (0, $fhlQp.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $2301b7c89f8b3a08$export$676cfe7b12693c4b = (0, $fhlQp.default)((0, $8e0d2b89727d4b50$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($2301b7c89f8b3a08$var$_t4 || ($2301b7c89f8b3a08$var$_t4 = $2301b7c89f8b3a08$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).rippleVisible, $2301b7c89f8b3a08$var$enterKeyframe, $2301b7c89f8b3a08$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).child, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).childLeaving, $2301b7c89f8b3a08$var$exitKeyframe, $2301b7c89f8b3a08$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).childPulsate, $2301b7c89f8b3a08$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $2301b7c89f8b3a08$var$TouchRipple = /*#__PURE__*/ $2hDQc.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $gZOiq.default)(props, $2301b7c89f8b3a08$var$_excluded);
    const [ripples, setRipples] = $2hDQc.useState([]);
    const nextKey = $2hDQc.useRef(0);
    const rippleCallback = $2hDQc.useRef(null);
    $2hDQc.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $2hDQc.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $2hDQc.useRef(null);
    const container = $2hDQc.useRef(null);
    const startCommit = $2hDQc.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $592Nh.jsx)($2301b7c89f8b3a08$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fLRFO.default)(classes.ripple, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $fLRFO.default)(classes.rippleVisible, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $fLRFO.default)(classes.ripplePulsate, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $fLRFO.default)(classes.child, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $fLRFO.default)(classes.childLeaving, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $fLRFO.default)(classes.childPulsate, (0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $2301b7c89f8b3a08$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $2hDQc.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($2301b7c89f8b3a08$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $2hDQc.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $2hDQc.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $2hDQc.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)($2301b7c89f8b3a08$export$f6b7418508c72c25, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)((0, $cc4df76bf2ef82f7$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $1eae365b5beaad76$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $2301b7c89f8b3a08$export$2e2bcd8739ae039 = $2301b7c89f8b3a08$var$TouchRipple;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $721c466bbf0a336d$export$fccb0498dcd99783(slot) {
    return (0, $01COD.default)("MuiButtonBase", slot);
}
const $721c466bbf0a336d$var$buttonBaseClasses = (0, $eLydt.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $721c466bbf0a336d$export$2e2bcd8739ae039 = $721c466bbf0a336d$var$buttonBaseClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $1379cc80d8f1a214$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $1379cc80d8f1a214$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $721c466bbf0a336d$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $1379cc80d8f1a214$export$7ec0dcc5e3cdcd36 = (0, $fhlQp.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $721c466bbf0a336d$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $1379cc80d8f1a214$var$ButtonBase = /*#__PURE__*/ $2hDQc.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $gZOiq.default)(props, $1379cc80d8f1a214$var$_excluded);
    const buttonRef = $2hDQc.useRef(null);
    const rippleRef = $2hDQc.useRef(null);
    const handleRippleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $d9607cff52dbd157$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $2hDQc.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $2hDQc.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $2hDQc.useState(false);
    $2hDQc.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $2hDQc.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $2hDQc.useRef(false);
    const handleKeyDown = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kxIgO.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $1379cc80d8f1a214$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($1379cc80d8f1a214$export$7ec0dcc5e3cdcd36, (0, $kxIgO.default)({
        as: ComponentProp,
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $592Nh.jsx)((0, $2301b7c89f8b3a08$export$2e2bcd8739ae039), (0, $kxIgO.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $1379cc80d8f1a214$export$2e2bcd8739ae039 = $1379cc80d8f1a214$var$ButtonBase;



var $lfMLv = parcelRequire("lfMLv");
parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $0db49f137278959a$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $4d461b560a61171f$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $4cfc861ddf7abc8d$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $4b736806fadc21f2$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $66e046f877d85f3a$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $66e046f877d85f3a$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $lfMLv.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, $lfMLv.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, $lfMLv.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const $66e046f877d85f3a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, $lfMLv.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, $lfMLv.default)(color)}`,
            color !== "standard" && `${variant}${(0, $lfMLv.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $13beb939d6e12be9$export$e4ce0a775adf2f74), classes);
};
const $66e046f877d85f3a$var$PaginationItemEllipsis = (0, $fhlQp.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $66e046f877d85f3a$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const $66e046f877d85f3a$var$PaginationItemPage = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $66e046f877d85f3a$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.variant === "text" && {
        [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).selected}`]: (0, $kxIgO.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).selected}`]: (0, $kxIgO.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $13beb939d6e12be9$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $66e046f877d85f3a$var$PaginationItemPageIcon = (0, $fhlQp.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $66e046f877d85f3a$var$PaginationItem = /*#__PURE__*/ $2hDQc.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className: className, color: color = "standard", component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = "circular", size: size = "medium", slots: slots = {}, type: type = "page", variant: variant = "text" } = props, other = (0, $gZOiq.default)(props, $66e046f877d85f3a$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const classes = $66e046f877d85f3a$var$useUtilityClasses(ownerState);
    const normalizedIcons = theme.direction === "rtl" ? {
        previous: slots.next || components.next || (0, $4b736806fadc21f2$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $4cfc861ddf7abc8d$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $0db49f137278959a$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $4d461b560a61171f$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $4cfc861ddf7abc8d$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $4b736806fadc21f2$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $0db49f137278959a$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $4d461b560a61171f$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, $592Nh.jsx)($66e046f877d85f3a$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $592Nh.jsxs)($66e046f877d85f3a$var$PaginationItemPage, (0, $kxIgO.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $fLRFO.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, $592Nh.jsx)($66e046f877d85f3a$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $66e046f877d85f3a$export$2e2bcd8739ae039 = $66e046f877d85f3a$var$PaginationItem;



var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $3360a10e2d2b01ef$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $3360a10e2d2b01ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $7fbb0f478038477e$export$427f1c1e2e839f85), classes);
};
const $3360a10e2d2b01ef$var$PaginationRoot = (0, $fhlQp.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $3360a10e2d2b01ef$var$PaginationUl = (0, $fhlQp.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function $3360a10e2d2b01ef$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const $3360a10e2d2b01ef$var$Pagination = /*#__PURE__*/ $2hDQc.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = "standard", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $3360a10e2d2b01ef$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $66e046f877d85f3a$export$2e2bcd8739ae039), (0, $kxIgO.default)({}, item)), shape: shape = "circular", showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = "medium", variant: variant = "text" } = props, other = (0, $gZOiq.default)(props, $3360a10e2d2b01ef$var$_excluded);
    const { items: items } = (0, $5266e6da9531d147$export$2e2bcd8739ae039)((0, $kxIgO.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, $kxIgO.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $3360a10e2d2b01ef$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($3360a10e2d2b01ef$var$PaginationRoot, (0, $kxIgO.default)({
        "aria-label": "pagination navigation",
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($3360a10e2d2b01ef$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)("li", {
                    children: renderItem((0, $kxIgO.default)({}, item, {
                        color: color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $3360a10e2d2b01ef$export$2e2bcd8739ae039 = $3360a10e2d2b01ef$var$Pagination;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $1d035842121e91ff$export$24c1f8f60cbac79e(slot) {
    return (0, $01COD.default)("MuiTypography", slot);
}
const $1d035842121e91ff$var$typographyClasses = (0, $eLydt.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $1d035842121e91ff$export$2e2bcd8739ae039 = $1d035842121e91ff$var$typographyClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $df1a4ec584b17f6d$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $df1a4ec584b17f6d$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $lfMLv.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $1d035842121e91ff$export$24c1f8f60cbac79e), classes);
};
const $df1a4ec584b17f6d$export$140e2f5526d3cad8 = (0, $fhlQp.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $lfMLv.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $df1a4ec584b17f6d$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $df1a4ec584b17f6d$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $df1a4ec584b17f6d$var$transformDeprecatedColors = (color)=>{
    return $df1a4ec584b17f6d$var$colorTransformations[color] || color;
};
const $df1a4ec584b17f6d$var$Typography = /*#__PURE__*/ $2hDQc.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $df1a4ec584b17f6d$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $5fa628c4a09d9d65$export$2e2bcd8739ae039)((0, $kxIgO.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $df1a4ec584b17f6d$var$defaultVariantMapping } = props, other = (0, $gZOiq.default)(props, $df1a4ec584b17f6d$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $df1a4ec584b17f6d$var$defaultVariantMapping[variant]) || "span";
    const classes = $df1a4ec584b17f6d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($df1a4ec584b17f6d$export$140e2f5526d3cad8, (0, $kxIgO.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className)
    }, other));
});
var $df1a4ec584b17f6d$export$2e2bcd8739ae039 = $df1a4ec584b17f6d$var$Typography;


var $2hDQc = parcelRequire("2hDQc");

var $l6gEk = parcelRequire("l6gEk");
var $hixEE = parcelRequire("hixEE");

"use client";
var $4a6d2c05dc7e96d8$export$2e2bcd8739ae039 = (0, $126d93cc939ed77e$export$2e2bcd8739ae039);


"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $ef97679917c36082$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $2hDQc.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $ef97679917c36082$var$maybeReactUseSyncExternalStore = $2hDQc.useSyncExternalStore;
function $ef97679917c36082$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $2hDQc.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $2hDQc.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $2hDQc.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $ef97679917c36082$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $ef97679917c36082$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $hixEE.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $l6gEk.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $ef97679917c36082$var$maybeReactUseSyncExternalStore !== undefined ? $ef97679917c36082$var$useMediaQueryNew : $ef97679917c36082$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $5pzCu = parcelRequire("5pzCu");
const $ae63e01d7dc24727$export$e8b67cc4f4c44ec6 = (pagination)=>{
    if (!pagination || !pagination.page || pagination.page <= 1) return undefined;
    const totalNumberOfPages = pagination.limit > 0 ? Math.ceil(pagination.total / pagination.limit) : 0;
    if (totalNumberOfPages <= 1) return undefined;
    const lastItems = pagination.total % pagination.limit || pagination.limit;
    if (lastItems !== 1) return undefined;
    if (pagination.page === totalNumberOfPages) return pagination.page - 1;
    return undefined;
};
const $ae63e01d7dc24727$export$4bec99d256114e49 = (sort, direction)=>{
    return {
        page: "1",
        limit: "20",
        sort: sort,
        direction: direction ?? "ASC"
    };
};
const $ae63e01d7dc24727$export$f381863f4c1c052a = (values)=>{
    const { page: page, limit: limit, sort: sort, direction: direction } = values;
    return {
        page: (0, $5pzCu.isInteger)(page) ? page.toString() : page.toString(),
        limit: (0, $5pzCu.isInteger)(limit) ? limit.toString() : limit.toString(),
        sort: sort,
        direction: direction
    };
};
const $ae63e01d7dc24727$var$MoovyPagination = ({ page: page, total: total, limit: limit, onNextPage: onNextPage })=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const totalNumberOfPages = total > 0 && limit > 0 ? Math.ceil(total / limit) : 0;
    const start = page ? page * limit - limit + 1 : 0;
    const end = Math.min(start + limit - 1, total);
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
        container: true,
        direction: "row",
        paddingTop: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                pl: 2,
                xs: 12,
                md: true,
                sx: {
                    pb: {
                        xs: 2,
                        md: 0
                    }
                },
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    sx: {
                        justifyContent: {
                            xs: "center",
                            md: "left"
                        }
                    },
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: `${start} - ${end} / ${total}`
                    })
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                md: true,
                sx: {
                    pb: {
                        xs: 1,
                        md: 0
                    }
                },
                xs: 12,
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    sx: {
                        justifyContent: {
                            xs: "center",
                            md: "right"
                        }
                    },
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3360a10e2d2b01ef$export$2e2bcd8739ae039), {
                        page: page,
                        siblingCount: 1,
                        boundaryCount: 0,
                        count: totalNumberOfPages,
                        shape: "rounded",
                        showFirstButton: !isMobile,
                        showLastButton: !isMobile,
                        onChange: (event, page)=>onNextPage(page)
                    })
                })
            })
        ]
    });
};
var $ae63e01d7dc24727$export$2e2bcd8739ae039 = $ae63e01d7dc24727$var$MoovyPagination;



var $2hDQc = parcelRequire("2hDQc");
const $7bfb91130cd4d35d$export$add10c4cb4cd7fd0 = "moovyBackdropAnimation";
const $7bfb91130cd4d35d$export$60dd4bbd6d459f57 = "moovyCatalogueRightsPaging";
const $7bfb91130cd4d35d$export$70568e7be1b89dff = "moovyCatalogueRightsSorting";
const $7bfb91130cd4d35d$export$2b74872b9eccd572 = "moovyCataloguesPaging";
const $7bfb91130cd4d35d$export$dd6ef14bcd36b902 = "moovyCataloguesSorting";
const $7bfb91130cd4d35d$export$d40389383c97912 = "moovyInvitationAdmingPaging";
const $7bfb91130cd4d35d$export$5cbc2ff09ff3e0 = "moovyInvitationLandlordPaging";
const $7bfb91130cd4d35d$export$1ef7c9c6b17b6642 = "moovyInvitationLandlordSorting";
const $7bfb91130cd4d35d$export$52484cb0e4bee674 = "moovyOfferingsTabCatalogues";
const $7bfb91130cd4d35d$export$fc22b6fdc7ebba93 = "moovyPlacesPaging";
const $7bfb91130cd4d35d$export$a9c7fdd2cd34e65d = "moovyPlacesSort";
const $7bfb91130cd4d35d$export$bf153b52ae22c83c = "moovyPlacesTabOfferings";
const $7bfb91130cd4d35d$export$50da30c0967674ee = "moovyRightHoldersTabVehicles";


const $5dcd3ee6df434ce0$export$88b06990067e1fdb = (intl, sortType)=>{
    const getLocalizedItems = (sortType, keys)=>{
        return keys.map((key)=>{
            return {
                key: key.toString(),
                value: intl.formatMessage({
                    id: `sort.${sortType}.${key}`
                })
            };
        });
    };
    switch(sortType){
        case "PLACES":
            {
                const keys = [
                    "NAME",
                    "CITY",
                    "CAPACITY",
                    "CUSTOMER_ID"
                ];
                return getLocalizedItems(sortType, keys);
            }
        case "INVITATIONS":
            {
                const keys = [
                    "NAME",
                    "EMAIL",
                    "CREATED_AT",
                    "USED"
                ];
                return getLocalizedItems(sortType, keys);
            }
        case "ACTIVE_RIGHTS":
            {
                const keys = [
                    "INDIVIDUAL",
                    "VEHICLE",
                    "VALIDITY_START",
                    "VALIDITY_END"
                ];
                return getLocalizedItems(sortType, keys);
            }
        case "CATALOGUES":
            {
                const keys = [
                    "CUSTOMER_ID",
                    "CREATED_AT",
                    "UPDATED_AT",
                    "AMOUNT"
                ];
                return getLocalizedItems(sortType, keys);
            }
        default:
            return [];
    }
};
const $5dcd3ee6df434ce0$export$fcce7887255d1c69 = (sortKey)=>{
    const invitationDescKeys = [
        "CREATED_AT",
        "USED"
    ];
    const placeDescKeys = [
        "CAPACITY"
    ];
    const activeRightDescKeys = [
        "VALIDITY_START",
        "VALIDITY_END"
    ];
    const catalogueDescKeys = [
        "CREATED_AT",
        "UPDATED_AT",
        "AMOUNT"
    ];
    if (invitationDescKeys.includes(sortKey) || placeDescKeys.includes(sortKey) || activeRightDescKeys.includes(sortKey) || catalogueDescKeys.includes(sortKey)) return "DESC";
    return "ASC";
};








var $785df74451564ce9$var$_client, $785df74451564ce9$var$_currentQuery, $785df74451564ce9$var$_currentQueryInitialState, $785df74451564ce9$var$_currentResult, $785df74451564ce9$var$_currentResultState, $785df74451564ce9$var$_currentResultOptions, $785df74451564ce9$var$_selectError, $785df74451564ce9$var$_selectFn, $785df74451564ce9$var$_selectResult, $785df74451564ce9$var$_lastQueryWithDefinedData, $785df74451564ce9$var$_staleTimeoutId, $785df74451564ce9$var$_refetchIntervalId, $785df74451564ce9$var$_currentRefetchInterval, $785df74451564ce9$var$_trackedProps, $785df74451564ce9$var$_executeFetch, $785df74451564ce9$var$executeFetch_fn, $785df74451564ce9$var$_updateStaleTimeout, $785df74451564ce9$var$updateStaleTimeout_fn, $785df74451564ce9$var$_computeRefetchInterval, $785df74451564ce9$var$computeRefetchInterval_fn, $785df74451564ce9$var$_updateRefetchInterval, $785df74451564ce9$var$updateRefetchInterval_fn, $785df74451564ce9$var$_updateTimers, $785df74451564ce9$var$updateTimers_fn, $785df74451564ce9$var$_clearStaleTimeout, $785df74451564ce9$var$clearStaleTimeout_fn, $785df74451564ce9$var$_clearRefetchInterval, $785df74451564ce9$var$clearRefetchInterval_fn, $785df74451564ce9$var$_updateQuery, $785df74451564ce9$var$updateQuery_fn, $785df74451564ce9$var$_notify, $785df74451564ce9$var$notify_fn;
var $785df74451564ce9$export$a06cf8c0066f0d4c = class extends (0, $cd2d669aebb9a53c$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_executeFetch);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_updateStaleTimeout);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_computeRefetchInterval);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_updateRefetchInterval);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_updateTimers);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_clearStaleTimeout);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_clearRefetchInterval);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_updateQuery);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_notify);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_client, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_currentQuery, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_currentQueryInitialState, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_currentResult, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_currentResultState, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_currentResultOptions, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_selectError, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_selectFn, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_lastQueryWithDefinedData, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_staleTimeoutId, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_refetchIntervalId, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_currentRefetchInterval, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $785df74451564ce9$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_client, client);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery).addObserver(this);
            if ($785df74451564ce9$var$shouldFetchOnMount((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery), this.options)) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_executeFetch, $785df74451564ce9$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateTimers, $785df74451564ce9$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $785df74451564ce9$var$shouldFetchOn((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $785df74451564ce9$var$shouldFetchOn((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_clearStaleTimeout, $785df74451564ce9$var$clearStaleTimeout_fn).call(this);
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_clearRefetchInterval, $785df74451564ce9$var$clearRefetchInterval_fn).call(this);
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery);
        this.options = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).defaultQueryOptions(options);
        if (!(0, $8299f902fbe20788$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery),
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateQuery, $785df74451564ce9$var$updateQuery_fn).call(this);
        const mounted = this.hasListeners();
        if (mounted && $785df74451564ce9$var$shouldFetchOptionally((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_executeFetch, $785df74451564ce9$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateStaleTimeout, $785df74451564ce9$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_computeRefetchInterval, $785df74451564ce9$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentRefetchInterval))) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateRefetchInterval, $785df74451564ce9$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).getQueryCache().build((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client), options);
        const result = this.createResult(query, options);
        if ($785df74451564ce9$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentResult, result);
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentResultOptions, this.options);
            (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentResultState, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult);
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_trackedProps).add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).defaultQueryOptions(options);
        const query = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).getQueryCache().build((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_executeFetch, $785df74451564ce9$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult);
        const prevResultState = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResultState);
        const prevResultOptions = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQueryInitialState);
        const { state: state } = query;
        let { error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $785df74451564ce9$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $785df74451564ce9$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $7bad956f3d5bc591$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!state.dataUpdatedAt) status = "pending";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        }
        if (options.select && typeof state.data !== "undefined") {
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_selectFn)) data = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_selectResult);
            else try {
                (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectFn, options.select);
                data = options.select(state.data);
                data = (0, $8299f902fbe20788$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectResult, data);
                (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectError, null);
            } catch (selectError) {
                (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectError, selectError);
            }
        } else data = state.data;
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectError, null);
                } catch (selectError) {
                    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_selectError, selectError);
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $8299f902fbe20788$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_selectError)) {
            error = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_selectError);
            data = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: state.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $785df74451564ce9$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult);
        const nextResult = this.createResult((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery), this.options);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentResultState, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery).state);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentResultOptions, this.options);
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResultState).data !== void 0) (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_lastQueryWithDefinedData, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery));
        if ((0, $8299f902fbe20788$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_notify, $785df74451564ce9$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateTimers, $785df74451564ce9$var$updateTimers_fn).call(this);
    }
};
$785df74451564ce9$var$_client = new WeakMap();
$785df74451564ce9$var$_currentQuery = new WeakMap();
$785df74451564ce9$var$_currentQueryInitialState = new WeakMap();
$785df74451564ce9$var$_currentResult = new WeakMap();
$785df74451564ce9$var$_currentResultState = new WeakMap();
$785df74451564ce9$var$_currentResultOptions = new WeakMap();
$785df74451564ce9$var$_selectError = new WeakMap();
$785df74451564ce9$var$_selectFn = new WeakMap();
$785df74451564ce9$var$_selectResult = new WeakMap();
$785df74451564ce9$var$_lastQueryWithDefinedData = new WeakMap();
$785df74451564ce9$var$_staleTimeoutId = new WeakMap();
$785df74451564ce9$var$_refetchIntervalId = new WeakMap();
$785df74451564ce9$var$_currentRefetchInterval = new WeakMap();
$785df74451564ce9$var$_trackedProps = new WeakMap();
$785df74451564ce9$var$_executeFetch = new WeakSet();
$785df74451564ce9$var$executeFetch_fn = function(fetchOptions) {
    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateQuery, $785df74451564ce9$var$updateQuery_fn).call(this);
    let promise = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $8299f902fbe20788$export$8793edee2d425525));
    return promise;
};
$785df74451564ce9$var$_updateStaleTimeout = new WeakSet();
$785df74451564ce9$var$updateStaleTimeout_fn = function() {
    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_clearStaleTimeout, $785df74451564ce9$var$clearStaleTimeout_fn).call(this);
    if ((0, $8299f902fbe20788$export$6acf61af03e62db) || (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult).isStale || !(0, $8299f902fbe20788$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $8299f902fbe20788$export$811b83d62bcf47f0)((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$785df74451564ce9$var$_computeRefetchInterval = new WeakSet();
$785df74451564ce9$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$785df74451564ce9$var$_updateRefetchInterval = new WeakSet();
$785df74451564ce9$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_clearRefetchInterval, $785df74451564ce9$var$clearRefetchInterval_fn).call(this);
    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentRefetchInterval, nextInterval);
    if ((0, $8299f902fbe20788$export$6acf61af03e62db) || this.options.enabled === false || !(0, $8299f902fbe20788$export$e539f754e934e270)((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentRefetchInterval)) || (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentRefetchInterval) === 0) return;
    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $0f2c5acf39adb8a1$export$6bf54661be5b02cf).isFocused()) (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_executeFetch, $785df74451564ce9$var$executeFetch_fn).call(this);
    }, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentRefetchInterval)));
};
$785df74451564ce9$var$_updateTimers = new WeakSet();
$785df74451564ce9$var$updateTimers_fn = function() {
    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateStaleTimeout, $785df74451564ce9$var$updateStaleTimeout_fn).call(this);
    (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_updateRefetchInterval, $785df74451564ce9$var$updateRefetchInterval_fn).call(this, (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $785df74451564ce9$var$_computeRefetchInterval, $785df74451564ce9$var$computeRefetchInterval_fn).call(this));
};
$785df74451564ce9$var$_clearStaleTimeout = new WeakSet();
$785df74451564ce9$var$clearStaleTimeout_fn = function() {
    if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_staleTimeoutId)) {
        clearTimeout((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_staleTimeoutId));
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_staleTimeoutId, void 0);
    }
};
$785df74451564ce9$var$_clearRefetchInterval = new WeakSet();
$785df74451564ce9$var$clearRefetchInterval_fn = function() {
    if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_refetchIntervalId)) {
        clearInterval((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_refetchIntervalId));
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_refetchIntervalId, void 0);
    }
};
$785df74451564ce9$var$_updateQuery = new WeakSet();
$785df74451564ce9$var$updateQuery_fn = function() {
    const query = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).getQueryCache().build((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client), this.options);
    if (query === (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery)) return;
    const prevQuery = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery);
    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentQuery, query);
    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $785df74451564ce9$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$785df74451564ce9$var$_notify = new WeakSet();
$785df74451564ce9$var$notify_fn = function(notifyOptions) {
    (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentResult));
        });
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_client).getQueryCache().notify({
            query: (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $785df74451564ce9$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $785df74451564ce9$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $785df74451564ce9$var$shouldFetchOnMount(query, options) {
    return $785df74451564ce9$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $785df74451564ce9$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $785df74451564ce9$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $785df74451564ce9$var$isStale(query, options);
    }
    return false;
}
function $785df74451564ce9$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $785df74451564ce9$var$isStale(query, options);
}
function $785df74451564ce9$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}
function $785df74451564ce9$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $8299f902fbe20788$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");
"use client";
function $921578c4d6b0bba1$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $921578c4d6b0bba1$var$QueryErrorResetBoundaryContext = $2hDQc.createContext($921578c4d6b0bba1$var$createValue());
var $921578c4d6b0bba1$export$50dfac555130cafd = ()=>$2hDQc.useContext($921578c4d6b0bba1$var$QueryErrorResetBoundaryContext);
var $921578c4d6b0bba1$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $2hDQc.useState(()=>$921578c4d6b0bba1$var$createValue());
    return /* @__PURE__ */ (0, $592Nh.jsx)($921578c4d6b0bba1$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};




var $2hDQc = parcelRequire("2hDQc");
"use client";
var $b694611e1bd0d54b$var$IsRestoringContext = $2hDQc.createContext(false);
var $b694611e1bd0d54b$export$4da0178d6b5f553 = ()=>$2hDQc.useContext($b694611e1bd0d54b$var$IsRestoringContext);
var $b694611e1bd0d54b$export$593807d4e94f9621 = $b694611e1bd0d54b$var$IsRestoringContext.Provider;



var $2hDQc = parcelRequire("2hDQc");
// src/utils.ts
function $d5bedcbc18008062$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}


"use client";
var $f5d6c1bb086e030a$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $f5d6c1bb086e030a$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $2hDQc.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $f5d6c1bb086e030a$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $d5bedcbc18008062$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $1e59b1d494ff8ea0$export$8bed2f8d02206063 = (_error, query)=>typeof query.state.data === "undefined";
var $1e59b1d494ff8ea0$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $1e59b1d494ff8ea0$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $1e59b1d494ff8ea0$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $1e59b1d494ff8ea0$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $b421074fbac4b195$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $97855a2dd31730f4$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $b694611e1bd0d54b$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $921578c4d6b0bba1$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $1e59b1d494ff8ea0$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $f5d6c1bb086e030a$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $f5d6c1bb086e030a$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $2hDQc.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $2hDQc.useSyncExternalStore($2hDQc.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $8d52467732f2e0e5$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $2hDQc.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $1e59b1d494ff8ea0$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $1e59b1d494ff8ea0$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $f5d6c1bb086e030a$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $b94a3cbdbee77a9d$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $b421074fbac4b195$export$fff0865807e996c5)(options, (0, $785df74451564ce9$export$a06cf8c0066f0d4c), queryClient);
}



var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $2hDQc = parcelRequire("2hDQc");
/**
 * @ignore - internal component.
 */ const $9283b7e5e1120b32$var$Tablelvl2Context = /*#__PURE__*/ $2hDQc.createContext();
var $9283b7e5e1120b32$export$2e2bcd8739ae039 = $9283b7e5e1120b32$var$Tablelvl2Context;



var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $d6f0598a42d2bd25$export$98bd2a9b566ec665(slot) {
    return (0, $01COD.default)("MuiTableBody", slot);
}
const $d6f0598a42d2bd25$var$tableBodyClasses = (0, $eLydt.default)("MuiTableBody", [
    "root"
]);
var $d6f0598a42d2bd25$export$2e2bcd8739ae039 = $d6f0598a42d2bd25$var$tableBodyClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $99c4caec9c67cdbd$var$_excluded = [
    "className",
    "component"
];
const $99c4caec9c67cdbd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $d6f0598a42d2bd25$export$98bd2a9b566ec665), classes);
};
const $99c4caec9c67cdbd$var$TableBodyRoot = (0, $fhlQp.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $99c4caec9c67cdbd$var$tablelvl2 = {
    variant: "body"
};
const $99c4caec9c67cdbd$var$defaultComponent = "tbody";
const $99c4caec9c67cdbd$var$TableBody = /*#__PURE__*/ $2hDQc.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $99c4caec9c67cdbd$var$defaultComponent } = props, other = (0, $gZOiq.default)(props, $99c4caec9c67cdbd$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component
    });
    const classes = $99c4caec9c67cdbd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $9283b7e5e1120b32$export$2e2bcd8739ae039).Provider, {
        value: $99c4caec9c67cdbd$var$tablelvl2,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($99c4caec9c67cdbd$var$TableBodyRoot, (0, $kxIgO.default)({
            className: (0, $fLRFO.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $99c4caec9c67cdbd$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $99c4caec9c67cdbd$export$2e2bcd8739ae039 = $99c4caec9c67cdbd$var$TableBody;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $lfMLv = parcelRequire("lfMLv");

var $2hDQc = parcelRequire("2hDQc");
"use client";
/**
 * @ignore - internal component.
 */ const $e3c635e52caa6d75$var$TableContext = /*#__PURE__*/ $2hDQc.createContext();
var $e3c635e52caa6d75$export$2e2bcd8739ae039 = $e3c635e52caa6d75$var$TableContext;




var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $a615673ad8750c84$export$33a0f07a16a10b1b(slot) {
    return (0, $01COD.default)("MuiTableCell", slot);
}
const $a615673ad8750c84$var$tableCellClasses = (0, $eLydt.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $a615673ad8750c84$export$2e2bcd8739ae039 = $a615673ad8750c84$var$tableCellClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $561148cb39ccf91a$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $561148cb39ccf91a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $lfMLv.default)(align)}`,
            padding !== "normal" && `padding${(0, $lfMLv.default)(padding)}`,
            `size${(0, $lfMLv.default)(size)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $a615673ad8750c84$export$33a0f07a16a10b1b), classes);
};
const $561148cb39ccf91a$var$TableCellRoot = (0, $fhlQp.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $lfMLv.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $lfMLv.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $lfMLv.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $6KAST.lighten)((0, $6KAST.alpha)(theme.palette.divider, 1), 0.88) : (0, $6KAST.darken)((0, $6KAST.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $a615673ad8750c84$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $561148cb39ccf91a$var$TableCell = /*#__PURE__*/ $2hDQc.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $gZOiq.default)(props, $561148cb39ccf91a$var$_excluded);
    const table = $2hDQc.useContext((0, $e3c635e52caa6d75$export$2e2bcd8739ae039));
    const tablelvl2 = $2hDQc.useContext((0, $9283b7e5e1120b32$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $kxIgO.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $561148cb39ccf91a$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $592Nh.jsx)($561148cb39ccf91a$var$TableCellRoot, (0, $kxIgO.default)({
        as: component,
        ref: ref,
        className: (0, $fLRFO.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $561148cb39ccf91a$export$2e2bcd8739ae039 = $561148cb39ccf91a$var$TableCell;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $3035a5c7a6ebfb4e$export$2e731cea2d1c2392(slot) {
    return (0, $01COD.default)("MuiTableHead", slot);
}
const $3035a5c7a6ebfb4e$var$tableHeadClasses = (0, $eLydt.default)("MuiTableHead", [
    "root"
]);
var $3035a5c7a6ebfb4e$export$2e2bcd8739ae039 = $3035a5c7a6ebfb4e$var$tableHeadClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $c2993d8c386a54e7$var$_excluded = [
    "className",
    "component"
];
const $c2993d8c386a54e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $3035a5c7a6ebfb4e$export$2e731cea2d1c2392), classes);
};
const $c2993d8c386a54e7$var$TableHeadRoot = (0, $fhlQp.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $c2993d8c386a54e7$var$tablelvl2 = {
    variant: "head"
};
const $c2993d8c386a54e7$var$defaultComponent = "thead";
const $c2993d8c386a54e7$var$TableHead = /*#__PURE__*/ $2hDQc.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $c2993d8c386a54e7$var$defaultComponent } = props, other = (0, $gZOiq.default)(props, $c2993d8c386a54e7$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component
    });
    const classes = $c2993d8c386a54e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $9283b7e5e1120b32$export$2e2bcd8739ae039).Provider, {
        value: $c2993d8c386a54e7$var$tablelvl2,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($c2993d8c386a54e7$var$TableHeadRoot, (0, $kxIgO.default)({
            as: component,
            className: (0, $fLRFO.default)(classes.root, className),
            ref: ref,
            role: component === $c2993d8c386a54e7$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $c2993d8c386a54e7$export$2e2bcd8739ae039 = $c2993d8c386a54e7$var$TableHead;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $86f8e71e0aca8ddf$export$ba0a6d6c28940107(slot) {
    return (0, $01COD.default)("MuiTableRow", slot);
}
const $86f8e71e0aca8ddf$var$tableRowClasses = (0, $eLydt.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $86f8e71e0aca8ddf$export$2e2bcd8739ae039 = $86f8e71e0aca8ddf$var$tableRowClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $d9497b169efaceb0$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $d9497b169efaceb0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $86f8e71e0aca8ddf$export$ba0a6d6c28940107), classes);
};
const $d9497b169efaceb0$var$TableRowRoot = (0, $fhlQp.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $86f8e71e0aca8ddf$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $86f8e71e0aca8ddf$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $d9497b169efaceb0$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $d9497b169efaceb0$var$TableRow = /*#__PURE__*/ $2hDQc.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $d9497b169efaceb0$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $gZOiq.default)(props, $d9497b169efaceb0$var$_excluded);
    const tablelvl2 = $2hDQc.useContext((0, $9283b7e5e1120b32$export$2e2bcd8739ae039));
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $d9497b169efaceb0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($d9497b169efaceb0$var$TableRowRoot, (0, $kxIgO.default)({
        as: component,
        ref: ref,
        className: (0, $fLRFO.default)(classes.root, className),
        role: component === $d9497b169efaceb0$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $d9497b169efaceb0$export$2e2bcd8739ae039 = $d9497b169efaceb0$var$TableRow;



var $2hDQc = parcelRequire("2hDQc");





var $dfea939c3011c424$var$_client, $dfea939c3011c424$var$_currentResult, $dfea939c3011c424$var$_currentMutation, $dfea939c3011c424$var$_mutateOptions, $dfea939c3011c424$var$_updateResult, $dfea939c3011c424$var$updateResult_fn, $dfea939c3011c424$var$_notify, $dfea939c3011c424$var$notify_fn;
var $dfea939c3011c424$export$d3c1860ee66f291a = class extends (0, $cd2d669aebb9a53c$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $dfea939c3011c424$var$_updateResult);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $dfea939c3011c424$var$_notify);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $dfea939c3011c424$var$_client, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $dfea939c3011c424$var$_currentResult, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $dfea939c3011c424$var$_currentMutation, void 0);
        (0, $c3affd701a8324c3$export$addf369becd23283)(this, $dfea939c3011c424$var$_mutateOptions, void 0);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $dfea939c3011c424$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $dfea939c3011c424$var$_updateResult, $dfea939c3011c424$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_client).defaultMutationOptions(options);
        if (!(0, $8299f902fbe20788$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $8299f902fbe20788$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $8299f902fbe20788$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation)) == null || _a.setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $dfea939c3011c424$var$_updateResult, $dfea939c3011c424$var$updateResult_fn).call(this);
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $dfea939c3011c424$var$_notify, $dfea939c3011c424$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $dfea939c3011c424$var$_currentMutation, void 0);
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $dfea939c3011c424$var$_updateResult, $dfea939c3011c424$var$updateResult_fn).call(this);
        (0, $c3affd701a8324c3$export$fa92d15b718fce20)(this, $dfea939c3011c424$var$_notify, $dfea939c3011c424$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $dfea939c3011c424$var$_mutateOptions, options);
        (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $dfea939c3011c424$var$_currentMutation, (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_client).getMutationCache().build((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_client), this.options));
        (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation).addObserver(this);
        return (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation).execute(variables);
    }
};
$dfea939c3011c424$var$_client = new WeakMap();
$dfea939c3011c424$var$_currentResult = new WeakMap();
$dfea939c3011c424$var$_currentMutation = new WeakMap();
$dfea939c3011c424$var$_mutateOptions = new WeakMap();
$dfea939c3011c424$var$_updateResult = new WeakSet();
$dfea939c3011c424$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $f0d32793e98a6b8a$export$a1659b54bac3252a)();
    (0, $c3affd701a8324c3$export$42432efe6614d3b4)(this, $dfea939c3011c424$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$dfea939c3011c424$var$_notify = new WeakSet();
$dfea939c3011c424$var$notify_fn = function(action) {
    (0, $8d52467732f2e0e5$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentResult).variables;
            const context = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $c3affd701a8324c3$export$18a094aefa070634)(this, $dfea939c3011c424$var$_currentResult));
        });
    });
};




"use client";
function $f93c0904c8c05d54$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $97855a2dd31730f4$export$22e77b9572c4fded)(queryClient);
    const [observer] = $2hDQc.useState(()=>new (0, $dfea939c3011c424$export$d3c1860ee66f291a)(client, options));
    $2hDQc.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $2hDQc.useSyncExternalStore($2hDQc.useCallback((onStoreChange)=>observer.subscribe((0, $8d52467732f2e0e5$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $2hDQc.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($f93c0904c8c05d54$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $d5bedcbc18008062$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}
function $f93c0904c8c05d54$var$noop() {}


"use strict";
function $66f21ce557ee50c3$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $834198957c4a6765$var$toString } = Object.prototype;
const { getPrototypeOf: $834198957c4a6765$var$getPrototypeOf } = Object;
const $834198957c4a6765$var$kindOf = ((cache)=>(thing)=>{
        const str = $834198957c4a6765$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $834198957c4a6765$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$834198957c4a6765$var$kindOf(thing) === type;
};
const $834198957c4a6765$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $834198957c4a6765$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $834198957c4a6765$var$isUndefined = $834198957c4a6765$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $834198957c4a6765$var$isBuffer(val) {
    return val !== null && !$834198957c4a6765$var$isUndefined(val) && val.constructor !== null && !$834198957c4a6765$var$isUndefined(val.constructor) && $834198957c4a6765$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $834198957c4a6765$var$isArrayBuffer = $834198957c4a6765$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $834198957c4a6765$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $834198957c4a6765$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $834198957c4a6765$var$isString = $834198957c4a6765$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $834198957c4a6765$var$isFunction = $834198957c4a6765$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $834198957c4a6765$var$isNumber = $834198957c4a6765$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $834198957c4a6765$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $834198957c4a6765$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $834198957c4a6765$var$isPlainObject = (val)=>{
    if ($834198957c4a6765$var$kindOf(val) !== "object") return false;
    const prototype = $834198957c4a6765$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $834198957c4a6765$var$isDate = $834198957c4a6765$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $834198957c4a6765$var$isFile = $834198957c4a6765$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $834198957c4a6765$var$isBlob = $834198957c4a6765$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $834198957c4a6765$var$isFileList = $834198957c4a6765$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $834198957c4a6765$var$isStream = (val)=>$834198957c4a6765$var$isObject(val) && $834198957c4a6765$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $834198957c4a6765$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $834198957c4a6765$var$isFunction(thing.append) && ((kind = $834198957c4a6765$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $834198957c4a6765$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $834198957c4a6765$var$isURLSearchParams = $834198957c4a6765$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $834198957c4a6765$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $834198957c4a6765$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($834198957c4a6765$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $834198957c4a6765$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $834198957c4a6765$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $834198957c4a6765$var$isContextDefined = (context)=>!$834198957c4a6765$var$isUndefined(context) && context !== $834198957c4a6765$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $834198957c4a6765$var$merge() {
    const { caseless: caseless } = $834198957c4a6765$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $834198957c4a6765$var$findKey(result, key) || key;
        if ($834198957c4a6765$var$isPlainObject(result[targetKey]) && $834198957c4a6765$var$isPlainObject(val)) result[targetKey] = $834198957c4a6765$var$merge(result[targetKey], val);
        else if ($834198957c4a6765$var$isPlainObject(val)) result[targetKey] = $834198957c4a6765$var$merge({}, val);
        else if ($834198957c4a6765$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $834198957c4a6765$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $834198957c4a6765$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $834198957c4a6765$var$forEach(b, (val, key)=>{
        if (thisArg && $834198957c4a6765$var$isFunction(val)) a[key] = (0, $66f21ce557ee50c3$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $834198957c4a6765$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $834198957c4a6765$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $834198957c4a6765$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $834198957c4a6765$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $834198957c4a6765$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $834198957c4a6765$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($834198957c4a6765$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$834198957c4a6765$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $834198957c4a6765$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $834198957c4a6765$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $834198957c4a6765$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $834198957c4a6765$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $834198957c4a6765$var$isHTMLForm = $834198957c4a6765$var$kindOfTest("HTMLFormElement");
const $834198957c4a6765$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $834198957c4a6765$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $834198957c4a6765$var$isRegExp = $834198957c4a6765$var$kindOfTest("RegExp");
const $834198957c4a6765$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $834198957c4a6765$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $834198957c4a6765$var$freezeMethods = (obj)=>{
    $834198957c4a6765$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($834198957c4a6765$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$834198957c4a6765$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $834198957c4a6765$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $834198957c4a6765$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $834198957c4a6765$var$noop = ()=>{};
const $834198957c4a6765$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $834198957c4a6765$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $834198957c4a6765$var$DIGIT = "0123456789";
const $834198957c4a6765$var$ALPHABET = {
    DIGIT: $834198957c4a6765$var$DIGIT,
    ALPHA: $834198957c4a6765$var$ALPHA,
    ALPHA_DIGIT: $834198957c4a6765$var$ALPHA + $834198957c4a6765$var$ALPHA.toUpperCase() + $834198957c4a6765$var$DIGIT
};
const $834198957c4a6765$var$generateString = (size = 16, alphabet = $834198957c4a6765$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $834198957c4a6765$var$isSpecCompliantForm(thing) {
    return !!(thing && $834198957c4a6765$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $834198957c4a6765$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($834198957c4a6765$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $834198957c4a6765$var$isArray(source) ? [] : {};
                $834198957c4a6765$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$834198957c4a6765$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $834198957c4a6765$var$isAsyncFn = $834198957c4a6765$var$kindOfTest("AsyncFunction");
const $834198957c4a6765$var$isThenable = (thing)=>thing && ($834198957c4a6765$var$isObject(thing) || $834198957c4a6765$var$isFunction(thing)) && $834198957c4a6765$var$isFunction(thing.then) && $834198957c4a6765$var$isFunction(thing.catch);
var $834198957c4a6765$export$2e2bcd8739ae039 = {
    isArray: $834198957c4a6765$var$isArray,
    isArrayBuffer: $834198957c4a6765$var$isArrayBuffer,
    isBuffer: $834198957c4a6765$var$isBuffer,
    isFormData: $834198957c4a6765$var$isFormData,
    isArrayBufferView: $834198957c4a6765$var$isArrayBufferView,
    isString: $834198957c4a6765$var$isString,
    isNumber: $834198957c4a6765$var$isNumber,
    isBoolean: $834198957c4a6765$var$isBoolean,
    isObject: $834198957c4a6765$var$isObject,
    isPlainObject: $834198957c4a6765$var$isPlainObject,
    isUndefined: $834198957c4a6765$var$isUndefined,
    isDate: $834198957c4a6765$var$isDate,
    isFile: $834198957c4a6765$var$isFile,
    isBlob: $834198957c4a6765$var$isBlob,
    isRegExp: $834198957c4a6765$var$isRegExp,
    isFunction: $834198957c4a6765$var$isFunction,
    isStream: $834198957c4a6765$var$isStream,
    isURLSearchParams: $834198957c4a6765$var$isURLSearchParams,
    isTypedArray: $834198957c4a6765$var$isTypedArray,
    isFileList: $834198957c4a6765$var$isFileList,
    forEach: $834198957c4a6765$var$forEach,
    merge: $834198957c4a6765$var$merge,
    extend: $834198957c4a6765$var$extend,
    trim: $834198957c4a6765$var$trim,
    stripBOM: $834198957c4a6765$var$stripBOM,
    inherits: $834198957c4a6765$var$inherits,
    toFlatObject: $834198957c4a6765$var$toFlatObject,
    kindOf: $834198957c4a6765$var$kindOf,
    kindOfTest: $834198957c4a6765$var$kindOfTest,
    endsWith: $834198957c4a6765$var$endsWith,
    toArray: $834198957c4a6765$var$toArray,
    forEachEntry: $834198957c4a6765$var$forEachEntry,
    matchAll: $834198957c4a6765$var$matchAll,
    isHTMLForm: $834198957c4a6765$var$isHTMLForm,
    hasOwnProperty: $834198957c4a6765$var$hasOwnProperty,
    hasOwnProp: $834198957c4a6765$var$hasOwnProperty,
    reduceDescriptors: $834198957c4a6765$var$reduceDescriptors,
    freezeMethods: $834198957c4a6765$var$freezeMethods,
    toObjectSet: $834198957c4a6765$var$toObjectSet,
    toCamelCase: $834198957c4a6765$var$toCamelCase,
    noop: $834198957c4a6765$var$noop,
    toFiniteNumber: $834198957c4a6765$var$toFiniteNumber,
    findKey: $834198957c4a6765$var$findKey,
    global: $834198957c4a6765$var$_global,
    isContextDefined: $834198957c4a6765$var$isContextDefined,
    ALPHABET: $834198957c4a6765$var$ALPHABET,
    generateString: $834198957c4a6765$var$generateString,
    isSpecCompliantForm: $834198957c4a6765$var$isSpecCompliantForm,
    toJSONObject: $834198957c4a6765$var$toJSONObject,
    isAsyncFn: $834198957c4a6765$var$isAsyncFn,
    isThenable: $834198957c4a6765$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $5d7bb6a92182310f$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $834198957c4a6765$export$2e2bcd8739ae039).inherits($5d7bb6a92182310f$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $834198957c4a6765$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $5d7bb6a92182310f$var$prototype = $5d7bb6a92182310f$var$AxiosError.prototype;
const $5d7bb6a92182310f$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $5d7bb6a92182310f$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($5d7bb6a92182310f$var$AxiosError, $5d7bb6a92182310f$var$descriptors);
Object.defineProperty($5d7bb6a92182310f$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$5d7bb6a92182310f$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($5d7bb6a92182310f$var$prototype);
    (0, $834198957c4a6765$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $5d7bb6a92182310f$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $5d7bb6a92182310f$export$2e2bcd8739ae039 = $5d7bb6a92182310f$var$AxiosError;


// eslint-disable-next-line strict
var $93dda30d8b06130a$export$2e2bcd8739ae039 = null;



var $43wp1 = parcelRequire("43wp1");
var $d934b479d93befbf$require$Buffer = $43wp1.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d934b479d93befbf$var$isVisitable(thing) {
    return (0, $834198957c4a6765$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d934b479d93befbf$var$removeBrackets(key) {
    return (0, $834198957c4a6765$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d934b479d93befbf$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d934b479d93befbf$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d934b479d93befbf$var$isFlatArray(arr) {
    return (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(arr) && !arr.some($d934b479d93befbf$var$isVisitable);
}
const $d934b479d93befbf$var$predicates = (0, $834198957c4a6765$export$2e2bcd8739ae039).toFlatObject((0, $834198957c4a6765$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d934b479d93befbf$var$toFormData(obj, formData, options) {
    if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $93dda30d8b06130a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $834198957c4a6765$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $834198957c4a6765$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $834198957c4a6765$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $834198957c4a6765$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $d934b479d93befbf$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(value) && $d934b479d93befbf$var$isFlatArray(value) || ((0, $834198957c4a6765$export$2e2bcd8739ae039).isFileList(value) || (0, $834198957c4a6765$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $834198957c4a6765$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d934b479d93befbf$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d934b479d93befbf$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($d934b479d93befbf$var$isVisitable(value)) return true;
        formData.append($d934b479d93befbf$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($d934b479d93befbf$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d934b479d93befbf$var$isVisitable
    });
    function build(value, path) {
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $834198957c4a6765$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $d934b479d93befbf$export$2e2bcd8739ae039 = $d934b479d93befbf$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $b6acdd2ef1744dc4$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $b6acdd2ef1744dc4$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $d934b479d93befbf$export$2e2bcd8739ae039)(params, this, options);
}
const $b6acdd2ef1744dc4$var$prototype = $b6acdd2ef1744dc4$var$AxiosURLSearchParams.prototype;
$b6acdd2ef1744dc4$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$b6acdd2ef1744dc4$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $b6acdd2ef1744dc4$var$encode);
    } : $b6acdd2ef1744dc4$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $b6acdd2ef1744dc4$export$2e2bcd8739ae039 = $b6acdd2ef1744dc4$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $2443a707027f4081$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $2443a707027f4081$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $2443a707027f4081$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $834198957c4a6765$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $b6acdd2ef1744dc4$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $b921b2cbb62b77c8$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $b921b2cbb62b77c8$export$2e2bcd8739ae039 = $b921b2cbb62b77c8$var$InterceptorManager;





"use strict";
var $2db6f3591ad3a958$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $9487fa2867c4660e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $b6acdd2ef1744dc4$export$2e2bcd8739ae039);


"use strict";
var $55aa8c74688a814b$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $9a64593b603c9470$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $7b5b17143d1dc192$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $7b5b17143d1dc192$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $7b5b17143d1dc192$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9487fa2867c4660e$export$2e2bcd8739ae039,
        FormData: $55aa8c74688a814b$export$2e2bcd8739ae039,
        Blob: $9a64593b603c9470$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $7b5b17143d1dc192$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $7b5b17143d1dc192$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $d50950705a3dea35$export$2e2bcd8739ae039(data, options) {
    return (0, $d934b479d93befbf$export$2e2bcd8739ae039)(data, new (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isNode && (0, $834198957c4a6765$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $ac138dff1179fff0$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $834198957c4a6765$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $ac138dff1179fff0$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $ac138dff1179fff0$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $834198957c4a6765$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $ac138dff1179fff0$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isFormData(formData) && (0, $834198957c4a6765$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $834198957c4a6765$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($ac138dff1179fff0$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $ac138dff1179fff0$export$2e2bcd8739ae039 = $ac138dff1179fff0$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $b9307422e031a466$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $834198957c4a6765$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $b9307422e031a466$var$defaults = {
    transitional: (0, $2db6f3591ad3a958$export$2e2bcd8739ae039),
    adapter: (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isNode ? "http" : "xhr",
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $834198957c4a6765$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $834198957c4a6765$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $834198957c4a6765$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $ac138dff1179fff0$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $834198957c4a6765$export$2e2bcd8739ae039).isBuffer(data) || (0, $834198957c4a6765$export$2e2bcd8739ae039).isStream(data) || (0, $834198957c4a6765$export$2e2bcd8739ae039).isFile(data) || (0, $834198957c4a6765$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $d50950705a3dea35$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $834198957c4a6765$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $d934b479d93befbf$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $b9307422e031a466$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $b9307422e031a466$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $834198957c4a6765$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).from(e, (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $834198957c4a6765$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $b9307422e031a466$var$defaults.headers[method] = {};
});
var $b9307422e031a466$export$2e2bcd8739ae039 = $b9307422e031a466$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $b62086b9351ab9c7$var$ignoreDuplicateOf = (0, $834198957c4a6765$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $b62086b9351ab9c7$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $b62086b9351ab9c7$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $7a9223f90a3aa1f2$var$$internals = Symbol("internals");
function $7a9223f90a3aa1f2$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $7a9223f90a3aa1f2$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(value) ? value.map($7a9223f90a3aa1f2$var$normalizeValue) : String(value);
}
function $7a9223f90a3aa1f2$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $7a9223f90a3aa1f2$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $7a9223f90a3aa1f2$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $7a9223f90a3aa1f2$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $7a9223f90a3aa1f2$var$buildAccessors(obj, header) {
    const accessorName = (0, $834198957c4a6765$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $7a9223f90a3aa1f2$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $7a9223f90a3aa1f2$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $834198957c4a6765$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $7a9223f90a3aa1f2$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$7a9223f90a3aa1f2$var$isValidHeaderName(header)) setHeaders((0, $b62086b9351ab9c7$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $7a9223f90a3aa1f2$var$normalizeHeader(header);
        if (header) {
            const key = (0, $834198957c4a6765$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $7a9223f90a3aa1f2$var$parseTokens(value);
                if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $7a9223f90a3aa1f2$var$normalizeHeader(header);
        if (header) {
            const key = (0, $834198957c4a6765$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $7a9223f90a3aa1f2$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $7a9223f90a3aa1f2$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $834198957c4a6765$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $7a9223f90a3aa1f2$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $7a9223f90a3aa1f2$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $834198957c4a6765$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $7a9223f90a3aa1f2$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $7a9223f90a3aa1f2$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $7a9223f90a3aa1f2$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$7a9223f90a3aa1f2$var$$internals] = this[$7a9223f90a3aa1f2$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $7a9223f90a3aa1f2$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $7a9223f90a3aa1f2$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$7a9223f90a3aa1f2$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $834198957c4a6765$export$2e2bcd8739ae039).reduceDescriptors($7a9223f90a3aa1f2$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $834198957c4a6765$export$2e2bcd8739ae039).freezeMethods($7a9223f90a3aa1f2$var$AxiosHeaders);
var $7a9223f90a3aa1f2$export$2e2bcd8739ae039 = $7a9223f90a3aa1f2$var$AxiosHeaders;


"use strict";
function $be9c0b6bd036e789$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $b9307422e031a466$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $e3d760b6f2e77558$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $016e99048fe201cb$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $834198957c4a6765$export$2e2bcd8739ae039).inherits($016e99048fe201cb$var$CanceledError, (0, $5d7bb6a92182310f$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $016e99048fe201cb$export$2e2bcd8739ae039 = $016e99048fe201cb$var$CanceledError;







"use strict";
function $9ec070ed7809f20f$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $b93cf645b5a85f39$export$2e2bcd8739ae039 = (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $e64f7d1f0948d5cf$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $f72e5868c870e372$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $5e7ec6191b7c28a8$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $e64f7d1f0948d5cf$export$2e2bcd8739ae039)(requestedURL)) return (0, $f72e5868c870e372$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $7d198203bea4e0a2$export$2e2bcd8739ae039 = (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $834198957c4a6765$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $d3e7d7ea7b077a74$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $14f68882f8be90c1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $14f68882f8be90c1$export$2e2bcd8739ae039 = $14f68882f8be90c1$var$speedometer;


"use strict";
function $d7c86353947eb680$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $14f68882f8be90c1$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $d7c86353947eb680$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $d7c86353947eb680$export$2e2bcd8739ae039 = $d7c86353947eb680$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $5e7ec6191b7c28a8$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $2443a707027f4081$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $9ec070ed7809f20f$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("Request aborted", (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("Network Error", (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $2db6f3591ad3a958$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ETIMEDOUT : (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $7b5b17143d1dc192$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $7d198203bea4e0a2$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $b93cf645b5a85f39$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $d7c86353947eb680$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $d7c86353947eb680$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $016e99048fe201cb$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $d3e7d7ea7b077a74$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $7b5b17143d1dc192$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $200d9fbf4cbb8499$var$knownAdapters = {
    http: (0, $93dda30d8b06130a$export$2e2bcd8739ae039),
    xhr: (0, $d7c86353947eb680$export$2e2bcd8739ae039)
};
(0, $834198957c4a6765$export$2e2bcd8739ae039).forEach($200d9fbf4cbb8499$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $200d9fbf4cbb8499$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $834198957c4a6765$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $200d9fbf4cbb8499$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $834198957c4a6765$export$2e2bcd8739ae039).hasOwnProp($200d9fbf4cbb8499$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $200d9fbf4cbb8499$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $0923e70ad2dabdd1$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $016e99048fe201cb$export$2e2bcd8739ae039)(null, config);
}
function $0923e70ad2dabdd1$export$2e2bcd8739ae039(config) {
    $0923e70ad2dabdd1$var$throwIfCancellationRequested(config);
    config.headers = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $be9c0b6bd036e789$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $200d9fbf4cbb8499$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $b9307422e031a466$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $0923e70ad2dabdd1$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $be9c0b6bd036e789$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $e3d760b6f2e77558$export$2e2bcd8739ae039)(reason)) {
            $0923e70ad2dabdd1$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $be9c0b6bd036e789$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $f643149814757480$var$headersToObject = (thing)=>thing instanceof (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $f643149814757480$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isPlainObject(target) && (0, $834198957c4a6765$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $834198957c4a6765$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $834198957c4a6765$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f643149814757480$var$headersToObject(a), $f643149814757480$var$headersToObject(b), true)
    };
    (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $834198957c4a6765$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $2e443fc839f9fd72$export$a4ad2735b021c132 = "1.5.0";



"use strict";
const $cd252064504ee611$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $cd252064504ee611$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $cd252064504ee611$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $cd252064504ee611$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $2e443fc839f9fd72$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$cd252064504ee611$var$deprecatedWarnings[opt]) {
            $cd252064504ee611$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $cd252064504ee611$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("options must be an object", (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $5d7bb6a92182310f$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $5d7bb6a92182310f$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $cd252064504ee611$export$2e2bcd8739ae039 = {
    assertOptions: $cd252064504ee611$var$assertOptions,
    validators: $cd252064504ee611$var$validators
};



"use strict";
const $4a72b5816d48939b$var$validators = (0, $cd252064504ee611$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $4a72b5816d48939b$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $b921b2cbb62b77c8$export$2e2bcd8739ae039)(),
            response: new (0, $b921b2cbb62b77c8$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f643149814757480$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $cd252064504ee611$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $4a72b5816d48939b$var$validators.transitional($4a72b5816d48939b$var$validators.boolean),
            forcedJSONParsing: $4a72b5816d48939b$var$validators.transitional($4a72b5816d48939b$var$validators.boolean),
            clarifyTimeoutError: $4a72b5816d48939b$var$validators.transitional($4a72b5816d48939b$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $834198957c4a6765$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $cd252064504ee611$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $4a72b5816d48939b$var$validators.function,
                serialize: $4a72b5816d48939b$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $834198957c4a6765$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $834198957c4a6765$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $0923e70ad2dabdd1$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $0923e70ad2dabdd1$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f643149814757480$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $5e7ec6191b7c28a8$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $2443a707027f4081$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $834198957c4a6765$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $4a72b5816d48939b$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f643149814757480$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $834198957c4a6765$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f643149814757480$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $4a72b5816d48939b$var$Axios.prototype[method] = generateHTTPMethod();
    $4a72b5816d48939b$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $4a72b5816d48939b$export$2e2bcd8739ae039 = $4a72b5816d48939b$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $7a3f966e0634f70c$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $016e99048fe201cb$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $7a3f966e0634f70c$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $7a3f966e0634f70c$export$2e2bcd8739ae039 = $7a3f966e0634f70c$var$CancelToken;






"use strict";
function $67c945f3914c79a9$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $6b2c2d6199e4359b$export$2e2bcd8739ae039(payload) {
    return (0, $834198957c4a6765$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $52c336a8bb2b20c7$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($52c336a8bb2b20c7$var$HttpStatusCode).forEach(([key, value])=>{
    $52c336a8bb2b20c7$var$HttpStatusCode[value] = key;
});
var $52c336a8bb2b20c7$export$2e2bcd8739ae039 = $52c336a8bb2b20c7$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $3442b7804eafb8f4$var$createInstance(defaultConfig) {
    const context = new (0, $4a72b5816d48939b$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $66f21ce557ee50c3$export$2e2bcd8739ae039)((0, $4a72b5816d48939b$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $834198957c4a6765$export$2e2bcd8739ae039).extend(instance, (0, $4a72b5816d48939b$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $834198957c4a6765$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $3442b7804eafb8f4$var$createInstance((0, $f643149814757480$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $3442b7804eafb8f4$var$axios = $3442b7804eafb8f4$var$createInstance((0, $b9307422e031a466$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$3442b7804eafb8f4$var$axios.Axios = (0, $4a72b5816d48939b$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$3442b7804eafb8f4$var$axios.CanceledError = (0, $016e99048fe201cb$export$2e2bcd8739ae039);
$3442b7804eafb8f4$var$axios.CancelToken = (0, $7a3f966e0634f70c$export$2e2bcd8739ae039);
$3442b7804eafb8f4$var$axios.isCancel = (0, $e3d760b6f2e77558$export$2e2bcd8739ae039);
$3442b7804eafb8f4$var$axios.VERSION = (0, $2e443fc839f9fd72$export$a4ad2735b021c132);
$3442b7804eafb8f4$var$axios.toFormData = (0, $d934b479d93befbf$export$2e2bcd8739ae039);
// Expose AxiosError class
$3442b7804eafb8f4$var$axios.AxiosError = (0, $5d7bb6a92182310f$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$3442b7804eafb8f4$var$axios.Cancel = $3442b7804eafb8f4$var$axios.CanceledError;
// Expose all/spread
$3442b7804eafb8f4$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$3442b7804eafb8f4$var$axios.spread = (0, $67c945f3914c79a9$export$2e2bcd8739ae039);
// Expose isAxiosError
$3442b7804eafb8f4$var$axios.isAxiosError = (0, $6b2c2d6199e4359b$export$2e2bcd8739ae039);
// Expose mergeConfig
$3442b7804eafb8f4$var$axios.mergeConfig = (0, $f643149814757480$export$2e2bcd8739ae039);
$3442b7804eafb8f4$var$axios.AxiosHeaders = (0, $7a9223f90a3aa1f2$export$2e2bcd8739ae039);
$3442b7804eafb8f4$var$axios.formToJSON = (thing)=>(0, $ac138dff1179fff0$export$2e2bcd8739ae039)((0, $834198957c4a6765$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$3442b7804eafb8f4$var$axios.getAdapter = (0, $200d9fbf4cbb8499$export$2e2bcd8739ae039).getAdapter;
$3442b7804eafb8f4$var$axios.HttpStatusCode = (0, $52c336a8bb2b20c7$export$2e2bcd8739ae039);
$3442b7804eafb8f4$var$axios.default = $3442b7804eafb8f4$var$axios;
var // this module should only have a default export
$3442b7804eafb8f4$export$2e2bcd8739ae039 = $3442b7804eafb8f4$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $336ed350dc8498df$export$1c00760e9e5a4e95, AxiosError: $336ed350dc8498df$export$c1fbed17c2f6a328, CanceledError: $336ed350dc8498df$export$1ab0c6b20d94fa14, isCancel: $336ed350dc8498df$export$3b22524397b493c6, CancelToken: $336ed350dc8498df$export$fd08e3cb425f0d61, VERSION: $336ed350dc8498df$export$a4ad2735b021c132, all: $336ed350dc8498df$export$84bf76cd7afc7469, Cancel: $336ed350dc8498df$export$848c9b7ead0df967, isAxiosError: $336ed350dc8498df$export$fbafdbe06a5b5a9a, spread: $336ed350dc8498df$export$3ae0fd4797ed47c8, toFormData: $336ed350dc8498df$export$10ae0d317ea97f8b, AxiosHeaders: $336ed350dc8498df$export$4e7d6ff0f3e6520, HttpStatusCode: $336ed350dc8498df$export$a972f69c851492b3, formToJSON: $336ed350dc8498df$export$86d7c59254d6a2c9, getAdapter: $336ed350dc8498df$export$17ddc20a97d669e2, mergeConfig: $336ed350dc8498df$export$7ec1ebcfa9d8bd6a } = (0, $3442b7804eafb8f4$export$2e2bcd8739ae039);



// only allow these values for ENVIRONMENT, otherwise abort
const $87c980b245bbb7d9$var$allowedEnvironmentValues = [
    "development",
    "sales",
    "production"
];
const $87c980b245bbb7d9$var$rawEnvironment = "sales"?.trim().toLowerCase();
if (!$87c980b245bbb7d9$var$rawEnvironment || !$87c980b245bbb7d9$var$allowedEnvironmentValues.includes($87c980b245bbb7d9$var$rawEnvironment || "")) throw new Error(`Invalid environment value: ${"sales"}. Must be one of ${$87c980b245bbb7d9$var$allowedEnvironmentValues.join(", ")}`);
const $87c980b245bbb7d9$export$be46596bc6608f3b = $87c980b245bbb7d9$var$rawEnvironment;
const $87c980b245bbb7d9$export$a743660edcdb697b = $87c980b245bbb7d9$var$rawEnvironment === "development";
const $87c980b245bbb7d9$export$c87012121925caf1 = false;
const $87c980b245bbb7d9$export$51eee90b2075d4e1 = "eu-west-1_w8sH4zm5D";
const $87c980b245bbb7d9$export$1c5434afbe5b51 = "5ppsefpch2eg0nautfoflkoe26";
const $87c980b245bbb7d9$export$c3ee1e672e1e24e7 = "/api";
const $87c980b245bbb7d9$export$c1914de753539b0b = undefined;
const $87c980b245bbb7d9$export$6faa4a850bc4d0ce = "https://0ba9119458a5d85d26f53d8463323bbc@o454086.ingest.us.sentry.io/4506970386268160";
const $87c980b245bbb7d9$export$d2c893bfac1da9a1 = "52ac0243";
const $87c980b245bbb7d9$export$934e799b0e87def5 = parseFloat("0.2");
const $87c980b245bbb7d9$var$sentryTracePropagationTargets = undefined?.split(",").map((target)=>{
    return new RegExp(target.trim());
});
const $87c980b245bbb7d9$export$6229fa3b56a23727 = $87c980b245bbb7d9$var$sentryTracePropagationTargets;
const $87c980b245bbb7d9$export$d991ba28bdd15482 = parseFloat("0.0");
const $87c980b245bbb7d9$export$6d698ff2c1f4a0ca = parseFloat("1.0");
const $87c980b245bbb7d9$export$e987ec915f285263 = false;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3a5448e34d6c38e9$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f8831aa2c334791f$export$39430dfe49142ae = (options)=>{
    return (0, $3a5448e34d6c38e9$export$39430dfe49142ae)((0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7), options);
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9b86e3745fe9fe93$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($9b86e3745fe9fe93$export$12d5c695b2213c4a || ($9b86e3745fe9fe93$export$12d5c695b2213c4a = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f6e29a46e63271fd$export$195137955146d376 = {
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS or TOTP",
        recoverySuggestion: "Try to pass TOTP or SMS as the challengeResponse"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $f6e29a46e63271fd$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($f6e29a46e63271fd$export$c3070468b9d65120 || ($f6e29a46e63271fd$export$c3070468b9d65120 = {}));
var $f6e29a46e63271fd$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($f6e29a46e63271fd$export$473ab0b56598aacd || ($f6e29a46e63271fd$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7372c4b3ac7c2efd$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $f6e29a46e63271fd$export$195137955146d376)[name];
    if (!assertion) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c1aa49233a0ce598$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $2655623d514a11e7$export$ede38edb26c0bfdf)({
        category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's password while authenticated.
 *
 * @param input - The UpdatePasswordInput object.
 * @throws - {@link ChangePasswordException} - Cognito service errors thrown when updating a password.
 * @throws - {@link AuthValidationErrorCode} - Validation errors thrown when oldPassword or newPassword are empty.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $dd112e3697fbcf38$export$e2853351e15b7895(input) {
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { oldPassword: oldPassword, newPassword: newPassword } = input;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!oldPassword, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyUpdatePassword);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!newPassword, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyUpdatePassword);
    const { tokens: tokens } = await (0, $f8831aa2c334791f$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $de2f10f4a648aec0$export$77712ea5882cac9f)(tokens);
    await (0, $03c131ae6cab815c$export$99d837dc30eb1ef7)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).UpdatePassword)
    }, {
        AccessToken: tokens.accessToken.toString(),
        PreviousPassword: oldPassword,
        ProposedPassword: newPassword
    });
}


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $c17bec419e92745c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $cf9b393ccf0ad3d9$export$a143d493d941bafc;
var $cf9b393ccf0ad3d9$export$e4cf37d7f6fb9e0a;
var $cf9b393ccf0ad3d9$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $cf9b393ccf0ad3d9$export$599f31c3813fae4d;
"use strict";

var $gzGF9 = parcelRequire("gzGF9");

var $ZhBnF = parcelRequire("ZhBnF");
var $06f8c5a0b372d1e8$exports = {};
var $06f8c5a0b372d1e8$var$toString = {}.toString;
$06f8c5a0b372d1e8$exports = Array.isArray || function(arr) {
    return $06f8c5a0b372d1e8$var$toString.call(arr) == "[object Array]";
};


$cf9b393ccf0ad3d9$export$a143d493d941bafc = $cf9b393ccf0ad3d9$var$Buffer;
$cf9b393ccf0ad3d9$export$e4cf37d7f6fb9e0a = $cf9b393ccf0ad3d9$var$SlowBuffer;
$cf9b393ccf0ad3d9$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $cf9b393ccf0ad3d9$var$typedArraySupport();
$cf9b393ccf0ad3d9$export$599f31c3813fae4d = $cf9b393ccf0ad3d9$var$kMaxLength();
function $cf9b393ccf0ad3d9$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $cf9b393ccf0ad3d9$var$kMaxLength() {
    return $cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $cf9b393ccf0ad3d9$var$createBuffer(that, length) {
    if ($cf9b393ccf0ad3d9$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $cf9b393ccf0ad3d9$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $cf9b393ccf0ad3d9$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $cf9b393ccf0ad3d9$var$Buffer(arg, encodingOrOffset, length) {
    if (!$cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $cf9b393ccf0ad3d9$var$Buffer)) return new $cf9b393ccf0ad3d9$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $cf9b393ccf0ad3d9$var$allocUnsafe(this, arg);
    }
    return $cf9b393ccf0ad3d9$var$from(this, arg, encodingOrOffset, length);
}
$cf9b393ccf0ad3d9$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$cf9b393ccf0ad3d9$var$Buffer._augment = function(arr) {
    arr.__proto__ = $cf9b393ccf0ad3d9$var$Buffer.prototype;
    return arr;
};
function $cf9b393ccf0ad3d9$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $cf9b393ccf0ad3d9$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $cf9b393ccf0ad3d9$var$fromString(that, value, encodingOrOffset);
    return $cf9b393ccf0ad3d9$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $cf9b393ccf0ad3d9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $cf9b393ccf0ad3d9$var$from(null, value, encodingOrOffset, length);
};
if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $cf9b393ccf0ad3d9$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $cf9b393ccf0ad3d9$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $cf9b393ccf0ad3d9$var$Buffer[Symbol.species] === $cf9b393ccf0ad3d9$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($cf9b393ccf0ad3d9$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $cf9b393ccf0ad3d9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $cf9b393ccf0ad3d9$var$alloc(that, size, fill, encoding) {
    $cf9b393ccf0ad3d9$var$assertSize(size);
    if (size <= 0) return $cf9b393ccf0ad3d9$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $cf9b393ccf0ad3d9$var$createBuffer(that, size).fill(fill, encoding) : $cf9b393ccf0ad3d9$var$createBuffer(that, size).fill(fill);
    return $cf9b393ccf0ad3d9$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $cf9b393ccf0ad3d9$var$Buffer.alloc = function(size, fill, encoding) {
    return $cf9b393ccf0ad3d9$var$alloc(null, size, fill, encoding);
};
function $cf9b393ccf0ad3d9$var$allocUnsafe(that, size) {
    $cf9b393ccf0ad3d9$var$assertSize(size);
    that = $cf9b393ccf0ad3d9$var$createBuffer(that, size < 0 ? 0 : $cf9b393ccf0ad3d9$var$checked(size) | 0);
    if (!$cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $cf9b393ccf0ad3d9$var$Buffer.allocUnsafe = function(size) {
    return $cf9b393ccf0ad3d9$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $cf9b393ccf0ad3d9$var$Buffer.allocUnsafeSlow = function(size) {
    return $cf9b393ccf0ad3d9$var$allocUnsafe(null, size);
};
function $cf9b393ccf0ad3d9$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$cf9b393ccf0ad3d9$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $cf9b393ccf0ad3d9$var$byteLength(string, encoding) | 0;
    that = $cf9b393ccf0ad3d9$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $cf9b393ccf0ad3d9$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $cf9b393ccf0ad3d9$var$checked(array.length) | 0;
    that = $cf9b393ccf0ad3d9$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $cf9b393ccf0ad3d9$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $cf9b393ccf0ad3d9$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $cf9b393ccf0ad3d9$var$fromArrayLike(that, array);
    return that;
}
function $cf9b393ccf0ad3d9$var$fromObject(that, obj) {
    if ($cf9b393ccf0ad3d9$var$Buffer.isBuffer(obj)) {
        var len = $cf9b393ccf0ad3d9$var$checked(obj.length) | 0;
        that = $cf9b393ccf0ad3d9$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $cf9b393ccf0ad3d9$var$isnan(obj.length)) return $cf9b393ccf0ad3d9$var$createBuffer(that, 0);
            return $cf9b393ccf0ad3d9$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $06f8c5a0b372d1e8$exports(obj.data)) return $cf9b393ccf0ad3d9$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $cf9b393ccf0ad3d9$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $cf9b393ccf0ad3d9$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $cf9b393ccf0ad3d9$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $cf9b393ccf0ad3d9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $cf9b393ccf0ad3d9$var$Buffer.alloc(+length);
}
$cf9b393ccf0ad3d9$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$cf9b393ccf0ad3d9$var$Buffer.compare = function compare(a, b) {
    if (!$cf9b393ccf0ad3d9$var$Buffer.isBuffer(a) || !$cf9b393ccf0ad3d9$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$cf9b393ccf0ad3d9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$cf9b393ccf0ad3d9$var$Buffer.concat = function concat(list, length) {
    if (!$06f8c5a0b372d1e8$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $cf9b393ccf0ad3d9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $cf9b393ccf0ad3d9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$cf9b393ccf0ad3d9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $cf9b393ccf0ad3d9$var$byteLength(string, encoding) {
    if ($cf9b393ccf0ad3d9$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $cf9b393ccf0ad3d9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $cf9b393ccf0ad3d9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $cf9b393ccf0ad3d9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$cf9b393ccf0ad3d9$var$Buffer.byteLength = $cf9b393ccf0ad3d9$var$byteLength;
function $cf9b393ccf0ad3d9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $cf9b393ccf0ad3d9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $cf9b393ccf0ad3d9$var$utf8Slice(this, start, end);
        case "ascii":
            return $cf9b393ccf0ad3d9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $cf9b393ccf0ad3d9$var$latin1Slice(this, start, end);
        case "base64":
            return $cf9b393ccf0ad3d9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $cf9b393ccf0ad3d9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$cf9b393ccf0ad3d9$var$Buffer.prototype._isBuffer = true;
function $cf9b393ccf0ad3d9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$cf9b393ccf0ad3d9$var$swap(this, i, i + 1);
    return this;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $cf9b393ccf0ad3d9$var$swap(this, i, i + 3);
        $cf9b393ccf0ad3d9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $cf9b393ccf0ad3d9$var$swap(this, i, i + 7);
        $cf9b393ccf0ad3d9$var$swap(this, i + 1, i + 6);
        $cf9b393ccf0ad3d9$var$swap(this, i + 2, i + 5);
        $cf9b393ccf0ad3d9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $cf9b393ccf0ad3d9$var$utf8Slice(this, 0, length);
    return $cf9b393ccf0ad3d9$var$slowToString.apply(this, arguments);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.equals = function equals(b) {
    if (!$cf9b393ccf0ad3d9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $cf9b393ccf0ad3d9$var$Buffer.compare(this, b) === 0;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $cf9b393ccf0ad3d9$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$cf9b393ccf0ad3d9$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $cf9b393ccf0ad3d9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $cf9b393ccf0ad3d9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($cf9b393ccf0ad3d9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $cf9b393ccf0ad3d9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $cf9b393ccf0ad3d9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $cf9b393ccf0ad3d9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $cf9b393ccf0ad3d9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $cf9b393ccf0ad3d9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $cf9b393ccf0ad3d9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $cf9b393ccf0ad3d9$var$utf8Write(buf, string, offset, length) {
    return $cf9b393ccf0ad3d9$var$blitBuffer($cf9b393ccf0ad3d9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $cf9b393ccf0ad3d9$var$asciiWrite(buf, string, offset, length) {
    return $cf9b393ccf0ad3d9$var$blitBuffer($cf9b393ccf0ad3d9$var$asciiToBytes(string), buf, offset, length);
}
function $cf9b393ccf0ad3d9$var$latin1Write(buf, string, offset, length) {
    return $cf9b393ccf0ad3d9$var$asciiWrite(buf, string, offset, length);
}
function $cf9b393ccf0ad3d9$var$base64Write(buf, string, offset, length) {
    return $cf9b393ccf0ad3d9$var$blitBuffer($cf9b393ccf0ad3d9$var$base64ToBytes(string), buf, offset, length);
}
function $cf9b393ccf0ad3d9$var$ucs2Write(buf, string, offset, length) {
    return $cf9b393ccf0ad3d9$var$blitBuffer($cf9b393ccf0ad3d9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $cf9b393ccf0ad3d9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $cf9b393ccf0ad3d9$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $cf9b393ccf0ad3d9$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $cf9b393ccf0ad3d9$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $cf9b393ccf0ad3d9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $cf9b393ccf0ad3d9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $cf9b393ccf0ad3d9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gzGF9.fromByteArray(buf);
    else return $gzGF9.fromByteArray(buf.slice(start, end));
}
function $cf9b393ccf0ad3d9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $cf9b393ccf0ad3d9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $cf9b393ccf0ad3d9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $cf9b393ccf0ad3d9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $cf9b393ccf0ad3d9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $cf9b393ccf0ad3d9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $cf9b393ccf0ad3d9$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $cf9b393ccf0ad3d9$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $cf9b393ccf0ad3d9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $cf9b393ccf0ad3d9$var$toHex(buf[i]);
    return out;
}
function $cf9b393ccf0ad3d9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $cf9b393ccf0ad3d9$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $cf9b393ccf0ad3d9$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $cf9b393ccf0ad3d9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 4, this.length);
    return $ZhBnF.read(this, offset, true, 23, 4);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 4, this.length);
    return $ZhBnF.read(this, offset, false, 23, 4);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 8, this.length);
    return $ZhBnF.read(this, offset, true, 52, 8);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkOffset(offset, 8, this.length);
    return $ZhBnF.read(this, offset, false, 52, 8);
};
function $cf9b393ccf0ad3d9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$cf9b393ccf0ad3d9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $cf9b393ccf0ad3d9$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $cf9b393ccf0ad3d9$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $cf9b393ccf0ad3d9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $cf9b393ccf0ad3d9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $cf9b393ccf0ad3d9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ZhBnF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $cf9b393ccf0ad3d9$var$writeFloat(this, value, offset, true, noAssert);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $cf9b393ccf0ad3d9$var$writeFloat(this, value, offset, false, noAssert);
};
function $cf9b393ccf0ad3d9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $cf9b393ccf0ad3d9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ZhBnF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $cf9b393ccf0ad3d9$var$writeDouble(this, value, offset, true, noAssert);
};
$cf9b393ccf0ad3d9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $cf9b393ccf0ad3d9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$cf9b393ccf0ad3d9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$cf9b393ccf0ad3d9$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$cf9b393ccf0ad3d9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$cf9b393ccf0ad3d9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $cf9b393ccf0ad3d9$var$Buffer.isBuffer(val) ? val : $cf9b393ccf0ad3d9$var$utf8ToBytes(new $cf9b393ccf0ad3d9$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $cf9b393ccf0ad3d9$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $cf9b393ccf0ad3d9$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $cf9b393ccf0ad3d9$var$stringtrim(str).replace($cf9b393ccf0ad3d9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $cf9b393ccf0ad3d9$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $cf9b393ccf0ad3d9$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $cf9b393ccf0ad3d9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $cf9b393ccf0ad3d9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $cf9b393ccf0ad3d9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $cf9b393ccf0ad3d9$var$base64ToBytes(str) {
    return $gzGF9.toByteArray($cf9b393ccf0ad3d9$var$base64clean(str));
}
function $cf9b393ccf0ad3d9$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $cf9b393ccf0ad3d9$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}


var $a709403f6bc447b2$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $a709403f6bc447b2$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$a709403f6bc447b2$var$crypto && typeof window !== "undefined" && window.msCrypto) $a709403f6bc447b2$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$a709403f6bc447b2$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $a709403f6bc447b2$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$a709403f6bc447b2$var$crypto && true) try {
    $a709403f6bc447b2$var$crypto = (parcelRequire("34JBo"));
} catch (err) {}
function $a709403f6bc447b2$export$2e2bcd8739ae039() {
    if ($a709403f6bc447b2$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $a709403f6bc447b2$var$crypto.getRandomValues === "function") try {
            return $a709403f6bc447b2$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $a709403f6bc447b2$var$crypto.randomBytes === "function") try {
            return $a709403f6bc447b2$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $17af9c40ffc042c9$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $17af9c40ffc042c9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $a709403f6bc447b2$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $17af9c40ffc042c9$var$hexStringify(this);
    };
    return WordArray;
}();


var $e276799cbbca4dad$exports = {};
"use strict";
Object.defineProperty($e276799cbbca4dad$exports, "__esModule", {
    value: true
});

var $fSuOO = parcelRequire("fSuOO");

(0, $fSuOO.__exportStar)((parcelRequire("jW2oE")), $e276799cbbca4dad$exports);


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $5f970ca552653674$export$2e2bcd8739ae039 = $5f970ca552653674$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $5f970ca552653674$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $5f970ca552653674$var$nbi() {
    return new $5f970ca552653674$var$BigInteger(null);
}
// Bits per digit
var $5f970ca552653674$var$dbits;
// JavaScript engine analysis
var $5f970ca552653674$var$canary = 0xdeadbeefcafe;
var $5f970ca552653674$var$j_lm = ($5f970ca552653674$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $5f970ca552653674$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $5f970ca552653674$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $5f970ca552653674$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $5f970ca552653674$var$inBrowser = typeof navigator !== "undefined";
if ($5f970ca552653674$var$inBrowser && $5f970ca552653674$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $5f970ca552653674$var$BigInteger.prototype.am = $5f970ca552653674$var$am2;
    $5f970ca552653674$var$dbits = 30;
} else if ($5f970ca552653674$var$inBrowser && $5f970ca552653674$var$j_lm && navigator.appName != "Netscape") {
    $5f970ca552653674$var$BigInteger.prototype.am = $5f970ca552653674$var$am1;
    $5f970ca552653674$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $5f970ca552653674$var$BigInteger.prototype.am = $5f970ca552653674$var$am3;
    $5f970ca552653674$var$dbits = 28;
}
$5f970ca552653674$var$BigInteger.prototype.DB = $5f970ca552653674$var$dbits;
$5f970ca552653674$var$BigInteger.prototype.DM = (1 << $5f970ca552653674$var$dbits) - 1;
$5f970ca552653674$var$BigInteger.prototype.DV = 1 << $5f970ca552653674$var$dbits;
var $5f970ca552653674$var$BI_FP = 52;
$5f970ca552653674$var$BigInteger.prototype.FV = Math.pow(2, $5f970ca552653674$var$BI_FP);
$5f970ca552653674$var$BigInteger.prototype.F1 = $5f970ca552653674$var$BI_FP - $5f970ca552653674$var$dbits;
$5f970ca552653674$var$BigInteger.prototype.F2 = 2 * $5f970ca552653674$var$dbits - $5f970ca552653674$var$BI_FP;
// Digit conversions
var $5f970ca552653674$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $5f970ca552653674$var$BI_RC = new Array();
var $5f970ca552653674$var$rr, $5f970ca552653674$var$vv;
$5f970ca552653674$var$rr = "0".charCodeAt(0);
for($5f970ca552653674$var$vv = 0; $5f970ca552653674$var$vv <= 9; ++$5f970ca552653674$var$vv)$5f970ca552653674$var$BI_RC[$5f970ca552653674$var$rr++] = $5f970ca552653674$var$vv;
$5f970ca552653674$var$rr = "a".charCodeAt(0);
for($5f970ca552653674$var$vv = 10; $5f970ca552653674$var$vv < 36; ++$5f970ca552653674$var$vv)$5f970ca552653674$var$BI_RC[$5f970ca552653674$var$rr++] = $5f970ca552653674$var$vv;
$5f970ca552653674$var$rr = "A".charCodeAt(0);
for($5f970ca552653674$var$vv = 10; $5f970ca552653674$var$vv < 36; ++$5f970ca552653674$var$vv)$5f970ca552653674$var$BI_RC[$5f970ca552653674$var$rr++] = $5f970ca552653674$var$vv;
function $5f970ca552653674$var$int2char(n) {
    return $5f970ca552653674$var$BI_RM.charAt(n);
}
function $5f970ca552653674$var$intAt(s, i) {
    var c = $5f970ca552653674$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $5f970ca552653674$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $5f970ca552653674$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $5f970ca552653674$var$nbv(i) {
    var r = $5f970ca552653674$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $5f970ca552653674$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $5f970ca552653674$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $5f970ca552653674$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $5f970ca552653674$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $5f970ca552653674$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $5f970ca552653674$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $5f970ca552653674$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $5f970ca552653674$var$bnNegate() {
    var r = $5f970ca552653674$var$nbi();
    $5f970ca552653674$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $5f970ca552653674$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $5f970ca552653674$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $5f970ca552653674$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $5f970ca552653674$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $5f970ca552653674$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $5f970ca552653674$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $5f970ca552653674$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $5f970ca552653674$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $5f970ca552653674$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $5f970ca552653674$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $5f970ca552653674$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $5f970ca552653674$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $5f970ca552653674$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $5f970ca552653674$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $5f970ca552653674$var$nbi();
    var y = $5f970ca552653674$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $5f970ca552653674$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $5f970ca552653674$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $5f970ca552653674$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $5f970ca552653674$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $5f970ca552653674$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $5f970ca552653674$var$bnMod(a) {
    var r = $5f970ca552653674$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($5f970ca552653674$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $5f970ca552653674$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $5f970ca552653674$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $5f970ca552653674$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $5f970ca552653674$var$bnAdd(a) {
    var r = $5f970ca552653674$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $5f970ca552653674$var$bnSubtract(a) {
    var r = $5f970ca552653674$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $5f970ca552653674$var$bnMultiply(a) {
    var r = $5f970ca552653674$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $5f970ca552653674$var$bnDivide(a) {
    var r = $5f970ca552653674$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $5f970ca552653674$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $5f970ca552653674$var$montConvert(x) {
    var r = $5f970ca552653674$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($5f970ca552653674$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $5f970ca552653674$var$montRevert(x) {
    var r = $5f970ca552653674$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $5f970ca552653674$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $5f970ca552653674$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $5f970ca552653674$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$5f970ca552653674$var$Montgomery.prototype.convert = $5f970ca552653674$var$montConvert;
$5f970ca552653674$var$Montgomery.prototype.revert = $5f970ca552653674$var$montRevert;
$5f970ca552653674$var$Montgomery.prototype.reduce = $5f970ca552653674$var$montReduce;
$5f970ca552653674$var$Montgomery.prototype.mulTo = $5f970ca552653674$var$montMulTo;
$5f970ca552653674$var$Montgomery.prototype.sqrTo = $5f970ca552653674$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $5f970ca552653674$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $5f970ca552653674$var$nbv(1), z = new $5f970ca552653674$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $5f970ca552653674$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $5f970ca552653674$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $5f970ca552653674$var$nbi(), t;
    i = $5f970ca552653674$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$5f970ca552653674$var$BigInteger.prototype.copyTo = $5f970ca552653674$var$bnpCopyTo;
$5f970ca552653674$var$BigInteger.prototype.fromInt = $5f970ca552653674$var$bnpFromInt;
$5f970ca552653674$var$BigInteger.prototype.fromString = $5f970ca552653674$var$bnpFromString;
$5f970ca552653674$var$BigInteger.prototype.clamp = $5f970ca552653674$var$bnpClamp;
$5f970ca552653674$var$BigInteger.prototype.dlShiftTo = $5f970ca552653674$var$bnpDLShiftTo;
$5f970ca552653674$var$BigInteger.prototype.drShiftTo = $5f970ca552653674$var$bnpDRShiftTo;
$5f970ca552653674$var$BigInteger.prototype.lShiftTo = $5f970ca552653674$var$bnpLShiftTo;
$5f970ca552653674$var$BigInteger.prototype.rShiftTo = $5f970ca552653674$var$bnpRShiftTo;
$5f970ca552653674$var$BigInteger.prototype.subTo = $5f970ca552653674$var$bnpSubTo;
$5f970ca552653674$var$BigInteger.prototype.multiplyTo = $5f970ca552653674$var$bnpMultiplyTo;
$5f970ca552653674$var$BigInteger.prototype.squareTo = $5f970ca552653674$var$bnpSquareTo;
$5f970ca552653674$var$BigInteger.prototype.divRemTo = $5f970ca552653674$var$bnpDivRemTo;
$5f970ca552653674$var$BigInteger.prototype.invDigit = $5f970ca552653674$var$bnpInvDigit;
$5f970ca552653674$var$BigInteger.prototype.addTo = $5f970ca552653674$var$bnpAddTo;
// public
$5f970ca552653674$var$BigInteger.prototype.toString = $5f970ca552653674$var$bnToString;
$5f970ca552653674$var$BigInteger.prototype.negate = $5f970ca552653674$var$bnNegate;
$5f970ca552653674$var$BigInteger.prototype.abs = $5f970ca552653674$var$bnAbs;
$5f970ca552653674$var$BigInteger.prototype.compareTo = $5f970ca552653674$var$bnCompareTo;
$5f970ca552653674$var$BigInteger.prototype.bitLength = $5f970ca552653674$var$bnBitLength;
$5f970ca552653674$var$BigInteger.prototype.mod = $5f970ca552653674$var$bnMod;
$5f970ca552653674$var$BigInteger.prototype.equals = $5f970ca552653674$var$bnEquals;
$5f970ca552653674$var$BigInteger.prototype.add = $5f970ca552653674$var$bnAdd;
$5f970ca552653674$var$BigInteger.prototype.subtract = $5f970ca552653674$var$bnSubtract;
$5f970ca552653674$var$BigInteger.prototype.multiply = $5f970ca552653674$var$bnMultiply;
$5f970ca552653674$var$BigInteger.prototype.divide = $5f970ca552653674$var$bnDivide;
$5f970ca552653674$var$BigInteger.prototype.modPow = $5f970ca552653674$var$bnModPow;
// "constants"
$5f970ca552653674$var$BigInteger.ZERO = $5f970ca552653674$var$nbv(0);
$5f970ca552653674$var$BigInteger.ONE = $5f970ca552653674$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $1d208b74eb74d3dd$var$randomBytes(nBytes) {
    return (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(new (0, $17af9c40ffc042c9$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $1d208b74eb74d3dd$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $1d208b74eb74d3dd$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $1d208b74eb74d3dd$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $1d208b74eb74d3dd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $5f970ca552653674$export$2e2bcd8739ae039)($1d208b74eb74d3dd$var$initN, 16);
        this.g = new (0, $5f970ca552653674$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $1d208b74eb74d3dd$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $1d208b74eb74d3dd$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $1d208b74eb74d3dd$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $5f970ca552653674$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $5f970ca552653674$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $5f970ca552653674$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $e276799cbbca4dad$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $5f970ca552653674$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $5f970ca552653674$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $1d208b74eb74d3dd$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $5f970ca552653674$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $5f970ca552653674$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $1d208b74eb74d3dd$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $5f970ca552653674$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $bf5d287d66e7a6d7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $a188457aa09f002f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $a188457aa09f002f$var$_setPrototypeOf(subClass, superClass);
}
function $a188457aa09f002f$var$_setPrototypeOf(o, p) {
    $a188457aa09f002f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a188457aa09f002f$var$_setPrototypeOf(o, p);
}
/** @class */ var $a188457aa09f002f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $a188457aa09f002f$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $bf5d287d66e7a6d7$export$2e2bcd8739ae039));



function $2580e83778ae42c3$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $2580e83778ae42c3$var$_setPrototypeOf(subClass, superClass);
}
function $2580e83778ae42c3$var$_setPrototypeOf(o, p) {
    $2580e83778ae42c3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2580e83778ae42c3$var$_setPrototypeOf(o, p);
}
/** @class */ var $2580e83778ae42c3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $2580e83778ae42c3$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $bf5d287d66e7a6d7$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $ed8bd83551787c17$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $db263c92408bc8b1$export$83d89fbfd8236492 = "5.0.4";


var $fa0d6d4137c19010$var$BASE_USER_AGENT = "aws-amplify/" + (0, $db263c92408bc8b1$export$83d89fbfd8236492);
var $fa0d6d4137c19010$export$2dffd0b5373a4389 = {
    userAgent: $fa0d6d4137c19010$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $fa0d6d4137c19010$export$7935961ef7719cb0 = function getUserAgent() {
    return $fa0d6d4137c19010$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $fa0d6d4137c19010$export$2e2bcd8739ae039 = $fa0d6d4137c19010$export$2dffd0b5373a4389;







/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $cc9a2aa989962b14$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $28df9dc7d7defc0c$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $28df9dc7d7defc0c$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $28df9dc7d7defc0c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $28df9dc7d7defc0c$var$weekNames[now.getUTCDay()];
        var month = $28df9dc7d7defc0c$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $b5126e8c8c44ed54$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $5f4e9a079f354bc7$var$dataMemory = {};
var $5f4e9a079f354bc7$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $5f4e9a079f354bc7$var$dataMemory[key] = value;
        return $5f4e9a079f354bc7$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($5f4e9a079f354bc7$var$dataMemory, key) ? $5f4e9a079f354bc7$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $5f4e9a079f354bc7$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $5f4e9a079f354bc7$var$dataMemory = {};
        return $5f4e9a079f354bc7$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $5f4e9a079f354bc7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $5f4e9a079f354bc7$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $4ad0de7cab15d7ec$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $4ad0de7cab15d7ec$var$userAgent = $4ad0de7cab15d7ec$var$isNavigatorAvailable ? (0, $fa0d6d4137c19010$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var $4ad0de7cab15d7ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $5f4e9a079f354bc7$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $1d208b74eb74d3dd$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $28df9dc7d7defc0c$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).concat([
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $1d208b74eb74d3dd$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $4ad0de7cab15d7ec$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $1d208b74eb74d3dd$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $1d208b74eb74d3dd$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $28df9dc7d7defc0c$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $5f970ca552653674$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).concat([
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $1d208b74eb74d3dd$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $1d208b74eb74d3dd$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $cf9b393ccf0ad3d9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $4ad0de7cab15d7ec$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $b5126e8c8c44ed54$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $2580e83778ae42c3$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $a188457aa09f002f$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $ed8bd83551787c17$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $cc9a2aa989962b14$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $2580e83778ae42c3$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $a188457aa09f002f$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $ed8bd83551787c17$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $cc9a2aa989962b14$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $f2dd0c09879dfb55$exports = {};


$f2dd0c09879dfb55$exports = self.fetch || (self.fetch = (parcelRequire("hdWZo")).default || (parcelRequire("hdWZo")));



var $6539c50553d88efc$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $6539c50553d88efc$export$2ef00488675027c = "auth";


// constructor
function $ab6b673587910c6b$var$UserAgent() {}
// public
$ab6b673587910c6b$var$UserAgent.prototype.userAgent = (0, $fa0d6d4137c19010$export$7935961ef7719cb0)();
var $ab6b673587910c6b$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($ab6b673587910c6b$var$UserAgent.prototype.userAgent && !$ab6b673587910c6b$var$UserAgent.prototype.userAgent.includes(content)) $ab6b673587910c6b$var$UserAgent.prototype.userAgent = $ab6b673587910c6b$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$ab6b673587910c6b$var$UserAgent.prototype.userAgent || $ab6b673587910c6b$var$UserAgent.prototype.userAgent === "") $ab6b673587910c6b$var$UserAgent.prototype.userAgent = content;
};
var $ab6b673587910c6b$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $ab6b673587910c6b$var$UserAgent.category = (0, $6539c50553d88efc$export$2ef00488675027c);
};
var $ab6b673587910c6b$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $ab6b673587910c6b$var$UserAgent.framework = framework;
};
var $ab6b673587910c6b$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $ab6b673587910c6b$var$UserAgent.category ? " " + $ab6b673587910c6b$var$UserAgent.category : "";
    var uaFramework = $ab6b673587910c6b$var$UserAgent.framework ? " framework/" + $ab6b673587910c6b$var$UserAgent.framework : "";
    var userAgent = "" + $ab6b673587910c6b$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$ab6b673587910c6b$export$2e2bcd8739ae039 = $ab6b673587910c6b$var$UserAgent;


function $6ef12ee879991026$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $6ef12ee879991026$var$_setPrototypeOf(subClass, superClass);
}
function $6ef12ee879991026$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $6ef12ee879991026$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$6ef12ee879991026$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $6ef12ee879991026$var$_construct(Class, arguments, $6ef12ee879991026$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6ef12ee879991026$var$_setPrototypeOf(Wrapper, Class);
    };
    return $6ef12ee879991026$var$_wrapNativeSuper(Class);
}
function $6ef12ee879991026$var$_construct(Parent, args, Class) {
    if ($6ef12ee879991026$var$_isNativeReflectConstruct()) $6ef12ee879991026$var$_construct = Reflect.construct.bind();
    else $6ef12ee879991026$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6ef12ee879991026$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $6ef12ee879991026$var$_construct.apply(null, arguments);
}
function $6ef12ee879991026$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6ef12ee879991026$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $6ef12ee879991026$var$_setPrototypeOf(o, p) {
    $6ef12ee879991026$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6ef12ee879991026$var$_setPrototypeOf(o, p);
}
function $6ef12ee879991026$var$_getPrototypeOf(o) {
    $6ef12ee879991026$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6ef12ee879991026$var$_getPrototypeOf(o);
}
var $6ef12ee879991026$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $6ef12ee879991026$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $6ef12ee879991026$var$_wrapNativeSuper(Error));
/** @class */ var $6ef12ee879991026$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $6ef12ee879991026$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $6ef12ee879991026$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $ab6b673587910c6b$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $6ef12ee879991026$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $6ef12ee879991026$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $6ef12ee879991026$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $6ef12ee879991026$var$_wrapNativeSuper(Error));
var $6ef12ee879991026$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $6ef12ee879991026$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $6ef12ee879991026$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $6ef12ee879991026$var$logger.debug("error on " + functionToRetry.name, err);
        if ($6ef12ee879991026$var$isNonRetryableError(err)) {
            $6ef12ee879991026$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $6ef12ee879991026$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $6ef12ee879991026$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $6ef12ee879991026$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $6ef12ee879991026$var$MAX_DELAY_MS = 300000;
function $6ef12ee879991026$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $6ef12ee879991026$var$MAX_DELAY_MS;
    return $6ef12ee879991026$var$retry(functionToRetry, args, $6ef12ee879991026$var$jitteredBackoff(maxDelayMs));
}




var $04bedfcd56dd0241$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $04bedfcd56dd0241$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $04bedfcd56dd0241$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $6ef12ee879991026$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $5f4e9a079f354bc7$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $4ad0de7cab15d7ec$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $4ad0de7cab15d7ec$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $12bab03e0c7b53fa$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $12bab03e0c7b53fa$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $9eb0a4043fb2fee0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $12bab03e0c7b53fa$exports.set(key, value, options);
        return $12bab03e0c7b53fa$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $12bab03e0c7b53fa$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $12bab03e0c7b53fa$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $12bab03e0c7b53fa$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();








const $0a1b437839f18938$var$poolData = {
    UserPoolId: (0, $87c980b245bbb7d9$export$51eee90b2075d4e1),
    ClientId: (0, $87c980b245bbb7d9$export$1c5434afbe5b51)
};
var $0a1b437839f18938$export$2e2bcd8739ae039 = new (0, $04bedfcd56dd0241$export$2e2bcd8739ae039)($0a1b437839f18938$var$poolData);


const $1ff9aa7c00d3fc54$export$ff0725f0ea898f41 = "/v1";
const $1ff9aa7c00d3fc54$export$662364dbe336d1ec = "/admin/v1";
const $1ff9aa7c00d3fc54$export$f654b28f82155665 = (admin)=>admin ? $1ff9aa7c00d3fc54$export$662364dbe336d1ec : $1ff9aa7c00d3fc54$export$ff0725f0ea898f41;



const $9b69f9955ab78e59$var$logout = ()=>{
    if (0, $87c980b245bbb7d9$export$c87012121925caf1) {
        (0, $0c6c769a0b0e21f2$export$e8df664d4863167e)();
        return Promise.resolve();
    }
    return new Promise((success, reject)=>{
        const user = (0, $0a1b437839f18938$export$2e2bcd8739ae039).getCurrentUser();
        if (!user) reject("Failed to get user");
        user?.signOut();
        (0, $0c6c769a0b0e21f2$export$e8df664d4863167e)();
        success(true);
    });
};
const $9b69f9955ab78e59$var$setTokenToInterceptor = (jwtToken)=>{
    (0, $0c6c769a0b0e21f2$export$f2561ccb0f636d32)((0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41), jwtToken);
};
const $9b69f9955ab78e59$var$getAuthSession = ()=>{
    return (0, $f8831aa2c334791f$export$39430dfe49142ae)();
};
const $9b69f9955ab78e59$var$getJWTToken = (authSession)=>{
    return authSession.tokens?.idToken?.toString();
};
const $9b69f9955ab78e59$var$getUserGroups = (authSession)=>{
    return authSession.tokens?.accessToken?.payload["cognito:groups"]?.join(",");
};
const $9b69f9955ab78e59$var$changePassword = (oldPassword, newPassword)=>{
    return (0, $dd112e3697fbcf38$export$e2853351e15b7895)({
        oldPassword: oldPassword,
        newPassword: newPassword
    });
};
const $9b69f9955ab78e59$var$devLogin = (email)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/dev/get-token`, {
        params: {
            email: email
        }
    }).then((response)=>response.data.token);
};
const $9b69f9955ab78e59$var$LoginAPI = {
    logout: $9b69f9955ab78e59$var$logout,
    setTokenToInterceptor: $9b69f9955ab78e59$var$setTokenToInterceptor,
    getAuthSession: $9b69f9955ab78e59$var$getAuthSession,
    getJWTToken: $9b69f9955ab78e59$var$getJWTToken,
    changePassword: $9b69f9955ab78e59$var$changePassword,
    getUserGroups: $9b69f9955ab78e59$var$getUserGroups,
    devLogin: $9b69f9955ab78e59$var$devLogin
};
var $9b69f9955ab78e59$export$2e2bcd8739ae039 = $9b69f9955ab78e59$var$LoginAPI;


let $0c6c769a0b0e21f2$var$failedQueue = [];
let $0c6c769a0b0e21f2$var$isRefreshing = false;
const $0c6c769a0b0e21f2$var$processQueue = (error)=>{
    $0c6c769a0b0e21f2$var$failedQueue.forEach((prom)=>{
        if (error) prom.reject(error);
        else prom.resolve();
    });
    $0c6c769a0b0e21f2$var$failedQueue = [];
};
const $0c6c769a0b0e21f2$var$setJwtToken = (jwtToken)=>{
    sessionStorage.setItem((0, $086351014303c4b8$export$cb43794bb023e720), jwtToken);
    $0c6c769a0b0e21f2$export$f2561ccb0f636d32($0c6c769a0b0e21f2$export$388e0302ca0d9a41, jwtToken);
};
const $0c6c769a0b0e21f2$export$e8df664d4863167e = ()=>{
    sessionStorage.setItem((0, $086351014303c4b8$export$cb43794bb023e720), "");
    sessionStorage.setItem((0, $086351014303c4b8$export$fbb0f21f223dce54), "");
    sessionStorage.setItem((0, $086351014303c4b8$export$ad6b2753bfb86074), "");
    sessionStorage.setItem((0, $086351014303c4b8$export$7590792a37b51514), "");
    sessionStorage.setItem((0, $086351014303c4b8$export$fa52eabe6f966a70), "");
    sessionStorage.setItem((0, $086351014303c4b8$export$85978fd627e990d0), "");
    sessionStorage.setItem((0, $086351014303c4b8$export$464bac997a211baf), "");
};
const $0c6c769a0b0e21f2$export$388e0302ca0d9a41 = $0c6c769a0b0e21f2$var$createAxiosClient({
    options: {
        baseURL: (0, $87c980b245bbb7d9$export$c3ee1e672e1e24e7),
        timeout: 300000
    },
    logout: $0c6c769a0b0e21f2$export$e8df664d4863167e,
    setJwtToken: $0c6c769a0b0e21f2$var$setJwtToken
});
const $0c6c769a0b0e21f2$export$f2561ccb0f636d32 = (client, jwtToken)=>{
    client.interceptors.request.clear();
    client.interceptors.request.use((config)=>{
        config.headers.Authorization = "Bearer " + jwtToken;
        return config;
    }, (error)=>{
        return Promise.reject(error);
    });
};
function $0c6c769a0b0e21f2$var$createAxiosClient({ options: options, logout: logout, setJwtToken: setJwtToken }) {
    const client = (0, $3442b7804eafb8f4$export$2e2bcd8739ae039).create(options);
    const token = sessionStorage.getItem((0, $086351014303c4b8$export$cb43794bb023e720));
    if (token) client.interceptors.request.use((config)=>{
        config.headers.Authorization = "Bearer " + token;
        return config;
    }, (error)=>{
        return Promise.reject(error);
    });
    client.interceptors.response.use((response)=>{
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, (error)=>{
        const originalRequest = error.config;
        // If error, process all the requests in the queue and logout the user.
        const handleError = (error)=>{
            $0c6c769a0b0e21f2$var$processQueue(error);
            logout();
            return Promise.reject(error);
        };
        // Refresh token conditions
        if (error.response?.status === 401 && error.response.data.error === "Token is not valid or has expired" && originalRequest?._retry !== true) {
            if ($0c6c769a0b0e21f2$var$isRefreshing) return new Promise(function(resolve, reject) {
                $0c6c769a0b0e21f2$var$failedQueue.push({
                    resolve: resolve,
                    reject: reject
                });
            }).then(()=>{
                return client(originalRequest);
            }).catch((err)=>{
                return Promise.reject(err);
            });
            $0c6c769a0b0e21f2$var$isRefreshing = true;
            originalRequest._retry = true;
            (0, $9b69f9955ab78e59$export$2e2bcd8739ae039).getAuthSession().then((authSession)=>{
                setJwtToken(authSession.tokens?.idToken?.toString() || "");
                $0c6c769a0b0e21f2$var$processQueue(null);
                return client(originalRequest);
            }, handleError).finally(()=>{
                $0c6c769a0b0e21f2$var$isRefreshing = false;
            });
        }
        // Refresh token missing or expired => logout user...
        if (error.response?.status === 401 && error.response.data.error === "Token is not valid or has expired") return handleError(error);
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
    return client;
}



const $5d8afbac14d682f8$var$BASE_URL = `invitations`;
const $5d8afbac14d682f8$var$getUrl = (admin)=>`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(admin)}/${$5d8afbac14d682f8$var$BASE_URL}`;
const $5d8afbac14d682f8$var$createLandlordInvitation = (admin, invitation)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post($5d8afbac14d682f8$var$getUrl(admin), invitation);
};
const $5d8afbac14d682f8$var$createTenantWithCatalogueInvitation = (invitation)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post($5d8afbac14d682f8$var$getUrl(false), invitation);
};
const $5d8afbac14d682f8$var$removeInvitation = (invitationId)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).delete(`${$5d8afbac14d682f8$var$getUrl(false)}/${invitationId}`);
};
const $5d8afbac14d682f8$var$getInvitationsByCustomerId = (admin, id, includeUsed = false)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$5d8afbac14d682f8$var$getUrl(admin)}`, {
        params: {
            customerId: id,
            includeUsed: includeUsed
        }
    }).then((response)=>response.data);
};
const $5d8afbac14d682f8$var$getInvitations = (admin, queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get($5d8afbac14d682f8$var$getUrl(admin), queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $5d8afbac14d682f8$var$getUserInvitations = ()=>(0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/user/invitations`).then((response)=>response.data);
const $5d8afbac14d682f8$var$InvitationsAPI = {
    createTenantWithCatalogueInvitation: $5d8afbac14d682f8$var$createTenantWithCatalogueInvitation,
    createLandlordInvitation: $5d8afbac14d682f8$var$createLandlordInvitation,
    removeInvitation: $5d8afbac14d682f8$var$removeInvitation,
    getInvitationsByCustomerId: $5d8afbac14d682f8$var$getInvitationsByCustomerId,
    getInvitations: $5d8afbac14d682f8$var$getInvitations,
    getUserInvitations: $5d8afbac14d682f8$var$getUserInvitations
};
var $5d8afbac14d682f8$export$2e2bcd8739ae039 = $5d8afbac14d682f8$var$InvitationsAPI;



var $592Nh = parcelRequire("592Nh");

var $592Nh = parcelRequire("592Nh");
var $ef7f032d6600fb73$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $ef7f032d6600fb73$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$ef7f032d6600fb73$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$ef7f032d6600fb73$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$ef7f032d6600fb73$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $ef7f032d6600fb73$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $ef7f032d6600fb73$var$DIGIT_REGEX = /^\d+$/, $ef7f032d6600fb73$var$LEAD_DIGIT_REGEX = /^\d/, $ef7f032d6600fb73$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $ef7f032d6600fb73$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $ef7f032d6600fb73$var$MAX_CACHE_SIZE = 512;
var $ef7f032d6600fb73$var$pathCache = new $ef7f032d6600fb73$var$Cache($ef7f032d6600fb73$var$MAX_CACHE_SIZE), $ef7f032d6600fb73$var$setCache = new $ef7f032d6600fb73$var$Cache($ef7f032d6600fb73$var$MAX_CACHE_SIZE), $ef7f032d6600fb73$var$getCache = new $ef7f032d6600fb73$var$Cache($ef7f032d6600fb73$var$MAX_CACHE_SIZE);
var $ef7f032d6600fb73$var$config;
$ef7f032d6600fb73$exports = {
    Cache: $ef7f032d6600fb73$var$Cache,
    split: $ef7f032d6600fb73$var$split,
    normalizePath: $ef7f032d6600fb73$var$normalizePath,
    setter: function(path) {
        var parts = $ef7f032d6600fb73$var$normalizePath(path);
        return $ef7f032d6600fb73$var$setCache.get(path) || $ef7f032d6600fb73$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $ef7f032d6600fb73$var$normalizePath(path);
        return $ef7f032d6600fb73$var$getCache.get(path) || $ef7f032d6600fb73$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($ef7f032d6600fb73$var$isQuoted(part) || $ef7f032d6600fb73$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $ef7f032d6600fb73$var$forEach(Array.isArray(path) ? path : $ef7f032d6600fb73$var$split(path), cb, thisArg);
    }
};
function $ef7f032d6600fb73$var$normalizePath(path) {
    return $ef7f032d6600fb73$var$pathCache.get(path) || $ef7f032d6600fb73$var$pathCache.set(path, $ef7f032d6600fb73$var$split(path).map(function(part) {
        return part.replace($ef7f032d6600fb73$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $ef7f032d6600fb73$var$split(path) {
    return path.match($ef7f032d6600fb73$var$SPLIT_REGEX) || [
        ""
    ];
}
function $ef7f032d6600fb73$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($ef7f032d6600fb73$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $ef7f032d6600fb73$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $ef7f032d6600fb73$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $ef7f032d6600fb73$var$hasLeadingNumber(part) {
    return part.match($ef7f032d6600fb73$var$LEAD_DIGIT_REGEX) && !part.match($ef7f032d6600fb73$var$DIGIT_REGEX);
}
function $ef7f032d6600fb73$var$hasSpecialChars(part) {
    return $ef7f032d6600fb73$var$SPEC_CHAR_REGEX.test(part);
}
function $ef7f032d6600fb73$var$shouldBeQuoted(part) {
    return !$ef7f032d6600fb73$var$isQuoted(part) && ($ef7f032d6600fb73$var$hasLeadingNumber(part) || $ef7f032d6600fb73$var$hasSpecialChars(part));
}


var $6dec5c6aac957a20$exports = {};
const $6dec5c6aac957a20$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $6dec5c6aac957a20$var$words = (str)=>str.match($6dec5c6aac957a20$var$reWords) || [];
const $6dec5c6aac957a20$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $6dec5c6aac957a20$var$join = (str, d)=>$6dec5c6aac957a20$var$words(str).join(d).toLowerCase();
const $6dec5c6aac957a20$var$camelCase = (str)=>$6dec5c6aac957a20$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $6dec5c6aac957a20$var$pascalCase = (str)=>$6dec5c6aac957a20$var$upperFirst($6dec5c6aac957a20$var$camelCase(str));
const $6dec5c6aac957a20$var$snakeCase = (str)=>$6dec5c6aac957a20$var$join(str, "_");
const $6dec5c6aac957a20$var$kebabCase = (str)=>$6dec5c6aac957a20$var$join(str, "-");
const $6dec5c6aac957a20$var$sentenceCase = (str)=>$6dec5c6aac957a20$var$upperFirst($6dec5c6aac957a20$var$join(str, " "));
const $6dec5c6aac957a20$var$titleCase = (str)=>$6dec5c6aac957a20$var$words(str).map($6dec5c6aac957a20$var$upperFirst).join(" ");
$6dec5c6aac957a20$exports = {
    words: $6dec5c6aac957a20$var$words,
    upperFirst: $6dec5c6aac957a20$var$upperFirst,
    camelCase: $6dec5c6aac957a20$var$camelCase,
    pascalCase: $6dec5c6aac957a20$var$pascalCase,
    snakeCase: $6dec5c6aac957a20$var$snakeCase,
    kebabCase: $6dec5c6aac957a20$var$kebabCase,
    sentenceCase: $6dec5c6aac957a20$var$sentenceCase,
    titleCase: $6dec5c6aac957a20$var$titleCase
};


var $3f37d9e86483661e$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $3f37d9e86483661e$exports = function(edges) {
    return $3f37d9e86483661e$var$toposort($3f37d9e86483661e$var$uniqueNodes(edges), edges);
};
$3f37d9e86483661e$exports.array = $3f37d9e86483661e$var$toposort;
function $3f37d9e86483661e$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $3f37d9e86483661e$var$makeOutgoingEdges(edges), nodesHash = $3f37d9e86483661e$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $3f37d9e86483661e$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $3f37d9e86483661e$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $3f37d9e86483661e$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $7a5dda49dca6ae9d$var$toString = Object.prototype.toString;
const $7a5dda49dca6ae9d$var$errorToString = Error.prototype.toString;
const $7a5dda49dca6ae9d$var$regExpToString = RegExp.prototype.toString;
const $7a5dda49dca6ae9d$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $7a5dda49dca6ae9d$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $7a5dda49dca6ae9d$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $7a5dda49dca6ae9d$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $7a5dda49dca6ae9d$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $7a5dda49dca6ae9d$var$symbolToString.call(val).replace($7a5dda49dca6ae9d$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $7a5dda49dca6ae9d$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $7a5dda49dca6ae9d$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $7a5dda49dca6ae9d$var$regExpToString.call(val);
    return null;
}
function $7a5dda49dca6ae9d$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $7a5dda49dca6ae9d$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $7a5dda49dca6ae9d$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $7a5dda49dca6ae9d$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $7a5dda49dca6ae9d$var$_Symbol$toStringTag;
let $7a5dda49dca6ae9d$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$7a5dda49dca6ae9d$var$_Symbol$toStringTag = Symbol.toStringTag;
class $7a5dda49dca6ae9d$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($7a5dda49dca6ae9d$var$strReg, (_, key)=>$7a5dda49dca6ae9d$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this[$7a5dda49dca6ae9d$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $7a5dda49dca6ae9d$var$toArray(errorOrErrors).forEach((err)=>{
            if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (!disableStack && Error.captureStackTrace) Error.captureStackTrace(this, $7a5dda49dca6ae9d$export$2191b9da168c6cf0);
    }
}
let $7a5dda49dca6ae9d$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$7a5dda49dca6ae9d$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$7a5dda49dca6ae9d$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$7a5dda49dca6ae9d$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $7a5dda49dca6ae9d$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $7a5dda49dca6ae9d$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $7a5dda49dca6ae9d$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $7a5dda49dca6ae9d$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $7a5dda49dca6ae9d$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $7a5dda49dca6ae9d$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $7a5dda49dca6ae9d$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$7a5dda49dca6ae9d$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$7a5dda49dca6ae9d$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $7a5dda49dca6ae9d$export$2191b9da168c6cf0.formatError($7a5dda49dca6ae9d$var$mixed.notType, params);
    }
};
var $7a5dda49dca6ae9d$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $7a5dda49dca6ae9d$var$mixed,
    string: $7a5dda49dca6ae9d$var$string,
    number: $7a5dda49dca6ae9d$var$number,
    date: $7a5dda49dca6ae9d$var$date,
    object: $7a5dda49dca6ae9d$var$object,
    array: $7a5dda49dca6ae9d$var$array,
    boolean: $7a5dda49dca6ae9d$var$boolean,
    tuple: $7a5dda49dca6ae9d$var$tuple
});
const $7a5dda49dca6ae9d$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $7a5dda49dca6ae9d$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $7a5dda49dca6ae9d$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$7a5dda49dca6ae9d$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $7a5dda49dca6ae9d$var$prefixes = {
    context: "$",
    value: "."
};
function $7a5dda49dca6ae9d$export$eff4d24c3ff7876e(key, options) {
    return new $7a5dda49dca6ae9d$var$Reference(key, options);
}
class $7a5dda49dca6ae9d$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $7a5dda49dca6ae9d$var$prefixes.context;
        this.isValue = this.key[0] === $7a5dda49dca6ae9d$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $7a5dda49dca6ae9d$var$prefixes.context : this.isValue ? $7a5dda49dca6ae9d$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $ef7f032d6600fb73$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$7a5dda49dca6ae9d$var$Reference.prototype.__isYupRef = true;
const $7a5dda49dca6ae9d$var$isAbsent = (value)=>value == null;
function $7a5dda49dca6ae9d$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $7a5dda49dca6ae9d$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            var _overrides$disableSta;
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $7a5dda49dca6ae9d$export$2191b9da168c6cf0($7a5dda49dca6ae9d$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, (_overrides$disableSta = overrides.disableStackTrace) != null ? _overrides$disableSta : disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $7a5dda49dca6ae9d$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $7a5dda49dca6ae9d$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $ef7f032d6600fb73$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $7a5dda49dca6ae9d$export$cfedb76369cc7782(obj, path, value, context) {
    return $7a5dda49dca6ae9d$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $7a5dda49dca6ae9d$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($7a5dda49dca6ae9d$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $7a5dda49dca6ae9d$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $7a5dda49dca6ae9d$var$clone(src, seen = new Map()) {
    if ($7a5dda49dca6ae9d$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $7a5dda49dca6ae9d$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $7a5dda49dca6ae9d$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($7a5dda49dca6ae9d$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $7a5dda49dca6ae9d$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $7a5dda49dca6ae9d$var$ReferenceSet();
        this._blacklist = new $7a5dda49dca6ae9d$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($7a5dda49dca6ae9d$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $7a5dda49dca6ae9d$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $7a5dda49dca6ae9d$var$isAbsent(result)) return result;
            let formattedValue = $7a5dda49dca6ae9d$export$5790025c6e6c2ba6(value);
            let formattedResult = $7a5dda49dca6ae9d$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${value ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $7a5dda49dca6ae9d$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $7a5dda49dca6ae9d$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($7a5dda49dca6ae9d$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $7a5dda49dca6ae9d$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $7a5dda49dca6ae9d$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $7a5dda49dca6ae9d$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $7a5dda49dca6ae9d$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $7a5dda49dca6ae9d$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $7a5dda49dca6ae9d$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $7a5dda49dca6ae9d$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $7a5dda49dca6ae9d$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $7a5dda49dca6ae9d$var$toArray(keys).map((key)=>new $7a5dda49dca6ae9d$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $7a5dda49dca6ae9d$var$Condition(deps, options) : $7a5dda49dca6ae9d$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $7a5dda49dca6ae9d$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $7a5dda49dca6ae9d$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $7a5dda49dca6ae9d$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $7a5dda49dca6ae9d$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $7a5dda49dca6ae9d$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$7a5dda49dca6ae9d$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$7a5dda49dca6ae9d$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $7a5dda49dca6ae9d$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$7a5dda49dca6ae9d$export$19342e026b58ebb7.prototype[alias] = $7a5dda49dca6ae9d$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$7a5dda49dca6ae9d$export$19342e026b58ebb7.prototype[alias] = $7a5dda49dca6ae9d$export$19342e026b58ebb7.prototype.notOneOf;
const $7a5dda49dca6ae9d$var$returnsTrue = ()=>true;
function $7a5dda49dca6ae9d$export$9b30b6294c1449a8(spec) {
    return new $7a5dda49dca6ae9d$export$1e88358c94ddec71(spec);
}
class $7a5dda49dca6ae9d$export$1e88358c94ddec71 extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $7a5dda49dca6ae9d$var$returnsTrue
        }, spec));
    }
}
$7a5dda49dca6ae9d$export$9b30b6294c1449a8.prototype = $7a5dda49dca6ae9d$export$1e88358c94ddec71.prototype;
function $7a5dda49dca6ae9d$export$87b259aa03e3d267() {
    return new $7a5dda49dca6ae9d$export$c7980688f11e1f49();
}
class $7a5dda49dca6ae9d$export$c7980688f11e1f49 extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $7a5dda49dca6ae9d$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $7a5dda49dca6ae9d$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $7a5dda49dca6ae9d$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $7a5dda49dca6ae9d$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$7a5dda49dca6ae9d$export$87b259aa03e3d267.prototype = $7a5dda49dca6ae9d$export$c7980688f11e1f49.prototype;
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $7a5dda49dca6ae9d$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $7a5dda49dca6ae9d$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $7a5dda49dca6ae9d$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $7a5dda49dca6ae9d$var$isTrimmed = (value)=>$7a5dda49dca6ae9d$var$isAbsent(value) || value === value.trim();
let $7a5dda49dca6ae9d$var$objStringTag = ({}).toString();
function $7a5dda49dca6ae9d$export$22b082955e083ec3() {
    return new $7a5dda49dca6ae9d$export$49bf8b2ede5138eb();
}
class $7a5dda49dca6ae9d$export$49bf8b2ede5138eb extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $7a5dda49dca6ae9d$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $7a5dda49dca6ae9d$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $7a5dda49dca6ae9d$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $7a5dda49dca6ae9d$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $7a5dda49dca6ae9d$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $7a5dda49dca6ae9d$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $7a5dda49dca6ae9d$var$string.email) {
        return this.matches($7a5dda49dca6ae9d$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $7a5dda49dca6ae9d$var$string.url) {
        return this.matches($7a5dda49dca6ae9d$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $7a5dda49dca6ae9d$var$string.uuid) {
        return this.matches($7a5dda49dca6ae9d$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $7a5dda49dca6ae9d$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $7a5dda49dca6ae9d$var$isTrimmed
        });
    }
    lowercase(message = $7a5dda49dca6ae9d$var$string.lowercase) {
        return this.transform((value)=>!$7a5dda49dca6ae9d$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$7a5dda49dca6ae9d$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $7a5dda49dca6ae9d$var$string.uppercase) {
        return this.transform((value)=>!$7a5dda49dca6ae9d$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$7a5dda49dca6ae9d$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$7a5dda49dca6ae9d$export$22b082955e083ec3.prototype = $7a5dda49dca6ae9d$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $7a5dda49dca6ae9d$var$isNaN$1 = (value)=>value != +value;
function $7a5dda49dca6ae9d$export$98e628dec113755e() {
    return new $7a5dda49dca6ae9d$export$f192ec5e9228ab19();
}
class $7a5dda49dca6ae9d$export$f192ec5e9228ab19 extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$7a5dda49dca6ae9d$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $7a5dda49dca6ae9d$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $7a5dda49dca6ae9d$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $7a5dda49dca6ae9d$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $7a5dda49dca6ae9d$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $7a5dda49dca6ae9d$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $7a5dda49dca6ae9d$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $7a5dda49dca6ae9d$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$7a5dda49dca6ae9d$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$7a5dda49dca6ae9d$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$7a5dda49dca6ae9d$export$98e628dec113755e.prototype = $7a5dda49dca6ae9d$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $7a5dda49dca6ae9d$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7a5dda49dca6ae9d$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
function $7a5dda49dca6ae9d$var$parseIsoDate(date) {
    const regexResult = $7a5dda49dca6ae9d$var$isoReg.exec(date);
    if (!regexResult) return Date.parse ? Date.parse(date) : Number.NaN;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    const struct = {
        year: $7a5dda49dca6ae9d$var$toNumber(regexResult[1]),
        month: $7a5dda49dca6ae9d$var$toNumber(regexResult[2], 1) - 1,
        day: $7a5dda49dca6ae9d$var$toNumber(regexResult[3], 1),
        hour: $7a5dda49dca6ae9d$var$toNumber(regexResult[4]),
        minute: $7a5dda49dca6ae9d$var$toNumber(regexResult[5]),
        second: $7a5dda49dca6ae9d$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $7a5dda49dca6ae9d$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $7a5dda49dca6ae9d$var$toNumber(regexResult[10]),
        minuteOffset: $7a5dda49dca6ae9d$var$toNumber(regexResult[11])
    };
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
let $7a5dda49dca6ae9d$var$invalidDate = new Date("");
let $7a5dda49dca6ae9d$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $7a5dda49dca6ae9d$export$324d90190a8b822a() {
    return new $7a5dda49dca6ae9d$export$18ec3cc5a157503f();
}
class $7a5dda49dca6ae9d$export$18ec3cc5a157503f extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $7a5dda49dca6ae9d$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $7a5dda49dca6ae9d$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $7a5dda49dca6ae9d$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$7a5dda49dca6ae9d$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $7a5dda49dca6ae9d$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $7a5dda49dca6ae9d$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$7a5dda49dca6ae9d$export$18ec3cc5a157503f.INVALID_DATE = $7a5dda49dca6ae9d$var$invalidDate;
$7a5dda49dca6ae9d$export$324d90190a8b822a.prototype = $7a5dda49dca6ae9d$export$18ec3cc5a157503f.prototype;
$7a5dda49dca6ae9d$export$324d90190a8b822a.INVALID_DATE = $7a5dda49dca6ae9d$var$invalidDate;
// @ts-expect-error
function $7a5dda49dca6ae9d$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $ef7f032d6600fb73$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($7a5dda49dca6ae9d$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($7a5dda49dca6ae9d$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3f37d9e86483661e$exports))).array(Array.from(nodes), edges).reverse();
}
function $7a5dda49dca6ae9d$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $7a5dda49dca6ae9d$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $7a5dda49dca6ae9d$var$findIndex(keys, a) - $7a5dda49dca6ae9d$var$findIndex(keys, b);
    };
}
const $7a5dda49dca6ae9d$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $7a5dda49dca6ae9d$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $7a5dda49dca6ae9d$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $7a5dda49dca6ae9d$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($7a5dda49dca6ae9d$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $7a5dda49dca6ae9d$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $ef7f032d6600fb73$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $ef7f032d6600fb73$exports.getter)((0, $ef7f032d6600fb73$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $7a5dda49dca6ae9d$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $7a5dda49dca6ae9d$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $7a5dda49dca6ae9d$var$defaultSort = $7a5dda49dca6ae9d$var$sortByKeyOrder([]);
function $7a5dda49dca6ae9d$export$be5493f9613cbbe(spec) {
    return new $7a5dda49dca6ae9d$export$18b4fc70ec7eccf8(spec);
}
class $7a5dda49dca6ae9d$export$18b4fc70ec7eccf8 extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $7a5dda49dca6ae9d$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $7a5dda49dca6ae9d$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $7a5dda49dca6ae9d$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$7a5dda49dca6ae9d$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $7a5dda49dca6ae9d$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $7a5dda49dca6ae9d$var$sortFields(shape, excludedEdges);
        next._sortErrors = $7a5dda49dca6ae9d$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $7a5dda49dca6ae9d$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $ef7f032d6600fb73$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($7a5dda49dca6ae9d$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($7a5dda49dca6ae9d$var$parseJson);
    }
    noUnknown(noAllow = true, message = $7a5dda49dca6ae9d$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $7a5dda49dca6ae9d$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $7a5dda49dca6ae9d$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $6dec5c6aac957a20$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $6dec5c6aac957a20$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $6dec5c6aac957a20$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$7a5dda49dca6ae9d$export$be5493f9613cbbe.prototype = $7a5dda49dca6ae9d$export$18b4fc70ec7eccf8.prototype;
function $7a5dda49dca6ae9d$export$2f23118c22fb2630(type) {
    return new $7a5dda49dca6ae9d$export$4347112b8447a7d(type);
}
class $7a5dda49dca6ae9d$export$4347112b8447a7d extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($7a5dda49dca6ae9d$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$7a5dda49dca6ae9d$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $7a5dda49dca6ae9d$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $7a5dda49dca6ae9d$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $7a5dda49dca6ae9d$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $7a5dda49dca6ae9d$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$7a5dda49dca6ae9d$export$2f23118c22fb2630.prototype = $7a5dda49dca6ae9d$export$4347112b8447a7d.prototype;
// @ts-ignore
function $7a5dda49dca6ae9d$export$65e3907585753458(schemas) {
    return new $7a5dda49dca6ae9d$export$411c3b3687e8ecc8(schemas);
}
class $7a5dda49dca6ae9d$export$411c3b3687e8ecc8 extends $7a5dda49dca6ae9d$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($7a5dda49dca6ae9d$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$7a5dda49dca6ae9d$export$65e3907585753458.prototype = $7a5dda49dca6ae9d$export$411c3b3687e8ecc8.prototype;
function $7a5dda49dca6ae9d$export$488013bae63b21da(builder) {
    return new $7a5dda49dca6ae9d$var$Lazy(builder);
}
class $7a5dda49dca6ae9d$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$7a5dda49dca6ae9d$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $7a5dda49dca6ae9d$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $7a5dda49dca6ae9d$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $7a5dda49dca6ae9d$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $7a5dda49dca6ae9d$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$7a5dda49dca6ae9d$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}




var $2hDQc = parcelRequire("2hDQc");

var $5pzCu = parcelRequire("5pzCu");

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $dc9b260cdf65d7b9$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $bfdb035652082a4b$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $dc9b260cdf65d7b9$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $9c7e9684713f453a$var$objectConstructor = {}.constructor;
function $9c7e9684713f453a$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $9c7e9684713f453a$var$objectConstructor;
}


function $50a54439c99f4764$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $50a54439c99f4764$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $50a54439c99f4764$var$ownKeys(Object(source), !0).forEach(function(key) {
            $50a54439c99f4764$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $50a54439c99f4764$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $50a54439c99f4764$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $50a54439c99f4764$var$_slicedToArray(arr, i) {
    return $50a54439c99f4764$var$_arrayWithHoles(arr) || $50a54439c99f4764$var$_iterableToArrayLimit(arr, i) || $50a54439c99f4764$var$_unsupportedIterableToArray(arr, i) || $50a54439c99f4764$var$_nonIterableRest();
}
function $50a54439c99f4764$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $50a54439c99f4764$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $50a54439c99f4764$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $50a54439c99f4764$var$_arrayLikeToArray(o, minLen);
}
function $50a54439c99f4764$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $50a54439c99f4764$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $50a54439c99f4764$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $50a54439c99f4764$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $50a54439c99f4764$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $50a54439c99f4764$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $9c7e9684713f453a$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $07e43220ced0d315$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $07e43220ced0d315$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $07e43220ced0d315$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $07e43220ced0d315$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $07e43220ced0d315$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $07e43220ced0d315$var$SLASHES = "\uFF0F/";
var $07e43220ced0d315$var$DOTS = "\uFF0E.";
var $07e43220ced0d315$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $07e43220ced0d315$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $07e43220ced0d315$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $07e43220ced0d315$export$7f01587e28f9194 = "".concat($07e43220ced0d315$var$DASHES).concat($07e43220ced0d315$var$SLASHES).concat($07e43220ced0d315$var$DOTS).concat($07e43220ced0d315$export$20542845033f576e).concat($07e43220ced0d315$var$BRACKETS).concat($07e43220ced0d315$var$TILDES);
var $07e43220ced0d315$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $5c137fdf8d9ced50$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5c137fdf8d9ced50$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5c137fdf8d9ced50$var$_typeof(obj);
}
function $5c137fdf8d9ced50$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5c137fdf8d9ced50$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5c137fdf8d9ced50$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5c137fdf8d9ced50$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5c137fdf8d9ced50$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5c137fdf8d9ced50$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5c137fdf8d9ced50$var$_setPrototypeOf(subClass, superClass);
}
function $5c137fdf8d9ced50$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5c137fdf8d9ced50$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5c137fdf8d9ced50$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5c137fdf8d9ced50$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5c137fdf8d9ced50$var$_possibleConstructorReturn(this, result);
    };
}
function $5c137fdf8d9ced50$var$_possibleConstructorReturn(self, call) {
    if (call && ($5c137fdf8d9ced50$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5c137fdf8d9ced50$var$_assertThisInitialized(self);
}
function $5c137fdf8d9ced50$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5c137fdf8d9ced50$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $5c137fdf8d9ced50$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$5c137fdf8d9ced50$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $5c137fdf8d9ced50$var$_construct(Class, arguments, $5c137fdf8d9ced50$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $5c137fdf8d9ced50$var$_setPrototypeOf(Wrapper, Class);
    };
    return $5c137fdf8d9ced50$var$_wrapNativeSuper(Class);
}
function $5c137fdf8d9ced50$var$_construct(Parent, args, Class) {
    if ($5c137fdf8d9ced50$var$_isNativeReflectConstruct()) $5c137fdf8d9ced50$var$_construct = Reflect.construct;
    else $5c137fdf8d9ced50$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $5c137fdf8d9ced50$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $5c137fdf8d9ced50$var$_construct.apply(null, arguments);
}
function $5c137fdf8d9ced50$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5c137fdf8d9ced50$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $5c137fdf8d9ced50$var$_setPrototypeOf(o, p) {
    $5c137fdf8d9ced50$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5c137fdf8d9ced50$var$_setPrototypeOf(o, p);
}
function $5c137fdf8d9ced50$var$_getPrototypeOf(o) {
    $5c137fdf8d9ced50$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5c137fdf8d9ced50$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $5c137fdf8d9ced50$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $5c137fdf8d9ced50$var$_inherits(ParseError, _Error);
    var _super = $5c137fdf8d9ced50$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $5c137fdf8d9ced50$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($5c137fdf8d9ced50$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $5c137fdf8d9ced50$var$_createClass(ParseError);
}(/*#__PURE__*/ $5c137fdf8d9ced50$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $731273a653884d60$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $c1e2b8fff127295e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c1e2b8fff127295e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c1e2b8fff127295e$var$_typeof(obj);
}
function $c1e2b8fff127295e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1e2b8fff127295e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c1e2b8fff127295e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1e2b8fff127295e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1e2b8fff127295e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $c1e2b8fff127295e$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $c1e2b8fff127295e$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $c1e2b8fff127295e$var$V4 = "1.7.35";
var $c1e2b8fff127295e$var$DEFAULT_EXT_PREFIX = " ext. ";
var $c1e2b8fff127295e$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $c1e2b8fff127295e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $c1e2b8fff127295e$var$_classCallCheck(this, Metadata);
        $c1e2b8fff127295e$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $c1e2b8fff127295e$var$setVersion.call(this, metadata);
    }
    $c1e2b8fff127295e$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $c1e2b8fff127295e$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $c1e2b8fff127295e$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $c1e2b8fff127295e$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $c1e2b8fff127295e$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $c1e2b8fff127295e$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $c1e2b8fff127295e$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $c1e2b8fff127295e$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $c1e2b8fff127295e$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $c1e2b8fff127295e$var$getType(this.types(), _type2)) return new $c1e2b8fff127295e$var$Type($c1e2b8fff127295e$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $c1e2b8fff127295e$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $c1e2b8fff127295e$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $c1e2b8fff127295e$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $c1e2b8fff127295e$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $c1e2b8fff127295e$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$c1e2b8fff127295e$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $c1e2b8fff127295e$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $c1e2b8fff127295e$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $c1e2b8fff127295e$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $c1e2b8fff127295e$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $c1e2b8fff127295e$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $c1e2b8fff127295e$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $9c7e9684713f453a$export$2e2bcd8739ae039)(metadata) || !(0, $9c7e9684713f453a$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $9c7e9684713f453a$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $c1e2b8fff127295e$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $c1e2b8fff127295e$var$typeOf = function typeOf(_) {
    return $c1e2b8fff127295e$var$_typeof(_);
};
function $c1e2b8fff127295e$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $c1e2b8fff127295e$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $c1e2b8fff127295e$var$DEFAULT_EXT_PREFIX;
}
function $c1e2b8fff127295e$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $c1e2b8fff127295e$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $c1e2b8fff127295e$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $c1e2b8fff127295e$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $731273a653884d60$export$2e2bcd8739ae039)(version, $c1e2b8fff127295e$var$V3) === -1) this.v2 = true;
        else if ((0, $731273a653884d60$export$2e2bcd8739ae039)(version, $c1e2b8fff127295e$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $370286b51ca69c15$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $370286b51ca69c15$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $07e43220ced0d315$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $370286b51ca69c15$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $370286b51ca69c15$var$RFC3966_EXTN_PREFIX + $370286b51ca69c15$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $370286b51ca69c15$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $370286b51ca69c15$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $370286b51ca69c15$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $370286b51ca69c15$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $370286b51ca69c15$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $b1b56224954773c6$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]{" + (0, $07e43220ced0d315$export$cd8355bcbe13154) + "}"; //
var $b1b56224954773c6$export$a77dd7471651eee = "[" + (0, $07e43220ced0d315$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $07e43220ced0d315$export$7f01587e28f9194) + "]*" + "[" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $07e43220ced0d315$export$7f01587e28f9194) + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $b1b56224954773c6$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $07e43220ced0d315$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $07e43220ced0d315$export$7f01587e28f9194) + "]*" + "[" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $b1b56224954773c6$export$a2d12a04749c087d = $b1b56224954773c6$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $370286b51ca69c15$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $b1b56224954773c6$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $b1b56224954773c6$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $b1b56224954773c6$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $b1b56224954773c6$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $07e43220ced0d315$export$cd8355bcbe13154) && $b1b56224954773c6$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $b1b56224954773c6$export$4c3f76c95c05197c(number) {
    return $b1b56224954773c6$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $e811b208f95423f4$var$EXTN_PATTERN = new RegExp("(?:" + (0, $370286b51ca69c15$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $e811b208f95423f4$export$2e2bcd8739ae039(number) {
    var start = number.search($e811b208f95423f4$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($e811b208f95423f4$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $07f6e0b38f8693c4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $07f6e0b38f8693c4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $07f6e0b38f8693c4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07f6e0b38f8693c4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07f6e0b38f8693c4$var$_arrayLikeToArray(o, minLen);
}
function $07f6e0b38f8693c4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07f6e0b38f8693c4$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $07f6e0b38f8693c4$export$1d16fddea1437169(character) {
    return $07f6e0b38f8693c4$export$2848f3d68c08fe69[character];
}
function $07f6e0b38f8693c4$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $07f6e0b38f8693c4$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $07f6e0b38f8693c4$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $f619772e76be4ac0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f619772e76be4ac0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f619772e76be4ac0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f619772e76be4ac0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f619772e76be4ac0$var$_arrayLikeToArray(o, minLen);
}
function $f619772e76be4ac0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f619772e76be4ac0$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $f619772e76be4ac0$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $f619772e76be4ac0$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $f619772e76be4ac0$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $07f6e0b38f8693c4$export$1d16fddea1437169)(character);
}




function $76afaae6f6de6504$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $76afaae6f6de6504$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76afaae6f6de6504$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $76afaae6f6de6504$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $76afaae6f6de6504$var$_arrayLikeToArray(o, minLen);
}
function $76afaae6f6de6504$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $76afaae6f6de6504$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $76afaae6f6de6504$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $3abec5db7defbd77$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $3abec5db7defbd77$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $3abec5db7defbd77$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $3abec5db7defbd77$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $76afaae6f6de6504$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $8566f2daa340c27b$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $8566f2daa340c27b$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $8566f2daa340c27b$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $3abec5db7defbd77$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $6e74369c4025b458$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $006699e7095a4155$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $006699e7095a4155$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $006699e7095a4155$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $006699e7095a4155$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $006699e7095a4155$var$_arrayLikeToArray(o, minLen);
}
function $006699e7095a4155$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $006699e7095a4155$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $006699e7095a4155$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($006699e7095a4155$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($006699e7095a4155$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $006699e7095a4155$var$_createForOfIteratorHelperLoose($006699e7095a4155$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($006699e7095a4155$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $006699e7095a4155$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $dd5a545c775d0661$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $006699e7095a4155$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $ab31d07f6ace6306$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $ab31d07f6ace6306$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $ab31d07f6ace6306$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $aa8176debcd1a83f$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $07e43220ced0d315$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $f14ee7663fbda08f$export$4f32ad1c51a7a6be = /(\$\d)/;
function $f14ee7663fbda08f$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($f14ee7663fbda08f$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $aa8176debcd1a83f$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $58f3967e415175c0$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $58f3967e415175c0$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($58f3967e415175c0$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $86bc4ca8872b52fe$var$_slicedToArray(arr, i) {
    return $86bc4ca8872b52fe$var$_arrayWithHoles(arr) || $86bc4ca8872b52fe$var$_iterableToArrayLimit(arr, i) || $86bc4ca8872b52fe$var$_unsupportedIterableToArray(arr, i) || $86bc4ca8872b52fe$var$_nonIterableRest();
}
function $86bc4ca8872b52fe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $86bc4ca8872b52fe$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $86bc4ca8872b52fe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $86bc4ca8872b52fe$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $86bc4ca8872b52fe$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $86bc4ca8872b52fe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $86bc4ca8872b52fe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $86bc4ca8872b52fe$var$_arrayLikeToArray(o, minLen);
}
function $86bc4ca8872b52fe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $86bc4ca8872b52fe$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $86bc4ca8872b52fe$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $86bc4ca8872b52fe$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $b1b56224954773c6$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $86bc4ca8872b52fe$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $7840aa9a253a6155$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7840aa9a253a6155$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7840aa9a253a6155$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7840aa9a253a6155$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7840aa9a253a6155$var$_arrayLikeToArray(o, minLen);
}
function $7840aa9a253a6155$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7840aa9a253a6155$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7840aa9a253a6155$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7840aa9a253a6155$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7840aa9a253a6155$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7840aa9a253a6155$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7840aa9a253a6155$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $7840aa9a253a6155$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $7840aa9a253a6155$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $7840aa9a253a6155$var$_objectSpread($7840aa9a253a6155$var$_objectSpread({}, $7840aa9a253a6155$var$DEFAULT_OPTIONS), options);
    else options = $7840aa9a253a6155$var$DEFAULT_OPTIONS;
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $7840aa9a253a6155$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $7840aa9a253a6155$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $7840aa9a253a6155$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $7840aa9a253a6155$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $86bc4ca8872b52fe$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $7840aa9a253a6155$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $7840aa9a253a6155$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $7840aa9a253a6155$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $7840aa9a253a6155$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $f14ee7663fbda08f$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $7840aa9a253a6155$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $7840aa9a253a6155$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $7840aa9a253a6155$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $7840aa9a253a6155$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $c1e2b8fff127295e$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $7840aa9a253a6155$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $58f3967e415175c0$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($7840aa9a253a6155$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $de87dd2c08950c20$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de87dd2c08950c20$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de87dd2c08950c20$var$ownKeys(Object(source), !0).forEach(function(key) {
            $de87dd2c08950c20$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de87dd2c08950c20$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de87dd2c08950c20$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de87dd2c08950c20$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $de87dd2c08950c20$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $de87dd2c08950c20$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $de87dd2c08950c20$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $de87dd2c08950c20$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $de87dd2c08950c20$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $de87dd2c08950c20$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $de87dd2c08950c20$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $de87dd2c08950c20$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $de87dd2c08950c20$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $ab31d07f6ace6306$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $8566f2daa340c27b$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $dd5a545c775d0661$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $006699e7095a4155$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $7840aa9a253a6155$export$2e2bcd8739ae039)(this, _format, options ? $de87dd2c08950c20$var$_objectSpread($de87dd2c08950c20$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $de87dd2c08950c20$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $de87dd2c08950c20$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($de87dd2c08950c20$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($de87dd2c08950c20$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $b99f58d5ff92c417$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "])");
function $b99f58d5ff92c417$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($b99f58d5ff92c417$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $f971835acc422f8c$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $27a94394e0b9e623$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $f971835acc422f8c$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$27a94394e0b9e623$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$27a94394e0b9e623$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $27a94394e0b9e623$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $27a94394e0b9e623$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $3abec5db7defbd77$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $6ed482d50035f48b$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $c1e2b8fff127295e$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $27a94394e0b9e623$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $27a94394e0b9e623$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $6e74369c4025b458$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $3abec5db7defbd77$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $808c6bd5821ac3df$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $b99f58d5ff92c417$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $6ed482d50035f48b$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $07e43220ced0d315$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $0cb3b17165b36aa9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0cb3b17165b36aa9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0cb3b17165b36aa9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0cb3b17165b36aa9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0cb3b17165b36aa9$var$_arrayLikeToArray(o, minLen);
}
function $0cb3b17165b36aa9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0cb3b17165b36aa9$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata);
    var matchingCountries = [];
    for(var _iterator = $0cb3b17165b36aa9$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $006699e7095a4155$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}


var $10885ee54925e59e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $10885ee54925e59e$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($10885ee54925e59e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $0cb3b17165b36aa9$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $7665de1d23e45b9b$export$1ddc7eed78155f68 = "+";
var $7665de1d23e45b9b$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $7665de1d23e45b9b$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]" + "|" + $7665de1d23e45b9b$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $7665de1d23e45b9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $7665de1d23e45b9b$export$1ddc7eed78155f68 + $7665de1d23e45b9b$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]" + $7665de1d23e45b9b$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $7665de1d23e45b9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($7665de1d23e45b9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $7665de1d23e45b9b$var$ALPHANUM_ = (0, $07e43220ced0d315$export$852d1d4a47329634);
var $7665de1d23e45b9b$var$RFC3966_DOMAINLABEL_ = "[" + $7665de1d23e45b9b$var$ALPHANUM_ + "]+((\\-)*[" + $7665de1d23e45b9b$var$ALPHANUM_ + "])*";
var $7665de1d23e45b9b$var$VALID_ALPHA_ = "a-zA-Z";
var $7665de1d23e45b9b$var$RFC3966_TOPLABEL_ = "[" + $7665de1d23e45b9b$var$VALID_ALPHA_ + "]+((\\-)*[" + $7665de1d23e45b9b$var$ALPHANUM_ + "])*";
var $7665de1d23e45b9b$var$RFC3966_DOMAINNAME_ = "^(" + $7665de1d23e45b9b$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $7665de1d23e45b9b$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $7665de1d23e45b9b$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($7665de1d23e45b9b$var$RFC3966_DOMAINNAME_, "g");
var $7665de1d23e45b9b$export$70d485ce3f6de783 = "tel:";
var $7665de1d23e45b9b$export$f6d5879d582c3a27 = ";phone-context=";
var $7665de1d23e45b9b$export$9e356e12edb00a81 = ";isub=";
function $7665de1d23e45b9b$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($7665de1d23e45b9b$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $7665de1d23e45b9b$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $7665de1d23e45b9b$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $7665de1d23e45b9b$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $7665de1d23e45b9b$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $d45714a97fecf369$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $7665de1d23e45b9b$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $7665de1d23e45b9b$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $7665de1d23e45b9b$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $7665de1d23e45b9b$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $7665de1d23e45b9b$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $7665de1d23e45b9b$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $7665de1d23e45b9b$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $fd3265244ad5c43a$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $fd3265244ad5c43a$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $07e43220ced0d315$export$207c99ccf3902df8) + (0, $07e43220ced0d315$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $fd3265244ad5c43a$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $07e43220ced0d315$export$852d1d4a47329634) + "#" + "]+$");
var $fd3265244ad5c43a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $fd3265244ad5c43a$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $c1e2b8fff127295e$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $fd3265244ad5c43a$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $fd3265244ad5c43a$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $07e43220ced0d315$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $07e43220ced0d315$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $de87dd2c08950c20$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $6e74369c4025b458$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $fd3265244ad5c43a$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $8566f2daa340c27b$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $fd3265244ad5c43a$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $fd3265244ad5c43a$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($fd3265244ad5c43a$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($fd3265244ad5c43a$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $fd3265244ad5c43a$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $d45714a97fecf369$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $fd3265244ad5c43a$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $b1b56224954773c6$export$2e2bcd8739ae039)(number)) {
        if ((0, $b1b56224954773c6$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $e811b208f95423f4$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $fd3265244ad5c43a$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $fd3265244ad5c43a$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $808c6bd5821ac3df$export$2e2bcd8739ae039)((0, $f619772e76be4ac0$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($fd3265244ad5c43a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $c1e2b8fff127295e$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $27a94394e0b9e623$export$2e2bcd8739ae039)((0, $f619772e76be4ac0$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $10885ee54925e59e$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $0f21e6b369670faf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0f21e6b369670faf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0f21e6b369670faf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0f21e6b369670faf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0f21e6b369670faf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0f21e6b369670faf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0f21e6b369670faf$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $fd3265244ad5c43a$export$2e2bcd8739ae039)(text, $0f21e6b369670faf$var$_objectSpread($0f21e6b369670faf$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $3c69ef02f97a6f27$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3c69ef02f97a6f27$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3c69ef02f97a6f27$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3c69ef02f97a6f27$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3c69ef02f97a6f27$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3c69ef02f97a6f27$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c69ef02f97a6f27$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $c1e2b8fff127295e$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $3c69ef02f97a6f27$var$_objectSpread($3c69ef02f97a6f27$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $0f21e6b369670faf$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $5c137fdf8d9ced50$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $fd7138e85b17cf44$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fd7138e85b17cf44$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fd7138e85b17cf44$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fd7138e85b17cf44$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fd7138e85b17cf44$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fd7138e85b17cf44$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fd7138e85b17cf44$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $50a54439c99f4764$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $fd7138e85b17cf44$var$_objectSpread($fd7138e85b17cf44$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $3c69ef02f97a6f27$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $d7636b381d8cdffc$export$992e2df24bec72ba() {
    return (0, $bfdb035652082a4b$export$2e2bcd8739ae039)((0, $fd7138e85b17cf44$export$2e2bcd8739ae039), arguments);
}


var $cc54526a7cedf1dd$export$32ea325d92ea6082;
(function(MoovyConstantNames) {
    MoovyConstantNames.APP_FULLNAME = "LUPAPALVELU";
    MoovyConstantNames.PHONE_FI_COUNTRY_CODE = "+358";
})($cc54526a7cedf1dd$export$32ea325d92ea6082 || ($cc54526a7cedf1dd$export$32ea325d92ea6082 = {}));
var $cc54526a7cedf1dd$export$4b65f495352b3bd3;
(function(MoovyConstantDOMIds) {
    MoovyConstantDOMIds.MOOVY_BACKDROP_ANIMATION = "moovy-backdrop-animation";
})($cc54526a7cedf1dd$export$4b65f495352b3bd3 || ($cc54526a7cedf1dd$export$4b65f495352b3bd3 = {}));


var $f218d410dbc4f9c0$exports = {};
"use strict";
Object.defineProperty($f218d410dbc4f9c0$exports, "__esModule", {
    value: true
});
$f218d410dbc4f9c0$exports.default = $f218d410dbc4f9c0$var$isEmail;

var $f218d410dbc4f9c0$var$_assertString = $f218d410dbc4f9c0$var$_interopRequireDefault((parcelRequire("gy0H7")));

var $f218d410dbc4f9c0$var$_isByteLength = $f218d410dbc4f9c0$var$_interopRequireDefault((parcelRequire("ii6fL")));

var $f218d410dbc4f9c0$var$_isFQDN = $f218d410dbc4f9c0$var$_interopRequireDefault((parcelRequire("bk0Dc")));

var $f218d410dbc4f9c0$var$_isIP = $f218d410dbc4f9c0$var$_interopRequireDefault((parcelRequire("jKz62")));

var $f218d410dbc4f9c0$var$_merge = $f218d410dbc4f9c0$var$_interopRequireDefault((parcelRequire("9Yb7c")));
function $f218d410dbc4f9c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f218d410dbc4f9c0$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: "",
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $f218d410dbc4f9c0$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $f218d410dbc4f9c0$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $f218d410dbc4f9c0$var$gmailUserPart = /^[a-z\d]+$/;
var $f218d410dbc4f9c0$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $f218d410dbc4f9c0$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $f218d410dbc4f9c0$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $f218d410dbc4f9c0$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $f218d410dbc4f9c0$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1"); // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
     // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
         // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $f218d410dbc4f9c0$var$isEmail(str, options) {
    (0, $f218d410dbc4f9c0$var$_assertString.default)(str);
    options = (0, $f218d410dbc4f9c0$var$_merge.default)(options, $f218d410dbc4f9c0$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($f218d410dbc4f9c0$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1]; // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, "").replace(/(^<|>$)/g, ""); // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(" ")) display_name = display_name.slice(0, -1);
            if (!$f218d410dbc4f9c0$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $f218d410dbc4f9c0$var$defaultMaxEmailLength) return false;
    var parts = str.split("@");
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join("@");
    if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase(); // Removing sub-address from username before gmail validation
        var username = user.split("+")[0]; // Dots are not included in gmail length restriction
        if (!(0, $f218d410dbc4f9c0$var$_isByteLength.default)(username.replace(/\./g, ""), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split(".");
        for(var i = 0; i < _user_parts.length; i++){
            if (!$f218d410dbc4f9c0$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $f218d410dbc4f9c0$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $f218d410dbc4f9c0$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $f218d410dbc4f9c0$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $f218d410dbc4f9c0$var$_isIP.default)(domain)) {
            if (!domain.startsWith("[") || !domain.endsWith("]")) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $f218d410dbc4f9c0$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $f218d410dbc4f9c0$var$quotedEmailUserUtf8.test(user) : $f218d410dbc4f9c0$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $f218d410dbc4f9c0$var$emailUserUtf8Part : $f218d410dbc4f9c0$var$emailUserPart;
    var user_parts = user.split(".");
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
    }
    return true;
}
$f218d410dbc4f9c0$exports = $f218d410dbc4f9c0$exports.default;
$f218d410dbc4f9c0$exports.default = $f218d410dbc4f9c0$exports.default;


var $066f7ec5b64309d3$export$85ea93c7f196b8c3;
(function(MoovyFormRestrictions) {
    MoovyFormRestrictions.INPUT_MAX_CHARS = 255;
})($066f7ec5b64309d3$export$85ea93c7f196b8c3 || ($066f7ec5b64309d3$export$85ea93c7f196b8c3 = {}));
const $066f7ec5b64309d3$export$dda1dcb0216445cd = (phoneNumber)=>{
    if (!phoneNumber?.trim() || phoneNumber === (0, $cc54526a7cedf1dd$export$32ea325d92ea6082).PHONE_FI_COUNTRY_CODE) return true;
    return (0, $d7636b381d8cdffc$export$992e2df24bec72ba)(phoneNumber);
};
const $066f7ec5b64309d3$export$dddb845077defee2 = (licensePlateNumber)=>{
    const pattern = /^[A-ZÅÄÖa-zåäö0-9\\s-]{2,10}$/;
    return !!licensePlateNumber && pattern.test(licensePlateNumber);
};
const $066f7ec5b64309d3$export$371e338370561054 = (email)=>{
    if (!email) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f218d410dbc4f9c0$exports)))(email, {
        allow_utf8_local_part: false
    });
};


const $d6fa861e91d42308$var$FormInvitation = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const getFormDefaultValues = ()=>{
        return {
            firstName: props.defaultValues?.firstName || "",
            lastName: props.defaultValues?.lastName || "",
            email: props.defaultValues?.email || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $2hDQc.useState)(getFormDefaultValues());
    (0, $2hDQc.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.firstName,
        props.defaultValues?.lastName,
        props.defaultValues?.email
    ]);
    const invitationSchema = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            firstName: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            lastName: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            email: $7a5dda49dca6ae9d$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return (0, $066f7ec5b64309d3$export$371e338370561054)(email);
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email } = values;
        props.onSubmit({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim()
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: invitationSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "firstName",
                                "data-testid": "firstName",
                                value: values.firstName,
                                autoFocus: true,
                                label: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.firstName"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.firstName"
                                }),
                                onChange: handleChange,
                                error: !!errors.firstName,
                                errorText: errors.firstName
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "lastName",
                                "data-testid": "lastName",
                                value: values.lastName,
                                label: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.lastName"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.lastName"
                                }),
                                onChange: handleChange,
                                error: !!errors.lastName,
                                errorText: errors.lastName
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "email",
                                "data-testid": "email",
                                value: values.email,
                                label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "common.text.email"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "common.text.email"
                                }),
                                onChange: handleChange,
                                error: !!errors.email,
                                errorText: errors.email
                            })
                        ]
                    })
                })
        })
    });
};
var $d6fa861e91d42308$export$2e2bcd8739ae039 = $d6fa861e91d42308$var$FormInvitation;




function $ee9cb80b5c23ac97$export$16bf6fe03653420f(value, message = "Reached unexpected case in exhaustive switch") {
    throw new Error(message);
}
const $ee9cb80b5c23ac97$export$8f98ff223296ded9 = (obj)=>{
    return obj && Object.keys(obj).some((key)=>obj[key] !== undefined);
};
const $ee9cb80b5c23ac97$export$b9d2d3b623c012b1 = (value, original)=>{
    if (!value) return undefined;
    if (!original) return value?.toString();
    if (typeof value === "number" && typeof original === "number") return value != original ? value.toString() : undefined;
    if (typeof value === "string" && typeof original === "string") return original.localeCompare(value.trim()) != 0 ? value : undefined;
    return undefined;
};
const $ee9cb80b5c23ac97$export$6d1c4f83343cbd5d = (avatarName)=>{
    if (!avatarName) return "";
    const spaceIndex = avatarName.lastIndexOf(" ");
    const secondIndex = spaceIndex === -1 ? avatarName.lastIndexOf("-") : spaceIndex;
    const firstChar = avatarName.substring(0, 1);
    const secondChar = avatarName.length > 1 ? avatarName.substring(secondIndex === -1 ? 1 : secondIndex + 1, secondIndex === -1 ? 2 : secondIndex + 2) : "";
    return `${firstChar}${secondChar}`.toUpperCase();
};
const $ee9cb80b5c23ac97$export$ec6ba75237411d31 = (jwtToken)=>{
    if (!jwtToken) return "";
    if (!jwtToken?.given_name && !jwtToken?.family_name) return jwtToken.name || "";
    else return jwtToken?.given_name ? `${jwtToken?.given_name} ${jwtToken?.family_name || ""}` : `${jwtToken?.family_name || ""}`;
};
const $ee9cb80b5c23ac97$export$ff20516246215bf = (first, second, separator = " ")=>{
    if (first) return second ? `${first}${separator}${second}` : first;
    else return second ? second : "";
};
const $ee9cb80b5c23ac97$export$ec9646ddc27ee461 = (totalCount, count, showTotal)=>{
    const slashPlusTotal = showTotal ? ` / ${totalCount} ` : " ";
    return `${count}${slashPlusTotal}${totalCount > 0 ? `(${Math.round(count / totalCount * 100)} %)` : "(0 %)"}`;
};
const $ee9cb80b5c23ac97$export$b34d9e7bbdff763e = (phoneNumber)=>{
    if (!phoneNumber?.trim()) return undefined;
    const trimmed = phoneNumber.trim();
    return trimmed !== (0, $cc54526a7cedf1dd$export$32ea325d92ea6082).PHONE_FI_COUNTRY_CODE ? trimmed : undefined;
};




class $cd88019720f33fe3$export$b9721ef022f71a68 extends Error {
}
$cd88019720f33fe3$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $cd88019720f33fe3$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $cd88019720f33fe3$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $cd88019720f33fe3$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $cd88019720f33fe3$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $cd88019720f33fe3$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $cd88019720f33fe3$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $cd88019720f33fe3$var$base64UrlDecode(part);
    } catch (e) {
        throw new $cd88019720f33fe3$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $cd88019720f33fe3$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


const $c753d58728ea6715$export$f023ae853add2e3e = (userPermissions, action, resource)=>{
    const userPermission = userPermissions.find((item)=>item.resource === resource);
    return userPermission?.action?.includes(action) || false;
};
const $c753d58728ea6715$var$getPermission = (actions, resource)=>{
    if (actions.includes("ALL")) return {
        action: [
            "READ",
            "CREATE",
            "EDIT",
            "DELETE"
        ],
        resource: resource
    };
    else return {
        action: actions,
        resource: resource
    };
};
const $c753d58728ea6715$var$getUserGroups = (userGroups)=>{
    const mapToUserGroups = (backendGroups)=>{
        return backendGroups.reduce((mappedGroups, group)=>{
            if ([
                "ADMIN",
                "SALE",
                "LANDLORD"
            ].includes(group)) mappedGroups.push(group);
            return mappedGroups;
        }, []);
    };
    const stringGroups = userGroups ? userGroups.split(",").map((item)=>item.toLocaleUpperCase()) : [];
    return mapToUserGroups(stringGroups);
};
const $c753d58728ea6715$export$fc970ed23da99565 = (userGroups)=>{
    const moovyUserGroups = $c753d58728ea6715$var$getUserGroups(userGroups);
    return moovyUserGroups.includes("ADMIN");
};
const $c753d58728ea6715$export$2571671736faa60a = (customerType)=>{
    return customerType === "T";
};
const $c753d58728ea6715$export$bd8b61dab9d38dea = (customerType, userGroups)=>{
    const moovyUserGroups = $c753d58728ea6715$var$getUserGroups(userGroups);
    // User belongs to admin user group
    if (moovyUserGroups.includes("ADMIN")) return [
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "ADMIN_PLACES"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "LANDLORD_INVITATIONS"),
        $c753d58728ea6715$var$getPermission([
            "READ"
        ], "ADMIN_INVITATIONS"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT"
        ], "TENANT_INVITATIONS"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "PLACES"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "RIGHT_HOLDERS"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "CUSTOMER"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "RIGHTS"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "CATALOGUES"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "OFFERING"),
        $c753d58728ea6715$var$getPermission([
            "READ"
        ], "USERS")
    ];
    else if (customerType === "L") return [
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "PLACES"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "RIGHT_HOLDERS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "ADMIN_INVITATIONS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "TENANT_INVITATIONS"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT"
        ], "CUSTOMER"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "RIGHTS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "CATALOGUES"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "OFFERING"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "CREATE",
            "EDIT",
            "DELETE"
        ], "USERS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "CATALOGUE_REPORTS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "RIGHT_REPORTS")
    ];
    // These are the default permissions for all other logged users like Tenant customer
    return [
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "RIGHT_HOLDERS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "ADMIN_INVITATIONS"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "EDIT"
        ], "CUSTOMER"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "RIGHTS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "CATALOGUES"),
        $c753d58728ea6715$var$getPermission([
            "READ",
            "CREATE",
            "EDIT",
            "DELETE"
        ], "USERS"),
        $c753d58728ea6715$var$getPermission([
            "ALL"
        ], "RIGHT_REPORTS")
    ];
};
const $c753d58728ea6715$export$61147a57d3c24ac8 = {
    ROOT: "/",
    LOGIN_STEPS: "/login-steps",
    INVITATIONS: "/invitations",
    RIGHT_HOLDERS: "/right-holders",
    PLACES: "/places",
    CUSTOMERS: "/customers",
    REPORTS: "/reports",
    USERS: "/users",
    OFFERINGS: "/offerings",
    CATALOGUES: "/catalogues",
    RIGHTS: "/rights"
};
const $c753d58728ea6715$export$25c4819f1669a599 = {
    SUB_PLACES: "/sub-places"
};
const $c753d58728ea6715$var$Permissions = {
    appRoutes: $c753d58728ea6715$export$61147a57d3c24ac8,
    isAllowed: $c753d58728ea6715$export$f023ae853add2e3e,
    getUserPermission: $c753d58728ea6715$export$bd8b61dab9d38dea
};
var $c753d58728ea6715$export$2e2bcd8739ae039 = $c753d58728ea6715$var$Permissions;






var $57utv = parcelRequire("57utv");
function $e152927a1ca3166e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e152927a1ca3166e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e152927a1ca3166e$export$2e2bcd8739ae039(o);
}



function $11946555d28d5067$export$2e2bcd8739ae039(input, hint) {
    if ((0, $e152927a1ca3166e$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $e152927a1ca3166e$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $9af465c973eb12a4$export$2e2bcd8739ae039(arg) {
    var key = (0, $11946555d28d5067$export$2e2bcd8739ae039)(arg, "string");
    return (0, $e152927a1ca3166e$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $7c5543a70f9e6272$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $9af465c973eb12a4$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $0124094b7a4c629c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0124094b7a4c629c$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0124094b7a4c629c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7c5543a70f9e6272$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0124094b7a4c629c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f57e9dc67fd3979f$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $f57e9dc67fd3979f$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f57e9dc67fd3979f$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $f57e9dc67fd3979f$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f57e9dc67fd3979f$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f57e9dc67fd3979f$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f57e9dc67fd3979f$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f57e9dc67fd3979f$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f57e9dc67fd3979f$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f57e9dc67fd3979f$var$isDate(val)) return "date";
    if ($f57e9dc67fd3979f$var$isError(val)) return "error";
    var constructorName = $f57e9dc67fd3979f$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f57e9dc67fd3979f$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f57e9dc67fd3979f$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f57e9dc67fd3979f$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f57e9dc67fd3979f$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f57e9dc67fd3979f$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(1));
        return enhancer($f57e9dc67fd3979f$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f57e9dc67fd3979f$var$isPlainObject(action)) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f57e9dc67fd3979f$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f57e9dc67fd3979f$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f57e9dc67fd3979f$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f57e9dc67fd3979f$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f57e9dc67fd3979f$export$8928921ea2d3b126 = $f57e9dc67fd3979f$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f57e9dc67fd3979f$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f57e9dc67fd3979f$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f57e9dc67fd3979f$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f57e9dc67fd3979f$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $f57e9dc67fd3979f$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f57e9dc67fd3979f$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $f57e9dc67fd3979f$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f57e9dc67fd3979f$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f57e9dc67fd3979f$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f57e9dc67fd3979f$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f57e9dc67fd3979f$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f57e9dc67fd3979f$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f57e9dc67fd3979f$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f57e9dc67fd3979f$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f57e9dc67fd3979f$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f57e9dc67fd3979f$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f57e9dc67fd3979f$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f57e9dc67fd3979f$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f57e9dc67fd3979f$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $0124094b7a4c629c$export$2e2bcd8739ae039)((0, $0124094b7a4c629c$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $14e3cef4dea3154c$var$NOT_FOUND = "NOT_FOUND";
function $14e3cef4dea3154c$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $14e3cef4dea3154c$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $14e3cef4dea3154c$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $14e3cef4dea3154c$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $14e3cef4dea3154c$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $14e3cef4dea3154c$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $14e3cef4dea3154c$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $14e3cef4dea3154c$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $14e3cef4dea3154c$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $14e3cef4dea3154c$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $14e3cef4dea3154c$var$createSingletonCache(comparator) : $14e3cef4dea3154c$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $14e3cef4dea3154c$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $025f9f9d97dabd31$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $025f9f9d97dabd31$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $025f9f9d97dabd31$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $025f9f9d97dabd31$export$595d22ed68ca2841 = /* #__PURE__ */ $025f9f9d97dabd31$export$5943f4447f6ef248((0, $14e3cef4dea3154c$export$281bff7f05488aa2));
var $025f9f9d97dabd31$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $025f9f9d97dabd31$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $740334a8efba208f$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $740334a8efba208f$var$thunk = $740334a8efba208f$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$740334a8efba208f$var$thunk.withExtraArgument = $740334a8efba208f$var$createThunkMiddleware;
var $740334a8efba208f$export$2e2bcd8739ae039 = $740334a8efba208f$var$thunk;



var $54X9E = parcelRequire("54X9E");
var $b6d40e24321310a3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b6d40e24321310a3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b6d40e24321310a3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $b6d40e24321310a3$var$__defProp = Object.defineProperty;
var $b6d40e24321310a3$var$__defProps = Object.defineProperties;
var $b6d40e24321310a3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b6d40e24321310a3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b6d40e24321310a3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b6d40e24321310a3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b6d40e24321310a3$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b6d40e24321310a3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b6d40e24321310a3$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b6d40e24321310a3$var$__hasOwnProp.call(b, prop)) $b6d40e24321310a3$var$__defNormalProp(a, prop, b[prop]);
    if ($b6d40e24321310a3$var$__getOwnPropSymbols) for(var _i = 0, _c = $b6d40e24321310a3$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($b6d40e24321310a3$var$__propIsEnum.call(b, prop)) $b6d40e24321310a3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b6d40e24321310a3$var$__spreadProps = function(a, b) {
    return $b6d40e24321310a3$var$__defProps(a, $b6d40e24321310a3$var$__getOwnPropDescs(b));
};
var $b6d40e24321310a3$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $b6d40e24321310a3$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $025f9f9d97dabd31$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $b6d40e24321310a3$var$__spreadArray([
            (0, $57utv.isDraft)(value) ? (0, $57utv.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $b6d40e24321310a3$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $f57e9dc67fd3979f$export$f672e0b6f7222cd7;
    return (0, $f57e9dc67fd3979f$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $b6d40e24321310a3$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $b6d40e24321310a3$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $b6d40e24321310a3$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $b6d40e24321310a3$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $b6d40e24321310a3$var$__spreadValues($b6d40e24321310a3$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $b6d40e24321310a3$export$b956e38827fca970(action) {
    return $b6d40e24321310a3$export$53b83ca8eaab0383(action) && "type" in action;
}
function $b6d40e24321310a3$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $b6d40e24321310a3$var$hasMatchFunction(action);
}
function $b6d40e24321310a3$export$ebd532f9034651f3(action) {
    return $b6d40e24321310a3$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($b6d40e24321310a3$var$isValidKey);
}
function $b6d40e24321310a3$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $b6d40e24321310a3$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $b6d40e24321310a3$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $b6d40e24321310a3$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $b6d40e24321310a3$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $b6d40e24321310a3$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $b6d40e24321310a3$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $b6d40e24321310a3$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $b6d40e24321310a3$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $b6d40e24321310a3$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $b6d40e24321310a3$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $b6d40e24321310a3$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $b6d40e24321310a3$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $b6d40e24321310a3$var$freezeDraftable(val) {
    return (0, $57utv.isDraftable)(val) ? (0, $57utv.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $b6d40e24321310a3$var$isProduction = true;
var $b6d40e24321310a3$var$prefix = "Invariant failed";
function $b6d40e24321310a3$var$invariant(condition, message) {
    if (condition) return;
    if ($b6d40e24321310a3$var$isProduction) throw new Error($b6d40e24321310a3$var$prefix);
    throw new Error($b6d40e24321310a3$var$prefix + ": " + (message || ""));
}
function $b6d40e24321310a3$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $b6d40e24321310a3$var$getSerialize(serializer, decycler), indent);
}
function $b6d40e24321310a3$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $b6d40e24321310a3$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $b6d40e24321310a3$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $b6d40e24321310a3$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $b6d40e24321310a3$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $b6d40e24321310a3$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $b6d40e24321310a3$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $b6d40e24321310a3$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $b6d40e24321310a3$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $b6d40e24321310a3$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $b6d40e24321310a3$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $b6d40e24321310a3$export$53b83ca8eaab0383(val);
}
function $b6d40e24321310a3$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $b6d40e24321310a3$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $b6d40e24321310a3$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $b6d40e24321310a3$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $b6d40e24321310a3$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$b6d40e24321310a3$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $b6d40e24321310a3$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $b6d40e24321310a3$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $b6d40e24321310a3$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $b6d40e24321310a3$export$36c1185aeee5b0a6(options);
    };
}
function $b6d40e24321310a3$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $b6d40e24321310a3$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($b6d40e24321310a3$var$isBoolean(thunk)) middlewareArray.push((0, $740334a8efba208f$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $740334a8efba208f$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $b6d40e24321310a3$var$IS_PRODUCTION = true;
function $b6d40e24321310a3$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $b6d40e24321310a3$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($b6d40e24321310a3$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $f57e9dc67fd3979f$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$b6d40e24321310a3$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$b6d40e24321310a3$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $f57e9dc67fd3979f$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $f57e9dc67fd3979f$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $b6d40e24321310a3$var$composeWithDevTools($b6d40e24321310a3$var$__spreadValues({
        trace: !$b6d40e24321310a3$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $b6d40e24321310a3$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $b6d40e24321310a3$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $f57e9dc67fd3979f$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $b6d40e24321310a3$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $b6d40e24321310a3$var$isStateFunction(x) {
    return typeof x === "function";
}
var $b6d40e24321310a3$var$hasWarnedAboutObjectNotation = false;
function $b6d40e24321310a3$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $b6d40e24321310a3$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($b6d40e24321310a3$var$isStateFunction(initialState)) getInitialState = function() {
        return $b6d40e24321310a3$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $b6d40e24321310a3$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $b6d40e24321310a3$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $57utv.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $57utv.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $57utv.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $b6d40e24321310a3$var$hasWarnedAboutObjectNotation2 = false;
function $b6d40e24321310a3$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $b6d40e24321310a3$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $54X9E;
    var initialState = typeof options.initialState == "function" ? options.initialState : $b6d40e24321310a3$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $b6d40e24321310a3$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $b6d40e24321310a3$export$309c7a02b0b0bc62(type, prepareCallback) : $b6d40e24321310a3$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $b6d40e24321310a3$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $b6d40e24321310a3$var$__spreadValues($b6d40e24321310a3$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $b6d40e24321310a3$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $b6d40e24321310a3$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $b6d40e24321310a3$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($b6d40e24321310a3$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $b6d40e24321310a3$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $b6d40e24321310a3$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $b6d40e24321310a3$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $b6d40e24321310a3$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $b6d40e24321310a3$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $b6d40e24321310a3$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $b6d40e24321310a3$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $b6d40e24321310a3$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $b6d40e24321310a3$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $b6d40e24321310a3$var$createSingleArgumentStateOperator(mutator) {
    var operator = $b6d40e24321310a3$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $b6d40e24321310a3$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $b6d40e24321310a3$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $57utv.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $57utv.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $b6d40e24321310a3$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $b6d40e24321310a3$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $b6d40e24321310a3$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $b6d40e24321310a3$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $b6d40e24321310a3$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $b6d40e24321310a3$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $b6d40e24321310a3$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $b6d40e24321310a3$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $b6d40e24321310a3$var$__spreadValues($b6d40e24321310a3$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $b6d40e24321310a3$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $b6d40e24321310a3$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $b6d40e24321310a3$var$createStateOperator(addOneMutably),
        addMany: $b6d40e24321310a3$var$createStateOperator(addManyMutably),
        setOne: $b6d40e24321310a3$var$createStateOperator(setOneMutably),
        setMany: $b6d40e24321310a3$var$createStateOperator(setManyMutably),
        setAll: $b6d40e24321310a3$var$createStateOperator(setAllMutably),
        updateOne: $b6d40e24321310a3$var$createStateOperator(updateOneMutably),
        updateMany: $b6d40e24321310a3$var$createStateOperator(updateManyMutably),
        upsertOne: $b6d40e24321310a3$var$createStateOperator(upsertOneMutably),
        upsertMany: $b6d40e24321310a3$var$createStateOperator(upsertManyMutably),
        removeOne: $b6d40e24321310a3$var$createStateOperator(removeOneMutably),
        removeMany: $b6d40e24321310a3$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $b6d40e24321310a3$var$createSortedStateAdapter(selectId, sort) {
    var _c = $b6d40e24321310a3$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($b6d40e24321310a3$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $b6d40e24321310a3$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $b6d40e24321310a3$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $b6d40e24321310a3$var$createStateOperator(addOneMutably),
        updateOne: $b6d40e24321310a3$var$createStateOperator(updateOneMutably),
        upsertOne: $b6d40e24321310a3$var$createStateOperator(upsertOneMutably),
        setOne: $b6d40e24321310a3$var$createStateOperator(setOneMutably),
        setMany: $b6d40e24321310a3$var$createStateOperator(setManyMutably),
        setAll: $b6d40e24321310a3$var$createStateOperator(setAllMutably),
        addMany: $b6d40e24321310a3$var$createStateOperator(addManyMutably),
        updateMany: $b6d40e24321310a3$var$createStateOperator(updateManyMutably),
        upsertMany: $b6d40e24321310a3$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $b6d40e24321310a3$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $b6d40e24321310a3$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $b6d40e24321310a3$var$createInitialStateFactory();
    var selectorsFactory = $b6d40e24321310a3$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $b6d40e24321310a3$var$createSortedStateAdapter(selectId, sortComparer) : $b6d40e24321310a3$var$createUnsortedStateAdapter(selectId);
    return $b6d40e24321310a3$var$__spreadValues($b6d40e24321310a3$var$__spreadValues($b6d40e24321310a3$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $b6d40e24321310a3$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $b6d40e24321310a3$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $b6d40e24321310a3$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $b6d40e24321310a3$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $b6d40e24321310a3$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $b6d40e24321310a3$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $b6d40e24321310a3$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $b6d40e24321310a3$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $b6d40e24321310a3$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $b6d40e24321310a3$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $b6d40e24321310a3$var$__spreadProps($b6d40e24321310a3$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $b6d40e24321310a3$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $b6d40e24321310a3$var$__spreadProps($b6d40e24321310a3$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $b6d40e24321310a3$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $b6d40e24321310a3$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $b6d40e24321310a3$var$__spreadProps($b6d40e24321310a3$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $b6d40e24321310a3$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $b6d40e24321310a3$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $b6d40e24321310a3$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$b6d40e24321310a3$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $b6d40e24321310a3$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $b6d40e24321310a3$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $b6d40e24321310a3$var$RejectWithValue) throw result;
                                                if (result instanceof $b6d40e24321310a3$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $b6d40e24321310a3$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($b6d40e24321310a3$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $b6d40e24321310a3$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $b6d40e24321310a3$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $b6d40e24321310a3$var$matches = function(matcher, action) {
    if ($b6d40e24321310a3$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $b6d40e24321310a3$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $b6d40e24321310a3$var$matches(matcher, action);
        });
    };
}
function $b6d40e24321310a3$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $b6d40e24321310a3$var$matches(matcher, action);
        });
    };
}
function $b6d40e24321310a3$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $b6d40e24321310a3$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $b6d40e24321310a3$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $b6d40e24321310a3$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$b6d40e24321310a3$var$isAsyncThunkArray(asyncThunks)) return $b6d40e24321310a3$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $b6d40e24321310a3$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $b6d40e24321310a3$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $b6d40e24321310a3$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$b6d40e24321310a3$var$isAsyncThunkArray(asyncThunks)) return $b6d40e24321310a3$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $b6d40e24321310a3$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $b6d40e24321310a3$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $b6d40e24321310a3$export$9dd1fb32974da385($b6d40e24321310a3$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$b6d40e24321310a3$var$isAsyncThunkArray(asyncThunks)) return $b6d40e24321310a3$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $b6d40e24321310a3$export$9dd1fb32974da385($b6d40e24321310a3$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $b6d40e24321310a3$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $b6d40e24321310a3$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$b6d40e24321310a3$var$isAsyncThunkArray(asyncThunks)) return $b6d40e24321310a3$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $b6d40e24321310a3$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $b6d40e24321310a3$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $b6d40e24321310a3$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$b6d40e24321310a3$var$isAsyncThunkArray(asyncThunks)) return $b6d40e24321310a3$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $b6d40e24321310a3$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $b6d40e24321310a3$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $b6d40e24321310a3$var$noop = function() {};
var $b6d40e24321310a3$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $b6d40e24321310a3$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $b6d40e24321310a3$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $b6d40e24321310a3$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $b6d40e24321310a3$var$task = "task";
var $b6d40e24321310a3$var$listener = "listener";
var $b6d40e24321310a3$var$completed = "completed";
var $b6d40e24321310a3$var$cancelled = "cancelled";
var $b6d40e24321310a3$var$taskCancelled = "task-" + $b6d40e24321310a3$var$cancelled;
var $b6d40e24321310a3$var$taskCompleted = "task-" + $b6d40e24321310a3$var$completed;
var $b6d40e24321310a3$var$listenerCancelled = $b6d40e24321310a3$var$listener + "-" + $b6d40e24321310a3$var$cancelled;
var $b6d40e24321310a3$var$listenerCompleted = $b6d40e24321310a3$var$listener + "-" + $b6d40e24321310a3$var$completed;
var $b6d40e24321310a3$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $b6d40e24321310a3$var$task + " " + $b6d40e24321310a3$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $b6d40e24321310a3$var$validateActive = function(signal) {
    if (signal.aborted) throw new $b6d40e24321310a3$export$cb1bdac908fed7f(signal.reason);
};
function $b6d40e24321310a3$var$raceWithSignal(signal, promise2) {
    var cleanup = $b6d40e24321310a3$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $b6d40e24321310a3$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $b6d40e24321310a3$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $b6d40e24321310a3$var$noop;
    });
}
var $b6d40e24321310a3$var$runTask = function(task2, cleanUp) {
    return $b6d40e24321310a3$var$__async(void 0, null, function() {
        var value, error_1;
        return $b6d40e24321310a3$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $b6d40e24321310a3$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $b6d40e24321310a3$var$createPause = function(signal) {
    return function(promise2) {
        return $b6d40e24321310a3$var$catchRejection($b6d40e24321310a3$var$raceWithSignal(signal, promise2).then(function(output) {
            $b6d40e24321310a3$var$validateActive(signal);
            return output;
        }));
    };
};
var $b6d40e24321310a3$var$createDelay = function(signal) {
    var pause = $b6d40e24321310a3$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $b6d40e24321310a3$var$assign = Object.assign;
var $b6d40e24321310a3$var$INTERNAL_NIL_TOKEN = {};
var $b6d40e24321310a3$var$alm = "listenerMiddleware";
var $b6d40e24321310a3$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $b6d40e24321310a3$var$addAbortSignalListener(parentAbortSignal, function() {
            return $b6d40e24321310a3$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $b6d40e24321310a3$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $b6d40e24321310a3$var$runTask(function() {
            return $b6d40e24321310a3$var$__async(void 0, null, function() {
                var result2;
                return $b6d40e24321310a3$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $b6d40e24321310a3$var$validateActive(parentAbortSignal);
                            $b6d40e24321310a3$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $b6d40e24321310a3$var$createPause(childAbortController.signal),
                                    delay: $b6d40e24321310a3$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $b6d40e24321310a3$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $b6d40e24321310a3$var$abortControllerWithReason(childAbortController, $b6d40e24321310a3$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $b6d40e24321310a3$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $b6d40e24321310a3$var$abortControllerWithReason(childAbortController, $b6d40e24321310a3$var$taskCancelled);
            }
        };
    };
};
var $b6d40e24321310a3$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $b6d40e24321310a3$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $b6d40e24321310a3$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $b6d40e24321310a3$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $b6d40e24321310a3$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $b6d40e24321310a3$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $b6d40e24321310a3$var$catchRejection(take(predicate, timeout));
    };
};
var $b6d40e24321310a3$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $b6d40e24321310a3$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $b6d40e24321310a3$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $b6d40e24321310a3$var$createListenerEntry = function(options) {
    var _c = $b6d40e24321310a3$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $b6d40e24321310a3$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $b6d40e24321310a3$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $b6d40e24321310a3$var$abortControllerWithReason(controller, $b6d40e24321310a3$var$listenerCancelled);
    });
};
var $b6d40e24321310a3$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($b6d40e24321310a3$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $b6d40e24321310a3$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $b6d40e24321310a3$export$f03a6b845d3fb58b = $b6d40e24321310a3$export$309c7a02b0b0bc62($b6d40e24321310a3$var$alm + "/add");
var $b6d40e24321310a3$export$b1b8022855fb2b71 = $b6d40e24321310a3$export$309c7a02b0b0bc62($b6d40e24321310a3$var$alm + "/removeAll");
var $b6d40e24321310a3$export$b03e9483f936dccb = $b6d40e24321310a3$export$309c7a02b0b0bc62($b6d40e24321310a3$var$alm + "/remove");
var $b6d40e24321310a3$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $b6d40e24321310a3$var$__spreadArray([
        $b6d40e24321310a3$var$alm + "/error"
    ], args));
};
function $b6d40e24321310a3$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $b6d40e24321310a3$var$defaultErrorHandler : _c;
    $b6d40e24321310a3$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $b6d40e24321310a3$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $b6d40e24321310a3$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $b6d40e24321310a3$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $b6d40e24321310a3$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $b6d40e24321310a3$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $b6d40e24321310a3$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $b6d40e24321310a3$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $b6d40e24321310a3$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $b6d40e24321310a3$var$createDelay(internalTaskController.signal),
                                pause: $b6d40e24321310a3$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $b6d40e24321310a3$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $b6d40e24321310a3$var$abortControllerWithReason(controller, $b6d40e24321310a3$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $b6d40e24321310a3$export$cb1bdac908fed7f)) $b6d40e24321310a3$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $b6d40e24321310a3$var$abortControllerWithReason(internalTaskController, $b6d40e24321310a3$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $b6d40e24321310a3$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$b6d40e24321310a3$export$b956e38827fca970(action)) return next(action);
                if ($b6d40e24321310a3$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($b6d40e24321310a3$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($b6d40e24321310a3$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $b6d40e24321310a3$var$INTERNAL_NIL_TOKEN) throw new Error($b6d40e24321310a3$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $b6d40e24321310a3$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $b6d40e24321310a3$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $b6d40e24321310a3$export$8fb31c0f05df007b = "RTK_autoBatch";
var $b6d40e24321310a3$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$b6d40e24321310a3$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $b6d40e24321310a3$var$promise;
var $b6d40e24321310a3$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($b6d40e24321310a3$var$promise || ($b6d40e24321310a3$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $b6d40e24321310a3$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $b6d40e24321310a3$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $b6d40e24321310a3$var$createQueueWithTimer(10);
var $b6d40e24321310a3$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $b6d40e24321310a3$var$queueMicrotaskShim : options.type === "raf" ? $b6d40e24321310a3$var$rAF : options.type === "callback" ? options.queueNotification : $b6d40e24321310a3$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$b6d40e24321310a3$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $57utv.enableES5)();


const $7d14d2e2868bd10d$var$stateKey = "moovyAuth";
const $7d14d2e2868bd10d$var$initialState = {
    token: sessionStorage.getItem((0, $086351014303c4b8$export$cb43794bb023e720)) || "",
    roles: [],
    userGroups: undefined,
    customerType: sessionStorage.getItem((0, $086351014303c4b8$export$85978fd627e990d0)) || ""
};
const $7d14d2e2868bd10d$var$slice = (0, $b6d40e24321310a3$export$4d8d9bd83c24ae8b)({
    name: $7d14d2e2868bd10d$var$stateKey,
    initialState: $7d14d2e2868bd10d$var$initialState,
    reducers: {
        setAuthentication (state, action) {
            sessionStorage.setItem((0, $086351014303c4b8$export$cb43794bb023e720), action.payload.token);
            state.token = action.payload.token;
            state.userGroups = action.payload.userGroups || "";
        },
        setToken (state, action) {
            const token = action.payload;
            sessionStorage.setItem((0, $086351014303c4b8$export$cb43794bb023e720), token);
            state.token = token;
        },
        setCustomerType (state, action) {
            const customerType = action.payload;
            sessionStorage.setItem((0, $086351014303c4b8$export$85978fd627e990d0), customerType);
            state.customerType = customerType;
        }
    }
});
var $7d14d2e2868bd10d$export$2e2bcd8739ae039 = $7d14d2e2868bd10d$var$slice.reducer;
const { setAuthentication: $7d14d2e2868bd10d$export$f10e7701d84a9c6, setToken: $7d14d2e2868bd10d$export$57e714f81a2c3d86, setCustomerType: $7d14d2e2868bd10d$export$246c2e82063be8d6 } = $7d14d2e2868bd10d$var$slice.actions;
const $7d14d2e2868bd10d$export$4cea0d77065449b7 = (payload)=>{
    return $7d14d2e2868bd10d$export$f10e7701d84a9c6(payload);
};
const $7d14d2e2868bd10d$export$518555436e9546c = (payload)=>{
    return $7d14d2e2868bd10d$export$57e714f81a2c3d86(payload);
};
const $7d14d2e2868bd10d$export$3160f67d8720ec42 = (payload)=>{
    return $7d14d2e2868bd10d$export$246c2e82063be8d6(payload);
};
const $7d14d2e2868bd10d$export$196bba85bc5ca29e = {
    getShortUsername: (state)=>{
        const decodedToken = state[$7d14d2e2868bd10d$var$stateKey]?.token && (0, $cd88019720f33fe3$export$fa1e2fb699b7861e)(state[$7d14d2e2868bd10d$var$stateKey]?.token);
        return (0, $ee9cb80b5c23ac97$export$6d1c4f83343cbd5d)((0, $ee9cb80b5c23ac97$export$ec6ba75237411d31)(decodedToken));
    },
    getToken: (state)=>state[$7d14d2e2868bd10d$var$stateKey]?.token,
    getCustomerType: (state)=>state[$7d14d2e2868bd10d$var$stateKey]?.customerType,
    getUserGroups: (state)=>state[$7d14d2e2868bd10d$var$stateKey]?.userGroups,
    getRoles: (state)=>state[$7d14d2e2868bd10d$var$stateKey]?.roles,
    isAuthenticated: (state)=>{
        return !!state[$7d14d2e2868bd10d$var$stateKey]?.token;
    }
};


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $6vtlW = parcelRequire("6vtlW");
var $c811d2f6a1db2d2b$exports = {};
"use strict";

$c811d2f6a1db2d2b$exports = (parcelRequire("33A3K"));





// Default to a dummy "batch" implementation that just runs the callback
function $6031a242a44aa366$var$defaultNoopBatch(callback) {
    callback();
}
let $6031a242a44aa366$var$batch = $6031a242a44aa366$var$defaultNoopBatch; // Allow injecting another batching function later
const $6031a242a44aa366$export$4b9874722d0da7bc = (newBatch)=>$6031a242a44aa366$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $6031a242a44aa366$export$fc47d4c0ba3bd2c6 = ()=>$6031a242a44aa366$var$batch;



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
const $d0f0e0cf5265ada5$var$ContextKey = Symbol.for(`react-redux-context`);
const $d0f0e0cf5265ada5$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d0f0e0cf5265ada5$var$getContext() {
    var _gT$ContextKey;
    if (!$2hDQc.createContext) return {};
    const contextMap = (_gT$ContextKey = $d0f0e0cf5265ada5$var$gT[$d0f0e0cf5265ada5$var$ContextKey]) != null ? _gT$ContextKey : $d0f0e0cf5265ada5$var$gT[$d0f0e0cf5265ada5$var$ContextKey] = new Map();
    let realContext = contextMap.get($2hDQc.createContext);
    if (!realContext) {
        realContext = $2hDQc.createContext(null);
        contextMap.set($2hDQc.createContext, realContext);
    }
    return realContext;
}
const $d0f0e0cf5265ada5$export$cc80c08dc91f1c00 = /*#__PURE__*/ $d0f0e0cf5265ada5$var$getContext();
var $d0f0e0cf5265ada5$export$2e2bcd8739ae039 = $d0f0e0cf5265ada5$export$cc80c08dc91f1c00;


function $7335c0f0e8080b5a$export$d4d6226d5fc61558(context = (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $2hDQc.useContext)(context);
        return contextValue;
    };
}
const $7335c0f0e8080b5a$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $7335c0f0e8080b5a$export$d4d6226d5fc61558();



const $21a1a8f9f4dc133d$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $704baa9769160210$var$useSyncExternalStoreWithSelector = (0, $21a1a8f9f4dc133d$export$20656a4825650bd0);
const $704baa9769160210$export$e2e6e3f3f3b782e3 = (fn)=>{
    $704baa9769160210$var$useSyncExternalStoreWithSelector = fn;
};
const $704baa9769160210$var$refEquality = (a, b)=>a === b;
function $704baa9769160210$export$2b53f90d2bd1cbfb(context = (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00) ? (0, $7335c0f0e8080b5a$export$c1275ca9a6fd3ec5) : (0, $7335c0f0e8080b5a$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $704baa9769160210$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $2hDQc.useRef)(true);
        const wrappedSelector = (0, $2hDQc.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $704baa9769160210$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $2hDQc.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $704baa9769160210$export$2105062e25df4afe = /*#__PURE__*/ $704baa9769160210$export$2b53f90d2bd1cbfb();



var $J0KCN = parcelRequire("J0KCN");
function $96c25b492bfa3184$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $8FL51 = parcelRequire("8FL51");

var $2hDQc = parcelRequire("2hDQc");
var $b8783e7fc2a861c5$exports = {};
"use strict";

$b8783e7fc2a861c5$exports = (parcelRequire("5fK8z"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $fc3cf8c12f402449$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $c5ef559fe1f0f617$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $fc3cf8c12f402449$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $c5ef559fe1f0f617$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c5ef559fe1f0f617$var$verify(mapStateToProps, "mapStateToProps");
    $c5ef559fe1f0f617$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c5ef559fe1f0f617$var$verify(mergeProps, "mergeProps");
}


const $0d08ad4486fffd14$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $0d08ad4486fffd14$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $0d08ad4486fffd14$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $96c25b492bfa3184$export$2e2bcd8739ae039)(_ref, $0d08ad4486fffd14$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $0d08ad4486fffd14$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $03ac62eed28c9d69$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $9dc281abb1902055$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $75219ed22ae310fd$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $9dc281abb1902055$export$2e2bcd8739ae039)(value)) (0, $fc3cf8c12f402449$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $3495cad03d576f3e$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $3495cad03d576f3e$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $3495cad03d576f3e$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $3495cad03d576f3e$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $3495cad03d576f3e$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $eeae33abb9356d4f$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $e3be463865bfc859$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $3495cad03d576f3e$export$710f7c60f68acd3e)((dispatch)=>(0, $03ac62eed28c9d69$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $3495cad03d576f3e$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $3495cad03d576f3e$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $eeae33abb9356d4f$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $a4452b191da3e4d3$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $3495cad03d576f3e$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $3495cad03d576f3e$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $eeae33abb9356d4f$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}



var $J0KCN = parcelRequire("J0KCN");


function $65b9051646e81051$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $J0KCN.default)({}, ownProps, stateProps, dispatchProps);
}
function $65b9051646e81051$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $65b9051646e81051$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$65b9051646e81051$export$691c327fc30bc857 : typeof mergeProps === "function" ? $65b9051646e81051$export$5b105939c84b5234(mergeProps) : (0, $eeae33abb9356d4f$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $7574e28bcd306cd8$var$createListenerCollection() {
    const batch = (0, $6031a242a44aa366$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $7574e28bcd306cd8$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $7574e28bcd306cd8$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $7574e28bcd306cd8$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $7574e28bcd306cd8$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $7574e28bcd306cd8$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $2hDQc = parcelRequire("2hDQc");
const $7c33f5f5b7a2a677$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $7c33f5f5b7a2a677$export$700979bc83e7db82 = $7c33f5f5b7a2a677$export$71594e8a50f746f4 ? $2hDQc.useLayoutEffect : $2hDQc.useEffect;


function $862218c1756340d5$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $862218c1756340d5$export$2e2bcd8739ae039(objA, objB) {
    if ($862218c1756340d5$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$862218c1756340d5$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $ceb3092ab486a733$var$_excluded = [
    "reactReduxForwardedRef"
];
let $ceb3092ab486a733$var$useSyncExternalStore = (0, $21a1a8f9f4dc133d$export$20656a4825650bd0);
const $ceb3092ab486a733$export$36d45daa6a4925b8 = (fn)=>{
    $ceb3092ab486a733$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $ceb3092ab486a733$var$EMPTY_ARRAY = [
    null,
    0
];
const $ceb3092ab486a733$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $ceb3092ab486a733$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $ceb3092ab486a733$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7c33f5f5b7a2a677$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $ceb3092ab486a733$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $ceb3092ab486a733$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $ceb3092ab486a733$var$initStateUpdates = ()=>$ceb3092ab486a733$var$EMPTY_ARRAY;
function $ceb3092ab486a733$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $ceb3092ab486a733$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $ceb3092ab486a733$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $ceb3092ab486a733$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $862218c1756340d5$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $862218c1756340d5$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $862218c1756340d5$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $a4452b191da3e4d3$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $e3be463865bfc859$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $65b9051646e81051$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $2hDQc.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $96c25b492bfa3184$export$2e2bcd8739ae039)(props, $ceb3092ab486a733$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $2hDQc.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $b8783e7fc2a861c5$exports.isContextConsumer)(/*#__PURE__*/ $2hDQc.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $2hDQc.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $2hDQc.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $0d08ad4486fffd14$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $2hDQc.useMemo(()=>{
                if (!shouldHandleStateChanges) return $ceb3092ab486a733$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $7574e28bcd306cd8$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $2hDQc.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $J0KCN.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $2hDQc.useRef();
            const lastWrapperProps = $2hDQc.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $2hDQc.useRef();
            const renderIsScheduled = $2hDQc.useRef(false);
            const isProcessingDispatch = $2hDQc.useRef(false);
            const isMounted = $2hDQc.useRef(false);
            const latestSubscriptionCallbackError = $2hDQc.useRef();
            (0, $7c33f5f5b7a2a677$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $2hDQc.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $2hDQc.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $ceb3092ab486a733$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $ceb3092ab486a733$var$useIsomorphicLayoutEffectWithArgs($ceb3092ab486a733$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $ceb3092ab486a733$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $7c33f5f5b7a2a677$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $2hDQc.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $2hDQc.createElement(WrappedComponent, (0, $J0KCN.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $2hDQc.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $2hDQc.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $2hDQc.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $2hDQc.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $2hDQc.createElement(Connect, (0, $J0KCN.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $ceb3092ab486a733$export$2e2bcd8739ae039 = $ceb3092ab486a733$var$connect;



var $2hDQc = parcelRequire("2hDQc");



function $131666d86e3b9233$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $2hDQc.useMemo(()=>{
        const subscription = (0, $7574e28bcd306cd8$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $2hDQc.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $7c33f5f5b7a2a677$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $2hDQc.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $131666d86e3b9233$export$2e2bcd8739ae039 = $131666d86e3b9233$var$Provider;







function $89d0382d061ef1fd$export$671dba69185d0304(context = (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00) ? (0, $7335c0f0e8080b5a$export$c1275ca9a6fd3ec5) : (0, $7335c0f0e8080b5a$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $89d0382d061ef1fd$export$6ccbb43953eebf8 = /*#__PURE__*/ $89d0382d061ef1fd$export$671dba69185d0304();


function $ca980beea4c3b32c$export$bc9b55530897c558(context = (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $d0f0e0cf5265ada5$export$cc80c08dc91f1c00) ? (0, $89d0382d061ef1fd$export$6ccbb43953eebf8) : (0, $89d0382d061ef1fd$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $ca980beea4c3b32c$export$8ad76b76a4c905f8 = /*#__PURE__*/ $ca980beea4c3b32c$export$bc9b55530897c558();









(0, $704baa9769160210$export$e2e6e3f3f3b782e3)((0, $c811d2f6a1db2d2b$exports.useSyncExternalStoreWithSelector));
(0, $ceb3092ab486a733$export$36d45daa6a4925b8)((0, $6vtlW.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $6031a242a44aa366$export$4b9874722d0da7bc)((0, $b36a61f25d8b4314$exports.unstable_batchedUpdates));


function $be143ece6599869a$export$2e2bcd8739ae039() {
    const dispatch = (0, $ca980beea4c3b32c$export$8ad76b76a4c905f8)();
    const setAuthentication = (value)=>dispatch((0, $7d14d2e2868bd10d$export$4cea0d77065449b7)(value));
    const setToken = (value)=>dispatch((0, $7d14d2e2868bd10d$export$518555436e9546c)(value));
    const setCustomerType = (value)=>dispatch((0, $7d14d2e2868bd10d$export$3160f67d8720ec42)(value));
    const customerType = (0, $704baa9769160210$export$2105062e25df4afe)((0, $7d14d2e2868bd10d$export$196bba85bc5ca29e).getCustomerType);
    const tenant = (0, $c753d58728ea6715$export$2571671736faa60a)(customerType);
    const isAuthenticated = (0, $704baa9769160210$export$2105062e25df4afe)((0, $7d14d2e2868bd10d$export$196bba85bc5ca29e).isAuthenticated);
    const roles = (0, $704baa9769160210$export$2105062e25df4afe)((0, $7d14d2e2868bd10d$export$196bba85bc5ca29e).getRoles);
    const userGroups = (0, $704baa9769160210$export$2105062e25df4afe)((0, $7d14d2e2868bd10d$export$196bba85bc5ca29e).getUserGroups);
    const admin = (0, $c753d58728ea6715$export$fc970ed23da99565)(userGroups);
    const token = (0, $704baa9769160210$export$2105062e25df4afe)((0, $7d14d2e2868bd10d$export$196bba85bc5ca29e).getToken);
    const decodedToken = token ? (0, $cd88019720f33fe3$export$fa1e2fb699b7861e)(token) : null;
    const usernameShort = (0, $704baa9769160210$export$2105062e25df4afe)((0, $7d14d2e2868bd10d$export$196bba85bc5ca29e).getShortUsername);
    const isPermission = (action, resource)=>{
        const userPermissions = (0, $c753d58728ea6715$export$bd8b61dab9d38dea)(customerType, userGroups);
        return userPermissions.length > 0 && (0, $c753d58728ea6715$export$f023ae853add2e3e)(userPermissions, action, resource);
    };
    return {
        setAuthentication: setAuthentication,
        setToken: setToken,
        setCustomerType: setCustomerType,
        isAuthenticated: isAuthenticated,
        customerType: customerType,
        roles: roles,
        token: token,
        decodedToken: decodedToken,
        isPermission: isPermission,
        userGroups: userGroups,
        tenant: tenant,
        admin: admin,
        usernameShort: usernameShort
    };
}



const $bf59313fc47a1b56$var$ModalAddInvitation = ({ open: open, addingInvitationParams: addingInvitationParams, onSubmit: onSubmit, onCancel: onCancel })=>{
    const FORM_REFERENCE = "formAddInvitation";
    const { admin: admin } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const createLandlordInvitationMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).createLandlordInvitation(admin, dto),
        onSuccess: (response)=>{
            const invitation = response.data || {};
            onSubmit(invitation);
        }
    });
    const createTenantInvitationMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).createTenantWithCatalogueInvitation(dto),
        onSuccess: (response)=>{
            const invitation = response.data || {};
            onSubmit(invitation);
        }
    });
    const createInvitation = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email } = values;
        const name = (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(firstName, lastName);
        const { invitationType: invitationType, landlordId: landlordId, tenantId: tenantId, catalogueId: catalogueId } = addingInvitationParams;
        switch(invitationType){
            case "TENANT":
                if (landlordId && tenantId && catalogueId) {
                    const dtoTenant = {
                        type: "TENANT_WITH_CATALOGUE",
                        name: name,
                        email: email,
                        landlordId: landlordId,
                        tenantId: tenantId,
                        catalogueId: catalogueId
                    };
                    createTenantInvitationMutation.mutate(dtoTenant);
                }
                break;
            case "LANDLORD":
                const dtoLandlord = {
                    name: name,
                    email: email
                };
                createLandlordInvitationMutation.mutate(dtoLandlord);
                break;
            case "ADMIN":
                if (landlordId) {
                    const dtoAdmin = {
                        type: "LANDLORD",
                        name: name,
                        email: email,
                        landlordId: landlordId
                    };
                    createLandlordInvitationMutation.mutate(dtoAdmin);
                }
                break;
            default:
                (0, $ee9cb80b5c23ac97$export$16bf6fe03653420f)(invitationType);
        }
    };
    const cancel = ()=>{
        createLandlordInvitationMutation.reset();
        createTenantInvitationMutation.reset();
        onCancel();
    };
    const TitleText = ()=>{
        const { invitationType: invitationType } = addingInvitationParams;
        switch(invitationType){
            case "TENANT":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.invitations.modalAddInvitation.tenant.title"
                });
            case "LANDLORD":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.invitations.modalAddInvitation.landlord.title"
                });
            case "ADMIN":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.invitations.modalAddInvitation.tenant.title"
                });
            default:
                return "";
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)(TitleText, {}),
            submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "common.buttons.add"
            }),
            children: [
                /*#__PURE__*/ (0, $592Nh.jsxs)("div", {
                    style: {
                        marginBottom: createLandlordInvitationMutation?.error || createTenantInvitationMutation?.error ? "1rem" : undefined
                    },
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                            mutation: createLandlordInvitationMutation,
                            errorTitleKey: "common.actions.add.error"
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                            mutation: createTenantInvitationMutation,
                            errorTitleKey: "common.actions.add.error"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $d6fa861e91d42308$export$2e2bcd8739ae039), {
                    onSubmit: (values)=>createInvitation(values),
                    formReference: FORM_REFERENCE
                })
            ]
        })
    });
};
var $bf59313fc47a1b56$export$2e2bcd8739ae039 = $bf59313fc47a1b56$var$ModalAddInvitation;



var $2hDQc = parcelRequire("2hDQc");

var $fLRFO = parcelRequire("fLRFO");
"use client";
const $3b24cfd775fb7d30$var$c = (e)=>"number" == typeof e && !isNaN(e), $3b24cfd775fb7d30$var$d = (e)=>"string" == typeof e, $3b24cfd775fb7d30$var$u = (e)=>"function" == typeof e, $3b24cfd775fb7d30$var$p = (e)=>$3b24cfd775fb7d30$var$d(e) || $3b24cfd775fb7d30$var$u(e) ? e : null, $3b24cfd775fb7d30$var$m = (e)=>(0, $2hDQc.isValidElement)(e) || $3b24cfd775fb7d30$var$d(e) || $3b24cfd775fb7d30$var$u(e) || $3b24cfd775fb7d30$var$c(e);
function $3b24cfd775fb7d30$export$184cca501f1aed7f(e, t, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = e;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(t, n);
        });
    });
}
function $3b24cfd775fb7d30$export$3ff7dc44d332d222(t) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = t;
    return function(t) {
        let { children: d, position: u, preventExitTransition: p, done: m, nodeRef: g, isIn: y, playToast: v } = t;
        const h = i ? `${a}--${u}` : a, T = i ? `${r}--${u}` : r, E = (0, $2hDQc.useRef)(0);
        return (0, $2hDQc.useLayoutEffect)(()=>{
            const e = g.current, t = h.split(" "), n = (o)=>{
                o.target === g.current && (v(), e.removeEventListener("animationend", n), e.removeEventListener("animationcancel", n), 0 === E.current && "animationcancel" !== o.type && e.classList.remove(...t));
            };
            e.classList.add(...t), e.addEventListener("animationend", n), e.addEventListener("animationcancel", n);
        }, []), (0, $2hDQc.useEffect)(()=>{
            const e = g.current, t = ()=>{
                e.removeEventListener("animationend", t), l ? $3b24cfd775fb7d30$export$184cca501f1aed7f(e, m, c) : m();
            };
            y || (p ? t() : (E.current = 1, e.className += ` ${T}`, e.addEventListener("animationend", t)));
        }, [
            y
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, d);
    };
}
function $3b24cfd775fb7d30$var$y(e, t) {
    return null != e ? {
        content: e.content,
        containerId: e.props.containerId,
        id: e.props.toastId,
        theme: e.props.theme,
        type: e.props.type,
        data: e.props.data || {},
        isLoading: e.props.isLoading,
        icon: e.props.icon,
        status: t
    } : {};
}
const $3b24cfd775fb7d30$var$v = new Map;
let $3b24cfd775fb7d30$var$h = [];
const $3b24cfd775fb7d30$var$T = new Set, $3b24cfd775fb7d30$var$E = (e)=>$3b24cfd775fb7d30$var$T.forEach((t)=>t(e)), $3b24cfd775fb7d30$var$b = ()=>$3b24cfd775fb7d30$var$v.size > 0;
function $3b24cfd775fb7d30$var$I(e, t) {
    var n;
    if (t) return !(null == (n = $3b24cfd775fb7d30$var$v.get(t)) || !n.isToastActive(e));
    let o = !1;
    return $3b24cfd775fb7d30$var$v.forEach((t)=>{
        t.isToastActive(e) && (o = !0);
    }), o;
}
function $3b24cfd775fb7d30$var$_(e, t) {
    $3b24cfd775fb7d30$var$m(e) && ($3b24cfd775fb7d30$var$b() || $3b24cfd775fb7d30$var$h.push({
        content: e,
        options: t
    }), $3b24cfd775fb7d30$var$v.forEach((n)=>{
        n.buildToast(e, t);
    }));
}
function $3b24cfd775fb7d30$var$C(e, t) {
    $3b24cfd775fb7d30$var$v.forEach((n)=>{
        null != t && null != t && t.containerId ? (null == t ? void 0 : t.containerId) === n.id && n.toggle(e, null == t ? void 0 : t.id) : n.toggle(e, null == t ? void 0 : t.id);
    });
}
function $3b24cfd775fb7d30$export$b262e13ca2dd2381(e) {
    const { subscribe: o, getSnapshot: s, setProps: i } = (0, $2hDQc.useRef)(function(e) {
        const n = e.containerId || 1;
        return {
            subscribe (o) {
                const s = function(e, n, o) {
                    let s = 1, r = 0, i = [], l = [], f = [], g = n;
                    const v = new Map, h = new Set, T = ()=>{
                        f = Array.from(v.values()), h.forEach((e)=>e());
                    }, E = (e)=>{
                        l = null == e ? [] : l.filter((t)=>t !== e), T();
                    }, b = (e)=>{
                        const { toastId: n, onOpen: s, updateId: a, children: r } = e.props, i = null == a;
                        e.staleId && v.delete(e.staleId), v.set(n, e), l = [
                            ...l,
                            e.props.toastId
                        ].filter((t)=>t !== e.staleId), T(), o($3b24cfd775fb7d30$var$y(e, i ? "added" : "updated")), i && $3b24cfd775fb7d30$var$u(s) && s((0, $2hDQc.isValidElement)(r) && r.props);
                    };
                    return {
                        id: e,
                        props: g,
                        observe: (e)=>(h.add(e), ()=>h.delete(e)),
                        toggle: (e, t)=>{
                            v.forEach((n)=>{
                                null != t && t !== n.props.toastId || $3b24cfd775fb7d30$var$u(n.toggle) && n.toggle(e);
                            });
                        },
                        removeToast: E,
                        toasts: v,
                        clearQueue: ()=>{
                            r -= i.length, i = [];
                        },
                        buildToast: (n, l)=>{
                            if (((t)=>{
                                let { containerId: n, toastId: o, updateId: s } = t;
                                const a = n ? n !== e : 1 !== e, r = v.has(o) && null == s;
                                return a || r;
                            })(l)) return;
                            const { toastId: f, updateId: h, data: I, staleId: _, delay: C } = l, L = ()=>{
                                E(f);
                            }, N = null == h;
                            N && r++;
                            const $ = {
                                ...g,
                                style: g.toastStyle,
                                key: s++,
                                ...Object.fromEntries(Object.entries(l).filter((e)=>{
                                    let [t, n] = e;
                                    return null != n;
                                })),
                                toastId: f,
                                updateId: h,
                                data: I,
                                closeToast: L,
                                isIn: !1,
                                className: $3b24cfd775fb7d30$var$p(l.className || g.toastClassName),
                                bodyClassName: $3b24cfd775fb7d30$var$p(l.bodyClassName || g.bodyClassName),
                                progressClassName: $3b24cfd775fb7d30$var$p(l.progressClassName || g.progressClassName),
                                autoClose: !l.isLoading && (w = l.autoClose, k = g.autoClose, !1 === w || $3b24cfd775fb7d30$var$c(w) && w > 0 ? w : k),
                                deleteToast () {
                                    const e = v.get(f), { onClose: n, children: s } = e.props;
                                    $3b24cfd775fb7d30$var$u(n) && n((0, $2hDQc.isValidElement)(s) && s.props), o($3b24cfd775fb7d30$var$y(e, "removed")), v.delete(f), r--, r < 0 && (r = 0), i.length > 0 ? b(i.shift()) : T();
                                }
                            };
                            var w, k;
                            $.closeButton = g.closeButton, !1 === l.closeButton || $3b24cfd775fb7d30$var$m(l.closeButton) ? $.closeButton = l.closeButton : !0 === l.closeButton && ($.closeButton = !$3b24cfd775fb7d30$var$m(g.closeButton) || g.closeButton);
                            let P = n;
                            (0, $2hDQc.isValidElement)(n) && !$3b24cfd775fb7d30$var$d(n.type) ? P = (0, $2hDQc.cloneElement)(n, {
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }) : $3b24cfd775fb7d30$var$u(n) && (P = n({
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }));
                            const M = {
                                content: P,
                                props: $,
                                staleId: _
                            };
                            g.limit && g.limit > 0 && r > g.limit && N ? i.push(M) : $3b24cfd775fb7d30$var$c(C) ? setTimeout(()=>{
                                b(M);
                            }, C) : b(M);
                        },
                        setProps (e) {
                            g = e;
                        },
                        setToggle: (e, t)=>{
                            v.get(e).toggle = t;
                        },
                        isToastActive: (e)=>l.some((t)=>t === e),
                        getSnapshot: ()=>g.newestOnTop ? f.reverse() : f
                    };
                }(n, e, $3b24cfd775fb7d30$var$E);
                $3b24cfd775fb7d30$var$v.set(n, s);
                const r = s.observe(o);
                return $3b24cfd775fb7d30$var$h.forEach((e)=>$3b24cfd775fb7d30$var$_(e.content, e.options)), $3b24cfd775fb7d30$var$h = [], ()=>{
                    r(), $3b24cfd775fb7d30$var$v.delete(n);
                };
            },
            setProps (e) {
                var t;
                null == (t = $3b24cfd775fb7d30$var$v.get(n)) || t.setProps(e);
            },
            getSnapshot () {
                var e;
                return null == (e = $3b24cfd775fb7d30$var$v.get(n)) ? void 0 : e.getSnapshot();
            }
        };
    }(e)).current;
    i(e);
    const l = (0, $2hDQc.useSyncExternalStore)(o, s, s);
    return {
        getToastToRender: function(e) {
            if (!l) return [];
            const t = new Map;
            return l.forEach((e)=>{
                const { position: n } = e.props;
                t.has(n) || t.set(n, []), t.get(n).push(e);
            }), Array.from(t, (t)=>e(t[0], t[1]));
        },
        isToastActive: $3b24cfd775fb7d30$var$I,
        count: null == l ? void 0 : l.length
    };
}
function $3b24cfd775fb7d30$export$a407b657d3044108(e) {
    const [t, o] = (0, $2hDQc.useState)(!1), [a, r] = (0, $2hDQc.useState)(!1), l = (0, $2hDQc.useRef)(null), c = (0, $2hDQc.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: u, closeToast: p, onClick: m, closeOnClick: f } = e;
    var g, y;
    function h() {
        o(!0);
    }
    function T() {
        o(!1);
    }
    function E(n) {
        const o = l.current;
        c.canDrag && o && (c.didMove = !0, t && T(), c.delta = "x" === e.draggableDirection ? n.clientX - c.start : n.clientY - c.start, c.start !== n.clientX && (c.canCloseOnClick = !1), o.style.transform = `translate3d(${"x" === e.draggableDirection ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`},0)`, o.style.opacity = "" + (1 - Math.abs(c.delta / c.removalDistance)));
    }
    function b() {
        document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", b);
        const t = l.current;
        if (c.canDrag && c.didMove && t) {
            if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) return r(!0), e.closeToast(), void e.collapseAll();
            t.style.transition = "transform 0.2s, opacity 0.2s", t.style.removeProperty("transform"), t.style.removeProperty("opacity");
        }
    }
    null == (y = $3b24cfd775fb7d30$var$v.get((g = {
        id: e.toastId,
        containerId: e.containerId,
        fn: o
    }).containerId || 1)) || y.setToggle(g.id, g.fn), (0, $2hDQc.useEffect)(()=>{
        if (e.pauseOnFocusLoss) return document.hasFocus() || T(), window.addEventListener("focus", h), window.addEventListener("blur", T), ()=>{
            window.removeEventListener("focus", h), window.removeEventListener("blur", T);
        };
    }, [
        e.pauseOnFocusLoss
    ]);
    const I = {
        onPointerDown: function(t) {
            if (!0 === e.draggable || e.draggable === t.pointerType) {
                c.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", b);
                const n = l.current;
                c.canCloseOnClick = !0, c.canDrag = !0, n.style.transition = "none", "x" === e.draggableDirection ? (c.start = t.clientX, c.removalDistance = n.offsetWidth * (e.draggablePercent / 100)) : (c.start = t.clientY, c.removalDistance = n.offsetHeight * (80 === e.draggablePercent ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
            }
        },
        onPointerUp: function(t) {
            const { top: n, bottom: o, left: s, right: a } = l.current.getBoundingClientRect();
            "touchend" !== t.nativeEvent.type && e.pauseOnHover && t.clientX >= s && t.clientX <= a && t.clientY >= n && t.clientY <= o ? T() : h();
        }
    };
    return d && u && (I.onMouseEnter = T, e.stacked || (I.onMouseLeave = h)), f && (I.onClick = (e)=>{
        m && m(e), c.canCloseOnClick && p();
    }), {
        playToast: h,
        pauseToast: T,
        isRunning: t,
        preventExitTransition: a,
        toastRef: l,
        eventHandlers: I
    };
}
function $3b24cfd775fb7d30$var$$(t) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: c, controlledProgress: d, progress: p, rtl: m, isIn: f, theme: g } = t;
    const y = r || d && 0 === p, v = {
        ...c,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    d && (v.transform = `scaleX(${p})`);
    const h = (0, $fLRFO.default)("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $3b24cfd775fb7d30$var$u(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: h
    }) : (0, $fLRFO.default)(h, i), E = {
        [d && p >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d && p < 1 ? null : ()=>{
            f && s();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${a}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: v,
        ...E
    }));
}
let $3b24cfd775fb7d30$var$w = 1;
const $3b24cfd775fb7d30$var$k = ()=>"" + $3b24cfd775fb7d30$var$w++;
function $3b24cfd775fb7d30$var$P(e) {
    return e && ($3b24cfd775fb7d30$var$d(e.toastId) || $3b24cfd775fb7d30$var$c(e.toastId)) ? e.toastId : $3b24cfd775fb7d30$var$k();
}
function $3b24cfd775fb7d30$var$M(e, t) {
    return $3b24cfd775fb7d30$var$_(e, t), t.toastId;
}
function $3b24cfd775fb7d30$var$x(e, t) {
    return {
        ...t,
        type: t && t.type || e,
        toastId: $3b24cfd775fb7d30$var$P(t)
    };
}
function $3b24cfd775fb7d30$var$A(e) {
    return (t, n)=>$3b24cfd775fb7d30$var$M(t, $3b24cfd775fb7d30$var$x(e, n));
}
function $3b24cfd775fb7d30$export$b410431fab84fa58(e, t) {
    return $3b24cfd775fb7d30$var$M(e, $3b24cfd775fb7d30$var$x("default", t));
}
$3b24cfd775fb7d30$export$b410431fab84fa58.loading = (e, t)=>$3b24cfd775fb7d30$var$M(e, $3b24cfd775fb7d30$var$x("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...t
    })), $3b24cfd775fb7d30$export$b410431fab84fa58.promise = function(e, t, n) {
    let o, { pending: s, error: a, success: r } = t;
    s && (o = $3b24cfd775fb7d30$var$d(s) ? $3b24cfd775fb7d30$export$b410431fab84fa58.loading(s, n) : $3b24cfd775fb7d30$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (e, t, s)=>{
        if (null == t) return void $3b24cfd775fb7d30$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: e,
            ...i,
            ...n,
            data: s
        }, r = $3b24cfd775fb7d30$var$d(t) ? {
            render: t
        } : t;
        return o ? $3b24cfd775fb7d30$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $3b24cfd775fb7d30$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $3b24cfd775fb7d30$var$u(e) ? e() : e;
    return c.then((e)=>l("success", r, e)).catch((e)=>l("error", a, e)), c;
}, $3b24cfd775fb7d30$export$b410431fab84fa58.success = $3b24cfd775fb7d30$var$A("success"), $3b24cfd775fb7d30$export$b410431fab84fa58.info = $3b24cfd775fb7d30$var$A("info"), $3b24cfd775fb7d30$export$b410431fab84fa58.error = $3b24cfd775fb7d30$var$A("error"), $3b24cfd775fb7d30$export$b410431fab84fa58.warning = $3b24cfd775fb7d30$var$A("warning"), $3b24cfd775fb7d30$export$b410431fab84fa58.warn = $3b24cfd775fb7d30$export$b410431fab84fa58.warning, $3b24cfd775fb7d30$export$b410431fab84fa58.dark = (e, t)=>$3b24cfd775fb7d30$var$M(e, $3b24cfd775fb7d30$var$x("default", {
        theme: "dark",
        ...t
    })), $3b24cfd775fb7d30$export$b410431fab84fa58.dismiss = function(e) {
    !function(e) {
        var t;
        if ($3b24cfd775fb7d30$var$b()) {
            if (null == e || $3b24cfd775fb7d30$var$d(t = e) || $3b24cfd775fb7d30$var$c(t)) $3b24cfd775fb7d30$var$v.forEach((t)=>{
                t.removeToast(e);
            });
            else if (e && ("containerId" in e || "id" in e)) {
                var n;
                (null == (n = $3b24cfd775fb7d30$var$v.get(e.containerId)) ? void 0 : n.removeToast(e.id)) || $3b24cfd775fb7d30$var$v.forEach((t)=>{
                    t.removeToast(e.id);
                });
            }
        } else $3b24cfd775fb7d30$var$h = $3b24cfd775fb7d30$var$h.filter((t)=>null != e && t.options.toastId !== e);
    }(e);
}, $3b24cfd775fb7d30$export$b410431fab84fa58.clearWaitingQueue = function(e) {
    void 0 === e && (e = {}), $3b24cfd775fb7d30$var$v.forEach((t)=>{
        !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
    });
}, $3b24cfd775fb7d30$export$b410431fab84fa58.isActive = $3b24cfd775fb7d30$var$I, $3b24cfd775fb7d30$export$b410431fab84fa58.update = function(e, t) {
    void 0 === t && (t = {});
    const n = ((e, t)=>{
        var n;
        let { containerId: o } = t;
        return null == (n = $3b24cfd775fb7d30$var$v.get(o || 1)) ? void 0 : n.toasts.get(e);
    })(e, t);
    if (n) {
        const { props: o, content: s } = n, a = {
            delay: 100,
            ...o,
            ...t,
            toastId: t.toastId || e,
            updateId: $3b24cfd775fb7d30$var$k()
        };
        a.toastId !== e && (a.staleId = e);
        const r = a.render || s;
        delete a.render, $3b24cfd775fb7d30$var$M(r, a);
    }
}, $3b24cfd775fb7d30$export$b410431fab84fa58.done = (e)=>{
    $3b24cfd775fb7d30$export$b410431fab84fa58.update(e, {
        progress: 1
    });
}, $3b24cfd775fb7d30$export$b410431fab84fa58.onChange = function(e) {
    return $3b24cfd775fb7d30$var$T.add(e), ()=>{
        $3b24cfd775fb7d30$var$T.delete(e);
    };
}, $3b24cfd775fb7d30$export$b410431fab84fa58.play = (e)=>$3b24cfd775fb7d30$var$C(!0, e), $3b24cfd775fb7d30$export$b410431fab84fa58.pause = (e)=>$3b24cfd775fb7d30$var$C(!1, e);
const $3b24cfd775fb7d30$var$O = "undefined" != typeof window ? (0, $2hDQc.useLayoutEffect) : (0, $2hDQc.useEffect), $3b24cfd775fb7d30$var$D = (t)=>{
    let { theme: n, type: o, isLoading: s, ...a } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...a
    });
}, $3b24cfd775fb7d30$export$4f13f83fd8bb1dac = {
    info: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($3b24cfd775fb7d30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($3b24cfd775fb7d30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($3b24cfd775fb7d30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($3b24cfd775fb7d30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
}, $3b24cfd775fb7d30$var$R = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i, playToast: c } = $3b24cfd775fb7d30$export$a407b657d3044108(n), { closeButton: d, children: p, autoClose: m, onClick: f, type: g, hideProgressBar: y, closeToast: v, transition: h, position: T, className: E, style: b, bodyClassName: I, bodyStyle: _, progressClassName: C, progressStyle: L, updateId: w, role: k, progress: P, rtl: M, toastId: x, deleteToast: A, isIn: B, isLoading: O, closeOnClick: D, theme: R } = n, S = (0, $fLRFO.default)("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${g}`, {
        "Toastify__toast--rtl": M
    }, {
        "Toastify__toast--close-on-click": D
    }), H = $3b24cfd775fb7d30$var$u(E) ? E({
        rtl: M,
        position: T,
        type: g,
        defaultClassName: S
    }) : (0, $fLRFO.default)(S, E), F = function(e) {
        let { theme: n, type: o, isLoading: s, icon: r } = e, i = null;
        const l = {
            theme: n,
            type: o
        };
        return !1 === r || ($3b24cfd775fb7d30$var$u(r) ? i = r({
            ...l,
            isLoading: s
        }) : (0, $2hDQc.isValidElement)(r) ? i = (0, $2hDQc.cloneElement)(r, l) : s ? i = $3b24cfd775fb7d30$export$4f13f83fd8bb1dac.spinner() : ((e)=>e in $3b24cfd775fb7d30$export$4f13f83fd8bb1dac)(o) && (i = $3b24cfd775fb7d30$export$4f13f83fd8bb1dac[o](l))), i;
    }(n), X = !!P || !m, Y = {
        closeToast: v,
        type: g,
        theme: R
    };
    let q = null;
    return !1 === d || (q = $3b24cfd775fb7d30$var$u(d) ? d(Y) : (0, $2hDQc.isValidElement)(d) ? (0, $2hDQc.cloneElement)(d, Y) : function(t) {
        let { closeToast: n, theme: o, ariaLabel: s = "close" } = t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("button", {
            className: `Toastify__close-button Toastify__close-button--${o}`,
            type: "button",
            onClick: (e)=>{
                e.stopPropagation(), n(e);
            },
            "aria-label": s
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 14 16"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
            fillRule: "evenodd",
            d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })));
    }(Y)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(h, {
        isIn: B,
        done: A,
        position: T,
        preventExitTransition: s,
        nodeRef: r,
        playToast: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        id: x,
        onClick: f,
        "data-in": B,
        className: H,
        ...i,
        style: b,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        ...B && {
            role: k
        },
        className: $3b24cfd775fb7d30$var$u(I) ? I({
            type: g
        }) : (0, $fLRFO.default)("Toastify__toast-body", I),
        style: _
    }, null != F && (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        className: (0, $fLRFO.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !O
        })
    }, F), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", null, p)), q, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($3b24cfd775fb7d30$var$$, {
        ...w && !X ? {
            key: `pb-${w}`
        } : {},
        rtl: M,
        theme: R,
        delay: m,
        isRunning: o,
        isIn: B,
        closeToast: v,
        hide: y,
        type: g,
        style: L,
        className: C,
        controlledProgress: X,
        progress: P || 0
    })));
}, $3b24cfd775fb7d30$var$S = function(e, t) {
    return void 0 === t && (t = !1), {
        enter: `Toastify--animate Toastify__${e}-enter`,
        exit: `Toastify--animate Toastify__${e}-exit`,
        appendPosition: t
    };
}, $3b24cfd775fb7d30$export$d20e79fdc3899e95 = $3b24cfd775fb7d30$export$3ff7dc44d332d222($3b24cfd775fb7d30$var$S("bounce", !0)), $3b24cfd775fb7d30$export$d8dc01b5c85a37b9 = $3b24cfd775fb7d30$export$3ff7dc44d332d222($3b24cfd775fb7d30$var$S("slide", !0)), $3b24cfd775fb7d30$export$65cfd44a2050f99 = $3b24cfd775fb7d30$export$3ff7dc44d332d222($3b24cfd775fb7d30$var$S("zoom")), $3b24cfd775fb7d30$export$4d2fae537bd90431 = $3b24cfd775fb7d30$export$3ff7dc44d332d222($3b24cfd775fb7d30$var$S("flip")), $3b24cfd775fb7d30$var$q = {
    position: "top-right",
    transition: $3b24cfd775fb7d30$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
function $3b24cfd775fb7d30$export$f2815235e76a62b9(t) {
    let o = {
        ...$3b24cfd775fb7d30$var$q,
        ...t
    };
    const s = t.stacked, [a, r] = (0, $2hDQc.useState)(!0), c = (0, $2hDQc.useRef)(null), { getToastToRender: d, isToastActive: m, count: f } = $3b24cfd775fb7d30$export$b262e13ca2dd2381(o), { className: g, style: y, rtl: v, containerId: h } = o;
    function T(e) {
        const t = (0, $fLRFO.default)("Toastify__toast-container", `Toastify__toast-container--${e}`, {
            "Toastify__toast-container--rtl": v
        });
        return $3b24cfd775fb7d30$var$u(g) ? g({
            position: e,
            rtl: v,
            defaultClassName: t
        }) : (0, $fLRFO.default)(t, $3b24cfd775fb7d30$var$p(g));
    }
    function E() {
        s && (r(!0), $3b24cfd775fb7d30$export$b410431fab84fa58.play());
    }
    return $3b24cfd775fb7d30$var$O(()=>{
        if (s) {
            var e;
            const t = c.current.querySelectorAll('[data-in="true"]'), n = 12, s = null == (e = o.position) ? void 0 : e.includes("top");
            let r = 0, i = 0;
            Array.from(t).reverse().forEach((e, t)=>{
                const o = e;
                o.classList.add("Toastify__toast--stacked"), t > 0 && (o.dataset.collapsed = `${a}`), o.dataset.pos || (o.dataset.pos = s ? "top" : "bot");
                const l = r * (a ? .2 : 1) + (a ? 0 : n * t);
                o.style.setProperty("--y", `${s ? l : -1 * l}px`), o.style.setProperty("--g", `${n}`), o.style.setProperty("--s", "" + (1 - (a ? i : 0))), r += o.offsetHeight, i += .025;
            });
        }
    }, [
        a,
        f,
        s
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
        ref: c,
        className: "Toastify",
        id: h,
        onMouseEnter: ()=>{
            s && (r(!1), $3b24cfd775fb7d30$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E
    }, d((t, n)=>{
        const o = n.length ? {
            ...y
        } : {
            ...y,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("div", {
            className: T(t),
            style: o,
            key: `container-${t}`
        }, n.map((t)=>{
            let { content: n, props: o } = t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($3b24cfd775fb7d30$var$R, {
                ...o,
                stacked: s,
                collapseAll: E,
                isIn: m(o.toastId, o.containerId),
                style: o.style,
                key: `toast-${o.key}`
            }, n);
        }));
    }));
}


var $eaea2ba9b50fd31e$export$266cbe012f0ab791;
(function(MoovyToast) {
    MoovyToast.showToast = (message, success = true)=>{
        success ? (0, $3b24cfd775fb7d30$export$b410431fab84fa58).success(message) : (0, $3b24cfd775fb7d30$export$b410431fab84fa58).error(message);
    };
})($eaea2ba9b50fd31e$export$266cbe012f0ab791 || ($eaea2ba9b50fd31e$export$266cbe012f0ab791 = {}));



const $1e83b5237b13819d$var$Invitations = ({ queryInvitations: queryInvitations, permissionAccess: permissionAccess, showModalAdd: showModalAdd, addingInvitationParams: addingInvitationParams, setShowModalAdd: setShowModalAdd, pagination: pagination, onInvitationAdded: onInvitationAdded, onInvitationRemoved: onInvitationRemoved, visibleColumns: visibleColumns = [
    "NAME",
    "EMAIL",
    "INVITED",
    "REGISTERED_IN",
    "REMOVE"
] })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const [showModalRemove, setShowModalRemove] = (0, $2hDQc.useState)(null);
    const invitations = addingInvitationParams.invitationType === "LANDLORD" ? queryInvitations?.data?.data || [] : queryInvitations?.data || [];
    const removeInvitationMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (invitationId)=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).removeInvitation(invitationId),
        onSuccess: (response)=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.invitations.list.actions.removed",
                values: {
                    name: showModalRemove?.name
                }
            }));
            setShowModalRemove(null);
            onInvitationRemoved();
        }
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                emptyTextId: "page.invitations.list.table.action.empty",
                errorTextId: "page.invitations.list.table.action.failed",
                query: queryInvitations,
                pagination: pagination,
                children: invitations.map((row)=>{
                    let cardContentList = [];
                    if (visibleColumns.includes("EMAIL")) {
                        cardContentList.push(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "common.text.email"
                        }));
                        cardContentList.push(/*#__PURE__*/ (0, $592Nh.jsx)("b", {
                            children: row.email
                        }));
                    }
                    if (visibleColumns.includes("REGISTERED_IN")) {
                        cardContentList.push(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.invitations.list.card.header.registeredIn"
                        }));
                        cardContentList.push(/*#__PURE__*/ (0, $592Nh.jsx)("b", {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                utcDateTime: row.used,
                                emptyText: "-"
                            })
                        }));
                    }
                    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                        cardTitle: row.name,
                        cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                            utcDateTime: row.createdAt
                        }),
                        cardContentList: cardContentList,
                        cardMenuActions: isPermission(permissionAccess.action, permissionAccess.resource) ? [
                            {
                                itemText: intl.formatMessage({
                                    id: "page.invitations.list.button.remove"
                                }),
                                onClick: ()=>setShowModalRemove({
                                        name: row.name,
                                        id: row.id
                                    })
                            }
                        ] : undefined
                    }, row.id);
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                items: invitations,
                emptyTextId: "page.invitations.list.table.action.empty",
                errorTextId: "page.invitations.list.table.action.failed",
                query: queryInvitations,
                pagination: pagination,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                            children: [
                                visibleColumns.includes("NAME") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.invitations.list.table.header.name"
                                    })
                                }),
                                visibleColumns.includes("EMAIL") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.text.email"
                                    })
                                }),
                                visibleColumns.includes("INVITED") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.invitations.list.table.header.invited"
                                    })
                                }),
                                visibleColumns.includes("REGISTERED_IN") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.invitations.list.table.header.registeredIn"
                                    })
                                }),
                                visibleColumns.includes("REMOVE") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                    action: permissionAccess.action,
                                    resource: permissionAccess.resource,
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                        "data-testid": "invitations-table-body",
                        children: invitations.map((row)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                children: [
                                    visibleColumns.includes("NAME") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.name
                                    }),
                                    visibleColumns.includes("EMAIL") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.email
                                    }),
                                    visibleColumns.includes("INVITED") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.createdAt
                                        })
                                    }),
                                    visibleColumns.includes("REGISTERED_IN") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.used
                                        })
                                    }),
                                    visibleColumns.includes("REMOVE") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                            action: permissionAccess.action,
                                            resource: permissionAccess.resource,
                                            visibility: !row.used,
                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                red: true,
                                                bold: true,
                                                onClick: ()=>setShowModalRemove({
                                                        name: row.name,
                                                        id: row.id
                                                    }),
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.invitations.list.button.remove"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $bf59313fc47a1b56$export$2e2bcd8739ae039), {
                open: showModalAdd,
                addingInvitationParams: addingInvitationParams,
                onSubmit: (response)=>{
                    setShowModalAdd(false);
                    (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.invitations.list.actions.added",
                        values: {
                            name: response.name
                        }
                    }));
                    onInvitationAdded();
                },
                onCancel: ()=>setShowModalAdd(false)
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $03bdcb6e7b9b2179$export$2e2bcd8739ae039), {
                open: !!showModalRemove,
                lang: {
                    confirmButton: "common.buttons.yes",
                    error: "common.actions.remove.error"
                },
                header: intl.formatMessage({
                    id: "page.invitations.modalRemove.header"
                }),
                content: intl.formatMessage({
                    id: "page.invitations.modalRemove.content"
                }, {
                    name: showModalRemove?.name
                }),
                onCancel: ()=>setShowModalRemove(null),
                onConfirm: ()=>showModalRemove?.id && removeInvitationMutation.mutate(showModalRemove.id),
                mutation: removeInvitationMutation
            })
        ]
    });
};
var $1e83b5237b13819d$export$2e2bcd8739ae039 = $1e83b5237b13819d$var$Invitations;






const $d79f754417ba871e$var$stateKey = "moovyUi";
const $d79f754417ba871e$var$initialState = {
    locale: localStorage.getItem((0, $086351014303c4b8$export$864b6a9fa5df87b6)) || "fi",
    initialized: sessionStorage.getItem((0, $086351014303c4b8$export$464bac997a211baf)) || "",
    landlord: {
        id: sessionStorage.getItem((0, $086351014303c4b8$export$fbb0f21f223dce54)) || "",
        name: sessionStorage.getItem((0, $086351014303c4b8$export$ad6b2753bfb86074)) || ""
    },
    place: {
        id: sessionStorage.getItem((0, $086351014303c4b8$export$7590792a37b51514)) || "",
        name: sessionStorage.getItem((0, $086351014303c4b8$export$fa52eabe6f966a70)) || ""
    },
    catalogueId: sessionStorage.getItem((0, $086351014303c4b8$export$738e7ce102bdae66)) || ""
};
const $d79f754417ba871e$var$slice = (0, $b6d40e24321310a3$export$4d8d9bd83c24ae8b)({
    name: $d79f754417ba871e$var$stateKey,
    initialState: $d79f754417ba871e$var$initialState,
    reducers: {
        setUI (state, action) {
            const newState = {
                ...state,
                [action.payload.key]: action.payload.value
            };
            return newState;
        },
        setLocale (state, action) {
            localStorage.setItem((0, $086351014303c4b8$export$864b6a9fa5df87b6), action.payload);
            state.locale = action.payload;
        },
        setInitialized (state, action) {
            sessionStorage.setItem((0, $086351014303c4b8$export$464bac997a211baf), action.payload);
            state.initialized = action.payload;
        },
        setCustomer (state, action) {
            sessionStorage.setItem((0, $086351014303c4b8$export$fbb0f21f223dce54), action.payload.id);
            sessionStorage.setItem((0, $086351014303c4b8$export$ad6b2753bfb86074), action.payload.name);
            state.landlord = {
                ...action.payload
            };
        },
        setPlace (state, action) {
            sessionStorage.setItem((0, $086351014303c4b8$export$7590792a37b51514), action.payload.id);
            sessionStorage.setItem((0, $086351014303c4b8$export$fa52eabe6f966a70), action.payload.name);
            state.place = {
                ...action.payload
            };
        },
        setCatalogueId (state, action) {
            sessionStorage.setItem((0, $086351014303c4b8$export$738e7ce102bdae66), action.payload);
            state.catalogueId = action.payload;
        }
    }
});
var $d79f754417ba871e$export$2e2bcd8739ae039 = $d79f754417ba871e$var$slice.reducer;
const { setUI: $d79f754417ba871e$export$32af90104174043f, setLocale: $d79f754417ba871e$export$c8aadf3621e41efb, setCustomer: $d79f754417ba871e$export$17f90c60f0971ba8, setPlace: $d79f754417ba871e$export$5a0d5937f9d14ce6, setInitialized: $d79f754417ba871e$export$e311492ce45a8298, setCatalogueId: $d79f754417ba871e$export$14203ab318469323 } = $d79f754417ba871e$var$slice.actions;
const $d79f754417ba871e$export$dad57afd7b5a98f5 = (key, payload)=>{
    return $d79f754417ba871e$export$32af90104174043f({
        key: key,
        value: payload
    });
};
const $d79f754417ba871e$export$7389484a7f69e71d = (payload)=>{
    return $d79f754417ba871e$export$c8aadf3621e41efb(payload);
};
const $d79f754417ba871e$export$bbe1eb340cdbd464 = (payload)=>{
    return $d79f754417ba871e$export$e311492ce45a8298(payload);
};
const $d79f754417ba871e$export$ae66d5a6ca962c9a = (payload)=>{
    return $d79f754417ba871e$export$17f90c60f0971ba8(payload);
};
const $d79f754417ba871e$export$2f52b3443c11c15a = (payload)=>{
    return $d79f754417ba871e$export$5a0d5937f9d14ce6(payload);
};
const $d79f754417ba871e$export$12af370a2d55934d = (payload)=>{
    return $d79f754417ba871e$export$14203ab318469323(payload);
};
const $d79f754417ba871e$export$1c46e3decb4a80c2 = {
    keyExists (state, uiKey) {
        return state[$d79f754417ba871e$var$stateKey]?.[uiKey] !== undefined;
    },
    getUiState (state, uiKey) {
        return state[$d79f754417ba871e$var$stateKey]?.[uiKey];
    },
    getLocale (state) {
        return state[$d79f754417ba871e$var$stateKey]?.locale;
    },
    getInitialized (state) {
        return state[$d79f754417ba871e$var$stateKey]?.initialized;
    },
    getCustomer (state) {
        return state[$d79f754417ba871e$var$stateKey]?.landlord;
    },
    getPlace (state) {
        return state[$d79f754417ba871e$var$stateKey]?.place;
    },
    getCatalogueId (state) {
        return state[$d79f754417ba871e$var$stateKey]?.catalogueId;
    }
};



function $cafa508c3f794a0e$export$2e2bcd8739ae039(options) {
    const dispatch = (0, $ca980beea4c3b32c$export$8ad76b76a4c905f8)();
    const { key: key, initialValue: initialValue } = options;
    const updateFunction = (value)=>dispatch((0, $d79f754417ba871e$export$dad57afd7b5a98f5)(key, value));
    const exists = (0, $704baa9769160210$export$2105062e25df4afe)((state)=>(0, $d79f754417ba871e$export$1c46e3decb4a80c2).keyExists(state, key));
    const selector = (0, $704baa9769160210$export$2105062e25df4afe)((state)=>(0, $d79f754417ba871e$export$1c46e3decb4a80c2).getUiState(state, key));
    // Value in Redux, function to update value
    return [
        exists ? selector : initialValue,
        updateFunction
    ];
}


const $eaa7b9c2dbfdf5a8$var$InvitationsLandlord = ()=>{
    const { admin: admin } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const [showModalAdd, setShowModalAdd] = (0, $2hDQc.useState)(false);
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $7bfb91130cd4d35d$export$5cbc2ff09ff3e0),
        initialValue: (0, $ae63e01d7dc24727$export$4bec99d256114e49)("CREATED_AT", "DESC")
    });
    const queryInvitations = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$7a161aff508d2cb1),
            pagingAndSortValues.page,
            pagingAndSortValues.sort
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $ae63e01d7dc24727$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $5d8afbac14d682f8$export$2e2bcd8739ae039).getInvitations(admin, {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction
            });
        },
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const pagination = queryInvitations.data?.pageable ? {
        page: queryInvitations.data.pageable.page,
        total: queryInvitations.data.pageable.total,
        limit: queryInvitations.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const items = (0, $5dcd3ee6df434ce0$export$88b06990067e1fdb)(intl, "INVITATIONS");
    const onInvitationRemoved = ()=>{
        const newPage = (0, $ae63e01d7dc24727$export$e8b67cc4f4c44ec6)(pagination);
        if (newPage) setPagingAndSortValues({
            ...pagingAndSortValues,
            page: newPage
        });
        onRefreshView();
    };
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$7a161aff508d2cb1)
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                loading: queryInvitations.isPending,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.invitations.list.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        description: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b69e7f737512ce9e$export$2e2bcd8739ae039), {
                            filterKey: (0, $7bfb91130cd4d35d$export$1ef7c9c6b17b6642),
                            items: items,
                            value: pagingAndSortValues.sort,
                            onChange: (value)=>{
                                pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                    ...pagingAndSortValues,
                                    sort: value,
                                    direction: (0, $5dcd3ee6df434ce0$export$fcce7887255d1c69)(value)
                                });
                            }
                        }),
                        button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                            action: "CREATE",
                            resource: "LANDLORD_INVITATIONS",
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowModalAdd(true),
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.invitations.list.button.landlord.newInvitation"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $1e83b5237b13819d$export$2e2bcd8739ae039), {
                            queryInvitations: queryInvitations,
                            permissionAccess: {
                                action: "DELETE",
                                resource: "LANDLORD_INVITATIONS"
                            },
                            addingInvitationParams: {
                                invitationType: "LANDLORD"
                            },
                            showModalAdd: showModalAdd,
                            setShowModalAdd: setShowModalAdd,
                            pagination: pagination,
                            onInvitationRemoved: onInvitationRemoved,
                            onInvitationAdded: onRefreshView
                        })
                    })
                ]
            })
        ]
    });
};
var $eaa7b9c2dbfdf5a8$export$2e2bcd8739ae039 = $eaa7b9c2dbfdf5a8$var$InvitationsLandlord;



var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");





const $122d1ee578c830fa$var$InvitationsTenant = ({ tenantId: tenantId, landlordId: landlordId, catalogueId: catalogueId })=>{
    const { admin: admin } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const [showModalAdd, setShowModalAdd] = (0, $2hDQc.useState)(false);
    const queryInvitations = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$415ddc16ccdc9af1),
            tenantId
        ],
        queryFn: ()=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).getInvitationsByCustomerId(admin, tenantId, true),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$415ddc16ccdc9af1)
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                loading: queryInvitations.isPending,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                            action: "CREATE",
                            resource: "TENANT_INVITATIONS",
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowModalAdd(true),
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.invitations.list.button.tenant.newInvitation"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $1e83b5237b13819d$export$2e2bcd8739ae039), {
                            queryInvitations: queryInvitations,
                            addingInvitationParams: {
                                invitationType: "TENANT",
                                landlordId: landlordId,
                                tenantId: tenantId,
                                catalogueId: catalogueId
                            },
                            permissionAccess: {
                                action: "DELETE",
                                resource: "TENANT_INVITATIONS"
                            },
                            showModalAdd: showModalAdd,
                            setShowModalAdd: setShowModalAdd,
                            onInvitationRemoved: onRefreshView,
                            onInvitationAdded: onRefreshView
                        })
                    })
                ]
            })
        ]
    });
};
var $122d1ee578c830fa$export$2e2bcd8739ae039 = $122d1ee578c830fa$var$InvitationsTenant;



var $592Nh = parcelRequire("592Nh");


var $2hDQc = parcelRequire("2hDQc");





const $61010f014b1b3692$var$InvitationsAdmin = ({ queryInvitations: queryInvitations, customerId: customerId })=>{
    const [showModalAdd, setShowModalAdd] = (0, $2hDQc.useState)(false);
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    /*
  // TODO Antti: Paging is missing from backend implementation
  const [pagingAndSortValues, setPagingAndSortValues] = useGlobalUI({
    key: SS_INVITATIONS_ADMIN_PAGING,
    initialValue: getPagingAndSortInitValues<InvitationSortType>('USED')
  })

  const pagination: MoovyPaginationProps | undefined = queryInvitations.data
    ?.pageable
    ? {
        page: queryInvitations.data.pageable.page,
        total: queryInvitations.data.pageable.total,
        limit: queryInvitations.data.pageable.limit,
        onNextPage: (page) =>
          setPagingAndSortValues({
            ...pagingAndSortValues,
            page: page.toString()
          })
      }
    : undefined
*/ const onInvitationRemoved = ()=>{
        /*
    // TODO Antti: Paging is missing from backend implementation
    const newPage = getNewPageAfterItemDeletion(pagination)
    if (newPage) {
      setPagingAndSortValues({
        ...pagingAndSortValues,
        page: newPage
      })
    }
*/ onRefreshView();
    };
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$96f07f442214aab),
                customerId
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        sx: {
            paddingTop: 2
        },
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
            loading: queryInvitations.isPending,
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $1e83b5237b13819d$export$2e2bcd8739ae039), {
                    queryInvitations: queryInvitations,
                    permissionAccess: {
                        action: "DELETE",
                        resource: "ADMIN_INVITATIONS"
                    },
                    addingInvitationParams: {
                        invitationType: "ADMIN",
                        landlordId: customerId
                    },
                    showModalAdd: showModalAdd,
                    setShowModalAdd: setShowModalAdd,
                    onInvitationRemoved: onInvitationRemoved,
                    onInvitationAdded: onRefreshView,
                    visibleColumns: isPermission("DELETE", "ADMIN_INVITATIONS") ? [
                        "NAME",
                        "EMAIL",
                        "INVITED",
                        "REMOVE"
                    ] : [
                        "NAME",
                        "EMAIL",
                        "INVITED"
                    ]
                })
            })
        })
    });
};
var $61010f014b1b3692$export$2e2bcd8739ae039 = $61010f014b1b3692$var$InvitationsAdmin;



var $592Nh = parcelRequire("592Nh");



var $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d;
(function(BackendDatetime) {
    BackendDatetime.nowToUTC = ()=>{
        return BackendDatetime.toUTC((0, $f65046485b965c63$exports.DateTime).local());
    };
    BackendDatetime.toUTC = (datetime)=>{
        if (!datetime.isValid) {
            console.error("Invalid datetime was given. ", datetime);
            return "";
        }
        return datetime.toUTC().toISO() || "";
    };
    BackendDatetime.fromUTC = (utcDatetime, locale)=>{
        return (0, $f65046485b965c63$exports.DateTime).fromISO(utcDatetime || "").setLocale(locale);
    };
})($4ea31e1953a3d675$export$6ef9dbcccbc4ed7d || ($4ea31e1953a3d675$export$6ef9dbcccbc4ed7d = {}));
var $4ea31e1953a3d675$export$59110d836eb073ac;
(function(UIDatetime) {
    UIDatetime.toString = (datetime)=>{
        return datetime.toLocaleString((0, $f65046485b965c63$exports.DateTime).DATETIME_SHORT);
    };
})($4ea31e1953a3d675$export$59110d836eb073ac || ($4ea31e1953a3d675$export$59110d836eb073ac = {}));
var $4ea31e1953a3d675$export$6c3b6c09c58d6bc3;
(function(UIDate) {
    UIDate.toString = (datetime)=>{
        return datetime.toLocaleString((0, $f65046485b965c63$exports.DateTime).DATE_SHORT);
    };
    UIDate.toCustomString = (datetime, format = "yyyyMMdd")=>{
        return datetime.toFormat(format);
    };
})($4ea31e1953a3d675$export$6c3b6c09c58d6bc3 || ($4ea31e1953a3d675$export$6c3b6c09c58d6bc3 = {}));



var $592Nh = parcelRequire("592Nh");


var $2hDQc = parcelRequire("2hDQc");

var $5pzCu = parcelRequire("5pzCu");



const $775d67ecd9fb7af5$var$FormEditVehicle = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const getFormDefaultValues = ()=>{
        return {
            licensePlate: props.licensePlate
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const schemaValidator = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            licensePlate: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
                id: "common.form.errors.licensePlate"
            }), function(licensePlate) {
                return (0, $066f7ec5b64309d3$export$dddb845077defee2)(licensePlate);
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { licensePlate: licensePlate } = values;
        props.onSubmit(licensePlate.trim().toLocaleUpperCase());
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
        validate: ()=>setFormikValidateOnChange(true),
        validationSchema: schemaValidator(),
        enableReinitialize: true,
        initialValues: getFormDefaultValues(),
        validateOnChange: formikValidateOnChange,
        onSubmit: (values)=>{
            onSubmitFormValues(values);
        },
        children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                onSubmit: handleSubmit,
                id: props.formReference,
                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "licensePlate",
                            "data-testid": "licensePlate",
                            value: values.licensePlate,
                            label: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            placeholder: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            onChange: handleChange,
                            error: !!errors.licensePlate,
                            errorText: errors.licensePlate
                        }),
                        props.showAccountingFields && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                    name: "costCenter",
                                    "data-testid": "costCenter",
                                    disabled: true,
                                    value: props.costCenter,
                                    label: intl.formatMessage({
                                        id: "common.text.costCenter"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                    name: "project",
                                    "data-testid": "project",
                                    value: props.project,
                                    disabled: true,
                                    label: intl.formatMessage({
                                        id: "common.text.project"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
var $775d67ecd9fb7af5$export$2e2bcd8739ae039 = $775d67ecd9fb7af5$var$FormEditVehicle;





const $46f3ff004257dc9a$var$BASE_URL = `${(0, $1ff9aa7c00d3fc54$export$ff0725f0ea898f41)}/rights`;
const $46f3ff004257dc9a$var$getRightByRef = async (ref)=>{
    const response = await (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$46f3ff004257dc9a$var$BASE_URL}/${ref}`);
    return response.data;
};
const $46f3ff004257dc9a$var$changeLicensePlate = (rightHolderRef, rightLicensePlateChange)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${$46f3ff004257dc9a$var$BASE_URL}/${rightHolderRef}/change-license-plate`, rightLicensePlateChange);
};
const $46f3ff004257dc9a$var$endRight = (rightHolderRef, right)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${$46f3ff004257dc9a$var$BASE_URL}/${rightHolderRef}/end`, right);
};
const $46f3ff004257dc9a$var$RightsAPI = {
    getRightByRef: $46f3ff004257dc9a$var$getRightByRef,
    changeLicensePlate: $46f3ff004257dc9a$var$changeLicensePlate,
    endRight: $46f3ff004257dc9a$var$endRight
};
var $46f3ff004257dc9a$export$2e2bcd8739ae039 = $46f3ff004257dc9a$var$RightsAPI;





var $2hDQc = parcelRequire("2hDQc");



const $be730b8591848347$var$BASE_URL = "catalogues";
const $be730b8591848347$var$getCataloguesByRef = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/${$be730b8591848347$var$BASE_URL}/${ref}`).then((response)=>response.data);
};
const $be730b8591848347$var$getCataloguesByCustomer = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/${$be730b8591848347$var$BASE_URL}/by-customer-id/${ref}`).then((response)=>response.data);
};
const $be730b8591848347$var$getActiveRightsById = (catalogueId, queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/${$be730b8591848347$var$BASE_URL}/${catalogueId}/active-rights`, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $be730b8591848347$var$createCatalogue = (catalogue)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/${$be730b8591848347$var$BASE_URL}`, catalogue);
};
const $be730b8591848347$var$updateCatalogue = (catalogueRef, catalogue)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).put(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/${$be730b8591848347$var$BASE_URL}/${catalogueRef}`, catalogue);
};
const $be730b8591848347$var$getByOffering = (offeringRef, queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/offerings/${offeringRef}/${$be730b8591848347$var$BASE_URL}`, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $be730b8591848347$export$25753268427e50ea = {
    getCataloguesByRef: $be730b8591848347$var$getCataloguesByRef,
    getCataloguesByCustomer: $be730b8591848347$var$getCataloguesByCustomer,
    getActiveRightsById: $be730b8591848347$var$getActiveRightsById,
    createCatalogue: $be730b8591848347$var$createCatalogue,
    getByOffering: $be730b8591848347$var$getByOffering,
    updateCatalogue: $be730b8591848347$var$updateCatalogue
};



var $592Nh = parcelRequire("592Nh");

var $2hDQc = parcelRequire("2hDQc");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8e0b634c21bbe511$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8e0b634c21bbe511$export$2e2bcd8739ae039 = $8e0b634c21bbe511$var$getOverlayAlpha;



var $afHYP = parcelRequire("afHYP");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $1eae3fb8ec1b23c6$export$29cdb466b9b6f20b(slot) {
    return (0, $01COD.default)("MuiPaper", slot);
}
const $1eae3fb8ec1b23c6$var$paperClasses = (0, $eLydt.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $1eae3fb8ec1b23c6$export$2e2bcd8739ae039 = $1eae3fb8ec1b23c6$var$paperClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $23b78932f8a6daaa$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $23b78932f8a6daaa$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $1eae3fb8ec1b23c6$export$29cdb466b9b6f20b), classes);
};
const $23b78932f8a6daaa$var$PaperRoot = (0, $fhlQp.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kxIgO.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $kxIgO.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $6KAST.alpha)("#fff", (0, $8e0b634c21bbe511$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $6KAST.alpha)("#fff", (0, $8e0b634c21bbe511$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $23b78932f8a6daaa$var$Paper = /*#__PURE__*/ $2hDQc.forwardRef(function Paper(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $gZOiq.default)(props, $23b78932f8a6daaa$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $23b78932f8a6daaa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($23b78932f8a6daaa$var$PaperRoot, (0, $kxIgO.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref
    }, other));
});
var $23b78932f8a6daaa$export$2e2bcd8739ae039 = $23b78932f8a6daaa$var$Paper;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $4f823d5858761308$export$69aecd24bc2cf7e3(slot) {
    return (0, $01COD.default)("MuiAlert", slot);
}
const $4f823d5858761308$var$alertClasses = (0, $eLydt.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $4f823d5858761308$export$2e2bcd8739ae039 = $4f823d5858761308$var$alertClasses;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $lfMLv = parcelRequire("lfMLv");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $6d38be97ab7b96ff$export$5e8702d71474f093(slot) {
    return (0, $01COD.default)("MuiIconButton", slot);
}
const $6d38be97ab7b96ff$var$iconButtonClasses = (0, $eLydt.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $6d38be97ab7b96ff$export$2e2bcd8739ae039 = $6d38be97ab7b96ff$var$iconButtonClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $f97b6ffd7ec1b40a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $f97b6ffd7ec1b40a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $lfMLv.default)(color)}`,
            edge && `edge${(0, $lfMLv.default)(edge)}`,
            `size${(0, $lfMLv.default)(size)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $6d38be97ab7b96ff$export$5e8702d71474f093), classes);
};
const $f97b6ffd7ec1b40a$var$IconButtonRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $lfMLv.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $lfMLv.default)(ownerState.edge)}`],
            styles[`size${(0, $lfMLv.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kxIgO.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $kxIgO.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $kxIgO.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $6d38be97ab7b96ff$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f97b6ffd7ec1b40a$var$IconButton = /*#__PURE__*/ $2hDQc.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $gZOiq.default)(props, $f97b6ffd7ec1b40a$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $f97b6ffd7ec1b40a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($f97b6ffd7ec1b40a$var$IconButtonRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $f97b6ffd7ec1b40a$export$2e2bcd8739ae039 = $f97b6ffd7ec1b40a$var$IconButton;


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $0dfb28a9f5e0cf89$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $955d856f1c56515f$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $88e53905b70c14b0$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $0322c3e11b9b9a30$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $e06505996467b5ce$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $592Nh = parcelRequire("592Nh");
"use client";
const $33c2057624e26cc6$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $33c2057624e26cc6$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $lfMLv.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $4f823d5858761308$export$69aecd24bc2cf7e3), classes);
};
const $33c2057624e26cc6$var$AlertRoot = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $lfMLv.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $6KAST.darken) : (0, $6KAST.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $6KAST.lighten) : (0, $6KAST.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $kxIgO.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $4f823d5858761308$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "outlined" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $4f823d5858761308$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "filled" && (0, $kxIgO.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $33c2057624e26cc6$var$AlertIcon = (0, $fhlQp.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $33c2057624e26cc6$var$AlertMessage = (0, $fhlQp.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $33c2057624e26cc6$var$AlertAction = (0, $fhlQp.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $33c2057624e26cc6$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0dfb28a9f5e0cf89$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $592Nh.jsx)((0, $955d856f1c56515f$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $592Nh.jsx)((0, $88e53905b70c14b0$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0322c3e11b9b9a30$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $33c2057624e26cc6$var$Alert = /*#__PURE__*/ $2hDQc.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $33c2057624e26cc6$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $gZOiq.default)(props, $33c2057624e26cc6$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $33c2057624e26cc6$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $e06505996467b5ce$export$2e2bcd8739ae039);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($33c2057624e26cc6$var$AlertRoot, (0, $kxIgO.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $592Nh.jsx)($33c2057624e26cc6$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $33c2057624e26cc6$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $592Nh.jsx)($33c2057624e26cc6$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $592Nh.jsx)($33c2057624e26cc6$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $592Nh.jsx)($33c2057624e26cc6$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $592Nh.jsx)(AlertCloseButton, (0, $kxIgO.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)(AlertCloseIcon, (0, $kxIgO.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $33c2057624e26cc6$export$2e2bcd8739ae039 = $33c2057624e26cc6$var$Alert;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $734d472f0fa83e79$export$5269a5bce2c2f987(slot) {
    return (0, $01COD.default)("MuiAlertTitle", slot);
}
const $734d472f0fa83e79$var$alertTitleClasses = (0, $eLydt.default)("MuiAlertTitle", [
    "root"
]);
var $734d472f0fa83e79$export$2e2bcd8739ae039 = $734d472f0fa83e79$var$alertTitleClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $c4e899b1e5af2fa6$var$_excluded = [
    "className"
];
const $c4e899b1e5af2fa6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $734d472f0fa83e79$export$5269a5bce2c2f987), classes);
};
const $c4e899b1e5af2fa6$var$AlertTitleRoot = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $c4e899b1e5af2fa6$var$AlertTitle = /*#__PURE__*/ $2hDQc.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $gZOiq.default)(props, $c4e899b1e5af2fa6$var$_excluded);
    const ownerState = props;
    const classes = $c4e899b1e5af2fa6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($c4e899b1e5af2fa6$var$AlertTitleRoot, (0, $kxIgO.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $fLRFO.default)(classes.root, className)
    }, other));
});
var $c4e899b1e5af2fa6$export$2e2bcd8739ae039 = $c4e899b1e5af2fa6$var$AlertTitle;


const $f3fa5d7307d7d7b0$export$1da928963a217e70 = ({ title: title, children: children, severity: severity = "error", style: style })=>{
    const isChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).isValidElement(children);
    const RenderOnlyTitle = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)("b", {
            children: title
        });
    };
    const RenderOnlyDescription = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
            children: children
        });
    };
    const RenderAll = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $c4e899b1e5af2fa6$export$2e2bcd8739ae039), {
                    children: title
                }),
                children
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $33c2057624e26cc6$export$2e2bcd8739ae039), {
        severity: severity,
        style: style,
        children: title && isChildren ? /*#__PURE__*/ (0, $592Nh.jsx)(RenderAll, {}) : title ? /*#__PURE__*/ (0, $592Nh.jsx)(RenderOnlyTitle, {}) : /*#__PURE__*/ (0, $592Nh.jsx)(RenderOnlyDescription, {})
    });
};


const $9c0eb4be3833c653$var$ModalEditVehicle = ({ open: open, rightId: rightId, catalogueId: catalogueId, licensePlate: licensePlate, costCenter: costCenter, project: project, onTerminated: onTerminated, onSubmit: onSubmit, onCancel: onCancel, showAccountingFields: showAccountingFields })=>{
    const FORM_REFERENCE = "formEditVehicle";
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const [confirmationTerminateRight, setConfirmationTerminateRight] = (0, $2hDQc.useState)(false);
    const [endReason, setEndReason] = (0, $2hDQc.useState)("");
    const [endReasonMissing, setEndReasonMissing] = (0, $2hDQc.useState)(false);
    const queryCatalog = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$93e1682d8eaccc31),
            catalogueId
        ],
        queryFn: ()=>(0, $be730b8591848347$export$25753268427e50ea).getCataloguesByRef(catalogueId),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc),
        enabled: !!catalogueId
    });
    const isWebshopCatalogue = queryCatalog.data?.type === "WEBSHOP";
    const changeRightMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $46f3ff004257dc9a$export$2e2bcd8739ae039).changeLicensePlate(rightId, dto),
        onSuccess: (response)=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "modalEditVehicle.actions.change"
            }));
            onSubmit(response.data);
        }
    });
    const updateRightHolder = (licensePlate)=>{
        const dto = {
            licensePlate: licensePlate ? licensePlate.trim().toLocaleUpperCase() : ""
        };
        if (dto.licensePlate) changeRightMutation.mutate(dto);
    };
    const terminateRightMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (endRight)=>(0, $46f3ff004257dc9a$export$2e2bcd8739ae039).endRight(rightId, endRight),
        onSuccess: (response)=>{
            setConfirmationTerminateRight(false);
            setEndReason("");
            setEndReasonMissing(false);
            onTerminated();
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "modalEditVehicle.actions.rightEnded"
            }));
        }
    });
    const cancel = ()=>{
        changeRightMutation.reset();
        onCancel();
    };
    const cancelConfirmation = ()=>{
        setConfirmationTerminateRight(false);
        setEndReasonMissing(false);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
                open: open,
                onCancel: cancel,
                formReference: FORM_REFERENCE,
                mutation: changeRightMutation,
                errorTitleKey: "common.actions.update.error",
                modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "modalEditVehicle.title"
                }),
                submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "common.buttons.update"
                }),
                disableSubmit: isWebshopCatalogue,
                leftSideButtons: isPermission("DELETE", "RIGHTS") ? [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        color: "error",
                        onClick: ()=>{
                            setConfirmationTerminateRight(true);
                        },
                        variant: "text",
                        disabled: isWebshopCatalogue,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "common.buttons.terminate"
                        })
                    }, "terminate")
                ] : undefined,
                children: [
                    isWebshopCatalogue && /*#__PURE__*/ (0, $592Nh.jsx)((0, $f3fa5d7307d7d7b0$export$1da928963a217e70), {
                        title: intl.formatMessage({
                            id: "modalEditVehicle.webshopWarning"
                        }),
                        severity: "warning",
                        style: {
                            marginBottom: "1rem"
                        }
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $775d67ecd9fb7af5$export$2e2bcd8739ae039), {
                        formReference: FORM_REFERENCE,
                        licensePlate: licensePlate,
                        costCenter: costCenter,
                        project: project,
                        onSubmit: updateRightHolder,
                        showAccountingFields: showAccountingFields
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $03bdcb6e7b9b2179$export$2e2bcd8739ae039), {
                open: confirmationTerminateRight,
                lang: {
                    confirmButton: "common.buttons.yes",
                    error: "modalEditVehicle.actions.error.end"
                },
                header: intl.formatMessage({
                    id: "modalEditVehicle.modalRemove.header"
                }),
                content: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                marginBottom: "1em"
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "modalEditVehicle.modalRemove.content",
                                values: {
                                    licensePlate: licensePlate
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "endReason",
                                "data-testid": "endReason",
                                value: endReason,
                                autoFocus: true,
                                multiline: true,
                                error: endReasonMissing,
                                errorText: endReasonMissing ? intl.formatMessage({
                                    id: "common.form.errors.empty"
                                }) : "",
                                label: intl.formatMessage({
                                    id: "modalEditVehicle.modalRemove.content.endReason"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "modalEditVehicle.modalRemove.content.endReason.placeholder"
                                }),
                                onChange: (evt)=>{
                                    setEndReason(evt.target.value);
                                    setEndReasonMissing(false);
                                }
                            })
                        })
                    ]
                }),
                onCancel: cancelConfirmation,
                onConfirm: ()=>{
                    if (endReason) terminateRightMutation.mutate({
                        validityEnd: (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).nowToUTC(),
                        endReason: endReason
                    });
                    else setEndReasonMissing(true);
                },
                mutation: terminateRightMutation
            })
        ]
    });
};
var $9c0eb4be3833c653$export$2e2bcd8739ae039 = $9c0eb4be3833c653$var$ModalEditVehicle;



var $592Nh = parcelRequire("592Nh");


var $592Nh = parcelRequire("592Nh");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $2hDQc = parcelRequire("2hDQc");
"use client";
/**
 * @ignore - internal component.
 */ const $8e8f5df0158f47bd$var$ListContext = /*#__PURE__*/ $2hDQc.createContext({});
var $8e8f5df0158f47bd$export$2e2bcd8739ae039 = $8e8f5df0158f47bd$var$ListContext;






var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $9a07995a2f6453fd$export$46f01d01378ec5a2(slot) {
    return (0, $01COD.default)("MuiDivider", slot);
}
const $9a07995a2f6453fd$var$dividerClasses = (0, $eLydt.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $9a07995a2f6453fd$export$2e2bcd8739ae039 = $9a07995a2f6453fd$var$dividerClasses;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $f68e01e6c6c209b4$export$81478e24460c57f2(slot) {
    return (0, $01COD.default)("MuiListItemIcon", slot);
}
const $f68e01e6c6c209b4$var$listItemIconClasses = (0, $eLydt.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $f68e01e6c6c209b4$export$2e2bcd8739ae039 = $f68e01e6c6c209b4$var$listItemIconClasses;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $b7a01c39f36d7d73$export$1061006a0db3aeb5(slot) {
    return (0, $01COD.default)("MuiListItemText", slot);
}
const $b7a01c39f36d7d73$var$listItemTextClasses = (0, $eLydt.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $b7a01c39f36d7d73$export$2e2bcd8739ae039 = $b7a01c39f36d7d73$var$listItemTextClasses;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $f0a85f9caae732e1$export$515f8c67b5305377(slot) {
    return (0, $01COD.default)("MuiMenuItem", slot);
}
const $f0a85f9caae732e1$var$menuItemClasses = (0, $eLydt.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $f0a85f9caae732e1$export$2e2bcd8739ae039 = $f0a85f9caae732e1$var$menuItemClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $a34e3655834f552c$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $a34e3655834f552c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $a34e3655834f552c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $f0a85f9caae732e1$export$515f8c67b5305377), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $a34e3655834f552c$var$MenuItemRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $a34e3655834f552c$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $f0a85f9caae732e1$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $f0a85f9caae732e1$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $f0a85f9caae732e1$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $f0a85f9caae732e1$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $f0a85f9caae732e1$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $9a07995a2f6453fd$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $9a07995a2f6453fd$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $b7a01c39f36d7d73$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $b7a01c39f36d7d73$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $f68e01e6c6c209b4$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $kxIgO.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $f68e01e6c6c209b4$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $a34e3655834f552c$var$MenuItem = /*#__PURE__*/ $2hDQc.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $gZOiq.default)(props, $a34e3655834f552c$var$_excluded);
    const context = $2hDQc.useContext((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039));
    const childContext = $2hDQc.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $2hDQc.useRef(null);
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $a34e3655834f552c$var$useUtilityClasses(props);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($a34e3655834f552c$var$MenuItemRoot, (0, $kxIgO.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $fLRFO.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $fLRFO.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $a34e3655834f552c$export$2e2bcd8739ae039 = $a34e3655834f552c$var$MenuItem;




var $2hDQc = parcelRequire("2hDQc");

var $5pzCu = parcelRequire("5pzCu");




function $d0a1f62c0ded2cbf$export$2e2bcd8739ae039() {
    const dispatch = (0, $ca980beea4c3b32c$export$8ad76b76a4c905f8)();
    const setInitialized = (initialized)=>{
        dispatch((0, $d79f754417ba871e$export$bbe1eb340cdbd464)(initialized));
    };
    const setCustomer = (customer, defineCustomType = false)=>{
        let customerToBeSet = {
            id: "",
            name: ""
        };
        let customerTypeToBeSet = "";
        if (!customer) {
            if (defineCustomType) dispatch((0, $7d14d2e2868bd10d$export$3160f67d8720ec42)(customerTypeToBeSet));
            dispatch((0, $d79f754417ba871e$export$ae66d5a6ca962c9a)(customerToBeSet));
            return;
        }
        customerToBeSet = {
            id: customer.id,
            name: customer.name
        };
        customerTypeToBeSet = customer.type;
        if (defineCustomType) dispatch((0, $7d14d2e2868bd10d$export$3160f67d8720ec42)(customerTypeToBeSet?.charAt(0)));
        dispatch((0, $d79f754417ba871e$export$ae66d5a6ca962c9a)(customerToBeSet));
    };
    const setCustomerFromArray = (customers, defineCustomType = false)=>{
        // At first, try to find landlord user
        let firstCustomer = customers.find((item)=>!item.parentId && item.type === "LANDLORD");
        // If not, use the first tenant
        if (!firstCustomer) firstCustomer = customers.find((item)=>item.type === "TENANT");
        setCustomer(firstCustomer, defineCustomType);
    };
    const place = (0, $704baa9769160210$export$2105062e25df4afe)((0, $d79f754417ba871e$export$1c46e3decb4a80c2).getPlace);
    const setPlace = (newPlace)=>{
        let placeToBeSet = {
            id: "",
            name: ""
        };
        if (!newPlace) {
            if (!place || !place.id || !place.name) dispatch((0, $d79f754417ba871e$export$2f52b3443c11c15a)(placeToBeSet));
            return;
        }
        placeToBeSet = {
            id: newPlace.id,
            name: newPlace.name
        };
        if (place.id != placeToBeSet.id || place.name.localeCompare(newPlace.name)) dispatch((0, $d79f754417ba871e$export$2f52b3443c11c15a)(placeToBeSet));
    };
    const setPlaceFromArray = (places)=>{
        const firstPlace = places?.find((item)=>!item.parentId);
        setPlace(firstPlace);
        setInitialized(true);
    };
    const setPlaceFromCatalogue = (catalogue)=>{
        setPlace({
            id: catalogue.place?.id,
            name: catalogue.place?.name
        });
        setCatalogueId(catalogue.id);
        setInitialized(true);
    };
    const setCatalogueId = (catalogueId)=>{
        dispatch((0, $d79f754417ba871e$export$12af370a2d55934d)(catalogueId));
    };
    const catalogueId = (0, $704baa9769160210$export$2105062e25df4afe)((0, $d79f754417ba871e$export$1c46e3decb4a80c2).getCatalogueId);
    const customer = (0, $704baa9769160210$export$2105062e25df4afe)((0, $d79f754417ba871e$export$1c46e3decb4a80c2).getCustomer);
    const customerConfigured = !!place.id && !!customer.id;
    const initialized = (0, $704baa9769160210$export$2105062e25df4afe)((0, $d79f754417ba871e$export$1c46e3decb4a80c2).getInitialized);
    return {
        setPlace: setPlace,
        setPlaceFromArray: setPlaceFromArray,
        setPlaceFromCatalogue: setPlaceFromCatalogue,
        place: place,
        setCustomer: setCustomer,
        setCustomerFromArray: setCustomerFromArray,
        customer: customer,
        setInitialized: setInitialized,
        initialized: initialized,
        customerConfigured: customerConfigured,
        setCatalogueId: setCatalogueId,
        catalogueId: catalogueId
    };
}


const $afa58e60223f8bda$var$FormSubPlace = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { customer: customer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const customerOptions = props.customers.map((item)=>{
        return {
            key: item.id,
            value: item.name
        };
    });
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const SubPlaceSchema = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            name: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            capacity: $7a5dda49dca6ae9d$export$98e628dec113755e().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })).typeError(intl.formatMessage({
                id: "common.form.errors.number"
            })),
            streetAddress: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            postalCode: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            city: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            }))
        });
    };
    const getFormDefaultValues = ()=>{
        return {
            name: props.defaultValues?.name || "",
            capacity: props.defaultValues?.capacity || "",
            streetAddress: props.defaultValues?.streetAddress || "",
            postalCode: props.defaultValues?.postalCode || "",
            city: props.defaultValues?.city || "",
            customerId: props.defaultValues?.customerId || customer.id
        };
    };
    const [defaultValues, setDefaultValues] = (0, $2hDQc.useState)(getFormDefaultValues());
    (0, $2hDQc.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.name,
        props.defaultValues?.capacity
    ]);
    const onSubmitFormValues = (values)=>{
        const { name: name, capacity: capacity, streetAddress: streetAddress, postalCode: postalCode, city: city, customerId: customerId } = values;
        props.onSubmit({
            name: name.trim(),
            capacity: capacity.trim(),
            streetAddress: streetAddress.trim(),
            postalCode: postalCode.trim(),
            city: city.trim(),
            customerId: customerId
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            enableReinitialize: true,
            validate: ()=>setFormikValidateOnChange(true),
            validateOnChange: formikValidateOnChange,
            initialValues: defaultValues,
            validationSchema: SubPlaceSchema(),
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $592Nh.jsxs)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)("h4", {
                            style: {
                                marginTop: "5px"
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.customer.formSubPlace.title.location"
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                            gap: 2,
                            display: "flex",
                            flexDirection: {
                                xs: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormSelect, {
                                        name: "customerId",
                                        label: intl.formatMessage({
                                            id: "page.places.formPlace.label.customer"
                                        }),
                                        value: values.customerId,
                                        onChange: handleChange,
                                        error: !!errors.customerId,
                                        children: customerOptions.map((item)=>{
                                            return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                                                value: item.key,
                                                children: item.value
                                            }, item.key);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                            fullWidth: true,
                                            name: "name",
                                            "data-testid": "name",
                                            value: values.name,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.name"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.name"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.name,
                                            errorText: errors.name
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                            name: "streetAddress",
                                            "data-testid": "streetAddress",
                                            value: values.streetAddress,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.streetAddress"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.streetAddress"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.streetAddress,
                                            errorText: errors.streetAddress
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                            name: "postalCode",
                                            "data-testid": "postalCode",
                                            value: values.postalCode,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.postalCode"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.postalCode"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.postalCode,
                                            errorText: errors.postalCode
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                            name: "city",
                                            "data-testid": "city",
                                            value: values.city,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.city"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.city"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.city,
                                            errorText: errors.city
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("h4", {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.customer.formSubPlace.title.space"
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "capacity",
                                "data-testid": "capacity",
                                value: values.capacity,
                                label: intl.formatMessage({
                                    id: "page.customer.formSubPlace.label.spots"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.customer.formSubPlace.label.spots"
                                }),
                                onChange: handleChange,
                                error: !!errors.capacity,
                                errorText: errors.capacity
                            })
                        })
                    ]
                })
        })
    });
};
var $afa58e60223f8bda$export$2e2bcd8739ae039 = $afa58e60223f8bda$var$FormSubPlace;





const $fb3b91fdd894004c$var$BASE_URL = `customers`;
const $fb3b91fdd894004c$var$getUrl = (admin)=>`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(admin)}/${$fb3b91fdd894004c$var$BASE_URL}`;
const $fb3b91fdd894004c$var$createCustomer = (customer)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post($fb3b91fdd894004c$var$getUrl(false), customer);
};
const $fb3b91fdd894004c$var$updateCustomer = (ref, customer)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).put(`${$fb3b91fdd894004c$var$getUrl(false)}/${ref}`, customer);
};
const $fb3b91fdd894004c$var$getCustomerByRef = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$fb3b91fdd894004c$var$getUrl(false)}/${ref}`).then((response)=>response.data);
};
const $fb3b91fdd894004c$var$getCustomers = (admin, queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get($fb3b91fdd894004c$var$getUrl(admin), queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $fb3b91fdd894004c$var$getLandlords = (admin, queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$fb3b91fdd894004c$var$getUrl(admin)}/landlords`, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $fb3b91fdd894004c$var$getIndividualsByCustomer = (admin, ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$fb3b91fdd894004c$var$getUrl(false)}/${ref}/right-holders/individuals`).then((response)=>response.data);
};
const $fb3b91fdd894004c$var$getPlacesByCustomer = (admin, ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$fb3b91fdd894004c$var$getUrl(admin)}/${ref}/places`).then((response)=>response.data);
};
const $fb3b91fdd894004c$var$getUsersByCustomer = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$fb3b91fdd894004c$var$getUrl(false)}/${ref}/users`).then((response)=>response.data);
};
const $fb3b91fdd894004c$var$removeUser = (customerId, userId)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).delete(`${(0, $1ff9aa7c00d3fc54$export$ff0725f0ea898f41)}/${$fb3b91fdd894004c$var$BASE_URL}/${customerId}/users/${userId}`);
};
const $fb3b91fdd894004c$var$CustomersAPI = {
    createCustomer: $fb3b91fdd894004c$var$createCustomer,
    updateCustomer: $fb3b91fdd894004c$var$updateCustomer,
    getCustomerByRef: $fb3b91fdd894004c$var$getCustomerByRef,
    getCustomers: $fb3b91fdd894004c$var$getCustomers,
    getLandlords: $fb3b91fdd894004c$var$getLandlords,
    getIndividualsByCustomer: $fb3b91fdd894004c$var$getIndividualsByCustomer,
    getPlacesByCustomer: $fb3b91fdd894004c$var$getPlacesByCustomer,
    removeUser: $fb3b91fdd894004c$var$removeUser,
    getUsersByCustomer: $fb3b91fdd894004c$var$getUsersByCustomer
};
var $fb3b91fdd894004c$export$2e2bcd8739ae039 = $fb3b91fdd894004c$var$CustomersAPI;







const $a37004fca245d806$var$BASE_URL = `${(0, $1ff9aa7c00d3fc54$export$ff0725f0ea898f41)}/places`;
const $a37004fca245d806$var$BASE_ADMIN_URL = `${(0, $1ff9aa7c00d3fc54$export$662364dbe336d1ec)}/places`;
const $a37004fca245d806$var$createPlaceWithDefaultOffering = (place)=>{
    place.createDefaultOffering = true;
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post($a37004fca245d806$var$BASE_URL, place);
};
const $a37004fca245d806$var$updatePlace = (ref, place)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).put(`${$a37004fca245d806$var$BASE_URL}/${ref}`, place);
};
const $a37004fca245d806$var$getPlaceByRef = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$a37004fca245d806$var$BASE_URL}/${ref}`).then((response)=>response.data);
};
const $a37004fca245d806$var$getOfferingsByPlace = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$a37004fca245d806$var$BASE_URL}/${ref}/offering`).then((response)=>response.data);
};
const $a37004fca245d806$var$getPlaces = (queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get($a37004fca245d806$var$BASE_ADMIN_URL, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $a37004fca245d806$export$2bffccb0f948be1f = {
    createPlaceWithDefaultOffering: $a37004fca245d806$var$createPlaceWithDefaultOffering,
    updatePlace: $a37004fca245d806$var$updatePlace,
    getPlaceByRef: $a37004fca245d806$var$getPlaceByRef,
    getPlaces: $a37004fca245d806$var$getPlaces,
    getOfferingsByPlace: $a37004fca245d806$var$getOfferingsByPlace
};
const $a37004fca245d806$export$17a026f5eed4231 = {
    getPlaces: $a37004fca245d806$var$getPlaces
};




const $584154d17c229856$var$ModalSubPlace = (props)=>{
    const FORM_REFERENCE = "formSubPlace";
    const { place: place } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const { admin: admin } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const queryCustomers = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$6efe1800fcda6819)
        ],
        // TODO Antti: Should be fixed later because there might be more than 500 customers.
        // Anyway, this code is not in use so far because UI does not support adding sub places
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getCustomers(admin, {
                limit: 500,
                sort: "TYPE",
                direction: "ASC"
            }),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const customers = queryCustomers.data?.data || [];
    const queryPlace = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$823cd27a3f5f229e),
            place.id
        ],
        queryFn: ()=>(0, $a37004fca245d806$export$2bffccb0f948be1f).getPlaceByRef(place.id || ""),
        enabled: !!place.id
    });
    const defaultValues = {
        name: "",
        streetAddress: queryPlace.data?.streetAddress || "",
        postalCode: queryPlace.data?.postalCode || "",
        city: queryPlace.data?.city || "",
        capacity: "",
        customerId: queryPlace.data?.customer?.id || props.customerId
    };
    const subPlaceMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $a37004fca245d806$export$2bffccb0f948be1f).createPlaceWithDefaultOffering(dto),
        onSuccess: (response)=>{
            const place = response.data || {};
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "components.modalSubPlace.actions.added"
            }));
            props.onSubmit(place);
        }
    });
    const addSubPlace = (values)=>{
        const { name: name, capacity: capacity, streetAddress: streetAddress, postalCode: postalCode, city: city, customerId: customerId } = values;
        const dto = {
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            customerId: customerId,
            parentId: place.id,
            capacity: Number.parseInt(capacity)
        };
        subPlaceMutation.mutate(dto);
    };
    const cancel = ()=>{
        subPlaceMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            mutation: subPlaceMutation,
            errorTitleKey: "components.modalSubPlace.actions.error.added",
            modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "components.modalSubPlace.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "components.modalSubPlace.button.add"
            }),
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $afa58e60223f8bda$export$2e2bcd8739ae039), {
                formReference: FORM_REFERENCE,
                onSubmit: addSubPlace,
                defaultValues: defaultValues,
                customers: customers
            })
        })
    });
};
var $584154d17c229856$export$2e2bcd8739ae039 = $584154d17c229856$var$ModalSubPlace;



var $592Nh = parcelRequire("592Nh");





const $95124b73b270900a$var$TableSubPlaces = (props)=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const { queryPlaces: queryPlaces, places: places } = props;
    const onClickRow = (placeRef, parentPlaceRef)=>{
        !!parentPlaceRef ? navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${parentPlaceRef}${(0, $c753d58728ea6715$export$25c4819f1669a599).SUB_PLACES}/${placeRef}`) : navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${placeRef}`);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                emptyTextId: "components.tableSubPlaces.action.empty",
                errorTextId: "components.tableSubPlaces.action.failed",
                query: queryPlaces,
                children: places.map((row)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                        cardTitle: row.name,
                        cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                            utcDateTime: row.updatedAt
                        }),
                        cardContentList: [
                            row.streetAddress,
                            row.postalCode,
                            row.city
                        ],
                        onCardClicked: ()=>onClickRow(row.id, row.parentId)
                    }, row.id))
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                items: places,
                emptyTextId: "components.tableSubPlaces.action.empty",
                errorTextId: "components.tableSubPlaces.action.failed",
                query: queryPlaces,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.customer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.streetAddress"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.postalCode"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.city"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.capacity"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                        "data-testid": "places-table-body",
                        children: places.map((row)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                hover: true,
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>onClickRow(row.id, row.parentId),
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                            bold: true,
                                            children: row.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.customer?.name
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.streetAddress
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.postalCode
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.city
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.capacity
                                    })
                                ]
                            }, row.id))
                    })
                ]
            })
        ]
    });
};
var $95124b73b270900a$export$2e2bcd8739ae039 = $95124b73b270900a$var$TableSubPlaces;



var $592Nh = parcelRequire("592Nh");



var $fhlQp = parcelRequire("fhlQp");
const $ea52dc2553d5098f$var$TimeStampItems = ({ createdAt: createdAt, updatedAt: updatedAt, createdText: createdText, dateOnly: dateOnly })=>{
    const Item = (0, $fhlQp.default)("span")`
    display: block;
    margin: 0;
  `;
    const StyledLabel = (0, $fhlQp.default)("span")`
    margin-right: 0.3rem;
  `;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)(StyledLabel, {
                        children: createdText ? createdText : /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "timeStampItems.createdAt"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                        utcDateTime: createdAt,
                        emptyText: "-",
                        dateOnly: dateOnly
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)(StyledLabel, {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "timeStampItems.updatedAt"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                        utcDateTime: updatedAt,
                        emptyText: "-",
                        dateOnly: dateOnly
                    })
                ]
            })
        ]
    });
};
var $ea52dc2553d5098f$export$2e2bcd8739ae039 = $ea52dc2553d5098f$var$TimeStampItems;



var $592Nh = parcelRequire("592Nh");

var $2hDQc = parcelRequire("2hDQc");
/**
 * Some libraries may not follow Node ES module spec and could be loaded as CommonJS modules,
 * To ensure the interoperability between ESM and CJS, modules from those libraries have to be loaded via namespace import
 * And sanitized by the function below because unlike ESM namespace, CJS namespace set `module.exports` object on the `default` key
 * https://nodejs.org/api/esm.html#interoperability-with-commonjs
 */ const $85b840b81f21bd6d$export$fa356a32a7b5bee2 = (namespaceModule)=>{
    const sanitizedNamespaceModule = {
        default: undefined,
        ...namespaceModule
    };
    return sanitizedNamespaceModule.default ?? sanitizedNamespaceModule;
};
/**
 * Checks if `value` is an Object (non-primitive, non-array, non-function)
 * Will return false for Arrays and functions
 *
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is an object, `false` otherwise
 */ function $85b840b81f21bd6d$export$a6cdc56e425d0d0a(value) {
    return value != null && !Array.isArray(value) && typeof value === "object";
}
/**
 * Checks if `value` is a string primitive or object
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a string, `false` otherwise
 */ function $85b840b81f21bd6d$export$844ec244b1367d54(value) {
    return typeof value === "string" || typeof value === "object" && Object.prototype.toString.call(value) === "[object String]";
}
/**
 * Checks if `value` is a Map
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a Map, `false` otherwise
 */ function $85b840b81f21bd6d$export$5c90113a285f2241(value) {
    return $85b840b81f21bd6d$export$a6cdc56e425d0d0a(value) && Object.prototype.toString.call(value) === "[object Map]";
}
/**
 * Checks if `value` is a Set
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a Set, `false` otherwise
 */ function $85b840b81f21bd6d$export$6750766a7c7ec627(value) {
    return $85b840b81f21bd6d$export$a6cdc56e425d0d0a(value) && Object.prototype.toString.call(value) === "[object Set]";
}
/**
 * Checks if `value` is undefined
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is undefined, `false` otherwise
 */ function $85b840b81f21bd6d$export$fce6876652108ab(value) {
    return value === undefined;
}
/**
 * Checks if `value` is nullish
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is nullish, `false` otherwise
 */ function $85b840b81f21bd6d$export$984f70f9382f5d27(value) {
    return value == null;
}
/**
 * Checks if `value` is empty
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is empty, `false` otherwise
 */ function $85b840b81f21bd6d$export$dd1bc94b04021eeb(value) {
    if (value === null || value === undefined) return true;
    if ($85b840b81f21bd6d$export$a6cdc56e425d0d0a(value) && ($85b840b81f21bd6d$export$5c90113a285f2241(value) || $85b840b81f21bd6d$export$6750766a7c7ec627(value))) return !value.size;
    if ($85b840b81f21bd6d$export$a6cdc56e425d0d0a(value) && ($85b840b81f21bd6d$export$844ec244b1367d54(value) || Array.isArray(value))) return !value.length;
    for(const key in value){
        if ($85b840b81f21bd6d$export$a4f4bb6b1453fff5(value, key)) return false;
    }
    return true;
}
/**
 * Checks if `value` is an empty array
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a empty, `false` otherwise
 */ function $85b840b81f21bd6d$var$isEmptyArray(value) {
    return Array.isArray(value) && $85b840b81f21bd6d$export$dd1bc94b04021eeb(value);
}
/**
 * Checks if all members of the `values` param are empty arrays
 *
 * @param {unknown} value The values to check
 * @returns {boolean} Returns `true` if all members of `values` are empty, `false` otherwise
 */ function $85b840b81f21bd6d$export$2c02be4a78959098(...values) {
    return values.every($85b840b81f21bd6d$var$isEmptyArray);
}
/**
 * Checks if `value` is an empty object
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is empty, `false` otherwise
 */ function $85b840b81f21bd6d$export$83b788b1a3698c03(value) {
    return $85b840b81f21bd6d$export$a6cdc56e425d0d0a(value) && $85b840b81f21bd6d$export$dd1bc94b04021eeb(value);
}
/**
 * Checks if all members of the `values` param are empty objects
 *
 * @param {unknown} values The values to check
 * @returns {boolean} Returns `true` if all members of the `values` param are empty, `false` otherwise
 */ function $85b840b81f21bd6d$export$d6708a3543c32fe4(...values) {
    return values.every($85b840b81f21bd6d$export$83b788b1a3698c03);
}
/**
 * Capitalizes `value` and its return type
 *
 * @param {string} value string to capitalize
 * @returns {string} capitalized string
 */ function $85b840b81f21bd6d$export$9a00dee1beb8f576(value) {
    return $85b840b81f21bd6d$export$844ec244b1367d54(value) ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}
/**
 * Checks if `key` is a direct property of `value`
 *
 * @param {unknown} value `object` potentially containing property
 * @param {string} key property key
 * @returns whether `key` param is a property of the `obj` param
 */ function $85b840b81f21bd6d$export$a4f4bb6b1453fff5(value, key) {
    return value != null && Object.prototype.hasOwnProperty.call(value, key);
}
/**
 * Checks if `value` is a function
 *
 * @param {unknown} value param to check
 * @returns {boolean} whether `value` is a function
 */ function $85b840b81f21bd6d$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
/**
 * This helper function creates modifier class names that are used for our flat BEM styling
 * it takes in a base and modifier and returns the modified class if a modifier was passed in and null otherwise
 * @param base The base class of the output
 * @param modifier The modifier to add onto the base
 * @returns the modified class name or empty string
 */ const $85b840b81f21bd6d$export$1d6fb99b5e148be8 = (base, modifier)=>{
    return modifier ? `${base}--${modifier}` : "";
};
/**
 * This helper function creates modified class names that are used for our flat BEM styling
 * it takes in a base, modifier, and flag and returns the modified class name if the flag is true and null if the flag is false
 * @param base
 * @param modifier
 * @param flag
 * @returns the modified class name or empty string
 */ const $85b840b81f21bd6d$export$3c152e7b97c7496c = (base, modifier, flag)=>{
    return flag ? `${base}--${modifier}` : "";
};
/**
 * `isFunction` but types the param with its function signature
 *
 * @param {unknown} value param to check
 * @returns {boolean} whether `value` is a function
 */ function $85b840b81f21bd6d$export$669248cdfeac1c30(value) {
    return $85b840b81f21bd6d$export$f6e2535fb5126e54(value);
}
/**
 * Similar to `Array.join`, with an optional callback/template param
 * for formatting returned string values
 *
 * @param {string[]} values string array
 * @param {(value: string) => string} template callback format param
 * @returns formatted string array
 */ function $85b840b81f21bd6d$export$41f379f522580228(values, template) {
    return values.reduce((acc, curr)=>`${acc}${$85b840b81f21bd6d$export$844ec244b1367d54(curr) ? template(curr) : ""}`, "");
}
/**
 * A function that does nothing
 *
 * @param {any[]} _ accepts any parameters
 * @returns nothing
 */ function $85b840b81f21bd6d$export$8793edee2d425525(..._) {
    return;
}
/**
 * @param {string} groupName name of group
 * @param events string values related to group
 */ function $85b840b81f21bd6d$export$c35e244fdf72907e(groupName, ...events) {
    const hasEvents = !!events?.length;
    if (hasEvents) {
        // eslint-disable-next-line no-console
        console.groupCollapsed(groupName);
        events?.forEach((event)=>{
            // eslint-disable-next-line no-console
            console.log(event);
        });
        // eslint-disable-next-line no-console
        console.groupEnd();
    } else // eslint-disable-next-line no-console
    console.log(groupName);
}



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
var $a34e6f08c3b801c5$var$index = (0, $2hDQc.useLayoutEffect);
var $a34e6f08c3b801c5$export$2e2bcd8739ae039 = $a34e6f08c3b801c5$var$index;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $465297b78447ad9b$export$18ce0697a983be9b = function() {
    $465297b78447ad9b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $465297b78447ad9b$export$18ce0697a983be9b.apply(this, arguments);
};
function $465297b78447ad9b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $465297b78447ad9b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $465297b78447ad9b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $465297b78447ad9b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4 || ($80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4 = {}));
var $80ddfa4e1f63e6fd$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($80ddfa4e1f63e6fd$export$79f5baa747fbdd45 || ($80ddfa4e1f63e6fd$export$79f5baa747fbdd45 = {}));



var $18e07f8ef0e00461$export$b060f3cec92ef5c9 = ".";
var $18e07f8ef0e00461$export$505a390a702f4a23 = {};
var $18e07f8ef0e00461$export$656461011b562379 = "xstate.guard";
var $18e07f8ef0e00461$export$31935b4577455331 = "";




var $28a07e6dd3d337a6$exports = {};

$parcel$export($28a07e6dd3d337a6$exports, "start", function () { return $28a07e6dd3d337a6$export$b3571188c770cc5a; });
$parcel$export($28a07e6dd3d337a6$exports, "stop", function () { return $28a07e6dd3d337a6$export$fa6813432f753b0d; });
$parcel$export($28a07e6dd3d337a6$exports, "raise", function () { return $28a07e6dd3d337a6$export$66313c302b2ea154; });
$parcel$export($28a07e6dd3d337a6$exports, "send", function () { return $28a07e6dd3d337a6$export$89db4734f6c919c4; });
$parcel$export($28a07e6dd3d337a6$exports, "cancel", function () { return $28a07e6dd3d337a6$export$70b61ad426ddbe54; });
$parcel$export($28a07e6dd3d337a6$exports, "nullEvent", function () { return $28a07e6dd3d337a6$export$9477ceca5dcd796a; });
$parcel$export($28a07e6dd3d337a6$exports, "assign", function () { return $28a07e6dd3d337a6$export$e6e34fd1f2686227; });
$parcel$export($28a07e6dd3d337a6$exports, "after", function () { return $28a07e6dd3d337a6$export$742acabee3dd6465; });
$parcel$export($28a07e6dd3d337a6$exports, "doneState", function () { return $28a07e6dd3d337a6$export$de2557b5933c9ac6; });
$parcel$export($28a07e6dd3d337a6$exports, "log", function () { return $28a07e6dd3d337a6$export$bef1f36f5486a6a3; });
$parcel$export($28a07e6dd3d337a6$exports, "init", function () { return $28a07e6dd3d337a6$export$2cd8252107eb640b; });
$parcel$export($28a07e6dd3d337a6$exports, "invoke", function () { return $28a07e6dd3d337a6$export$468cda29b159ee5d; });
$parcel$export($28a07e6dd3d337a6$exports, "errorExecution", function () { return $28a07e6dd3d337a6$export$aca059ee6fbf94e8; });
$parcel$export($28a07e6dd3d337a6$exports, "errorPlatform", function () { return $28a07e6dd3d337a6$export$503a23d0e5cd1226; });
$parcel$export($28a07e6dd3d337a6$exports, "error", function () { return $28a07e6dd3d337a6$export$a3bc9b8ed74fc; });
$parcel$export($28a07e6dd3d337a6$exports, "update", function () { return $28a07e6dd3d337a6$export$722fbec263ad908a; });
$parcel$export($28a07e6dd3d337a6$exports, "choose", function () { return $28a07e6dd3d337a6$export$7877a478dd30fd3d; });
$parcel$export($28a07e6dd3d337a6$exports, "pure", function () { return $28a07e6dd3d337a6$export$48ec4a2b1cfc6557; });

var $28a07e6dd3d337a6$export$b3571188c770cc5a = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Start;
var $28a07e6dd3d337a6$export$fa6813432f753b0d = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Stop;
var $28a07e6dd3d337a6$export$66313c302b2ea154 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Raise;
var $28a07e6dd3d337a6$export$89db4734f6c919c4 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Send;
var $28a07e6dd3d337a6$export$70b61ad426ddbe54 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Cancel;
var $28a07e6dd3d337a6$export$9477ceca5dcd796a = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).NullEvent;
var $28a07e6dd3d337a6$export$e6e34fd1f2686227 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Assign;
var $28a07e6dd3d337a6$export$742acabee3dd6465 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).After;
var $28a07e6dd3d337a6$export$de2557b5933c9ac6 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).DoneState;
var $28a07e6dd3d337a6$export$bef1f36f5486a6a3 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Log;
var $28a07e6dd3d337a6$export$2cd8252107eb640b = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Init;
var $28a07e6dd3d337a6$export$468cda29b159ee5d = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Invoke;
var $28a07e6dd3d337a6$export$aca059ee6fbf94e8 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).ErrorExecution;
var $28a07e6dd3d337a6$export$503a23d0e5cd1226 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).ErrorPlatform;
var $28a07e6dd3d337a6$export$a3bc9b8ed74fc = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).ErrorCustom;
var $28a07e6dd3d337a6$export$722fbec263ad908a = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Update;
var $28a07e6dd3d337a6$export$7877a478dd30fd3d = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Choose;
var $28a07e6dd3d337a6$export$48ec4a2b1cfc6557 = (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Pure;



var $12632c59f8871ae5$export$9b5f2e1c20ef6571 = true;


var $8c2ce3e7c653a1d4$var$_a;
function $8c2ce3e7c653a1d4$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $8c2ce3e7c653a1d4$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $18e07f8ef0e00461$export$b060f3cec92ef5c9);
    var parentStateValue = $8c2ce3e7c653a1d4$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $8c2ce3e7c653a1d4$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($8c2ce3e7c653a1d4$export$844ec244b1367d54(childStateValue)) {
        if ($8c2ce3e7c653a1d4$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($8c2ce3e7c653a1d4$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $8c2ce3e7c653a1d4$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $8c2ce3e7c653a1d4$export$7193fc8c8cd445e9(event) {
    try {
        return $8c2ce3e7c653a1d4$export$844ec244b1367d54(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function $8c2ce3e7c653a1d4$export$e303144c5506946a(action) {
    try {
        return $8c2ce3e7c653a1d4$export$844ec244b1367d54(action) || typeof action === "number" ? "".concat(action) : $8c2ce3e7c653a1d4$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function $8c2ce3e7c653a1d4$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($8c2ce3e7c653a1d4$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $8c2ce3e7c653a1d4$export$e080e3931a079c9b(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function $8c2ce3e7c653a1d4$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($8c2ce3e7c653a1d4$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($8c2ce3e7c653a1d4$export$43bee75e5e14138e(stateValue)) return $8c2ce3e7c653a1d4$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = $8c2ce3e7c653a1d4$export$304cde62ecda7af8(stateValue, delimiter);
    return $8c2ce3e7c653a1d4$export$f2ee84fc53c45e74(statePath);
}
function $8c2ce3e7c653a1d4$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $8c2ce3e7c653a1d4$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $8c2ce3e7c653a1d4$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $8c2ce3e7c653a1d4$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $8c2ce3e7c653a1d4$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $8c2ce3e7c653a1d4$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($8c2ce3e7c653a1d4$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $8c2ce3e7c653a1d4$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $8c2ce3e7c653a1d4$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $8c2ce3e7c653a1d4$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $8c2ce3e7c653a1d4$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(array), false));
}
function $8c2ce3e7c653a1d4$export$2c0b6b2f4faf21e1(value) {
    if ($8c2ce3e7c653a1d4$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $8c2ce3e7c653a1d4$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $8c2ce3e7c653a1d4$export$2c0b6b2f4faf21e1(value);
}
function $8c2ce3e7c653a1d4$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($8c2ce3e7c653a1d4$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($8c2ce3e7c653a1d4$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $8c2ce3e7c653a1d4$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $8c2ce3e7c653a1d4$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($8c2ce3e7c653a1d4$export$f6e2535fb5126e54(value) || typeof value === "object") && $8c2ce3e7c653a1d4$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $8c2ce3e7c653a1d4$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function $8c2ce3e7c653a1d4$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $465297b78447ad9b$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $8c2ce3e7c653a1d4$export$3737909a0074eb1(hist, stateValue) {
    return $8c2ce3e7c653a1d4$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($8c2ce3e7c653a1d4$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $8c2ce3e7c653a1d4$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $8c2ce3e7c653a1d4$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $8c2ce3e7c653a1d4$export$3737909a0074eb1(hist, stateValue)
    };
}
function $8c2ce3e7c653a1d4$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($8c2ce3e7c653a1d4$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $8c2ce3e7c653a1d4$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d = function() {};
if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $8c2ce3e7c653a1d4$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $8c2ce3e7c653a1d4$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $8c2ce3e7c653a1d4$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $8c2ce3e7c653a1d4$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($8c2ce3e7c653a1d4$export$844ec244b1367d54(condition)) return {
        type: (0, $18e07f8ef0e00461$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($8c2ce3e7c653a1d4$export$f6e2535fb5126e54(condition)) return {
        type: (0, $18e07f8ef0e00461$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $8c2ce3e7c653a1d4$export$5cd057a6046189f9(value) {
    try {
        return "subscribe" in value && $8c2ce3e7c653a1d4$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $8c2ce3e7c653a1d4$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $8c2ce3e7c653a1d4$export$a6273dafbee7f61e = ($8c2ce3e7c653a1d4$var$_a = {}, $8c2ce3e7c653a1d4$var$_a[$8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
    return this;
}, $8c2ce3e7c653a1d4$var$_a[Symbol.observable] = function() {
    return this;
}, $8c2ce3e7c653a1d4$var$_a);
function $8c2ce3e7c653a1d4$export$2163e7903738b5df(value) {
    return !!value && "__xstatenode" in value;
}
function $8c2ce3e7c653a1d4$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === "function";
}
var $8c2ce3e7c653a1d4$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $8c2ce3e7c653a1d4$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($8c2ce3e7c653a1d4$export$844ec244b1367d54(event) || typeof event === "number") return (0, $465297b78447ad9b$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $8c2ce3e7c653a1d4$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$8c2ce3e7c653a1d4$export$844ec244b1367d54(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = $8c2ce3e7c653a1d4$export$5a4ea50826a01d14(event);
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function $8c2ce3e7c653a1d4$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $8c2ce3e7c653a1d4$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || $8c2ce3e7c653a1d4$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $8c2ce3e7c653a1d4$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $18e07f8ef0e00461$export$31935b4577455331)) return undefined;
    return $8c2ce3e7c653a1d4$export$45b10814cc054894(target);
}
function $8c2ce3e7c653a1d4$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $8c2ce3e7c653a1d4$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $18e07f8ef0e00461$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $8c2ce3e7c653a1d4$export$436e852aa2feda95(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function $8c2ce3e7c653a1d4$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $8c2ce3e7c653a1d4$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $8c2ce3e7c653a1d4$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $28a07e6dd3d337a6$export$66313c302b2ea154) || action.type === (0, $28a07e6dd3d337a6$export$89db4734f6c919c4) && action.to === (0, $80ddfa4e1f63e6fd$export$79f5baa747fbdd45).Internal) && typeof action.delay !== "number";
}




var $14e26cbc9f73b2c7$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === "atomic" || stateNode.type === "final";
};
function $14e26cbc9f73b2c7$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $14e26cbc9f73b2c7$export$f8cf48ee793b41be(stateNode) {
    return $14e26cbc9f73b2c7$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== "history";
    });
}
function $14e26cbc9f73b2c7$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($14e26cbc9f73b2c7$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)($14e26cbc9f73b2c7$export$f8cf48ee793b41be(stateNode).map($14e26cbc9f73b2c7$export$3de19bba299e3801)));
}
function $14e26cbc9f73b2c7$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $14e26cbc9f73b2c7$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $14e26cbc9f73b2c7$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === "compound" && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === "parallel") try {
                    for(var _e = (e_3 = void 0, (0, $465297b78447ad9b$export$19a8beecd37a4c45)($14e26cbc9f73b2c7$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $14e26cbc9f73b2c7$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === "compound") {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($14e26cbc9f73b2c7$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $14e26cbc9f73b2c7$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $14e26cbc9f73b2c7$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $14e26cbc9f73b2c7$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $14e26cbc9f73b2c7$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $14e26cbc9f73b2c7$var$getValueFromAdj(rootNode, $14e26cbc9f73b2c7$export$b837d8c2d0189d63(config));
}
function $14e26cbc9f73b2c7$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $14e26cbc9f73b2c7$export$c661ab6895e3ed73(configuration) {
    return (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(new Set((0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $14e26cbc9f73b2c7$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === "compound") return $14e26cbc9f73b2c7$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === "final" && $14e26cbc9f73b2c7$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === "parallel") return $14e26cbc9f73b2c7$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $14e26cbc9f73b2c7$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $14e26cbc9f73b2c7$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $14e26cbc9f73b2c7$export$5301196121335ca0(configuration) {
    return new Set((0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}


var $e262c78e8c90133a$exports = {};

$parcel$export($e262c78e8c90133a$exports, "initEvent", function () { return $e262c78e8c90133a$export$163c566c60ed2ec9; });
$parcel$export($e262c78e8c90133a$exports, "getActionFunction", function () { return $e262c78e8c90133a$export$c7e5ca927bd4567; });
$parcel$export($e262c78e8c90133a$exports, "toActionObject", function () { return $e262c78e8c90133a$export$b38b66cc2da3ede7; });
$parcel$export($e262c78e8c90133a$exports, "toActionObjects", function () { return $e262c78e8c90133a$export$aa68691f32e6c459; });
$parcel$export($e262c78e8c90133a$exports, "toActivityDefinition", function () { return $e262c78e8c90133a$export$e81fdd8937d44864; });
$parcel$export($e262c78e8c90133a$exports, "raise", function () { return $e262c78e8c90133a$export$66313c302b2ea154; });
$parcel$export($e262c78e8c90133a$exports, "resolveRaise", function () { return $e262c78e8c90133a$export$ed3daf8e935ede01; });
$parcel$export($e262c78e8c90133a$exports, "send", function () { return $e262c78e8c90133a$export$89db4734f6c919c4; });
$parcel$export($e262c78e8c90133a$exports, "resolveSend", function () { return $e262c78e8c90133a$export$f43e8cbb721d72d5; });
$parcel$export($e262c78e8c90133a$exports, "sendParent", function () { return $e262c78e8c90133a$export$408d8d51fa351f53; });
$parcel$export($e262c78e8c90133a$exports, "sendTo", function () { return $e262c78e8c90133a$export$daa976aaff721e41; });
$parcel$export($e262c78e8c90133a$exports, "sendUpdate", function () { return $e262c78e8c90133a$export$7f8b724299523eb6; });
$parcel$export($e262c78e8c90133a$exports, "respond", function () { return $e262c78e8c90133a$export$72b816ae90496f19; });
$parcel$export($e262c78e8c90133a$exports, "log", function () { return $e262c78e8c90133a$export$bef1f36f5486a6a3; });
$parcel$export($e262c78e8c90133a$exports, "resolveLog", function () { return $e262c78e8c90133a$export$12cba28d36be4946; });
$parcel$export($e262c78e8c90133a$exports, "cancel", function () { return $e262c78e8c90133a$export$70b61ad426ddbe54; });
$parcel$export($e262c78e8c90133a$exports, "start", function () { return $e262c78e8c90133a$export$b3571188c770cc5a; });
$parcel$export($e262c78e8c90133a$exports, "stop", function () { return $e262c78e8c90133a$export$fa6813432f753b0d; });
$parcel$export($e262c78e8c90133a$exports, "resolveStop", function () { return $e262c78e8c90133a$export$21aa461f4eb8e82; });
$parcel$export($e262c78e8c90133a$exports, "assign", function () { return $e262c78e8c90133a$export$e6e34fd1f2686227; });
$parcel$export($e262c78e8c90133a$exports, "isActionObject", function () { return $e262c78e8c90133a$export$6e816592f80fc079; });
$parcel$export($e262c78e8c90133a$exports, "after", function () { return $e262c78e8c90133a$export$742acabee3dd6465; });
$parcel$export($e262c78e8c90133a$exports, "done", function () { return $e262c78e8c90133a$export$3df11c9c20e7b288; });
$parcel$export($e262c78e8c90133a$exports, "doneInvoke", function () { return $e262c78e8c90133a$export$c105e588793f70b4; });
$parcel$export($e262c78e8c90133a$exports, "error", function () { return $e262c78e8c90133a$export$a3bc9b8ed74fc; });
$parcel$export($e262c78e8c90133a$exports, "pure", function () { return $e262c78e8c90133a$export$48ec4a2b1cfc6557; });
$parcel$export($e262c78e8c90133a$exports, "forwardTo", function () { return $e262c78e8c90133a$export$eb147b7589db8e8a; });
$parcel$export($e262c78e8c90133a$exports, "escalate", function () { return $e262c78e8c90133a$export$f514678a4137c4d6; });
$parcel$export($e262c78e8c90133a$exports, "choose", function () { return $e262c78e8c90133a$export$7877a478dd30fd3d; });
$parcel$export($e262c78e8c90133a$exports, "resolveActions", function () { return $e262c78e8c90133a$export$b8b9e7ba5b8c7b3e; });
$parcel$export($e262c78e8c90133a$exports, "actionTypes", function () { return $28a07e6dd3d337a6$exports; });





var $e262c78e8c90133a$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)({
    type: (0, $28a07e6dd3d337a6$export$2cd8252107eb640b)
});
function $e262c78e8c90133a$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $e262c78e8c90133a$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(action) || typeof action === "number") {
        var exec = $e262c78e8c90133a$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $e262c78e8c90133a$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(exec)) actionObject = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $e262c78e8c90133a$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $8c2ce3e7c653a1d4$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $e262c78e8c90133a$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $e262c78e8c90133a$export$e81fdd8937d44864(action) {
    var actionObject = $e262c78e8c90133a$export$b38b66cc2da3ede7(action);
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({
        id: (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $e262c78e8c90133a$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $28a07e6dd3d337a6$export$66313c302b2ea154),
        event: typeof event === "function" ? event : (0, $8c2ce3e7c653a1d4$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $e262c78e8c90133a$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, action), {
        type: (0, $28a07e6dd3d337a6$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $e262c78e8c90133a$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $28a07e6dd3d337a6$export$89db4734f6c919c4),
        event: (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(event) ? event : (0, $8c2ce3e7c653a1d4$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(event) ? event.name : (0, $8c2ce3e7c653a1d4$export$7193fc8c8cd445e9)(event)
    };
}
function $e262c78e8c90133a$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $e262c78e8c90133a$export$408d8d51fa351f53(event, options) {
    return $e262c78e8c90133a$export$89db4734f6c919c4(event, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, options), {
        to: (0, $80ddfa4e1f63e6fd$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $e262c78e8c90133a$export$daa976aaff721e41(actor, event, options) {
    return $e262c78e8c90133a$export$89db4734f6c919c4(event, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $e262c78e8c90133a$export$7f8b724299523eb6() {
    return $e262c78e8c90133a$export$408d8d51fa351f53((0, $28a07e6dd3d337a6$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $e262c78e8c90133a$export$72b816ae90496f19(event, options) {
    return $e262c78e8c90133a$export$89db4734f6c919c4(event, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $e262c78e8c90133a$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $e262c78e8c90133a$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $e262c78e8c90133a$var$defaultLogExpr;
    return {
        type: (0, $28a07e6dd3d337a6$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $e262c78e8c90133a$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, action), {
        value: (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $e262c78e8c90133a$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $28a07e6dd3d337a6$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $e262c78e8c90133a$export$b3571188c770cc5a(activity) {
    var activityDef = $e262c78e8c90133a$export$e81fdd8937d44864(activity);
    return {
        type: (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $e262c78e8c90133a$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(actorRef) ? actorRef : $e262c78e8c90133a$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $e262c78e8c90133a$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $e262c78e8c90133a$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $28a07e6dd3d337a6$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $e262c78e8c90133a$export$6e816592f80fc079(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $e262c78e8c90133a$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat((0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $e262c78e8c90133a$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $e262c78e8c90133a$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $e262c78e8c90133a$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $e262c78e8c90133a$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $e262c78e8c90133a$export$eb147b7589db8e8a(target, options) {
    if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571) && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $e262c78e8c90133a$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $e262c78e8c90133a$export$f514678a4137c4d6(errorData, options) {
    return $e262c78e8c90133a$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $28a07e6dd3d337a6$export$a3bc9b8ed74fc),
            data: (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, options), {
        to: (0, $80ddfa4e1f63e6fd$export$79f5baa747fbdd45).Parent
    }));
}
function $e262c78e8c90133a$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $e262c78e8c90133a$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $28a07e6dd3d337a6$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $e262c78e8c90133a$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $e262c78e8c90133a$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $8c2ce3e7c653a1d4$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $28a07e6dd3d337a6$export$66313c302b2ea154:
                var raisedAction = $e262c78e8c90133a$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $28a07e6dd3d337a6$export$89db4734f6c919c4:
                var sendAction = $e262c78e8c90133a$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!(0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $80ddfa4e1f63e6fd$export$79f5baa747fbdd45).Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $28a07e6dd3d337a6$export$bef1f36f5486a6a3:
                var resolved = $e262c78e8c90133a$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $28a07e6dd3d337a6$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $8c2ce3e7c653a1d4$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $8c2ce3e7c653a1d4$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $465297b78447ad9b$export$8d051b38c9118094)($e262c78e8c90133a$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $e262c78e8c90133a$export$aa68691f32e6c459((0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $28a07e6dd3d337a6$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $465297b78447ad9b$export$8d051b38c9118094)($e262c78e8c90133a$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $e262c78e8c90133a$export$aa68691f32e6c459((0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $28a07e6dd3d337a6$export$fa6813432f753b0d:
                var resolved = $e262c78e8c90133a$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $28a07e6dd3d337a6$export$e6e34fd1f2686227:
                updatedContext = (0, $8c2ce3e7c653a1d4$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $e262c78e8c90133a$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $465297b78447ad9b$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $465297b78447ad9b$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $6fe2abc7c12bffa9$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(a) || (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $6fe2abc7c12bffa9$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $6fe2abc7c12bffa9$export$4c86eb6450eda77a(state) {
    if (typeof state !== "object" || state === null) return false;
    return "value" in state && "_event" in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $6fe2abc7c12bffa9$export$e5d60a6bbabd36f = $6fe2abc7c12bffa9$export$4c86eb6450eda77a;
function $6fe2abc7c12bffa9$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $6fe2abc7c12bffa9$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $18e07f8ef0e00461$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $18e07f8ef0e00461$export$505a390a702f4a23);
        this.meta = (0, $14e26cbc9f73b2c7$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, "nextEvents", {
            get: function() {
                return (0, $14e26cbc9f73b2c7$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $e262c78e8c90133a$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $e262c78e8c90133a$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = ".";
        if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $465297b78447ad9b$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $8c2ce3e7c653a1d4$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $12632c59f8871ae5$export$9b5f2e1c20ef6571) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();







var $5a50bc3d0360a181$var$defaultOptions = {
    deferEvents: false
};
var $5a50bc3d0360a181$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, $5a50bc3d0360a181$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error("Event queue should be empty when it is not processing events");
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();




/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $2b876e45a63193b3$var$serviceStack = [];
var $2b876e45a63193b3$export$abe1e183e22e10ad = function(service, fn) {
    $2b876e45a63193b3$var$serviceStack.push(service);
    var result = fn(service);
    $2b876e45a63193b3$var$serviceStack.pop();
    return result;
};
var $2b876e45a63193b3$export$e11e6a155c5c4d9d = function(fn) {
    return fn($2b876e45a63193b3$var$serviceStack[$2b876e45a63193b3$var$serviceStack.length - 1]);
};


function $fb40831f8ea463a4$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $fb40831f8ea463a4$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $8c2ce3e7c653a1d4$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $8c2ce3e7c653a1d4$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $fb40831f8ea463a4$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $fb40831f8ea463a4$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $fb40831f8ea463a4$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $fb40831f8ea463a4$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $2b876e45a63193b3$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $fb40831f8ea463a4$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === "function";
    } catch (e) {
        return false;
    }
}
function $fb40831f8ea463a4$export$b0f989039dc164f9(item) {
    return $fb40831f8ea463a4$export$e769f6913f14f1b7(item) && "id" in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $fb40831f8ea463a4$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: "anonymous",
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}


var $2673973364edf245$var$children = /*#__PURE__*/ new Map();
var $2673973364edf245$var$sessionIdIndex = 0;
var $2673973364edf245$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($2673973364edf245$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $2673973364edf245$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $2673973364edf245$var$children.get(id);
    },
    free: function(id) {
        $2673973364edf245$var$children.delete(id);
    }
};



function $76e2b92e371c95eb$export$a4e55266d2135a7f() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function $76e2b92e371c95eb$var$getDevTools() {
    var global1 = $76e2b92e371c95eb$export$a4e55266d2135a7f();
    if (global1 && "__xstate__" in global1) return global1.__xstate__;
    return undefined;
}
function $76e2b92e371c95eb$export$4d7a7d14704ebc13(service) {
    if (!$76e2b92e371c95eb$export$a4e55266d2135a7f()) return;
    var devTools = $76e2b92e371c95eb$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $9b544958bc7e6fc4$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $9b544958bc7e6fc4$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: "pending"
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case "fulfill":
                    parent === null || parent === void 0 || parent.send((0, $e262c78e8c90133a$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: "fulfilled"
                    };
                case "reject":
                    parent === null || parent === void 0 || parent.send((0, $e262c78e8c90133a$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: "rejected"
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: "fulfill",
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: "reject",
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $9b544958bc7e6fc4$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $fb40831f8ea463a4$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $8c2ce3e7c653a1d4$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || "anonymous",
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $19dcc9cc6e75cec4$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $19dcc9cc6e75cec4$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($19dcc9cc6e75cec4$export$7a567c9c5088a551 || ($19dcc9cc6e75cec4$export$7a567c9c5088a551 = {}));
var $19dcc9cc6e75cec4$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $19dcc9cc6e75cec4$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $8c2ce3e7c653a1d4$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)((0, $8c2ce3e7c653a1d4$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $80ddfa4e1f63e6fd$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(to) ? to === (0, $80ddfa4e1f63e6fd$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $2673973364edf245$export$4bb7493d241fd8a5).get(to) : (0, $8c2ce3e7c653a1d4$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ("machine" in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $28a07e6dd3d337a6$export$a3bc9b8ed74fc) ? "".concat((0, $e262c78e8c90133a$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $e262c78e8c90133a$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: "xstate.error",
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $28a07e6dd3d337a6$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $28a07e6dd3d337a6$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === "number") {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $e262c78e8c90133a$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $28a07e6dd3d337a6$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $28a07e6dd3d337a6$export$b3571188c770cc5a:
                    if (_this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $80ddfa4e1f63e6fd$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $8c2ce3e7c653a1d4$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!("forward" in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $8c2ce3e7c653a1d4$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === "string") // TODO: warn
                        return;
                        var source = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $28a07e6dd3d337a6$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $28a07e6dd3d337a6$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $5a50bc3d0360a181$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $2673973364edf245$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $2b876e45a63193b3$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $e262c78e8c90133a$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === "final" && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $8c2ce3e7c653a1d4$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $e262c78e8c90133a$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $2673973364edf245$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $8c2ce3e7c653a1d4$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $2673973364edf245$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $2b876e45a63193b3$export$abe1e183e22e10ad)(this, function() {
            return (0, $6fe2abc7c12bffa9$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $6fe2abc7c12bffa9$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $e262c78e8c90133a$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $19dcc9cc6e75cec4$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $5a50bc3d0360a181$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            var _a;
            if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) return;
             // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)({
                type: "xstate.stop"
            });
            var nextState = (0, $2b876e45a63193b3$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $e262c78e8c90133a$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $465297b78447ad9b$export$8d051b38c9118094)((0, $e262c78e8c90133a$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: "exit",
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $8c2ce3e7c653a1d4$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $2673973364edf245$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        } else if (this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $2b876e45a63193b3$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $6fe2abc7c12bffa9$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $28a07e6dd3d337a6$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $28a07e6dd3d337a6$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $2b876e45a63193b3$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ("to" in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $19dcc9cc6e75cec4$export$7a567c9c5088a551.Running) return (0, $fb40831f8ea463a4$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $8c2ce3e7c653a1d4$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $fb40831f8ea463a4$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $8c2ce3e7c653a1d4$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $8c2ce3e7c653a1d4$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, $19dcc9cc6e75cec4$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $28a07e6dd3d337a6$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $9b544958bc7e6fc4$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)((0, $e262c78e8c90133a$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $e262c78e8c90133a$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $8c2ce3e7c653a1d4$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $8c2ce3e7c653a1d4$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $e262c78e8c90133a$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $8c2ce3e7c653a1d4$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $8c2ce3e7c653a1d4$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)((0, $e262c78e8c90133a$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)((0, $e262c78e8c90133a$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $76e2b92e371c95eb$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $465297b78447ad9b$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $76e2b92e371c95eb$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $8c2ce3e7c653a1d4$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $19dcc9cc6e75cec4$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $19dcc9cc6e75cec4$export$67beed298888a38b;
    return Interpreter;
}();
var $19dcc9cc6e75cec4$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(nameOrOptions)) return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, $19dcc9cc6e75cec4$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, $19dcc9cc6e75cec4$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $8c2ce3e7c653a1d4$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $19dcc9cc6e75cec4$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $19dcc9cc6e75cec4$var$resolveSpawnOptions(nameOrOptions);
    return (0, $2b876e45a63193b3$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(entity) || (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(entity);
            (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!!service || isLazyEntity, 'Attempted to spawn an Actor (ID: "'.concat((0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(entity) ? entity.id : "undefined", '") outside of a service. This will have no effect.'));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $fb40831f8ea463a4$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $19dcc9cc6e75cec4$export$67beed298888a38b(machine, options) {
    var interpreter = new $19dcc9cc6e75cec4$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}



var $2hDQc = parcelRequire("2hDQc");
function $e55d1c28ea285f8b$export$2e2bcd8739ae039(fn) {
    var ref = $2hDQc.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}


var $fc31ecaf08cabc55$var$__assign = undefined && undefined.__assign || function() {
    $fc31ecaf08cabc55$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc31ecaf08cabc55$var$__assign.apply(this, arguments);
};
var $fc31ecaf08cabc55$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fc31ecaf08cabc55$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $fc31ecaf08cabc55$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $e55d1c28ea285f8b$export$2e2bcd8739ae039)(function() {
        return typeof getMachine === "function" ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $fc31ecaf08cabc55$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $e55d1c28ea285f8b$export$2e2bcd8739ae039)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $fc31ecaf08cabc55$var$__assign($fc31ecaf08cabc55$var$__assign({}, machine.context), context);
        });
        return (0, $19dcc9cc6e75cec4$export$67beed298888a38b)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $a34e6f08c3b801c5$export$2e2bcd8739ae039)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $fc31ecaf08cabc55$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $fc31ecaf08cabc55$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $fc31ecaf08cabc55$export$d09836c9e303db57(getMachine, options);
    (0, $2hDQc.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $8c2ce3e7c653a1d4$export$75b67481063f2f98)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $2hDQc.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $19dcc9cc6e75cec4$export$7a567c9c5088a551).NotStarted;
        };
    }, []);
    return service;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a5b39965b404a259$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $de2f10f4a648aec0$export$77712ea5882cac9f)(tokens);
    const { "cognito:username": username, sub: sub } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $a5b39965b404a259$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $a5b39965b404a259$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $4539220ee0fa802b$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $a5b39965b404a259$export$e5432d4c8eb97ea7)((0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7));
};



















function $1aef4ce5ba85fb67$export$436e852aa2feda95(src) {
    if (typeof src === "string") {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $1aef4ce5ba85fb67$export$4c73f685ba879446(invokeConfig) {
    return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({
        type: (0, $28a07e6dd3d337a6$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $465297b78447ad9b$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $28a07e6dd3d337a6$export$468cda29b159ee5d),
                src: $1aef4ce5ba85fb67$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $974250a1d4061117$var$NULL_EVENT = "";
var $974250a1d4061117$var$STATE_IDENTIFIER = "#";
var $974250a1d4061117$var$WILDCARD = "*";
var $974250a1d4061117$var$EMPTY_OBJECT = {};
var $974250a1d4061117$var$isStateId = function(str) {
    return str[0] === $974250a1d4061117$var$STATE_IDENTIFIER;
};
var $974250a1d4061117$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $974250a1d4061117$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !("cond" in transition) && !("in" in transition) && ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(transition.target) || (0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $974250a1d4061117$var$NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
    (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $974250a1d4061117$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = "context" in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($974250a1d4061117$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $18e07f8ef0e00461$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $465297b78447ad9b$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $465297b78447ad9b$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $8c2ce3e7c653a1d4$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $465297b78447ad9b$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $974250a1d4061117$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)((0, $14e26cbc9f73b2c7$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? "shallow" : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $974250a1d4061117$var$NULL_EVENT;
        }) : $974250a1d4061117$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $e262c78e8c90133a$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $e262c78e8c90133a$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === "final" ? this.config.data : undefined;
        this.invoke = (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $8c2ce3e7c653a1d4$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $465297b78447ad9b$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $1aef4ce5ba85fb67$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $8c2ce3e7c653a1d4$export$107b54c5097f9157)(_this.id, i);
                return (0, $1aef4ce5ba85fb67$export$4c73f685ba879446)((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $8c2ce3e7c653a1d4$export$2163e7903738b5df)(invokeConfig.src) || (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $8c2ce3e7c653a1d4$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $465297b78447ad9b$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $1aef4ce5ba85fb67$export$4c73f685ba879446)((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $1aef4ce5ba85fb67$export$4c73f685ba879446)((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({
                    id: (0, $8c2ce3e7c653a1d4$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $e262c78e8c90133a$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $14e26cbc9f73b2c7$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $8c2ce3e7c653a1d4$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $974250a1d4061117$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $974250a1d4061117$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $8c2ce3e7c653a1d4$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $e262c78e8c90133a$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $e262c78e8c90133a$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $e262c78e8c90133a$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $8c2ce3e7c653a1d4$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd) ? state.value : (0, $8c2ce3e7c653a1d4$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)((0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $8c2ce3e7c653a1d4$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd) ? state : (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $14e26cbc9f73b2c7$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd)((0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $14e26cbc9f73b2c7$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $14e26cbc9f73b2c7$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(stateIn) && $974250a1d4061117$var$isStateId(stateIn) ? state.matches((0, $8c2ce3e7c653a1d4$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $8c2ce3e7c653a1d4$export$2870710bf0eac88e)((0, $8c2ce3e7c653a1d4$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $8c2ce3e7c653a1d4$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $8c2ce3e7c653a1d4$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $14e26cbc9f73b2c7$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $14e26cbc9f73b2c7$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $14e26cbc9f73b2c7$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $14e26cbc9f73b2c7$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $14e26cbc9f73b2c7$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== "final") return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $e262c78e8c90133a$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $e262c78e8c90133a$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $8c2ce3e7c653a1d4$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === "parallel") {
                if ((0, $14e26cbc9f73b2c7$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $14e26cbc9f73b2c7$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $e262c78e8c90133a$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $e262c78e8c90133a$export$b3571188c770cc5a)(activity);
            });
            return {
                type: "entry",
                actions: (0, $e262c78e8c90133a$export$aa68691f32e6c459)(predictableExec ? (0, $465297b78447ad9b$export$1216008129fb82ed)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(entryActions), false), (0, $465297b78447ad9b$export$8d051b38c9118094)(invokeActions), false) : (0, $465297b78447ad9b$export$1216008129fb82ed)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(invokeActions), false), (0, $465297b78447ad9b$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: "state_done",
            actions: doneEvents.map(function(event) {
                return (0, $e262c78e8c90133a$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: "exit",
                actions: (0, $e262c78e8c90133a$export$aa68691f32e6c459)((0, $465297b78447ad9b$export$1216008129fb82ed)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(stateNode.onExit), false), (0, $465297b78447ad9b$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $e262c78e8c90133a$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: "transition",
            actions: (0, $e262c78e8c90133a$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $e262c78e8c90133a$export$aa68691f32e6c459)((0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $8c2ce3e7c653a1d4$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: "stop",
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $8c2ce3e7c653a1d4$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $6fe2abc7c12bffa9$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(state) ? this.resolve((0, $8c2ce3e7c653a1d4$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $6fe2abc7c12bffa9$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571) && _event.name === $974250a1d4061117$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($974250a1d4061117$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $8c2ce3e7c653a1d4$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $14e26cbc9f73b2c7$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $14e26cbc9f73b2c7$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $e262c78e8c90133a$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $14e26cbc9f73b2c7$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $14e26cbc9f73b2c7$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $465297b78447ad9b$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $465297b78447ad9b$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $28a07e6dd3d337a6$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $28a07e6dd3d337a6$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $465297b78447ad9b$export$8d051b38c9118094)((0, $e262c78e8c90133a$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $465297b78447ad9b$export$8d051b38c9118094)((0, $8c2ce3e7c653a1d4$export$b29f828819edca8d)(resolvedActions, (0, $8c2ce3e7c653a1d4$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $28a07e6dd3d337a6$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $28a07e6dd3d337a6$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $fb40831f8ea463a4$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $465297b78447ad9b$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $6fe2abc7c12bffa9$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $8c2ce3e7c653a1d4$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $14e26cbc9f73b2c7$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $28a07e6dd3d337a6$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $974250a1d4061117$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $28a07e6dd3d337a6$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $6fe2abc7c12bffa9$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($974250a1d4061117$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $974250a1d4061117$var$isStateId(stateId) ? stateId.slice($974250a1d4061117$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === "string" && $974250a1d4061117$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $8c2ce3e7c653a1d4$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $974250a1d4061117$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case "parallel":
                return (0, $8c2ce3e7c653a1d4$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $974250a1d4061117$var$EMPTY_OBJECT;
                });
            case "compound":
                if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === "parallel" || subStateNode.type === "compound") return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $8c2ce3e7c653a1d4$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $974250a1d4061117$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $974250a1d4061117$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($974250a1d4061117$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($974250a1d4061117$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $8c2ce3e7c653a1d4$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === "parallel") initialStateValue = (0, $8c2ce3e7c653a1d4$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $974250a1d4061117$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === "history");
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $14e26cbc9f73b2c7$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === "history") {
                var historyConfig = this.config;
                if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(historyConfig.target)) target = $974250a1d4061117$var$isStateId(historyConfig.target) ? (0, $8c2ce3e7c653a1d4$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $14e26cbc9f73b2c7$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === "compound" && !this.initial) {
                if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $8c2ce3e7c653a1d4$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $465297b78447ad9b$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === "history") return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $8c2ce3e7c653a1d4$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== "history") return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)((0, $8c2ce3e7c653a1d4$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $8c2ce3e7c653a1d4$export$314d0a1a7c835392)(parent.path, "states")(historyValue).current;
        if ((0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)((0, $8c2ce3e7c653a1d4$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $465297b78447ad9b$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $8c2ce3e7c653a1d4$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $8c2ce3e7c653a1d4$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $e262c78e8c90133a$export$aa68691f32e6c459)((0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $8c2ce3e7c653a1d4$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $465297b78447ad9b$export$18ce0697a983be9b)((0, $465297b78447ad9b$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $974250a1d4061117$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $465297b78447ad9b$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571) && key === $974250a1d4061117$var$NULL_EVENT) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
                var transitionConfigArray = (0, $8c2ce3e7c653a1d4$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) $974250a1d4061117$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $8c2ce3e7c653a1d4$export$3822a36ea084a4d5)($974250a1d4061117$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $8c2ce3e7c653a1d4$export$3822a36ea084a4d5)("", this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $8c2ce3e7c653a1d4$export$3822a36ea084a4d5)(String((0, $e262c78e8c90133a$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571)) (0, $8c2ce3e7c653a1d4$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
        var invokeConfig = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)((0, $8c2ce3e7c653a1d4$export$3822a36ea084a4d5)(String((0, $e262c78e8c90133a$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)((0, $8c2ce3e7c653a1d4$export$3822a36ea084a4d5)(String((0, $e262c78e8c90133a$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $8c2ce3e7c653a1d4$export$bffa455ba8c619a6)((0, $465297b78447ad9b$export$1216008129fb82ed)((0, $465297b78447ad9b$export$1216008129fb82ed)((0, $465297b78447ad9b$export$1216008129fb82ed)((0, $465297b78447ad9b$export$1216008129fb82ed)([], (0, $465297b78447ad9b$export$8d051b38c9118094)(doneConfig), false), (0, $465297b78447ad9b$export$8d051b38c9118094)(invokeConfig), false), (0, $465297b78447ad9b$export$8d051b38c9118094)(onConfig), false), (0, $465297b78447ad9b$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $8c2ce3e7c653a1d4$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $465297b78447ad9b$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $cfd28b8a1b5bcf91$var$warned = false;
function $cfd28b8a1b5bcf91$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $974250a1d4061117$export$342f24f5edd47b1)(config, options, initialContext);
}
function $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $12632c59f8871ae5$export$9b5f2e1c20ef6571) && !("predictableActionArguments" in config) && !$cfd28b8a1b5bcf91$var$warned) {
        $cfd28b8a1b5bcf91$var$warned = true;
        console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
    }
    return new (0, $974250a1d4061117$export$342f24f5edd47b1)(config, options);
}










var $bbe1427e84b1ce64$export$e6e34fd1f2686227 = (0, $e262c78e8c90133a$export$e6e34fd1f2686227), $bbe1427e84b1ce64$export$70b61ad426ddbe54 = (0, $e262c78e8c90133a$export$70b61ad426ddbe54), $bbe1427e84b1ce64$export$89db4734f6c919c4 = (0, $e262c78e8c90133a$export$89db4734f6c919c4), $bbe1427e84b1ce64$export$daa976aaff721e41 = (0, $e262c78e8c90133a$export$daa976aaff721e41), $bbe1427e84b1ce64$export$408d8d51fa351f53 = (0, $e262c78e8c90133a$export$408d8d51fa351f53), $bbe1427e84b1ce64$export$7f8b724299523eb6 = (0, $e262c78e8c90133a$export$7f8b724299523eb6), $bbe1427e84b1ce64$export$eb147b7589db8e8a = (0, $e262c78e8c90133a$export$eb147b7589db8e8a), $bbe1427e84b1ce64$export$c105e588793f70b4 = (0, $e262c78e8c90133a$export$c105e588793f70b4), $bbe1427e84b1ce64$export$66313c302b2ea154 = (0, $e262c78e8c90133a$export$66313c302b2ea154), $bbe1427e84b1ce64$export$bef1f36f5486a6a3 = (0, $e262c78e8c90133a$export$bef1f36f5486a6a3), $bbe1427e84b1ce64$export$48ec4a2b1cfc6557 = (0, $e262c78e8c90133a$export$48ec4a2b1cfc6557), $bbe1427e84b1ce64$export$7877a478dd30fd3d = (0, $e262c78e8c90133a$export$7877a478dd30fd3d), $bbe1427e84b1ce64$export$fa6813432f753b0d = (0, $e262c78e8c90133a$export$fa6813432f753b0d);











const $e69d66b471ba80af$export$a51e8cda1526c737 = [
    "+1",
    "+7",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+81",
    "+82",
    "+84",
    "+86",
    "+90",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+345",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+537",
    "+590",
    "+591",
    "+593",
    "+594",
    "+595",
    "+596",
    "+597",
    "+598",
    "+599",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+872",
    "+880",
    "+886",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
];



/**
 * This file contains helpers related to forms and input attributes.
 */ const $1501912d3aedff2e$export$1222d357a3c2c47f = {
    birthdate: {
        label: "Birthdate",
        placeholder: "Enter your Birthdate",
        type: "date",
        autocomplete: "bday",
        isRequired: true
    },
    confirmation_code: {
        label: "Confirmation Code",
        placeholder: "Enter your Confirmation Code",
        type: "text",
        autocomplete: "one-time-code",
        isRequired: true
    },
    confirm_password: {
        label: "Confirm Password",
        placeholder: "Please confirm your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: true
    },
    email: {
        label: "Email",
        placeholder: "Enter your Email",
        type: "email",
        autocomplete: "username",
        isRequired: true
    },
    family_name: {
        label: "Family Name",
        placeholder: "Enter your Family Name",
        type: "text",
        autocomplete: "family-name",
        isRequired: true
    },
    given_name: {
        label: "Given Name",
        placeholder: "Enter your Given Name",
        type: "text",
        autocomplete: "given-name",
        isRequired: true
    },
    middle_name: {
        label: "Middle Name",
        placeholder: "Enter your Middle Name",
        type: "text",
        autocomplete: "additional-name",
        isRequired: true
    },
    name: {
        label: "Name",
        placeholder: "Enter your Name",
        type: "text",
        autocomplete: "name",
        isRequired: true
    },
    nickname: {
        label: "Nickname",
        placeholder: "Enter your Nickname",
        type: "text",
        autocomplete: "tel",
        isRequired: true
    },
    password: {
        label: "Password",
        placeholder: "Enter your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: true
    },
    phone_number: {
        label: "Phone Number",
        placeholder: "Enter your Phone Number",
        type: "tel",
        autocomplete: "tel",
        dialCode: "+1",
        dialCodeList: (0, $e69d66b471ba80af$export$a51e8cda1526c737),
        isRequired: true
    },
    preferred_username: {
        label: "Preferred Username",
        placeholder: "Enter your Preferred Username",
        type: "text",
        isRequired: true
    },
    profile: {
        label: "Profile",
        placeholder: "Add your Profile",
        type: "url",
        autocomplete: "url",
        isRequired: true
    },
    website: {
        label: "Website",
        placeholder: "Add your Website",
        type: "url",
        autocomplete: "url",
        isRequired: true
    },
    username: {
        label: "Username",
        placeholder: "Enter your Username",
        type: "text",
        autocomplete: "username",
        isRequired: true
    }
};
/**
 * List of special characters that Cognito allows.
 *
 * Adapted from https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
 */ // prettier-ignore
const $1501912d3aedff2e$export$4223938282102ea7 = [
    "^",
    "$",
    "*",
    ".",
    "[",
    "]",
    "{",
    "}",
    "(",
    ")",
    "?",
    '"',
    "!",
    "@",
    "#",
    "%",
    "&",
    "/",
    "\\",
    ",",
    ">",
    "<",
    "'",
    ":",
    ";",
    "|",
    "_",
    "~",
    "`",
    "=",
    "+",
    "-",
    " "
];
/**
 * Email validation regex
 *
 * source: HTML5 spec https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 */ const $1501912d3aedff2e$export$976c37132e9c6a10 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
/**
+ * map navigable route keys to auth event names
+ */ const $1501912d3aedff2e$export$7ccc20c5f9bc8a70 = {
    forgotPassword: "FORGOT_PASSWORD",
    signIn: "SIGN_IN",
    signUp: "SIGN_UP"
};


// replaces all characters in a string with '*', except for the first and last char
const $508296b373a163a4$export$655775443891f2b8 = (value)=>{
    const split = value.trim().split("");
    for(let i = 0; i < split.length; i++)if (i > 0 && i < split.length - 1) split[i] = "*";
    return split.join("");
};
// censors all but the last four characters of a phone number
const $508296b373a163a4$export$72b2b64445441bf7 = (val)=>{
    if (val.length < 4) return val;
    const split = val.split("");
    for(let i = 0; i < split.length - 4; i++)split[i] = "*";
    return split.join("");
};
const $508296b373a163a4$export$1ec93875315f071d = (password)=>(0, $1501912d3aedff2e$export$4223938282102ea7).some((char)=>password.includes(char));
const $508296b373a163a4$export$f1f323074be5cac0 = (issuer, username, secret)=>encodeURI(`otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}`);
function $508296b373a163a4$export$205c000fb676adf6(values, ...ignored) {
    return Object.entries(values).reduce((acc, [name, value])=>({
            ...acc,
            [name]: ignored.includes(name) ? value : value?.trim()
        }), {});
}
const $508296b373a163a4$export$371e338370561054 = (value)=>{
    if (!value) return false;
    return (0, $1501912d3aedff2e$export$976c37132e9c6a10).test(value);
};




var $1fba8391251b976e$exports = {};
var $1286baf6978c1736$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1286baf6978c1736$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$1286baf6978c1736$exports = $1286baf6978c1736$var$arrayMap;


var $1c889f35b6a76829$exports = {};
var $8d50d509810e290d$exports = {};
var $2cf33e48e1909fb9$exports = {};
var $0b7f1a3b3f2b2666$exports = {};
var $c03a360af3c87456$exports = {};
var $4e3b10c6eaa4a501$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4e3b10c6eaa4a501$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$4e3b10c6eaa4a501$exports = $4e3b10c6eaa4a501$var$listCacheClear;


var $5ddeba6284ace21b$exports = {};
var $f13195c24032ba0e$exports = {};
var $d13292808fb6c9f3$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d13292808fb6c9f3$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$d13292808fb6c9f3$exports = $d13292808fb6c9f3$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f13195c24032ba0e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d13292808fb6c9f3$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f13195c24032ba0e$exports = $f13195c24032ba0e$var$assocIndexOf;


/** Used for built-in method references. */ var $5ddeba6284ace21b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5ddeba6284ace21b$var$splice = $5ddeba6284ace21b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5ddeba6284ace21b$var$listCacheDelete(key) {
    var data = this.__data__, index = $f13195c24032ba0e$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5ddeba6284ace21b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$5ddeba6284ace21b$exports = $5ddeba6284ace21b$var$listCacheDelete;


var $7d17c47284f15e17$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7d17c47284f15e17$var$listCacheGet(key) {
    var data = this.__data__, index = $f13195c24032ba0e$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$7d17c47284f15e17$exports = $7d17c47284f15e17$var$listCacheGet;


var $2870f9144ac4d007$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2870f9144ac4d007$var$listCacheHas(key) {
    return $f13195c24032ba0e$exports(this.__data__, key) > -1;
}
$2870f9144ac4d007$exports = $2870f9144ac4d007$var$listCacheHas;


var $d0197fa95029f733$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d0197fa95029f733$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f13195c24032ba0e$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$d0197fa95029f733$exports = $d0197fa95029f733$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c03a360af3c87456$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$c03a360af3c87456$var$ListCache.prototype.clear = $4e3b10c6eaa4a501$exports;
$c03a360af3c87456$var$ListCache.prototype["delete"] = $5ddeba6284ace21b$exports;
$c03a360af3c87456$var$ListCache.prototype.get = $7d17c47284f15e17$exports;
$c03a360af3c87456$var$ListCache.prototype.has = $2870f9144ac4d007$exports;
$c03a360af3c87456$var$ListCache.prototype.set = $d0197fa95029f733$exports;
$c03a360af3c87456$exports = $c03a360af3c87456$var$ListCache;


var $28fe01065c65793c$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $28fe01065c65793c$var$stackClear() {
    this.__data__ = new $c03a360af3c87456$exports;
    this.size = 0;
}
$28fe01065c65793c$exports = $28fe01065c65793c$var$stackClear;


var $17f9f30dd327edf6$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $17f9f30dd327edf6$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$17f9f30dd327edf6$exports = $17f9f30dd327edf6$var$stackDelete;


var $1b0a79b367d02cba$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1b0a79b367d02cba$var$stackGet(key) {
    return this.__data__.get(key);
}
$1b0a79b367d02cba$exports = $1b0a79b367d02cba$var$stackGet;


var $937f925b122392de$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $937f925b122392de$var$stackHas(key) {
    return this.__data__.has(key);
}
$937f925b122392de$exports = $937f925b122392de$var$stackHas;


var $8bedbb469e360d2b$exports = {};

var $ecd23ce29148d615$exports = {};
var $929a6c5acb32eaf1$exports = {};
var $9ef7687ee84c216a$exports = {};
var $612178f1216980b6$exports = {};
var $3125d712601865c3$exports = {};
var $e62011c91336a38e$exports = {};

var $90DZ0 = parcelRequire("90DZ0");
/** Built-in value references. */ var $e62011c91336a38e$var$Symbol = $90DZ0.Symbol;
$e62011c91336a38e$exports = $e62011c91336a38e$var$Symbol;


var $4e0e22547af04f15$exports = {};

/** Used for built-in method references. */ var $4e0e22547af04f15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4e0e22547af04f15$var$hasOwnProperty = $4e0e22547af04f15$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4e0e22547af04f15$var$nativeObjectToString = $4e0e22547af04f15$var$objectProto.toString;
/** Built-in value references. */ var $4e0e22547af04f15$var$symToStringTag = $e62011c91336a38e$exports ? $e62011c91336a38e$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4e0e22547af04f15$var$getRawTag(value) {
    var isOwn = $4e0e22547af04f15$var$hasOwnProperty.call(value, $4e0e22547af04f15$var$symToStringTag), tag = value[$4e0e22547af04f15$var$symToStringTag];
    try {
        value[$4e0e22547af04f15$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4e0e22547af04f15$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4e0e22547af04f15$var$symToStringTag] = tag;
        else delete value[$4e0e22547af04f15$var$symToStringTag];
    }
    return result;
}
$4e0e22547af04f15$exports = $4e0e22547af04f15$var$getRawTag;


var $a886961d63455237$exports = {};
/** Used for built-in method references. */ var $a886961d63455237$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a886961d63455237$var$nativeObjectToString = $a886961d63455237$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a886961d63455237$var$objectToString(value) {
    return $a886961d63455237$var$nativeObjectToString.call(value);
}
$a886961d63455237$exports = $a886961d63455237$var$objectToString;


/** `Object#toString` result references. */ var $3125d712601865c3$var$nullTag = "[object Null]", $3125d712601865c3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $3125d712601865c3$var$symToStringTag = $e62011c91336a38e$exports ? $e62011c91336a38e$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3125d712601865c3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3125d712601865c3$var$undefinedTag : $3125d712601865c3$var$nullTag;
    return $3125d712601865c3$var$symToStringTag && $3125d712601865c3$var$symToStringTag in Object(value) ? $4e0e22547af04f15$exports(value) : $a886961d63455237$exports(value);
}
$3125d712601865c3$exports = $3125d712601865c3$var$baseGetTag;


var $a907a279eb9c391c$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a907a279eb9c391c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$a907a279eb9c391c$exports = $a907a279eb9c391c$var$isObject;


/** `Object#toString` result references. */ var $612178f1216980b6$var$asyncTag = "[object AsyncFunction]", $612178f1216980b6$var$funcTag = "[object Function]", $612178f1216980b6$var$genTag = "[object GeneratorFunction]", $612178f1216980b6$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $612178f1216980b6$var$isFunction(value) {
    if (!$a907a279eb9c391c$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $3125d712601865c3$exports(value);
    return tag == $612178f1216980b6$var$funcTag || tag == $612178f1216980b6$var$genTag || tag == $612178f1216980b6$var$asyncTag || tag == $612178f1216980b6$var$proxyTag;
}
$612178f1216980b6$exports = $612178f1216980b6$var$isFunction;


var $0c424e165c5aa5fa$exports = {};
var $ac27dcbf61071e7c$exports = {};

var $90DZ0 = parcelRequire("90DZ0");
/** Used to detect overreaching core-js shims. */ var $ac27dcbf61071e7c$var$coreJsData = $90DZ0["__core-js_shared__"];
$ac27dcbf61071e7c$exports = $ac27dcbf61071e7c$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $0c424e165c5aa5fa$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($ac27dcbf61071e7c$exports && $ac27dcbf61071e7c$exports.keys && $ac27dcbf61071e7c$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0c424e165c5aa5fa$var$isMasked(func) {
    return !!$0c424e165c5aa5fa$var$maskSrcKey && $0c424e165c5aa5fa$var$maskSrcKey in func;
}
$0c424e165c5aa5fa$exports = $0c424e165c5aa5fa$var$isMasked;



var $ce9cc1f9c79940bc$exports = {};
/** Used for built-in method references. */ var $ce9cc1f9c79940bc$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce9cc1f9c79940bc$var$funcToString = $ce9cc1f9c79940bc$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ce9cc1f9c79940bc$var$toSource(func) {
    if (func != null) {
        try {
            return $ce9cc1f9c79940bc$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$ce9cc1f9c79940bc$exports = $ce9cc1f9c79940bc$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $9ef7687ee84c216a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $9ef7687ee84c216a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $9ef7687ee84c216a$var$funcProto = Function.prototype, $9ef7687ee84c216a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9ef7687ee84c216a$var$funcToString = $9ef7687ee84c216a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9ef7687ee84c216a$var$hasOwnProperty = $9ef7687ee84c216a$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $9ef7687ee84c216a$var$reIsNative = RegExp("^" + $9ef7687ee84c216a$var$funcToString.call($9ef7687ee84c216a$var$hasOwnProperty).replace($9ef7687ee84c216a$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $9ef7687ee84c216a$var$baseIsNative(value) {
    if (!$a907a279eb9c391c$exports(value) || $0c424e165c5aa5fa$exports(value)) return false;
    var pattern = $612178f1216980b6$exports(value) ? $9ef7687ee84c216a$var$reIsNative : $9ef7687ee84c216a$var$reIsHostCtor;
    return pattern.test($ce9cc1f9c79940bc$exports(value));
}
$9ef7687ee84c216a$exports = $9ef7687ee84c216a$var$baseIsNative;


var $b9e4f34423ae56ea$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b9e4f34423ae56ea$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$b9e4f34423ae56ea$exports = $b9e4f34423ae56ea$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $929a6c5acb32eaf1$var$getNative(object, key) {
    var value = $b9e4f34423ae56ea$exports(object, key);
    return $9ef7687ee84c216a$exports(value) ? value : undefined;
}
$929a6c5acb32eaf1$exports = $929a6c5acb32eaf1$var$getNative;



var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $ecd23ce29148d615$var$Map = $929a6c5acb32eaf1$exports($90DZ0, "Map");
$ecd23ce29148d615$exports = $ecd23ce29148d615$var$Map;


var $c9cf7c353d57a3d9$exports = {};
var $c5552fde0e4da01a$exports = {};
var $e11cf146bd2821c8$exports = {};
var $746d2c4b190fcac2$exports = {};
var $f211d67d36f1822d$exports = {};

/* Built-in method references that are verified to be native. */ var $f211d67d36f1822d$var$nativeCreate = $929a6c5acb32eaf1$exports(Object, "create");
$f211d67d36f1822d$exports = $f211d67d36f1822d$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $746d2c4b190fcac2$var$hashClear() {
    this.__data__ = $f211d67d36f1822d$exports ? $f211d67d36f1822d$exports(null) : {};
    this.size = 0;
}
$746d2c4b190fcac2$exports = $746d2c4b190fcac2$var$hashClear;


var $944937b1f498ffa0$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $944937b1f498ffa0$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$944937b1f498ffa0$exports = $944937b1f498ffa0$var$hashDelete;


var $1c7fde32a4676826$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $1c7fde32a4676826$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $1c7fde32a4676826$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1c7fde32a4676826$var$hasOwnProperty = $1c7fde32a4676826$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1c7fde32a4676826$var$hashGet(key) {
    var data = this.__data__;
    if ($f211d67d36f1822d$exports) {
        var result = data[key];
        return result === $1c7fde32a4676826$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1c7fde32a4676826$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$1c7fde32a4676826$exports = $1c7fde32a4676826$var$hashGet;


var $18306287a99cfbe3$exports = {};

/** Used for built-in method references. */ var $18306287a99cfbe3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18306287a99cfbe3$var$hasOwnProperty = $18306287a99cfbe3$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $18306287a99cfbe3$var$hashHas(key) {
    var data = this.__data__;
    return $f211d67d36f1822d$exports ? data[key] !== undefined : $18306287a99cfbe3$var$hasOwnProperty.call(data, key);
}
$18306287a99cfbe3$exports = $18306287a99cfbe3$var$hashHas;


var $6d2dc2a97470f687$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $6d2dc2a97470f687$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6d2dc2a97470f687$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $f211d67d36f1822d$exports && value === undefined ? $6d2dc2a97470f687$var$HASH_UNDEFINED : value;
    return this;
}
$6d2dc2a97470f687$exports = $6d2dc2a97470f687$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e11cf146bd2821c8$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e11cf146bd2821c8$var$Hash.prototype.clear = $746d2c4b190fcac2$exports;
$e11cf146bd2821c8$var$Hash.prototype["delete"] = $944937b1f498ffa0$exports;
$e11cf146bd2821c8$var$Hash.prototype.get = $1c7fde32a4676826$exports;
$e11cf146bd2821c8$var$Hash.prototype.has = $18306287a99cfbe3$exports;
$e11cf146bd2821c8$var$Hash.prototype.set = $6d2dc2a97470f687$exports;
$e11cf146bd2821c8$exports = $e11cf146bd2821c8$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c5552fde0e4da01a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $e11cf146bd2821c8$exports,
        "map": new ($ecd23ce29148d615$exports || $c03a360af3c87456$exports),
        "string": new $e11cf146bd2821c8$exports
    };
}
$c5552fde0e4da01a$exports = $c5552fde0e4da01a$var$mapCacheClear;


var $61562791956929ce$exports = {};
var $859b2034a216e74e$exports = {};
var $57dffcfcf0724031$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $57dffcfcf0724031$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$57dffcfcf0724031$exports = $57dffcfcf0724031$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $859b2034a216e74e$var$getMapData(map, key) {
    var data = map.__data__;
    return $57dffcfcf0724031$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$859b2034a216e74e$exports = $859b2034a216e74e$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $61562791956929ce$var$mapCacheDelete(key) {
    var result = $859b2034a216e74e$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$61562791956929ce$exports = $61562791956929ce$var$mapCacheDelete;


var $c640b903d8789647$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c640b903d8789647$var$mapCacheGet(key) {
    return $859b2034a216e74e$exports(this, key).get(key);
}
$c640b903d8789647$exports = $c640b903d8789647$var$mapCacheGet;


var $e423968af27f8656$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e423968af27f8656$var$mapCacheHas(key) {
    return $859b2034a216e74e$exports(this, key).has(key);
}
$e423968af27f8656$exports = $e423968af27f8656$var$mapCacheHas;


var $c178db560e0cf9ad$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c178db560e0cf9ad$var$mapCacheSet(key, value) {
    var data = $859b2034a216e74e$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$c178db560e0cf9ad$exports = $c178db560e0cf9ad$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c9cf7c353d57a3d9$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c9cf7c353d57a3d9$var$MapCache.prototype.clear = $c5552fde0e4da01a$exports;
$c9cf7c353d57a3d9$var$MapCache.prototype["delete"] = $61562791956929ce$exports;
$c9cf7c353d57a3d9$var$MapCache.prototype.get = $c640b903d8789647$exports;
$c9cf7c353d57a3d9$var$MapCache.prototype.has = $e423968af27f8656$exports;
$c9cf7c353d57a3d9$var$MapCache.prototype.set = $c178db560e0cf9ad$exports;
$c9cf7c353d57a3d9$exports = $c9cf7c353d57a3d9$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $8bedbb469e360d2b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8bedbb469e360d2b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $c03a360af3c87456$exports) {
        var pairs = data.__data__;
        if (!$ecd23ce29148d615$exports || pairs.length < $8bedbb469e360d2b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $c9cf7c353d57a3d9$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$8bedbb469e360d2b$exports = $8bedbb469e360d2b$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0b7f1a3b3f2b2666$var$Stack(entries) {
    var data = this.__data__ = new $c03a360af3c87456$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$0b7f1a3b3f2b2666$var$Stack.prototype.clear = $28fe01065c65793c$exports;
$0b7f1a3b3f2b2666$var$Stack.prototype["delete"] = $17f9f30dd327edf6$exports;
$0b7f1a3b3f2b2666$var$Stack.prototype.get = $1b0a79b367d02cba$exports;
$0b7f1a3b3f2b2666$var$Stack.prototype.has = $937f925b122392de$exports;
$0b7f1a3b3f2b2666$var$Stack.prototype.set = $8bedbb469e360d2b$exports;
$0b7f1a3b3f2b2666$exports = $0b7f1a3b3f2b2666$var$Stack;


var $84deb446a3e1b942$exports = {};
var $9f3c410396a940ed$exports = {};

var $889fac67ba0c1a3c$exports = {};
var $4ead165e1d32874e$exports = {};

var $4d37dd98a5e9d1b9$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $4d37dd98a5e9d1b9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $4d37dd98a5e9d1b9$var$setCacheAdd(value) {
    this.__data__.set(value, $4d37dd98a5e9d1b9$var$HASH_UNDEFINED);
    return this;
}
$4d37dd98a5e9d1b9$exports = $4d37dd98a5e9d1b9$var$setCacheAdd;


var $4ef246cbd2e1fd38$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $4ef246cbd2e1fd38$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$4ef246cbd2e1fd38$exports = $4ef246cbd2e1fd38$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $4ead165e1d32874e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $c9cf7c353d57a3d9$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$4ead165e1d32874e$var$SetCache.prototype.add = $4ead165e1d32874e$var$SetCache.prototype.push = $4d37dd98a5e9d1b9$exports;
$4ead165e1d32874e$var$SetCache.prototype.has = $4ef246cbd2e1fd38$exports;
$4ead165e1d32874e$exports = $4ead165e1d32874e$var$SetCache;


var $f79ca59ba54b6324$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $f79ca59ba54b6324$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$f79ca59ba54b6324$exports = $f79ca59ba54b6324$var$arraySome;


var $738d1e9174cf1920$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $738d1e9174cf1920$var$cacheHas(cache, key) {
    return cache.has(key);
}
$738d1e9174cf1920$exports = $738d1e9174cf1920$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $889fac67ba0c1a3c$var$COMPARE_PARTIAL_FLAG = 1, $889fac67ba0c1a3c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $889fac67ba0c1a3c$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $889fac67ba0c1a3c$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $889fac67ba0c1a3c$var$COMPARE_UNORDERED_FLAG ? new $4ead165e1d32874e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$f79ca59ba54b6324$exports(other, function(othValue, othIndex) {
                if (!$738d1e9174cf1920$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$889fac67ba0c1a3c$exports = $889fac67ba0c1a3c$var$equalArrays;


var $5ddccacbf661a7e0$exports = {};

var $6eb0233855d9f9d2$exports = {};

var $90DZ0 = parcelRequire("90DZ0");
/** Built-in value references. */ var $6eb0233855d9f9d2$var$Uint8Array = $90DZ0.Uint8Array;
$6eb0233855d9f9d2$exports = $6eb0233855d9f9d2$var$Uint8Array;




var $7877b9ec4c466bbb$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $7877b9ec4c466bbb$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$7877b9ec4c466bbb$exports = $7877b9ec4c466bbb$var$mapToArray;


var $dbba5f9c5ff69d7a$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $dbba5f9c5ff69d7a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$dbba5f9c5ff69d7a$exports = $dbba5f9c5ff69d7a$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $5ddccacbf661a7e0$var$COMPARE_PARTIAL_FLAG = 1, $5ddccacbf661a7e0$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $5ddccacbf661a7e0$var$boolTag = "[object Boolean]", $5ddccacbf661a7e0$var$dateTag = "[object Date]", $5ddccacbf661a7e0$var$errorTag = "[object Error]", $5ddccacbf661a7e0$var$mapTag = "[object Map]", $5ddccacbf661a7e0$var$numberTag = "[object Number]", $5ddccacbf661a7e0$var$regexpTag = "[object RegExp]", $5ddccacbf661a7e0$var$setTag = "[object Set]", $5ddccacbf661a7e0$var$stringTag = "[object String]", $5ddccacbf661a7e0$var$symbolTag = "[object Symbol]";
var $5ddccacbf661a7e0$var$arrayBufferTag = "[object ArrayBuffer]", $5ddccacbf661a7e0$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $5ddccacbf661a7e0$var$symbolProto = $e62011c91336a38e$exports ? $e62011c91336a38e$exports.prototype : undefined, $5ddccacbf661a7e0$var$symbolValueOf = $5ddccacbf661a7e0$var$symbolProto ? $5ddccacbf661a7e0$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5ddccacbf661a7e0$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $5ddccacbf661a7e0$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $5ddccacbf661a7e0$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $6eb0233855d9f9d2$exports(object), new $6eb0233855d9f9d2$exports(other))) return false;
            return true;
        case $5ddccacbf661a7e0$var$boolTag:
        case $5ddccacbf661a7e0$var$dateTag:
        case $5ddccacbf661a7e0$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $d13292808fb6c9f3$exports(+object, +other);
        case $5ddccacbf661a7e0$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $5ddccacbf661a7e0$var$regexpTag:
        case $5ddccacbf661a7e0$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $5ddccacbf661a7e0$var$mapTag:
            var convert = $7877b9ec4c466bbb$exports;
        case $5ddccacbf661a7e0$var$setTag:
            var isPartial = bitmask & $5ddccacbf661a7e0$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $dbba5f9c5ff69d7a$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $5ddccacbf661a7e0$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $889fac67ba0c1a3c$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $5ddccacbf661a7e0$var$symbolTag:
            if ($5ddccacbf661a7e0$var$symbolValueOf) return $5ddccacbf661a7e0$var$symbolValueOf.call(object) == $5ddccacbf661a7e0$var$symbolValueOf.call(other);
    }
    return false;
}
$5ddccacbf661a7e0$exports = $5ddccacbf661a7e0$var$equalByTag;


var $3da46543fa8e58d4$exports = {};
var $c1e16af8d2378bd4$exports = {};
var $175c4b19c2fa1459$exports = {};
var $575d7cfe73cf9a75$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $575d7cfe73cf9a75$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$575d7cfe73cf9a75$exports = $575d7cfe73cf9a75$var$arrayPush;


var $d30563dfe4b5a399$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d30563dfe4b5a399$var$isArray = Array.isArray;
$d30563dfe4b5a399$exports = $d30563dfe4b5a399$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $175c4b19c2fa1459$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $d30563dfe4b5a399$exports(object) ? result : $575d7cfe73cf9a75$exports(result, symbolsFunc(object));
}
$175c4b19c2fa1459$exports = $175c4b19c2fa1459$var$baseGetAllKeys;


var $bdab7f89335843c3$exports = {};
var $ba0447a4ae86c3c6$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ba0447a4ae86c3c6$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$ba0447a4ae86c3c6$exports = $ba0447a4ae86c3c6$var$arrayFilter;


var $3a273c644af62660$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $3a273c644af62660$var$stubArray() {
    return [];
}
$3a273c644af62660$exports = $3a273c644af62660$var$stubArray;


/** Used for built-in method references. */ var $bdab7f89335843c3$var$objectProto = Object.prototype;
/** Built-in value references. */ var $bdab7f89335843c3$var$propertyIsEnumerable = $bdab7f89335843c3$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bdab7f89335843c3$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $bdab7f89335843c3$var$getSymbols = !$bdab7f89335843c3$var$nativeGetSymbols ? $3a273c644af62660$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $ba0447a4ae86c3c6$exports($bdab7f89335843c3$var$nativeGetSymbols(object), function(symbol) {
        return $bdab7f89335843c3$var$propertyIsEnumerable.call(object, symbol);
    });
};
$bdab7f89335843c3$exports = $bdab7f89335843c3$var$getSymbols;


var $938ef6bad5499717$exports = {};
var $bc681d0dea7aaa7f$exports = {};
var $3a3bf8e6fa707b17$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3a3bf8e6fa707b17$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$3a3bf8e6fa707b17$exports = $3a3bf8e6fa707b17$var$baseTimes;


var $80896eeab9a768af$exports = {};
var $c6a7fcd8c84d36d9$exports = {};

var $211120fa3b9d50b6$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $211120fa3b9d50b6$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$211120fa3b9d50b6$exports = $211120fa3b9d50b6$var$isObjectLike;


/** `Object#toString` result references. */ var $c6a7fcd8c84d36d9$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c6a7fcd8c84d36d9$var$baseIsArguments(value) {
    return $211120fa3b9d50b6$exports(value) && $3125d712601865c3$exports(value) == $c6a7fcd8c84d36d9$var$argsTag;
}
$c6a7fcd8c84d36d9$exports = $c6a7fcd8c84d36d9$var$baseIsArguments;



/** Used for built-in method references. */ var $80896eeab9a768af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $80896eeab9a768af$var$hasOwnProperty = $80896eeab9a768af$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $80896eeab9a768af$var$propertyIsEnumerable = $80896eeab9a768af$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $80896eeab9a768af$var$isArguments = $c6a7fcd8c84d36d9$exports(function() {
    return arguments;
}()) ? $c6a7fcd8c84d36d9$exports : function(value) {
    return $211120fa3b9d50b6$exports(value) && $80896eeab9a768af$var$hasOwnProperty.call(value, "callee") && !$80896eeab9a768af$var$propertyIsEnumerable.call(value, "callee");
};
$80896eeab9a768af$exports = $80896eeab9a768af$var$isArguments;




var $kNG5d = parcelRequire("kNG5d");
var $419a027284a64f12$exports = {};
/** Used as references for various `Number` constants. */ var $419a027284a64f12$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $419a027284a64f12$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $419a027284a64f12$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $419a027284a64f12$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $419a027284a64f12$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$419a027284a64f12$exports = $419a027284a64f12$var$isIndex;


var $c08e6012d64254c0$exports = {};
var $91e4841e9e1f5ca9$exports = {};

var $648f935d2d306587$exports = {};
/** Used as references for various `Number` constants. */ var $648f935d2d306587$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $648f935d2d306587$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $648f935d2d306587$var$MAX_SAFE_INTEGER;
}
$648f935d2d306587$exports = $648f935d2d306587$var$isLength;



/** `Object#toString` result references. */ var $91e4841e9e1f5ca9$var$argsTag = "[object Arguments]", $91e4841e9e1f5ca9$var$arrayTag = "[object Array]", $91e4841e9e1f5ca9$var$boolTag = "[object Boolean]", $91e4841e9e1f5ca9$var$dateTag = "[object Date]", $91e4841e9e1f5ca9$var$errorTag = "[object Error]", $91e4841e9e1f5ca9$var$funcTag = "[object Function]", $91e4841e9e1f5ca9$var$mapTag = "[object Map]", $91e4841e9e1f5ca9$var$numberTag = "[object Number]", $91e4841e9e1f5ca9$var$objectTag = "[object Object]", $91e4841e9e1f5ca9$var$regexpTag = "[object RegExp]", $91e4841e9e1f5ca9$var$setTag = "[object Set]", $91e4841e9e1f5ca9$var$stringTag = "[object String]", $91e4841e9e1f5ca9$var$weakMapTag = "[object WeakMap]";
var $91e4841e9e1f5ca9$var$arrayBufferTag = "[object ArrayBuffer]", $91e4841e9e1f5ca9$var$dataViewTag = "[object DataView]", $91e4841e9e1f5ca9$var$float32Tag = "[object Float32Array]", $91e4841e9e1f5ca9$var$float64Tag = "[object Float64Array]", $91e4841e9e1f5ca9$var$int8Tag = "[object Int8Array]", $91e4841e9e1f5ca9$var$int16Tag = "[object Int16Array]", $91e4841e9e1f5ca9$var$int32Tag = "[object Int32Array]", $91e4841e9e1f5ca9$var$uint8Tag = "[object Uint8Array]", $91e4841e9e1f5ca9$var$uint8ClampedTag = "[object Uint8ClampedArray]", $91e4841e9e1f5ca9$var$uint16Tag = "[object Uint16Array]", $91e4841e9e1f5ca9$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $91e4841e9e1f5ca9$var$typedArrayTags = {};
$91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$float32Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$float64Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$int8Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$int16Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$int32Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint8Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint8ClampedTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint16Tag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$uint32Tag] = true;
$91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$argsTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$arrayTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$arrayBufferTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$boolTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$dataViewTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$dateTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$errorTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$funcTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$mapTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$numberTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$objectTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$regexpTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$setTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$stringTag] = $91e4841e9e1f5ca9$var$typedArrayTags[$91e4841e9e1f5ca9$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $91e4841e9e1f5ca9$var$baseIsTypedArray(value) {
    return $211120fa3b9d50b6$exports(value) && $648f935d2d306587$exports(value.length) && !!$91e4841e9e1f5ca9$var$typedArrayTags[$3125d712601865c3$exports(value)];
}
$91e4841e9e1f5ca9$exports = $91e4841e9e1f5ca9$var$baseIsTypedArray;


var $2e7c12d7c1c23c18$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $2e7c12d7c1c23c18$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$2e7c12d7c1c23c18$exports = $2e7c12d7c1c23c18$var$baseUnary;



var $61667 = parcelRequire("61667");
/* Node.js helper references. */ var $c08e6012d64254c0$var$nodeIsTypedArray = $61667 && $61667.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $c08e6012d64254c0$var$isTypedArray = $c08e6012d64254c0$var$nodeIsTypedArray ? $2e7c12d7c1c23c18$exports($c08e6012d64254c0$var$nodeIsTypedArray) : $91e4841e9e1f5ca9$exports;
$c08e6012d64254c0$exports = $c08e6012d64254c0$var$isTypedArray;


/** Used for built-in method references. */ var $bc681d0dea7aaa7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bc681d0dea7aaa7f$var$hasOwnProperty = $bc681d0dea7aaa7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $bc681d0dea7aaa7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $d30563dfe4b5a399$exports(value), isArg = !isArr && $80896eeab9a768af$exports(value), isBuff = !isArr && !isArg && $kNG5d(value), isType = !isArr && !isArg && !isBuff && $c08e6012d64254c0$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $3a3bf8e6fa707b17$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $bc681d0dea7aaa7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $419a027284a64f12$exports(key, length)))) result.push(key);
    return result;
}
$bc681d0dea7aaa7f$exports = $bc681d0dea7aaa7f$var$arrayLikeKeys;


var $cfd4a1b5fe90449a$exports = {};
var $0acc6119f1de8223$exports = {};
/** Used for built-in method references. */ var $0acc6119f1de8223$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0acc6119f1de8223$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $0acc6119f1de8223$var$objectProto;
    return value === proto;
}
$0acc6119f1de8223$exports = $0acc6119f1de8223$var$isPrototype;


var $fcf0f6ff5ed9829c$exports = {};
var $4c8142e631f639a0$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4c8142e631f639a0$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$4c8142e631f639a0$exports = $4c8142e631f639a0$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $fcf0f6ff5ed9829c$var$nativeKeys = $4c8142e631f639a0$exports(Object.keys, Object);
$fcf0f6ff5ed9829c$exports = $fcf0f6ff5ed9829c$var$nativeKeys;


/** Used for built-in method references. */ var $cfd4a1b5fe90449a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cfd4a1b5fe90449a$var$hasOwnProperty = $cfd4a1b5fe90449a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cfd4a1b5fe90449a$var$baseKeys(object) {
    if (!$0acc6119f1de8223$exports(object)) return $fcf0f6ff5ed9829c$exports(object);
    var result = [];
    for(var key in Object(object))if ($cfd4a1b5fe90449a$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$cfd4a1b5fe90449a$exports = $cfd4a1b5fe90449a$var$baseKeys;


var $06a40c4626ec02cc$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $06a40c4626ec02cc$var$isArrayLike(value) {
    return value != null && $648f935d2d306587$exports(value.length) && !$612178f1216980b6$exports(value);
}
$06a40c4626ec02cc$exports = $06a40c4626ec02cc$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $938ef6bad5499717$var$keys(object) {
    return $06a40c4626ec02cc$exports(object) ? $bc681d0dea7aaa7f$exports(object) : $cfd4a1b5fe90449a$exports(object);
}
$938ef6bad5499717$exports = $938ef6bad5499717$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c1e16af8d2378bd4$var$getAllKeys(object) {
    return $175c4b19c2fa1459$exports(object, $938ef6bad5499717$exports, $bdab7f89335843c3$exports);
}
$c1e16af8d2378bd4$exports = $c1e16af8d2378bd4$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $3da46543fa8e58d4$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3da46543fa8e58d4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da46543fa8e58d4$var$hasOwnProperty = $3da46543fa8e58d4$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3da46543fa8e58d4$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3da46543fa8e58d4$var$COMPARE_PARTIAL_FLAG, objProps = $c1e16af8d2378bd4$exports(object), objLength = objProps.length, othProps = $c1e16af8d2378bd4$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3da46543fa8e58d4$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$3da46543fa8e58d4$exports = $3da46543fa8e58d4$var$equalObjects;


var $5a2eb8212e9759db$exports = {};
var $eaf6a06c5a810587$exports = {};


var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $eaf6a06c5a810587$var$DataView = $929a6c5acb32eaf1$exports($90DZ0, "DataView");
$eaf6a06c5a810587$exports = $eaf6a06c5a810587$var$DataView;



var $49526a9ff16d96e7$exports = {};


var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $49526a9ff16d96e7$var$Promise = $929a6c5acb32eaf1$exports($90DZ0, "Promise");
$49526a9ff16d96e7$exports = $49526a9ff16d96e7$var$Promise;


var $960ca74452c26c48$exports = {};


var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $960ca74452c26c48$var$Set = $929a6c5acb32eaf1$exports($90DZ0, "Set");
$960ca74452c26c48$exports = $960ca74452c26c48$var$Set;


var $fc46342694bd5fc0$exports = {};


var $90DZ0 = parcelRequire("90DZ0");
/* Built-in method references that are verified to be native. */ var $fc46342694bd5fc0$var$WeakMap = $929a6c5acb32eaf1$exports($90DZ0, "WeakMap");
$fc46342694bd5fc0$exports = $fc46342694bd5fc0$var$WeakMap;




/** `Object#toString` result references. */ var $5a2eb8212e9759db$var$mapTag = "[object Map]", $5a2eb8212e9759db$var$objectTag = "[object Object]", $5a2eb8212e9759db$var$promiseTag = "[object Promise]", $5a2eb8212e9759db$var$setTag = "[object Set]", $5a2eb8212e9759db$var$weakMapTag = "[object WeakMap]";
var $5a2eb8212e9759db$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5a2eb8212e9759db$var$dataViewCtorString = $ce9cc1f9c79940bc$exports($eaf6a06c5a810587$exports), $5a2eb8212e9759db$var$mapCtorString = $ce9cc1f9c79940bc$exports($ecd23ce29148d615$exports), $5a2eb8212e9759db$var$promiseCtorString = $ce9cc1f9c79940bc$exports($49526a9ff16d96e7$exports), $5a2eb8212e9759db$var$setCtorString = $ce9cc1f9c79940bc$exports($960ca74452c26c48$exports), $5a2eb8212e9759db$var$weakMapCtorString = $ce9cc1f9c79940bc$exports($fc46342694bd5fc0$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5a2eb8212e9759db$var$getTag = $3125d712601865c3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($eaf6a06c5a810587$exports && $5a2eb8212e9759db$var$getTag(new $eaf6a06c5a810587$exports(new ArrayBuffer(1))) != $5a2eb8212e9759db$var$dataViewTag || $ecd23ce29148d615$exports && $5a2eb8212e9759db$var$getTag(new $ecd23ce29148d615$exports) != $5a2eb8212e9759db$var$mapTag || $49526a9ff16d96e7$exports && $5a2eb8212e9759db$var$getTag($49526a9ff16d96e7$exports.resolve()) != $5a2eb8212e9759db$var$promiseTag || $960ca74452c26c48$exports && $5a2eb8212e9759db$var$getTag(new $960ca74452c26c48$exports) != $5a2eb8212e9759db$var$setTag || $fc46342694bd5fc0$exports && $5a2eb8212e9759db$var$getTag(new $fc46342694bd5fc0$exports) != $5a2eb8212e9759db$var$weakMapTag) $5a2eb8212e9759db$var$getTag = function(value) {
    var result = $3125d712601865c3$exports(value), Ctor = result == $5a2eb8212e9759db$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $ce9cc1f9c79940bc$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5a2eb8212e9759db$var$dataViewCtorString:
            return $5a2eb8212e9759db$var$dataViewTag;
        case $5a2eb8212e9759db$var$mapCtorString:
            return $5a2eb8212e9759db$var$mapTag;
        case $5a2eb8212e9759db$var$promiseCtorString:
            return $5a2eb8212e9759db$var$promiseTag;
        case $5a2eb8212e9759db$var$setCtorString:
            return $5a2eb8212e9759db$var$setTag;
        case $5a2eb8212e9759db$var$weakMapCtorString:
            return $5a2eb8212e9759db$var$weakMapTag;
    }
    return result;
};
$5a2eb8212e9759db$exports = $5a2eb8212e9759db$var$getTag;




var $kNG5d = parcelRequire("kNG5d");

/** Used to compose bitmasks for value comparisons. */ var $9f3c410396a940ed$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $9f3c410396a940ed$var$argsTag = "[object Arguments]", $9f3c410396a940ed$var$arrayTag = "[object Array]", $9f3c410396a940ed$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $9f3c410396a940ed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9f3c410396a940ed$var$hasOwnProperty = $9f3c410396a940ed$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9f3c410396a940ed$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $d30563dfe4b5a399$exports(object), othIsArr = $d30563dfe4b5a399$exports(other), objTag = objIsArr ? $9f3c410396a940ed$var$arrayTag : $5a2eb8212e9759db$exports(object), othTag = othIsArr ? $9f3c410396a940ed$var$arrayTag : $5a2eb8212e9759db$exports(other);
    objTag = objTag == $9f3c410396a940ed$var$argsTag ? $9f3c410396a940ed$var$objectTag : objTag;
    othTag = othTag == $9f3c410396a940ed$var$argsTag ? $9f3c410396a940ed$var$objectTag : othTag;
    var objIsObj = objTag == $9f3c410396a940ed$var$objectTag, othIsObj = othTag == $9f3c410396a940ed$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $kNG5d(object)) {
        if (!$kNG5d(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $0b7f1a3b3f2b2666$exports);
        return objIsArr || $c08e6012d64254c0$exports(object) ? $889fac67ba0c1a3c$exports(object, other, bitmask, customizer, equalFunc, stack) : $5ddccacbf661a7e0$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $9f3c410396a940ed$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $9f3c410396a940ed$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $9f3c410396a940ed$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $0b7f1a3b3f2b2666$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $0b7f1a3b3f2b2666$exports);
    return $3da46543fa8e58d4$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$9f3c410396a940ed$exports = $9f3c410396a940ed$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $84deb446a3e1b942$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$211120fa3b9d50b6$exports(value) && !$211120fa3b9d50b6$exports(other)) return value !== value && other !== other;
    return $9f3c410396a940ed$exports(value, other, bitmask, customizer, $84deb446a3e1b942$var$baseIsEqual, stack);
}
$84deb446a3e1b942$exports = $84deb446a3e1b942$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $2cf33e48e1909fb9$var$COMPARE_PARTIAL_FLAG = 1, $2cf33e48e1909fb9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2cf33e48e1909fb9$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $0b7f1a3b3f2b2666$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $84deb446a3e1b942$exports(srcValue, objValue, $2cf33e48e1909fb9$var$COMPARE_PARTIAL_FLAG | $2cf33e48e1909fb9$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$2cf33e48e1909fb9$exports = $2cf33e48e1909fb9$var$baseIsMatch;


var $20a45eb50ccff1f3$exports = {};
var $c20c96418f916da3$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $c20c96418f916da3$var$isStrictComparable(value) {
    return value === value && !$a907a279eb9c391c$exports(value);
}
$c20c96418f916da3$exports = $c20c96418f916da3$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $20a45eb50ccff1f3$var$getMatchData(object) {
    var result = $938ef6bad5499717$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $c20c96418f916da3$exports(value)
        ];
    }
    return result;
}
$20a45eb50ccff1f3$exports = $20a45eb50ccff1f3$var$getMatchData;


var $bd940c14e1a46ca1$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $bd940c14e1a46ca1$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$bd940c14e1a46ca1$exports = $bd940c14e1a46ca1$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $8d50d509810e290d$var$baseMatches(source) {
    var matchData = $20a45eb50ccff1f3$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $bd940c14e1a46ca1$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2cf33e48e1909fb9$exports(object, source, matchData);
    };
}
$8d50d509810e290d$exports = $8d50d509810e290d$var$baseMatches;


var $80b3ba164936a3ba$exports = {};

var $ce7ee28b4c2e921d$exports = {};
var $7ff4fcece97a0cbf$exports = {};
var $6ffd8603ecec6b04$exports = {};

var $4ef65d81fa207eed$exports = {};

var $5339777265736955$exports = {};


/** `Object#toString` result references. */ var $5339777265736955$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5339777265736955$var$isSymbol(value) {
    return typeof value == "symbol" || $211120fa3b9d50b6$exports(value) && $3125d712601865c3$exports(value) == $5339777265736955$var$symbolTag;
}
$5339777265736955$exports = $5339777265736955$var$isSymbol;


/** Used to match property names within property paths. */ var $4ef65d81fa207eed$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $4ef65d81fa207eed$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $4ef65d81fa207eed$var$isKey(value, object) {
    if ($d30563dfe4b5a399$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $5339777265736955$exports(value)) return true;
    return $4ef65d81fa207eed$var$reIsPlainProp.test(value) || !$4ef65d81fa207eed$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$4ef65d81fa207eed$exports = $4ef65d81fa207eed$var$isKey;


var $b84a2bcafe1cf48a$exports = {};
var $48f8945a6f240127$exports = {};
var $2953d175e6e33a4c$exports = {};

/** Error message constants. */ var $2953d175e6e33a4c$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $2953d175e6e33a4c$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($2953d175e6e33a4c$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($2953d175e6e33a4c$var$memoize.Cache || $c9cf7c353d57a3d9$exports);
    return memoized;
}
// Expose `MapCache`.
$2953d175e6e33a4c$var$memoize.Cache = $c9cf7c353d57a3d9$exports;
$2953d175e6e33a4c$exports = $2953d175e6e33a4c$var$memoize;


/** Used as the maximum memoize cache size. */ var $48f8945a6f240127$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $48f8945a6f240127$var$memoizeCapped(func) {
    var result = $2953d175e6e33a4c$exports(func, function(key) {
        if (cache.size === $48f8945a6f240127$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$48f8945a6f240127$exports = $48f8945a6f240127$var$memoizeCapped;


/** Used to match property names within property paths. */ var $b84a2bcafe1cf48a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $b84a2bcafe1cf48a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $b84a2bcafe1cf48a$var$stringToPath = $48f8945a6f240127$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($b84a2bcafe1cf48a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($b84a2bcafe1cf48a$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$b84a2bcafe1cf48a$exports = $b84a2bcafe1cf48a$var$stringToPath;


var $5f889ff337c3b19a$exports = {};
var $dc393d85e9974d53$exports = {};




/** Used as references for various `Number` constants. */ var $dc393d85e9974d53$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $dc393d85e9974d53$var$symbolProto = $e62011c91336a38e$exports ? $e62011c91336a38e$exports.prototype : undefined, $dc393d85e9974d53$var$symbolToString = $dc393d85e9974d53$var$symbolProto ? $dc393d85e9974d53$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dc393d85e9974d53$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($d30563dfe4b5a399$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $1286baf6978c1736$exports(value, $dc393d85e9974d53$var$baseToString) + "";
    if ($5339777265736955$exports(value)) return $dc393d85e9974d53$var$symbolToString ? $dc393d85e9974d53$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$dc393d85e9974d53$var$INFINITY ? "-0" : result;
}
$dc393d85e9974d53$exports = $dc393d85e9974d53$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $5f889ff337c3b19a$var$toString(value) {
    return value == null ? "" : $dc393d85e9974d53$exports(value);
}
$5f889ff337c3b19a$exports = $5f889ff337c3b19a$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $6ffd8603ecec6b04$var$castPath(value, object) {
    if ($d30563dfe4b5a399$exports(value)) return value;
    return $4ef65d81fa207eed$exports(value, object) ? [
        value
    ] : $b84a2bcafe1cf48a$exports($5f889ff337c3b19a$exports(value));
}
$6ffd8603ecec6b04$exports = $6ffd8603ecec6b04$var$castPath;


var $df71fee66688396e$exports = {};

/** Used as references for various `Number` constants. */ var $df71fee66688396e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $df71fee66688396e$var$toKey(value) {
    if (typeof value == "string" || $5339777265736955$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$df71fee66688396e$var$INFINITY ? "-0" : result;
}
$df71fee66688396e$exports = $df71fee66688396e$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $7ff4fcece97a0cbf$var$baseGet(object, path) {
    path = $6ffd8603ecec6b04$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$df71fee66688396e$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$7ff4fcece97a0cbf$exports = $7ff4fcece97a0cbf$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $ce7ee28b4c2e921d$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7ff4fcece97a0cbf$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$ce7ee28b4c2e921d$exports = $ce7ee28b4c2e921d$var$get;


var $a14bdbb22e4c8140$exports = {};
var $d43185d79c9ca6ed$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d43185d79c9ca6ed$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d43185d79c9ca6ed$exports = $d43185d79c9ca6ed$var$baseHasIn;


var $c686a5359976c05b$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $c686a5359976c05b$var$hasPath(object, path, hasFunc) {
    path = $6ffd8603ecec6b04$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $df71fee66688396e$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $648f935d2d306587$exports(length) && $419a027284a64f12$exports(key, length) && ($d30563dfe4b5a399$exports(object) || $80896eeab9a768af$exports(object));
}
$c686a5359976c05b$exports = $c686a5359976c05b$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a14bdbb22e4c8140$var$hasIn(object, path) {
    return object != null && $c686a5359976c05b$exports(object, path, $d43185d79c9ca6ed$exports);
}
$a14bdbb22e4c8140$exports = $a14bdbb22e4c8140$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $80b3ba164936a3ba$var$COMPARE_PARTIAL_FLAG = 1, $80b3ba164936a3ba$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $80b3ba164936a3ba$var$baseMatchesProperty(path, srcValue) {
    if ($4ef65d81fa207eed$exports(path) && $c20c96418f916da3$exports(srcValue)) return $bd940c14e1a46ca1$exports($df71fee66688396e$exports(path), srcValue);
    return function(object) {
        var objValue = $ce7ee28b4c2e921d$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $a14bdbb22e4c8140$exports(object, path) : $84deb446a3e1b942$exports(srcValue, objValue, $80b3ba164936a3ba$var$COMPARE_PARTIAL_FLAG | $80b3ba164936a3ba$var$COMPARE_UNORDERED_FLAG);
    };
}
$80b3ba164936a3ba$exports = $80b3ba164936a3ba$var$baseMatchesProperty;


var $e46546f1a84cd405$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e46546f1a84cd405$var$identity(value) {
    return value;
}
$e46546f1a84cd405$exports = $e46546f1a84cd405$var$identity;



var $cbaae0f7b30ed265$exports = {};
var $7be16c6c4c194907$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7be16c6c4c194907$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$7be16c6c4c194907$exports = $7be16c6c4c194907$var$baseProperty;


var $49d020086cc7a841$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $49d020086cc7a841$var$basePropertyDeep(path) {
    return function(object) {
        return $7ff4fcece97a0cbf$exports(object, path);
    };
}
$49d020086cc7a841$exports = $49d020086cc7a841$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $cbaae0f7b30ed265$var$property(path) {
    return $4ef65d81fa207eed$exports(path) ? $7be16c6c4c194907$exports($df71fee66688396e$exports(path)) : $49d020086cc7a841$exports(path);
}
$cbaae0f7b30ed265$exports = $cbaae0f7b30ed265$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $1c889f35b6a76829$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $e46546f1a84cd405$exports;
    if (typeof value == "object") return $d30563dfe4b5a399$exports(value) ? $80b3ba164936a3ba$exports(value[0], value[1]) : $8d50d509810e290d$exports(value);
    return $cbaae0f7b30ed265$exports(value);
}
$1c889f35b6a76829$exports = $1c889f35b6a76829$var$baseIteratee;


var $0515bc7c56ee2691$exports = {};

var $7d52e9ad15c449bb$exports = {};
var $e08d80eed186b416$exports = {};
var $77165e63beda781c$exports = {};
var $8998a7d51dbf7887$exports = {};

var $8998a7d51dbf7887$var$defineProperty = function() {
    try {
        var func = $929a6c5acb32eaf1$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$8998a7d51dbf7887$exports = $8998a7d51dbf7887$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $77165e63beda781c$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $8998a7d51dbf7887$exports) $8998a7d51dbf7887$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$77165e63beda781c$exports = $77165e63beda781c$var$baseAssignValue;



/** Used for built-in method references. */ var $e08d80eed186b416$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e08d80eed186b416$var$hasOwnProperty = $e08d80eed186b416$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e08d80eed186b416$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($e08d80eed186b416$var$hasOwnProperty.call(object, key) && $d13292808fb6c9f3$exports(objValue, value)) || value === undefined && !(key in object)) $77165e63beda781c$exports(object, key, value);
}
$e08d80eed186b416$exports = $e08d80eed186b416$var$assignValue;






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $7d52e9ad15c449bb$var$baseSet(object, path, value, customizer) {
    if (!$a907a279eb9c391c$exports(object)) return object;
    path = $6ffd8603ecec6b04$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $df71fee66688396e$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $a907a279eb9c391c$exports(objValue) ? objValue : $419a027284a64f12$exports(path[index + 1]) ? [] : {};
        }
        $e08d80eed186b416$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$7d52e9ad15c449bb$exports = $7d52e9ad15c449bb$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $0515bc7c56ee2691$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $7ff4fcece97a0cbf$exports(object, path);
        if (predicate(value, path)) $7d52e9ad15c449bb$exports(result, $6ffd8603ecec6b04$exports(path, object), value);
    }
    return result;
}
$0515bc7c56ee2691$exports = $0515bc7c56ee2691$var$basePickBy;


var $f943f40b48630a0f$exports = {};

var $b8232b0a95a7ca78$exports = {};

var $2d3fbf15bb262d54$exports = {};

/** Built-in value references. */ var $2d3fbf15bb262d54$var$getPrototype = $4c8142e631f639a0$exports(Object.getPrototypeOf, Object);
$2d3fbf15bb262d54$exports = $2d3fbf15bb262d54$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $b8232b0a95a7ca78$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b8232b0a95a7ca78$var$getSymbolsIn = !$b8232b0a95a7ca78$var$nativeGetSymbols ? $3a273c644af62660$exports : function(object) {
    var result = [];
    while(object){
        $575d7cfe73cf9a75$exports(result, $bdab7f89335843c3$exports(object));
        object = $2d3fbf15bb262d54$exports(object);
    }
    return result;
};
$b8232b0a95a7ca78$exports = $b8232b0a95a7ca78$var$getSymbolsIn;


var $013baf1d8a379e13$exports = {};

var $58f259b513e72faf$exports = {};


var $3aac4b03468762ed$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $3aac4b03468762ed$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$3aac4b03468762ed$exports = $3aac4b03468762ed$var$nativeKeysIn;


/** Used for built-in method references. */ var $58f259b513e72faf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $58f259b513e72faf$var$hasOwnProperty = $58f259b513e72faf$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $58f259b513e72faf$var$baseKeysIn(object) {
    if (!$a907a279eb9c391c$exports(object)) return $3aac4b03468762ed$exports(object);
    var isProto = $0acc6119f1de8223$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$58f259b513e72faf$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$58f259b513e72faf$exports = $58f259b513e72faf$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $013baf1d8a379e13$var$keysIn(object) {
    return $06a40c4626ec02cc$exports(object) ? $bc681d0dea7aaa7f$exports(object, true) : $58f259b513e72faf$exports(object);
}
$013baf1d8a379e13$exports = $013baf1d8a379e13$var$keysIn;


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f943f40b48630a0f$var$getAllKeysIn(object) {
    return $175c4b19c2fa1459$exports(object, $013baf1d8a379e13$exports, $b8232b0a95a7ca78$exports);
}
$f943f40b48630a0f$exports = $f943f40b48630a0f$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $1fba8391251b976e$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $1286baf6978c1736$exports($f943f40b48630a0f$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $1c889f35b6a76829$exports(predicate);
    return $0515bc7c56ee2691$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$1fba8391251b976e$exports = $1fba8391251b976e$var$pickBy;





// default `autoSignIn` flag is `true`
const $bd617b144b33cb29$var$DEFAULT_AUTO_SIGN_IN = true;
const $bd617b144b33cb29$var$EMPTY_STRING = "";
const $bd617b144b33cb29$export$bdf2363efaa77dc8 = (dialCode, phoneNumber)=>`${dialCode}${phoneNumber}`.replace(/[^A-Z0-9+]/gi, "");
const $bd617b144b33cb29$var$selectUserAttributes = (_, key)=>{
    // Allowlist of Cognito User Pool Attributes (from OpenID Connect specification)
    // See: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
    switch(key){
        case "address":
        case "birthdate":
        case "email":
        case "family_name":
        case "gender":
        case "given_name":
        case "locale":
        case "middle_name":
        case "name":
        case "nickname":
        case "phone_number":
        case "picture":
        case "preferred_username":
        case "profile":
        case "updated_at":
        case "website":
        case "zoneinfo":
            return true;
        // Otherwise, it's a custom attribute
        default:
            return key.startsWith("custom:");
    }
};
const $bd617b144b33cb29$export$e741ea695767fdb4 = (formValues)=>{
    const { phone_number: phone_number, ...userAttributes } = (0, (/*@__PURE__*/$parcel$interopDefault($1fba8391251b976e$exports)))(formValues, $bd617b144b33cb29$var$selectUserAttributes);
    // only include `phone_number` attribute in `userAttributes` if it has a value
    if ((0, $85b840b81f21bd6d$export$844ec244b1367d54)(phone_number) && phone_number !== $bd617b144b33cb29$var$EMPTY_STRING) {
        const { country_code: country_code } = formValues;
        return {
            ...userAttributes,
            phone_number: $bd617b144b33cb29$export$bdf2363efaa77dc8(country_code, phone_number)
        };
    }
    return userAttributes;
};
const $bd617b144b33cb29$export$6bc605b0b68c7601 = (username, formValues, loginMechanism)=>{
    const { password: password, ...values } = formValues;
    const attributes = $bd617b144b33cb29$export$e741ea695767fdb4(values);
    const options = {
        autoSignIn: $bd617b144b33cb29$var$DEFAULT_AUTO_SIGN_IN,
        userAttributes: {
            // use `username` value for `phone_number`
            ...loginMechanism === "phone_number" ? {
                ...attributes,
                phone_number: username
            } : attributes
        }
    };
    return {
        username: username,
        password: password,
        options: options
    };
};
const $bd617b144b33cb29$export$4ff49060fec3afdc = ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
    const loginMechanism = loginMechanisms[0];
    if (loginMechanism === "phone_number") {
        const { country_code: country_code, phone_number: phone_number } = formValues;
        return $bd617b144b33cb29$export$bdf2363efaa77dc8(country_code, phone_number);
    }
    return formValues[loginMechanism];
};


const { assign: $d2a1a0d0733f5d9b$var$assign } = (0, $e262c78e8c90133a$exports);
const $d2a1a0d0733f5d9b$var$clearActorDoneData = $d2a1a0d0733f5d9b$var$assign({
    actorDoneData: undefined
});
const $d2a1a0d0733f5d9b$var$clearChallengeName = $d2a1a0d0733f5d9b$var$assign({
    challengeName: undefined
});
const $d2a1a0d0733f5d9b$var$clearMissingAttributes = $d2a1a0d0733f5d9b$var$assign({
    missingAttributes: undefined
});
const $d2a1a0d0733f5d9b$var$clearError = $d2a1a0d0733f5d9b$var$assign({
    remoteError: undefined
});
const $d2a1a0d0733f5d9b$var$clearFormValues = $d2a1a0d0733f5d9b$var$assign({
    formValues: {}
});
const $d2a1a0d0733f5d9b$var$clearTouched = $d2a1a0d0733f5d9b$var$assign({
    touched: {}
});
const $d2a1a0d0733f5d9b$var$clearUser = $d2a1a0d0733f5d9b$var$assign({
    user: undefined
});
const $d2a1a0d0733f5d9b$var$clearValidationError = $d2a1a0d0733f5d9b$var$assign({
    validationError: {}
});
/**
 * "set" actions
 */ const $d2a1a0d0733f5d9b$var$setTotpSecretCode = $d2a1a0d0733f5d9b$var$assign({
    totpSecretCode: (_, { data: data })=>{
        const { sharedSecret: sharedSecret } = data.nextStep?.totpSetupDetails ?? {};
        return sharedSecret;
    }
});
const $d2a1a0d0733f5d9b$var$setSignInStep = $d2a1a0d0733f5d9b$var$assign({
    step: "SIGN_IN"
});
const $d2a1a0d0733f5d9b$var$setShouldVerifyUserAttributeStep = $d2a1a0d0733f5d9b$var$assign({
    step: "SHOULD_CONFIRM_USER_ATTRIBUTE"
});
const $d2a1a0d0733f5d9b$var$setConfirmAttributeCompleteStep = $d2a1a0d0733f5d9b$var$assign({
    step: "CONFIRM_ATTRIBUTE_COMPLETE"
});
// map v6 `signInStep` to v5 `challengeName`
const $d2a1a0d0733f5d9b$var$setChallengeName = $d2a1a0d0733f5d9b$var$assign({
    challengeName: (_, { data: data })=>{
        const { signInStep: signInStep } = data.nextStep;
        return signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ? "SMS_MFA" : signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE" ? "SOFTWARE_TOKEN_MFA" : undefined;
    }
});
const $d2a1a0d0733f5d9b$var$setUsernameForgotPassword = $d2a1a0d0733f5d9b$var$assign({
    username: ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
        const loginMechanism = loginMechanisms[0];
        const { username: username, country_code: country_code } = formValues;
        if (loginMechanism === "phone_number") // forgot password `formValues` uses `username` for base phone number value
        // prefix `country_code` for full `username`
        return (0, $bd617b144b33cb29$export$bdf2363efaa77dc8)(country_code, username);
        // default username field for loginMechanism === 'email' is "username" for SignIn
        return username;
    }
});
const $d2a1a0d0733f5d9b$var$setUsernameSignUp = $d2a1a0d0733f5d9b$var$assign({
    username: (0, $bd617b144b33cb29$export$4ff49060fec3afdc)
});
const $d2a1a0d0733f5d9b$var$setUsernameSignIn = $d2a1a0d0733f5d9b$var$assign({
    username: ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
        const loginMechanism = loginMechanisms[0];
        const { username: username, country_code: country_code } = formValues;
        if (loginMechanism === "phone_number") // sign in `formValues` uses `username` for base phone number value
        // prefix `country_code` for full `username`
        return (0, $bd617b144b33cb29$export$bdf2363efaa77dc8)(country_code, username);
        // return `email` and `username`
        return username;
    }
});
const $d2a1a0d0733f5d9b$var$setNextSignInStep = $d2a1a0d0733f5d9b$var$assign({
    step: (_, { data: data })=>data.nextStep.signInStep === "DONE" ? "SIGN_IN_COMPLETE" : data.nextStep.signInStep
});
const $d2a1a0d0733f5d9b$var$setNextSignUpStep = $d2a1a0d0733f5d9b$var$assign({
    step: (_, { data: data })=>data.nextStep.signUpStep === "DONE" ? "SIGN_UP_COMPLETE" : data.nextStep.signUpStep
});
const $d2a1a0d0733f5d9b$var$setNextResetPasswordStep = $d2a1a0d0733f5d9b$var$assign({
    step: (_, { data: data })=>data.nextStep.resetPasswordStep === "DONE" ? "RESET_PASSWORD_COMPLETE" : data.nextStep.resetPasswordStep
});
const $d2a1a0d0733f5d9b$var$setMissingAttributes = $d2a1a0d0733f5d9b$var$assign({
    missingAttributes: (_, { data: data })=>data.nextStep?.missingAttributes
});
const $d2a1a0d0733f5d9b$var$setFieldErrors = $d2a1a0d0733f5d9b$var$assign({
    validationError: (_, { data: data })=>data
});
const $d2a1a0d0733f5d9b$var$setRemoteError = $d2a1a0d0733f5d9b$var$assign({
    remoteError: (_, { data: data })=>{
        if (data.name === "NoUserPoolError") return `Configuration error (see console) \u{2013} please contact the administrator`;
        return data?.message || data;
    }
});
const $d2a1a0d0733f5d9b$var$setUser = $d2a1a0d0733f5d9b$var$assign({
    user: (_, { data: data })=>data
});
const $d2a1a0d0733f5d9b$var$resolveCodeDeliveryDetails = (details)=>({
        Destination: details.destination,
        DeliveryMedium: details.deliveryMedium,
        AttributeName: details.attributName
    });
const $d2a1a0d0733f5d9b$var$setCodeDeliveryDetails = $d2a1a0d0733f5d9b$var$assign({
    codeDeliveryDetails: (_, { data: data })=>{
        if (data?.nextStep?.codeDeliveryDetails) return $d2a1a0d0733f5d9b$var$resolveCodeDeliveryDetails(data.nextStep.codeDeliveryDetails);
        return $d2a1a0d0733f5d9b$var$resolveCodeDeliveryDetails(data);
    }
});
const $d2a1a0d0733f5d9b$var$handleInput = $d2a1a0d0733f5d9b$var$assign({
    formValues: (context, { data: data })=>{
        const { name: name, value: value } = data;
        return {
            ...context["formValues"],
            [name]: value
        };
    }
});
const $d2a1a0d0733f5d9b$var$handleSubmit = $d2a1a0d0733f5d9b$var$assign({
    formValues: (context, { data: data })=>// do not trim password
        (0, $508296b373a163a4$export$205c000fb676adf6)({
            ...context["formValues"],
            ...data
        }, "password")
});
const $d2a1a0d0733f5d9b$var$handleBlur = $d2a1a0d0733f5d9b$var$assign({
    touched: (context, { data: data })=>({
            ...context["touched"],
            [data.name]: true
        })
});
const $d2a1a0d0733f5d9b$var$setUnverifiedUserAttributes = $d2a1a0d0733f5d9b$var$assign({
    unverifiedUserAttributes: (_, { data: data })=>{
        const { email: email, phone_number: phone_number } = data;
        const unverifiedUserAttributes = {
            ...email && {
                email: email
            },
            ...phone_number && {
                phone_number: phone_number
            }
        };
        return unverifiedUserAttributes;
    }
});
const $d2a1a0d0733f5d9b$var$clearSelectedUserAttribute = $d2a1a0d0733f5d9b$var$assign({
    selectedUserAttribute: undefined
});
const $d2a1a0d0733f5d9b$var$setSelectedUserAttribute = $d2a1a0d0733f5d9b$var$assign({
    selectedUserAttribute: (context)=>context.formValues?.unverifiedAttr
});
// Maps to unexposed `ConfirmSignUpSignUpStep`
const $d2a1a0d0733f5d9b$var$setConfirmSignUpSignUpStep = $d2a1a0d0733f5d9b$var$assign({
    step: "CONFIRM_SIGN_UP"
});
const $d2a1a0d0733f5d9b$export$2e2bcd8739ae039 = {
    clearActorDoneData: $d2a1a0d0733f5d9b$var$clearActorDoneData,
    clearChallengeName: $d2a1a0d0733f5d9b$var$clearChallengeName,
    clearError: $d2a1a0d0733f5d9b$var$clearError,
    clearFormValues: $d2a1a0d0733f5d9b$var$clearFormValues,
    clearMissingAttributes: $d2a1a0d0733f5d9b$var$clearMissingAttributes,
    clearSelectedUserAttribute: $d2a1a0d0733f5d9b$var$clearSelectedUserAttribute,
    clearTouched: $d2a1a0d0733f5d9b$var$clearTouched,
    clearUser: $d2a1a0d0733f5d9b$var$clearUser,
    clearValidationError: $d2a1a0d0733f5d9b$var$clearValidationError,
    handleBlur: $d2a1a0d0733f5d9b$var$handleBlur,
    handleInput: $d2a1a0d0733f5d9b$var$handleInput,
    handleSubmit: $d2a1a0d0733f5d9b$var$handleSubmit,
    setChallengeName: $d2a1a0d0733f5d9b$var$setChallengeName,
    setCodeDeliveryDetails: $d2a1a0d0733f5d9b$var$setCodeDeliveryDetails,
    setFieldErrors: $d2a1a0d0733f5d9b$var$setFieldErrors,
    setMissingAttributes: $d2a1a0d0733f5d9b$var$setMissingAttributes,
    setNextResetPasswordStep: $d2a1a0d0733f5d9b$var$setNextResetPasswordStep,
    setNextSignInStep: $d2a1a0d0733f5d9b$var$setNextSignInStep,
    setNextSignUpStep: $d2a1a0d0733f5d9b$var$setNextSignUpStep,
    setRemoteError: $d2a1a0d0733f5d9b$var$setRemoteError,
    setConfirmAttributeCompleteStep: $d2a1a0d0733f5d9b$var$setConfirmAttributeCompleteStep,
    setConfirmSignUpSignUpStep: $d2a1a0d0733f5d9b$var$setConfirmSignUpSignUpStep,
    setShouldVerifyUserAttributeStep: $d2a1a0d0733f5d9b$var$setShouldVerifyUserAttributeStep,
    setSelectedUserAttribute: $d2a1a0d0733f5d9b$var$setSelectedUserAttribute,
    setSignInStep: $d2a1a0d0733f5d9b$var$setSignInStep,
    setTotpSecretCode: $d2a1a0d0733f5d9b$var$setTotpSecretCode,
    setUser: $d2a1a0d0733f5d9b$var$setUser,
    setUnverifiedUserAttributes: $d2a1a0d0733f5d9b$var$setUnverifiedUserAttributes,
    setUsernameForgotPassword: $d2a1a0d0733f5d9b$var$setUsernameForgotPassword,
    setUsernameSignIn: $d2a1a0d0733f5d9b$var$setUsernameSignIn,
    setUsernameSignUp: $d2a1a0d0733f5d9b$var$setUsernameSignUp
};


const $b5e04cdb6d60d786$var$SIGN_IN_STEP_MFA_CONFIRMATION = [
    "CONFIRM_SIGN_IN_WITH_SMS_CODE",
    "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
];
// response next step guards
const $b5e04cdb6d60d786$var$shouldConfirmSignInWithNewPassword = (_, { data: data })=>data?.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED";
const $b5e04cdb6d60d786$var$shouldResetPasswordFromSignIn = (_, { data: data })=>data?.nextStep?.signInStep === "RESET_PASSWORD";
const $b5e04cdb6d60d786$var$shouldConfirmSignUpFromSignIn = (_, { data: data })=>data?.nextStep.signInStep === "CONFIRM_SIGN_UP";
const $b5e04cdb6d60d786$var$shouldAutoSignIn = (_, { data: data })=>data?.nextStep.signUpStep === "COMPLETE_AUTO_SIGN_IN";
const $b5e04cdb6d60d786$var$hasCompletedSignIn = (_, { data: data })=>data?.nextStep.signInStep === "DONE";
const $b5e04cdb6d60d786$var$hasCompletedSignUp = (_, { data: data })=>data?.nextStep.signUpStep === "DONE";
const $b5e04cdb6d60d786$var$hasCompletedResetPassword = (_, { data: data })=>data?.nextStep.resetPasswordStep === "DONE";
// actor done guards read `step` from actor exit event
const $b5e04cdb6d60d786$var$hasCompletedAttributeConfirmation = (_, { data: data })=>data?.step === "CONFIRM_ATTRIBUTE_COMPLETE";
const $b5e04cdb6d60d786$var$isConfirmUserAttributeStep = (_, { data: data })=>data?.step === "CONFIRM_ATTRIBUTE_WITH_CODE";
const $b5e04cdb6d60d786$var$isShouldConfirmUserAttributeStep = (_, { data: data })=>data?.step === "SHOULD_CONFIRM_USER_ATTRIBUTE";
const $b5e04cdb6d60d786$var$isResetPasswordStep = (_, { data: data })=>data?.step === "RESET_PASSWORD";
const $b5e04cdb6d60d786$var$isConfirmSignUpStep = (_, { data: data })=>data?.step === "CONFIRM_SIGN_UP";
// actor entry guards read `step` from actor context
const $b5e04cdb6d60d786$var$shouldConfirmSignIn = ({ step: step })=>$b5e04cdb6d60d786$var$SIGN_IN_STEP_MFA_CONFIRMATION.includes(step);
const $b5e04cdb6d60d786$var$shouldSetupTotp = ({ step: step })=>step === "CONTINUE_SIGN_IN_WITH_TOTP_SETUP";
const $b5e04cdb6d60d786$var$shouldResetPassword = ({ step: step })=>step === "RESET_PASSWORD";
const $b5e04cdb6d60d786$var$shouldConfirmResetPassword = ({ step: step })=>step === "CONFIRM_RESET_PASSWORD_WITH_CODE";
const $b5e04cdb6d60d786$var$shouldConfirmSignUp = ({ step: step })=>step === "CONFIRM_SIGN_UP";
// miscellaneous guards
const $b5e04cdb6d60d786$var$shouldVerifyAttribute = (_, { data: data })=>{
    const { phone_number_verified: phone_number_verified, email_verified: email_verified } = data;
    // email/phone_verified is returned as a string
    const emailNotVerified = email_verified === undefined || email_verified === "false";
    const phoneNotVerified = phone_number_verified === undefined || phone_number_verified === "false";
    // only request verification if both email and phone are not verified
    return emailNotVerified && phoneNotVerified;
};
/**
 * This guard covers an edge case that exists in the current state of the UI.
 * As of now, our ConfirmSignUp screen only supports showing an input for a
 * confirmation code. However, a Cognito UserPool can instead verify users
 * through a link that gets emailed to them. If a user verifies through the
 * link and then they click on the "Resend Code" button, they will get an error
 * saying that the user has already been confirmed. If we encounter that error,
 * we want to just funnel them through the rest of the flow. In the future, we will
 * want to update our UI to support both confirmation codes and links.
 *
 * https://github.com/aws-amplify/amplify-ui/issues/219
 */ const $b5e04cdb6d60d786$var$isUserAlreadyConfirmed = (_, { data: data })=>data.message === "User is already confirmed.";
const $b5e04cdb6d60d786$export$2e2bcd8739ae039 = {
    hasCompletedAttributeConfirmation: $b5e04cdb6d60d786$var$hasCompletedAttributeConfirmation,
    hasCompletedResetPassword: $b5e04cdb6d60d786$var$hasCompletedResetPassword,
    hasCompletedSignIn: $b5e04cdb6d60d786$var$hasCompletedSignIn,
    hasCompletedSignUp: $b5e04cdb6d60d786$var$hasCompletedSignUp,
    isConfirmSignUpStep: $b5e04cdb6d60d786$var$isConfirmSignUpStep,
    isConfirmUserAttributeStep: $b5e04cdb6d60d786$var$isConfirmUserAttributeStep,
    isResetPasswordStep: $b5e04cdb6d60d786$var$isResetPasswordStep,
    isShouldConfirmUserAttributeStep: $b5e04cdb6d60d786$var$isShouldConfirmUserAttributeStep,
    isUserAlreadyConfirmed: $b5e04cdb6d60d786$var$isUserAlreadyConfirmed,
    shouldAutoSignIn: $b5e04cdb6d60d786$var$shouldAutoSignIn,
    shouldConfirmResetPassword: $b5e04cdb6d60d786$var$shouldConfirmResetPassword,
    shouldConfirmSignIn: $b5e04cdb6d60d786$var$shouldConfirmSignIn,
    shouldConfirmSignInWithNewPassword: $b5e04cdb6d60d786$var$shouldConfirmSignInWithNewPassword,
    shouldConfirmSignUp: $b5e04cdb6d60d786$var$shouldConfirmSignUp,
    shouldConfirmSignUpFromSignIn: $b5e04cdb6d60d786$var$shouldConfirmSignUpFromSignIn,
    shouldResetPassword: $b5e04cdb6d60d786$var$shouldResetPassword,
    shouldResetPasswordFromSignIn: $b5e04cdb6d60d786$var$shouldResetPasswordFromSignIn,
    shouldSetupTotp: $b5e04cdb6d60d786$var$shouldSetupTotp,
    shouldVerifyAttribute: $b5e04cdb6d60d786$var$shouldVerifyAttribute
};



var $e199042d4523c70a$exports = {};
var $e581203f683afa5d$exports = {};

var $9fb85d0d84e3014c$exports = {};


/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9fb85d0d84e3014c$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$d13292808fb6c9f3$exports(object[key], value) || value === undefined && !(key in object)) $77165e63beda781c$exports(object, key, value);
}
$9fb85d0d84e3014c$exports = $9fb85d0d84e3014c$var$assignMergeValue;


var $4b11d536db99cffb$exports = {};
var $10244d26a3f3bc5f$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $10244d26a3f3bc5f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$10244d26a3f3bc5f$exports = $10244d26a3f3bc5f$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $4b11d536db99cffb$var$baseFor = $10244d26a3f3bc5f$exports();
$4b11d536db99cffb$exports = $4b11d536db99cffb$var$baseFor;


var $a87b0ba89d4e3422$exports = {};


var $assjx = parcelRequire("assjx");
var $9f75b5692441ca48$exports = {};
var $24c875d49b73f391$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $24c875d49b73f391$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $6eb0233855d9f9d2$exports(result).set(new $6eb0233855d9f9d2$exports(arrayBuffer));
    return result;
}
$24c875d49b73f391$exports = $24c875d49b73f391$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $9f75b5692441ca48$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $24c875d49b73f391$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$9f75b5692441ca48$exports = $9f75b5692441ca48$var$cloneTypedArray;


var $bec2f8ab3900ce79$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $bec2f8ab3900ce79$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$bec2f8ab3900ce79$exports = $bec2f8ab3900ce79$var$copyArray;


var $9f43a757d68355a8$exports = {};
var $00800d52860ce1b4$exports = {};

/** Built-in value references. */ var $00800d52860ce1b4$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $00800d52860ce1b4$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$a907a279eb9c391c$exports(proto)) return {};
        if ($00800d52860ce1b4$var$objectCreate) return $00800d52860ce1b4$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$00800d52860ce1b4$exports = $00800d52860ce1b4$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f43a757d68355a8$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$0acc6119f1de8223$exports(object) ? $00800d52860ce1b4$exports($2d3fbf15bb262d54$exports(object)) : {};
}
$9f43a757d68355a8$exports = $9f43a757d68355a8$var$initCloneObject;




var $1b353aa29b0ce842$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1b353aa29b0ce842$var$isArrayLikeObject(value) {
    return $211120fa3b9d50b6$exports(value) && $06a40c4626ec02cc$exports(value);
}
$1b353aa29b0ce842$exports = $1b353aa29b0ce842$var$isArrayLikeObject;



var $kNG5d = parcelRequire("kNG5d");


var $02f5e12bcd89aa1c$exports = {};



/** `Object#toString` result references. */ var $02f5e12bcd89aa1c$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $02f5e12bcd89aa1c$var$funcProto = Function.prototype, $02f5e12bcd89aa1c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $02f5e12bcd89aa1c$var$funcToString = $02f5e12bcd89aa1c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $02f5e12bcd89aa1c$var$hasOwnProperty = $02f5e12bcd89aa1c$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $02f5e12bcd89aa1c$var$objectCtorString = $02f5e12bcd89aa1c$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $02f5e12bcd89aa1c$var$isPlainObject(value) {
    if (!$211120fa3b9d50b6$exports(value) || $3125d712601865c3$exports(value) != $02f5e12bcd89aa1c$var$objectTag) return false;
    var proto = $2d3fbf15bb262d54$exports(value);
    if (proto === null) return true;
    var Ctor = $02f5e12bcd89aa1c$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $02f5e12bcd89aa1c$var$funcToString.call(Ctor) == $02f5e12bcd89aa1c$var$objectCtorString;
}
$02f5e12bcd89aa1c$exports = $02f5e12bcd89aa1c$var$isPlainObject;



var $38694a169fb4d1de$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $38694a169fb4d1de$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$38694a169fb4d1de$exports = $38694a169fb4d1de$var$safeGet;


var $e203b13a67cc84c6$exports = {};
var $f4618d1c90e265aa$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $f4618d1c90e265aa$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $77165e63beda781c$exports(object, key, newValue);
        else $e08d80eed186b416$exports(object, key, newValue);
    }
    return object;
}
$f4618d1c90e265aa$exports = $f4618d1c90e265aa$var$copyObject;



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $e203b13a67cc84c6$var$toPlainObject(value) {
    return $f4618d1c90e265aa$exports(value, $013baf1d8a379e13$exports(value));
}
$e203b13a67cc84c6$exports = $e203b13a67cc84c6$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $a87b0ba89d4e3422$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $38694a169fb4d1de$exports(object, key), srcValue = $38694a169fb4d1de$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $9fb85d0d84e3014c$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $d30563dfe4b5a399$exports(srcValue), isBuff = !isArr && $kNG5d(srcValue), isTyped = !isArr && !isBuff && $c08e6012d64254c0$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($d30563dfe4b5a399$exports(objValue)) newValue = objValue;
            else if ($1b353aa29b0ce842$exports(objValue)) newValue = $bec2f8ab3900ce79$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $assjx(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $9f75b5692441ca48$exports(srcValue, true);
            } else newValue = [];
        } else if ($02f5e12bcd89aa1c$exports(srcValue) || $80896eeab9a768af$exports(srcValue)) {
            newValue = objValue;
            if ($80896eeab9a768af$exports(objValue)) newValue = $e203b13a67cc84c6$exports(objValue);
            else if (!$a907a279eb9c391c$exports(objValue) || $612178f1216980b6$exports(objValue)) newValue = $9f43a757d68355a8$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $9fb85d0d84e3014c$exports(object, key, newValue);
}
$a87b0ba89d4e3422$exports = $a87b0ba89d4e3422$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $e581203f683afa5d$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $4b11d536db99cffb$exports(source, function(srcValue, key) {
        stack || (stack = new $0b7f1a3b3f2b2666$exports);
        if ($a907a279eb9c391c$exports(srcValue)) $a87b0ba89d4e3422$exports(object, source, key, srcIndex, $e581203f683afa5d$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($38694a169fb4d1de$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $9fb85d0d84e3014c$exports(object, key, newValue);
        }
    }, $013baf1d8a379e13$exports);
}
$e581203f683afa5d$exports = $e581203f683afa5d$var$baseMerge;


var $e3620bb5b42bd8c6$exports = {};
var $dada414ef1a927ba$exports = {};

var $2a15be326351b644$exports = {};
var $c6df339d0d7e8af4$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $c6df339d0d7e8af4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$c6df339d0d7e8af4$exports = $c6df339d0d7e8af4$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $2a15be326351b644$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $2a15be326351b644$var$overRest(func, start, transform) {
    start = $2a15be326351b644$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $2a15be326351b644$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $c6df339d0d7e8af4$exports(func, this, otherArgs);
    };
}
$2a15be326351b644$exports = $2a15be326351b644$var$overRest;


var $ae8b5d78b948181a$exports = {};
var $d42c81e581e80f10$exports = {};
var $766e43c56b5391e4$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $766e43c56b5391e4$var$constant(value) {
    return function() {
        return value;
    };
}
$766e43c56b5391e4$exports = $766e43c56b5391e4$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d42c81e581e80f10$var$baseSetToString = !$8998a7d51dbf7887$exports ? $e46546f1a84cd405$exports : function(func, string) {
    return $8998a7d51dbf7887$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $766e43c56b5391e4$exports(string),
        "writable": true
    });
};
$d42c81e581e80f10$exports = $d42c81e581e80f10$var$baseSetToString;


var $9bde8ea2bafdbe6c$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $9bde8ea2bafdbe6c$var$HOT_COUNT = 800, $9bde8ea2bafdbe6c$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9bde8ea2bafdbe6c$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $9bde8ea2bafdbe6c$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $9bde8ea2bafdbe6c$var$nativeNow(), remaining = $9bde8ea2bafdbe6c$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $9bde8ea2bafdbe6c$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$9bde8ea2bafdbe6c$exports = $9bde8ea2bafdbe6c$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ae8b5d78b948181a$var$setToString = $9bde8ea2bafdbe6c$exports($d42c81e581e80f10$exports);
$ae8b5d78b948181a$exports = $ae8b5d78b948181a$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $dada414ef1a927ba$var$baseRest(func, start) {
    return $ae8b5d78b948181a$exports($2a15be326351b644$exports(func, start, $e46546f1a84cd405$exports), func + "");
}
$dada414ef1a927ba$exports = $dada414ef1a927ba$var$baseRest;


var $b81ad72953a5d710$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b81ad72953a5d710$var$isIterateeCall(value, index, object) {
    if (!$a907a279eb9c391c$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $06a40c4626ec02cc$exports(object) && $419a027284a64f12$exports(index, object.length) : type == "string" && index in object) return $d13292808fb6c9f3$exports(object[index], value);
    return false;
}
$b81ad72953a5d710$exports = $b81ad72953a5d710$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $e3620bb5b42bd8c6$var$createAssigner(assigner) {
    return $dada414ef1a927ba$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $b81ad72953a5d710$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$e3620bb5b42bd8c6$exports = $e3620bb5b42bd8c6$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $e199042d4523c70a$var$merge = $e3620bb5b42bd8c6$exports(function(object, source, srcIndex) {
    $e581203f683afa5d$exports(object, source, srcIndex);
});
$e199042d4523c70a$exports = $e199042d4523c70a$var$merge;





// Runs all validators given. Resolves if there are no error. Rejects otherwise.
const $f759a5e2f85cdfdb$export$59e2b39f02edfada = async (formData, touchData, passwordSettings, validators)=>{
    const errors = await Promise.all(validators.map((validator)=>validator(formData, touchData, passwordSettings)));
    const mergedError = (0, (/*@__PURE__*/$parcel$interopDefault($e199042d4523c70a$exports)))({}, ...errors);
    if ((0, $85b840b81f21bd6d$export$dd1bc94b04021eeb)(mergedError)) // no errors were found
    return Promise.resolve();
    else return Promise.reject(mergedError);
};













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms the new password and verification code to reset the password.
 *
 * @param input -  The ConfirmResetPasswordInput object.
 * @throws -{@link ConfirmForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code, password or username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $4ddd631ec25f5744$export$890261705c8ce36b(input) {
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = authConfig;
    const { username: username, newPassword: newPassword } = input;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!newPassword, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword);
    const code = input.confirmationCode;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!code, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode);
    const metadata = input.options?.clientMetadata;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    await (0, $03c131ae6cab815c$export$c7a5d0826ce3a2b2)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmResetPassword)
    }, {
        Username: username,
        ConfirmationCode: code,
        Password: newPassword,
        ClientMetadata: metadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $247432156eb0860b$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            return {
                ...state,
                signInSession: action.value
            };
        case "SET_SIGN_IN_STATE":
            return {
                ...action.value
            };
        case "SET_CHALLENGE_NAME":
            return {
                ...state,
                challengeName: action.value
            };
        case "SET_USERNAME":
            return {
                ...state,
                username: action.value
            };
        case "SET_INITIAL_STATE":
            return $247432156eb0860b$var$defaultState();
        default:
            return state;
    }
};
function $247432156eb0860b$var$defaultState() {
    return {
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    };
}
const $247432156eb0860b$var$createStore = (reducer)=>{
    let currentState = reducer($247432156eb0860b$var$defaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $247432156eb0860b$export$390d5da4c63a4a41 = $247432156eb0860b$var$createStore($247432156eb0860b$var$signInReducer);
function $247432156eb0860b$export$bae72361b690e075(state) {
    $247432156eb0860b$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
function $247432156eb0860b$export$f3dfaa7234c98dc0() {
    $247432156eb0860b$export$390d5da4c63a4a41.dispatch({
        type: "SET_INITIAL_STATE"
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e6f62167118edba2$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $022d6056dd354b6b$export$695b149896bd3e2a = {
    convert (input, { urlSafe: urlSafe } = {
        urlSafe: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $e6f62167118edba2$export$7c746b75f47c9c7d)(input);
        const encodedStr = (0, $cc2669c14dc942e5$export$94f295707b435c6d)()(inputStr);
        // see details about the char replacing at https://datatracker.ietf.org/doc/html/rfc4648#section-5
        return urlSafe ? encodedStr.replace(/\+/g, "-").replace(/\//g, "_") : encodedStr;
    }
};


/* tslint:disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $cbffac20bdf0d6f2$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $cbffac20bdf0d6f2$var$nbi() {
    return new $cbffac20bdf0d6f2$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $cbffac20bdf0d6f2$var$dbits;
// JavaScript engine analysis
const $cbffac20bdf0d6f2$var$canary = 0xdeadbeefcafe;
const $cbffac20bdf0d6f2$var$j_lm = ($cbffac20bdf0d6f2$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $cbffac20bdf0d6f2$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $cbffac20bdf0d6f2$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $cbffac20bdf0d6f2$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $cbffac20bdf0d6f2$var$inBrowser = typeof navigator !== "undefined";
if ($cbffac20bdf0d6f2$var$inBrowser && $cbffac20bdf0d6f2$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.am = $cbffac20bdf0d6f2$var$am2;
    $cbffac20bdf0d6f2$var$dbits = 30;
} else if ($cbffac20bdf0d6f2$var$inBrowser && $cbffac20bdf0d6f2$var$j_lm && navigator.appName !== "Netscape") {
    $cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.am = $cbffac20bdf0d6f2$var$am1;
    $cbffac20bdf0d6f2$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.am = $cbffac20bdf0d6f2$var$am3;
    $cbffac20bdf0d6f2$var$dbits = 28;
}
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.DB = $cbffac20bdf0d6f2$var$dbits;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.DM = (1 << $cbffac20bdf0d6f2$var$dbits) - 1;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.DV = 1 << $cbffac20bdf0d6f2$var$dbits;
const $cbffac20bdf0d6f2$var$BI_FP = 52;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $cbffac20bdf0d6f2$var$BI_FP);
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.F1 = $cbffac20bdf0d6f2$var$BI_FP - $cbffac20bdf0d6f2$var$dbits;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.F2 = 2 * $cbffac20bdf0d6f2$var$dbits - $cbffac20bdf0d6f2$var$BI_FP;
// Digit conversions
const $cbffac20bdf0d6f2$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $cbffac20bdf0d6f2$var$BI_RC = new Array();
let $cbffac20bdf0d6f2$var$rr, $cbffac20bdf0d6f2$var$vv;
$cbffac20bdf0d6f2$var$rr = "0".charCodeAt(0);
for($cbffac20bdf0d6f2$var$vv = 0; $cbffac20bdf0d6f2$var$vv <= 9; ++$cbffac20bdf0d6f2$var$vv)$cbffac20bdf0d6f2$var$BI_RC[$cbffac20bdf0d6f2$var$rr++] = $cbffac20bdf0d6f2$var$vv;
$cbffac20bdf0d6f2$var$rr = "a".charCodeAt(0);
for($cbffac20bdf0d6f2$var$vv = 10; $cbffac20bdf0d6f2$var$vv < 36; ++$cbffac20bdf0d6f2$var$vv)$cbffac20bdf0d6f2$var$BI_RC[$cbffac20bdf0d6f2$var$rr++] = $cbffac20bdf0d6f2$var$vv;
$cbffac20bdf0d6f2$var$rr = "A".charCodeAt(0);
for($cbffac20bdf0d6f2$var$vv = 10; $cbffac20bdf0d6f2$var$vv < 36; ++$cbffac20bdf0d6f2$var$vv)$cbffac20bdf0d6f2$var$BI_RC[$cbffac20bdf0d6f2$var$rr++] = $cbffac20bdf0d6f2$var$vv;
function $cbffac20bdf0d6f2$var$int2char(n) {
    return $cbffac20bdf0d6f2$var$BI_RM.charAt(n);
}
function $cbffac20bdf0d6f2$var$intAt(s, i) {
    var c = $cbffac20bdf0d6f2$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $cbffac20bdf0d6f2$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $cbffac20bdf0d6f2$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $cbffac20bdf0d6f2$var$nbv(i) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $cbffac20bdf0d6f2$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        const x = $cbffac20bdf0d6f2$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $cbffac20bdf0d6f2$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $cbffac20bdf0d6f2$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    let km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $cbffac20bdf0d6f2$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $cbffac20bdf0d6f2$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $cbffac20bdf0d6f2$var$bnNegate() {
    var r = $cbffac20bdf0d6f2$var$nbi();
    $cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $cbffac20bdf0d6f2$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $cbffac20bdf0d6f2$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $cbffac20bdf0d6f2$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $cbffac20bdf0d6f2$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $cbffac20bdf0d6f2$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $cbffac20bdf0d6f2$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $cbffac20bdf0d6f2$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $cbffac20bdf0d6f2$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    let ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $cbffac20bdf0d6f2$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $cbffac20bdf0d6f2$var$bnpSubTo(a, r) {
    let i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $cbffac20bdf0d6f2$var$bnpMultiplyTo(a, r) {
    const x = this.abs(), y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $cbffac20bdf0d6f2$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $cbffac20bdf0d6f2$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $cbffac20bdf0d6f2$var$nbi();
    var y = $cbffac20bdf0d6f2$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $cbffac20bdf0d6f2$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    let i = r.t, j = i - ys, t = q === null ? $cbffac20bdf0d6f2$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $cbffac20bdf0d6f2$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $cbffac20bdf0d6f2$var$bnMod(a) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $cbffac20bdf0d6f2$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) === 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $cbffac20bdf0d6f2$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $cbffac20bdf0d6f2$var$bnpAddTo(a, r) {
    let i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $cbffac20bdf0d6f2$var$bnAdd(a) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $cbffac20bdf0d6f2$var$bnSubtract(a) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $cbffac20bdf0d6f2$var$bnMultiply(a) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $cbffac20bdf0d6f2$var$bnDivide(a) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $cbffac20bdf0d6f2$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $cbffac20bdf0d6f2$var$montConvert(x) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $cbffac20bdf0d6f2$var$montRevert(x) {
    var r = $cbffac20bdf0d6f2$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $cbffac20bdf0d6f2$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $cbffac20bdf0d6f2$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $cbffac20bdf0d6f2$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$cbffac20bdf0d6f2$var$Montgomery.prototype.convert = $cbffac20bdf0d6f2$var$montConvert;
$cbffac20bdf0d6f2$var$Montgomery.prototype.revert = $cbffac20bdf0d6f2$var$montRevert;
$cbffac20bdf0d6f2$var$Montgomery.prototype.reduce = $cbffac20bdf0d6f2$var$montReduce;
$cbffac20bdf0d6f2$var$Montgomery.prototype.mulTo = $cbffac20bdf0d6f2$var$montMulTo;
$cbffac20bdf0d6f2$var$Montgomery.prototype.sqrTo = $cbffac20bdf0d6f2$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $cbffac20bdf0d6f2$var$bnModPow(e, m, callback) {
    let i = e.bitLength(), k, r = $cbffac20bdf0d6f2$var$nbv(1), z = new $cbffac20bdf0d6f2$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    let g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $cbffac20bdf0d6f2$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $cbffac20bdf0d6f2$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1, w, is1 = true, r2 = $cbffac20bdf0d6f2$var$nbi(), t;
    i = $cbffac20bdf0d6f2$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.copyTo = $cbffac20bdf0d6f2$var$bnpCopyTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.fromInt = $cbffac20bdf0d6f2$var$bnpFromInt;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.fromString = $cbffac20bdf0d6f2$var$bnpFromString;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.clamp = $cbffac20bdf0d6f2$var$bnpClamp;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.dlShiftTo = $cbffac20bdf0d6f2$var$bnpDLShiftTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.drShiftTo = $cbffac20bdf0d6f2$var$bnpDRShiftTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.lShiftTo = $cbffac20bdf0d6f2$var$bnpLShiftTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.rShiftTo = $cbffac20bdf0d6f2$var$bnpRShiftTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.subTo = $cbffac20bdf0d6f2$var$bnpSubTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.multiplyTo = $cbffac20bdf0d6f2$var$bnpMultiplyTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.squareTo = $cbffac20bdf0d6f2$var$bnpSquareTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.divRemTo = $cbffac20bdf0d6f2$var$bnpDivRemTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.invDigit = $cbffac20bdf0d6f2$var$bnpInvDigit;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.addTo = $cbffac20bdf0d6f2$var$bnpAddTo;
// public
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.toString = $cbffac20bdf0d6f2$var$bnToString;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.negate = $cbffac20bdf0d6f2$var$bnNegate;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.abs = $cbffac20bdf0d6f2$var$bnAbs;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.compareTo = $cbffac20bdf0d6f2$var$bnCompareTo;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.bitLength = $cbffac20bdf0d6f2$var$bnBitLength;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.mod = $cbffac20bdf0d6f2$var$bnMod;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.equals = $cbffac20bdf0d6f2$var$bnEquals;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.add = $cbffac20bdf0d6f2$var$bnAdd;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.subtract = $cbffac20bdf0d6f2$var$bnSubtract;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.multiply = $cbffac20bdf0d6f2$var$bnMultiply;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.divide = $cbffac20bdf0d6f2$var$bnDivide;
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.prototype.modPow = $cbffac20bdf0d6f2$var$bnModPow;
// "constants"
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.ZERO = $cbffac20bdf0d6f2$var$nbv(0);
$cbffac20bdf0d6f2$export$2e2bcd8739ae039.ONE = $cbffac20bdf0d6f2$var$nbv(1);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $976fb44f5c2a57e0$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $56a49e28766e6cbb$export$f7340100dd3acd38 = async ({ a: a, g: g, k: k, x: x, B: B, N: N, U: U })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2cca39fbf40196e7$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $2cca39fbf40196e7$export$a0f75f7d2f3bd702 = {};
const $2cca39fbf40196e7$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $2cca39fbf40196e7$export$a0f75f7d2f3bd702[i] = encodedByte;
    $2cca39fbf40196e7$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $36b3e9978a55a3f5$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $2cca39fbf40196e7$export$fcb552daf117d7e3)) out[i / 2] = (0, $2cca39fbf40196e7$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $d7e1e39094f5b2ff$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $2cca39fbf40196e7$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $430a0a473476a7c9$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $e276799cbbca4dad$exports.Sha256)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $d7e1e39094f5b2ff$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $ca97a3ecd02c7386$export$8b112e065a8843a = (hexStr)=>(0, $430a0a473476a7c9$export$629ee8d7d3ebacd1)((0, $36b3e9978a55a3f5$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $16172e2edd30b0ab$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $16172e2edd30b0ab$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $16172e2edd30b0ab$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $dad78877699ab335$export$e2f40082638513e7 = ({ A: A, B: B })=>{
    const U = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)((0, $ca97a3ecd02c7386$export$8b112e065a8843a)((0, $16172e2edd30b0ab$export$35d4ea07514a0402)(A) + (0, $16172e2edd30b0ab$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $c0d91edfb81a8f16$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $e276799cbbca4dad$exports.Sha256)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $b0412f36dc551b56$export$d265930babe23ca5() {
    const crypto = (0, $cc2669c14dc942e5$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $048ab6517ff95813$var$hexStringify(wordArray) {
    // Shortcuts
    const words = wordArray.words;
    const sigBytes = wordArray.sigBytes;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $048ab6517ff95813$export$2e2bcd8739ae039 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $b0412f36dc551b56$export$d265930babe23ca5)());
        return new $048ab6517ff95813$export$2e2bcd8739ae039(words, nBytes);
    }
    toString() {
        return $048ab6517ff95813$var$hexStringify(this);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $e3fdfb4648e377fc$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $048ab6517ff95813$export$2e2bcd8739ae039)().random(nBytes).toString();
    return (0, $36b3e9978a55a3f5$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $47ae19bb5b0e90c2$export$8c487394e1c35fbe = ()=>(0, $022d6056dd354b6b$export$695b149896bd3e2a).convert((0, $e3fdfb4648e377fc$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $72d8d5434c850942$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName, a: a, g: g, A: A, N: N }){
        this.encoder = (0, $976fb44f5c2a57e0$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)((0, $ca97a3ecd02c7386$export$8b112e065a8843a)(`${(0, $16172e2edd30b0ab$export$35d4ea07514a0402)(N)}${(0, $16172e2edd30b0ab$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $47ae19bb5b0e90c2$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $430a0a473476a7c9$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $d7e1e39094f5b2ff$export$22a20ab34c1d7a2b)((0, $e3fdfb4648e377fc$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $16172e2edd30b0ab$export$35d4ea07514a0402)(new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)((0, $ca97a3ecd02c7386$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $16172e2edd30b0ab$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username, password: password, serverBValue: serverBValue, salt: salt }) {
        if (serverBValue.mod(this.N).equals((0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $dad78877699ab335$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $430a0a473476a7c9$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)((0, $ca97a3ecd02c7386$export$8b112e065a8843a)((0, $16172e2edd30b0ab$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $56a49e28766e6cbb$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $c0d91edfb81a8f16$export$295a0a5429217d03)((0, $36b3e9978a55a3f5$export$b772e43c3daf2e7a)((0, $16172e2edd30b0ab$export$35d4ea07514a0402)(S)), (0, $36b3e9978a55a3f5$export$b772e43c3daf2e7a)((0, $16172e2edd30b0ab$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $3c7d26a9145dc16a$export$53a55138f9e96c65 = async ({ a: a, g: g, N: N })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $e806a7d73658208c$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)((0, $2cca39fbf40196e7$export$baab4dd8c7240846), 16);
    const g = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)("2", 16);
    const a = $e806a7d73658208c$var$generateRandomBigInteger();
    const A = await (0, $3c7d26a9145dc16a$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $72d8d5434c850942$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $e806a7d73658208c$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $d7e1e39094f5b2ff$export$22a20ab34c1d7a2b)((0, $e3fdfb4648e377fc$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(hexRandom, 16);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7b02b5af461748d9$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $7b02b5af461748d9$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $7b02b5af461748d9$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $7b02b5af461748d9$var$WEEK_NAMES[now.getUTCDay()];
    const month = $7b02b5af461748d9$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fce84a7a862dfd66$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName, username: username, challengeParameters: challengeParameters, dateNow: dateNow, hkdf: hkdf })=>{
    const bufUPIDaToB = (0, $976fb44f5c2a57e0$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $976fb44f5c2a57e0$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $fce84a7a862dfd66$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $976fb44f5c2a57e0$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $022d6056dd354b6b$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $fce84a7a862dfd66$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = (0, $9647d74a451fedae$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6498cdebde8b5967$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($6498cdebde8b5967$export$3cc5c71ef5f25e57 || ($6498cdebde8b5967$export$3cc5c71ef5f25e57 = {}));
var $6498cdebde8b5967$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$4327725e8bb80c51 || ($6498cdebde8b5967$export$4327725e8bb80c51 = {}));
var $6498cdebde8b5967$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$87a956d0b1b725a1 || ($6498cdebde8b5967$export$87a956d0b1b725a1 = {}));
var $6498cdebde8b5967$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$b86a388af82085af || ($6498cdebde8b5967$export$b86a388af82085af = {}));
var $6498cdebde8b5967$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$2ec29642a27fd055 || ($6498cdebde8b5967$export$2ec29642a27fd055 = {}));
var $6498cdebde8b5967$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$c6d546f0ab5ecb26 || ($6498cdebde8b5967$export$c6d546f0ab5ecb26 = {}));
var $6498cdebde8b5967$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$315864c77a135492 || ($6498cdebde8b5967$export$315864c77a135492 = {}));
var $6498cdebde8b5967$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$622cff54bc9a0bb0 || ($6498cdebde8b5967$export$622cff54bc9a0bb0 = {}));
var $6498cdebde8b5967$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$cedaef1e1242f8be || ($6498cdebde8b5967$export$cedaef1e1242f8be = {}));
var $6498cdebde8b5967$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$8d5b6b7a140e0c94 || ($6498cdebde8b5967$export$8d5b6b7a140e0c94 = {}));
var $6498cdebde8b5967$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($6498cdebde8b5967$export$506f117795ed2bb2 || ($6498cdebde8b5967$export$506f117795ed2bb2 = {}));
var $6498cdebde8b5967$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($6498cdebde8b5967$export$9bff15c85d75f437 || ($6498cdebde8b5967$export$9bff15c85d75f437 = {}));
var $6498cdebde8b5967$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$2a6bba23fbf84d1b || ($6498cdebde8b5967$export$2a6bba23fbf84d1b = {}));
var $6498cdebde8b5967$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($6498cdebde8b5967$export$3f7e490ba4e0b71e || ($6498cdebde8b5967$export$3f7e490ba4e0b71e = {}));
var $6498cdebde8b5967$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$43ac0110dfdad33b || ($6498cdebde8b5967$export$43ac0110dfdad33b = {}));
var $6498cdebde8b5967$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$8807b62ddb0e4d9d || ($6498cdebde8b5967$export$8807b62ddb0e4d9d = {}));
var $6498cdebde8b5967$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$da9908386393628f || ($6498cdebde8b5967$export$da9908386393628f = {}));
var $6498cdebde8b5967$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$23ea34859d89459d || ($6498cdebde8b5967$export$23ea34859d89459d = {}));
var $6498cdebde8b5967$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($6498cdebde8b5967$export$d0816902ed99fce6 || ($6498cdebde8b5967$export$d0816902ed99fce6 = {}));
var $6498cdebde8b5967$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$44cb15f260897376 || ($6498cdebde8b5967$export$44cb15f260897376 = {}));
var $6498cdebde8b5967$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$a974f64d24be573a || ($6498cdebde8b5967$export$a974f64d24be573a = {}));
var $6498cdebde8b5967$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$527caabb62d14fe3 || ($6498cdebde8b5967$export$527caabb62d14fe3 = {}));
var $6498cdebde8b5967$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$de57be1863bdb9d6 || ($6498cdebde8b5967$export$de57be1863bdb9d6 = {}));
var $6498cdebde8b5967$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($6498cdebde8b5967$export$eb8cb06bdb07bf0c || ($6498cdebde8b5967$export$eb8cb06bdb07bf0c = {}));
const $6498cdebde8b5967$export$ecd3eb1722b48d26 = "SetUpTOTPException";













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c5e8e2c675aaf23$var$USER_ATTRIBUTES = "userAttributes.";
async function $2c5e8e2c675aaf23$export$6fe6331471b54d26({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $2c5e8e2c675aaf23$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $2c5e8e2c675aaf23$export$9b78cd405a35bccd({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, deviceName: deviceName, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username
    };
    const { Session: Session } = await (0, $03c131ae6cab815c$export$72b1124e126ff51c)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        UserCode: challengeResponse,
        Session: session,
        FriendlyDeviceName: deviceName
    });
    (0, $247432156eb0860b$export$390d5da4c63a4a41).dispatch({
        type: "SET_SIGN_IN_SESSION",
        value: Session
    });
    const jsonReq = {
        ChallengeName: "MFA_SETUP",
        ChallengeResponses: challengeResponses,
        Session: Session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId
    };
    return (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId)
    }, jsonReq);
}
async function $2c5e8e2c675aaf23$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS", (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $2c5e8e2c675aaf23$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $2c5e8e2c675aaf23$export$3eab958abdf5e22d({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username,
        SMS_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SMS_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $2c5e8e2c675aaf23$export$b89ff5a8f5e11286({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username,
        SOFTWARE_TOKEN_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SOFTWARE_TOKEN_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $2c5e8e2c675aaf23$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, requiredAttributes: requiredAttributes, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        ...$2c5e8e2c675aaf23$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $2c5e8e2c675aaf23$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $03c131ae6cab815c$export$567b0d5ec943f827)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    $2c5e8e2c675aaf23$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $2c5e8e2c675aaf23$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $2c5e8e2c675aaf23$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $e806a7d73658208c$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_SRP_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const resp = await (0, $03c131ae6cab815c$export$567b0d5ec943f827)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters, Session: session } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $2c5e8e2c675aaf23$export$fecfbc200868d412(activeUsername);
    return $2c5e8e2c675aaf23$export$30f932fe98713ccc($2c5e8e2c675aaf23$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $2c5e8e2c675aaf23$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $03c131ae6cab815c$export$567b0d5ec943f827)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    $2c5e8e2c675aaf23$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $2c5e8e2c675aaf23$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $2c5e8e2c675aaf23$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $e806a7d73658208c$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const { ChallengeParameters: challengeParameters, Session: session } = await (0, $03c131ae6cab815c$export$567b0d5ec943f827)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $2c5e8e2c675aaf23$export$fecfbc200868d412(activeUsername);
    return $2c5e8e2c675aaf23$export$30f932fe98713ccc($2c5e8e2c675aaf23$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $2c5e8e2c675aaf23$var$handleDeviceSRPAuth({ username: username, config: config, clientMetadata: clientMetadata, session: session, tokenOrchestrator: tokenOrchestrator }) {
    const userPoolId = config.userPoolId;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $de2f10f4a648aec0$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $e806a7d73658208c$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const { ChallengeParameters: ChallengeParameters, Session: Session } = await (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    return $2c5e8e2c675aaf23$var$handleDevicePasswordVerifier(username, ChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $2c5e8e2c675aaf23$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId, userPoolClientId: userPoolClientId }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $de2f10f4a648aec0$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const deviceKey = deviceMetadata.deviceKey;
    const deviceGroupKey = deviceMetadata.deviceGroupKey;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $7b02b5af461748d9$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $fce84a7a862dfd66$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    return (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
}
async function $2c5e8e2c675aaf23$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const serverBValue = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $cbffac20bdf0d6f2$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $7b02b5af461748d9$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $fce84a7a862dfd66$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $03c131ae6cab815c$export$b196467a22b300ec)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $2c5e8e2c675aaf23$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $2c5e8e2c675aaf23$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName, challengeParameters: challengeParameters } = params;
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            const { signInSession: signInSession, username: username } = (0, $247432156eb0860b$export$390d5da4c63a4a41).getState();
            if (!$2c5e8e2c675aaf23$export$aac29c972ddf3e91(challengeParameters, "TOTP")) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
                name: (0, $f6e29a46e63271fd$export$473ab0b56598aacd).SignInException,
                message: `Cannot initiate MFA setup from available types: ${$2c5e8e2c675aaf23$export$d70c792e078766ea($2c5e8e2c675aaf23$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP))}`
            });
            const { Session: Session, SecretCode: secretCode } = await (0, $03c131ae6cab815c$export$4531a27964554be8)({
                region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId)
            }, {
                Session: signInSession
            });
            (0, $247432156eb0860b$export$390d5da4c63a4a41).dispatch({
                type: "SET_SIGN_IN_SESSION",
                value: Session
            });
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                    totpSetupDetails: $2c5e8e2c675aaf23$export$b105c3e8e4f5ce91(secretCode, username)
                }
            };
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $2c5e8e2c675aaf23$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $2c5e8e2c675aaf23$export$d70c792e078766ea($2c5e8e2c675aaf23$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $f6e29a46e63271fd$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $2c5e8e2c675aaf23$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $2b8867449626b446$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $2c5e8e2c675aaf23$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $6498cdebde8b5967$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $6498cdebde8b5967$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $2c5e8e2c675aaf23$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($2c5e8e2c675aaf23$var$USER_ATTRIBUTES) ? att.replace($2c5e8e2c675aaf23$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $2c5e8e2c675aaf23$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$2c5e8e2c675aaf23$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $2c5e8e2c675aaf23$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case "SMS_MFA":
            return $2c5e8e2c675aaf23$export$3eab958abdf5e22d({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "SELECT_MFA_TYPE":
            return $2c5e8e2c675aaf23$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $2c5e8e2c675aaf23$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $2c5e8e2c675aaf23$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return $2c5e8e2c675aaf23$export$30f932fe98713ccc($2c5e8e2c675aaf23$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SOFTWARE_TOKEN_MFA":
            return $2c5e8e2c675aaf23$export$b89ff5a8f5e11286({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
    }
    // TODO: remove this error message for production apps
    throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $f6e29a46e63271fd$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process. 
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $2c5e8e2c675aaf23$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    return mfaType;
}
function $2c5e8e2c675aaf23$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
// TODO: log warning for unknown MFA type
}
function $2c5e8e2c675aaf23$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($2c5e8e2c675aaf23$export$6ce04ce89055b1fe).filter(Boolean);
}
function $2c5e8e2c675aaf23$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $2c5e8e2c675aaf23$export$aac29c972ddf3e91(challengeParams, mfaType) {
    const { MFAS_CAN_SETUP: MFAS_CAN_SETUP } = challengeParams;
    const mfaTypes = $2c5e8e2c675aaf23$export$d70c792e078766ea($2c5e8e2c675aaf23$export$4055ded9e78438ba(MFAS_CAN_SETUP));
    if (!mfaTypes) return false;
    return mfaTypes.includes(mfaType);
}
async function $2c5e8e2c675aaf23$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $0927f39e1da098a6$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $2c5e8e2c675aaf23$export$5fd317fac33d34b1(userPoolId, newDeviceMetadata, accessToken) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $e806a7d73658208c$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? "", deviceKey ?? "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $022d6056dd354b6b$export$695b149896bd3e2a).convert((0, $36b3e9978a55a3f5$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $022d6056dd354b6b$export$695b149896bd3e2a).convert((0, $36b3e9978a55a3f5$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        await (0, $03c131ae6cab815c$export$3a7ad63dc35b752f)({
            region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $2c5e8e2c675aaf23$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $cb87c343b3a92609$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return await func(...args);
        }
        throw error;
    }
}
function $2c5e8e2c675aaf23$export$fecfbc200868d412(username) {
    const { dispatch: dispatch } = (0, $247432156eb0860b$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}
function $2c5e8e2c675aaf23$export$cc3585de146a51be(username) {
    const state = (0, $247432156eb0860b$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $679aa6730ab7f609$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $4398d957ad502806$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $3caf5c41ef04ef89$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Continues or completes the sign in process when required by the initial call to `signIn`.
 *
 * @param input -  The ConfirmSignInInput object
 * @returns ConfirmSignInOutput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link RespondToAuthChallengeException }:
 * Thrown due to an invalid auth challenge response.
 * @throws  -{@link AssociateSoftwareTokenException}:
 * Thrown due to a service error during the MFA setup process.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `challengeResponse` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $9143a0342aca171d$export$a477d84c2f7b792a(input) {
    const { challengeResponse: challengeResponse, options: options } = input;
    const { username: username, challengeName: challengeName, signInSession: signInSession, signInDetails: signInDetails } = (0, $247432156eb0860b$export$390d5da4c63a4a41).getState();
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options?.clientMetadata;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!challengeResponse, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyChallengeResponse);
    if (!username || !challengeName || !signInSession) // TODO: remove this error message for production apps
    throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $f6e29a46e63271fd$export$473ab0b56598aacd).SignInException,
        message: `
			An error occurred during the sign in process. 
			
			This most likely occurred due to:
			1. signIn was not called before confirmSignIn.
			2. signIn threw an exception.
			3. page was refreshed during the sign in flow.
			`,
        recoverySuggestion: "Make sure a successful call to signIn is made before calling confirmSignInand that the page is not refreshed until the sign in process is done."
    });
    try {
        const { Session: Session, ChallengeName: ChallengeName, AuthenticationResult: AuthenticationResult, ChallengeParameters: ChallengeParameters } = await (0, $2c5e8e2c675aaf23$export$cfd8b50d0f78e4fa)(username, challengeName, signInSession, challengeResponse, authConfig, (0, $4398d957ad502806$export$66561e66d62991d0), clientMetaData, options);
        // sets up local state used during the sign-in process
        (0, $247432156eb0860b$export$bae72361b690e075)({
            signInSession: Session,
            username: username,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
            await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
                username: username,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $2c5e8e2c675aaf23$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $2c5e8e2c675aaf23$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
        const result = (0, $2c5e8e2c675aaf23$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $df2ea615251f04ab$export$7f948971bcf643ff(input) {
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options?.clientMetadata;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!password, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $2c5e8e2c675aaf23$export$30f932fe98713ccc)((0, $2c5e8e2c675aaf23$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $4398d957ad502806$export$66561e66d62991d0)
        ], username, (0, $4398d957ad502806$export$66561e66d62991d0));
        const activeUsername = (0, $2c5e8e2c675aaf23$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $247432156eb0860b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
            await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $2c5e8e2c675aaf23$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $2c5e8e2c675aaf23$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
        (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
        const result = (0, $2c5e8e2c675aaf23$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $92662b4bda7bfebd$export$2c0317ed1bbb0787(input) {
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!password, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $2c5e8e2c675aaf23$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $4398d957ad502806$export$66561e66d62991d0));
        const activeUsername = (0, $2c5e8e2c675aaf23$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $247432156eb0860b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $2c5e8e2c675aaf23$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $2c5e8e2c675aaf23$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
        (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
        const result = (0, $2c5e8e2c675aaf23$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $8160092f149ffacc$export$728178cf826a5ab9(input) {
    const { username: username, password: password } = input;
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!password, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $2c5e8e2c675aaf23$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $4398d957ad502806$export$66561e66d62991d0));
        const activeUsername = (0, $2c5e8e2c675aaf23$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $247432156eb0860b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
            await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $2c5e8e2c675aaf23$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $2c5e8e2c675aaf23$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
        (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
        const result = (0, $2c5e8e2c675aaf23$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $56fab1523b432198$export$200af5a623414b2b(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!password, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $2c5e8e2c675aaf23$export$30f932fe98713ccc)((0, $2c5e8e2c675aaf23$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $4398d957ad502806$export$66561e66d62991d0)
        ], username, (0, $4398d957ad502806$export$66561e66d62991d0));
        const activeUsername = (0, $2c5e8e2c675aaf23$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $247432156eb0860b$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $2c5e8e2c675aaf23$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
            (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $2c5e8e2c675aaf23$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $247432156eb0860b$export$f3dfaa7234c98dc0)();
        (0, $f37be53782e2980b$export$5b3890f50cd4853f)(error);
        const result = (0, $2c5e8e2c675aaf23$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $073c7364ad96fccf$export$9670d83f11d4b64a(input) {
    const authFlowType = input.options?.authFlowType;
    await (0, $2c5e8e2c675aaf23$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $8160092f149ffacc$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $56fab1523b432198$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $df2ea615251f04ab$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $92662b4bda7bfebd$export$2c0317ed1bbb0787)(input);
        default:
            return (0, $8160092f149ffacc$export$728178cf826a5ab9)(input);
    }
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2160dbb81d4937f8$var$initialAutoSignIn = async ()=>{
    throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $0927f39e1da098a6$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ let $2160dbb81d4937f8$export$c5378dc7d6787fa5 = $2160dbb81d4937f8$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $2160dbb81d4937f8$export$7dcbf67a23c27835(callback) {
    $2160dbb81d4937f8$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $2160dbb81d4937f8$export$1ffa2742ce5c589b() {
    $2160dbb81d4937f8$export$c5378dc7d6787fa5 = $2160dbb81d4937f8$var$initialAutoSignIn;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $302fdbbfebb33bfb$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $302fdbbfebb33bfb$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $b47473e783336341$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $b47473e783336341$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $2160dbb81d4937f8$export$7dcbf67a23c27835)($302fdbbfebb33bfb$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        $302fdbbfebb33bfb$export$be9e824afabf429b(false);
        clearTimeout(timeOutId);
        (0, $2160dbb81d4937f8$export$1ffa2742ce5c589b)();
    }, $302fdbbfebb33bfb$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $302fdbbfebb33bfb$var$debounce(fun, delay) {
    let timer;
    return function(args) {
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $302fdbbfebb33bfb$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $302fdbbfebb33bfb$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            $302fdbbfebb33bfb$export$be9e824afabf429b(false);
            reject(new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
                name: (0, $0927f39e1da098a6$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $2160dbb81d4937f8$export$1ffa2742ce5c589b)();
            return;
        } else try {
            const signInOutput = await (0, $073c7364ad96fccf$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                $302fdbbfebb33bfb$export$be9e824afabf429b(false);
                (0, $2160dbb81d4937f8$export$1ffa2742ce5c589b)();
                return;
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            $302fdbbfebb33bfb$export$be9e824afabf429b(false);
            reject(error);
            (0, $2160dbb81d4937f8$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $302fdbbfebb33bfb$var$debouncedAutoSignInWithLink = $302fdbbfebb33bfb$var$debounce($302fdbbfebb33bfb$var$handleAutoSignInWithLink, 300);
const $302fdbbfebb33bfb$var$debouncedAutoSignWithCodeOrUserConfirmed = $302fdbbfebb33bfb$var$debounce($302fdbbfebb33bfb$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
let $302fdbbfebb33bfb$var$autoSignInStarted = false;
let $302fdbbfebb33bfb$var$usernameUsedForAutoSignIn;
function $302fdbbfebb33bfb$export$9542ecebf2267645(username) {
    $302fdbbfebb33bfb$var$usernameUsedForAutoSignIn = username;
}
function $302fdbbfebb33bfb$export$2eb7cf6e92e4b85f(username) {
    return $302fdbbfebb33bfb$var$usernameUsedForAutoSignIn === username;
}
function $302fdbbfebb33bfb$export$ae4fc21c931f7784() {
    return $302fdbbfebb33bfb$var$autoSignInStarted;
}
function $302fdbbfebb33bfb$export$be9e824afabf429b(value) {
    if (value === false) $302fdbbfebb33bfb$export$9542ecebf2267645(undefined);
    $302fdbbfebb33bfb$var$autoSignInStarted = value;
}
function $302fdbbfebb33bfb$export$9fd29532e325aae0(output) {
    return !!output.UserConfirmed;
}
function $302fdbbfebb33bfb$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise(async (resolve, reject)=>{
            $302fdbbfebb33bfb$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $302fdbbfebb33bfb$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = await (0, $073c7364ad96fccf$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $2160dbb81d4937f8$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $2160dbb81d4937f8$export$1ffa2742ce5c589b)();
    }
}
function $302fdbbfebb33bfb$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise(async (resolve, reject)=>{
            $302fdbbfebb33bfb$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $302fdbbfebb33bfb$export$9ec2c3d010185172 = $302fdbbfebb33bfb$var$autoSignInWithCode;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $18ac90c34c5d5236$export$2ce39ab6662e8c24(input) {
    const { username: username, confirmationCode: confirmationCode, options: options } = input;
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!confirmationCode, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    await (0, $03c131ae6cab815c$export$2ce39ab6662e8c24)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            if (!(0, $302fdbbfebb33bfb$export$ae4fc21c931f7784)() || !(0, $302fdbbfebb33bfb$export$2eb7cf6e92e4b85f)(username)) return resolve(signUpOut);
            const stopListener = (0, $b47473e783336341$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        (0, $302fdbbfebb33bfb$export$be9e824afabf429b)(false);
                        stopListener();
                }
            });
            (0, $b47473e783336341$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resets a user's password.
 *
 * @param input -  The ResetPasswordInput object.
 * @returns ResetPasswordOutput
 * @throws -{@link ForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function $26bdb14eefe06e66$export$dc726c8e334dd814(input) {
    const username = input.username;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyResetPasswordUsername);
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = authConfig;
    const clientMetadata = input.options?.clientMetadata;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const res = await (0, $03c131ae6cab815c$export$66791fb2cfeec3e)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ResetPassword)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    const codeDeliveryDetails = res.CodeDeliveryDetails;
    return {
        isPasswordReset: false,
        nextStep: {
            resetPasswordStep: "CONFIRM_RESET_PASSWORD_WITH_CODE",
            codeDeliveryDetails: {
                deliveryMedium: codeDeliveryDetails?.DeliveryMedium,
                destination: codeDeliveryDetails?.Destination,
                attributeName: codeDeliveryDetails?.AttributeName
            }
        }
    };
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $8ec81cb60cf73552$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $8ec81cb60cf73552$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $8b9df63eebf3d724$export$cf64224bcd829024(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? "code";
    const { clientMetadata: clientMetadata, validationData: validationData, autoSignIn: autoSignIn } = input.options ?? {};
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignUpUsername);
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!password, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignUpPassword);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== "CUSTOM_WITHOUT_SRP") signInInput["password"] = password;
    if (signInServiceOptions || autoSignIn === true) {
        (0, $302fdbbfebb33bfb$export$9542ecebf2267645)(username);
        (0, $302fdbbfebb33bfb$export$be9e824afabf429b)(true);
    }
    const clientOutput = await (0, $03c131ae6cab815c$export$cf64224bcd829024)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignUp)
    }, {
        Username: username,
        Password: password,
        UserAttributes: options?.userAttributes && (0, $8ec81cb60cf73552$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $8ec81cb60cf73552$export$720a7caa078a04b0)(validationData),
        ClientId: authConfig.userPoolClientId
    });
    const { UserSub: UserSub, CodeDeliveryDetails: CodeDeliveryDetails } = clientOutput;
    if ((0, $302fdbbfebb33bfb$export$9fd29532e325aae0)(clientOutput) && (0, $302fdbbfebb33bfb$export$ae4fc21c931f7784)()) {
        (0, $2160dbb81d4937f8$export$7dcbf67a23c27835)((0, $302fdbbfebb33bfb$export$9ec2c3d010185172)(signInInput));
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN"
            }
        };
    } else if ((0, $302fdbbfebb33bfb$export$9fd29532e325aae0)(clientOutput) && !(0, $302fdbbfebb33bfb$export$ae4fc21c931f7784)()) return {
        isSignUpComplete: true,
        nextStep: {
            signUpStep: "DONE"
        }
    };
    else if (!(0, $302fdbbfebb33bfb$export$9fd29532e325aae0)(clientOutput) && (0, $302fdbbfebb33bfb$export$ae4fc21c931f7784)() && signUpVerificationMethod === "code") (0, $302fdbbfebb33bfb$export$385d6b43f72ecccf)(signInInput);
    else if (!(0, $302fdbbfebb33bfb$export$9fd29532e325aae0)(clientOutput) && (0, $302fdbbfebb33bfb$export$ae4fc21c931f7784)() && signUpVerificationMethod === "link") {
        (0, $2160dbb81d4937f8$export$7dcbf67a23c27835)((0, $302fdbbfebb33bfb$export$feaed4858b71e8a)(signInInput));
        return {
            isSignUpComplete: false,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN",
                codeDeliveryDetails: {
                    deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                    destination: CodeDeliveryDetails?.Destination,
                    attributeName: CodeDeliveryDetails?.AttributeName
                }
            },
            userId: UserSub
        };
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: {
                deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                destination: CodeDeliveryDetails?.Destination,
                attributeName: CodeDeliveryDetails?.AttributeName
            }
        },
        userId: UserSub
    };
}









// Cognito does not allow a password length less then 8 characters
const $03873ba183dba266$var$DEFAULT_COGNITO_PASSWORD_MIN_LENGTH = 8;
const $03873ba183dba266$export$7ae2d201ca9520b = {
    async getAmplifyConfig () {
        const result = (0, $730e5f1eab7dc7cb$export$11ac3725994bec7b).getConfig();
        const cliConfig = result.Auth?.Cognito;
        const { loginWith: loginWith, userAttributes: userAttributes } = result.Auth?.Cognito ?? {};
        const parsedLoginMechanisms = loginWith ? Object.entries(loginWith).filter(([key, _value])=>key !== "oauth").filter(([_key, value])=>!!value).map((keyValueArray)=>{
            return keyValueArray[0] === "phone" // the key for phone_number is phone in getConfig but everywhere else we treat is as phone_number
             ? "phone_number" : keyValueArray[0];
        }) : undefined;
        const parsedSignupAttributes = userAttributes ? Object.entries(userAttributes).map(([_key, value])=>Object.keys(value)[0]) : undefined;
        const parsedSocialProviders = loginWith?.oauth?.providers ? loginWith.oauth.providers?.map((provider)=>provider.toString().toLowerCase()) : undefined;
        return {
            ...cliConfig,
            loginMechanisms: parsedLoginMechanisms,
            signUpAttributes: parsedSignupAttributes,
            socialProviders: parsedSocialProviders
        };
    },
    getCurrentUser: $4539220ee0fa802b$export$e5432d4c8eb97ea7,
    handleSignIn: (0, $073c7364ad96fccf$export$9670d83f11d4b64a),
    handleSignUp: (0, $8b9df63eebf3d724$export$cf64224bcd829024),
    handleConfirmSignIn: (0, $9143a0342aca171d$export$a477d84c2f7b792a),
    handleConfirmSignUp: (0, $18ac90c34c5d5236$export$2ce39ab6662e8c24),
    handleForgotPasswordSubmit: (0, $4ddd631ec25f5744$export$890261705c8ce36b),
    handleForgotPassword: (0, $26bdb14eefe06e66$export$dc726c8e334dd814),
    // Validation hooks for overriding
    async validateCustomSignUp (formData, touchData) {},
    async validateFormPassword (formData, touchData, passwordSettings) {
        const { password: password } = formData;
        const { password: touched_password } = touchData;
        /**
         * If the password is not touched,
         * or if the password settings are not set, we don't need to validate it.
         */ if (!touched_password || !passwordSettings) return null;
        const password_complexity = [];
        const policyMinLength = passwordSettings.minLength ?? $03873ba183dba266$var$DEFAULT_COGNITO_PASSWORD_MIN_LENGTH;
        if (password.length < policyMinLength) password_complexity.push(`Password must have at least ${policyMinLength} characters`);
        if (passwordSettings.requireLowercase && !/[a-z]/.test(password)) password_complexity.push("Password must have lower case letters");
        if (passwordSettings.requireUppercase && !/[A-Z]/.test(password)) password_complexity.push("Password must have upper case letters");
        if (passwordSettings.requireNumbers && !/[0-9]/.test(password)) password_complexity.push("Password must have numbers");
        // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
        if (passwordSettings.requireSpecialCharacters && !(0, $508296b373a163a4$export$1ec93875315f071d)(password)) password_complexity.push("Password must have special characters");
        /**
         * Only return an error if there is at least one error.
         */ return password_complexity.length !== 0 ? {
            password: password_complexity
        } : null;
    },
    async validateConfirmPassword (formData, touchData) {
        const { password: password, confirm_password: confirm_password } = formData;
        const { confirm_password: touched_confirm_password, password: touched_password } = touchData;
        if (!password && !confirm_password) // these inputs are clean, don't complain yet
        return null;
        else if ((password || confirm_password) && password !== confirm_password && (touched_confirm_password && touched_password || password?.length >= 6 && confirm_password?.length >= 6)) // Only return an error if both fields have text entered,
        // the passwords do not match, and the fields have been
        // touched or the password and confirm password is longer then or equal to 6.
        return {
            confirm_password: "Your passwords must match"
        };
    },
    async validatePreferredUsername (formData, touchData) {}
};


function $b9f0aa007876a1a3$export$d384478d1c0083d2({ services: services }) {
    return (0, $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8)({
        id: "forgotPasswordActor",
        initial: "init",
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: "shouldResetPassword",
                        target: "confirmResetPassword"
                    },
                    {
                        cond: "shouldConfirmResetPassword",
                        target: "confirmResetPassword"
                    },
                    {
                        target: "forgotPassword"
                    }
                ]
            },
            forgotPassword: {
                initial: "edit",
                entry: "sendUpdate",
                exit: [
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "sendUpdate",
                            "clearError",
                            "setUsernameForgotPassword"
                        ],
                        invoke: {
                            src: "handleResetPassword",
                            onDone: {
                                actions: [
                                    "setCodeDeliveryDetails",
                                    "setNextResetPasswordStep"
                                ],
                                target: "#forgotPasswordActor.confirmResetPassword"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmResetPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    RESEND: "resendCode",
                                    CHANGE: {
                                        actions: "handleInput"
                                    },
                                    BLUR: {
                                        actions: "handleBlur"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            resendCode: {
                                tags: "pending",
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "handleResetPassword",
                                    onDone: {
                                        target: "idle"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            },
                            pending: {
                                tags: "pending",
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "handleConfirmResetPassword",
                                    onDone: [
                                        {
                                            cond: "hasCompletedResetPassword",
                                            actions: "setNextResetPasswordStep",
                                            target: "#forgotPasswordActor.resolved"
                                        },
                                        {
                                            actions: "setSignInStep",
                                            target: "#forgotPasswordActor.resolved"
                                        }
                                    ],
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: ({ step: step })=>({
                        step: step
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $d2a1a0d0733f5d9b$export$2e2bcd8739ae039),
            sendUpdate: (0, $bbe1427e84b1ce64$export$7f8b724299523eb6)()
        },
        guards: (0, $b5e04cdb6d60d786$export$2e2bcd8739ae039),
        services: {
            handleResetPassword ({ username: username }) {
                return services.handleForgotPassword({
                    username: username
                });
            },
            handleConfirmResetPassword ({ formValues: formValues, username: username }) {
                const { confirmation_code: confirmationCode, password: newPassword } = formValues;
                return services.handleForgotPasswordSubmit({
                    confirmationCode: confirmationCode,
                    newPassword: newPassword,
                    username: username
                });
            },
            validateFields (context) {
                return (0, $f759a5e2f85cdfdb$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $03873ba183dba266$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $03873ba183dba266$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e865c816e94f8738$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { tokens: tokens } = await (0, $3a5448e34d6c38e9$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $de2f10f4a648aec0$export$77712ea5882cac9f)(tokens);
    const { UserAttributes: UserAttributes } = await (0, $03c131ae6cab815c$export$7cbf767827cd68ba)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $8ec81cb60cf73552$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $7ab176055223e057$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $e865c816e94f8738$export$5dc95ecf3f16c6c9)((0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7));
};









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resend the confirmation code while signing up
 *
 * @param input -  The ResendSignUpCodeInput object
 * @returns ResendSignUpCodeOutput
 * @throws service: {@link ResendConfirmationException } - Cognito service errors thrown when resending the code.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $6d30f2c471d07326$export$b295e842f1d42d13(input) {
    const username = input.username;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!username, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptySignUpUsername);
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = authConfig;
    const clientMetadata = input.options?.clientMetadata;
    const UserContextData = (0, $b1bc599c96d5eaef$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await (0, $03c131ae6cab815c$export$f24137cafeaef1a1)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ResendSignUpCode)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = {
        ...CodeDeliveryDetails
    };
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName ? AttributeName : undefined
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $35ad0e56ab0f9057$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $06fdf39f1a8030b8$export$a7ea17e93539f9a5(hex) {
    const matchArr = hex.match(/.{2}/g) || [];
    return matchArr.map((char)=>String.fromCharCode(parseInt(char, 16))).join("");
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $0780c3909c10c3b1$export$b855308a44508212(str) {
    return str.split("").map((char)=>char.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $43b1f40fd98614d2$export$6893de5f4e1216c3 = {
    Google: "Google",
    Facebook: "Facebook",
    Amazon: "LoginWithAmazon",
    Apple: "SignInWithApple"
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c3c9f6c1e86f636$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $2c3c9f6c1e86f636$var$name = "CognitoIdentityServiceProvider";
class $2c3c9f6c1e86f636$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($2c3c9f6c1e86f636$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($2c3c9f6c1e86f636$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $2c3c9f6c1e86f636$var$createKeysForAuthStorage($2c3c9f6c1e86f636$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $2c3c9f6c1e86f636$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $91e101dfd31622f4$export$dfb8da757ca62eed)((0, $de2f10f4a648aec0$export$3820b4ff343394ea))(provider, identifier);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Auth instance options
 */ // export interface AuthOptions {
// 	userPoolId?: string;
// 	userPoolWebClientId?: string;
// 	identityPoolId?: string;
// 	region?: string;
// 	mandatorySignIn?: boolean;
// 	cookieStorage?: ICookieStorageData;
// 	oauth?: OAuthOpts;
// 	refreshHandlers?: object;
// 	storage?: ICognitoStorage;
// 	authenticationFlowType?: string;
// 	identityPoolRegion?: string;
// 	clientMetadata?: any;
// 	endpoint?: string;
// 	signUpVerificationMethod?: 'code' | 'link';
// }
var $1c0762cc928ab7c3$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($1c0762cc928ab7c3$export$eeb013770cb92342 || ($1c0762cc928ab7c3$export$eeb013770cb92342 = {}));
function $1c0762cc928ab7c3$export$9b905d6895bdc426(obj) {
    const keys = [
        "provider"
    ];
    return obj && !!keys.find((k)=>obj.hasOwnProperty(k));
}
function $1c0762cc928ab7c3$export$828f8efbdf71714b(obj) {
    const keys = [
        "customProvider"
    ];
    return obj && !!keys.find((k)=>obj.hasOwnProperty(k));
}
function $1c0762cc928ab7c3$export$6bae5520ca265d22(obj) {
    const keys = [
        "customState"
    ];
    return obj && !!keys.find((k)=>obj.hasOwnProperty(k));
}
function $1c0762cc928ab7c3$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $1c0762cc928ab7c3$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
    AuthErrorTypes["OAuthSignInError"] = "oauthSignInError";
})($1c0762cc928ab7c3$export$edb367c0a140d3db || ($1c0762cc928ab7c3$export$edb367c0a140d3db = {}));
function $1c0762cc928ab7c3$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $1c0762cc928ab7c3$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($1c0762cc928ab7c3$export$cfce9c15015bef96 || ($1c0762cc928ab7c3$export$cfce9c15015bef96 = {}));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e363233d06433080$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("AuthError");
class $e363233d06433080$export$145273558d58e0ac extends Error {
    constructor(type){
        const { message: message, log: log } = $e363233d06433080$export$d8113b8d790509a4[type];
        super(message);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $e363233d06433080$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $e363233d06433080$export$145273558d58e0ac.prototype);
        this.name = "AuthError";
        this.log = log || message;
        $e363233d06433080$var$logger.error(this.log);
    }
}
class $e363233d06433080$export$71192787e041818c extends $e363233d06433080$export$145273558d58e0ac {
    constructor(type){
        super(type);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $e363233d06433080$export$71192787e041818c;
        Object.setPrototypeOf(this, $e363233d06433080$export$71192787e041818c.prototype);
        this.name = "NoUserPoolError";
    }
}
const $e363233d06433080$export$d8113b8d790509a4 = {
    oauthSignInError: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).OAUTH_ERROR,
        log: "Make sure Cognito Hosted UI has been configured correctly"
    },
    noConfig: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
    },
    missingAuthConfig: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
    },
    emptyUsername: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $f6e29a46e63271fd$export$c3070468b9d65120).DEFAULT_MSG
    }
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $aba0ef47f4ab23d4$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0f907e44c249ad21$var$CODE_VERIFIER_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
/**
 *
 * @param length Desired length of the code verifier.
 *
 * **NOTE:** According to the [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 * A code verifier must be with a length >= 43 and <= 128.
 *
 * @returns An object that contains the generated `codeVerifier` and a method
 * `toCodeChallenge` to generate the code challenge from the `codeVerifier`
 * following the spec of [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2).
 */ const $0f907e44c249ad21$export$cf1891f923f5943a = (length)=>{
    const randomBytes = new Uint8Array(length);
    (0, $cc2669c14dc942e5$export$e003cc239f955cb6)().getRandomValues(randomBytes);
    let value = "";
    let codeChallenge;
    for (let byte of randomBytes)value += $0f907e44c249ad21$var$CODE_VERIFIER_CHARSET.charAt(byte % $0f907e44c249ad21$var$CODE_VERIFIER_CHARSET.length);
    return {
        value: value,
        method: "S256",
        toCodeChallenge () {
            if (codeChallenge) return codeChallenge;
            codeChallenge = $0f907e44c249ad21$var$generateCodeChallenge(value);
            return codeChallenge;
        }
    };
};
function $0f907e44c249ad21$var$generateCodeChallenge(codeVerifier) {
    const awsCryptoHash = new (0, $e276799cbbca4dad$exports.Sha256)();
    awsCryptoHash.update(codeVerifier);
    const codeChallenge = $0f907e44c249ad21$var$removePaddingChar((0, $022d6056dd354b6b$export$695b149896bd3e2a).convert(awsCryptoHash.digestSync(), {
        urlSafe: true
    }));
    return codeChallenge;
}
function $0f907e44c249ad21$var$removePaddingChar(base64Encoded) {
    return base64Encoded.replace(/=/g, "");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bb0c179fef242544$export$9e15fb06e64c4810 = (length)=>{
    const STATE_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for(let i = 0; i < length; i++)result += STATE_CHARSET.charAt(Math.floor(Math.random() * STATE_CHARSET.length));
    return result;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d3bbd2ca041a5c42$export$9ccd2716e53a229b = ()=>{
    return (0, $bb0c179fef242544$export$9e15fb06e64c4810)(32);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $55880ae2adbc4de1$export$93832c3affb240d3(redirects) {
    const redirectUrlFromTheSameOrigin = redirects?.find($55880ae2adbc4de1$var$isSameOriginAndPathName) ?? redirects?.find($55880ae2adbc4de1$var$isTheSameDomain);
    const redirectUrlFromDifferentOrigin = redirects?.find($55880ae2adbc4de1$var$isHttps) ?? redirects?.find($55880ae2adbc4de1$var$isHttp);
    if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
    else if (redirectUrlFromDifferentOrigin) throw 0, $0927f39e1da098a6$export$c01b4acd6291e035;
    throw 0, $0927f39e1da098a6$export$60b68b138a52e5ae;
}
// origin + pathname => https://example.com/app
const $55880ae2adbc4de1$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(String((window.location.origin + window.location.pathname) ?? "/"));
// domain => outlook.live.com, github.com
const $55880ae2adbc4de1$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $55880ae2adbc4de1$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $55880ae2adbc4de1$var$isHttps = (redirect)=>redirect.startsWith("https://");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs in a user with OAuth. Redirects the application to an Identity Provider.
 *
 * @param input - The SignInWithRedirectInput object, if empty it will redirect to Cognito HostedUI
 *
 * @throws AuthTokenConfigException - Thrown when the userpool config is invalid.
 * @throws OAuthNotConfigureException - Thrown when the oauth config is invalid.
 */ async function $70e231d9d71cde8b$export$3d0a7d1372e866bb(input) {
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    (0, $1373aa7f126ca50c$export$c13e6dbaf90a8e5f)(authConfig);
    $70e231d9d71cde8b$export$6f57813fe9f31bf9.setAuthConfig(authConfig);
    await (0, $2c5e8e2c675aaf23$export$8061cd07f982ef08)();
    let provider = "COGNITO"; // Default
    if (typeof input?.provider === "string") provider = (0, $43b1f40fd98614d2$export$6893de5f4e1216c3)[input.provider];
    else if (input?.provider?.custom) provider = input.provider.custom;
    return $70e231d9d71cde8b$export$9920513c105dd3a6({
        oauthConfig: authConfig.loginWith.oauth,
        clientId: authConfig.userPoolClientId,
        provider: provider,
        customState: input?.customState,
        preferPrivateSession: input?.options?.preferPrivateSession
    });
}
const $70e231d9d71cde8b$export$6f57813fe9f31bf9 = new (0, $2c3c9f6c1e86f636$export$9b2cef5d94f9b6e8)((0, $54aa5b1883c07459$export$586b30dcaeecb901));
async function $70e231d9d71cde8b$export$9920513c105dd3a6({ oauthConfig: oauthConfig, provider: provider, clientId: clientId, customState: customState, preferPrivateSession: preferPrivateSession }) {
    const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType, scopes: scopes } = oauthConfig;
    const randomState = (0, $d3bbd2ca041a5c42$export$9ccd2716e53a229b)();
    /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
    single-encodes/decodes url on first sign in and double-encodes/decodes url
    when user already signed in. Using encodeURIComponent, Base32, Base64 add
    characters % or = which on further encoding becomes unsafe. '=' create issue
    for parsing query params.
    Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ const state = customState ? `${randomState}-${(0, $0780c3909c10c3b1$export$b855308a44508212)(customState)}` : randomState;
    const { value: value, method: method, toCodeChallenge: toCodeChallenge } = (0, $0f907e44c249ad21$export$cf1891f923f5943a)(128);
    $70e231d9d71cde8b$export$6f57813fe9f31bf9.storeOAuthInFlight(true);
    $70e231d9d71cde8b$export$6f57813fe9f31bf9.storeOAuthState(state);
    $70e231d9d71cde8b$export$6f57813fe9f31bf9.storePKCE(value);
    const queryString = Object.entries({
        redirect_uri: (0, $55880ae2adbc4de1$export$93832c3affb240d3)(oauthConfig.redirectSignIn),
        response_type: responseType,
        client_id: clientId,
        identity_provider: provider,
        scope: scopes.join(" "),
        state: state,
        ...responseType === "code" && {
            code_challenge: toCodeChallenge(),
            code_challenge_method: method
        }
    }).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
    // TODO(v6): use URL object instead
    const oAuthUrl = `https://${domain}/oauth2/authorize?${queryString}`;
    const { type: type, error: error, url: url } = await (0, $aba0ef47f4ab23d4$export$a673d54799039714)(oAuthUrl) ?? {};
    if (type === "success" && url) // ensure the code exchange completion resolves the signInWithRedirect
    // returned promise in react-native
    await $70e231d9d71cde8b$var$handleAuthResponse({
        currentUrl: url,
        clientId: clientId,
        domain: domain,
        redirectUri: redirectSignIn[0],
        responseType: responseType,
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignInWithRedirect),
        preferPrivateSession: preferPrivateSession
    });
    if (type === "error") $70e231d9d71cde8b$var$handleFailure(String(error));
}
async function $70e231d9d71cde8b$var$handleCodeFlow({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, domain: domain, preferPrivateSession: preferPrivateSession }) {
    /* Convert URL into an object with parameters as keys
{ redirect_uri: 'http://localhost:3000/', response_type: 'code', ...} */ const url = new (0, $2b8867449626b446$export$beb82d9d9136c16e)(currentUrl);
    let validatedState;
    try {
        validatedState = await $70e231d9d71cde8b$var$validateStateFromURL(url);
    } catch (err) {
        $70e231d9d71cde8b$var$invokeAndClearPromise();
        // clear temp values
        await $70e231d9d71cde8b$export$6f57813fe9f31bf9.clearOAuthInflightData();
        return;
    }
    const code = url.searchParams.get("code");
    if (!code) {
        await $70e231d9d71cde8b$export$6f57813fe9f31bf9.clearOAuthData();
        $70e231d9d71cde8b$var$invokeAndClearPromise();
        return;
    }
    const oAuthTokenEndpoint = "https://" + domain + "/oauth2/token";
    // TODO(v6): check hub events
    // dispatchAuthEvent(
    // 	'codeFlow',
    // 	{},
    // 	`Retrieving tokens from ${oAuthTokenEndpoint}`
    // );
    const codeVerifier = await $70e231d9d71cde8b$export$6f57813fe9f31bf9.loadPKCE();
    const oAuthTokenBody = {
        grant_type: "authorization_code",
        code: code,
        client_id: clientId,
        redirect_uri: redirectUri,
        ...codeVerifier ? {
            code_verifier: codeVerifier
        } : {}
    };
    const body = Object.entries(oAuthTokenBody).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
    const { access_token: access_token, refresh_token: refresh_token, id_token: id_token, error: error, token_type: token_type, expires_in: expires_in } = await (await fetch(oAuthTokenEndpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            [(0, $7362059d750d76ac$export$16032fc466434892)]: userAgentValue
        },
        body: body
    })).json();
    if (error) {
        $70e231d9d71cde8b$var$invokeAndClearPromise();
        $70e231d9d71cde8b$var$handleFailure(error);
    }
    await $70e231d9d71cde8b$export$6f57813fe9f31bf9.clearOAuthInflightData();
    const username = (access_token && (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(access_token).payload.username) ?? "username";
    await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token,
        RefreshToken: refresh_token,
        TokenType: token_type,
        ExpiresIn: expires_in
    });
    return $70e231d9d71cde8b$var$completeFlow({
        redirectUri: redirectUri,
        state: validatedState,
        preferPrivateSession: preferPrivateSession
    });
}
async function $70e231d9d71cde8b$var$handleImplicitFlow({ currentUrl: currentUrl, redirectUri: redirectUri, preferPrivateSession: preferPrivateSession }) {
    // hash is `null` if `#` doesn't exist on URL
    const url = new (0, $2b8867449626b446$export$beb82d9d9136c16e)(currentUrl);
    const { id_token: id_token, access_token: access_token, state: state, token_type: token_type, expires_in: expires_in } = (url.hash ?? "#").substring(1) // Remove # from returned code
    .split("&").map((pairings)=>pairings.split("=")).reduce((accum, [k, v])=>({
            ...accum,
            [k]: v
        }), {
        id_token: undefined,
        access_token: undefined,
        state: undefined,
        token_type: undefined,
        expires_in: undefined
    });
    if (!access_token) {
        await $70e231d9d71cde8b$export$6f57813fe9f31bf9.clearOAuthData();
        $70e231d9d71cde8b$var$invokeAndClearPromise();
        return;
    }
    try {
        $70e231d9d71cde8b$var$validateState(state);
    } catch (error) {
        $70e231d9d71cde8b$var$invokeAndClearPromise();
        return;
    }
    const username = (access_token && (0, $1373aa7f126ca50c$export$9a62e6c0a30e00bc)(access_token).payload.username) ?? "username";
    await (0, $679aa6730ab7f609$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token,
        TokenType: token_type,
        ExpiresIn: expires_in
    });
    return $70e231d9d71cde8b$var$completeFlow({
        redirectUri: redirectUri,
        state: state,
        preferPrivateSession: preferPrivateSession
    });
}
async function $70e231d9d71cde8b$var$completeFlow({ redirectUri: redirectUri, state: state, preferPrivateSession: preferPrivateSession }) {
    await $70e231d9d71cde8b$export$6f57813fe9f31bf9.clearOAuthData();
    await $70e231d9d71cde8b$export$6f57813fe9f31bf9.storeOAuthSignIn(true, preferPrivateSession);
    if ($70e231d9d71cde8b$var$isCustomState(state)) (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
        event: "customOAuthState",
        data: (0, $06fdf39f1a8030b8$export$a7ea17e93539f9a5)($70e231d9d71cde8b$var$getCustomState(state))
    }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
    (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signInWithRedirect"
    }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
    (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedIn",
        data: await (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)()
    }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
    $70e231d9d71cde8b$var$clearHistory(redirectUri);
    $70e231d9d71cde8b$var$invokeAndClearPromise();
}
async function $70e231d9d71cde8b$var$handleAuthResponse({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, responseType: responseType, domain: domain, preferPrivateSession: preferPrivateSession }) {
    try {
        const urlParams = new (0, $2b8867449626b446$export$beb82d9d9136c16e)(currentUrl);
        const error = urlParams.searchParams.get("error");
        const errorMessage = urlParams.searchParams.get("error_description");
        if (error) $70e231d9d71cde8b$var$handleFailure(errorMessage);
        if (responseType === "code") return await $70e231d9d71cde8b$var$handleCodeFlow({
            currentUrl: currentUrl,
            userAgentValue: userAgentValue,
            clientId: clientId,
            redirectUri: redirectUri,
            domain: domain,
            preferPrivateSession: preferPrivateSession
        });
        else return await $70e231d9d71cde8b$var$handleImplicitFlow({
            currentUrl: currentUrl,
            redirectUri: redirectUri,
            preferPrivateSession: preferPrivateSession
        });
    } catch (e) {
        throw e;
    }
}
async function $70e231d9d71cde8b$var$validateStateFromURL(urlParams) {
    const returnedState = urlParams.searchParams.get("state");
    $70e231d9d71cde8b$var$validateState(returnedState);
    return returnedState;
}
function $70e231d9d71cde8b$var$validateState(state) {
    let savedState;
    $70e231d9d71cde8b$export$6f57813fe9f31bf9.loadOAuthState().then((resp)=>{
        savedState = resp;
    });
    // This is because savedState only exists if the flow was initiated by Amplify
    if (savedState && state && savedState !== state) throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        name: (0, $1c0762cc928ab7c3$export$edb367c0a140d3db).OAuthSignInError,
        message: "An error occurred while validating the state",
        recoverySuggestion: "Try to initiate an OAuth flow from Amplify"
    });
}
function $70e231d9d71cde8b$var$handleFailure(errorMessage) {
    (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signInWithRedirect_failure"
    }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
    throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
        message: errorMessage ?? "",
        name: (0, $f6e29a46e63271fd$export$473ab0b56598aacd).OAuthSignInError,
        recoverySuggestion: (0, $e363233d06433080$export$d8113b8d790509a4).oauthSignInError.log
    });
}
async function $70e231d9d71cde8b$var$parseRedirectURL() {
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    try {
        (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
        $70e231d9d71cde8b$export$6f57813fe9f31bf9.setAuthConfig(authConfig);
    } catch (_err) {
        // Token provider not configure nothing to do
        return;
    }
    // No OAuth inflight doesnt need to parse the url
    if (!await $70e231d9d71cde8b$export$6f57813fe9f31bf9.loadOAuthInFlight()) return;
    try {
        (0, $1373aa7f126ca50c$export$c13e6dbaf90a8e5f)(authConfig);
    } catch (err) {
        // TODO(v6): this should warn you have signInWithRedirect but is not configured
        return;
    }
    try {
        const currentUrl = window.location.href;
        const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
        const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType } = loginWith.oauth;
        $70e231d9d71cde8b$var$handleAuthResponse({
            currentUrl: currentUrl,
            clientId: userPoolClientId,
            domain: domain,
            redirectUri: redirectSignIn[0],
            responseType: responseType,
            userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignInWithRedirect)
        });
    } catch (err) {
    // is ok if there is not OAuthConfig
    }
}
function $70e231d9d71cde8b$var$urlListener() {
    // Listen configure to parse url
    $70e231d9d71cde8b$var$parseRedirectURL();
    (0, $b47473e783336341$export$8c41bb232f1008b1).listen("core", (capsule)=>{
        if (capsule.payload.event === "configure") $70e231d9d71cde8b$var$parseRedirectURL();
    });
}
(0, $35ad0e56ab0f9057$export$4e09c449d6c407f7)() && $70e231d9d71cde8b$var$urlListener();
// This has a reference for listeners that requires to be notified, TokenOrchestrator use this for load tokens
let $70e231d9d71cde8b$var$inflightPromiseResolvers = [];
const $70e231d9d71cde8b$var$invokeAndClearPromise = ()=>{
    for (const promiseResolver of $70e231d9d71cde8b$var$inflightPromiseResolvers)promiseResolver();
    $70e231d9d71cde8b$var$inflightPromiseResolvers = [];
};
(0, $35ad0e56ab0f9057$export$4e09c449d6c407f7)() && (0, $4398d957ad502806$export$18e158b80aac31a7).setWaitForInflightOAuth(()=>new Promise(async (res, _rej)=>{
        if (!await $70e231d9d71cde8b$export$6f57813fe9f31bf9.loadOAuthInFlight()) res();
        else $70e231d9d71cde8b$var$inflightPromiseResolvers.push(res);
        return;
    }));
function $70e231d9d71cde8b$var$clearHistory(redirectUri) {
    if (typeof window !== "undefined" && typeof window.history !== "undefined") window.history.replaceState({}, "", redirectUri);
}
function $70e231d9d71cde8b$var$isCustomState(state) {
    return /-/.test(state);
}
function $70e231d9d71cde8b$var$getCustomState(state) {
    return state.split("-").splice(1).join("-");
}






const $994053336e0d1de1$var$handleSignInResponse = {
    onDone: [
        {
            cond: "hasCompletedSignIn",
            actions: "setNextSignInStep",
            target: "#signInActor.fetchUserAttributes"
        },
        {
            cond: "shouldConfirmSignInWithNewPassword",
            actions: [
                "setMissingAttributes",
                "setNextSignInStep"
            ],
            target: "#signInActor.forceChangePassword"
        },
        {
            cond: "shouldResetPasswordFromSignIn",
            actions: "setNextSignInStep",
            target: "#signInActor.resetPassword"
        },
        {
            cond: "shouldConfirmSignUpFromSignIn",
            actions: "setNextSignInStep",
            target: "#signInActor.resendSignUpCode"
        },
        {
            actions: [
                "setChallengeName",
                "setMissingAttributes",
                "setNextSignInStep",
                "setTotpSecretCode"
            ],
            target: "#signInActor.init"
        }
    ],
    onError: {
        actions: "setRemoteError",
        target: "edit"
    }
};
const $994053336e0d1de1$var$handleFetchUserAttributesResponse = {
    onDone: [
        {
            cond: "shouldVerifyAttribute",
            actions: [
                "setShouldVerifyUserAttributeStep",
                "setUnverifiedUserAttributes"
            ],
            target: "#signInActor.resolved"
        },
        {
            actions: "setConfirmAttributeCompleteStep",
            target: "#signInActor.resolved"
        }
    ],
    onError: {
        actions: "setConfirmAttributeCompleteStep",
        target: "#signInActor.resolved"
    }
};
function $994053336e0d1de1$export$f9c30eaa77191700({ services: services }) {
    return (0, $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8)({
        id: "signInActor",
        initial: "init",
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: "shouldConfirmSignIn",
                        target: "confirmSignIn"
                    },
                    {
                        cond: "shouldSetupTotp",
                        target: "setupTotp"
                    },
                    {
                        cond: ({ step: step })=>step === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                        actions: "setActorDoneData",
                        target: "forceChangePassword"
                    },
                    {
                        target: "signIn"
                    }
                ]
            },
            federatedSignIn: {
                entry: [
                    "sendUpdate",
                    "clearError"
                ],
                invoke: {
                    src: "signInWithRedirect",
                    onError: {
                        actions: "setRemoteError"
                    }
                }
            },
            fetchUserAttributes: {
                invoke: {
                    src: "fetchUserAttributes",
                    ...$994053336e0d1de1$var$handleFetchUserAttributesResponse
                }
            },
            resendSignUpCode: {
                invoke: {
                    src: "handleResendSignUpCode",
                    onDone: {
                        actions: "setCodeDeliveryDetails",
                        target: "#signInActor.resolved"
                    },
                    onError: {
                        actions: "setRemoteError",
                        target: "#signInActor.signIn"
                    }
                }
            },
            resetPassword: {
                invoke: {
                    src: "resetPassword",
                    onDone: [
                        {
                            actions: "setCodeDeliveryDetails",
                            target: "#signInActor.resolved"
                        }
                    ],
                    onError: {
                        actions: [
                            "setRemoteError",
                            "sendUpdate"
                        ]
                    }
                }
            },
            signIn: {
                initial: "edit",
                exit: "clearTouched",
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            CHANGE: {
                                actions: "handleInput"
                            },
                            FEDERATED_SIGN_IN: {
                                target: "#signInActor.federatedSignIn"
                            },
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate",
                            "setUsernameSignIn"
                        ],
                        exit: "clearFormValues",
                        invoke: {
                            src: "handleSignIn",
                            ...$994053336e0d1de1$var$handleSignInResponse
                        }
                    }
                }
            },
            confirmSignIn: {
                initial: "edit",
                exit: [
                    "clearChallengeName",
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            ...$994053336e0d1de1$var$handleSignInResponse
                        }
                    }
                }
            },
            forceChangePassword: {
                entry: "sendUpdate",
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            SIGN_IN: {
                                actions: "setSignInStep",
                                target: "#signInActor.resolved"
                            },
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submit: {
                        initial: "edit",
                        entry: "clearError",
                        states: {
                            edit: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        actions: "clearValidationError",
                                        target: "pending"
                                    },
                                    onError: {
                                        actions: "setFieldErrors",
                                        target: "edit"
                                    }
                                }
                            },
                            pending: {
                                tags: "pending",
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "handleForceChangePassword",
                                    ...$994053336e0d1de1$var$handleSignInResponse
                                }
                            }
                        }
                    }
                }
            },
            setupTotp: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            ...$994053336e0d1de1$var$handleSignInResponse
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (context)=>({
                        codeDeliveryDetails: context.codeDeliveryDetails,
                        remoteError: context.remoteError,
                        step: context.step,
                        unverifiedUserAttributes: context.unverifiedUserAttributes,
                        username: context.username
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $d2a1a0d0733f5d9b$export$2e2bcd8739ae039),
            sendUpdate: (0, $bbe1427e84b1ce64$export$7f8b724299523eb6)()
        },
        guards: (0, $b5e04cdb6d60d786$export$2e2bcd8739ae039),
        services: {
            async fetchUserAttributes () {
                return (0, $7ab176055223e057$export$5dc95ecf3f16c6c9)();
            },
            resetPassword ({ username: username }) {
                return (0, $26bdb14eefe06e66$export$dc726c8e334dd814)({
                    username: username
                });
            },
            handleResendSignUpCode ({ username: username }) {
                return (0, $6d30f2c471d07326$export$b295e842f1d42d13)({
                    username: username
                });
            },
            handleSignIn ({ formValues: formValues, username: username }) {
                const { password: password } = formValues;
                return services.handleSignIn({
                    username: username,
                    password: password
                });
            },
            confirmSignIn ({ formValues: formValues }) {
                const { confirmation_code: challengeResponse } = formValues;
                return services.handleConfirmSignIn({
                    challengeResponse: challengeResponse
                });
            },
            async handleForceChangePassword ({ formValues: formValues }) {
                let { password: challengeResponse, phone_number: phone_number, country_code: country_code, confirm_password: // destructure and toss UI confirm_password field
                // to prevent error from sending to confirmSignIn
                confirm_password, ...userAttributes } = formValues;
                let phoneNumberWithCountryCode;
                if (phone_number) {
                    phoneNumberWithCountryCode = `${country_code}${phone_number}`.replace(/[^A-Z0-9+]/gi, "");
                    userAttributes = {
                        ...userAttributes,
                        phone_number: phoneNumberWithCountryCode
                    };
                }
                const input = {
                    challengeResponse: challengeResponse,
                    options: {
                        userAttributes: userAttributes
                    }
                };
                return (0, $9143a0342aca171d$export$a477d84c2f7b792a)(input);
            },
            signInWithRedirect (_, { data: data }) {
                return (0, $70e231d9d71cde8b$export$3d0a7d1372e866bb)(data);
            },
            async validateFields (context) {
                return (0, $f759a5e2f85cdfdb$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $03873ba183dba266$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $03873ba183dba266$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}








const $b611e69e189b7d3b$var$handleResetPasswordResponse = {
    onDone: [
        {
            actions: "setCodeDeliveryDetails",
            target: "#signUpActor.resolved"
        }
    ],
    onError: {
        actions: [
            "setRemoteError",
            "sendUpdate"
        ]
    }
};
const $b611e69e189b7d3b$var$handleAutoSignInResponse = {
    onDone: [
        {
            cond: "hasCompletedSignIn",
            actions: "setNextSignInStep",
            target: "#signUpActor.fetchUserAttributes"
        },
        {
            cond: "shouldConfirmSignInWithNewPassword",
            actions: "setNextSignInStep",
            target: "#signUpActor.resolved"
        },
        {
            cond: "shouldResetPasswordFromSignIn",
            actions: "setNextSignInStep",
            target: "#signUpActor.resetPassword"
        },
        {
            cond: "shouldConfirmSignUpFromSignIn",
            actions: "setNextSignInStep",
            target: "#signUpActor.resendSignUpCode"
        },
        {
            actions: [
                "setNextSignInStep",
                "setChallengeName",
                "setMissingAttributes",
                "setTotpSecretCode"
            ],
            target: "#signUpActor.resolved"
        }
    ],
    onError: {
        actions: "setRemoteError",
        target: "#signUpActor.resolved"
    }
};
const $b611e69e189b7d3b$var$handleFetchUserAttributesResponse = {
    onDone: [
        {
            cond: "shouldVerifyAttribute",
            actions: [
                "setShouldVerifyUserAttributeStep",
                "setUnverifiedUserAttributes"
            ],
            target: "#signUpActor.resolved"
        },
        {
            actions: "setConfirmAttributeCompleteStep",
            target: "#signUpActor.resolved"
        }
    ],
    onError: {
        actions: "setConfirmAttributeCompleteStep",
        target: "#signUpActor.resolved"
    }
};
function $b611e69e189b7d3b$export$6cf61434854181b4({ services: services }) {
    return (0, $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8)({
        id: "signUpActor",
        initial: "init",
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: "shouldConfirmSignUp",
                        target: "confirmSignUp"
                    },
                    {
                        target: "signUp"
                    }
                ]
            },
            autoSignIn: {
                tags: "pending",
                invoke: {
                    src: "autoSignIn",
                    ...$b611e69e189b7d3b$var$handleAutoSignInResponse
                }
            },
            fetchUserAttributes: {
                invoke: {
                    src: "fetchUserAttributes",
                    ...$b611e69e189b7d3b$var$handleFetchUserAttributesResponse
                }
            },
            resetPassword: {
                invoke: {
                    src: "resetPassword",
                    ...$b611e69e189b7d3b$var$handleResetPasswordResponse
                }
            },
            resendSignUpCode: {
                tags: "pending",
                entry: "sendUpdate",
                exit: "sendUpdate",
                invoke: {
                    src: "resendSignUpCode",
                    onDone: {
                        actions: [
                            "setCodeDeliveryDetails",
                            "sendUpdate"
                        ],
                        target: "#signUpActor.confirmSignUp"
                    },
                    onError: [
                        {
                            cond: "isUserAlreadyConfirmed",
                            target: "#signUpActor.resolved"
                        },
                        {
                            actions: [
                                "setRemoteError",
                                "sendUpdate"
                            ]
                        }
                    ]
                }
            },
            signUp: {
                type: "parallel",
                exit: "clearTouched",
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        actions: "clearValidationError",
                                        target: "valid"
                                    },
                                    onError: {
                                        actions: "setFieldErrors",
                                        target: "invalid"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: [
                                    "sendUpdate"
                                ],
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    FEDERATED_SIGN_IN: "federatedSignIn"
                                }
                            },
                            federatedSignIn: {
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "federatedSignIn",
                                    onError: {
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "signUp",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        actions: "setFieldErrors",
                                        target: "idle"
                                    }
                                }
                            },
                            signUp: {
                                tags: "pending",
                                entry: [
                                    "setUsernameSignUp",
                                    "clearError"
                                ],
                                exit: "sendUpdate",
                                invoke: {
                                    src: "handleSignUp",
                                    onDone: [
                                        {
                                            cond: "hasCompletedSignUp",
                                            actions: "setNextSignUpStep",
                                            target: "#signUpActor.resolved"
                                        },
                                        {
                                            cond: "shouldAutoSignIn",
                                            actions: "setNextSignUpStep",
                                            target: "#signUpActor.autoSignIn"
                                        },
                                        {
                                            actions: [
                                                "setCodeDeliveryDetails",
                                                "setNextSignUpStep"
                                            ],
                                            target: "#signUpActor.init"
                                        }
                                    ],
                                    onError: {
                                        actions: [
                                            "sendUpdate",
                                            "setRemoteError"
                                        ],
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            confirmSignUp: {
                initial: "edit",
                entry: "sendUpdate",
                states: {
                    edit: {
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            },
                            RESEND: "#signUpActor.resendSignUpCode"
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignUp",
                            onDone: [
                                {
                                    cond: "shouldAutoSignIn",
                                    actions: [
                                        "setNextSignUpStep",
                                        "clearFormValues"
                                    ],
                                    target: "#signUpActor.autoSignIn"
                                },
                                {
                                    actions: "setNextSignUpStep",
                                    target: "#signUpActor.init"
                                }
                            ],
                            onError: {
                                actions: [
                                    "setRemoteError",
                                    "sendUpdate"
                                ],
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (context)=>({
                        challengeName: context.challengeName,
                        missingAttributes: context.missingAttributes,
                        remoteError: context.remoteError,
                        step: context.step,
                        totpSecretCode: context.totpSecretCode,
                        unverifiedUserAttributes: context.unverifiedUserAttributes
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $d2a1a0d0733f5d9b$export$2e2bcd8739ae039),
            sendUpdate: (0, $bbe1427e84b1ce64$export$7f8b724299523eb6)()
        },
        guards: (0, $b5e04cdb6d60d786$export$2e2bcd8739ae039),
        services: {
            autoSignIn () {
                return (0, $2160dbb81d4937f8$export$c5378dc7d6787fa5)();
            },
            async fetchUserAttributes () {
                return (0, $7ab176055223e057$export$5dc95ecf3f16c6c9)();
            },
            confirmSignUp ({ formValues: formValues, username: username }) {
                const { confirmation_code: confirmationCode } = formValues;
                const input = {
                    username: username,
                    confirmationCode: confirmationCode
                };
                return services.handleConfirmSignUp(input);
            },
            resendSignUpCode ({ username: username }) {
                return (0, $6d30f2c471d07326$export$b295e842f1d42d13)({
                    username: username
                });
            },
            async federatedSignIn (_, { data: data }) {
                return (0, $70e231d9d71cde8b$export$3d0a7d1372e866bb)(data);
            },
            async handleSignUp (context) {
                const { formValues: formValues, loginMechanisms: loginMechanisms, username: username } = context;
                const loginMechanism = loginMechanisms[0];
                const input = (0, $bd617b144b33cb29$export$6bc605b0b68c7601)(username, formValues, loginMechanism);
                return services.handleSignUp(input);
            },
            async validateSignUp (context) {
                // This needs to exist in the machine to reference new `services`
                return (0, $f759a5e2f85cdfdb$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    // Validation of password
                    services.validateFormPassword,
                    // Validation for default form fields
                    services.validateConfirmPassword,
                    services.validatePreferredUsername,
                    // Validation for any custom Sign Up fields
                    services.validateCustomSignUp
                ]);
            }
        }
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ab7582d4f0df9e0d$export$d1b63878dfcc70a6() {
    return (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).Auth.clearCredentials();
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8ad1bcb185c71a09$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $4398d957ad502806$export$66561e66d62991d0).clearTokens();
    await (0, $ab7582d4f0df9e0d$export$d1b63878dfcc70a6)();
    (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $71a81a331bb643cb$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false)=>{
    (0, $1373aa7f126ca50c$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
    const { domain: domain, redirectSignOut: redirectSignOut } = loginWith.oauth;
    const signoutUri = (0, $55880ae2adbc4de1$export$93832c3affb240d3)(redirectSignOut);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $aba0ef47f4ab23d4$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $666e2d686e1431b0$export$74290142c99a2f64 = async (cognitoConfig, store)=>{
    const { isOAuthSignIn: isOAuthSignIn } = await store.loadOAuthSignIn();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $8ad1bcb185c71a09$export$f8a4fedaab76b065)(store);
    if (isOAuthSignIn) // On web, this will always end up being a void action
    return (0, $71a81a331bb643cb$export$a20426d3d43ad21f)(cognitoConfig);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $03a947cd94d98315$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $03a947cd94d98315$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $03a947cd94d98315$var$globalSignOut(cognitoConfig);
    else await $03a947cd94d98315$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $1373aa7f126ca50c$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $2c3c9f6c1e86f636$export$9b2cef5d94f9b6e8)((0, $54aa5b1883c07459$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type } = await (0, $666e2d686e1431b0$export$74290142c99a2f64)(cognitoConfig, oAuthStore) ?? {};
        if (type === "error") throw new (0, $cb87c343b3a92609$export$145273558d58e0ac)({
            name: (0, $0927f39e1da098a6$export$625255707e22459c),
            message: "An error occurred when attempting to log out from OAuth provider."
        });
    } else {
        // complete sign out
        (0, $4398d957ad502806$export$66561e66d62991d0).clearTokens();
        await (0, $ab7582d4f0df9e0d$export$d1b63878dfcc70a6)();
        (0, $b47473e783336341$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $b47473e783336341$export$aadf71dd9875dd20));
    }
}
async function $03a947cd94d98315$var$clientSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $4398d957ad502806$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $de2f10f4a648aec0$export$be38b2d22222d505)(authTokens);
        if ($03a947cd94d98315$var$isSessionRevocable(authTokens.accessToken)) await (0, $03c131ae6cab815c$export$2428f6ba65615593)({
            region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignOut)
        }, {
            ClientId: cognitoConfig.userPoolClientId,
            Token: authTokens.refreshToken
        });
    } catch (err) {
        // this shouldn't throw
        $03a947cd94d98315$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $03a947cd94d98315$var$globalSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $4398d957ad502806$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $de2f10f4a648aec0$export$77712ea5882cac9f)(authTokens);
        await (0, $03c131ae6cab815c$export$a92c2ab9b6303723)({
            region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $03a947cd94d98315$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $03a947cd94d98315$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;


const $33c96889839dbe22$export$2f15f45f1f7b7787 = ()=>{
    return (0, $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8)({
        initial: "pending",
        id: "signOutActor",
        predictableActionArguments: true,
        states: {
            pending: {
                tags: "pending",
                invoke: {
                    src: "signOut",
                    onDone: "resolved",
                    onError: "rejected"
                }
            },
            resolved: {
                type: "final"
            },
            rejected: {
                type: "final"
            }
        }
    }, {
        services: {
            signOut: ()=>(0, $03a947cd94d98315$export$b0ac3a1c242cb1ea)()
        }
    });
};











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a user attribute with the confirmation code.
 *
 * @param input -  The ConfirmUserAttributeInput object
 * @throws  -{@link AuthValidationErrorCode } -
 * Thrown when `confirmationCode` is not defined.
 * @throws  -{@link VerifyUserAttributeException } - Thrown due to an invalid confirmation code or attribute.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $a0dc9c77d0988ec2$export$db3262544786991c(input) {
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { confirmationCode: confirmationCode, userAttributeKey: userAttributeKey } = input;
    (0, $7372c4b3ac7c2efd$export$45936001d12f9b53)(!!confirmationCode, (0, $9b86e3745fe9fe93$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode);
    const { tokens: tokens } = await (0, $f8831aa2c334791f$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $de2f10f4a648aec0$export$77712ea5882cac9f)(tokens);
    await (0, $03c131ae6cab815c$export$40fc6c986f86e9a5)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmUserAttribute)
    }, {
        AccessToken: tokens.accessToken.toString(),
        AttributeName: userAttributeKey,
        Code: confirmationCode
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resends user's confirmation code when updating attributes while authenticated.
 *
 * @param input - The SendUserAttributeVerificationCodeInput object
 * @returns SendUserAttributeVerificationCodeOutput
 * @throws - {@link GetUserAttributeVerificationException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $d8f533b07fdb0875$export$fa66ca482758432e = async (input)=>{
    const { userAttributeKey: userAttributeKey, options: options } = input;
    const authConfig = (0, $53e4c01d7e03bcc8$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const clientMetadata = options?.clientMetadata;
    (0, $1373aa7f126ca50c$export$80c92581e59ed502)(authConfig);
    const { tokens: tokens } = await (0, $f8831aa2c334791f$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $de2f10f4a648aec0$export$77712ea5882cac9f)(tokens);
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await (0, $03c131ae6cab815c$export$3a9721eaccd0e7b3)({
        region: (0, $3d2f8329dc39998b$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $c1aa49233a0ce598$export$d6cd780379f37dae)((0, $9d643ce80023347d$export$900b1436d7e65f4).SendUserAttributeVerificationCode)
    }, {
        AccessToken: tokens.accessToken.toString(),
        ClientMetadata: clientMetadata,
        AttributeName: userAttributeKey
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = {
        ...CodeDeliveryDetails
    };
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName
    };
};





function $6ca28cf1e233dd04$export$15cd9b2846733edf() {
    return (0, $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8)({
        id: "verifyUserAttributesActor",
        initial: "selectUserAttributes",
        predictableActionArguments: true,
        states: {
            selectUserAttributes: {
                initial: "edit",
                exit: [
                    "clearError",
                    "clearTouched",
                    "sendUpdate"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: {
                                target: "#verifyUserAttributesActor.resolved"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "sendUserAttributeVerificationCode",
                            onDone: {
                                actions: [
                                    "setSelectedUserAttribute",
                                    "setCodeDeliveryDetails"
                                ],
                                target: "#verifyUserAttributesActor.confirmVerifyUserAttribute"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmVerifyUserAttribute: {
                initial: "edit",
                exit: [
                    "clearError",
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#verifyUserAttributesActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmVerifyUserAttribute",
                            onDone: {
                                actions: [
                                    "setConfirmAttributeCompleteStep",
                                    "clearSelectedUserAttribute"
                                ],
                                target: "#verifyUserAttributesActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: ({ step: step })=>({
                        step: step
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $d2a1a0d0733f5d9b$export$2e2bcd8739ae039),
            sendUpdate: (0, $bbe1427e84b1ce64$export$7f8b724299523eb6)()
        },
        services: {
            sendUserAttributeVerificationCode ({ formValues: { unverifiedAttr: unverifiedAttr } }) {
                const input = {
                    userAttributeKey: unverifiedAttr
                };
                return (0, $d8f533b07fdb0875$export$fa66ca482758432e)(input);
            },
            async confirmVerifyUserAttribute ({ formValues: { confirmation_code: confirmationCode }, selectedUserAttribute: selectedUserAttribute }) {
                const input = {
                    confirmationCode: confirmationCode,
                    userAttributeKey: selectedUserAttribute
                };
                return (0, $a0dc9c77d0988ec2$export$db3262544786991c)(input);
            },
            async validateFields (context) {
                return (0, $f759a5e2f85cdfdb$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $03873ba183dba266$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $03873ba183dba266$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}



const $243fc4ae95ba491e$var$getActorContext = (context, defaultStep)=>({
        ...context.actorDoneData,
        step: context?.actorDoneData?.step ?? defaultStep,
        // initialize empty objects on actor start
        formValues: {},
        touched: {},
        validationError: {},
        // values included on `context.config` that should be available in actors
        formFields: context.config?.formFields,
        loginMechanisms: context.config?.loginMechanisms,
        passwordSettings: context.config?.passwordSettings,
        signUpAttributes: context.config?.signUpAttributes,
        socialProviders: context.config?.socialProviders
    });
const { choose: $243fc4ae95ba491e$var$choose, stop: $243fc4ae95ba491e$var$stop } = (0, $e262c78e8c90133a$exports);
const $243fc4ae95ba491e$var$stopActor = (machineId)=>$243fc4ae95ba491e$var$stop(machineId);
// setup step waits for ui to emit INIT action to proceed to configure
const $243fc4ae95ba491e$var$LEGACY_WAIT_CONFIG = {
    on: {
        INIT: {
            actions: [
                "configure"
            ],
            target: "getConfig"
        },
        SIGN_OUT: "#authenticator.signOut"
    }
};
// setup step proceeds directly to configure
const $243fc4ae95ba491e$var$NEXT_WAIT_CONFIG = {
    always: {
        actions: [
            "configure"
        ],
        target: "getConfig"
    }
};
function $243fc4ae95ba491e$export$af98f08c6e0e0d4d(options) {
    const { useNextWaitConfig: useNextWaitConfig, ...overrideConfigServices } = options ?? {};
    const initConfig = useNextWaitConfig ? $243fc4ae95ba491e$var$NEXT_WAIT_CONFIG : $243fc4ae95ba491e$var$LEGACY_WAIT_CONFIG;
    return (0, $cfd28b8a1b5bcf91$export$aaa7fa18f8e9b2e8)({
        id: "authenticator",
        initial: "idle",
        context: {
            user: undefined,
            config: {},
            services: (0, $03873ba183dba266$export$7ae2d201ca9520b),
            actorRef: undefined,
            hasSetup: false
        },
        predictableActionArguments: true,
        states: {
            // See: https://xstate.js.org/docs/guides/communication.html#invoking-promises
            idle: {
                invoke: {
                    src: "handleGetCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "setup"
                    },
                    onError: {
                        target: "setup"
                    }
                }
            },
            setup: {
                initial: "initConfig",
                states: {
                    initConfig: initConfig,
                    getConfig: {
                        invoke: {
                            src: "getAmplifyConfig",
                            onDone: [
                                {
                                    actions: [
                                        "applyAmplifyConfig",
                                        "setHasSetup"
                                    ],
                                    cond: "hasUser",
                                    target: "#authenticator.authenticated"
                                },
                                {
                                    actions: [
                                        "applyAmplifyConfig",
                                        "setHasSetup"
                                    ],
                                    target: "goToInitialState"
                                }
                            ]
                        }
                    },
                    goToInitialState: {
                        always: [
                            {
                                cond: "isInitialStateSignUp",
                                target: "#authenticator.signUpActor"
                            },
                            {
                                cond: "isInitialStateResetPassword",
                                target: "#authenticator.forgotPasswordActor"
                            },
                            {
                                target: "#authenticator.signInActor"
                            }
                        ]
                    }
                }
            },
            getCurrentUser: {
                invoke: {
                    src: "handleGetCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "#authenticator.authenticated"
                    },
                    onError: {
                        target: "#authenticator.setup"
                    }
                }
            },
            signInActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignInActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $243fc4ae95ba491e$var$stopActor("signInActor")
                    }
                },
                on: {
                    FORGOT_PASSWORD: "forgotPasswordActor",
                    SIGN_IN: "signInActor",
                    SIGN_UP: "signUpActor",
                    "done.invoke.signInActor": [
                        {
                            cond: "hasCompletedAttributeConfirmation",
                            target: "#authenticator.getCurrentUser"
                        },
                        {
                            cond: "isShouldConfirmUserAttributeStep",
                            actions: "setActorDoneData",
                            target: "#authenticator.verifyUserAttributesActor"
                        },
                        {
                            cond: "isResetPasswordStep",
                            actions: "setActorDoneData",
                            target: "#authenticator.forgotPasswordActor"
                        },
                        {
                            cond: "isConfirmSignUpStep",
                            actions: "setActorDoneData",
                            target: "#authenticator.signUpActor"
                        }
                    ]
                }
            },
            signUpActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignUpActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $243fc4ae95ba491e$var$stopActor("signUpActor")
                    }
                },
                on: {
                    SIGN_IN: "signInActor",
                    "done.invoke.signUpActor": [
                        {
                            cond: "hasCompletedAttributeConfirmation",
                            target: "#authenticator.getCurrentUser"
                        },
                        {
                            cond: "isConfirmUserAttributeStep",
                            target: "#authenticator.verifyUserAttributesActor"
                        },
                        {
                            actions: "setActorDoneData",
                            target: "#authenticator.signInActor"
                        }
                    ]
                }
            },
            forgotPasswordActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnForgotPasswordActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $243fc4ae95ba491e$var$stopActor("forgotPasswordActor")
                    }
                },
                on: {
                    SIGN_IN: "signInActor",
                    "done.invoke.forgotPasswordActor": [
                        {
                            target: "#authenticator.signInActor"
                        }
                    ]
                }
            },
            verifyUserAttributesActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnVerifyUserAttributesActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $243fc4ae95ba491e$var$stopActor("verifyUserAttributesActor")
                    }
                },
                on: {
                    "done.invoke.verifyUserAttributesActor": [
                        {
                            actions: "setActorDoneData",
                            target: "#authenticator.getCurrentUser"
                        }
                    ]
                }
            },
            authenticated: {
                initial: "idle",
                states: {
                    idle: {
                        on: {
                            TOKEN_REFRESH: "refreshUser"
                        }
                    },
                    refreshUser: {
                        invoke: {
                            src: "#authenticator.getCurrentUser",
                            onDone: {
                                actions: "setUser",
                                target: "idle"
                            },
                            onError: {
                                target: "#authenticator.signOut"
                            }
                        }
                    }
                },
                on: {
                    SIGN_OUT: "signOut"
                }
            },
            signOut: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignOutActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $243fc4ae95ba491e$var$stopActor("signOutActor")
                    }
                },
                on: {
                    "done.invoke.signOutActor": {
                        actions: "clearUser",
                        target: "setup.getConfig"
                    }
                }
            }
        },
        on: {
            SIGN_IN_WITH_REDIRECT: {
                target: "#authenticator.getCurrentUser"
            },
            CHANGE: {
                actions: "forwardToActor"
            },
            BLUR: {
                actions: "forwardToActor"
            },
            SUBMIT: {
                actions: "forwardToActor"
            },
            FEDERATED_SIGN_IN: {
                actions: "forwardToActor"
            },
            RESEND: {
                actions: "forwardToActor"
            },
            SIGN_IN: {
                actions: "forwardToActor"
            },
            SKIP: {
                actions: "forwardToActor"
            }
        }
    }, {
        actions: {
            ...(0, $d2a1a0d0733f5d9b$export$2e2bcd8739ae039),
            forwardToActor: $243fc4ae95ba491e$var$choose([
                {
                    cond: "hasActor",
                    actions: (0, $bbe1427e84b1ce64$export$eb147b7589db8e8a)(({ actorRef: actorRef })=>actorRef)
                }
            ]),
            setActorDoneData: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                actorDoneData: (context, event)=>({
                        codeDeliveryDetails: event.data.codeDeliveryDetails,
                        missingAttributes: event.data.missingAttributes,
                        remoteError: event.data.remoteError,
                        username: event.data.username,
                        step: event.data.step,
                        totpSecretCode: event.data.totpSecretCode,
                        unverifiedUserAttributes: event.data.unverifiedUserAttributes
                    })
            }),
            applyAmplifyConfig: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                config (context, { data: cliConfig }) {
                    // Prefer explicitly configured settings over default CLI values\
                    const { loginMechanisms: loginMechanisms = cliConfig.loginMechanisms ?? [], signUpAttributes: signUpAttributes = cliConfig.signUpAttributes ?? [], socialProviders: socialProviders = cliConfig.socialProviders ?? [], initialState: initialState, formFields: _formFields, passwordSettings: passwordSettings = cliConfig.passwordFormat ?? {} } = context.config;
                    // By default, Cognito assumes `username`, so there isn't a different username attribute like `email`.
                    // We explicitly add it as a login mechanism to be consistent with Admin UI's language.
                    if (loginMechanisms.length === 0) loginMechanisms.push("username");
                    const formFields = $243fc4ae95ba491e$var$convertFormFields(_formFields) ?? {};
                    return {
                        formFields: formFields,
                        initialState: initialState,
                        loginMechanisms: loginMechanisms,
                        passwordSettings: passwordSettings,
                        signUpAttributes: signUpAttributes,
                        socialProviders: socialProviders
                    };
                }
            }),
            spawnSignInActor: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $994053336e0d1de1$export$f9c30eaa77191700)({
                        services: services
                    }).withContext($243fc4ae95ba491e$var$getActorContext(context, "SIGN_IN"));
                    return (0, $19dcc9cc6e75cec4$export$1713f5ac2bf0caf5)(actor, {
                        name: "signInActor"
                    });
                }
            }),
            spawnSignUpActor: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $b611e69e189b7d3b$export$6cf61434854181b4)({
                        services: services
                    }).withContext($243fc4ae95ba491e$var$getActorContext(context, "SIGN_UP"));
                    return (0, $19dcc9cc6e75cec4$export$1713f5ac2bf0caf5)(actor, {
                        name: "signUpActor"
                    });
                }
            }),
            spawnForgotPasswordActor: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $b9f0aa007876a1a3$export$d384478d1c0083d2)({
                        services: services
                    }).withContext($243fc4ae95ba491e$var$getActorContext(context, "FORGOT_PASSWORD"));
                    return (0, $19dcc9cc6e75cec4$export$1713f5ac2bf0caf5)(actor, {
                        name: "forgotPasswordActor"
                    });
                }
            }),
            spawnVerifyUserAttributesActor: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                actorRef: (context)=>{
                    const actor = (0, $6ca28cf1e233dd04$export$15cd9b2846733edf)().withContext($243fc4ae95ba491e$var$getActorContext(context));
                    return (0, $19dcc9cc6e75cec4$export$1713f5ac2bf0caf5)(actor, {
                        name: "verifyUserAttributesActor"
                    });
                }
            }),
            spawnSignOutActor: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                actorRef: (context)=>{
                    const actor = (0, $33c96889839dbe22$export$2f15f45f1f7b7787)().withContext({
                        user: context?.user
                    });
                    return (0, $19dcc9cc6e75cec4$export$1713f5ac2bf0caf5)(actor, {
                        name: "signOutActor"
                    });
                }
            }),
            configure: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)((_, event)=>{
                const { services: customServices, ...config } = !(0, $85b840b81f21bd6d$export$83b788b1a3698c03)(overrideConfigServices) ? overrideConfigServices : event.data ?? {};
                return {
                    services: {
                        ...(0, $03873ba183dba266$export$7ae2d201ca9520b),
                        ...customServices
                    },
                    config: config
                };
            }),
            setHasSetup: (0, $bbe1427e84b1ce64$export$e6e34fd1f2686227)({
                hasSetup: true
            })
        },
        guards: {
            ...(0, $b5e04cdb6d60d786$export$2e2bcd8739ae039),
            hasActor: ({ actorRef: actorRef })=>!!actorRef,
            isInitialStateSignUp: ({ config: config })=>config.initialState === "signUp",
            isInitialStateResetPassword: ({ config: config })=>config.initialState === "forgotPassword",
            shouldSetup: ({ hasSetup: hasSetup })=>!hasSetup,
            hasUser: ({ user: user })=>{
                return !!user;
            }
        },
        services: {
            getAmplifyConfig: ({ services: services })=>services.getAmplifyConfig(),
            handleGetCurrentUser: ({ services: services })=>services.getCurrentUser()
        }
    });
}
function $243fc4ae95ba491e$var$convertFormFields(formFields) {
    if (formFields) Object.keys(formFields).forEach((component)=>{
        Object.keys(formFields[component]).forEach((inputName)=>{
            let ff = formFields[component][inputName];
            ff.required = ff.isRequired;
        });
    });
    return formFields;
}





/**
 * Handles Amplify JS Auth hub events, by forwarding hub events as appropriate
 * xstate events.
 */ const $d0948e6cce9dc44c$export$f726708373635d8a = async ({ payload: payload }, service, options)=>{
    const { event: event } = payload;
    const { send: send } = service;
    const { onSignIn: onSignIn, onSignOut: onSignOut } = options ?? {};
    switch(event){
        case "signedIn":
            if ((0, $85b840b81f21bd6d$export$f6e2535fb5126e54)(onSignIn)) onSignIn(payload);
            break;
        case "signInWithRedirect":
            send("SIGN_IN_WITH_REDIRECT");
            break;
        case "signedOut":
        case "tokenRefresh_failure":
            if (event === "signedOut" && (0, $85b840b81f21bd6d$export$f6e2535fb5126e54)(onSignOut)) onSignOut();
            send("SIGN_OUT");
            break;
    }
};
const $d0948e6cce9dc44c$var$getHubEventHandler = (service, handler)=>(data)=>{
        handler(data, service);
    };
/**
 * Listens to external auth Hub events and sends corresponding event to
 * the `authService` of interest
 *
 * @param send - `send` function associated with the `authService` of interest
 *
 * @returns function that unsubscribes to the hub evenmt
 */ const $d0948e6cce9dc44c$export$4776c363cae9362c = (service, // angular passes its own `handler` param
handler = $d0948e6cce9dc44c$export$f726708373635d8a)=>{
    return (0, $b47473e783336341$export$8c41bb232f1008b1).listen("auth", $d0948e6cce9dc44c$var$getHubEventHandler(service, handler), "authenticator-hub-handler");
};



var $2hDQc = parcelRequire("2hDQc");
/**
 * AuthenticatorContext serves static reference to the auth machine service.
 *
 * https://xstate.js.org/docs/recipes/react.html#context-provider
 */ const $1aaa37dea0f4e3ac$export$2254a7bd02a5abf7 = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createContext(null);


const $cf66f8524ccb62e2$var$createHubHandler = (options)=>async (data, service)=>{
        await (0, $d0948e6cce9dc44c$export$f726708373635d8a)(data, service, options);
    };
function $cf66f8524ccb62e2$export$2e2bcd8739ae039({ children: children }) {
    // `authStatus` is exposed by `useAuthenticator` but should not be derived directly from the
    // state machine as the machine only updates on `Authenticator` initiated events, which
    // leads to scenarios where the state machine `authStatus` gets "stuck". For exmample,
    // if a user was to sign in using `Auth.signIn` directly rather than using `Authenticator`
    const [authStatus, setAuthStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useState("configuring");
    // only run on first render
    (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useEffect(()=>{
        (0, $4539220ee0fa802b$export$e5432d4c8eb97ea7)().then(()=>{
            setAuthStatus("authenticated");
        }).catch(()=>{
            setAuthStatus("unauthenticated");
        });
    }, []);
    /**
     * Based on use cases, developer might already have added another Provider
     * outside Authenticator. In that case, we sync the two providers by just
     * passing the parent value.
     *
     * TODO(BREAKING): enforce only one provider in App tree
     */ const parentProviderVal = (0, $2hDQc.useContext)((0, $1aaa37dea0f4e3ac$export$2254a7bd02a5abf7));
    const service = (0, $fc31ecaf08cabc55$export$d9e9b060fbbae528)((0, $243fc4ae95ba491e$export$af98f08c6e0e0d4d));
    const value = (0, $2hDQc.useMemo)(()=>!parentProviderVal ? {
            authStatus: authStatus,
            service: service
        } : parentProviderVal, [
        authStatus,
        parentProviderVal,
        service
    ]);
    const { service: activeService } = value;
    (0, $2hDQc.useEffect)(()=>{
        const onSignIn = ()=>{
            setAuthStatus("authenticated");
        };
        const onSignOut = ()=>{
            setAuthStatus("unauthenticated");
        };
        const unsubscribe = (0, $d0948e6cce9dc44c$export$4776c363cae9362c)(activeService, $cf66f8524ccb62e2$var$createHubHandler({
            onSignIn: onSignIn,
            onSignOut: onSignOut
        }));
        return unsubscribe;
    }, [
        activeService
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $1aaa37dea0f4e3ac$export$2254a7bd02a5abf7).Provider, {
        value: value
    }, children);
}


var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");




var $0a3f34f3196a57ae$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0a3f34f3196a57ae$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $0a3f34f3196a57ae$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $0a3f34f3196a57ae$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $0a3f34f3196a57ae$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $0a3f34f3196a57ae$export$2b6ccfda635c9803(service) {
    return service.status !== 0 ? service.getSnapshot() : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function $0a3f34f3196a57ae$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $0a3f34f3196a57ae$export$d36bdfa510afb180(objA, objB) {
    if ($0a3f34f3196a57ae$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$0a3f34f3196a57ae$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $0a3f34f3196a57ae$export$ab21a1e7bed2882e(actor) {
    return "state" in actor && "machine" in actor;
}
function $0a3f34f3196a57ae$export$3496c38320247757(service, prevState, nextState) {
    if (service.status === (0, $19dcc9cc6e75cec4$export$7a567c9c5088a551).NotStarted) return true;
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined && (Object.keys(nextState.children).length > 0 || typeof prevState.changed === "boolean");
    return !(nextState.changed || initialStateChanged);
}


function $c59018547ccbff16$var$identity(a) {
    return a;
}
function $c59018547ccbff16$export$656eb38a7c1ce0b6(actorRef) {
    return "state" in actorRef;
}
function $c59018547ccbff16$var$isDeferredActor(actorRef) {
    return "deferred" in actorRef;
}
function $c59018547ccbff16$var$defaultGetSnapshot(actorRef) {
    return "getSnapshot" in actorRef ? (0, $0a3f34f3196a57ae$export$ab21a1e7bed2882e)(actorRef) ? (0, $0a3f34f3196a57ae$export$2b6ccfda635c9803)(actorRef) : actorRef.getSnapshot() : $c59018547ccbff16$export$656eb38a7c1ce0b6(actorRef) ? actorRef.state : undefined;
}
function $c59018547ccbff16$export$25c4ab29592aabd9(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = $c59018547ccbff16$var$defaultGetSnapshot;
    var actorRefRef = (0, $2hDQc.useRef)(actorRef);
    var deferredEventsRef = (0, $2hDQc.useRef)([]);
    var subscribe = (0, $2hDQc.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, $2hDQc.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var isEqual = (0, $2hDQc.useCallback)(function(prevState, nextState) {
        if ((0, $0a3f34f3196a57ae$export$ab21a1e7bed2882e)(actorRef)) return (0, $0a3f34f3196a57ae$export$3496c38320247757)(actorRef, prevState, nextState);
        return prevState === nextState;
    }, [
        actorRef
    ]);
    var storeSnapshot = (0, $c811d2f6a1db2d2b$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, $c59018547ccbff16$var$identity, isEqual);
    var send = (0, $e55d1c28ea285f8b$export$2e2bcd8739ae039)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if ($c59018547ccbff16$var$isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, $a34e6f08c3b801c5$export$2e2bcd8739ae039)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}



var $f879b07c5eea45e0$var$defaultCompare = function(a, b) {
    return a === b;
};
var $f879b07c5eea45e0$var$defaultGetSnapshot = function(a, initialStateCacheRef) {
    if ((0, $0a3f34f3196a57ae$export$ab21a1e7bed2882e)(a)) {
        // A status of 0 = interpreter not started
        if (a.status === 0 && initialStateCacheRef.current) return initialStateCacheRef.current;
        var snapshot = (0, $0a3f34f3196a57ae$export$2b6ccfda635c9803)(a);
        initialStateCacheRef.current = a.status === 0 ? snapshot : null;
        return snapshot;
    }
    return (0, $c59018547ccbff16$export$656eb38a7c1ce0b6)(a) ? a.state : undefined;
};
function $f879b07c5eea45e0$export$2105062e25df4afe(actor, selector, compare, getSnapshot) {
    if (compare === void 0) compare = $f879b07c5eea45e0$var$defaultCompare;
    var initialStateCacheRef = (0, $2hDQc.useRef)(null);
    var subscribe = (0, $2hDQc.useCallback)(function(handleStoreChange) {
        var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actor
    ]);
    var boundGetSnapshot = (0, $2hDQc.useCallback)(function() {
        if (getSnapshot) return getSnapshot(actor);
        return $f879b07c5eea45e0$var$defaultGetSnapshot(actor, initialStateCacheRef);
    }, [
        actor,
        getSnapshot
    ]);
    var selectedSnapshot = (0, $c811d2f6a1db2d2b$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}


/**
 * This file contains helpers that lets you easily access current actor's state
 * and context.
 */ /**
 * Get the state of current actor. This is useful for checking which screen
 * to render: e.g. `getActorState(state).matches('confirmSignUp.edit').
 */ const $aad66079c52fd2e7$export$99a4282e2c3b772d = (state)=>{
    return state.context.actorRef?.getSnapshot();
};
/**
 * Get the context of current actor. Useful for getting any nested context
 * like remoteError.
 */ const $aad66079c52fd2e7$export$c39505fa2700473f = (state)=>{
    return $aad66079c52fd2e7$export$99a4282e2c3b772d(state)?.context;
};



const $c1a889c09e794dac$export$da6d2f7032b7150b = (state, actorState)=>{
    switch(true){
        case state.matches("idle"):
            return "idle";
        case state.matches("setup"):
            return "setup";
        case state.matches("signOut"):
            return "signOut";
        case state.matches("authenticated"):
            return "authenticated";
        case actorState?.matches("confirmSignUp"):
        case actorState?.matches("confirmSignUp.resendConfirmationCode"):
            return "confirmSignUp";
        case actorState?.matches("confirmSignIn"):
            return "confirmSignIn";
        case actorState?.matches("setupTotp.edit"):
        case actorState?.matches("setupTotp.submit"):
            return "setupTotp";
        case actorState?.matches("signIn"):
            return "signIn";
        case actorState?.matches("signUp"):
            return "signUp";
        case actorState?.matches("forceChangePassword"):
            return "forceNewPassword";
        case actorState?.matches("forgotPassword"):
            return "forgotPassword";
        case actorState?.matches("confirmResetPassword"):
            return "confirmResetPassword";
        case actorState?.matches("selectUserAttributes"):
            return "verifyUser";
        case actorState?.matches("confirmVerifyUserAttribute"):
            return "confirmVerifyUser";
        case state.matches("getCurrentUser"):
        case actorState.matches("fetchUserAttributes"):
            /**
             * This route is needed for autoSignIn to capture both the
             * autoSignIn.pending and the resolved states when the
             * signIn actor is running.
             */ return "transition";
        default:
            console.debug("Cannot infer `route` from Authenticator state:", state.value);
            return null;
    }
};


/**
 * This file contains helpers that translates xstate internals to more
 * understandable authenticator contexts. We provide these contexts with
 * `useAuthenticator` hook/composable/service.
 */ /**
 * Creates public facing auth helpers that abstracts out xstate implementation
 * detail. Each framework implementation can export these helpers so that
 * developers can send events without having to learn internals.
 *
 * ```
 * const [state, send] = useActor(...);
 * const { submit } = getSendEventAliases(send);
 * submit({ username, password})
 * ```
 */ const $04caa321ed2d354a$export$2def2023b76dbf7d = (send)=>{
    const sendToMachine = (type)=>{
        // TODO If these were created during the creation of the machine & provider,
        // then invalid transitions could be caught via https://xstate.js.org/docs/guides/states.html#state-can-event
        return (data)=>send({
                type: type,
                data: data
            });
    };
    return {
        initializeMachine: sendToMachine("INIT"),
        resendCode: sendToMachine("RESEND"),
        signOut: sendToMachine("SIGN_OUT"),
        submitForm: sendToMachine("SUBMIT"),
        updateForm: sendToMachine("CHANGE"),
        updateBlur: sendToMachine("BLUR"),
        // Actions that don't immediately invoke a service but instead transition to a screen
        // are prefixed with `to*`
        toFederatedSignIn: sendToMachine("FEDERATED_SIGN_IN"),
        toForgotPassword: sendToMachine("FORGOT_PASSWORD"),
        toSignIn: sendToMachine("SIGN_IN"),
        toSignUp: sendToMachine("SIGN_UP"),
        skipVerification: sendToMachine("SKIP")
    };
};
const $04caa321ed2d354a$var$getNextSendEventAliases = (send)=>{
    const { toFederatedSignIn: toFederatedSignIn, submitForm: submitForm, resendCode: resendCode, skipVerification: skipVerification } = $04caa321ed2d354a$export$2def2023b76dbf7d(send);
    return {
        handleSubmit: submitForm,
        resendConfirmationCode: resendCode,
        // manual "route" navigation
        setRoute: (route)=>send({
                type: (0, $1501912d3aedff2e$export$7ccc20c5f9bc8a70)[route]
            }),
        skipAttributeVerification: skipVerification,
        toFederatedSignIn: toFederatedSignIn
    };
};
const $04caa321ed2d354a$export$e6da373757d26435 = (state)=>{
    const actorContext = (0, $aad66079c52fd2e7$export$c39505fa2700473f)(state) ?? {};
    const { challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails, remoteError: error, validationError: validationErrors, totpSecretCode: totpSecretCode = null, unverifiedUserAttributes: unverifiedUserAttributes, username: username } = actorContext;
    const { socialProviders: socialProviders = [] } = state.context?.config ?? {};
    // check for user in actorContext prior to state context. actorContext is more "up to date",
    // but is not available on all states
    const user = actorContext?.user ?? state.context?.user;
    const hasValidationErrors = !!(validationErrors && Object.keys(validationErrors).length > 0);
    const actorState = (0, $aad66079c52fd2e7$export$99a4282e2c3b772d)(state);
    const isPending = state.hasTag("pending") || actorState?.hasTag("pending");
    const route = (0, $c1a889c09e794dac$export$da6d2f7032b7150b)(state, actorState);
    // Auth status represents the current state of the auth flow
    // The `configuring` state is used to indicate when the xState machine is loading
    const authStatus = ((route)=>{
        switch(route){
            case "idle":
            case "setup":
                return "configuring";
            case "authenticated":
                return "authenticated";
            default:
                return "unauthenticated";
        }
    })(route);
    const facade = {
        authStatus: authStatus,
        challengeName: challengeName,
        codeDeliveryDetails: codeDeliveryDetails,
        error: error,
        hasValidationErrors: hasValidationErrors,
        isPending: isPending,
        route: route,
        socialProviders: socialProviders,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        user: user,
        username: username,
        validationErrors: validationErrors
    };
    return facade;
};
const $04caa321ed2d354a$export$198a1c4c61f42650 = (state)=>{
    const actorContext = (0, $aad66079c52fd2e7$export$c39505fa2700473f)(state) ?? {};
    const { challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails, remoteError: errorMessage, totpSecretCode: totpSecretCode, unverifiedUserAttributes: unverifiedUserAttributes, username: username } = actorContext;
    const { socialProviders: federatedProviders, loginMechanisms: loginMechanisms } = state.context?.config ?? {};
    const loginMechanism = loginMechanisms?.[0];
    const actorState = (0, $aad66079c52fd2e7$export$99a4282e2c3b772d)(state);
    const isPending = state.hasTag("pending") || actorState?.hasTag("pending");
    // @todo-migration remove this cast for Authenticator.Next
    const route = (0, $c1a889c09e794dac$export$da6d2f7032b7150b)(state, actorState);
    return {
        challengeName: challengeName,
        codeDeliveryDetails: codeDeliveryDetails,
        errorMessage: errorMessage,
        federatedProviders: federatedProviders,
        isPending: isPending,
        loginMechanism: loginMechanism,
        route: route,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        username: username
    };
};
const $04caa321ed2d354a$export$5f925d5954b1c10b = ({ send: send, state: state })=>{
    const sendEventAliases = $04caa321ed2d354a$export$2def2023b76dbf7d(send);
    const serviceContext = $04caa321ed2d354a$export$e6da373757d26435(state);
    return {
        ...sendEventAliases,
        ...serviceContext
    };
};
const $04caa321ed2d354a$export$d158c470c375eb4d = ({ send: send, state: state })=>({
        ...$04caa321ed2d354a$var$getNextSendEventAliases(send),
        ...$04caa321ed2d354a$export$198a1c4c61f42650(state)
    });




const $e0dd8c84067ac3c1$export$7e92b2e9f0809b11 = "`useAuthenticator` must be used inside an `Authenticator.Provider`.";



/** Array of auth fields that we supply defaults with */ const $42b64a22da585343$export$43a753047a354e27 = [
    "birthdate",
    "email",
    "family_name",
    "given_name",
    "middle_name",
    "name",
    "nickname",
    "phone_number",
    "preferred_username",
    "profile",
    "website"
];
/** Array of auth fields that we do not supply defaults with */ const $42b64a22da585343$export$a263a0ca54f86170 = [
    "address",
    "gender",
    "locale",
    "picture",
    "updated_at",
    "zoneinfo"
];
/** Array of known login mechanisms */ const $42b64a22da585343$export$c3f13f1789f7946b = [
    "username",
    "email",
    "phone_number"
];
const $42b64a22da585343$export$ee5f111526f572af = [
    ...$42b64a22da585343$export$c3f13f1789f7946b,
    ...$42b64a22da585343$export$43a753047a354e27,
    "confirmation_code",
    "password",
    "confirm_password"
];
const $42b64a22da585343$export$fed672849e2dd0ad = (field)=>{
    return $42b64a22da585343$export$ee5f111526f572af.includes(field);
};








const $69e267558438992b$export$e29bbbec84471f66 = (event)=>{
    const formData = new FormData(event.target);
    return Object.fromEntries(formData);
};
const $69e267558438992b$export$b5859dd113079414 = (formOverrides, fieldNames)=>{
    let orderedKeys = [];
    if (formOverrides) orderedKeys = Object.keys(formOverrides).reduce((prev, key)=>{
        // reduce to array that can be sorted
        prev.push([
            key,
            formOverrides[key]?.order
        ]);
        return prev;
    }, []).sort((a, b)=>//sort them based on order
        a[1] - b[1]) // returned just key
    .filter((a)=>a[1] !== undefined).map((a)=>a[0]);
    // remove duplicates
    return Array.from(new Set([
        ...orderedKeys,
        ...fieldNames
    ]));
};
const $69e267558438992b$export$3237178b1c616b9f = (field)=>{
    return (0, $42b64a22da585343$export$ee5f111526f572af).includes(field);
};
const $69e267558438992b$var$isArray = (val)=>{
    return Array.isArray(val);
};
const $69e267558438992b$export$501239432719417d = (errors)=>{
    if (!errors) return null;
    if ($69e267558438992b$var$isArray(errors)) return errors;
    else return [
        errors
    ];
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cf0ec994dcf63358$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("I18n");
/**
 * Language translation utility.
 */ let $cf0ec994dcf63358$export$dbe3113d60765c1a = class I18n {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ constructor(){
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
    }
    /**
     * Sets the default language from the configuration when required.
     */ setDefaultLanguage() {
        // Default to window language if not set in instance
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $cf0ec994dcf63358$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ setLanguage(lang) {
        this._lang = lang;
    }
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ get(key, defVal) {
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        const lang = this._lang;
        let val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    }
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ getByLanguage(key, language, defVal = null) {
        if (!language) return defVal;
        const lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ putVocabulariesForLanguage(language, vocabularies) {
        let lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = {
            ...lang_dict,
            ...vocabularies
        };
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ putVocabularies(vocabularies) {
        Object.keys(vocabularies).map((key)=>{
            this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    }
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $df81a1f253225487$export$6cc46f5977c4544e;
(function(I18nErrorCode) {
    I18nErrorCode["NotConfigured"] = "NotConfigured";
})($df81a1f253225487$export$6cc46f5977c4544e || ($df81a1f253225487$export$6cc46f5977c4544e = {}));
const $df81a1f253225487$var$i18nErrorMap = {
    [$df81a1f253225487$export$6cc46f5977c4544e.NotConfigured]: {
        message: "i18n is not configured."
    }
};
const $df81a1f253225487$export$a7a9523472993e97 = (0, $c683ae836e700a37$export$5cb8fc27ccbe9d40)($df81a1f253225487$var$i18nErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2ffc6dafd8dc611a$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("I18n");
let $2ffc6dafd8dc611a$var$_config = {
    language: null
};
let $2ffc6dafd8dc611a$var$_i18n = null;
/**
 * Export I18n APIs
 */ class $2ffc6dafd8dc611a$export$dbe3113d60765c1a {
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ static configure(config) {
        $2ffc6dafd8dc611a$var$logger.debug("configure I18n");
        if (!config) return $2ffc6dafd8dc611a$var$_config;
        $2ffc6dafd8dc611a$var$_config = Object.assign({}, $2ffc6dafd8dc611a$var$_config, config.I18n || config);
        $2ffc6dafd8dc611a$export$dbe3113d60765c1a.createInstance();
        return $2ffc6dafd8dc611a$var$_config;
    }
    static getModuleName() {
        return "I18n";
    }
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ static createInstance() {
        $2ffc6dafd8dc611a$var$logger.debug("create I18n instance");
        if ($2ffc6dafd8dc611a$var$_i18n) return;
        $2ffc6dafd8dc611a$var$_i18n = new (0, $cf0ec994dcf63358$export$dbe3113d60765c1a)();
    }
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ static setLanguage(lang) {
        $2ffc6dafd8dc611a$export$dbe3113d60765c1a.checkConfig();
        (0, $df81a1f253225487$export$a7a9523472993e97)(!!$2ffc6dafd8dc611a$var$_i18n, (0, $df81a1f253225487$export$6cc46f5977c4544e).NotConfigured);
        return $2ffc6dafd8dc611a$var$_i18n.setLanguage(lang);
    }
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ static get(key, defVal) {
        if (!$2ffc6dafd8dc611a$export$dbe3113d60765c1a.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        (0, $df81a1f253225487$export$a7a9523472993e97)(!!$2ffc6dafd8dc611a$var$_i18n, (0, $df81a1f253225487$export$6cc46f5977c4544e).NotConfigured);
        return $2ffc6dafd8dc611a$var$_i18n.get(key, defVal);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ static putVocabulariesForLanguage(language, vocabularies) {
        $2ffc6dafd8dc611a$export$dbe3113d60765c1a.checkConfig();
        (0, $df81a1f253225487$export$a7a9523472993e97)(!!$2ffc6dafd8dc611a$var$_i18n, (0, $df81a1f253225487$export$6cc46f5977c4544e).NotConfigured);
        return $2ffc6dafd8dc611a$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ static putVocabularies(vocabularies) {
        $2ffc6dafd8dc611a$export$dbe3113d60765c1a.checkConfig();
        (0, $df81a1f253225487$export$a7a9523472993e97)(!!$2ffc6dafd8dc611a$var$_i18n, (0, $df81a1f253225487$export$6cc46f5977c4544e).NotConfigured);
        return $2ffc6dafd8dc611a$var$_i18n.putVocabularies(vocabularies);
    }
    static checkConfig() {
        if (!$2ffc6dafd8dc611a$var$_i18n) $2ffc6dafd8dc611a$export$dbe3113d60765c1a.createInstance();
        return true;
    }
}
// Create an instance of I18n in the static class
$2ffc6dafd8dc611a$export$dbe3113d60765c1a.createInstance();


const $5c565350bf72d6f8$export$cca4a41bdb910c51 = {
    "Account recovery requires verified contact information": "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
    "Back to Sign In": "Zur\xfcck zur Anmeldung",
    "Change Password": "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: "Code",
    "Confirm Password": "Passwort best\xe4tigen",
    "Please confirm your Password": "Bitte best\xe4tigen Sie Ihr Passwort",
    "Confirm Sign Up": "Registrierung best\xe4tigen",
    "Confirm SMS Code": "SMS-Code best\xe4tigen",
    "Confirm TOTP Code": "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    "Confirmation Code": "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    "Create a new account": "Einen neuen Account erstellen",
    "Create Account": "Account erstellen",
    "Creating Account": "Account wird erstellt",
    "Dismiss alert": "Warnung verwerfen",
    Email: "Email",
    "Enter your code": "Geben Sie Ihren Code ein",
    "Enter your Email": "Geben Sie Ihre E-Mail ein",
    "Enter your phone number": "Geben Sie Ihre Telefonnummer ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot your password?": "Passwort vergessen? ",
    "Hide password": "Passwort verbergen",
    "It may take a minute to arrive": "Es kann eine Minute dauern, bis er ankommt",
    Loading: "Wird geladen",
    "New password": "Neues Passwort",
    or: "oder",
    Password: "Passwort",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Code erneut senden",
    "Reset your Password": "Zur\xfccksetzen des Passwort",
    "Reset your password": "Zur\xfccksetzen des passwort",
    "Send code": "Code senden",
    "Send Code": "Code senden",
    Sending: "Wird gesendet",
    "Setup TOTP": "TOTP einrichten",
    "Show password": "Passwort anzeigen",
    "Sign in to your account": "Melden Sie sich mit Ihrem Account an",
    "Sign In with Amazon": "Mit Amazon anmelden",
    "Sign In with Apple": "Mit Apple anmelden",
    "Sign In with Facebook": "Mit Facebook anmelden",
    "Sign In with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Sign In": "Anmelden",
    "Signing in": "Wird angemeldet",
    Skip: "\xdcberspringen",
    Submit: "Abschicken",
    Submitting: "Wird gesendet",
    Username: "Benutzername",
    "Verify Contact": "Kontakt verifizieren",
    Verify: "Verifizieren",
    "We Sent A Code": "Wir haben einen Code gesendet",
    "We Texted You": "Wir haben Ihnen eine SMS gesendet",
    "Your code is on the way. To log in, enter the code we sent you": "Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.",
    "Confirm a Code": "Code best\xe4tigen",
    "Confirm Sign In": "Anmeldung best\xe4tigen",
    "Create account": "Hier registrieren",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Enter your Password": "Geben Sie Ihr Passwort ein",
    "Sign Up with Facebook": "Mit Facebook registrieren",
    "Sign Up with Google": "Mit Google registrieren",
    "Forgot Password": "Passwort vergessen",
    "Have an account? ": "Schon registriert? ",
    "Incorrect username or password": "Falscher Benutzername oder falsches Passwort",
    "Invalid password format": "Ung\xfcltiges Passwort-Format",
    "Invalid phone number format": `Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900`,
    "It may take a minute to arrive.": "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    "Lost your code? ": "Code verloren? ",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Account? ",
    "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
    "Reset password": "Passwort zur\xfccksetzen",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrieren",
    "User already exists": "Dieser Benutzer existiert bereits",
    "User does not exist": "Dieser Benutzer existiert nicht",
    "Username cannot be empty": "Benutzername darf nicht leer sein",
    "We Emailed You": "Email wurde versendet",
    "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an",
    "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an"
};


const $00974024e2418748$export$eb91f595f110d703 = {
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "Add your Profile": "Add your Profile",
    "Add your Website": "Add your Website",
    "Back to Sign In": "Back to Sign In",
    "Change Password": "Change Password",
    Changing: "Changing",
    Code: "Code",
    "Confirm Password": "Confirm Password",
    "Confirm Sign Up": "Confirm Sign Up",
    "Confirm SMS Code": "Confirm SMS Code",
    "Confirm TOTP Code": "Confirm TOTP Code",
    Confirm: "Confirm",
    "Confirmation Code": "Confirmation Code",
    Confirming: "Confirming",
    "Create a new account": "Create a new account",
    "Create Account": "Create Account",
    "Creating Account": "Creating Account",
    "Dismiss alert": "Dismiss alert",
    Email: "Email",
    "Enter your Birthdate": "Enter your Birthdate",
    "Enter your code": "Enter your code",
    "Enter your Confirmation Code": "Enter your Confirmation Code",
    "Enter your Email": "Enter your Email",
    "Enter your Family Name": "Enter your Family Name",
    "Enter your Given Name": "Enter your Given Name",
    "Enter your Middle Name": "Enter your Middle Name",
    "Enter your Name": "Enter your Name",
    "Enter your Nickname": "Enter your Nickname",
    "Enter your Password": "Enter your Password",
    "Enter your phone number": "Enter your phone number",
    "Enter your Preferred Username": "Enter your Preferred Username",
    "Enter your username": "Enter your username",
    "Forgot password?": "Forgot password?",
    "Forgot your password?": "Forgot your password?",
    "Hide password": "Hide password",
    "It may take a minute to arrive": "It may take a minute to arrive",
    Loading: "Loading",
    "New password": "New password",
    or: "or",
    Password: "Password",
    "Phone Number": "Phone Number",
    "Please confirm your Password": "Please confirm your Password",
    "Resend Code": "Resend Code",
    "Reset your password": "Reset your password",
    "Reset your Password": "Reset your Password",
    "Send code": "Send code",
    "Send Code": "Send Code",
    Sending: "Sending",
    "Setup TOTP": "Setup TOTP",
    "Show password": "Show password",
    "Sign in to your account": "Sign in to your account",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "Sign in",
    "Sign In": "Sign In",
    "Signing in": "Signing in",
    Skip: "Skip",
    Submit: "Submit",
    Submitting: "Submitting",
    Username: "Username",
    "Verify Contact": "Verify Contact",
    Verify: "Verify",
    "We Emailed You": "We Emailed You",
    "We Sent A Code": "We Sent A Code",
    "We Texted You": "We Texted You",
    "Your code is on the way. To log in, enter the code we emailed to": "Your code is on the way. To log in, enter the code we emailed to",
    "Your code is on the way. To log in, enter the code we sent you": "Your code is on the way. To log in, enter the code we sent you",
    "Your code is on the way. To log in, enter the code we texted to": "Your code is on the way. To log in, enter the code we texted to"
};


const $f4d288d142e27756$export$1d204a99f5862ba9 = {
    "Account recovery requires verified contact information": "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    "Back to Sign In": "Volver a inicio de sesi\xf3n",
    "Change Password": "Cambiar contrase\xf1a",
    Changing: "Cambiando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirmar contrase\xf1a",
    "Confirm Sign Up": "Confirmar registro",
    "Confirm SMS Code": "Confirmar el c\xf3digo de SMS",
    "Confirm TOTP Code": "Confirmar c\xf3digo TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "C\xf3digo de confirmaci\xf3n",
    Confirming: "Confirmando",
    "Create a new account": "Crear una cuenta nueva",
    "Create Account": "Crear cuenta",
    "Creating Account": "Creando cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Email",
    "Enter your code": "Ingrese el c\xf3digo",
    "Enter your Email": "Escriba su Email",
    "Enter your Password": "Escriba su Contrase\xf1a",
    "Enter your phone number": "Ingrese el n\xfamero de tel\xe9fono",
    "Enter your username": "Ingrese el nombre de usuario",
    "Forgot your password?": "\xbfOlvid\xf3 su contrase\xf1a?",
    "Hide password": "Ocultar contrase\xf1a",
    "It may take a minute to arrive": "Es posible que tarde un minuto en llegar",
    Loading: "Cargando",
    "New password": "Nueva contrase\xf1a",
    or: "o",
    Password: "Contrase\xf1a",
    "Phone Number": "N\xfamero de tel\xe9fono",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Restablecer su contrase\xf1a",
    "Reset your Password": "Restablecer su Contrase\xf1a",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contrase\xf1a",
    "Sign in to your account": "Iniciar sesi\xf3n en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesi\xf3n con Amazon",
    "Sign In with Apple": "Iniciar Sesi\xf3n con Apple",
    "Sign In with Facebook": "Iniciar Sesi\xf3n con Facebook",
    "Sign In with Google": "Iniciar Sesi\xf3n con Google",
    "Sign in": "Iniciar sesi\xf3n",
    "Sign In": "Iniciar Sesi\xf3n",
    "Signing in": "Iniciando sesi\xf3n",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de usuario",
    "Verify Contact": "Verificar contacto",
    Verify: "Verificar",
    "We Emailed You": "Le hemos enviado un correo electr\xf3nico",
    "We Sent A Code": "Hemos enviado un c\xf3digo",
    "We Texted You": "Le hemos enviado un mensaje de texto",
    "Your code is on the way. To log in, enter the code we emailed to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por correo electr\xf3nico a",
    "Your code is on the way. To log in, enter the code we sent you": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que le hemos enviado",
    "Your code is on the way. To log in, enter the code we texted to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por mensaje de texto a",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.",
    "Confirm a Code": "Confirmar un c\xf3digo",
    "Confirm Sign In": "Confirmar inicio de sesi\xf3n",
    "Forgot Password": "Olvid\xe9 mi contrase\xf1a",
    "Incorrect username or password.": "Nombre de usuario o contrase\xf1a incorrecta",
    "Invalid password format": "Formato de contrase\xf1a inv\xe1lido",
    "Invalid phone number format": "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    "Loading...": "Cargando...",
    "New Password": "Nueva contrase\xf1a",
    "Resend a Code": "Reenviar un c\xf3digo",
    "Sign Out": "Cerrar sesi\xf3n",
    "Sign Up with Amazon": "Crear cuenta con Amazon",
    "Sign Up with Apple": "Crear cuenta con Apple",
    "Sign Up with Facebook": "Crear cuenta con Facebook",
    "Sign Up with Google": "Crear cuenta con Google",
    "Sign Up": "Crear cuenta",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "Username cannot be empty": "El nombre de usuario no puede estar vac\xedo",
    "Your passwords must match": "Las contrase\xf1as deben coincidir"
};


const $f152c73e6c904413$export$8cfa91bfcf8d11c8 = {
    "Account recovery requires verified contact information": "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    "Back to Sign In": "Retour \xe0 la connexion",
    "Change Password": "Modifier le mot de passe",
    Changing: "Modification en cours",
    Code: "Code",
    "Confirm Password": "Confirmez le mot de passe",
    "Confirm Sign Up": "Confirmer l'inscription",
    "Confirm SMS Code": "Confirmer le code SMS",
    "Confirm TOTP Code": "Confirmer le code TOTP",
    Confirm: "Confirmer",
    "Confirmation Code": "Code de confirmation",
    Confirming: "Confirmation",
    "Create a new account": "Cr\xe9er un nouveau compte",
    "Create Account": "Cr\xe9er un compte",
    "Creating Account": `Cr\xe9ation d'un compte`,
    "Dismiss alert": `Supprimer l'alerte`,
    Email: "Email",
    "Enter your code": "Saisissez cotre code de confirmation",
    "Enter your Email": "Saisissez votre adresse email",
    "Enter your phone number": "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    "Enter your username": "Saisissez votre nom d'utilisateur",
    "Forgot your password?": "Mot de passe oubli\xe9 ? ",
    "Hide password": "Masquer le mot de passe",
    "It may take a minute to arrive": "Cela peut prendre une minute",
    Loading: "Chargement en cours",
    "New password": "Nouveau mot de passe",
    or: "ou",
    Password: "Mot de passe",
    "Phone Number": "Num\xe9ro de t\xe9l\xe9phone",
    "Resend Code": "Renvoyer le code",
    "Reset your Password": "R\xe9initialiser votre mot de passe",
    "Reset your password": "R\xe9initialisez votre mot de passe",
    "Send code": "Envoyer le code",
    "Send Code": "M'envoyer un code",
    Sending: "Envoi en cours",
    "Setup TOTP": "Configuration de TOTP",
    "Show password": "Afficher le mot de passe",
    "Sign in to your account": "Connexion \xe0 votre compte",
    "Sign In with Amazon": "Se connecter avec Amazon",
    "Sign In with Apple": "Se connecter avec Apple",
    "Sign In with Facebook": "Se connecter avec Facebook",
    "Sign In with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Sign In": "Se connecter",
    "Signing in": "Connexion en cours",
    Skip: "Passer",
    Submit: "Soumettre",
    Submitting: "Envoi en cours",
    Username: "Nom d'utilisateur",
    "Verify Contact": "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    "We Sent A Code": "Nous avons envoy\xe9 un code",
    "We Texted You": "Nous vous avons envoy\xe9 un SMS",
    "Your code is on the way. To log in, enter the code we sent you": `Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoy\xe9`,
    // Additional translations provided by customers
    "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Change: "Modifier",
    "Confirm a Code": "Confirmer un code",
    "Confirm Sign In": "Confirmer la connexion",
    "Create account": "Cr\xe9er un compte",
    "Enter your password": "Saisissez votre mot de passe",
    "Forgot Password": "Mot de passe oubli\xe9",
    "Have an account? ": "D\xe9j\xe0 un compte ? ",
    Hello: "Bonjour",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid password format": "Format de mot de passe invalide",
    "Invalid phone number format": `Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900`,
    "Loading...": "Chargement...",
    "Lost your code? ": "Vous avez perdu votre code ? ",
    "Network error": "Erreur r\xe9seau",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ? ",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "R\xe9initialisez votre mot de passe",
    Send: "Envoyer",
    "Sign In with AWS": "Se connecter avec AWS",
    "Sign Out": "D\xe9connexion",
    "Sign Up": "S'inscrire",
    SMS: "SMS",
    "User already exists": "L'utilisateur existe d\xe9j\xe0",
    "User does not exist": "L'utilisateur n'existe pas",
    "Username cannot be empty": "Le nom d'utilisateur doit \xeatre renseign\xe9",
    "Username/client id combination not found.": "L'utilisateur n'existe pas",
    "We Emailed You": "Nous vous avons envoy\xe9 un code",
    "Your code is on the way. To log in, enter the code we emailed to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur cette adresse email",
    "Your code is on the way. To log in, enter the code we texted to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur ce num\xe9ro de t\xe9l\xe9phone",
    "Your passwords must match": "Vos mots de passe doivent \xeatre identiques",
    "It may take a minute to arrive.": "Cela peut prendre quelques minutes."
};


const $76d8995cf1391512$export$5c8da73de176fccc = {
    "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate",
    "Back to Sign In": "Torna alla schermata di accesso",
    "Change Password": "Cambia la password",
    Changing: "Modifica in corso",
    Code: "Codice",
    "Confirm Password": "Conferma la password",
    "Confirm Sign Up": "Conferma registrazione",
    "Confirm SMS Code": "Conferma codice SMS",
    "Confirm TOTP Code": "Conferma codice TOTP",
    Confirm: "Conferma",
    "Confirmation Code": "Codice di verifica",
    Confirming: "Conferma in corso",
    "Create a new account": "Crea un nuovo account",
    "Create Account": "Crea Account",
    "Creating Account": "Creazione account in corso",
    "Dismiss alert": `Ignora l'avviso`,
    Email: "Email",
    "Enter your code": "Inserisci il tuo codice",
    "Enter your Email": "Inserisci la tua e-mail",
    "Enter your phone number": 'Inserisci il tuo numero di telefono"',
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot your password?": "Password dimenticata?",
    "Hide password": "Nascondi password",
    "It may take a minute to arrive": "L'arrivo potrebbe richiedere qualche minuto",
    Loading: "Caricamento in corso",
    "New password": "Nuova password",
    or: "oppure",
    Password: "Password",
    "Phone Number": "Numero di telefono",
    "Resend Code": "Invia nuovamente il codice",
    "Reset your Password": "Reimposta la tua Password",
    "Reset your password": "Reimposta la tua password",
    "Send code": "Invia codice",
    "Send Code": "Invia codice",
    Sending: "Invio in corso",
    "Setup TOTP": "Configura TOTP",
    "Show password": "Mostra password",
    "Sign in to your account": "Accedi al tuo account",
    "Sign In with Amazon": "Accedi con Amazon",
    "Sign In with Apple": "Accedi con Apple",
    "Sign In with Facebook": "Accedi con Facebook",
    "Sign In with Google": "Accedi con Google",
    "Sign in": "Accedi",
    "Sign In": "Accedi",
    "Signing in": "Accesso in corso",
    Skip: "Salta",
    Submit: "Invia",
    Submitting: "Invio in corso",
    Username: "Nome utente",
    "Verify Contact": "Verifica contatto",
    Verify: "Verifica",
    "We Emailed You": "Ti abbiamo inviato un'e-mail",
    "We Sent A Code": "Ti abbiamo inviato un codice",
    "We Texted You": "Ti abbiamo inviato un SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Il codice \xe8 in arrivo. Per effettuare l'accesso, immetti il codice che ti abbiamo inviato via e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che ti abbiamo inviato",
    "Your code is on the way. To log in, enter the code we texted to": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che abbiamo inviato tramite SMS",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    "Confirm a Code": "Conferma un codice",
    "Confirm Sign In": "Conferma l'accesso",
    "Create account": "Crea account",
    "Enter your password": "Inserisci la tua password",
    "Forgot Password?": "Password dimenticata?",
    "Have an account? ": "Gi\xe0 registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Formato del numero di telefono non valido",
    "Lost your code?": "Codice smarrito?",
    "New Password": "Nuova password",
    "No account? ": "Non hai un account?",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    "Reset password": "Reimposta password",
    "Sign Out": "Esci",
    "Sign Up": "Registrati",
    "User already exists": "Utente gi\xe0 esistente",
    "User does not exist": "Utente inesistente",
    "Username cannot be empty": "Il nome utente non pu\xf2 essere vuoto"
};


const $aa6d21b28870bac3$export$c416809cd76fbf21 = {
    "Account recovery requires verified contact information": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
    "Back to Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
    "Change Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
    Changing: "\u5909\u66F4\u4E2D",
    Code: "\u30B3\u30FC\u30C9",
    "Confirm Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
    "Confirm Sign Up": "\u767B\u9332\u3059\u308B",
    "Confirm SMS Code": "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm TOTP Code": "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    Confirm: "\u78BA\u5B9A",
    "Confirmation Code": "\u78BA\u8A8D\u30B3\u30FC\u30C9",
    Confirming: "\u78BA\u8A8D\u4E2D",
    "Create a new account": "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Create Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Creating Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D",
    "Dismiss alert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B",
    Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    "Enter your code": "\u30B3\u30FC\u30C9\u3092\u5165\u529B",
    "Enter your Email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
    "Enter your phone number": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B",
    "Enter your username": "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    "Forgot your password?": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
    "Hide password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A",
    "It may take a minute to arrive": "\u5230\u7740\u3059\u308B\u307E\u3067\u306B 1 \u5206\u304B\u304B\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002",
    Loading: "\u30ED\u30FC\u30C9\u4E2D",
    "New password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    or: "\u53C8\u306F",
    Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
    "Phone Number": "\u96FB\u8A71\u756A\u53F7",
    "Resend Code": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
    "Reset your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Reset your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
    "Send code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    "Send Code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    Sending: "\u9001\u4FE1\u4E2D",
    "Setup TOTP": "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    "Show password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
    "Sign in to your account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign In with Amazon": "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Apple": "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Facebook": "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Google": "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign in": "\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Signing in": "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D",
    Skip: "\u30B9\u30AD\u30C3\u30D7",
    Submit: "\u9001\u4FE1",
    Submitting: "\u9001\u4FE1\u4E2D",
    Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
    "Verify Contact": "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
    Verify: "\u78BA\u8A8D",
    "We Sent A Code": "\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    "We Texted You": "\u30C6\u30AD\u30B9\u30C8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we sent you": "\u30B3\u30FC\u30C9\u304C\u9014\u4E2D\u3067\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u9001\u4FE1\u3057\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    // Additional translations provided by customers
    "An account with the given email already exists.": "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
    "Confirm a Code": "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
    "Create account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
    "Enter your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
    "Enter your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    "Please confirm your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    "Forgot Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
    "Have an account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
    "Incorrect username or password": "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    "Invalid password format": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
    "Invalid phone number format": "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    "It may take a minute to arrive.": "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "Lost your code? ": "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
    "New Password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    "No account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
    "Password attempts exceeded": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
    "Reset password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
    "Reset Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Sign Out": "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
    "Sign Up": "\u767B\u9332 ",
    "User already exists": "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
    "User does not exist": "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
    "Username cannot be empty": "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
    "We Emailed You": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:",
    "Your code is on the way. To log in, enter the code we texted to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:"
};


const $2ca5a301c1e61034$export$fb1930c2b96707b2 = {
    "Account recovery requires verified contact information": "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    "Back to Sign In": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    "Change Password": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30",
    Changing: "\uBCC0\uACBD\uC911",
    Code: "\uCF54\uB4DC",
    "Confirm Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778",
    "Confirm Sign Up": "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778",
    "Confirm SMS Code": "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778",
    "Confirm TOTP Code": "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778",
    Confirm: "\uD655\uC778",
    "Confirmation Code": "\uC778\uC99D\uBC88\uD638",
    Confirming: "\uD655\uC778\uC911",
    "Create a new account": "\uD68C\uC6D0\uAC00\uC785",
    "Create Account": "\uD68C\uC6D0\uAC00\uC785",
    "Creating Account": "\uD68C\uC6D0\uAC00\uC785\uC911",
    "Dismiss alert": "\uC54C\uB9BC \uBB34\uC2DC",
    Email: "\uC774\uBA54\uC77C",
    "Enter your code": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Enter your Email": "\uC774\uBA54\uC77C \uC785\uB825",
    "Enter your phone number": "\uC804\uD654\uBC88\uD638 \uC785\uB825",
    "Enter your username": "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Hide password": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
    "It may take a minute to arrive": "\uB3C4\uCC29\uD558\uB294 \uB370 1\uBD84 \uC815\uB3C4 \uAC78\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    Loading: "\uB85C\uB529\uC911",
    "New password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
    or: "\uB610\uB294",
    Password: "\uBE44\uBC00\uBC88\uD638",
    "Phone Number": "\uC804\uD654\uBC88\uD638",
    "Resend Code": "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1",
    "Reset your password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Reset your Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Send code": "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30",
    "Send Code": "\uCF54\uB4DC \uC804\uC1A1",
    Sending: "\uC804\uC1A1\uC911",
    "Setup TOTP": "TOTP \uC124\uC815\uD558\uAE30",
    "Show password": "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30",
    "Sign in to your account": "\uB85C\uADF8\uC778",
    "Sign In with Amazon": "Amazon \uB85C\uADF8\uC778",
    "Sign In with Apple": "Apple \uB85C\uADF8\uC778",
    "Sign In with Facebook": "Facebook \uB85C\uADF8\uC778",
    "Sign In with Google": "Google \uB85C\uADF8\uC778",
    "Sign in": "\uB85C\uADF8\uC778",
    "Sign In": "\uB85C\uADF8\uC778",
    "Signing in": "\uB85C\uADF8\uC778\uC911",
    Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
    Submit: "\uD655\uC778",
    Submitting: "\uD655\uC778\uC911",
    Username: "\uC544\uC774\uB514",
    "Verify Contact": "\uC5F0\uB77D\uCC98 \uD655\uC778",
    Verify: "\uC778\uC99D",
    "We Emailed You": "\uC774\uBA54\uC77C\uC744 \uBCF4\uB0C4",
    "We Sent A Code": "\uCF54\uB4DC\uB97C \uBCF4\uB0C4",
    "We Texted You": "\uBB38\uC790 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0C4",
    "Your code is on the way. To log in, enter the code we emailed to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    "Your code is on the way. To log in, enter the code we sent you": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    "Your code is on the way. To log in, enter the code we texted to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uBB38\uC790 \uBA54\uC2DC\uC9C0\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    // Additional translations provided by customers
    Birthdate: "\uC0DD\uB144\uC6D4\uC77C",
    "Family Name": "\uC131",
    "Forgot your password?": "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    "Given Name": "\uC774\uB984",
    Name: "\uC131\uD568",
    Nickname: "\uB2C9\uB124\uC784",
    "Preferred Username": "\uB2C9\uB124\uC784",
    Profile: "\uD504\uB85C\uD544",
    "Reset Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    Website: "\uC6F9\uC0AC\uC774\uD2B8"
};


const $8c366918d19dfaa7$export$c27bce1749452052 = {
    "Account recovery requires verified contact information": "Gjenoppretting av konto krever verifisert kontaktinformajson",
    "Add your Profile": "Legg til profilen din",
    "Add your Website": "Legg til nettsiden din",
    "Back to Sign In": "Tilbake til innlogging",
    "Change Password": "Bytt passord",
    Changing: "Endre",
    Code: "Kode",
    "Confirm Password": "Bekreft passordet",
    "Confirm Sign Up": "Bekreft registrering",
    "Confirm SMS Code": "Bekreft SMS-kode",
    "Confirm TOTP Code": "Bekreft TOTP-kode",
    Confirm: "Bekreft",
    "Confirmation Code": "Bekreftelseskode",
    Confirming: "Bekrefter",
    "Create a new account": "Opprett en ny konto",
    "Create Account": "Opprett konto",
    "Creating Account": "Oppretter konto",
    "Dismiss alert": "Avvis varsel",
    Email: "E-post",
    "Enter your Birthdate": "Skriv inn f\xf8dselsdatoen din",
    "Enter your code": "Skriv inn koden din",
    "Enter your Confirmation Code": "Skriv inn bekreftelseskoden din",
    "Enter your Email": "Skriv inn e-postadressen din",
    "Enter your Family Name": "Skriv inn etternavnet ditt",
    "Enter your Given Name": "Skriv inn fornavnet ditt",
    "Enter your Middle Name": "Skriv inn mellomnavnet ditt",
    "Enter your Name": "Skriv inn navnet ditt",
    "Enter your Nickname": "Skriv inn kallenavnet ditt",
    "Enter your Password": "Skriv inn passordet ditt",
    "Enter your phone number": "Skriv inn telefonnummeret ditt",
    "Enter your Preferred Username": "Skriv inn det foretrukne brukernavnet ditt",
    "Enter your username": "Skriv inn brukernavnet ditt",
    "Forgot password?": "Glemt passord?",
    "Forgot your password?": "Glemt passordet ditt?",
    "Hide password": "Skjul passordet",
    "It may take a minute to arrive": "Det kan ta et minutt for \xe5 komme frem",
    Loading: "Laster inn",
    "New password": "Nytt passord",
    or: "eller",
    Password: "Passord",
    "Phone Number": "Telefonnummer",
    "Please confirm your Password": "Vennligst bekreft passordet ditt",
    "Resend Code": "Send koden p\xe5 nytt",
    "Reset your password": "Nullstill passordet ditt",
    "Reset your Password": "Nullstill passordet ditt",
    "Send code": "Send kode",
    "Send Code": "Send kode",
    Sending: "Sender",
    "Setup TOTP": "Konfigurer TOTP",
    "Show password": "Vis passordet",
    "Sign in to your account": "Logg inn p\xe5 kontoen din",
    "Sign In with Amazon": "Logg inn med Amazon",
    "Sign In with Apple": "Logg inn med Apple",
    "Sign In with Facebook": "Logg inn med Facebook",
    "Sign In with Google": "Logg inn med Google",
    "Sign in": "Logg inn",
    "Sign In": "Logg inn",
    "Signing in": "Logger inn",
    Skip: "Hopp over",
    Submit: "Send inn",
    Submitting: "Sender inn",
    Username: "Brukernavn",
    "Verify Contact": "Bekreft kontakt",
    Verify: "Bekreft",
    "We Emailed You": "Vi sendte deg en e-post",
    "We Sent A Code": "Vi sendte en kode",
    "We Texted You": "Vi sendte deg en tekstmelding",
    "Your code is on the way. To log in, enter the code we emailed to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte e-post til",
    "Your code is on the way. To log in, enter the code we sent you": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte deg",
    "Your code is on the way. To log in, enter the code we texted to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte tekstmelding til",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Det finnes allerede en konto med denne e-postadressen",
    "Confirm a Code": "Bekreft koden",
    "Confirm Sign In": "Bekreft innlogging",
    "Create account": "Opprett konto",
    "Enter your password": "Skriv inn passordet ditt",
    "Forgot Password": "Glemt passordet",
    "Have an account? ": "Har en konto allerede? ",
    "Incorrect username or password": "Feil brukernavn eller passord",
    "Invalid password format": "Ugyldig passordformat",
    "Invalid phone number format": "Ugyldig telefonnummerformat",
    "Lost your code? ": "Mistet koden? ",
    "New Password": "Nytt passord",
    "No account? ": "Ingen konto? ",
    "Password attempts exceeded": "For mange mislykkede passordfors\xf8k",
    "Reset password": "Nullstill passord",
    "Sign Out": "Logg ut",
    "Sign Up": "Registrering",
    "User already exists": "Brukeren finnes allerede",
    "User does not exist": "Brukeren finnes ikke",
    "Username cannot be empty": "Brukernavnet kan ikke v\xe6re tomt"
};


const $98d102d7f66d4552$export$8569df33fbaae243 = {
    "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens",
    "Back to Sign In": "Terug naar inloggen",
    "Change Password": "Wachtwoord wijzigen",
    Changing: "Wordt aangepast",
    Code: "Code",
    "Confirm Password": "Bevestig Wachtwoord",
    "Confirm Sign Up": "Bevestig inschrijving",
    "Confirm SMS Code": "Bevestig SMS Code",
    "Confirm TOTP Code": "Bevestig TOTP Code",
    Confirm: "Bevestig",
    "Confirmation Code": "Bevestigingscode",
    Confirming: "Bevestigen",
    "Create a new account": "Nieuw account aanmaken",
    "Create Account": "Account aanmaken",
    "Creating Account": "Account wordt aangemaakt",
    "Dismiss alert": "Waarschuwing sluiten",
    Email: "E-mail",
    "Enter your code": "Vul je code in",
    "Enter your Email": "Vul je e-mail in",
    "Enter your Password": "Vul je wachtwoord in",
    "Enter your phone number": "Vul je telefoonnummer in",
    "Enter your username": "Vul je gebruikersnaam in",
    "Enter your Username": "Vul je gebruikersnaam in",
    "Forgot your password?": "Wachtwoord vergeten? ",
    "Hide password": "Verberg wachtwoord",
    "It may take a minute to arrive": "Het kan even duren voordat deze aankomt",
    Loading: "Laden",
    "New password": "Nieuw wachtwoord",
    "New Password": "Nieuw Wachtwoord",
    or: "of",
    Password: "Wachtwoord",
    "Phone Number": "Telefoonnummer",
    "Please confirm your Password": "Bevestig je wachtwoord",
    "Resend Code": "Verstuur code nogmaals",
    "Reset Password": "Wachtwoord resetten",
    "Reset your password": "Reset je wachtwoord",
    "Reset your Password": "Wachtwoord resetten",
    "Send code": "Verstuur code",
    "Send Code": "Verstuur Code",
    Sending: "Versturen",
    "Setup TOTP": "TOTP Instellingen",
    "Show password": "Toon wachtwoord",
    "Sign in to your account": "Inloggen op je account",
    "Sign In with Amazon": "Inloggen met Amazon",
    "Sign In with Apple": "Inloggen met Apple",
    "Sign In with Facebook": "Inloggen met Facebook",
    "Sign In with Google": "Inloggen met Google",
    "Sign in": "Inloggen",
    "Sign In": "Inloggen",
    "Signing in": "Inloggen",
    Skip: "Overslaan",
    Submit: "Versturen",
    Submitting: "Wordt verstuurd",
    Username: "Gebruikersnaam",
    "Verify Contact": "Verifieer Contact",
    Verify: "Verifieer",
    "We Emailed You": "We hebben u een e-mail gestuurd",
    "We Sent A Code": "We hebben een code gestuurd",
    "We Texted You": "We hebben u een sms gestuurd",
    "Your code is on the way. To log in, enter the code we emailed to": "Uw code is onderweg. Om in te loggen, voer de code in die we gemaild hebben naar",
    "Your code is on the way. To log in, enter the code we sent you": "Uw code is onderweg. Om in te loggen, voer de code in die we u hebben gestuurd",
    "Your code is on the way. To log in, enter the code we texted to": "Uw code is onderweg. Om in te loggen, voer de code in die we hebben gestuurd naar",
    "Your passwords must match": "Je wachtwoorden moeten overeenkomen"
};


const $9460b889a7ed3b88$export$6fb0e8139f7ef98d = {
    "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    "Back to Sign In": "Powr\xf3t do logowania",
    "Change Password": "Zmie\u0144 has\u0142o",
    Changing: "Zmienianie",
    Code: "Kod",
    "Confirm Password": "Potwierd\u017A Has\u0142o",
    "Confirm Sign Up": "Potwierd\u017A rejestracj\u0119",
    "Confirm SMS Code": "Potwierd\u017A kod SMS",
    "Confirm TOTP Code": "Potwierd\u017A has\u0142o jednorazowe",
    Confirm: "Potwierd\u017A",
    "Confirmation Code": "Kod potwierdzenia",
    Confirming: "Potwierdzanie",
    "Create a new account": "Utw\xf3rz nowe konto",
    "Create Account": "Utw\xf3rz konto",
    "Creating Account": "Tworzenie konta",
    "Dismiss alert": "Odrzu\u0107 alert",
    Email: "E-mail",
    "Enter your code": "Wprowad\u017A sw\xf3j kod",
    "Enter your Email": "Wpisz sw\xf3j adres e-mail",
    "Enter your phone number": "Wpisz sw\xf3j numer telefonu",
    "Enter your username": "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika",
    "Forgot your password?": "Zapomnia\u0142e\u015B has\u0142a? ",
    "Hide password": "Ukryj has\u0142o",
    "It may take a minute to arrive": "Mo\u017Ce to chwil\u0119 potrwa\u0107",
    Loading: "\u0141adowanie",
    "New password": "Nowe has\u0142o",
    or: "albo",
    Password: "Has\u0142o",
    "Phone Number": "Numer telefonu",
    "Resend Code": "Wy\u015Blij kod ponownie",
    "Reset your password": "Zresetuj swoje has\u0142o",
    "Reset your Password": "Zresetuj swoje has\u0142o",
    "Send code": "Wy\u015Blij kod",
    "Send Code": "Zresetuj has\u0142o",
    Sending: "Wysy\u0142anie",
    "Setup TOTP": "Konfiguruj TOTP",
    "Show password": "Poka\u017C has\u0142o",
    "Sign in to your account": "Zaloguj si\u0119 na swoje konto",
    "Sign In with Amazon": "Zaloguj z Amazon",
    "Sign In with Apple": "Zaloguj z Apple",
    "Sign In with Facebook": "Zaloguj z Facebook",
    "Sign In with Google": "Zaloguj z Google",
    "Sign In": "Logowanie",
    "Sign in": "Zaloguj",
    "Signing in": "Logowanie",
    Skip: "Pomi\u0144",
    Submit: "Wy\u015Blij",
    Submitting: "Wysy\u0142anie",
    Username: "Nazwa u\u017Cytkownika",
    "Verify Contact": "Weryfikacja danych kontaktowych",
    Verify: "Zweryfikuj",
    // Additional translations provided by customers
    Birthdate: "Data urodzenia",
    "Family Name": "Nazwisko",
    "Given Name": "Pierwsze imi\u0119",
    "Middle Name": "Drugie imi\u0119",
    Name: "Imi\u0119 i nazwisko",
    Nickname: "Pseudonim",
    "Preferred Username": "Preferowana nazwa u\u017Cytkownika",
    Profile: "Profil",
    Website: "Strona internetowa",
    "We Emailed You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 e-mail",
    "We Sent A Code": "Wys\u0142ali\u015Bmy kod",
    "We Texted You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any na adres e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A wys\u0142any do Ciebie kod",
    "Your code is on the way. To log in, enter the code we texted to": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any do Ciebie w wiadomo\u015Bci SMS pod numer"
};


const $e703924540652610$export$c7dddbf179b434d1 = {
    "Account recovery requires verified contact information": "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    "Back to Sign In": "Voltar para Entrar",
    "Change Password": "Mudar senha",
    Changing: "Mudando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirme a Senha",
    "Confirm Sign Up": "Confirmar inscri\xe7\xe3o",
    "Confirm SMS Code": "Confirme o c\xf3digo SMS",
    "Confirm TOTP Code": "Confirme o c\xf3digo TOTP",
    Confirm: "confirme",
    "Confirmation Code": "C\xf3digo de confirma\xe7\xe3o",
    Confirming: "Confirmando",
    "Create a new account": "Criar uma nova conta",
    "Create Account": "Criar Conta",
    "Creating Account": "Criando conta",
    "Dismiss alert": "Descartar alerta",
    Email: "O email",
    "Enter your code": "Insira seu c\xf3digo",
    "Enter your Email": "Digite seu e-mail",
    "Enter your phone number": "Digite seu n\xfamero de telefone",
    "Enter your username": "entre com seu nome de usu\xe1rio",
    "Forgot your password?": "Esqueceu sua senha? ",
    "Hide password": "Esconder a senha",
    "It may take a minute to arrive": "Pode levar um minuto para chegar",
    Loading: "Carregando",
    "New password": "Nova Senha",
    or: "ou",
    Password: "Senha",
    "Phone Number": "N\xfamero de telefone",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Redefina sua senha",
    "Reset your Password": "Redefina sua senha",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar senha",
    "Sign in to your account": "Fa\xe7a login em sua conta",
    "Sign In with Amazon": "Entrar com a Amazon",
    "Sign In with Apple": "Entrar com a Apple",
    "Sign In with Facebook": "Entrar com o Facebook",
    "Sign In with Google": "Fa\xe7a login no Google",
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Signing in": "Entrando",
    Skip: "Pular",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nome do usu\xe1rio",
    "Verify Contact": "Verificar contato",
    Verify: "Verificar",
    "We Emailed You": "Enviamos um e-mail para voc\xea",
    "We Sent A Code": "Enviamos um c\xf3digo",
    "We Texted You": "Enviamos um SMS para voc\xea",
    "Your code is on the way. To log in, enter the code we emailed to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos um e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo que enviamos para voc\xea",
    "Your code is on the way. To log in, enter the code we texted to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos uma mensagem de texto"
};


const $582df3439196dcb6$export$2a86dc37ee9734c = {
    "Account recovery requires verified contact information": "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
    "Back to Sign In": "\u56DE\u5230\u767B\u5F55",
    "Change Password": "\u66F4\u6539\u5BC6\u7801",
    Changing: "\u6B63\u5728\u4FEE\u6539",
    Code: "\u786E\u8BA4\u7801",
    "Confirm Password": "\u786E\u8BA4\u5BC6\u7801",
    "Confirm Sign Up": "\u786E\u8BA4\u6CE8\u518C",
    "Confirm SMS Code": "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    "Confirm TOTP Code": "\u786E\u8BA4 TOTP \u4EE3\u7801",
    Confirm: "\u786E\u8BA4",
    "Confirmation Code": "\u786E\u8BA4\u7801",
    Confirming: "\u6B63\u5728\u786E\u8BA4",
    "Create a new account": "\u521B\u5EFA\u65B0\u8D26\u6237",
    "Create Account": "\u521B\u5EFA\u8D26\u6237",
    "Creating Account": "\u6B63\u5728\u521B\u5EFA\u8D26\u6237",
    "Dismiss alert": "\u5173\u95ED\u8B66\u62A5",
    Email: "\u90AE\u7BB1",
    "Enter your code": "\u8F93\u5165\u9A8C\u8BC1\u7801",
    "Enter your Email": "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6",
    "Enter your phone number": "\u8F93\u5165\u7535\u8BDD\u53F7\u7801",
    "Enter your username": "\u8F93\u5165\u7528\u6237\u540D",
    "Forgot your password?": "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F",
    "Hide password": "\u9690\u85CF\u5BC6\u7801",
    "It may take a minute to arrive": "\u53EF\u80FD\u9700\u8981\u4E00\u5206\u949F\u624D\u80FD\u5230\u8FBE",
    Loading: "\u6B63\u5728\u52A0\u8F7D",
    "New password": "\u65B0\u5BC6\u7801",
    or: "\u6216\u8005",
    Password: "\u5BC6\u7801",
    "Phone Number": "\u7535\u8BDD",
    "Resend Code": "\u91CD\u53D1\u9A8C\u8BC1\u7801",
    "Reset your password": "\u91CD\u7F6E\u5BC6\u7801",
    "Reset your Password": "\u91CD\u7F6E\u5BC6\u7801",
    "Send Code": "\u53D1\u9001\u786E\u8BA4\u7801",
    "Send code": "\u53D1\u9001\u9A8C\u8BC1\u7801",
    Sending: "\u6B63\u5728\u53D1\u9001",
    "Setup TOTP": "\u8BBE\u7F6E TOTP",
    "Show password": "\u663E\u793A\u5BC6\u7801",
    "Sign in to your account": "\u767B\u5F55\u8D26\u6237",
    "Sign In with Amazon": "\u901A\u8FC7 Amazon \u767B\u5F55",
    "Sign In with Apple": "\u901A\u8FC7 Apple \u767B\u5F55",
    "Sign In with Facebook": "\u901A\u8FC7 Facebook \u767B\u5F55",
    "Sign In with Google": "\u901A\u8FC7 Google \u767B\u5F55",
    "Sign in": "\u767B\u5F55",
    "Sign In": "\u767B\u5F55",
    "Signing in": "\u6B63\u5728\u767B\u5F55",
    Skip: "\u8DF3\u8FC7",
    Submit: "\u63D0\u4EA4",
    Submitting: "\u6B63\u5728\u63D0\u4EA4",
    Username: "\u7528\u6237\u540D",
    "Verify Contact": "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
    Verify: "\u9A8C\u8BC1",
    "We Emailed You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u7535\u5B50\u90AE\u4EF6",
    "We Sent A Code": "\u6211\u4EEC\u53D1\u9001\u4E86\u4EE3\u7801",
    "We Texted You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u77ED\u4FE1",
    "Your code is on the way. To log in, enter the code we emailed to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    "Your code is on the way. To log in, enter the code we sent you": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u7ED9\u60A8\u7684\u4EE3\u7801",
    "Your code is on the way. To log in, enter the code we texted to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u77ED\u4FE1\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    // Additional translations provided by customers
    "Confirm a Code": "\u786E\u8BA4\u7801",
    "Confirm Sign In": "\u786E\u8BA4\u767B\u5F55",
    "Forgot Password": "\u5FD8\u8BB0\u5BC6\u7801",
    "Incorrect username or password": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    "Invalid password format": "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
    "Invalid phone number format": "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900",
    "New Password": "\u65B0\u5BC6\u7801",
    "Resend a Code": "\u91CD\u53D1\u786E\u8BA4\u7801",
    "Sign Out": "\u9000\u51FA",
    "Sign Up": "\u6CE8\u518C",
    "User already exists": "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
    "User does not exist": "\u7528\u6237\u4E0D\u5B58\u5728"
};


const $379f4bf6669f0132$export$9f1a61f9baaa2d2e = {
    "Account recovery requires verified contact information": "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    "Back to Sign In": "Tillbaka till inloggningen",
    "Change Password": "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: "Kod",
    "Confirm Password": "Bekr\xe4fta l\xf6senord",
    "Confirm Sign Up": "Bekr\xe4fta registrering",
    "Confirm SMS Code": "Bekr\xe4fta SMS-kod",
    "Confirm TOTP Code": "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    "Confirmation Code": "Verifikationskod",
    Confirming: "Bekr\xe4ftar",
    "Create a new account": "Skapa ett nytt konto",
    "Create Account": "Skapa konto",
    "Creating Account": "Skapar konto",
    "Dismiss alert": "Avvisa varning",
    Email: "E-post",
    "Enter your code": "Skriv din kod",
    "Enter your Email": "Fyll i din e-post",
    "Enter your phone number": "Ange ditt telefonnummer",
    "Enter your username": "Ange ditt anv\xe4ndarnamn",
    "Forgot your password?": "Gl\xf6mt ditt l\xf6senord? ",
    "Hide password": "D\xf6lj l\xf6senord",
    "It may take a minute to arrive": "Det kan ta en minut att komma fram",
    Loading: "Laddar",
    "New password": "Nytt l\xf6senord",
    or: "eller",
    Password: "L\xf6senord",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Skicka koden igen",
    "Reset your password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Reset your Password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Send code": "Skicka kod",
    "Send Code": "Skicka kod",
    Sending: "Skickar",
    "Setup TOTP": "Konfigurera TOTP",
    "Show password": "Visa l\xf6senord",
    "Sign in to your account": "Logga in till ditt konto",
    "Sign In with Amazon": "Logga in med Amazon",
    "Sign In with Apple": "Logga in med Apple",
    "Sign In with Facebook": "Logga in med Facebook",
    "Sign In with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Signing in": "Loggar in",
    Skip: "Hoppa \xf6ver",
    Submit: "Skicka",
    Submitting: "Skickar in",
    Username: "Anv\xe4ndarnamn",
    "Verify Contact": "Verifiera kontakt",
    Verify: "Verifiera",
    "We Sent A Code": "Vi skickade en kod",
    "We Texted You": "Vi sms:ade dig",
    "Your code is on the way. To log in, enter the code we emailed to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi mejlade till",
    "Your code is on the way. To log in, enter the code we sent you": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi skickade till dig",
    "Your code is on the way. To log in, enter the code we texted to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi sms:ade till",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress",
    "Confirm a Code": "Bekr\xe4fta koden",
    "Confirm Sign In": "Bekr\xe4fta inloggning",
    "Create account": "Skapa konto",
    "Enter your password": "Ange ditt l\xf6senord",
    "Forgot Password": "Gl\xf6mt l\xf6senordet",
    "Have an account? ": "Redan registrerad? ",
    "Incorrect username or password": "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    "Invalid password format": "Ogiltigt l\xf6senordsformat",
    "Invalid phone number format": `Ogiltigt format f\xf6r telefonnummer`,
    "Lost your code? ": "F\xf6rlorat koden? ",
    "New Password": "Nytt l\xf6senord",
    "No account? ": "Inget konto? ",
    "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    "Reset password": "\xc5terst\xe4ll l\xf6senord",
    "Sign Out": "Logga ut",
    "Sign Up": "Registrering",
    "User already exists": "Anv\xe4ndaren finns redan",
    "User does not exist": "Anv\xe4ndaren finns inte",
    "Username cannot be empty": "Anv\xe4ndarnamnet kan inte vara tomt",
    "We Emailed You": "Vi har skickat e-post till dig"
};


const $668295922885b064$export$710642024bfcbd8f = {
    "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi",
    "Back to Sign In": "Kembali ke Masuk",
    "Change Password": "Ubah kata sandi",
    Changing: "Mengubah",
    Code: "Kode",
    "Confirm Password": "Konfirmasi kata sandi",
    "Confirm Sign Up": "Konfirmasi Pendaftaran",
    "Confirm SMS Code": "Konfirmasi Kode SMS",
    "Confirm TOTP Code": "Konfirmasi Kode TOTP",
    Confirm: "Konfirmasi",
    "Confirmation Code": "Kode Konfirmasi",
    Confirming: "Mengkonfirmasi",
    "Create a new account": "Buat akun baru",
    "Create Account": "Buat Akun",
    "Creating Account": "Membuat Akun",
    "Dismiss alert": "Hentikan pemberitahuan",
    Email: "Email",
    "Enter your code": "Masukkan kode anda",
    "Enter your Email": "Masukkan email anda",
    "Enter your phone number": "Masukkan nomor telepon anda",
    "Enter your username": "Masukkan nama akun anda",
    "Forgot your password?": "Lupa kata sandi? ",
    "Hide password": "Sembunyikan kata sandi",
    "It may take a minute to arrive": "Mungkin perlu waktu satu menit untuk tiba",
    Loading: "Memuat",
    "New password": "Kata sandi baru",
    or: "atau",
    Password: "Kata sandi",
    "Phone Number": "Nomor telepon",
    "Resend Code": "Kirim ulang kodenya",
    "Reset your Password": "Reset Kata Sandi",
    "Reset your password": "Ubah kata sandi anda",
    "Send code": "Kirim kode",
    "Send Code": "Kirim Kode",
    Sending: "Mengirim",
    "Setup TOTP": "Siapkan TOTP",
    "Show password": "Tampilkan kata sandi",
    "Sign in to your account": "Masuk akun anda",
    "Sign In with Amazon": "Masuk dengan Amazon",
    "Sign In with Apple": "Masuk dengan Apple",
    "Sign In with Facebook": "Masuk dengan Facebook",
    "Sign In with Google": "Masuk dengan Google",
    "Sign in": "Masuk",
    "Sign In": "Masuk",
    "Signing in": "Memasuki",
    Skip: "Lewati",
    Submit: "Ajukan",
    Submitting: "Mengajukan",
    Username: "Nama akun",
    "Verify Contact": "Verifikasi Kontak",
    Verify: "Verifikasi",
    "We Sent A Code": "Kami Mengirim Kode",
    "We Texted You": "Kami mengirim SMS kepada Anda",
    "Your code is on the way. To log in, enter the code we sent you": "Kode Anda segera hadir. Untuk masuk, masukkan kode yang kami kirimkan kepada Anda",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.",
    "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon",
    Change: "Ubah",
    "Confirm a Code": "Konfirmasi kode",
    "Create account": "Buat akun",
    "Enter your password": "Masukkan kata sandi anda",
    "Forgot Password": "Lupa kata sandi",
    "Have an account? ": "Sudah punya akun? ",
    Hello: "Halo",
    "Incorrect username or password.": "Nama akun atau kata sandi salah.",
    "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.",
    "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.",
    "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.",
    "Lost your code? ": "Kode anda hilang?",
    Name: "Nama",
    "Network error": "Galat jaringan",
    "No account? ": "Tidak ada akun?",
    "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "Ubah kata sandi anda",
    Send: "Kirim",
    "Sign In with AWS": "Masuk dengan AWS",
    "Sign Up with Amazon": "Daftar dengan Amazon",
    "Sign Up with AWS": "Daftar dengan AWS",
    "Sign Up with Facebook": "Daftar dengan Facebook",
    "Sign Up with Google": "Daftar dengan Google",
    SMS: "SMS",
    "User already exists": "Akun sudah terdaftar",
    "User does not exist.": "Akun tidak terdaftar.",
    "User is disabled.": "Akun dinonaktifkan.",
    "Username cannot be empty": "Nama akun tidak boleh kosong",
    "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.",
    "We Emailed You": "Kami mengirimkanmu email",
    "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke",
    "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke",
    "Your passwords must match": "Kata sandi harus sama"
};


const $17a84fff3e604ee6$export$6961fa2059aeacf0 = {
    "Account recovery requires verified contact information": "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir",
    "Back to Sign In": "Oturum A\xe7maya Geri D\xf6n",
    "Change Password": "\u015Eifreyi De\u011Fi\u015Ftir",
    Changing: "De\u011Fi\u015Ftiriliyor",
    Code: "Kod",
    "Confirm Password": "\u015Eifreyi Do\u011Frula",
    "Confirm Sign Up": "Kay\u0131t \u0130\u015Flemini Do\u011Frula",
    "Confirm SMS Code": "SMS Kodunu Do\u011Frula",
    "Confirm TOTP Code": "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula",
    Confirm: "Do\u011Frula",
    "Confirmation Code": "Do\u011Frulama Kodu",
    Confirming: "Do\u011Frulan\u0131yor",
    "Create a new account": "Yeni bir hesap olu\u015Ftur",
    "Create Account": "Hesap Olu\u015Ftur",
    "Creating Account": "Hesap Olu\u015Fturuluyor",
    "Dismiss alert": "Uyar\u0131y\u0131 reddet",
    Email: "E-posta",
    "Enter your code": "Kodu girin",
    "Enter your Email": "E-posta adresinizi girin",
    "Enter your phone number": "Telefon numaran\u0131z\u0131 girin",
    "Enter your username": "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    "Forgot your password?": "\u015Eifrenizi mi unuttunuz?",
    "Hide password": "\u015Eifreyi gizle",
    "It may take a minute to arrive": "Kodun gelmesi bir dakika s\xfcrebilir",
    Loading: "Y\xfckleniyor",
    "New password": "Yeni \u015Fifre",
    or: "veya",
    Password: "\u015Eifre",
    "Phone Number": "Telefon Numaras\u0131",
    "Resend Code": "Kodu Yeniden G\xf6nder",
    "Reset your password": "\u015Eifrenizi s\u0131f\u0131rlay\u0131n",
    "Reset your Password": "\u015Eifrenizi S\u0131f\u0131rlay\u0131n",
    "Send code": "Kod g\xf6nder",
    "Send Code": "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    "Setup TOTP": "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap",
    "Show password": "\u015Eifreyi g\xf6ster",
    "Sign in to your account": "Hesab\u0131n\u0131zda oturum a\xe7\u0131n",
    "Sign In with Amazon": "Amazon ile Oturum A\xe7",
    "Sign In with Apple": "Apple ile Oturum A\xe7",
    "Sign In with Facebook": "Facebook ile Oturum A\xe7",
    "Sign In with Google": "Google ile Oturum A\xe7",
    "Sign in": "Oturum a\xe7",
    "Sign In": "Oturum A\xe7",
    "Signing in": "Oturum a\xe7\u0131l\u0131yor",
    Skip: "Atla",
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    Username: "Kullan\u0131c\u0131 ad\u0131",
    "Verify Contact": "Ki\u015Fiyi Do\u011Frula",
    Verify: "Do\u011Frula",
    "We Emailed You": "Size E-posta G\xf6nderdik",
    "We Sent A Code": "Bir Kod G\xf6nderdik",
    "We Texted You": "Size Mesaj G\xf6nderdik",
    "Your code is on the way. To log in, enter the code we emailed to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz e-postadaki kodu girin",
    "Your code is on the way. To log in, enter the code we sent you": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, size g\xf6nderdi\u011Fimiz kodu girin",
    "Your code is on the way. To log in, enter the code we texted to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz mesajdaki kodu girin",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.",
    "Confirm Sign In": "Oturum A\xe7may\u0131 Do\u011Frula",
    "Have an account? ": "Hesab\u0131n\u0131z var m\u0131? ",
    "Incorrect username or password": "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    "Invalid password format": "Ge\xe7ersiz parola format\u0131",
    "Invalid phone number format": "Ge\xe7ersiz telefon numaras\u0131 format\u0131",
    "Lost your code? ": "Kodu mu kaybettiniz? ",
    "No account? ": "Hesab\u0131n\u0131z yok mu? ",
    "Password attempts exceeded": "Maksimum oturum a\xe7ma giri\u015Fimi a\u015F\u0131ld\u0131",
    "Sign Out": "\xc7\u0131k\u0131\u015F yap",
    "Sign Up": "Kay\u0131t Ol",
    "User already exists": "Bu kullan\u0131c\u0131 zaten var",
    "User does not exist": "B\xf6yle bir kullan\u0131c\u0131 mevcut de\u011Fil",
    "Username cannot be empty": "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz"
};


const $98fc9cd149dc1f40$export$6240aeddf7c74bb8 = {
    "Account recovery requires verified contact information": "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438",
    "Change Password": "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
    "Confirm Sign Up": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    "Confirm SMS Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434",
    Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C",
    "Confirmation Code": "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
    "Create a new account": "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Create Account": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Creating Account": "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
    "Dismiss alert": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your code": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434",
    "Enter your Email": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your phone number": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Enter your username": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Forgot your password?": "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    "New password": "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0438\u043B\u0438",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Resend Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434",
    "Reset your password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    "Send Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430",
    "Setup TOTP": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "Sign In with Amazon": "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon",
    "Sign In with Apple": "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple",
    "Sign In with Facebook": "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook",
    "Sign In with Google": "\u0437\u043D\u0430\u043A \u0432 \u0441 Google",
    "Sign in": "\u0437\u043D\u0430\u043A \u0432",
    "Sign In": "\u0437\u043D\u0430\u043A \u0432",
    "Signing in": "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C",
    Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435",
    Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432",
    Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Verify Contact": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C",
    "We Emailed You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E",
    "We Sent A Code": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    "We Texted You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435",
    "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043F\u043E\u0441\u043B\u0430\u043B\u0438 \u0432\u0430\u043C",
    "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C"
};


const $63cc30565ce15f70$export$b2ba232c100e7a36 = {
    "Account recovery requires verified contact information": "\u05E9\u05D7\u05D6\u05D5\u05E8 \u05DC\u05E7\u05D5\u05D7 \u05D3\u05D5\u05E8\u05E9 \u05E2\u05D5\u05D3 \u05DE\u05D9\u05D3\u05E2",
    "Back to Sign In": "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4",
    "Change Password": "\u05E2\u05D3\u05DB\u05D5\u05DF \u05E1\u05D9\u05E1\u05DE\u05D0",
    Changing: "\u05DE\u05E2\u05D3\u05DB\u05DF",
    Code: "\u05E7\u05D5\u05D3",
    "Confirm Password": "\u05D0\u05E9\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Confirm Sign Up": "\u05D0\u05E9\u05E8 \u05D4\u05E8\u05E9\u05DE\u05D4",
    "Confirm SMS Code": "\u05D0\u05E9\u05E8 sms \u05E7\u05D5\u05D3",
    "Confirm TOTP Code": "\u05D0\u05E9\u05E8 totp \u05E7\u05D5\u05D3",
    Confirm: "\u05D0\u05D9\u05E9\u05D5\u05E8",
    "Confirmation Code": "\u05D0\u05D9\u05E9\u05D5\u05E8 \u05E7\u05D5\u05D3",
    Confirming: "\u05DE\u05D0\u05E9\u05E8",
    "Create a new account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D7\u05D3\u05E9",
    "Create Account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Creating Account": "\u05D9\u05E6\u05D9\u05E8\u05EA \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Dismiss alert": "\u05D4\u05E1\u05E8 \u05D4\u05EA\u05E8\u05D0\u05D4",
    Email: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    "Enter your code": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3",
    "Enter your Email": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA",
    "Enter your phone number": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
    "Enter your username": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DE\u05EA\u05DE\u05E9 \u05E9\u05DC\u05DA",
    "Forgot your password?": "\u05E9\u05D7\u05DB\u05EA \u05E1\u05D9\u05E1\u05DE\u05D0 ?",
    "Hide password": "\u05D4\u05E1\u05EA\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    Loading: "\u05D8\u05D5\u05E2\u05DF",
    "New password": "\u05E1\u05D9\u05E1\u05DE\u05D0 \u05D7\u05D3\u05E9\u05D4",
    or: "\u05D0\u05D5\u05B9",
    Password: "\u05E1\u05D9\u05E1\u05DE\u05D0",
    "Phone Number": "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
    "Resend Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
    "Reset your password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Reset your Password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Send code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    "Send Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    Sending: "\u05E9\u05D5\u05DC\u05D7",
    "Setup TOTP": "Setup TOTP",
    "Show password": "\u05D4\u05E6\u05D2 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Sign in to your account": "\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "\u05D4\u05EA\u05D7\u05D1\u05E8",
    "Sign In": "\u05D4\u05EA\u05D7\u05D1\u05E8",
    "Signing in": "\u05DE\u05EA\u05D7\u05D1\u05E8",
    Skip: "\u05D3\u05DC\u05D2",
    Submit: "\u05E9\u05DC\u05D7",
    Submitting: "\u05E9\u05D5\u05DC\u05D7",
    Username: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Verify Contact": "\u05D0\u05DE\u05EA \u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8",
    Verify: "\u05D0\u05DE\u05EA"
};


const $f7ae71ebb4739253$export$373d6304c6310960 = {
    "Account recovery requires verified contact information": "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0445\u043E\u0434\u0443",
    "Change Password": "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0417\u043C\u0456\u043D\u044E\u0454\u043C\u043E",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Confirm Sign Up": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E",
    "Confirm SMS Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C SMS \u043A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C TOTP \u043A\u043E\u0434",
    Confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    "Confirmation Code": "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
    Confirming: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u043C\u043E",
    "Create a new account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "Create Account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "Creating Account": "\u0420\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u043C\u043E",
    "Dismiss alert": "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    Email: "Email",
    "Enter your code": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    "Enter your Email": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 email",
    "Enter your phone number": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Enter your username": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    "Forgot password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Forgot your password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435 \u0442\u0440\u0438\u0432\u0430\u0442\u0438 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E",
    "New password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0430\u0431\u043E",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Resend Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    "Reset your password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    "Send Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    Sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    "Setup TOTP": "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0443 \u0432\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    "Sign In with Amazon": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Amazon",
    "Sign In with Apple": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Apple",
    "Sign In with Facebook": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Facebook",
    "Sign In with Google": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Google",
    "Sign in": "\u0423\u0432\u0456\u0439\u0442\u0438",
    "Sign In": "\u0423\u0432\u0456\u0439\u0442\u0438",
    "Signing in": "\u0412\u0445\u043E\u0434\u0438\u043C\u043E",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438",
    Submit: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
    Submitting: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    Username: "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    "Verify Contact": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u041A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    "We Emailed You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C Email",
    "We Sent A Code": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    "We Texted You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u043D\u0430 Email",
    "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0430\u043C \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438",
    "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0438\u043C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F\u043C",
    // Additional translations
    "An account with the given email already exists.": "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0437 \u0446\u0438\u043C Email \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454.",
    "Confirm a Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    "Confirm Sign In": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0432\u0445\u0456\u0434",
    "Forgot Password": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Incorrect username or password.": "\u041D\u0435\u0432\u0456\u0440\u043D\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043F\u0430\u0440\u043E\u043B\u044C",
    "Invalid password format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0430\u0440\u043E\u043B\u044E",
    "Invalid phone number format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Loading...": "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E...",
    "New Password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Resend a Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    "Reset Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign Out": "\u0412\u0438\u0439\u0442\u0438",
    "Sign Up with Amazon": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Amazon",
    "Sign Up with Apple": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Apple",
    "Sign Up with Facebook": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Facebook",
    "Sign Up with Google": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Google",
    "Sign Up": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "User already exists": "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    "User does not exist": "\u0422\u0430\u043A\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454",
    "Username cannot be empty": "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
    "Your passwords must match": "\u041F\u0430\u0440\u043E\u043B\u0456 \u043C\u0430\u044E\u0442\u044C \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F"
};


const $3377f0bc6a807edc$export$320d289eca4cc695 = {
    ADD_PROFILE: "Add your Profile",
    ADD_WEBSITE: "Add your Website",
    BACK_SIGN_IN: "Back to Sign In",
    BIRTHDATE: "Birthdate",
    CHANGE_PASSWORD: "Change Password",
    CHANGING_PASSWORD: "Changing",
    CODE: "Code",
    CODE_ARRIVAL: "It may take a minute to arrive",
    CODE_EMAILED: "Your code is on the way. To log in, enter the code we emailed to",
    CODE_SENT: "Your code is on the way. To log in, enter the code we sent you",
    CODE_TEXTED: "Your code is on the way. To log in, enter the code we texted to",
    CONFIRM_PASSWORD: "Confirm Password",
    CONFIRM_PASSWORD_PLACEHOLDER: "Please confirm your Password",
    CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password",
    CONFIRM_SIGNUP_HEADING: "Confirm Sign Up",
    CONFIRM_SMS: "Confirm SMS Code",
    CONFIRM_TOTP: "Confirm TOTP Code",
    CONFIRM: "Confirm",
    CONFIRMATION_CODE: "Confirmation Code",
    CONFIRMING: "Confirming",
    CREATE_ACCOUNT: "Create Account",
    CREATING_ACCOUNT: "Creating Account",
    EMAIL_ADDRESS: "Email",
    ENTER_BIRTHDATE: "Enter your Birthdate",
    ENTER_CODE: "Enter your code",
    ENTER_CONFIRMATION_CODE: "Enter your Confirmation Code",
    ENTER_EMAIL: "Enter your Email",
    ENTER_FAMILY_NAME: "Enter your Family Name",
    ENTER_GIVEN_NAME: "Enter your Given Name",
    ENTER_MIDDLE_NAME: "Enter your Middle Name",
    ENTER_NAME: "Enter your Name",
    ENTER_NICK_NAME: "Enter your Nickname",
    ENTER_PASSWORD: "Enter your Password",
    ENTER_PHONE_NUMBER: "Enter your Phone Number",
    ENTER_PREFERRED_USERNAME: "Enter your Preferred Username",
    ENTER_USERNAME: "Enter your username",
    FAMILY_NAME: "Family Name",
    GIVEN_NAME: "Given Name",
    FORGOT_PASSWORD: "Forgot Password?",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    HIDE_PASSWORD: "Hide password",
    LOADING: "Loading",
    LOGIN_NAME: "Username",
    MIDDLE_NAME: "Middle Name",
    NAME: "Name",
    NICKNAME: "Nickname",
    NEW_PASSWORD: "New password",
    OR: "or",
    PASSWORD: "Password",
    PHONE_NUMBER: "Phone Number",
    PREFERRED_USERNAME: "Preferred Username",
    PROFILE: "Profile",
    RESEND_CODE: "Resend Code",
    RESET_PASSWORD_HEADING: "Reset your password",
    RESET_PASSWORD: "Reset Password",
    SEND_CODE: "Send code",
    SENDING: "Sending",
    SETUP_TOTP: "Setup TOTP",
    SHOW_PASSWORD: "Show password",
    SIGN_IN_BUTTON: "Sign in",
    SIGN_IN_TAB: "Sign In",
    SIGN_IN_WITH_AMAZON: "Sign In with Amazon",
    SIGN_IN_WITH_APPLE: "Sign In with Apple",
    SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook",
    SIGN_IN_WITH_GOOGLE: "Sign In with Google",
    SIGN_IN: "Sign in to your account",
    SIGN_UP_BUTTON: "Create a new account",
    SIGNING_IN_BUTTON: "Signing in",
    SKIP: "Skip",
    SUBMIT: "Submit",
    SUBMITTING: "Submitting",
    UPPERCASE_COPY: "COPY",
    VERIFY_CONTACT: "Verify Contact",
    VERIFY_HEADING: "Account recovery requires verified contact information",
    VERIFY: "Verify",
    WE_EMAILED: "We Emailed You",
    WE_SENT_CODE: "We Sent A Code",
    WE_TEXTED: "We Texted You",
    WEBSITE: "Website"
};


//merge all the new module translations in respective locale constants
const $3850f1ca91f4812d$export$cca4a41bdb910c51 = {
    ...(0, $5c565350bf72d6f8$export$cca4a41bdb910c51)
};
const $3850f1ca91f4812d$export$eb91f595f110d703 = {
    ...(0, $00974024e2418748$export$eb91f595f110d703)
};
const $3850f1ca91f4812d$export$1d204a99f5862ba9 = {
    ...(0, $f4d288d142e27756$export$1d204a99f5862ba9)
};
const $3850f1ca91f4812d$export$8cfa91bfcf8d11c8 = {
    ...(0, $f152c73e6c904413$export$8cfa91bfcf8d11c8)
};
const $3850f1ca91f4812d$export$5c8da73de176fccc = {
    ...(0, $76d8995cf1391512$export$5c8da73de176fccc)
};
const $3850f1ca91f4812d$export$c416809cd76fbf21 = {
    ...(0, $aa6d21b28870bac3$export$c416809cd76fbf21)
};
const $3850f1ca91f4812d$export$fb1930c2b96707b2 = {
    ...(0, $2ca5a301c1e61034$export$fb1930c2b96707b2)
};
const $3850f1ca91f4812d$export$c27bce1749452052 = {
    ...(0, $8c366918d19dfaa7$export$c27bce1749452052)
};
const $3850f1ca91f4812d$export$8569df33fbaae243 = {
    ...(0, $98d102d7f66d4552$export$8569df33fbaae243)
};
const $3850f1ca91f4812d$export$6fb0e8139f7ef98d = {
    ...(0, $9460b889a7ed3b88$export$6fb0e8139f7ef98d)
};
const $3850f1ca91f4812d$export$c7dddbf179b434d1 = {
    ...(0, $e703924540652610$export$c7dddbf179b434d1)
};
const $3850f1ca91f4812d$export$2a86dc37ee9734c = {
    ...(0, $582df3439196dcb6$export$2a86dc37ee9734c)
};
const $3850f1ca91f4812d$export$9f1a61f9baaa2d2e = {
    ...(0, $379f4bf6669f0132$export$9f1a61f9baaa2d2e)
};
const $3850f1ca91f4812d$export$710642024bfcbd8f = {
    ...(0, $668295922885b064$export$710642024bfcbd8f)
};
const $3850f1ca91f4812d$export$6961fa2059aeacf0 = {
    ...(0, $17a84fff3e604ee6$export$6961fa2059aeacf0)
};
const $3850f1ca91f4812d$export$6240aeddf7c74bb8 = {
    ...(0, $98fc9cd149dc1f40$export$6240aeddf7c74bb8)
};
const $3850f1ca91f4812d$export$b2ba232c100e7a36 = {
    ...(0, $63cc30565ce15f70$export$b2ba232c100e7a36)
};
const $3850f1ca91f4812d$export$373d6304c6310960 = {
    ...(0, $f7ae71ebb4739253$export$373d6304c6310960)
};
const $3850f1ca91f4812d$export$320d289eca4cc695 = {
    ...(0, $3377f0bc6a807edc$export$320d289eca4cc695)
};


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * Contains translatable strings that authenticator provides by default. Customers
 * can use this to add custom vocabularies:
 *
 * ```
 * I18n.putVocabulariesForLanguage("en", {
 *  [DefaultTexts.SIGN_IN]: "Custom Sign In Text",
 *  [DefaultTexts.SIGN_IN_BUTTON]: "Custom Click Here to Sign In"
 * });
 * ```
 */ const $9afaaee5b06e14b0$export$6ba37fd455cdd594 = {
    ...(0, $3850f1ca91f4812d$export$320d289eca4cc695)
};
/**
 * This helper type checks that given phrase is one of the texts @aws-amplify/ui
 * provides by default. This enables vscode autocompletion to help catch typos
 * during development.
 *
 * You can also use translate<string> to handle custom strings or dynamic content.
 */ function $9afaaee5b06e14b0$export$d73ee8ef04f5226a(phrase) {
    return (0, $2ffc6dafd8dc611a$export$dbe3113d60765c1a).get(phrase);
}
/**
 * Whether I18n has a translation entry for given phrase
 */ function $9afaaee5b06e14b0$export$8a4bbd9646545970(phrase) {
    return (0, $2ffc6dafd8dc611a$export$dbe3113d60765c1a).get(phrase) !== phrase;
}
const $9afaaee5b06e14b0$export$150b732325d14d04 = {
    de: (0, $3850f1ca91f4812d$export$cca4a41bdb910c51),
    en: (0, $3850f1ca91f4812d$export$eb91f595f110d703),
    es: (0, $3850f1ca91f4812d$export$1d204a99f5862ba9),
    fr: (0, $3850f1ca91f4812d$export$8cfa91bfcf8d11c8),
    id: (0, $3850f1ca91f4812d$export$710642024bfcbd8f),
    it: (0, $3850f1ca91f4812d$export$5c8da73de176fccc),
    ja: (0, $3850f1ca91f4812d$export$c416809cd76fbf21),
    // TODO: remove kr in next major release
    kr: (0, $3850f1ca91f4812d$export$fb1930c2b96707b2),
    ko: (0, $3850f1ca91f4812d$export$fb1930c2b96707b2),
    nb: (0, $3850f1ca91f4812d$export$c27bce1749452052),
    nl: (0, $3850f1ca91f4812d$export$8569df33fbaae243),
    pl: (0, $3850f1ca91f4812d$export$6fb0e8139f7ef98d),
    pt: (0, $3850f1ca91f4812d$export$c7dddbf179b434d1),
    zh: (0, $3850f1ca91f4812d$export$2a86dc37ee9734c),
    sv: (0, $3850f1ca91f4812d$export$9f1a61f9baaa2d2e),
    tr: (0, $3850f1ca91f4812d$export$6961fa2059aeacf0),
    ru: (0, $3850f1ca91f4812d$export$6240aeddf7c74bb8),
    he: (0, $3850f1ca91f4812d$export$b2ba232c100e7a36),
    ua: (0, $3850f1ca91f4812d$export$373d6304c6310960)
};


const $ddddad7ebe8e1222$export$65f2c683ca9e9a02 = (state)=>{
    const loginMechanisms = state?.context.config?.loginMechanisms;
    /**
     * @migration this is where we grab only the first index of `aws_cognito_username_attributes`
     */ const [primaryAlias] = loginMechanisms ?? [
        "username"
    ];
    return primaryAlias;
};
/** Applies translations to label and placeholder */ const $ddddad7ebe8e1222$export$850c34c1087496e6 = (formFields)=>{
    const newFormFields = {
        ...formFields
    };
    for (const [name, options] of Object.entries(formFields)){
        const { label: label, placeholder: placeholder } = options;
        newFormFields[name] = {
            ...options,
            label: label ? (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(label) : undefined,
            placeholder: placeholder ? (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(placeholder) : undefined
        };
    }
    return newFormFields;
};
/** Sorts formFields according to their `order`.  */ const $ddddad7ebe8e1222$export$c610ae674f32e5d9 = (formFields)=>{
    return Object.entries(formFields).sort((a, b)=>{
        const orderA = a[1].order || Number.MAX_VALUE;
        const orderB = b[1].order || Number.MAX_VALUE;
        return orderA - orderB;
    }).filter((formFieldEntry)=>formFieldEntry[1] !== undefined);
};


/**
 * This file contains helpers that generate default formFields for each screen
 */ const $2c1ca3409e084fc3$export$7baaffefa21dec1 = "+1";
/** Helper function that gets the default formField for given field name */ const $2c1ca3409e084fc3$var$getDefaultFormField = (fieldName)=>{
    let options = (0, $1501912d3aedff2e$export$1222d357a3c2c47f)[fieldName];
    const { type: type } = options;
    if (type === "tel") options = {
        ...options,
        dialCode: $2c1ca3409e084fc3$export$7baaffefa21dec1
    };
    return options;
};
// Helper function that returns default form field for configured primary alias
const $2c1ca3409e084fc3$export$447e18c20e391f9 = (state)=>{
    const primaryAlias = (0, $ddddad7ebe8e1222$export$65f2c683ca9e9a02)(state);
    return {
        ...$2c1ca3409e084fc3$var$getDefaultFormField(primaryAlias),
        autocomplete: "username"
    };
};
/** Reusable confirmation code form fields. */ const $2c1ca3409e084fc3$var$getConfirmationCodeFormFields = (state)=>({
        confirmation_code: {
            ...$2c1ca3409e084fc3$var$getDefaultFormField("confirmation_code"),
            label: "Code *",
            placeholder: "Code"
        }
    });
const $2c1ca3409e084fc3$var$getSignInFormFields = (state)=>({
        username: {
            ...$2c1ca3409e084fc3$export$447e18c20e391f9(state)
        },
        password: {
            ...$2c1ca3409e084fc3$var$getDefaultFormField("password"),
            autocomplete: "current-password"
        }
    });
const $2c1ca3409e084fc3$var$getSignUpFormFields = (state)=>{
    const { loginMechanisms: loginMechanisms, signUpAttributes: signUpAttributes } = state.context.config;
    const primaryAlias = (0, $ddddad7ebe8e1222$export$65f2c683ca9e9a02)(state);
    /**
     * @migration signUp Fields created here
     */ const fieldNames = Array.from(new Set([
        ...loginMechanisms,
        "password",
        "confirm_password",
        ...signUpAttributes
    ]));
    const formField = {};
    for (const fieldName of fieldNames)if ((0, $69e267558438992b$export$3237178b1c616b9f)(fieldName)) {
        const fieldAttrs = fieldName === primaryAlias ? $2c1ca3409e084fc3$export$447e18c20e391f9(state) : $2c1ca3409e084fc3$var$getDefaultFormField(fieldName);
        formField[fieldName] = {
            ...fieldAttrs
        };
    } else // There's a `custom:*` attribute or one we don't already have an implementation for
    console.debug(`Authenticator does not have a default implementation for ${fieldName}. Customize SignUp FormFields to add your own.`);
    return formField;
};
const $2c1ca3409e084fc3$var$getConfirmSignUpFormFields = (state)=>({
        confirmation_code: {
            ...$2c1ca3409e084fc3$var$getDefaultFormField("confirmation_code"),
            placeholder: "Enter your code"
        }
    });
const $2c1ca3409e084fc3$var$getForgotPasswordFormFields = (state)=>{
    const primaryAlias = (0, $ddddad7ebe8e1222$export$65f2c683ca9e9a02)(state);
    const { label: label } = (0, $1501912d3aedff2e$export$1222d357a3c2c47f)[primaryAlias];
    return {
        username: {
            ...$2c1ca3409e084fc3$export$447e18c20e391f9(state),
            label: `Enter your ${label.toLowerCase()}`,
            placeholder: `Enter your ${label.toLowerCase()}`
        }
    };
};
const $2c1ca3409e084fc3$var$getConfirmResetPasswordFormFields = (state)=>({
        ...$2c1ca3409e084fc3$var$getConfirmationCodeFormFields(),
        password: {
            ...$2c1ca3409e084fc3$var$getDefaultFormField("password"),
            label: "New Password",
            placeholder: "New Password"
        },
        confirm_password: {
            ...$2c1ca3409e084fc3$var$getDefaultFormField("confirm_password"),
            label: "Confirm Password",
            placeholder: "Confirm Password"
        }
    });
const $2c1ca3409e084fc3$var$getForceNewPasswordFormFields = (state)=>{
    const actorState = (0, $aad66079c52fd2e7$export$99a4282e2c3b772d)(state);
    const { missingAttributes: missingAttributes } = actorState.context;
    const fieldNames = Array.from(new Set([
        "password",
        "confirm_password",
        ...missingAttributes ?? []
    ]));
    const formField = {};
    for (const fieldName of fieldNames)if ((0, $69e267558438992b$export$3237178b1c616b9f)(fieldName)) formField[fieldName] = {
        ...$2c1ca3409e084fc3$var$getDefaultFormField(fieldName)
    };
    else // There's a `custom:*` attribute or one we don't already have an implementation for
    console.debug(`Authenticator does not have a default implementation for ${fieldName}. Customize ForceNewPassword FormFields to add your own.`);
    return formField;
};
/** Collect all the defaultFormFields getters */ const $2c1ca3409e084fc3$export$9bcaa03841470ad7 = {
    signIn: $2c1ca3409e084fc3$var$getSignInFormFields,
    signUp: $2c1ca3409e084fc3$var$getSignUpFormFields,
    confirmSignUp: $2c1ca3409e084fc3$var$getConfirmSignUpFormFields,
    confirmSignIn: $2c1ca3409e084fc3$var$getConfirmationCodeFormFields,
    forceNewPassword: $2c1ca3409e084fc3$var$getForceNewPasswordFormFields,
    forgotPassword: $2c1ca3409e084fc3$var$getForgotPasswordFormFields,
    confirmResetPassword: $2c1ca3409e084fc3$var$getConfirmResetPasswordFormFields,
    confirmVerifyUser: $2c1ca3409e084fc3$var$getConfirmationCodeFormFields,
    setupTotp: $2c1ca3409e084fc3$var$getConfirmationCodeFormFields
};



// Gets the default formFields for given route
const $4b9f7b07e64c329a$export$bafc1c085dad2945 = (route, state)=>{
    const formFieldGetter = (0, $2c1ca3409e084fc3$export$9bcaa03841470ad7)[route];
    return formFieldGetter(state);
};
// Gets custom formFields, and applies default values
const $4b9f7b07e64c329a$export$40c1faef715b9f52 = (route, state)=>{
    const customFormFields = (0, $aad66079c52fd2e7$export$c39505fa2700473f)(state)?.formFields?.[route];
    if (!customFormFields || Object.keys(customFormFields).length === 0) return {};
    return Object.entries(customFormFields).reduce((acc, [fieldName, customOptions])=>{
        if ((route === "signIn" || route === "forgotPassword") && fieldName === "username") {
            // Unlike other screens, `signIn` and `forgotPassword` screens default login
            // alias field names to "username", even if it's a phone number or email.
            // In this case, we get the default formFieldOptions based on loginMechanism.
            const defaultOptions = (0, $2c1ca3409e084fc3$export$447e18c20e391f9)(state);
            // apply default to fill any gaps that are not present in customOptions
            const mergedOptions = {
                ...defaultOptions,
                ...customOptions
            };
            return {
                ...acc,
                [fieldName]: mergedOptions
            };
        } else if ((0, $42b64a22da585343$export$fed672849e2dd0ad)(fieldName)) {
            // if this field is a known auth attribute that we have defaults for,
            // apply defaults to customOptions.
            const defaultOptions = (0, $1501912d3aedff2e$export$1222d357a3c2c47f)[fieldName];
            const mergedOptions = {
                ...defaultOptions,
                ...customOptions
            };
            return {
                ...acc,
                [fieldName]: mergedOptions
            };
        } else // if this is not a known field, use customOptions as is.
        return {
            ...acc,
            [fieldName]: customOptions
        };
    }, {});
};
const $4b9f7b07e64c329a$export$5e097831852eb087 = (route, state)=>{
    const defaultFormFields = $4b9f7b07e64c329a$export$bafc1c085dad2945(route, state);
    const customFormFields = $4b9f7b07e64c329a$export$40c1faef715b9f52(route, state);
    const formFields = {
        ...defaultFormFields,
        ...customFormFields
    };
    delete formFields["QR"];
    return (0, $ddddad7ebe8e1222$export$850c34c1087496e6)(formFields);
};
const $4b9f7b07e64c329a$export$8f6c429ad9970441 = (formFields)=>formFields.map((field)=>{
        const key = field[0];
        // Drop order key to prevent passing to form field UI components
        const values = {
            ...field[1],
            order: undefined
        };
        return [
            key,
            values
        ];
    });
/** Calls `getFormFields` above, then sorts it into an indexed array */ const $4b9f7b07e64c329a$export$2fcee3580f06a0ca = (route, state)=>{
    const formFields = $4b9f7b07e64c329a$export$5e097831852eb087(route, state);
    return $4b9f7b07e64c329a$export$8f6c429ad9970441((0, $ddddad7ebe8e1222$export$c610ae674f32e5d9)(formFields));
};


const $0325cfb6e0643784$export$297d226dd86a0de7 = [
    "confirmResetPassword",
    "confirmSignIn",
    "confirmSignUp",
    "confirmVerifyUser",
    "forceNewPassword",
    "forgotPassword",
    "setupTotp",
    "signIn",
    "signUp",
    "verifyUser"
];
const $0325cfb6e0643784$export$8ccdb5ff21fda761 = [
    "ConfirmResetPassword",
    "ConfirmSignIn",
    "ConfirmSignUp",
    "ConfirmVerifyUser",
    "ForceNewPassword",
    "ForgotPassword",
    "SetupTotp",
    "SignIn",
    "SignUp",
    "VerifyUser"
];


const $812aae218a14c3c2$export$65443658c81b32cc = (route)=>(0, $0325cfb6e0643784$export$297d226dd86a0de7).some((componentRoute)=>componentRoute === route);
function $812aae218a14c3c2$export$a909c85e22b33d81(defaults, overrides) {
    if (!overrides) return defaults;
    return (0, $0325cfb6e0643784$export$8ccdb5ff21fda761).reduce((components, route)=>{
        const Default = defaults[route];
        const Override = overrides[route];
        if (typeof Override !== "function") return {
            ...components,
            [route]: Default
        };
        const { Footer: Footer, FormFields: FormFields, Header: Header } = Default;
        // cast to allow assigning of component slots
        const Component = Override;
        Component.Footer = Footer;
        Component.FormFields = FormFields;
        Component.Header = Header;
        return {
            ...components,
            [route]: Component
        };
    }, {});
}


const $58a0f7c73d95a99e$export$6756c954b2014a15 = ()=>false;
/**
 * Does an ordering and shallow comparison of each array value,
 * plus a value equality check for empty objects and arrays.
 */ function $58a0f7c73d95a99e$export$6d39b5fae5236692(currentDeps, nextDeps) {
    if (currentDeps.length !== nextDeps.length) return false;
    return currentDeps.every((currentDep, index)=>{
        const nextDep = nextDeps[index];
        if ((0, $85b840b81f21bd6d$export$2c02be4a78959098)(currentDep, nextDep) || (0, $85b840b81f21bd6d$export$d6708a3543c32fe4)(currentDep, nextDep)) return true;
        return currentDep === nextDep;
    });
}
const $58a0f7c73d95a99e$export$1f14d6e84ea4650a = (selector)=>(currentFacade, nextFacade)=>{
        const currentSelectorDeps = selector(currentFacade);
        const nextSelectorDeps = selector(nextFacade);
        // Shallow compare the array values
        return $58a0f7c73d95a99e$export$6d39b5fae5236692(currentSelectorDeps, nextSelectorDeps);
    };
const $58a0f7c73d95a99e$export$4680a6e0cbf2b7d7 = (state)=>({
        ...(0, $aad66079c52fd2e7$export$c39505fa2700473f)(state)?.formFields?.setupTotp?.QR
    });
const $58a0f7c73d95a99e$var$flattenFormFields = (fields)=>fields.flatMap(([name, options])=>({
            name: name,
            ...options
        }));
const $58a0f7c73d95a99e$var$convertContactMethodsToFields = (unverifiedUserAttributes)=>{
    return unverifiedUserAttributes && Object.entries(unverifiedUserAttributes).map(([name, value])=>{
        const valueIsString = (0, $85b840b81f21bd6d$export$844ec244b1367d54)(value);
        if (!valueIsString || !name) return {};
        return {
            name: name,
            label: value,
            type: "radio",
            value: value
        };
    });
};
/**
 * Retrieves default and custom (RWA only, to be updated) form field values from state machine
 * for subcomponent routes that render fields
 */ const $58a0f7c73d95a99e$export$e72db6842cb587a1 = (route, state, unverifiedUserAttributes)=>{
    if ((0, $812aae218a14c3c2$export$65443658c81b32cc)(route)) return route === "verifyUser" ? $58a0f7c73d95a99e$var$convertContactMethodsToFields(unverifiedUserAttributes) : $58a0f7c73d95a99e$var$flattenFormFields((0, $4b9f7b07e64c329a$export$2fcee3580f06a0ca)(route, state));
    return [];
};


/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator/headless#useauthenticator-hook)
 */ function $eeb86049f3e8b8d0$export$2e2bcd8739ae039(selector) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useContext((0, $1aaa37dea0f4e3ac$export$2254a7bd02a5abf7));
    if (!context) throw new Error((0, $e0dd8c84067ac3c1$export$7e92b2e9f0809b11));
    const { service: service } = context;
    const { send: send } = service;
    const xstateSelector = (0, $2hDQc.useCallback)((state)=>({
            ...(0, $04caa321ed2d354a$export$5f925d5954b1c10b)({
                send: send,
                state: state
            })
        }), [
        send
    ]);
    const comparator = selector ? (0, $58a0f7c73d95a99e$export$1f14d6e84ea4650a)(selector) : (0, $58a0f7c73d95a99e$export$6756c954b2014a15);
    // the purpose of `context.authStatus`is to intentionally override `facade.authStatus`. `facade.authStatus` does
    // not update on external sign in events (for example when a user is not using the `Authenticator`).
    const { authStatus: authStatus } = context;
    const facade = (0, $f879b07c5eea45e0$export$2105062e25df4afe)(service, xstateSelector, comparator);
    const { route: route, totpSecretCode: totpSecretCode, unverifiedUserAttributes: unverifiedUserAttributes, user: user, ...rest } = facade;
    // do not memoize output. `service.getSnapshot` reference remains stable preventing
    // `fields` from updating with current form state on value changes
    const serviceSnapshot = service.getSnapshot();
    // legacy `QRFields` values only used for SetupTotp page to retrieve issuer information, will be removed in future
    const QRFields = route === "setupTotp" ? (0, $58a0f7c73d95a99e$export$4680a6e0cbf2b7d7)(serviceSnapshot) : null;
    // legacy `formFields` values required until form state is removed from state machine
    const fields = (0, $58a0f7c73d95a99e$export$e72db6842cb587a1)(route, serviceSnapshot, unverifiedUserAttributes);
    return {
        ...rest,
        authStatus: authStatus,
        route: route,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        user: user,
        fields: /** @deprecated For internal use only */ fields,
        QRFields: QRFields
    };
}


var $2hDQc = parcelRequire("2hDQc");

// only select `route` from machine context
const $df39709324226e13$export$55f632bbdf6d0e4 = ({ route: route })=>[
        route
    ];
function $df39709324226e13$export$2e2bcd8739ae039(data) {
    const { route: route, initializeMachine: initializeMachine } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)($df39709324226e13$export$55f632bbdf6d0e4);
    const hasInitialized = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useEffect(()=>{
        if (!hasInitialized.current && route === "setup") {
            initializeMachine(data);
            hasInitialized.current = true;
        }
    }, [
        initializeMachine,
        route,
        data
    ]);
}


var $2hDQc = parcelRequire("2hDQc");


const $62612e72aec86394$export$f0e53cf2fcbe6801 = {
    apis: [
        (0, $9d643ce80023347d$export$900b1436d7e65f4).DeleteUser,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).UpdatePassword
    ],
    category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).Auth
};
const $62612e72aec86394$export$b4592dada0e918ed = {
    apis: [
        (0, $9d643ce80023347d$export$900b1436d7e65f4).SignUp,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignUp,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).ResendSignUpCode,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).SignIn,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmSignIn,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).FetchUserAttributes,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).SignOut,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).ResetPassword,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).ConfirmResetPassword,
        (0, $9d643ce80023347d$export$900b1436d7e65f4).SignInWithRedirect
    ],
    category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).Auth
};
const $62612e72aec86394$export$9350eeaf9304c617 = {
    apis: [
        (0, $9d643ce80023347d$export$c01a8c16ffda791e).NotifyMessageInteraction
    ],
    category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).InAppMessaging
};
const $62612e72aec86394$export$9ec4d9b90e0651f3 = {
    category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).Geo,
    apis: [
        (0, $9d643ce80023347d$export$afafab3eb8fc6fef).SearchByText,
        (0, $9d643ce80023347d$export$afafab3eb8fc6fef).SearchForSuggestions,
        (0, $9d643ce80023347d$export$afafab3eb8fc6fef).SearchByPlaceId
    ]
};
const $62612e72aec86394$export$8b6b593c0f557e5e = {
    category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).Geo,
    apis: []
};
const $62612e72aec86394$export$5650166bd1af1e38 = {
    apis: [
        (0, $9d643ce80023347d$export$d4f3c54b808b00ce).UploadData
    ],
    category: (0, $9d643ce80023347d$export$3a8840c5b2ecf003).Storage
};



/**
 * @example
 * ```ts
 * // set user agent options
 * const clear = setUserAgent(input);
 *
 * // clear user agent options
 * clear();
 * ```
 */ const $8afcbdccdeac7cde$export$57d3cdb500cb5402 = ({ componentName: componentName, packageName: packageName, version: version })=>{
    const packageData = [
        `ui-${packageName}`,
        version
    ];
    switch(componentName){
        case "Authenticator":
            (0, $2d7a577398a8ac08$export$20cd2fa9001e90da)({
                ...(0, $62612e72aec86394$export$b4592dada0e918ed),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "ChangePassword":
        case "DeleteUser":
            (0, $2d7a577398a8ac08$export$20cd2fa9001e90da)({
                ...(0, $62612e72aec86394$export$f0e53cf2fcbe6801),
                additionalDetails: [
                    [
                        "AccountSettings"
                    ],
                    packageData
                ]
            });
            break;
        case "InAppMessaging":
            (0, $2d7a577398a8ac08$export$20cd2fa9001e90da)({
                ...(0, $62612e72aec86394$export$9350eeaf9304c617),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "LocationSearch":
            (0, $2d7a577398a8ac08$export$20cd2fa9001e90da)({
                ...(0, $62612e72aec86394$export$9ec4d9b90e0651f3),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "MapView":
            (0, $2d7a577398a8ac08$export$20cd2fa9001e90da)({
                ...(0, $62612e72aec86394$export$8b6b593c0f557e5e),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "StorageManager":
            (0, $2d7a577398a8ac08$export$20cd2fa9001e90da)({
                ...(0, $62612e72aec86394$export$5650166bd1af1e38),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
    }
    return 0, $85b840b81f21bd6d$export$8793edee2d425525;
};


function $060d76aa10a5b245$export$2e2bcd8739ae039({ componentName: componentName, packageName: packageName, version: version }) {
    (0, $2hDQc.useEffect)(()=>{
        const clearUserAgent = (0, $8afcbdccdeac7cde$export$57d3cdb500cb5402)({
            componentName: componentName,
            packageName: packageName,
            version: version
        });
        return clearUserAgent;
    }, [
        componentName,
        packageName,
        version
    ]);
}


const $b96c5d763660034f$export$a4ad2735b021c132 = "6.0.5";



var $2hDQc = parcelRequire("2hDQc");
/**
 * Logs a deprecation warning message.
 *
 * @important Please use the React/React Native specific platform implementations.
 * This version of the hook is a base implementation that the others extend from due
 * to env differences between running in RN or the browser
 */ const $47de4578d19a3245$export$2e2bcd8739ae039 = ({ shouldWarn: shouldWarn, message: message })=>{
    $2hDQc.useEffect(()=>{
        if (shouldWarn) // eslint-disable-next-line no-console
        console.warn(message);
    }, [
        shouldWarn,
        message
    ]);
};



var $54X9E = parcelRequire("54X9E");
/**
 * Logs a deprecation warning `message` to the console.
 */ const $f80c235def355e34$export$406e4c8585b97b03 = ({ message: message, shouldWarn: _shouldWarn })=>{
    const shouldWarn = _shouldWarn && // show message on builds without Node `process` polyfill
    // or with process.env.NODE_ENV not production
    (typeof $54X9E === "undefined" || $54X9E && false);
    (0, $47de4578d19a3245$export$2e2bcd8739ae039)({
        message: message,
        shouldWarn: shouldWarn
    });
};



var $2hDQc = parcelRequire("2hDQc");
const $089704face704122$export$da5ac45a736a5880 = // @ts-ignore
$2hDQc.createContext(null);
const $089704face704122$export$b0e9d19f717d0a5c = ()=>{
    const context = $2hDQc.useContext($089704face704122$export$da5ac45a736a5880);
    if (!context) throw new Error("`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`");
    return context;
};




var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");

/**
 * ConfirmSignIn
 */ const $1bf63f0ec1759aca$var$getChallengeText = (challengeName)=>{
    switch(challengeName){
        case "SMS_MFA":
            return (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CONFIRM_SMS);
        case "SOFTWARE_TOKEN_MFA":
            return (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CONFIRM_TOTP);
        default:
            throw new Error(`${(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)("Unexpected challengeName encountered in ConfirmSignIn:")} ${challengeName}`);
    }
};
/**
 * ConfirmSignUp
 */ const $1bf63f0ec1759aca$var$getDeliveryMessageText = (codeDeliveryDetails)=>{
    const { DeliveryMedium: DeliveryMedium, Destination: Destination } = codeDeliveryDetails ?? {};
    const isEmailMessage = DeliveryMedium === "EMAIL";
    const isTextMessage = DeliveryMedium === "SMS";
    const arrivalMessage = (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CODE_ARRIVAL);
    if (!(isEmailMessage || isTextMessage)) return `${(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CODE_SENT)}. ${arrivalMessage}.`;
    const instructionMessage = isEmailMessage ? (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CODE_EMAILED) : (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CODE_TEXTED);
    return `${instructionMessage} ${Destination}. ${arrivalMessage}.`;
};
const $1bf63f0ec1759aca$var$getDeliveryMethodText = (codeDeliveryDetails)=>{
    const { DeliveryMedium: DeliveryMedium } = codeDeliveryDetails ?? {};
    const isEmailMessage = DeliveryMedium === "EMAIL";
    const isTextMessage = DeliveryMedium === "SMS";
    if (!isEmailMessage && isTextMessage) return (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).WE_SENT_CODE);
    return isEmailMessage ? (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).WE_EMAILED) : (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).WE_TEXTED);
};
/**
 * FederatedSignIn
 */ const $1bf63f0ec1759aca$var$providerNameMap = {
    amazon: "Amazon",
    apple: "Apple",
    facebook: "Facebook",
    google: "Google"
};
const $1bf63f0ec1759aca$var$getSignInWithFederationText = (route, provider)=>{
    const isSignIn = route === "signIn";
    return (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(`Sign ${isSignIn ? "In" : "Up"} with ${$1bf63f0ec1759aca$var$providerNameMap[provider]}`);
};
const $1bf63f0ec1759aca$export$34e9c32aebe14fbb = {
    /** Shared */ getBackToSignInText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).BACK_SIGN_IN),
    getChangePasswordText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CHANGE_PASSWORD),
    getChangingText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CHANGING_PASSWORD),
    getConfirmText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CONFIRM),
    getConfirmingText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CONFIRMING),
    getCopyText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).UPPERCASE_COPY),
    getHidePasswordText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).HIDE_PASSWORD),
    getLoadingText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).LOADING),
    getOrText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).OR),
    getResendCodeText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).RESEND_CODE),
    getSendCodeText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SEND_CODE),
    getSendingText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SENDING),
    getShowPasswordText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SHOW_PASSWORD),
    getSubmitText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SUBMIT),
    getSubmittingText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SUBMITTING),
    /** SignInSignUpTabs */ getSignInTabText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SIGN_IN_TAB),
    getSignUpTabText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    /** SignIn */ getForgotPasswordText: (shortVersion)=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(shortVersion ? (0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).FORGOT_PASSWORD : (0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).FORGOT_YOUR_PASSWORD),
    getSigningInText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SIGNING_IN_BUTTON),
    getSignInText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SIGN_IN_BUTTON),
    /** SignUp */ getCreatingAccountText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CREATING_ACCOUNT),
    getCreateAccountText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    getDeliveryMessageText: /** ConfirmSignUp */ $1bf63f0ec1759aca$var$getDeliveryMessageText,
    getDeliveryMethodText: $1bf63f0ec1759aca$var$getDeliveryMethodText,
    getChallengeText: /** ConfirmSignIn */ $1bf63f0ec1759aca$var$getChallengeText,
    /** ForgotPassword */ getResetYourPasswordText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).RESET_PASSWORD),
    /** SetupTotp */ getSetupTotpText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SETUP_TOTP),
    // TODO: add defaultText for below
    getSetupTotpInstructionsText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)("Copy and paste the secret key below into an authenticator app and then enter the code in the text field below."),
    // TODO: add defaultText for "COPIED"
    getCopiedText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)("COPIED"),
    getSignInWithFederationText: /** FederatedSignIn */ $1bf63f0ec1759aca$var$getSignInWithFederationText,
    /** VerifyUser */ getSkipText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).SKIP),
    getVerifyText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).VERIFY),
    getVerifyContactText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).VERIFY_CONTACT),
    getAccountRecoveryInfoText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)((0, $9afaaee5b06e14b0$export$6ba37fd455cdd594).VERIFY_HEADING),
    /** Validations */ // TODO: add defaultText
    getInvalidEmailText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)("Please enter a valid email"),
    // TODO: add defaultText
    getRequiredFieldText: ()=>(0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)("This field is required")
}; // using `as const` so that keys are strongly typed



var $2hDQc = parcelRequire("2hDQc");

const $811347c147720737$export$ce4ab0c55987d1ff = (...args)=>{
    const classes = [];
    for (const arg of args){
        // skip falsey values
        if (!arg) continue;
        if ((0, $85b840b81f21bd6d$export$844ec244b1367d54)(arg)) {
            classes.push(arg);
            continue;
        }
        if (typeof arg === "number") {
            classes.push(arg.toString());
            continue;
        }
        if (Array.isArray(arg)) {
            classes.push($811347c147720737$export$ce4ab0c55987d1ff(...arg));
            continue;
        }
        if ((0, $85b840b81f21bd6d$export$a6cdc56e425d0d0a)(arg)) {
            // check if the object has a valid .toString() method
            if (arg.toString !== Object.prototype.toString && arg.toString() !== "[object Object]") {
                classes.push(arg.toString());
                continue;
            }
            for(const key in arg)if ((0, $85b840b81f21bd6d$export$a4f4bb6b1453fff5)(arg, key) && arg[key]) classes.push(key);
        }
    }
    return classes.join(" ");
};

const $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6 = {
    Accordion: "amplify-accordion",
    AccordionItem: "amplify-accordion__item",
    AccordionItemTrigger: "amplify-accordion__item__trigger",
    AccordionItemContent: "amplify-accordion__item__content",
    AccordionItemIcon: "amplify-accordion__item__icon",
    Alert: "amplify-alert",
    AlertIcon: "amplify-alert__icon",
    AlertHeading: "amplify-alert__heading",
    AlertBody: "amplify-alert__body",
    AlertDismiss: "amplify-alert__dismiss",
    Autocomplete: "amplify-autocomplete",
    AutocompleteMenu: "amplify-autocomplete__menu",
    AutocompleteMenuEmpty: "amplify-autocomplete__menu--empty",
    AutocompleteMenuFooter: "amplify-autocomplete__menu__footer",
    AutocompleteMenuHeader: "amplify-autocomplete__menu__header",
    AutocompleteMenuLoading: "amplify-autocomplete__menu--loading",
    AutocompleteMenuOption: "amplify-autocomplete__menu__option",
    AutocompleteMenuOptions: "amplify-autocomplete__menu__options",
    Badge: "amplify-badge",
    Breadcrumbs: "amplify-breadcrumbs",
    BreadcrumbsList: "amplify-breadcrumbs__list",
    BreadcrumbsItem: "amplify-breadcrumbs__item",
    BreadcrumbsSeparator: "amplify-breadcrumbs__separator",
    BreadcrumbsLink: "amplify-breadcrumbs__link",
    Button: "amplify-button",
    ButtonGroup: "amplify-buttongroup",
    ButtonLoaderWrapper: "amplify-button__loader-wrapper",
    Card: "amplify-card",
    Checkbox: "amplify-checkbox",
    CheckboxButton: "amplify-checkbox__button",
    CheckboxIcon: "amplify-checkbox__icon",
    CheckboxInput: "amplify-checkbox__input",
    CheckboxLabel: "amplify-checkbox__label",
    CheckboxField: "amplify-checkboxfield",
    Collection: "amplify-collection",
    CollectionItems: "amplify-collection-items",
    CollectionSearch: "amplify-collection-search",
    CollectionPagination: "amplify-collection-pagination",
    CountryCodeSelect: "amplify-countrycodeselect",
    DialCodeSelect: "amplify-dialcodeselect",
    Divider: "amplify-divider",
    DividerLabel: "amplify-divider--label",
    DropZone: "amplify-dropzone",
    Field: "amplify-field",
    FieldDescription: "amplify-field__description",
    FieldErrorMessage: "amplify-field__error-message",
    FieldGroup: "amplify-field-group",
    FieldGroupControl: "amplify-field-group__control",
    FieldGroupOuterEnd: "amplify-field-group__outer-end",
    FieldGroupOuterStart: "amplify-field-group__outer-start",
    FieldGroupInnerEnd: "amplify-field-group__inner-end",
    FieldGroupInnerStart: "amplify-field-group__inner-start",
    FieldGroupIcon: "amplify-field-group__icon",
    FieldGroupIconButton: "amplify-field-group__icon-button",
    FieldGroupHasInnerEnd: "amplify-field-group--has-inner-end",
    FieldGroupHasInnerStart: "amplify-field-group--has-inner-start",
    FieldShowPassword: "amplify-field__show-password",
    FieldGroupFieldWrapper: "amplify-field-group__field-wrapper",
    Fieldset: "amplify-fieldset",
    FieldsetLegend: "amplify-fieldset__legend",
    Flex: "amplify-flex",
    Grid: "amplify-grid",
    Heading: "amplify-heading",
    HighlightMatch: "amplify-highlightmatch",
    HighlightMatchHighlighted: "amplify-highlightmatch__highlighted",
    Icon: "amplify-icon",
    Image: "amplify-image",
    Input: "amplify-input",
    Label: "amplify-label",
    Link: "amplify-link",
    Loader: "amplify-loader",
    LoaderLabel: "amplify-loader__label",
    MenuContent: "amplify-menu__content",
    MenuItem: "amplify-menu__content__item",
    MenuTrigger: "amplify-menu__trigger",
    MenuWrapper: "amplify-menu__wrapper",
    Message: "amplify-message",
    MessageIcon: "amplify-message__icon",
    MessageHeading: "amplify-message__heading",
    MessageBody: "amplify-message__body",
    MessageContent: "amplify-message__content",
    MessageDismiss: "amplify-message__dismiss",
    Pagination: "amplify-pagination",
    PaginationItem: "amplify-pagination__item",
    PasswordField: "amplify-passwordfield",
    PhoneNumberField: "amplify-phonenumberfield",
    Placeholder: "amplify-placeholder",
    Radio: "amplify-radio",
    RadioButton: "amplify-radio__button",
    RadioInput: "amplify-radio__input",
    RadioLabel: "amplify-radio__label",
    RadioGroupField: "amplify-radiogroupfield",
    RadioGroup: "amplify-radiogroup",
    Rating: "amplify-rating",
    RatingItem: "amplify-rating__item",
    RatingIcon: "amplify-rating__icon",
    RatingLabel: "amplify-rating__label",
    ScrollView: "amplify-scrollview",
    SearchField: "amplify-searchfield",
    SearchFieldClear: "amplify-searchfield__clear",
    SearchFieldSearch: "amplify-searchfield__search",
    Select: "amplify-select",
    SelectField: "amplify-selectfield",
    SelectWrapper: "amplify-select__wrapper",
    SelectIcon: "amplify-select__icon",
    SliderField: "amplify-sliderfield",
    SliderFieldGroup: "amplify-sliderfield__group",
    SliderFieldLabel: "amplify-sliderfield__label",
    SliderFieldRange: "amplify-sliderfield__range",
    SliderFieldRoot: "amplify-sliderfield__root",
    SliderFieldThumb: "amplify-sliderfield__thumb",
    SliderFieldTrack: "amplify-sliderfield__track",
    StepperField: "amplify-stepperfield",
    StepperFieldButtonDecrease: "amplify-stepperfield__button--decrease",
    StepperFieldButtonIncrease: "amplify-stepperfield__button--increase",
    StepperFieldInput: "amplify-stepperfield__input",
    StorageImage: "amplify-storageimage",
    StorageManager: "amplify-storagemanager",
    StorageManagerDropZone: "amplify-storagemanager__dropzone",
    StorageManagerDropZoneIcon: "amplify-storagemanager__dropzone__icon",
    StorageManagerDropZoneText: "amplify-storagemanager__dropzone__text",
    StorageManagerFilePicker: "amplify-storagemanager__file__picker",
    StorageManagerFile: "amplify-storagemanager__file",
    StorageManagerFileWrapper: "amplify-storagemanager__file__wrapper",
    StorageManagerFileList: "amplify-storagemanager__file__list",
    StorageManagerFileName: "amplify-storagemanager__file__name",
    StorageManagerFileSize: "amplify-storagemanager__file__size",
    StorageManagerFileInfo: "amplify-storagemanager__file__info",
    StorageManagerFileImage: "amplify-storagemanager__file__image",
    StorageManagerFileMain: "amplify-storagemanager__file__main",
    StorageManagerFileStatus: "amplify-storagemanager__file__status",
    StorageManagerLoader: "amplify-storagemanager__loader",
    StorageManagerPreviewer: "amplify-storagemanager__previewer",
    StorageManagerPreviewerText: "amplify-storagemanager__previewer__text",
    StorageManagerPreviewerActions: "amplify-storagemanager__previewer__actions",
    StorageManagerPreviewerFooter: "amplify-storagemanager__previewer__footer",
    SwitchField: "amplify-switchfield",
    SwitchLabel: "amplify-switch__label",
    SwitchThumb: "amplify-switch__thumb",
    SwitchTrack: "amplify-switch__track",
    SwitchWrapper: "amplify-switch__wrapper",
    Table: "amplify-table",
    TableCaption: "amplify-table__caption",
    TableBody: "amplify-table__body",
    TableTd: "amplify-table__td",
    TableTh: "amplify-table__th",
    TableFoot: "amplify-table__foot",
    TableHead: "amplify-table__head",
    TableRow: "amplify-table__row",
    Tabs: "amplify-tabs",
    TabsList: "amplify-tabs__list",
    TabsItem: "amplify-tabs__item",
    TabsPanel: "amplify-tabs__panel",
    Text: "amplify-text",
    Textarea: "amplify-textarea",
    TextAreaField: "amplify-textareafield",
    TextField: "amplify-textfield",
    ToggleButton: "amplify-togglebutton",
    ToggleButtonGroup: "amplify-togglebuttongroup",
    VisuallyHidden: "amplify-visually-hidden"
};



var $2hDQc = parcelRequire("2hDQc");
/**
 * Updates the return type for primitives wrapped in `React.forwardRef` to
 * `React.ReactElement`. In React 18 the return type of `React.ExoticComponent`
 * was changed from `React.ReactElement` to `React.ReactNode`, which breaks
 * clients using React 16 and 17.
 *
 * @param primitive UI Primitive to be wrapped with `React.forwardRef`
 * @returns ForwaredRef wrapped UI Primitive
 */ const $62181de68de3c447$export$44aa160b17c73194 = (primitive)=>$2hDQc.forwardRef(primitive);



var $2hDQc = parcelRequire("2hDQc");
const $7bec285a424993af$export$74e4d3bc6dc1117 = $2hDQc.createContext({
    isFieldsetDisabled: false
});
/**
 * @description Fieldsets in HTML can be disabled, which disables all child
 * fieldsets and input controls. `useFieldset` passes the disabled state down
 * via context.
 */ const $7bec285a424993af$export$b140571ec72925dd = ()=>$2hDQc.useContext($7bec285a424993af$export$74e4d3bc6dc1117);



var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
var $678d163f58d956fe$exports = {};
var $b1a8e42f6a8537fe$exports = {};
var $328b576f2214a685$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $328b576f2214a685$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$328b576f2214a685$exports = $328b576f2214a685$var$arrayReduce;


var $d42b1e9fdfb29cc6$exports = {};
var $fdac625d103770aa$exports = {};
var $7282dcc76e78a5bc$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $7282dcc76e78a5bc$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$7282dcc76e78a5bc$exports = $7282dcc76e78a5bc$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $fdac625d103770aa$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $fdac625d103770aa$var$deburrLetter = $7282dcc76e78a5bc$exports($fdac625d103770aa$var$deburredLetters);
$fdac625d103770aa$exports = $fdac625d103770aa$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $d42b1e9fdfb29cc6$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $d42b1e9fdfb29cc6$var$rsComboMarksRange = "\\u0300-\\u036f", $d42b1e9fdfb29cc6$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $d42b1e9fdfb29cc6$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $d42b1e9fdfb29cc6$var$rsComboRange = $d42b1e9fdfb29cc6$var$rsComboMarksRange + $d42b1e9fdfb29cc6$var$reComboHalfMarksRange + $d42b1e9fdfb29cc6$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $d42b1e9fdfb29cc6$var$rsCombo = "[" + $d42b1e9fdfb29cc6$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $d42b1e9fdfb29cc6$var$reComboMark = RegExp($d42b1e9fdfb29cc6$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $d42b1e9fdfb29cc6$var$deburr(string) {
    string = $5f889ff337c3b19a$exports(string);
    return string && string.replace($d42b1e9fdfb29cc6$var$reLatin, $fdac625d103770aa$exports).replace($d42b1e9fdfb29cc6$var$reComboMark, "");
}
$d42b1e9fdfb29cc6$exports = $d42b1e9fdfb29cc6$var$deburr;


var $edceeb447344616f$exports = {};
var $e7c06cb4256c3a00$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $e7c06cb4256c3a00$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $e7c06cb4256c3a00$var$asciiWords(string) {
    return string.match($e7c06cb4256c3a00$var$reAsciiWord) || [];
}
$e7c06cb4256c3a00$exports = $e7c06cb4256c3a00$var$asciiWords;


var $c37acf538d2c5ff3$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $c37acf538d2c5ff3$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $c37acf538d2c5ff3$var$hasUnicodeWord(string) {
    return $c37acf538d2c5ff3$var$reHasUnicodeWord.test(string);
}
$c37acf538d2c5ff3$exports = $c37acf538d2c5ff3$var$hasUnicodeWord;



var $95212725557b18d7$exports = {};
/** Used to compose unicode character classes. */ var $95212725557b18d7$var$rsAstralRange = "\ud800-\udfff", $95212725557b18d7$var$rsComboMarksRange = "\\u0300-\\u036f", $95212725557b18d7$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $95212725557b18d7$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $95212725557b18d7$var$rsComboRange = $95212725557b18d7$var$rsComboMarksRange + $95212725557b18d7$var$reComboHalfMarksRange + $95212725557b18d7$var$rsComboSymbolsRange, $95212725557b18d7$var$rsDingbatRange = "\\u2700-\\u27bf", $95212725557b18d7$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $95212725557b18d7$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $95212725557b18d7$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $95212725557b18d7$var$rsPunctuationRange = "\\u2000-\\u206f", $95212725557b18d7$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $95212725557b18d7$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $95212725557b18d7$var$rsVarRange = "\\ufe0e\\ufe0f", $95212725557b18d7$var$rsBreakRange = $95212725557b18d7$var$rsMathOpRange + $95212725557b18d7$var$rsNonCharRange + $95212725557b18d7$var$rsPunctuationRange + $95212725557b18d7$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $95212725557b18d7$var$rsApos = "['\u2019]", $95212725557b18d7$var$rsBreak = "[" + $95212725557b18d7$var$rsBreakRange + "]", $95212725557b18d7$var$rsCombo = "[" + $95212725557b18d7$var$rsComboRange + "]", $95212725557b18d7$var$rsDigits = "\\d+", $95212725557b18d7$var$rsDingbat = "[" + $95212725557b18d7$var$rsDingbatRange + "]", $95212725557b18d7$var$rsLower = "[" + $95212725557b18d7$var$rsLowerRange + "]", $95212725557b18d7$var$rsMisc = "[^" + $95212725557b18d7$var$rsAstralRange + $95212725557b18d7$var$rsBreakRange + $95212725557b18d7$var$rsDigits + $95212725557b18d7$var$rsDingbatRange + $95212725557b18d7$var$rsLowerRange + $95212725557b18d7$var$rsUpperRange + "]", $95212725557b18d7$var$rsFitz = "\ud83c[\udffb-\udfff]", $95212725557b18d7$var$rsModifier = "(?:" + $95212725557b18d7$var$rsCombo + "|" + $95212725557b18d7$var$rsFitz + ")", $95212725557b18d7$var$rsNonAstral = "[^" + $95212725557b18d7$var$rsAstralRange + "]", $95212725557b18d7$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $95212725557b18d7$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $95212725557b18d7$var$rsUpper = "[" + $95212725557b18d7$var$rsUpperRange + "]", $95212725557b18d7$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $95212725557b18d7$var$rsMiscLower = "(?:" + $95212725557b18d7$var$rsLower + "|" + $95212725557b18d7$var$rsMisc + ")", $95212725557b18d7$var$rsMiscUpper = "(?:" + $95212725557b18d7$var$rsUpper + "|" + $95212725557b18d7$var$rsMisc + ")", $95212725557b18d7$var$rsOptContrLower = "(?:" + $95212725557b18d7$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $95212725557b18d7$var$rsOptContrUpper = "(?:" + $95212725557b18d7$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $95212725557b18d7$var$reOptMod = $95212725557b18d7$var$rsModifier + "?", $95212725557b18d7$var$rsOptVar = "[" + $95212725557b18d7$var$rsVarRange + "]?", $95212725557b18d7$var$rsOptJoin = "(?:" + $95212725557b18d7$var$rsZWJ + "(?:" + [
    $95212725557b18d7$var$rsNonAstral,
    $95212725557b18d7$var$rsRegional,
    $95212725557b18d7$var$rsSurrPair
].join("|") + ")" + $95212725557b18d7$var$rsOptVar + $95212725557b18d7$var$reOptMod + ")*", $95212725557b18d7$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $95212725557b18d7$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $95212725557b18d7$var$rsSeq = $95212725557b18d7$var$rsOptVar + $95212725557b18d7$var$reOptMod + $95212725557b18d7$var$rsOptJoin, $95212725557b18d7$var$rsEmoji = "(?:" + [
    $95212725557b18d7$var$rsDingbat,
    $95212725557b18d7$var$rsRegional,
    $95212725557b18d7$var$rsSurrPair
].join("|") + ")" + $95212725557b18d7$var$rsSeq;
/** Used to match complex or compound words. */ var $95212725557b18d7$var$reUnicodeWord = RegExp([
    $95212725557b18d7$var$rsUpper + "?" + $95212725557b18d7$var$rsLower + "+" + $95212725557b18d7$var$rsOptContrLower + "(?=" + [
        $95212725557b18d7$var$rsBreak,
        $95212725557b18d7$var$rsUpper,
        "$"
    ].join("|") + ")",
    $95212725557b18d7$var$rsMiscUpper + "+" + $95212725557b18d7$var$rsOptContrUpper + "(?=" + [
        $95212725557b18d7$var$rsBreak,
        $95212725557b18d7$var$rsUpper + $95212725557b18d7$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $95212725557b18d7$var$rsUpper + "?" + $95212725557b18d7$var$rsMiscLower + "+" + $95212725557b18d7$var$rsOptContrLower,
    $95212725557b18d7$var$rsUpper + "+" + $95212725557b18d7$var$rsOptContrUpper,
    $95212725557b18d7$var$rsOrdUpper,
    $95212725557b18d7$var$rsOrdLower,
    $95212725557b18d7$var$rsDigits,
    $95212725557b18d7$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $95212725557b18d7$var$unicodeWords(string) {
    return string.match($95212725557b18d7$var$reUnicodeWord) || [];
}
$95212725557b18d7$exports = $95212725557b18d7$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $edceeb447344616f$var$words(string, pattern, guard) {
    string = $5f889ff337c3b19a$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $c37acf538d2c5ff3$exports(string) ? $95212725557b18d7$exports(string) : $e7c06cb4256c3a00$exports(string);
    return string.match(pattern) || [];
}
$edceeb447344616f$exports = $edceeb447344616f$var$words;


/** Used to compose unicode capture groups. */ var $b1a8e42f6a8537fe$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $b1a8e42f6a8537fe$var$reApos = RegExp($b1a8e42f6a8537fe$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $b1a8e42f6a8537fe$var$createCompounder(callback) {
    return function(string) {
        return $328b576f2214a685$exports($edceeb447344616f$exports($d42b1e9fdfb29cc6$exports(string).replace($b1a8e42f6a8537fe$var$reApos, "")), callback, "");
    };
}
$b1a8e42f6a8537fe$exports = $b1a8e42f6a8537fe$var$createCompounder;


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $678d163f58d956fe$var$kebabCase = $b1a8e42f6a8537fe$exports(function(result, word, index) {
    return result + (index ? "-" : "") + word.toLowerCase();
});
$678d163f58d956fe$exports = $678d163f58d956fe$var$kebabCase;


var $9a10b03a0a9b649b$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $49f035d74d9acef2$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $595110d12ec3d813$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const $595110d12ec3d813$var$defaults = {
    opening_character: "{",
    closing_character: "}",
    separator: "."
};
$595110d12ec3d813$exports = $595110d12ec3d813$var$defaults;


function $49f035d74d9acef2$var$createReferenceRegex(opts = {}) {
    const options = Object.assign({}, $595110d12ec3d813$exports, opts);
    return new RegExp("\\" + options.opening_character + "([^" + options.closing_character + "]+)" + "\\" + options.closing_character, "g");
}
$49f035d74d9acef2$exports = $49f035d74d9acef2$var$createReferenceRegex;


/**
 * Checks if the value uses a value reference.
 * @memberof Dictionary
 * @param {string} value
 * @param {Object|RegExp} regexOrOptions
 * @returns {boolean} - True, if the value uses a value reference
 */ function $9a10b03a0a9b649b$var$usesReference(value, regexOrOptions = {}) {
    const regex = regexOrOptions instanceof RegExp ? regexOrOptions : $49f035d74d9acef2$exports(regexOrOptions);
    if (typeof value === "string") return regex.test(value);
    if (typeof value === "object") {
        let hasReference = false;
        // iterate over each property in the object,
        // if any element passes the regex test,
        // the whole thing should be true
        for(const key in value)if (value.hasOwnProperty(key)) {
            const element = value[key];
            let reference = $9a10b03a0a9b649b$var$usesReference(element, regexOrOptions);
            if (reference) {
                hasReference = true;
                break;
            }
        }
        return hasReference;
    }
    return false;
}
$9a10b03a0a9b649b$exports = $9a10b03a0a9b649b$var$usesReference;





const $b706ac0725f36f03$export$f9ebafeabd662d32 = "amplify";
// Important: these properties should not be altered in
// order to maintain the expected order of the CSS `box-shadow` property
const $b706ac0725f36f03$var$SHADOW_PROPERTIES = [
    "offsetX",
    "offsetY",
    "blurRadius",
    "spreadRadius",
    "color"
];
function $b706ac0725f36f03$var$referenceValue(value) {
    if (!value) return "";
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9a10b03a0a9b649b$exports)))(value)) {
        const path = value.replace(/\{|\}/g, "").replace(".value", "").split(".");
        return `var(--${$b706ac0725f36f03$export$8658ddf1aae625a3({
            path: path
        })})`;
    }
    return value;
}
function $b706ac0725f36f03$export$55101aa37e5c1f8f(token) {
    const { value: value } = token;
    if ((0, $85b840b81f21bd6d$export$844ec244b1367d54)(value)) return $b706ac0725f36f03$var$referenceValue(value);
    if ($b706ac0725f36f03$export$50306062f6ed54c(value)) return $b706ac0725f36f03$var$SHADOW_PROPERTIES.map((property)=>{
        return $b706ac0725f36f03$var$referenceValue(// lookup property against `token` first for custom non-nested value, then lookup
        // property against `value` for design token value
        $b706ac0725f36f03$export$50306062f6ed54c(token) ? token[property] : value[property]);
    }).join(" ");
    return value;
}
function $b706ac0725f36f03$export$8658ddf1aae625a3({ path: path = [] }) {
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($678d163f58d956fe$exports)))([
        $b706ac0725f36f03$export$f9ebafeabd662d32,
        ...path
    ].join(" "))}`;
}
/**
 * Helper function to test if something is a design token or not.
 * Used in the React component style props.
 *
 * @param value - thing to test if it is a design token or not
 * @returns boolean
 */ function $b706ac0725f36f03$export$daee9cd42beef6d1(value) {
    return (0, $85b840b81f21bd6d$export$a6cdc56e425d0d0a)(value) && (0, $85b840b81f21bd6d$export$a4f4bb6b1453fff5)(value, "value");
}
function $b706ac0725f36f03$export$50306062f6ed54c(value) {
    return (0, $85b840b81f21bd6d$export$a6cdc56e425d0d0a)(value) && (0, $85b840b81f21bd6d$export$a4f4bb6b1453fff5)(value, "offsetX");
}
/**
 * Recursive function that will walk down the token object
 * and perform the setupToken function on each token.
 * Similar to what Style Dictionary does.
 */ function $b706ac0725f36f03$export$4ae67d38aae8ca2e({ tokens: tokens, path: path = [], setupToken: setupToken }) {
    if ((0, $85b840b81f21bd6d$export$a4f4bb6b1453fff5)(tokens, "value")) return setupToken({
        token: tokens,
        path: path
    });
    const output = {};
    for(const name in tokens)if ((0, $85b840b81f21bd6d$export$a4f4bb6b1453fff5)(tokens, name)) {
        const value = tokens[name];
        const nextTokens = (0, $85b840b81f21bd6d$export$a6cdc56e425d0d0a)(value) ? value : {
            value: value
        };
        output[name] = $b706ac0725f36f03$export$4ae67d38aae8ca2e({
            tokens: nextTokens,
            path: path.concat(name),
            setupToken: setupToken
        });
    }
    return output;
}


/**
 * @internal May be removed in a future version
 * Maps from component style props to React `style` props
 * Note: Primarily needed to map from component style props that don't match CSS Properties directly
 * such as wrap => flexWrap and direction => flexDirection
 */ const $2dee35cb0db75fdf$export$c69338bc7d797351 = {
    alignContent: "alignContent",
    alignItems: "alignItems",
    alignSelf: "alignSelf",
    area: "gridArea",
    aspectRatio: "aspectRatio",
    autoColumns: "gridAutoColumns",
    autoFlow: "gridAutoFlow",
    autoRows: "gridAutoRows",
    backgroundColor: "backgroundColor",
    backgroundImage: "backgroundImage",
    basis: "flexBasis",
    border: "border",
    borderRadius: "borderRadius",
    borderColor: "borderColor",
    borderWidth: "borderWidth",
    borderStyle: "borderStyle",
    bottom: "bottom",
    boxShadow: "boxShadow",
    color: "color",
    column: "gridColumn",
    columnEnd: "gridColumnEnd",
    columnGap: "columnGap",
    columnSpan: "gridColumn",
    columnStart: "gridColumnStart",
    direction: "flexDirection",
    display: "display",
    flex: "flex",
    fontFamily: "fontFamily",
    fontSize: "fontSize",
    fontStyle: "fontStyle",
    fontWeight: "fontWeight",
    gap: "gap",
    grow: "flexGrow",
    height: "height",
    justifyContent: "justifyContent",
    left: "left",
    letterSpacing: "letterSpacing",
    lineHeight: "lineHeight",
    margin: "margin",
    marginBlock: "marginBlock",
    marginBlockEnd: "marginBlockEnd",
    marginBlockStart: "marginBlockStart",
    marginBottom: "marginBlockEnd",
    marginInline: "marginInline",
    marginInlineEnd: "marginInlineEnd",
    marginInlineStart: "marginInlineStart",
    marginLeft: "marginInlineStart",
    marginRight: "marginInlineEnd",
    marginTop: "marginBlockStart",
    maxHeight: "maxHeight",
    maxWidth: "maxWidth",
    minHeight: "minHeight",
    minWidth: "minWidth",
    objectFit: "objectFit",
    objectPosition: "objectPosition",
    opacity: "opacity",
    order: "order",
    overflow: "overflow",
    padding: "padding",
    paddingBlock: "paddingBlock",
    paddingBlockEnd: "paddingBlockEnd",
    paddingBlockStart: "paddingBlockStart",
    paddingBottom: "paddingBlockEnd",
    paddingInline: "paddingInline",
    paddingInlineEnd: "paddingInlineEnd",
    paddingInlineStart: "paddingInlineStart",
    paddingLeft: "paddingInlineStart",
    paddingRight: "paddingInlineEnd",
    paddingTop: "paddingBlockStart",
    position: "position",
    resize: "resize",
    right: "right",
    row: "gridRow",
    rowEnd: "gridRowEnd",
    rowGap: "rowGap",
    rowSpan: "gridRow",
    rowStart: "gridRowStart",
    shrink: "flexShrink",
    templateAreas: "gridTemplateAreas",
    templateColumns: "gridTemplateColumns",
    templateRows: "gridTemplateRows",
    textAlign: "textAlign",
    textDecoration: "textDecoration",
    textTransform: "textTransform",
    top: "top",
    transform: "transform",
    transformOrigin: "transformOrigin",
    width: "width",
    whiteSpace: "whiteSpace",
    wrap: "flexWrap"
};
/**
 * @internal May be removed in a future version
 */ const $2dee35cb0db75fdf$export$885e0ebc08cdd9a0 = Object.keys($2dee35cb0db75fdf$export$c69338bc7d797351);


const $7bc43641dca04e6a$export$6f3cc5789c9e770e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $dd63c221f0429332$export$8f45430ccf837300 = {
    red: {
        10: {
            value: "hsl(0, 75%, 95%)"
        },
        20: {
            value: "hsl(0, 75%, 85%)"
        },
        40: {
            value: "hsl(0, 75%, 75%)"
        },
        60: {
            value: "hsl(0, 50%, 50%)"
        },
        80: {
            value: "hsl(0, 95%, 30%)"
        },
        90: {
            value: "hsl(0, 100%, 20%)"
        },
        100: {
            value: "hsl(0, 100%, 15%)"
        }
    },
    orange: {
        10: {
            value: "hsl(30, 75%, 95%)"
        },
        20: {
            value: "hsl(30, 75%, 85%)"
        },
        40: {
            value: "hsl(30, 75%, 75%)"
        },
        60: {
            value: "hsl(30, 50%, 50%)"
        },
        80: {
            value: "hsl(30, 95%, 30%)"
        },
        90: {
            value: "hsl(30, 100%, 20%)"
        },
        100: {
            value: "hsl(30, 100%, 15%)"
        }
    },
    yellow: {
        10: {
            value: "hsl(60, 75%, 95%)"
        },
        20: {
            value: "hsl(60, 75%, 85%)"
        },
        40: {
            value: "hsl(60, 75%, 75%)"
        },
        60: {
            value: "hsl(60, 50%, 50%)"
        },
        80: {
            value: "hsl(60, 95%, 30%)"
        },
        90: {
            value: "hsl(60, 100%, 20%)"
        },
        100: {
            value: "hsl(60, 100%, 15%)"
        }
    },
    green: {
        10: {
            value: "hsl(130, 60%, 95%)"
        },
        20: {
            value: "hsl(130, 60%, 90%)"
        },
        40: {
            value: "hsl(130, 44%, 63%)"
        },
        60: {
            value: "hsl(130, 43%, 46%)"
        },
        80: {
            value: "hsl(130, 33%, 37%)"
        },
        90: {
            value: "hsl(130, 27%, 29%)"
        },
        100: {
            value: "hsl(130, 22%, 23%)"
        }
    },
    teal: {
        10: {
            value: "hsl(190, 75%, 95%)"
        },
        20: {
            value: "hsl(190, 75%, 85%)"
        },
        40: {
            value: "hsl(190, 70%, 70%)"
        },
        60: {
            value: "hsl(190, 50%, 50%)"
        },
        80: {
            value: "hsl(190, 95%, 30%)"
        },
        90: {
            value: "hsl(190, 100%, 20%)"
        },
        100: {
            value: "hsl(190, 100%, 15%)"
        }
    },
    blue: {
        10: {
            value: "hsl(220, 95%, 95%)"
        },
        20: {
            value: "hsl(220, 85%, 85%)"
        },
        40: {
            value: "hsl(220, 70%, 70%)"
        },
        60: {
            value: "hsl(220, 50%, 50%)"
        },
        80: {
            value: "hsl(220, 95%, 30%)"
        },
        90: {
            value: "hsl(220, 100%, 20%)"
        },
        100: {
            value: "hsl(220, 100%, 15%)"
        }
    },
    purple: {
        10: {
            value: "hsl(300, 95%, 95%)"
        },
        20: {
            value: "hsl(300, 85%, 85%)"
        },
        40: {
            value: "hsl(300, 70%, 70%)"
        },
        60: {
            value: "hsl(300, 50%, 50%)"
        },
        80: {
            value: "hsl(300, 95%, 30%)"
        },
        90: {
            value: "hsl(300, 100%, 20%)"
        },
        100: {
            value: "hsl(300, 100%, 15%)"
        }
    },
    pink: {
        10: {
            value: "hsl(340, 95%, 95%)"
        },
        20: {
            value: "hsl(340, 90%, 85%)"
        },
        40: {
            value: "hsl(340, 70%, 70%)"
        },
        60: {
            value: "hsl(340, 50%, 50%)"
        },
        80: {
            value: "hsl(340, 95%, 30%)"
        },
        90: {
            value: "hsl(340, 100%, 20%)"
        },
        100: {
            value: "hsl(340, 100%, 15%)"
        }
    },
    neutral: {
        10: {
            value: "hsl(210, 5%, 98%)"
        },
        20: {
            value: "hsl(210, 5%, 94%)"
        },
        40: {
            value: "hsl(210, 5%, 87%)"
        },
        60: {
            value: "hsl(210, 10%, 58%)"
        },
        80: {
            value: "hsl(210, 10%, 40%)"
        },
        90: {
            value: "hsl(210, 25%, 25%)"
        },
        100: {
            value: "hsl(210, 50%, 10%)"
        }
    },
    primary: {
        10: {
            value: "{colors.teal.10.value}"
        },
        20: {
            value: "{colors.teal.20.value}"
        },
        40: {
            value: "{colors.teal.40.value}"
        },
        60: {
            value: "{colors.teal.60.value}"
        },
        80: {
            value: "{colors.teal.80.value}"
        },
        90: {
            value: "{colors.teal.90.value}"
        },
        100: {
            value: "{colors.teal.100.value}"
        }
    },
    secondary: {
        10: {
            value: "{colors.purple.10.value}"
        },
        20: {
            value: "{colors.purple.20.value}"
        },
        40: {
            value: "{colors.purple.40.value}"
        },
        60: {
            value: "{colors.purple.60.value}"
        },
        80: {
            value: "{colors.purple.80.value}"
        },
        90: {
            value: "{colors.purple.90.value}"
        },
        100: {
            value: "{colors.purple.100.value}"
        }
    },
    font: {
        primary: {
            value: "{colors.neutral.100.value}"
        },
        secondary: {
            value: "{colors.neutral.90.value}"
        },
        tertiary: {
            value: "{colors.neutral.80.value}"
        },
        disabled: {
            value: "{colors.neutral.60.value}"
        },
        inverse: {
            value: "{colors.white.value}"
        },
        interactive: {
            value: "{colors.primary.80.value}"
        },
        // Hover and Focus colors are intentionally different colors.
        // This allows users to distinguish between the current keyboard focus
        // and the location of their pointer
        hover: {
            value: "{colors.primary.90.value}"
        },
        // Focus color is set to 100 to ensure enough contrast for accessibility
        focus: {
            value: "{colors.primary.100.value}"
        },
        active: {
            value: "{colors.primary.100.value}"
        },
        info: {
            value: "{colors.blue.90.value}"
        },
        warning: {
            value: "{colors.orange.90.value}"
        },
        error: {
            value: "{colors.red.90.value}"
        },
        success: {
            value: "{colors.green.90.value}"
        }
    },
    background: {
        primary: {
            value: "{colors.white.value}"
        },
        secondary: {
            value: "{colors.neutral.10.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        quaternary: {
            value: "{colors.neutral.60.value}"
        },
        disabled: {
            value: "{colors.background.tertiary.value}"
        },
        info: {
            value: "{colors.blue.10.value}"
        },
        warning: {
            value: "{colors.orange.10.value}"
        },
        error: {
            value: "{colors.red.10.value}"
        },
        success: {
            value: "{colors.green.10.value}"
        }
    },
    border: {
        primary: {
            value: "{colors.neutral.60.value}"
        },
        secondary: {
            value: "{colors.neutral.40.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        disabled: {
            value: "{colors.border.tertiary.value}"
        },
        pressed: {
            value: "{colors.primary.100.value}"
        },
        // Focus color is set to 100 to ensure enough contrast for accessibility
        focus: {
            value: "{colors.primary.100.value}"
        },
        error: {
            value: "{colors.red.80.value}"
        },
        info: {
            value: "{colors.blue.80.value}"
        },
        success: {
            value: "{colors.green.80.value}"
        },
        warning: {
            value: "{colors.orange.80.value}"
        }
    },
    shadow: {
        primary: {
            value: "hsla(210, 50%, 10%, 0.25)"
        },
        secondary: {
            value: "hsla(210, 50%, 10%, 0.15)"
        },
        tertiary: {
            value: "hsla(210, 50%, 10%, 0.05)"
        }
    },
    overlay: {
        5: {
            value: "hsla(0, 0%, 0%, 0.05)"
        },
        10: {
            value: "hsla(0, 0%, 0%, 0.1)"
        },
        20: {
            value: "hsla(0, 0%, 0%, 0.2)"
        },
        30: {
            value: "hsla(0, 0%, 0%, 0.3)"
        },
        40: {
            value: "hsla(0, 0%, 0%, 0.4)"
        },
        50: {
            value: "hsla(0, 0%, 0%, 0.5)"
        },
        60: {
            value: "hsla(0, 0%, 0%, 0.6)"
        },
        70: {
            value: "hsla(0, 0%, 0%, 0.7)"
        },
        80: {
            value: "hsla(0, 0%, 0%, 0.8)"
        },
        90: {
            value: "hsla(0, 0%, 0%, 0.9)"
        }
    },
    black: {
        value: "hsl(0, 0%, 0%)"
    },
    white: {
        value: "hsl(0, 0%, 100%)"
    },
    transparent: {
        value: "transparent"
    }
};


const $4836dd2c5887122c$export$5ea928c9faf85bd3 = {
    // Default styles
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "space-between"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    // Variations
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    }
};


const $cbb47b2ce649a112$export$485ded5f26ebe08d = {
    menu: {
        width: {
            value: "100%"
        },
        marginBlockStart: {
            value: "{space.xxxs}"
        },
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        options: {
            display: {
                value: "flex"
            },
            flexDirection: {
                value: "column"
            },
            maxHeight: {
                value: "300px"
            }
        },
        option: {
            backgroundColor: {
                value: "{colors.background.primary}"
            },
            color: {
                value: "currentcolor"
            },
            cursor: {
                value: "pointer"
            },
            transitionDuration: {
                value: "{time.short}"
            },
            transitionProperty: {
                value: "background-color, color"
            },
            transitionTimingFunction: {
                value: "ease"
            },
            _active: {
                backgroundColor: {
                    value: "{colors.primary.80}"
                },
                color: {
                    value: "{colors.white}"
                }
            }
        },
        _empty: {
            display: {
                value: "flex"
            }
        },
        _loading: {
            alignItems: {
                value: "center"
            },
            display: {
                value: "flex"
            },
            gap: {
                value: "{space.xxxs}"
            }
        },
        spaceShared: {
            paddingBlock: {
                value: "{space.xs}"
            },
            paddingInline: {
                value: "{space.small}"
            }
        }
    }
};


const $8c0c2be9281ce619$export$d5cb6eef88ffbde2 = {
    maxWidth: {
        value: "60rem"
    },
    modal: {
        width: {
            value: "{space.relative.full}"
        },
        height: {
            value: "{space.relative.full}"
        },
        backgroundColor: {
            value: "{colors.overlay.50.value}"
        },
        top: {
            value: "{space.zero}"
        },
        left: {
            value: "{space.zero}"
        }
    },
    container: {
        widthMax: {
            value: "30rem"
        }
    },
    router: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    },
    footer: {
        paddingBottom: {
            value: "{space.medium.value}"
        }
    },
    form: {
        padding: {
            value: "{space.xl.value}"
        }
    },
    state: {
        inactive: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    orContainer: {
        color: {
            value: "{colors.neutral.80.value}"
        },
        orLine: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    }
};


const $fc55beed687a5aed$export$4aebd143f31d0c0d = {
    // Default styles
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: "{fontWeights.semibold.value}"
    },
    fontSize: {
        value: "{fontSizes.small.value}"
    },
    textAlign: {
        value: "center"
    },
    paddingVertical: {
        value: "{space.xs.value}"
    },
    paddingHorizontal: {
        value: "{space.small.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    // An arbitrarily large value to ensure that the left and right sides of the badge are perfectly rounded for any size variation
    borderRadius: {
        value: "{radii.xl.value}"
    },
    // Variations
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    // Sizes
    small: {
        fontSize: {
            value: "{fontSizes.xs.value}"
        },
        paddingVertical: {
            value: "{space.xxs.value}"
        },
        paddingHorizontal: {
            value: "{space.xs.value}"
        }
    },
    // medium is the default size
    large: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        }
    }
};


const $3afa51171f111525$export$515d2155aaad79e4 = {
    flexDirection: {
        value: "row"
    },
    flexWrap: {
        value: "wrap"
    },
    gap: {
        value: "0"
    },
    color: {
        value: "{colors.font.tertiary}"
    },
    item: {
        flexDirection: {
            value: "row"
        },
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        alignItems: {
            value: "center"
        },
        lineHeight: {
            value: "1"
        }
    },
    separator: {
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        paddingInline: {
            value: "{space.xxs}"
        }
    },
    link: {
        color: {
            value: "{components.link.color}"
        },
        fontSize: {
            value: "inherit"
        },
        fontWeight: {
            value: "normal"
        },
        textDecoration: {
            value: "none"
        },
        paddingInline: {
            value: "{space.xs}"
        },
        paddingBlock: {
            value: "{space.xxs}"
        },
        current: {
            color: {
                value: "inherit"
            },
            fontSize: {
                value: "inherit"
            },
            fontWeight: {
                value: "normal"
            },
            textDecoration: {
                value: "none"
            }
        }
    }
};


const $1912bd6df94634d5$export$2ba01fb71ed41cb6 = {
    // shared styles
    fontWeight: {
        value: "{fontWeights.bold.value}"
    },
    transitionDuration: {
        value: "{components.fieldcontrol.transitionDuration.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    lineHeight: {
        value: "{components.fieldcontrol.lineHeight.value}"
    },
    paddingBlockStart: {
        value: "{components.fieldcontrol.paddingBlockStart.value}"
    },
    paddingBlockEnd: {
        value: "{components.fieldcontrol.paddingBlockEnd.value}"
    },
    paddingInlineStart: {
        value: "{components.fieldcontrol.paddingInlineStart.value}"
    },
    paddingInlineEnd: {
        value: "{components.fieldcontrol.paddingInlineEnd.value}"
    },
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    borderWidth: {
        value: "{components.fieldcontrol.borderWidth.value}"
    },
    borderStyle: {
        value: "{components.fieldcontrol.borderStyle.value}"
    },
    borderRadius: {
        value: "{components.fieldcontrol.borderRadius.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.primary.10.value}"
        },
        borderColor: {
            value: "{colors.primary.60.value}"
        }
    },
    _focus: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.primary.10.value}"
        },
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    _active: {
        color: {
            value: "{colors.font.active.value}"
        },
        backgroundColor: {
            value: "{colors.primary.20.value}"
        },
        borderColor: {
            value: "{colors.primary.100.value}"
        }
    },
    _loading: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    // variations
    outlined: {
        info: {
            borderColor: {
                value: "{colors.blue.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.blue.60.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.info._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "{colors.orange.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.orange.60.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.warning._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "{colors.green.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.green.60.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.success._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "{colors.red.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.red.60.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "{colors.overlay.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.primary.value}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.overlay.60.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.neutral.100.value}"
                }
            }
        }
    },
    primary: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.primary.80.value}"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.100.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.blue.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.info._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.orange.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.green.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.success._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.overlay.70}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        }
    },
    menu: {
        borderWidth: {
            value: "{space.zero.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        justifyContent: {
            value: "start"
        },
        // Focus and hover styles are identical for menu variation
        // because for Menu primitive, menu items are forced to be focused even
        // for mouse interactions, making it impossible to distinguish the two interactions
        _hover: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.primary.80.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.primary.80.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.primary.90.value}"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    link: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.interactive.value}"
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.10.value}"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.10.value}"
            },
            color: {
                value: "{colors.font.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.20.value}"
            },
            color: {
                value: "{colors.font.active.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.info._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.warning._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.success._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.neutral.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.80.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            }
        }
    },
    warning: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.red.60}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        color: {
            value: "{colors.red.60}"
        },
        _hover: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.font.error}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.red.80}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "{colors.red.100}"
            },
            backgroundColor: {
                value: "{colors.red.20}"
            },
            color: {
                value: "{colors.red.100}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        }
    },
    destructive: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.red.60}"
        },
        color: {
            value: "{colors.font.inverse}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.100}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        }
    },
    // sizes
    small: {
        fontSize: {
            value: "{components.fieldcontrol.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.small.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.small.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.small.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.small.paddingInlineEnd.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.fieldcontrol.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.large.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.large.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.large.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.large.paddingInlineEnd.value}"
        }
    },
    loaderWrapper: {
        alignItems: {
            value: "center"
        },
        gap: {
            value: "{space.xs.value}"
        }
    }
};


const $00d7f2cbb7da7357$export$aa3e815946b80764 = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    borderWidth: {
        value: "0"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "transparent"
    },
    boxShadow: {
        value: "none"
    },
    padding: {
        value: "{space.medium.value}"
    },
    outlined: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        boxShadow: {
            value: "{components.card.boxShadow.value}"
        }
    },
    elevated: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "0"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "transparent"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    }
};


const $435c1abd3ebbceb4$export$b07e517d22efa1ca = {
    cursor: {
        value: "pointer"
    },
    alignItems: {
        value: "center"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        position: {
            value: "relative"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        before: {
            width: {
                value: "100%"
            },
            height: {
                value: "100%"
            },
            borderWidth: {
                value: "{borderWidths.medium.value}"
            },
            borderRadius: {
                value: "20%"
            },
            borderStyle: {
                value: "solid"
            },
            borderColor: {
                value: "{colors.border.primary.value}"
            }
        },
        _focus: {
            outlineColor: {
                value: "{colors.transparent.value}"
            },
            outlineStyle: {
                value: "solid"
            },
            outlineWidth: {
                value: "{outlineWidths.medium.value}"
            },
            outlineOffset: {
                value: "{outlineOffsets.medium.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderColor: {
                    value: "{colors.border.error.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        }
    },
    icon: {
        backgroundColor: {
            value: "{colors.primary.80.value}"
        },
        borderRadius: {
            value: "20%"
        },
        opacity: {
            value: "{opacities.0.value}"
        },
        transform: {
            value: "scale(0)"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.short.value}"
        },
        transitionTimingFunction: {
            value: "ease-in-out"
        },
        _checked: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _indeterminate: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        }
    },
    label: {
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


const $e0b32ea6384a2dd2$export$282c9e915736aefa = {
    alignItems: {
        value: "flex-start"
    },
    alignContent: {
        value: "center"
    },
    flexDirection: {
        value: "column"
    },
    justifyContent: {
        value: "center"
    }
};


//we are reusing the types from the nested components but new tokens need to be created that reference the previous tokens so that they can inherit the needed values but can be overwritten and only effect the collection component.
//only a subset of the design tokens of the nested components are being exposed, this can be expanded later.
const $4e7b7644c5d608fc$export$bf5175b0c24981cd = {
    pagination: {
        current: {
            color: {
                value: "{components.pagination.current.color}"
            },
            backgroundColor: {
                value: "{components.pagination.current.backgroundColor}"
            }
        },
        button: {
            color: {
                value: "{components.pagination.button.color}"
            },
            _hover: {
                backgroundColor: {
                    value: "{components.pagination.button.hover.backgroundColor}"
                },
                color: {
                    value: "{components.pagination.button.hover.color}"
                }
            },
            _disabled: {
                color: {
                    value: "{components.pagination.button.disabled.color}"
                }
            }
        }
    },
    search: {
        input: {
            color: {
                value: "{components.searchfield.color}"
            }
        },
        button: {
            color: {
                value: "{components.searchfield.button.color}"
            },
            _active: {
                backgroundColor: {
                    value: "{components.searchfield.button._active.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._active.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._active.color}"
                }
            },
            _disabled: {
                backgroundColor: {
                    value: "{components.searchfield.button._disabled.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._disabled.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._disabled.color}"
                }
            },
            _focus: {
                backgroundColor: {
                    value: "{components.searchfield.button._focus.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._focus.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._focus.color}"
                }
            },
            _hover: {
                backgroundColor: {
                    value: "{components.searchfield.button._hover.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._hover.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._hover.color}"
                }
            }
        }
    }
};


const $a942f67a0e15850b$export$784d13d8ee351f07 = {
    fontSize: {
        value: "{fontSizes.xs}"
    },
    gap: {
        value: "{space.relative.medium}"
    },
    svg: {
        path: {
            fill: {
                value: "{colors.font.primary}"
            }
        }
    },
    toolTip: {
        bottom: {
            value: "{space.large}"
        },
        color: {
            value: "{colors.teal.100}"
        },
        fontSize: {
            value: "{fontSizes.xxs}"
        }
    }
};


const $1c82dae8b508beaa$export$5a80fc6ecf647d64 = {
    height: {
        value: "{space.relative.full.value}"
    }
};


const $cf9cacde028b81dc$export$e8c9778bf415dd08 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    label: {
        color: {
            value: "{colors.font.tertiary.value}"
        },
        paddingInline: {
            value: "{space.medium.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        }
    },
    small: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        }
    },
    large: {
        borderWidth: {
            value: "{borderWidths.large.value}"
        }
    },
    opacity: {
        value: "{opacities.60.value}"
    }
};


const $2356e5131c4e6a3b$export$585d0a7a39ed94ea = {
    backgroundColor: {
        value: "{colors.background.primary}"
    },
    borderRadius: {
        value: "{radii.small}"
    },
    borderColor: {
        value: "{colors.border.primary}"
    },
    borderStyle: {
        value: "dashed"
    },
    borderWidth: {
        value: "{borderWidths.small}"
    },
    color: {
        value: "{colors.font.primary}"
    },
    gap: {
        value: "{space.small}"
    },
    paddingBlock: {
        value: "{space.xl}"
    },
    paddingInline: {
        value: "{space.large}"
    },
    textAlign: {
        value: "center"
    },
    _active: {
        backgroundColor: {
            value: "{colors.primary.10}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.primary}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.background.disabled}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.disabled}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.disabled}"
        }
    },
    accepted: {
        backgroundColor: {
            value: "{colors.background.success}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.success}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.success}"
        }
    },
    rejected: {
        backgroundColor: {
            value: "{colors.background.error}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.error}"
        }
    }
};


const $1ecf911bd942f0c5$export$77f5744dadf9dca6 = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    item: {
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small.value}"
        },
        trigger: {
            alignItems: {
                value: "center"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            color: {
                value: "inherit"
            },
            gap: {
                value: "{space.small.value}"
            },
            justifyContent: {
                value: "space-between"
            },
            paddingBlock: {
                value: "{space.xs.value}"
            },
            paddingInline: {
                value: "{space.small.value}"
            },
            _hover: {
                color: {
                    value: "inherit"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0",
                        offsetY: "0",
                        blurRadius: "0",
                        spreadRadius: "2px",
                        color: "{colors.border.focus.value}"
                    }
                }
            }
        },
        content: {
            color: {
                value: "inherit"
            },
            paddingInline: {
                value: "{space.small.value}"
            },
            paddingBlockEnd: {
                value: "{space.small.value}"
            },
            paddingBlockStart: {
                value: "{space.xxxs.value}"
            }
        },
        icon: {
            color: {
                value: "{colors.font.tertiary.value}"
            },
            transitionDuration: {
                value: "{time.medium.value}"
            },
            transitionTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        }
    }
};


const $7598d4d761f44d2d$export$e0f35d825088c098 = {
    // default styles
    gap: {
        value: "{space.xs.value}"
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    flexDirection: {
        value: "column"
    },
    // Adjust base fontSize and gap for small and large sizes
    small: {
        gap: {
            value: "{space.xxxs.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    large: {
        gap: {
            value: "{space.small.value}"
        },
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    label: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    }
};


const $8d631a53ae164ebe$export$5ba822cdf6eca6d5 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.small.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    paddingBlockStart: {
        value: "{space.xs.value}"
    },
    paddingBlockEnd: {
        value: "{space.xs.value}"
    },
    paddingInlineStart: {
        value: "{space.medium.value}"
    },
    paddingInlineEnd: {
        value: "{space.medium.value}"
    },
    fontSize: {
        value: "{components.field.fontSize.value}"
    },
    lineHeight: {
        value: "{lineHeights.medium.value}"
    },
    transitionDuration: {
        value: "{time.medium.value}"
    },
    outlineColor: {
        value: "{colors.transparent.value}"
    },
    outlineStyle: {
        value: "solid"
    },
    outlineWidth: {
        value: "{outlineWidths.medium.value}"
    },
    outlineOffset: {
        value: "{outlineOffsets.medium.value}"
    },
    small: {
        fontSize: {
            value: "{components.field.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xxs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xxs.value}"
        },
        paddingInlineStart: {
            value: "{space.small.value}"
        },
        paddingInlineEnd: {
            value: "{space.small.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.field.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xs.value}"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    },
    quiet: {
        borderStyle: {
            value: "none"
        },
        borderInlineStart: {
            value: "none"
        },
        borderInlineEnd: {
            value: "none"
        },
        borderBlockStart: {
            value: "none"
        },
        borderRadius: {
            value: "0"
        },
        _focus: {
            borderBlockEndColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderBlockEndColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderBlockEndColor: {
                    value: "transparent"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        }
    },
    _focus: {
        // These focus styles have been calibrated to create
        // a highly visible focus indicator per WCAG 2.2 guidlines:
        // See: https://www.w3.org/TR/WCAG22/#focus-appearance
        //
        // Key features:
        // * Focus indicator area is at least the 2 CSS px perimeter around the component.
        // * Contrast between focused and unfocused area of contrast has a ratio of 3:1
        //
        // IMPORTANT: Must recalibrate if `colors.border.focus` are changed
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "2px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        cursor: {
            value: "not-allowed"
        },
        borderColor: {
            value: "{colors.transparent.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    _error: {
        borderColor: {
            value: "{colors.border.error.value}"
        },
        color: {
            value: "{colors.font.error.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.border.error.value}"
                }
            }
        }
    },
    info: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.blue.100.value}"
                }
            }
        }
    },
    warning: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.orange.100.value}"
                }
            }
        }
    },
    success: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.green.100.value}"
                }
            }
        }
    },
    overlay: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.overlay.90.value}"
                }
            }
        }
    }
};


const $5b8eb19db63b8016$export$886e4abc352a8403 = {
    gap: {
        value: "{space.zero.value}"
    },
    vertical: {
        alignItems: {
            value: "center"
        }
    },
    outer: {
        alignItems: {
            value: "center"
        }
    }
};


const $dc85335e2b77f4af$export$a38812d1aa1302d9 = {
    backgroundColor: {
        value: "transparent"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{components.field.gap.value}"
    },
    legend: {
        color: {
            value: "{colors.font.primary.value}"
        },
        fontSize: {
            value: "{components.field.fontSize.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        lineHeight: {
            value: "{lineHeights.medium.value}"
        },
        small: {
            fontSize: "{components.field.small.fontSize.value}"
        },
        large: {
            fontSize: "{components.field.large.fontSize.value}"
        }
    },
    outlined: {
        padding: "{space.medium.value}",
        borderColor: "{colors.neutral.40.value}",
        borderWidth: "{borderWidths.small.value}",
        borderStyle: "solid",
        small: {
            padding: "{space.small.value}"
        },
        large: {
            padding: "{space.large.value}"
        }
    },
    small: {
        gap: "{components.field.small.gap.value}"
    },
    large: {
        gap: "{components.field.large.gap.value}"
    }
};


const $ea50a5612f7fc2b5$export$b29676ca3eb575f7 = {
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    description: {
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontStyle: {
            value: "italic"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    }
};


const $e90c010f8ed1ecb9$export$97691fbb80847c19 = {
    gap: {
        value: "{space.medium.value}"
    },
    justifyContent: {
        value: "normal"
    },
    alignItems: {
        value: "stretch"
    },
    alignContent: {
        value: "normal"
    },
    flexWrap: {
        value: "nowrap"
    }
};


const $b45e006a820a2039$export$46e4a324ac90507f = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    1: {
        fontSize: {
            value: "{fontSizes.xxxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.light.value}"
        }
    },
    2: {
        fontSize: {
            value: "{fontSizes.xxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        }
    },
    3: {
        fontSize: {
            value: "{fontSizes.xxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.medium.value}"
        }
    },
    4: {
        fontSize: {
            value: "{fontSizes.xl.value}"
        },
        fontWeight: {
            value: "{fontWeights.semibold.value}"
        }
    },
    5: {
        fontSize: {
            value: "{fontSizes.large.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    6: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


const $24a4e05316cc67e6$export$5340050496cd0f8f = {
    highlighted: {
        fontWeight: {
            value: "{fontWeights.bold}"
        }
    }
};


const $58b850eac680ce4b$export$1ca1ec8b29a4ce27 = {
    lineHeight: {
        value: 1
    },
    height: {
        value: "1em"
    }
};


const $d7ebfff67d3d8047$export$b7e3ae3d7c15e42e = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $6d8f5914bb8a535a$export$5c452ff88e35e47d = {
    maxWidth: {
        value: "100%"
    },
    height: {
        value: "auto"
    },
    objectFit: {
        value: "initial"
    },
    objectPosition: {
        value: "initial"
    }
};


const $228a0ba5ccae6bd4$export$be5f4c7eec37e17e = {
    banner: {
        height: {
            value: "150px "
        },
        width: {
            value: "400px "
        }
    },
    button: {
        backgroundColor: {
            value: "#e8e8e8"
        },
        borderRadius: {
            value: "5px"
        },
        color: {
            value: "black"
        }
    },
    dialog: {
        height: {
            value: "50vh"
        },
        minHeight: {
            value: "400px"
        },
        minWidth: {
            value: "400px"
        },
        width: {
            value: "30vw"
        }
    },
    header: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


const $36cb36891a4432e7$export$9c30223ca0a664fb = {
    active: {
        color: {
            value: "{colors.font.active.value}"
        }
    },
    color: {
        value: "{colors.font.interactive.value}"
    },
    focus: {
        color: {
            value: "{colors.font.focus.value}"
        }
    },
    hover: {
        color: {
            value: "{colors.font.hover.value}"
        }
    },
    visited: {
        color: {
            value: "{colors.font.interactive.value}"
        }
    }
};


const $a0e7c929feb0971a$export$674047c1a0a83243 = {
    cameraModule: {
        backgroundColor: {
            value: "{colors.black}"
        }
    }
};


const $1c357ae75c4605d4$export$f4c5de44377d2946 = {
    width: {
        value: "{fontSizes.medium.value}"
    },
    height: {
        value: "{fontSizes.medium.value}"
    },
    fontSize: {
        value: "{fontSizes.xs.value}"
    },
    strokeEmpty: {
        value: "{colors.neutral.20.value}"
    },
    strokeFilled: {
        value: "{colors.primary.80.value}"
    },
    strokeLinecap: {
        value: "round"
    },
    animationDuration: {
        value: "1s"
    },
    small: {
        width: {
            value: "{fontSizes.small.value}"
        },
        height: {
            value: "{fontSizes.small.value}"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.large.value}"
        },
        height: {
            value: "{fontSizes.large.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    linear: {
        width: {
            value: "100%"
        },
        minWidth: {
            value: "5rem"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        },
        strokeWidth: {
            value: "{fontSizes.xxs.value}"
        },
        strokeFilled: {
            value: "{colors.primary.80.value}"
        },
        strokeEmpty: {
            value: "{colors.neutral.20.value}"
        },
        strokeLinecap: {
            value: "round"
        },
        animationDuration: {
            value: "1s"
        },
        small: {
            strokeWidth: {
                value: "{fontSizes.xxxs.value}"
            },
            fontSize: {
                value: "{fontSizes.xxxs.value}"
            }
        },
        large: {
            strokeWidth: {
                value: "{fontSizes.xs.value}"
            },
            fontSize: {
                value: "{fontSizes.xs.value}"
            }
        }
    },
    text: {
        fill: {
            value: "{colors.font.primary.value}"
        }
    }
};


const $e3e6ed53069df779$export$b1e5508a851be14d = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{space.zero.value}"
    },
    maxWidth: {
        value: "30rem"
    },
    minWidth: {
        value: "14rem"
    },
    small: {
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.xxxl.value}"
        },
        height: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    item: {
        minHeight: {
            value: "2.5rem"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    }
};


const $26b433bcaf0ef334$export$a8ecead220dd38a6 = {
    // Default styles
    alignItems: {
        value: "center"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderColor: {
        value: "transparent"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    justifyContent: {
        value: "flex-start"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    dismiss: {
        gap: {
            value: "{space.xxs.value}"
        }
    },
    // Variations
    plain: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    },
    outlined: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.info.value}"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.error.value}"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.success.value}"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.warning.value}"
            }
        }
    },
    filled: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.secondary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.info.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.error.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.success.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.warning.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    }
};


const $3dc8249ff48d9db2$export$22fa394f3ba39578 = {
    current: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.40.value}"
        }
    },
    button: {
        color: {
            value: "{colors.font.primary.value}"
        },
        paddingInlineStart: {
            value: "{space.xxs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xxs.value}"
        },
        transitionProperty: {
            value: "background-color"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    ellipsis: {
        alignItems: {
            value: "baseline"
        },
        justifyContent: {
            value: "center"
        },
        paddingInlineStart: {
            value: "{space.xs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xs.value}"
        }
    },
    itemContainer: {
        marginLeft: {
            value: "{space.xxxs.value}"
        },
        marginRight: {
            value: "{space.xxxs.value}"
        }
    },
    itemShared: {
        height: {
            value: "{fontSizes.xxl.value}"
        },
        minWidth: {
            value: "{fontSizes.xxl.value}"
        },
        borderRadius: {
            value: "{fontSizes.medium.value}"
        }
    }
};


const $3d19bb755b6eff99$export$75dd6c0d8e7c7e6b = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


const $c13d26b554f0a66b$export$2b14d7973e978f83 = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    }
};


const $a8ffd1ed449c2ffa$export$c7187bbd1a7a9244 = {
    borderRadius: {
        value: "{radii.small.value}"
    },
    transitionDuration: {
        value: "{time.long.value}"
    },
    startColor: {
        value: "{colors.background.secondary.value}"
    },
    endColor: {
        value: "{colors.background.tertiary.value}"
    },
    // sizes
    small: {
        height: {
            value: "{space.small.value}"
        }
    },
    default: {
        height: {
            value: "{space.medium.value}"
        }
    },
    large: {
        height: {
            value: "{space.large.value}"
        }
    }
};


const $7041648d4ad416e7$export$b56dc0f160585b86 = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    },
    gap: {
        value: "inherit"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        },
        boxSizing: {
            value: "border-box"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "50%"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        color: {
            value: "{colors.background.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        outlineColor: {
            value: "{colors.transparent.value}"
        },
        outlineStyle: {
            value: "solid"
        },
        outlineWidth: {
            value: "{outlineWidths.medium.value}"
        },
        outlineOffset: {
            value: "{outlineOffsets.medium.value}"
        },
        // We want the dot inside the border to be a border-width from the border
        padding: {
            value: "{borderWidths.medium.value}"
        },
        small: {
            width: {
                value: "{fontSizes.small.value}"
            },
            height: {
                value: "{fontSizes.small.value}"
            }
        },
        large: {
            width: {
                value: "{fontSizes.large.value}"
            },
            height: {
                value: "{fontSizes.large.value}"
            }
        },
        _checked: {
            color: {
                value: "{colors.primary.80.value}"
            },
            _disabled: {
                color: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    },
    label: {
        color: {
            value: "{components.text.color.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


const $900f498b7c5396e0$export$19d611f01a2bdcee = {
    radio: {
        borderWidth: {
            value: "{components.radio.button.borderWidth}"
        },
        borderColor: {
            value: "{components.radio.button.borderColor}"
        },
        backgroundColor: {
            value: "{components.radio.button.backgroundColor}"
        },
        _checked: {
            color: {
                value: "{components.radio.button._checked.color}"
            }
        },
        label: {
            color: {
                value: "{components.radio.label.color}"
            }
        }
    },
    legend: {
        color: {
            value: "{components.fieldset.legend.color}"
        },
        fontWeight: {
            value: "{fontWeights.normal}"
        }
    }
};


const $76bd4d74bb608da6$export$8121c87bde23d44 = {
    large: {
        size: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    default: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    small: {
        size: {
            value: "{fontSizes.small.value}"
        }
    },
    filled: {
        color: {
            value: "{colors.secondary.80.value}"
        }
    },
    empty: {
        color: {
            value: "{colors.background.tertiary.value}"
        }
    }
};


const $dcb08bc2efd2cb23$export$20f8183d3857720a = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


const $107d0470fac495cc$export$2e6c959c16ff56b8 = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    paddingInlineEnd: {
        value: "{space.xxl.value}"
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    // wrappers
    wrapper: {
        flex: {
            value: "1"
        },
        display: {
            value: "block"
        },
        position: {
            value: "relative"
        },
        cursor: {
            value: "pointer"
        }
    },
    iconWrapper: {
        alignItems: {
            value: "center"
        },
        position: {
            value: "absolute"
        },
        top: {
            value: "50%"
        },
        right: {
            value: "{space.medium.value}"
        },
        transform: {
            value: "translateY(-50%)"
        },
        pointerEvents: {
            value: "none"
        },
        small: {
            right: {
                value: "{space.xs.value}"
            }
        },
        large: {
            right: {
                value: "{space.medium.value}"
            }
        }
    },
    // It's important to test these option values on Chrome/FireFox/Edge
    // on Windows because they allow styling of the option element.
    // Chrome/Safari/Firefox on Mac uses the system ui.
    option: {
        backgroundColor: {
            value: "transparent"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            },
            backgroundColor: {
                value: "transparent"
            }
        }
    },
    whiteSpace: {
        value: "nowrap"
    },
    minWidth: {
        value: "6.5rem"
    },
    small: {
        minWidth: {
            value: "5.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xl.value}"
        }
    },
    large: {
        minWidth: {
            value: "7.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xxl.value}"
        }
    },
    expanded: {
        paddingBlock: {
            value: "{space.xs.value}"
        },
        paddingInline: {
            value: "{space.small.value}"
        },
        option: {
            paddingBlock: {
                value: "{space.xs.value}"
            },
            paddingInline: {
                value: "{space.small.value}"
            }
        }
    }
};


const $0b2fce711b22085d$export$43b12a9ec74e5c15 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    color: {
        value: "{components.fieldcontrol.color}"
    },
    flexDirection: {
        value: "column"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};


const $ef18faaf0e22b28d$export$91a82c92775294e7 = {
    paddingBlock: {
        value: "{space.xs.value}"
    },
    // The track is the thin background of the slider
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        height: {
            value: "0.375rem"
        },
        minWidth: {
            value: "10rem"
        }
    },
    // The range is the filled part of the track
    range: {
        backgroundColor: {
            value: "{colors.primary.80.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            }
        }
    },
    // The thumb is the circle above the track that the user drags
    thumb: {
        width: {
            value: "1.25rem"
        },
        height: {
            value: "1.25rem"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderRadius: {
            value: "50%"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            borderColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "none"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        }
    },
    small: {
        track: {
            height: {
                value: "0.25rem"
            }
        },
        thumb: {
            width: {
                value: "1rem"
            },
            height: {
                value: "1rem"
            }
        }
    },
    large: {
        track: {
            height: {
                value: "0.625rem"
            }
        },
        thumb: {
            width: {
                value: "1.5rem"
            },
            height: {
                value: "1.5rem"
            }
        }
    }
};


const $54779adc3f62057c$export$2391ed8b13703124 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    flexDirection: {
        value: "column"
    },
    input: {
        color: {
            value: "{components.fieldcontrol.color}"
        },
        fontSize: {
            value: "{components.fieldcontrol.fontSize}"
        },
        textAlign: {
            value: "center"
        }
    },
    button: {
        color: {
            value: "{components.button.color}"
        },
        backgroundColor: {
            value: "{colors.transparent}"
        },
        _active: {
            color: {
                value: "{components.button._active.color}"
            },
            backgroundColor: {
                value: "{components.button._active.backgroundColor}"
            }
        },
        _focus: {
            color: {
                value: "{components.button._focus.color}"
            },
            backgroundColor: {
                value: "{components.button._focus.backgroundColor}"
            }
        },
        _disabled: {
            color: {
                value: "{components.button._disabled.color}"
            },
            backgroundColor: {
                value: "{components.fieldcontrol._disabled.backgroundColor}"
            }
        },
        _hover: {
            color: {
                value: "{components.button._hover.color}"
            },
            backgroundColor: {
                value: "{components.button._hover.backgroundColor}"
            }
        }
    }
};


const $2cf3514c5467a8dd$export$38e5783f648ff5e4 = {
    dropzone: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "dashed"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        gap: {
            value: "{space.small}"
        },
        paddingBlock: {
            value: "{space.xl}"
        },
        paddingInline: {
            value: "{space.large}"
        },
        textAlign: {
            value: "center"
        },
        _active: {
            backgroundColor: {
                value: "{colors.primary.10}"
            },
            borderRadius: {
                value: "{components.storagemanager.dropzone.borderRadius}"
            },
            borderColor: {
                value: "{colors.border.pressed}"
            },
            borderStyle: {
                value: "{components.storagemanager.dropzone.borderStyle}"
            },
            borderWidth: {
                value: "{borderWidths.medium}"
            }
        },
        icon: {
            color: {
                value: "{colors.border.primary}"
            },
            fontSize: {
                value: "{fontSizes.xxl}"
            }
        },
        text: {
            color: {
                value: "{colors.font.tertiary}"
            },
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            }
        }
    },
    file: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        paddingBlock: {
            value: "{space.xs}"
        },
        paddingInline: {
            value: "{space.small}"
        },
        gap: {
            value: "{space.small}"
        },
        alignItems: {
            value: "baseline"
        },
        name: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        size: {
            fontSize: {
                value: "{fontSizes.small}"
            },
            fontWeight: {
                value: "{fontWeights.normal}"
            },
            color: {
                value: "{colors.font.tertiary}"
            }
        },
        image: {
            width: {
                value: "{space.xxl}"
            },
            height: {
                value: "{space.xxl}"
            },
            backgroundColor: {
                value: "{colors.background.secondary}"
            },
            color: {
                value: "{colors.font.tertiary}"
            },
            borderRadius: {
                value: "{radii.small}"
            }
        }
    },
    filelist: {
        flexDirection: {
            value: "column"
        },
        gap: {
            value: "{space.small}"
        }
    },
    loader: {
        strokeLinecap: {
            value: "round"
        },
        strokeEmpty: {
            value: "{colors.border.secondary}"
        },
        strokeFilled: {
            value: "{components.loader.strokeFilled}"
        },
        strokeWidth: {
            value: "{borderWidths.large}"
        }
    },
    previewer: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        paddingBlock: {
            value: "{space.zero}"
        },
        paddingInline: {
            value: "{space.zero}"
        },
        maxHeight: {
            value: "40rem"
        },
        maxWidth: {
            value: "auto"
        },
        text: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        body: {
            paddingBlock: {
                value: "{space.medium}"
            },
            paddingInline: {
                value: "{space.medium}"
            },
            gap: {
                value: "{space.small}"
            }
        },
        footer: {
            justifyContent: {
                value: "flex-end"
            }
        }
    }
};


const $b63a498a6b8553a7$export$3df77196ea7dd221 = {
    // States
    _disabled: {
        opacity: {
            value: "{opacities.60.value}"
        }
    },
    _focused: {
        shadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    // Sizes
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    large: {
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    // Child elements
    label: {
        padding: {
            value: "{space.xs.value}"
        }
    },
    thumb: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            transform: {
                value: "{transforms.slideX.medium.value}"
            }
        },
        transition: {
            duration: {
                value: "{time.medium.value}"
            }
        },
        width: {
            value: "{space.relative.medium.value}"
        }
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            backgroundColor: {
                value: "{colors.primary.80.value}"
            }
        },
        height: {
            value: "{space.relative.medium.value}"
        },
        padding: {
            value: "{outlineWidths.medium.value}"
        },
        transition: {
            duration: {
                value: "{time.short.value}"
            }
        },
        width: {
            value: "{space.relative.xl.value}"
        },
        _error: {
            backgroundColor: {
                value: "{colors.background.error.value}"
            }
        }
    }
};


const $1ef359d34fff9c93$export$9852986a3ec5f6a0 = {
    /**
     * Default table styles
     */ borderCollapse: {
        value: "collapse"
    },
    display: {
        value: "table"
    },
    width: {
        value: "100%"
    },
    /**
     * Default table head styles
     */ head: {
        display: {
            value: "table-header-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    /**
     * Default table body styles
     */ body: {
        display: {
            value: "table-row-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    /**
     * Default table foot styles
     */ foot: {
        display: {
            value: "table-footer-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    /**
     * Default table row styles
     */ row: {
        display: {
            value: "table-row"
        },
        verticalAlign: {
            value: "middle"
        },
        hover: {
            backgroundColor: {
                value: "{colors.background.tertiary.value}"
            }
        },
        striped: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    /**
     * Default table header cell styles
     */ header: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    /**
     * Default table data cell styles
     */ data: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    /**
     * Default table caption styles
     */ caption: {
        captionSide: {
            value: "bottom"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-caption"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        wordBreak: {
            value: "break-all"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            }
        }
    }
};


const $b8bf3c869b4e5c3a$export$39f5674517ec0000 = {
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{colors.border.secondary.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    gap: {
        value: "0"
    },
    item: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        _hover: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "none"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "{borderWidths.medium}",
                    color: "{colors.border.focus.value}"
                }
            },
            color: {
                value: "{colors.font.focus.value}"
            }
        },
        _active: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.font.interactive.value}"
            },
            boxShadow: {
                value: "none"
            },
            color: {
                value: "{colors.font.interactive.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.tertiary.value}"
            },
            boxShadow: {
                value: "none"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    panel: {
        backgroundColor: {
            value: "transparent"
        },
        paddingInline: {
            value: "0"
        },
        paddingBlock: {
            value: "{space.small.value}"
        }
    }
};


const $9745e9a2d08d4b56$export$6f093cfa640b7166 = {
    // default styles
    color: {
        value: "{colors.font.primary.value}"
    },
    // variations
    primary: {
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    secondary: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    },
    tertiary: {
        color: {
            value: "{colors.font.tertiary.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        }
    }
};


const $6b40291880eaf666$export$a97649e9ae9088d4 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $6d0e6545455715cf$export$a0baff9279ccf6a1 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $5da487374c3dcae7$export$72f8a860416016a1 = {
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        backgroundColor: {
            value: "{colors.overlay.10.value}"
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    _active: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderColor: {
            value: "{colors.border.disabled.value}"
        },
        color: {
            value: "{colors.font.disabled.value}"
        }
    },
    _pressed: {
        borderColor: {
            value: "{colors.border.pressed.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.20.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.30.value}"
            }
        }
    },
    primary: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.primary.80.value}"
            },
            borderColor: {
                value: "{colors.primary.80.value}"
            },
            color: {
                value: "{colors.background.primary.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.border.focus.value}"
                },
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            },
            _hover: {
                borderColor: {
                    value: "{colors.primary.60.value}"
                },
                backgroundColor: {
                    value: "{colors.primary.60.value}"
                },
                boxShadow: {
                    value: "{colors.primary.60.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            }
        }
    },
    link: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        color: {
            value: "{colors.overlay.50.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.90.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.transparent.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            },
            _hover: {
                color: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.transparent.value}"
                }
            }
        }
    }
};


const $9d1c34db377630cc$export$8f367359b07a0011 = {
    alignItems: {
        value: "center"
    },
    alignContent: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    }
};


const $83f0e3b84d6d6163$export$9b5ac10f59f76296 = {
    accordion: $1ecf911bd942f0c5$export$77f5744dadf9dca6,
    alert: $4836dd2c5887122c$export$5ea928c9faf85bd3,
    authenticator: $8c0c2be9281ce619$export$d5cb6eef88ffbde2,
    autocomplete: $cbb47b2ce649a112$export$485ded5f26ebe08d,
    badge: $fc55beed687a5aed$export$4aebd143f31d0c0d,
    breadcrumbs: $3afa51171f111525$export$515d2155aaad79e4,
    button: $1912bd6df94634d5$export$2ba01fb71ed41cb6,
    card: $00d7f2cbb7da7357$export$aa3e815946b80764,
    checkbox: $435c1abd3ebbceb4$export$b07e517d22efa1ca,
    checkboxfield: $e0b32ea6384a2dd2$export$282c9e915736aefa,
    collection: $4e7b7644c5d608fc$export$bf5175b0c24981cd,
    copy: $a942f67a0e15850b$export$784d13d8ee351f07,
    countrycodeselect: (0, $1c82dae8b508beaa$export$5a80fc6ecf647d64),
    divider: $cf9cacde028b81dc$export$e8c9778bf415dd08,
    dropzone: $2356e5131c4e6a3b$export$585d0a7a39ed94ea,
    field: $7598d4d761f44d2d$export$e0f35d825088c098,
    fieldcontrol: $8d631a53ae164ebe$export$5ba822cdf6eca6d5,
    fieldgroup: $5b8eb19db63b8016$export$886e4abc352a8403,
    fieldmessages: $ea50a5612f7fc2b5$export$b29676ca3eb575f7,
    fieldset: $dc85335e2b77f4af$export$a38812d1aa1302d9,
    flex: $e90c010f8ed1ecb9$export$97691fbb80847c19,
    heading: $b45e006a820a2039$export$46e4a324ac90507f,
    icon: $58b850eac680ce4b$export$1ca1ec8b29a4ce27,
    highlightmatch: $24a4e05316cc67e6$export$5340050496cd0f8f,
    image: $6d8f5914bb8a535a$export$5c452ff88e35e47d,
    inappmessaging: $228a0ba5ccae6bd4$export$be5f4c7eec37e17e,
    input: $d7ebfff67d3d8047$export$b7e3ae3d7c15e42e,
    link: $36cb36891a4432e7$export$9c30223ca0a664fb,
    liveness: $a0e7c929feb0971a$export$674047c1a0a83243,
    loader: $1c357ae75c4605d4$export$f4c5de44377d2946,
    menu: $e3e6ed53069df779$export$b1e5508a851be14d,
    message: $26b433bcaf0ef334$export$a8ecead220dd38a6,
    pagination: $3dc8249ff48d9db2$export$22fa394f3ba39578,
    passwordfield: $3d19bb755b6eff99$export$75dd6c0d8e7c7e6b,
    phonenumberfield: $c13d26b554f0a66b$export$2b14d7973e978f83,
    placeholder: $a8ffd1ed449c2ffa$export$c7187bbd1a7a9244,
    radio: $7041648d4ad416e7$export$b56dc0f160585b86,
    radiogroup: $900f498b7c5396e0$export$19d611f01a2bdcee,
    rating: $76bd4d74bb608da6$export$8121c87bde23d44,
    searchfield: $dcb08bc2efd2cb23$export$20f8183d3857720a,
    select: $107d0470fac495cc$export$2e6c959c16ff56b8,
    selectfield: $0b2fce711b22085d$export$43b12a9ec74e5c15,
    sliderfield: $ef18faaf0e22b28d$export$91a82c92775294e7,
    stepperfield: $54779adc3f62057c$export$2391ed8b13703124,
    storagemanager: $2cf3514c5467a8dd$export$38e5783f648ff5e4,
    switchfield: $b63a498a6b8553a7$export$3df77196ea7dd221,
    table: $1ef359d34fff9c93$export$9852986a3ec5f6a0,
    tabs: $b8bf3c869b4e5c3a$export$39f5674517ec0000,
    text: $9745e9a2d08d4b56$export$6f093cfa640b7166,
    textareafield: $6b40291880eaf666$export$a97649e9ae9088d4,
    textfield: $6d0e6545455715cf$export$a0baff9279ccf6a1,
    togglebutton: $5da487374c3dcae7$export$72f8a860416016a1,
    togglebuttongroup: $9d1c34db377630cc$export$8f367359b07a0011
};


// TODO: update the design tokens to use an array
// export interface FontDesignToken {
//   value: Array<string>
// }
const $634aeeaa81af9f0f$export$f45fbea8fe20ca8a = {
    default: {
        variable: {
            value: `'InterVariable', 'Inter var', 'Inter', -apple-system, BlinkMacSystemFont,
        'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',
        sans-serif`
        },
        static: {
            value: `'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
        'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif`
        }
    }
};


const $2021dfbfb4155652$export$67baea80019ff381 = {
    xxxs: {
        value: "0.375rem"
    },
    xxs: {
        value: "0.5rem"
    },
    xs: {
        value: "0.75rem"
    },
    small: {
        value: "0.875rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.25rem"
    },
    xl: {
        value: "1.5rem"
    },
    xxl: {
        value: "2rem"
    },
    xxxl: {
        value: "2.5rem"
    },
    xxxxl: {
        value: "3rem"
    }
};


const $a60ba6cf6e24ab23$export$59230918eb9bd861 = {
    hairline: {
        value: 100
    },
    thin: {
        value: 200
    },
    light: {
        value: 300
    },
    normal: {
        value: 400
    },
    medium: {
        value: 500
    },
    semibold: {
        value: 600
    },
    bold: {
        value: 700
    },
    extrabold: {
        value: 800
    },
    black: {
        value: 900
    }
};


const $c4bfed175506ec88$export$e646ed6b629bf51e = {
    small: {
        value: "1.25"
    },
    medium: {
        value: "1.5"
    },
    large: {
        value: "2"
    }
};


const $23fc46691e9854ac$export$da6c1b172b339805 = {
    0: {
        value: "0"
    },
    10: {
        value: "0.1"
    },
    20: {
        value: "0.2"
    },
    30: {
        value: "0.3"
    },
    40: {
        value: "0.4"
    },
    50: {
        value: "0.5"
    },
    60: {
        value: "0.6"
    },
    70: {
        value: "0.7"
    },
    80: {
        value: "0.8"
    },
    90: {
        value: "0.9"
    },
    100: {
        value: "1"
    }
};


const $0f86a23b71c3bf16$export$ef75ee03a03b44a8 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $62d061881596d3ef$export$d532f76375153c47 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $aaa4765bd3028673$export$18f838d5aba6962a = {
    xs: {
        value: "0.125rem"
    },
    small: {
        value: "0.25rem"
    },
    medium: {
        value: "0.5rem"
    },
    large: {
        value: "1rem"
    },
    xl: {
        value: "2rem"
    },
    xxl: {
        value: "4rem"
    },
    xxxl: {
        value: "8rem"
    }
};


const $d4e38ecd99728735$export$3eb26d38a832ce9a = {
    small: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "4px",
            color: "{colors.shadow.tertiary.value}"
        }
    },
    medium: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "6px",
            color: "{colors.shadow.secondary.value}"
        }
    },
    large: {
        value: {
            offsetX: "0px",
            offsetY: "4px",
            blurRadius: "12px",
            color: "{colors.shadow.primary.value}"
        }
    }
};


const $68964e5e12057045$export$a941ed4b947d12f8 = {
    zero: {
        value: "0"
    },
    xxxs: {
        value: "0.25rem"
    },
    xxs: {
        value: "0.375rem"
    },
    xs: {
        value: "0.5rem"
    },
    small: {
        value: "0.75rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.5rem"
    },
    xl: {
        value: "2.0rem"
    },
    xxl: {
        value: "3.0rem"
    },
    xxxl: {
        value: "4.5rem"
    },
    relative: {
        //creating a second set of sizes using em which will be sized relative to a parent instead of the root
        xxxs: {
            value: "0.25em"
        },
        xxs: {
            value: "0.375em"
        },
        xs: {
            value: "0.5em"
        },
        small: {
            value: "0.75em"
        },
        medium: {
            value: "1em"
        },
        large: {
            value: "1.5em"
        },
        xl: {
            value: "2.0em"
        },
        xxl: {
            value: "3.0em"
        },
        xxxl: {
            value: "4.5em"
        },
        full: {
            value: "100%"
        }
    }
};


const $62d5a319778f6408$export$2da9be4cfdb689b1 = {
    short: {
        value: "100ms"
    },
    medium: {
        value: "250ms"
    },
    long: {
        value: "500ms"
    }
};


const $82a936b343cbeb97$export$63e4f03d302d3e40 = {
    // TODO: make this more generic and cross-platform
    slideX: {
        small: {
            value: "translateX(0.5em)"
        },
        medium: {
            value: "translateX(1em)"
        },
        large: {
            value: "translateX(2em)"
        }
    }
};


const $4682168b4f6c5617$export$6ad93df59e712c43 = {
    components: $83f0e3b84d6d6163$export$9b5ac10f59f76296,
    borderWidths: $7bc43641dca04e6a$export$6f3cc5789c9e770e,
    colors: $dd63c221f0429332$export$8f45430ccf837300,
    fonts: $634aeeaa81af9f0f$export$f45fbea8fe20ca8a,
    fontSizes: $2021dfbfb4155652$export$67baea80019ff381,
    fontWeights: $a60ba6cf6e24ab23$export$59230918eb9bd861,
    lineHeights: $c4bfed175506ec88$export$e646ed6b629bf51e,
    opacities: $23fc46691e9854ac$export$da6c1b172b339805,
    outlineOffsets: $0f86a23b71c3bf16$export$ef75ee03a03b44a8,
    outlineWidths: $62d061881596d3ef$export$d532f76375153c47,
    radii: $aaa4765bd3028673$export$18f838d5aba6962a,
    shadows: $d4e38ecd99728735$export$3eb26d38a832ce9a,
    space: $68964e5e12057045$export$a941ed4b947d12f8,
    time: $62d5a319778f6408$export$2da9be4cfdb689b1,
    transforms: $82a936b343cbeb97$export$63e4f03d302d3e40
};
const $4682168b4f6c5617$export$166e3af4fe3ca756 = {
    colors: $dd63c221f0429332$export$8f45430ccf837300,
    borderWidths: $7bc43641dca04e6a$export$6f3cc5789c9e770e,
    fontSizes: {
        xxs: (0, $2021dfbfb4155652$export$67baea80019ff381).xxs,
        xs: (0, $2021dfbfb4155652$export$67baea80019ff381).xs,
        small: (0, $2021dfbfb4155652$export$67baea80019ff381).small,
        medium: (0, $2021dfbfb4155652$export$67baea80019ff381).medium,
        large: (0, $2021dfbfb4155652$export$67baea80019ff381).large,
        xl: (0, $2021dfbfb4155652$export$67baea80019ff381).xl,
        xxl: (0, $2021dfbfb4155652$export$67baea80019ff381).xxl,
        xxxl: (0, $2021dfbfb4155652$export$67baea80019ff381).xxxl
    },
    fontWeights: $a60ba6cf6e24ab23$export$59230918eb9bd861,
    opacities: $23fc46691e9854ac$export$da6c1b172b339805,
    // React Native doesn't need the relative space values
    space: {
        // use `space.xxxs` to output a value of `2` and avoid odd space numbers
        xxs: (0, $68964e5e12057045$export$a941ed4b947d12f8).xxxs,
        xs: (0, $68964e5e12057045$export$a941ed4b947d12f8).xs,
        small: (0, $68964e5e12057045$export$a941ed4b947d12f8).small,
        medium: (0, $68964e5e12057045$export$a941ed4b947d12f8).medium,
        large: (0, $68964e5e12057045$export$a941ed4b947d12f8).large,
        xl: (0, $68964e5e12057045$export$a941ed4b947d12f8).xl,
        xxl: (0, $68964e5e12057045$export$a941ed4b947d12f8).xxl,
        xxxl: (0, $68964e5e12057045$export$a941ed4b947d12f8).xxxl
    },
    radii: $aaa4765bd3028673$export$18f838d5aba6962a,
    time: $62d5a319778f6408$export$2da9be4cfdb689b1
};


// Breakpoint unit is in pixels
const $2cf20821539d0cbf$export$d07517a676ce386f = {
    values: {
        base: 0,
        small: 480,
        medium: 768,
        large: 992,
        xl: 1280,
        xxl: 1536
    },
    defaultBreakpoint: "base"
};


const $35080b1bd8feebe1$export$164de7ab8df77ef0 = {
    tokens: $4682168b4f6c5617$export$6ad93df59e712c43,
    breakpoints: $2cf20821539d0cbf$export$d07517a676ce386f,
    name: "default-theme"
};



// For internal use, no need to export
const $dca455d5eea3302b$export$529e7eefcb1e2a4c = {
    Alert: {
        dismissButtonLabel: "Dismiss alert"
    },
    Autocomplete: {
        emptyText: "No options found",
        loadingText: "Loading options..."
    },
    Collection: {
        searchButtonLabel: "Search",
        searchNoResultsFound: "No results found"
    },
    Fields: {
        clearButtonLabel: "Clear input"
    },
    Message: {
        dismissLabel: "Dismiss message"
    },
    PaginationItem: {
        currentPageLabel: "Page",
        nextLabel: "Go to next page",
        pageLabel: "Go to page",
        previousLabel: "Go to previous page"
    },
    PhoneNumberField: {
        countryCodeLabel: "Country code"
    },
    SearchField: {
        searchButtonLabel: "Search"
    },
    PasswordField: {
        passwordIsHidden: "Password is hidden",
        passwordIsShown: "Password is shown",
        showPassword: "Show password"
    },
    StepperField: {
        increaseButtonLabel: "Increase to",
        decreaseButtonLabel: "Decrease to"
    }
};
const $dca455d5eea3302b$export$f486c23e21d151b2 = {
    backgroundColor: "colors",
    borderColor: "colors",
    borderWidth: "borderWidths",
    color: "colors",
    borderRadius: "radii",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    fontFamily: "fonts",
    lineHeight: "lineHeights",
    opacity: "opacities",
    boxShadow: "shadows",
    transform: "transforms",
    left: "space",
    right: "space",
    top: "space",
    bottom: "space",
    height: "space",
    width: "space",
    letterSpacing: "space",
    margin: "space",
    marginBlock: "space",
    marginBlockEnd: "space",
    marginBlockStart: "space",
    marginInline: "space",
    marginInlineEnd: "space",
    marginInlineStart: "space",
    marginLeft: "space",
    marginRight: "space",
    marginTop: "space",
    marginBottom: "space",
    maxHeight: "space",
    maxWidth: "space",
    minHeight: "space",
    minWidth: "space",
    padding: "space",
    paddingBlock: "space",
    paddingBlockEnd: "space",
    paddingBlockStart: "space",
    paddingInline: "space",
    paddingInlineEnd: "space",
    paddingInlineStart: "space",
    paddingLeft: "space",
    paddingRight: "space",
    paddingTop: "space",
    paddingBottom: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space"
};
// key name
const $dca455d5eea3302b$export$728705b4513abbb5 = "Escape";
const $dca455d5eea3302b$export$4162dbd8c730437 = "Enter";
const $dca455d5eea3302b$export$8188339dbe6c99c4 = "ArrowUp";
const $dca455d5eea3302b$export$59f214baefff6196 = "ArrowDown";


const $7c13924ec60f0cde$export$2e3e72bc642e327 = (key)=>{
    return key in (0, $dca455d5eea3302b$export$f486c23e21d151b2);
};



const $ceac741e44b5a224$export$c6251bf2bc4bb464 = (str)=>typeof str === "string" && str.length > 0;
const $ceac741e44b5a224$export$78d1711480f95c3e = (value)=>typeof value === "string" && value.length === 0;
const $ceac741e44b5a224$export$68b32c1946a6b59c = (value)=>value == null || $ceac741e44b5a224$export$78d1711480f95c3e(value);
/**
 * Create a consecutive integer array from start value to end value.
 * @param start start value
 * @param end end value
 * @returns an integer array with elements from start to end consecutively
 */ const $ceac741e44b5a224$export$12cda49cb4509427 = (start, end)=>{
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, idx)=>idx + start);
};
/**
 * TS helper function to make using Object.keys more typesafe
 */ const $ceac741e44b5a224$export$259b4dd69e654a7a = (obj)=>{
    return Object.keys(obj);
};
const $ceac741e44b5a224$export$b0c777ec01738e5b = (propKey, value, tokens)=>{
    if (typeof value !== "string") return value;
    // For shorthand properties like `padding` which can accept 1, 2, 3, or 4 values
    // run this function on each value. This would not work on CSS shorthands that
    // mix types, like border which is a composite of borderWidth, borderStyle, and
    // borderColor.
    if (value.includes(" ")) return value.split(" ").map((val)=>$ceac741e44b5a224$export$b0c777ec01738e5b(propKey, val, tokens)).join(" ");
    if ((0, $7c13924ec60f0cde$export$2e3e72bc642e327)(propKey)) {
        const path = value.split(".");
        const tokenKey = (0, $dca455d5eea3302b$export$f486c23e21d151b2)[propKey];
        let tokenProps = tokens[tokenKey];
        for(let i = 0; i < path.length; i++){
            if (tokenProps) {
                // overwrite tokenProps with next nested value of tokenProps
                tokenProps = tokenProps[path[i]];
                continue;
            }
            break;
        }
        return (0, $b706ac0725f36f03$export$daee9cd42beef6d1)(tokenProps) ? `var(--${(0, $b706ac0725f36f03$export$8658ddf1aae625a3)({
            path: [
                (0, $dca455d5eea3302b$export$f486c23e21d151b2)[propKey],
                ...path
            ]
        })})` : value;
    }
    return value;
};


const $c445291e42fe2972$var$getClosestValueByBreakpoint = ({ breakpoint: breakpoint, breakpoints: breakpoints, values: values })=>{
    const value = values[breakpoint];
    // Check if breakpoint exists in values
    if (value !== undefined) return value;
    // Otherwise use a lower breakpoint value
    const breakpointsDesc = (0, $ceac741e44b5a224$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[b] - breakpoints[a]);
    const lowerBreakpoints = breakpointsDesc.slice(breakpointsDesc.indexOf(breakpoint));
    for (const breakpoint of lowerBreakpoints){
        // Check if breakpoint exists in values
        const value = values[breakpoint];
        if (value !== undefined) return value;
    }
    return null;
};
/**
 * This takes an object and will return an object that only has the
 * breakpoint keys
 * @param obj
 * @returns
 */ const $c445291e42fe2972$var$valueObjToBreakpoints = (obj)=>{
    return (0, $ceac741e44b5a224$export$259b4dd69e654a7a)(obj).reduce((acc, key)=>key in (0, $35080b1bd8feebe1$export$164de7ab8df77ef0).breakpoints.values ? {
            ...acc,
            [key]: obj[key]
        } : acc, {});
};
const $c445291e42fe2972$export$7791b19c8f6fdbca = ({ breakpoint: breakpoint, breakpoints: breakpoints, values: values })=>{
    let breakpointCompatValues = {};
    const breakpointsAscending = (0, $ceac741e44b5a224$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[a] - breakpoints[b]);
    if (Array.isArray(values)) values.forEach((value, index)=>{
        breakpointCompatValues[breakpointsAscending[index]] = value;
    });
    else if (typeof values === "object") breakpointCompatValues = $c445291e42fe2972$var$valueObjToBreakpoints(values);
    return $c445291e42fe2972$var$getClosestValueByBreakpoint({
        breakpoint: breakpoint,
        breakpoints: breakpoints,
        values: breakpointCompatValues
    });
};



var $2hDQc = parcelRequire("2hDQc");

// Inspiration for getMediaQueries and useBreakpoint
const $8710695687023cd5$export$872f03ff2a363331 = ({ breakpoints: breakpoints })=>{
    const sortedBreakpoints = (0, $ceac741e44b5a224$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[b] - breakpoints[a]);
    return sortedBreakpoints.map((breakpoint, index)=>{
        let query = "";
        const minWidth = breakpoints[breakpoint];
        const nextBreakpoint = sortedBreakpoints[index - 1];
        const maxWidth = nextBreakpoint ? breakpoints[nextBreakpoint] - 1 : null;
        if (minWidth >= 0) query = `(min-width: ${minWidth}px)`;
        if (maxWidth !== null) {
            if (query) query += " and ";
            query += `(max-width: ${maxWidth}px)`;
        }
        return {
            breakpoint: breakpoint,
            query: query,
            maxWidth: maxWidth,
            minWidth: minWidth
        };
    });
};


// Inspiration for getMediaQueries and useBreakpoint
const $632ca023bc088c4a$var$useIsomorphicEffect = typeof window === "undefined" ? $2hDQc.useEffect : $2hDQc.useLayoutEffect;
const $632ca023bc088c4a$export$199d6754bdf4e1e3 = ({ breakpoints: breakpoints, defaultBreakpoint: defaultBreakpoint })=>{
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const matchMedia = supportMatchMedia ? window.matchMedia : null;
    const mediaQueries = $2hDQc.useMemo(()=>(0, $8710695687023cd5$export$872f03ff2a363331)({
            breakpoints: breakpoints
        }), [
        breakpoints
    ]);
    const [breakpoint, setBreakpoint] = $2hDQc.useState(defaultBreakpoint);
    const updateBreakpoint = $2hDQc.useCallback((matches, breakpoint)=>{
        if (matches) setBreakpoint(breakpoint);
    }, [
        setBreakpoint
    ]);
    $632ca023bc088c4a$var$useIsomorphicEffect(()=>{
        if (!matchMedia) return;
        const unsubscribeList = mediaQueries.map(({ query: query, breakpoint: breakpoint })=>{
            const queryList = matchMedia(query);
            updateBreakpoint(queryList.matches, breakpoint);
            const handleMediaChange = (event)=>{
                if (event.matches) setBreakpoint(breakpoint);
            };
            queryList.addEventListener("change", handleMediaChange);
            return ()=>queryList.removeEventListener("change", handleMediaChange);
        });
        return ()=>{
            unsubscribeList.forEach((unsubscribe)=>unsubscribe());
        };
    }, [
        breakpoints,
        setBreakpoint,
        matchMedia,
        mediaQueries
    ]);
    /** Print a nice debug value for React Devtools */ $2hDQc.useDebugValue(breakpoint, (breakpoint)=>breakpoint);
    return breakpoint;
};



var $2hDQc = parcelRequire("2hDQc");
var $ef92553cb6e83178$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $b935691dabfbf70e$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $4UZnF = parcelRequire("4UZnF");

var $4UZnF = parcelRequire("4UZnF");
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $71e93e224de227ad$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $71e93e224de227ad$export$206cd6ecad4fcdde(str, locale) {
    var lang = $71e93e224de227ad$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $71e93e224de227ad$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $71e93e224de227ad$export$61d6efbc6547e8eb(str);
}
function $71e93e224de227ad$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}


// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $fa9614ee91f6c5c7$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $fa9614ee91f6c5c7$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $fa9614ee91f6c5c7$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $fa9614ee91f6c5c7$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $fa9614ee91f6c5c7$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $71e93e224de227ad$export$61d6efbc6547e8eb) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $fa9614ee91f6c5c7$var$replace($fa9614ee91f6c5c7$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $fa9614ee91f6c5c7$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}


function $e65282cf2edb9cec$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $e65282cf2edb9cec$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $e65282cf2edb9cec$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $fa9614ee91f6c5c7$export$a596972587f860c8)(input, (0, $4UZnF.__assign)({
        delimiter: "",
        transform: $e65282cf2edb9cec$export$66a4dfea2695736
    }, options));
}


function $0accfff25a685ee6$export$1c6885769b2bad6f(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $e65282cf2edb9cec$export$66a4dfea2695736)(input, index);
}
function $0accfff25a685ee6$export$f3c8e8146a7dbf93(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $e65282cf2edb9cec$export$c27cf446dc44c0b9)(input);
}
function $0accfff25a685ee6$export$8a7688a96d852767(input, options) {
    if (options === void 0) options = {};
    return (0, $e65282cf2edb9cec$export$26c6f48841fe1a8a)(input, (0, $4UZnF.__assign)({
        transform: $0accfff25a685ee6$export$1c6885769b2bad6f
    }, options));
}


var $4UZnF = parcelRequire("4UZnF");

var $4UZnF = parcelRequire("4UZnF");

function $008473d4ca81f46b$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $fa9614ee91f6c5c7$export$a596972587f860c8)(input, (0, $4UZnF.__assign)({
        delimiter: "."
    }, options));
}


function $8f7f4c9cd5da4454$export$c68d52815ae74c39(input, options) {
    if (options === void 0) options = {};
    return (0, $008473d4ca81f46b$export$e1b697368b9a68f5)(input, (0, $4UZnF.__assign)({
        delimiter: "-"
    }, options));
}


var $4UZnF = parcelRequire("4UZnF");

function $f8e0d52221dbefe5$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $008473d4ca81f46b$export$e1b697368b9a68f5)(input, (0, $4UZnF.__assign)({
        delimiter: "_"
    }, options));
}


const $b935691dabfbf70e$var$reduce = function(obj, f, accumulator_init) {
    return Object.keys(obj || {}).reduce((accumulator, key)=>{
        let value = obj[key];
        return f(accumulator, value, key, obj);
    }, accumulator_init);
};
const $b935691dabfbf70e$var$forEach = function(obj, f) {
    Object.keys(obj || {}).forEach((key)=>{
        let value = obj[key];
        f(value, key);
    });
};
// Note: This is a crappy version to a certain extent... don't use with Strings, for example...
const $b935691dabfbf70e$var$clone = function(object) {
    return Object.assign(new object.constructor(), object);
};
const $b935691dabfbf70e$var$cloneDeep = function(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object") return obj;
    if (obj instanceof Array) return obj.reduce((arr, item, i)=>{
        arr[i] = $b935691dabfbf70e$var$cloneDeep(item);
        return arr;
    }, []);
    if (obj instanceof Object) return Object.keys(obj || {}).reduce((cpObj, key)=>{
        cpObj[key] = $b935691dabfbf70e$var$cloneDeep(obj[key]);
        return cpObj;
    }, {});
};
const $b935691dabfbf70e$var$isObject = function(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
};
const $b935691dabfbf70e$var$isString = function(obj) {
    return typeof obj === "string" || obj instanceof String;
};
const $b935691dabfbf70e$var$isArray = function(obj) {
    return Array.isArray(obj);
};
const $b935691dabfbf70e$var$isEmpty = function(obj) {
    return [
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
function $b935691dabfbf70e$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
const $b935691dabfbf70e$var$filter = function(arr, filter) {
    if (typeof filter !== "function") throw "filter is not a function";
    if (typeof arr === "undefined") return [];
    return arr.filter(filter);
};
const $b935691dabfbf70e$var$assign = function() {
    let args = Array.prototype.slice.call(arguments);
    args.unshift({});
    return Object.assign(...args);
};
/* global Set */ const $b935691dabfbf70e$var$pull = function(arr, ...removeList) {
    var removeSet = new Set(removeList);
    for(let i = arr.length - 1; i >= 0; i--)if (removeSet.has(arr[i])) arr.splice(i, 1);
};
const $b935691dabfbf70e$var$unique = function(arr) {
    return [
        ...new Set(arr)
    ];
};
const $b935691dabfbf70e$var$upperFirst = function(str) {
    return str ? str[0].toUpperCase() + str.substr(1) : "";
};
const $b935691dabfbf70e$var$matchFn = function(inputObj, testObj) {
    if ($b935691dabfbf70e$var$isObject(testObj)) return Object.keys(testObj).every((key)=>$b935691dabfbf70e$var$matchFn(inputObj[key], testObj[key]));
    else return inputObj == testObj;
};
const $b935691dabfbf70e$var$matches = function(matchObj) {
    let cloneObj = $b935691dabfbf70e$var$cloneDeep(matchObj);
    let matchesFn = (inputObj)=>$b935691dabfbf70e$var$matchFn(inputObj, cloneObj);
    return matchesFn;
};
const $b935691dabfbf70e$var$DEFAULT_OPTIONS = {
    transform: $0accfff25a685ee6$export$f3c8e8146a7dbf93
};
const $b935691dabfbf70e$var$changeDefaultCaseTransform = function(caseFunction, default_options) {
    return (caseToChange, options)=>caseFunction(caseToChange, Object.assign({}, $b935691dabfbf70e$var$DEFAULT_OPTIONS, default_options, options));
};
$b935691dabfbf70e$exports = {
    each: $b935691dabfbf70e$var$forEach,
    forEach: $b935691dabfbf70e$var$forEach,
    forIn: $b935691dabfbf70e$var$forEach,
    keys: Object.keys,
    clone: $b935691dabfbf70e$var$clone,
    cloneDeep: $b935691dabfbf70e$var$cloneDeep,
    extend: Object.assign,
    isString: $b935691dabfbf70e$var$isString,
    isArray: $b935691dabfbf70e$var$isArray,
    isObject: $b935691dabfbf70e$var$isObject,
    isPlainObject: $b935691dabfbf70e$var$isPlainObject,
    isEmpty: $b935691dabfbf70e$var$isEmpty,
    filter: $b935691dabfbf70e$var$filter,
    reduce: $b935691dabfbf70e$var$reduce,
    assign: $b935691dabfbf70e$var$assign,
    upperFirst: $b935691dabfbf70e$var$upperFirst,
    camelCase: $b935691dabfbf70e$var$changeDefaultCaseTransform($0accfff25a685ee6$export$8a7688a96d852767),
    snakeCase: $f8e0d52221dbefe5$export$feae9a740c003485,
    kebabCase: $8f7f4c9cd5da4454$export$c68d52815ae74c39,
    pull: $b935691dabfbf70e$var$pull,
    matches: $b935691dabfbf70e$var$matches,
    unique: $b935691dabfbf70e$var$unique
};


/**
 * Performs an deep extend on the objects, from right to left.
 * @private
 * @param {Object[]} objects - An array of JS objects
 * @param {Function} collision - A function to be called when a merge collision happens.
 * @param {string[]} path - (for internal use) An array of strings which is the current path down the object when this is called recursively.
 * @returns {Object}
 */ function $ef92553cb6e83178$var$deepExtend(objects, collision, path) {
    if (objects == null) return {};
    var src, copyIsArray, copy, name, options, clone, target = objects[0] || {}, i = 1, length = objects.length;
    path = path || [];
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object") target = {};
    for(; i < length; i++){
        // Only deal with non-null/undefined values
        if ((options = objects[i]) != null) // Extend the base object
        for(name in options){
            if (!options.hasOwnProperty(name)) continue;
            if (name === "__proto__") continue;
            src = target[name];
            copy = options[name];
            // Prevent never-ending loop
            if (target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (copy && ($b935691dabfbf70e$exports.isPlainObject(copy) || (copyIsArray = $b935691dabfbf70e$exports.isArray(copy)))) {
                if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && $b935691dabfbf70e$exports.isArray(src) ? src : [];
                } else clone = src && $b935691dabfbf70e$exports.isPlainObject(src) ? src : {};
                var nextPath = path.slice(0);
                nextPath.push(name);
                // Never move original objects, clone them
                target[name] = $ef92553cb6e83178$var$deepExtend([
                    clone,
                    copy
                ], collision, nextPath);
            // Don't bring in undefined values
            } else if (copy !== undefined) {
                if (src != null && typeof collision == "function") collision({
                    target: target,
                    copy: options,
                    path: path,
                    key: name
                });
                target[name] = copy;
            }
        }
    }
    return target;
}
$ef92553cb6e83178$exports = $ef92553cb6e83178$var$deepExtend;


var $1d05f296c3717ce4$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/**
 * Takes an plain javascript object and will make a flat array of all the leaf nodes.
 * A leaf node in this context has a 'value' property. Potentially refactor this to
 * be more generic.
 * @private
 * @param  {Object} properties - The plain object you want flattened into an array.
 * @param  {Array} [to_ret=[]] - Properties array. This function is recursive therefore this is what gets passed along.
 * @return {Array}
 */ function $1d05f296c3717ce4$var$flattenProperties(properties, to_ret) {
    to_ret = to_ret || [];
    for(var name in properties)if (properties.hasOwnProperty(name)) {
        // TODO: this is a bit fragile and arbitrary to stop when we get to a 'value' property.
        if ($b935691dabfbf70e$exports.isPlainObject(properties[name]) && "value" in properties[name]) to_ret.push(properties[name]);
        else if ($b935691dabfbf70e$exports.isPlainObject(properties[name])) $1d05f296c3717ce4$var$flattenProperties(properties[name], to_ret);
    }
    return to_ret;
}
$1d05f296c3717ce4$exports = $1d05f296c3717ce4$var$flattenProperties;







// Internal Style Dictionary methods
/**
 * This will take a design token and add some data to it for it
 * to be used in JS/CSS. It will create its CSS var name and update
 * the value to use a CSS var if it is a reference. It will also
 * add a `.toString()` method to make it easier to use in JS.
 *
 * We should see if there is a way to share this logic with style dictionary...
 */ const $9119ccb92a2ac9ed$var$setupToken = ({ token: token, path: path })=>{
    const name = `--${(0, $b706ac0725f36f03$export$8658ddf1aae625a3)({
        path: path
    })}`;
    const { value: original } = token;
    const value = (0, $b706ac0725f36f03$export$55101aa37e5c1f8f)(token);
    return {
        name: name,
        original: original,
        path: path,
        value: value,
        toString: ()=>`var(${name})`
    };
};
/**
 * Takes a set of keys and a color name and returns an object of design tokens,
 * used for applying a primary color at the theme level to our tokens.
 *
 * createColorPalette({keys: ['10','20',...], value: 'red'})
 * returns {
 *   10: { value: '{colors.red.10.value}' },
 *   20: { value: '{colors.red.20.value}' },
 *   ...
 * }
 */ function $9119ccb92a2ac9ed$var$createColorPalette({ keys: keys, value: value }) {
    return keys.reduce((acc, key)=>{
        return {
            ...acc,
            [key]: {
                value: `{colors.${value}.${key}.value}`
            }
        };
    }, {});
}
/**
 * This will be used like `const myTheme = createTheme({})`
 * `myTheme` can then be passed to a Provider or the generated CSS
 * can be passed to a stylesheet at build-time or run-time.
 * const myTheme = createTheme({})
 * const myOtherTheme = createTheme({}, myTheme);
 */ function $9119ccb92a2ac9ed$export$25d302a5b900a763(theme, DefaultTheme = (0, $35080b1bd8feebe1$export$164de7ab8df77ef0)) {
    // merge theme and DefaultTheme to get a complete theme
    // deepExtend is an internal Style Dictionary method
    // that performs a deep merge on n objects. We could change
    // this to another 3p deep merge solution too.
    const mergedTheme = (0, (/*@__PURE__*/$parcel$interopDefault($ef92553cb6e83178$exports)))([
        {},
        DefaultTheme,
        theme
    ]);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor } = mergedTheme;
    // apply primaryColor and secondaryColor if present
    if ((0, $85b840b81f21bd6d$export$844ec244b1367d54)(primaryColor)) mergedTheme.tokens.colors.primary = $9119ccb92a2ac9ed$var$createColorPalette({
        keys: Object.keys(mergedTheme.tokens.colors[primaryColor]),
        value: primaryColor
    });
    if ((0, $85b840b81f21bd6d$export$844ec244b1367d54)(secondaryColor)) mergedTheme.tokens.colors.secondary = $9119ccb92a2ac9ed$var$createColorPalette({
        keys: Object.keys(mergedTheme.tokens.colors[secondaryColor]),
        value: secondaryColor
    });
    // Setting up the tokens. This is similar to what Style Dictionary
    // does. At the end of this, each token should have:
    // - CSS variable name of itself
    // - its value (reference to another CSS variable or raw value)
    const tokens = (0, $b706ac0725f36f03$export$4ae67d38aae8ca2e)({
        tokens: mergedTheme.tokens,
        setupToken: $9119ccb92a2ac9ed$var$setupToken
    }); // Setting the type here because setupTokens is recursive
    const { breakpoints: breakpoints, name: name } = mergedTheme;
    // flattenProperties is another internal Style Dictionary function
    // that creates an array of all tokens.
    let cssText = `[data-amplify-theme="${name}"] {\n` + (0, (/*@__PURE__*/$parcel$interopDefault($1d05f296c3717ce4$exports)))(tokens).map((token)=>`${token.name}: ${token.value};`).join("\n") + `\n}\n`;
    let overrides = [];
    /**
     * For each override, we setup the tokens and then generate the CSS.
     * This allows us to have one single CSS string for all possible overrides
     * and avoid re-renders in React, but also support other frameworks as well.
     */ if (mergedTheme.overrides) overrides = mergedTheme.overrides.map((override)=>{
        const tokens = (0, $b706ac0725f36f03$export$4ae67d38aae8ca2e)({
            tokens: override.tokens,
            setupToken: $9119ccb92a2ac9ed$var$setupToken
        });
        const customProperties = (0, (/*@__PURE__*/$parcel$interopDefault($1d05f296c3717ce4$exports)))(tokens).map((token)=>`${token.name}: ${token.value};`).join("\n");
        // Overrides can have a selector, media query, breakpoint, or color mode
        // for creating the selector
        if ("selector" in override) cssText += `\n${override.selector} {\n${customProperties}\n}\n`;
        if ("mediaQuery" in override) cssText += `\n@media (${override.mediaQuery}) {
  [data-amplify-theme="${name}"] {
    ${customProperties}
  }
}\n`;
        if ("breakpoint" in override) {
            const breakpoint = mergedTheme.breakpoints.values[override.breakpoint];
            cssText += `\n@media (min-width: ${breakpoint}px) {
  [data-amplify-theme="${name}"] {
    ${customProperties}
  }
}\n`;
        }
        if ("colorMode" in override) {
            cssText += `\n@media (prefers-color-scheme: ${override.colorMode}) {
          [data-amplify-theme="${name}"][data-amplify-color-mode="system"] {
            ${customProperties}
            color-scheme: ${override.colorMode};
          }
        }\n`;
            cssText += `\n[data-amplify-theme="${name}"][data-amplify-color-mode="${override.colorMode}"] {
          ${customProperties}
          color-scheme: ${override.colorMode};
        }\n`;
        }
        return {
            ...override,
            tokens: tokens
        };
    });
    return {
        tokens: tokens,
        breakpoints: breakpoints,
        name: name,
        cssText: cssText,
        overrides: // keep overrides separate from base theme
        // this allows web platforms to use plain CSS scoped to a
        // selector and only override the CSS vars needed. This
        // means we could generate CSS at build-time in a postcss
        // plugin, or do it at runtime and inject the CSS into a
        // style tag.
        // This also allows RN to dynamically switch themes in a
        // provider.
        overrides
    };
}



var $2hDQc = parcelRequire("2hDQc");

const $85fda1b943c36a9d$export$2c657da244d00bd6 = $2hDQc.createContext({
    theme: (0, $9119ccb92a2ac9ed$export$25d302a5b900a763)(),
    colorMode: undefined
});


/**
 * Get current Theme object value from Amplify context.
 * Returns a default theme if context is not available
 */ const $5d7454344a59ab33$export$1a3896b0420de28d = (context)=>{
    if (typeof context === "undefined" || typeof context.theme === "undefined") return (0, $9119ccb92a2ac9ed$export$25d302a5b900a763)();
    return context.theme;
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/theming)
 */ const $5d7454344a59ab33$export$93d4e7f90805808f = ()=>{
    const context = $2hDQc.useContext((0, $85fda1b943c36a9d$export$2c657da244d00bd6));
    return $5d7454344a59ab33$export$1a3896b0420de28d(context);
};
/**
 * Internal use only
 */ const $5d7454344a59ab33$export$20f3076712c8dfa = ()=>{
    const context = $2hDQc.useContext((0, $85fda1b943c36a9d$export$2c657da244d00bd6));
    return context.colorMode;
};




/**
 * This takes an unknown value, which could be a:
 * - design token: `color={tokens.colors.font.primary}`
 * - string, which could be a:
 *   - theme key: `color='font.primary'`
 *   - plain style: `color='red'`
 * - or a number: `padding={10}`
 * and returns the appropriate and resolved value
 */ const $3fdb13c1b6570e4f$export$741ad47189a64aa0 = ({ value: value, propKey: propKey, tokens: tokens })=>{
    if ((0, $b706ac0725f36f03$export$daee9cd42beef6d1)(value)) return value.toString();
    if ((0, $85b840b81f21bd6d$export$844ec244b1367d54)(value)) return (0, $85b840b81f21bd6d$export$844ec244b1367d54)(propKey) ? (0, $ceac741e44b5a224$export$b0c777ec01738e5b)(propKey, value, tokens) : value;
    return null;
};



const $5f1ff41e4cf190a9$export$63d3b2476bc623b7 = (spanValue)=>{
    return spanValue === "auto" || typeof spanValue === "number" && !isNaN(spanValue) || typeof spanValue === "string" && !isNaN(parseFloat(spanValue));
};
const $5f1ff41e4cf190a9$export$7a05ae144bf7b4de = (spanValue)=>{
    return spanValue === "auto" ? "auto" : `span ${spanValue}`;
};
const $5f1ff41e4cf190a9$export$2289a9e09445ac09 = (spanValue)=>{
    // PropertyType
    if ($5f1ff41e4cf190a9$export$63d3b2476bc623b7(spanValue)) return $5f1ff41e4cf190a9$export$7a05ae144bf7b4de(spanValue);
    // PropertyType[]
    if (Array.isArray(spanValue)) return spanValue.map((value)=>$5f1ff41e4cf190a9$export$7a05ae144bf7b4de(value));
    // ResponsiveObject<PropertyType>
    if (typeof spanValue === "object" && spanValue != null) return Object.entries(spanValue).reduce((acc, [key, value])=>({
            ...acc,
            [key]: $5f1ff41e4cf190a9$export$7a05ae144bf7b4de(value)
        }), {});
    return null;
};
/**
 * Transforms style props to another target prop
 * where the original is a simpler API than the target.
 * This function will remove the original prop and
 * replace target prop values with calculated
 * E.g. rowSpan => row, columnSpan => column
 */ const $5f1ff41e4cf190a9$export$708ec223603a550 = (props)=>{
    const { rowSpan: rowSpan, columnSpan: columnSpan, row: row, column: column, ...rest } = props;
    const { rowFromSpanValue: rowFromSpanValue, columnFromSpanValue: columnFromSpanValue } = $2hDQc.useMemo(()=>{
        return {
            rowFromSpanValue: $5f1ff41e4cf190a9$export$2289a9e09445ac09(rowSpan),
            columnFromSpanValue: $5f1ff41e4cf190a9$export$2289a9e09445ac09(columnSpan)
        };
    }, [
        rowSpan,
        columnSpan
    ]);
    return {
        row: !(0, $ceac741e44b5a224$export$68b32c1946a6b59c)(row) ? row : rowFromSpanValue,
        column: !(0, $ceac741e44b5a224$export$68b32c1946a6b59c)(column) ? column : columnFromSpanValue,
        ...rest
    };
};
const $5f1ff41e4cf190a9$var$isComponentStyleProp = (key)=>{
    return key in (0, $2dee35cb0db75fdf$export$c69338bc7d797351);
};
/**
 * Convert style props to CSS variables for React style prop
 * Note: Will filter out undefined, null, and empty string prop values
 */ const $5f1ff41e4cf190a9$export$2184e8c9a9308f34 = ({ props: props = {}, style: style = {}, breakpoint: breakpoint, breakpoints: breakpoints, tokens: tokens })=>{
    const nonStyleProps = {};
    Object.keys(props).filter((propKey)=>props[propKey] !== null).forEach((propKey)=>{
        if ($5f1ff41e4cf190a9$var$isComponentStyleProp(propKey)) {
            const values = props[propKey];
            if (!values || (0, $ceac741e44b5a224$export$78d1711480f95c3e)(values)) return;
            const reactStyleProp = (0, $2dee35cb0db75fdf$export$c69338bc7d797351)[propKey];
            // short circuit the style prop here if it is a string or design token
            // so we don't have to call getValueAtCurrentBreakpoint every time
            let value = "";
            if ((0, $b706ac0725f36f03$export$daee9cd42beef6d1)(values)) value = values.toString();
            else if (typeof values === "string") value = (0, $ceac741e44b5a224$export$b0c777ec01738e5b)(propKey, values, tokens);
            else if (typeof values === "number") value = values;
            else if (typeof values === "object") // here values should be a responsive array or object
            value = (0, $3fdb13c1b6570e4f$export$741ad47189a64aa0)({
                propKey: propKey,
                tokens: tokens,
                value: (0, $c445291e42fe2972$export$7791b19c8f6fdbca)({
                    values: values,
                    breakpoint: breakpoint,
                    breakpoints: breakpoints
                })
            });
            style = {
                ...style,
                [reactStyleProp]: value
            };
        } else if (typeof props[propKey] !== "undefined") nonStyleProps[propKey] = props[propKey];
    });
    return {
        propStyles: style,
        nonStyleProps: nonStyleProps
    };
};
const $5f1ff41e4cf190a9$export$28e6b9b82ee883c = (props, style)=>{
    const { breakpoints: { values: breakpoints, defaultBreakpoint: defaultBreakpoint }, tokens: tokens } = (0, $5d7454344a59ab33$export$93d4e7f90805808f)();
    const breakpoint = (0, $632ca023bc088c4a$export$199d6754bdf4e1e3)({
        breakpoints: breakpoints,
        defaultBreakpoint: defaultBreakpoint
    });
    const propStyles = $5f1ff41e4cf190a9$export$708ec223603a550(props);
    return $2hDQc.useMemo(()=>$5f1ff41e4cf190a9$export$2184e8c9a9308f34({
            props: propStyles,
            style: style,
            breakpoint: breakpoint,
            breakpoints: breakpoints,
            tokens: tokens
        }), [
        propStyles,
        style,
        breakpoints,
        breakpoint,
        tokens
    ]);
};



const $65027f4b45f2008d$var$ViewPrimitive = ({ as: as = "div", children: children, testId: testId, ariaLabel: ariaLabel, isDisabled: isDisabled, style: style, inert: inert, ...rest }, ref)=>{
    const { propStyles: propStyles, nonStyleProps: nonStyleProps } = (0, $5f1ff41e4cf190a9$export$28e6b9b82ee883c)(rest, style);
    return $2hDQc.createElement(as, {
        "aria-label": ariaLabel,
        "data-testid": testId,
        disabled: isDisabled,
        ref: ref,
        inert: inert ? "" : null,
        style: propStyles,
        ...nonStyleProps
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/view)
 */ const $65027f4b45f2008d$export$27a5bd065ad55220 = (0, $62181de68de3c447$export$44aa160b17c73194)($65027f4b45f2008d$var$ViewPrimitive);
$65027f4b45f2008d$export$27a5bd065ad55220.displayName = "View";



const $f9df95057f6ae67f$var$FlexPrimitive = ({ className: className, children: children, ...rest }, ref)=>$2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Flex, className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/flex)
 */ const $f9df95057f6ae67f$export$f51f4c4ede09e011 = (0, $62181de68de3c447$export$44aa160b17c73194)($f9df95057f6ae67f$var$FlexPrimitive);
$f9df95057f6ae67f$export$f51f4c4ede09e011.displayName = "Flex";



var $2hDQc = parcelRequire("2hDQc");



const $5bf65e8aa1938c3f$export$c47c5262afb3a760 = "linear-empty";
const $5bf65e8aa1938c3f$export$84e78a619b590ebb = "linear-filled";
const $5bf65e8aa1938c3f$export$2dac697651a47d0c = "circular-empty";
const $5bf65e8aa1938c3f$export$c6c37ac3a7f79d5a = "circular-filled";
// radius + strokeWidth = 50
const $5bf65e8aa1938c3f$export$a2450a64b7863610 = 8;
const $5bf65e8aa1938c3f$export$2d2c9be8b5b863f = 42;
// circumference = 2 * r * PI  (r = 42)
const $5bf65e8aa1938c3f$export$d13f13f2833cdb46 = 2 * $5bf65e8aa1938c3f$export$2d2c9be8b5b863f * Math.PI;
const $5bf65e8aa1938c3f$var$LoaderPrimitive = ({ className: className, filledColor: filledColor, emptyColor: emptyColor, size: size, variation: variation, isDeterminate: isDeterminate = false, isPercentageTextHidden: isPercentageTextHidden = false, percentage: percentage = 0, ...rest }, ref)=>{
    percentage = Math.min(percentage, 100);
    percentage = Math.max(percentage, 0);
    const percent = `${percentage}%`;
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Loader, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Loader, size), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Loader, variation), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Loader, "determinate", isDeterminate), className);
    const linearLoader = $2hDQc.createElement("g", null, $2hDQc.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: String(emptyColor)
        },
        "data-testid": $5bf65e8aa1938c3f$export$c47c5262afb3a760
    }), $2hDQc.createElement("line", {
        x1: "0",
        x2: isDeterminate ? percent : "100%",
        y1: "50%",
        y2: "50%",
        style: {
            // To get rid of the visible stroke linecap when percentage is 0
            stroke: isDeterminate && percentage === 0 ? "none" : filledColor ? String(filledColor) : undefined
        },
        "data-testid": $5bf65e8aa1938c3f$export$84e78a619b590ebb
    }), isDeterminate ? $2hDQc.createElement("text", {
        "aria-live": "polite",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).LoaderLabel, isPercentageTextHidden ? (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden : null),
        // -1% offset makes the text position look nicest
        x: `${-1 + percentage}%`,
        y: "200%"
    }, percent) : null);
    // r + stroke-width should add up to 50% to avoid overflow
    const circularLoader = $2hDQc.createElement("g", null, $2hDQc.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: `${$5bf65e8aa1938c3f$export$2d2c9be8b5b863f}%`,
        strokeWidth: `${$5bf65e8aa1938c3f$export$a2450a64b7863610}%`,
        style: {
            stroke: String(emptyColor)
        },
        "data-testid": $5bf65e8aa1938c3f$export$2dac697651a47d0c
    }), $2hDQc.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: `${$5bf65e8aa1938c3f$export$2d2c9be8b5b863f}%`,
        strokeWidth: `${$5bf65e8aa1938c3f$export$a2450a64b7863610}%`,
        style: {
            stroke: String(filledColor),
            strokeDasharray: isDeterminate ? `${$5bf65e8aa1938c3f$export$d13f13f2833cdb46}% ${$5bf65e8aa1938c3f$export$d13f13f2833cdb46}%` : undefined,
            strokeDashoffset: isDeterminate ? `${$5bf65e8aa1938c3f$export$d13f13f2833cdb46 - $5bf65e8aa1938c3f$export$d13f13f2833cdb46 * percentage / 100}%` : undefined
        },
        "data-testid": $5bf65e8aa1938c3f$export$c6c37ac3a7f79d5a
    }), isDeterminate ? $2hDQc.createElement("text", {
        "aria-live": "polite",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).LoaderLabel, isPercentageTextHidden ? (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden : null),
        // this x and y make text position look nicest
        x: "130%",
        y: "80%"
    }, percent) : null);
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "svg",
        className: componentClasses,
        ref: ref,
        role: "img",
        ...rest
    }, variation === "linear" ? linearLoader : circularLoader);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/loader)
 */ const $5bf65e8aa1938c3f$export$3b0d6d7590275603 = (0, $62181de68de3c447$export$44aa160b17c73194)($5bf65e8aa1938c3f$var$LoaderPrimitive);
$5bf65e8aa1938c3f$export$3b0d6d7590275603.displayName = "Loader";



// These variations support colorThemes. 'undefined' accounts for our
// 'default' variation which is not named.
const $6933ba031aede256$var$supportedVariations = [
    "link",
    "primary",
    undefined
];
const $6933ba031aede256$var$ButtonPrimitive = ({ className: className, children: children, colorTheme: colorTheme, isFullWidth: isFullWidth = false, isDisabled: isDisabled, isLoading: isLoading, loadingText: loadingText = "", size: size, type: type = "button", variation: variation, ...rest }, ref)=>{
    // Creates our colorTheme modifier string based on if the variation
    // supports colorThemes and a colorTheme is used.
    const colorThemeModifier = $6933ba031aede256$var$supportedVariations.includes(variation) && colorTheme ? `${variation ?? "outlined"}--${colorTheme}` : undefined;
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $7bec285a424993af$export$b140571ec72925dd)();
    const shouldBeDisabled = isFieldsetDisabled ? isFieldsetDisabled : isDisabled ?? isLoading ?? rest["disabled"];
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, variation), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, colorThemeModifier), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, size), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, "disabled", shouldBeDisabled), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, "loading", isLoading), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Button, "fullwidth", isFullWidth), className);
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        ref: ref,
        as: "button",
        className: componentClasses,
        isDisabled: shouldBeDisabled,
        type: type,
        ...rest
    }, isLoading ? $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "span",
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).ButtonLoaderWrapper
    }, $2hDQc.createElement((0, $5bf65e8aa1938c3f$export$3b0d6d7590275603), {
        size: size
    }), loadingText ? loadingText : null) : children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/button)
 */ const $6933ba031aede256$export$353f5b6fc5456de1 = (0, $62181de68de3c447$export$44aa160b17c73194)($6933ba031aede256$var$ButtonPrimitive);
$6933ba031aede256$export$353f5b6fc5456de1.displayName = "Button";




var $2hDQc = parcelRequire("2hDQc");



const $9d1ea6f43618b301$var$headingLevels = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $9d1ea6f43618b301$var$HeadingPrimitive = ({ className: className, children: children, isTruncated: isTruncated, level: level = 6, ...rest }, ref)=>$2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: $9d1ea6f43618b301$var$headingLevels[level],
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Heading, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Heading, level), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Heading, "truncated", isTruncated), className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/heading)
 */ const $9d1ea6f43618b301$export$a8a3e93435678ff9 = (0, $62181de68de3c447$export$44aa160b17c73194)($9d1ea6f43618b301$var$HeadingPrimitive);
$9d1ea6f43618b301$export$a8a3e93435678ff9.displayName = "Heading";



var $2hDQc = parcelRequire("2hDQc");



const $387905725642d69a$var$TextPrimitive = ({ as: as = "p", className: className, children: children, isTruncated: isTruncated, variation: variation, ...rest }, ref)=>{
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Text, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Text, variation), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Text, "truncated", isTruncated), className);
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: as,
        className: componentClasses,
        ref: ref,
        ...rest
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/text)
 */ const $387905725642d69a$export$5f1af8db9871e1d6 = (0, $62181de68de3c447$export$44aa160b17c73194)($387905725642d69a$var$TextPrimitive);
$387905725642d69a$export$5f1af8db9871e1d6.displayName = "Text";





var $2hDQc = parcelRequire("2hDQc");
const $796503614faf5aa2$export$e29bbbec84471f66 = (event)=>{
    const formData = new FormData(event.target);
    return Object.fromEntries(formData);
};



function $75eb2fee620372ec$export$df6a82844cee724c() {
    const { submitForm: submitForm, updateBlur: updateBlur, updateForm: updateForm } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.submitForm,
            context.updateBlur,
            context.updateForm
        ]);
    const handleBlur = (0, $2hDQc.useCallback)(({ target: { name: name } })=>{
        updateBlur({
            name: name
        });
    }, [
        updateBlur
    ]);
    // @TODO: align multiple input type handling with react docs example for 3.0 release
    // example: https://reactjs.org/docs/forms.html#handling-multiple-inputs
    const handleChange = (0, $2hDQc.useCallback)(({ target: { checked: checked, name: name, type: type, value: value } })=>{
        const isUncheckedCheckbox = type === "checkbox" && !checked;
        updateForm({
            name: name,
            value: isUncheckedCheckbox ? undefined : value
        });
    }, [
        updateForm
    ]);
    const handleSubmit = (0, $2hDQc.useCallback)((event)=>{
        event.preventDefault();
        submitForm((0, $796503614faf5aa2$export$e29bbbec84471f66)(event));
    }, [
        submitForm
    ]);
    return {
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleSubmit: handleSubmit
    };
}



var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");







var $2hDQc = parcelRequire("2hDQc");




var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
const $bcd4c7704ec2a7ba$export$5f8c516af44338bb = $2hDQc.createContext({});


function $7b83175df15408b7$export$75b0b37acc90e887(component) {
    const context = $2hDQc.useContext((0, $bcd4c7704ec2a7ba$export$5f8c516af44338bb));
    if (component && context) return context[component];
    return undefined;
}




var $2hDQc = parcelRequire("2hDQc");


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $192929345306a92d$export$8fb9587943155ce3 = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
        fill: "currentColor"
    })));
};




var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $941499338b013165$export$66493327321323ad = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
    })));
};




var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $8c29ade880258910$export$340bfce9b4df026b = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
        fill: "currentColor"
    })));
};




var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $4a9c4ed2e011cbd2$export$5be70e40251e6f9b = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
    })));
};


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $6b5487a80ac0946a$export$4a143c8822a09fb4 = ({ variation: variation, ariaHidden: ariaHidden })=>{
    const icons = (0, $7b83175df15408b7$export$75b0b37acc90e887)("alert");
    let icon;
    switch(variation){
        case "info":
            icon = icons?.info ?? $2hDQc.createElement((0, $8c29ade880258910$export$340bfce9b4df026b), {
                "aria-hidden": ariaHidden
            });
            break;
        case "error":
            icon = icons?.error ?? $2hDQc.createElement((0, $941499338b013165$export$66493327321323ad), {
                "aria-hidden": ariaHidden
            });
            break;
        case "warning":
            icon = icons?.warning ?? $2hDQc.createElement((0, $4a9c4ed2e011cbd2$export$5be70e40251e6f9b), {
                "aria-hidden": ariaHidden
            });
            break;
        case "success":
            icon = icons?.success ?? $2hDQc.createElement((0, $192929345306a92d$export$8fb9587943155ce3), {
                "aria-hidden": ariaHidden
            });
            break;
    }
    return icon ? $2hDQc.createElement("span", {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).AlertIcon
    }, icon) : null;
};
$6b5487a80ac0946a$export$4a143c8822a09fb4.displayName = "AlertIcon";







var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $db58a20639839e85$export$e04bcc6127e699bf = (props)=>{
    const { className: className, size: size, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: size ?? "1em",
        height: size ?? "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: size ? {
            width: size,
            height: size
        } : undefined
    }, $2hDQc.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
    })));
};


const $1e9f9f155afe969d$var$AlertPrimitive = ({ buttonRef: buttonRef, children: children, className: className, dismissButtonLabel: dismissButtonLabel = (0, $dca455d5eea3302b$export$529e7eefcb1e2a4c).Alert.dismissButtonLabel, hasIcon: hasIcon = true, heading: heading, isDismissible: isDismissible = false, onDismiss: onDismiss, variation: variation, ...rest }, ref)=>{
    const [dismissed, setDismissed] = $2hDQc.useState(false);
    const icons = (0, $7b83175df15408b7$export$75b0b37acc90e887)("alert");
    const dismissAlert = $2hDQc.useCallback(()=>{
        setDismissed(!dismissed);
        if ((0, $85b840b81f21bd6d$export$f6e2535fb5126e54)(onDismiss)) onDismiss();
    }, [
        setDismissed,
        onDismiss,
        dismissed
    ]);
    return !dismissed ? $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Alert, className, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Alert, variation)),
        ref: ref,
        role: "alert",
        ...rest
    }, hasIcon && $2hDQc.createElement((0, $6b5487a80ac0946a$export$4a143c8822a09fb4), {
        variation: variation,
        ariaHidden: true
    }), $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        flex: "1"
    }, heading && $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).AlertHeading
    }, heading), $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).AlertBody
    }, children)), isDismissible && $2hDQc.createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        ariaLabel: dismissButtonLabel,
        variation: "link",
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).AlertDismiss,
        onClick: dismissAlert,
        ref: buttonRef
    }, icons?.close ?? $2hDQc.createElement((0, $db58a20639839e85$export$e04bcc6127e699bf), {
        "aria-hidden": "true"
    }))) : null;
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/alert)
 */ const $1e9f9f155afe969d$export$caec2af78bcc877f = (0, $62181de68de3c447$export$44aa160b17c73194)($1e9f9f155afe969d$var$AlertPrimitive);
$1e9f9f155afe969d$export$caec2af78bcc877f.displayName = "Alert";


const $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a = ()=>{
    const { error: error } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.error
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, error ? (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $1e9f9f155afe969d$export$caec2af78bcc877f), {
        variation: "error",
        isDismissible: true
    }, (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(error)) : null);
};



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");



const $6a564f6545e800b7$var$VisuallyHiddenPrimitive = ({ as: as = "span", children: children, className: className, ...rest }, ref)=>$2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: as,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden, className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/visuallyhidden)
 */ const $6a564f6545e800b7$export$439d29a4e110a164 = (0, $62181de68de3c447$export$44aa160b17c73194)($6a564f6545e800b7$var$VisuallyHiddenPrimitive);
$6a564f6545e800b7$export$439d29a4e110a164.displayName = "VisuallyHidden";









var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $9eae99243a9f7cd6$export$9ef36bcf05bb63d9 = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
        fill: "currentColor"
    })));
};




var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $df68723f9f3eed43$export$e8b904c5d6d728c0 = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
        fill: "currentColor"
    })));
};



const { passwordIsHidden: $53546277b3698700$var$passwordIsHidden, passwordIsShown: $53546277b3698700$var$passwordIsShown, showPassword: $53546277b3698700$var$showPassword } = (0, $dca455d5eea3302b$export$529e7eefcb1e2a4c).PasswordField;
const $53546277b3698700$var$ShowPasswordButtonPrimitive = ({ fieldType: fieldType, passwordIsHiddenLabel: passwordIsHiddenLabel = $53546277b3698700$var$passwordIsHidden, passwordIsShownLabel: passwordIsShownLabel = $53546277b3698700$var$passwordIsShown, showPasswordButtonLabel: showPasswordButtonLabel = $53546277b3698700$var$showPassword, size: size, hasError: hasError, ...rest }, ref)=>{
    const icons = (0, $7b83175df15408b7$export$75b0b37acc90e887)("passwordField");
    const showPasswordButtonClass = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldShowPassword, (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldShowPassword, "error", hasError));
    const icon = fieldType === "password" ? icons?.visibility ?? $2hDQc.createElement((0, $df68723f9f3eed43$export$e8b904c5d6d728c0), {
        "aria-hidden": "true"
    }) : icons?.visibilityOff ?? $2hDQc.createElement((0, $9eae99243a9f7cd6$export$9ef36bcf05bb63d9), {
        "aria-hidden": "true"
    });
    return $2hDQc.createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        "aria-checked": fieldType !== "password",
        ariaLabel: showPasswordButtonLabel,
        className: showPasswordButtonClass,
        ref: ref,
        role: "switch",
        size: size,
        ...rest
    }, $2hDQc.createElement((0, $6a564f6545e800b7$export$439d29a4e110a164), {
        "aria-live": "polite"
    }, fieldType === "password" ? passwordIsHiddenLabel : passwordIsShownLabel), icon);
};
const $53546277b3698700$export$c42f83a0ca8c8188 = (0, $62181de68de3c447$export$44aa160b17c73194)($53546277b3698700$var$ShowPasswordButtonPrimitive);
$53546277b3698700$export$c42f83a0ca8c8188.displayName = "ShowPasswordButton";



var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");


const $1b05dc3c654ece32$export$806e181b7f4dca8a = "qa-field-description";
const $1b05dc3c654ece32$export$873ced4623a3149c = ({ descriptiveText: descriptiveText, labelHidden: labelHidden, ...rest })=>descriptiveText ? $2hDQc.createElement((0, $387905725642d69a$export$5f1af8db9871e1d6), {
        "data-testid": $1b05dc3c654ece32$export$806e181b7f4dca8a,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldDescription, {
            [(0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden]: labelHidden
        }),
        ...rest
    }, descriptiveText) : null;
$1b05dc3c654ece32$export$873ced4623a3149c.displayName = "FieldDescription";



var $2hDQc = parcelRequire("2hDQc");


const $daba90391b752297$export$1c081951d49ad6f6 = ({ errorMessage: errorMessage, hasError: hasError, ...rest })=>{
    return hasError && errorMessage ? $2hDQc.createElement((0, $387905725642d69a$export$5f1af8db9871e1d6), {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldErrorMessage,
        ...rest
    }, errorMessage) : null;
};
$daba90391b752297$export$1c081951d49ad6f6.displayName = "FieldErrorMessage";




var $2hDQc = parcelRequire("2hDQc");




const $908db1108648c2f9$var$FieldGroupPrimitive = ({ children: children, className: className, innerEndComponent: innerEndComponent, innerStartComponent: innerStartComponent, orientation: orientation = "horizontal", outerEndComponent: outerEndComponent, outerStartComponent: outerStartComponent, variation: variation, ...rest }, ref)=>{
    // Don't apply hasInner classnames unless a component was provided
    const hasInnerStartComponent = innerStartComponent != null;
    const hasInnerEndComponent = innerEndComponent != null;
    const fieldGroupHasInnerStartClassName = hasInnerStartComponent ? (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerStart : null;
    const fieldGroupHasInnerEndClassName = hasInnerEndComponent ? (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerEnd : null;
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroup, fieldGroupHasInnerStartClassName, fieldGroupHasInnerEndClassName, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroup, orientation), className);
    return $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        className: componentClasses,
        ref: ref,
        ...rest
    }, outerStartComponent && $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart, variation))
    }, outerStartComponent), $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper, orientation))
    }, innerStartComponent && $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupInnerStart
    }, innerStartComponent), children, innerEndComponent && $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupInnerEnd
    }, innerEndComponent)), outerEndComponent && $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd, variation))
    }, outerEndComponent));
};
const $908db1108648c2f9$export$f0fe469072bc6950 = (0, $62181de68de3c447$export$44aa160b17c73194)($908db1108648c2f9$var$FieldGroupPrimitive);
$908db1108648c2f9$export$f0fe469072bc6950.displayName = "FieldGroup";




var $2hDQc = parcelRequire("2hDQc");




const $039f045064e97e9e$var$InputPrimitive = ({ autoComplete: autoComplete, checked: checked, className: className, defaultChecked: defaultChecked, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, size: size, type: type = "text", hasError: hasError = false, value: value, variation: variation, ...rest }, ref)=>{
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Input, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Input, variation), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Input, "error", hasError), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Input, size), className);
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $7bec285a424993af$export$b140571ec72925dd)();
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "aria-invalid": hasError,
        as: "input",
        autoComplete: autoComplete,
        checked: checked,
        className: componentClasses,
        defaultChecked: defaultChecked,
        defaultValue: defaultValue,
        isDisabled: isFieldsetDisabled ? isFieldsetDisabled : isDisabled,
        id: id,
        readOnly: isReadOnly,
        ref: ref,
        required: isRequired,
        type: type,
        value: value,
        ...rest
    });
};
const $039f045064e97e9e$export$f5b8910cec6cf069 = (0, $62181de68de3c447$export$44aa160b17c73194)($039f045064e97e9e$var$InputPrimitive);
$039f045064e97e9e$export$f5b8910cec6cf069.displayName = "Input";



var $2hDQc = parcelRequire("2hDQc");



const $df3d0f3d4df7a922$var$LabelPrimitive = ({ children: children, className: className, visuallyHidden: visuallyHidden, ...rest }, ref)=>{
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "label",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Label, className, {
            [(0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden]: visuallyHidden
        }),
        ref: ref,
        ...rest
    }, children);
};
const $df3d0f3d4df7a922$export$b04be29aa201d4f5 = (0, $62181de68de3c447$export$44aa160b17c73194)($df3d0f3d4df7a922$var$LabelPrimitive);
$df3d0f3d4df7a922$export$b04be29aa201d4f5.displayName = "Label";



const $adc705eec999410b$var$isStyleKey = (prop)=>{
    return prop in (0, $2dee35cb0db75fdf$export$c69338bc7d797351);
};
/**
 * This function splits props into style props and non-style props. This is used
 * on Field primitives so we can apply style props on the wrapper element and
 * the rest on the input.
 * @param props this should be a destructured `rest` from the component's props
 */ const $adc705eec999410b$export$584a75f5facb0a5 = (props)=>{
    const splitProps = {
        styleProps: {},
        rest: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ($adc705eec999410b$var$isStyleKey(prop)) // we know it is a style key
        // so we know we can assign the key in styleProps
        splitProps.styleProps = {
            ...splitProps.styleProps,
            [prop]: props[prop]
        };
        else splitProps.rest = {
            ...splitProps.rest,
            [prop]: props[prop]
        };
    });
    return splitProps;
};



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
// Source: https://github.com/radix-ui/primitives/blob/7ae63b6cce6ea53ea5d65b6d411894c004b38f47/packages/react/use-layout-effect/src/useLayoutEffect.tsx
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $d43ae446e4c69b5b$export$e5c5a5f917a5871c = globalThis?.document ? $2hDQc.useLayoutEffect : ()=>{};


// Adapted from https://github.com/radix-ui/primitives/blob/main/packages/react/id/src/id.tsx#L8
// Prefixed autogenerated id created by useStableId
const $e37092acc6c1e2fc$export$766b2b49c9d08de4 = "amplify-id";
// Create a local version of React.useId which will reference React.useId for React 18
// and fallback to noop for React 17 and below
// Note: We use `toString()` to prevent bundlers from trying to `import { useId } from 'react';`
// since it doesn't exist in React 17 and below (prevents https://github.com/aws-amplify/amplify-ui/issues/1154)
const $e37092acc6c1e2fc$var$useReactId = // disable eslint below to allow usage of casting React to `any`, which ensures that TS
// does not get confused about the existence of `useId` in React 17 and below
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
$2hDQc["useId".toString()] || (()=>undefined);
let $e37092acc6c1e2fc$var$count = 0;
/**
 * Create a uuid to use with amplify fields unless
 * an id is provided
 * @param id user specified id
 * @returns string
 */ const $e37092acc6c1e2fc$export$5c0b1cf3fea224ac = (id)=>{
    const [stableId, setStableId] = $2hDQc.useState($e37092acc6c1e2fc$var$useReactId());
    // React versions older than 18 will have client-side ids only
    (0, $d43ae446e4c69b5b$export$e5c5a5f917a5871c)(()=>{
        if (!id) setStableId((reactId)=>reactId ?? String($e37092acc6c1e2fc$var$count++));
    }, [
        id
    ]);
    return id ?? (stableId ? `${$e37092acc6c1e2fc$export$766b2b49c9d08de4}-${stableId}` : "");
};



const $8a519bedd156dc2e$var$TextFieldPrimitive = (props, ref)=>{
    const { className: className, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, innerEndComponent: innerEndComponent, innerStartComponent: innerStartComponent, label: label, labelHidden: labelHidden = false, outerEndComponent: outerEndComponent, outerStartComponent: outerStartComponent, size: size, testId: testId, variation: variation, inputStyles: inputStyles, ..._rest } = props;
    const fieldId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)(id);
    const descriptionId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = descriptiveText ? descriptionId : undefined;
    const { styleProps: styleProps, rest: rest } = (0, $adc705eec999410b$export$584a75f5facb0a5)(_rest);
    return $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Field, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Field, size), (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TextField, className),
        testId: testId,
        ...styleProps
    }, $2hDQc.createElement((0, $df3d0f3d4df7a922$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        visuallyHidden: labelHidden
    }, label), $2hDQc.createElement((0, $1b05dc3c654ece32$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: labelHidden,
        descriptiveText: descriptiveText
    }), $2hDQc.createElement((0, $908db1108648c2f9$export$f0fe469072bc6950), {
        outerStartComponent: outerStartComponent,
        outerEndComponent: outerEndComponent,
        innerStartComponent: innerStartComponent,
        innerEndComponent: innerEndComponent,
        variation: variation
    }, $2hDQc.createElement((0, $039f045064e97e9e$export$f5b8910cec6cf069), {
        "aria-describedby": ariaDescribedBy,
        hasError: hasError,
        id: fieldId,
        ref: ref,
        size: size,
        variation: variation,
        ...inputStyles,
        ...rest
    })), $2hDQc.createElement((0, $daba90391b752297$export$1c081951d49ad6f6), {
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/textfield)
 */ const $8a519bedd156dc2e$export$2c73285ae9390cec = (0, $62181de68de3c447$export$44aa160b17c73194)($8a519bedd156dc2e$var$TextFieldPrimitive);
$8a519bedd156dc2e$export$2c73285ae9390cec.displayName = "TextField";



const $00563f3d43710c94$var$PasswordFieldPrimitive = ({ autoComplete: autoComplete = "current-password", label: label, className: className, hideShowPassword: hideShowPassword = false, passwordIsHiddenLabel: passwordIsHiddenLabel, passwordIsShownLabel: passwordIsShownLabel, showPasswordButtonLabel: showPasswordButtonLabel, showPasswordButtonRef: showPasswordButtonRef, size: size, hasError: hasError, ...rest }, ref)=>{
    const [type, setType] = $2hDQc.useState("password");
    const showPasswordOnClick = $2hDQc.useCallback(()=>{
        if (type === "password") setType("text");
        else setType("password");
    }, [
        setType,
        type
    ]);
    return $2hDQc.createElement((0, $8a519bedd156dc2e$export$2c73285ae9390cec), {
        autoComplete: autoComplete,
        outerEndComponent: hideShowPassword ? null : $2hDQc.createElement((0, $53546277b3698700$export$c42f83a0ca8c8188), {
            fieldType: type,
            onClick: showPasswordOnClick,
            passwordIsHiddenLabel: passwordIsHiddenLabel,
            passwordIsShownLabel: passwordIsShownLabel,
            ref: showPasswordButtonRef,
            size: size,
            showPasswordButtonLabel: showPasswordButtonLabel,
            hasError: hasError
        }),
        size: size,
        type: type,
        label: label,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).PasswordField, className),
        ref: ref,
        hasError: hasError,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/passwordfield)
 */ const $00563f3d43710c94$export$65ed9482db2257fa = (0, $62181de68de3c447$export$44aa160b17c73194)($00563f3d43710c94$var$PasswordFieldPrimitive);
$00563f3d43710c94$export$65ed9482db2257fa.displayName = "PasswordField";



var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");








var $2hDQc = parcelRequire("2hDQc");








var $2hDQc = parcelRequire("2hDQc");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $e3d5e82aac982dc3$export$e0c00b3c5102a294 = (props)=>{
    const { className: className, ...rest } = props;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
        fill: "currentColor"
    })));
};




const $1ada4f273683d513$var$SelectPrimitive = ({ autoComplete: autoComplete, className: className, size: size, variation: variation, value: value, defaultValue: defaultValue, hasError: hasError, icon: icon, iconColor: iconColor, children: children, placeholder: placeholder, isDisabled: isDisabled, isRequired: isRequired, isMultiple: isMultiple = false, selectSize: selectSize = 1, ...rest }, ref)=>{
    const DEFAULT_PLACEHOLDER_VALUE = "";
    // value === undefined is to make sure that component is used in uncontrolled way so that setting defaultValue is valid
    const shouldSetDefaultPlaceholderValue = value === undefined && defaultValue === undefined && placeholder;
    const isExpanded = isMultiple || selectSize > 1;
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Select, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Select, size), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Select, variation), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Select, "error", hasError), (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Select, "expanded", isExpanded), className);
    const icons = (0, $7b83175df15408b7$export$75b0b37acc90e887)("select");
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $7bec285a424993af$export$b140571ec72925dd)();
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).SelectWrapper
    }, $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "aria-invalid": hasError,
        as: "select",
        autoComplete: autoComplete,
        value: value,
        defaultValue: shouldSetDefaultPlaceholderValue ? DEFAULT_PLACEHOLDER_VALUE : defaultValue,
        isDisabled: isFieldsetDisabled ? isFieldsetDisabled : isDisabled,
        multiple: isMultiple,
        size: selectSize,
        required: isRequired,
        className: componentClasses,
        ref: ref,
        ...rest
    }, placeholder && $2hDQc.createElement("option", {
        value: ""
    }, placeholder), children), isExpanded ? null : $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).SelectIcon, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).SelectIcon, size)),
        color: iconColor
    }, icon ?? icons?.expand ?? $2hDQc.createElement((0, $e3d5e82aac982dc3$export$e0c00b3c5102a294), null)));
};
const $1ada4f273683d513$export$ef9b1a59e592288f = (0, $62181de68de3c447$export$44aa160b17c73194)($1ada4f273683d513$var$SelectPrimitive);
$1ada4f273683d513$export$ef9b1a59e592288f.displayName = "Select";





const $284b4f46dc64f7a3$var$selectFieldChildren = ({ children: children, options: options })=>{
    if (children) {
        if (options?.length) // eslint-disable-next-line no-console
        console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children.");
        return children;
    }
    return options?.map((option, index)=>$2hDQc.createElement("option", {
            label: option,
            value: option,
            key: `${option}-${index}`
        }, option));
};
const $284b4f46dc64f7a3$var$SelectFieldPrimitive = (props, ref)=>{
    const { children: children, className: className, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, label: label, labelHidden: labelHidden = false, options: options, size: size, testId: testId, inputStyles: inputStyles, ..._rest } = props;
    const fieldId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)(id);
    const descriptionId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = descriptiveText ? descriptionId : undefined;
    const { styleProps: styleProps, rest: rest } = (0, $adc705eec999410b$export$584a75f5facb0a5)(_rest);
    return $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Field, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Field, size), (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).SelectField, className),
        testId: testId,
        ...styleProps
    }, $2hDQc.createElement((0, $df3d0f3d4df7a922$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        visuallyHidden: labelHidden
    }, label), $2hDQc.createElement((0, $1b05dc3c654ece32$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: labelHidden,
        descriptiveText: descriptiveText
    }), $2hDQc.createElement((0, $1ada4f273683d513$export$ef9b1a59e592288f), {
        "aria-describedby": ariaDescribedBy,
        hasError: hasError,
        id: fieldId,
        ref: ref,
        size: size,
        ...rest,
        ...inputStyles
    }, $284b4f46dc64f7a3$var$selectFieldChildren({
        children: children,
        options: options
    })), $2hDQc.createElement((0, $daba90391b752297$export$1c081951d49ad6f6), {
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/selectfield)
 */ const $284b4f46dc64f7a3$export$d55b50a564d0b931 = (0, $62181de68de3c447$export$44aa160b17c73194)($284b4f46dc64f7a3$var$SelectFieldPrimitive);
$284b4f46dc64f7a3$export$d55b50a564d0b931.displayName = "SelectField";



const $da4f23d6273f4999$var$DialCodeSelectPrimitive = ({ className: className, dialCodeList: dialCodeList, isReadOnly: isReadOnly, ...props }, ref)=>{
    const dialList = dialCodeList ?? (0, $e69d66b471ba80af$export$a51e8cda1526c737);
    const dialCodeOptions = $2hDQc.useMemo(()=>dialList.map((dialCode)=>// Regarding the `disabled` attribute, see comment in SelectField below
            $2hDQc.createElement("option", {
                key: dialCode,
                value: dialCode,
                disabled: isReadOnly
            }, dialCode)), [
        dialList,
        isReadOnly
    ]);
    return $2hDQc.createElement((0, $284b4f46dc64f7a3$export$d55b50a564d0b931), {
        "aria-disabled": isReadOnly,
        autoComplete: "tel-country-code",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).CountryCodeSelect, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).DialCodeSelect, className),
        labelHidden: true,
        ref: ref,
        ...props
    }, dialCodeOptions);
};
const $da4f23d6273f4999$export$5dbfe48f3829fce4 = (0, $62181de68de3c447$export$44aa160b17c73194)($da4f23d6273f4999$var$DialCodeSelectPrimitive);
$da4f23d6273f4999$export$5dbfe48f3829fce4.displayName = "DialCodeSelect";





const $708ce27172be69e6$var$PhoneNumberFieldPrimitive = ({ autoComplete: autoComplete = "tel-national", className: className, defaultDialCode: defaultDialCode, dialCodeLabel: dialCodeLabel = (0, $dca455d5eea3302b$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, dialCodeList: dialCodeList, dialCodeName: dialCodeName, dialCodeRef: dialCodeRef, hasError: hasError, isDisabled: isDisabled, isReadOnly: isReadOnly, onDialCodeChange: onDialCodeChange, onInput: onInput, size: size, variation: variation, ...rest }, ref)=>{
    return $2hDQc.createElement((0, $8a519bedd156dc2e$export$2c73285ae9390cec), {
        outerStartComponent: $2hDQc.createElement((0, $da4f23d6273f4999$export$5dbfe48f3829fce4), {
            defaultValue: defaultDialCode,
            dialCodeList: dialCodeList,
            className: className,
            hasError: hasError,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            label: dialCodeLabel,
            name: dialCodeName,
            onChange: onDialCodeChange,
            ref: dialCodeRef,
            size: size,
            variation: variation
        }),
        autoComplete: autoComplete,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).PhoneNumberField, className),
        hasError: hasError,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        onInput: onInput,
        ref: ref,
        size: size,
        type: "tel",
        variation: variation,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/phonenumberfield)
 */ const $708ce27172be69e6$export$522a16be7a55e553 = (0, $62181de68de3c447$export$44aa160b17c73194)($708ce27172be69e6$var$PhoneNumberFieldPrimitive);
$708ce27172be69e6$export$522a16be7a55e553.displayName = "PhoneNumberField";






var $2hDQc = parcelRequire("2hDQc");



const $0dc507f2b167afad$export$db10347ccaf03b65 = ({ errors: errors, id: id, dataAttr: dataAttr })=>{
    if (!(errors?.length > 0)) return null;
    const dataAttrProp = dataAttr ? {
        [dataAttr]: true
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        ...dataAttrProp,
        id: id
    }, errors.map((error)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $387905725642d69a$export$5f1af8db9871e1d6), {
            key: error,
            role: "alert",
            variation: "error"
        }, (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(error));
    }));
};


function $e70985d3667f509e$export$56e87bf42978147a({ autocomplete: autoComplete, dialCode: dialCode, name: name, type: type, ...props }) {
    const { validationErrors: validationErrors } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ validationErrors: validationErrors })=>[
            validationErrors
        ]);
    const errors = $2hDQc.useMemo(()=>(0, $69e267558438992b$export$501239432719417d)(validationErrors[name]), [
        name,
        validationErrors
    ]);
    const hasError = errors?.length > 0;
    const errorId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = hasError ? errorId : undefined;
    if (type === "tel") return $2hDQc.createElement($2hDQc.Fragment, null, $2hDQc.createElement((0, $708ce27172be69e6$export$522a16be7a55e553), {
        ...props,
        name: name,
        defaultDialCode: dialCode,
        dialCodeName: "country_code",
        autoComplete: autoComplete,
        hasError: hasError,
        "aria-describedby": ariaDescribedBy
    }), $2hDQc.createElement((0, $0dc507f2b167afad$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
    else if (type === "password") return $2hDQc.createElement($2hDQc.Fragment, null, $2hDQc.createElement((0, $00563f3d43710c94$export$65ed9482db2257fa), {
        ...props,
        name: name,
        autoComplete: autoComplete,
        hasError: hasError,
        "aria-describedby": ariaDescribedBy
    }), $2hDQc.createElement((0, $0dc507f2b167afad$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
    else return $2hDQc.createElement($2hDQc.Fragment, null, $2hDQc.createElement((0, $8a519bedd156dc2e$export$2c73285ae9390cec), {
        ...props,
        name: name,
        autoComplete: autoComplete,
        hasError: hasError,
        type: type,
        "aria-describedby": ariaDescribedBy
    }), $2hDQc.createElement((0, $0dc507f2b167afad$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
}



function $b31a891f80c4c8e2$export$125d0b248abd3e88() {
    const { fields: fields } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const formFields = $2hDQc.useRef(fields.map((field, index)=>$2hDQc.createElement((0, $e70985d3667f509e$export$56e87bf42978147a), {
            // use index for key, field order is static
            key: index,
            ...field
        }))).current;
    return $2hDQc.createElement($2hDQc.Fragment, null, formFields);
}



var $2hDQc = parcelRequire("2hDQc");



// TODO replace usage of this util with the `isSignInOrSignUpRoute` util in v3.
// Currently `hasTabs` always returns `undefined` as the right condition always
// resolves to truthy. This prevents the "data-amplify-router-content" attribute
// from being applied below. Fixing it will cause consumer snapshot tests to break,
// so wait to update.
const $836f3d1750024f12$var$hasTabs = (route)=>{
    return route === "signIn" || "signUp";
};
function $836f3d1750024f12$export$253df7dc30f737bc({ children: children, className: className, variation: variation = "default" }) {
    const { route: route } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const { // @ts-ignore
    components: { Header: Header, Footer: Footer } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        className: className,
        "data-amplify-authenticator": "",
        "data-variation": variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "data-amplify-container": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "data-amplify-router": "",
        "data-amplify-router-content": $836f3d1750024f12$var$hasTabs(route) ? undefined : ""
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null)));
}


const { getDeliveryMessageText: $bae7bca463c3990b$var$getDeliveryMessageText, getDeliveryMethodText: $bae7bca463c3990b$var$getDeliveryMethodText, getConfirmingText: $bae7bca463c3990b$var$getConfirmingText, getConfirmText: $bae7bca463c3990b$var$getConfirmText, getResendCodeText: $bae7bca463c3990b$var$getResendCodeText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
function $bae7bca463c3990b$export$649c708157e61c64({ className: className, variation: variation }) {
    const { isPending: isPending, resendCode: resendCode, codeDeliveryDetails: codeDeliveryDetails } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.resendCode,
            context.codeDeliveryDetails
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmSignUp: { Header: Header = $bae7bca463c3990b$export$649c708157e61c64.Header, Footer: Footer = $bae7bca463c3990b$export$649c708157e61c64.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return(// TODO Automatically add these namespaces again from `useAmplify`
    (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignup": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $387905725642d69a$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__subtitle"
    }, $bae7bca463c3990b$var$getDeliveryMessageText(codeDeliveryDetails)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        variation: "primary",
        isDisabled: isPending,
        type: "submit",
        loadingText: $bae7bca463c3990b$var$getConfirmingText(),
        isLoading: isPending,
        fontWeight: "normal"
    }, $bae7bca463c3990b$var$getConfirmText()), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        onClick: resendCode,
        type: "button",
        fontWeight: "normal"
    }, $bae7bca463c3990b$var$getResendCodeText())), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null)))));
}
const $bae7bca463c3990b$var$DefaultHeader = ()=>{
    const { codeDeliveryDetails: codeDeliveryDetails } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.codeDeliveryDetails
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 4
    }, $bae7bca463c3990b$var$getDeliveryMethodText(codeDeliveryDetails));
};
$bae7bca463c3990b$export$649c708157e61c64.Header = $bae7bca463c3990b$var$DefaultHeader;
$bae7bca463c3990b$export$649c708157e61c64.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $2hDQc = parcelRequire("2hDQc");










const { getChangePasswordText: $cfad12c60a932151$var$getChangePasswordText, getChangingText: $cfad12c60a932151$var$getChangingText, getBackToSignInText: $cfad12c60a932151$var$getBackToSignInText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $cfad12c60a932151$export$b3aae0a112274a60 = ({ className: className, variation: variation })=>{
    const { isPending: isPending, toSignIn: toSignIn } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.toSignIn
        ]);
    const { handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ForceNewPassword: { FormFields: FormFields = $cfad12c60a932151$export$b3aae0a112274a60.FormFields, Header: Header = $cfad12c60a932151$export$b3aae0a112274a60.Header, Footer: Footer = $cfad12c60a932151$export$b3aae0a112274a60.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forcenewpassword": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(FormFields, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $cfad12c60a932151$var$getChangingText(),
        fontWeight: "normal"
    }, $cfad12c60a932151$var$getChangePasswordText()), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        type: "button",
        fontWeight: "normal",
        variation: "link",
        size: "small"
    }, $cfad12c60a932151$var$getBackToSignInText()), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null))));
};
$cfad12c60a932151$export$b3aae0a112274a60.FormFields = function FormFields$1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null);
};
$cfad12c60a932151$export$b3aae0a112274a60.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 4
    }, $cfad12c60a932151$var$getChangePasswordText());
};
$cfad12c60a932151$export$b3aae0a112274a60.Footer = function Footer() {
    return null;
};


var $43ff60d898f96de5$exports = {};

$parcel$export($43ff60d898f96de5$exports, "create", function () { return $43ff60d898f96de5$export$185802fd694ee1f5; }, function (v) { return $43ff60d898f96de5$export$185802fd694ee1f5 = v; });
$parcel$export($43ff60d898f96de5$exports, "toCanvas", function () { return $43ff60d898f96de5$export$f87f6982d1fd4f81; }, function (v) { return $43ff60d898f96de5$export$f87f6982d1fd4f81 = v; });
$parcel$export($43ff60d898f96de5$exports, "toDataURL", function () { return $43ff60d898f96de5$export$723e4939e5a27c8; }, function (v) { return $43ff60d898f96de5$export$723e4939e5a27c8 = v; });
$parcel$export($43ff60d898f96de5$exports, "toString", function () { return $43ff60d898f96de5$export$f84e8e69fd4488a5; }, function (v) { return $43ff60d898f96de5$export$f84e8e69fd4488a5 = v; });
var $43ff60d898f96de5$export$185802fd694ee1f5;
var $43ff60d898f96de5$export$f87f6982d1fd4f81;
var $43ff60d898f96de5$export$723e4939e5a27c8;
// only svg for now.
var $43ff60d898f96de5$export$f84e8e69fd4488a5;
var $b264a02c26d7862d$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$b264a02c26d7862d$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $f1ed51f28018a735$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $d573d5453f022646$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $d573d5453f022646$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $d573d5453f022646$export$ed1d66da50968976;
var $d573d5453f022646$export$6733b14783f975c2;
var $d573d5453f022646$export$ce5b1274f8597fa0;
var $d573d5453f022646$export$43dd553ecded716d;
let $d573d5453f022646$var$toSJISFunction;
const $d573d5453f022646$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$d573d5453f022646$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$d573d5453f022646$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $d573d5453f022646$var$CODEWORDS_COUNT[version];
};
$d573d5453f022646$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$d573d5453f022646$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $d573d5453f022646$var$toSJISFunction = f;
};
$d573d5453f022646$export$ce5b1274f8597fa0 = function() {
    return typeof $d573d5453f022646$var$toSJISFunction !== "undefined";
};
$d573d5453f022646$export$43dd553ecded716d = function toSJIS(kanji) {
    return $d573d5453f022646$var$toSJISFunction(kanji);
};


var $748775d86fb90ca6$export$61196ced6d74a310;
var $748775d86fb90ca6$export$3a1a48c8f6ef640e;
var $748775d86fb90ca6$export$3722cfe417b6ed86;
var $748775d86fb90ca6$export$7f8ddf7c7c20b3cd;
var $748775d86fb90ca6$export$1ea939691cdc45b8;
var $748775d86fb90ca6$export$6788812c4e6611e6;
$748775d86fb90ca6$export$61196ced6d74a310 = {
    bit: 1
};
$748775d86fb90ca6$export$3a1a48c8f6ef640e = {
    bit: 0
};
$748775d86fb90ca6$export$3722cfe417b6ed86 = {
    bit: 3
};
$748775d86fb90ca6$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $748775d86fb90ca6$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $748775d86fb90ca6$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $748775d86fb90ca6$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $748775d86fb90ca6$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $748775d86fb90ca6$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$748775d86fb90ca6$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$748775d86fb90ca6$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($748775d86fb90ca6$export$1ea939691cdc45b8(value)) return value;
    try {
        return $748775d86fb90ca6$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $8338601214b5c471$exports = {};
function $8338601214b5c471$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$8338601214b5c471$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$8338601214b5c471$exports = $8338601214b5c471$var$BitBuffer;


var $076b4b6cc83b1421$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $076b4b6cc83b1421$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $076b4b6cc83b1421$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $076b4b6cc83b1421$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $076b4b6cc83b1421$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $076b4b6cc83b1421$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$076b4b6cc83b1421$exports = $076b4b6cc83b1421$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $4493965323a3ffe8$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $4493965323a3ffe8$export$c39457c570f2b189;

var $4493965323a3ffe8$require$getSymbolSize = $d573d5453f022646$export$8d4a06d3facd414b;
$4493965323a3ffe8$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $4493965323a3ffe8$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$4493965323a3ffe8$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $4493965323a3ffe8$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $dc5e85d10fd651cc$export$c39457c570f2b189;

var $dc5e85d10fd651cc$require$getSymbolSize = $d573d5453f022646$export$8d4a06d3facd414b;
const $dc5e85d10fd651cc$var$FINDER_PATTERN_SIZE = 7;
$dc5e85d10fd651cc$export$c39457c570f2b189 = function getPositions(version) {
    const size = $dc5e85d10fd651cc$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $dc5e85d10fd651cc$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $dc5e85d10fd651cc$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $a3f1d94ed5177c8c$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $a3f1d94ed5177c8c$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $a3f1d94ed5177c8c$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $a3f1d94ed5177c8c$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $a3f1d94ed5177c8c$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $a3f1d94ed5177c8c$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $a3f1d94ed5177c8c$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $a3f1d94ed5177c8c$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $a3f1d94ed5177c8c$export$fe9625aaceb0e563;
$a3f1d94ed5177c8c$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $a3f1d94ed5177c8c$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$a3f1d94ed5177c8c$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$a3f1d94ed5177c8c$export$6788812c4e6611e6 = function from(value) {
    return $a3f1d94ed5177c8c$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$a3f1d94ed5177c8c$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $a3f1d94ed5177c8c$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $a3f1d94ed5177c8c$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $a3f1d94ed5177c8c$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $a3f1d94ed5177c8c$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$a3f1d94ed5177c8c$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $a3f1d94ed5177c8c$var$PenaltyScores.N2;
};
$a3f1d94ed5177c8c$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $a3f1d94ed5177c8c$var$PenaltyScores.N3;
};
$a3f1d94ed5177c8c$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $a3f1d94ed5177c8c$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $a3f1d94ed5177c8c$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $a3f1d94ed5177c8c$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$a3f1d94ed5177c8c$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $a3f1d94ed5177c8c$var$getMaskAt(pattern, row, col));
    }
};
$a3f1d94ed5177c8c$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($a3f1d94ed5177c8c$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $a3f1d94ed5177c8c$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $a3f1d94ed5177c8c$export$a5fd3a02c14d0b3e(data) + $a3f1d94ed5177c8c$export$9a9385107a518e46(data) + $a3f1d94ed5177c8c$export$ade754353f0dc75e(data) + $a3f1d94ed5177c8c$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $a3f1d94ed5177c8c$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $5ae8a971418e2d2a$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $5ae8a971418e2d2a$export$683d1b3e8a1a8438;

const $5ae8a971418e2d2a$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $5ae8a971418e2d2a$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$5ae8a971418e2d2a$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $748775d86fb90ca6$export$61196ced6d74a310:
            return $5ae8a971418e2d2a$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $748775d86fb90ca6$export$3a1a48c8f6ef640e:
            return $5ae8a971418e2d2a$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $748775d86fb90ca6$export$3722cfe417b6ed86:
            return $5ae8a971418e2d2a$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $748775d86fb90ca6$export$7f8ddf7c7c20b3cd:
            return $5ae8a971418e2d2a$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$5ae8a971418e2d2a$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $748775d86fb90ca6$export$61196ced6d74a310:
            return $5ae8a971418e2d2a$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $748775d86fb90ca6$export$3a1a48c8f6ef640e:
            return $5ae8a971418e2d2a$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $748775d86fb90ca6$export$3722cfe417b6ed86:
            return $5ae8a971418e2d2a$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $748775d86fb90ca6$export$7f8ddf7c7c20b3cd:
            return $5ae8a971418e2d2a$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $1644c83876e6b22f$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $0c2196aaf361a7e2$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $0c2196aaf361a7e2$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $0c2196aaf361a7e2$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $4f704f184c7898dd$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $4f704f184c7898dd$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $4f704f184c7898dd$export$6e3a27864ab166fe;
const $4f704f184c7898dd$var$EXP_TABLE = new Uint8Array(512);
const $4f704f184c7898dd$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $4f704f184c7898dd$var$EXP_TABLE[i] = x;
        $4f704f184c7898dd$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$4f704f184c7898dd$var$EXP_TABLE[i] = $4f704f184c7898dd$var$EXP_TABLE[i - 255];
})();
$4f704f184c7898dd$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $4f704f184c7898dd$var$LOG_TABLE[n];
};
$4f704f184c7898dd$export$b310ec824aaee37f = function exp(n) {
    return $4f704f184c7898dd$var$EXP_TABLE[n];
};
$4f704f184c7898dd$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $4f704f184c7898dd$var$EXP_TABLE[$4f704f184c7898dd$var$LOG_TABLE[x] + $4f704f184c7898dd$var$LOG_TABLE[y]];
};


$0c2196aaf361a7e2$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $4f704f184c7898dd$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$0c2196aaf361a7e2$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $4f704f184c7898dd$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$0c2196aaf361a7e2$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $0c2196aaf361a7e2$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $4f704f184c7898dd$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $1644c83876e6b22f$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $1644c83876e6b22f$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $0c2196aaf361a7e2$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $1644c83876e6b22f$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $0c2196aaf361a7e2$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$1644c83876e6b22f$exports = $1644c83876e6b22f$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $c960756ae156c048$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $c960756ae156c048$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $c960756ae156c048$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $c960756ae156c048$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $0681db43113a1285$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $0681db43113a1285$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $0681db43113a1285$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $0681db43113a1285$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $0681db43113a1285$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $0681db43113a1285$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $0681db43113a1285$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $0681db43113a1285$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $0681db43113a1285$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $0681db43113a1285$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $1a2f6dc3e705f14c$export$1ea939691cdc45b8;
$1a2f6dc3e705f14c$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $263423e14dcc1f56$export$a4d452c2363c8e12;
var $263423e14dcc1f56$export$9df7c29d562bab83;
var $263423e14dcc1f56$export$8f4bf8f7eb581284;
var $263423e14dcc1f56$export$4d318981b5a83836;
var $263423e14dcc1f56$export$376a9ed239d6c1c8;
var $263423e14dcc1f56$export$175f16aef75a4569;
var $263423e14dcc1f56$export$50b7f9bf92c74274;
var $263423e14dcc1f56$export$4ba5f52893b4ac97;
const $263423e14dcc1f56$var$numeric = "[0-9]+";
const $263423e14dcc1f56$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $263423e14dcc1f56$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$263423e14dcc1f56$var$kanji = $263423e14dcc1f56$var$kanji.replace(/u/g, "\\u");
const $263423e14dcc1f56$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $263423e14dcc1f56$var$kanji + ")(?:.|[\r\n]))+";
$263423e14dcc1f56$export$a4d452c2363c8e12 = new RegExp($263423e14dcc1f56$var$kanji, "g");
$263423e14dcc1f56$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$263423e14dcc1f56$export$8f4bf8f7eb581284 = new RegExp($263423e14dcc1f56$var$byte, "g");
$263423e14dcc1f56$export$4d318981b5a83836 = new RegExp($263423e14dcc1f56$var$numeric, "g");
$263423e14dcc1f56$export$376a9ed239d6c1c8 = new RegExp($263423e14dcc1f56$var$alphanumeric, "g");
const $263423e14dcc1f56$var$TEST_KANJI = new RegExp("^" + $263423e14dcc1f56$var$kanji + "$");
const $263423e14dcc1f56$var$TEST_NUMERIC = new RegExp("^" + $263423e14dcc1f56$var$numeric + "$");
const $263423e14dcc1f56$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$263423e14dcc1f56$export$175f16aef75a4569 = function testKanji(str) {
    return $263423e14dcc1f56$var$TEST_KANJI.test(str);
};
$263423e14dcc1f56$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $263423e14dcc1f56$var$TEST_NUMERIC.test(str);
};
$263423e14dcc1f56$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $263423e14dcc1f56$var$TEST_ALPHANUMERIC.test(str);
};


$0681db43113a1285$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$0681db43113a1285$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$0681db43113a1285$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$0681db43113a1285$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$0681db43113a1285$export$bb410559a65d3418 = {
    bit: -1
};
$0681db43113a1285$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$1a2f6dc3e705f14c$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$0681db43113a1285$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($263423e14dcc1f56$export$50b7f9bf92c74274(dataStr)) return $0681db43113a1285$export$4d318981b5a83836;
    else if ($263423e14dcc1f56$export$4ba5f52893b4ac97(dataStr)) return $0681db43113a1285$export$376a9ed239d6c1c8;
    else if ($263423e14dcc1f56$export$175f16aef75a4569(dataStr)) return $0681db43113a1285$export$a4d452c2363c8e12;
    else return $0681db43113a1285$export$8f4bf8f7eb581284;
};
$0681db43113a1285$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$0681db43113a1285$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $0681db43113a1285$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $0681db43113a1285$export$4d318981b5a83836;
        case "alphanumeric":
            return $0681db43113a1285$export$376a9ed239d6c1c8;
        case "kanji":
            return $0681db43113a1285$export$a4d452c2363c8e12;
        case "byte":
            return $0681db43113a1285$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$0681db43113a1285$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0681db43113a1285$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0681db43113a1285$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $c960756ae156c048$var$G18 = 7973;
const $c960756ae156c048$var$G18_BCH = $d573d5453f022646$export$ed1d66da50968976($c960756ae156c048$var$G18);
function $c960756ae156c048$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $c960756ae156c048$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $c960756ae156c048$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $0681db43113a1285$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $c960756ae156c048$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $c960756ae156c048$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $c960756ae156c048$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $c960756ae156c048$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $c960756ae156c048$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $0681db43113a1285$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$c960756ae156c048$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($1a2f6dc3e705f14c$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$c960756ae156c048$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$1a2f6dc3e705f14c$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $0681db43113a1285$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $d573d5453f022646$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $5ae8a971418e2d2a$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $0681db43113a1285$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $c960756ae156c048$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $0681db43113a1285$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $0681db43113a1285$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $0681db43113a1285$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $0681db43113a1285$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$c960756ae156c048$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $748775d86fb90ca6$export$6788812c4e6611e6(errorCorrectionLevel, $748775d86fb90ca6$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $c960756ae156c048$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $c960756ae156c048$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$c960756ae156c048$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$1a2f6dc3e705f14c$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($d573d5453f022646$export$ed1d66da50968976(d) - $c960756ae156c048$var$G18_BCH >= 0)d ^= $c960756ae156c048$var$G18 << $d573d5453f022646$export$ed1d66da50968976(d) - $c960756ae156c048$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $a4f523f57ecebd8c$export$eee5438974ef6f0e;

const $a4f523f57ecebd8c$var$G15 = 1335;
const $a4f523f57ecebd8c$var$G15_MASK = 21522;
const $a4f523f57ecebd8c$var$G15_BCH = $d573d5453f022646$export$ed1d66da50968976($a4f523f57ecebd8c$var$G15);
$a4f523f57ecebd8c$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($d573d5453f022646$export$ed1d66da50968976(d) - $a4f523f57ecebd8c$var$G15_BCH >= 0)d ^= $a4f523f57ecebd8c$var$G15 << $d573d5453f022646$export$ed1d66da50968976(d) - $a4f523f57ecebd8c$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $a4f523f57ecebd8c$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $6f0bd26962828ab8$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $6f0bd26962828ab8$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $6f0bd26962828ab8$export$89ab1afb9839589b;

var $54efb9aae25ca15c$exports = {};

function $54efb9aae25ca15c$var$NumericData(data) {
    this.mode = $0681db43113a1285$export$4d318981b5a83836;
    this.data = data.toString();
}
$54efb9aae25ca15c$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$54efb9aae25ca15c$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$54efb9aae25ca15c$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $54efb9aae25ca15c$var$NumericData.getBitsLength(this.data.length);
};
$54efb9aae25ca15c$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$54efb9aae25ca15c$exports = $54efb9aae25ca15c$var$NumericData;


var $1ba8e1fb39b631ef$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $1ba8e1fb39b631ef$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $1ba8e1fb39b631ef$var$AlphanumericData(data) {
    this.mode = $0681db43113a1285$export$376a9ed239d6c1c8;
    this.data = data;
}
$1ba8e1fb39b631ef$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$1ba8e1fb39b631ef$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$1ba8e1fb39b631ef$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $1ba8e1fb39b631ef$var$AlphanumericData.getBitsLength(this.data.length);
};
$1ba8e1fb39b631ef$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $1ba8e1fb39b631ef$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $1ba8e1fb39b631ef$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($1ba8e1fb39b631ef$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$1ba8e1fb39b631ef$exports = $1ba8e1fb39b631ef$var$AlphanumericData;


var $b1ce0de803e9727d$exports = {};
var $25518e703867b86f$exports = {};
"use strict";
$25518e703867b86f$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $b1ce0de803e9727d$var$ByteData(data) {
    this.mode = $0681db43113a1285$export$8f4bf8f7eb581284;
    this.data = new Uint8Array($25518e703867b86f$exports(data));
}
$b1ce0de803e9727d$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$b1ce0de803e9727d$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b1ce0de803e9727d$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $b1ce0de803e9727d$var$ByteData.getBitsLength(this.data.length);
};
$b1ce0de803e9727d$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$b1ce0de803e9727d$exports = $b1ce0de803e9727d$var$ByteData;


var $4aea5676093e7759$exports = {};


function $4aea5676093e7759$var$KanjiData(data) {
    this.mode = $0681db43113a1285$export$a4d452c2363c8e12;
    this.data = data;
}
$4aea5676093e7759$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$4aea5676093e7759$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4aea5676093e7759$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $4aea5676093e7759$var$KanjiData.getBitsLength(this.data.length);
};
$4aea5676093e7759$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $d573d5453f022646$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$4aea5676093e7759$exports = $4aea5676093e7759$var$KanjiData;




var $41fc5594a4f2531d$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $41fc5594a4f2531d$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $41fc5594a4f2531d$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $41fc5594a4f2531d$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $41fc5594a4f2531d$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $41fc5594a4f2531d$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$41fc5594a4f2531d$exports = $41fc5594a4f2531d$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $6f0bd26962828ab8$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $6f0bd26962828ab8$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $6f0bd26962828ab8$var$getSegmentsFromString(dataStr) {
    const numSegs = $6f0bd26962828ab8$var$getSegments($263423e14dcc1f56$export$4d318981b5a83836, $0681db43113a1285$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $6f0bd26962828ab8$var$getSegments($263423e14dcc1f56$export$376a9ed239d6c1c8, $0681db43113a1285$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($d573d5453f022646$export$ce5b1274f8597fa0()) {
        byteSegs = $6f0bd26962828ab8$var$getSegments($263423e14dcc1f56$export$8f4bf8f7eb581284, $0681db43113a1285$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $6f0bd26962828ab8$var$getSegments($263423e14dcc1f56$export$a4d452c2363c8e12, $0681db43113a1285$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $6f0bd26962828ab8$var$getSegments($263423e14dcc1f56$export$9df7c29d562bab83, $0681db43113a1285$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $6f0bd26962828ab8$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $0681db43113a1285$export$4d318981b5a83836:
            return $54efb9aae25ca15c$exports.getBitsLength(length);
        case $0681db43113a1285$export$376a9ed239d6c1c8:
            return $1ba8e1fb39b631ef$exports.getBitsLength(length);
        case $0681db43113a1285$export$a4d452c2363c8e12:
            return $4aea5676093e7759$exports.getBitsLength(length);
        case $0681db43113a1285$export$8f4bf8f7eb581284:
            return $b1ce0de803e9727d$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $6f0bd26962828ab8$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $6f0bd26962828ab8$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $0681db43113a1285$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $0681db43113a1285$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $0681db43113a1285$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $0681db43113a1285$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $0681db43113a1285$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $0681db43113a1285$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $0681db43113a1285$export$8f4bf8f7eb581284,
                        length: $6f0bd26962828ab8$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $0681db43113a1285$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $0681db43113a1285$export$8f4bf8f7eb581284,
                        length: $6f0bd26962828ab8$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $6f0bd26962828ab8$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $6f0bd26962828ab8$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $6f0bd26962828ab8$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $6f0bd26962828ab8$var$getSegmentBitsLength(node.length, node.mode) + 4 + $0681db43113a1285$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $6f0bd26962828ab8$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $0681db43113a1285$export$1bd4c93ffb42e55e(data);
    mode = $0681db43113a1285$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $0681db43113a1285$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $0681db43113a1285$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $0681db43113a1285$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $0681db43113a1285$export$a4d452c2363c8e12 && !$d573d5453f022646$export$ce5b1274f8597fa0()) mode = $0681db43113a1285$export$8f4bf8f7eb581284;
    switch(mode){
        case $0681db43113a1285$export$4d318981b5a83836:
            return new $54efb9aae25ca15c$exports(data);
        case $0681db43113a1285$export$376a9ed239d6c1c8:
            return new $1ba8e1fb39b631ef$exports(data);
        case $0681db43113a1285$export$a4d452c2363c8e12:
            return new $4aea5676093e7759$exports(data);
        case $0681db43113a1285$export$8f4bf8f7eb581284:
            return new $b1ce0de803e9727d$exports(data);
    }
}
$6f0bd26962828ab8$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($6f0bd26962828ab8$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($6f0bd26962828ab8$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$6f0bd26962828ab8$export$3004f64547af360e = function fromString(data, version) {
    const segs = $6f0bd26962828ab8$var$getSegmentsFromString(data, $d573d5453f022646$export$ce5b1274f8597fa0());
    const nodes = $6f0bd26962828ab8$var$buildNodes(segs);
    const graph = $6f0bd26962828ab8$var$buildGraph(nodes, version);
    const path = $41fc5594a4f2531d$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $6f0bd26962828ab8$export$571d59b505e6bb4e($6f0bd26962828ab8$var$mergeSegments(optimizedSegs));
};
$6f0bd26962828ab8$export$89ab1afb9839589b = function rawSplit(data) {
    return $6f0bd26962828ab8$export$571d59b505e6bb4e($6f0bd26962828ab8$var$getSegmentsFromString(data, $d573d5453f022646$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $f1ed51f28018a735$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $dc5e85d10fd651cc$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $f1ed51f28018a735$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $f1ed51f28018a735$var$setupAlignmentPattern(matrix, version) {
    const pos = $4493965323a3ffe8$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $f1ed51f28018a735$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $c960756ae156c048$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $f1ed51f28018a735$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $a4f523f57ecebd8c$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $f1ed51f28018a735$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $f1ed51f28018a735$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $8338601214b5c471$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $0681db43113a1285$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $d573d5453f022646$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $5ae8a971418e2d2a$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $f1ed51f28018a735$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $f1ed51f28018a735$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $d573d5453f022646$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $5ae8a971418e2d2a$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $5ae8a971418e2d2a$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $1644c83876e6b22f$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $f1ed51f28018a735$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $6f0bd26962828ab8$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $6f0bd26962828ab8$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $c960756ae156c048$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $6f0bd26962828ab8$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $c960756ae156c048$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $f1ed51f28018a735$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $d573d5453f022646$export$8d4a06d3facd414b(version);
    const modules = new $076b4b6cc83b1421$exports(moduleCount);
    // Add function modules
    $f1ed51f28018a735$var$setupFinderPattern(modules, version);
    $f1ed51f28018a735$var$setupTimingPattern(modules);
    $f1ed51f28018a735$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $f1ed51f28018a735$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $f1ed51f28018a735$var$setupVersionInfo(modules, version);
    // Add data codewords
    $f1ed51f28018a735$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $a3f1d94ed5177c8c$export$fe9625aaceb0e563(modules, $f1ed51f28018a735$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $a3f1d94ed5177c8c$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $f1ed51f28018a735$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$f1ed51f28018a735$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $748775d86fb90ca6$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $748775d86fb90ca6$export$6788812c4e6611e6(options.errorCorrectionLevel, $748775d86fb90ca6$export$3a1a48c8f6ef640e);
        version = $c960756ae156c048$export$6788812c4e6611e6(options.version);
        mask = $a3f1d94ed5177c8c$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $d573d5453f022646$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $f1ed51f28018a735$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $70b3de1fed4f0648$export$b3890eb0ae9dca99;
var $70b3de1fed4f0648$export$c3e5526bbaf70a25;
var $393cea4403b9cfce$export$d2312e68e1f5ad00;
var $393cea4403b9cfce$export$5cdac61cf538712e;
var $393cea4403b9cfce$export$c3a1a1f268a8142b;
var $393cea4403b9cfce$export$83136f57c739c5f3;
function $393cea4403b9cfce$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$393cea4403b9cfce$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $393cea4403b9cfce$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $393cea4403b9cfce$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$393cea4403b9cfce$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$393cea4403b9cfce$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $393cea4403b9cfce$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$393cea4403b9cfce$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $393cea4403b9cfce$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $70b3de1fed4f0648$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $70b3de1fed4f0648$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$70b3de1fed4f0648$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $70b3de1fed4f0648$var$getCanvasElement();
    opts = $393cea4403b9cfce$export$d2312e68e1f5ad00(opts);
    const size = $393cea4403b9cfce$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $393cea4403b9cfce$export$83136f57c739c5f3(image.data, qrData, opts);
    $70b3de1fed4f0648$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$70b3de1fed4f0648$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $70b3de1fed4f0648$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $be9a84baa9fce0d6$export$b3890eb0ae9dca99;

function $be9a84baa9fce0d6$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $be9a84baa9fce0d6$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $be9a84baa9fce0d6$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $be9a84baa9fce0d6$var$svgCmd("M", col + margin, 0.5 + row + margin) : $be9a84baa9fce0d6$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $be9a84baa9fce0d6$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$be9a84baa9fce0d6$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $393cea4403b9cfce$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $be9a84baa9fce0d6$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $be9a84baa9fce0d6$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $be9a84baa9fce0d6$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $43ff60d898f96de5$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$b264a02c26d7862d$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $f1ed51f28018a735$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $f1ed51f28018a735$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$43ff60d898f96de5$export$185802fd694ee1f5 = $f1ed51f28018a735$export$185802fd694ee1f5;
$43ff60d898f96de5$export$f87f6982d1fd4f81 = $43ff60d898f96de5$var$renderCanvas.bind(null, $70b3de1fed4f0648$export$b3890eb0ae9dca99);
$43ff60d898f96de5$export$723e4939e5a27c8 = $43ff60d898f96de5$var$renderCanvas.bind(null, $70b3de1fed4f0648$export$c3e5526bbaf70a25);
$43ff60d898f96de5$export$f84e8e69fd4488a5 = $43ff60d898f96de5$var$renderCanvas.bind(null, function(data, _, opts) {
    return $be9a84baa9fce0d6$export$b3890eb0ae9dca99(data, opts);
});



var $2hDQc = parcelRequire("2hDQc");








var $2hDQc = parcelRequire("2hDQc");




const { getConfirmText: $e99991201ce018ab$var$getConfirmText, getConfirmingText: $e99991201ce018ab$var$getConfirmingText, getBackToSignInText: $e99991201ce018ab$var$getBackToSignInText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $e99991201ce018ab$export$76e9c0cec6811ff4 = ()=>{
    const { isPending: isPending, toSignIn: toSignIn } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.toSignIn
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        fontWeight: "normal",
        isLoading: isPending,
        loadingText: $e99991201ce018ab$var$getConfirmingText()
    }, $e99991201ce018ab$var$getConfirmText()), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, $e99991201ce018ab$var$getBackToSignInText()));
};





const $6bff16d8c619ec2e$var$logger = new (0, $5a5ccf3b282369bb$export$ba6a9c7ac8291f7f)("SetupTotp-logger");
const { getSetupTotpText: $6bff16d8c619ec2e$var$getSetupTotpText, getCopiedText: $6bff16d8c619ec2e$var$getCopiedText, getLoadingText: $6bff16d8c619ec2e$var$getLoadingText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $6bff16d8c619ec2e$export$1f819652bce2948d = ({ className: className, variation: variation })=>{
    const { totpSecretCode: totpSecretCode, isPending: isPending, username: username, QRFields: QRFields } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.totpSecretCode,
            context.username
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SetupTotp: { Header: Header = $6bff16d8c619ec2e$export$1f819652bce2948d.Header, Footer: Footer = $6bff16d8c619ec2e$export$1f819652bce2948d.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    const [isLoading, setIsLoading] = $2hDQc.useState(true);
    const [qrCode, setQrCode] = $2hDQc.useState();
    const [copyTextLabel, setCopyTextLabel] = $2hDQc.useState("COPY");
    const { totpIssuer: totpIssuer = "AWSCognito", totpUsername: totpUsername = username } = QRFields ?? {};
    const generateQRCode = $2hDQc.useCallback(async ()=>{
        try {
            const totpCode = (0, $508296b373a163a4$export$f1f323074be5cac0)(totpIssuer, totpUsername, totpSecretCode);
            const qrCodeImageSource = await (0, (/*@__PURE__*/$parcel$interopDefault($43ff60d898f96de5$exports))).toDataURL(totpCode);
            setQrCode(qrCodeImageSource);
        } catch (error) {
            $6bff16d8c619ec2e$var$logger.error(error);
        } finally{
            setIsLoading(false);
        }
    }, [
        totpIssuer,
        totpUsername,
        totpSecretCode
    ]);
    $2hDQc.useEffect(()=>{
        if (!qrCode) generateQRCode();
    }, [
        generateQRCode,
        qrCode
    ]);
    const copyText = ()=>{
        navigator.clipboard.writeText(totpSecretCode);
        setCopyTextLabel($6bff16d8c619ec2e$var$getCopiedText());
    };
    return $2hDQc.createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, $2hDQc.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-totp": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, $2hDQc.createElement(Header, null), $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, isLoading ? $2hDQc.createElement("p", null, $6bff16d8c619ec2e$var$getLoadingText(), "\u2026") : $2hDQc.createElement("img", {
        "data-amplify-qrcode": true,
        src: qrCode,
        alt: "qr code",
        width: "228",
        height: "228"
    }), $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        "data-amplify-copy": true
    }, $2hDQc.createElement("div", null, totpSecretCode), $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        "data-amplify-copy-svg": true,
        onClick: copyText
    }, $2hDQc.createElement("div", {
        "data-amplify-copy-tooltip": true
    }, copyTextLabel), $2hDQc.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2hDQc.createElement("path", {
        d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), $2hDQc.createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null), $2hDQc.createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null)), $2hDQc.createElement((0, $e99991201ce018ab$export$76e9c0cec6811ff4), null), $2hDQc.createElement(Footer, null))));
};
$6bff16d8c619ec2e$export$1f819652bce2948d.Header = function Header() {
    return $2hDQc.createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 3
    }, $6bff16d8c619ec2e$var$getSetupTotpText());
};
$6bff16d8c619ec2e$export$1f819652bce2948d.Footer = function Footer() {
    // @ts-ignore
    return null;
};








var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");




var $2hDQc = parcelRequire("2hDQc");
const $8d7ff0d585efe4c2$export$cfa7aa87c26e7d1f = $2hDQc.createContext({
    activeTab: "",
    setActiveTab: ()=>{}
});


const $dd46ce452f29b2c7$var$TabsItemPrimitive = ({ className: className, value: value, children: children, onClick: onClick, as: as = "button", role: role = "tab", ...rest }, ref)=>{
    const { activeTab: activeTab, setActiveTab: setActiveTab } = $2hDQc.useContext((0, $8d7ff0d585efe4c2$export$cfa7aa87c26e7d1f));
    const isActive = activeTab === value;
    const handleOnClick = (e)=>{
        if ((0, $85b840b81f21bd6d$export$669248cdfeac1c30)(onClick)) onClick?.(e);
        setActiveTab(value);
    };
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        as: as,
        id: `${value}-tab`,
        "aria-selected": isActive,
        "aria-controls": `${value}-panel`,
        tabIndex: !isActive ? -1 : undefined,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsItem, (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsItem, "active", activeTab === value), className),
        ref: ref,
        onClick: handleOnClick
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $dd46ce452f29b2c7$export$6d702cd3660ac20b = (0, $62181de68de3c447$export$44aa160b17c73194)($dd46ce452f29b2c7$var$TabsItemPrimitive);
$dd46ce452f29b2c7$export$6d702cd3660ac20b.displayName = "Tabs.Item";



var $2hDQc = parcelRequire("2hDQc");




const $cacff9bfef689041$var$isValidTab = (child)=>$2hDQc.isValidElement(child);
const $cacff9bfef689041$var$TabListPrimitive = ({ className: className, children: children, indicatorPosition: indicatorPosition, spacing: spacing, role: role = "tablist", ...rest }, ref)=>{
    const internalRef = $2hDQc.useRef(null);
    const { activeTab: activeTab, setActiveTab: setActiveTab } = $2hDQc.useContext((0, $8d7ff0d585efe4c2$export$cfa7aa87c26e7d1f));
    $2hDQc.useImperativeHandle(ref, ()=>internalRef.current);
    const values = $2hDQc.useMemo(()=>$2hDQc.Children.toArray(children).map((child)=>{
            if (child && $cacff9bfef689041$var$isValidTab(child)) return child.props.value;
        }).filter((child)=>!!child), [
        children
    ]);
    const currentIndex = values.indexOf(activeTab);
    const nextTab = $2hDQc.useCallback(()=>{
        let nextIndex = currentIndex === values.length - 1 ? 0 : currentIndex + 1;
        const elems = internalRef.current?.querySelectorAll("button") ?? [];
        while(elems[nextIndex].disabled)if (nextIndex === values.length - 1) nextIndex = 0;
        else nextIndex++;
        const value = values[nextIndex];
        if (value) {
            setActiveTab(value);
            const elem = elems[nextIndex];
            elem?.focus();
            elem?.click();
        }
    }, [
        currentIndex,
        setActiveTab,
        values
    ]);
    const prevTab = $2hDQc.useCallback(()=>{
        let prevIndex = currentIndex === 0 ? values.length - 1 : currentIndex - 1;
        const elems = internalRef.current?.querySelectorAll("button") ?? [];
        while(elems[prevIndex].disabled)if (prevIndex === 0) prevIndex = values.length - 1;
        else prevIndex--;
        const value = values[prevIndex];
        if (value) {
            setActiveTab(value);
            const elem = elems[prevIndex];
            elem?.focus();
            elem?.click();
        }
    }, [
        currentIndex,
        setActiveTab,
        values
    ]);
    const onKeyDown = $2hDQc.useCallback((event)=>{
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                event.stopPropagation();
                prevTab();
                break;
            case "ArrowUp":
            case "ArrowRight":
                event.preventDefault();
                event.stopPropagation();
                nextTab();
                break;
        }
    }, [
        prevTab,
        nextTab
    ]);
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        onKeyDown: onKeyDown,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsList, indicatorPosition ? (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsList, indicatorPosition) : null, spacing ? (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsList, spacing) : null, className),
        ref: internalRef
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $cacff9bfef689041$export$e51a686c67fdaa2d = (0, $62181de68de3c447$export$44aa160b17c73194)($cacff9bfef689041$var$TabListPrimitive);
$cacff9bfef689041$export$e51a686c67fdaa2d.displayName = "Tabs.List";



var $2hDQc = parcelRequire("2hDQc");




const $93b6dc855f32b334$var$TabPanelPrimitive = ({ className: className, value: value, children: children, role: role = "tabpanel", ...rest }, ref)=>{
    const { activeTab: activeTab, isLazy: isLazy } = $2hDQc.useContext((0, $8d7ff0d585efe4c2$export$cfa7aa87c26e7d1f));
    if (isLazy && activeTab !== value) return null;
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        id: `${value}-panel`,
        "aria-labelledby": `${value}-tab`,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsPanel, (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).TabsPanel, "active", activeTab === value), className),
        ref: ref
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $93b6dc855f32b334$export$3d96ec278d3efce4 = (0, $62181de68de3c447$export$44aa160b17c73194)($93b6dc855f32b334$var$TabPanelPrimitive);
$93b6dc855f32b334$export$3d96ec278d3efce4.displayName = "Tabs.Panel";



var $2hDQc = parcelRequire("2hDQc");




const $a5046788b8a99839$var$TabsContainerPrimitive = ({ children: children, defaultValue: defaultValue, className: className, value: controlledValue, onValueChange: onValueChange, isLazy: isLazy, ...rest }, ref)=>{
    const isControlled = controlledValue !== undefined;
    const [localValue, setLocalValue] = $2hDQc.useState(()=>isControlled ? controlledValue : defaultValue);
    const activeTab = isControlled ? controlledValue : localValue ?? "";
    const setActiveTab = $2hDQc.useCallback((newValue)=>{
        if ((0, $85b840b81f21bd6d$export$f6e2535fb5126e54)(onValueChange)) onValueChange(newValue);
        if (!isControlled) setLocalValue(newValue);
    }, [
        onValueChange,
        isControlled
    ]);
    const _value = $2hDQc.useMemo(()=>{
        return {
            activeTab: activeTab,
            isLazy: isLazy,
            setActiveTab: setActiveTab
        };
    }, [
        activeTab,
        setActiveTab,
        isLazy
    ]);
    return $2hDQc.createElement((0, $8d7ff0d585efe4c2$export$cfa7aa87c26e7d1f).Provider, {
        value: _value
    }, $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        ...rest,
        ref: ref,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)(className, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Tabs)
    }, children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $a5046788b8a99839$export$2206531ad8592d57 = (0, $62181de68de3c447$export$44aa160b17c73194)($a5046788b8a99839$var$TabsContainerPrimitive);
$a5046788b8a99839$export$2206531ad8592d57.displayName = "Tabs.Container";


const $05b07b067370b905$var$TabsPrimitive = ({ items: items, indicatorPosition: indicatorPosition, justifyContent: justifyContent, spacing: spacing, ...rest }, ref)=>{
    return $2hDQc.createElement((0, $a5046788b8a99839$export$2206531ad8592d57), {
        ...rest,
        ref: ref
    }, $2hDQc.createElement((0, $cacff9bfef689041$export$e51a686c67fdaa2d), {
        indicatorPosition: indicatorPosition,
        justifyContent: justifyContent,
        spacing: spacing
    }, items?.map(({ value: value, label: label, content: content, ...rest })=>$2hDQc.createElement((0, $dd46ce452f29b2c7$export$6d702cd3660ac20b), {
            ...rest,
            key: value,
            value: value
        }, label))), items?.map(({ value: value, content: content, isDisabled: isDisabled })=>$2hDQc.createElement((0, $93b6dc855f32b334$export$3d96ec278d3efce4), {
            key: value,
            value: value,
            isDisabled: isDisabled
        }, content)));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $05b07b067370b905$export$b2539bed5023c21c = Object.assign((0, $62181de68de3c447$export$44aa160b17c73194)($05b07b067370b905$var$TabsPrimitive), {
    Item: (0, $dd46ce452f29b2c7$export$6d702cd3660ac20b),
    List: (0, $cacff9bfef689041$export$e51a686c67fdaa2d),
    Panel: (0, $93b6dc855f32b334$export$3d96ec278d3efce4),
    Container: (0, $a5046788b8a99839$export$2206531ad8592d57)
});
$05b07b067370b905$export$b2539bed5023c21c.displayName = "Tabs";




var $2hDQc = parcelRequire("2hDQc");






var $2hDQc = parcelRequire("2hDQc");
/** Federated IDPs that Authenticator supports */ var $9f747e99d2b8b36e$export$4d240f091c25e146;
(function(FederatedIdentityProviders) {
    FederatedIdentityProviders["Apple"] = "Apple";
    FederatedIdentityProviders["Amazon"] = "Amazon";
    FederatedIdentityProviders["Facebook"] = "Facebook";
    FederatedIdentityProviders["Google"] = "Google";
})($9f747e99d2b8b36e$export$4d240f091c25e146 || ($9f747e99d2b8b36e$export$4d240f091c25e146 = {}));
/**
 * Cognito user contact method types that have not been verified as valid
 */ var $9f747e99d2b8b36e$export$5733d30e1ebcb3c0;
(function(UnverifiedContactMethodType) {
    UnverifiedContactMethodType["Email"] = "email";
    UnverifiedContactMethodType["PhoneNumber"] = "phone_number";
})($9f747e99d2b8b36e$export$5733d30e1ebcb3c0 || ($9f747e99d2b8b36e$export$5733d30e1ebcb3c0 = {}));




var $2hDQc = parcelRequire("2hDQc");


const $882aab911a92391f$var$DividerPrimitive = ({ className: className, orientation: orientation = "horizontal", size: size, label: label, ...rest }, ref)=>{
    const componentClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Divider, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Divider, orientation), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Divider, size), className);
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "aria-orientation": orientation,
        as: "hr",
        className: componentClasses,
        "data-label": label,
        ref: ref,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/divider)
 */ const $882aab911a92391f$export$2e0a83ec2e27ecbb = (0, $62181de68de3c447$export$44aa160b17c73194)($882aab911a92391f$var$DividerPrimitive);
$882aab911a92391f$export$2e0a83ec2e27ecbb.displayName = "Divider";





var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");



const $8b0f787bd2f89ae8$var$defaultViewBox = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
};
const $8b0f787bd2f89ae8$var$IconPrimitive = ({ className: className, as: // as can be used to render other icon react components too
as = "svg", fill: fill = "currentColor", pathData: pathData, viewBox: viewBox = $8b0f787bd2f89ae8$var$defaultViewBox, children: children, paths: paths, ...rest }, ref)=>{
    const minX = viewBox.minX ? viewBox.minX : $8b0f787bd2f89ae8$var$defaultViewBox.minX;
    const minY = viewBox.minY ? viewBox.minY : $8b0f787bd2f89ae8$var$defaultViewBox.minY;
    const width = viewBox.width ? viewBox.width : $8b0f787bd2f89ae8$var$defaultViewBox.width;
    const height = viewBox.height ? viewBox.height : $8b0f787bd2f89ae8$var$defaultViewBox.height;
    // An icon can be drawn in 3 ways:
    // 1. Pass it children which should be valid SVG elements
    // 2. Pass an array of path-like objects to `paths` prop
    // 3. Supply `pathData` for a simple icons
    let _children;
    if (children) _children = children;
    if (paths) _children = paths.map((path, index)=>$2hDQc.createElement("path", {
            ...path,
            key: index
        }));
    if (pathData) _children = $2hDQc.createElement("path", {
        d: pathData,
        fill: fill
    });
    return $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: as,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Icon, className),
        ref: ref,
        viewBox: `${minX} ${minY} ${width} ${height}`,
        ...rest
    }, _children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/icon)
 */ const $8b0f787bd2f89ae8$export$f04a61298a47a40f = (0, $62181de68de3c447$export$44aa160b17c73194)($8b0f787bd2f89ae8$var$IconPrimitive);
$8b0f787bd2f89ae8$export$f04a61298a47a40f.displayName = "Icon";






const $27925f14b201784f$var$AppleIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("svg", {
        "aria-label": "Apple icon",
        className: "amplify-icon federated-sign-in-icon",
        fill: "#000",
        preserveAspectRatio: "xMidYMid",
        stroke: "#000",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
    }));
};
const $27925f14b201784f$var$GoogleIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("svg", {
        "aria-label": "Google icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    }));
};
const $27925f14b201784f$var$FacebookIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $8b0f787bd2f89ae8$export$f04a61298a47a40f), {
        className: "federated-sign-in-icon",
        ariaLabel: "Facebook icon",
        viewBox: {
            minX: 0,
            minY: 0,
            width: 279,
            height: 538
        },
        pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
        fill: "#1877F2"
    });
};
const $27925f14b201784f$var$AmazonIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("svg", {
        "aria-label": "Amazon icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 243 264",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
        fill: "#F2541B"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
        fill: "#F2541B"
    }));
};
const $27925f14b201784f$export$66f93ed48923765d = (props)=>{
    const { icon: icon, provider: provider, text: text } = props;
    const { toFederatedSignIn: toFederatedSignIn } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)();
    const handleClick = (event)=>{
        event.preventDefault();
        toFederatedSignIn({
            provider: provider
        });
    };
    let iconComponent;
    if (icon === "facebook") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($27925f14b201784f$var$FacebookIcon, null);
    else if (icon === "google") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($27925f14b201784f$var$GoogleIcon, null);
    else if (icon === "amazon") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($27925f14b201784f$var$AmazonIcon, null);
    else if (icon === "apple") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement($27925f14b201784f$var$AppleIcon, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        onClick: handleClick,
        className: "federated-sign-in-button",
        fontWeight: "normal",
        gap: "1rem"
    }, iconComponent, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $387905725642d69a$export$5f1af8db9871e1d6), {
        as: "span"
    }, text));
};


const { getSignInWithFederationText: $ddb9f5fd80abda1e$var$getSignInWithFederationText, getOrText: $ddb9f5fd80abda1e$var$getOrText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
function $ddb9f5fd80abda1e$export$558443b7244c6aa() {
    const { route: route, socialProviders: socialProviders } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ route: route, socialProviders: socialProviders })=>[
            route,
            socialProviders
        ]);
    if (socialProviders.length === 0) // @ts-ignore
    return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column",
        padding: `0 0 1rem 0`,
        className: "federated-sign-in-container"
    }, socialProviders.map((provider)=>{
        switch(provider){
            case "amazon":
                return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $27925f14b201784f$export$66f93ed48923765d), {
                    icon: "amazon",
                    key: provider,
                    provider: (0, $9f747e99d2b8b36e$export$4d240f091c25e146).Amazon,
                    text: $ddb9f5fd80abda1e$var$getSignInWithFederationText(route, provider)
                });
            case "apple":
                return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $27925f14b201784f$export$66f93ed48923765d), {
                    icon: "apple",
                    key: provider,
                    provider: (0, $9f747e99d2b8b36e$export$4d240f091c25e146).Apple,
                    text: $ddb9f5fd80abda1e$var$getSignInWithFederationText(route, provider)
                });
            case "facebook":
                return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $27925f14b201784f$export$66f93ed48923765d), {
                    icon: "facebook",
                    key: provider,
                    provider: (0, $9f747e99d2b8b36e$export$4d240f091c25e146).Facebook,
                    text: $ddb9f5fd80abda1e$var$getSignInWithFederationText(route, provider)
                });
            case "google":
                return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $27925f14b201784f$export$66f93ed48923765d), {
                    icon: "google",
                    key: provider,
                    provider: (0, $9f747e99d2b8b36e$export$4d240f091c25e146).Google,
                    text: $ddb9f5fd80abda1e$var$getSignInWithFederationText(route, provider)
                });
            default:
                // eslint-disable-next-line no-console
                console.error(`Authenticator does not support ${provider}. Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose`);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $882aab911a92391f$export$2e0a83ec2e27ecbb), {
        size: "small",
        label: $ddb9f5fd80abda1e$var$getOrText()
    }));
}







const { getSignInText: $b3c75fe00b081331$var$getSignInText, getSigningInText: $b3c75fe00b081331$var$getSigningInText, getForgotPasswordText: $b3c75fe00b081331$var$getForgotPasswordText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
function $b3c75fe00b081331$export$b64708c6f1b3ed96() {
    const { isPending: isPending } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SignIn: { Header: Header = $b3c75fe00b081331$export$b64708c6f1b3ed96.Header, Footer: Footer = $b3c75fe00b081331$export$b64708c6f1b3ed96.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signin": "",
        method: "post",
        onSubmit: handleSubmit,
        onChange: handleChange
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $ddb9f5fd80abda1e$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6a564f6545e800b7$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("legend", null, $b3c75fe00b081331$var$getSignInText())), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        isFullWidth: true,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $b3c75fe00b081331$var$getSigningInText()
    }, $b3c75fe00b081331$var$getSignInText()))), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null));
}
const $b3c75fe00b081331$var$DefaultFooter = ()=>{
    const { toForgotPassword: toForgotPassword } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.toForgotPassword
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "data-amplify-footer": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        onClick: toForgotPassword,
        size: "small",
        variation: "link"
    }, $b3c75fe00b081331$var$getForgotPasswordText()));
};
$b3c75fe00b081331$export$b64708c6f1b3ed96.Footer = $b3c75fe00b081331$var$DefaultFooter;
$b3c75fe00b081331$export$b64708c6f1b3ed96.Header = function Header() {
    // @ts-ignore
    return null;
};



var $2hDQc = parcelRequire("2hDQc");










const { getCreateAccountText: $c4b42c4272d0e6cc$var$getCreateAccountText, getCreatingAccountText: $c4b42c4272d0e6cc$var$getCreatingAccountText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
function $c4b42c4272d0e6cc$export$4ee457d816cea81a() {
    const { hasValidationErrors: hasValidationErrors, isPending: isPending } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.hasValidationErrors,
            context.isPending
        ]);
    const { handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SignUp: { Header: Header = $c4b42c4272d0e6cc$export$4ee457d816cea81a.Header, FormFields: FormFields = $c4b42c4272d0e6cc$export$4ee457d816cea81a.FormFields, Footer: Footer = $c4b42c4272d0e6cc$export$4ee457d816cea81a.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signup": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $ddb9f5fd80abda1e$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(FormFields, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        isDisabled: hasValidationErrors || isPending,
        isFullWidth: true,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $c4b42c4272d0e6cc$var$getCreatingAccountText()
    }, $c4b42c4272d0e6cc$var$getCreateAccountText()))), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null));
}
$c4b42c4272d0e6cc$export$4ee457d816cea81a.Header = function Header() {
    // @ts-ignore
    return null;
};
$c4b42c4272d0e6cc$export$4ee457d816cea81a.FormFields = function FormFields$1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null);
};
$c4b42c4272d0e6cc$export$4ee457d816cea81a.Footer = function Footer() {
    // @ts-ignore
    return null;
};



const { getSignInTabText: $df423517e92de164$var$getSignInTabText, getSignUpTabText: $df423517e92de164$var$getSignUpTabText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $df423517e92de164$export$6815ad73b98d75ed = ({ className: className, hideSignUp: hideSignUp, variation: variation })=>{
    const { route: route, toSignIn: toSignIn, toSignUp: toSignUp } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.route,
            context.toSignIn,
            context.toSignUp
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, hideSignUp ? (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, route === "signIn" && (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b3c75fe00b081331$export$b64708c6f1b3ed96), null)) : (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $05b07b067370b905$export$b2539bed5023c21c).Container, {
        value: route,
        isLazy: true,
        onValueChange: ()=>route === "signIn" ? toSignUp() : toSignIn()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $05b07b067370b905$export$b2539bed5023c21c).List, {
        spacing: "equal",
        indicatorPosition: "top"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $05b07b067370b905$export$b2539bed5023c21c).Item, {
        value: "signIn"
    }, $df423517e92de164$var$getSignInTabText()), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $05b07b067370b905$export$b2539bed5023c21c).Item, {
        value: "signUp"
    }, $df423517e92de164$var$getSignUpTabText())), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $05b07b067370b905$export$b2539bed5023c21c).Panel, {
        value: "signIn",
        "data-amplify-router-content": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b3c75fe00b081331$export$b64708c6f1b3ed96), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $05b07b067370b905$export$b2539bed5023c21c).Panel, {
        value: "signUp",
        "data-amplify-router-content": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $c4b42c4272d0e6cc$export$4ee457d816cea81a), null))));
};



var $2hDQc = parcelRequire("2hDQc");








var $2hDQc = parcelRequire("2hDQc");




const { getSubmitText: $96da4634321dd7a6$var$getSubmitText, getSubmittingText: $96da4634321dd7a6$var$getSubmittingText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $96da4634321dd7a6$export$8311b872375357fe = (props)=>{
    const { cancelButtonSendType: cancelButtonSendType, cancelButtonText: cancelButtonText, submitButtonText: submitButtonText } = props;
    const { isPending: isPending, resendCode: resendCode, skipVerification: skipVerification, toSignIn: toSignIn } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const onClick = ()=>{
        switch(cancelButtonSendType){
            case "SKIP":
                skipVerification();
                break;
            case "RESEND":
                resendCode();
                break;
            case "SIGN_IN":
                toSignIn();
                break;
            default:
                return;
        }
    };
    const defaultSubmitText = isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, $96da4634321dd7a6$var$getSubmittingText(), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, $96da4634321dd7a6$var$getSubmitText());
    const submitText = submitButtonText ?? defaultSubmitText;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        variation: "primary",
        isDisabled: isPending,
        type: "submit"
    }, submitText), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $6933ba031aede256$export$353f5b6fc5456de1), {
        onClick: onClick,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, cancelButtonText));
};




const { getAccountRecoveryInfoText: $665c617ca3b19fb4$var$getAccountRecoveryInfoText, getSkipText: $665c617ca3b19fb4$var$getSkipText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $665c617ca3b19fb4$export$79a17bba512ce899 = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmVerifyUser: { Header: Header = $665c617ca3b19fb4$export$79a17bba512ce899.Header, Footer: Footer = $665c617ca3b19fb4$export$79a17bba512ce899.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmverifyuser": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $96da4634321dd7a6$export$8311b872375357fe), {
        cancelButtonText: $665c617ca3b19fb4$var$getSkipText(),
        cancelButtonSendType: "SKIP"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null))));
};
$665c617ca3b19fb4$export$79a17bba512ce899.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 3
    }, $665c617ca3b19fb4$var$getAccountRecoveryInfoText());
};
$665c617ca3b19fb4$export$79a17bba512ce899.Footer = function Footer() {
    return null;
};



var $2hDQc = parcelRequire("2hDQc");




var $2hDQc = parcelRequire("2hDQc");





var $2hDQc = parcelRequire("2hDQc");
const $51081380e1d03cf0$var$defaultValue = {
    name: "default"
};
const $51081380e1d03cf0$export$a79eda4ff50e30b6 = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createContext($51081380e1d03cf0$var$defaultValue);
const $51081380e1d03cf0$export$7bea016dc7ad2ddf = ()=>{
    return (0, $2hDQc.useContext)($51081380e1d03cf0$export$a79eda4ff50e30b6);
};




const $8b562c6675330311$export$d493a8d66e90d1ca = ({ children: children, className: className, id: id, isDisabled: isDisabled = false, testId: testId, value: value, labelPosition: radioLabelPosition, ...rest }, ref)=>{
    const { currentValue: currentValue, defaultValue: defaultValue, name: name, hasError: hasError, isGroupDisabled: isGroupDisabled = false, isRequired: isRequired, isReadOnly: isReadOnly, onChange: onChange, size: size, labelPosition: groupLabelPosition } = (0, $51081380e1d03cf0$export$7bea016dc7ad2ddf)();
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $7bec285a424993af$export$b140571ec72925dd)();
    const shouldBeDisabled = isFieldsetDisabled ? isFieldsetDisabled : isGroupDisabled || isDisabled || isReadOnly && defaultValue !== value;
    // for controlled component
    const checked = currentValue !== undefined ? value === currentValue : undefined;
    // for uncontrolled component
    const defaultChecked = defaultValue !== undefined ? value === defaultValue : undefined;
    const labelPosition = radioLabelPosition ? radioLabelPosition : groupLabelPosition;
    return $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "label",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Radio, (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Radio, `disabled`, shouldBeDisabled), labelPosition ? `amplify-label-${labelPosition}` : null, className)
    }, children && $2hDQc.createElement((0, $387905725642d69a$export$5f1af8db9871e1d6), {
        as: "span",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioLabel, (0, $85b840b81f21bd6d$export$3c152e7b97c7496c)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioLabel, `disabled`, shouldBeDisabled))
    }, children), $2hDQc.createElement((0, $039f045064e97e9e$export$f5b8910cec6cf069), {
        checked: checked,
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioInput),
        defaultChecked: defaultChecked,
        hasError: hasError,
        id: id,
        isDisabled: shouldBeDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        onChange: onChange,
        ref: ref,
        type: "radio",
        name: name,
        value: value,
        ...rest
    }), $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        "aria-hidden": "true",
        as: "span",
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioButton, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioButton, size)),
        testId: testId
    }));
};
const $8b562c6675330311$export$d7b12c4107be0d61 = (0, $62181de68de3c447$export$44aa160b17c73194)($8b562c6675330311$export$d493a8d66e90d1ca);
$8b562c6675330311$export$d7b12c4107be0d61.displayName = "Radio";



var $2hDQc = parcelRequire("2hDQc");






var $2hDQc = parcelRequire("2hDQc");






const $03ec0aeb34f7599c$var$FieldsetPrimitive = ({ children: children, className: className, isDisabled: isDisabled, legend: legend, legendHidden: legendHidden, size: size, testId: testId, variation: variation = "plain", ...rest }, ref)=>{
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $7bec285a424993af$export$b140571ec72925dd)();
    // Fieldsets that are nested within a disabled Fieldset should
    // also be disabled.
    const shouldBeDisabled = isFieldsetDisabled ? isFieldsetDisabled : isDisabled;
    const value = $2hDQc.useMemo(()=>({
            isFieldsetDisabled: shouldBeDisabled
        }), [
        shouldBeDisabled
    ]);
    const fieldsetClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Fieldset, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Fieldset, variation), (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Fieldset, size), className);
    const legendClasses = (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldsetLegend, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).FieldsetLegend, size), {
        [(0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).VisuallyHidden]: legendHidden
    });
    return $2hDQc.createElement((0, $7bec285a424993af$export$74e4d3bc6dc1117).Provider, {
        value: value
    }, $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        className: fieldsetClasses,
        ref: ref,
        disabled: shouldBeDisabled,
        testId: testId,
        ...rest
    }, $2hDQc.createElement((0, $6a564f6545e800b7$export$439d29a4e110a164), {
        as: "legend"
    }, legend), $2hDQc.createElement((0, $65027f4b45f2008d$export$27a5bd065ad55220), {
        as: "div",
        "aria-hidden": "true",
        className: legendClasses
    }, legend), children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/fieldset)
 */ const $03ec0aeb34f7599c$export$e154be390aa0e14 = (0, $62181de68de3c447$export$44aa160b17c73194)($03ec0aeb34f7599c$var$FieldsetPrimitive);
$03ec0aeb34f7599c$export$e154be390aa0e14.displayName = "Fieldset";





const $cf42dd5719c207a0$export$ec17b125bc42c229 = (testId, component)=>testId && component ? `${testId}-${component}` : undefined;




const $285e43e06af2eb81$var$RadioGroupFieldPrimitive = ({ children: children, className: className, defaultValue: defaultValue, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, isDisabled: isDisabled, isRequired: isRequired, isReadOnly: isReadOnly, legend: legend, legendHidden: legendHidden = false, labelPosition: labelPosition, onChange: onChange, name: name, size: size, testId: testId, value: value, variation: variation, ...rest }, ref)=>{
    const fieldId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)(id);
    const descriptionId = (0, $e37092acc6c1e2fc$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = descriptiveText ? descriptionId : undefined;
    const radioGroupTestId = (0, $cf42dd5719c207a0$export$ec17b125bc42c229)(testId, (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioGroup);
    const radioGroupContextValue = $2hDQc.useMemo(()=>({
            currentValue: value,
            defaultValue: defaultValue,
            hasError: hasError,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
            isGroupDisabled: isDisabled,
            onChange: onChange,
            size: size,
            name: name,
            labelPosition: labelPosition
        }), [
        defaultValue,
        hasError,
        isDisabled,
        isRequired,
        isReadOnly,
        onChange,
        size,
        name,
        value,
        labelPosition
    ]);
    return $2hDQc.createElement((0, $03ec0aeb34f7599c$export$e154be390aa0e14), {
        className: (0, $811347c147720737$export$ce4ab0c55987d1ff)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Field, (0, $85b840b81f21bd6d$export$1d6fb99b5e148be8)((0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).Field, size), (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioGroupField, className),
        isDisabled: isDisabled,
        legend: legend,
        legendHidden: legendHidden,
        ref: ref,
        role: "radiogroup",
        size: size,
        testId: testId,
        variation: variation,
        ...rest
    }, $2hDQc.createElement((0, $1b05dc3c654ece32$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: legendHidden,
        descriptiveText: descriptiveText
    }), $2hDQc.createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        "aria-describedby": ariaDescribedBy,
        className: (0, $a7285459b7fbfb54$export$a5e41a4bc3f9b1d6).RadioGroup,
        id: fieldId,
        testId: radioGroupTestId
    }, $2hDQc.createElement((0, $51081380e1d03cf0$export$a79eda4ff50e30b6).Provider, {
        value: radioGroupContextValue
    }, children)), $2hDQc.createElement((0, $daba90391b752297$export$1c081951d49ad6f6), {
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/radiogroupfield)
 */ const $285e43e06af2eb81$export$a314277471067e8a = (0, $62181de68de3c447$export$44aa160b17c73194)($285e43e06af2eb81$var$RadioGroupFieldPrimitive);
$285e43e06af2eb81$export$a314277471067e8a.displayName = "RadioGroupField";








const { getSkipText: $7d8a0a76b3ca6129$var$getSkipText, getVerifyText: $7d8a0a76b3ca6129$var$getVerifyText, getVerifyContactText: $7d8a0a76b3ca6129$var$getVerifyContactText, getAccountRecoveryInfoText: $7d8a0a76b3ca6129$var$getAccountRecoveryInfoText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $7d8a0a76b3ca6129$var$censorContactInformation = (type, value)=>{
    const translated = (0, $9afaaee5b06e14b0$export$d73ee8ef04f5226a)(type);
    let newVal = value;
    if (type === "Phone Number") newVal = (0, $508296b373a163a4$export$72b2b64445441bf7)(value);
    else if (type === "Email") {
        const splitEmail = value.split("@");
        const censoredName = (0, $508296b373a163a4$export$655775443891f2b8)(splitEmail[0]);
        newVal = `${censoredName}@${splitEmail[1]}`;
    }
    return `${translated}: ${newVal}`;
};
const $7d8a0a76b3ca6129$var$generateRadioGroup = (attributes)=>{
    return Object.entries(attributes).map(([key, value])=>(0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $8b562c6675330311$export$d7b12c4107be0d61), {
            name: "unverifiedAttr",
            value: key,
            key: key
        }, $7d8a0a76b3ca6129$var$censorContactInformation((0, $1501912d3aedff2e$export$1222d357a3c2c47f)[key].label, value)));
};
const $7d8a0a76b3ca6129$export$da61eb776d8ee98b = ({ className: className, variation: variation })=>{
    const { components: { // @ts-ignore
    VerifyUser: { Header: Header = $7d8a0a76b3ca6129$export$da61eb776d8ee98b.Header, Footer: Footer = $7d8a0a76b3ca6129$export$da61eb776d8ee98b.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    const { isPending: isPending, unverifiedUserAttributes: unverifiedUserAttributes } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ isPending: isPending, unverifiedUserAttributes: unverifiedUserAttributes })=>[
            isPending,
            unverifiedUserAttributes
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const footerSubmitText = isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, "Verifying\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, $7d8a0a76b3ca6129$var$getVerifyText());
    const verificationRadioGroup = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $285e43e06af2eb81$export$a314277471067e8a), {
        legend: $7d8a0a76b3ca6129$var$getVerifyContactText(),
        name: "verify_context",
        isDisabled: isPending,
        legendHidden: true
    }, $7d8a0a76b3ca6129$var$generateRadioGroup(unverifiedUserAttributes));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-verifyuser": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), verificationRadioGroup, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $96da4634321dd7a6$export$8311b872375357fe), {
        cancelButtonText: $7d8a0a76b3ca6129$var$getSkipText(),
        cancelButtonSendType: "SKIP",
        submitButtonText: footerSubmitText
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null))));
};
$7d8a0a76b3ca6129$export$da61eb776d8ee98b.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 3
    }, $7d8a0a76b3ca6129$var$getAccountRecoveryInfoText());
};
$7d8a0a76b3ca6129$export$da61eb776d8ee98b.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $2hDQc = parcelRequire("2hDQc");










const { getChallengeText: $c24e12c5a872ded8$var$getChallengeText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $c24e12c5a872ded8$export$b8b09b30a5bdd893 = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmSignIn: { Header: Header = $c24e12c5a872ded8$export$b8b09b30a5bdd893.Header, Footer: Footer = $c24e12c5a872ded8$export$b8b09b30a5bdd893.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignin": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $e99991201ce018ab$export$76e9c0cec6811ff4), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null))));
};
function $c24e12c5a872ded8$var$Header() {
    const { challengeName: challengeName } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ challengeName: challengeName })=>[
            challengeName
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 3
    }, $c24e12c5a872ded8$var$getChallengeText(challengeName));
}
$c24e12c5a872ded8$export$b8b09b30a5bdd893.Header = $c24e12c5a872ded8$var$Header;
$c24e12c5a872ded8$export$b8b09b30a5bdd893.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $2hDQc = parcelRequire("2hDQc");










const { getResendCodeText: $14284dd16579b03c$var$getResendCodeText, getResetYourPasswordText: $14284dd16579b03c$var$getResetYourPasswordText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $14284dd16579b03c$export$fb3a0d1a16180c0d = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmResetPassword: { Header: Header = $14284dd16579b03c$export$fb3a0d1a16180c0d.Header, Footer: Footer = $14284dd16579b03c$export$fb3a0d1a16180c0d.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmresetpassword": "",
        method: "post",
        onSubmit: handleSubmit,
        onChange: handleChange,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $96da4634321dd7a6$export$8311b872375357fe), {
        cancelButtonSendType: "RESEND",
        cancelButtonText: $14284dd16579b03c$var$getResendCodeText()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null))));
};
$14284dd16579b03c$export$fb3a0d1a16180c0d.Header = function Header() {
    const headerText = $14284dd16579b03c$var$getResetYourPasswordText();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 3
    }, headerText);
};
$14284dd16579b03c$export$fb3a0d1a16180c0d.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $2hDQc = parcelRequire("2hDQc");










const { getBackToSignInText: $fc5fa37fc711cc7b$var$getBackToSignInText, getSendingText: $fc5fa37fc711cc7b$var$getSendingText, getSendCodeText: $fc5fa37fc711cc7b$var$getSendCodeText, getResetYourPasswordText: $fc5fa37fc711cc7b$var$getResetYourPasswordText } = (0, $1bf63f0ec1759aca$export$34e9c32aebe14fbb);
const $fc5fa37fc711cc7b$export$b597ee422a3143dc = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $75eb2fee620372ec$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ForgotPassword: { Header: Header = $fc5fa37fc711cc7b$export$b597ee422a3143dc.Header, Footer: Footer = $fc5fa37fc711cc7b$export$b597ee422a3143dc.Footer } } } = (0, $089704face704122$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $836f3d1750024f12$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forgotpassword": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f9df95057f6ae67f$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $b31a891f80c4c8e2$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $37ad4ae2a349ede8$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $96da4634321dd7a6$export$8311b872375357fe), {
        cancelButtonText: $fc5fa37fc711cc7b$var$getBackToSignInText(),
        cancelButtonSendType: "SIGN_IN",
        submitButtonText: isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, $fc5fa37fc711cc7b$var$getSendingText(), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, null, $fc5fa37fc711cc7b$var$getSendCodeText())
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(Footer, null))));
};
$fc5fa37fc711cc7b$export$b597ee422a3143dc.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $9d1ea6f43618b301$export$a8a3e93435678ff9), {
        level: 3
    }, $fc5fa37fc711cc7b$var$getResetYourPasswordText());
};
$fc5fa37fc711cc7b$export$b597ee422a3143dc.Footer = function Footer() {
    // @ts-ignore
    return null;
};


const $1451357b2fc1a1c5$export$c92b4b399eea902a = (route)=>route === "signIn" || route === "signUp";


function $df61c981975efc6e$var$RenderNothing() {
    // @ts-ignore
    return null;
}
const $df61c981975efc6e$var$getRouteComponent = (route)=>{
    switch(route){
        case "authenticated":
        case "idle":
        case "setup":
        case "transition":
            return $df61c981975efc6e$var$RenderNothing;
        case "confirmSignUp":
            return 0, $bae7bca463c3990b$export$649c708157e61c64;
        case "confirmSignIn":
            return 0, $c24e12c5a872ded8$export$b8b09b30a5bdd893;
        case "setupTotp":
            return 0, $6bff16d8c619ec2e$export$1f819652bce2948d;
        case "signIn":
        case "signUp":
            return 0, $df423517e92de164$export$6815ad73b98d75ed;
        case "forceNewPassword":
            return 0, $cfad12c60a932151$export$b3aae0a112274a60;
        case "forgotPassword":
            return 0, $fc5fa37fc711cc7b$export$b597ee422a3143dc;
        case "confirmResetPassword":
            return 0, $14284dd16579b03c$export$fb3a0d1a16180c0d;
        case "verifyUser":
            return 0, $7d8a0a76b3ca6129$export$da61eb776d8ee98b;
        case "confirmVerifyUser":
            return 0, $665c617ca3b19fb4$export$79a17bba512ce899;
        default:
            // eslint-disable-next-line no-console
            console.warn(`Unhandled Authenticator route - please open an issue: ${route}`);
            return $df61c981975efc6e$var$RenderNothing;
    }
};
function $df61c981975efc6e$export$55185c17a0fcbe46({ className: className, hideSignUp: hideSignUp, variation: variation }) {
    const { route: route } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const RouterChildren = (0, $2hDQc.useMemo)(()=>$df61c981975efc6e$var$getRouteComponent(route), [
        route
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement(RouterChildren, {
        className: className,
        // @ts-ignore
        hideSignUp: (0, $1451357b2fc1a1c5$export$c92b4b399eea902a)(route) ? hideSignUp : undefined,
        variation: variation
    });
}


















const $4cb82a806197ef16$export$71abc632aa29e6fe = {
    // @ts-ignore
    Header: ()=>null,
    SignIn: {
        Header: (0, $b3c75fe00b081331$export$b64708c6f1b3ed96).Header,
        Footer: (0, $b3c75fe00b081331$export$b64708c6f1b3ed96).Footer
    },
    SignUp: {
        Header: (0, $c4b42c4272d0e6cc$export$4ee457d816cea81a).Header,
        FormFields: (0, $c4b42c4272d0e6cc$export$4ee457d816cea81a).FormFields,
        Footer: (0, $c4b42c4272d0e6cc$export$4ee457d816cea81a).Footer
    },
    ConfirmSignUp: {
        Header: (0, $bae7bca463c3990b$export$649c708157e61c64).Header,
        Footer: (0, $bae7bca463c3990b$export$649c708157e61c64).Footer
    },
    SetupTotp: {
        Header: (0, $6bff16d8c619ec2e$export$1f819652bce2948d).Header,
        Footer: (0, $6bff16d8c619ec2e$export$1f819652bce2948d).Footer
    },
    ConfirmResetPassword: {
        Header: (0, $14284dd16579b03c$export$fb3a0d1a16180c0d).Header,
        Footer: (0, $14284dd16579b03c$export$fb3a0d1a16180c0d).Footer
    },
    ConfirmSignIn: {
        Header: (0, $c24e12c5a872ded8$export$b8b09b30a5bdd893).Header,
        Footer: (0, $c24e12c5a872ded8$export$b8b09b30a5bdd893).Footer
    },
    VerifyUser: {
        Header: (0, $7d8a0a76b3ca6129$export$da61eb776d8ee98b).Header,
        Footer: (0, $7d8a0a76b3ca6129$export$da61eb776d8ee98b).Footer
    },
    ConfirmVerifyUser: {
        Header: (0, $665c617ca3b19fb4$export$79a17bba512ce899).Header,
        // @ts-ignore
        Footer: (0, $665c617ca3b19fb4$export$79a17bba512ce899).Footer
    },
    ForceNewPassword: {
        Header: (0, $cfad12c60a932151$export$b3aae0a112274a60).Header,
        Footer: (0, $cfad12c60a932151$export$b3aae0a112274a60).Footer,
        FormFields: (0, $cfad12c60a932151$export$b3aae0a112274a60).FormFields
    },
    ForgotPassword: {
        Header: (0, $fc5fa37fc711cc7b$export$b597ee422a3143dc).Header,
        Footer: (0, $fc5fa37fc711cc7b$export$b597ee422a3143dc).Footer
    },
    // @ts-ignore
    Footer: ()=>null
};


// `AuthenticatorInternal` exists to give access to the context returned via `useAuthenticator`,
// which allows the `Authenticator` to just return `children` if a user is authenticated.
// Once the `Provider` is removed from the `Authenticator` component and exported as
// `AuthenticatorProvider`, this component should be renamed to `Authenticator`.
function $f7223b976be2f24f$export$213d252991da224({ children: children, className: className, components: customComponents, formFields: formFields, hideSignUp: hideSignUp, initialState: initialState, loginMechanisms: loginMechanisms, passwordSettings: passwordSettings, signUpAttributes: signUpAttributes, services: services, socialProviders: socialProviders, variation: variation }) {
    (0, $f80c235def355e34$export$406e4c8585b97b03)({
        message: "The `passwordSettings` prop has been deprecated and will be removed in a future major version of Amplify UI.",
        // shouldWarn: !!passwordSettings,
        /**
         * @migration turn off until getConfig returns zero config
         */ shouldWarn: false
    });
    const { route: route, signOut: signOut, user: user } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)(({ route: route, signOut: signOut, user: user })=>[
            route,
            signOut,
            user
        ]);
    (0, $df39709324226e13$export$2e2bcd8739ae039)({
        initialState: initialState,
        loginMechanisms: loginMechanisms,
        passwordSettings: passwordSettings,
        services: services,
        signUpAttributes: signUpAttributes,
        socialProviders: socialProviders,
        formFields: formFields
    });
    const value = $2hDQc.useMemo(()=>({
            components: {
                ...(0, $4cb82a806197ef16$export$71abc632aa29e6fe),
                ...customComponents
            }
        }), [
        customComponents
    ]);
    const isAuthenticatedRoute = route === "authenticated" || route === "signOut";
    if (isAuthenticatedRoute) {
        // `Authenticator` might not have user defined `children` for non SPA use cases.
        if (!children) // @ts-ignore
        return null;
        return $2hDQc.createElement($2hDQc.Fragment, null, (0, $85b840b81f21bd6d$export$f6e2535fb5126e54)(children) ? children({
            signOut: signOut,
            user: user
        }) // children is a render prop
         : children);
    }
    return $2hDQc.createElement((0, $089704face704122$export$da5ac45a736a5880).Provider, {
        value: value
    }, $2hDQc.createElement((0, $df61c981975efc6e$export$55185c17a0fcbe46), {
        className: className,
        hideSignUp: hideSignUp,
        variation: variation
    }));
}
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator)
 */ function $f7223b976be2f24f$export$3d7a1e8452f884f3(props) {
    (0, $060d76aa10a5b245$export$2e2bcd8739ae039)({
        componentName: "Authenticator",
        packageName: "react",
        version: (0, $b96c5d763660034f$export$a4ad2735b021c132)
    });
    return $2hDQc.createElement((0, $cf66f8524ccb62e2$export$2e2bcd8739ae039), null, $2hDQc.createElement($f7223b976be2f24f$export$213d252991da224, {
        ...props
    }));
}
$f7223b976be2f24f$export$3d7a1e8452f884f3.Provider = (0, $cf66f8524ccb62e2$export$2e2bcd8739ae039);
$f7223b976be2f24f$export$3d7a1e8452f884f3.ForgotPassword = (0, $fc5fa37fc711cc7b$export$b597ee422a3143dc);
$f7223b976be2f24f$export$3d7a1e8452f884f3.SetupTotp = (0, $6bff16d8c619ec2e$export$1f819652bce2948d);
$f7223b976be2f24f$export$3d7a1e8452f884f3.SignIn = (0, $b3c75fe00b081331$export$b64708c6f1b3ed96);
$f7223b976be2f24f$export$3d7a1e8452f884f3.SignUp = (0, $c4b42c4272d0e6cc$export$4ee457d816cea81a);
$f7223b976be2f24f$export$3d7a1e8452f884f3.ForceNewPassword = (0, $cfad12c60a932151$export$b3aae0a112274a60);





var $2hDQc = parcelRequire("2hDQc");













var $2hDQc = parcelRequire("2hDQc");


const $52c37f2f8c911c73$var$useAuthenticatorData = ({ customerId: customerId, queryCataloguesEnabled: queryCataloguesEnabled = false, queryPlacesEnabled: queryPlacesEnabled = false, queryCustomersEnabled: queryCustomersEnabled = false })=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const { admin: admin, customerType: customerType } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const { setCustomerFromArray: setCustomerFromArray, customer: customer, setPlaceFromArray: setPlaceFromArray, setPlaceFromCatalogue: setPlaceFromCatalogue, setInitialized: setInitialized } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const queryCatalogues = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$90904af181961b2),
            customerId
        ],
        queryFn: ()=>(0, $be730b8591848347$export$25753268427e50ea).getCataloguesByCustomer(customerId),
        enabled: queryCataloguesEnabled && customerType === "T"
    });
    const queryPlaces = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$9e8d1e7efde0f0d3)
        ],
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getPlacesByCustomer(admin, customerId),
        enabled: queryPlacesEnabled && customerType === "L"
    });
    const queryCustomers = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$a8e0fd0e2c725bd)
        ],
        queryFn: ()=>admin ? (0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getLandlords(true, {
                limit: 10
            }) : (0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getCustomers(false, {
                limit: 10,
                sort: "TYPE",
                direction: "ASC"
            }),
        enabled: queryCustomersEnabled
    });
    (0, $2hDQc.useEffect)(()=>{
        if (queryCustomers.isSuccess) {
            const response = queryCustomers.data;
            if (response.data && response.data?.length > 0 && response.data[0]?.id && response.data[0]?.name) setCustomerFromArray(response.data, true);
            else {
                setInitialized(true);
                navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).LOGIN_STEPS, {
                    replace: true
                });
            }
        }
    }, [
        queryCustomers.isSuccess
    ]);
    (0, $2hDQc.useEffect)(()=>{
        if (queryCatalogues.isSuccess) {
            const response = queryCatalogues.data;
            if (response && response.length > 0 && response[0]?.place?.id && response[0]?.place?.name) setPlaceFromCatalogue(response[0]);
        }
    }, [
        queryCatalogues.isSuccess
    ]);
    (0, $2hDQc.useEffect)(()=>{
        if (queryPlaces.isSuccess) {
            const response = queryPlaces.data;
            if (response && response.length > 0 && response[0]?.id && response[0]?.name) setPlaceFromArray(response);
            else {
                setInitialized(true);
                navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).LOGIN_STEPS, {
                    replace: true
                });
            }
        }
    }, [
        queryPlaces.isSuccess
    ]);
    const waitingForCustomers = queryCustomers.isPending;
    const waitingForPlaces = customerType === "T" ? customer?.id && queryCatalogues.isPending : customer?.id && queryPlaces.isPending;
    return {
        queryCustomers: queryCustomers,
        queryCatalogues: queryCatalogues,
        queryPlaces: queryPlaces,
        waitingForCustomers: waitingForCustomers,
        waitingForPlaces: waitingForPlaces
    };
};
var $52c37f2f8c911c73$export$2e2bcd8739ae039 = $52c37f2f8c911c73$var$useAuthenticatorData;


const $97e236a54f421b1b$var$MoovyAuthenticator = ({ children: children })=>{
    const { user: user } = (0, $eeb86049f3e8b8d0$export$2e2bcd8739ae039)((context)=>[
            context.user
        ]);
    const [searchParams] = (0, $944912ac1928e04f$export$f1a78c17382fe22a)();
    const signUp = searchParams.get("signUp");
    const { isAuthenticated: isAuthenticated, setAuthentication: setAuthentication, userGroups: userGroups } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const { customer: customer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const sessionQuery = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$136d5c9516c6d4cd)
        ],
        queryFn: ()=>(0, $9b69f9955ab78e59$export$2e2bcd8739ae039).getAuthSession(),
        enabled: false
    });
    const { queryPlaces: queryPlaces, queryCustomers: queryCustomers, waitingForCustomers: waitingForCustomers, waitingForPlaces: waitingForPlaces } = (0, $52c37f2f8c911c73$export$2e2bcd8739ae039)({
        customerId: customer?.id,
        queryCataloguesEnabled: sessionQuery.isSuccess,
        queryPlacesEnabled: sessionQuery.isSuccess,
        queryCustomersEnabled: sessionQuery.isSuccess
    });
    (0, $2hDQc.useEffect)(()=>{
        if (sessionQuery.isSuccess) {
            const jwtToken = (0, $9b69f9955ab78e59$export$2e2bcd8739ae039).getJWTToken(sessionQuery.data);
            if (jwtToken) {
                setAuthentication({
                    userGroups: (0, $9b69f9955ab78e59$export$2e2bcd8739ae039).getUserGroups(sessionQuery.data),
                    token: jwtToken
                });
                (0, $9b69f9955ab78e59$export$2e2bcd8739ae039).setTokenToInterceptor(jwtToken);
            }
        }
    }, [
        sessionQuery.isSuccess
    ]);
    const waitingForSession = sessionQuery.isPending;
    const waitingForGroups = userGroups === undefined;
    // Login has happened, fetch session data to Redux state and Session storage
    (0, $2hDQc.useEffect)(()=>{
        user?.username && sessionQuery.refetch();
    }, [
        user?.username
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f7223b976be2f24f$export$3d7a1e8452f884f3), {
            initialState: signUp ? "signUp" : "signIn",
            signUpAttributes: [
                "given_name",
                "family_name",
                "email"
            ],
            children: ({ signOut: signOut, user: user })=>{
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                    children: !isAuthenticated || waitingForGroups || waitingForSession || waitingForCustomers || waitingForPlaces ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {}) : sessionQuery.isError || queryPlaces.isError || queryCustomers.isError ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $0ad050a15234ec76$export$2e2bcd8739ae039), {}) : children
                });
            }
        })
    });
};
var $97e236a54f421b1b$export$2e2bcd8739ae039 = $97e236a54f421b1b$var$MoovyAuthenticator;



var $592Nh = parcelRequire("592Nh");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $1e7157234cae45bf$export$c6bd6795ed6e3203(slot) {
    return (0, $01COD.default)("MuiList", slot);
}
const $1e7157234cae45bf$var$listClasses = (0, $eLydt.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $1e7157234cae45bf$export$2e2bcd8739ae039 = $1e7157234cae45bf$var$listClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $e0a8f8fda2869892$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $e0a8f8fda2869892$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $1e7157234cae45bf$export$c6bd6795ed6e3203), classes);
};
const $e0a8f8fda2869892$var$ListRoot = (0, $fhlQp.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $e0a8f8fda2869892$var$List = /*#__PURE__*/ $2hDQc.forwardRef(function List(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $gZOiq.default)(props, $e0a8f8fda2869892$var$_excluded);
    const context = $2hDQc.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $e0a8f8fda2869892$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)($e0a8f8fda2869892$var$ListRoot, (0, $kxIgO.default)({
            as: component,
            className: (0, $fLRFO.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $e0a8f8fda2869892$export$2e2bcd8739ae039 = $e0a8f8fda2869892$var$List;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");



var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");


var $592Nh = parcelRequire("592Nh");
"use client";
const $227710469f9d2c1d$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $227710469f9d2c1d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $b7a01c39f36d7d73$export$1061006a0db3aeb5), classes);
};
const $227710469f9d2c1d$var$ListItemTextRoot = (0, $fhlQp.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $b7a01c39f36d7d73$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $b7a01c39f36d7d73$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $227710469f9d2c1d$var$ListItemText = /*#__PURE__*/ $2hDQc.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $gZOiq.default)(props, $227710469f9d2c1d$var$_excluded);
    const { dense: dense } = $2hDQc.useContext((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $kxIgO.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $227710469f9d2c1d$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $df1a4ec584b17f6d$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $df1a4ec584b17f6d$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $592Nh.jsxs)($227710469f9d2c1d$var$ListItemTextRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $227710469f9d2c1d$export$2e2bcd8739ae039 = $227710469f9d2c1d$var$ListItemText;



var $592Nh = parcelRequire("592Nh");

var $2hDQc = parcelRequire("2hDQc");

function $cb0bc60fb82b84a3$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $592Nh = parcelRequire("592Nh");
"use client";
function $bb428e42283f734d$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $bb428e42283f734d$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $bb428e42283f734d$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $2hDQc.useRef(false);
    const nodeRef = $2hDQc.useRef(null);
    const activatedRef = $2hDQc.useRef(false);
    const syntheticEventRef = $2hDQc.useRef(false);
    $2hDQc.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $09890193466d3518$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $bb428e42283f734d$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $2hDQc.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $bb428e42283f734d$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $2hDQc.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $bb428e42283f734d$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
        children: /*#__PURE__*/ $2hDQc.cloneElement(children, childrenProps)
    });
}


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");



var $gZOiq = parcelRequire("gZOiq");



var $2hDQc = parcelRequire("2hDQc");

var $2325fc080e6ce8f4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $79a4a62df1ed8344$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $f1775b3e9e6fc859$export$bb38bb9a1161268 = "unmounted";
var $f1775b3e9e6fc859$export$84cbff306f539230 = "exited";
var $f1775b3e9e6fc859$export$df38205c966be359 = "entering";
var $f1775b3e9e6fc859$export$78e9e6e3e014d60a = "entered";
var $f1775b3e9e6fc859$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $f1775b3e9e6fc859$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $dfdff6b428ca04e3$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $f1775b3e9e6fc859$export$84cbff306f539230;
                _this.appearStatus = $f1775b3e9e6fc859$export$df38205c966be359;
            } else initialStatus = $f1775b3e9e6fc859$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $f1775b3e9e6fc859$export$bb38bb9a1161268;
        else initialStatus = $f1775b3e9e6fc859$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $f1775b3e9e6fc859$export$bb38bb9a1161268) return {
            status: $f1775b3e9e6fc859$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $f1775b3e9e6fc859$export$df38205c966be359 && status !== $f1775b3e9e6fc859$export$78e9e6e3e014d60a) nextStatus = $f1775b3e9e6fc859$export$df38205c966be359;
            } else if (status === $f1775b3e9e6fc859$export$df38205c966be359 || status === $f1775b3e9e6fc859$export$78e9e6e3e014d60a) nextStatus = $f1775b3e9e6fc859$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $f1775b3e9e6fc859$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b36a61f25d8b4314$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $79a4a62df1ed8344$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $f1775b3e9e6fc859$export$84cbff306f539230) this.setState({
            status: $f1775b3e9e6fc859$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b36a61f25d8b4314$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2325fc080e6ce8f4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $f1775b3e9e6fc859$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $f1775b3e9e6fc859$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $f1775b3e9e6fc859$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b36a61f25d8b4314$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2325fc080e6ce8f4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $f1775b3e9e6fc859$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $f1775b3e9e6fc859$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $f1775b3e9e6fc859$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b36a61f25d8b4314$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $f1775b3e9e6fc859$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $gZOiq.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $fe107dad5725a895$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Component);
$f1775b3e9e6fc859$var$Transition.contextType = (0, $fe107dad5725a895$export$2e2bcd8739ae039);
$f1775b3e9e6fc859$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $f1775b3e9e6fc859$var$noop() {}
$f1775b3e9e6fc859$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $f1775b3e9e6fc859$var$noop,
    onEntering: $f1775b3e9e6fc859$var$noop,
    onEntered: $f1775b3e9e6fc859$var$noop,
    onExit: $f1775b3e9e6fc859$var$noop,
    onExiting: $f1775b3e9e6fc859$var$noop,
    onExited: $f1775b3e9e6fc859$var$noop
};
$f1775b3e9e6fc859$var$Transition.UNMOUNTED = $f1775b3e9e6fc859$export$bb38bb9a1161268;
$f1775b3e9e6fc859$var$Transition.EXITED = $f1775b3e9e6fc859$export$84cbff306f539230;
$f1775b3e9e6fc859$var$Transition.ENTERING = $f1775b3e9e6fc859$export$df38205c966be359;
$f1775b3e9e6fc859$var$Transition.ENTERED = $f1775b3e9e6fc859$export$78e9e6e3e014d60a;
$f1775b3e9e6fc859$var$Transition.EXITING = $f1775b3e9e6fc859$export$4aacc83d4d59139f;
var $f1775b3e9e6fc859$export$2e2bcd8739ae039 = $f1775b3e9e6fc859$var$Transition;



const $1aa5c4f4ecb43caa$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $592Nh = parcelRequire("592Nh");
"use client";
const $7206ceb21be884d5$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7206ceb21be884d5$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7206ceb21be884d5$var$styles = {
    entering: {
        opacity: 1,
        transform: $7206ceb21be884d5$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7206ceb21be884d5$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7206ceb21be884d5$var$Grow = /*#__PURE__*/ $2hDQc.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f1775b3e9e6fc859$export$2e2bcd8739ae039) } = props, other = (0, $gZOiq.default)(props, $7206ceb21be884d5$var$_excluded);
    const timer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    const autoTimeout = $2hDQc.useRef();
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const nodeRef = $2hDQc.useRef(null);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1aa5c4f4ecb43caa$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7206ceb21be884d5$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7206ceb21be884d5$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7206ceb21be884d5$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $7206ceb21be884d5$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $2hDQc.cloneElement(children, (0, $kxIgO.default)({
                style: (0, $kxIgO.default)({
                    opacity: 0,
                    transform: $7206ceb21be884d5$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $7206ceb21be884d5$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7206ceb21be884d5$var$Grow.muiSupportAuto = true;
var $7206ceb21be884d5$export$2e2bcd8739ae039 = $7206ceb21be884d5$var$Grow;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");



var $8be63c98f6bdf56e$export$2e2bcd8739ae039 = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039);



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7ed4db476b689edd$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $895a4c7c223d611e$export$2e2bcd8739ae039 = (0, $7ed4db476b689edd$export$2e2bcd8739ae039);





var $592Nh = parcelRequire("592Nh");
"use client";
const $908e39c61e238c21$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $908e39c61e238c21$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $908e39c61e238c21$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $908e39c61e238c21$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $908e39c61e238c21$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$908e39c61e238c21$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $908e39c61e238c21$var$MenuList = /*#__PURE__*/ $2hDQc.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $gZOiq.default)(props, $908e39c61e238c21$var$_excluded);
    const listRef = $2hDQc.useRef(null);
    const textCriteriaRef = $2hDQc.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $2hDQc.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $895a4c7c223d611e$export$2e2bcd8739ae039)((0, $8be63c98f6bdf56e$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $8be63c98f6bdf56e$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $908e39c61e238c21$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $908e39c61e238c21$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $908e39c61e238c21$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $908e39c61e238c21$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $908e39c61e238c21$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $908e39c61e238c21$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $908e39c61e238c21$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $908e39c61e238c21$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $908e39c61e238c21$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $908e39c61e238c21$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $908e39c61e238c21$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $2hDQc.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $2hDQc.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $2hDQc.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $2hDQc.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $908e39c61e238c21$export$2e2bcd8739ae039 = $908e39c61e238c21$var$MenuList;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");

function $23bfc64a667b2c60$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b1841ec7f0414ab1$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b1841ec7f0414ab1$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b1841ec7f0414ab1$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $23c3944bcf8f5f72$export$8960430cfd85939f = Math.max;
var $23c3944bcf8f5f72$export$96ec731ed4dcb222 = Math.min;
var $23c3944bcf8f5f72$export$2077e0241d6afd3c = Math.round;



function $aae6093e2bdd30a0$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $54db2ca5841a6abd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $aae6093e2bdd30a0$export$2e2bcd8739ae039)());
}


function $552a36f424541fa4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(element) ? (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $54db2ca5841a6abd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $da1734441d1134fd$export$2e2bcd8739ae039(node) {
    var win = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $19dd3f2770c1e823$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $dd17bca7a54a00ab$export$2e2bcd8739ae039(node) {
    if (node === (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(node) || !(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(node)) return (0, $da1734441d1134fd$export$2e2bcd8739ae039)(node);
    else return (0, $19dd3f2770c1e823$export$2e2bcd8739ae039)(node);
}


function $e98e23441bde3086$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $8bb9d7df3ba6a06e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $bcbbdb54536baeac$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $552a36f424541fa4$export$2e2bcd8739ae039)((0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element)).left + (0, $da1734441d1134fd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $5a21022d6f915cf0$export$2e2bcd8739ae039(element) {
    return (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $fd78ac594e4a6e37$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $762ab75df74183a5$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $762ab75df74183a5$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(offsetParent) && $762ab75df74183a5$var$isElementScaled(offsetParent);
    var documentElement = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e98e23441bde3086$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $fd78ac594e4a6e37$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $dd17bca7a54a00ab$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $bcbbdb54536baeac$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $643a8468b8f55590$export$2e2bcd8739ae039(element) {
    if ((0, $e98e23441bde3086$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b1841ec7f0414ab1$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $f66a20117ca5d60a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $e98e23441bde3086$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(node) && (0, $fd78ac594e4a6e37$export$2e2bcd8739ae039)(node)) return node;
    return $f66a20117ca5d60a$export$2e2bcd8739ae039((0, $643a8468b8f55590$export$2e2bcd8739ae039)(node));
}





function $1580d1f1bc5f0ff3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $f66a20117ca5d60a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $fd78ac594e4a6e37$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1580d1f1bc5f0ff3$export$2e2bcd8739ae039((0, $643a8468b8f55590$export$2e2bcd8739ae039)(target)));
}







function $e883e847abce7648$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $e98e23441bde3086$export$2e2bcd8739ae039)(element)) >= 0;
}




function $4200170a8fe0a087$var$getTrueOffsetParent(element) {
    if (!(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $4200170a8fe0a087$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $aae6093e2bdd30a0$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $aae6093e2bdd30a0$export$2e2bcd8739ae039)());
    if (isIE && (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $643a8468b8f55590$export$2e2bcd8739ae039)(element);
    if ((0, $b1841ec7f0414ab1$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $e98e23441bde3086$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $4200170a8fe0a087$export$2e2bcd8739ae039(element) {
    var window = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element);
    var offsetParent = $4200170a8fe0a087$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $e883e847abce7648$export$2e2bcd8739ae039)(offsetParent) && (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $4200170a8fe0a087$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $e98e23441bde3086$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $e98e23441bde3086$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $4200170a8fe0a087$var$getContainingBlock(element) || window;
}


var $c6657ed2bd4b5f0a$export$1e95b668f3b82d = "top";
var $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb = "bottom";
var $c6657ed2bd4b5f0a$export$79ffe56a765070d2 = "right";
var $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4 = "left";
var $c6657ed2bd4b5f0a$export$dfb5619354ba860 = "auto";
var $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3 = [
    $c6657ed2bd4b5f0a$export$1e95b668f3b82d,
    $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb,
    $c6657ed2bd4b5f0a$export$79ffe56a765070d2,
    $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4
];
var $c6657ed2bd4b5f0a$export$b3571188c770cc5a = "start";
var $c6657ed2bd4b5f0a$export$bd5df0f255a350f8 = "end";
var $c6657ed2bd4b5f0a$export$390fd549c5303b4d = "clippingParents";
var $c6657ed2bd4b5f0a$export$d7b7311ec04a3e8f = "viewport";
var $c6657ed2bd4b5f0a$export$ae5ab1c730825774 = "popper";
var $c6657ed2bd4b5f0a$export$ca50aac9f3ba507f = "reference";
var $c6657ed2bd4b5f0a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c6657ed2bd4b5f0a$export$b3571188c770cc5a,
        placement + "-" + $c6657ed2bd4b5f0a$export$bd5df0f255a350f8
    ]);
}, []);
var $c6657ed2bd4b5f0a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c6657ed2bd4b5f0a$export$aec2ce47c367b8c3, [
    $c6657ed2bd4b5f0a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c6657ed2bd4b5f0a$export$b3571188c770cc5a,
        placement + "-" + $c6657ed2bd4b5f0a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c6657ed2bd4b5f0a$export$421679a7c3d56e = "beforeRead";
var $c6657ed2bd4b5f0a$export$aafa59e2e03f2942 = "read";
var $c6657ed2bd4b5f0a$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $c6657ed2bd4b5f0a$export$c65e99957a05207c = "beforeMain";
var $c6657ed2bd4b5f0a$export$f22da7240b7add18 = "main";
var $c6657ed2bd4b5f0a$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c6657ed2bd4b5f0a$export$8d4d2d70e7d46032 = "beforeWrite";
var $c6657ed2bd4b5f0a$export$68d8715fc104d294 = "write";
var $c6657ed2bd4b5f0a$export$70a6e5159acce2e6 = "afterWrite";
var $c6657ed2bd4b5f0a$export$d087d3878fdf71d5 = [
    $c6657ed2bd4b5f0a$export$421679a7c3d56e,
    $c6657ed2bd4b5f0a$export$aafa59e2e03f2942,
    $c6657ed2bd4b5f0a$export$6964f6c886723980,
    $c6657ed2bd4b5f0a$export$c65e99957a05207c,
    $c6657ed2bd4b5f0a$export$f22da7240b7add18,
    $c6657ed2bd4b5f0a$export$bab79516f2d662fe,
    $c6657ed2bd4b5f0a$export$8d4d2d70e7d46032,
    $c6657ed2bd4b5f0a$export$68d8715fc104d294,
    $c6657ed2bd4b5f0a$export$70a6e5159acce2e6
];


function $46ba3bafee2163e3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $46ba3bafee2163e3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $46ba3bafee2163e3$var$order(modifiers); // order based on phase
    return (0, $c6657ed2bd4b5f0a$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9cd3e4a7a0d8020b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4ae09abd06a8d91c$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $f7095fb200459102$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $f7095fb200459102$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $f7095fb200459102$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f7095fb200459102$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $f7095fb200459102$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(reference) ? (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $46ba3bafee2163e3$export$2e2bcd8739ae039)((0, $4ae09abd06a8d91c$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f7095fb200459102$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $762ab75df74183a5$export$2e2bcd8739ae039)(reference, (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9cd3e4a7a0d8020b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f7095fb200459102$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f7095fb200459102$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f7095fb200459102$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $034398a97685f722$var$passive = {
    passive: true
};
function $034398a97685f722$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $034398a97685f722$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $034398a97685f722$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $034398a97685f722$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $034398a97685f722$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $034398a97685f722$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $034398a97685f722$var$effect,
    data: {}
};



function $61de13b434c26827$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $c6a018a4a1ef38e4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $2dab833bacc18f84$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $8c30663fe0bf4764$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $61de13b434c26827$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2dab833bacc18f84$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $c6657ed2bd4b5f0a$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $817cdc30d090b763$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $8c30663fe0bf4764$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $817cdc30d090b763$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $817cdc30d090b763$var$popperOffsets,
    data: {}
};










var $3f5d8947cd4685ee$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3f5d8947cd4685ee$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $23c3944bcf8f5f72$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3f5d8947cd4685ee$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
    var sideY = (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(popper);
            if ((0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) || (placement === (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4) || placement === (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2)) && variation === (0, $c6657ed2bd4b5f0a$export$bd5df0f255a350f8)) {
            sideY = (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4) || (placement === (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) || placement === (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)) && variation === (0, $c6657ed2bd4b5f0a$export$bd5df0f255a350f8)) {
            sideX = (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3f5d8947cd4685ee$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3f5d8947cd4685ee$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $3f5d8947cd4685ee$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $61de13b434c26827$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3f5d8947cd4685ee$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3f5d8947cd4685ee$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3f5d8947cd4685ee$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $3f5d8947cd4685ee$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $a26367323d29f85c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) || !(0, $e98e23441bde3086$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $a26367323d29f85c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) || !(0, $e98e23441bde3086$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $a26367323d29f85c$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $a26367323d29f85c$var$applyStyles,
    effect: $a26367323d29f85c$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $f39a2db16c583784$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4),
        (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4),
        (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f39a2db16c583784$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $c6657ed2bd4b5f0a$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $f39a2db16c583784$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f39a2db16c583784$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $f39a2db16c583784$var$offset
};


var $fc0120f6911cbc7d$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $fc0120f6911cbc7d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $fc0120f6911cbc7d$var$hash[matched];
    });
}



var $5acdbe1f7ef8ca86$var$hash = {
    start: "end",
    end: "start"
};
function $5acdbe1f7ef8ca86$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5acdbe1f7ef8ca86$var$hash[matched];
    });
}







function $0c209d99105e5baa$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $23bfc64a667b2c60$export$2e2bcd8739ae039)(element);
    var html = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $54db2ca5841a6abd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $bcbbdb54536baeac$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f3c5111ca93a319e$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $da1734441d1134fd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $bcbbdb54536baeac$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $4c605c525ca0edeb$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b1841ec7f0414ab1$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $c0bc3f890525ed3b$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $40338b76a3b0d8f0$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $40338b76a3b0d8f0$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $c6657ed2bd4b5f0a$export$d7b7311ec04a3e8f) ? (0, $c0bc3f890525ed3b$export$2e2bcd8739ae039)((0, $0c209d99105e5baa$export$2e2bcd8739ae039)(element, strategy)) : (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(clippingParent) ? $40338b76a3b0d8f0$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c0bc3f890525ed3b$export$2e2bcd8739ae039)((0, $f3c5111ca93a319e$export$2e2bcd8739ae039)((0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $40338b76a3b0d8f0$var$getClippingParents(element) {
    var clippingParents = (0, $1580d1f1bc5f0ff3$export$2e2bcd8739ae039)((0, $643a8468b8f55590$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $5a21022d6f915cf0$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b1841ec7f0414ab1$export$1b3bfaa9684536aa)(element) ? (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4c605c525ca0edeb$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $e98e23441bde3086$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $40338b76a3b0d8f0$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $40338b76a3b0d8f0$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $40338b76a3b0d8f0$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $40338b76a3b0d8f0$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $2835d14c37255796$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $50b8f91f4d6175a0$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2835d14c37255796$export$2e2bcd8739ae039)(), paddingObject);
}


function $0985dc62839206c0$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $a7b0a9f6d274853f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $c6657ed2bd4b5f0a$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $c6657ed2bd4b5f0a$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $50b8f91f4d6175a0$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $0985dc62839206c0$export$2e2bcd8739ae039)(padding, (0, $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) ? (0, $c6657ed2bd4b5f0a$export$ca50aac9f3ba507f) : (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $40338b76a3b0d8f0$export$2e2bcd8739ae039)((0, $b1841ec7f0414ab1$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $8bb9d7df3ba6a06e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $552a36f424541fa4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $8c30663fe0bf4764$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $c0bc3f890525ed3b$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $c6657ed2bd4b5f0a$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2),
                (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
                (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $8cf189dfd52c74f8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $c6657ed2bd4b5f0a$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $c6657ed2bd4b5f0a$export$368f9a87e87fa4e1) : (0, $c6657ed2bd4b5f0a$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $61de13b434c26827$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $80a537add0d1475a$var$getExpandedFallbackPlacements(placement) {
    if ((0, $61de13b434c26827$export$2e2bcd8739ae039)(placement) === (0, $c6657ed2bd4b5f0a$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5acdbe1f7ef8ca86$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5acdbe1f7ef8ca86$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $80a537add0d1475a$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $80a537add0d1475a$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $61de13b434c26827$export$2e2bcd8739ae039)(placement) === (0, $c6657ed2bd4b5f0a$export$dfb5619354ba860) ? (0, $8cf189dfd52c74f8$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(placement) === (0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a);
        var isVertical = [
            (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
            (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $fc0120f6911cbc7d$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $80a537add0d1475a$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $80a537add0d1475a$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $00857c4adc5c4048$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $25e22eb95c43d6c5$export$f28d906d67a997f3(min, value, max) {
    return (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(min, (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(value, max));
}
function $25e22eb95c43d6c5$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $25e22eb95c43d6c5$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $59e0fe2f023eedbd$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $c6a018a4a1ef38e4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2dab833bacc18f84$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $00857c4adc5c4048$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $c6657ed2bd4b5f0a$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $2835d14c37255796$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(tether ? (0, $23c3944bcf8f5f72$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $23c3944bcf8f5f72$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
            (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $25e22eb95c43d6c5$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $59e0fe2f023eedbd$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $59e0fe2f023eedbd$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $2aacc20cad9175ed$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $50b8f91f4d6175a0$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $0985dc62839206c0$export$2e2bcd8739ae039)(padding, (0, $c6657ed2bd4b5f0a$export$aec2ce47c367b8c3)));
};
function $2aacc20cad9175ed$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $61de13b434c26827$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $2dab833bacc18f84$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4),
        (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2aacc20cad9175ed$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ca6fbbb2fbb9fbe4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d) : (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb) : (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $4200170a8fe0a087$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $25e22eb95c43d6c5$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2aacc20cad9175ed$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4c605c525ca0edeb$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2aacc20cad9175ed$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $2aacc20cad9175ed$var$arrow,
    effect: $2aacc20cad9175ed$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $5ac86404024ba63f$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $5ac86404024ba63f$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $c6657ed2bd4b5f0a$export$1e95b668f3b82d),
        (0, $c6657ed2bd4b5f0a$export$79ffe56a765070d2),
        (0, $c6657ed2bd4b5f0a$export$40e543e69a8b3fbb),
        (0, $c6657ed2bd4b5f0a$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $5ac86404024ba63f$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $a7b0a9f6d274853f$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $5ac86404024ba63f$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $5ac86404024ba63f$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $5ac86404024ba63f$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $5ac86404024ba63f$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $5ac86404024ba63f$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $5ac86404024ba63f$var$hide
};




var $160facd9e41a3641$export$d34966752335dd47 = [
    (0, $034398a97685f722$export$2e2bcd8739ae039),
    (0, $817cdc30d090b763$export$2e2bcd8739ae039),
    (0, $3f5d8947cd4685ee$export$2e2bcd8739ae039),
    (0, $a26367323d29f85c$export$2e2bcd8739ae039),
    (0, $f39a2db16c583784$export$2e2bcd8739ae039),
    (0, $80a537add0d1475a$export$2e2bcd8739ae039),
    (0, $59e0fe2f023eedbd$export$2e2bcd8739ae039),
    (0, $2aacc20cad9175ed$export$2e2bcd8739ae039),
    (0, $5ac86404024ba63f$export$2e2bcd8739ae039)
];
var $160facd9e41a3641$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $f7095fb200459102$export$ed5e13716264f202)({
    defaultModifiers: $160facd9e41a3641$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $dJnC1 = parcelRequire("dJnC1");

var $2hDQc = parcelRequire("2hDQc");




var $592Nh = parcelRequire("592Nh");
"use client";
function $7443ce9ff05e49c4$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $7443ce9ff05e49c4$export$602eac185826482c = /*#__PURE__*/ $2hDQc.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $2hDQc.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(/*#__PURE__*/ $2hDQc.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($7443ce9ff05e49c4$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $bf8564c56950a7db$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $bf8564c56950a7db$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $2hDQc.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $2hDQc.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
        children: mountNode ? /*#__PURE__*/ $b36a61f25d8b4314$exports.createPortal(children, mountNode) : mountNode
    });
});



var $01COD = parcelRequire("01COD");
const $7d3a85815e2985d9$var$GLOBAL_CLASS_PREFIX = "base";
function $7d3a85815e2985d9$var$buildStateClass(state) {
    return `${$7d3a85815e2985d9$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $7d3a85815e2985d9$var$buildSlotClass(componentName, slot) {
    return `${$7d3a85815e2985d9$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $7d3a85815e2985d9$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $01COD.globalStateClasses)[slot];
    return globalStateClass ? $7d3a85815e2985d9$var$buildStateClass(globalStateClass) : $7d3a85815e2985d9$var$buildSlotClass(componentName, slot);
}
function $7d3a85815e2985d9$export$34c0130b1f3e8ae3(slot) {
    return (0, $01COD.globalStateClasses)[slot] !== undefined;
}



function $1874f340a81a3a82$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $7d3a85815e2985d9$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $e0b2d6055e451592$var$COMPONENT_NAME = "Popper";
function $e0b2d6055e451592$export$1b69b6cd0fa638a1(slot) {
    return (0, $7d3a85815e2985d9$export$1d132570e11858b0)($e0b2d6055e451592$var$COMPONENT_NAME, slot);
}
const $e0b2d6055e451592$export$b6aa214021e734b0 = (0, $1874f340a81a3a82$export$de4f15803c389669)($e0b2d6055e451592$var$COMPONENT_NAME, [
    "root"
]);



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");


var $kxIgO = parcelRequire("kxIgO");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $1ade516e245d7339$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $c5c2ae979df9b048$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $1ade516e245d7339$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $kxIgO.default)({}, otherProps, {
        ownerState: (0, $kxIgO.default)({}, otherProps.ownerState, ownerState)
    });
}



var $kxIgO = parcelRequire("kxIgO");

var $fLRFO = parcelRequire("fLRFO");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $b3f8ec5af2a54766$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $e05d4fa646a68d61$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $6c940b6aa32935f2$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $fLRFO.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kxIgO.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kxIgO.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $b3f8ec5af2a54766$export$24d5698b57eff81c)((0, $kxIgO.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $e05d4fa646a68d61$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $e05d4fa646a68d61$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $fLRFO.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kxIgO.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kxIgO.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $f2cfe87d0a3b30e9$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $6f3442660a15142b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $6f3442660a15142b$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $gZOiq.default)(parameters, $6f3442660a15142b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $f2cfe87d0a3b30e9$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $6c940b6aa32935f2$export$b01d1e419b049226)((0, $kxIgO.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $c5c2ae979df9b048$export$b089efb01a7bdf50)(elementType, (0, $kxIgO.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $2hDQc = parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");
"use client";
const $c10ba98b55e47895$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $c10ba98b55e47895$var$ClassNameConfiguratorContext = /*#__PURE__*/ $2hDQc.createContext($c10ba98b55e47895$var$defaultContextValue);
function $c10ba98b55e47895$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $2hDQc.useContext($c10ba98b55e47895$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $c10ba98b55e47895$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $2hDQc.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)($c10ba98b55e47895$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $592Nh = parcelRequire("592Nh");
"use client";
const $0d6997ab75daa08a$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $0d6997ab75daa08a$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $0d6997ab75daa08a$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $0d6997ab75daa08a$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $0d6997ab75daa08a$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $0d6997ab75daa08a$var$isVirtualElement(element) {
    return !$0d6997ab75daa08a$var$isHTMLElement(element);
}
const $0d6997ab75daa08a$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $c10ba98b55e47895$export$b0f7603cd2f9ee15)((0, $e0b2d6055e451592$export$1b69b6cd0fa638a1)));
};
const $0d6997ab75daa08a$var$defaultPopperOptions = {};
const $0d6997ab75daa08a$var$PopperTooltip = /*#__PURE__*/ $2hDQc.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $gZOiq.default)(props, $0d6997ab75daa08a$var$_excluded);
    const tooltipRef = $2hDQc.useRef(null);
    const ownRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $2hDQc.useRef(null);
    const handlePopperRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $2hDQc.useRef(handlePopperRef);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $2hDQc.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $0d6997ab75daa08a$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $2hDQc.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $2hDQc.useState($0d6997ab75daa08a$var$resolveAnchorEl(anchorEl));
    $2hDQc.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $2hDQc.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($0d6997ab75daa08a$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $160facd9e41a3641$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $kxIgO.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $0d6997ab75daa08a$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)(Root, (0, $kxIgO.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $0d6997ab75daa08a$export$badac9ada3a0bdf9 = /*#__PURE__*/ $2hDQc.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $0d6997ab75daa08a$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $gZOiq.default)(props, $0d6997ab75daa08a$var$_excluded2);
    const [exited, setExited] = $2hDQc.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $0d6997ab75daa08a$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $0d6997ab75daa08a$var$isHTMLElement(resolvedAnchorEl) ? (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $7443ce9ff05e49c4$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($0d6997ab75daa08a$var$PopperTooltip, (0, $kxIgO.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $kxIgO.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});



var $hixEE = parcelRequire("hixEE");



var $2hDQc = parcelRequire("2hDQc");

var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");

var $592Nh = parcelRequire("592Nh");
"use client";
const $4ef6802bb98f4e22$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $4ef6802bb98f4e22$var$PopperRoot = (0, $fhlQp.default)((0, $0d6997ab75daa08a$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $4ef6802bb98f4e22$var$Popper = /*#__PURE__*/ $2hDQc.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $hixEE.default)();
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $gZOiq.default)(props, $4ef6802bb98f4e22$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $kxIgO.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $592Nh.jsx)($4ef6802bb98f4e22$var$PopperRoot, (0, $kxIgO.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $4ef6802bb98f4e22$export$2e2bcd8739ae039 = $4ef6802bb98f4e22$var$Popper;



var $2hDQc = parcelRequire("2hDQc");
const $41509f6a27074b22$var$MoovyCardMenu = ({ open: open, setOpen: setOpen, anchorRef: anchorRef, menuItems: menuItems })=>{
    const handleClose = (event, onMenuItemClick)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
        if (onMenuItemClick) {
            event.preventDefault();
            event.stopPropagation();
            onMenuItemClick();
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") setOpen(false);
    };
    const prevOpen = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useRef(open);
    (0, $2hDQc.useEffect)(()=>{
        if (prevOpen.current === true && open === false) anchorRef.current.focus();
        prevOpen.current = open;
    }, [
        open
    ]);
    const isMenu = menuItems && menuItems.length > 0;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $4ef6802bb98f4e22$export$2e2bcd8739ae039), {
        open: open,
        anchorEl: anchorRef.current,
        role: undefined,
        placement: "bottom-start",
        transition: true,
        disablePortal: true,
        style: {
            zIndex: 1
        },
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $7206ceb21be884d5$export$2e2bcd8739ae039), {
                ...TransitionProps,
                style: {
                    transformOrigin: placement === "bottom-start" ? "left top" : "left bottom"
                },
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
                    children: isMenu && /*#__PURE__*/ (0, $592Nh.jsx)((0, $bb428e42283f734d$export$58385c17fee43f89), {
                        onClickAway: handleClose,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $908e39c61e238c21$export$2e2bcd8739ae039), {
                            autoFocusItem: open,
                            id: "composition-menu",
                            "aria-labelledby": "composition-button",
                            onKeyDown: handleListKeyDown,
                            children: menuItems.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                                    onClick: (event)=>handleClose(event, item.onClick),
                                    children: item.itemText
                                }, index))
                        })
                    })
                })
            })
    });
};
var $41509f6a27074b22$export$2e2bcd8739ae039 = $41509f6a27074b22$var$MoovyCardMenu;



var $2hDQc = parcelRequire("2hDQc");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");
parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $40d3d64409950bf5$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $afe7c73ff808608f$export$ffd560f22c0ecf04(slot) {
    return (0, $01COD.default)("MuiAvatar", slot);
}
const $afe7c73ff808608f$var$avatarClasses = (0, $eLydt.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $afe7c73ff808608f$export$2e2bcd8739ae039 = $afe7c73ff808608f$var$avatarClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $560cc98f1d9121b1$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $560cc98f1d9121b1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $afe7c73ff808608f$export$ffd560f22c0ecf04), classes);
};
const $560cc98f1d9121b1$var$AvatarRoot = (0, $fhlQp.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $kxIgO.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $kxIgO.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $560cc98f1d9121b1$var$AvatarImg = (0, $fhlQp.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $560cc98f1d9121b1$var$AvatarFallback = (0, $fhlQp.default)((0, $40d3d64409950bf5$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $560cc98f1d9121b1$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $2hDQc.useState(false);
    $2hDQc.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $560cc98f1d9121b1$var$Avatar = /*#__PURE__*/ $2hDQc.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $gZOiq.default)(props, $560cc98f1d9121b1$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $560cc98f1d9121b1$var$useLoaded((0, $kxIgO.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $kxIgO.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $560cc98f1d9121b1$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $592Nh.jsx)($560cc98f1d9121b1$var$AvatarImg, (0, $kxIgO.default)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null && childrenProp !== "" && typeof childrenProp !== "boolean") children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $592Nh.jsx)($560cc98f1d9121b1$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($560cc98f1d9121b1$var$AvatarRoot, (0, $kxIgO.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $560cc98f1d9121b1$export$2e2bcd8739ae039 = $560cc98f1d9121b1$var$Avatar;



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $69feffa4178c9406$export$f3b76d2cce458caa(slot) {
    return (0, $01COD.default)("MuiCard", slot);
}
const $69feffa4178c9406$var$cardClasses = (0, $eLydt.default)("MuiCard", [
    "root"
]);
var $69feffa4178c9406$export$2e2bcd8739ae039 = $69feffa4178c9406$var$cardClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $78ce8df72ecef187$var$_excluded = [
    "className",
    "raised"
];
const $78ce8df72ecef187$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $69feffa4178c9406$export$f3b76d2cce458caa), classes);
};
const $78ce8df72ecef187$var$CardRoot = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $78ce8df72ecef187$var$Card = /*#__PURE__*/ $2hDQc.forwardRef(function Card(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $gZOiq.default)(props, $78ce8df72ecef187$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        raised: raised
    });
    const classes = $78ce8df72ecef187$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($78ce8df72ecef187$var$CardRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $78ce8df72ecef187$export$2e2bcd8739ae039 = $78ce8df72ecef187$var$Card;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $54eb295708f163ef$export$2a5c27c211442e3c(slot) {
    return (0, $01COD.default)("MuiCardActions", slot);
}
const $54eb295708f163ef$var$cardActionsClasses = (0, $eLydt.default)("MuiCardActions", [
    "root",
    "spacing"
]);
var $54eb295708f163ef$export$2e2bcd8739ae039 = $54eb295708f163ef$var$cardActionsClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $afc8705c82d57607$var$_excluded = [
    "disableSpacing",
    "className"
];
const $afc8705c82d57607$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $54eb295708f163ef$export$2a5c27c211442e3c), classes);
};
const $afc8705c82d57607$var$CardActionsRoot = (0, $fhlQp.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $afc8705c82d57607$var$CardActions = /*#__PURE__*/ $2hDQc.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $gZOiq.default)(props, $afc8705c82d57607$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $afc8705c82d57607$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($afc8705c82d57607$var$CardActionsRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $afc8705c82d57607$export$2e2bcd8739ae039 = $afc8705c82d57607$var$CardActions;



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $da6900438f3c4283$export$964336739a8c7119(slot) {
    return (0, $01COD.default)("MuiCardContent", slot);
}
const $da6900438f3c4283$var$cardContentClasses = (0, $eLydt.default)("MuiCardContent", [
    "root"
]);
var $da6900438f3c4283$export$2e2bcd8739ae039 = $da6900438f3c4283$var$cardContentClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $ed3d66ecfb561ddb$var$_excluded = [
    "className",
    "component"
];
const $ed3d66ecfb561ddb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $da6900438f3c4283$export$964336739a8c7119), classes);
};
const $ed3d66ecfb561ddb$var$CardContentRoot = (0, $fhlQp.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $ed3d66ecfb561ddb$var$CardContent = /*#__PURE__*/ $2hDQc.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $gZOiq.default)(props, $ed3d66ecfb561ddb$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component
    });
    const classes = $ed3d66ecfb561ddb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($ed3d66ecfb561ddb$var$CardContentRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $ed3d66ecfb561ddb$export$2e2bcd8739ae039 = $ed3d66ecfb561ddb$var$CardContent;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $a69a8d08d38d682d$export$f54c8b0d04b67946(slot) {
    return (0, $01COD.default)("MuiCardHeader", slot);
}
const $a69a8d08d38d682d$var$cardHeaderClasses = (0, $eLydt.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
var $a69a8d08d38d682d$export$2e2bcd8739ae039 = $a69a8d08d38d682d$var$cardHeaderClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $c63165c810a3670b$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $c63165c810a3670b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $a69a8d08d38d682d$export$f54c8b0d04b67946), classes);
};
const $c63165c810a3670b$var$CardHeaderRoot = (0, $fhlQp.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $kxIgO.default)({
            [`& .${(0, $a69a8d08d38d682d$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $a69a8d08d38d682d$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const $c63165c810a3670b$var$CardHeaderAvatar = (0, $fhlQp.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const $c63165c810a3670b$var$CardHeaderAction = (0, $fhlQp.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $c63165c810a3670b$var$CardHeaderContent = (0, $fhlQp.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const $c63165c810a3670b$var$CardHeader = /*#__PURE__*/ $2hDQc.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action: action, avatar: avatar, className: className, component: component = "div", disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $gZOiq.default)(props, $c63165c810a3670b$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $c63165c810a3670b$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $df1a4ec584b17f6d$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $df1a4ec584b17f6d$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $592Nh.jsxs)($c63165c810a3670b$var$CardHeaderRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $592Nh.jsx)($c63165c810a3670b$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)($c63165c810a3670b$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $592Nh.jsx)($c63165c810a3670b$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $c63165c810a3670b$export$2e2bcd8739ae039 = $c63165c810a3670b$var$CardHeader;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");

var $fLRFO = parcelRequire("fLRFO");




var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $8xjDP = parcelRequire("8xjDP");




var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $9067ec1159c7df92$export$5162da8f798e0959(slot) {
    return (0, $01COD.default)("MuiCollapse", slot);
}
const $9067ec1159c7df92$var$collapseClasses = (0, $eLydt.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $9067ec1159c7df92$export$2e2bcd8739ae039 = $9067ec1159c7df92$var$collapseClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $b59e9ad4c427b463$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $b59e9ad4c427b463$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $9067ec1159c7df92$export$5162da8f798e0959), classes);
};
const $b59e9ad4c427b463$var$CollapseRoot = (0, $fhlQp.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $kxIgO.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $b59e9ad4c427b463$var$CollapseWrapper = (0, $fhlQp.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $b59e9ad4c427b463$var$CollapseWrapperInner = (0, $fhlQp.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b59e9ad4c427b463$var$Collapse = /*#__PURE__*/ $2hDQc.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $8xjDP.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f1775b3e9e6fc859$export$2e2bcd8739ae039) } = props, other = (0, $gZOiq.default)(props, $b59e9ad4c427b463$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $b59e9ad4c427b463$var$useUtilityClasses(ownerState);
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const timer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    const wrapperRef = $2hDQc.useRef(null);
    const autoTransitionDuration = $2hDQc.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $2hDQc.useRef(null);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $592Nh.jsx)($b59e9ad4c427b463$var$CollapseRoot, (0, $kxIgO.default)({
                as: component,
                className: (0, $fLRFO.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $kxIgO.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $kxIgO.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $592Nh.jsx)($b59e9ad4c427b463$var$CollapseWrapper, {
                    ownerState: (0, $kxIgO.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)($b59e9ad4c427b463$var$CollapseWrapperInner, {
                        ownerState: (0, $kxIgO.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$b59e9ad4c427b463$var$Collapse.muiSupportAuto = true;
var $b59e9ad4c427b463$export$2e2bcd8739ae039 = $b59e9ad4c427b463$var$Collapse;


var $0b38e67c954daa26$exports = {};
"use strict";
"use client";
var $5a628e0d34cb386c$exports = {};
function $5a628e0d34cb386c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$5a628e0d34cb386c$exports = $5a628e0d34cb386c$var$_interopRequireDefault, $5a628e0d34cb386c$exports.__esModule = true, $5a628e0d34cb386c$exports["default"] = $5a628e0d34cb386c$exports;


Object.defineProperty($0b38e67c954daa26$exports, "__esModule", {
    value: true
});
$0b38e67c954daa26$exports.default = void 0;

var $0b38e67c954daa26$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $0b38e67c954daa26$var$_default = $0b38e67c954daa26$exports.default = (0, $0b38e67c954daa26$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");



var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dfmyc = parcelRequire("dfmyc");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $lfMLv = parcelRequire("lfMLv");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $b76bd2df937754f5$export$5a6f9035944c8119(slot) {
    return (0, $01COD.default)("MuiButton", slot);
}
const $b76bd2df937754f5$var$buttonClasses = (0, $eLydt.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $b76bd2df937754f5$export$2e2bcd8739ae039 = $b76bd2df937754f5$var$buttonClasses;



var $2hDQc = parcelRequire("2hDQc");
/**
 * @ignore - internal component.
 */ const $72fcb995c3911449$var$ButtonGroupContext = /*#__PURE__*/ $2hDQc.createContext({});
var $72fcb995c3911449$export$2e2bcd8739ae039 = $72fcb995c3911449$var$ButtonGroupContext;



var $2hDQc = parcelRequire("2hDQc");
/**
 * @ignore - internal component.
 */ const $fbb1c92d4c480400$var$ButtonGroupButtonContext = /*#__PURE__*/ $2hDQc.createContext(undefined);
var $fbb1c92d4c480400$export$2e2bcd8739ae039 = $fbb1c92d4c480400$var$ButtonGroupButtonContext;



var $592Nh = parcelRequire("592Nh");
"use client";
const $b439b08811d707e1$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $b439b08811d707e1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $lfMLv.default)(color)}`,
            `size${(0, $lfMLv.default)(size)}`,
            `${variant}Size${(0, $lfMLv.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $lfMLv.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $lfMLv.default)(size)}`
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $b76bd2df937754f5$export$5a6f9035944c8119), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $b439b08811d707e1$var$commonIconStyles = (ownerState)=>(0, $kxIgO.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $b439b08811d707e1$var$ButtonRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $lfMLv.default)(ownerState.color)}`],
            styles[`size${(0, $lfMLv.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $lfMLv.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kxIgO.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $kxIgO.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $kxIgO.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $b76bd2df937754f5$export$2e2bcd8739ae039).focusVisible}`]: (0, $kxIgO.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $b76bd2df937754f5$export$2e2bcd8739ae039).disabled}`]: (0, $kxIgO.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $6KAST.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $b76bd2df937754f5$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $b76bd2df937754f5$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $b439b08811d707e1$var$ButtonStartIcon = (0, $fhlQp.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $lfMLv.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $b439b08811d707e1$var$commonIconStyles(ownerState)));
const $b439b08811d707e1$var$ButtonEndIcon = (0, $fhlQp.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $lfMLv.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $b439b08811d707e1$var$commonIconStyles(ownerState)));
const $b439b08811d707e1$var$Button = /*#__PURE__*/ $2hDQc.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $2hDQc.useContext((0, $72fcb995c3911449$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $2hDQc.useContext((0, $fbb1c92d4c480400$export$2e2bcd8739ae039));
    const resolvedProps = (0, $dfmyc.default)(contextProps, inProps);
    const props = (0, $afHYP.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $gZOiq.default)(props, $b439b08811d707e1$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $b439b08811d707e1$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $592Nh.jsx)($b439b08811d707e1$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $592Nh.jsx)($b439b08811d707e1$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $592Nh.jsxs)($b439b08811d707e1$var$ButtonRoot, (0, $kxIgO.default)({
        ownerState: ownerState,
        className: (0, $fLRFO.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fLRFO.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $b439b08811d707e1$export$2e2bcd8739ae039 = $b439b08811d707e1$var$Button;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $3NAKi = parcelRequire("3NAKi");

var $lfMLv = parcelRequire("lfMLv");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $91f632173b8110bd$export$29cad1383b3f235d(slot) {
    return (0, $01COD.default)("MuiCircularProgress", slot);
}
const $91f632173b8110bd$var$circularProgressClasses = (0, $eLydt.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $91f632173b8110bd$export$2e2bcd8739ae039 = $91f632173b8110bd$var$circularProgressClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $24e2cd5750b4780c$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $24e2cd5750b4780c$var$_ = (t)=>t, $24e2cd5750b4780c$var$_t, $24e2cd5750b4780c$var$_t2, $24e2cd5750b4780c$var$_t3, $24e2cd5750b4780c$var$_t4;
const $24e2cd5750b4780c$var$SIZE = 44;
const $24e2cd5750b4780c$var$circularRotateKeyframe = (0, $3NAKi.keyframes)($24e2cd5750b4780c$var$_t || ($24e2cd5750b4780c$var$_t = $24e2cd5750b4780c$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $24e2cd5750b4780c$var$circularDashKeyframe = (0, $3NAKi.keyframes)($24e2cd5750b4780c$var$_t2 || ($24e2cd5750b4780c$var$_t2 = $24e2cd5750b4780c$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $24e2cd5750b4780c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $lfMLv.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $lfMLv.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $91f632173b8110bd$export$29cad1383b3f235d), classes);
};
const $24e2cd5750b4780c$var$CircularProgressRoot = (0, $fhlQp.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $lfMLv.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $3NAKi.css)($24e2cd5750b4780c$var$_t3 || ($24e2cd5750b4780c$var$_t3 = $24e2cd5750b4780c$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $24e2cd5750b4780c$var$circularRotateKeyframe));
const $24e2cd5750b4780c$var$CircularProgressSVG = (0, $fhlQp.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $24e2cd5750b4780c$var$CircularProgressCircle = (0, $fhlQp.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $lfMLv.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $3NAKi.css)($24e2cd5750b4780c$var$_t4 || ($24e2cd5750b4780c$var$_t4 = $24e2cd5750b4780c$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $24e2cd5750b4780c$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $24e2cd5750b4780c$var$CircularProgress = /*#__PURE__*/ $2hDQc.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $gZOiq.default)(props, $24e2cd5750b4780c$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $24e2cd5750b4780c$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($24e2cd5750b4780c$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $592Nh.jsx)($24e2cd5750b4780c$var$CircularProgressRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        style: (0, $kxIgO.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($24e2cd5750b4780c$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$24e2cd5750b4780c$var$SIZE / 2} ${$24e2cd5750b4780c$var$SIZE / 2} ${$24e2cd5750b4780c$var$SIZE} ${$24e2cd5750b4780c$var$SIZE}`,
            children: /*#__PURE__*/ (0, $592Nh.jsx)($24e2cd5750b4780c$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $24e2cd5750b4780c$var$SIZE,
                cy: $24e2cd5750b4780c$var$SIZE,
                r: ($24e2cd5750b4780c$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $24e2cd5750b4780c$export$2e2bcd8739ae039 = $24e2cd5750b4780c$var$CircularProgress;


var $fhlQp = parcelRequire("fhlQp");
parcelRequire("2hDQc");
const $7c79f74a177f653a$var$LinkButton = (0, $fhlQp.default)((0, $b439b08811d707e1$export$2e2bcd8739ae039))({
    textTransform: "none",
    padding: 0,
    minWidth: 0,
    "&:hover": {
        backgroundColor: "transparent" // Disable hover effect
    }
});
const $7c79f74a177f653a$var$MoovyLink = (props)=>{
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($7c79f74a177f653a$var$LinkButton, {
                style: props.style,
                onClick: (event)=>{
                    if (props.onClick) {
                        if (props.disabled || props.loading) event.preventDefault();
                        else props.onClick(event);
                    }
                },
                color: props?.red ? "error" : undefined,
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                    children: props.bold && /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                        children: props.children
                    }) || props.children
                })
            }),
            props.loading && /*#__PURE__*/ (0, $592Nh.jsx)((0, $24e2cd5750b4780c$export$2e2bcd8739ae039), {
                size: "mini"
            })
        ]
    });
};
var $7c79f74a177f653a$export$2e2bcd8739ae039 = $7c79f74a177f653a$var$MoovyLink;


var $eb376bd07f4daa47$exports = {};
"use strict";
"use client";

Object.defineProperty($eb376bd07f4daa47$exports, "__esModule", {
    value: true
});
$eb376bd07f4daa47$exports.default = void 0;

var $eb376bd07f4daa47$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $eb376bd07f4daa47$var$_default = $eb376bd07f4daa47$exports.default = (0, $eb376bd07f4daa47$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVert");




var $iMY5u = parcelRequire("iMY5u");

var $fhlQp = parcelRequire("fhlQp");
const $048939e8d048fac8$var$ExpandMore = (0, $fhlQp.default)((props)=>{
    const { expand: expand, ...other } = props;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
        ...other
    });
})(({ theme: theme, expand: expand })=>({
        transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        })
    }));
const $048939e8d048fac8$var$MoovyCard = (props)=>{
    const [expanded, setExpanded] = (0, $2hDQc.useState)(false);
    const [open, setOpen] = (0, $2hDQc.useState)(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useRef(null);
    const handleToggle = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setOpen((prevOpen)=>!prevOpen);
    };
    const prevOpen = (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useRef(open);
    (0, $2hDQc.useEffect)(()=>{
        if (prevOpen.current === true && open === false) anchorRef.current.focus();
        prevOpen.current = open;
    }, [
        open
    ]);
    const handleExpandClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setExpanded(!expanded);
    };
    const expandList = props.cardExpandContentList;
    const avatarName = props.avatarName || (typeof props.cardTitle === "string" ? props.cardTitle : "");
    const shortAvatarName = (0, $ee9cb80b5c23ac97$export$6d1c4f83343cbd5d)(avatarName);
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $78ce8df72ecef187$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 200
        },
        onClick: (event)=>props.onCardClicked && props.onCardClicked(event),
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $c63165c810a3670b$export$2e2bcd8739ae039), {
                avatar: /*#__PURE__*/ (0, $592Nh.jsx)((0, $560cc98f1d9121b1$export$2e2bcd8739ae039), {
                    sx: {
                        bgcolor: (0, $iMY5u.default)[500]
                    },
                    "aria-label": avatarName,
                    children: shortAvatarName
                }),
                action: props.cardMenuActions ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
                    "aria-label": "settings",
                    ref: anchorRef,
                    "aria-controls": open ? "composition-menu" : undefined,
                    "aria-expanded": open ? "true" : undefined,
                    "aria-haspopup": "true",
                    onClick: handleToggle,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eb376bd07f4daa47$exports))), {})
                }) : undefined,
                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                    style: {
                        textAlign: "left"
                    },
                    children: props.cardTitle
                }),
                subheader: props.cardSecondaryTitle
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $ed3d66ecfb561ddb$export$2e2bcd8739ae039), {
                style: {
                    paddingBottom: props.cardContentList.length > 0 || expandList ? 12 : 0,
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
                    style: {
                        paddingBottom: 0,
                        paddingTop: 0
                    },
                    children: props.cardContentList.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                            secondary: item,
                            style: {
                                wordBreak: "break-all"
                            }
                        }, index))
                })
            }),
            expandList && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $afc8705c82d57607$export$2e2bcd8739ae039), {
                        disableSpacing: true,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)($048939e8d048fac8$var$ExpandMore, {
                            expand: expanded,
                            onClick: handleExpandClick,
                            "aria-expanded": expanded,
                            "aria-label": "show more",
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0b38e67c954daa26$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b59e9ad4c427b463$export$2e2bcd8739ae039), {
                        in: expanded,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $ed3d66ecfb561ddb$export$2e2bcd8739ae039), {
                            style: {
                                paddingBottom: 0,
                                paddingTop: 0
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
                                children: expandList.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                                        secondary: item,
                                        style: {
                                            wordBreak: "break-all"
                                        }
                                    }, index))
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $41509f6a27074b22$export$2e2bcd8739ae039), {
                open: open,
                setOpen: setOpen,
                anchorRef: anchorRef,
                menuItems: props.cardMenuActions
            })
        ]
    }, props.key);
};
var $048939e8d048fac8$export$2e2bcd8739ae039 = $048939e8d048fac8$var$MoovyCard;



var $592Nh = parcelRequire("592Nh");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");



var $lfMLv = parcelRequire("lfMLv");
var $2hDQc = parcelRequire("2hDQc");
"use client";
let $2bc2ec8fa2635683$var$globalId = 0;
function $2bc2ec8fa2635683$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $2hDQc.useState(idOverride);
    const id = idOverride || defaultId;
    $2hDQc.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $2bc2ec8fa2635683$var$globalId += 1;
            setDefaultId(`mui-${$2bc2ec8fa2635683$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $2bc2ec8fa2635683$var$maybeReactUseId = $2hDQc["useId".toString()];
function $2bc2ec8fa2635683$export$2e2bcd8739ae039(idOverride) {
    if ($2bc2ec8fa2635683$var$maybeReactUseId !== undefined) {
        const reactId = $2bc2ec8fa2635683$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $2bc2ec8fa2635683$var$useGlobalId(idOverride);
}


"use client";
var $a92f7cdb3954c0c7$export$2e2bcd8739ae039 = (0, $2bc2ec8fa2635683$export$2e2bcd8739ae039);



var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




var $dfmyc = parcelRequire("dfmyc");

var $01COD = parcelRequire("01COD");

var $eLydt = parcelRequire("eLydt");
function $6b1b8590f0465f6f$export$24fdd7c0683a4fed(slot) {
    return (0, $01COD.default)("MuiLoadingButton", slot);
}
const $6b1b8590f0465f6f$var$loadingButtonClasses = (0, $eLydt.default)("MuiLoadingButton", [
    "root",
    "loading",
    "loadingIndicator",
    "loadingIndicatorCenter",
    "loadingIndicatorStart",
    "loadingIndicatorEnd",
    "endIconLoadingEnd",
    "startIconLoadingStart"
]);
var $6b1b8590f0465f6f$export$2e2bcd8739ae039 = $6b1b8590f0465f6f$var$loadingButtonClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $e34f31da31a377f3$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $e34f31da31a377f3$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            loading && "loading"
        ],
        startIcon: [
            loading && `startIconLoading${(0, $lfMLv.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $lfMLv.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            "loadingIndicator",
            loading && `loadingIndicator${(0, $lfMLv.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $6b1b8590f0465f6f$export$24fdd7c0683a4fed), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $e34f31da31a377f3$var$rootShouldForwardProp = (prop)=>prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as" && prop !== "classes";
const $e34f31da31a377f3$var$LoadingButtonRoot = (0, $fhlQp.default)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>$e34f31da31a377f3$var$rootShouldForwardProp(prop) || prop === "classes",
    name: "MuiLoadingButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        [`& .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === "center" && {
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).loading}`]: {
            color: "transparent"
        }
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        [`& .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        [`& .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $6b1b8590f0465f6f$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $e34f31da31a377f3$var$LoadingButtonLoadingIndicator = (0, $fhlQp.default)("span", {
    name: "MuiLoadingButton",
    slot: "LoadingIndicator",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $lfMLv.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        position: "absolute",
        visibility: "visible",
        display: "flex"
    }, ownerState.loadingPosition === "start" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        left: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "start" && ownerState.variant === "text" && {
        left: 6
    }, ownerState.loadingPosition === "center" && {
        left: "50%",
        transform: "translate(-50%)",
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.loadingPosition === "end" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        right: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "end" && ownerState.variant === "text" && {
        right: 6
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        position: "relative",
        left: -10
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        position: "relative",
        right: -10
    }));
const $e34f31da31a377f3$var$LoadingButton = /*#__PURE__*/ $2hDQc.forwardRef(function LoadingButton(inProps, ref) {
    const contextProps = $2hDQc.useContext((0, $72fcb995c3911449$export$2e2bcd8739ae039));
    const resolvedProps = (0, $dfmyc.default)(contextProps, inProps);
    const props = (0, $afHYP.default)({
        props: resolvedProps,
        name: "MuiLoadingButton"
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = "center", variant: variant = "text" } = props, other = (0, $gZOiq.default)(props, $e34f31da31a377f3$var$_excluded);
    const id = (0, $a92f7cdb3954c0c7$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $592Nh.jsx)((0, $24e2cd5750b4780c$export$2e2bcd8739ae039), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $e34f31da31a377f3$var$useUtilityClasses(ownerState);
    const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/ (0, $592Nh.jsx)($e34f31da31a377f3$var$LoadingButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState: ownerState,
        children: loadingIndicator
    }) : null;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($e34f31da31a377f3$var$LoadingButtonRoot, (0, $kxIgO.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: [
            ownerState.loadingPosition === "end" ? children : loadingButtonLoadingIndicator,
            ownerState.loadingPosition === "end" ? loadingButtonLoadingIndicator : children
        ]
    }));
});
var $e34f31da31a377f3$export$2e2bcd8739ae039 = $e34f31da31a377f3$var$LoadingButton;


parcelRequire("2hDQc");
const $234b0cbb679ba096$var$MoovyButton = (props)=>{
    const { mutation: mutation, query: query, startIcon: startIcon, showAsIconButton: showAsIconButton, ...rest } = props;
    const isLoading = props?.mutation?.isPending || props?.query?.isFetching || props?.query?.isLoading;
    const NormalButton = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e34f31da31a377f3$export$2e2bcd8739ae039), {
            ...rest,
            disabled: isLoading || !!props.disabled,
            loading: isLoading,
            variant: props.variant || "contained",
            children: props?.children
        });
    };
    const IconOnlyButton = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                visibility: rest.hidden ? "hidden" : undefined
            },
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
                    disabled: isLoading || !!props.disabled,
                    ...rest,
                    children: startIcon
                }),
                isLoading && /*#__PURE__*/ (0, $592Nh.jsx)((0, $24e2cd5750b4780c$export$2e2bcd8739ae039), {
                    size: 24,
                    style: {
                        position: "absolute"
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: showAsIconButton ? /*#__PURE__*/ (0, $592Nh.jsx)(IconOnlyButton, {}) : /*#__PURE__*/ (0, $592Nh.jsx)(NormalButton, {})
    });
};
var $234b0cbb679ba096$export$2e2bcd8739ae039 = $234b0cbb679ba096$var$MoovyButton;



var $592Nh = parcelRequire("592Nh");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");



var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");
parcelRequire("2hDQc");


var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");
parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $7024fc64c66c6e5a$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");




var $592Nh = parcelRequire("592Nh");
"use client";
const $5b05ba7b79f41230$var$_excluded = [
    "slots",
    "slotProps"
];
const $5b05ba7b79f41230$var$BreadcrumbCollapsedButton = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $kxIgO.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, $kxIgO.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, $kxIgO.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, $6KAST.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $6KAST.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $5b05ba7b79f41230$var$BreadcrumbCollapsedIcon = (0, $fhlQp.default)((0, $7024fc64c66c6e5a$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $5b05ba7b79f41230$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $gZOiq.default)(props, $5b05ba7b79f41230$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $592Nh.jsx)("li", {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($5b05ba7b79f41230$var$BreadcrumbCollapsedButton, (0, $kxIgO.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $592Nh.jsx)($5b05ba7b79f41230$var$BreadcrumbCollapsedIcon, (0, $kxIgO.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $5b05ba7b79f41230$export$2e2bcd8739ae039 = $5b05ba7b79f41230$var$BreadcrumbCollapsed;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $26a23b624393a45d$export$17261110b18c8084(slot) {
    return (0, $01COD.default)("MuiBreadcrumbs", slot);
}
const $26a23b624393a45d$var$breadcrumbsClasses = (0, $eLydt.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
var $26a23b624393a45d$export$2e2bcd8739ae039 = $26a23b624393a45d$var$breadcrumbsClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $05c0bfdab6b2b091$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $05c0bfdab6b2b091$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $26a23b624393a45d$export$17261110b18c8084), classes);
};
const $05c0bfdab6b2b091$var$BreadcrumbsRoot = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $26a23b624393a45d$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $05c0bfdab6b2b091$var$BreadcrumbsOl = (0, $fhlQp.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const $05c0bfdab6b2b091$var$BreadcrumbsSeparator = (0, $fhlQp.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function $05c0bfdab6b2b091$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $592Nh.jsx)($05c0bfdab6b2b091$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $05c0bfdab6b2b091$var$Breadcrumbs = /*#__PURE__*/ $2hDQc.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children: children, className: className, component: component = "nav", slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = "Show path", itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = "/" } = props, other = (0, $gZOiq.default)(props, $05c0bfdab6b2b091$var$_excluded);
    const [expanded, setExpanded] = $2hDQc.useState(false);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $05c0bfdab6b2b091$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $2hDQc.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5b05ba7b79f41230$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $2hDQc.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $2hDQc.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $592Nh.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $592Nh.jsx)($05c0bfdab6b2b091$var$BreadcrumbsRoot, (0, $kxIgO.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($05c0bfdab6b2b091$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $05c0bfdab6b2b091$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $05c0bfdab6b2b091$export$2e2bcd8739ae039 = $05c0bfdab6b2b091$var$Breadcrumbs;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $lfMLv = parcelRequire("lfMLv");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");




var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $899abeeea35e9df8$export$d6efab9620b78fec(slot) {
    return (0, $01COD.default)("MuiLink", slot);
}
const $899abeeea35e9df8$var$linkClasses = (0, $eLydt.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $899abeeea35e9df8$export$2e2bcd8739ae039 = $899abeeea35e9df8$var$linkClasses;



var $6KAST = parcelRequire("6KAST");
var $85voO = parcelRequire("85voO");
const $d69960df46594ca2$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $d69960df46594ca2$var$transformDeprecatedColors = (color)=>{
    return $d69960df46594ca2$export$c4e140d5d351182b[color] || color;
};
const $d69960df46594ca2$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $d69960df46594ca2$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $85voO.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $85voO.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $6KAST.alpha)(color, 0.4);
};
var $d69960df46594ca2$export$2e2bcd8739ae039 = $d69960df46594ca2$var$getTextDecoration;



var $592Nh = parcelRequire("592Nh");
"use client";
const $75dfa6692b16df0d$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $75dfa6692b16df0d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $lfMLv.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $899abeeea35e9df8$export$d6efab9620b78fec), classes);
};
const $75dfa6692b16df0d$var$LinkRoot = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $lfMLv.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $kxIgO.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $kxIgO.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $d69960df46594ca2$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $899abeeea35e9df8$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $75dfa6692b16df0d$var$Link = /*#__PURE__*/ $2hDQc.forwardRef(function Link(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $gZOiq.default)(props, $75dfa6692b16df0d$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $d9607cff52dbd157$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $2hDQc.useState(false);
    const handlerRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $75dfa6692b16df0d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($75dfa6692b16df0d$var$LinkRoot, (0, $kxIgO.default)({
        color: color,
        className: (0, $fLRFO.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $d69960df46594ca2$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $75dfa6692b16df0d$export$2e2bcd8739ae039 = $75dfa6692b16df0d$var$Link;


parcelRequire("2hDQc");
const $fc04d73f4230d70f$var$MoovyBreadcrumbs = (props)=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const routes = props.customBreadcrumbs || [];
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $05c0bfdab6b2b091$export$2e2bcd8739ae039), {
        maxItems: isMobile ? 2 : undefined,
        "aria-label": "breadcrumb",
        style: {
            marginTop: "10px"
        },
        children: [
            routes.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $75dfa6692b16df0d$export$2e2bcd8739ae039), {
                    underline: "hover",
                    color: "inherit",
                    href: item?.route,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                        children: item?.name
                    })
                }, index)),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
                color: "text.primary",
                children: props.lastBreadcrumb
            })
        ]
    });
};
var $fc04d73f4230d70f$export$2e2bcd8739ae039 = $fc04d73f4230d70f$var$MoovyBreadcrumbs;



var $592Nh = parcelRequire("592Nh");



function $2baeba59fba86da4$export$2e2bcd8739ae039() {
    const dispatch = (0, $ca980beea4c3b32c$export$8ad76b76a4c905f8)();
    const setLocale = (value)=>dispatch((0, $d79f754417ba871e$export$7389484a7f69e71d)(value));
    const locale = (0, $704baa9769160210$export$2105062e25df4afe)((0, $d79f754417ba871e$export$1c46e3decb4a80c2).getLocale);
    return {
        setLocale: setLocale,
        locale: locale
    };
}


const $022472611720380a$var$MoovyDateTime = (props)=>{
    if (!props.utcDateTime) return props?.emptyText || "";
    const { locale: locale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const datetime = (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).fromUTC(props.utcDateTime, locale);
    if (props.dateOnly) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: (0, $4ea31e1953a3d675$export$6c3b6c09c58d6bc3).toString(datetime)
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: (0, $4ea31e1953a3d675$export$59110d836eb073ac).toString(datetime)
    });
};
var $022472611720380a$export$2e2bcd8739ae039 = $022472611720380a$var$MoovyDateTime;



var $592Nh = parcelRequire("592Nh");

const $0ad050a15234ec76$var$MoovyErrorPage = ()=>{
    return /*#__PURE__*/ (0, $592Nh.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("h1", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "moovyErrorPage.oops"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)("p", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "moovyErrorPage.message"
                })
            })
        ]
    });
};
var $0ad050a15234ec76$export$2e2bcd8739ae039 = $0ad050a15234ec76$var$MoovyErrorPage;



var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");
var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
"use client";
const $193f9095d744f7ae$var$usePreviousProps = (value)=>{
    const ref = $2hDQc.useRef({});
    $2hDQc.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $193f9095d744f7ae$export$2e2bcd8739ae039 = $193f9095d744f7ae$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $9ae7ca84beab435a$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $9ae7ca84beab435a$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $9ae7ca84beab435a$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $9ae7ca84beab435a$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $9ae7ca84beab435a$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $9ae7ca84beab435a$var$defaultFilterOptions = $9ae7ca84beab435a$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $9ae7ca84beab435a$var$pageSize = 5;
const $9ae7ca84beab435a$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $9ae7ca84beab435a$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $9ae7ca84beab435a$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $9ae7ca84beab435a$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $2bc2ec8fa2635683$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $2hDQc.useRef(false);
    const firstFocus = $2hDQc.useRef(true);
    const inputRef = $2hDQc.useRef(null);
    const listboxRef = $2hDQc.useRef(null);
    const [anchorEl, setAnchorEl] = $2hDQc.useState(null);
    const [focusedTag, setFocusedTag] = $2hDQc.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $2hDQc.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $e6fa6f6bfcc49892$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $e6fa6f6bfcc49892$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $2hDQc.useState(false);
    const resetInputValue = $2hDQc.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $e6fa6f6bfcc49892$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $2hDQc.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $193f9095d744f7ae$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $2hDQc.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $09890193466d3518$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $2hDQc.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $09890193466d3518$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $09890193466d3518$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $2hDQc.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $9ae7ca84beab435a$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $9ae7ca84beab435a$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $09890193466d3518$export$2e2bcd8739ae039)((node)=>{
        (0, $bf8564c56950a7db$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $2hDQc.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $2hDQc.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $9ae7ca84beab435a$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$9ae7ca84beab435a$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $9ae7ca84beab435a$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $kxIgO.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $kxIgO.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $6KAST = parcelRequire("6KAST");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $941bfbad2cfea088$export$6816d4fc0981ec7(slot) {
    return (0, $01COD.default)("MuiListSubheader", slot);
}
const $941bfbad2cfea088$var$listSubheaderClasses = (0, $eLydt.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $941bfbad2cfea088$export$2e2bcd8739ae039 = $941bfbad2cfea088$var$listSubheaderClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $864c1da0e0cdde54$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $864c1da0e0cdde54$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $lfMLv.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $941bfbad2cfea088$export$6816d4fc0981ec7), classes);
};
const $864c1da0e0cdde54$var$ListSubheaderRoot = (0, $fhlQp.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $lfMLv.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $864c1da0e0cdde54$var$ListSubheader = /*#__PURE__*/ $2hDQc.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $gZOiq.default)(props, $864c1da0e0cdde54$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $864c1da0e0cdde54$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($864c1da0e0cdde54$var$ListSubheaderRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$864c1da0e0cdde54$var$ListSubheader.muiSkipListHighlight = true;
var $864c1da0e0cdde54$export$2e2bcd8739ae039 = $864c1da0e0cdde54$var$ListSubheader;





var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");
parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $6516328eccf84503$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $lfMLv = parcelRequire("lfMLv");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $65d6178ba79ca6ff$export$31444911e4ee6fdd(slot) {
    return (0, $01COD.default)("MuiChip", slot);
}
const $65d6178ba79ca6ff$var$chipClasses = (0, $eLydt.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $65d6178ba79ca6ff$export$2e2bcd8739ae039 = $65d6178ba79ca6ff$var$chipClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $1010c6f3caf374f8$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $1010c6f3caf374f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $lfMLv.default)(size)}`,
            `color${(0, $lfMLv.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $lfMLv.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $lfMLv.default)(color)}`,
            `${variant}${(0, $lfMLv.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $lfMLv.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $lfMLv.default)(size)}`,
            `avatarColor${(0, $lfMLv.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $lfMLv.default)(size)}`,
            `iconColor${(0, $lfMLv.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $lfMLv.default)(size)}`,
            `deleteIconColor${(0, $lfMLv.default)(color)}`,
            `deleteIcon${(0, $lfMLv.default)(variant)}Color${(0, $lfMLv.default)(color)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $65d6178ba79ca6ff$export$31444911e4ee6fdd), classes);
};
const $1010c6f3caf374f8$var$ChipRoot = (0, $fhlQp.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $lfMLv.default)(size)}`]
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $lfMLv.default)(color)}`]
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $lfMLv.default)(size)}`]
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $lfMLv.default)(iconColor)}`]
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $lfMLv.default)(size)}`]
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $lfMLv.default)(color)}`]
            },
            {
                [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $lfMLv.default)(variant)}Color${(0, $lfMLv.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $lfMLv.default)(size)}`],
            styles[`color${(0, $lfMLv.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $lfMLv.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $lfMLv.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $lfMLv.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $kxIgO.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).icon}`]: (0, $kxIgO.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $kxIgO.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: (0, $kxIgO.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $6KAST.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $6KAST.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $6KAST.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $65d6178ba79ca6ff$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $1010c6f3caf374f8$var$ChipLabel = (0, $fhlQp.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $lfMLv.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $1010c6f3caf374f8$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $1010c6f3caf374f8$var$Chip = /*#__PURE__*/ $2hDQc.forwardRef(function Chip(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $gZOiq.default)(props, $1010c6f3caf374f8$var$_excluded);
    const chipRef = $2hDQc.useRef(null);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $1010c6f3caf374f8$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $1010c6f3caf374f8$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $1379cc80d8f1a214$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $2hDQc.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $1010c6f3caf374f8$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $1379cc80d8f1a214$export$2e2bcd8739ae039) ? (0, $kxIgO.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $2hDQc.isValidElement(deleteIconProp) ? /*#__PURE__*/ $2hDQc.cloneElement(deleteIconProp, {
        className: (0, $fLRFO.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $6516328eccf84503$export$2e2bcd8739ae039), {
        className: (0, $fLRFO.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $2hDQc.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $2hDQc.cloneElement(avatarProp, {
        className: (0, $fLRFO.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $2hDQc.isValidElement(iconProp)) icon = /*#__PURE__*/ $2hDQc.cloneElement(iconProp, {
        className: (0, $fLRFO.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)($1010c6f3caf374f8$var$ChipRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $592Nh.jsx)($1010c6f3caf374f8$var$ChipLabel, {
                className: (0, $fLRFO.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $1010c6f3caf374f8$export$2e2bcd8739ae039 = $1010c6f3caf374f8$var$Chip;



var $kxIgO = parcelRequire("kxIgO");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $279ecd4d42a27d11$export$ef57d5c8ca2278f6(slot) {
    return (0, $01COD.default)("MuiInputBase", slot);
}
const $279ecd4d42a27d11$var$inputBaseClasses = (0, $eLydt.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $279ecd4d42a27d11$export$2e2bcd8739ae039 = $279ecd4d42a27d11$var$inputBaseClasses;


function $62f57d1f8902cea6$export$cdb270390122322b(slot) {
    return (0, $01COD.default)("MuiInput", slot);
}
const $62f57d1f8902cea6$var$inputClasses = (0, $kxIgO.default)({}, (0, $279ecd4d42a27d11$export$2e2bcd8739ae039), (0, $eLydt.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $62f57d1f8902cea6$export$2e2bcd8739ae039 = $62f57d1f8902cea6$var$inputClasses;




var $kxIgO = parcelRequire("kxIgO");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");

function $691b7746cbd1d3e8$export$89922944c7227687(slot) {
    return (0, $01COD.default)("MuiOutlinedInput", slot);
}
const $691b7746cbd1d3e8$var$outlinedInputClasses = (0, $kxIgO.default)({}, (0, $279ecd4d42a27d11$export$2e2bcd8739ae039), (0, $eLydt.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $691b7746cbd1d3e8$export$2e2bcd8739ae039 = $691b7746cbd1d3e8$var$outlinedInputClasses;



var $kxIgO = parcelRequire("kxIgO");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");

function $f13fd63238f7a9df$export$3331e419f1a48437(slot) {
    return (0, $01COD.default)("MuiFilledInput", slot);
}
const $f13fd63238f7a9df$var$filledInputClasses = (0, $kxIgO.default)({}, (0, $279ecd4d42a27d11$export$2e2bcd8739ae039), (0, $eLydt.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $f13fd63238f7a9df$export$2e2bcd8739ae039 = $f13fd63238f7a9df$var$filledInputClasses;



parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $bda4913232f1306c$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $335af2b5f4384d2a$export$8ee01529667e66d9(slot) {
    return (0, $01COD.default)("MuiAutocomplete", slot);
}
const $335af2b5f4384d2a$var$autocompleteClasses = (0, $eLydt.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $335af2b5f4384d2a$export$2e2bcd8739ae039 = $335af2b5f4384d2a$var$autocompleteClasses;



var $lfMLv = parcelRequire("lfMLv");


var $592Nh = parcelRequire("592Nh");
"use client";
var $173005e46403214d$var$_ClearIcon, $173005e46403214d$var$_ArrowDropDownIcon;
const $173005e46403214d$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $173005e46403214d$var$_excluded2 = [
    "ref"
], $173005e46403214d$var$_excluded3 = [
    "key"
];
const $173005e46403214d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $lfMLv.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $335af2b5f4384d2a$export$8ee01529667e66d9), classes);
};
const $173005e46403214d$var$AutocompleteRoot = (0, $fhlQp.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $lfMLv.default)(size)}`]
            },
            {
                [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        [`&.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).focused} .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).tag}`]: (0, $kxIgO.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).root}.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).root}`]: {
            padding: 9,
            [`.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).root}.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).root}.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).root}.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).root}.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).hiddenLabel}.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).input}`]: (0, $kxIgO.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $173005e46403214d$var$AutocompleteEndAdornment = (0, $fhlQp.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $173005e46403214d$var$AutocompleteClearIndicator = (0, $fhlQp.default)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $173005e46403214d$var$AutocompletePopupIndicator = (0, $fhlQp.default)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $kxIgO.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $173005e46403214d$var$AutocompletePopper = (0, $fhlQp.default)((0, $4ef6802bb98f4e22$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $173005e46403214d$var$AutocompletePaper = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $kxIgO.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $173005e46403214d$var$AutocompleteLoading = (0, $fhlQp.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $173005e46403214d$var$AutocompleteNoOptions = (0, $fhlQp.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $173005e46403214d$var$AutocompleteListbox = (0, $fhlQp.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $173005e46403214d$var$AutocompleteGroupLabel = (0, $fhlQp.default)((0, $864c1da0e0cdde54$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $173005e46403214d$var$AutocompleteGroupUl = (0, $fhlQp.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $335af2b5f4384d2a$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $173005e46403214d$var$Autocomplete = /*#__PURE__*/ $2hDQc.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $173005e46403214d$var$_ClearIcon || ($173005e46403214d$var$_ClearIcon = /*#__PURE__*/ (0, $592Nh.jsx)((0, $e06505996467b5ce$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $23b78932f8a6daaa$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $4ef6802bb98f4e22$export$2e2bcd8739ae039), popupIcon: popupIcon = $173005e46403214d$var$_ArrowDropDownIcon || ($173005e46403214d$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $592Nh.jsx)((0, $bda4913232f1306c$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $gZOiq.default)(props, $173005e46403214d$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $9ae7ca84beab435a$export$1e40b3ca02d92d21)((0, $kxIgO.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $gZOiq.default)(_getListboxProps, $173005e46403214d$var$_excluded2);
    const combinedListboxRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $kxIgO.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $173005e46403214d$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $kxIgO.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $1010c6f3caf374f8$export$2e2bcd8739ae039), (0, $kxIgO.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $592Nh.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $592Nh.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        const { key: key } = props2, otherProps = (0, $gZOiq.default)(props2, $173005e46403214d$var$_excluded3);
        return /*#__PURE__*/ (0, $592Nh.jsx)("li", (0, $kxIgO.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $kxIgO.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteRoot, (0, $kxIgO.default)({
                ref: ref,
                className: (0, $fLRFO.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $kxIgO.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $592Nh.jsxs)($173005e46403214d$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteClearIndicator, (0, $kxIgO.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $fLRFO.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompletePopupIndicator, (0, $kxIgO.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $fLRFO.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $kxIgO.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompletePopper, (0, $kxIgO.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $fLRFO.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $592Nh.jsxs)($173005e46403214d$var$AutocompletePaper, (0, $kxIgO.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $fLRFO.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $592Nh.jsx)($173005e46403214d$var$AutocompleteListbox, (0, $kxIgO.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $173005e46403214d$export$2e2bcd8739ae039 = $173005e46403214d$var$Autocomplete;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $08acd951c3e86122$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $08acd951c3e86122$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($08acd951c3e86122$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $08acd951c3e86122$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $08acd951c3e86122$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $lfMLv = parcelRequire("lfMLv");

var $2hDQc = parcelRequire("2hDQc");
function $adf804fb5382ba20$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $2hDQc.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $a81f7819c5c3d8dd$export$2e2bcd8739ae039 = (0, $adf804fb5382ba20$export$2e2bcd8739ae039);



var $2hDQc = parcelRequire("2hDQc");
/**
 * @ignore - internal component.
 */ const $e2e023c13a569f7a$var$FormControlContext = /*#__PURE__*/ $2hDQc.createContext(undefined);
var $e2e023c13a569f7a$export$2e2bcd8739ae039 = $e2e023c13a569f7a$var$FormControlContext;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $e0efc9342e8800f5$export$149c8b8bab2289d1(slot) {
    return (0, $01COD.default)("MuiFormControl", slot);
}
const $e0efc9342e8800f5$var$formControlClasses = (0, $eLydt.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $e0efc9342e8800f5$export$2e2bcd8739ae039 = $e0efc9342e8800f5$var$formControlClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $df0187c1973aff1d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $df0187c1973aff1d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $lfMLv.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $e0efc9342e8800f5$export$149c8b8bab2289d1), classes);
};
const $df0187c1973aff1d$var$FormControlRoot = (0, $fhlQp.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kxIgO.default)({}, styles.root, styles[`margin${(0, $lfMLv.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $df0187c1973aff1d$var$FormControl = /*#__PURE__*/ $2hDQc.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $gZOiq.default)(props, $df0187c1973aff1d$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $df0187c1973aff1d$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $2hDQc.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $2hDQc.Children.forEach(children, (child)=>{
            if (!(0, $a81f7819c5c3d8dd$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $a81f7819c5c3d8dd$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $08acd951c3e86122$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $2hDQc.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $2hDQc.Children.forEach(children, (child)=>{
            if (!(0, $a81f7819c5c3d8dd$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $08acd951c3e86122$export$d652b828d7fdeff8)(child.props, true) || (0, $08acd951c3e86122$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $2hDQc.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $2hDQc.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e2e023c13a569f7a$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($df0187c1973aff1d$var$FormControlRoot, (0, $kxIgO.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fLRFO.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $df0187c1973aff1d$export$2e2bcd8739ae039 = $df0187c1973aff1d$var$FormControl;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $2hDQc = parcelRequire("2hDQc");

"use client";
function $d664d4831d5b413a$export$2e2bcd8739ae039() {
    return $2hDQc.useContext((0, $e2e023c13a569f7a$export$2e2bcd8739ae039));
}




var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $lCJj0 = parcelRequire("lCJj0");
var $dJnC1 = parcelRequire("dJnC1");
var $01COD = parcelRequire("01COD");

var $dnmSH = parcelRequire("dnmSH");
const $70775a9528723de3$var$styled = (0, $dnmSH.default)();
var $70775a9528723de3$export$2e2bcd8739ae039 = $70775a9528723de3$var$styled;



var $lEYqa = parcelRequire("lEYqa");


var $l1ZeQ = parcelRequire("l1ZeQ");

var $koNI7 = parcelRequire("koNI7");

var $fDcTc = parcelRequire("fDcTc");

var $592Nh = parcelRequire("592Nh");
const $3eb7ea0930902923$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $3eb7ea0930902923$var$defaultTheme = (0, $l1ZeQ.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $3eb7ea0930902923$var$defaultCreateStyledComponent = (0, $70775a9528723de3$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $3eb7ea0930902923$var$useThemePropsDefault(props) {
    return (0, $lEYqa.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $3eb7ea0930902923$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $3eb7ea0930902923$var$joinChildren(children, separator) {
    const childrenArray = $2hDQc.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $2hDQc.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $3eb7ea0930902923$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $3eb7ea0930902923$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $kxIgO.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $koNI7.handleBreakpoints)({
        theme: theme
    }, (0, $koNI7.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fDcTc.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $koNI7.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $koNI7.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fDcTc.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$3eb7ea0930902923$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fDcTc.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $lCJj0.default)(styles, (0, $koNI7.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $koNI7.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $3eb7ea0930902923$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $3eb7ea0930902923$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $3eb7ea0930902923$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $dJnC1.default)(slots, (slot)=>(0, $01COD.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($3eb7ea0930902923$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $2hDQc.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $5fa628c4a09d9d65$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $gZOiq.default)(props, $3eb7ea0930902923$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $592Nh.jsx)(StackRoot, (0, $kxIgO.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $fLRFO.default)(classes.root, className)
        }, other, {
            children: divider ? $3eb7ea0930902923$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");
"use client";
const $cc2403a042b6d76d$var$Stack = (0, $3eb7ea0930902923$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $fhlQp.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $afHYP.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $cc2403a042b6d76d$export$2e2bcd8739ae039 = $cc2403a042b6d76d$var$Stack;




var $lfMLv = parcelRequire("lfMLv");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $e26fecc7e4986298$export$717666c39ec07e12(slot) {
    return (0, $01COD.default)("MuiFormControlLabel", slot);
}
const $e26fecc7e4986298$var$formControlLabelClasses = (0, $eLydt.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $e26fecc7e4986298$export$2e2bcd8739ae039 = $e26fecc7e4986298$var$formControlLabelClasses;


function $8b06d8a0923886b3$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $592Nh = parcelRequire("592Nh");
"use client";
const $0d47cf95f93fa68a$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $0d47cf95f93fa68a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $lfMLv.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $e26fecc7e4986298$export$717666c39ec07e12), classes);
};
const $0d47cf95f93fa68a$export$1b479270917a5676 = (0, $fhlQp.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e26fecc7e4986298$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $lfMLv.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $e26fecc7e4986298$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $e26fecc7e4986298$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $e26fecc7e4986298$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $0d47cf95f93fa68a$var$AsteriskComponent = (0, $fhlQp.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $e26fecc7e4986298$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $0d47cf95f93fa68a$var$FormControlLabel = /*#__PURE__*/ $2hDQc.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $gZOiq.default)(props, $0d47cf95f93fa68a$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $0d47cf95f93fa68a$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $df1a4ec584b17f6d$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $fLRFO.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $592Nh.jsxs)($0d47cf95f93fa68a$export$1b479270917a5676, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $2hDQc.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $592Nh.jsxs)((0, $cc2403a042b6d76d$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $592Nh.jsxs)($0d47cf95f93fa68a$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $0d47cf95f93fa68a$export$2e2bcd8739ae039 = $0d47cf95f93fa68a$var$FormControlLabel;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");



var $lfMLv = parcelRequire("lfMLv");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $7a345d0be1d2b993$export$f7d501e40371cd17(slot) {
    return (0, $01COD.default)("MuiFormLabel", slot);
}
const $7a345d0be1d2b993$var$formLabelClasses = (0, $eLydt.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $7a345d0be1d2b993$export$2e2bcd8739ae039 = $7a345d0be1d2b993$var$formLabelClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $e4333663acb8b769$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $e4333663acb8b769$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lfMLv.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $7a345d0be1d2b993$export$f7d501e40371cd17), classes);
};
const $e4333663acb8b769$export$aa5bc7f8a4705b27 = (0, $fhlQp.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kxIgO.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $7a345d0be1d2b993$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $7a345d0be1d2b993$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $7a345d0be1d2b993$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $e4333663acb8b769$var$AsteriskComponent = (0, $fhlQp.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $7a345d0be1d2b993$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $e4333663acb8b769$var$FormLabel = /*#__PURE__*/ $2hDQc.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $gZOiq.default)(props, $e4333663acb8b769$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $e4333663acb8b769$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($e4333663acb8b769$export$aa5bc7f8a4705b27, (0, $kxIgO.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $592Nh.jsxs)($e4333663acb8b769$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $e4333663acb8b769$export$2e2bcd8739ae039 = $e4333663acb8b769$var$FormLabel;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $dJnC1 = parcelRequire("dJnC1");

var $fLRFO = parcelRequire("fLRFO");




var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $bf756c575edb223f$export$c1c4b4545ad2ea5f(slot) {
    return (0, $01COD.default)("MuiInputLabel", slot);
}
const $bf756c575edb223f$var$inputLabelClasses = (0, $eLydt.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $bf756c575edb223f$export$2e2bcd8739ae039 = $bf756c575edb223f$var$inputLabelClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $c66893090d56545d$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $c66893090d56545d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $lfMLv.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $bf756c575edb223f$export$c1c4b4545ad2ea5f), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $c66893090d56545d$var$InputLabelRoot = (0, $fhlQp.default)((0, $e4333663acb8b769$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7a345d0be1d2b993$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $kxIgO.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $kxIgO.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $kxIgO.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $c66893090d56545d$var$InputLabel = /*#__PURE__*/ $2hDQc.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $afHYP.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $gZOiq.default)(props, $c66893090d56545d$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $c66893090d56545d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($c66893090d56545d$var$InputLabelRoot, (0, $kxIgO.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $fLRFO.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $c66893090d56545d$export$2e2bcd8739ae039 = $c66893090d56545d$var$InputLabel;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $lfMLv = parcelRequire("lfMLv");

var $fhlQp = parcelRequire("fhlQp");

"use client";
var $ff224becc5bb5771$export$2e2bcd8739ae039 = (0, $e6fa6f6bfcc49892$export$2e2bcd8739ae039);





var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $e1b188221c3ede15$export$baa0faa0c7ad8085(slot) {
    return (0, $01COD.default)("PrivateSwitchBase", slot);
}
const $e1b188221c3ede15$var$switchBaseClasses = (0, $eLydt.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $e1b188221c3ede15$export$2e2bcd8739ae039 = $e1b188221c3ede15$var$switchBaseClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $67b1c1d795b89349$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $67b1c1d795b89349$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $lfMLv.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $e1b188221c3ede15$export$baa0faa0c7ad8085), classes);
};
const $67b1c1d795b89349$var$SwitchBaseRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $67b1c1d795b89349$var$SwitchBaseInput = (0, $fhlQp.default)("input", {
    shouldForwardProp: (0, $fhlQp.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $67b1c1d795b89349$var$SwitchBase = /*#__PURE__*/ $2hDQc.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $gZOiq.default)(props, $67b1c1d795b89349$var$_excluded);
    const [checked, setCheckedState] = (0, $ff224becc5bb5771$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $kxIgO.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $67b1c1d795b89349$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($67b1c1d795b89349$var$SwitchBaseRoot, (0, $kxIgO.default)({
        component: "span",
        className: (0, $fLRFO.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($67b1c1d795b89349$var$SwitchBaseInput, (0, $kxIgO.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $67b1c1d795b89349$export$2e2bcd8739ae039 = $67b1c1d795b89349$var$SwitchBase;



var $afHYP = parcelRequire("afHYP");

var $kxIgO = parcelRequire("kxIgO");
parcelRequire("2hDQc");

parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $07931596ab2cd080$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $eca1cd2c16aaf0d5$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $93c06a394628cef5$var$RadioButtonIconRoot = (0, $fhlQp.default)("span", {
    shouldForwardProp: (0, $fhlQp.rootShouldForwardProp)
})({
    position: "relative",
    display: "flex"
});
const $93c06a394628cef5$var$RadioButtonIconBackground = (0, $fhlQp.default)((0, $07931596ab2cd080$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $93c06a394628cef5$var$RadioButtonIconDot = (0, $fhlQp.default)((0, $eca1cd2c16aaf0d5$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $93c06a394628cef5$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $kxIgO.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)($93c06a394628cef5$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($93c06a394628cef5$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)($93c06a394628cef5$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $93c06a394628cef5$export$2e2bcd8739ae039 = $93c06a394628cef5$var$RadioButtonIcon;



var $lfMLv = parcelRequire("lfMLv");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $70332ac9d4d9e127$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $5c4372a6d09c095c$export$2e2bcd8739ae039 = (0, $70332ac9d4d9e127$export$2e2bcd8739ae039);



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
/**
 * @ignore - internal component.
 */ const $7ca226911a2aa89c$var$RadioGroupContext = /*#__PURE__*/ $2hDQc.createContext(undefined);
var $7ca226911a2aa89c$export$2e2bcd8739ae039 = $7ca226911a2aa89c$var$RadioGroupContext;


"use client";
function $8e27e89450fd9c1c$export$2e2bcd8739ae039() {
    return $2hDQc.useContext((0, $7ca226911a2aa89c$export$2e2bcd8739ae039));
}



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $0b2f1d6dbf5a43c6$export$192f7b2363c77155(slot) {
    return (0, $01COD.default)("MuiRadio", slot);
}
const $0b2f1d6dbf5a43c6$var$radioClasses = (0, $eLydt.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $0b2f1d6dbf5a43c6$export$2e2bcd8739ae039 = $0b2f1d6dbf5a43c6$var$radioClasses;



var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $b716fe5ce517ca5d$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $b716fe5ce517ca5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lfMLv.default)(color)}`,
            size !== "medium" && `size${(0, $lfMLv.default)(size)}`
        ]
    };
    return (0, $kxIgO.default)({}, classes, (0, $dJnC1.default)(slots, (0, $0b2f1d6dbf5a43c6$export$192f7b2363c77155), classes));
};
const $b716fe5ce517ca5d$var$RadioRoot = (0, $fhlQp.default)((0, $67b1c1d795b89349$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $lfMLv.default)(ownerState.size)}`],
            styles[`color${(0, $lfMLv.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $0b2f1d6dbf5a43c6$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $0b2f1d6dbf5a43c6$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $b716fe5ce517ca5d$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $b716fe5ce517ca5d$var$defaultCheckedIcon = /*#__PURE__*/ (0, $592Nh.jsx)((0, $93c06a394628cef5$export$2e2bcd8739ae039), {
    checked: true
});
const $b716fe5ce517ca5d$var$defaultIcon = /*#__PURE__*/ (0, $592Nh.jsx)((0, $93c06a394628cef5$export$2e2bcd8739ae039), {});
const $b716fe5ce517ca5d$var$Radio = /*#__PURE__*/ $2hDQc.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $b716fe5ce517ca5d$var$defaultCheckedIcon, color: color = "primary", icon: icon = $b716fe5ce517ca5d$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $gZOiq.default)(props, $b716fe5ce517ca5d$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $b716fe5ce517ca5d$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $8e27e89450fd9c1c$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $5c4372a6d09c095c$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $b716fe5ce517ca5d$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $592Nh.jsx)($b716fe5ce517ca5d$var$RadioRoot, (0, $kxIgO.default)({
        type: "radio",
        icon: /*#__PURE__*/ $2hDQc.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $b716fe5ce517ca5d$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $2hDQc.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $b716fe5ce517ca5d$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $fLRFO.default)(classes.root, className)
    }, other));
});
var $b716fe5ce517ca5d$export$2e2bcd8739ae039 = $b716fe5ce517ca5d$var$Radio;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $lCJj0 = parcelRequire("lCJj0");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $e79HO = parcelRequire("e79HO");

var $2hDQc = parcelRequire("2hDQc");



var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");



var $lfMLv = parcelRequire("lfMLv");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");



var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");




var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $dc140d5d1bfc2562$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $9edf6df80e9bc497$export$2e2bcd8739ae039 = (0, $dc140d5d1bfc2562$export$2e2bcd8739ae039);




function $d147d5c8f4c3f267$export$2e2bcd8739ae039(node) {
    const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $9bc586e64615ae98$export$2e2bcd8739ae039 = (0, $d147d5c8f4c3f267$export$2e2bcd8739ae039);





var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");



var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");



// Is a vertical scrollbar displayed?
function $f463854baff8461b$var$isOverflowing(container) {
    const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $d147d5c8f4c3f267$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $f463854baff8461b$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $f463854baff8461b$var$getPaddingRight(element) {
    return parseInt((0, $d147d5c8f4c3f267$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $f463854baff8461b$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $f463854baff8461b$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$f463854baff8461b$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $f463854baff8461b$export$e1bd0c6150f13d96(element, show);
    });
}
function $f463854baff8461b$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $f463854baff8461b$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($f463854baff8461b$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7ed4db476b689edd$export$2e2bcd8739ae039)((0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$f463854baff8461b$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$f463854baff8461b$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $d147d5c8f4c3f267$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $f463854baff8461b$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $f463854baff8461b$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $f463854baff8461b$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $f463854baff8461b$var$getHiddenSiblings(container);
        $f463854baff8461b$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $f463854baff8461b$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $f463854baff8461b$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $f463854baff8461b$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $f463854baff8461b$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $f463854baff8461b$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $f463854baff8461b$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $f463854baff8461b$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $f13573b5e75d5096$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $f13573b5e75d5096$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f13573b5e75d5096$var$defaultManager = new (0, $f463854baff8461b$export$ce11c4ecd08cea67)();
function $f13573b5e75d5096$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f13573b5e75d5096$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $2hDQc.useRef({});
    const mountNodeRef = $2hDQc.useRef(null);
    const modalRef = $2hDQc.useRef(null);
    const handleRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $2hDQc.useState(!open);
    const hasTransition = $f13573b5e75d5096$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $09890193466d3518$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $f13573b5e75d5096$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $2hDQc.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $09890193466d3518$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $f463854baff8461b$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $2hDQc.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $2hDQc.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $2hDQc.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $b3f8ec5af2a54766$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $kxIgO.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kxIgO.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $kxIgO.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $70332ac9d4d9e127$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $70332ac9d4d9e127$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $dJnC1 = parcelRequire("dJnC1");

var $2hDQc = parcelRequire("2hDQc");



var $592Nh = parcelRequire("592Nh");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $fc4f877660d5a3c1$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $fc4f877660d5a3c1$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $fc4f877660d5a3c1$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $fc4f877660d5a3c1$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $fc4f877660d5a3c1$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $fc4f877660d5a3c1$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($fc4f877660d5a3c1$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $fc4f877660d5a3c1$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$fc4f877660d5a3c1$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $fc4f877660d5a3c1$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $fc4f877660d5a3c1$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $fc4f877660d5a3c1$var$defaultGetTabbable, isEnabled: isEnabled = $fc4f877660d5a3c1$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $2hDQc.useRef(false);
    const sentinelStart = $2hDQc.useRef(null);
    const sentinelEnd = $2hDQc.useRef(null);
    const nodeToRestore = $2hDQc.useRef(null);
    const reactFocusEventTarget = $2hDQc.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $2hDQc.useRef(false);
    const rootRef = $2hDQc.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $2hDQc.useRef(null);
    $2hDQc.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $2hDQc.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $2hDQc.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $cb0bc60fb82b84a3$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $2hDQc.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}




var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");







var $592Nh = parcelRequire("592Nh");
"use client";
const $12215051e1caa84a$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $12215051e1caa84a$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $12215051e1caa84a$var$Fade = /*#__PURE__*/ $2hDQc.forwardRef(function Fade(props, ref) {
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f1775b3e9e6fc859$export$2e2bcd8739ae039) } = props, other = (0, $gZOiq.default)(props, $12215051e1caa84a$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $2hDQc.useRef(null);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1aa5c4f4ecb43caa$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $2hDQc.cloneElement(children, (0, $kxIgO.default)({
                style: (0, $kxIgO.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $12215051e1caa84a$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $12215051e1caa84a$export$2e2bcd8739ae039 = $12215051e1caa84a$var$Fade;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $5bc23bc015f41397$export$9927a91fd93152bd(slot) {
    return (0, $01COD.default)("MuiBackdrop", slot);
}
const $5bc23bc015f41397$var$backdropClasses = (0, $eLydt.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $5bc23bc015f41397$export$2e2bcd8739ae039 = $5bc23bc015f41397$var$backdropClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $4674b63572c4d684$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4674b63572c4d684$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $5bc23bc015f41397$export$9927a91fd93152bd), classes);
};
const $4674b63572c4d684$var$BackdropRoot = (0, $fhlQp.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $4674b63572c4d684$var$Backdrop = /*#__PURE__*/ $2hDQc.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $12215051e1caa84a$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $gZOiq.default)(props, $4674b63572c4d684$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4674b63572c4d684$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($4674b63572c4d684$var$BackdropRoot, (0, $kxIgO.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $fLRFO.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kxIgO.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4674b63572c4d684$export$2e2bcd8739ae039 = $4674b63572c4d684$var$Backdrop;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $e32fa98c81d2f6e2$export$67960e22b12a638d(slot) {
    return (0, $01COD.default)("MuiModal", slot);
}
const $e32fa98c81d2f6e2$var$modalClasses = (0, $eLydt.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $e32fa98c81d2f6e2$export$2e2bcd8739ae039 = $e32fa98c81d2f6e2$var$modalClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $fecdaeba05e13765$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $fecdaeba05e13765$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $e32fa98c81d2f6e2$export$67960e22b12a638d), classes);
};
const $fecdaeba05e13765$var$ModalRoot = (0, $fhlQp.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $fecdaeba05e13765$var$ModalBackdrop = (0, $fhlQp.default)((0, $4674b63572c4d684$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $fecdaeba05e13765$var$Modal = /*#__PURE__*/ $2hDQc.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $afHYP.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $fecdaeba05e13765$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $gZOiq.default)(props, $fecdaeba05e13765$var$_excluded);
    const propsWithDefaults = (0, $kxIgO.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $f13573b5e75d5096$export$33ffd74ebf07f060)((0, $kxIgO.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $kxIgO.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $fecdaeba05e13765$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $fecdaeba05e13765$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $fLRFO.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $kxIgO.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $fLRFO.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $7443ce9ff05e49c4$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)(RootSlot, (0, $kxIgO.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $592Nh.jsx)(BackdropSlot, (0, $kxIgO.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $fc4f877660d5a3c1$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $2hDQc.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $fecdaeba05e13765$export$2e2bcd8739ae039 = $fecdaeba05e13765$var$Modal;




var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $ced67f6137cc7e86$export$88f455dd56c95edb(slot) {
    return (0, $01COD.default)("MuiPopover", slot);
}
const $ced67f6137cc7e86$var$popoverClasses = (0, $eLydt.default)("MuiPopover", [
    "root",
    "paper"
]);
var $ced67f6137cc7e86$export$2e2bcd8739ae039 = $ced67f6137cc7e86$var$popoverClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $977877ac810bb112$var$_excluded = [
    "onEntering"
], $977877ac810bb112$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $977877ac810bb112$var$_excluded3 = [
    "slotProps"
];
function $977877ac810bb112$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $977877ac810bb112$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $977877ac810bb112$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $977877ac810bb112$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $977877ac810bb112$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $ced67f6137cc7e86$export$88f455dd56c95edb), classes);
};
const $977877ac810bb112$export$bcce13685275fc99 = (0, $fhlQp.default)((0, $fecdaeba05e13765$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $977877ac810bb112$export$821346c38a2d9390 = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $977877ac810bb112$var$Popover = /*#__PURE__*/ $2hDQc.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $7206ceb21be884d5$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $gZOiq.default)(props.TransitionProps, $977877ac810bb112$var$_excluded), other = (0, $gZOiq.default)(props, $977877ac810bb112$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $2hDQc.useRef();
    const handlePaperRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kxIgO.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $977877ac810bb112$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $2hDQc.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $977877ac810bb112$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $8be63c98f6bdf56e$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $977877ac810bb112$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $977877ac810bb112$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $2hDQc.useCallback((elemRect)=>{
        return {
            vertical: $977877ac810bb112$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $977877ac810bb112$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $2hDQc.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $977877ac810bb112$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9bc586e64615ae98$export$2e2bcd8739ae039)($977877ac810bb112$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $977877ac810bb112$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $2hDQc.useState(open);
    const setPositioningStyles = $2hDQc.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $2hDQc.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $2hDQc.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $2hDQc.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $2hDQc.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $9edf6df80e9bc497$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9bc586e64615ae98$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $8be63c98f6bdf56e$export$2e2bcd8739ae039)($977877ac810bb112$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $977877ac810bb112$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $977877ac810bb112$export$821346c38a2d9390;
    const paperProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kxIgO.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kxIgO.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $gZOiq.default)(_useSlotProps, $977877ac810bb112$var$_excluded3);
    return /*#__PURE__*/ (0, $592Nh.jsx)(RootSlot, (0, $kxIgO.default)({}, rootProps, !(0, $1ade516e245d7339$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $592Nh.jsx)(PaperSlot, (0, $kxIgO.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $977877ac810bb112$export$2e2bcd8739ae039 = $977877ac810bb112$var$Popover;



var $fhlQp = parcelRequire("fhlQp");


var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $60fcaed85c4919ff$export$2cf86a63a84fe23d(slot) {
    return (0, $01COD.default)("MuiMenu", slot);
}
const $60fcaed85c4919ff$var$menuClasses = (0, $eLydt.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $60fcaed85c4919ff$export$2e2bcd8739ae039 = $60fcaed85c4919ff$var$menuClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $655e6265c42a9c6c$var$_excluded = [
    "onEntering"
], $655e6265c42a9c6c$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $655e6265c42a9c6c$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $655e6265c42a9c6c$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $655e6265c42a9c6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $60fcaed85c4919ff$export$2cf86a63a84fe23d), classes);
};
const $655e6265c42a9c6c$var$MenuRoot = (0, $fhlQp.default)((0, $977877ac810bb112$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $655e6265c42a9c6c$export$4f7c51a5920c9f33 = (0, $fhlQp.default)((0, $977877ac810bb112$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $655e6265c42a9c6c$var$MenuMenuList = (0, $fhlQp.default)((0, $908e39c61e238c21$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $655e6265c42a9c6c$var$Menu = /*#__PURE__*/ $2hDQc.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $gZOiq.default)(props.TransitionProps, $655e6265c42a9c6c$var$_excluded), other = (0, $gZOiq.default)(props, $655e6265c42a9c6c$var$_excluded2);
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $kxIgO.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $655e6265c42a9c6c$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $2hDQc.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $2hDQc.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $2hDQc.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $655e6265c42a9c6c$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($655e6265c42a9c6c$var$MenuRoot, (0, $kxIgO.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $655e6265c42a9c6c$var$RTL_ORIGIN : $655e6265c42a9c6c$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kxIgO.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($655e6265c42a9c6c$var$MenuMenuList, (0, $kxIgO.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $fLRFO.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $655e6265c42a9c6c$export$2e2bcd8739ae039 = $655e6265c42a9c6c$var$Menu;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $lfMLv = parcelRequire("lfMLv");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $951e6e0ea2986048$export$1ee13051fd9e2ab5(slot) {
    return (0, $01COD.default)("MuiNativeSelect", slot);
}
const $951e6e0ea2986048$var$nativeSelectClasses = (0, $eLydt.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $951e6e0ea2986048$export$2e2bcd8739ae039 = $951e6e0ea2986048$var$nativeSelectClasses;



var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $4dcd720a54f64386$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $4dcd720a54f64386$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $lfMLv.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $951e6e0ea2986048$export$1ee13051fd9e2ab5), classes);
};
const $4dcd720a54f64386$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $kxIgO.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $951e6e0ea2986048$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $4dcd720a54f64386$var$NativeSelectSelect = (0, $fhlQp.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $fhlQp.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $951e6e0ea2986048$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($4dcd720a54f64386$export$c1eccd1617458c87);
const $4dcd720a54f64386$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $951e6e0ea2986048$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $4dcd720a54f64386$var$NativeSelectIcon = (0, $fhlQp.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $lfMLv.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($4dcd720a54f64386$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $4dcd720a54f64386$var$NativeSelectInput = /*#__PURE__*/ $2hDQc.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $gZOiq.default)(props, $4dcd720a54f64386$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $4dcd720a54f64386$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($4dcd720a54f64386$var$NativeSelectSelect, (0, $kxIgO.default)({
                ownerState: ownerState,
                className: (0, $fLRFO.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $592Nh.jsx)($4dcd720a54f64386$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $4dcd720a54f64386$export$2e2bcd8739ae039 = $4dcd720a54f64386$var$NativeSelectInput;




var $fhlQp = parcelRequire("fhlQp");



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $bd7f06ac4b539350$export$2c0c1ee5a3392e(slot) {
    return (0, $01COD.default)("MuiSelect", slot);
}
const $bd7f06ac4b539350$var$selectClasses = (0, $eLydt.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $bd7f06ac4b539350$export$2e2bcd8739ae039 = $bd7f06ac4b539350$var$selectClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
var $78714f72613dc803$var$_span;
const $78714f72613dc803$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $78714f72613dc803$var$SelectSelect = (0, $fhlQp.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bd7f06ac4b539350$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $bd7f06ac4b539350$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bd7f06ac4b539350$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $bd7f06ac4b539350$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $4dcd720a54f64386$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $bd7f06ac4b539350$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $78714f72613dc803$var$SelectIcon = (0, $fhlQp.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $lfMLv.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $4dcd720a54f64386$export$e7a817afd12a40d0));
const $78714f72613dc803$var$SelectNativeInput = (0, $fhlQp.default)("input", {
    shouldForwardProp: (prop)=>(0, $fhlQp.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $78714f72613dc803$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $78714f72613dc803$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $78714f72613dc803$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $lfMLv.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $bd7f06ac4b539350$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $78714f72613dc803$var$SelectInput = /*#__PURE__*/ $2hDQc.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $gZOiq.default)(props, $78714f72613dc803$var$_excluded);
    const [value, setValueState] = (0, $ff224becc5bb5771$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $ff224becc5bb5771$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $2hDQc.useRef(null);
    const displayRef = $2hDQc.useRef(null);
    const [displayNode, setDisplayNode] = $2hDQc.useState(null);
    const { current: isOpenControlled } = $2hDQc.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $2hDQc.useState();
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $2hDQc.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $2hDQc.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $2hDQc.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $2hDQc.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $2hDQc.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8be63c98f6bdf56e$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $2hDQc.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $08acd951c3e86122$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $2hDQc.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $e79HO.default)(2));
            selected = value.some((v)=>$78714f72613dc803$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $78714f72613dc803$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $2hDQc.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kxIgO.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $78714f72613dc803$var$useUtilityClasses(ownerState);
    const paperProps = (0, $kxIgO.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $2bc2ec8fa2635683$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($78714f72613dc803$var$SelectSelect, (0, $kxIgO.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $fLRFO.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $78714f72613dc803$var$isEmpty(display) ? $78714f72613dc803$var$_span || ($78714f72613dc803$var$_span = /*#__PURE__*/ (0, $592Nh.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $592Nh.jsx)($78714f72613dc803$var$SelectNativeInput, (0, $kxIgO.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $592Nh.jsx)($78714f72613dc803$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $655e6265c42a9c6c$export$2e2bcd8739ae039), (0, $kxIgO.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $kxIgO.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $kxIgO.default)({}, MenuProps.slotProps, {
                    paper: (0, $kxIgO.default)({}, paperProps, {
                        style: (0, $kxIgO.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $78714f72613dc803$export$2e2bcd8739ae039 = $78714f72613dc803$var$SelectInput;






var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $dJnC1 = parcelRequire("dJnC1");

var $lCJj0 = parcelRequire("lCJj0");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $e79HO = parcelRequire("e79HO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");




var $592Nh = parcelRequire("592Nh");
"use client";
const $5d086ad2856156f2$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $5d086ad2856156f2$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $5d086ad2856156f2$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $5d086ad2856156f2$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $5d086ad2856156f2$export$d1710922ecaf577a = /*#__PURE__*/ $2hDQc.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $gZOiq.default)(props, $5d086ad2856156f2$var$_excluded);
    const { current: isControlled } = $2hDQc.useRef(value != null);
    const inputRef = $2hDQc.useRef(null);
    const handleRef = (0, $b737a795d4422d4b$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $2hDQc.useRef(null);
    const renders = $2hDQc.useRef(0);
    const [state, setState] = $2hDQc.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $2hDQc.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $d147d5c8f4c3f267$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $5d086ad2856156f2$var$getStyleValue(computedStyle.paddingBottom) + $5d086ad2856156f2$var$getStyleValue(computedStyle.paddingTop);
        const border = $5d086ad2856156f2$var$getStyleValue(computedStyle.borderBottomWidth) + $5d086ad2856156f2$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $2hDQc.useCallback(()=>{
        const newState = getUpdatedState();
        if ($5d086ad2856156f2$var$isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if ($5d086ad2856156f2$var$isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            $b36a61f25d8b4314$exports.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $dc140d5d1bfc2562$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $d147d5c8f4c3f267$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, $126d93cc939ed77e$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $2hDQc.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("textarea", (0, $kxIgO.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $kxIgO.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $592Nh.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $kxIgO.default)({}, $5d086ad2856156f2$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


var $dJnC1 = parcelRequire("dJnC1");




var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");



var $kxIgO = parcelRequire("kxIgO");
parcelRequire("2hDQc");

parcelRequire("2hDQc");


var $gfsZE = parcelRequire("gfsZE");

var $cQwLz = parcelRequire("cQwLz");

var $592Nh = parcelRequire("592Nh");
"use client";
function $1eca475d75ee190b$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $cQwLz.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $gfsZE.default), {
        styles: globalStyles
    });
}
var $1eca475d75ee190b$export$2e2bcd8739ae039 = $1eca475d75ee190b$var$GlobalStyles;



var $7D60m = parcelRequire("7D60m");

var $3apk9 = parcelRequire("3apk9");

var $592Nh = parcelRequire("592Nh");
"use client";
function $1cc3ee8eb12d8b92$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $1eca475d75ee190b$export$2e2bcd8739ae039), (0, $kxIgO.default)({}, props, {
        defaultTheme: (0, $7D60m.default),
        themeId: (0, $3apk9.default)
    }));
}
var $1cc3ee8eb12d8b92$export$2e2bcd8739ae039 = $1cc3ee8eb12d8b92$var$GlobalStyles;





var $592Nh = parcelRequire("592Nh");
"use client";
const $320d2aeab47c5577$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $320d2aeab47c5577$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $lfMLv.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $320d2aeab47c5577$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $320d2aeab47c5577$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lfMLv.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $lfMLv.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $279ecd4d42a27d11$export$ef57d5c8ca2278f6), classes);
};
const $320d2aeab47c5577$export$298a043133d72a38 = (0, $fhlQp.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $320d2aeab47c5577$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $kxIgO.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $320d2aeab47c5577$export$a1ad29c901026019 = (0, $fhlQp.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $320d2aeab47c5577$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $kxIgO.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kxIgO.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $279ecd4d42a27d11$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $320d2aeab47c5577$var$inputGlobalStyles = /*#__PURE__*/ (0, $592Nh.jsx)((0, $1cc3ee8eb12d8b92$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $320d2aeab47c5577$var$InputBase = /*#__PURE__*/ $2hDQc.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $gZOiq.default)(props, $320d2aeab47c5577$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $2hDQc.useRef(value != null);
    const inputRef = $2hDQc.useRef();
    const handleInputRefWarning = $2hDQc.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $2hDQc.useState(false);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $2hDQc.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $2hDQc.useCallback((obj)=>{
        if ((0, $08acd951c3e86122$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $e79HO.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $2hDQc.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $kxIgO.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kxIgO.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $5d086ad2856156f2$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $2hDQc.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $320d2aeab47c5577$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $320d2aeab47c5577$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $320d2aeab47c5577$export$a1ad29c901026019;
    inputProps = (0, $kxIgO.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $320d2aeab47c5577$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $592Nh.jsxs)(Root, (0, $kxIgO.default)({}, rootProps, !(0, $1ade516e245d7339$export$e28348cc2430497)(Root) && {
                ownerState: (0, $kxIgO.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $fLRFO.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e2e023c13a569f7a$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)(Input, (0, $kxIgO.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $1ade516e245d7339$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kxIgO.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $fLRFO.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kxIgO.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $320d2aeab47c5577$export$2e2bcd8739ae039 = $320d2aeab47c5577$var$InputBase;



var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");



var $592Nh = parcelRequire("592Nh");
"use client";
const $e179988b5ef0260b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e179988b5ef0260b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $62f57d1f8902cea6$export$cdb270390122322b), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $e179988b5ef0260b$var$InputRoot = (0, $fhlQp.default)((0, $320d2aeab47c5577$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $320d2aeab47c5577$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kxIgO.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).disabled}, .${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $62f57d1f8902cea6$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $e179988b5ef0260b$var$InputInput = (0, $fhlQp.default)((0, $320d2aeab47c5577$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $320d2aeab47c5577$export$cf507b112810e72d)
})({});
const $e179988b5ef0260b$var$Input = /*#__PURE__*/ $2hDQc.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $gZOiq.default)(props, $e179988b5ef0260b$var$_excluded);
    const classes = $e179988b5ef0260b$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $lCJj0.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e179988b5ef0260b$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e179988b5ef0260b$var$InputInput;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $320d2aeab47c5577$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e179988b5ef0260b$var$Input.muiName = "Input";
var $e179988b5ef0260b$export$2e2bcd8739ae039 = $e179988b5ef0260b$var$Input;




var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");

var $lCJj0 = parcelRequire("lCJj0");


var $dJnC1 = parcelRequire("dJnC1");


var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");



var $592Nh = parcelRequire("592Nh");
"use client";
const $e3132144e8079e72$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e3132144e8079e72$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $f13fd63238f7a9df$export$3331e419f1a48437), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $e3132144e8079e72$var$FilledInputRoot = (0, $fhlQp.default)((0, $320d2aeab47c5577$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $320d2aeab47c5577$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $kxIgO.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).disabled}, .${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $f13fd63238f7a9df$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kxIgO.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $e3132144e8079e72$var$FilledInputInput = (0, $fhlQp.default)((0, $320d2aeab47c5577$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $320d2aeab47c5577$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $e3132144e8079e72$var$FilledInput = /*#__PURE__*/ $2hDQc.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $gZOiq.default)(props, $e3132144e8079e72$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $e3132144e8079e72$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $lCJj0.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e3132144e8079e72$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e3132144e8079e72$var$FilledInputInput;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $320d2aeab47c5577$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e3132144e8079e72$var$FilledInput.muiName = "Input";
var $e3132144e8079e72$export$2e2bcd8739ae039 = $e3132144e8079e72$var$FilledInput;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");



var $dJnC1 = parcelRequire("dJnC1");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");
parcelRequire("2hDQc");


var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
var $8d08bf2de7060ec0$var$_span;
const $8d08bf2de7060ec0$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $8d08bf2de7060ec0$var$NotchedOutlineRoot = (0, $fhlQp.default)("fieldset", {
    shouldForwardProp: (0, $fhlQp.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $8d08bf2de7060ec0$var$NotchedOutlineLegend = (0, $fhlQp.default)("legend", {
    shouldForwardProp: (0, $fhlQp.rootShouldForwardProp)
})(({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kxIgO.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $8d08bf2de7060ec0$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $gZOiq.default)(props, $8d08bf2de7060ec0$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $kxIgO.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($8d08bf2de7060ec0$var$NotchedOutlineRoot, (0, $kxIgO.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($8d08bf2de7060ec0$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $592Nh.jsx)("span", {
                children: label
            }) : $8d08bf2de7060ec0$var$_span || ($8d08bf2de7060ec0$var$_span = /*#__PURE__*/ (0, $592Nh.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $fhlQp = parcelRequire("fhlQp");



var $afHYP = parcelRequire("afHYP");

var $592Nh = parcelRequire("592Nh");
"use client";
const $2476118dd0009aaa$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $2476118dd0009aaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $691b7746cbd1d3e8$export$89922944c7227687), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $2476118dd0009aaa$var$OutlinedInputRoot = (0, $fhlQp.default)((0, $320d2aeab47c5577$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $320d2aeab47c5577$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $kxIgO.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).focused} .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).error} .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).disabled} .${(0, $691b7746cbd1d3e8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kxIgO.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $2476118dd0009aaa$var$NotchedOutlineRoot = (0, $fhlQp.default)((0, $8d08bf2de7060ec0$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $2476118dd0009aaa$var$OutlinedInputInput = (0, $fhlQp.default)((0, $320d2aeab47c5577$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $320d2aeab47c5577$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $2476118dd0009aaa$var$OutlinedInput = /*#__PURE__*/ $2hDQc.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $gZOiq.default)(props, $2476118dd0009aaa$var$_excluded);
    const classes = $2476118dd0009aaa$var$useUtilityClasses(props);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $2476118dd0009aaa$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $2476118dd0009aaa$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $320d2aeab47c5577$export$2e2bcd8739ae039), (0, $kxIgO.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $592Nh.jsx)($2476118dd0009aaa$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kxIgO.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$2476118dd0009aaa$var$OutlinedInput.muiName = "Input";
var $2476118dd0009aaa$export$2e2bcd8739ae039 = $2476118dd0009aaa$var$OutlinedInput;



var $afHYP = parcelRequire("afHYP");


var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $fea672baf31d9c16$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $fea672baf31d9c16$var$_excluded2 = [
    "root"
];
const $fea672baf31d9c16$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $fea672baf31d9c16$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $fea672baf31d9c16$var$StyledInput = (0, $fhlQp.default)((0, $e179988b5ef0260b$export$2e2bcd8739ae039), $fea672baf31d9c16$var$styledRootConfig)("");
const $fea672baf31d9c16$var$StyledOutlinedInput = (0, $fhlQp.default)((0, $2476118dd0009aaa$export$2e2bcd8739ae039), $fea672baf31d9c16$var$styledRootConfig)("");
const $fea672baf31d9c16$var$StyledFilledInput = (0, $fhlQp.default)((0, $e3132144e8079e72$export$2e2bcd8739ae039), $fea672baf31d9c16$var$styledRootConfig)("");
const $fea672baf31d9c16$var$Select = /*#__PURE__*/ $2hDQc.forwardRef(function Select(inProps, ref) {
    const props = (0, $afHYP.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $bda4913232f1306c$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $gZOiq.default)(props, $fea672baf31d9c16$var$_excluded);
    const inputComponent = native ? (0, $4dcd720a54f64386$export$2e2bcd8739ae039) : (0, $78714f72613dc803$export$2e2bcd8739ae039);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kxIgO.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $fea672baf31d9c16$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $gZOiq.default)(classes, $fea672baf31d9c16$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $592Nh.jsx)($fea672baf31d9c16$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $592Nh.jsx)($fea672baf31d9c16$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $592Nh.jsx)($fea672baf31d9c16$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
        children: /*#__PURE__*/ $2hDQc.cloneElement(InputComponent, (0, $kxIgO.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kxIgO.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kxIgO.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $lCJj0.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $fLRFO.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$fea672baf31d9c16$var$Select.muiName = "Select";
var $fea672baf31d9c16$export$2e2bcd8739ae039 = $fea672baf31d9c16$var$Select;


var $fhlQp = parcelRequire("fhlQp");
var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $lfMLv = parcelRequire("lfMLv");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $761dde84f808bba4$export$39f6debbec19b3ba(slot) {
    return (0, $01COD.default)("MuiSwitch", slot);
}
const $761dde84f808bba4$var$switchClasses = (0, $eLydt.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $761dde84f808bba4$export$2e2bcd8739ae039 = $761dde84f808bba4$var$switchClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $6af5f58e1468d2cf$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $6af5f58e1468d2cf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $lfMLv.default)(edge)}`,
            `size${(0, $lfMLv.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $lfMLv.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $761dde84f808bba4$export$39f6debbec19b3ba), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $6af5f58e1468d2cf$var$SwitchRoot = (0, $fhlQp.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $lfMLv.default)(ownerState.edge)}`],
            styles[`size${(0, $lfMLv.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $6af5f58e1468d2cf$var$SwitchSwitchBase = (0, $fhlQp.default)((0, $67b1c1d795b89349$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $lfMLv.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).checked} + .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).disabled} + .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $6KAST.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $6KAST.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $761dde84f808bba4$export$2e2bcd8739ae039).checked} + .${(0, $761dde84f808bba4$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $6af5f58e1468d2cf$var$SwitchTrack = (0, $fhlQp.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $6af5f58e1468d2cf$var$SwitchThumb = (0, $fhlQp.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $6af5f58e1468d2cf$var$Switch = /*#__PURE__*/ $2hDQc.forwardRef(function Switch(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $gZOiq.default)(props, $6af5f58e1468d2cf$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $6af5f58e1468d2cf$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $592Nh.jsx)($6af5f58e1468d2cf$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)($6af5f58e1468d2cf$var$SwitchRoot, {
        className: (0, $fLRFO.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)($6af5f58e1468d2cf$var$SwitchSwitchBase, (0, $kxIgO.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $kxIgO.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $592Nh.jsx)($6af5f58e1468d2cf$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $6af5f58e1468d2cf$export$2e2bcd8739ae039 = $6af5f58e1468d2cf$var$Switch;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");






var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");



var $fhlQp = parcelRequire("fhlQp");

var $lfMLv = parcelRequire("lfMLv");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $36299ae2d17dc673$export$a394fa61b1d583a9(slot) {
    return (0, $01COD.default)("MuiFormHelperText", slot);
}
const $36299ae2d17dc673$var$formHelperTextClasses = (0, $eLydt.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $36299ae2d17dc673$export$2e2bcd8739ae039 = $36299ae2d17dc673$var$formHelperTextClasses;



var $afHYP = parcelRequire("afHYP");

var $592Nh = parcelRequire("592Nh");
"use client";
var $ed8956e03f59bb6e$var$_span;
const $ed8956e03f59bb6e$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $ed8956e03f59bb6e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $lfMLv.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $36299ae2d17dc673$export$a394fa61b1d583a9), classes);
};
const $ed8956e03f59bb6e$var$FormHelperTextRoot = (0, $fhlQp.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $lfMLv.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $36299ae2d17dc673$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $36299ae2d17dc673$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $ed8956e03f59bb6e$var$FormHelperText = /*#__PURE__*/ $2hDQc.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $gZOiq.default)(props, $ed8956e03f59bb6e$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $ed8956e03f59bb6e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($ed8956e03f59bb6e$var$FormHelperTextRoot, (0, $kxIgO.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $ed8956e03f59bb6e$var$_span || ($ed8956e03f59bb6e$var$_span = /*#__PURE__*/ (0, $592Nh.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $ed8956e03f59bb6e$export$2e2bcd8739ae039 = $ed8956e03f59bb6e$var$FormHelperText;




var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $ce3055e497c6e184$export$c1bdcbaf0596aeda(slot) {
    return (0, $01COD.default)("MuiTextField", slot);
}
const $ce3055e497c6e184$var$textFieldClasses = (0, $eLydt.default)("MuiTextField", [
    "root"
]);
var $ce3055e497c6e184$export$2e2bcd8739ae039 = $ce3055e497c6e184$var$textFieldClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $ea4b9cb15628748b$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $ea4b9cb15628748b$var$variantComponent = {
    standard: (0, $e179988b5ef0260b$export$2e2bcd8739ae039),
    filled: (0, $e3132144e8079e72$export$2e2bcd8739ae039),
    outlined: (0, $2476118dd0009aaa$export$2e2bcd8739ae039)
};
const $ea4b9cb15628748b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $ce3055e497c6e184$export$c1bdcbaf0596aeda), classes);
};
const $ea4b9cb15628748b$var$TextFieldRoot = (0, $fhlQp.default)((0, $df0187c1973aff1d$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $ea4b9cb15628748b$var$TextField = /*#__PURE__*/ $2hDQc.forwardRef(function TextField(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $gZOiq.default)(props, $ea4b9cb15628748b$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $ea4b9cb15628748b$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $2bc2ec8fa2635683$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $ea4b9cb15628748b$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $592Nh.jsx)(InputComponent, (0, $kxIgO.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $592Nh.jsxs)($ea4b9cb15628748b$var$TextFieldRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $592Nh.jsx)((0, $c66893090d56545d$export$2e2bcd8739ae039), (0, $kxIgO.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $fea672baf31d9c16$export$2e2bcd8739ae039), (0, $kxIgO.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $592Nh.jsx)((0, $ed8956e03f59bb6e$export$2e2bcd8739ae039), (0, $kxIgO.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $ea4b9cb15628748b$export$2e2bcd8739ae039 = $ea4b9cb15628748b$var$TextField;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");


var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");








var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $4788027c7f652b64$export$837848f5f6cee923(slot) {
    return (0, $01COD.default)("MuiTooltip", slot);
}
const $4788027c7f652b64$var$tooltipClasses = (0, $eLydt.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $4788027c7f652b64$export$2e2bcd8739ae039 = $4788027c7f652b64$var$tooltipClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $f1471c74f5c30504$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $f1471c74f5c30504$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $f1471c74f5c30504$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $lfMLv.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $4788027c7f652b64$export$837848f5f6cee923), classes);
};
const $f1471c74f5c30504$var$TooltipPopper = (0, $fhlQp.default)((0, $4ef6802bb98f4e22$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $kxIgO.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $4788027c7f652b64$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $4788027c7f652b64$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $4788027c7f652b64$export$2e2bcd8739ae039).arrow}`]: (0, $kxIgO.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $4788027c7f652b64$export$2e2bcd8739ae039).arrow}`]: (0, $kxIgO.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $f1471c74f5c30504$var$TooltipTooltip = (0, $fhlQp.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $lfMLv.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $6KAST.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$f1471c74f5c30504$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $4788027c7f652b64$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $kxIgO.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $kxIgO.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $kxIgO.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $4788027c7f652b64$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $kxIgO.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $kxIgO.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $kxIgO.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $4788027c7f652b64$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $kxIgO.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $4788027c7f652b64$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $kxIgO.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $f1471c74f5c30504$var$TooltipArrow = (0, $fhlQp.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $6KAST.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $f1471c74f5c30504$var$hystersisOpen = false;
const $f1471c74f5c30504$var$hystersisTimer = new (0, $15f15456097d008b$export$786b4da70f00938b)();
let $f1471c74f5c30504$var$cursorPosition = {
    x: 0,
    y: 0
};
function $f1471c74f5c30504$export$b9ee5a7ace0541f8() {
    $f1471c74f5c30504$var$hystersisOpen = false;
    $f1471c74f5c30504$var$hystersisTimer.clear();
}
function $f1471c74f5c30504$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $f1471c74f5c30504$var$Tooltip = /*#__PURE__*/ $2hDQc.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $7206ceb21be884d5$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $gZOiq.default)(props, $f1471c74f5c30504$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $2hDQc.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $592Nh.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $2hDQc.useState();
    const [arrowRef, setArrowRef] = $2hDQc.useState(null);
    const ignoreNonTouchEvents = $2hDQc.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    const enterTimer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    const touchTimer = (0, $15f15456097d008b$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $ff224becc5bb5771$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $a92f7cdb3954c0c7$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $2hDQc.useRef();
    const stopTouchInteraction = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $2hDQc.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $f1471c74f5c30504$var$hystersisTimer.clear();
        $f1471c74f5c30504$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $f1471c74f5c30504$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $f1471c74f5c30504$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $f1471c74f5c30504$var$hystersisOpen && enterNextDelay) enterTimer.start($f1471c74f5c30504$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $d9607cff52dbd157$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $2hDQc.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $2hDQc.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $2hDQc.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $f1471c74f5c30504$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $kxIgO.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $fLRFO.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $f1471c74f5c30504$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $f1471c74f5c30504$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $f1471c74f5c30504$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $f1471c74f5c30504$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $2hDQc.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $kxIgO.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $f1471c74f5c30504$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $f1471c74f5c30504$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $7206ceb21be884d5$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $f1471c74f5c30504$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $f1471c74f5c30504$var$TooltipArrow;
    const popperProps = (0, $c5c2ae979df9b048$export$b089efb01a7bdf50)(PopperComponent, (0, $kxIgO.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $fLRFO.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $c5c2ae979df9b048$export$b089efb01a7bdf50)(TransitionComponent, (0, $kxIgO.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $c5c2ae979df9b048$export$b089efb01a7bdf50)(TooltipComponent, (0, $kxIgO.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $fLRFO.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $c5c2ae979df9b048$export$b089efb01a7bdf50)(ArrowComponent, (0, $kxIgO.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $fLRFO.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ $2hDQc.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $592Nh.jsx)(PopperComponent, (0, $kxIgO.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $4ef6802bb98f4e22$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $f1471c74f5c30504$var$cursorPosition.y,
                            left: $f1471c74f5c30504$var$cursorPosition.x,
                            right: $f1471c74f5c30504$var$cursorPosition.x,
                            bottom: $f1471c74f5c30504$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)(TooltipComponent, (0, $kxIgO.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $592Nh.jsx)(ArrowComponent, (0, $kxIgO.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $f1471c74f5c30504$export$2e2bcd8739ae039 = $f1471c74f5c30504$var$Tooltip;



var $2hDQc = parcelRequire("2hDQc");
var $3b59f2c00dc8bed5$exports = {};
"use strict";
"use client";

Object.defineProperty($3b59f2c00dc8bed5$exports, "__esModule", {
    value: true
});
$3b59f2c00dc8bed5$exports.default = void 0;

var $3b59f2c00dc8bed5$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $3b59f2c00dc8bed5$var$_default = $3b59f2c00dc8bed5$exports.default = (0, $3b59f2c00dc8bed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2V7h2z"
}), "InfoRounded");



const $b8b9780b21c9795b$var$FormContainer = (props)=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $df0187c1973aff1d$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            mb: 1,
            mt: 1,
            gap: 2,
            children: props.children
        })
    });
};
const $b8b9780b21c9795b$var$StyledTextField = (0, $fhlQp.default)((0, $ea4b9cb15628748b$export$2e2bcd8739ae039))(({ error: error, theme: theme })=>({
        color: error ? theme.palette.error.main : "inherit"
    }));
const $b8b9780b21c9795b$var$FormTextField = ({ errorText: errorText, ...textFieldProps })=>{
    let inputProps = undefined;
    if (textFieldProps?.inputProps) inputProps = textFieldProps.inputProps?.maxLength ? textFieldProps.inputProps : {
        ...textFieldProps.inputProps,
        maxLength: (0, $066f7ec5b64309d3$export$85ea93c7f196b8c3).INPUT_MAX_CHARS
    };
    else inputProps = {
        maxLength: (0, $066f7ec5b64309d3$export$85ea93c7f196b8c3).INPUT_MAX_CHARS
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)($b8b9780b21c9795b$var$StyledTextField, {
        ...textFieldProps,
        inputProps: inputProps,
        helperText: errorText ? errorText : "",
        sx: {
            flex: 1
        }
    });
};
const $b8b9780b21c9795b$var$FormAutoCompleteTextField = (props)=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $173005e46403214d$export$2e2bcd8739ae039), {
        ...props
    });
};
const $b8b9780b21c9795b$var$FormRadio = (props)=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $0d47cf95f93fa68a$export$2e2bcd8739ae039), {
        ...props,
        control: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b716fe5ce517ca5d$export$2e2bcd8739ae039), {})
    });
};
const $b8b9780b21c9795b$var$FormLabel = (props)=>{
    const [tooltipOpen, setTooltipOpen] = (0, $2hDQc.useState)(false);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e4333663acb8b769$export$2e2bcd8739ae039), {
        ...props,
        children: props.info ? /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                    children: props.children
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $f1471c74f5c30504$export$2e2bcd8739ae039), {
                    title: props.info,
                    open: tooltipOpen,
                    onClose: ()=>setTooltipOpen(false),
                    onClick: ()=>setTooltipOpen(true),
                    placement: "top",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
                        onMouseEnter: ()=>setTooltipOpen(true),
                        onMouseLeave: ()=>setTooltipOpen(false),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b59f2c00dc8bed5$exports))), {})
                    })
                })
            ]
        }) : props.children
    });
};
const $b8b9780b21c9795b$var$FormSwitch = (props)=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $0d47cf95f93fa68a$export$2e2bcd8739ae039), {
        label: props.label,
        control: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6af5f58e1468d2cf$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
const $b8b9780b21c9795b$var$FormBoxRow = (props)=>{
    const { children: children, gap: gap, flexDirection: flexDirection } = props;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        display: "flex",
        gap: gap ? gap : 2,
        flex: 1,
        flexDirection: flexDirection ? {
            xs: "column",
            md: "row"
        } : undefined,
        children: children
    });
};
const $b8b9780b21c9795b$var$FormSelect = (props)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $df0187c1973aff1d$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $c66893090d56545d$export$2e2bcd8739ae039), {
                id: rest.labelId,
                children: rest.label
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $fea672baf31d9c16$export$2e2bcd8739ae039), {
                ...rest,
                children: children
            })
        ]
    });
};
const $b8b9780b21c9795b$var$FormTitle = (props)=>/*#__PURE__*/ (0, $592Nh.jsx)($b8b9780b21c9795b$var$FormBoxRow, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)("h4", {
            style: {
                margin: 0
            },
            children: props.title
        })
    });
var $b8b9780b21c9795b$export$2e2bcd8739ae039 = {
    FormAutoCompleteTextField: $b8b9780b21c9795b$var$FormAutoCompleteTextField,
    FormTextField: $b8b9780b21c9795b$var$FormTextField,
    FormContainer: $b8b9780b21c9795b$var$FormContainer,
    FormRadio: $b8b9780b21c9795b$var$FormRadio,
    FormSwitch: $b8b9780b21c9795b$var$FormSwitch,
    FormLabel: $b8b9780b21c9795b$var$FormLabel,
    FormBoxRow: $b8b9780b21c9795b$var$FormBoxRow,
    FormSelect: $b8b9780b21c9795b$var$FormSelect,
    FormTitle: $b8b9780b21c9795b$var$FormTitle
};



var $592Nh = parcelRequire("592Nh");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $cgn0z = parcelRequire("cgn0z");
var $dJnC1 = parcelRequire("dJnC1");
var $01COD = parcelRequire("01COD");

var $lEYqa = parcelRequire("lEYqa");


var $l1ZeQ = parcelRequire("l1ZeQ");

var $592Nh = parcelRequire("592Nh");
const $545ea2f5d60c1e77$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $545ea2f5d60c1e77$var$defaultTheme = (0, $l1ZeQ.default)();
const $545ea2f5d60c1e77$var$defaultCreateStyledComponent = (0, $70775a9528723de3$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $cgn0z.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $545ea2f5d60c1e77$var$useThemePropsDefault = (inProps)=>(0, $lEYqa.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $545ea2f5d60c1e77$var$defaultTheme
    });
const $545ea2f5d60c1e77$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $01COD.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $cgn0z.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $dJnC1.default)(slots, getContainerUtilityClass, classes);
};
function $545ea2f5d60c1e77$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $545ea2f5d60c1e77$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $545ea2f5d60c1e77$var$useThemePropsDefault, componentName: componentName = "MuiContainer" } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $2hDQc.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $gZOiq.default)(props, $545ea2f5d60c1e77$var$_excluded);
        const ownerState = (0, $kxIgO.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $545ea2f5d60c1e77$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $592Nh.jsx)(ContainerRoot, (0, $kxIgO.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fLRFO.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $lfMLv = parcelRequire("lfMLv");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");
"use client";
const $2b9be4f525f9526f$var$Container = (0, $545ea2f5d60c1e77$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $fhlQp.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $lfMLv.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $afHYP.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $2b9be4f525f9526f$export$2e2bcd8739ae039 = $2b9be4f525f9526f$var$Container;


var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");

const $7b7bd7a94688db70$var$MoovyRestricted = ({ action: action, resource: resource, visibility: visibility = true, children: children })=>{
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: isPermission(action, resource) && visibility && children
    });
};
var $7b7bd7a94688db70$export$2e2bcd8739ae039 = $7b7bd7a94688db70$var$MoovyRestricted;


const $3a3b2ea64f1e763a$var$MoovyContainerContent = ({ action: action, resource: resource, children: children })=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: action && resource ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
            action: action,
            resource: resource,
            children: children
        }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
            children: children
        })
    });
};
var $3a3b2ea64f1e763a$export$2e2bcd8739ae039 = $3a3b2ea64f1e763a$var$MoovyContainerContent;



var $592Nh = parcelRequire("592Nh");

parcelRequire("2hDQc");
const $73a8034909278da5$var$MoovyContainerHeader = ({ breadcrumbs: breadcrumbs, children: children })=>{
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            breadcrumbs && /*#__PURE__*/ (0, $592Nh.jsx)((0, $fc04d73f4230d70f$export$2e2bcd8739ae039), {
                lastBreadcrumb: breadcrumbs?.lastBreadcrumb,
                customBreadcrumbs: breadcrumbs?.customBreadcrumbs
            }),
            children
        ]
    });
};
var $73a8034909278da5$export$2e2bcd8739ae039 = $73a8034909278da5$var$MoovyContainerHeader;



var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $592Nh = parcelRequire("592Nh");
"use client";
const $b79f77af355b16a9$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $b79f77af355b16a9$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $9a07995a2f6453fd$export$46f01d01378ec5a2), classes);
};
const $b79f77af355b16a9$var$DividerRoot = (0, $fhlQp.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $6KAST.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $b79f77af355b16a9$var$DividerWrapper = (0, $fhlQp.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $b79f77af355b16a9$var$Divider = /*#__PURE__*/ $2hDQc.forwardRef(function Divider(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $gZOiq.default)(props, $b79f77af355b16a9$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $b79f77af355b16a9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($b79f77af355b16a9$var$DividerRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $592Nh.jsx)($b79f77af355b16a9$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $b79f77af355b16a9$var$Divider.muiSkipListHighlight = true;
var $b79f77af355b16a9$export$2e2bcd8739ae039 = $b79f77af355b16a9$var$Divider;



parcelRequire("2hDQc");
const $e83de8e31a85810a$var$MoovyContainerSubHeader = ({ action: action, resource: resource, title: title, description: description, button: button, divider: divider, props: props, titleProps: titleProps })=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const Render = ()=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    alignItems: "center",
                    p: 2,
                    ...props,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        container: true,
                        item: true,
                        xs: 12,
                        direction: "row",
                        alignItems: description ? "flex-end" : "center",
                        gap: isMobile && description ? 1 : 0,
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                item: true,
                                xs: description ? 12 : 8,
                                md: 8,
                                ...titleProps,
                                children: /*#__PURE__*/ (0, $592Nh.jsx)("h3", {
                                    style: {
                                        padding: 0,
                                        margin: 0,
                                        lineHeight: "120%"
                                    },
                                    children: title
                                })
                            }),
                            description && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 8,
                                children: description
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                item: true,
                                md: 4,
                                xs: description ? 12 : 4,
                                display: "flex",
                                container: true,
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                                    children: button
                                })
                            })
                        ]
                    })
                }),
                divider && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    pb: 2,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {})
                })
            ]
        });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: action && resource ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
            action: action,
            resource: resource,
            children: /*#__PURE__*/ (0, $592Nh.jsx)(Render, {})
        }) : /*#__PURE__*/ (0, $592Nh.jsx)(Render, {})
    });
};
var $e83de8e31a85810a$export$2e2bcd8739ae039 = $e83de8e31a85810a$var$MoovyContainerSubHeader;




var $2hDQc = parcelRequire("2hDQc");
const $0e37363bdf6cc6d4$var$MoovyHeader = ({ breadcrumbsVisible: breadcrumbsVisible, children: children })=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: children && /*#__PURE__*/ (0, $592Nh.jsx)("h1", {
            style: {
                marginTop: breadcrumbsVisible ? "0" : undefined
            },
            children: children
        })
    });
};
const $0e37363bdf6cc6d4$var$MoovySubHeader = ({ children: children })=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: children
    });
};
const $0e37363bdf6cc6d4$var$MoovyContent = ({ query: query, children: children })=>{
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: [
            query && query.error && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    pl: 2,
                    pr: 2,
                    pb: 2,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                        query: query,
                        errorTitleKey: "common.actions.get.error"
                    })
                })
            }),
            children && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    pl: 2,
                    pr: 2,
                    pb: 2,
                    children: children
                })
            })
        ]
    });
};
const $0e37363bdf6cc6d4$var$MoovyContainer = ({ loading: loading, children: children })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Children.toArray(children).some((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).isValidElement(child) && child.type !== (0, $73a8034909278da5$export$2e2bcd8739ae039) && child.type !== (0, $e83de8e31a85810a$export$2e2bcd8739ae039) && child.type !== (0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039) && child.type !== (0, $7b7bd7a94688db70$export$2e2bcd8739ae039))) throw new Error("MoovyContainer contains invalid components. They must be MoovyContainerHeader, MoovyContainerSubHeader or MoovyContainerContent.");
    const getContent = (source, target)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Children.toArray(source).find((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).isValidElement(child) && child.type === target);
    };
    const header = getContent(children, (0, $73a8034909278da5$export$2e2bcd8739ae039));
    const subHeader = getContent(children, (0, $e83de8e31a85810a$export$2e2bcd8739ae039));
    const content = getContent(children, (0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039));
    const breadcrumbsVisible = !!header?.props.breadcrumbs;
    const StyledPaper = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039))({
        boxShadow: "6px 6px 54px 0px rgba(0, 0, 0, 0.05)"
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        },
        children: loading ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {
            sx: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        }) : /*#__PURE__*/ (0, $592Nh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)($0e37363bdf6cc6d4$var$MoovyHeader, {
                    breadcrumbsVisible: breadcrumbsVisible,
                    children: header
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $2b9be4f525f9526f$export$2e2bcd8739ae039), {
                    style: {
                        padding: 0
                    },
                    component: StyledPaper,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)($0e37363bdf6cc6d4$var$MoovySubHeader, {
                                children: subHeader
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)($0e37363bdf6cc6d4$var$MoovyContent, {
                                children: content
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $0e37363bdf6cc6d4$export$2e2bcd8739ae039 = $0e37363bdf6cc6d4$var$MoovyContainer;






var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $lfMLv = parcelRequire("lfMLv");




var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $2fc2b6d0cfc82752$export$2177af0aa15c34c2(slot) {
    return (0, $01COD.default)("MuiDialog", slot);
}
const $2fc2b6d0cfc82752$var$dialogClasses = (0, $eLydt.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $2fc2b6d0cfc82752$export$2e2bcd8739ae039 = $2fc2b6d0cfc82752$var$dialogClasses;



var $2hDQc = parcelRequire("2hDQc");
const $a8f72e610fd3caf5$var$DialogContext = /*#__PURE__*/ $2hDQc.createContext({});
var $a8f72e610fd3caf5$export$2e2bcd8739ae039 = $a8f72e610fd3caf5$var$DialogContext;





var $592Nh = parcelRequire("592Nh");
"use client";
const $8df7cb0c72533ff7$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $8df7cb0c72533ff7$var$DialogBackdrop = (0, $fhlQp.default)((0, $4674b63572c4d684$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $8df7cb0c72533ff7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $lfMLv.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $lfMLv.default)(scroll)}`,
            `paperWidth${(0, $lfMLv.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $2fc2b6d0cfc82752$export$2177af0aa15c34c2), classes);
};
const $8df7cb0c72533ff7$var$DialogRoot = (0, $fhlQp.default)((0, $fecdaeba05e13765$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $8df7cb0c72533ff7$var$DialogContainer = (0, $fhlQp.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $lfMLv.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $8df7cb0c72533ff7$var$DialogPaper = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $lfMLv.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $lfMLv.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $2fc2b6d0cfc82752$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $2fc2b6d0cfc82752$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $2fc2b6d0cfc82752$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $8df7cb0c72533ff7$var$Dialog = /*#__PURE__*/ $2hDQc.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $23b78932f8a6daaa$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $12215051e1caa84a$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $gZOiq.default)(props, $8df7cb0c72533ff7$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $8df7cb0c72533ff7$var$useUtilityClasses(ownerState);
    const backdropClick = $2hDQc.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $2bc2ec8fa2635683$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $2hDQc.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)($8df7cb0c72533ff7$var$DialogRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $8df7cb0c72533ff7$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kxIgO.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $592Nh.jsx)($8df7cb0c72533ff7$var$DialogContainer, {
                className: (0, $fLRFO.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $592Nh.jsx)($8df7cb0c72533ff7$var$DialogPaper, (0, $kxIgO.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $fLRFO.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8f72e610fd3caf5$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $8df7cb0c72533ff7$export$2e2bcd8739ae039 = $8df7cb0c72533ff7$var$Dialog;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $fe72fba456321a43$export$5e57a444791c63be(slot) {
    return (0, $01COD.default)("MuiDialogActions", slot);
}
const $fe72fba456321a43$var$dialogActionsClasses = (0, $eLydt.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $fe72fba456321a43$export$2e2bcd8739ae039 = $fe72fba456321a43$var$dialogActionsClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $034e58a90bc1a7b5$var$_excluded = [
    "className",
    "disableSpacing"
];
const $034e58a90bc1a7b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $fe72fba456321a43$export$5e57a444791c63be), classes);
};
const $034e58a90bc1a7b5$var$DialogActionsRoot = (0, $fhlQp.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $034e58a90bc1a7b5$var$DialogActions = /*#__PURE__*/ $2hDQc.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $gZOiq.default)(props, $034e58a90bc1a7b5$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $034e58a90bc1a7b5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($034e58a90bc1a7b5$var$DialogActionsRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $034e58a90bc1a7b5$export$2e2bcd8739ae039 = $034e58a90bc1a7b5$var$DialogActions;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $7a1ebc58e4a0b6fd$export$61b0ee1f05fb344e(slot) {
    return (0, $01COD.default)("MuiDialogContent", slot);
}
const $7a1ebc58e4a0b6fd$var$dialogContentClasses = (0, $eLydt.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $7a1ebc58e4a0b6fd$export$2e2bcd8739ae039 = $7a1ebc58e4a0b6fd$var$dialogContentClasses;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $8244831acb86610d$export$f5d2ec7e4c47e088(slot) {
    return (0, $01COD.default)("MuiDialogTitle", slot);
}
const $8244831acb86610d$var$dialogTitleClasses = (0, $eLydt.default)("MuiDialogTitle", [
    "root"
]);
var $8244831acb86610d$export$2e2bcd8739ae039 = $8244831acb86610d$var$dialogTitleClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $27d8040194495028$var$_excluded = [
    "className",
    "dividers"
];
const $27d8040194495028$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $7a1ebc58e4a0b6fd$export$61b0ee1f05fb344e), classes);
};
const $27d8040194495028$var$DialogContentRoot = (0, $fhlQp.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $8244831acb86610d$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $27d8040194495028$var$DialogContent = /*#__PURE__*/ $2hDQc.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $gZOiq.default)(props, $27d8040194495028$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        dividers: dividers
    });
    const classes = $27d8040194495028$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($27d8040194495028$var$DialogContentRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $27d8040194495028$export$2e2bcd8739ae039 = $27d8040194495028$var$DialogContent;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");



var $592Nh = parcelRequire("592Nh");
"use client";
const $ff715749ff2cf905$var$_excluded = [
    "className",
    "id"
];
const $ff715749ff2cf905$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $8244831acb86610d$export$f5d2ec7e4c47e088), classes);
};
const $ff715749ff2cf905$var$DialogTitleRoot = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $ff715749ff2cf905$var$DialogTitle = /*#__PURE__*/ $2hDQc.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $gZOiq.default)(props, $ff715749ff2cf905$var$_excluded);
    const ownerState = props;
    const classes = $ff715749ff2cf905$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $2hDQc.useContext((0, $a8f72e610fd3caf5$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $592Nh.jsx)($ff715749ff2cf905$var$DialogTitleRoot, (0, $kxIgO.default)({
        component: "h2",
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ff715749ff2cf905$export$2e2bcd8739ae039 = $ff715749ff2cf905$var$DialogTitle;



var $7115a2fd0c35c547$exports = {};
"use strict";
"use client";

Object.defineProperty($7115a2fd0c35c547$exports, "__esModule", {
    value: true
});
$7115a2fd0c35c547$exports.default = void 0;

var $7115a2fd0c35c547$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $7115a2fd0c35c547$var$_default = $7115a2fd0c35c547$exports.default = (0, $7115a2fd0c35c547$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), "CloseRounded");



parcelRequire("2hDQc");
const $03bdcb6e7b9b2179$var$MoovyDialogConfirmation = (props)=>{
    const { open: open, header: header, content: content, lang: lang, onCancel: onCancel, onConfirm: onConfirm } = props;
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const resetView = ()=>{
        props.mutation?.reset();
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $8df7cb0c72533ff7$export$2e2bcd8739ae039), {
        open: open,
        onClose: ()=>{
            resetView();
            onCancel();
        },
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $ff715749ff2cf905$export$2e2bcd8739ae039), {
                sx: {
                    pr: 7
                },
                children: header
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
                onClick: props.onCancel,
                sx: {
                    position: "absolute",
                    right: 10,
                    top: 10,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7115a2fd0c35c547$exports))), {})
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $27d8040194495028$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                        mutation: props.mutation,
                        errorTitleKey: lang.error
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                        style: {
                            padding: "5px"
                        },
                        children: content
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $034e58a90bc1a7b5$export$2e2bcd8739ae039), {
                sx: {
                    padding: 2
                },
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            resetView();
                            onCancel();
                        },
                        variant: "text",
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "common.buttons.cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        disabled: props.mutation?.isPending || props.disableSubmit,
                        mutation: props.mutation,
                        onClick: ()=>{
                            onConfirm();
                        },
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: lang.confirmButton
                        })
                    })
                ]
            })
        ]
    });
};
var $03bdcb6e7b9b2179$export$2e2bcd8739ae039 = $03bdcb6e7b9b2179$var$MoovyDialogConfirmation;



var $592Nh = parcelRequire("592Nh");





const $625d026951ac286d$var$MoovyDialog = (props)=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const fullScreen = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("md"));
    const { open: open, mutation: mutation, errorTitleKey: errorTitleKey, children: children, modalTitle: modalTitle, submitButtonContent: submitButtonContent, disableSubmit: disableSubmit, formReference: formReference, leftSideButtons: leftSideButtons, contentPadding: contentPadding, hideCancelButton: hideCancelButton, onCancel: onCancel, onSubmit: onSubmit, ...other } = props;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $8df7cb0c72533ff7$export$2e2bcd8739ae039), {
            open: open,
            onSubmit: onSubmit,
            fullScreen: fullScreen,
            onClose: onCancel,
            sx: fullScreen ? undefined : {
                "& .MuiDialog-paper": {
                    // Minimum width of all Moovy dialogs is set here
                    minWidth: "350px"
                }
            },
            ...other,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $ff715749ff2cf905$export$2e2bcd8739ae039), {
                    sx: {
                        pr: 7
                    },
                    children: modalTitle
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    sx: {
                        position: "absolute",
                        right: 10,
                        top: 10,
                        color: (theme)=>theme.palette.grey[500]
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7115a2fd0c35c547$exports))), {})
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $27d8040194495028$export$2e2bcd8739ae039), {
                    dividers: true,
                    sx: {
                        padding: contentPadding,
                        position: "relative"
                    },
                    children: [
                        mutation && /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                marginBottom: mutation?.error ? "1rem" : undefined
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                                mutation: mutation,
                                errorTitleKey: errorTitleKey || "common.actions.error"
                            })
                        }),
                        children,
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $4674b63572c4d684$export$2e2bcd8739ae039), {
                                sx: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMainBackground,
                                    zIndex: 1
                                },
                                open: mutation?.isPending || false,
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $24e2cd5750b4780c$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $034e58a90bc1a7b5$export$2e2bcd8739ae039), {
                    sx: {
                        padding: 2
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            justifyContent: leftSideButtons ? "space-between" : "right",
                            width: "100%"
                        },
                        children: [
                            leftSideButtons?.map((item)=>item),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "flex",
                                    gap: 1
                                },
                                children: [
                                    !hideCancelButton && /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            onCancel();
                                        },
                                        variant: "text",
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "common.buttons.cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                        type: "submit",
                                        form: formReference,
                                        mutation: mutation,
                                        onClick: onSubmit,
                                        disabled: disableSubmit,
                                        children: submitButtonContent
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $625d026951ac286d$export$2e2bcd8739ae039 = $625d026951ac286d$var$MoovyDialog;




var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");






var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $a5a978bd8a1190f7$export$5682c366c0c669d9(slot) {
    return (0, $01COD.default)("MuiListItem", slot);
}
const $a5a978bd8a1190f7$var$listItemClasses = (0, $eLydt.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $a5a978bd8a1190f7$export$2e2bcd8739ae039 = $a5a978bd8a1190f7$var$listItemClasses;



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $e434de5118acb2b8$export$c09531d8563c67a5(slot) {
    return (0, $01COD.default)("MuiListItemButton", slot);
}
const $e434de5118acb2b8$var$listItemButtonClasses = (0, $eLydt.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $e434de5118acb2b8$export$2e2bcd8739ae039 = $e434de5118acb2b8$var$listItemButtonClasses;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $a133f33b20e4a7be$export$ccdb26aeba48a86e(slot) {
    return (0, $01COD.default)("MuiListItemSecondaryAction", slot);
}
const $a133f33b20e4a7be$var$listItemSecondaryActionClasses = (0, $eLydt.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $a133f33b20e4a7be$export$2e2bcd8739ae039 = $a133f33b20e4a7be$var$listItemSecondaryActionClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $691f3f6b662c3da5$var$_excluded = [
    "className"
];
const $691f3f6b662c3da5$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $a133f33b20e4a7be$export$ccdb26aeba48a86e), classes);
};
const $691f3f6b662c3da5$var$ListItemSecondaryActionRoot = (0, $fhlQp.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $691f3f6b662c3da5$var$ListItemSecondaryAction = /*#__PURE__*/ $2hDQc.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $gZOiq.default)(props, $691f3f6b662c3da5$var$_excluded);
    const context = $2hDQc.useContext((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039));
    const ownerState = (0, $kxIgO.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $691f3f6b662c3da5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($691f3f6b662c3da5$var$ListItemSecondaryActionRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$691f3f6b662c3da5$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $691f3f6b662c3da5$export$2e2bcd8739ae039 = $691f3f6b662c3da5$var$ListItemSecondaryAction;



var $592Nh = parcelRequire("592Nh");
"use client";
const $003822cb1451b251$var$_excluded = [
    "className"
], $003822cb1451b251$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $003822cb1451b251$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $003822cb1451b251$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $a5a978bd8a1190f7$export$5682c366c0c669d9), classes);
};
const $003822cb1451b251$export$aed538f7519abe89 = (0, $fhlQp.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $003822cb1451b251$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $kxIgO.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $e434de5118acb2b8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $a5a978bd8a1190f7$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $a5a978bd8a1190f7$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $a5a978bd8a1190f7$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $a5a978bd8a1190f7$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $a5a978bd8a1190f7$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $003822cb1451b251$var$ListItemContainer = (0, $fhlQp.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $003822cb1451b251$var$ListItem = /*#__PURE__*/ $2hDQc.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $gZOiq.default)(props.ContainerProps, $003822cb1451b251$var$_excluded), other = (0, $gZOiq.default)(props, $003822cb1451b251$var$_excluded2);
    const context = $2hDQc.useContext((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039));
    const childContext = $2hDQc.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $2hDQc.useRef(null);
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $2hDQc.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $a81f7819c5c3d8dd$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $003822cb1451b251$var$useUtilityClasses(ownerState);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $003822cb1451b251$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $fLRFO.default)((0, $a5a978bd8a1190f7$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $1379cc80d8f1a214$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $592Nh.jsxs)($003822cb1451b251$var$ListItemContainer, (0, $kxIgO.default)({
                as: ContainerComponent,
                className: (0, $fLRFO.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)(Root, (0, $kxIgO.default)({}, rootProps, !(0, $1ade516e245d7339$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $kxIgO.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)(Root, (0, $kxIgO.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $1ade516e245d7339$export$e28348cc2430497)(Root) && {
            ownerState: (0, $kxIgO.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $592Nh.jsx)((0, $691f3f6b662c3da5$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $003822cb1451b251$export$2e2bcd8739ae039 = $003822cb1451b251$var$ListItem;


parcelRequire("2hDQc");
const $b05c28a9697a5f63$var$MoovyListLabelValue = ({ data: data, breakpoint: breakpoint, splitByMiddle: splitByMiddle })=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down(breakpoint || "sm"));
    if (isMobile) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
        children: data.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                    primary: item.label,
                    secondary: /*#__PURE__*/ (0, $592Nh.jsx)("span", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: item.value
                    })
                })
            }, index))
    });
    return data.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
            container: true,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: splitByMiddle ? 5 : 4,
                    children: item.label
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    children: ":"
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: splitByMiddle ? 6 : 5,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)("span", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: item.value
                    })
                })
            ]
        }, index));
};
var $b05c28a9697a5f63$export$2e2bcd8739ae039 = $b05c28a9697a5f63$var$MoovyListLabelValue;



var $592Nh = parcelRequire("592Nh");

parcelRequire("2hDQc");

const $09ef42aa6aba452d$var$getValidationErrors = (intl, validationErrors)=>{
    return validationErrors?.map((item)=>{
        return intl.formatMessage({
            id: `validation.code.${item.code}`,
            defaultMessage: intl.formatMessage({
                id: "validation.code.generic"
            })
        }, {
            field: intl.formatMessage({
                id: `validation.field.${item.field}`,
                defaultMessage: item.field
            })
        });
    });
};
const $09ef42aa6aba452d$export$414e01788cec8720 = (intl, error)=>{
    if (error.response?.data?.validationErrors && error.response.data.validationErrors.length > 0) return $09ef42aa6aba452d$var$getValidationErrors(intl, error.response.data.validationErrors);
    return null;
};
const $09ef42aa6aba452d$export$b2aeb2d3d984ebee = (intl, error)=>{
    if (error.response?.data?.code) return intl.formatMessage({
        id: `api.error.code.${error.response?.data?.code}`,
        defaultMessage: intl.formatMessage({
            id: "api.error.code.generic"
        })
    });
    return null;
};
const $09ef42aa6aba452d$var$MoovyMutationError = ({ mutation: mutation, query: query, errorTitleKey: errorTitleKey, errorBodyKey: errorBodyKey })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const localizedErrorText = ({ mutation: mutation, query: query, errorBodyKey: errorBodyKey, errorTitleKey: errorTitleKey })=>{
        if (!mutation?.isError && !query?.isError) return "";
        const error = mutation?.error || query?.error;
        const localizedValidationErrors = $09ef42aa6aba452d$export$414e01788cec8720(intl, error);
        const localizedError = $09ef42aa6aba452d$export$b2aeb2d3d984ebee(intl, error);
        const localizedTitle = errorTitleKey && intl.formatMessage({
            id: errorTitleKey
        });
        if (localizedValidationErrors) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $f3fa5d7307d7d7b0$export$1da928963a217e70), {
            title: localizedTitle,
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                children: localizedValidationErrors.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)("li", {
                        children: item
                    }, index))
            })
        });
        else if (localizedError) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $f3fa5d7307d7d7b0$export$1da928963a217e70), {
            title: localizedError
        });
        else return /*#__PURE__*/ (0, $592Nh.jsx)((0, $f3fa5d7307d7d7b0$export$1da928963a217e70), {
            title: localizedTitle,
            children: errorBodyKey ? intl.formatMessage({
                id: errorBodyKey
            }) : null
        });
    };
    return localizedErrorText({
        mutation: mutation,
        query: query,
        errorBodyKey: errorBodyKey,
        errorTitleKey: errorTitleKey
    });
};
var $09ef42aa6aba452d$export$2e2bcd8739ae039 = $09ef42aa6aba452d$var$MoovyMutationError;




var $592Nh = parcelRequire("592Nh");

const $4453c76d9a9c1264$var$MoovyProgress = (props)=>{
    const style = props.sx || {
        display: "flex",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        sx: style,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $24e2cd5750b4780c$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
var $4453c76d9a9c1264$export$2e2bcd8739ae039 = $4453c76d9a9c1264$var$MoovyProgress;




var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $lfMLv = parcelRequire("lfMLv");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $278af4732c89cc06$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $01COD.default)("MuiFab", slot);
}
const $278af4732c89cc06$var$fabClasses = (0, $eLydt.default)("MuiFab", [
    "root",
    "primary",
    "secondary",
    "extended",
    "circular",
    "focusVisible",
    "disabled",
    "colorInherit",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "info",
    "error",
    "warning",
    "success"
]);
var $278af4732c89cc06$export$2e2bcd8739ae039 = $278af4732c89cc06$var$fabClasses;



var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
"use client";
const $42bb8bc95f42633b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $42bb8bc95f42633b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `size${(0, $lfMLv.default)(size)}`,
            color === "inherit" ? "colorInherit" : color
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $278af4732c89cc06$export$e2cfa0ca4bce1fc2), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $42bb8bc95f42633b$var$FabRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    name: "MuiFab",
    slot: "Root",
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $lfMLv.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            styles[(0, $lfMLv.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $kxIgO.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: "50%",
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: "none"
        },
        [`&.${(0, $278af4732c89cc06$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === "small" && {
        width: 40,
        height: 40
    }, ownerState.size === "medium" && {
        width: 48,
        height: 48
    }, ownerState.variant === "extended" && {
        borderRadius: 24,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
    }, ownerState.variant === "extended" && ownerState.size === "small" && {
        width: "auto",
        padding: "0 8px",
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === "extended" && ownerState.size === "medium" && {
        width: "auto",
        padding: "0 16px",
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === "inherit" && {
        color: "inherit"
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.color !== "inherit" && ownerState.color !== "default" && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $278af4732c89cc06$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $42bb8bc95f42633b$var$Fab = /*#__PURE__*/ $2hDQc.forwardRef(function Fab(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFab"
    });
    const { children: children, className: className, color: color = "default", component: component = "button", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = "large", variant: variant = "circular" } = props, other = (0, $gZOiq.default)(props, $42bb8bc95f42633b$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $42bb8bc95f42633b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($42bb8bc95f42633b$var$FabRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fLRFO.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $42bb8bc95f42633b$export$2e2bcd8739ae039 = $42bb8bc95f42633b$var$Fab;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");







var $592Nh = parcelRequire("592Nh");
"use client";
const $f8fa5b275306430b$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $f8fa5b275306430b$var$styles = {
    entering: {
        transform: "none"
    },
    entered: {
        transform: "none"
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $f8fa5b275306430b$var$Zoom = /*#__PURE__*/ $2hDQc.forwardRef(function Zoom(props, ref) {
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f1775b3e9e6fc859$export$2e2bcd8739ae039) } = props, other = (0, $gZOiq.default)(props, $f8fa5b275306430b$var$_excluded);
    const nodeRef = $2hDQc.useRef(null);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1aa5c4f4ecb43caa$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $2hDQc.cloneElement(children, (0, $kxIgO.default)({
                style: (0, $kxIgO.default)({
                    transform: "scale(0)",
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $f8fa5b275306430b$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $f8fa5b275306430b$export$2e2bcd8739ae039 = $f8fa5b275306430b$var$Zoom;



var $2hDQc = parcelRequire("2hDQc");
var $879e12d9b519c92d$exports = {};
"use strict";
"use client";

Object.defineProperty($879e12d9b519c92d$exports, "__esModule", {
    value: true
});
$879e12d9b519c92d$exports.default = void 0;

var $879e12d9b519c92d$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $879e12d9b519c92d$var$_default = $879e12d9b519c92d$exports.default = (0, $879e12d9b519c92d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M8.12 14.71 12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71a.9959.9959 0 0 0-1.41 0L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.38 1.03.39 1.42 0"
}), "KeyboardArrowUpRounded");


const $5f4a92248a848f80$var$MoovyScrollToTop = ({})=>{
    const [showScroll, setshowScroll] = (0, $2hDQc.useState)(false);
    const [scrollY, setScrollY] = (0, $2hDQc.useState)(0);
    (0, $2hDQc.useEffect)(()=>{
        const handleScroll = ()=>{
            const innerHeight = window.innerHeight || 0;
            const y = window.scrollY;
            // Show the button only if user is scrolling down.
            setshowScroll(scrollY < y && y > innerHeight / 2);
            setScrollY(y);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        scrollY
    ]);
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f8fa5b275306430b$export$2e2bcd8739ae039), {
            in: showScroll,
            timeout: {
                enter: 500,
                exit: 500
            },
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $42bb8bc95f42633b$export$2e2bcd8739ae039), {
                size: "small",
                style: {
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    backgroundColor: "transparent"
                },
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($879e12d9b519c92d$exports))), {
                    onClick: scrollToTop
                })
            })
        })
    });
};
var $5f4a92248a848f80$export$2e2bcd8739ae039 = $5f4a92248a848f80$var$MoovyScrollToTop;



var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");

const $b69e7f737512ce9e$var$MoovySortAndFilter = ({ filterKey: filterKey, items: items, value: value, pt: pt, pb: pb, onChange: onChange })=>{
    const [state, setState] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: filterKey,
        initialValue: {
            value: value || ""
        }
    });
    (0, $2hDQc.useEffect)(()=>{
        if (state.value) onChange(state.value);
    }, [
        state.value
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
        container: true,
        direction: "row",
        pt: pt,
        pb: pb,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
            item: true,
            md: 4,
            xs: 12,
            children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $df0187c1973aff1d$export$2e2bcd8739ae039), {
                fullWidth: true,
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c66893090d56545d$export$2e2bcd8739ae039), {
                        id: "moovy-sort-and-filter-select-label",
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "moovySortAndFilter.sortingCriteria"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $fea672baf31d9c16$export$2e2bcd8739ae039), {
                        labelId: "moovy-sort-and-filter-select-label",
                        id: "moovy-sort-and-filter-select",
                        label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "moovySortAndFilter.sortingCriteria"
                        }),
                        value: value,
                        onChange: (event)=>setState({
                                ...state,
                                value: event.target.value
                            }),
                        children: items.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                                value: item.key,
                                children: item.value
                            }, index))
                    })
                ]
            })
        })
    });
};
var $b69e7f737512ce9e$export$2e2bcd8739ae039 = $b69e7f737512ce9e$var$MoovySortAndFilter;



var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $lfMLv = parcelRequire("lfMLv");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $7974e6c012cacd51$export$72aef224d6115253(slot) {
    return (0, $01COD.default)("MuiTab", slot);
}
const $7974e6c012cacd51$var$tabClasses = (0, $eLydt.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $7974e6c012cacd51$export$2e2bcd8739ae039 = $7974e6c012cacd51$var$tabClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $6152b1c1aa5c924e$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $6152b1c1aa5c924e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $lfMLv.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $7974e6c012cacd51$export$72aef224d6115253), classes);
};
const $6152b1c1aa5c924e$var$TabRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $lfMLv.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).iconWrapper}`]: (0, $kxIgO.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $7974e6c012cacd51$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $6152b1c1aa5c924e$var$Tab = /*#__PURE__*/ $2hDQc.forwardRef(function Tab(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $gZOiq.default)(props, $6152b1c1aa5c924e$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $6152b1c1aa5c924e$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $2hDQc.isValidElement(iconProp) ? /*#__PURE__*/ $2hDQc.cloneElement(iconProp, {
        className: (0, $fLRFO.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)($6152b1c1aa5c924e$var$TabRoot, (0, $kxIgO.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $6152b1c1aa5c924e$export$2e2bcd8739ae039 = $6152b1c1aa5c924e$var$Tab;



var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");


var $592Nh = parcelRequire("592Nh");
"use client";
const $6c3ebbd2aab90ef4$var$Context = /*#__PURE__*/ $2hDQc.createContext(null);
function $6c3ebbd2aab90ef4$var$useUniquePrefix() {
    const [id, setId] = $2hDQc.useState(null);
    $2hDQc.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $6c3ebbd2aab90ef4$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $6c3ebbd2aab90ef4$var$useUniquePrefix();
    const context = $2hDQc.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)($6c3ebbd2aab90ef4$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $6c3ebbd2aab90ef4$export$5a3bad273ac578e0() {
    return $2hDQc.useContext($6c3ebbd2aab90ef4$var$Context);
}
function $6c3ebbd2aab90ef4$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $6c3ebbd2aab90ef4$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");



var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $683af5166cf1d36c$var$cachedType;
function $683af5166cf1d36c$export$a10970ffb6510128() {
    if ($683af5166cf1d36c$var$cachedType) return $683af5166cf1d36c$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $683af5166cf1d36c$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $683af5166cf1d36c$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $683af5166cf1d36c$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $683af5166cf1d36c$var$cachedType;
}
function $683af5166cf1d36c$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $683af5166cf1d36c$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $633aecbe37112a2a$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $633aecbe37112a2a$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $633aecbe37112a2a$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");




var $592Nh = parcelRequire("592Nh");
"use client";
const $525b91966e235058$var$_excluded = [
    "onChange"
];
const $525b91966e235058$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $525b91966e235058$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $gZOiq.default)(props, $525b91966e235058$var$_excluded);
    const scrollbarHeight = $2hDQc.useRef();
    const nodeRef = $2hDQc.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $9edf6df80e9bc497$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $9bc586e64615ae98$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $2hDQc.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)("div", (0, $kxIgO.default)({
        style: $525b91966e235058$var$styles,
        ref: nodeRef
    }, other));
}



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");
parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $381cb0966d88a4f7$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $bacbf1c5fef54163$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");





var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $539ab0d743b4ccbb$export$34861783d3c2eef8(slot) {
    return (0, $01COD.default)("MuiTabScrollButton", slot);
}
const $539ab0d743b4ccbb$var$tabScrollButtonClasses = (0, $eLydt.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $539ab0d743b4ccbb$export$2e2bcd8739ae039 = $539ab0d743b4ccbb$var$tabScrollButtonClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $26a906973ddb961c$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $26a906973ddb961c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $539ab0d743b4ccbb$export$34861783d3c2eef8), classes);
};
const $26a906973ddb961c$var$TabScrollButtonRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $539ab0d743b4ccbb$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $26a906973ddb961c$var$TabScrollButton = /*#__PURE__*/ $2hDQc.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $gZOiq.default)(props, $26a906973ddb961c$var$_excluded);
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $kxIgO.default)({
        isRtl: isRtl
    }, props);
    const classes = $26a906973ddb961c$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $381cb0966d88a4f7$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $bacbf1c5fef54163$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($26a906973ddb961c$var$TabScrollButtonRoot, (0, $kxIgO.default)({
        component: "div",
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $592Nh.jsx)(StartButtonIcon, (0, $kxIgO.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $592Nh.jsx)(EndButtonIcon, (0, $kxIgO.default)({}, endButtonIconProps))
    }));
});
var $26a906973ddb961c$export$2e2bcd8739ae039 = $26a906973ddb961c$var$TabScrollButton;




var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $7be0f9646402d49d$export$cdd93bd054dec359(slot) {
    return (0, $01COD.default)("MuiTabs", slot);
}
const $7be0f9646402d49d$var$tabsClasses = (0, $eLydt.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $7be0f9646402d49d$export$2e2bcd8739ae039 = $7be0f9646402d49d$var$tabsClasses;





var $592Nh = parcelRequire("592Nh");
"use client";
const $ffe399ce3625ee07$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $ffe399ce3625ee07$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $ffe399ce3625ee07$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $ffe399ce3625ee07$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $ffe399ce3625ee07$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $7be0f9646402d49d$export$cdd93bd054dec359), classes);
};
const $ffe399ce3625ee07$var$TabsRoot = (0, $fhlQp.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7be0f9646402d49d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $7be0f9646402d49d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $7be0f9646402d49d$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $ffe399ce3625ee07$var$TabsScroller = (0, $fhlQp.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $ffe399ce3625ee07$var$FlexContainer = (0, $fhlQp.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $ffe399ce3625ee07$var$TabsIndicator = (0, $fhlQp.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $kxIgO.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $ffe399ce3625ee07$var$TabsScrollbarSize = (0, $fhlQp.default)((0, $525b91966e235058$export$2e2bcd8739ae039))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $ffe399ce3625ee07$var$defaultIndicatorStyle = {};
let $ffe399ce3625ee07$var$warnedOnceTabPresent = false;
const $ffe399ce3625ee07$var$Tabs = /*#__PURE__*/ $2hDQc.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $26a906973ddb961c$export$2e2bcd8739ae039), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $gZOiq.default)(props, $ffe399ce3625ee07$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $ffe399ce3625ee07$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $6f3442660a15142b$export$1e5c9e6e4e15efe3)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $2hDQc.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $2hDQc.useState($ffe399ce3625ee07$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $2hDQc.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $2hDQc.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $2hDQc.useState(false);
    const [scrollerStyle, setScrollerStyle] = $2hDQc.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $2hDQc.useRef(null);
    const tabListRef = $2hDQc.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $683af5166cf1d36c$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $633aecbe37112a2a$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $683af5166cf1d36c$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $2hDQc.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $592Nh.jsx)($ffe399ce3625ee07$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $fLRFO.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $592Nh.jsx)(ScrollButtonComponent, (0, $kxIgO.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $fLRFO.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $592Nh.jsx)(ScrollButtonComponent, (0, $kxIgO.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $fLRFO.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $5f74bea4646b1b07$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $2hDQc.useEffect(()=>{
        const handleResize = (0, $9edf6df80e9bc497$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $9bc586e64615ae98$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $2hDQc.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $2hDQc.useEffect(()=>{
        setMounted(true);
    }, []);
    $2hDQc.useEffect(()=>{
        updateIndicatorState();
    });
    $2hDQc.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($ffe399ce3625ee07$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $2hDQc.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $592Nh.jsx)($ffe399ce3625ee07$var$TabsIndicator, (0, $kxIgO.default)({}, TabIndicatorProps, {
        className: (0, $fLRFO.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $kxIgO.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $2hDQc.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $2hDQc.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $2hDQc.cloneElement(child, (0, $kxIgO.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $8be63c98f6bdf56e$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $ffe399ce3625ee07$var$moveFocus(list, currentFocus, $ffe399ce3625ee07$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $ffe399ce3625ee07$var$moveFocus(list, currentFocus, $ffe399ce3625ee07$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $ffe399ce3625ee07$var$moveFocus(list, null, $ffe399ce3625ee07$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $ffe399ce3625ee07$var$moveFocus(list, null, $ffe399ce3625ee07$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $592Nh.jsxs)($ffe399ce3625ee07$var$TabsRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $592Nh.jsxs)($ffe399ce3625ee07$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)($ffe399ce3625ee07$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $ffe399ce3625ee07$export$2e2bcd8739ae039 = $ffe399ce3625ee07$var$Tabs;




var $592Nh = parcelRequire("592Nh");
"use client";
const $b6896624bbe45c23$var$_excluded = [
    "children"
];
const $b6896624bbe45c23$var$TabList = /*#__PURE__*/ $2hDQc.forwardRef(function TabList(props, ref) {
    const { children: childrenProp } = props, other = (0, $gZOiq.default)(props, $b6896624bbe45c23$var$_excluded);
    const context = (0, $6c3ebbd2aab90ef4$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError("No TabContext provided");
    const children = $2hDQc.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $2hDQc.isValidElement(child)) return null;
        return /*#__PURE__*/ $2hDQc.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            "aria-controls": (0, $6c3ebbd2aab90ef4$export$629f80328afcade5)(context, child.props.value),
            id: (0, $6c3ebbd2aab90ef4$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $ffe399ce3625ee07$export$2e2bcd8739ae039), (0, $kxIgO.default)({}, other, {
        ref: ref,
        value: context.value,
        children: children
    }));
});
var $b6896624bbe45c23$export$2e2bcd8739ae039 = $b6896624bbe45c23$var$TabList;



var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");

var $dJnC1 = parcelRequire("dJnC1");

var $01COD = parcelRequire("01COD");

var $eLydt = parcelRequire("eLydt");
function $a24ed332cef257cf$export$cfb3da2e74936ec(slot) {
    return (0, $01COD.default)("MuiTabPanel", slot);
}
const $a24ed332cef257cf$var$tabPanelClasses = (0, $eLydt.default)("MuiTabPanel", [
    "root"
]);
var $a24ed332cef257cf$export$2e2bcd8739ae039 = $a24ed332cef257cf$var$tabPanelClasses;




var $592Nh = parcelRequire("592Nh");
"use client";
const $311180d54ce91c14$var$_excluded = [
    "children",
    "className",
    "value"
];
const $311180d54ce91c14$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $a24ed332cef257cf$export$cfb3da2e74936ec), classes);
};
const $311180d54ce91c14$var$TabPanelRoot = (0, $fhlQp.default)("div", {
    name: "MuiTabPanel",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $311180d54ce91c14$var$TabPanel = /*#__PURE__*/ $2hDQc.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTabPanel"
    });
    const { children: children, className: className, value: value } = props, other = (0, $gZOiq.default)(props, $311180d54ce91c14$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props);
    const classes = $311180d54ce91c14$var$useUtilityClasses(ownerState);
    const context = (0, $6c3ebbd2aab90ef4$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError("No TabContext provided");
    const id = (0, $6c3ebbd2aab90ef4$export$629f80328afcade5)(context, value);
    const tabId = (0, $6c3ebbd2aab90ef4$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $592Nh.jsx)($311180d54ce91c14$var$TabPanelRoot, (0, $kxIgO.default)({
        "aria-labelledby": tabId,
        className: (0, $fLRFO.default)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState
    }, other, {
        children: value === context.value && children
    }));
});
var $311180d54ce91c14$export$2e2bcd8739ae039 = $311180d54ce91c14$var$TabPanel;



const $74f5dfbf7740a204$var$MoovyTab = ({ tabKey: tabKey, tabHeaders: tabHeaders, defaultPanel: defaultPanel, tabPanels: tabPanels })=>{
    const [state, setState] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: tabKey,
        initialValue: {
            value: defaultPanel || "0"
        }
    });
    (0, $2hDQc.useEffect)(()=>{
        if (state.value >= tabPanels.length) setState({
            ...state,
            value: (tabPanels.length - 1).toString()
        });
    }, [
        state
    ]);
    const handleChange = (event, newValue)=>{
        setState({
            ...state,
            value: newValue
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $6c3ebbd2aab90ef4$export$2e2bcd8739ae039), {
        value: state.value,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 2,
                    borderBottom: 1,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b6896624bbe45c23$export$2e2bcd8739ae039), {
                    onChange: handleChange,
                    children: tabHeaders.map((header, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $6152b1c1aa5c924e$export$2e2bcd8739ae039), {
                            label: header,
                            value: index.toString()
                        }, index))
                })
            }),
            tabPanels.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $311180d54ce91c14$export$2e2bcd8739ae039), {
                    value: index.toString(),
                    style: {
                        padding: 0
                    },
                    children: item
                }, index))
        ]
    });
};
var $74f5dfbf7740a204$export$2e2bcd8739ae039 = $74f5dfbf7740a204$var$MoovyTab;



var $592Nh = parcelRequire("592Nh");

var $fhlQp = parcelRequire("fhlQp");
var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $3917c1305f20b950$export$315cb19215f77ce0(slot) {
    return (0, $01COD.default)("MuiTable", slot);
}
const $3917c1305f20b950$var$tableClasses = (0, $eLydt.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $3917c1305f20b950$export$2e2bcd8739ae039 = $3917c1305f20b950$var$tableClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $d30c8e9738c26069$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $d30c8e9738c26069$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $3917c1305f20b950$export$315cb19215f77ce0), classes);
};
const $d30c8e9738c26069$var$TableRoot = (0, $fhlQp.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $kxIgO.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $d30c8e9738c26069$var$defaultComponent = "table";
const $d30c8e9738c26069$var$Table = /*#__PURE__*/ $2hDQc.forwardRef(function Table(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $d30c8e9738c26069$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $gZOiq.default)(props, $d30c8e9738c26069$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $d30c8e9738c26069$var$useUtilityClasses(ownerState);
    const table = $2hDQc.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e3c635e52caa6d75$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($d30c8e9738c26069$var$TableRoot, (0, $kxIgO.default)({
            as: component,
            role: component === $d30c8e9738c26069$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $fLRFO.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $d30c8e9738c26069$export$2e2bcd8739ae039 = $d30c8e9738c26069$var$Table;


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $ae8b247de2fb15ce$export$eed427986a7abdf9(slot) {
    return (0, $01COD.default)("MuiTableContainer", slot);
}
const $ae8b247de2fb15ce$var$tableContainerClasses = (0, $eLydt.default)("MuiTableContainer", [
    "root"
]);
var $ae8b247de2fb15ce$export$2e2bcd8739ae039 = $ae8b247de2fb15ce$var$tableContainerClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $efa725d80d5a79be$var$_excluded = [
    "className",
    "component"
];
const $efa725d80d5a79be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $ae8b247de2fb15ce$export$eed427986a7abdf9), classes);
};
const $efa725d80d5a79be$var$TableContainerRoot = (0, $fhlQp.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const $efa725d80d5a79be$var$TableContainer = /*#__PURE__*/ $2hDQc.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className: className, component: component = "div" } = props, other = (0, $gZOiq.default)(props, $efa725d80d5a79be$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component
    });
    const classes = $efa725d80d5a79be$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($efa725d80d5a79be$var$TableContainerRoot, (0, $kxIgO.default)({
        ref: ref,
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $efa725d80d5a79be$export$2e2bcd8739ae039 = $efa725d80d5a79be$var$TableContainer;




var $2hDQc = parcelRequire("2hDQc");




const $e5d33b18908fef3d$var$StyledPaper = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039))({
    boxShadow: "none"
});
const $e5d33b18908fef3d$var$EmptyTable = (props)=>{
    const { children: children, query: query, emptyTextId: emptyTextId, errorTextId: errorTextId } = props;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Children.map(children, (child, i)=>{
                // Parse only the first content which is the header of the table
                if (i > 1) return;
                return child;
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                        colSpan: 99,
                        children: query?.isError ? /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                                query: query,
                                errorTitleKey: errorTextId || "shared.moovyTable.action.failed"
                            })
                        }) : /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: emptyTextId && /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: emptyTextId
                            }) || /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "shared.moovyTable.action.emptySet"
                            })
                        })
                    })
                })
            })
        ]
    });
};
const $e5d33b18908fef3d$var$ContentTable = ({ items: items, emptyTextId: emptyTextId, errorTextId: errorTextId, query: query, pagination: pagination, ...tableProps })=>{
    const [page, setPage] = (0, $2hDQc.useState)(pagination?.page || 1);
    if (items?.length > 0 && tableProps.children) return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $efa725d80d5a79be$export$2e2bcd8739ae039), {
        component: $e5d33b18908fef3d$var$StyledPaper,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $d30c8e9738c26069$export$2e2bcd8739ae039), {
                ...tableProps,
                children: tableProps.children
            }),
            pagination && pagination.total > pagination.limit && /*#__PURE__*/ (0, $592Nh.jsx)((0, $ae63e01d7dc24727$export$2e2bcd8739ae039), {
                page: page,
                total: pagination.total,
                limit: pagination.limit,
                onNextPage: (page)=>{
                    setPage(page);
                    pagination.onNextPage(page);
                }
            })
        ]
    });
    else return /*#__PURE__*/ (0, $592Nh.jsx)((0, $d30c8e9738c26069$export$2e2bcd8739ae039), {
        ...tableProps,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($e5d33b18908fef3d$var$EmptyTable, {
            query: query,
            emptyTextId: emptyTextId,
            errorTextId: errorTextId,
            children: tableProps.children
        })
    });
};
const $e5d33b18908fef3d$var$LoadingTable = (props)=>{
    const [isProgressVisible, setIsProgressVisible] = (0, $2hDQc.useState)(false);
    const [state] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $7bfb91130cd4d35d$export$add10c4cb4cd7fd0),
        initialValue: {
            value: ""
        }
    });
    (0, $2hDQc.useEffect)(()=>{
        setIsProgressVisible(!!state.value);
    }, [
        state.value
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
            sx: {
                opacity: 0.5,
                color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).progressBlockContentColor,
                pointerEvents: "none",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)($e5d33b18908fef3d$var$ContentTable, {
                    ...props
                }),
                !isProgressVisible && /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {
                    sx: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }
                })
            ]
        })
    });
};
const $e5d33b18908fef3d$var$MoovyTable = (props)=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    // As a default, the table is hidden in mobile view.
    const isHidden = props.hidden || isMobile;
    return !isHidden && (props.query?.isLoading || props.query?.isFetching ? /*#__PURE__*/ (0, $592Nh.jsx)($e5d33b18908fef3d$var$LoadingTable, {
        ...props
    }) : /*#__PURE__*/ (0, $592Nh.jsx)($e5d33b18908fef3d$var$ContentTable, {
        ...props
    }));
};
var $e5d33b18908fef3d$export$2e2bcd8739ae039 = $e5d33b18908fef3d$var$MoovyTable;



var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");



const $24359d10cdf7053d$var$MoovyGrid = ({ emptyTextId: emptyTextId, errorTextId: errorTextId, hidden: hidden, query: query, pagination: pagination, children: children })=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const [page, setPage] = (0, $2hDQc.useState)(pagination?.page || 1);
    const cards = children;
    const showEmptyText = !query?.isError && (!cards || cards.length <= 0);
    const showLoading = query?.isLoading || query?.isFetching;
    // As a default, the grid is hidden in browser view.
    const isHidden = hidden || !isMobile;
    return !isHidden && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
        container: true,
        gap: 2,
        justifyContent: "center",
        children: [
            showLoading && /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                query: query,
                errorTitleKey: errorTextId || "common.actions.error"
            }),
            cards?.map((item, index)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: item
                }, index)),
            showEmptyText && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                xs: 12,
                justifyContent: "center",
                children: emptyTextId && /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: emptyTextId
                }) || /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "common.actions.get.error"
                })
            }),
            pagination && pagination.total > pagination.limit && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $ae63e01d7dc24727$export$2e2bcd8739ae039), {
                        page: page,
                        total: pagination.total,
                        limit: pagination.limit,
                        onNextPage: (page)=>{
                            setPage(page);
                            pagination.onNextPage(page);
                        }
                    })
                })
            })
        ]
    });
};
var $24359d10cdf7053d$export$2e2bcd8739ae039 = $24359d10cdf7053d$var$MoovyGrid;



var $592Nh = parcelRequire("592Nh");


parcelRequire("2hDQc");
const $aee91e5fd2415227$var$MoovyGridCard = (props)=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    return isMobile && /*#__PURE__*/ (0, $592Nh.jsx)((0, $048939e8d048fac8$export$2e2bcd8739ae039), {
        ...props
    });
};
var $aee91e5fd2415227$export$2e2bcd8739ae039 = $aee91e5fd2415227$var$MoovyGridCard;



var $592Nh = parcelRequire("592Nh");



var $c8c441f475741a99$exports = {};
"use strict";
"use client";

Object.defineProperty($c8c441f475741a99$exports, "__esModule", {
    value: true
});
$c8c441f475741a99$exports.default = void 0;

var $c8c441f475741a99$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $c8c441f475741a99$var$_default = $c8c441f475741a99$exports.default = (0, $c8c441f475741a99$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "CheckCircleOutline");


const $52a02ab158cbbbf2$var$MoovyParkingEnforcementStatus = ({ parkingEnforcement: parkingEnforcement })=>{
    return parkingEnforcement ? /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8c441f475741a99$exports))), {
                sx: {
                    mr: 1
                },
                color: "success"
            }),
            " ",
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "moovyParkingEnforcementStatus.yes"
            })
        ]
    }) : /*#__PURE__*/ (0, $592Nh.jsx)("span", {
        style: {
            color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonRed
        },
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "moovyParkingEnforcementStatus.no"
        })
    });
};
var $52a02ab158cbbbf2$export$2e2bcd8739ae039 = $52a02ab158cbbbf2$var$MoovyParkingEnforcementStatus;



var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");

var $fLRFO = parcelRequire("fLRFO");


var $3NAKi = parcelRequire("3NAKi");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");function $f869676bebd3566e$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $f869676bebd3566e$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $f869676bebd3566e$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $f869676bebd3566e$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $f869676bebd3566e$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $f869676bebd3566e$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $f869676bebd3566e$export$8af1d214c6c2f0f1(length) * $f869676bebd3566e$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $f869676bebd3566e$export$8af1d214c6c2f0f1(length) * $f869676bebd3566e$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $f869676bebd3566e$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $f869676bebd3566e$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $f869676bebd3566e$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $f869676bebd3566e$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $f869676bebd3566e$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $78fd7f7891143ca2$export$c987db9fc844f86(slot) {
    return (0, $01COD.default)("MuiSkeleton", slot);
}
const $78fd7f7891143ca2$var$skeletonClasses = (0, $eLydt.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $78fd7f7891143ca2$export$2e2bcd8739ae039 = $78fd7f7891143ca2$var$skeletonClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $ab312a9d0a7c7993$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $ab312a9d0a7c7993$var$_ = (t)=>t, $ab312a9d0a7c7993$var$_t, $ab312a9d0a7c7993$var$_t2, $ab312a9d0a7c7993$var$_t3, $ab312a9d0a7c7993$var$_t4;
const $ab312a9d0a7c7993$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $78fd7f7891143ca2$export$c987db9fc844f86), classes);
};
const $ab312a9d0a7c7993$var$pulseKeyframe = (0, $3NAKi.keyframes)($ab312a9d0a7c7993$var$_t || ($ab312a9d0a7c7993$var$_t = $ab312a9d0a7c7993$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $ab312a9d0a7c7993$var$waveKeyframe = (0, $3NAKi.keyframes)($ab312a9d0a7c7993$var$_t2 || ($ab312a9d0a7c7993$var$_t2 = $ab312a9d0a7c7993$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $ab312a9d0a7c7993$var$SkeletonRoot = (0, $fhlQp.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $f869676bebd3566e$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $f869676bebd3566e$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $kxIgO.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $6KAST.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $3NAKi.css)($ab312a9d0a7c7993$var$_t3 || ($ab312a9d0a7c7993$var$_t3 = $ab312a9d0a7c7993$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $ab312a9d0a7c7993$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $3NAKi.css)($ab312a9d0a7c7993$var$_t4 || ($ab312a9d0a7c7993$var$_t4 = $ab312a9d0a7c7993$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $ab312a9d0a7c7993$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $ab312a9d0a7c7993$var$Skeleton = /*#__PURE__*/ $2hDQc.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $gZOiq.default)(props, $ab312a9d0a7c7993$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $ab312a9d0a7c7993$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($ab312a9d0a7c7993$var$SkeletonRoot, (0, $kxIgO.default)({
        as: component,
        ref: ref,
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $kxIgO.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $ab312a9d0a7c7993$export$2e2bcd8739ae039 = $ab312a9d0a7c7993$var$Skeleton;



var $2hDQc = parcelRequire("2hDQc");








const $72c1b40a1572cee0$export$e32ce87e5105839e = (navigate, error)=>{
    if (error && (0, $3442b7804eafb8f4$export$2e2bcd8739ae039).isAxiosError(error)) {
        const axiosError = error;
        if (axiosError?.response?.status === 404) navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).ROOT);
    }
};




const $43fd4d081f3eea77$var$BackdropAnimation = ({ show: show })=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const [state, setState] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $7bfb91130cd4d35d$export$add10c4cb4cd7fd0),
        initialValue: {
            value: ""
        }
    });
    (0, $2hDQc.useEffect)(()=>{
        if (show != !!state.value) setState({
            value: show ? "true" : ""
        });
    }, [
        show
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        sx: {
            opacity: 0.5,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: theme.zIndex.drawer + 1,
            visibility: show ? "visible" : "hidden"
        },
        id: (0, $cc54526a7cedf1dd$export$4b65f495352b3bd3).MOOVY_BACKDROP_ANIMATION,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $4674b63572c4d684$export$2e2bcd8739ae039), {
            sx: {
                backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMainBackground
            },
            open: show,
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {})
        })
    });
};
const $43fd4d081f3eea77$var$ProgressAnimation = ()=>{
    const getSkeletonAnimations = ()=>{
        const skeletonCount = 8;
        const skeletonItems = [];
        for(let i = 0; i < skeletonCount; i++)skeletonItems.push(/*#__PURE__*/ (0, $592Nh.jsx)((0, $ab312a9d0a7c7993$export$2e2bcd8739ae039), {
            animation: "wave"
        }, i));
        return skeletonItems.map((item)=>item);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
        container: true,
        gap: 2,
        mt: 2,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $ab312a9d0a7c7993$export$2e2bcd8739ae039), {
                    variant: "rounded",
                    height: 60
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: getSkeletonAnimations()
            })
        ]
    });
};
const $43fd4d081f3eea77$var$MoovyQueryHandler = ({ query: query, rootPageIfNotFoundError: rootPageIfNotFoundError, children: children })=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    if (rootPageIfNotFoundError) (0, $72c1b40a1572cee0$export$e32ce87e5105839e)(navigate, query.error);
    const noDataAnimation = query.isFetching && !query.data;
    const dataAnimation = query.isFetching && !!query.data;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            query.isError ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $0ad050a15234ec76$export$2e2bcd8739ae039), {}) : noDataAnimation ? /*#__PURE__*/ (0, $592Nh.jsx)($43fd4d081f3eea77$var$ProgressAnimation, {}) : /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)($43fd4d081f3eea77$var$BackdropAnimation, {
                        show: dataAnimation
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                query: query,
                errorTitleKey: "common.actions.get.error"
            })
        ]
    });
};
var $43fd4d081f3eea77$export$2e2bcd8739ae039 = $43fd4d081f3eea77$var$MoovyQueryHandler;





var $592Nh = parcelRequire("592Nh");


var $592Nh = parcelRequire("592Nh");








var $592Nh = parcelRequire("592Nh");



parcelRequire("2hDQc");

const $39b43260797a31d6$var$CataloguePlaceInfo = ({ place: place })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const data = [
        {
            label: intl.formatMessage({
                id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.name"
            }),
            value: place?.name
        },
        {
            label: intl.formatMessage({
                id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.street"
            }),
            value: `${(0, $ee9cb80b5c23ac97$export$ff20516246215bf)(place?.streetAddress, place?.postalCode, ", ")} ${place?.city}`
        },
        {
            label: intl.formatMessage({
                id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.capacity"
            }),
            value: place?.capacity
        }
    ];
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("h3", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.title"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {
                style: {
                    marginBottom: "20px"
                }
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                data: data,
                splitByMiddle: true
            })
        ]
    });
};
var $39b43260797a31d6$export$2e2bcd8739ae039 = $39b43260797a31d6$var$CataloguePlaceInfo;



var $592Nh = parcelRequire("592Nh");



parcelRequire("2hDQc");

const $fe7312e28f7f7475$var$CatalogueStatusInfo = ({ catalogue: catalogue, whitelistOffering: whitelistOffering })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const grantAmount = catalogue?.amount || 0;
    const grantedAmount = catalogue?.activeRights || 0;
    const data = [];
    !whitelistOffering && data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.grantAmount"
        }),
        value: grantAmount
    });
    data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.grantedAmount"
        }),
        value: whitelistOffering ? grantedAmount : (0, $ee9cb80b5c23ac97$export$ec9646ddc27ee461)(grantAmount, grantedAmount)
    });
    if (catalogue?.costCenter) data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.costCenter"
        }),
        value: catalogue.costCenter
    });
    if (catalogue?.project) data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.project"
        }),
        value: catalogue.project
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("h3", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.catalogues.tabCatalogue.catalogueStatusInfo.title"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {
                style: {
                    marginBottom: "20px"
                }
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                data: data,
                splitByMiddle: true
            })
        ]
    });
};
var $fe7312e28f7f7475$export$2e2bcd8739ae039 = $fe7312e28f7f7475$var$CatalogueStatusInfo;






const $0b5c38c6bf15e48a$var$BASE_URL = "offerings";
const $0b5c38c6bf15e48a$var$getOfferingById = (id)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/${$0b5c38c6bf15e48a$var$BASE_URL}/${id}`).then((response)=>response.data);
};
const $0b5c38c6bf15e48a$var$createOffering = (placeRef, offering)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/places/${placeRef}/offering`, offering);
};
const $0b5c38c6bf15e48a$var$updateOffering = (ref, placeRef, offering)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).put(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/places/${placeRef}/${$0b5c38c6bf15e48a$var$BASE_URL}/${ref}`, offering);
};
const $0b5c38c6bf15e48a$var$getRightHoldersByOffering = (offeringId, queryParams)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${(0, $1ff9aa7c00d3fc54$export$f654b28f82155665)(false)}/offerings/${offeringId}/active-rights`, {
        params: queryParams
    }).then((response)=>response.data);
};
const $0b5c38c6bf15e48a$export$ca807e2054383e2d = {
    getOfferingById: $0b5c38c6bf15e48a$var$getOfferingById,
    createOffering: $0b5c38c6bf15e48a$var$createOffering,
    updateOffering: $0b5c38c6bf15e48a$var$updateOffering,
    getRightHoldersByOffering: $0b5c38c6bf15e48a$var$getRightHoldersByOffering
};



var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");


var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $2hDQc = parcelRequire("2hDQc");
/**
 * Provides information about the current step in Stepper.
 */ const $005b27a8131ae577$var$StepperContext = /*#__PURE__*/ $2hDQc.createContext({});
function $005b27a8131ae577$export$1ff9b16b13b0447() {
    return $2hDQc.useContext($005b27a8131ae577$var$StepperContext);
}
var $005b27a8131ae577$export$2e2bcd8739ae039 = $005b27a8131ae577$var$StepperContext;



var $2hDQc = parcelRequire("2hDQc");
/**
 * Provides information about the current step in Stepper.
 */ const $8142b8ee407bb70e$var$StepContext = /*#__PURE__*/ $2hDQc.createContext({});
function $8142b8ee407bb70e$export$90d5f24cfecec416() {
    return $2hDQc.useContext($8142b8ee407bb70e$var$StepContext);
}
var $8142b8ee407bb70e$export$2e2bcd8739ae039 = $8142b8ee407bb70e$var$StepContext;



var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $8465a1a4c465d7ad$export$8977e0f3c012cfac(slot) {
    return (0, $01COD.default)("MuiStep", slot);
}
const $8465a1a4c465d7ad$var$stepClasses = (0, $eLydt.default)("MuiStep", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "completed"
]);
var $8465a1a4c465d7ad$export$2e2bcd8739ae039 = $8465a1a4c465d7ad$var$stepClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $bcdb9f1f7c6b0b25$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $bcdb9f1f7c6b0b25$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            completed && "completed"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $8465a1a4c465d7ad$export$8977e0f3c012cfac), classes);
};
const $bcdb9f1f7c6b0b25$var$StepRoot = (0, $fhlQp.default)("div", {
    name: "MuiStep",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({}, ownerState.orientation === "horizontal" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: "relative"
    }));
const $bcdb9f1f7c6b0b25$var$Step = /*#__PURE__*/ $2hDQc.forwardRef(function Step(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiStep"
    });
    const { active: activeProp, children: children, className: className, component: component = "div", completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $gZOiq.default)(props, $bcdb9f1f7c6b0b25$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $2hDQc.useContext((0, $005b27a8131ae577$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $2hDQc.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $bcdb9f1f7c6b0b25$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $592Nh.jsxs)($bcdb9f1f7c6b0b25$var$StepRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8142b8ee407bb70e$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $bcdb9f1f7c6b0b25$export$2e2bcd8739ae039 = $bcdb9f1f7c6b0b25$var$Step;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");
parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $abe1ff50fdda8b48$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle");


parcelRequire("2hDQc");

var $koHCo = parcelRequire("koHCo");

var $592Nh = parcelRequire("592Nh");
"use client";
var $f429e5f7d54590aa$export$2e2bcd8739ae039 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");



var $iOTXZ = parcelRequire("iOTXZ");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $614e380a501246e3$export$62a6e0748bec9297(slot) {
    return (0, $01COD.default)("MuiStepIcon", slot);
}
const $614e380a501246e3$var$stepIconClasses = (0, $eLydt.default)("MuiStepIcon", [
    "root",
    "active",
    "completed",
    "error",
    "text"
]);
var $614e380a501246e3$export$2e2bcd8739ae039 = $614e380a501246e3$var$stepIconClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
var $f56f9eabd2587cc8$var$_circle;
const $f56f9eabd2587cc8$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $f56f9eabd2587cc8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active",
            completed && "completed",
            error && "error"
        ],
        text: [
            "text"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $614e380a501246e3$export$62a6e0748bec9297), classes);
};
const $f56f9eabd2587cc8$var$StepIconRoot = (0, $fhlQp.default)((0, $iOTXZ.default), {
    name: "MuiStepIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $614e380a501246e3$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $614e380a501246e3$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $614e380a501246e3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $f56f9eabd2587cc8$var$StepIconText = (0, $fhlQp.default)("text", {
    name: "MuiStepIcon",
    slot: "Text",
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $f56f9eabd2587cc8$var$StepIcon = /*#__PURE__*/ $2hDQc.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiStepIcon"
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $gZOiq.default)(props, $f56f9eabd2587cc8$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $f56f9eabd2587cc8$var$useUtilityClasses(ownerState);
    if (typeof icon === "number" || typeof icon === "string") {
        const className = (0, $fLRFO.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $592Nh.jsx)($f56f9eabd2587cc8$var$StepIconRoot, (0, $kxIgO.default)({
            as: (0, $f429e5f7d54590aa$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $592Nh.jsx)($f56f9eabd2587cc8$var$StepIconRoot, (0, $kxIgO.default)({
            as: (0, $abe1ff50fdda8b48$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $592Nh.jsxs)($f56f9eabd2587cc8$var$StepIconRoot, (0, $kxIgO.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $f56f9eabd2587cc8$var$_circle || ($f56f9eabd2587cc8$var$_circle = /*#__PURE__*/ (0, $592Nh.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $592Nh.jsx)($f56f9eabd2587cc8$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $f56f9eabd2587cc8$export$2e2bcd8739ae039 = $f56f9eabd2587cc8$var$StepIcon;





var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $ff867f32f1d6f467$export$9625a725551d158a(slot) {
    return (0, $01COD.default)("MuiStepLabel", slot);
}
const $ff867f32f1d6f467$var$stepLabelClasses = (0, $eLydt.default)("MuiStepLabel", [
    "root",
    "horizontal",
    "vertical",
    "label",
    "active",
    "completed",
    "error",
    "disabled",
    "iconContainer",
    "alternativeLabel",
    "labelContainer"
]);
var $ff867f32f1d6f467$export$2e2bcd8739ae039 = $ff867f32f1d6f467$var$stepLabelClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $af0cc4b2992db34c$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $af0cc4b2992db34c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        label: [
            "label",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        iconContainer: [
            "iconContainer",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        labelContainer: [
            "labelContainer",
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $ff867f32f1d6f467$export$9625a725551d158a), classes);
};
const $af0cc4b2992db34c$var$StepLabelRoot = (0, $fhlQp.default)("span", {
    name: "MuiStepLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        alignItems: "center",
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: "column"
        },
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.orientation === "vertical" && {
        textAlign: "left",
        padding: "8px 0"
    }));
const $af0cc4b2992db34c$var$StepLabelLabel = (0, $fhlQp.default)("span", {
    name: "MuiStepLabel",
    slot: "Label",
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $kxIgO.default)({}, theme.typography.body2, {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $af0cc4b2992db34c$var$StepLabelIconContainer = (0, $fhlQp.default)("span", {
    name: "MuiStepLabel",
    slot: "IconContainer",
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: "flex",
        paddingRight: 8,
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $af0cc4b2992db34c$var$StepLabelLabelContainer = (0, $fhlQp.default)("span", {
    name: "MuiStepLabel",
    slot: "LabelContainer",
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: "100%",
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ff867f32f1d6f467$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: "center"
        }
    }));
const $af0cc4b2992db34c$var$StepLabel = /*#__PURE__*/ $2hDQc.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiStepLabel"
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $gZOiq.default)(props, $af0cc4b2992db34c$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $2hDQc.useContext((0, $005b27a8131ae577$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $2hDQc.useContext((0, $8142b8ee407bb70e$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $f56f9eabd2587cc8$export$2e2bcd8739ae039);
    const ownerState = (0, $kxIgO.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $af0cc4b2992db34c$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($af0cc4b2992db34c$var$StepLabelRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $592Nh.jsx)($af0cc4b2992db34c$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $592Nh.jsx)(StepIconComponent, (0, $kxIgO.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $592Nh.jsxs)($af0cc4b2992db34c$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $592Nh.jsx)($af0cc4b2992db34c$var$StepLabelLabel, (0, $kxIgO.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $fLRFO.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$af0cc4b2992db34c$var$StepLabel.muiName = "StepLabel";
var $af0cc4b2992db34c$export$2e2bcd8739ae039 = $af0cc4b2992db34c$var$StepLabel;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $8e118fe140f77b32$export$797947b6292e28e1(slot) {
    return (0, $01COD.default)("MuiStepper", slot);
}
const $8e118fe140f77b32$var$stepperClasses = (0, $eLydt.default)("MuiStepper", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel"
]);
var $8e118fe140f77b32$export$2e2bcd8739ae039 = $8e118fe140f77b32$var$stepperClasses;



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $lfMLv = parcelRequire("lfMLv");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");



var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $34cab54a1ad38698$export$6fbaff484b0d9308(slot) {
    return (0, $01COD.default)("MuiStepConnector", slot);
}
const $34cab54a1ad38698$var$stepConnectorClasses = (0, $eLydt.default)("MuiStepConnector", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "active",
    "completed",
    "disabled",
    "line",
    "lineHorizontal",
    "lineVertical"
]);
var $34cab54a1ad38698$export$2e2bcd8739ae039 = $34cab54a1ad38698$var$stepConnectorClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $8a5134c3b1844c8e$var$_excluded = [
    "className"
];
const $8a5134c3b1844c8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            active && "active",
            completed && "completed",
            disabled && "disabled"
        ],
        line: [
            "line",
            `line${(0, $lfMLv.default)(orientation)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $34cab54a1ad38698$export$6fbaff484b0d9308), classes);
};
const $8a5134c3b1844c8e$var$StepConnectorRoot = (0, $fhlQp.default)("div", {
    name: "MuiStepConnector",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        flex: "1 1 auto"
    }, ownerState.orientation === "vertical" && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: "absolute",
        top: 12,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)"
    }));
const $8a5134c3b1844c8e$var$StepConnectorLine = (0, $fhlQp.default)("span", {
    name: "MuiStepConnector",
    slot: "Line",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $lfMLv.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $kxIgO.default)({
        display: "block",
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === "horizontal" && {
        borderTopStyle: "solid",
        borderTopWidth: 1
    }, ownerState.orientation === "vertical" && {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $8a5134c3b1844c8e$var$StepConnector = /*#__PURE__*/ $2hDQc.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiStepConnector"
    });
    const { className: className } = props, other = (0, $gZOiq.default)(props, $8a5134c3b1844c8e$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = "horizontal" } = $2hDQc.useContext((0, $005b27a8131ae577$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $2hDQc.useContext((0, $8142b8ee407bb70e$export$2e2bcd8739ae039));
    const ownerState = (0, $kxIgO.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $8a5134c3b1844c8e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($8a5134c3b1844c8e$var$StepConnectorRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($8a5134c3b1844c8e$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $8a5134c3b1844c8e$export$2e2bcd8739ae039 = $8a5134c3b1844c8e$var$StepConnector;




var $592Nh = parcelRequire("592Nh");
"use client";
const $7339a81857f49d36$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $7339a81857f49d36$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $8e118fe140f77b32$export$797947b6292e28e1), classes);
};
const $7339a81857f49d36$var$StepperRoot = (0, $fhlQp.default)("div", {
    name: "MuiStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex"
    }, ownerState.orientation === "horizontal" && {
        flexDirection: "row",
        alignItems: "center"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.alternativeLabel && {
        alignItems: "flex-start"
    }));
const $7339a81857f49d36$var$defaultConnector = /*#__PURE__*/ (0, $592Nh.jsx)((0, $8a5134c3b1844c8e$export$2e2bcd8739ae039), {});
const $7339a81857f49d36$var$Stepper = /*#__PURE__*/ $2hDQc.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiStepper"
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = "div", connector: connector = $7339a81857f49d36$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = "horizontal" } = props, other = (0, $gZOiq.default)(props, $7339a81857f49d36$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $7339a81857f49d36$var$useUtilityClasses(ownerState);
    const childrenArray = $2hDQc.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $2hDQc.cloneElement(step, (0, $kxIgO.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $2hDQc.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $005b27a8131ae577$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($7339a81857f49d36$var$StepperRoot, (0, $kxIgO.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fLRFO.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $7339a81857f49d36$export$2e2bcd8739ae039 = $7339a81857f49d36$var$Stepper;




var $2hDQc = parcelRequire("2hDQc");
const $335b32823e91bbd2$export$e49861a9373f5f25 = (rightHolder)=>{
    if (rightHolder.type === "individual") {
        const dataIndividual = rightHolder;
        return `${dataIndividual.firstName}${dataIndividual.firstName ? " " : ""}${dataIndividual.lastName}`;
    } else if (rightHolder.type === "vehicle") {
        const dataVehicle = rightHolder;
        return dataVehicle.licensePlate;
    }
    return "";
};



var $c066d1c6ec749c12$exports = {};
"use strict";
"use client";

Object.defineProperty($c066d1c6ec749c12$exports, "__esModule", {
    value: true
});
$c066d1c6ec749c12$exports.default = void 0;

var $c066d1c6ec749c12$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $c066d1c6ec749c12$var$_default = $c066d1c6ec749c12$exports.default = (0, $c066d1c6ec749c12$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V6h16zM4 0h16v2H4zm0 22h16v2H4zm8-10c1.38 0 2.5-1.12 2.5-2.5S13.38 7 12 7 9.5 8.12 9.5 9.5 10.62 12 12 12m0-3.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m5 7.49C17 13.9 13.69 13 12 13s-5 .9-5 2.99V17h10zm-8.19-.49c.61-.52 2.03-1 3.19-1 1.17 0 2.59.48 3.2 1z"
}), "ContactsOutlined");



var $b240c3693ff60c3d$exports = {};
"use strict";
"use client";

Object.defineProperty($b240c3693ff60c3d$exports, "__esModule", {
    value: true
});
$b240c3693ff60c3d$exports.default = void 0;

var $b240c3693ff60c3d$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $b240c3693ff60c3d$var$_default = $b240c3693ff60c3d$exports.default = (0, $b240c3693ff60c3d$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $592Nh.jsx)("path", {
        d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9"
    }, "0"),
    /*#__PURE__*/ (0, $592Nh.jsx)("circle", {
        cx: "12",
        cy: "9",
        r: "2.5"
    }, "1")
], "LocationOnOutlined");






const $6d5f4ec705c7ab18$var$BASE_URL = `${(0, $1ff9aa7c00d3fc54$export$ff0725f0ea898f41)}/individuals`;
const $6d5f4ec705c7ab18$var$createIndividual = (rightHolder)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post($6d5f4ec705c7ab18$var$BASE_URL, rightHolder);
};
const $6d5f4ec705c7ab18$var$updateIndividual = (rightHolderRef, rightHolder)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).put(`${$6d5f4ec705c7ab18$var$BASE_URL}/${rightHolderRef}`, rightHolder);
};
const $6d5f4ec705c7ab18$var$getIndividualByRef = (ref)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get(`${$6d5f4ec705c7ab18$var$BASE_URL}/${ref}`).then((response)=>response.data);
};
const $6d5f4ec705c7ab18$var$getIndividualsByEmail = (email)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).get($6d5f4ec705c7ab18$var$BASE_URL, {
        params: {
            email: email
        }
    }).then((response)=>response.data);
};
const $6d5f4ec705c7ab18$var$grantRightToIndividual = (ref, data)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${$6d5f4ec705c7ab18$var$BASE_URL}/${ref}/grant-right`, data);
};
const $6d5f4ec705c7ab18$var$grantRightToVehicle = (data)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${(0, $1ff9aa7c00d3fc54$export$ff0725f0ea898f41)}/vehicles/grant-right`, data);
};
const $6d5f4ec705c7ab18$var$RightHoldersAPI = {
    createIndividual: $6d5f4ec705c7ab18$var$createIndividual,
    updateIndividual: $6d5f4ec705c7ab18$var$updateIndividual,
    getIndividualByRef: $6d5f4ec705c7ab18$var$getIndividualByRef,
    getIndividualsByEmail: $6d5f4ec705c7ab18$var$getIndividualsByEmail,
    grantRightToIndividual: $6d5f4ec705c7ab18$var$grantRightToIndividual,
    grantRightToVehicle: $6d5f4ec705c7ab18$var$grantRightToVehicle
};
var $6d5f4ec705c7ab18$export$2e2bcd8739ae039 = $6d5f4ec705c7ab18$var$RightHoldersAPI;



var $592Nh = parcelRequire("592Nh");

var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");


var $5pzCu = parcelRequire("5pzCu");



function $4236c3996bc2da77$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $2hDQc = parcelRequire("2hDQc");



var $afHYP = parcelRequire("afHYP");




var $2hDQc = parcelRequire("2hDQc");

var $bZSVP = parcelRequire("bZSVP");
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $e70b7281efcbe69a$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $e70b7281efcbe69a$export$2e2bcd8739ae039 = $e70b7281efcbe69a$var$resolveComponentProps;



var $bZSVP = parcelRequire("bZSVP");
const $4d48afa0e5078fc9$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object
]);
var $4d48afa0e5078fc9$export$2e2bcd8739ae039 = $4d48afa0e5078fc9$var$refType;




const $bd76bef4ec2caf62$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $bd76bef4ec2caf62$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error("MUI X: The `views` prop must contain at least one view.");
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $6008d551a5f07604$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    mergedDate = utils.setMilliseconds(mergedDate, utils.getMilliseconds(timeParam));
    return mergedDate;
};
const $6008d551a5f07604$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = $6008d551a5f07604$export$a98b123b8f29e004(utils, utils.date(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $6008d551a5f07604$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $6008d551a5f07604$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $6008d551a5f07604$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $6008d551a5f07604$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $6008d551a5f07604$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === "date" ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const $6008d551a5f07604$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === "am" ? 2 : 14);
    return utils.format(date, "meridiem");
};
const $6008d551a5f07604$var$dateViews = [
    "year",
    "month",
    "day"
];
const $6008d551a5f07604$export$b32dfef9f07dea64 = (view)=>$6008d551a5f07604$var$dateViews.includes(view);
const $6008d551a5f07604$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "year"
    ])) return formats.year;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "month"
    ])) return formats.month;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "day"
    ])) return formats.dayOfMonth;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "month",
        "year"
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "day",
        "month"
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $6008d551a5f07604$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $9aafba1b8c629c28$var$timeViews = [
    "hours",
    "minutes",
    "seconds"
];
const $9aafba1b8c629c28$export$8f04d380cefd5a0d = (view)=>$9aafba1b8c629c28$var$timeViews.includes(view);
const $9aafba1b8c629c28$export$a3328136ac50623d = (view)=>$9aafba1b8c629c28$var$timeViews.includes(view) || view === "meridiem";
const $9aafba1b8c629c28$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const $9aafba1b8c629c28$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const $9aafba1b8c629c28$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $9aafba1b8c629c28$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $9aafba1b8c629c28$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $9aafba1b8c629c28$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $9aafba1b8c629c28$export$888a1ce13aa61986(dateLeft, utils) > $9aafba1b8c629c28$export$888a1ce13aa61986(dateRight, utils);
    };
const $9aafba1b8c629c28$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "hours"
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "minutes"
    ])) return formats.minutes;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "seconds"
    ])) return formats.seconds;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "minutes",
        "seconds"
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $bd76bef4ec2caf62$export$f07872cd524bec98)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $bfb695e56b2e7def$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$bfb695e56b2e7def$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $bfb695e56b2e7def$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $bfb695e56b2e7def$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $bfb695e56b2e7def$var$roundDate(utils, granularity, (0, $6008d551a5f07604$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $bfb695e56b2e7def$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $bfb695e56b2e7def$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $9aafba1b8c629c28$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $bfb695e56b2e7def$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $6008d551a5f07604$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $bfb695e56b2e7def$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $6008d551a5f07604$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



const $f98be61bc28ae2a3$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."
    ].join("\n"));
    if (typeof config === "string") return {
        type: config,
        contentType: config === "meridiem" ? "letter" : "digit",
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $f98be61bc28ae2a3$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case "ArrowUp":
            return 1;
        case "ArrowDown":
            return -1;
        case "PageUp":
            return 5;
        case "PageDown":
            return -5;
        default:
            return 0;
    }
};
const $f98be61bc28ae2a3$export$c65c7173f879039f = (utils, format)=>{
    const elements = [];
    const now = utils.date(undefined, "default");
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $f98be61bc28ae2a3$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case "month":
            return (0, $6008d551a5f07604$export$62591b96a734eacd)(utils, utils.date(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case "weekDay":
            return $f98be61bc28ae2a3$export$c65c7173f879039f(utils, format);
        case "meridiem":
            {
                const now = utils.date(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $f98be61bc28ae2a3$export$b918512475916205 = "s";
const $f98be61bc28ae2a3$var$NON_LOCALIZED_DIGITS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
const $f98be61bc28ae2a3$export$b42be9ae7016ef5d = (utils)=>{
    const today = utils.date(undefined);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), $f98be61bc28ae2a3$export$b918512475916205);
    if (formattedZero === "0") return $f98be61bc28ae2a3$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), $f98be61bc28ae2a3$export$b918512475916205));
};
const $f98be61bc28ae2a3$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === "0") return valueStr;
    const digits = [];
    let currentFormattedDigit = "";
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = "";
        }
    }
    return digits.join("");
};
const $f98be61bc28ae2a3$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === "0") return valueStr;
    return valueStr.split("").map((char)=>localizedDigits[Number(char)]).join("");
};
const $f98be61bc28ae2a3$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $f98be61bc28ae2a3$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== " " && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $f98be61bc28ae2a3$export$713c6d756c12fc27 = (valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $f98be61bc28ae2a3$export$ef88db4bceade9fd = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === "day" && section.contentType === "digit-with-letter") {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $f98be61bc28ae2a3$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $f98be61bc28ae2a3$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $f98be61bc28ae2a3$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes)=>{
    const delta = $f98be61bc28ae2a3$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === "Home";
    const isEnd = keyCode === "End";
    const shouldSetAbsolute = section.value === "" || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$f98be61bc28ae2a3$export$ef88db4bceade9fd(utils, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === "minutes" && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt($f98be61bc28ae2a3$export$7dd321105a319e8(section.value, localizedDigits), 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === "year" && !isEnd && !isStart) return utils.formatByString(utils.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $f98be61bc28ae2a3$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === "digit" || section.contentType === "digit-with-letter") return adjustDigitSection();
    return adjustLetterSection();
};
const $f98be61bc28ae2a3$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($f98be61bc28ae2a3$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        "input-rtl",
        "input-ltr"
    ].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === "input-rtl") value = `\u2068${value}\u2069`;
    return value;
};
const $f98be61bc28ae2a3$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $f98be61bc28ae2a3$var$isFourDigitYearFormat = (utils, format)=>utils.formatByString(utils.date(undefined, "system"), format).length === 4;
const $f98be61bc28ae2a3$export$78b5830e2dd2de49 = (utils, contentType, sectionType, format)=>{
    if (contentType !== "digit") return false;
    const now = utils.date(undefined, "default");
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case "year":
            {
                if ($f98be61bc28ae2a3$var$isFourDigitYearFormat(utils, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === "0001";
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === "01";
            }
        case "month":
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case "day":
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case "weekDay":
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case "hours":
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case "minutes":
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case "seconds":
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error("Invalid section type");
    }
};
const $f98be61bc28ae2a3$export$b0c1bfd065bfe742 = (utils, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === "day");
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($f98be61bc28ae2a3$export$85daa91f6c6e875f(section, "non-input", localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(" ");
    const dateWithoutSeparatorStr = sectionValues.join(" ");
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $f98be61bc28ae2a3$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join("");
const $f98be61bc28ae2a3$export$7ffdf006c6dc825f = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $f98be61bc28ae2a3$export$85daa91f6c6e875f(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join("");
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $f98be61bc28ae2a3$export$360600f456ea7d5f = (utils, localizedDigits, timezone)=>{
    const today = utils.date(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $6008d551a5f07604$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $f98be61bc28ae2a3$var$isFourDigitYearFormat(utils, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === "digit") {
                const daysInWeek = $f98be61bc28ae2a3$export$c65c7173f879039f(utils, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = $f98be61bc28ae2a3$export$7dd321105a319e8(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($f98be61bc28ae2a3$export$7dd321105a319e8(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $f98be61bc28ae2a3$var$warnedOnceInvalidSection = false;
const $f98be61bc28ae2a3$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $f98be61bc28ae2a3$var$transferDateSectionValue = (utils, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case "year":
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case "month":
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case "weekDay":
            {
                const formattedDaysInWeek = $f98be61bc28ae2a3$export$c65c7173f879039f(utils, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case "day":
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case "meridiem":
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case "hours":
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case "minutes":
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case "seconds":
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $f98be61bc28ae2a3$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $f98be61bc28ae2a3$export$6c6df982c77f60a9 = (utils, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$f98be61bc28ae2a3$var$reliableSectionModificationOrder[a.type] - $f98be61bc28ae2a3$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $f98be61bc28ae2a3$var$transferDateSectionValue(utils, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $f98be61bc28ae2a3$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().includes("android");
const $f98be61bc28ae2a3$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
            section.endSeparator !== " / ");
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $f98be61bc28ae2a3$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === "all") return "all";
    if (typeof selectedSections === "string") return sections.findIndex((section)=>section.type === selectedSections);
    return selectedSections;
};
const $f98be61bc28ae2a3$export$b5e30842500b6cab = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case "month":
            {
                if (section.contentType === "digit") return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), "month");
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, "month") : undefined;
            }
        case "day":
            return section.contentType === "digit" ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), "dayOfMonthFull") : section.value;
        case "weekDay":
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
};
const $f98be61bc28ae2a3$export$b46fd324c5adcf31 = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case "weekDay":
            if (section.contentType === "letter") // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case "meridiem":
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case "day":
            return section.contentType === "digit-with-letter" ? parseInt(section.value, 10) : Number(section.value);
        case "month":
            {
                if (section.contentType === "digit") return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== "letter" ? Number(section.value) : undefined;
    }
};


const $60e2396f80eb3f46$var$_excluded = [
    "value",
    "referenceDate"
];
const $60e2396f80eb3f46$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $6008d551a5f07604$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $60e2396f80eb3f46$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $bfb695e56b2e7def$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $6008d551a5f07604$export$36ca889e039badd5),
    areValuesEqual: (0, $6008d551a5f07604$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $60e2396f80eb3f46$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return getSectionsFromDate(date);
    },
    getV7HiddenInputValueFromSections: (0, $f98be61bc28ae2a3$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $f98be61bc28ae2a3$export$7ffdf006c6dc825f),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};





var $2hDQc = parcelRequire("2hDQc");



var $afHYP = parcelRequire("afHYP");

var $2hDQc = parcelRequire("2hDQc");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $8966033e32fdfbaa$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $7685748376ebf0ad$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $2hDQc.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $8966033e32fdfbaa$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $aebc90c7f3145674$var$isHostComponent(element) {
    return typeof element === "string";
}
var $aebc90c7f3145674$export$2e2bcd8739ae039 = $aebc90c7f3145674$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $ac77a25c5fbd972f$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $aebc90c7f3145674$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $ac77a25c5fbd972f$export$2e2bcd8739ae039 = $ac77a25c5fbd972f$var$appendOwnerState;


function $5cb909bd25998edc$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $5cb909bd25998edc$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $5cb909bd25998edc$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $5cb909bd25998edc$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5cb909bd25998edc$export$2e2bcd8739ae039 = $5cb909bd25998edc$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $19f38625b862c177$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $19f38625b862c177$export$2e2bcd8739ae039 = $19f38625b862c177$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $b0bb85c49b68ddfa$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $b0bb85c49b68ddfa$export$2e2bcd8739ae039 = $b0bb85c49b68ddfa$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $7309bdeb61cfc46a$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $19f38625b862c177$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $b0bb85c49b68ddfa$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $b0bb85c49b68ddfa$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $7309bdeb61cfc46a$export$2e2bcd8739ae039 = $7309bdeb61cfc46a$var$mergeSlotProps;



"use client";
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $1543fd145b554948$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $7309bdeb61cfc46a$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $ac77a25c5fbd972f$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $1543fd145b554948$export$2e2bcd8739ae039 = $1543fd145b554948$var$useSlotProps;






var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $7bdf63f5b8ef95fd$var$useEnhancedEffect = typeof window !== "undefined" ? $2hDQc.useLayoutEffect : $2hDQc.useEffect;
var $7bdf63f5b8ef95fd$export$2e2bcd8739ae039 = $7bdf63f5b8ef95fd$var$useEnhancedEffect;



var $2hDQc = parcelRequire("2hDQc");

"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b61557e39989b411$var$useEventCallback(fn) {
    const ref = $2hDQc.useRef(fn);
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $2hDQc.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b61557e39989b411$export$2e2bcd8739ae039 = $b61557e39989b411$var$useEventCallback;



var $2hDQc = parcelRequire("2hDQc");


var $592Nh = parcelRequire("592Nh");
const $ac632f976f38c6a5$var$RtlContext = /*#__PURE__*/ $2hDQc.createContext();
function $ac632f976f38c6a5$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $592Nh.jsx)($ac632f976f38c6a5$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $ac632f976f38c6a5$export$b2dd014b6c321cb = ()=>{
    const value = $2hDQc.useContext($ac632f976f38c6a5$var$RtlContext);
    return value ?? false;
};
var $ac632f976f38c6a5$export$2e2bcd8739ae039 = $ac632f976f38c6a5$var$RtlProvider;



var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");


var $afHYP = parcelRequire("afHYP");

var $592Nh = parcelRequire("592Nh");
"use client";
const $cfd5de74b2d9a49e$var$_excluded = [
    "localeText"
];
const $cfd5de74b2d9a49e$export$544976378534cf9 = /*#__PURE__*/ $2hDQc.createContext(null);
const $cfd5de74b2d9a49e$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(inProps, $cfd5de74b2d9a49e$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = $2hDQc.useContext($cfd5de74b2d9a49e$export$544976378534cf9) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $afHYP.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $2hDQc.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            "MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`",
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $2hDQc.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $2hDQc.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)($cfd5de74b2d9a49e$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



const $e19c1a6a3395907f$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};
const $e19c1a6a3395907f$export$7eae96bf9dd7ca56 = (params)=>{
    const { utils: utils, formatKey: formatKey, contextTranslation: contextTranslation, propsTranslation: propsTranslation } = params;
    return (value)=>{
        const formattedValue = value !== null && utils.isValid(value) ? utils.format(value, formatKey) : null;
        const translation = propsTranslation ?? contextTranslation;
        return translation(value, utils, formattedValue);
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $7bb4f9784d7a27d6$var$enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "Open previous view",
    openNextView: "Open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    // DateRange labels
    start: "Start",
    end: "End",
    startDate: "Start date",
    startTime: "Start time",
    endDate: "End date",
    endTime: "End time",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerToolbarTitle: "Select date",
    dateTimePickerToolbarTitle: "Select date & time",
    timePickerToolbarTitle: "Select time",
    dateRangePickerToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, utils, formattedTime)=>`Select ${view}. ${!formattedTime && (time === null || !utils.isValid(time)) ? "No time selected" : `Selected time is ${formattedTime ?? utils.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "Week number",
    calendarWeekNumberHeaderText: "#",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils, formattedDate)=>formattedDate || value !== null && utils.isValid(value) ? `Choose date, selected date is ${formattedDate ?? utils.format(value, "fullDate")}` : "Choose date",
    openTimePickerDialogue: (value, utils, formattedTime)=>formattedTime || value !== null && utils.isValid(value) ? `Choose time, selected time is ${formattedTime ?? utils.format(value, "fullTime")}` : "Choose time",
    fieldClearLabel: "Clear",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"Y".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "MMMM" : "MM",
    fieldDayPlaceholder: ()=>"DD",
    fieldWeekDayPlaceholder: (params)=>params.contentType === "letter" ? "EEEE" : "EE",
    fieldHoursPlaceholder: ()=>"hh",
    fieldMinutesPlaceholder: ()=>"mm",
    fieldSecondsPlaceholder: ()=>"ss",
    fieldMeridiemPlaceholder: ()=>"aa",
    // View names
    year: "Year",
    month: "Month",
    day: "Day",
    weekDay: "Week day",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    meridiem: "Meridiem",
    // Common
    empty: "Empty"
};
const $7bb4f9784d7a27d6$export$1af4c7e47ad72f44 = $7bb4f9784d7a27d6$var$enUSPickers;
const $7bb4f9784d7a27d6$export$137380d9ce54f7f = (0, $e19c1a6a3395907f$export$67c96d35a1b010b3)($7bb4f9784d7a27d6$var$enUSPickers);


const $404db1959acab970$export$4b5a24245de9f7f9 = ()=>{
    const localization = $2hDQc.useContext((0, $cfd5de74b2d9a49e$export$544976378534cf9));
    if (localization === null) throw new Error([
        "MUI X: Can not find the date and time pickers localization context.",
        "It looks like you forgot to wrap your component in LocalizationProvider.",
        "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"
    ].join("\n"));
    if (localization.utils === null) throw new Error([
        "MUI X: Can not find the date and time pickers adapter from its localization context.",
        "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."
    ].join("\n"));
    const localeText = $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $7bb4f9784d7a27d6$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $404db1959acab970$export$1163b47e39508a46 = ()=>$404db1959acab970$export$4b5a24245de9f7f9().utils;
const $404db1959acab970$export$7c38da3a2e90fa83 = ()=>$404db1959acab970$export$4b5a24245de9f7f9().defaultDates;
const $404db1959acab970$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $404db1959acab970$export$1163b47e39508a46();
    const now = $2hDQc.useRef();
    if (now.current === undefined) now.current = utils.date(undefined, timezone);
    return now.current;
};


"use client";
function $6dac1f43294e1bc1$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $404db1959acab970$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $2hDQc.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $2hDQc.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}






var $2hDQc = parcelRequire("2hDQc");

var $2hDQc = parcelRequire("2hDQc");
"use client";
function $380b9a9318603e37$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $2hDQc.useRef(controlled !== undefined);
    const [valueState, setValue] = $2hDQc.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $2hDQc.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}




"use client";
const $802219c7e61ac159$export$3cdcc56057891b44 = ()=>(0, $404db1959acab970$export$4b5a24245de9f7f9)().localeText;






const $c38a5ed37bcb88b0$var$expandFormat = ({ utils: utils, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
    }
    return nextFormat;
};
const $c38a5ed37bcb88b0$var$getEscapedPartsFromFormat = ({ utils: utils, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $c38a5ed37bcb88b0$var$getSectionPlaceholder = (utils, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case "year":
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(undefined, "default"), sectionFormat).length,
                format: sectionFormat
            });
        case "month":
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "day":
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case "weekDay":
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "hours":
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case "minutes":
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case "seconds":
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case "meridiem":
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $c38a5ed37bcb88b0$var$createSection = ({ utils: utils, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === "") throw new Error("MUI X: Should not call `commitToken` with an empty token");
    const sectionConfig = (0, $f98be61bc28ae2a3$export$2f3c5fac7a2a65f6)(utils, token);
    const hasLeadingZerosInFormat = (0, $f98be61bc28ae2a3$export$78b5830e2dd2de49)(utils, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : "";
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === "" ? utils.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $f98be61bc28ae2a3$export$80dbbc19eba82070)((0, $f98be61bc28ae2a3$export$713c6d756c12fc27)((0, $f98be61bc28ae2a3$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $c38a5ed37bcb88b0$var$getSectionPlaceholder(utils, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: "",
        modified: false
    });
};
const $c38a5ed37bcb88b0$var$buildSections = (params)=>{
    const { utils: utils, expandedFormat: expandedFormat, escapedParts: escapedParts } = params;
    const now = utils.date(undefined);
    const sections = [];
    let startSeparator = "";
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join("|")})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join("|")})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($c38a5ed37bcb88b0$var$createSection((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = "";
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: "empty",
        contentType: "letter",
        maxLength: null,
        format: "",
        value: "",
        placeholder: "",
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: "",
        modified: false
    });
    return sections;
};
const $c38a5ed37bcb88b0$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(" ")) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === "spacious" && [
                "/",
                ".",
                "-"
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $c38a5ed37bcb88b0$export$34084be60bfe3b3b = (params)=>{
    let expandedFormat = $c38a5ed37bcb88b0$var$expandFormat(params);
    if (params.isRtl && params.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(" ").reverse().join(" ");
    const escapedParts = $c38a5ed37bcb88b0$var$getEscapedPartsFromFormat((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params, {
        expandedFormat: expandedFormat
    }));
    const sections = $c38a5ed37bcb88b0$var$buildSections((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $c38a5ed37bcb88b0$var$postProcessSections((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params, {
        sections: sections
    }));
};



var $2hDQc = parcelRequire("2hDQc");



const $b42e00cec95bf032$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const firstDefaultValue = $2hDQc.useRef(defaultValue);
    const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
    const inputTimezone = $2hDQc.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = timezoneProp ?? inputTimezone ?? "default";
    const valueWithTimezoneToRender = $2hDQc.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $b42e00cec95bf032$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: name,
        state: "value",
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const onChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp?.(newValue, ...otherParams);
    });
    return $b42e00cec95bf032$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};



const $118c2511612b6079$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const adapter = (0, $404db1959acab970$export$4b5a24245de9f7f9)();
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = "dense", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $b42e00cec95bf032$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const localizedDigits = $2hDQc.useMemo(()=>(0, $f98be61bc28ae2a3$export$b42be9ae7016ef5d)(utils), [
        utils
    ]);
    const sectionsValueBoundaries = $2hDQc.useMemo(()=>(0, $f98be61bc28ae2a3$export$360600f456ea7d5f)(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $2hDQc.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date)=>(0, $c38a5ed37bcb88b0$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $2hDQc.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $f98be61bc28ae2a3$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $bfb695e56b2e7def$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: "useField",
        state: "selectedSections"
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $2hDQc.useMemo(()=>(0, $f98be61bc28ae2a3$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === "all" ? 0 : parsedSelectedSections;
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                timezone: timezone,
                props: internalProps
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== "").length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === "" ? 0 : 1);
        const newSections = setSectionValue(activeSectionIndex, "");
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        publishValue((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, newValues, {
            sections: newSections
        }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $c38a5ed37bcb88b0$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $f98be61bc28ae2a3$export$6c6df982c77f60a9)(utils, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $f98be61bc28ae2a3$export$b0c1bfd065bfe742)(utils, newActiveDateSections, localizedDigits);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $f98be61bc28ae2a3$export$6c6df982c77f60a9)(utils, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $2hDQc.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $f98be61bc28ae2a3$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale,
        isRtl
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $2hDQc.useEffect(()=>{
        let shouldUpdate;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        activeSectionIndex: activeSectionIndex,
        parsedSelectedSections: parsedSelectedSections,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        getSectionsFromValue: getSectionsFromValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        timezone: timezone
    };
};




var $2hDQc = parcelRequire("2hDQc");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $e675a520cf2ca79a$var$QUERY_LIFE_DURATION_MS = 5000;
const $e675a520cf2ca79a$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $e675a520cf2ca79a$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const [query, setQuery] = $2hDQc.useState(null);
    const resetQuery = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>setQuery(null));
    $2hDQc.useEffect(()=>{
        if (query != null && sections[query.sectionIndex]?.type !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $2hDQc.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $e675a520cf2ca79a$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$e675a520cf2ca79a$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($e675a520cf2ca79a$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($e675a520cf2ca79a$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $f98be61bc28ae2a3$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === "letter") return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $f98be61bc28ae2a3$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === "letter") {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($e675a520cf2ca79a$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case "month":
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $f98be61bc28ae2a3$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case "weekDay":
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case "meridiem":
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const cleanQueryValue = (0, $f98be61bc28ae2a3$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $f98be61bc28ae2a3$export$ef88db4bceade9fd)(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === "month") {
                const hasLeadingZerosInFormat = (0, $f98be61bc28ae2a3$export$78b5830e2dd2de49)(utils, "digit", "month", "MM");
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: "MM",
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: "digit",
                    maxLength: 2
                });
                if ($e675a520cf2ca79a$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $f98be61bc28ae2a3$export$2816862a602354ce)(utils, response.sectionValue, "MM", activeSection.format);
                return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === "weekDay") {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($e675a520cf2ca79a$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $f98be61bc28ae2a3$export$c65c7173f879039f)(utils, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $f98be61bc28ae2a3$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    const applyCharacterEditing = (0, $b61557e39989b411$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = (0, $f98be61bc28ae2a3$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params, {
            keyPressed: (0, $f98be61bc28ae2a3$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



var $2hDQc = parcelRequire("2hDQc");




var $2hDQc = parcelRequire("2hDQc");
"use client";
let $c2cd4d1945fef3ba$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $c2cd4d1945fef3ba$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $2hDQc.useState(idOverride);
    const id = idOverride || defaultId;
    $2hDQc.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $c2cd4d1945fef3ba$var$globalId += 1;
            setDefaultId(`mui-${$c2cd4d1945fef3ba$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $c2cd4d1945fef3ba$var$safeReact = {
    ...$2hDQc
};
const $c2cd4d1945fef3ba$var$maybeReactUseId = $c2cd4d1945fef3ba$var$safeReact.useId;
function $c2cd4d1945fef3ba$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($c2cd4d1945fef3ba$var$maybeReactUseId !== undefined) {
        const reactId = $c2cd4d1945fef3ba$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $c2cd4d1945fef3ba$var$useGlobalId(idOverride);
}



/* Use it instead of .includes method for IE support */ function $5e6b2caee8dd3380$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $5e6b2caee8dd3380$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $5e6b2caee8dd3380$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $5e6b2caee8dd3380$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $5e6b2caee8dd3380$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $5e6b2caee8dd3380$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($5e6b2caee8dd3380$export$cd4e5573fbe2b576(document));
};
const $5e6b2caee8dd3380$export$9ae5b19305db48ce = "@media (pointer: fine)";




const $3b7232d0ad2a9010$export$3b5f62b9baf9717e = (params)=>{
    const { internalProps: { disabled: disabled, readOnly: readOnly = false }, forwardedProps: { sectionListRef: inSectionListRef, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, focused: focusedProp, autoFocus: autoFocus = false }, fieldValueManager: fieldValueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, setSelectedSections: setSelectedSections, parsedSelectedSections: parsedSelectedSections, state: state, clearActiveSection: clearActiveSection, clearValue: clearValue, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, sectionOrder: sectionOrder, areAllSectionsEmpty: areAllSectionsEmpty, sectionsValueBoundaries: sectionsValueBoundaries } = params;
    const sectionListRef = $2hDQc.useRef(null);
    const handleSectionListRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(inSectionListRef, sectionListRef);
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const id = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const [focused, setFocused] = $2hDQc.useState(false);
    const interactions = $2hDQc.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!sectionListRef.current) return;
                const selection = document.getSelection();
                if (!selection) return;
                if (parsedSelectedSections == null) {
                    // If the selection contains an element inside the field, we reset it.
                    if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
                    if (focused) sectionListRef.current.getRoot().blur();
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                if (!sectionListRef.current.getRoot().contains((0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document))) return;
                const range = new window.Range();
                let target;
                if (parsedSelectedSections === "all") target = sectionListRef.current.getRoot();
                else {
                    const section = state.sections[parsedSelectedSections];
                    if (section.type === "empty") target = sectionListRef.current.getSectionContainer(parsedSelectedSections);
                    else target = sectionListRef.current.getSectionContent(parsedSelectedSections);
                }
                range.selectNodeContents(target);
                target.focus();
                selection.removeAllRanges();
                selection.addRange(range);
            },
            getActiveSectionIndexFromDOM: ()=>{
                const activeElement = (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document);
                if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
                return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
            },
            focusField: (newSelectedSections = 0)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $f98be61bc28ae2a3$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                setFocused(true);
                sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
            },
            setSelectedSections: (newSelectedSections)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $f98be61bc28ae2a3$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === "all" ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            isFieldFocused: ()=>{
                const activeElement = (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document);
                return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
            }
        }), [
        parsedSelectedSections,
        setSelectedSections,
        state.sections,
        focused
    ]);
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!sectionListRef.current) return;
        const section = state.sections[sectionIndex];
        sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        interactions.syncSelectionToDOM();
    });
    const handleContainerClick = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleContainerClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented() || !sectionListRef.current) return;
        setFocused(true);
        onClick?.(event, ...args);
        if (parsedSelectedSections === "all") setTimeout(()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleContainerInput = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        onInput?.(event);
        if (!sectionListRef.current || parsedSelectedSections !== "all") return;
        const target = event.target;
        const keyPressed = target.textContent ?? "";
        sectionListRef.current.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join("");
        interactions.syncSelectionToDOM();
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            resetCharacterQuery();
            clearValue();
            setSelectedSections("all");
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: 0
        });
    });
    const handleContainerPaste = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        if (readOnly || parsedSelectedSections !== "all") {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData("text");
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        if (focused || !sectionListRef.current) return;
        setFocused(true);
        const isFocusInsideASection = sectionListRef.current.getSectionIndexFromDOMElement((0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document)) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerBlur = (0, $b61557e39989b411$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setTimeout(()=>{
            if (!sectionListRef.current) return;
            const activeElement = (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document);
            const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    const getInputContainerClickHandler = (0, $b61557e39989b411$export$2e2bcd8739ae039)((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentMouseUp = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const getInputContentFocusHandler = (0, $b61557e39989b411$export$2e2bcd8739ae039)((sectionIndex)=>()=>{
            setSelectedSections(sectionIndex);
        });
    const handleInputContentPaste = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== "number") return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData("text");
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
        if (isValidPastedValue) {
            resetCharacterQuery();
            updateSectionValue({
                activeSection: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            resetCharacterQuery();
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleInputContentDragOver = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = "none";
    });
    const handleInputContentInput = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!sectionListRef.current) return;
        const target = event.target;
        const keyPressed = target.textContent ?? "";
        const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly || !sectionListRef.current) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === "") {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === "insertParagraph" || inputType === "insertLineBreak") {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === "all") sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === "number") {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    const sectionBoundaries = $2hDQc.useMemo(()=>{
        return state.sections.reduce((acc, next)=>{
            acc[next.type] = sectionsValueBoundaries[next.type]({
                currentDate: null,
                contentType: next.contentType,
                format: next.format
            });
            return acc;
        }, {});
    }, [
        sectionsValueBoundaries,
        state.sections
    ]);
    const isContainerEditable = parsedSelectedSections === "all";
    const elements = $2hDQc.useMemo(()=>{
        return state.sections.map((section, index)=>{
            const isEditable = !isContainerEditable && !disabled && !readOnly;
            return {
                container: {
                    "data-sectionindex": index,
                    onClick: getInputContainerClickHandler(index)
                },
                content: {
                    tabIndex: isContainerEditable || index > 0 ? -1 : 0,
                    contentEditable: !isContainerEditable && !disabled && !readOnly,
                    role: "spinbutton",
                    id: `${id}-${section.type}`,
                    "aria-labelledby": `${id}-${section.type}`,
                    "aria-readonly": readOnly,
                    "aria-valuenow": (0, $f98be61bc28ae2a3$export$b46fd324c5adcf31)(section, utils),
                    "aria-valuemin": sectionBoundaries[section.type].minimum,
                    "aria-valuemax": sectionBoundaries[section.type].maximum,
                    "aria-valuetext": section.value ? (0, $f98be61bc28ae2a3$export$b5e30842500b6cab)(section, utils) : translations.empty,
                    "aria-label": translations[section.type],
                    "aria-disabled": disabled,
                    spellCheck: isEditable ? false : undefined,
                    autoCapitalize: isEditable ? "off" : undefined,
                    autoCorrect: isEditable ? "off" : undefined,
                    [parseInt($2hDQc.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : undefined,
                    children: section.value || section.placeholder,
                    onInput: handleInputContentInput,
                    onPaste: handleInputContentPaste,
                    onFocus: getInputContentFocusHandler(index),
                    onDragOver: handleInputContentDragOver,
                    onMouseUp: handleInputContentMouseUp,
                    inputMode: section.contentType === "letter" ? "text" : "numeric"
                },
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator
                }
            };
        });
    }, [
        state.sections,
        getInputContentFocusHandler,
        handleInputContentPaste,
        handleInputContentDragOver,
        handleInputContentInput,
        getInputContainerClickHandler,
        handleInputContentMouseUp,
        disabled,
        readOnly,
        isContainerEditable,
        translations,
        utils,
        sectionBoundaries,
        id
    ]);
    const handleValueStrChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $2hDQc.useMemo(()=>areAllSectionsEmpty ? "" : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    $2hDQc.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            "MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`",
            "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.",
            "",
            "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:",
            "",
            "<DatePicker slots={{ textField: MyCustomTextField }} />",
            "",
            "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"
        ].join("\n"));
        if (autoFocus && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        interactions: interactions,
        returnedValue: {
            autoFocus: // Forwarded
            autoFocus,
            readOnly: readOnly,
            focused: focusedProp ?? focused,
            sectionListRef: handleSectionListRef,
            onBlur: handleContainerBlur,
            onClick: handleContainerClick,
            onFocus: handleContainerFocus,
            onInput: handleContainerInput,
            onPaste: handleContainerPaste,
            // Additional
            enableAccessibleFieldDOMStructure: true,
            elements: elements,
            // TODO v7: Try to set to undefined when there is a section selected.
            tabIndex: parsedSelectedSections === 0 ? -1 : 0,
            contentEditable: isContainerEditable,
            value: valueStr,
            onChange: handleValueStrChange,
            areAllSectionsEmpty: areAllSectionsEmpty
        }
    };
};




var $2hDQc = parcelRequire("2hDQc");





const $8a92c50b21b5f0d9$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
const $8a92c50b21b5f0d9$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $f98be61bc28ae2a3$export$85daa91f6c6e875f)(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $8a92c50b21b5f0d9$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $8a92c50b21b5f0d9$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === "" ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $8a92c50b21b5f0d9$export$4995d3b7b56fcd3f = (params)=>{
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const focusTimeoutRef = $2hDQc.useRef();
    const selectionSyncTimeoutRef = $2hDQc.useRef();
    const { forwardedProps: { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, inputRef: inputRefProp, placeholder: inPlaceholder }, internalProps: { readOnly: readOnly = false, disabled: disabled = false }, parsedSelectedSections: parsedSelectedSections, activeSectionIndex: activeSectionIndex, state: state, fieldValueManager: fieldValueManager, valueManager: valueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, clearActiveSection: clearActiveSection, clearValue: clearValue, setTempAndroidValueStr: setTempAndroidValueStr, setSelectedSections: setSelectedSections, getSectionsFromValue: getSectionsFromValue, areAllSectionsEmpty: areAllSectionsEmpty, localizedDigits: localizedDigits } = params;
    const inputRef = $2hDQc.useRef(null);
    const handleRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const sections = $2hDQc.useMemo(()=>$8a92c50b21b5f0d9$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    const interactions = $2hDQc.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!inputRef.current) return;
                if (parsedSelectedSections == null) {
                    if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                    // setting selection range to 0 causes issues in Safari.
                    // https://bugs.webkit.org/show_bug.cgi?id=224425
                    inputRef.current.scrollLeft = 0;
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
                // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
                if (inputRef.current !== (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document)) return;
                // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
                const currentScrollTop = inputRef.current.scrollTop;
                if (parsedSelectedSections === "all") inputRef.current.select();
                else {
                    const selectedSection = sections[parsedSelectedSections];
                    const selectionStart = selectedSection.type === "empty" ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                    const selectionEnd = selectedSection.type === "empty" ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                        if (inputRef.current === (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    }
                    clearTimeout(selectionSyncTimeoutRef.current);
                    selectionSyncTimeoutRef.current = setTimeout(()=>{
                        // handle case when the selection is not updated correctly
                        // could happen on Android
                        if (inputRef.current && inputRef.current === (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
                        // https://github.com/mui/mui-x/pull/13652
                        inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) interactions.syncSelectionToDOM();
                    });
                }
                // Even reading this variable seems to do the trick, but also setting it just to make use of it
                inputRef.current.scrollTop = currentScrollTop;
            },
            getActiveSectionIndexFromDOM: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            focusField: (newSelectedSection = 0)=>{
                inputRef.current?.focus();
                setSelectedSections(newSelectedSection);
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            isFieldFocused: ()=>inputRef.current === (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document)
        }), [
        inputRef,
        parsedSelectedSections,
        sections,
        setSelectedSections
    ]);
    const syncSelectionFromDOM = ()=>{
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections("all");
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData("text");
        if (typeof parsedSelectedSections === "number") {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $b61557e39989b411$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === "") {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $8a92c50b21b5f0d9$var$cleanString(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === "all" && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $8a92c50b21b5f0d9$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $8a92c50b21b5f0d9$var$cleanString(activeSection.endSeparator || "").length;
            keyPressed = cleanValueStr.slice(activeSection.start + $8a92c50b21b5f0d9$var$cleanString(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $f98be61bc28ae2a3$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const placeholder = $2hDQc.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $2hDQc.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $2hDQc.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document)) setSelectedSections("all");
        return ()=>{
            clearTimeout(focusTimeoutRef.current);
            clearTimeout(selectionSyncTimeoutRef.current);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const inputMode = $2hDQc.useMemo(()=>{
        if (activeSectionIndex == null) return "text";
        if (state.sections[activeSectionIndex].contentType === "letter") return "text";
        return "numeric";
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    return {
        interactions: interactions,
        returnedValue: {
            readOnly: // Forwarded
            readOnly,
            onBlur: handleContainerBlur,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onPaste: handleInputPaste,
            inputRef: handleRef,
            // Additional
            enableAccessibleFieldDOMStructure: false,
            placeholder: placeholder,
            inputMode: inputMode,
            autoComplete: "off",
            value: shouldShowPlaceholder ? "" : valueStr,
            onChange: handleInputChange
        }
    };
};


const $35ce92a8864cc63f$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const { internalProps: internalProps, internalProps: { unstableFieldRef: unstableFieldRef, minutesStep: minutesStep, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false, disabled: disabled = false, readOnly: readOnly = false }, forwardedProps: { onKeyDown: onKeyDown, error: error, clearable: clearable, onClear: onClear }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params;
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const stateResponse = (0, $118c2511612b6079$export$4e8d6353e50062e7)(params);
    const { state: state, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone } = stateResponse;
    const characterEditingResponse = (0, $e675a520cf2ca79a$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const { resetCharacterQuery: resetCharacterQuery } = characterEditingResponse;
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $3b7232d0ad2a9010$export$3b5f62b9baf9717e) : (0, $8a92c50b21b5f0d9$export$4995d3b7b56fcd3f);
    const sectionOrder = $2hDQc.useMemo(()=>(0, $f98be61bc28ae2a3$export$7725fd6fe0a2aadf)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const { returnedValue: returnedValue, interactions: interactions } = useFieldTextField((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params, stateResponse, characterEditingResponse, {
        areAllSectionsEmpty: areAllSectionsEmpty,
        sectionOrder: sectionOrder
    }));
    const handleContainerKeyDown = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === "A" && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections("all");
                break;
            // Move selection to next section
            case event.key === "ArrowRight":
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === "all") setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === "ArrowLeft":
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === "all") setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === "Delete":
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === "all") clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
                "PageUp",
                "PageDown"
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    const activeSection = state.sections[activeSectionIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $f98be61bc28ae2a3$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        interactions.syncSelectionToDOM();
    });
    const { hasValidationError: hasValidationError } = (0, $6dac1f43294e1bc1$export$87fe492f99f25a20)({
        props: internalProps,
        validator: validator,
        timezone: timezone,
        value: state.value,
        onError: internalProps.onError
    });
    const inputError = $2hDQc.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return hasValidationError;
    }, [
        hasValidationError,
        error
    ]);
    $2hDQc.useEffect(()=>{
        if (!inputError && activeSectionIndex == null) resetCharacterQuery();
    }, [
        state.referenceValue,
        activeSectionIndex,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $2hDQc.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $2hDQc.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
            setSelectedSections: interactions.setSelectedSections,
            focusField: interactions.focusField,
            isFieldFocused: interactions.isFieldFocused
        }));
    const handleClearValue = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!interactions.isFieldFocused()) // setSelectedSections is called internally
        interactions.focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const commonForwardedProps = {
        onKeyDown: handleContainerKeyDown,
        onClear: handleClearValue,
        error: inputError,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    };
    const commonAdditionalProps = {
        disabled: disabled,
        readOnly: readOnly
    };
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};




const $7ee2e31e1f24b6a5$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const minDate = (0, $6008d551a5f07604$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $6008d551a5f07604$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return "shouldDisableDate";
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return "shouldDisableMonth";
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return "shouldDisableYear";
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};
$7ee2e31e1f24b6a5$export$ffb3d0046ef3a2.valueManager = (0, $60e2396f80eb3f46$export$2764b246aa3b75ba);




const $5e01c2dccfcb8c5b$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const isAfter = (0, $9aafba1b8c629c28$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(minTime && isAfter(minTime, value)):
            return "minTime";
        case Boolean(maxTime && isAfter(value, maxTime)):
            return "maxTime";
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return "disablePast";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "hours")):
            return "shouldDisableTime-hours";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "minutes")):
            return "shouldDisableTime-minutes";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "seconds")):
            return "shouldDisableTime-seconds";
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return "minutesStep";
        default:
            return null;
    }
};
$5e01c2dccfcb8c5b$export$7bd013ac69eb590c.valueManager = (0, $60e2396f80eb3f46$export$2764b246aa3b75ba);



const $422df713a3183182$export$ed94a8ff1f54c4f = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const dateValidationResult = (0, $7ee2e31e1f24b6a5$export$ffb3d0046ef3a2)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $5e01c2dccfcb8c5b$export$7bd013ac69eb590c)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
};
$422df713a3183182$export$ed94a8ff1f54c4f.valueManager = (0, $60e2396f80eb3f46$export$2764b246aa3b75ba);




var $2hDQc = parcelRequire("2hDQc");
const $ce5f8da25e363804$export$430d9fc64cf058d6 = [
    "disablePast",
    "disableFuture",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear"
];
const $ce5f8da25e363804$export$fd5e0f8b4115a8c7 = [
    "disablePast",
    "disableFuture",
    "minTime",
    "maxTime",
    "shouldDisableTime",
    "minutesStep",
    "ampm",
    "disableIgnoringDatePartForTimeValidation"
];
const $ce5f8da25e363804$export$1df62d3ba2121371 = [
    "minDateTime",
    "maxDateTime"
];
const $ce5f8da25e363804$var$VALIDATION_PROP_NAMES = [
    ...$ce5f8da25e363804$export$430d9fc64cf058d6,
    ...$ce5f8da25e363804$export$fd5e0f8b4115a8c7,
    ...$ce5f8da25e363804$export$1df62d3ba2121371
];
const $ce5f8da25e363804$export$5890f750904acddb = (props)=>$ce5f8da25e363804$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


"use client";
const $12f029ff43856ce2$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    "value",
    "defaultValue",
    "referenceDate",
    "format",
    "formatDensity",
    "onChange",
    "timezone",
    "onError",
    "shouldRespectLeadingZeros",
    "selectedSections",
    "onSelectedSectionsChange",
    "unstableFieldRef",
    "enableAccessibleFieldDOMStructure",
    "disabled",
    "readOnly",
    "dateSeparator"
];
const $12f029ff43856ce2$export$be857fabf132acea = (props, valueType)=>{
    return $2hDQc.useMemo(()=>{
        const forwardedProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $12f029ff43856ce2$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === "date") (0, $ce5f8da25e363804$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === "time") (0, $ce5f8da25e363804$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === "date-time") {
            (0, $ce5f8da25e363804$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $ce5f8da25e363804$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $ce5f8da25e363804$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
};





const $371ce98de234cd61$export$c04f15aa68a6177a = (props)=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? utils.formats.keyboardDate,
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $371ce98de234cd61$export$e740b972b66c04cd = (props)=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat
    });
};
const $371ce98de234cd61$export$ae5b8d06aeae1db3 = (props)=>{
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
        minTime: props.minDateTime ?? props.minTime,
        maxTime: props.maxDateTime ?? props.maxTime
    });
};


"use client";
const $3a14efd6eb7a660c$export$2c2e7f1ceedfa8fa = (inProps)=>{
    const props = (0, $371ce98de234cd61$export$ae5b8d06aeae1db3)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $12f029ff43856ce2$export$be857fabf132acea)(props, "date-time");
    return (0, $35ce92a8864cc63f$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba),
        fieldValueManager: (0, $60e2396f80eb3f46$export$b602c94f557316b4),
        validator: (0, $422df713a3183182$export$ed94a8ff1f54c4f),
        valueType: "date-time"
    });
};





var $2hDQc = parcelRequire("2hDQc");



var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $lfMLv = parcelRequire("lfMLv");




var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $c76df6ffa8406c9f$export$4b135a4b3a6c4550(slot) {
    return (0, $01COD.default)("MuiInputAdornment", slot);
}
const $c76df6ffa8406c9f$var$inputAdornmentClasses = (0, $eLydt.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $c76df6ffa8406c9f$export$2e2bcd8739ae039 = $c76df6ffa8406c9f$var$inputAdornmentClasses;



var $afHYP = parcelRequire("afHYP");

var $592Nh = parcelRequire("592Nh");
"use client";
var $c0c33a2da04f3a5d$var$_span;
const $c0c33a2da04f3a5d$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $c0c33a2da04f3a5d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $lfMLv.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $c0c33a2da04f3a5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $lfMLv.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $lfMLv.default)(size)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $c76df6ffa8406c9f$export$4b135a4b3a6c4550), classes);
};
const $c0c33a2da04f3a5d$var$InputAdornmentRoot = (0, $fhlQp.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $c0c33a2da04f3a5d$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $c76df6ffa8406c9f$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $c76df6ffa8406c9f$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $c0c33a2da04f3a5d$var$InputAdornment = /*#__PURE__*/ $2hDQc.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $gZOiq.default)(props, $c0c33a2da04f3a5d$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $kxIgO.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $c0c33a2da04f3a5d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e2e023c13a569f7a$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($c0c33a2da04f3a5d$var$InputAdornmentRoot, (0, $kxIgO.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fLRFO.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $c0c33a2da04f3a5d$var$_span || ($c0c33a2da04f3a5d$var$_span = /*#__PURE__*/ (0, $592Nh.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $c0c33a2da04f3a5d$export$2e2bcd8739ae039 = $c0c33a2da04f3a5d$var$InputAdornment;



var $koHCo = parcelRequire("koHCo");

var $2hDQc = parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");
const $3330a4c49b9b1ac8$export$ed0fe318cc298673 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $3330a4c49b9b1ac8$export$8afed21ef5c2afa5 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const $3330a4c49b9b1ac8$export$9ca09caa9c849d9c = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const $3330a4c49b9b1ac8$export$5fda1783bb83f57b = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const $3330a4c49b9b1ac8$export$8099ab97743c966c = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
    children: [
        /*#__PURE__*/ (0, $592Nh.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $592Nh.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const $3330a4c49b9b1ac8$export$90a8eab2a2411720 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const $3330a4c49b9b1ac8$export$7e95adcf912503e3 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
    children: [
        /*#__PURE__*/ (0, $592Nh.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $592Nh.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");
const $3330a4c49b9b1ac8$export$cefbac224a47f32 = (0, $koHCo.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");




var $592Nh = parcelRequire("592Nh");
"use client";
const $ed4bfd55e5e0e707$var$_excluded = [
    "clearable",
    "onClear",
    "InputProps",
    "sx",
    "slots",
    "slotProps"
], $ed4bfd55e5e0e707$var$_excluded2 = [
    "ownerState"
];
const $ed4bfd55e5e0e707$export$db9644cdb7e3d432 = (props)=>{
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const { clearable: clearable, onClear: onClear, InputProps: InputProps, sx: sx, slots: slots, slotProps: slotProps } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $ed4bfd55e5e0e707$var$_excluded);
    const IconButton = slots?.clearButton ?? (0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: IconButton,
        externalSlotProps: slotProps?.clearButton,
        ownerState: {},
        className: "clearButton",
        additionalProps: {
            title: translations.fieldClearLabel
        }
    }), iconButtonProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps, $ed4bfd55e5e0e707$var$_excluded2);
    const EndClearIcon = slots?.clearIcon ?? (0, $3330a4c49b9b1ac8$export$cefbac224a47f32);
    const endClearIconProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: EndClearIcon,
        externalSlotProps: slotProps?.clearIcon,
        ownerState: {}
    });
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
        InputProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, InputProps, {
            endAdornment: /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                children: [
                    clearable && /*#__PURE__*/ (0, $592Nh.jsx)((0, $c0c33a2da04f3a5d$export$2e2bcd8739ae039), {
                        position: "end",
                        sx: {
                            marginRight: InputProps?.endAdornment ? -1 : -1.5
                        },
                        children: /*#__PURE__*/ (0, $592Nh.jsx)(IconButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, iconButtonProps, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, $592Nh.jsx)(EndClearIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                                fontSize: "small"
                            }, endClearIconProps))
                        }))
                    }),
                    InputProps?.endAdornment
                ]
            })
        }),
        sx: [
            {
                "& .clearButton": {
                    opacity: 1
                },
                "@media (pointer: fine)": {
                    "& .clearButton": {
                        opacity: 0
                    },
                    "&:hover, &:focus-within": {
                        ".clearButton": {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
};





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ function $7b90fada85d5daeb$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = "";
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? "" : " ") + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += " " + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}






const $cc33a2d1a4ceae43$var$defaultGenerator = (componentName)=>componentName;
const $cc33a2d1a4ceae43$var$createClassNameGenerator = ()=>{
    let generate = $cc33a2d1a4ceae43$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $cc33a2d1a4ceae43$var$defaultGenerator;
        }
    };
};
const $cc33a2d1a4ceae43$var$ClassNameGenerator = $cc33a2d1a4ceae43$var$createClassNameGenerator();
var $cc33a2d1a4ceae43$export$2e2bcd8739ae039 = $cc33a2d1a4ceae43$var$ClassNameGenerator;


const $da27f637207bc43f$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $da27f637207bc43f$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $da27f637207bc43f$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $cc33a2d1a4ceae43$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $da27f637207bc43f$export$34c0130b1f3e8ae3(slot) {
    return $da27f637207bc43f$export$9d6b9120de57c54[slot] !== undefined;
}



function $b6d5eeabe08428a3$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $da27f637207bc43f$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $c6a27a63f709a45c$export$d99678ed7aad1677(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersTextField", slot);
}
const $c6a27a63f709a45c$export$284739773a7ae972 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersTextField", [
    "root",
    "focused",
    "disabled",
    "error",
    "required"
]);





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");







function $5c6c921c3ac8423c$export$3821cb625ac26962(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersInputBase", slot);
}
const $5c6c921c3ac8423c$export$f20b5ba262568322 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersInputBase", [
    "root",
    "focused",
    "disabled",
    "error",
    "notchedOutline",
    "sectionContent",
    "sectionBefore",
    "sectionAfter",
    "adornedStart",
    "adornedEnd",
    "input"
]);


function $812b5dc3881c2db6$export$c0dd951a3959ac7f(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersOutlinedInput", slot);
}
const $812b5dc3881c2db6$export$a7da60486bcc91df = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $5c6c921c3ac8423c$export$f20b5ba262568322), (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));




parcelRequire("2hDQc");

var $fhlQp = parcelRequire("fhlQp");

var $592Nh = parcelRequire("592Nh");
const $1a74e07a7c739474$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $1a74e07a7c739474$var$OutlineRoot = (0, $fhlQp.default)("fieldset", {
    name: "MuiPickersOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        textAlign: "left",
        position: "absolute",
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: "0 8px",
        pointerEvents: "none",
        borderRadius: "inherit",
        borderStyle: "solid",
        borderWidth: 1,
        overflow: "hidden",
        minWidth: "0%",
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $1a74e07a7c739474$var$OutlineLabel = (0, $fhlQp.default)("span")(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit"
    }));
const $1a74e07a7c739474$var$OutlineLegend = (0, $fhlQp.default)("legend")(({ theme: theme })=>({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden",
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    withLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: "11px",
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create("width", {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    withLabel: true
                },
                style: {
                    display: "block",
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: theme.transitions.create("max-width", {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: "inline-block",
                        opacity: 0,
                        visibility: "visible"
                    }
                }
            },
            {
                props: {
                    withLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: "100%",
                    transition: theme.transitions.create("max-width", {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $1a74e07a7c739474$export$2e2bcd8739ae039(props) {
    const { className: className, label: label } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $1a74e07a7c739474$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($1a74e07a7c739474$var$OutlineRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($1a74e07a7c739474$var$OutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $592Nh.jsx)($1a74e07a7c739474$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $592Nh.jsx)($1a74e07a7c739474$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");



/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $b81993b150f8c491$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append("args[]", arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $4e13dcbdd82c6d0c$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $b81993b150f8c491$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



const $a77b7c73d6d47bd5$var$visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};
var $a77b7c73d6d47bd5$export$2e2bcd8739ae039 = $a77b7c73d6d47bd5$var$visuallyHidden;







var $2hDQc = parcelRequire("2hDQc");





var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


function $2bc77bc6175f285e$export$f891a98d04ce6513(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersSectionList", slot);
}
const $2bc77bc6175f285e$export$8455939b33d2ee90 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersSectionList", [
    "root",
    "section",
    "sectionContent"
]);



var $592Nh = parcelRequire("592Nh");
"use client";
const $0ce67dc0caf93160$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef"
];
const $0ce67dc0caf93160$export$4ee86b293725486c = (0, $fhlQp.default)("div", {
    name: "MuiPickersSectionList",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    direction: "ltr /*! @noflip */",
    outline: "none"
});
const $0ce67dc0caf93160$export$30e7187e386feb4f = (0, $fhlQp.default)("span", {
    name: "MuiPickersSectionList",
    slot: "Section",
    overridesResolver: (props, styles)=>styles.section
})({});
const $0ce67dc0caf93160$export$c403b59604f63120 = (0, $fhlQp.default)("span", {
    name: "MuiPickersSectionList",
    slot: "SectionSeparator",
    overridesResolver: (props, styles)=>styles.sectionSeparator
})({
    whiteSpace: "pre"
});
const $0ce67dc0caf93160$export$1f2c61561fe3d6 = (0, $fhlQp.default)("span", {
    name: "MuiPickersSectionList",
    slot: "SectionContent",
    overridesResolver: (props, styles)=>styles.sectionContent
})({
    outline: "none"
});
const $0ce67dc0caf93160$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        section: [
            "section"
        ],
        sectionContent: [
            "sectionContent"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $2bc77bc6175f285e$export$f891a98d04ce6513), classes);
};
function $0ce67dc0caf93160$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const Section = slots?.section ?? $0ce67dc0caf93160$export$30e7187e386feb4f;
    const sectionProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: {}
    });
    const SectionContent = slots?.sectionContent ?? $0ce67dc0caf93160$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: {}
    });
    const SectionSeparator = slots?.sectionSeparator ?? $0ce67dc0caf93160$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: {
            position: "before"
        }
    });
    const sectionSeparatorAfterProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: {
            position: "after"
        }
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)(Section, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)(SectionSeparator, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $592Nh.jsx)(SectionContent, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $592Nh.jsx)(SectionSeparator, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $0ce67dc0caf93160$export$847fd4b97819700 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersSectionList"
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $0ce67dc0caf93160$var$_excluded);
    const classes = $0ce67dc0caf93160$var$useUtilityClasses(props);
    const rootRef = $2hDQc.useRef(null);
    const handleRootRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $2hDQc.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot("getRoot");
            },
            getSectionContainer (index) {
                const root = getRoot("getSectionContainer");
                return root.querySelector(`.${(0, $2bc77bc6175f285e$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot("getSectionContent");
                return root.querySelector(`.${(0, $2bc77bc6175f285e$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $2bc77bc6175f285e$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot("getSectionIndexFromDOMElement");
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $2bc77bc6175f285e$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $2bc77bc6175f285e$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $0ce67dc0caf93160$export$4ee86b293725486c;
    const rootProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)(Root, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join("") : /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $592Nh.jsx)($0ce67dc0caf93160$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});



var $592Nh = parcelRequire("592Nh");
const $b4510dd60f8802d8$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef"
];
const $b4510dd60f8802d8$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $b4510dd60f8802d8$export$ddc18880178d980e = (0, $fhlQp.default)("div", {
    name: "MuiPickersInputBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: "text",
        padding: 0,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$b4510dd60f8802d8$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: "100%"
                }
            }
        ]
    }));
const $b4510dd60f8802d8$export$52f3fbbfe9321824 = (0, $fhlQp.default)((0, $0ce67dc0caf93160$export$4ee86b293725486c), {
    name: "MuiPickersInputBase",
    slot: "SectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})(({ theme: theme })=>({
        padding: "4px 0 5px",
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit",
        lineHeight: "1.4375em",
        // 23px
        flexGrow: 1,
        outline: "none",
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
        letterSpacing: "inherit",
        // Baseline behavior
        width: "182px",
        variants: [
            {
                props: {
                    isRtl: true
                },
                style: {
                    textAlign: "right /*! @noflip */"
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    adornedStart: false,
                    focused: false,
                    filled: false
                },
                style: {
                    color: "currentColor",
                    opacity: 0
                }
            },
            {
                // Can't use the object notation because label can be null or undefined
                props: ({ adornedStart: adornedStart, focused: focused, filled: filled, label: label })=>!adornedStart && !focused && !filled && label == null,
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === "light" ? 0.42 : 0.5
                }
            }
        ]
    }));
const $b4510dd60f8802d8$var$PickersInputBaseSection = (0, $fhlQp.default)((0, $0ce67dc0caf93160$export$30e7187e386feb4f), {
    name: "MuiPickersInputBase",
    slot: "Section",
    overridesResolver: (props, styles)=>styles.section
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit",
        letterSpacing: "inherit",
        lineHeight: "1.4375em",
        // 23px
        display: "flex"
    }));
const $b4510dd60f8802d8$var$PickersInputBaseSectionContent = (0, $fhlQp.default)((0, $0ce67dc0caf93160$export$1f2c61561fe3d6), {
    name: "MuiPickersInputBase",
    slot: "SectionContent",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: "1.4375em",
        // 23px
        letterSpacing: "inherit",
        width: "fit-content",
        outline: "none"
    }));
const $b4510dd60f8802d8$var$PickersInputBaseSectionSeparator = (0, $fhlQp.default)((0, $0ce67dc0caf93160$export$c403b59604f63120), {
    name: "MuiPickersInputBase",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})(()=>({
        whiteSpace: "pre",
        letterSpacing: "inherit"
    }));
const $b4510dd60f8802d8$var$PickersInputBaseInput = (0, $fhlQp.default)("input", {
    name: "MuiPickersInputBase",
    slot: "Input",
    overridesResolver: (props, styles)=>styles.hiddenInput
})((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $a77b7c73d6d47bd5$export$2e2bcd8739ae039)));
const $b4510dd60f8802d8$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, error: error, classes: classes, fullWidth: fullWidth, readOnly: readOnly, color: color, size: size, endAdornment: endAdornment, startAdornment: startAdornment } = ownerState;
    const slots = {
        root: [
            "root",
            focused && !disabled && "focused",
            disabled && "disabled",
            readOnly && "readOnly",
            error && "error",
            fullWidth && "fullWidth",
            `color${(0, $4e13dcbdd82c6d0c$export$2e2bcd8739ae039)(color)}`,
            size === "small" && "inputSizeSmall",
            Boolean(startAdornment) && "adornedStart",
            Boolean(endAdornment) && "adornedEnd"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ],
        sectionsContainer: [
            "sectionsContainer"
        ],
        sectionContent: [
            "sectionContent"
        ],
        sectionBefore: [
            "sectionBefore"
        ],
        sectionAfter: [
            "sectionAfter"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $5c6c921c3ac8423c$export$3821cb625ac26962), classes);
};
/**
 * @ignore - internal component.
 */ const $b4510dd60f8802d8$export$ff827734ba831074 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersInputBase"
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $b4510dd60f8802d8$var$_excluded);
    const rootRef = $2hDQc.useRef(null);
    const handleRootRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, rootRef);
    const handleInputRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(inputProps?.ref, inputRef);
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
    const handleInputFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (muiFormControl.disabled) {
            event.stopPropagation();
            return;
        }
        muiFormControl.onFocus?.(event);
    };
    $2hDQc.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $2hDQc.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, muiFormControl, {
        isRtl: isRtl
    });
    const classes = $b4510dd60f8802d8$var$useUtilityClasses(ownerState);
    const InputRoot = slots?.root || $b4510dd60f8802d8$export$ddc18880178d980e;
    const inputRootProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            "aria-invalid": muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $b4510dd60f8802d8$export$52f3fbbfe9321824;
    return /*#__PURE__*/ (0, $592Nh.jsxs)(InputRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $0ce67dc0caf93160$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: muiFormControl.onBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $b4510dd60f8802d8$var$PickersInputBaseSection,
                    sectionContent: $b4510dd60f8802d8$var$PickersInputBaseSectionContent,
                    sectionSeparator: $b4510dd60f8802d8$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: {
                        ownerState: ownerState
                    },
                    sectionContent: {
                        className: (0, $5c6c921c3ac8423c$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ position: position })=>({
                            className: position === "before" ? (0, $5c6c921c3ac8423c$export$f20b5ba262568322).sectionBefore : (0, $5c6c921c3ac8423c$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $592Nh.jsx)($b4510dd60f8802d8$var$PickersInputBaseInput, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled
            }, inputProps, {
                ref: handleInputRef
            }))
        ]
    }));
});




var $592Nh = parcelRequire("592Nh");
const $73cbd526dc76f0f8$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "notched"
];
const $73cbd526dc76f0f8$var$PickersOutlinedInputRoot = (0, $fhlQp.default)((0, $b4510dd60f8802d8$export$ddc18880178d980e), {
    name: "MuiPickersOutlinedInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        padding: "0 14px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).focused} .${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: "solid",
            borderWidth: 2
        },
        [`&.${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            "*": {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).error} .${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    color: color
                },
                style: {
                    [`&.${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).focused}:not(.${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).error}) .${(0, $812b5dc3881c2db6$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $73cbd526dc76f0f8$var$PickersOutlinedInputSectionsContainer = (0, $fhlQp.default)((0, $b4510dd60f8802d8$export$52f3fbbfe9321824), {
    name: "MuiPickersOutlinedInput",
    slot: "SectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    padding: "16.5px 0",
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                padding: "8.5px 0"
            }
        }
    ]
});
const $73cbd526dc76f0f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $812b5dc3881c2db6$export$c0dd951a3959ac7f), classes);
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $73cbd526dc76f0f8$export$44d4d00edb0c710f = /*#__PURE__*/ $2hDQc.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersOutlinedInput"
    });
    const { label: label, ownerState: ownerStateProp, notched: notched } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $73cbd526dc76f0f8$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || "primary"
    });
    const classes = $73cbd526dc76f0f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b4510dd60f8802d8$export$ff827734ba831074), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        slots: {
            root: $73cbd526dc76f0f8$var$PickersOutlinedInputRoot,
            input: $73cbd526dc76f0f8$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $1a74e07a7c739474$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== "" && muiFormControl?.required ? /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                }) : label,
                ownerState: ownerState
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$73cbd526dc76f0f8$export$44d4d00edb0c710f.muiName = "Input";





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");
/**
 * @mui/styled-engine v6.1.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $jFevA = parcelRequire("jFevA");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $393192585dd53dba$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $03775b331878e0ff$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


function $a8d18c2a60ba03d6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $57497250c1598cdc$var$isDevelopment = false;
var $57497250c1598cdc$var$hyphenateRegex = /[A-Z]|^ms/g;
var $57497250c1598cdc$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $57497250c1598cdc$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $57497250c1598cdc$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $57497250c1598cdc$var$processStyleName = /* #__PURE__ */ (0, $a8d18c2a60ba03d6$export$2e2bcd8739ae039)(function(styleName) {
    return $57497250c1598cdc$var$isCustomProperty(styleName) ? styleName : styleName.replace($57497250c1598cdc$var$hyphenateRegex, "-$&").toLowerCase();
});
var $57497250c1598cdc$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($57497250c1598cdc$var$animationRegex, function(match, p1, p2) {
                $57497250c1598cdc$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $57497250c1598cdc$var$cursor
                };
                return p1;
            });
    }
    if ((0, $03775b331878e0ff$export$2e2bcd8739ae039)[key] !== 1 && !$57497250c1598cdc$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $57497250c1598cdc$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $57497250c1598cdc$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $57497250c1598cdc$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $57497250c1598cdc$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $57497250c1598cdc$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $57497250c1598cdc$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $57497250c1598cdc$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $57497250c1598cdc$var$cursor;
                var result = interpolation(mergedProps);
                $57497250c1598cdc$var$cursor = previousCursor;
                return $57497250c1598cdc$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $57497250c1598cdc$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $57497250c1598cdc$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($57497250c1598cdc$var$isProcessableValue(asString)) string += $57497250c1598cdc$var$processStyleName(key) + ":" + $57497250c1598cdc$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $57497250c1598cdc$var$isDevelopment) throw new Error($57497250c1598cdc$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($57497250c1598cdc$var$isProcessableValue(value[_i])) string += $57497250c1598cdc$var$processStyleName(key) + ":" + $57497250c1598cdc$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $57497250c1598cdc$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $57497250c1598cdc$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $57497250c1598cdc$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $57497250c1598cdc$var$cursor;
function $57497250c1598cdc$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $57497250c1598cdc$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $57497250c1598cdc$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $57497250c1598cdc$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $57497250c1598cdc$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $57497250c1598cdc$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $393192585dd53dba$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $57497250c1598cdc$var$cursor
    };
}





function $a042392bca350758$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $jFevA.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $a042392bca350758$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $a042392bca350758$var$wrapper = [];
function $a042392bca350758$export$13a2d3ef13012b32(styles) {
    $a042392bca350758$var$wrapper[0] = styles;
    return (0, $57497250c1598cdc$export$6321afa313b251b5)($a042392bca350758$var$wrapper);
}


// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $e6977b25cc9bee11$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $e6977b25cc9bee11$var$deepClone(source) {
    if (!$e6977b25cc9bee11$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $e6977b25cc9bee11$var$deepClone(source[key]);
    });
    return output;
}
function $e6977b25cc9bee11$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($e6977b25cc9bee11$export$53b83ca8eaab0383(target) && $e6977b25cc9bee11$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($e6977b25cc9bee11$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $e6977b25cc9bee11$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $e6977b25cc9bee11$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $e6977b25cc9bee11$export$53b83ca8eaab0383(source[key]) ? $e6977b25cc9bee11$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



var $0b5ae67d154c5a19$exports = {};
"use strict";

$0b5ae67d154c5a19$exports = (parcelRequire("iCWoj"));


function $cca8d5533c77b4d2$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || fallback;
}
function $cca8d5533c77b4d2$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $cca8d5533c77b4d2$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $cca8d5533c77b4d2$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $cca8d5533c77b4d2$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $0b5ae67d154c5a19$exports.ForwardRef:
            return $cca8d5533c77b4d2$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $0b5ae67d154c5a19$exports.Memo:
            return $cca8d5533c77b4d2$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $66915a199282a9a0$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $66915a199282a9a0$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $66915a199282a9a0$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5, ...other } = breakpoints;
    const sortedValues = $66915a199282a9a0$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



function $4805fe948256ebea$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith("@container")).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $4805fe948256ebea$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === "@" || value.startsWith("@") && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $4805fe948256ebea$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $4805fe948256ebea$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes("not all and")) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $978606646b1b8312$var$shape = {
    borderRadius: 4
};
var $978606646b1b8312$export$2e2bcd8739ae039 = $978606646b1b8312$var$shape;






function $8ce48bce3740f54d$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $e6977b25cc9bee11$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $8ce48bce3740f54d$export$2e2bcd8739ae039 = $8ce48bce3740f54d$var$merge;



const $362fef7787030bb2$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $362fef7787030bb2$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$362fef7787030bb2$export$68c286be0e7e55b7[key]}px)`
};
const $362fef7787030bb2$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === "number" ? key : $362fef7787030bb2$export$68c286be0e7e55b7[key] || key;
                if (typeof result === "number") result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $362fef7787030bb2$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $362fef7787030bb2$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $362fef7787030bb2$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $4805fe948256ebea$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $4805fe948256ebea$export$10a9745dfa00d15)(theme.containerQueries ? theme : $362fef7787030bb2$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $362fef7787030bb2$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $362fef7787030bb2$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $362fef7787030bb2$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $8ce48bce3740f54d$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $362fef7787030bb2$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $362fef7787030bb2$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $362fef7787030bb2$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $362fef7787030bb2$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $e6977b25cc9bee11$export$2e2bcd8739ae039)(prev, next), {});
    return $362fef7787030bb2$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $362fef7787030bb2$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $362fef7787030bb2$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $362fef7787030bb2$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $362fef7787030bb2$export$2e2bcd8739ae039 = $362fef7787030bb2$var$breakpoints;





function $07e4cd835caf7654$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $07e4cd835caf7654$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $07e4cd835caf7654$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $07e4cd835caf7654$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $07e4cd835caf7654$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $07e4cd835caf7654$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $07e4cd835caf7654$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $4e13dcbdd82c6d0c$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $07e4cd835caf7654$export$2e2bcd8739ae039 = $07e4cd835caf7654$var$style;



function $3a5d321751cff2de$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $41eaab164fbb9bdd$var$properties = {
    m: "margin",
    p: "padding"
};
const $41eaab164fbb9bdd$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $41eaab164fbb9bdd$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $41eaab164fbb9bdd$var$getCssProperties = (0, $3a5d321751cff2de$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($41eaab164fbb9bdd$var$aliases[prop]) prop = $41eaab164fbb9bdd$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $41eaab164fbb9bdd$var$properties[a];
    const direction = $41eaab164fbb9bdd$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $41eaab164fbb9bdd$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $41eaab164fbb9bdd$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $41eaab164fbb9bdd$var$spacingKeys = [
    ...$41eaab164fbb9bdd$export$aab52a0dde05ad8a,
    ...$41eaab164fbb9bdd$export$f8397d44f03ab6ad
];
function $41eaab164fbb9bdd$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $07e4cd835caf7654$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === "number" || typeof themeSpacing === "string") return (val)=>{
        if (typeof val === "string") return val;
        if (typeof themeSpacing === "string") return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === "string") return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === "number") return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $41eaab164fbb9bdd$export$1def6f833384e3d1(theme) {
    return $41eaab164fbb9bdd$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $41eaab164fbb9bdd$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    return transformer(propValue);
}
function $41eaab164fbb9bdd$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $41eaab164fbb9bdd$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $41eaab164fbb9bdd$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $41eaab164fbb9bdd$var$getCssProperties(prop);
    const styleFromPropValue = $41eaab164fbb9bdd$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $41eaab164fbb9bdd$var$style(props, keys) {
    const transformer = $41eaab164fbb9bdd$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$41eaab164fbb9bdd$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $8ce48bce3740f54d$export$2e2bcd8739ae039), {});
}
function $41eaab164fbb9bdd$export$7ede87f9b603dd3c(props) {
    return $41eaab164fbb9bdd$var$style(props, $41eaab164fbb9bdd$export$aab52a0dde05ad8a);
}
$41eaab164fbb9bdd$export$7ede87f9b603dd3c.propTypes = {};
$41eaab164fbb9bdd$export$7ede87f9b603dd3c.filterProps = $41eaab164fbb9bdd$export$aab52a0dde05ad8a;
function $41eaab164fbb9bdd$export$6f98e8eaf0be1996(props) {
    return $41eaab164fbb9bdd$var$style(props, $41eaab164fbb9bdd$export$f8397d44f03ab6ad);
}
$41eaab164fbb9bdd$export$6f98e8eaf0be1996.propTypes = {};
$41eaab164fbb9bdd$export$6f98e8eaf0be1996.filterProps = $41eaab164fbb9bdd$export$f8397d44f03ab6ad;
function $41eaab164fbb9bdd$var$spacing(props) {
    return $41eaab164fbb9bdd$var$style(props, $41eaab164fbb9bdd$var$spacingKeys);
}
$41eaab164fbb9bdd$var$spacing.propTypes = {};
$41eaab164fbb9bdd$var$spacing.filterProps = $41eaab164fbb9bdd$var$spacingKeys;
var $41eaab164fbb9bdd$export$2e2bcd8739ae039 = $41eaab164fbb9bdd$var$spacing;


function $6142311100019a12$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $41eaab164fbb9bdd$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}











function $cff2545ee3ce268b$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $8ce48bce3740f54d$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $cff2545ee3ce268b$export$2e2bcd8739ae039 = $cff2545ee3ce268b$var$compose;




function $e5731a43ece6b147$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $e5731a43ece6b147$var$createBorderStyle(prop, transform) {
    return (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $e5731a43ece6b147$export$1edee58a52776cd9 = $e5731a43ece6b147$var$createBorderStyle("border", $e5731a43ece6b147$export$34e2febe53ae29cc);
const $e5731a43ece6b147$export$f9a7b6bd24892946 = $e5731a43ece6b147$var$createBorderStyle("borderTop", $e5731a43ece6b147$export$34e2febe53ae29cc);
const $e5731a43ece6b147$export$5abca33e6be905d2 = $e5731a43ece6b147$var$createBorderStyle("borderRight", $e5731a43ece6b147$export$34e2febe53ae29cc);
const $e5731a43ece6b147$export$e2ce9f12a980a822 = $e5731a43ece6b147$var$createBorderStyle("borderBottom", $e5731a43ece6b147$export$34e2febe53ae29cc);
const $e5731a43ece6b147$export$47658cca1a909427 = $e5731a43ece6b147$var$createBorderStyle("borderLeft", $e5731a43ece6b147$export$34e2febe53ae29cc);
const $e5731a43ece6b147$export$e7fb0694ba2404fc = $e5731a43ece6b147$var$createBorderStyle("borderColor");
const $e5731a43ece6b147$export$126a92c968acdb85 = $e5731a43ece6b147$var$createBorderStyle("borderTopColor");
const $e5731a43ece6b147$export$85cc51cb8fbb8c0e = $e5731a43ece6b147$var$createBorderStyle("borderRightColor");
const $e5731a43ece6b147$export$340b0327727f6d1a = $e5731a43ece6b147$var$createBorderStyle("borderBottomColor");
const $e5731a43ece6b147$export$60beef91a985b4bf = $e5731a43ece6b147$var$createBorderStyle("borderLeftColor");
const $e5731a43ece6b147$export$f9258c55612cbed7 = $e5731a43ece6b147$var$createBorderStyle("outline", $e5731a43ece6b147$export$34e2febe53ae29cc);
const $e5731a43ece6b147$export$621fe586efeb64b9 = $e5731a43ece6b147$var$createBorderStyle("outlineColor");
const $e5731a43ece6b147$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $41eaab164fbb9bdd$export$cb5ee237cce814a2)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $41eaab164fbb9bdd$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e5731a43ece6b147$export$7a57f79000377ca2.propTypes = {};
$e5731a43ece6b147$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $e5731a43ece6b147$var$borders = (0, $cff2545ee3ce268b$export$2e2bcd8739ae039)($e5731a43ece6b147$export$1edee58a52776cd9, $e5731a43ece6b147$export$f9a7b6bd24892946, $e5731a43ece6b147$export$5abca33e6be905d2, $e5731a43ece6b147$export$e2ce9f12a980a822, $e5731a43ece6b147$export$47658cca1a909427, $e5731a43ece6b147$export$e7fb0694ba2404fc, $e5731a43ece6b147$export$126a92c968acdb85, $e5731a43ece6b147$export$85cc51cb8fbb8c0e, $e5731a43ece6b147$export$340b0327727f6d1a, $e5731a43ece6b147$export$60beef91a985b4bf, $e5731a43ece6b147$export$7a57f79000377ca2, $e5731a43ece6b147$export$f9258c55612cbed7, $e5731a43ece6b147$export$621fe586efeb64b9);
var $e5731a43ece6b147$export$2e2bcd8739ae039 = $e5731a43ece6b147$var$borders;







const $1e8ccbc97a7c463c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $41eaab164fbb9bdd$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $41eaab164fbb9bdd$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$1e8ccbc97a7c463c$export$5df9adcb0db95e1e.propTypes = {};
$1e8ccbc97a7c463c$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $1e8ccbc97a7c463c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $41eaab164fbb9bdd$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $41eaab164fbb9bdd$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$1e8ccbc97a7c463c$export$ec60d70ff941a580.propTypes = {};
$1e8ccbc97a7c463c$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $1e8ccbc97a7c463c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $41eaab164fbb9bdd$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $41eaab164fbb9bdd$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$1e8ccbc97a7c463c$export$8a833ffa5f5dbeda.propTypes = {};
$1e8ccbc97a7c463c$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $1e8ccbc97a7c463c$export$baf44164ca3a34e8 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
const $1e8ccbc97a7c463c$export$8f7213a1cd01e832 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
const $1e8ccbc97a7c463c$export$b0e0abbc49ba668 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
const $1e8ccbc97a7c463c$export$bcd8b929d4b4142 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
const $1e8ccbc97a7c463c$export$e5039a674e14c828 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
const $1e8ccbc97a7c463c$export$42bd9088661ffb03 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
const $1e8ccbc97a7c463c$export$920682ae05b999bc = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
const $1e8ccbc97a7c463c$export$1b88fbdd482fd33a = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
const $1e8ccbc97a7c463c$export$bdb486e40d52d26f = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
const $1e8ccbc97a7c463c$var$grid = (0, $cff2545ee3ce268b$export$2e2bcd8739ae039)($1e8ccbc97a7c463c$export$5df9adcb0db95e1e, $1e8ccbc97a7c463c$export$ec60d70ff941a580, $1e8ccbc97a7c463c$export$8a833ffa5f5dbeda, $1e8ccbc97a7c463c$export$baf44164ca3a34e8, $1e8ccbc97a7c463c$export$8f7213a1cd01e832, $1e8ccbc97a7c463c$export$b0e0abbc49ba668, $1e8ccbc97a7c463c$export$bcd8b929d4b4142, $1e8ccbc97a7c463c$export$e5039a674e14c828, $1e8ccbc97a7c463c$export$42bd9088661ffb03, $1e8ccbc97a7c463c$export$920682ae05b999bc, $1e8ccbc97a7c463c$export$1b88fbdd482fd33a, $1e8ccbc97a7c463c$export$bdb486e40d52d26f);
var $1e8ccbc97a7c463c$export$2e2bcd8739ae039 = $1e8ccbc97a7c463c$var$grid;




function $94613b626a508f2a$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $94613b626a508f2a$export$35e9368ef982300f = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette",
    transform: $94613b626a508f2a$export$dbaffd4420ea0ac6
});
const $94613b626a508f2a$export$2506f56c10355b33 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $94613b626a508f2a$export$dbaffd4420ea0ac6
});
const $94613b626a508f2a$export$8c5a050822fd698c = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $94613b626a508f2a$export$dbaffd4420ea0ac6
});
const $94613b626a508f2a$var$palette = (0, $cff2545ee3ce268b$export$2e2bcd8739ae039)($94613b626a508f2a$export$35e9368ef982300f, $94613b626a508f2a$export$2506f56c10355b33, $94613b626a508f2a$export$8c5a050822fd698c);
var $94613b626a508f2a$export$2e2bcd8739ae039 = $94613b626a508f2a$var$palette;





function $40396efe585b092c$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $40396efe585b092c$export$7e3df82ee760448c = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $362fef7787030bb2$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $40396efe585b092c$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$40396efe585b092c$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $40396efe585b092c$export$ee148fbbe8357dd2 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$ac607276a8fe9f0a = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$dc0d8bd0b94f8570 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$a43cf604e12f3b17 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$ffed9f14fb65e276 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$905076ed6620e671 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $40396efe585b092c$export$8afece71750ec241
});
const $40396efe585b092c$export$6ccc93f785106a58 = (0, $07e4cd835caf7654$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
const $40396efe585b092c$var$sizing = (0, $cff2545ee3ce268b$export$2e2bcd8739ae039)($40396efe585b092c$export$7e3df82ee760448c, $40396efe585b092c$export$488fda99655ff65a, $40396efe585b092c$export$ee148fbbe8357dd2, $40396efe585b092c$export$ac607276a8fe9f0a, $40396efe585b092c$export$dc0d8bd0b94f8570, $40396efe585b092c$export$a43cf604e12f3b17, $40396efe585b092c$export$6ccc93f785106a58);
var $40396efe585b092c$export$2e2bcd8739ae039 = $40396efe585b092c$var$sizing;


const $f44bc615f842a557$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $e5731a43ece6b147$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $e5731a43ece6b147$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $e5731a43ece6b147$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $e5731a43ece6b147$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $e5731a43ece6b147$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $e5731a43ece6b147$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $e5731a43ece6b147$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $94613b626a508f2a$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $94613b626a508f2a$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $94613b626a508f2a$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $41eaab164fbb9bdd$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $41eaab164fbb9bdd$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $1e8ccbc97a7c463c$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $1e8ccbc97a7c463c$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $1e8ccbc97a7c463c$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $40396efe585b092c$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $40396efe585b092c$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $40396efe585b092c$export$8afece71750ec241)
    },
    height: {
        transform: (0, $40396efe585b092c$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $40396efe585b092c$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $40396efe585b092c$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: "font"
    },
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $f44bc615f842a557$export$2e2bcd8739ae039 = $f44bc615f842a557$var$defaultSxConfig;


function $4882141a91661fec$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $4882141a91661fec$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $4882141a91661fec$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $07e4cd835caf7654$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $07e4cd835caf7654$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $07e4cd835caf7654$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $4e13dcbdd82c6d0c$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $362fef7787030bb2$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $f44bc615f842a557$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $362fef7787030bb2$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $4882141a91661fec$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $8ce48bce3740f54d$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $362fef7787030bb2$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($4882141a91661fec$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $8ce48bce3740f54d$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $8ce48bce3740f54d$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $4805fe948256ebea$export$456f6c1142f990db)(theme, (0, $362fef7787030bb2$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $4882141a91661fec$var$styleFunctionSx = $4882141a91661fec$export$7d53d8bf2911e013();
$4882141a91661fec$var$styleFunctionSx.filterProps = [
    "sx"
];
var $4882141a91661fec$export$2e2bcd8739ae039 = $4882141a91661fec$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $02c9ac58077315fc$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== "function") return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === "&") return styles;
        if (selector.includes("data-") || selector.includes(".")) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $02596902ba8d09d3$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $66915a199282a9a0$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $6142311100019a12$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $e6977b25cc9bee11$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: {
            mode: "light",
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $978606646b1b8312$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $4805fe948256ebea$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $02c9ac58077315fc$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $e6977b25cc9bee11$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $f44bc615f842a557$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $4882141a91661fec$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $02596902ba8d09d3$export$2e2bcd8739ae039 = $02596902ba8d09d3$var$createTheme;




function $0a6478eef281b75a$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $a042392bca350758$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== "function") variant.style = (0, $a042392bca350758$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $08a7bc8a92e05f98$export$35e57303dbd8a66 = (0, $02596902ba8d09d3$export$2e2bcd8739ae039)();
function $08a7bc8a92e05f98$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function $08a7bc8a92e05f98$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $08a7bc8a92e05f98$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $08a7bc8a92e05f98$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $08a7bc8a92e05f98$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === "function" ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$08a7bc8a92e05f98$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $08a7bc8a92e05f98$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $08a7bc8a92e05f98$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === "function") {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === "function") {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $08a7bc8a92e05f98$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $08a7bc8a92e05f98$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $08a7bc8a92e05f98$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $08a7bc8a92e05f98$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $08a7bc8a92e05f98$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $a042392bca350758$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $4882141a91661fec$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $08a7bc8a92e05f98$var$defaultOverridesResolver($08a7bc8a92e05f98$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $08a7bc8a92e05f98$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($08a7bc8a92e05f98$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $a042392bca350758$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $08a7bc8a92e05f98$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === "function" && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $08a7bc8a92e05f98$var$processStyle(props, style);
            };
            if ((0, $e6977b25cc9bee11$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $0a6478eef281b75a$export$2e2bcd8739ae039)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $08a7bc8a92e05f98$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $08a7bc8a92e05f98$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $08a7bc8a92e05f98$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $4882141a91661fec$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill("");
                const placeholdersTail = new Array(expressionsTail.length).fill("");
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $08a7bc8a92e05f98$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $4e13dcbdd82c6d0c$export$2e2bcd8739ae039)(componentSlot || "")}`;
    return `Styled(${(0, $cca8d5533c77b4d2$export$2e2bcd8739ae039)(tag)})`;
}
function $08a7bc8a92e05f98$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $08a7bc8a92e05f98$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $08a7bc8a92e05f98$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $08a7bc8a92e05f98$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}








function $999788ef3d02aacf$export$6cb188bdacb35d0e(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersFilledInput", slot);
}
const $999788ef3d02aacf$export$3964d3188824d772 = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $5c6c921c3ac8423c$export$f20b5ba262568322), (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersFilledInput", [
    "root",
    "underline",
    "input"
]));





var $592Nh = parcelRequire("592Nh");
const $c365b6619e8e57e9$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $c365b6619e8e57e9$var$PickersFilledInputRoot = (0, $fhlQp.default)((0, $b4510dd60f8802d8$export$ddc18880178d980e), {
    name: "MuiPickersFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $08a7bc8a92e05f98$export$3ba67b570e26eea0)(prop) && prop !== "disableUnderline"
})(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $999788ef3d02aacf$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $999788ef3d02aacf$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        "&::after": {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $999788ef3d02aacf$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $999788ef3d02aacf$export$3964d3188824d772).error}`]: {
                        "&:before, &:after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $999788ef3d02aacf$export$3964d3188824d772).disabled}, .${(0, $999788ef3d02aacf$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $999788ef3d02aacf$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            {
                props: ({ startAdornment: startAdornment })=>!!startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ endAdornment: endAdornment })=>!!endAdornment,
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $c365b6619e8e57e9$var$PickersFilledSectionsContainer = (0, $fhlQp.default)((0, $b4510dd60f8802d8$export$52f3fbbfe9321824), {
    name: "MuiPickersFilledInput",
    slot: "sectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: ({ startAdornment: startAdornment })=>!!startAdornment,
            style: {
                paddingLeft: 0
            }
        },
        {
            props: ({ endAdornment: endAdornment })=>!!endAdornment,
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                size: "small"
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $c365b6619e8e57e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $999788ef3d02aacf$export$6cb188bdacb35d0e), classes);
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $c365b6619e8e57e9$export$8cc8c624890b5045 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersFilledInput"
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $c365b6619e8e57e9$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || "primary"
    });
    const classes = $c365b6619e8e57e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b4510dd60f8802d8$export$ff827734ba831074), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        slots: {
            root: $c365b6619e8e57e9$var$PickersFilledInputRoot,
            input: $c365b6619e8e57e9$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$c365b6619e8e57e9$export$8cc8c624890b5045.muiName = "Input";





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");






function $b3633e9e68aacf5c$export$defbb17803ff7cff(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersFilledInput", slot);
}
const $b3633e9e68aacf5c$export$f5c5ba079c8bb9dd = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $5c6c921c3ac8423c$export$f20b5ba262568322), (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersInput", [
    "root",
    "input"
]));





var $592Nh = parcelRequire("592Nh");
const $20e78907dab11ecf$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $20e78907dab11ecf$var$PickersInputRoot = (0, $fhlQp.default)((0, $b4510dd60f8802d8$export$ddc18880178d980e), {
    name: "MuiPickersInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        "label + &": {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        "&::after": {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    "&::after": {
                        background: "red",
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $b3633e9e68aacf5c$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $b3633e9e68aacf5c$export$f5c5ba079c8bb9dd).error}`]: {
                        "&:before, &:after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $b3633e9e68aacf5c$export$f5c5ba079c8bb9dd).disabled}, .${(0, $b3633e9e68aacf5c$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $b3633e9e68aacf5c$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            }
        ]
    };
});
const $20e78907dab11ecf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $b3633e9e68aacf5c$export$defbb17803ff7cff), classes);
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $20e78907dab11ecf$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersInput"
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $20e78907dab11ecf$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        disableUnderline: disableUnderline,
        color: muiFormControl?.color || "primary"
    });
    const classes = $20e78907dab11ecf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b4510dd60f8802d8$export$ff827734ba831074), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        slots: {
            root: $20e78907dab11ecf$var$PickersInputRoot
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$20e78907dab11ecf$export$7c4ebb2cfaf4f474.muiName = "Input";



var $592Nh = parcelRequire("592Nh");
"use client";
const $97e36ad1d7b41ef9$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps"
];
const $97e36ad1d7b41ef9$var$VARIANT_COMPONENT = {
    standard: (0, $20e78907dab11ecf$export$7c4ebb2cfaf4f474),
    filled: (0, $c365b6619e8e57e9$export$8cc8c624890b5045),
    outlined: (0, $73cbd526dc76f0f8$export$44d4d00edb0c710f)
};
const $97e36ad1d7b41ef9$var$PickersTextFieldRoot = (0, $fhlQp.default)((0, $df0187c1973aff1d$export$2e2bcd8739ae039), {
    name: "MuiPickersTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $97e36ad1d7b41ef9$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, classes: classes, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            focused && !disabled && "focused",
            disabled && "disabled",
            required && "required"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $c6a27a63f709a45c$export$d99678ed7aad1677), classes);
};
const $97e36ad1d7b41ef9$export$b3e9b101d92e4d4d = /*#__PURE__*/ $2hDQc.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersTextField"
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, color: color = "primary", disabled: disabled = false, error: error = false, variant: variant = "outlined", required: required = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $97e36ad1d7b41ef9$var$_excluded);
    const rootRef = $2hDQc.useRef(null);
    const handleRootRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        required: required,
        variant: variant
    });
    const classes = $97e36ad1d7b41ef9$var$useUtilityClasses(ownerState);
    const PickersInputComponent = $97e36ad1d7b41ef9$var$VARIANT_COMPONENT[variant];
    return /*#__PURE__*/ (0, $592Nh.jsxs)($97e36ad1d7b41ef9$var$PickersTextFieldRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRootRef,
        focused: focused,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        variant: variant,
        error: error,
        color: color,
        fullWidth: fullWidth,
        required: required,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $c66893090d56545d$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            /*#__PURE__*/ (0, $592Nh.jsx)(PickersInputComponent, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                elements: elements,
                areAllSectionsEmpty: areAllSectionsEmpty,
                onClick: onClick,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                onInput: onInput,
                onPaste: onPaste,
                endAdornment: endAdornment,
                startAdornment: startAdornment,
                tabIndex: tabIndex,
                contentEditable: contentEditable,
                value: value,
                onChange: onChange,
                id: id,
                fullWidth: fullWidth,
                inputProps: inputProps,
                inputRef: inputRef,
                sectionListRef: sectionListRef,
                label: label,
                name: name,
                role: "group",
                "aria-labelledby": inputLabelId
            }, InputProps)),
            helperText && /*#__PURE__*/ (0, $592Nh.jsx)((0, $ed8956e03f59bb6e$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});




const $48579f89749b710b$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $48579f89749b710b$var$_excluded2 = [
    "InputProps",
    "readOnly"
], $48579f89749b710b$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef"
];
const $48579f89749b710b$export$20bf15d9b24b4dad = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $48579f89749b710b$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly } = fieldResponse, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(fieldResponse, $48579f89749b710b$var$_excluded2);
        return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
            InputProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                readOnly: readOnly
            })
        });
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef } = fieldResponse, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(fieldResponse, $48579f89749b710b$var$_excluded3);
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
        InputProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
            readOnly: readOnly
        }),
        inputProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, inputProps ?? {}, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    });
};



var $592Nh = parcelRequire("592Nh");
"use client";
const $74a2cfc4679d3cd1$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const $74a2cfc4679d3cd1$export$ae1ced156568f0b0 = /*#__PURE__*/ $2hDQc.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateTimeField"
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(themeProps, $74a2cfc4679d3cd1$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $97e36ad1d7b41ef9$export$b3e9b101d92e4d4d) : (0, $ea4b9cb15628748b$export$2e2bcd8739ae039));
    const textFieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: inRef
        }
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $3a14efd6eb7a660c$export$2c2e7f1ceedfa8fa)(textFieldProps);
    const convertedFieldResponse = (0, $48579f89749b710b$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $ed4bfd55e5e0e707$export$db9644cdb7e3d432)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $592Nh.jsx)(TextField, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, processedFieldProps));
});




var $2hDQc = parcelRequire("2hDQc");

var $afHYP = parcelRequire("afHYP");



var $2hDQc = parcelRequire("2hDQc");





var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




function $47b9e76428c4002b$export$c994a6b377ce38df(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDateTimePickerTabs", slot);
}
const $47b9e76428c4002b$export$a2a6922f6f97d267 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDateTimePickerTabs", [
    "root"
]);




var $592Nh = parcelRequire("592Nh");
"use client";
const $8e3fa4346c27fe2f$var$viewToTab = (view)=>{
    if ((0, $6008d551a5f07604$export$b32dfef9f07dea64)(view)) return "date";
    return "time";
};
const $8e3fa4346c27fe2f$var$tabToView = (tab)=>{
    if (tab === "date") return "day";
    return "hours";
};
const $8e3fa4346c27fe2f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $47b9e76428c4002b$export$c994a6b377ce38df), classes);
};
const $8e3fa4346c27fe2f$var$DateTimePickerTabsRoot = (0, $fhlQp.default)((0, $ffe399ce3625ee07$export$2e2bcd8739ae039), {
    name: "MuiDateTimePickerTabs",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        "&:last-child": {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${(0, $7be0f9646402d49d$export$2e2bcd8739ae039).indicator}`]: {
                bottom: "auto",
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const $8e3fa4346c27fe2f$export$95dfad4074502244 = function DateTimePickerTabs(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateTimePickerTabs"
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $592Nh.jsx)((0, $3330a4c49b9b1ac8$export$90a8eab2a2411720), {}), onViewChange: onViewChange, timeIcon: timeIcon = /*#__PURE__*/ (0, $592Nh.jsx)((0, $3330a4c49b9b1ac8$export$7e95adcf912503e3), {}), view: view, hidden: hidden = typeof window === "undefined" || window.innerHeight < 667, className: className, sx: sx } = props;
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const classes = $8e3fa4346c27fe2f$var$useUtilityClasses(props);
    const handleChange = (event, value)=>{
        onViewChange($8e3fa4346c27fe2f$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($8e3fa4346c27fe2f$var$DateTimePickerTabsRoot, {
        ownerState: props,
        variant: "fullWidth",
        value: $8e3fa4346c27fe2f$var$viewToTab(view),
        onChange: handleChange,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $6152b1c1aa5c924e$export$2e2bcd8739ae039), {
                value: "date",
                "aria-label": translations.dateTableLabel,
                icon: /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $6152b1c1aa5c924e$export$2e2bcd8739ae039), {
                value: "time",
                "aria-label": translations.timeTableLabel,
                icon: /*#__PURE__*/ (0, $592Nh.jsx)($2hDQc.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


function $c0e322b46580cd75$export$2aab7addfa1bc589(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersToolbarText", slot);
}
const $c0e322b46580cd75$export$4ca7b92014bf2e56 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersToolbarText", [
    "root",
    "selected"
]);



var $592Nh = parcelRequire("592Nh");
const $5e141e2e43d77deb$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $5e141e2e43d77deb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $c0e322b46580cd75$export$2aab7addfa1bc589), classes);
};
const $5e141e2e43d77deb$var$PickersToolbarTextRoot = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarText",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $c0e322b46580cd75$export$4ca7b92014bf2e56).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create("color"),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $c0e322b46580cd75$export$4ca7b92014bf2e56).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $5e141e2e43d77deb$export$2006bc630443fa2 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersToolbarText"
    });
    const { className: className, value: value } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $5e141e2e43d77deb$var$_excluded);
    const classes = $5e141e2e43d77deb$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $592Nh.jsx)($5e141e2e43d77deb$var$PickersToolbarTextRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        component: "span"
    }, other, {
        children: value
    }));
});





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


function $323c234d6016ebcd$export$b109c489973c3d80(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersToolbar", slot);
}
const $323c234d6016ebcd$export$59f09e5e2b3d9913 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersToolbar", [
    "root",
    "content"
]);



var $592Nh = parcelRequire("592Nh");
const $ba48f243f78bafeb$var$_excluded = [
    "children",
    "className",
    "toolbarTitle",
    "hidden",
    "titleId",
    "isLandscape",
    "classes",
    "landscapeDirection"
];
const $ba48f243f78bafeb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $323c234d6016ebcd$export$b109c489973c3d80), classes);
};
const $ba48f243f78bafeb$var$PickersToolbarRoot = (0, $fhlQp.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    height: "auto",
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: "flex-start",
                    flexWrap: "wrap"
                }
            }
        ]
    }));
const $ba48f243f78bafeb$var$PickersToolbarContent = (0, $fhlQp.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column"
            }
        },
        {
            props: {
                isLandscape: true,
                landscapeDirection: "row"
            },
            style: {
                flexDirection: "row"
            }
        }
    ]
});
const $ba48f243f78bafeb$export$eb3c4d84783d6feb = /*#__PURE__*/ $2hDQc.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $ba48f243f78bafeb$var$_excluded);
    const ownerState = props;
    const classes = $ba48f243f78bafeb$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($ba48f243f78bafeb$var$PickersToolbarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)($ba48f243f78bafeb$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});





var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




var $592Nh = parcelRequire("592Nh");
const $06f07a8e6d52aac6$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $06f07a8e6d52aac6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $323c234d6016ebcd$export$b109c489973c3d80), classes);
};
const $06f07a8e6d52aac6$var$PickersToolbarButtonRoot = (0, $fhlQp.default)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarButton",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: "none"
});
const $06f07a8e6d52aac6$export$614ed940168c780c = /*#__PURE__*/ $2hDQc.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersToolbarButton"
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $06f07a8e6d52aac6$var$_excluded);
    const classes = $06f07a8e6d52aac6$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $592Nh.jsx)($06f07a8e6d52aac6$var$PickersToolbarButtonRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        variant: "text",
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5e141e2e43d77deb$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});





function $964d49d081fee76c$export$c40f5731216f0c9d(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDateTimePickerToolbar", slot);
}
const $964d49d081fee76c$export$82ac739c3153ffd4 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDateTimePickerToolbar", [
    "root",
    "dateContainer",
    "timeContainer",
    "timeDigitsContainer",
    "separator",
    "timeLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);



var $2hDQc = parcelRequire("2hDQc");


function $78e4c4ab8f2469fb$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    return $2hDQc.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $78e4c4ab8f2469fb$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    return $2hDQc.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $78e4c4ab8f2469fb$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const meridiemMode = (0, $9aafba1b8c629c28$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $2hDQc.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $9aafba1b8c629c28$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? "partial");
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}


const $8768610d9d8fd41e$export$3f0060ce4cc8f4d0 = 36;
const $8768610d9d8fd41e$export$dde58b009b497666 = 2;
const $8768610d9d8fd41e$export$ee46b8a74d6c94d3 = 320;
const $8768610d9d8fd41e$export$73724491020e90c7 = 280;
const $8768610d9d8fd41e$export$f2fef360e2df0cb7 = 336;
const $8768610d9d8fd41e$export$1c2eabda4acea0e4 = 232;
const $8768610d9d8fd41e$export$a462ceb9cfdb5d71 = 48;






var $592Nh = parcelRequire("592Nh");
"use client";
const $daad2a0674de6d50$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "onChange",
    "view",
    "isLandscape",
    "onViewChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "disabled",
    "readOnly",
    "toolbarVariant",
    "toolbarTitle",
    "className"
];
const $daad2a0674de6d50$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape, isRtl: isRtl } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        dateContainer: [
            "dateContainer"
        ],
        timeContainer: [
            "timeContainer",
            isRtl && "timeLabelReverse"
        ],
        timeDigitsContainer: [
            "timeDigitsContainer",
            isRtl && "timeLabelReverse"
        ],
        separator: [
            "separator"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $964d49d081fee76c$export$c40f5731216f0c9d), classes);
};
const $daad2a0674de6d50$var$DateTimePickerToolbarRoot = (0, $fhlQp.default)((0, $ba48f243f78bafeb$export$eb3c4d84783d6feb), {
    name: "MuiDateTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: "space-around",
        position: "relative",
        variants: [
            {
                props: {
                    toolbarVariant: "desktop"
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${(0, $323c234d6016ebcd$export$59f09e5e2b3d9913).content} .${(0, $c0e322b46580cd75$export$4ca7b92014bf2e56).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: true
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: false
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
const $daad2a0674de6d50$var$DateTimePickerToolbarDateContainer = (0, $fhlQp.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "DateContainer",
    overridesResolver: (props, styles)=>styles.dateContainer
})({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
});
const $daad2a0674de6d50$var$DateTimePickerToolbarTimeContainer = (0, $fhlQp.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "TimeContainer",
    overridesResolver: (props, styles)=>styles.timeContainer
})({
    display: "flex",
    flexDirection: "row",
    variants: [
        {
            props: {
                isRtl: true
            },
            style: {
                flexDirection: "row-reverse"
            }
        },
        {
            props: {
                toolbarVariant: "desktop",
                isLandscape: false
            },
            style: {
                gap: 9,
                marginRight: 4,
                alignSelf: "flex-end"
            }
        },
        {
            props: ({ isLandscape: isLandscape, toolbarVariant: toolbarVariant })=>isLandscape && toolbarVariant !== "desktop",
            style: {
                flexDirection: "column"
            }
        },
        {
            props: ({ isLandscape: isLandscape, toolbarVariant: toolbarVariant, isRtl: isRtl })=>isLandscape && toolbarVariant !== "desktop" && isRtl,
            style: {
                flexDirection: "column-reverse"
            }
        }
    ]
});
const $daad2a0674de6d50$var$DateTimePickerToolbarTimeDigitsContainer = (0, $fhlQp.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "TimeDigitsContainer",
    overridesResolver: (props, styles)=>styles.timeDigitsContainer
})({
    display: "flex",
    variants: [
        {
            props: {
                isRtl: true
            },
            style: {
                flexDirection: "row-reverse"
            }
        },
        {
            props: {
                toolbarVariant: "desktop"
            },
            style: {
                gap: 1.5
            }
        }
    ]
});
const $daad2a0674de6d50$var$DateTimePickerToolbarSeparator = (0, $fhlQp.default)((0, $5e141e2e43d77deb$export$2006bc630443fa2), {
    name: "MuiDateTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    margin: "0 4px 0 2px",
    cursor: "default",
    variants: [
        {
            props: {
                toolbarVariant: "desktop"
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const $daad2a0674de6d50$var$DateTimePickerToolbarAmPmSelection = (0, $fhlQp.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $964d49d081fee76c$export$82ac739c3153ffd4).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $964d49d081fee76c$export$82ac739c3153ffd4).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    marginLeft: 12,
    [`& .${(0, $964d49d081fee76c$export$82ac739c3153ffd4).ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: "4px 0 auto",
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%"
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerToolbar API](https://mui.com/x/api/date-pickers/date-time-picker-toolbar/)
 */ function $daad2a0674de6d50$export$fe4ab7cbc0078243(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, onChange: onChange, view: view, isLandscape: isLandscape, onViewChange: onViewChange, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, disabled: disabled, readOnly: readOnly, toolbarVariant: toolbarVariant = "mobile", toolbarTitle: inToolbarTitle, className: className } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $daad2a0674de6d50$var$_excluded);
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl
    });
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $78e4c4ab8f2469fb$export$6aaabc31cb076d17)(value, ampm, onChange);
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const isDesktop = toolbarVariant === "desktop";
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const classes = $daad2a0674de6d50$var$useUtilityClasses(ownerState);
    const toolbarTitle = inToolbarTitle ?? translations.dateTimePickerToolbarTitle;
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const dateText = $2hDQc.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(value, toolbarFormat);
        return utils.format(value, "shortDate");
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($daad2a0674de6d50$var$DateTimePickerToolbarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        isLandscape: isLandscape,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        toolbarTitle: toolbarTitle
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)($daad2a0674de6d50$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes("year") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>onViewChange("year"),
                        selected: view === "year",
                        value: value ? utils.format(value, "year") : "\u2013"
                    }),
                    views.includes("day") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: isDesktop ? "h5" : "h4",
                        onClick: ()=>onViewChange("day"),
                        selected: view === "day",
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)($daad2a0674de6d50$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsxs)($daad2a0674de6d50$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        children: [
                            views.includes("hours") && /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $8768610d9d8fd41e$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("hours"),
                                        selected: view === "hours",
                                        value: value ? formatHours(value) : "--"
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)($daad2a0674de6d50$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? "h5" : "h3",
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $8768610d9d8fd41e$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("minutes"),
                                        selected: view === "minutes" || !views.includes("minutes") && view === "hours",
                                        value: value ? utils.format(value, "minutes") : "--",
                                        disabled: !views.includes("minutes")
                                    })
                                ]
                            }),
                            views.includes("seconds") && /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)($daad2a0674de6d50$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? "h5" : "h3",
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $8768610d9d8fd41e$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("seconds"),
                                        selected: view === "seconds",
                                        value: value ? utils.format(value, "seconds") : "--"
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $592Nh.jsxs)($daad2a0674de6d50$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === "am",
                                typographyClassName: classes.ampmLabel,
                                value: (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "am"),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === "pm",
                                typographyClassName: classes.ampmLabel,
                                value: (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "pm"),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                        variant: "h5",
                        onClick: ()=>onViewChange("meridiem"),
                        selected: view === "meridiem",
                        value: value && meridiemMode ? (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, meridiemMode) : "--",
                        width: (0, $8768610d9d8fd41e$export$a462ceb9cfdb5d71)
                    })
                ]
            })
        ]
    }));
}



function $b357cd105ba6c926$export$6e4d96e87e6dc2d3(props, name) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const themeProps = (0, $afHYP.default)({
        props: props,
        name: name
    });
    const ampm = themeProps.ampm ?? utils.is12HourCycleInCurrentLocale();
    const localeText = $2hDQc.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps, (0, $bd76bef4ec2caf62$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "year",
            "day",
            "hours",
            "minutes"
        ],
        defaultOpenTo: "day"
    }), {
        ampm: ampm,
        localeText: localeText,
        orientation: themeProps.orientation ?? "portrait",
        // TODO: Remove from public API
        disableIgnoringDatePartForTimeValidation: themeProps.disableIgnoringDatePartForTimeValidation ?? Boolean(themeProps.minDateTime || themeProps.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
        themeProps.disablePast || themeProps.disableFuture),
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.minDateTime ?? themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.maxDateTime ?? themeProps.maxDate, defaultDates.maxDate),
        minTime: themeProps.minDateTime ?? themeProps.minTime,
        maxTime: themeProps.maxDateTime ?? themeProps.maxTime,
        slots: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            toolbar: (0, $daad2a0674de6d50$export$fe4ab7cbc0078243),
            tabs: (0, $8e3fa4346c27fe2f$export$95dfad4074502244)
        }, themeProps.slots),
        slotProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps.slotProps, {
            toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                ampm: ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}


parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");



var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");


"use client";
const $abe0ba4ffb5e3f52$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $404db1959acab970$export$4b5a24245de9f7f9)();
    return $2hDQc.useCallback((day)=>(0, $7ee2e31e1f24b6a5$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





"use client";
const $af942451118d86d9$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "changeMonthTimezone":
                {
                    const newTimezone = action.newTimezone;
                    if (utils.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = utils.setTimezone(state.currentMonth, newTimezone);
                    if (utils.getMonth(newCurrentMonth) !== utils.getMonth(state.currentMonth)) newCurrentMonth = utils.setMonth(newCurrentMonth, utils.getMonth(state.currentMonth));
                    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case "finishMonthSwitchingAnimation":
                return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const $af942451118d86d9$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const reducerFn = $2hDQc.useRef($af942451118d86d9$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $2hDQc.useMemo(()=>{
        return (0, $60e2396f80eb3f46$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $2hDQc.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: "left"
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $2hDQc.useEffect(()=>{
        dispatch({
            type: "changeMonthTimezone",
            newTimezone: utils.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        utils
    ]);
    const handleChangeMonth = $2hDQc.useCallback((payload)=>{
        dispatch((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $2hDQc.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $abe0ba4ffb5e3f52$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $2hDQc.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


const $8a3ee9e00a2fff03$export$5b0bb0174eb448ca = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersFadeTransitionGroup", slot);
const $8a3ee9e00a2fff03$export$1461f245817ac559 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersFadeTransitionGroup", [
    "root"
]);



var $592Nh = parcelRequire("592Nh");
const $a4c5c6d72b520201$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $8a3ee9e00a2fff03$export$5b0bb0174eb448ca), classes);
};
const $a4c5c6d72b520201$var$PickersFadeTransitionGroupRoot = (0, $fhlQp.default)((0, $1eae365b5beaad76$export$2e2bcd8739ae039), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function $a4c5c6d72b520201$export$5262185daf493fee(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $a4c5c6d72b520201$var$useUtilityClasses(props);
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $592Nh.jsx)($a4c5c6d72b520201$var$PickersFadeTransitionGroupRoot, {
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $12215051e1caa84a$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $2hDQc = parcelRequire("2hDQc");





var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");





var $2hDQc = parcelRequire("2hDQc");





var $6KAST = parcelRequire("6KAST");
var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");



function $1c210933cd2b217d$export$4b25deb0350d3e53(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersDay", slot);
}
const $1c210933cd2b217d$export$68b221ad3c35e288 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);



var $592Nh = parcelRequire("592Nh");
"use client";
const $d20698e631973012$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $d20698e631973012$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            "root",
            selected && !isHiddenDaySpacingFiller && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $1c210933cd2b217d$export$4b25deb0350d3e53), classes);
};
const $d20698e631973012$var$styleArg = ({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $8768610d9d8fd41e$export$3f0060ce4cc8f4d0),
        height: (0, $8768610d9d8fd41e$export$3f0060ce4cc8f4d0),
        borderRadius: "50%",
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: "transparent",
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        "@media (pointer: fine)": {
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).selected}`]: {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            "&:hover": {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).disabled}:not(.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).disabled}&.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $8768610d9d8fd41e$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    outsideCurrentMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    today: true
                },
                style: {
                    [`&:not(.${(0, $1c210933cd2b217d$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $d20698e631973012$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $d20698e631973012$var$PickersDayRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $d20698e631973012$var$overridesResolver
})($d20698e631973012$var$styleArg);
const $d20698e631973012$var$PickersDayFiller = (0, $fhlQp.default)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $d20698e631973012$var$overridesResolver
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $d20698e631973012$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const $d20698e631973012$var$noop = ()=>{};
const $d20698e631973012$var$PickersDayRaw = /*#__PURE__*/ $2hDQc.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $d20698e631973012$var$noop, onBlur: onBlur = $d20698e631973012$var$noop, onKeyDown: onKeyDown = $d20698e631973012$var$noop, onMouseDown: onMouseDown = $d20698e631973012$var$noop, onMouseEnter: onMouseEnter = $d20698e631973012$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $d20698e631973012$var$_excluded);
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $d20698e631973012$var$useUtilityClasses(ownerState);
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const ref = $2hDQc.useRef(null);
    const handleRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $592Nh.jsx)($d20698e631973012$var$PickersDayFiller, {
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($d20698e631973012$var$PickersDayRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const $d20698e631973012$export$d7378e6e864346fa = /*#__PURE__*/ $2hDQc.memo($d20698e631973012$var$PickersDayRaw);








var $2hDQc = parcelRequire("2hDQc");


var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $70b88a28a6db4636$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $cce5fe13fb4f6f3a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $70b88a28a6db4636$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $ee115fd9f4d7d8de$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $ee115fd9f4d7d8de$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $ee115fd9f4d7d8de$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $ee115fd9f4d7d8de$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $2hDQc = parcelRequire("2hDQc");



var $b0a4cd95999a31f9$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $cce5fe13fb4f6f3a$export$2e2bcd8739ae039)(node, c);
    });
};
var $b0a4cd95999a31f9$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $ee115fd9f4d7d8de$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $b0a4cd95999a31f9$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $dfdff6b428ca04e3$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $79a4a62df1ed8344$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $b0a4cd95999a31f9$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $b0a4cd95999a31f9$var$removeClass(node, baseClassName);
        if (activeClassName) $b0a4cd95999a31f9$var$removeClass(node, activeClassName);
        if (doneClassName) $b0a4cd95999a31f9$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $gZOiq.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).createElement((0, $f1775b3e9e6fc859$export$2e2bcd8739ae039), (0, $kxIgO.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Component);
$b0a4cd95999a31f9$var$CSSTransition.defaultProps = {
    classNames: ""
};
$b0a4cd95999a31f9$var$CSSTransition.propTypes = {};
var $b0a4cd95999a31f9$export$2e2bcd8739ae039 = $b0a4cd95999a31f9$var$CSSTransition;



const $1ac5715d1f344cf1$export$e98c1b6c3bbc3c59 = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersSlideTransition", slot);
const $1ac5715d1f344cf1$export$d251a58673156a67 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);



var $592Nh = parcelRequire("592Nh");
const $aea79aa4750830eb$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $aea79aa4750830eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        exit: [
            "slideExit"
        ],
        enterActive: [
            "slideEnterActive"
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $1ac5715d1f344cf1$export$e98c1b6c3bbc3c59), classes);
};
const $aea79aa4750830eb$var$PickersSlideTransitionRoot = (0, $fhlQp.default)((0, $1eae365b5beaad76$export$2e2bcd8739ae039), {
    name: "MuiPickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, $1ac5715d1f344cf1$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $1ac5715d1f344cf1$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: theme.transitions.duration.complex,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, $1ac5715d1f344cf1$export$d251a58673156a67).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, $1ac5715d1f344cf1$export$d251a58673156a67).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $1ac5715d1f344cf1$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $aea79aa4750830eb$export$e868fcc7557d3a06(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersSlideTransition"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $aea79aa4750830eb$var$_excluded);
    const classes = $aea79aa4750830eb$var$useUtilityClasses(props);
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $592Nh.jsx)("div", {
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)($aea79aa4750830eb$var$PickersSlideTransitionRoot, {
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $2hDQc.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b0a4cd95999a31f9$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





const $108aeae4a02f72ea$export$fbe827982a69894a = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDayCalendar", slot);
const $108aeae4a02f72ea$export$b3f91ee59da1294a = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDayCalendar", [
    "root",
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer",
    "weekNumberLabel",
    "weekNumber"
]);



var $592Nh = parcelRequire("592Nh");
const $9e3690639f536c9e$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $9e3690639f536c9e$var$_excluded2 = [
    "ownerState"
];
const $9e3690639f536c9e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ],
        weekNumberLabel: [
            "weekNumberLabel"
        ],
        weekNumber: [
            "weekNumber"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $108aeae4a02f72ea$export$fbe827982a69894a), classes);
};
const $9e3690639f536c9e$var$weeksContainerHeight = ((0, $8768610d9d8fd41e$export$3f0060ce4cc8f4d0) + (0, $8768610d9d8fd41e$export$dde58b009b497666) * 2) * 6;
const $9e3690639f536c9e$var$PickersCalendarDayRoot = (0, $fhlQp.default)("div", {
    name: "MuiDayCalendar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $9e3690639f536c9e$var$PickersCalendarDayHeader = (0, $fhlQp.default)("div", {
    name: "MuiDayCalendar",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $9e3690639f536c9e$var$PickersCalendarWeekDayLabel = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: (theme.vars || theme).palette.text.secondary
    }));
const $9e3690639f536c9e$var$PickersCalendarWeekNumberLabel = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumberLabel",
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.disabled
    }));
const $9e3690639f536c9e$var$PickersCalendarWeekNumber = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumber",
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $8768610d9d8fd41e$export$3f0060ce4cc8f4d0),
        height: (0, $8768610d9d8fd41e$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $8768610d9d8fd41e$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: "0.75rem",
        alignItems: "center",
        justifyContent: "center",
        display: "inline-flex"
    }));
const $9e3690639f536c9e$var$PickersCalendarLoadingContainer = (0, $fhlQp.default)("div", {
    name: "MuiDayCalendar",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: $9e3690639f536c9e$var$weeksContainerHeight
});
const $9e3690639f536c9e$var$PickersCalendarSlideTransition = (0, $fhlQp.default)((0, $aea79aa4750830eb$export$e868fcc7557d3a06), {
    name: "MuiDayCalendar",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $9e3690639f536c9e$var$weeksContainerHeight
});
const $9e3690639f536c9e$var$PickersCalendarWeekContainer = (0, $fhlQp.default)("div", {
    name: "MuiDayCalendar",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const $9e3690639f536c9e$var$PickersCalendarWeek = (0, $fhlQp.default)("div", {
    name: "MuiDayCalendar",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $8768610d9d8fd41e$export$dde58b009b497666)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function $9e3690639f536c9e$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $9e3690639f536c9e$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = slots?.day ?? (0, $d20698e631973012$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: "gridcell",
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            "data-timestamp": utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps, $9e3690639f536c9e$var$_excluded2);
    const isDisabled = $2hDQc.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $2hDQc.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $2hDQc.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $2hDQc.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)(Day, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? "date" : undefined
    }));
}
function $9e3690639f536c9e$export$8fb56b32a5df6314(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDayCalendar"
    });
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $592Nh.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>utils.format(date, "weekdayShort").charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const classes = $9e3690639f536c9e$var$useUtilityClasses(props);
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const isDateDisabled = (0, $abe0ba4ffb5e3f52$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const [internalHasFocus, setInternalHasFocus] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: "DayCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $2hDQc.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $b61557e39989b411$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange?.(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $6008d551a5f07604$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $6008d551a5f07604$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = $2hDQc.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $2hDQc.useMemo(()=>/*#__PURE__*/ $2hDQc.createRef(), [
        transitionKey
    ]);
    const focusableDay = $2hDQc.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $6008d551a5f07604$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $2hDQc.useMemo(()=>{
        const toDisplay = utils.getWeekArray(currentMonth);
        let nextMonth = utils.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($9e3690639f536c9e$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)($9e3690639f536c9e$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $6008d551a5f07604$export$24c38139da66592d)(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(weekday, "weekday"),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$PickersCalendarSlideTransition, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $592Nh.jsxs)($9e3690639f536c9e$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $592Nh.jsx)($9e3690639f536c9e$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




var $2hDQc = parcelRequire("2hDQc");


var $6KAST = parcelRequire("6KAST");
var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




function $ba1a4f0061dac0b3$export$db90a620ac957a73(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersMonth", slot);
}
const $ba1a4f0061dac0b3$export$911e3973fa70a12b = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersMonth", [
    "root",
    "monthButton",
    "disabled",
    "selected"
]);



var $592Nh = parcelRequire("592Nh");
const $af66ab21a4a89370$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow",
    "slots",
    "slotProps"
];
const $af66ab21a4a89370$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthButton: [
            "monthButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $ba1a4f0061dac0b3$export$db90a620ac957a73), classes);
};
const $af66ab21a4a89370$var$PickersMonthRoot = (0, $fhlQp.default)("div", {
    name: "MuiPickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "33.3%",
    variants: [
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                flexBasis: "25%"
            }
        }
    ]
});
const $af66ab21a4a89370$var$MonthCalendarButton = (0, $fhlQp.default)("button", {
    name: "MuiPickersMonth",
    slot: "MonthButton",
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $ba1a4f0061dac0b3$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $ba1a4f0061dac0b3$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $ba1a4f0061dac0b3$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $ba1a4f0061dac0b3$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $af66ab21a4a89370$export$bc52fdb7f02f591a = /*#__PURE__*/ $2hDQc.memo(function PickersMonth(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersMonth"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent, "aria-label": ariaLabel, slots: slots, slotProps: slotProps } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $af66ab21a4a89370$var$_excluded);
    const ref = $2hDQc.useRef(null);
    const classes = $af66ab21a4a89370$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $af66ab21a4a89370$var$MonthCalendarButton;
    const monthButtonProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: "button",
            role: "radio",
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.monthButton
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($af66ab21a4a89370$var$PickersMonthRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)(MonthButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, monthButtonProps))
    }));
});




function $c589b6b3e9dccde5$export$da0c97315339ebd9(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiMonthCalendar", slot);
}
const $c589b6b3e9dccde5$export$edf77d5566c7007c = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiMonthCalendar", [
    "root"
]);








var $592Nh = parcelRequire("592Nh");
"use client";
const $a1dc52b030c13eff$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $a1dc52b030c13eff$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $c589b6b3e9dccde5$export$da0c97315339ebd9), classes);
};
function $a1dc52b030c13eff$export$5b6e066572408095(props, name) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const themeProps = (0, $afHYP.default)({
        props: props,
        name: name
    });
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $a1dc52b030c13eff$var$MonthCalendarRoot = (0, $fhlQp.default)("div", {
    name: "MuiMonthCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    padding: "0 4px",
    width: (0, $8768610d9d8fd41e$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: "border-box"
});
const $a1dc52b030c13eff$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $2hDQc.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $a1dc52b030c13eff$export$5b6e066572408095(inProps, "MuiMonthCalendar");
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $a1dc52b030c13eff$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "MonthCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba)
    });
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const referenceDate = $2hDQc.useMemo(()=>(0, $60e2396f80eb3f46$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $a1dc52b030c13eff$var$useUtilityClasses(ownerState);
    const todayMonth = $2hDQc.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $2hDQc.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = $2hDQc.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: "MonthCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $2hDQc.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $b61557e39989b411$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $2hDQc.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($a1dc52b030c13eff$var$MonthCalendarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $6008d551a5f07604$export$62591b96a734eacd)(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const monthLabel = utils.format(month, "month");
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $592Nh.jsx)((0, $af66ab21a4a89370$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? "date" : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: monthText
            }, monthText);
        })
    }));
});





var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




var $2hDQc = parcelRequire("2hDQc");


var $6KAST = parcelRequire("6KAST");
var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




function $9a6102e8fd190be4$export$183c9f339a61cd79(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersYear", slot);
}
const $9a6102e8fd190be4$export$4ef58a3d9c6f4296 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersYear", [
    "root",
    "yearButton",
    "selected",
    "disabled"
]);



var $592Nh = parcelRequire("592Nh");
const $be0f36f652e79fc1$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow",
    "slots",
    "slotProps"
];
const $be0f36f652e79fc1$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $9a6102e8fd190be4$export$183c9f339a61cd79), classes);
};
const $be0f36f652e79fc1$var$PickersYearRoot = (0, $fhlQp.default)("div", {
    name: "MuiPickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "33.3%",
    variants: [
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                flexBasis: "25%"
            }
        }
    ]
});
const $be0f36f652e79fc1$var$YearCalendarButton = (0, $fhlQp.default)("button", {
    name: "MuiPickersYear",
    slot: "YearButton",
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $9a6102e8fd190be4$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $9a6102e8fd190be4$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "6px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6KAST.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $9a6102e8fd190be4$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $9a6102e8fd190be4$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $be0f36f652e79fc1$export$261f3fbd5fd5814d = /*#__PURE__*/ $2hDQc.memo(function PickersYear(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersYear"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent, slots: slots, slotProps: slotProps } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $be0f36f652e79fc1$var$_excluded);
    const ref = $2hDQc.useRef(null);
    const classes = $be0f36f652e79fc1$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $be0f36f652e79fc1$var$YearCalendarButton;
    const yearButtonProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: "button",
            role: "radio",
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.yearButton
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)($be0f36f652e79fc1$var$PickersYearRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)(YearButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, yearButtonProps))
    }));
});




function $c13a779988803be5$export$4477acc520094dec(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiYearCalendar", slot);
}
const $c13a779988803be5$export$e42d427cd9fe5fd7 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiYearCalendar", [
    "root"
]);








var $592Nh = parcelRequire("592Nh");
"use client";
const $5934abc02d20fcdf$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $5934abc02d20fcdf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $c13a779988803be5$export$4477acc520094dec), classes);
};
function $5934abc02d20fcdf$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const themeProps = (0, $afHYP.default)({
        props: props,
        name: name
    });
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $5934abc02d20fcdf$var$YearCalendarRoot = (0, $fhlQp.default)("div", {
    name: "MuiYearCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    width: (0, $8768610d9d8fd41e$export$ee46b8a74d6c94d3),
    maxHeight: (0, $8768610d9d8fd41e$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: "border-box",
    position: "relative"
});
const $5934abc02d20fcdf$export$657f9200591b2b71 = /*#__PURE__*/ $2hDQc.forwardRef(function YearCalendar(inProps, ref) {
    const props = $5934abc02d20fcdf$var$useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder = "asc", yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $5934abc02d20fcdf$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "YearCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba)
    });
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const referenceDate = $2hDQc.useMemo(()=>(0, $60e2396f80eb3f46$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $5934abc02d20fcdf$var$useUtilityClasses(ownerState);
    const todayYear = $2hDQc.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $2hDQc.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = $2hDQc.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: "YearCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $2hDQc.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $b61557e39989b411$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $2hDQc.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== "desc" ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === "asc" || !isRtl && yearsOrder === "desc" ? -1 : 1;
    const handleKeyDown = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $2hDQc.useRef(null);
    const handleRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, scrollerRef);
    $2hDQc.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = utils.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === "desc") yearRange.reverse();
    return /*#__PURE__*/ (0, $592Nh.jsx)($5934abc02d20fcdf$var$YearCalendarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: yearRange.map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $592Nh.jsx)((0, $be0f36f652e79fc1$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? "date" : undefined,
                yearsPerRow: yearsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    }));
});



var $2hDQc = parcelRequire("2hDQc");


let $2c5912d759d255cd$var$warnedOnceNotValidView = false;
function $2c5912d759d255cd$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    const previousOpenTo = $2hDQc.useRef(openTo);
    const previousViews = $2hDQc.useRef(views);
    const defaultView = $2hDQc.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "view",
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $2hDQc.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "focusedView",
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $2hDQc.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $b61557e39989b411$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}





var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");










var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");





function $f8ed98c7bfa9e14c$export$cef978c25740de90(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersArrowSwitcher", slot);
}
const $f8ed98c7bfa9e14c$export$f8819209558cd362 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button",
    "previousIconButton",
    "nextIconButton",
    "leftArrowIcon",
    "rightArrowIcon"
]);



var $592Nh = parcelRequire("592Nh");
const $da6a77f421ae8723$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId"
], $da6a77f421ae8723$var$_excluded2 = [
    "ownerState"
], $da6a77f421ae8723$var$_excluded3 = [
    "ownerState"
];
const $da6a77f421ae8723$var$PickersArrowSwitcherRoot = (0, $fhlQp.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const $da6a77f421ae8723$var$PickersArrowSwitcherSpacer = (0, $fhlQp.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $da6a77f421ae8723$var$PickersArrowSwitcherButton = (0, $fhlQp.default)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})({
    variants: [
        {
            props: {
                hidden: true
            },
            style: {
                visibility: "hidden"
            }
        }
    ]
});
const $da6a77f421ae8723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ],
        previousIconButton: [
            "previousIconButton"
        ],
        nextIconButton: [
            "nextIconButton"
        ],
        leftArrowIcon: [
            "leftArrowIcon"
        ],
        rightArrowIcon: [
            "rightArrowIcon"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $f8ed98c7bfa9e14c$export$cef978c25740de90), classes);
};
const $da6a77f421ae8723$export$597b7cbdb7b2a24c = /*#__PURE__*/ $2hDQc.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $da6a77f421ae8723$var$_excluded);
    const ownerState = props;
    const classes = $da6a77f421ae8723$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $da6a77f421ae8723$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: "medium",
            title: previousProps.label,
            "aria-label": previousProps.label,
            disabled: previousProps.isDisabled,
            edge: "end",
            onClick: previousProps.goTo
        },
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $da6a77f421ae8723$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: "medium",
            title: nextProps.label,
            "aria-label": nextProps.label,
            disabled: nextProps.isDisabled,
            edge: "start",
            onClick: nextProps.goTo
        },
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $3330a4c49b9b1ac8$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps, $da6a77f421ae8723$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $3330a4c49b9b1ac8$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps2, $da6a77f421ae8723$var$_excluded3);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($da6a77f421ae8723$var$PickersArrowSwitcherRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)(PreviousIconButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $592Nh.jsx)(RightArrowIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $592Nh.jsx)(LeftArrowIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $592Nh.jsx)($da6a77f421ae8723$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)(NextIconButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $592Nh.jsx)(LeftArrowIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $592Nh.jsx)(RightArrowIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});




const $69ee8bd619d251ef$export$457ac4d3a1ad92b4 = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersCalendarHeader", slot);
const $69ee8bd619d251ef$export$63db7afb9247cb91 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);



var $592Nh = parcelRequire("592Nh");
"use client";
const $48b2c8152396d2e7$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone",
    "format"
], $48b2c8152396d2e7$var$_excluded2 = [
    "ownerState"
];
const $48b2c8152396d2e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $69ee8bd619d251ef$export$457ac4d3a1ad92b4), classes);
};
const $48b2c8152396d2e7$var$PickersCalendarHeaderRoot = (0, $fhlQp.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $48b2c8152396d2e7$var$PickersCalendarHeaderLabelContainer = (0, $fhlQp.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $48b2c8152396d2e7$var$PickersCalendarHeaderLabel = (0, $fhlQp.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $48b2c8152396d2e7$var$PickersCalendarHeaderSwitchViewButton = (0, $fhlQp.default)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: "auto",
    variants: [
        {
            props: {
                view: "year"
            },
            style: {
                [`.${(0, $69ee8bd619d251ef$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: "rotate(180deg)"
                }
            }
        }
    ]
});
const $48b2c8152396d2e7$var$PickersCalendarHeaderSwitchViewIcon = (0, $fhlQp.default)((0, $3330a4c49b9b1ac8$export$ed0fe318cc298673), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $48b2c8152396d2e7$export$6801ffebb353f473 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone, format: format = `${utils.formats.month} ${utils.formats.year}` } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $48b2c8152396d2e7$var$_excluded);
    const ownerState = props;
    const classes = $48b2c8152396d2e7$var$useUtilityClasses(props);
    const SwitchViewButton = slots?.switchViewButton ?? $48b2c8152396d2e7$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: "small",
            "aria-label": translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $48b2c8152396d2e7$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps, $48b2c8152396d2e7$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), "right");
    const isNextMonthDisabled = (0, $78e4c4ab8f2469fb$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $78e4c4ab8f2469fb$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($48b2c8152396d2e7$var$PickersCalendarHeaderRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)($48b2c8152396d2e7$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $a4c5c6d72b520201$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)($48b2c8152396d2e7$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $592Nh.jsx)(SwitchViewButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)(SwitchViewIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $12215051e1caa84a$export$2e2bcd8739ae039), {
                in: view === "day",
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $da6a77f421ae8723$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});




var $fhlQp = parcelRequire("fhlQp");

const $63f62fcdd7a667e6$export$512b066b8abdfde4 = (0, $fhlQp.default)("div")({
    overflow: "hidden",
    width: (0, $8768610d9d8fd41e$export$ee46b8a74d6c94d3),
    maxHeight: (0, $8768610d9d8fd41e$export$f2fef360e2df0cb7),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});



const $fb3a5f9ff3173fe5$var$PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
// detect if user agent has Android version < 10 or iOS version < 13
const $fb3a5f9ff3173fe5$var$mobileVersionMatches = typeof navigator !== "undefined" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $fb3a5f9ff3173fe5$var$androidVersion = $fb3a5f9ff3173fe5$var$mobileVersionMatches && $fb3a5f9ff3173fe5$var$mobileVersionMatches[1] ? parseInt($fb3a5f9ff3173fe5$var$mobileVersionMatches[1], 10) : null;
const $fb3a5f9ff3173fe5$var$iOSVersion = $fb3a5f9ff3173fe5$var$mobileVersionMatches && $fb3a5f9ff3173fe5$var$mobileVersionMatches[2] ? parseInt($fb3a5f9ff3173fe5$var$mobileVersionMatches[2], 10) : null;
const $fb3a5f9ff3173fe5$export$7e3b2a595fb375e5 = $fb3a5f9ff3173fe5$var$androidVersion && $fb3a5f9ff3173fe5$var$androidVersion < 10 || $fb3a5f9ff3173fe5$var$iOSVersion && $fb3a5f9ff3173fe5$var$iOSVersion < 13 || false;
const $fb3a5f9ff3173fe5$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $ef97679917c36082$export$2e2bcd8739ae039)($fb3a5f9ff3173fe5$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $fb3a5f9ff3173fe5$export$7e3b2a595fb375e5;
};



const $6cf6de08b0e4b85d$export$da8c2318897a6672 = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDateCalendar", slot);
const $6cf6de08b0e4b85d$export$d0237e2bb9598e8d = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDateCalendar", [
    "root",
    "viewTransitionContainer"
]);






var $592Nh = parcelRequire("592Nh");
"use client";
const $cac04a8893bbf0ec$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $cac04a8893bbf0ec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $6cf6de08b0e4b85d$export$da8c2318897a6672), classes);
};
function $cac04a8893bbf0ec$var$useDateCalendarDefaultizedProps(props, name) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $fb3a5f9ff3173fe5$export$ce40fb97be7f02d9)();
    const themeProps = (0, $afHYP.default)({
        props: props,
        name: name
    });
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps, {
        loading: themeProps.loading ?? false,
        disablePast: themeProps.disablePast ?? false,
        disableFuture: themeProps.disableFuture ?? false,
        openTo: themeProps.openTo ?? "day",
        views: themeProps.views ?? [
            "year",
            "day"
        ],
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $592Nh.jsx)("span", {
                children: "..."
            })),
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $cac04a8893bbf0ec$var$DateCalendarRoot = (0, $fhlQp.default)((0, $63f62fcdd7a667e6$export$512b066b8abdfde4), {
    name: "MuiDateCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    height: (0, $8768610d9d8fd41e$export$f2fef360e2df0cb7)
});
const $cac04a8893bbf0ec$var$DateCalendarViewTransitionContainer = (0, $fhlQp.default)((0, $a4c5c6d72b520201$export$5262185daf493fee), {
    name: "MuiDateCalendar",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $cac04a8893bbf0ec$export$68078fe5d2bf8909 = /*#__PURE__*/ $2hDQc.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const id = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const props = $cac04a8893bbf0ec$var$useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $cac04a8893bbf0ec$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "DateCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $2c5912d759d255cd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $af942451118d86d9$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $48b2c8152396d2e7$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $6008d551a5f07604$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onMonthChange?.(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $6008d551a5f07604$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onYearChange?.(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $6008d551a5f07604$export$a98b123b8f29e004)(utils, day, value ?? referenceDate), "finish", view);
        return handleValueChange(day, "finish", view);
    });
    $2hDQc.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $cac04a8893bbf0ec$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $2hDQc.useRef(view);
    $2hDQc.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $2hDQc.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($cac04a8893bbf0ec$var$DateCalendarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)(CalendarHeader, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $592Nh.jsx)($cac04a8893bbf0ec$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $592Nh.jsxs)("div", {
                    children: [
                        view === "year" && /*#__PURE__*/ (0, $592Nh.jsx)((0, $5934abc02d20fcdf$export$657f9200591b2b71), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("year", isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "month" && /*#__PURE__*/ (0, $592Nh.jsx)((0, $a1dc52b030c13eff$export$d7a7c85c0f5afc4a), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("month", isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "day" && /*#__PURE__*/ (0, $592Nh.jsx)((0, $9e3690639f536c9e$export$8fb56b32a5df6314), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("day", isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $592Nh = parcelRequire("592Nh");
const $45537147104b190d$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $cac04a8893bbf0ec$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $6008d551a5f07604$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $6008d551a5f07604$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });









var $2hDQc = parcelRequire("2hDQc");








var $2hDQc = parcelRequire("2hDQc");






function $5f586a705493630a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");

function $ee024455d9acdc08$export$5519b4d4bf80ce6f(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersPopper", slot);
}
const $ee024455d9acdc08$export$46e9184c9b1af0ce = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersPopper", [
    "root",
    "paper"
]);





var $592Nh = parcelRequire("592Nh");
const $84e7719119ca70fc$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $84e7719119ca70fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $ee024455d9acdc08$export$5519b4d4bf80ce6f), classes);
};
const $84e7719119ca70fc$var$PickersPopperRoot = (0, $fhlQp.default)((0, $4ef6802bb98f4e22$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $84e7719119ca70fc$var$PickersPopperPaper = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})({
    outline: 0,
    transformOrigin: "top center",
    variants: [
        {
            props: ({ placement: placement })=>[
                    "top",
                    "top-start",
                    "top-end"
                ].includes(placement),
            style: {
                transformOrigin: "bottom center"
            }
        }
    ]
});
function $84e7719119ca70fc$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $84e7719119ca70fc$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $2hDQc.useRef(false);
    const syntheticEventRef = $2hDQc.useRef(false);
    const nodeRef = $2hDQc.useRef(null);
    const activatedRef = $2hDQc.useRef(false);
    $2hDQc.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $5f586a705493630a$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && $84e7719119ca70fc$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $2hDQc.useEffect(()=>{
        if (active) {
            const doc = (0, $5f586a705493630a$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $2hDQc.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $5f586a705493630a$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $84e7719119ca70fc$var$PickersPopperPaperWrapper = /*#__PURE__*/ $2hDQc.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $84e7719119ca70fc$var$_excluded);
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)(PaperComponent, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $84e7719119ca70fc$export$96ce8482474de8a5(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $2hDQc.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === "Escape") onDismiss();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $2hDQc.useRef(null);
    $2hDQc.useEffect(()=>{
        if (role === "tooltip" || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $84e7719119ca70fc$var$useClickAwayListener(open, onBlur ?? onDismiss);
    const paperRef = $2hDQc.useRef(null);
    const handleRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $84e7719119ca70fc$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $fb3a5f9ff3173fe5$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $12215051e1caa84a$export$2e2bcd8739ae039) : (0, $7206ceb21be884d5$export$2e2bcd8739ae039);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $fc4f877660d5a3c1$export$34eba2437817a67b);
    const Paper = slots?.desktopPaper ?? $84e7719119ca70fc$var$PickersPopperPaper;
    const Popper = slots?.popper ?? $84e7719119ca70fc$var$PickersPopperRoot;
    const popperProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)(Popper, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $592Nh.jsx)(FocusTrap, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $592Nh.jsx)(Transition, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, TransitionProps, slotProps?.desktopTransition, {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)($84e7719119ca70fc$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}





var $2hDQc = parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");
const $6015263d7b769612$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $2hDQc.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = $2hDQc.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $2hDQc.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $2hDQc.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};





/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $1e8263f6bc3ee469$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === "setValueFromField") return true;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState !== "shallow") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromShortcut") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $1e8263f6bc3ee469$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState === "finish" && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept" && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $1e8263f6bc3ee469$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === "setValueFromAction") return true;
    if (action.name === "setValueFromView") return action.selectionState === "finish" && closeOnSelect;
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept";
    return false;
};
const $1e8263f6bc3ee469$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValueWithoutRenderTimezone, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === "desktop", timezone: timezoneProp } = props;
    const { current: defaultValue } = $2hDQc.useRef(inDefaultValue);
    const { current: isControlled } = $2hDQc.useRef(inValueWithoutRenderTimezone !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const adapter = (0, $404db1959acab970$export$4b5a24245de9f7f9)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $6015263d7b769612$export$7d3a09d5141ab1f4)(props);
    const { timezone: timezone, value: inValueWithTimezoneToRender, handleValueChange: handleValueChange } = (0, $b42e00cec95bf032$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValueWithoutRenderTimezone,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const [dateState, setDateState] = $2hDQc.useState(()=>{
        let initialValue;
        if (inValueWithTimezoneToRender !== undefined) initialValue = inValueWithTimezoneToRender;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValueWithTimezoneToRender,
            hasBeenModifiedSinceMount: false
        };
    });
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $6dac1f43294e1bc1$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: dateState.draft,
        onError: props.onError
    });
    const updateDate = (0, $b61557e39989b411$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $1e8263f6bc3ee469$var$shouldPublishValue(updaterParams);
        const shouldCommit = $1e8263f6bc3ee469$var$shouldCommitValue(updaterParams);
        const shouldClose = $1e8263f6bc3ee469$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                const validationError = action.name === "setValueFromField" ? action.context.validationError : getValidationErrorForNewValue(action.value);
                cachedContext = {
                    validationError: validationError
                };
                if (action.name === "setValueFromShortcut") cachedContext.shortcut = action.shortcut;
            }
            return cachedContext;
        };
        if (shouldPublish) handleValueChange(action.value, getContext());
        if (shouldCommit && onAccept) onAccept(action.value, getContext());
        if (shouldClose) setIsOpen(false);
    });
    if (inValueWithTimezoneToRender !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValueWithTimezoneToRender))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValueWithTimezoneToRender);
        setDateState((prev)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, prev, {
                lastControlledValue: inValueWithTimezoneToRender
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValueWithTimezoneToRender,
                lastPublishedValue: inValueWithTimezoneToRender,
                draft: inValueWithTimezoneToRender,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: "setValueFromAction",
            pickerAction: "clear"
        });
    });
    const handleAccept = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "accept"
        });
    });
    const handleDismiss = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "dismiss"
        });
    });
    const handleCancel = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: "setValueFromAction",
            pickerAction: "cancel"
        });
    });
    const handleSetToday = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: "setValueFromAction",
            pickerAction: "today"
        });
    });
    const handleOpen = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        setIsOpen(true);
    });
    const handleClose = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        event?.preventDefault();
        setIsOpen(false);
    });
    const handleChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue, selectionState = "partial")=>updateDate({
            name: "setValueFromView",
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: "setValueFromShortcut",
            value: newValue,
            changeImportance: changeImportance,
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: "setValueFromField",
            value: newValue,
            context: context
        }));
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField
    };
    const viewValue = $2hDQc.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    const contextValue = $2hDQc.useMemo(()=>({
            onOpen: handleOpen,
            onClose: handleClose,
            open: isOpen
        }), [
        isOpen,
        handleClose,
        handleOpen
    ]);
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions,
        contextValue: contextValue
    };
};





var $2hDQc = parcelRequire("2hDQc");




const $7d35c8abb1359be6$var$_excluded = [
    "className",
    "sx"
];
const $7d35c8abb1359be6$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const { onChange: onChange, open: open, onClose: onClose } = propsFromPickerValue;
    const { view: inView, views: views, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $7d35c8abb1359be6$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $2c5912d759d255cd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $2hDQc.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (viewRenderers[viewForReduce] != null) viewMode = "UI";
            else viewMode = "field";
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === "UI") acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        viewRenderers,
        views
    ]);
    const timeViewsCount = $2hDQc.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $9aafba1b8c629c28$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $b61557e39989b411$export$2e2bcd8739ae039)(()=>currentViewMode === "UI");
    const [popperView, setPopperView] = $2hDQc.useState(currentViewMode === "UI" ? view : null);
    if (popperView !== view && viewModeLookup[view] === "UI") setPopperView(view);
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === "field" && open) {
            onClose();
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === "field" && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            const rendererProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            });
            if (rendererInterceptor) return rendererInterceptor(viewRenderers, popperView, rendererProps);
            return renderer(rendererProps);
        }
    };
};





var $2hDQc = parcelRequire("2hDQc");


function $aa83be89fb40b9b6$var$getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const $aa83be89fb40b9b6$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $2hDQc.useState($aa83be89fb40b9b6$var$getOrientation);
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($aa83be89fb40b9b6$var$getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, $5e6b2caee8dd3380$export$22012a5c726bef55)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};


const $977968cb7ded7b6a$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $aa83be89fb40b9b6$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const layoutProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        isRtl: isRtl,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



var $2hDQc = parcelRequire("2hDQc");
function $78ed474070f7607e$export$cfaabb8dcad411b(parameters) {
    const { props: props, pickerValueResponse: pickerValueResponse } = parameters;
    return $2hDQc.useMemo(()=>({
            value: pickerValueResponse.viewProps.value,
            open: pickerValueResponse.open,
            disabled: props.disabled ?? false,
            readOnly: props.readOnly ?? false
        }), [
        pickerValueResponse.viewProps.value,
        pickerValueResponse.open,
        props.disabled,
        props.readOnly
    ]);
}


const $ab66e2d0db94ef47$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const pickerValueResponse = (0, $1e8263f6bc3ee469$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $7d35c8abb1359be6$export$c0a71b697a2df210)({
        props: props,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        fieldRef: fieldRef,
        propsFromPickerValue: pickerValueResponse.viewProps,
        rendererInterceptor: rendererInterceptor
    });
    const pickerLayoutResponse = (0, $977968cb7ded7b6a$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    const pickerOwnerState = (0, $78ed474070f7607e$export$cfaabb8dcad411b)({
        props: props,
        pickerValueResponse: pickerValueResponse
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps,
        // Picker context
        contextValue: pickerValueResponse.contextValue,
        // Picker owner state
        ownerState: pickerOwnerState
    };
};



var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");



function $070be4c6d96e032f$export$1671c31de798d429(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiPickersLayout", slot);
}
const $070be4c6d96e032f$export$7a6dac186703fe4c = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiPickersLayout", [
    "root",
    "landscape",
    "contentWrapper",
    "toolbar",
    "actionBar",
    "tabs",
    "shortcuts"
]);



parcelRequire("2hDQc");




parcelRequire("2hDQc");





var $592Nh = parcelRequire("592Nh");
"use client";
const $6ec539d0d32c79dd$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $6ec539d0d32c79dd$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $6ec539d0d32c79dd$var$_excluded);
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: translations.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: translations.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: translations.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: translations.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $034e58a90bc1a7b5$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}





parcelRequire("2hDQc");






var $592Nh = parcelRequire("592Nh");
"use client";
const $7bc8ddb003a249b6$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $7bc8ddb003a249b6$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $7bc8ddb003a249b6$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = "accept", onChange: onChange, isValid: isValid } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $7bc8ddb003a249b6$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $7bc8ddb003a249b6$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, item, {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        });
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $8768610d9d8fd41e$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: "auto"
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $1010c6f3caf374f8$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, item))
            }, item.id ?? item.label);
        })
    }));
}



var $592Nh = parcelRequire("592Nh");
"use client";
function $ee0f45b4ee1b4993$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $ee0f45b4ee1b4993$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ],
        toolbar: [
            "toolbar"
        ],
        actionBar: [
            "actionBar"
        ],
        tabs: [
            "tabs"
        ],
        landscape: [
            "landscape"
        ],
        shortcuts: [
            "shortcuts"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $070be4c6d96e032f$export$1671c31de798d429), classes);
};
const $ee0f45b4ee1b4993$var$usePickerLayout = (props)=>{
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, slots: slots, slotProps: slotProps } = props;
    const classes = $ee0f45b4ee1b4993$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $6ec539d0d32c79dd$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === "desktop" ? [] : [
                "cancel",
                "accept"
            ]
        },
        className: classes.actionBar,
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $592Nh.jsx)(ActionBar, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly
        },
        className: classes.toolbar,
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $ee0f45b4ee1b4993$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $592Nh.jsx)(Toolbar, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $592Nh.jsx)(Tabs, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $7bc8ddb003a249b6$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut
        },
        className: classes.shortcuts,
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $592Nh.jsx)(Shortcuts, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $ee0f45b4ee1b4993$export$2e2bcd8739ae039 = $ee0f45b4ee1b4993$var$usePickerLayout;



var $592Nh = parcelRequire("592Nh");
"use client";
const $46ae727063dcf2b3$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $070be4c6d96e032f$export$1671c31de798d429), classes);
};
const $46ae727063dcf2b3$export$9a9363506c13836 = (0, $fhlQp.default)("div", {
    name: "MuiPickersLayout",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "grid",
    gridAutoColumns: "max-content auto max-content",
    gridAutoRows: "max-content auto max-content",
    [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: "1 / 4",
        gridRow: 3
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: "2 / 3"
                },
                [`.${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: "2 / 4",
                    gridRow: 1
                }
            }
        },
        {
            props: {
                isLandscape: true,
                isRtl: true
            },
            style: {
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 3
                }
            }
        },
        {
            props: {
                isLandscape: false
            },
            style: {
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: "2 / 4",
                    gridRow: 1
                },
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: "2 / 3"
                }
            }
        },
        {
            props: {
                isLandscape: false,
                isRtl: true
            },
            style: {
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 3
                }
            }
        }
    ]
});
const $46ae727063dcf2b3$export$bc1494d918129235 = (0, $fhlQp.default)("div", {
    name: "MuiPickersLayout",
    slot: "ContentWrapper",
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: "flex",
    flexDirection: "column"
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $46ae727063dcf2b3$export$647f604ea2397c05 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiPickersLayout"
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $ee0f45b4ee1b4993$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, wrapperVariant: wrapperVariant } = props;
    const classes = $46ae727063dcf2b3$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($46ae727063dcf2b3$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $592Nh.jsx)($46ae727063dcf2b3$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === "desktop" ? /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});



var $2hDQc = parcelRequire("2hDQc");


var $592Nh = parcelRequire("592Nh");
const $99df210e1ad84f76$export$38de57b7f4a44eea = /*#__PURE__*/ $2hDQc.createContext(null);
function $99df210e1ad84f76$export$38e969d523d4d57f(props) {
    const { contextValue: contextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $592Nh.jsx)($99df210e1ad84f76$export$38de57b7f4a44eea.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $cfd5de74b2d9a49e$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: children
        })
    });
}



var $592Nh = parcelRequire("592Nh");
const $19329be014c1de79$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $19329be014c1de79$var$_excluded2 = [
    "ownerState"
], $19329be014c1de79$var$_excluded3 = [
    "ownerState"
];
const $19329be014c1de79$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $19329be014c1de79$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const containerRef = $2hDQc.useRef(null);
    const fieldRef = $2hDQc.useRef(null);
    const labelId = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps, contextValue: contextValue, ownerState: ownerState } = (0, $ab66e2d0db94ef47$export$fc3313977ac596c4)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "desktop"
    }));
    const InputAdornment = slots.inputAdornment ?? (0, $c0c33a2da04f3a5d$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps?.inputAdornment,
        additionalProps: {
            position: "end"
        },
        ownerState: props
    }), inputAdornmentProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps, $19329be014c1de79$var$_excluded2);
    const OpenPickerButton = slots.openPickerButton ?? (0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps?.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            "aria-label": getOpenDialogAriaText(pickerFieldProps.value),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useSlotProps2, $19329be014c1de79$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const openPickerIconProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: OpenPickerIcon,
        externalSlotProps: innerSlotProps?.openPickerIcon,
        ownerState: ownerState
    });
    const Field = slots.field;
    const fieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps.InputProps, {
        ref: containerRef
    }, !props.disableOpenPicker && {
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $592Nh.jsx)(InputAdornment, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $592Nh.jsx)(OpenPickerButton, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $592Nh.jsx)(OpenPickerIcon, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, openPickerIconProps))
            }))
        }))
    });
    const slotsForField = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $46ae727063dcf2b3$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.popper)
    });
    const handleFieldRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $99df210e1ad84f76$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)(Field, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $84e7719119ca70fc$export$96ce8482474de8a5), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)(Layout, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};






const $1fc3df882463942c$var$_excluded = [
    "views",
    "format"
];
const $1fc3df882463942c$export$ebf7b30b32db6f57 = (utils, _ref, ignoreDateResolving)=>{
    let { views: views, format: format } = _ref, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $1fc3df882463942c$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $9aafba1b8c629c28$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else if ((0, $6008d551a5f07604$export$b32dfef9f07dea64)(view)) dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $6008d551a5f07604$export$bb1c921f313ec928)(utils, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $9aafba1b8c629c28$export$3a6776b3863772fe)(utils, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        views: timeViews
    }, other));
    const timeFormat = (0, $9aafba1b8c629c28$export$3a6776b3863772fe)(utils, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        views: timeViews
    }, other));
    const dateFormat = ignoreDateResolving ? utils.formats.keyboardDate : (0, $6008d551a5f07604$export$bb1c921f313ec928)(utils, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const $1fc3df882463942c$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $9aafba1b8c629c28$export$a3328136ac50623d)(view) || view === "hours");
    return ampm ? [
        ...views,
        "meridiem"
    ] : views;
};
const $1fc3df882463942c$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function $1fc3df882463942c$export$e2d664f2dd4d34bc({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $1fc3df882463942c$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $1fc3df882463942c$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}


parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");



var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");









function $7596771b8cfa22d0$export$148b188041a720e4(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiTimeClock", slot);
}
const $7596771b8cfa22d0$export$191dec874db3257b = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiTimeClock", [
    "root",
    "arrowSwitcher"
]);




var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




var $2hDQc = parcelRequire("2hDQc");


var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");

const $c6a9620fc8707326$export$8c8ec20d3854d7e6 = 220;
const $c6a9620fc8707326$export$729c0e543e4dc21d = 36;
const $c6a9620fc8707326$var$clockCenter = {
    x: $c6a9620fc8707326$export$8c8ec20d3854d7e6 / 2,
    y: $c6a9620fc8707326$export$8c8ec20d3854d7e6 / 2
};
const $c6a9620fc8707326$var$baseClockPoint = {
    x: $c6a9620fc8707326$var$clockCenter.x,
    y: 0
};
const $c6a9620fc8707326$var$cx = $c6a9620fc8707326$var$baseClockPoint.x - $c6a9620fc8707326$var$clockCenter.x;
const $c6a9620fc8707326$var$cy = $c6a9620fc8707326$var$baseClockPoint.y - $c6a9620fc8707326$var$clockCenter.y;
const $c6a9620fc8707326$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $c6a9620fc8707326$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $c6a9620fc8707326$var$clockCenter.x;
    const y = offsetY - $c6a9620fc8707326$var$clockCenter.y;
    const atan = Math.atan2($c6a9620fc8707326$var$cx, $c6a9620fc8707326$var$cy) - Math.atan2(x, y);
    let deg = $c6a9620fc8707326$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $c6a9620fc8707326$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $c6a9620fc8707326$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $c6a9620fc8707326$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $c6a9620fc8707326$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $c6a9620fc8707326$export$8c8ec20d3854d7e6 / 2 - $c6a9620fc8707326$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



function $42fb4db221c16144$export$12faa62796978e2f(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiClockPointer", slot);
}
const $42fb4db221c16144$export$64afeec9352615cb = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiClockPointer", [
    "root",
    "thumb"
]);



var $592Nh = parcelRequire("592Nh");
const $795967ab879a3167$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $795967ab879a3167$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $42fb4db221c16144$export$12faa62796978e2f), classes);
};
const $795967ab879a3167$var$ClockPointerRoot = (0, $fhlQp.default)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px",
        variants: [
            {
                props: {
                    shouldAnimate: true
                },
                style: {
                    transition: theme.transitions.create([
                        "transform",
                        "height"
                    ])
                }
            }
        ]
    }));
const $795967ab879a3167$var$ClockPointerThumb = (0, $fhlQp.default)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, $c6a9620fc8707326$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $c6a9620fc8707326$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: "content-box",
        variants: [
            {
                props: {
                    hasSelected: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
function $795967ab879a3167$export$f257f213e6c08f97(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $795967ab879a3167$var$_excluded);
    const previousType = $2hDQc.useRef(type);
    $2hDQc.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $795967ab879a3167$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === "hours" && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $c6a9620fc8707326$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)($795967ab879a3167$var$ClockPointerRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        style: getAngleStyle(),
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($795967ab879a3167$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}






function $7ac55c61b38eb597$export$e44ecab24167799b(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiClock", slot);
}
const $7ac55c61b38eb597$export$4626e3a61e161c64 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton",
    "meridiemText",
    "selected"
]);




var $592Nh = parcelRequire("592Nh");
const $8776e90a36885ef7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, meridiemMode: meridiemMode } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton",
            meridiemMode === "am" && "selected"
        ],
        pmButton: [
            "pmButton",
            meridiemMode === "pm" && "selected"
        ],
        meridiemText: [
            "meridiemText"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $7ac55c61b38eb597$export$e44ecab24167799b), classes);
};
const $8776e90a36885ef7$var$ClockRoot = (0, $fhlQp.default)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const $8776e90a36885ef7$var$ClockClock = (0, $fhlQp.default)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const $8776e90a36885ef7$var$ClockWrapper = (0, $fhlQp.default)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const $8776e90a36885ef7$var$ClockSquareMask = (0, $fhlQp.default)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})({
    width: "100%",
    height: "100%",
    position: "absolute",
    pointerEvents: "auto",
    outline: 0,
    // Disable scroll capabilities.
    touchAction: "none",
    userSelect: "none",
    variants: [
        {
            props: {
                disabled: false
            },
            style: {
                "@media (pointer: fine)": {
                    cursor: "pointer",
                    borderRadius: "50%"
                },
                "&:active": {
                    cursor: "move"
                }
            }
        }
    ]
});
const $8776e90a36885ef7$var$ClockPin = (0, $fhlQp.default)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const $8776e90a36885ef7$var$meridiemButtonCommonStyles = (theme, meridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $c6a9620fc8707326$export$729c0e543e4dc21d),
        variants: [
            {
                props: {
                    meridiemMode: meridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    "&:hover": {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const $8776e90a36885ef7$var$ClockAmButton = (0, $fhlQp.default)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $8776e90a36885ef7$var$meridiemButtonCommonStyles(theme, "am"), {
        // keeping it here to make TS happy
        position: "absolute",
        left: 8
    }));
const $8776e90a36885ef7$var$ClockPmButton = (0, $fhlQp.default)((0, $f97b6ffd7ec1b40a$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme })=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $8776e90a36885ef7$var$meridiemButtonCommonStyles(theme, "pm"), {
        // keeping it here to make TS happy
        position: "absolute",
        right: 8
    }));
const $8776e90a36885ef7$var$ClockMeridiemText = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "meridiemText",
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
function $8776e90a36885ef7$export$9735c82c4bae3302(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled = false, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const isMoving = $2hDQc.useRef(false);
    const classes = $8776e90a36885ef7$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === "hours" && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, $c6a9620fc8707326$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $c6a9620fc8707326$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = $2hDQc.useMemo(()=>{
        if (type === "hours") return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = $2hDQc.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $7bdf63f5b8ef95fd$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // reset both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(viewValue + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(viewValue - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "PageUp":
                handleValueChange(viewValue + 5, "partial");
                event.preventDefault();
                break;
            case "PageDown":
                handleValueChange(viewValue - 5, "partial");
                event.preventDefault();
                break;
            case "Enter":
            case " ":
                handleValueChange(viewValue, "finish");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)($8776e90a36885ef7$var$ClockRoot, {
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)($8776e90a36885ef7$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $592Nh.jsx)((0, $795967ab879a3167$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value, utils, value == null ? null : utils.format(value, "fullTime")),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "am"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "am")
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "pm"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)($8776e90a36885ef7$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "pm")
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("2hDQc");


parcelRequire("2hDQc");


var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");



function $74bfad0111e6746b$export$527226d166658911(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiClockNumber", slot);
}
const $74bfad0111e6746b$export$c8efb3a779c9844a = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);



var $592Nh = parcelRequire("592Nh");
const $fc7f441d8c90782d$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $fc7f441d8c90782d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $74bfad0111e6746b$export$527226d166658911), classes);
};
const $fc7f441d8c90782d$var$ClockNumberRoot = (0, $fhlQp.default)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $74bfad0111e6746b$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $74bfad0111e6746b$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        height: (0, $c6a9620fc8707326$export$729c0e543e4dc21d),
        width: (0, $c6a9620fc8707326$export$729c0e543e4dc21d),
        position: "absolute",
        left: `calc((100% - ${0, $c6a9620fc8707326$export$729c0e543e4dc21d}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $74bfad0111e6746b$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $74bfad0111e6746b$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: "none",
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    inner: true
                },
                style: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
function $fc7f441d8c90782d$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $fc7f441d8c90782d$var$_excluded);
    const ownerState = props;
    const classes = $fc7f441d8c90782d$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $c6a9620fc8707326$export$8c8ec20d3854d7e6) - (0, $c6a9620fc8707326$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $592Nh.jsx)($fc7f441d8c90782d$var$ClockNumberRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $c6a9620fc8707326$export$8c8ec20d3854d7e6) - (0, $c6a9620fc8707326$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $592Nh = parcelRequire("592Nh");
const $017739a1f4591e80$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $592Nh.jsx)((0, $fc7f441d8c90782d$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $017739a1f4591e80$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $fc7f441d8c90782d$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};





var $2hDQc = parcelRequire("2hDQc");



const $e1f5d4fca9c481d9$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $2hDQc.useMemo(()=>(0, $60e2396f80eb3f46$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $bfb695e56b2e7def$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $6008d551a5f07604$export$1118e4272ea1e258)(utils, timezone, "date")
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};



var $592Nh = parcelRequire("592Nh");
"use client";
const $3d49e674a0b597a5$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $3d49e674a0b597a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $7596771b8cfa22d0$export$148b188041a720e4), classes);
};
const $3d49e674a0b597a5$var$TimeClockRoot = (0, $fhlQp.default)((0, $63f62fcdd7a667e6$export$512b066b8abdfde4), {
    name: "MuiTimeClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    position: "relative"
});
const $3d49e674a0b597a5$var$TimeClockArrowSwitcher = (0, $fhlQp.default)((0, $da6a77f421ae8723$export$597b7cbdb7b2a24c), {
    name: "MuiTimeClock",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const $3d49e674a0b597a5$var$TIME_CLOCK_DEFAULT_VIEWS = [
    "hours",
    "minutes"
];
const $3d49e674a0b597a5$export$7e96244e18c4be57 = /*#__PURE__*/ $2hDQc.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiTimeClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $3d49e674a0b597a5$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $3d49e674a0b597a5$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "TimeClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $e1f5d4fca9c481d9$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $2c5912d759d255cd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $78e4c4ab8f2469fb$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $2hDQc.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $9aafba1b8c629c28$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $9aafba1b8c629c28$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const viewProps = $2hDQc.useMemo(()=>{
        switch(view){
            case "hours":
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $9aafba1b8c629c28$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, "hours");
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $017739a1f4591e80$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, "hours"),
                            selectedId: selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish, "minutes");
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $017739a1f4591e80$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, "minutes"),
                            selectedId: selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish, "seconds");
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $017739a1f4591e80$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, "seconds"),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        view,
        utils,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $3d49e674a0b597a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($3d49e674a0b597a5$var$TimeClockRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $8776e90a36885ef7$export$9735c82c4bae3302), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes("hours"),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $592Nh.jsx)($3d49e674a0b597a5$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});





var $2hDQc = parcelRequire("2hDQc");




var $6KAST = parcelRequire("6KAST");
var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");











function $aea18f429bbddd1f$export$aeb645018b209578(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDigitalClock", slot);
}
const $aea18f429bbddd1f$export$baf91642e79c8163 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDigitalClock", [
    "root",
    "list",
    "item"
]);









var $592Nh = parcelRequire("592Nh");
"use client";
const $fca214853f3c29df$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $fca214853f3c29df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        list: [
            "list"
        ],
        item: [
            "item"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $aea18f429bbddd1f$export$aeb645018b209578), classes);
};
const $fca214853f3c29df$var$DigitalClockRoot = (0, $fhlQp.default)((0, $63f62fcdd7a667e6$export$512b066b8abdfde4), {
    name: "MuiDigitalClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    overflowY: "auto",
    width: "100%",
    "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "auto"
    },
    maxHeight: (0, $8768610d9d8fd41e$export$1c2eabda4acea0e4),
    variants: [
        {
            props: {
                alreadyRendered: true
            },
            style: {
                "@media (prefers-reduced-motion: no-preference)": {
                    scrollBehavior: "smooth"
                }
            }
        }
    ]
});
const $fca214853f3c29df$var$DigitalClockList = (0, $fhlQp.default)((0, $908e39c61e238c21$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $fca214853f3c29df$var$DigitalClockItem = (0, $fhlQp.default)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "Item",
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: "8px 16px",
        margin: "2px 4px",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $fca214853f3c29df$export$9a2b219a5b06deb7 = /*#__PURE__*/ $2hDQc.forwardRef(function DigitalClock(inProps, ref) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const containerRef = $2hDQc.useRef(null);
    const handleRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, containerRef);
    const listRef = $2hDQc.useRef(null);
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        "hours"
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $fca214853f3c29df$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "DigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba)
    });
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const ownerState = $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $fca214853f3c29df$var$useUtilityClasses(ownerState);
    const ClockItem = slots?.digitalClockItem ?? $fca214853f3c29df$var$DigitalClockItem;
    const clockItemProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $e1f5d4fca9c481d9$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue)=>handleRawValueChange(newValue, "finish", "hours"));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $2c5912d759d255cd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish");
    });
    $2hDQc.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $2hDQc.useCallback((valueToCheck)=>{
        const isAfter = (0, $9aafba1b8c629c28$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, "hours");
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = $2hDQc.useMemo(()=>{
        const result = [];
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(utils.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = utils.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>utils.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "PageUp":
                {
                    const newIndex = (0, $5e6b2caee8dd3380$export$4165ccf43f4d7767)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case "PageDown":
                {
                    const newIndex = (0, $5e6b2caee8dd3380$export$4165ccf43f4d7767)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)($fca214853f3c29df$var$DigitalClockRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $592Nh.jsx)($fca214853f3c29df$var$DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                const formattedValue = utils.format(option, ampm ? "fullTime12h" : "fullTime24h");
                const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
                return /*#__PURE__*/ (0, $592Nh.jsx)(ClockItem, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});





var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");










function $a34fcc2d9eb87f0a$export$b828b7724b7b2890(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClock", slot);
}
const $a34fcc2d9eb87f0a$export$f2277d947b8f7a8a = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClock", [
    "root"
]);





var $2hDQc = parcelRequire("2hDQc");


var $6KAST = parcelRequire("6KAST");
var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");






function $c7668338cabc87e5$export$ab23463cad6963ff(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClockSection", slot);
}
const $c7668338cabc87e5$export$eaf2b63fa45eff23 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClockSection", [
    "root",
    "item"
]);





var $592Nh = parcelRequire("592Nh");
const $76eed7ffe9b8c737$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $76eed7ffe9b8c737$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        item: [
            "item"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $c7668338cabc87e5$export$ab23463cad6963ff), classes);
};
const $76eed7ffe9b8c737$var$MultiSectionDigitalClockSectionRoot = (0, $fhlQp.default)((0, $908e39c61e238c21$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        maxHeight: (0, $8768610d9d8fd41e$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: "hidden",
        "@media (prefers-reduced-motion: no-preference)": {
            scrollBehavior: "auto"
        },
        "@media (pointer: fine)": {
            "&:hover": {
                overflowY: "auto"
            }
        },
        "@media (pointer: none), (pointer: coarse)": {
            overflowY: "auto"
        },
        "&:not(:first-of-type)": {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        "&::after": {
            display: "block",
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: "calc(100% - 40px - 6px)"
        },
        variants: [
            {
                props: {
                    alreadyRendered: true
                },
                style: {
                    "@media (prefers-reduced-motion: no-preference)": {
                        scrollBehavior: "smooth"
                    }
                }
            }
        ]
    }));
const $76eed7ffe9b8c737$var$MultiSectionDigitalClockSectionItem = (0, $fhlQp.default)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Item",
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: "2px 4px",
        width: (0, $8768610d9d8fd41e$export$a462ceb9cfdb5d71),
        justifyContent: "center",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $76eed7ffe9b8c737$export$f971f93dc8464c = /*#__PURE__*/ $2hDQc.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = $2hDQc.useRef(null);
    const handleRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(ref, containerRef);
    const previousActive = $2hDQc.useRef(null);
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClockSection"
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $76eed7ffe9b8c737$var$_excluded);
    const ownerState = $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $76eed7ffe9b8c737$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? $76eed7ffe9b8c737$var$MultiSectionDigitalClockSectionItem;
    $2hDQc.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "PageUp":
                {
                    const newIndex = (0, $5e6b2caee8dd3380$export$4165ccf43f4d7767)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case "PageDown":
                {
                    const newIndex = (0, $5e6b2caee8dd3380$export$4165ccf43f4d7767)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)($76eed7ffe9b8c737$var$MultiSectionDigitalClockSectionRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, $592Nh.jsx)(DigitalClockSectionItem, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $0c4eb3d6d5649966$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep, valueOrReferenceDate: valueOrReferenceDate })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, utils.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? "hours12h" : "hours24h");
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $0c4eb3d6d5649966$export$e7b56db95f8a7b9c = ({ value: value, utils: utils, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};







var $592Nh = parcelRequire("592Nh");
"use client";
const $31ee5154b009188c$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $31ee5154b009188c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $a34fcc2d9eb87f0a$export$b828b7724b7b2890), classes);
};
const $31ee5154b009188c$var$MultiSectionDigitalClockRoot = (0, $fhlQp.default)((0, $63f62fcdd7a667e6$export$512b066b8abdfde4), {
    name: "MuiMultiSectionDigitalClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $31ee5154b009188c$export$c48dada788ff933b = /*#__PURE__*/ $2hDQc.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        "hours",
        "minutes"
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $31ee5154b009188c$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "MultiSectionDigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba)
    });
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $e1f5d4fca9c481d9$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $2hDQc.useMemo(()=>{
        if (!ampm || !inViews.includes("hours")) return inViews;
        return inViews.includes("meridiem") ? inViews : [
            ...inViews,
            "meridiem"
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $2c5912d759d255cd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish", "meridiem");
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $78e4c4ab8f2469fb$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, "finish");
    const isTimeDisabled = $2hDQc.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $9aafba1b8c629c28$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $9aafba1b8c629c28$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $2hDQc.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case "hours":
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $9aafba1b8c629c28$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), "finish", "hours");
                    },
                    items: (0, $0c4eb3d6d5649966$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>isTimeDisabled(hours, "hours"),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate: valueOrReferenceDate
                    })
                };
            case "minutes":
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), "finish", "minutes");
                    },
                    items: (0, $0c4eb3d6d5649966$export$e7b56db95f8a7b9c)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, "minutes"),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), "minutes"),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case "seconds":
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), "finish", "seconds");
                    },
                    items: (0, $0c4eb3d6d5649966$export$e7b56db95f8a7b9c)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, "seconds"),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), "seconds"),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case "meridiem":
                {
                    const amLabel = (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "am");
                    const pmLabel = (0, $6008d551a5f07604$export$fae94c0a662107ef)(utils, "pm");
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: "am",
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === "am",
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === "am",
                                ariaLabel: amLabel
                            },
                            {
                                value: "pm",
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === "pm",
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === "pm",
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = $2hDQc.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== "meridiem");
        digitViews.reverse();
        if (views.includes("meridiem")) digitViews.push("meridiem");
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = $2hDQc.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $31ee5154b009188c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($31ee5154b009188c$var$MultiSectionDigitalClockRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $76eed7ffe9b8c737$export$f971f93dc8464c), {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus ?? focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});




var $592Nh = parcelRequire("592Nh");
const $5a42405dd93111cb$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $3d49e674a0b597a5$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $9aafba1b8c629c28$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $9aafba1b8c629c28$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $5a42405dd93111cb$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $fca214853f3c29df$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $9aafba1b8c629c28$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $5a42405dd93111cb$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $31ee5154b009188c$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $9aafba1b8c629c28$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });






var $2hDQc = parcelRequire("2hDQc");






var $592Nh = parcelRequire("592Nh");
/**
 * @ignore - internal component.
 */ const $5b73e619a05d37af$export$4066d2955a85e052 = /*#__PURE__*/ $2hDQc.forwardRef(function DesktopDateTimePickerLayout(props, ref) {
    const isRtl = (0, $ac632f976f38c6a5$export$b2dd014b6c321cb)();
    const { toolbar: toolbar, tabs: tabs, content: content, actionBar: actionBar, shortcuts: shortcuts } = (0, $ee0f45b4ee1b4993$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, classes: classes } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $46ae727063dcf2b3$export$9a9363506c13836), {
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)((0, $070be4c6d96e032f$export$7a6dac186703fe4c).root, classes?.root, className),
        sx: [
            {
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).tabs}`]: {
                    gridRow: 4,
                    gridColumn: "1 / 4"
                },
                [`& .${(0, $070be4c6d96e032f$export$7a6dac186703fe4c).actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $46ae727063dcf2b3$export$bc1494d918129235), {
                className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)((0, $070be4c6d96e032f$export$7a6dac186703fe4c).contentWrapper, classes?.contentWrapper),
                sx: {
                    display: "grid"
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {
                        sx: {
                            gridRow: 3,
                            gridColumn: "1 / 4"
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
});







var $592Nh = parcelRequire("592Nh");
"use client";
const $267fe19d644edbf2$var$_excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const $267fe19d644edbf2$var$rendererInterceptor = function rendererInterceptor(inViewRenderers, popperView, rendererProps) {
    const { openTo: openTo, focusedView: focusedView, timeViewsCount: timeViewsCount } = rendererProps, otherProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(rendererProps, $267fe19d644edbf2$var$_excluded);
    const finalProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, otherProps, {
        focusedView: null,
        sx: [
            {
                [`&.${(0, $a34fcc2d9eb87f0a$export$f2277d947b8f7a8a).root}`]: {
                    borderBottom: 0
                },
                [`&.${(0, $a34fcc2d9eb87f0a$export$f2277d947b8f7a8a).root}, .${(0, $c7668338cabc87e5$export$eaf2b63fa45eff23).root}, &.${(0, $aea18f429bbddd1f$export$baf91642e79c8163).root}`]: {
                    maxHeight: (0, $8768610d9d8fd41e$export$f2fef360e2df0cb7)
                }
            }
        ]
    });
    const isTimeViewActive = (0, $9aafba1b8c629c28$export$a3328136ac50623d)(popperView);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            inViewRenderers[!isTimeViewActive ? popperView : "day"]?.((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rendererProps, {
                view: !isTimeViewActive ? popperView : "day",
                focusedView: focusedView && (0, $6008d551a5f07604$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
                views: rendererProps.views.filter((0, $6008d551a5f07604$export$b32dfef9f07dea64)),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    inViewRenderers[isTimeViewActive ? popperView : "hours"]?.((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, finalProps, {
                        view: isTimeViewActive ? popperView : "hours",
                        focusedView: focusedView && (0, $9aafba1b8c629c28$export$a3328136ac50623d)(focusedView) ? focusedView : null,
                        openTo: (0, $9aafba1b8c629c28$export$a3328136ac50623d)(openTo) ? openTo : "hours",
                        views: rendererProps.views.filter((0, $9aafba1b8c629c28$export$a3328136ac50623d)),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateTimePicker API](https://mui.com/x/api/date-pickers/desktop-date-time-picker/)
 */ const $267fe19d644edbf2$export$74e5e82f1557571f = /*#__PURE__*/ $2hDQc.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $b357cd105ba6c926$export$6e4d96e87e6dc2d3)(inProps, "MuiDesktopDateTimePicker");
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn, views: resolvedViews, timeSteps: timeSteps } = (0, $1fc3df882463942c$export$e2d664f2dd4d34bc)(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $5a42405dd93111cb$export$a2917c76dc0aa7e) : (0, $5a42405dd93111cb$export$48a290886291c531);
    const viewRenderers = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        day: (0, $45537147104b190d$export$69888ffe06193e5e),
        month: (0, $45537147104b190d$export$69888ffe06193e5e),
        year: (0, $45537147104b190d$export$69888ffe06193e5e),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, $5a42405dd93111cb$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? resolvedViews.filter((view)=>view !== "meridiem") : resolvedViews;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        "accept"
    ];
    // Props with the default values specific to the desktop variant
    const props = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $1fc3df882463942c$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        views: views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        slots: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            field: (0, $74a2cfc4679d3cd1$export$ae1ced156568f0b0),
            layout: (0, $5b73e619a05d37af$export$4066d2955a85e052),
            openPickerIcon: (0, $3330a4c49b9b1ac8$export$5fda1783bb83f57b)
        }, defaultizedProps.slots),
        slotProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $ce5f8da25e363804$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                hidden: true,
                ampmInClock: ampmInClock,
                toolbarVariant: "desktop"
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.tabs),
            actionBar: (ownerState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    actions: actionBarActions
                }, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.actionBar, ownerState))
        })
    });
    const { renderPicker: renderPicker } = (0, $19329be014c1de79$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba),
        valueType: "date-time",
        getOpenDialogAriaText: (0, $e19c1a6a3395907f$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: "fullDate",
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $422df713a3183182$export$ed94a8ff1f54c4f),
        rendererInterceptor: $267fe19d644edbf2$var$rendererInterceptor
    });
    return renderPicker();
});
$267fe19d644edbf2$export$74e5e82f1557571f.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $4d48afa0e5078fc9$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "day",
        "hours",
        "meridiem",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "day",
        "hours",
        "meridiem",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "asc",
        "desc"
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        3,
        4
    ])
};




var $2hDQc = parcelRequire("2hDQc");

var $bZSVP = parcelRequire("bZSVP");











var $2hDQc = parcelRequire("2hDQc");




parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");


var $592Nh = parcelRequire("592Nh");
const $73e8d2e22730b6dc$var$PickersModalDialogRoot = (0, $fhlQp.default)((0, $8df7cb0c72533ff7$export$2e2bcd8739ae039))({
    [`& .${(0, $2fc2b6d0cfc82752$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $2fc2b6d0cfc82752$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $8768610d9d8fd41e$export$ee46b8a74d6c94d3)
    }
});
const $73e8d2e22730b6dc$var$PickersModalDialogContent = (0, $fhlQp.default)((0, $27d8040194495028$export$2e2bcd8739ae039))({
    "&:first-of-type": {
        padding: 0
    }
});
function $73e8d2e22730b6dc$export$99f83c99e1491f77(props) {
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = slots?.dialog ?? $73e8d2e22730b6dc$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $12215051e1caa84a$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $592Nh.jsx)(Dialog, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        open: open,
        onClose: onDismiss
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($73e8d2e22730b6dc$var$PickersModalDialogContent, {
            children: children
        })
    }));
}







var $592Nh = parcelRequire("592Nh");
const $9fa16968c97b094b$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $9fa16968c97b094b$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $9fa16968c97b094b$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const fieldRef = $2hDQc.useRef(null);
    const labelId = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $ab66e2d0db94ef47$export$fc3313977ac596c4)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "mobile"
    }));
    const Field = slots.field;
    const fieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $5e6b2caee8dd3380$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps.inputProps, {
        "aria-label": getOpenDialogAriaText(pickerFieldProps.value)
    });
    const slotsForField = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $46ae727063dcf2b3$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const handleFieldRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $99df210e1ad84f76$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)(Field, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $73e8d2e22730b6dc$export$99f83c99e1491f77), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)(Layout, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};






"use client";
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const $dd6ded5beaf17657$export$5b4e219fe76d27da = /*#__PURE__*/ $2hDQc.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $b357cd105ba6c926$export$6e4d96e87e6dc2d3)(inProps, "MuiMobileDateTimePicker");
    const viewRenderers = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        day: (0, $45537147104b190d$export$69888ffe06193e5e),
        month: (0, $45537147104b190d$export$69888ffe06193e5e),
        year: (0, $45537147104b190d$export$69888ffe06193e5e),
        hours: (0, $5a42405dd93111cb$export$a3ad21a1b07c504f),
        minutes: (0, $5a42405dd93111cb$export$a3ad21a1b07c504f),
        seconds: (0, $5a42405dd93111cb$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Props with the default values specific to the mobile variant
    const props = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $1fc3df882463942c$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        ampmInClock: ampmInClock,
        slots: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            field: (0, $74a2cfc4679d3cd1$export$ae1ced156568f0b0)
        }, defaultizedProps.slots),
        slotProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $ce5f8da25e363804$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker: renderPicker } = (0, $9fa16968c97b094b$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba),
        valueType: "date-time",
        getOpenDialogAriaText: (0, $e19c1a6a3395907f$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: "fullDate",
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $422df713a3183182$export$ed94a8ff1f54c4f)
    });
    return renderPicker();
});
$dd6ded5beaf17657$export$5b4e219fe76d27da.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $4d48afa0e5078fc9$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "asc",
        "desc"
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        3,
        4
    ])
};




var $592Nh = parcelRequire("592Nh");
"use client";
const $161736656f2ba8cf$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/)
 */ const $161736656f2ba8cf$export$ccdfd7928785632e = /*#__PURE__*/ $2hDQc.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateTimePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $5e6b2caee8dd3380$export$9ae5b19305db48ce) } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $161736656f2ba8cf$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $ef97679917c36082$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $267fe19d644edbf2$export$74e5e82f1557571f), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $dd6ded5beaf17657$export$5b4e219fe76d27da), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});



const $552f85174d4aa274$var$FormIndividualRightHolder = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const offeringName = props.offering?.name || "";
    const getFormDefaultValues = ()=>{
        return {
            firstName: props.defaultValues?.firstName || "",
            lastName: props.defaultValues?.lastName || "",
            email: props.defaultValues?.email || "",
            phoneNumber: props.defaultValues?.phoneNumber || (0, $cc54526a7cedf1dd$export$32ea325d92ea6082).PHONE_FI_COUNTRY_CODE,
            licensePlate: props.defaultValues?.licensePlate || "",
            catalogueId: props.catalogueId || "",
            validityStart: props.defaultValues?.validityStart || (0, $f65046485b965c63$exports.DateTime).local(),
            validityEnd: props.defaultValues?.validityEnd || null,
            costCenter: props.defaultValues?.costCenter || "",
            project: props.defaultValues?.project || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $2hDQc.useState)(getFormDefaultValues());
    (0, $2hDQc.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.firstName,
        props.defaultValues?.lastName,
        props.defaultValues?.email,
        props.defaultValues?.phoneNumber,
        props.defaultValues?.licensePlate,
        props.offering?.id
    ]);
    const schemaValidator = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            firstName: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            lastName: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            email: $7a5dda49dca6ae9d$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return (0, $066f7ec5b64309d3$export$371e338370561054)(email);
            }),
            phoneNumber: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("phoneNumber", intl.formatMessage({
                id: "common.form.errors.phoneNumber"
            }), (0, $066f7ec5b64309d3$export$dda1dcb0216445cd)),
            licensePlate: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
                id: "common.form.errors.licensePlate"
            }), (0, $066f7ec5b64309d3$export$dddb845077defee2)),
            validityStart: $7a5dda49dca6ae9d$export$324d90190a8b822a().required(intl.formatMessage({
                id: "common.form.errors.invalidDateTime"
            })).typeError(intl.formatMessage({
                id: "common.form.errors.invalidDateTime"
            })),
            validityEnd: $7a5dda49dca6ae9d$export$324d90190a8b822a().nullable().typeError(intl.formatMessage({
                id: "common.form.errors.invalidDateTime"
            })),
            costCenter: $7a5dda49dca6ae9d$export$22b082955e083ec3().max(255),
            project: $7a5dda49dca6ae9d$export$22b082955e083ec3().max(255)
        });
    };
    const onSubmitFormValues = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate, catalogueId: catalogueId, validityStart: validityStart, validityEnd: validityEnd, costCenter: costCenter, project: project } = values;
        props.onSubmit({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            phoneNumber: phoneNumber.trim(),
            licensePlate: licensePlate.trim().toLocaleUpperCase(),
            catalogueId: catalogueId,
            validityStart: validityStart,
            validityEnd: validityEnd,
            costCenter: costCenter?.trim() || undefined,
            project: project?.trim() || undefined
        });
    };
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: schemaValidator(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.customerDetails"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "firstName",
                                        "data-testid": "firstName",
                                        value: values.firstName,
                                        label: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        autoFocus: !props.disableCustomerData,
                                        error: !!errors.firstName,
                                        errorText: errors.firstName
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "lastName",
                                        "data-testid": "lastName",
                                        value: values.lastName,
                                        label: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        error: !!errors.lastName,
                                        errorText: errors.lastName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "email",
                                        "data-testid": "email",
                                        value: values.email,
                                        label: intl.formatMessage({
                                            id: "common.text.email"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "common.text.email"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        error: !!errors.email,
                                        errorText: errors.email
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "phoneNumber",
                                        "data-testid": "phoneNumber",
                                        value: values.phoneNumber,
                                        label: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        error: !!errors.phoneNumber,
                                        errorText: errors.phoneNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.productDetails"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormSwitch, {
                                checked: true,
                                label: offeringName,
                                style: {
                                    fontWeight: "bold"
                                },
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "costCenter",
                                        "data-testid": "costCenter",
                                        value: values.costCenter,
                                        label: intl.formatMessage({
                                            id: "common.text.costCenter"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "common.text.costCenter"
                                        }),
                                        onChange: handleChange,
                                        autoFocus: props.disableCustomerData,
                                        error: !!errors.costCenter,
                                        errorText: errors.costCenter
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "project",
                                        "data-testid": "project",
                                        value: values.project,
                                        label: intl.formatMessage({
                                            id: "common.text.project"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "common.text.project"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.project,
                                        errorText: errors.project
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.licensePlateDetails"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                display: "flex",
                                gap: 2,
                                flex: 2,
                                pr: 1,
                                width: isMobile ? "100%" : "50%",
                                flexDirection: {
                                    xs: "column",
                                    md: "row"
                                },
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                    name: "licensePlate",
                                    "data-testid": "licensePlate",
                                    value: values.licensePlate,
                                    label: intl.formatMessage({
                                        id: "common.text.licensePlate"
                                    }),
                                    placeholder: intl.formatMessage({
                                        id: "common.text.licensePlate"
                                    }),
                                    onChange: handleChange,
                                    error: !!errors.licensePlate,
                                    errorText: errors.licensePlate
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.validity"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $161736656f2ba8cf$export$ccdfd7928785632e), {
                                        name: "validityStart",
                                        "data-testid": "validityStart",
                                        value: values.validityStart,
                                        disablePast: true,
                                        onChange: (newValue)=>setFieldValue("validityStart", newValue),
                                        label: intl.formatMessage({
                                            id: "common.text.validityStart"
                                        }),
                                        slotProps: {
                                            textField: {
                                                helperText: errors.validityStart ? "" + errors?.validityStart : null,
                                                error: !!errors.validityStart
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $161736656f2ba8cf$export$ccdfd7928785632e), {
                                        name: "validityEnd",
                                        "data-testid": "validityEnd",
                                        value: values.validityEnd,
                                        onChange: (newValue)=>setFieldValue("validityEnd", newValue),
                                        label: intl.formatMessage({
                                            id: "common.text.validityEnd"
                                        }),
                                        slotProps: {
                                            textField: {
                                                helperText: errors.validityEnd ? "" + errors?.validityEnd : null,
                                                error: !!errors.validityEnd
                                            }
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $552f85174d4aa274$export$2e2bcd8739ae039 = $552f85174d4aa274$var$FormIndividualRightHolder;




const $bcb54676fdf95094$var$StepAddRightHolder = (props)=>{
    const createRightHolder = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate, validityStart: validityStart, validityEnd: validityEnd, catalogueId: catalogueId, project: project, costCenter: costCenter } = values;
        if (props.individualRightHolderId) {
            const dto = {
                licensePlate: licensePlate,
                catalogueId: catalogueId,
                validityStart: (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(validityStart),
                validityEnd: validityEnd ? (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(validityEnd) : undefined,
                active: true,
                costCenter: costCenter,
                project: project
            };
            props.onSubmit(dto);
        } else {
            const dto = {
                type: "individual",
                customerId: props.customerId,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phoneNumber: (0, $ee9cb80b5c23ac97$export$b34d9e7bbdff763e)(phoneNumber),
                catalogueId: catalogueId,
                vehicles: [
                    {
                        licensePlate: licensePlate,
                        grantRights: [
                            {
                                rightHolderType: "vehicle",
                                validityStart: (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(validityStart),
                                validityEnd: validityEnd ? (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(validityEnd) : undefined,
                                active: true,
                                costCenter: costCenter,
                                project: project
                            }
                        ]
                    }
                ]
            };
            props.onSubmit(dto);
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $552f85174d4aa274$export$2e2bcd8739ae039), {
        formReference: props.formReference,
        disableCustomerData: !!props.individualRightHolderId,
        offering: props.offering,
        catalogueId: props.catalogueId || "",
        onSubmit: createRightHolder,
        defaultValues: props.defaultValues
    });
};
var $bcb54676fdf95094$export$2e2bcd8739ae039 = $bcb54676fdf95094$var$StepAddRightHolder;



var $592Nh = parcelRequire("592Nh");




var $5pzCu = parcelRequire("5pzCu");


var $2hDQc = parcelRequire("2hDQc");

const $f2315e658030fa98$var$StepFindRightHolder = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const schemaValidator = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            email: $7a5dda49dca6ae9d$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return (0, $066f7ec5b64309d3$export$371e338370561054)(email);
            })
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
        validationSchema: schemaValidator(),
        initialValues: {
            email: props.email
        },
        onSubmit: (values)=>{
            props.onSubmit(values);
        },
        enableReinitialize: true,
        children: ({ values: values, errors: errors, handleChange: handleChange, setFieldValue: setFieldValue, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                onSubmit: handleSubmit,
                id: props.formReference,
                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.modalFindRightHolder.info"
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormAutoCompleteTextField, {
                            options: props.selectableOptions,
                            value: values.email,
                            freeSolo: true,
                            onChange: (event, value)=>setFieldValue("email", value ?? ""),
                            renderInput: (params)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                    ...params,
                                    name: "email",
                                    "data-testid": "email",
                                    value: values.email,
                                    label: intl.formatMessage({
                                        id: "page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email"
                                    }),
                                    placeholder: intl.formatMessage({
                                        id: "page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email"
                                    }),
                                    onChange: handleChange,
                                    error: !!errors.email,
                                    errorText: errors.email,
                                    autoFocus: true,
                                    InputProps: {
                                        ...params.InputProps,
                                        endAdornment: /*#__PURE__*/ (0, $592Nh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
                                            children: [
                                                props.isFetching ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $24e2cd5750b4780c$export$2e2bcd8739ae039), {
                                                    color: "inherit",
                                                    size: 20
                                                }) : null,
                                                params.InputProps.endAdornment
                                            ]
                                        })
                                    }
                                })
                        })
                    ]
                })
            })
    });
};
var $f2315e658030fa98$export$2e2bcd8739ae039 = $f2315e658030fa98$var$StepFindRightHolder;




const $25ab609f73dd94e7$var$ModalAddRightHolder = (props)=>{
    const [activeStep, setActiveStep] = (0, $2hDQc.useState)("STEP_FIND");
    const [completedSteps, setCompletedSteps] = (0, $2hDQc.useState)([]);
    const [filledEmail, setFilledEmail] = (0, $2hDQc.useState)("");
    const [givenEmail, setGivenEmail] = (0, $2hDQc.useState)("");
    const [emailOptions, setEmailOptions] = (0, $2hDQc.useState)([]);
    const [foundIndividual, setFoundIndividual] = (0, $2hDQc.useState)(null);
    const FORM_REFERENCE_FIND = "formModalIndividualsFind";
    const FORM_REFERENCE_FILL = "formModalIndividualsFill";
    const queryIndividualsByEmail = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$9f074a658d5580d),
            givenEmail
        ],
        queryFn: ()=>(0, $6d5f4ec705c7ab18$export$2e2bcd8739ae039).getIndividualsByEmail(givenEmail || ""),
        retry: false,
        enabled: !!givenEmail
    });
    const goToFillStep = ()=>{
        if (!completedSteps.includes("STEP_FIND")) setCompletedSteps([
            ...completedSteps,
            "STEP_FIND"
        ]);
        setActiveStep("STEP_FILL");
        setFilledEmail(givenEmail);
    };
    const goToFindStep = ()=>{
        setCompletedSteps([]);
        setActiveStep("STEP_FIND");
    };
    (0, $2hDQc.useEffect)(()=>{
        if (!queryIndividualsByEmail.data || !queryIndividualsByEmail.isFetched) return;
        if (queryIndividualsByEmail.data.length <= 0) {
            setFoundIndividual(null);
            setEmailOptions([]);
            goToFillStep();
        } else if (queryIndividualsByEmail.data.length === 1) {
            setFoundIndividual(queryIndividualsByEmail.data[0]);
            setEmailOptions(queryIndividualsByEmail.data.map((item)=>item.email));
            goToFillStep();
        } else {
            setFoundIndividual(queryIndividualsByEmail.data[0]);
            setEmailOptions(queryIndividualsByEmail.data.map((item)=>item.email));
        }
    }, [
        queryIndividualsByEmail.fetchStatus
    ]);
    const createRightHolderMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $6d5f4ec705c7ab18$export$2e2bcd8739ae039).createIndividual(dto),
        onSuccess: (response)=>{
            const rightHolder = response.data || {};
            let name = "";
            const dataIndividual = rightHolder;
            name = (0, $335b32823e91bbd2$export$e49861a9373f5f25)(dataIndividual);
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.catalogues.tabCatalogue.modalFindRightHolder.actions.added",
                values: {
                    name: name
                }
            }));
            props.onSubmit(rightHolder);
        }
    });
    const grantRightMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $6d5f4ec705c7ab18$export$2e2bcd8739ae039).grantRightToIndividual(foundIndividual?.id || "", dto),
        onSuccess: (response)=>{
            const rightHolder = response.data || {};
            let name = "";
            name = rightHolder.vehicle?.licensePlate || "";
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.catalogues.tabCatalogue.modalFindRightHolder.actions.added",
                values: {
                    name: name
                }
            }));
            props.onSubmit(rightHolder);
        }
    });
    const findEmail = (email)=>{
        if (email && email === givenEmail) goToFillStep();
        else setGivenEmail(email);
    };
    const cancel = ()=>{
        createRightHolderMutation.reset();
        props.onCancel();
    };
    const steps = [
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.catalogues.modalAddRightHolder.steps.bar.email"
            }),
            step: "STEP_FIND",
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c066d1c6ec749c12$exports))), {
                fontSize: "large"
            })
        },
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.catalogues.modalAddRightHolder.steps.bar.rightHolder"
            }),
            step: "STEP_FILL",
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b240c3693ff60c3d$exports))), {
                fontSize: "large"
            })
        }
    ];
    const StepContent = ({ step: step })=>{
        switch(step){
            case "STEP_FIND":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $f2315e658030fa98$export$2e2bcd8739ae039), {
                    isFetching: queryIndividualsByEmail.isFetching,
                    email: filledEmail ?? "",
                    selectableOptions: emailOptions,
                    formReference: FORM_REFERENCE_FIND,
                    onSubmit: ({ email: email })=>findEmail(email)
                });
            case "STEP_FILL":
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $bcb54676fdf95094$export$2e2bcd8739ae039), {
                    formReference: FORM_REFERENCE_FILL,
                    customerId: props.customerId,
                    offering: props.offering,
                    catalogueId: props.catalogueId || "",
                    individualRightHolderId: foundIndividual?.id,
                    defaultValues: {
                        firstName: foundIndividual?.firstName ?? "",
                        lastName: foundIndividual?.lastName ?? "",
                        email: foundIndividual?.email ?? filledEmail ?? "",
                        phoneNumber: foundIndividual?.phoneNumber ?? "",
                        licensePlate: foundIndividual?.vehicles[0]?.licensePlate ?? "",
                        catalogueId: props.catalogueId || "",
                        validityStart: (0, $f65046485b965c63$exports.DateTime).local(),
                        costCenter: "",
                        project: ""
                    },
                    onSubmit: (dto)=>foundIndividual ? grantRightMutation.mutate(dto) : createRightHolderMutation.mutate(dto)
                });
            default:
                (0, $ee9cb80b5c23ac97$export$16bf6fe03653420f)(step);
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: activeStep === "STEP_FIND" ? FORM_REFERENCE_FIND : FORM_REFERENCE_FILL,
            mutation: createRightHolderMutation,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.catalogues.modalAddRightHolder.title"
            }),
            submitButtonContent: activeStep === "STEP_FIND" ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "common.buttons.next"
            }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            leftSideButtons: completedSteps.includes("STEP_FIND") ? [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                    onClick: goToFindStep,
                    variant: "text",
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "common.buttons.back"
                    })
                }, "back")
            ] : undefined,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                    style: {
                        marginBottom: queryIndividualsByEmail?.error ? "1rem" : undefined
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                        query: queryIndividualsByEmail,
                        errorTitleKey: "common.actions.get.error"
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    sx: {
                        mt: "0px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $7339a81857f49d36$export$2e2bcd8739ae039), {
                            alternativeLabel: true,
                            sx: {
                                width: "100%",
                                padding: "0"
                            },
                            children: steps.map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $bcdb9f1f7c6b0b25$export$2e2bcd8739ae039), {
                                    active: activeStep === item.step,
                                    completed: completedSteps.includes(item.step),
                                    disabled: completedSteps.includes(item.step),
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $af0cc4b2992db34c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)("h3", {
                                                    style: {
                                                        margin: "5px"
                                                    },
                                                    children: item.label
                                                })
                                            })
                                        })
                                    })
                                }, item.step.toString()))
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                padding: "5px"
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)(StepContent, {
                                step: completedSteps.includes("STEP_FIND") ? "STEP_FILL" : "STEP_FIND"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $25ab609f73dd94e7$export$2e2bcd8739ae039 = $25ab609f73dd94e7$var$ModalAddRightHolder;



var $592Nh = parcelRequire("592Nh");

var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");


var $5pzCu = parcelRequire("5pzCu");



const $7360275773ad5214$var$initialValues = {
    licensePlate: "",
    costCenter: "",
    project: "",
    validityStart: (0, $f65046485b965c63$exports.DateTime).local(),
    validityEnd: null
};
const $7360275773ad5214$var$FormIndividualRightHolder = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const validationSchema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
        licensePlate: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
            id: "common.form.errors.licensePlate"
        }), function(licensePlate) {
            return (0, $066f7ec5b64309d3$export$dddb845077defee2)(licensePlate);
        }),
        validityStart: $7a5dda49dca6ae9d$export$324d90190a8b822a().required(intl.formatMessage({
            id: "common.form.errors.invalidDateTime"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.invalidDateTime"
        })),
        validityEnd: $7a5dda49dca6ae9d$export$324d90190a8b822a().nullable().typeError(intl.formatMessage({
            id: "common.form.errors.invalidDateTime"
        })),
        costCenter: $7a5dda49dca6ae9d$export$22b082955e083ec3(),
        project: $7a5dda49dca6ae9d$export$22b082955e083ec3()
    });
    const onSubmitFormValues = (values)=>{
        const { validityStart: validityStart, validityEnd: validityEnd, costCenter: costCenter, project: project } = values;
        props.onSubmit({
            licensePlate: values.licensePlate.trim().toLocaleUpperCase(),
            validityStart: validityStart,
            validityEnd: validityEnd,
            costCenter: costCenter,
            project: project
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
        validate: ()=>setFormikValidateOnChange(true),
        validationSchema: validationSchema,
        enableReinitialize: true,
        initialValues: $7360275773ad5214$var$initialValues,
        validateOnChange: formikValidateOnChange,
        onSubmit: (values)=>{
            onSubmitFormValues(values);
        },
        children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                onSubmit: handleSubmit,
                id: props.formReference,
                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                            title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.formVehicleRightHolder.label.vehicleDetails"
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            fullWidth: true,
                            name: "licensePlate",
                            "data-testid": "licensePlate",
                            value: values.licensePlate,
                            label: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            placeholder: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            onChange: handleChange,
                            autoFocus: true,
                            error: !!errors.licensePlate,
                            errorText: errors.licensePlate
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                            title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.formVehicleRightHolder.label.validity"
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $161736656f2ba8cf$export$ccdfd7928785632e), {
                                    name: "validityStart",
                                    "data-testid": "validityStart",
                                    value: values.validityStart,
                                    disablePast: true,
                                    onChange: (newValue)=>setFieldValue("validityStart", newValue),
                                    label: intl.formatMessage({
                                        id: "common.text.validityStart"
                                    }),
                                    slotProps: {
                                        textField: {
                                            helperText: errors.validityStart ? "" + errors?.validityStart : null,
                                            error: !!errors.validityStart
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $161736656f2ba8cf$export$ccdfd7928785632e), {
                                    name: "validityEnd",
                                    "data-testid": "validityEnd",
                                    value: values.validityEnd,
                                    onChange: (newValue)=>setFieldValue("validityEnd", newValue),
                                    label: intl.formatMessage({
                                        id: "common.text.validityEnd"
                                    }),
                                    minDateTime: values.validityStart,
                                    slotProps: {
                                        textField: {
                                            helperText: errors.validityEnd ? "" + errors?.validityEnd : null,
                                            error: !!errors.validityEnd
                                        }
                                    }
                                })
                            ]
                        }),
                        props.showAccountingFields && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                    name: "costCenter",
                                    "data-testid": "costCenter",
                                    value: values.costCenter,
                                    onChange: handleChange,
                                    label: intl.formatMessage({
                                        id: "common.text.costCenter"
                                    }),
                                    error: !!errors.costCenter,
                                    errorText: errors.costCenter
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                    name: "project",
                                    "data-testid": "project",
                                    value: values.project,
                                    onChange: handleChange,
                                    label: intl.formatMessage({
                                        id: "common.text.project"
                                    }),
                                    error: !!errors.project,
                                    errorText: errors.project
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
var $7360275773ad5214$export$2e2bcd8739ae039 = $7360275773ad5214$var$FormIndividualRightHolder;








const $3b083d873a5d73f4$var$ModalAddRightHolder = (props)=>{
    const FORM_VEHICLE_RIGHT_HOLDER = "formModalVehicleRightHolder";
    const createRightHolderMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $6d5f4ec705c7ab18$export$2e2bcd8739ae039).grantRightToVehicle(dto),
        onSuccess: (response)=>{
            const right = response.data || {};
            let name = right.vehicle?.licensePlate || "";
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.catalogues.tabCatalogue.modalFindRightHolder.actions.added",
                values: {
                    name: name
                }
            }));
            props.onSubmit(right);
        }
    });
    const cancel = ()=>{
        createRightHolderMutation.reset();
        props.onCancel();
    };
    const createVehicleRightHolder = (values)=>{
        const { licensePlate: licensePlate, validityStart: validityStart, validityEnd: validityEnd, costCenter: costCenter, project: project } = values;
        const dto = {
            licensePlate: licensePlate,
            right: {
                rightHolderType: "vehicle",
                catalogueId: props.catalogueId,
                validityStart: (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(validityStart),
                validityEnd: validityEnd ? (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(validityEnd) : undefined,
                active: true,
                costCenter: costCenter?.trim() || undefined,
                project: project?.trim() || undefined
            }
        };
        createRightHolderMutation.mutate(dto);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
        open: props.open,
        onCancel: cancel,
        formReference: FORM_VEHICLE_RIGHT_HOLDER,
        mutation: createRightHolderMutation,
        errorTitleKey: "common.actions.add.error",
        modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.catalogues.modalAddVehicleRightHolder.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7360275773ad5214$export$2e2bcd8739ae039), {
            formReference: FORM_VEHICLE_RIGHT_HOLDER,
            onSubmit: createVehicleRightHolder,
            showAccountingFields: props.showAccountingFields
        })
    });
};
var $3b083d873a5d73f4$export$2e2bcd8739ae039 = $3b083d873a5d73f4$var$ModalAddRightHolder;





const $eb15dd71039061f5$var$RightHolders = ({ queryActiveRights: queryActiveRights, place: place, customerId: customerId, catalogue: catalogue, offering: offering, showModalAddRightHolder: showModalAddRightHolder, showModalAddVehicle: showModalAddVehicle, pagination: pagination, onSubmitAdd: onSubmitAdd, onSubmitEdit: onSubmitEdit, onTerminate: onTerminate, onCancel: onCancel })=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [showModalEditVehicle, setShowModalEditVehicle] = (0, $2hDQc.useState)(undefined);
    const activeRights = queryActiveRights.data?.data || [];
    const onClickRow = (row)=>{
        if (row.individual?.id) navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHT_HOLDERS}/${row.individual?.id || ""}`, {
            state: {
                placeId: place.id,
                placeName: place.name,
                catalogueId: catalogue?.id,
                offeringName: catalogue?.offering?.name
            }
        });
        else navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHTS}/${row.id || ""}`);
    };
    const isWhitelist = offering?.type === "WHITELIST";
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                emptyTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.empty",
                errorTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.failed",
                query: queryActiveRights,
                pagination: pagination,
                children: activeRights.map((row)=>{
                    const normalContentList = [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "common.text.email"
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                            children: row.individual?.email || ""
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "common.text.licensePlate"
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                            children: row.vehicle?.licensePlate || ""
                        })
                    ];
                    const commonContentList = [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.catalogues.tabCatalogue.rightHolders.card.header.place"
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                            children: row.place.name
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.catalogues.tabCatalogue.rightHolders.card.header.validUntil"
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                utcDateTime: row.validityEnd,
                                emptyText: intl.formatMessage({
                                    id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                })
                            })
                        })
                    ];
                    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                        cardTitle: isWhitelist ? row.vehicle?.licensePlate || "" : (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName),
                        cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                            utcDateTime: row.validityStart
                        }),
                        cardContentList: isWhitelist ? commonContentList : [
                            ...normalContentList,
                            ...commonContentList
                        ],
                        onCardClicked: ()=>onClickRow(row)
                    }, row.id);
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                items: activeRights,
                emptyTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.empty",
                errorTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.failed",
                query: queryActiveRights,
                pagination: pagination,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                            children: [
                                !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                id: "page.catalogues.tabCatalogue.rightHolders.table.header.name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                id: "common.text.email"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.text.licensePlate"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.table.header.place"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.table.header.validFrom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.table.header.validUntil"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                        "data-testid": "places-table-body",
                        children: activeRights.map((row)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                onClick: ()=>onClickRow(row),
                                hover: true,
                                sx: {
                                    cursor: "pointer"
                                },
                                children: [
                                    !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                    children: (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: row.individual?.email || ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.individual ? row.vehicle?.licensePlate || "" : /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                            children: row.vehicle?.licensePlate || ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.place.name
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.validityStart
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.validityEnd,
                                            emptyText: intl.formatMessage({
                                                id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                            onClick: (evt)=>{
                                                evt.stopPropagation();
                                                setShowModalEditVehicle({
                                                    individualId: row.individual?.id,
                                                    rightId: row.id,
                                                    catalogueId: row.catalogueId,
                                                    licensePlate: row.vehicle?.licensePlate || "",
                                                    costCenter: row.costCenter,
                                                    project: row.project
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                id: "common.buttons.edit"
                                            })
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $25ab609f73dd94e7$export$2e2bcd8739ae039), {
                open: showModalAddRightHolder,
                customerId: customerId,
                catalogueId: catalogue?.id || "",
                offering: catalogue?.offering,
                onSubmit: ()=>{
                    onSubmitAdd(showModalEditVehicle?.individualId);
                },
                onCancel: ()=>onCancel()
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $9c0eb4be3833c653$export$2e2bcd8739ae039), {
                open: !!showModalEditVehicle,
                rightId: showModalEditVehicle?.rightId || "",
                catalogueId: showModalEditVehicle?.catalogueId || "",
                licensePlate: showModalEditVehicle?.licensePlate || "",
                costCenter: showModalEditVehicle?.costCenter,
                project: showModalEditVehicle?.project,
                onTerminated: ()=>{
                    onTerminate(showModalEditVehicle?.individualId);
                    setShowModalEditVehicle(undefined);
                },
                onSubmit: ()=>{
                    onSubmitEdit(showModalEditVehicle?.individualId);
                    setShowModalEditVehicle(undefined);
                },
                onCancel: ()=>setShowModalEditVehicle(undefined),
                showAccountingFields: !isWhitelist
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $3b083d873a5d73f4$export$2e2bcd8739ae039), {
                open: showModalAddVehicle,
                customerId: customerId,
                catalogueId: catalogue?.id || "",
                onSubmit: ()=>{
                    onSubmitAdd(showModalEditVehicle?.individualId);
                },
                onCancel: ()=>onCancel(),
                showAccountingFields: !isWhitelist
            })
        ]
    });
};
var $eb15dd71039061f5$export$2e2bcd8739ae039 = $eb15dd71039061f5$var$RightHolders;





var $2hDQc = parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");


var $2hDQc = parcelRequire("2hDQc");


const $b319539231dd532f$var$SearchRightHolders = ({ initialSearch: initialSearch = "", onSearch: onSearch, query: query })=>{
    const [search, setSearch] = (0, $2hDQc.useState)(initialSearch);
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const searchInvalid = search?.length === 1 || search?.length === 2;
    const searchHandler = (evt)=>{
        evt.preventDefault();
        if (!searchInvalid) onSearch(search);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)("div", {
        style: {
            marginBottom: "2rem"
        },
        children: /*#__PURE__*/ (0, $592Nh.jsx)("form", {
            onSubmit: searchHandler,
            id: "search",
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "searchTerm",
                            "data-testid": "searchTerm",
                            value: search,
                            label: intl.formatMessage({
                                id: "page.catalogues.tabCatalogue.search.label"
                            }),
                            onChange: (evt)=>{
                                setSearch(evt.target.value);
                            },
                            size: "small",
                            error: searchInvalid,
                            errorText: searchInvalid ? intl.formatMessage({
                                id: "page.catalogues.tabCatalogue.search.invalid"
                            }) : "",
                            type: "search"
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                            style: {
                                marginLeft: "1rem"
                            },
                            query: query,
                            type: "submit",
                            disabled: searchInvalid,
                            children: "Hae"
                        })
                    ]
                })
            })
        })
    });
};
var $b319539231dd532f$export$2e2bcd8739ae039 = $b319539231dd532f$var$SearchRightHolders;


const $d51df1ce2bec0fc8$var$TabCatalogue = ({ catalogue: catalogue })=>{
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const { tenant: tenant } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const [showModalAddRightHolder, setShowModalAddRightHolder] = (0, $2hDQc.useState)(false);
    const [showModalAddVehicle, setShowModalAddVehicle] = (0, $2hDQc.useState)(false);
    const place = catalogue?.place;
    const customerId = catalogue?.customer?.id;
    const catalogueId = catalogue?.id;
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $7bfb91130cd4d35d$export$60dd4bbd6d459f57),
        initialValue: (0, $ae63e01d7dc24727$export$4bec99d256114e49)("VEHICLE")
    });
    const [searchTerm, setSearchTerm] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: "moovyCatalogueRightsSearch",
        initialValue: {
            value: ""
        }
    });
    const queryOffering = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$79b5a04d4c49a4e2),
            catalogue?.offering.id
        ],
        queryFn: ()=>(0, $0b5c38c6bf15e48a$export$ca807e2054383e2d).getOfferingById(catalogue?.offering.id || ""),
        enabled: !!catalogue?.offering.id && !tenant,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const offering = queryOffering.data;
    const queryActiveRights = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$e94a35ab41f6d829),
            catalogueId,
            pagingAndSortValues.page,
            pagingAndSortValues.sort,
            searchTerm.value
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $ae63e01d7dc24727$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $be730b8591848347$export$25753268427e50ea).getActiveRightsById(catalogueId || "", {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction,
                searchTerm: searchTerm.value
            });
        },
        enabled: !!catalogueId
    });
    const pagination = queryActiveRights.data?.pageable ? {
        page: queryActiveRights.data.pageable.page,
        total: queryActiveRights.data.pageable.total,
        limit: queryActiveRights.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const refreshView = (individualId)=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$93e1682d8eaccc31),
                catalogueId
            ]
        });
        if (offering?.id) {
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d),
                    offering.id
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$79b5a04d4c49a4e2),
                    offering.id
                ]
            });
        }
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
                place?.id
            ]
        });
        individualId && queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$475c1d76a7297be4),
                individualId
            ]
        });
    };
    const isWhitelist = offering?.type === "WHITELIST";
    const isWebshopCatalogue = catalogue?.type === "WEBSHOP";
    const allowIndividualGrant = !isWebshopCatalogue && !isWhitelist;
    const allowVehicleGrant = !isWebshopCatalogue && catalogue?.allowVehicleGrant;
    const items = (0, $5dcd3ee6df434ce0$export$88b06990067e1fdb)(intl, "ACTIVE_RIGHTS").filter((item)=>!isWhitelist || item.key !== "INDIVIDUAL");
    const onSubmitAdd = (individualId)=>{
        setShowModalAddRightHolder(false);
        setShowModalAddVehicle(false);
        refreshView(individualId);
    };
    const onSubmitEdit = (individualId)=>{
        refreshView(individualId);
    };
    const onTerminate = (individualId)=>{
        const newPage = (0, $ae63e01d7dc24727$export$e8b67cc4f4c44ec6)(pagination);
        if (newPage) setPagingAndSortValues({
            ...pagingAndSortValues,
            page: newPage
        });
        refreshView(individualId);
    };
    const onCancel = ()=>{
        setShowModalAddVehicle(false);
        setShowModalAddRightHolder(false);
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                    title: catalogue?.offering?.name,
                    props: {
                        paddingTop: 4
                    }
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $fe7312e28f7f7475$export$2e2bcd8739ae039), {
                                        catalogue: catalogue,
                                        whitelistOffering: isWhitelist
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $39b43260797a31d6$export$2e2bcd8739ae039), {
                                        place: place
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                            props: {
                                pl: 0,
                                pr: 0
                            },
                            title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.title.rightHolder"
                            }),
                            titleProps: {
                                pb: 2
                            },
                            description: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b319539231dd532f$export$2e2bcd8739ae039), {
                                        initialSearch: searchTerm.value,
                                        onSearch: (newSearchTerm)=>{
                                            setSearchTerm({
                                                value: newSearchTerm
                                            });
                                            setPagingAndSortValues({
                                                ...pagingAndSortValues,
                                                page: 1
                                            });
                                        },
                                        query: queryActiveRights
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b69e7f737512ce9e$export$2e2bcd8739ae039), {
                                        filterKey: (0, $7bfb91130cd4d35d$export$70568e7be1b89dff),
                                        items: items,
                                        value: pagingAndSortValues.sort,
                                        onChange: (value)=>{
                                            pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                                ...pagingAndSortValues,
                                                sort: value,
                                                direction: (0, $5dcd3ee6df434ce0$export$fcce7887255d1c69)(value)
                                            });
                                        }
                                    })
                                ]
                            }),
                            button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                action: "CREATE",
                                resource: "RIGHT_HOLDERS",
                                children: /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                                    children: isWhitelist ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                        onClick: ()=>setShowModalAddVehicle(true),
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "page.catalogues.tabCatalogue.button.addVehicle"
                                        })
                                    }) : /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                        container: true,
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: allowIndividualGrant && /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                                    onClick: ()=>setShowModalAddRightHolder(true),
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.catalogues.tabCatalogue.button.addIndividual"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                                item: true,
                                                pt: 1,
                                                children: allowVehicleGrant && /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                                    style: {
                                                        marginLeft: "1rem"
                                                    },
                                                    onClick: ()=>setShowModalAddVehicle(true),
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.catalogues.tabCatalogue.button.addVehicle"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $eb15dd71039061f5$export$2e2bcd8739ae039), {
                            queryActiveRights: queryActiveRights,
                            pagination: pagination,
                            customerId: customerId || "",
                            catalogue: catalogue,
                            place: {
                                id: place?.id || "",
                                name: place?.name || ""
                            },
                            offering: offering,
                            showModalAddRightHolder: showModalAddRightHolder,
                            showModalAddVehicle: showModalAddVehicle,
                            onSubmitAdd: onSubmitAdd,
                            onSubmitEdit: onSubmitEdit,
                            onTerminate: onTerminate,
                            onCancel: onCancel
                        })
                    ]
                })
            ]
        })
    });
};
var $d51df1ce2bec0fc8$export$2e2bcd8739ae039 = $d51df1ce2bec0fc8$var$TabCatalogue;



var $592Nh = parcelRequire("592Nh");
parcelRequire("2hDQc");

const $c5690d06390e785b$var$TabInvitations = ({ catalogue: catalogue })=>{
    // The component is only intended to be shown tenant invitations
    if (catalogue?.customer.type !== "TENANT") return "";
    const tenantId = catalogue?.customer.id || "";
    const landlordId = catalogue?.customer.parentId || "";
    const catalogueId = catalogue?.id || "";
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $122d1ee578c830fa$export$2e2bcd8739ae039), {
        tenantId: tenantId,
        landlordId: landlordId,
        catalogueId: catalogueId
    });
};
var $c5690d06390e785b$export$2e2bcd8739ae039 = $c5690d06390e785b$var$TabInvitations;





var $592Nh = parcelRequire("592Nh");






var $592Nh = parcelRequire("592Nh");





var $6b47564d3e770674$exports = {};
"use strict";
"use client";

Object.defineProperty($6b47564d3e770674$exports, "__esModule", {
    value: true
});
$6b47564d3e770674$exports.default = void 0;

var $6b47564d3e770674$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $6b47564d3e770674$var$_default = $6b47564d3e770674$exports.default = (0, $6b47564d3e770674$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3M12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), "WarningRounded");



const $fbaa0965168458a7$var$InvitationsOngoing = ({ customerId: customerId, onLinkClicked: onLinkClicked })=>{
    const queryInvitations = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$96f07f442214aab),
            customerId
        ],
        queryFn: ()=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).getInvitationsByCustomerId(false, customerId),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const invitationsCount = queryInvitations.data ? queryInvitations.data.length : 0;
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
            pt: 1,
            visibility: invitationsCount > 0 ? "visible" : "hidden",
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                onClick: onLinkClicked,
                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b47564d3e770674$exports))), {}),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                            marginLeft: "5px",
                            paddingTop: "2px",
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                values: {
                                    count: invitationsCount
                                },
                                id: "page.customers.tabAdministrators.invitationsOngoing.link"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $fbaa0965168458a7$export$2e2bcd8739ae039 = $fbaa0965168458a7$var$InvitationsOngoing;




var $592Nh = parcelRequire("592Nh");


const $50a1fe16d8606f60$var$ModalAdminInvitations = ({ open: open, queryAdminInvitations: queryAdminInvitations, landlordId: landlordId, onClose: onClose })=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
        maxWidth: "lg",
        hideCancelButton: true,
        open: open,
        onCancel: onClose,
        onSubmit: onClose,
        errorTitleKey: "common.actions.add.error",
        modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.customers.tabAdministrators.modalAdminInvitations.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "common.ok"
        }),
        contentPadding: 0,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $61010f014b1b3692$export$2e2bcd8739ae039), {
                queryInvitations: queryAdminInvitations,
                customerId: landlordId
            })
        ]
    });
var $50a1fe16d8606f60$export$2e2bcd8739ae039 = $50a1fe16d8606f60$var$ModalAdminInvitations;




var $592Nh = parcelRequire("592Nh");





const $b2701f19f7ab427b$var$TableAdministrators = ({ queryAdministrators: queryAdministrators, setShowModalRemove: setShowModalRemove })=>{
    const { isPermission: isPermission, decodedToken: decodedToken } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const administrators = queryAdministrators.data || [];
    // Check that logged in user can't delete his own administrator rights
    const isCurrentUserRow = (row)=>row.id === decodedToken?.sub;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                emptyTextId: "page.customers.tabAdministrators.tableAdministrators.action.empty",
                errorTextId: "page.customers.tabAdministrators.tableAdministrators.action.failed",
                query: queryAdministrators,
                children: administrators.map((row)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                        cardTitle: (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.lastName, row.firstName),
                        cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                            utcDateTime: row.createdAt
                        }),
                        cardContentList: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "common.text.email"
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                children: row.email
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.customers.tabAdministrators.tableAdministrators.header.registeredIn"
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                    utcDateTime: row.createdAt,
                                    emptyText: "-"
                                })
                            })
                        ],
                        cardMenuActions: isPermission("DELETE", "USERS") && !isCurrentUserRow(row) ? [
                            {
                                itemText: intl.formatMessage({
                                    id: "page.customers.tabAdministrators.tableAdministrators.button.remove"
                                }),
                                onClick: ()=>setShowModalRemove({
                                        name: (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.lastName, row.firstName),
                                        id: row.id
                                    })
                            }
                        ] : undefined
                    }, row.id))
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                items: administrators,
                emptyTextId: "page.customers.tabAdministrators.tableAdministrators.action.empty",
                errorTextId: "page.customers.tabAdministrators.tableAdministrators.action.failed",
                query: queryAdministrators,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.customers.tabAdministrators.tableAdministrators.header.name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.text.email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.customers.tabAdministrators.tableAdministrators.header.registeredIn"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                    action: "DELETE",
                                    resource: "USERS",
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                        children: administrators.map((row)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.lastName, row.firstName)
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: row.email
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.createdAt
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                        action: "DELETE",
                                        resource: "USERS",
                                        visibility: !!row.createdAt && !isCurrentUserRow(row),
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                            align: "right",
                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                red: true,
                                                bold: true,
                                                onClick: ()=>setShowModalRemove({
                                                        name: (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.lastName, row.firstName),
                                                        id: row.id
                                                    }),
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.customers.tabAdministrators.tableAdministrators.button.remove"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            })
        ]
    });
};
var $b2701f19f7ab427b$export$2e2bcd8739ae039 = $b2701f19f7ab427b$var$TableAdministrators;



var $2hDQc = parcelRequire("2hDQc");

const $68fa3602ae98c34a$var$TabAdministrators = ({ customerId: customerId, showInvitationCreate: showInvitationCreate = true })=>{
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [modalAdminInvitations, setModalAdminInvitations] = (0, $2hDQc.useState)(false);
    const [showModalAdd, setShowModalAdd] = (0, $2hDQc.useState)(false);
    const [selectedUserForDeletion, setSelectedUserForDeletion] = (0, $2hDQc.useState)(null);
    const showModalRemove = selectedUserForDeletion !== null;
    const queryAdmins = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$6d14da40fa4f1ffe),
            customerId
        ],
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getUsersByCustomer(customerId),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const queryAdminInvitations = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$96f07f442214aab),
            customerId
        ],
        queryFn: ()=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).getInvitationsByCustomerId(false, customerId),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const removeAdminUserMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (userId)=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).removeUser(customerId, userId),
        onSuccess: (response)=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.customers.tabAdministrators.modalRemove.actions.removed"
            }));
            setSelectedUserForDeletion(null);
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$6d14da40fa4f1ffe),
                    customerId
                ]
            });
        }
    });
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$96f07f442214aab),
                customerId
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        description: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.customers.tabAdministrators.infoText"
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $fbaa0965168458a7$export$2e2bcd8739ae039), {
                                    customerId: customerId,
                                    onLinkClicked: ()=>setModalAdminInvitations(true)
                                })
                            ]
                        }),
                        button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                            action: "CREATE",
                            resource: "ADMIN_INVITATIONS",
                            visibility: showInvitationCreate,
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowModalAdd(true),
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.customers.tabAdministrators.button.newAdminInvitation"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b2701f19f7ab427b$export$2e2bcd8739ae039), {
                            queryAdministrators: queryAdmins,
                            setShowModalRemove: (user)=>setSelectedUserForDeletion(user)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $bf59313fc47a1b56$export$2e2bcd8739ae039), {
                addingInvitationParams: {
                    invitationType: "ADMIN",
                    landlordId: customerId
                },
                open: showModalAdd,
                onSubmit: (response)=>{
                    setShowModalAdd(false);
                    (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.customers.tabAdministrators.actions.added",
                        values: {
                            name: response.name
                        }
                    }));
                    onRefreshView();
                },
                onCancel: ()=>setShowModalAdd(false)
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $50a1fe16d8606f60$export$2e2bcd8739ae039), {
                open: modalAdminInvitations,
                landlordId: customerId,
                queryAdminInvitations: queryAdminInvitations,
                onClose: ()=>setModalAdminInvitations(false)
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $03bdcb6e7b9b2179$export$2e2bcd8739ae039), {
                open: showModalRemove,
                lang: {
                    confirmButton: "common.buttons.yes",
                    error: "common.actions.remove.error"
                },
                header: intl.formatMessage({
                    id: "page.customers.tabAdministrators.modalRemove.header"
                }),
                content: intl.formatMessage({
                    id: "page.customers.tabAdministrators.modalRemove.content"
                }, {
                    name: selectedUserForDeletion?.name
                }),
                onCancel: ()=>setSelectedUserForDeletion(null),
                onConfirm: ()=>removeAdminUserMutation.mutate(selectedUserForDeletion?.id || ""),
                mutation: removeAdminUserMutation
            })
        ]
    });
};
var $68fa3602ae98c34a$export$2e2bcd8739ae039 = $68fa3602ae98c34a$var$TabAdministrators;


const $e81b1540ee2b51ad$var$CatalogueTabs = ({ catalogue: catalogue })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { admin: admin, isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    // Invitations and administrators tabs are only shown for tenant customer type and logged users who are not admin
    const isVisible = catalogue?.customer.type === "TENANT" && !admin && isPermission("READ", "TENANT_INVITATIONS");
    let tabHeaders = [
        intl.formatMessage({
            id: "page.places.catalogueTabs.catalogue.header"
        })
    ];
    let tabPanels = [
        /*#__PURE__*/ (0, $592Nh.jsx)((0, $d51df1ce2bec0fc8$export$2e2bcd8739ae039), {
            catalogue: catalogue
        })
    ];
    if (isVisible) {
        tabHeaders.push(intl.formatMessage({
            id: "page.places.catalogueTabs.administrators.header"
        }), intl.formatMessage({
            id: "page.places.catalogueTabs.invitations.header"
        }));
        tabPanels.push(/*#__PURE__*/ (0, $592Nh.jsx)((0, $68fa3602ae98c34a$export$2e2bcd8739ae039), {
            customerId: catalogue.customer.id,
            showInvitationCreate: false
        }), /*#__PURE__*/ (0, $592Nh.jsx)((0, $c5690d06390e785b$export$2e2bcd8739ae039), {
            catalogue: catalogue
        }));
    }
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
        loading: false,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $74f5dfbf7740a204$export$2e2bcd8739ae039), {
                tabKey: "tabsRightHolderGroup",
                tabHeaders: tabHeaders,
                tabPanels: tabPanels
            })
        })
    });
};
var $e81b1540ee2b51ad$export$2e2bcd8739ae039 = $e81b1540ee2b51ad$var$CatalogueTabs;




var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");


var $ac0e6f973d0bafe8$exports = {};
"use strict";
"use client";

Object.defineProperty($ac0e6f973d0bafe8$exports, "__esModule", {
    value: true
});
$ac0e6f973d0bafe8$exports.default = void 0;

var $ac0e6f973d0bafe8$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $ac0e6f973d0bafe8$var$_default = $ac0e6f973d0bafe8$exports.default = (0, $ac0e6f973d0bafe8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "EditRounded");



var $592Nh = parcelRequire("592Nh");

var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");
var $7c1f800c75354614$exports = {};
"use strict";
Object.defineProperty($7c1f800c75354614$exports, "__esModule", {
    value: true
});
var $7c1f800c75354614$var$BUSINESS_ID_REGEX = /^[\d]{7}-[\d]$/;
var $7c1f800c75354614$var$VAT_NUMBER_REGEX = /^FI[\d]{8}$/;
var $7c1f800c75354614$var$MULTIPLIERS = [
    7,
    9,
    10,
    5,
    8,
    4,
    2
];
function $7c1f800c75354614$var$randomBusinessIdWithoutChecksum() {
    while(true){
        var businessId = (Math.floor(Math.random() * 1000000) + 1000000).toString();
        if ($7c1f800c75354614$var$FinnishBusinessIds.calculateChecksum(businessId) !== -1) return businessId;
    }
}
var $7c1f800c75354614$var$FinnishBusinessIds = /** @class */ function() {
    function FinnishBusinessIds() {}
    FinnishBusinessIds.isValidBusinessId = function(businessId) {
        if (!$7c1f800c75354614$var$BUSINESS_ID_REGEX.test(businessId)) return false;
        var givenChecksum = parseInt(businessId.substring(8, 9), 10);
        var idNumbers = businessId.substring(0, 7);
        var calculatedChecksum = FinnishBusinessIds.calculateChecksum(idNumbers);
        return calculatedChecksum === givenChecksum;
    };
    FinnishBusinessIds.isValidVatNumber = function(vatNumber) {
        if (!$7c1f800c75354614$var$VAT_NUMBER_REGEX.test(vatNumber)) return false;
        var vatAsBusinessId = vatNumber.substring(2, 9) + "-" + vatNumber.substring(9, 10);
        return this.isValidBusinessId(vatAsBusinessId);
    };
    FinnishBusinessIds.generateBusinessId = function() {
        var businessId = $7c1f800c75354614$var$randomBusinessIdWithoutChecksum();
        var checksum = FinnishBusinessIds.calculateChecksum(businessId);
        return businessId + "-" + checksum;
    };
    FinnishBusinessIds.generateVatNumber = function() {
        var countryCode = "FI";
        var businessId = $7c1f800c75354614$var$randomBusinessIdWithoutChecksum();
        var checksum = FinnishBusinessIds.calculateChecksum(businessId);
        return countryCode + businessId + checksum;
    };
    FinnishBusinessIds.calculateChecksum = function(idNumbers) {
        var sum = 0;
        for(var i = 0; i < idNumbers.length; i++)sum += parseInt(idNumbers[i], 10) * $7c1f800c75354614$var$MULTIPLIERS[i];
        var remainder = sum % 11;
        if (remainder === 1) return -1;
        else if (remainder > 1) remainder = 11 - remainder;
        return remainder;
    };
    return FinnishBusinessIds;
}();
$7c1f800c75354614$exports.FinnishBusinessIds = $7c1f800c75354614$var$FinnishBusinessIds;



var $5pzCu = parcelRequire("5pzCu");

const $2422be65d3727472$var$FormCustomer = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const getFormDefaultValues = ()=>{
        return {
            name: props.defaultValues?.name || "",
            streetAddress: props.defaultValues?.streetAddress || "",
            postalCode: props.defaultValues?.postalCode || "",
            city: props.defaultValues?.city || "",
            businessId: props.defaultValues?.businessId || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $2hDQc.useState)(getFormDefaultValues());
    (0, $2hDQc.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.businessId,
        props.defaultValues?.city,
        props.defaultValues?.name,
        props.defaultValues?.postalCode,
        props.defaultValues?.streetAddress
    ]);
    const CustomerSchema = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            name: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            businessId: $7a5dda49dca6ae9d$export$22b082955e083ec3().test("businessId", intl.formatMessage({
                id: "common.form.errors.businessId"
            }), function(businessId) {
                return !!businessId && (0, $7c1f800c75354614$exports.FinnishBusinessIds).isValidBusinessId(businessId);
            }),
            streetAddress: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            postalCode: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            city: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            }))
        });
    };
    const onSubmitFormValues = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, businessId: businessId } = values;
        props.onSubmit({
            name: name.trim(),
            streetAddress: streetAddress.trim(),
            postalCode: postalCode.trim(),
            city: city.trim(),
            businessId: businessId.trim()
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: CustomerSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            props.showTitle && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.customers.formCustomer.contentTitle"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "name",
                                        "data-testid": "name",
                                        value: values.name,
                                        autoFocus: true,
                                        label: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.name"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.name"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.name,
                                        errorText: errors.name
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "businessId",
                                        "data-testid": "businessId",
                                        value: values.businessId,
                                        label: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.businessId"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.businessId"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.businessId,
                                        errorText: errors.businessId,
                                        disabled: props.editView
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                            name: "streetAddress",
                                            "data-testid": "streetAddress",
                                            value: values.streetAddress,
                                            label: intl.formatMessage({
                                                id: "page.customers.formCustomer.label.streetAddress"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customers.formCustomer.label.streetAddress"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.streetAddress,
                                            errorText: errors.streetAddress
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                            children: [
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                                    name: "postalCode",
                                                    "data-testid": "postalCode",
                                                    value: values.postalCode,
                                                    label: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.postalCode"
                                                    }),
                                                    placeholder: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.postalCode"
                                                    }),
                                                    onChange: handleChange,
                                                    error: !!errors.postalCode,
                                                    errorText: errors.postalCode
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                                    name: "city",
                                                    "data-testid": "city",
                                                    value: values.city,
                                                    label: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.city"
                                                    }),
                                                    placeholder: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.city"
                                                    }),
                                                    onChange: handleChange,
                                                    error: !!errors.city,
                                                    errorText: errors.city
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
        })
    });
};
var $2422be65d3727472$export$2e2bcd8739ae039 = $2422be65d3727472$var$FormCustomer;







const $c2895c5c4d47f320$var$ModalEditCustomer = (props)=>{
    const FORM_REFERENCE = "formUpdateCustomer";
    const { defaultValues: defaultValues } = props;
    const updateCustomerMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).updateCustomer(props.editableCustomerRef, dto),
        onSuccess: (response)=>{
            props.onSubmit(response.data);
        }
    });
    const updateCustomer = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city } = values;
        const dto = {
            name: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(name, defaultValues.name),
            streetAddress: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(streetAddress, defaultValues.streetAddress),
            postalCode: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(postalCode, defaultValues.postalCode),
            city: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(city, defaultValues.city),
            businessId: undefined // Not allowed to modify by frontend
        };
        if ((0, $ee9cb80b5c23ac97$export$8f98ff223296ded9)(dto)) updateCustomerMutation.mutate(dto);
    };
    const cancel = ()=>{
        updateCustomerMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.update.error",
            modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.customer.modalEditCustomer.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            mutation: updateCustomerMutation,
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $2422be65d3727472$export$2e2bcd8739ae039), {
                showTitle: true,
                onSubmit: (values)=>{
                    updateCustomer(values);
                },
                formReference: FORM_REFERENCE,
                defaultValues: defaultValues,
                editView: true
            })
        })
    });
};
var $c2895c5c4d47f320$export$2e2bcd8739ae039 = $c2895c5c4d47f320$var$ModalEditCustomer;





const $0b6148e3de0802ef$var$CustomerInformation = ({ header: header, customerId: customerId, customBreadcrumbs: customBreadcrumbs })=>{
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const [showModal, setShowModal] = (0, $2hDQc.useState)(false);
    const { customer: customer, setCustomer: setCustomer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryCustomer = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$b3c26f5832e8795f),
            customerId
        ],
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getCustomerByRef(customerId || ""),
        enabled: !!customerId,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const { name: name, streetAddress: streetAddress, city: city, postalCode: postalCode, businessId: businessId, customerNumber: customerNumber } = queryCustomer.data ?? {};
    const defaultValues = {
        name: name || "",
        streetAddress: streetAddress || "",
        city: city || "",
        postalCode: postalCode || "",
        businessId: businessId || "",
        customerNumber: customerNumber || ""
    };
    const data = [
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.name"
            }),
            value: `${defaultValues.name}`
        },
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.streetAddress"
            }),
            value: `${(0, $ee9cb80b5c23ac97$export$ff20516246215bf)(defaultValues?.streetAddress, defaultValues?.postalCode, ", ")} ${defaultValues?.city}`
        },
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.businessId"
            }),
            value: `${defaultValues.businessId}`
        },
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.customerNumber"
            }),
            value: `${defaultValues.customerNumber}`
        }
    ];
    const refreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$b3c26f5832e8795f),
                customerId
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d)
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryCustomer,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                        breadcrumbs: customBreadcrumbs,
                        children: header || name
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.customer.title"
                        }),
                        button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                            action: "EDIT",
                            resource: "CUSTOMER",
                            visibility: !!customerId,
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac0e6f973d0bafe8$exports))), {}),
                                onClick: ()=>setShowModal(true),
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "page.customer.button.edit"
                                })
                            })
                        }),
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                            data: data
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2895c5c4d47f320$export$2e2bcd8739ae039), {
                open: showModal,
                editableCustomerRef: customerId || "",
                defaultValues: defaultValues,
                onSubmit: (response)=>{
                    (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.customer.actions.updated",
                        values: {
                            name: response?.name
                        }
                    }));
                    response && response.id === customer.id && setCustomer(response);
                    refreshView();
                    setShowModal(false);
                },
                onCancel: ()=>setShowModal(false)
            })
        ]
    });
};
var $0b6148e3de0802ef$export$2e2bcd8739ae039 = $0b6148e3de0802ef$var$CustomerInformation;




parcelRequire("2hDQc");




const $49cb6c7164a35383$var$Catalogue = ()=>{
    const { catalogueRef: catalogueRef } = (0, $86f6846c59d1b386$export$99eaa27ddbbb95ef)();
    const { tenant: tenant } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const catalogueId = catalogueRef || "";
    const queryCatalogue = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$93e1682d8eaccc31),
            catalogueId
        ],
        queryFn: ()=>(0, $be730b8591848347$export$25753268427e50ea).getCataloguesByRef(catalogueId),
        enabled: !!catalogueId
    });
    const customerId = queryCatalogue.data?.customer?.id;
    const catalogue = queryCatalogue.data;
    const lastItem = catalogue?.name || catalogue?.customer?.name || "";
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryCatalogue,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0b6148e3de0802ef$export$2e2bcd8739ae039), {
                            header: lastItem,
                            customerId: customerId,
                            customBreadcrumbs: {
                                lastBreadcrumb: lastItem,
                                customBreadcrumbs: !tenant ? [
                                    {
                                        route: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${catalogue?.place.id}`,
                                        name: catalogue?.place.name || ""
                                    },
                                    {
                                        route: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).OFFERINGS}/${catalogue?.offering?.id}`,
                                        name: catalogue?.offering?.name || ""
                                    }
                                ] : undefined
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $e81b1540ee2b51ad$export$2e2bcd8739ae039), {
                            catalogue: catalogue
                        })
                    })
                ]
            })
        ]
    });
};
var $49cb6c7164a35383$export$2e2bcd8739ae039 = $49cb6c7164a35383$var$Catalogue;



var $592Nh = parcelRequire("592Nh");




var $592Nh = parcelRequire("592Nh");



var $592Nh = parcelRequire("592Nh");


var $2hDQc = parcelRequire("2hDQc");
const $ddd24467ba6f94d1$var$TabSubPlaces = ({ customerId: customerId, queryPlaces: queryPlaces })=>{
    const [showSubPlaceModal, setShowSubPlaceModal] = (0, $2hDQc.useState)(false);
    const places = queryPlaces.data || [];
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
        loading: queryPlaces.isFetching,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $95124b73b270900a$export$2e2bcd8739ae039), {
                        queryPlaces: queryPlaces,
                        places: places
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $584154d17c229856$export$2e2bcd8739ae039), {
                        open: showSubPlaceModal,
                        onSubmit: (values)=>{
                            queryPlaces.refetch();
                            setShowSubPlaceModal(false);
                        },
                        onCancel: ()=>setShowSubPlaceModal(false),
                        customerId: customerId
                    })
                ]
            })
        ]
    });
};
var $ddd24467ba6f94d1$export$2e2bcd8739ae039 = $ddd24467ba6f94d1$var$TabSubPlaces;



const $4990a72ef4db9487$var$CustomerTabs = ({ customerId: customerId, enableTabPlaces: enableTabPlaces, enableTabAdmins: enableTabAdmins, queryPlaces: queryPlaces })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const tabHeaders = [
        enableTabPlaces ? intl.formatMessage({
            id: "page.customer.customerTabs.locations.header"
        }) : "",
        enableTabAdmins ? intl.formatMessage({
            id: "page.customer.customerTabs.admins.header"
        }) : ""
    ].filter((item)=>item);
    const tabPanels = [
        enableTabPlaces ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $ddd24467ba6f94d1$export$2e2bcd8739ae039), {
            customerId: customerId,
            queryPlaces: queryPlaces
        }) : "",
        enableTabAdmins ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $68fa3602ae98c34a$export$2e2bcd8739ae039), {
            customerId: customerId
        }) : ""
    ].filter((item)=>item);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $74f5dfbf7740a204$export$2e2bcd8739ae039), {
        tabKey: "tabsRightHolderGroup",
        tabHeaders: tabHeaders,
        tabPanels: tabPanels
    });
};
var $4990a72ef4db9487$export$2e2bcd8739ae039 = $4990a72ef4db9487$var$CustomerTabs;




parcelRequire("2hDQc");



const $3da4975b8ab9ba9a$var$Customer = ()=>{
    let { customerRef: customerRef } = (0, $86f6846c59d1b386$export$99eaa27ddbbb95ef)();
    const { admin: admin, isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const customerId = customerRef || "";
    const queryPlaces = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$995d68b6ebb26447),
            customerId
        ],
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getPlacesByCustomer(admin, customerId),
        enabled: !!customerId && isPermission("READ", "PLACES"),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const enableTabPlaces = !!queryPlaces.data && queryPlaces.data.length > 0;
    const enableTabAdmins = isPermission("READ", "ADMIN_INVITATIONS");
    const showTabs = enableTabPlaces || enableTabAdmins;
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        direction: "row",
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0b6148e3de0802ef$export$2e2bcd8739ae039), {
                    customerId: customerId
                })
            }),
            showTabs && /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $4990a72ef4db9487$export$2e2bcd8739ae039), {
                            customerId: customerId,
                            enableTabPlaces: enableTabPlaces,
                            enableTabAdmins: enableTabAdmins,
                            queryPlaces: queryPlaces
                        })
                    })
                })
            })
        ]
    });
};
var $3da4975b8ab9ba9a$export$2e2bcd8739ae039 = $3da4975b8ab9ba9a$var$Customer;



var $592Nh = parcelRequire("592Nh");

parcelRequire("2hDQc");
const $bf15ae79bcdd79ca$var$Invitations = ()=>{
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $eaa7b9c2dbfdf5a8$export$2e2bcd8739ae039), {});
};
var $bf15ae79bcdd79ca$export$2e2bcd8739ae039 = $bf15ae79bcdd79ca$var$Invitations;



var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");





var $592Nh = parcelRequire("592Nh");








const $be2418ef5618e226$var$StepLandlord = (props)=>{
    const { setCustomer: setCustomer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const FORM_REFERENCE = "formStepAddLandlord";
    const createCustomerMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).createCustomer(dto),
        onSuccess: (response)=>{
            const customer = response.data || {};
            setCustomer(customer, true);
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.steps.landlord.actions.added",
                values: {
                    name: customer.name
                }
            }));
            props.onStepCompleted();
        }
    });
    const createCustomer = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, businessId: businessId } = values;
        const dto = {
            type: "LANDLORD",
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            businessId: businessId
        };
        createCustomerMutation.mutate(dto);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("h1", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.steps.landlord.title"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                mutation: createCustomerMutation,
                errorTitleKey: "common.actions.add.error"
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)("p", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.steps.landlord.info"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $2422be65d3727472$export$2e2bcd8739ae039), {
                onSubmit: (values)=>{
                    createCustomer(values);
                },
                formReference: FORM_REFERENCE
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                pt: 12,
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                    type: "submit",
                    mutation: createCustomerMutation,
                    form: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "common.buttons.next"
                    })
                })
            })
        ]
    });
};
var $be2418ef5618e226$export$2e2bcd8739ae039 = $be2418ef5618e226$var$StepLandlord;



var $592Nh = parcelRequire("592Nh");


var $592Nh = parcelRequire("592Nh");



var $2hDQc = parcelRequire("2hDQc");

var $5pzCu = parcelRequire("5pzCu");



const $b3dd93895be367f7$var$FormPlace = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { customer: customer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const customerOptions = props.customers.map((item)=>{
        return {
            key: item.id,
            value: item.name
        };
    });
    const getFormDefaultValues = ()=>{
        return {
            name: props.defaultValues?.name || "",
            streetAddress: props.defaultValues?.streetAddress || "",
            postalCode: props.defaultValues?.postalCode || "",
            city: props.defaultValues?.city || "",
            capacity: props.defaultValues?.capacity || "",
            customerId: props.defaultValues?.customerId || customer.id
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $2hDQc.useState)(getFormDefaultValues());
    (0, $2hDQc.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.capacity,
        props.defaultValues?.city,
        props.defaultValues?.name,
        props.defaultValues?.postalCode,
        props.defaultValues?.streetAddress,
        props.defaultValues?.customerId
    ]);
    const placeSchema = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            customerId: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            name: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            streetAddress: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            postalCode: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            city: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            capacity: $7a5dda49dca6ae9d$export$98e628dec113755e().required(intl.formatMessage({
                id: "common.form.errors.empty"
            }))
        });
    };
    const onSubmitFormValues = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, capacity: capacity, customerId: customerId } = values;
        props.onSubmit({
            name: name.trim(),
            streetAddress: streetAddress.trim(),
            postalCode: postalCode.trim(),
            city: city.trim(),
            capacity: capacity,
            customerId: customerId
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: placeSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            props.showTitle && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.places.formPlace.contentTitle"
                                })
                            }),
                            customerOptions.length > 1 && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormSelect, {
                                    name: "customerId",
                                    label: intl.formatMessage({
                                        id: "page.places.formPlace.label.customer"
                                    }),
                                    value: values.customerId,
                                    onChange: handleChange,
                                    error: !!errors.customerId,
                                    children: customerOptions.map((item)=>{
                                        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                                            value: item.key,
                                            children: item.value
                                        }, item.key);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "name",
                                        "data-testid": "name",
                                        value: values.name,
                                        autoFocus: true,
                                        label: intl.formatMessage({
                                            id: "page.places.formPlace.label.name"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.places.formPlace.label.name"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.name,
                                        errorText: errors.name
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "streetAddress",
                                        "data-testid": "streetAddress",
                                        value: values.streetAddress,
                                        label: intl.formatMessage({
                                            id: "page.places.formPlace.label.streetAddress"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.places.formPlace.label.streetAddress"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.streetAddress,
                                        errorText: errors.streetAddress
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                                name: "postalCode",
                                                "data-testid": "postalCode",
                                                value: values.postalCode,
                                                label: intl.formatMessage({
                                                    id: "page.places.formPlace.label.postalCode"
                                                }),
                                                placeholder: intl.formatMessage({
                                                    id: "page.places.formPlace.label.postalCode"
                                                }),
                                                onChange: handleChange,
                                                error: !!errors.postalCode,
                                                errorText: errors.postalCode
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                                name: "city",
                                                "data-testid": "city",
                                                value: values.city,
                                                label: intl.formatMessage({
                                                    id: "page.places.formPlace.label.city"
                                                }),
                                                placeholder: intl.formatMessage({
                                                    id: "page.places.formPlace.label.city"
                                                }),
                                                onChange: handleChange,
                                                error: !!errors.city,
                                                errorText: errors.city
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                            name: "capacity",
                                            "data-testid": "capacity",
                                            value: values.capacity || "",
                                            type: "number",
                                            label: intl.formatMessage({
                                                id: "page.places.formPlace.label.capacity"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.places.formPlace.label.capacity"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.capacity,
                                            errorText: errors.capacity,
                                            disabled: props?.editView
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $b3dd93895be367f7$export$2e2bcd8739ae039 = $b3dd93895be367f7$var$FormPlace;








const $1471d86429d9ded7$var$StepPlace = (props)=>{
    const { customer: customer, setPlace: setPlace } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const FORM_REFERENCE = "formStepAddPlace";
    const createPlaceMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $a37004fca245d806$export$2bffccb0f948be1f).createPlaceWithDefaultOffering(dto),
        onSuccess: (response)=>{
            const place = response.data;
            setPlace(place);
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.steps.place.actions.added",
                values: {
                    name: place.name
                }
            }));
            props.onStepCompleted();
        }
    });
    const createPlace = (values)=>{
        const customerId = customer.id;
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, capacity: capacity } = values;
        const createPlaceDto = {
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            customerId: customerId,
            capacity: capacity
        };
        createPlaceMutation.mutate(createPlaceDto);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("h1", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.steps.place.title"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                mutation: createPlaceMutation,
                errorTitleKey: "common.actions.update.error"
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)("p", {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.steps.place.info"
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b3dd93895be367f7$export$2e2bcd8739ae039), {
                onSubmit: (values)=>{
                    createPlace(values);
                },
                formReference: FORM_REFERENCE,
                customers: []
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                pt: 12,
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                    type: "submit",
                    mutation: createPlaceMutation,
                    form: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "common.buttons.complete"
                    })
                })
            })
        ]
    });
};
var $1471d86429d9ded7$export$2e2bcd8739ae039 = $1471d86429d9ded7$var$StepPlace;









const $09bbf9a38ef348fb$var$LoginSteps = ()=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    let eStep;
    (function(eStep) {
        eStep[eStep["STEP_LANDLORD"] = 0] = "STEP_LANDLORD";
        eStep[eStep["STEP_PLACE"] = 1] = "STEP_PLACE";
    })(eStep || (eStep = {}));
    const { customer: customer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const { admin: admin } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const [activeStep, setActiveStep] = (0, $2hDQc.useState)(customer?.id ? 1 : 0);
    const [completedSteps, setCompletedSteps] = (0, $2hDQc.useState)([]);
    const queryPlaces = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$9e8d1e7efde0f0d3)
        ],
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getPlacesByCustomer(admin, customer.id),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc),
        enabled: !!customer?.id
    });
    const queryInvitations = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$a10de6d4556ab62e)
        ],
        queryFn: ()=>(0, $5d8afbac14d682f8$export$2e2bcd8739ae039).getUserInvitations(),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const isAllowedToCreateCustomer = queryInvitations.data?.find((invitation)=>!invitation.used && !invitation.landlordId);
    // If the user has no customer relationship defined and no open invitation to create one -> can't access Lupapalvelu
    const userHasNoRightsToContinue = !isAllowedToCreateCustomer && !customer.id;
    (0, $2hDQc.useEffect)(()=>{
        const response = queryPlaces.data;
        if (response && response.length > 0 && response[0]?.id && response[0]?.name) navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).ROOT, {
            replace: true
        });
    }, [
        queryPlaces.isSuccess
    ]);
    if (userHasNoRightsToContinue) return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    sx: {
                        mt: "2rem"
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.steps.noRights.header"
                    })
                })
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    sx: {
                        pt: "1rem"
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsx)("p", {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.steps.noRights.content"
                        })
                    })
                })
            })
        ]
    });
    const stepCompleted = (step)=>{
        !completedSteps.includes(step) && setCompletedSteps([
            ...completedSteps,
            step
        ]);
        switch(step){
            case 0:
                setActiveStep(1);
                break;
            case 1:
                navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).ROOT, {
                    replace: true
                });
                break;
            default:
                (0, $ee9cb80b5c23ac97$export$16bf6fe03653420f)(step);
        }
    };
    const StepContent = ({ step: step })=>{
        switch(step){
            case 0:
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $be2418ef5618e226$export$2e2bcd8739ae039), {
                    onStepCompleted: ()=>stepCompleted(0)
                });
            case 1:
                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $1471d86429d9ded7$export$2e2bcd8739ae039), {
                    onStepCompleted: ()=>stepCompleted(1)
                });
            default:
                (0, $ee9cb80b5c23ac97$export$16bf6fe03653420f)(step);
        }
    };
    const isLoading = ()=>{
        return queryPlaces.isFetching;
    };
    const steps = [
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.steps.bar.landlord.title"
            }),
            step: 0,
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c066d1c6ec749c12$exports))), {
                fontSize: "large"
            }),
            description: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.steps.bar.landlord.description"
            })
        },
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.steps.bar.place.title"
            }),
            step: 1,
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b240c3693ff60c3d$exports))), {
                fontSize: "large"
            }),
            description: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.steps.bar.place.description"
            })
        }
    ];
    return /*#__PURE__*/ (0, $592Nh.jsx)("div", {
        children: isLoading() ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                    sx: {
                        mt: "30px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $7339a81857f49d36$export$2e2bcd8739ae039), {
                            alternativeLabel: true,
                            sx: {
                                width: "100%",
                                pt: "50px"
                            },
                            children: steps.map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $bcdb9f1f7c6b0b25$export$2e2bcd8739ae039), {
                                    active: activeStep === item.step,
                                    disabled: activeStep !== item.step,
                                    completed: completedSteps.includes(item.step),
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $af0cc4b2992db34c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)("h3", {
                                                        style: {
                                                            margin: "5px"
                                                        },
                                                        children: item.label
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                                                            style: {
                                                                display: "flex"
                                                            },
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            pl: 1,
                                                            children: item.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, item.step))
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                padding: "50px"
                            },
                            children: /*#__PURE__*/ (0, $592Nh.jsx)(StepContent, {
                                step: activeStep
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $09bbf9a38ef348fb$export$2e2bcd8739ae039 = $09bbf9a38ef348fb$var$LoginSteps;



var $592Nh = parcelRequire("592Nh");



var $592Nh = parcelRequire("592Nh");





var $2hDQc = parcelRequire("2hDQc");






var $592Nh = parcelRequire("592Nh");



var $5pzCu = parcelRequire("5pzCu");


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $ae9a622371f6e67b$export$d72d4cbdc30b331f(slot) {
    return (0, $01COD.default)("MuiFormGroup", slot);
}
const $ae9a622371f6e67b$var$formGroupClasses = (0, $eLydt.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $ae9a622371f6e67b$export$2e2bcd8739ae039 = $ae9a622371f6e67b$var$formGroupClasses;





var $592Nh = parcelRequire("592Nh");
"use client";
const $eb418b46e6dd1d2c$var$_excluded = [
    "className",
    "row"
];
const $eb418b46e6dd1d2c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $ae9a622371f6e67b$export$d72d4cbdc30b331f), classes);
};
const $eb418b46e6dd1d2c$var$FormGroupRoot = (0, $fhlQp.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $eb418b46e6dd1d2c$var$FormGroup = /*#__PURE__*/ $2hDQc.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $gZOiq.default)(props, $eb418b46e6dd1d2c$var$_excluded);
    const muiFormControl = (0, $d664d4831d5b413a$export$2e2bcd8739ae039)();
    const fcs = (0, $8b06d8a0923886b3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $kxIgO.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $eb418b46e6dd1d2c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($eb418b46e6dd1d2c$var$FormGroupRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $eb418b46e6dd1d2c$export$2e2bcd8739ae039 = $eb418b46e6dd1d2c$var$FormGroup;







var $592Nh = parcelRequire("592Nh");
"use client";
const $b34bb119bbd6d528$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $b34bb119bbd6d528$var$RadioGroup = /*#__PURE__*/ $2hDQc.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $gZOiq.default)(props, $b34bb119bbd6d528$var$_excluded);
    const rootRef = $2hDQc.useRef(null);
    const [value, setValueState] = (0, $ff224becc5bb5771$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $2hDQc.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $a92f7cdb3954c0c7$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $2hDQc.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $7ca226911a2aa89c$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $eb418b46e6dd1d2c$export$2e2bcd8739ae039), (0, $kxIgO.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $b34bb119bbd6d528$export$2e2bcd8739ae039 = $b34bb119bbd6d528$var$RadioGroup;



var $2hDQc = parcelRequire("2hDQc");






const $d5de9a575e4272c3$var$ModalCreateCatalogue = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, offering: offering })=>{
    const FORM_REFERENCE = "formCreateCatalogue";
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const [grantedTo, setGrantedTo] = (0, $2hDQc.useState)("TENANT");
    const mutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $be730b8591848347$export$25753268427e50ea).createCatalogue(dto),
        onSuccess: ()=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.modalCreateCatalogue.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d),
                    offering?.id
                ]
            });
        }
    });
    const { customer: customer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    (0, $2hDQc.useEffect)(()=>{
        mutation.reset();
        setGrantedTo("TENANT");
    }, [
        open
    ]);
    if (!offering) return null;
    const isWhitelist = offering.type === "WHITELIST";
    // Handle conflict response as a amount exceeds offering error message, no localized error message from backend
    const error = mutation.error ? mutation.error : undefined;
    const conflictErrorKey = error && error.response?.status === 409 ? "page.offering.modalCreateCatalogue.mutation.conflict" : undefined;
    const nameSchema = {
        catalogueName: $7a5dda49dca6ae9d$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        }))
    };
    const amountSchema = {
        amount: $7a5dda49dca6ae9d$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalCreateCatalogue.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    };
    const landlordSchema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
        ...nameSchema,
        ...amountSchema
    });
    const tenantSchema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
        ...nameSchema,
        ...amountSchema,
        customerName: $7a5dda49dca6ae9d$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        })),
        businessId: $7a5dda49dca6ae9d$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).test("businessId", intl.formatMessage({
            id: "common.form.errors.businessId"
        }), function(businessId) {
            return !!businessId && (0, $7c1f800c75354614$exports.FinnishBusinessIds).isValidBusinessId(businessId);
        }),
        costCenter: $7a5dda49dca6ae9d$export$22b082955e083ec3(),
        project: $7a5dda49dca6ae9d$export$22b082955e083ec3(),
        streetAddress: $7a5dda49dca6ae9d$export$22b082955e083ec3(),
        postalCode: $7a5dda49dca6ae9d$export$22b082955e083ec3(),
        city: $7a5dda49dca6ae9d$export$22b082955e083ec3()
    });
    const whitelistSchema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape(nameSchema);
    const submitHandler = (values)=>{
        const { catalogueName: catalogueName, amount: amount, customerName: customerName, businessId: businessId, costCenter: costCenter, project: project, streetAddress: streetAddress, postalCode: postalCode, city: city, allowVehicleGrant: allowVehicleGrant } = values;
        const dto = {
            name: catalogueName,
            costCenter: costCenter?.trim() || undefined,
            project: project?.trim() || undefined,
            amount: Number.parseInt(amount),
            customerId: customer.id,
            offeringId: offering.id,
            allowVehicleGrant: allowVehicleGrant
        };
        if (!isWhitelist && grantedTo === "TENANT") {
            dto.createTenant = {
                type: "TENANT",
                parentId: customer.id,
                name: customerName,
                businessId: businessId,
                streetAddress: !!streetAddress && streetAddress.trim().length > 0 ? streetAddress : undefined,
                postalCode: !!postalCode && postalCode.trim().length > 0 ? postalCode : undefined,
                city: !!city && city.trim().length > 0 ? city : undefined
            };
            dto.customerId = undefined;
        }
        mutation.mutate(dto);
    };
    const OwnerDetail = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b34bb119bbd6d528$export$2e2bcd8739ae039), {
            value: grantedTo,
            onChange: (event)=>setGrantedTo(event.target.value),
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                    sx: {
                        fontWeight: "bold"
                    },
                    focused: false,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.grantedTo"
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormRadio, {
                    control: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b716fe5ce517ca5d$export$2e2bcd8739ae039), {}),
                    label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.grantedTo.customer"
                    }),
                    value: "TENANT"
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormRadio, {
                    control: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b716fe5ce517ca5d$export$2e2bcd8739ae039), {}),
                    label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.grantedTo.self"
                    }),
                    value: "LANDLORD"
                })
            ]
        });
    };
    const TenantDetail = ({ values: values, handleChange: handleChange, setFieldValue: setFieldValue, errors: errors })=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                    sx: {
                        fontWeight: "bold"
                    },
                    focused: false,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.customerLabel"
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "customerName",
                            "data-testid": "customerName",
                            value: values.customerName,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.customerName"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.customerName"
                            }),
                            onChange: handleChange,
                            error: !!errors.customerName,
                            errorText: errors.customerName
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "businessId",
                            "data-testid": "businessId",
                            value: values.businessId,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.businessId"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.businessId"
                            }),
                            onChange: handleChange,
                            error: !!errors.businessId,
                            errorText: errors.businessId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "costCenter",
                            "data-testid": "costCenter",
                            value: values.costCenter,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.costCenter"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.costCenter"
                            }),
                            onChange: handleChange,
                            error: !!errors.costCenter,
                            errorText: errors.costCenter
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "project",
                            "data-testid": "project",
                            value: values.project,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.project"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.project"
                            }),
                            onChange: handleChange,
                            error: !!errors.project,
                            errorText: errors.project
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "streetAddress",
                            "data-testid": "streetAddress",
                            value: values.streetAddress,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.streetAddress"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.streetAddress"
                            }),
                            onChange: handleChange,
                            error: !!errors.streetAddress,
                            errorText: errors.streetAddress
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "postalCode",
                            "data-testid": "postalCode",
                            value: values.postalCode,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.postalCode"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.postalCode"
                            }),
                            onChange: handleChange,
                            error: !!errors.postalCode,
                            errorText: errors.postalCode
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "city",
                            "data-testid": "city",
                            value: values.city,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.city"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.city"
                            }),
                            onChange: handleChange,
                            error: !!errors.city,
                            errorText: errors.city
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                    style: {
                        fontWeight: "bold"
                    },
                    focused: false,
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.offering.modalCreateCatalogue.offering"
                        }),
                        (" " + offering.name) ?? ""
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormSwitch, {
                    checked: values.allowVehicleGrant,
                    name: "allowVehicleGrant",
                    label: intl.formatMessage({
                        id: "page.offering.modalCreateCatalogue.allowVehicleGrant"
                    }),
                    style: {
                        fontWeight: "bold"
                    },
                    onChange: (event)=>setFieldValue("allowVehicleGrant", event.target.checked)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.offering.modalCreateCatalogue.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        mutation: mutation,
        formReference: FORM_REFERENCE,
        errorTitleKey: conflictErrorKey,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                amount: "",
                catalogueName: "",
                customerName: "",
                businessId: "",
                streetAddress: "",
                postalCode: "",
                city: "",
                costCenter: "",
                project: ""
            },
            validationSchema: isWhitelist ? whitelistSchema : grantedTo === "LANDLORD" ? landlordSchema : tenantSchema,
            onSubmit: (values)=>{
                submitHandler(values);
            },
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, setFieldValue: setFieldValue, values: values, errors: errors })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    style: {
                        padding: "0 1rem"
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                                style: {
                                    fontWeight: "bold"
                                },
                                focused: false,
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalCreateCatalogue.catalogueName"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "catalogueName",
                                value: values.catalogueName,
                                onChange: handleChange,
                                label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalCreateCatalogue.catalogueName"
                                }),
                                error: !!errors.catalogueName,
                                errorText: errors.catalogueName
                            }),
                            !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)(OwnerDetail, {}),
                                    grantedTo === "TENANT" && /*#__PURE__*/ (0, $592Nh.jsx)(TenantDetail, {
                                        values: values,
                                        handleChange: handleChange,
                                        setFieldValue: setFieldValue,
                                        errors: errors
                                    }),
                                    !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "amount",
                                        value: values.amount,
                                        onChange: handleChange,
                                        label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "page.offering.modalCreateCatalogue.amount"
                                        }),
                                        error: !!errors.amount,
                                        errorText: errors.amount
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $d5de9a575e4272c3$export$2e2bcd8739ae039 = $d5de9a575e4272c3$var$ModalCreateCatalogue;



var $592Nh = parcelRequire("592Nh");






var $5pzCu = parcelRequire("5pzCu");


parcelRequire("2hDQc");

const $bf10a65f0a1f5434$var$ModalEditCatalogue = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, catalogue: catalogue, offering: offering })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const FORM_REFERENCE = "formEditCatalogue";
    const nameSchema = {
        catalogueName: $7a5dda49dca6ae9d$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        }))
    };
    const schema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
        ...nameSchema,
        amount: $7a5dda49dca6ae9d$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalEditCatalogue.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    });
    const whitelistSchema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape(nameSchema);
    const mutationCatalogue = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $be730b8591848347$export$25753268427e50ea).updateCatalogue(catalogue?.id ?? "", dto),
        onSuccess: ()=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.modalEditCatalogue.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d)
                ]
            });
        }
    });
    // Handle conflict response as a amount exceeds offering error message, no localized error message from backend
    const error = mutationCatalogue.error ? mutationCatalogue.error : undefined;
    const conflictErrorKey = error && error.response?.status === 409 ? "page.offering.modalCreateCatalogue.mutation.conflict" : undefined;
    const submitHandler = (values)=>{
        const amount = (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(Number.parseInt(values.amount), catalogue?.amount);
        const name = (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(values.catalogueName, catalogue?.name);
        if (name || amount) {
            const dto = {
                amount: amount ? Number.parseInt(amount) : catalogue?.amount || 0,
                name: name
            };
            mutationCatalogue.mutate(dto);
        }
    };
    const isWhitelist = offering?.type === "WHITELIST";
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.offering.modalEditCatalogue.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        formReference: FORM_REFERENCE,
        mutation: mutationCatalogue,
        errorTitleKey: conflictErrorKey,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                catalogueName: catalogue?.name ?? "",
                amount: catalogue?.amount ? catalogue.amount.toString() : ""
            },
            validationSchema: isWhitelist ? whitelistSchema : schema,
            onSubmit: (values)=>submitHandler(values),
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                                style: {
                                    fontWeight: "bold"
                                },
                                focused: false,
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.catalogueName"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "catalogueName",
                                value: values.catalogueName,
                                onChange: handleChange,
                                label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.catalogueName"
                                }),
                                error: !!errors.catalogueName,
                                errorText: errors.catalogueName
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.customer"
                                })
                            }),
                            catalogue?.customer.name,
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.offering"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormSwitch, {
                                checked: true,
                                label: offering?.name || "",
                                style: {
                                    fontWeight: "bold"
                                },
                                disabled: true
                            }),
                            !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "page.offering.modalEditCatalogue.amountLabel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                        name: "amount",
                                        value: values.amount,
                                        onChange: handleChange,
                                        error: !!errors.amount,
                                        errorText: errors.amount,
                                        sx: {
                                            minWidth: "50%"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $bf10a65f0a1f5434$export$2e2bcd8739ae039 = $bf10a65f0a1f5434$var$ModalEditCatalogue;






const $76677b5e6b8d7324$var$CataloguesTab = ({ offering: offering })=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const [showCreateCatalogueModal, setShowCreateCatalogueModal] = (0, $2hDQc.useState)(false);
    const [selectedCatalogueRef, setSelectedCatalogueRef] = (0, $2hDQc.useState)(undefined);
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $7bfb91130cd4d35d$export$2b74872b9eccd572),
        initialValue: (0, $ae63e01d7dc24727$export$4bec99d256114e49)("CREATED_AT")
    });
    if (!offering) return null;
    const queryCatalogs = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d),
            offering.id,
            pagingAndSortValues.page,
            pagingAndSortValues.sort
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $ae63e01d7dc24727$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $be730b8591848347$export$25753268427e50ea).getByOffering(offering.id, {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction
            });
        },
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const catalogues = queryCatalogs.data?.data ?? [];
    const pagination = queryCatalogs.data?.pageable ? {
        page: queryCatalogs.data.pageable.page,
        total: queryCatalogs.data.pageable.total,
        limit: queryCatalogs.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const onClickRow = (item)=>{
        navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CATALOGUES}/${item.id}`);
    };
    const refreshData = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d),
                offering.id
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
                offering.placeId
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$79b5a04d4c49a4e2),
                offering.placeId
            ]
        });
    };
    const items = (0, $5dcd3ee6df434ce0$export$88b06990067e1fdb)(intl, "CATALOGUES");
    return /*#__PURE__*/ (0, $592Nh.jsx)("div", {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                    description: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.offering.cataloguesTab.infoText1"
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                action: "CREATE",
                                resource: "CATALOGUES",
                                children: /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.offering.cataloguesTab.infoText2"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b69e7f737512ce9e$export$2e2bcd8739ae039), {
                                pt: 2,
                                filterKey: (0, $7bfb91130cd4d35d$export$dd6ef14bcd36b902),
                                items: items,
                                value: pagingAndSortValues.sort,
                                onChange: (value)=>{
                                    pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        sort: value,
                                        direction: (0, $5dcd3ee6df434ce0$export$fcce7887255d1c69)(value)
                                    });
                                }
                            })
                        ]
                    }),
                    button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                        action: "CREATE",
                        resource: "CATALOGUES",
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                            onClick: ()=>setShowCreateCatalogueModal(true),
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.offering.cataloguesTab.createCatalogue"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                            emptyTextId: "page.offering.cataloguesTab.table.empty",
                            errorTextId: "page.offering.cataloguesTab.table.error",
                            query: queryCatalogs,
                            pagination: pagination,
                            children: catalogues.map((catalog)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                                    cardTitle: catalog.name || catalog.customer.name,
                                    cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                        utcDateTime: catalog.createdAt,
                                        dateOnly: true
                                    }),
                                    cardMenuActions: isPermission("EDIT", "CATALOGUES") ? [
                                        {
                                            itemText: intl.formatMessage({
                                                id: "page.offering.cataloguesTab.table.catalogue.edit"
                                            }),
                                            onClick: ()=>setSelectedCatalogueRef(catalog.id)
                                        }
                                    ] : undefined,
                                    cardContentList: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "page.offering.cataloguesTab.table.customer"
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                            children: catalog.customer.name
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $ac59c0458c13eb62$export$5fc72c219969b0e6), {
                                            amount: catalog.amount,
                                            activeRights: catalog.activeRights
                                        })
                                    ],
                                    onCardClicked: ()=>onClickRow(catalog)
                                }, catalog.id))
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                            items: catalogues,
                            emptyTextId: "page.offering.cataloguesTab.table.empty",
                            errorTextId: "page.offering.cataloguesTab.table.error",
                            query: queryCatalogs,
                            pagination: pagination,
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.name"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.customer"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.overview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.timestamps"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                                    children: catalogues.map((item)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                            onClick: ()=>onClickRow(item),
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                        children: item.name || ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                        children: item.customer.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: offering.type === "WHITELIST" ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $ac59c0458c13eb62$export$4421fe64f84f2e51), {
                                                        offering: offering
                                                    }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $ac59c0458c13eb62$export$5fc72c219969b0e6), {
                                                        amount: item.amount,
                                                        activeRights: item.activeRights
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $ea52dc2553d5098f$export$2e2bcd8739ae039), {
                                                        createdAt: item.createdAt,
                                                        updatedAt: item.updatedAt,
                                                        dateOnly: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    align: "right",
                                                    children: isPermission("EDIT", "CATALOGUES") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                        onClick: (evt)=>{
                                                            evt.stopPropagation();
                                                            setSelectedCatalogueRef(item.id);
                                                        },
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                            id: "page.offering.cataloguesTab.table.catalogue.edit"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, item.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $d5de9a575e4272c3$export$2e2bcd8739ae039), {
                            open: showCreateCatalogueModal,
                            onCancel: ()=>setShowCreateCatalogueModal(false),
                            onSubmit: ()=>{
                                setShowCreateCatalogueModal(false);
                                refreshData();
                            },
                            offering: offering
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $bf10a65f0a1f5434$export$2e2bcd8739ae039), {
                            open: !!selectedCatalogueRef,
                            onCancel: ()=>setSelectedCatalogueRef(undefined),
                            onSubmit: ()=>{
                                setSelectedCatalogueRef(undefined);
                                refreshData();
                            },
                            catalogue: catalogues.find((item)=>item.id === selectedCatalogueRef),
                            offering: offering
                        })
                    ]
                })
            ]
        })
    });
};
var $76677b5e6b8d7324$export$2e2bcd8739ae039 = $76677b5e6b8d7324$var$CataloguesTab;



var $592Nh = parcelRequire("592Nh");
parcelRequire("2hDQc");













const $4954525fc76ea286$var$RightHoldersTab = ({ offering: offering })=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $1a19893cc26bc20f$export$9512f33c9b8e71c5),
        initialValue: (0, $ae63e01d7dc24727$export$4bec99d256114e49)("VEHICLE")
    });
    const [searchTerm, setSearchTerm] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: "moovyOfferingRightHoldersSearch",
        initialValue: {
            value: ""
        }
    });
    if (!offering) return null;
    const queryRightHolders = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$9eb9aa3283b45cff),
            offering.id,
            pagingAndSortValues.page,
            pagingAndSortValues.sort,
            searchTerm.value
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $ae63e01d7dc24727$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $0b5c38c6bf15e48a$export$ca807e2054383e2d).getRightHoldersByOffering(offering.id, {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction,
                searchTerm: searchTerm.value
            });
        },
        enabled: searchTerm.value.length >= 3
    });
    const rightHolders = queryRightHolders.data?.data ?? [];
    const pagination = queryRightHolders.data?.pageable ? {
        page: queryRightHolders.data.pageable.page,
        total: queryRightHolders.data.pageable.total,
        limit: queryRightHolders.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const onClickRow = (row)=>{
        if (row.individual?.id) navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHT_HOLDERS}/${row.individual?.id || ""}`, {
            state: {
                placeId: row.place?.id,
                placeName: row.place?.name,
                catalogueId: row.catalogueId,
                offeringName: offering.name
            }
        });
        else navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHTS}/${row.id || ""}`);
    };
    const items = (0, $5dcd3ee6df434ce0$export$88b06990067e1fdb)(intl, "ACTIVE_RIGHTS").filter((item)=>offering.type !== "WHITELIST" || item.key !== "INDIVIDUAL");
    const isWhitelist = offering.type === "WHITELIST";
    return /*#__PURE__*/ (0, $592Nh.jsx)("div", {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                    description: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b319539231dd532f$export$2e2bcd8739ae039), {
                                initialSearch: searchTerm.value,
                                onSearch: (newSearchTerm)=>{
                                    setSearchTerm({
                                        value: newSearchTerm
                                    });
                                    setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        page: 1
                                    });
                                },
                                query: queryRightHolders
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b69e7f737512ce9e$export$2e2bcd8739ae039), {
                                filterKey: (0, $1a19893cc26bc20f$export$209a8ef612aeedd2),
                                items: items,
                                value: pagingAndSortValues.sort,
                                onChange: (value)=>{
                                    pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        sort: value,
                                        direction: (0, $5dcd3ee6df434ce0$export$fcce7887255d1c69)(value)
                                    });
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                            emptyTextId: searchTerm.value.length === 0 ? "page.offering.rightHoldersTab.table.search.empty" : "page.offering.rightHoldersTab.table.empty",
                            errorTextId: "page.offering.rightHoldersTab.table.error",
                            query: queryRightHolders,
                            pagination: pagination,
                            children: rightHolders.map((row)=>{
                                const normalContentList = [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.text.email"
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                        children: row.individual?.email || ""
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.text.licensePlate"
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                        children: row.vehicle?.licensePlate || ""
                                    })
                                ];
                                const commonContentList = [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.card.header.place"
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                        children: row.place?.name
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.card.header.validUntil"
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.validityEnd,
                                            emptyText: intl.formatMessage({
                                                id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                            })
                                        })
                                    })
                                ];
                                return /*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                                    cardTitle: isWhitelist ? row.vehicle?.licensePlate || "" : (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName),
                                    cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                        utcDateTime: row.validityStart
                                    }),
                                    cardContentList: isWhitelist ? commonContentList : [
                                        ...normalContentList,
                                        ...commonContentList
                                    ],
                                    onCardClicked: ()=>onClickRow(row)
                                }, row.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                            items: rightHolders,
                            emptyTextId: searchTerm.value.length === 0 ? "page.offering.rightHoldersTab.table.search.empty" : "page.offering.rightHoldersTab.table.empty",
                            errorTextId: "page.offering.rightHoldersTab.table.error",
                            query: queryRightHolders,
                            pagination: pagination,
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                        children: [
                                            !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                            id: "page.catalogues.tabCatalogue.rightHolders.table.header.name"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                            id: "common.text.email"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "common.text.licensePlate"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.catalogues.tabCatalogue.rightHolders.table.header.place"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.offering.rightHoldersTab.table.header.customer"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.catalogues.tabCatalogue.rightHolders.table.header.validFrom"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.catalogues.tabCatalogue.rightHolders.table.header.validUntil"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                                    children: rightHolders.map((row)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                            onClick: ()=>onClickRow(row),
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                !isWhitelist && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                                children: (0, $ee9cb80b5c23ac97$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                            children: row.individual?.email || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: row.individual ? row.vehicle?.licensePlate || "" : /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                        children: row.vehicle?.licensePlate || ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: row.place?.name
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: row.customerName
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                                        utcDateTime: row.validityStart
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                                        utcDateTime: row.validityEnd,
                                                        emptyText: intl.formatMessage({
                                                            id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, row.id))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $4954525fc76ea286$export$2e2bcd8739ae039 = $4954525fc76ea286$var$RightHoldersTab;




var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");



var $592Nh = parcelRequire("592Nh");





var $5pzCu = parcelRequire("5pzCu");



parcelRequire("2hDQc");
const $26fb018baed91308$var$ModalEditOffering = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, offering: offering })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const FORM_REFERENCE = "formEditOffering";
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const mutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $0b5c38c6bf15e48a$export$ca807e2054383e2d).updateOffering(offering?.id ?? "", offering?.placeId ?? "", dto),
        onSuccess: ()=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.modalEditOffering.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$79b5a04d4c49a4e2),
                    offering?.id
                ]
            });
        }
    });
    const schema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
        amount: $7a5dda49dca6ae9d$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalEditOffering.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    });
    const submitHandler = (values)=>{
        if (values?.amount) return mutation.mutate({
            amount: Number.parseInt(values.amount)
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.offering.modalEditOffering.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        formReference: FORM_REFERENCE,
        mutation: mutation,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                amount: offering?.amount ? "" + offering.amount : ""
            },
            validationSchema: schema,
            onSubmit: (values)=>submitHandler(values),
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.product"
                                })
                            }),
                            offering?.name,
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.amountLabel"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "amount",
                                value: values.amount,
                                onChange: handleChange,
                                error: !!errors.amount,
                                errorText: errors.amount,
                                sx: {
                                    minWidth: "50%"
                                }
                            })
                        ]
                    })
                })
        })
    });
};
var $26fb018baed91308$export$2e2bcd8739ae039 = $26fb018baed91308$var$ModalEditOffering;






const $1f37a14dba7117d0$var$OfferingInfo = ({ queryOffering: queryOffering })=>{
    const [showModal, setShowModal] = (0, $2hDQc.useState)(false);
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { tenant: tenant } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const offering = queryOffering.data;
    const queryPlace = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$823cd27a3f5f229e),
            offering?.placeId
        ],
        queryFn: ()=>(0, $a37004fca245d806$export$2bffccb0f948be1f).getPlaceByRef(offering?.placeId || ""),
        enabled: !!offering,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const place = queryPlace.data;
    const lastItem = offering?.name || "";
    const customBreadcrumbs = {
        lastBreadcrumb: lastItem,
        customBreadcrumbs: !tenant ? [
            {
                route: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${place?.id}`,
                name: place?.name || ""
            }
        ] : undefined
    };
    const isWhitelist = offering?.type === "WHITELIST";
    const isEditable = !isWhitelist && !offering?.ignoreAmountForCatalogue;
    const { name: name, summary: summary, amount: amount } = offering ?? {};
    const defaultValues = {
        offeringName: name || "",
        placeName: place?.name || "",
        amount: offering?.ignoreAmountForCatalogue ? intl.formatMessage({
            id: "page.offering.offeringInfo.ignoreAmountLimits"
        }) : amount,
        cataloguesAmount: isWhitelist ? summary?.catalogues : (0, $ee9cb80b5c23ac97$export$ec9646ddc27ee461)(summary?.cataloguesTotalAmount || 0, summary?.catalogues || 0, true)
    };
    const data = [
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.offeringInfo.name"
            }),
            value: `${defaultValues.offeringName}`
        },
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.offeringInfo.location"
            }),
            value: `${defaultValues?.placeName}`
        },
        {
            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.offeringInfo.catalogues.amount"
            }),
            value: `${defaultValues.cataloguesAmount}`
        }
    ];
    if (!isWhitelist) data.push({
        label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.offering.offeringInfo.maximumAmount"
        }),
        value: `${defaultValues.amount}`
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                        breadcrumbs: customBreadcrumbs,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.offering.offeringInfo.title"
                        }),
                        button: isEditable ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                            action: "EDIT",
                            resource: "OFFERING",
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac0e6f973d0bafe8$exports))), {}),
                                onClick: ()=>setShowModal(true),
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "page.offering.button.edit"
                                })
                            })
                        }) : undefined,
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                            data: data
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $26fb018baed91308$export$2e2bcd8739ae039), {
                open: showModal,
                offering: offering,
                onSubmit: ()=>{
                    setShowModal(false);
                },
                onCancel: ()=>setShowModal(false)
            })
        ]
    });
};
var $1f37a14dba7117d0$export$2e2bcd8739ae039 = $1f37a14dba7117d0$var$OfferingInfo;



parcelRequire("2hDQc");




const $0b0cc6f98ae6eb9e$var$Offering = ()=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { offeringId: offeringId } = (0, $86f6846c59d1b386$export$99eaa27ddbbb95ef)();
    const queryOffering = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$79b5a04d4c49a4e2),
            offeringId
        ],
        queryFn: ()=>(0, $0b5c38c6bf15e48a$export$ca807e2054383e2d).getOfferingById(offeringId || ""),
        enabled: !!offeringId,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryOffering,
        rootPageIfNotFoundError: true,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $1f37a14dba7117d0$export$2e2bcd8739ae039), {
                        queryOffering: queryOffering
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $74f5dfbf7740a204$export$2e2bcd8739ae039), {
                                tabKey: (0, $7bfb91130cd4d35d$export$52484cb0e4bee674),
                                tabHeaders: [
                                    intl.formatMessage({
                                        id: "page.offering.cataloguesTab.header"
                                    }),
                                    intl.formatMessage({
                                        id: "page.offering.rightHoldersTab.header"
                                    })
                                ],
                                tabPanels: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $76677b5e6b8d7324$export$2e2bcd8739ae039), {
                                        offering: queryOffering.data
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $4954525fc76ea286$export$2e2bcd8739ae039), {
                                        offering: queryOffering.data
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $0b0cc6f98ae6eb9e$export$2e2bcd8739ae039 = $0b0cc6f98ae6eb9e$var$Offering;



var $592Nh = parcelRequire("592Nh");





var $2hDQc = parcelRequire("2hDQc");





var $592Nh = parcelRequire("592Nh");








const $5617db4b69b86dd9$var$ModalAddPlace = (props)=>{
    const FORM_REFERENCE = "formAddPlace";
    const { admin: admin } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const queryCustomers = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$6efe1800fcda6819)
        ],
        // TODO Antti: Should be fixed later because there might be more than 500 customers.
        // Anyway, this code is not in use so far because UI does not support adding sub places
        queryFn: ()=>admin ? (0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getLandlords(true, {
                limit: 500
            }) : (0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getCustomers(false, {
                limit: 500
            }),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const customers = queryCustomers.data?.data || [];
    const createPlaceMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $a37004fca245d806$export$2bffccb0f948be1f).createPlaceWithDefaultOffering(dto),
        onSuccess: (response)=>{
            const place = response.data || {};
            props.onSubmit(place);
        }
    });
    const createPlace = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, capacity: capacity, customerId: customerId } = values;
        const dto = {
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            customerId: customerId,
            capacity: Number.parseInt(capacity)
        };
        createPlaceMutation.mutate(dto);
    };
    const cancel = ()=>{
        createPlaceMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.places.modalAddPlace.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.places.modalAddPlace.button.add"
            }),
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                    mutation: createPlaceMutation,
                    errorTitleKey: "common.actions.add.error"
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b3dd93895be367f7$export$2e2bcd8739ae039), {
                    onSubmit: (values)=>createPlace(values),
                    formReference: FORM_REFERENCE,
                    customers: customers
                })
            ]
        })
    });
};
var $5617db4b69b86dd9$export$2e2bcd8739ae039 = $5617db4b69b86dd9$var$ModalAddPlace;








const $bc1972822b94da20$var$Places = ()=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const { setCustomer: setCustomer, customer: customer, setPlace: setPlace } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const [showModalAdd, setShowModalAdd] = (0, $2hDQc.useState)(false);
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $cafa508c3f794a0e$export$2e2bcd8739ae039)({
        key: (0, $7bfb91130cd4d35d$export$fc22b6fdc7ebba93),
        initialValue: (0, $ae63e01d7dc24727$export$4bec99d256114e49)("NAME")
    });
    const queryPlaces = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$d6da98a467d609dc),
            pagingAndSortValues.page,
            pagingAndSortValues.sort
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $ae63e01d7dc24727$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $a37004fca245d806$export$17a026f5eed4231).getPlaces({
                page: page,
                limit: limit,
                sort: sort,
                direction: direction
            });
        },
        enabled: !!customer?.id,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const places = queryPlaces.data?.data || [];
    const pagination = queryPlaces.data?.pageable ? {
        page: queryPlaces.data.pageable.page,
        total: queryPlaces.data.pageable.total,
        limit: queryPlaces.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const items = (0, $5dcd3ee6df434ce0$export$88b06990067e1fdb)(intl, "PLACES");
    const onClickRow = (place)=>{
        setPlace(place);
        setCustomer(place.customer);
        navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${place.id}`);
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                loading: queryPlaces.isPending,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.places.list.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        action: "CREATE",
                        resource: "PLACES",
                        button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                            onClick: ()=>setShowModalAdd(true),
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.places.list.button.newPlace"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsxs)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b69e7f737512ce9e$export$2e2bcd8739ae039), {
                                filterKey: (0, $7bfb91130cd4d35d$export$a9c7fdd2cd34e65d),
                                items: items,
                                value: pagingAndSortValues.sort,
                                onChange: (value)=>{
                                    pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        sort: value,
                                        direction: (0, $5dcd3ee6df434ce0$export$fcce7887255d1c69)(value)
                                    });
                                },
                                pt: 2,
                                pb: 2
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                                emptyTextId: "page.places.list.table.action.empty",
                                errorTextId: "page.places.list.table.action.failed",
                                query: queryPlaces,
                                pagination: pagination,
                                children: places.map((row)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                                        cardTitle: row.name,
                                        cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                            utcDateTime: row.createdAt
                                        }),
                                        cardContentList: [
                                            row.streetAddress,
                                            row.postalCode,
                                            row.city,
                                            row.customer?.name ?? ""
                                        ],
                                        onCardClicked: ()=>onClickRow(row)
                                    }, row.id))
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                                items: places,
                                emptyTextId: "page.places.list.table.action.empty",
                                errorTextId: "page.places.list.table.action.failed",
                                query: queryPlaces,
                                pagination: pagination,
                                children: [
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.name"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.streetAddress"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.postalCode"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.city"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.capacity"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.customer"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                                        "data-testid": "places-table-body",
                                        children: places.map((row)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                                onClick: ()=>onClickRow(row),
                                                hover: true,
                                                sx: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                            bold: true,
                                                            children: row.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: row.streetAddress
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: row.postalCode
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: row.city
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: row.capacity
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                        children: row.customer?.name
                                                    })
                                                ]
                                            }, row.id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5617db4b69b86dd9$export$2e2bcd8739ae039), {
                open: showModalAdd,
                onSubmit: (response)=>{
                    setShowModalAdd(false);
                    (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.places.list.actions.added",
                        values: {
                            name: response.name
                        }
                    }));
                    queryClient.invalidateQueries({
                        queryKey: [
                            (0, $1a19893cc26bc20f$export$d6da98a467d609dc)
                        ]
                    });
                },
                onCancel: ()=>setShowModalAdd(false)
            })
        ]
    });
};
var $bc1972822b94da20$export$2e2bcd8739ae039 = $bc1972822b94da20$var$Places;



var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");



var $592Nh = parcelRequire("592Nh");






const $8b1c65ee4a192948$var$ModalEditPlace = (props)=>{
    const FORM_REFERENCE = "formUpdatePlace";
    const { defaultValues: defaultValues } = props;
    const updatePlaceMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $a37004fca245d806$export$2bffccb0f948be1f).updatePlace(props.editablePlaceRef, dto),
        onSuccess: (response)=>{
            props.onSubmit(response.data);
        }
    });
    const updatePlace = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city } = values;
        // Note, capacity cannot be modify
        const dto = {
            name: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(name, defaultValues.name),
            streetAddress: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(streetAddress, defaultValues.streetAddress),
            postalCode: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(postalCode, defaultValues.postalCode),
            city: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(city, defaultValues.city)
        };
        if ((0, $ee9cb80b5c23ac97$export$8f98ff223296ded9)(dto)) updatePlaceMutation.mutate(dto);
    };
    const cancel = ()=>{
        updatePlaceMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.place.modalEditPlace.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            mutation: updatePlaceMutation,
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b3dd93895be367f7$export$2e2bcd8739ae039), {
                showTitle: true,
                onSubmit: (values)=>{
                    updatePlace(values);
                },
                formReference: FORM_REFERENCE,
                defaultValues: defaultValues,
                editView: true,
                customers: []
            })
        })
    });
};
var $8b1c65ee4a192948$export$2e2bcd8739ae039 = $8b1c65ee4a192948$var$ModalEditPlace;




var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");

var $fe57e258b44028e4$exports = {};
"use strict";
"use client";

Object.defineProperty($fe57e258b44028e4$exports, "__esModule", {
    value: true
});
$fe57e258b44028e4$exports.default = void 0;

var $fe57e258b44028e4$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $fe57e258b44028e4$var$_default = $fe57e258b44028e4$exports.default = (0, $fe57e258b44028e4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M20 12c0-.76.43-1.42 1.06-1.76.6-.33.94-1.01.94-1.7V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.89-1.99 1.99v2.55c0 .69.33 1.37.94 1.69C3.58 10.58 4 11.24 4 12s-.43 1.43-1.06 1.76c-.6.33-.94 1.01-.94 1.7V18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2.54c0-.69-.34-1.37-.94-1.7-.63-.34-1.06-1-1.06-1.76m-5.5 4.1L12 14.5l-2.5 1.61c-.38.24-.87-.11-.75-.55l.75-2.88-2.3-1.88c-.35-.29-.17-.86.29-.89l2.96-.17 1.08-2.75c.17-.42.77-.42.93 0l1.08 2.76 2.96.17c.45.03.64.6.29.89l-2.3 1.88.76 2.86c.12.45-.37.8-.75.55"
}), "LocalActivityRounded");



var $592Nh = parcelRequire("592Nh");





var $5pzCu = parcelRequire("5pzCu");



parcelRequire("2hDQc");
const $4510b293fcbc0a42$var$ModalEditOffering = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, offering: offering })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const FORM_REFERENCE = "formEditOffering";
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const mutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $0b5c38c6bf15e48a$export$ca807e2054383e2d).updateOffering(offering?.id ?? "", offering?.placeId ?? "", dto),
        onSuccess: ()=>{
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.offering.modalEditOffering.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
                    offering?.placeId
                ]
            });
        }
    });
    const schema = $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
        amount: $7a5dda49dca6ae9d$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalEditOffering.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    });
    const submitHandler = (values)=>{
        if (values?.amount) return mutation.mutate({
            amount: Number.parseInt(values.amount)
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "page.offering.modalEditOffering.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        formReference: FORM_REFERENCE,
        mutation: mutation,
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                amount: offering?.amount ? "" + offering.amount : ""
            },
            validationSchema: schema,
            onSubmit: (values)=>submitHandler(values),
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.product"
                                })
                            }),
                            offering?.name,
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.amountLabel"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                name: "amount",
                                value: values.amount,
                                onChange: handleChange,
                                error: !!errors.amount,
                                errorText: errors.amount,
                                sx: {
                                    minWidth: "50%"
                                }
                            })
                        ]
                    })
                })
        })
    });
};
var $4510b293fcbc0a42$export$2e2bcd8739ae039 = $4510b293fcbc0a42$var$ModalEditOffering;



var $1a1ad1758f03b18c$exports = {};
"use strict";
"use client";

Object.defineProperty($1a1ad1758f03b18c$exports, "__esModule", {
    value: true
});
$1a1ad1758f03b18c$exports.default = void 0;

var $1a1ad1758f03b18c$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $1a1ad1758f03b18c$var$_default = $1a1ad1758f03b18c$exports.default = (0, $1a1ad1758f03b18c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M22 14c0-1.95-1.4-3.57-3.25-3.92L17.4 6.05C17 4.82 15.85 4 14.56 4H9.44C8.15 4 7 4.82 6.6 6.05L5.81 8.4 4.41 7l.29-.29c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0l-2 2c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l.3-.3 1.79 1.79C3.18 10.72 2 12.22 2 14c0 1.5.83 2.79 2.05 3.48C4.28 18.9 5.51 20 7 20c1.3 0 2.4-.84 2.82-2h4.37c.41 1.16 1.51 2 2.82 2 1.49 0 2.72-1.1 2.95-2.52C21.17 16.79 22 15.5 22 14M7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m4-8H7.41l-.02-.02 1.1-3.3c.14-.41.52-.68.95-.68H11zm2-4h1.56c.43 0 .81.27.95.68l1.1 3.32H13zm4 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), "ToysRounded");





const $9bb79ad2462ac4e5$var$OfferingsTab = ({ placeId: placeId, queryOfferings: queryOfferings })=>{
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const [showOfferingModal, setShowOfferingModal] = (0, $2hDQc.useState)(undefined);
    const offerings = queryOfferings.data || [];
    const onClickRow = (item)=>{
        navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).OFFERINGS}/${item.id}`);
    };
    const refreshData = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
                placeId
            ]
        });
    };
    const isWhitelist = (offering)=>{
        return offering.type === "WHITELIST";
    };
    const isEditable = (offering)=>{
        return isPermission("EDIT", "OFFERING") && !isWhitelist(offering) && !offering.ignoreAmountForCatalogue;
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryOfferings,
        rootPageIfNotFoundError: true,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                    description: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "page.place.offeringsTab.infoText1"
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                            emptyTextId: "page.place.offeringsTab.table.empty",
                            errorTextId: "page.place.offeringsTab.table.error",
                            query: queryOfferings,
                            children: offerings.map((offering)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                                    onCardClicked: ()=>onClickRow(offering),
                                    cardTitle: offering.name ?? "",
                                    cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                        utcDateTime: offering.createdAt,
                                        dateOnly: true
                                    }),
                                    cardMenuActions: isEditable(offering) ? [
                                        {
                                            itemText: intl.formatMessage({
                                                id: "page.place.offeringsTab.table.offering.edit"
                                            }),
                                            onClick: ()=>setShowOfferingModal(offering)
                                        }
                                    ] : undefined,
                                    cardContentList: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $ac59c0458c13eb62$export$4421fe64f84f2e51), {
                                            offering: offering
                                        })
                                    ]
                                }, offering.id))
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                            items: offerings,
                            emptyTextId: "page.place.offeringsTab.table.empty",
                            errorTextId: "page.place.offeringsTab.table.error",
                            query: queryOfferings,
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.place.offeringsTab.table.product"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.place.offeringsTab.table.overview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.place.offeringsTab.table.timestamps"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                                    children: offerings.map((offering)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                                            onClick: ()=>onClickRow(offering),
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: [
                                                            isWhitelist(offering) ? /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1a1ad1758f03b18c$exports))), {
                                                                style: {
                                                                    marginRight: "1rem"
                                                                }
                                                            }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fe57e258b44028e4$exports))), {
                                                                style: {
                                                                    marginRight: "1rem"
                                                                }
                                                            }),
                                                            offering.name
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $ac59c0458c13eb62$export$4421fe64f84f2e51), {
                                                        offering: offering
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $ea52dc2553d5098f$export$2e2bcd8739ae039), {
                                                        createdAt: offering.createdAt,
                                                        updatedAt: offering.updatedAt,
                                                        dateOnly: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                                    align: "right",
                                                    children: isEditable(offering) && /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                                        onClick: (evt)=>{
                                                            evt.stopPropagation();
                                                            setShowOfferingModal(offering);
                                                        },
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                            id: "page.place.offeringsTab.table.offering.edit"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, offering.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $4510b293fcbc0a42$export$2e2bcd8739ae039), {
                            open: !!showOfferingModal,
                            onCancel: ()=>setShowOfferingModal(undefined),
                            onSubmit: ()=>{
                                setShowOfferingModal(undefined);
                                refreshData();
                            },
                            offering: showOfferingModal
                        })
                    ]
                })
            ]
        })
    });
};
var $9bb79ad2462ac4e5$export$2e2bcd8739ae039 = $9bb79ad2462ac4e5$var$OfferingsTab;



var $592Nh = parcelRequire("592Nh");




const $82a00302c38c2a26$var$PlaceInformation = ({ loading: loading, place: place, offeringAmount: offeringAmount, onEdit: onEdit })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const data = [
        {
            label: intl.formatMessage({
                id: "page.placeRights.placeInformation.address"
            }),
            value: `${(0, $ee9cb80b5c23ac97$export$ff20516246215bf)(place?.streetAddress, place?.postalCode, ", ")} ${place?.city}`
        },
        {
            label: intl.formatMessage({
                id: "page.placeRights.placeInformation.capacity"
            }),
            value: place?.capacity
        },
        {
            label: intl.formatMessage({
                id: "page.placeRights.placeInformation.offeringAmount"
            }),
            value: (0, $ee9cb80b5c23ac97$export$ec9646ddc27ee461)(place?.capacity || 0, offeringAmount)
        }
    ];
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.placeRights.placeInformation.header"
                }),
                button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                    action: "EDIT",
                    resource: "PLACES",
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                        startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac0e6f973d0bafe8$exports))), {}),
                        onClick: onEdit,
                        showAsIconButton: true,
                        "aria-label": intl.formatMessage({
                            id: "page.placeRights.placeInformation.button.edit"
                        })
                    })
                }),
                divider: true
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                    data: data
                })
            })
        ]
    });
};
var $82a00302c38c2a26$export$2e2bcd8739ae039 = $82a00302c38c2a26$var$PlaceInformation;





var $592Nh = parcelRequire("592Nh");




const $21a24180448a2f2a$var$SituationOverview = ({ parkingEnforcement: parkingEnforcement, isLoading: isLoading, cataloguesTotal: cataloguesTotal, capacity: capacity })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const data = [
        {
            label: intl.formatMessage({
                id: "page.placeRights.situationOverview.totalAmount"
            }),
            value: capacity && cataloguesTotal && (0, $ee9cb80b5c23ac97$export$ec9646ddc27ee461)(capacity, cataloguesTotal)
        },
        {
            label: intl.formatMessage({
                id: "page.placeRights.situationOverview.parkingEnforcement"
            }),
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $52a02ab158cbbbf2$export$2e2bcd8739ae039), {
                parkingEnforcement: parkingEnforcement
            })
        }
    ];
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
        loading: isLoading,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.placeRights.situationOverview.header"
                }),
                button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                    startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac0e6f973d0bafe8$exports))), {}),
                    showAsIconButton: true,
                    "aria-label": "",
                    hidden: true
                }),
                divider: true
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                    splitByMiddle: true,
                    data: data,
                    breakpoint: "lg"
                })
            })
        ]
    });
};
var $21a24180448a2f2a$export$2e2bcd8739ae039 = $21a24180448a2f2a$var$SituationOverview;




const $fd7de2136a4de36c$var$Place = ()=>{
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { placeRef: placeRef } = (0, $86f6846c59d1b386$export$99eaa27ddbbb95ef)();
    const { place: place, setPlace: setPlace } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const [showPlaceModal, setShowPlaceModal] = (0, $2hDQc.useState)(false);
    const queryPlace = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$823cd27a3f5f229e),
            placeRef
        ],
        queryFn: ()=>(0, $a37004fca245d806$export$2bffccb0f948be1f).getPlaceByRef(placeRef || ""),
        enabled: !!placeRef,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const queryOfferings = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
            placeRef
        ],
        queryFn: ()=>(0, $a37004fca245d806$export$2bffccb0f948be1f).getOfferingsByPlace(placeRef || ""),
        enabled: !!placeRef,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const defaultPlaceData = {
        name: queryPlace.data?.name || "",
        streetAddress: queryPlace.data?.streetAddress || "",
        postalCode: queryPlace.data?.postalCode || "",
        city: queryPlace.data?.city || "",
        capacity: queryPlace.data?.capacity?.toString() || "",
        customerId: queryPlace.data?.customer?.id || ""
    };
    const isParkingEnforcement = !!queryPlace.data?.parkingEnforcementZoneId;
    const normalOfferings = queryOfferings.data ? queryOfferings.data.filter((item)=>item.type !== "WHITELIST") : [];
    const cataloguesTotal = normalOfferings?.map((item)=>item.summary.cataloguesTotalAmount).reduce((accumulator, current)=>accumulator + current, 0);
    const offeringsTotal = normalOfferings.reduce((accumulator, offering)=>accumulator + offering.amount, 0);
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryPlace,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsx)("h1", {
                children: place?.name
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: queryPlace.error || queryOfferings.error ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                            errorTitleKey: "common.actions.get.error",
                            query: queryPlace.isError ? queryPlace : queryOfferings
                        }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $82a00302c38c2a26$export$2e2bcd8739ae039), {
                            loading: queryPlace.isPending || queryOfferings.isPending,
                            place: queryPlace.data,
                            offeringAmount: offeringsTotal,
                            onEdit: ()=>setShowPlaceModal(true)
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                                errorTitleKey: "common.actions.get.error",
                                query: queryPlace
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $21a24180448a2f2a$export$2e2bcd8739ae039), {
                                parkingEnforcement: isParkingEnforcement,
                                isLoading: queryPlace.isPending,
                                capacity: queryPlace.data?.capacity,
                                cataloguesTotal: cataloguesTotal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $74f5dfbf7740a204$export$2e2bcd8739ae039), {
                                    tabKey: (0, $7bfb91130cd4d35d$export$bf153b52ae22c83c),
                                    tabHeaders: [
                                        intl.formatMessage({
                                            id: "page.place.offeringsTab.header"
                                        })
                                    ],
                                    tabPanels: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $9bb79ad2462ac4e5$export$2e2bcd8739ae039), {
                                            queryOfferings: queryOfferings,
                                            placeId: placeRef || ""
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $8b1c65ee4a192948$export$2e2bcd8739ae039), {
                        open: showPlaceModal,
                        editablePlaceRef: placeRef || "",
                        defaultValues: defaultPlaceData,
                        onSubmit: (response)=>{
                            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                id: "page.place.actions.updated",
                                values: {
                                    name: response?.name
                                }
                            }));
                            setShowPlaceModal(false);
                            response && response.id === place.id && setPlace(response);
                            queryClient.invalidateQueries({
                                queryKey: [
                                    (0, $1a19893cc26bc20f$export$823cd27a3f5f229e),
                                    placeRef
                                ]
                            });
                            queryClient.invalidateQueries({
                                queryKey: [
                                    (0, $1a19893cc26bc20f$export$d6da98a467d609dc)
                                ]
                            });
                        },
                        onCancel: ()=>setShowPlaceModal(false)
                    })
                ]
            })
        ]
    });
};
var $fd7de2136a4de36c$export$2e2bcd8739ae039 = $fd7de2136a4de36c$var$Place;



var $592Nh = parcelRequire("592Nh");






var $2hDQc = parcelRequire("2hDQc");





var $2hDQc = parcelRequire("2hDQc");



var $afHYP = parcelRequire("afHYP");



var $2hDQc = parcelRequire("2hDQc");

var $bZSVP = parcelRequire("bZSVP");







const $b353ade247ebb76a$export$b0d0c72cc357b4dd = (sections)=>{
    const startDateSections = [];
    const endDateSections = [];
    sections.forEach((section)=>{
        if (section.dateName === "start") startDateSections.push(section);
        else endDateSections.push(section);
    });
    return {
        startDate: startDateSections,
        endDate: endDateSections
    };
};
const $b353ade247ebb76a$export$927f12730cacf7f9 = (dateSections)=>dateSections.map((section, sectionIndex)=>{
        if (sectionIndex === dateSections.length - 1) return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, section, {
            separator: null
        });
        return section;
    });


const $bc86ae5cc45374b5$var$_excluded = [
    "value",
    "referenceDate"
];
const $bc86ae5cc45374b5$export$f0e1e223b0d1e9e1 = {
    emptyValue: [
        null,
        null
    ],
    getTodayValue: (utils, timezone, valueType)=>[
            (0, $6008d551a5f07604$export$1118e4272ea1e258)(utils, timezone, valueType),
            (0, $6008d551a5f07604$export$1118e4272ea1e258)(utils, timezone, valueType)
        ],
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDateProp } = _ref, params = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $bc86ae5cc45374b5$var$_excluded);
        const shouldKeepStartDate = value[0] != null && params.utils.isValid(value[0]);
        const shouldKeepEndDate = value[1] != null && params.utils.isValid(value[1]);
        if (shouldKeepStartDate && shouldKeepEndDate) return value;
        const referenceDate = referenceDateProp ?? (0, $bfb695e56b2e7def$export$6a31d56794238e4e)(params);
        return [
            shouldKeepStartDate ? value[0] : referenceDate,
            shouldKeepEndDate ? value[1] : referenceDate
        ];
    },
    cleanValue: (utils, value)=>value.map((date)=>(0, $6008d551a5f07604$export$36ca889e039badd5)(utils, date)),
    areValuesEqual: (utils, a, b)=>(0, $6008d551a5f07604$export$8fabf9a4cbada414)(utils, a[0], b[0]) && (0, $6008d551a5f07604$export$8fabf9a4cbada414)(utils, a[1], b[1]),
    isSameError: (a, b)=>b !== null && a[1] === b[1] && a[0] === b[0],
    hasError: (error)=>error[0] != null || error[1] != null,
    defaultErrorState: [
        null,
        null
    ],
    getTimezone: (utils, value)=>{
        const timezoneStart = value[0] == null || !utils.isValid(value[0]) ? null : utils.getTimezone(value[0]);
        const timezoneEnd = value[1] == null || !utils.isValid(value[1]) ? null : utils.getTimezone(value[1]);
        if (timezoneStart != null && timezoneEnd != null && timezoneStart !== timezoneEnd) throw new Error("MUI X: The timezone of the start and the end date should be the same.");
        return timezoneStart ?? timezoneEnd;
    },
    setTimezone: (utils, timezone, value)=>[
            value[0] == null ? null : utils.setTimezone(value[0], timezone),
            value[1] == null ? null : utils.setTimezone(value[1], timezone)
        ]
};
const $bc86ae5cc45374b5$export$f11c2373fda8386 = ({ dateSeparator: dateSeparator = "\u2013" })=>({
        updateReferenceValue: (utils, value, prevReferenceValue)=>{
            const shouldKeepStartDate = value[0] != null && utils.isValid(value[0]);
            const shouldKeepEndDate = value[1] != null && utils.isValid(value[1]);
            if (!shouldKeepStartDate && !shouldKeepEndDate) return prevReferenceValue;
            if (shouldKeepStartDate && shouldKeepEndDate) return value;
            if (shouldKeepStartDate) return [
                value[0],
                prevReferenceValue[0]
            ];
            return [
                prevReferenceValue[1],
                value[1]
            ];
        },
        getSectionsFromValue: (utils, [start, end], fallbackSections, getSectionsFromDate)=>{
            const separatedFallbackSections = fallbackSections == null ? {
                startDate: null,
                endDate: null
            } : (0, $b353ade247ebb76a$export$b0d0c72cc357b4dd)(fallbackSections);
            const getSections = (newDate, fallbackDateSections, position)=>{
                const shouldReUsePrevDateSections = !utils.isValid(newDate) && !!fallbackDateSections;
                if (shouldReUsePrevDateSections) return fallbackDateSections;
                const sections = getSectionsFromDate(newDate);
                return sections.map((section, sectionIndex)=>{
                    if (sectionIndex === sections.length - 1 && position === "start") return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, section, {
                        dateName: position,
                        // TODO: Check if RTL still works
                        endSeparator: `${section.endSeparator} ${dateSeparator} `
                    });
                    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, section, {
                        dateName: position
                    });
                });
            };
            return [
                ...getSections(start, separatedFallbackSections.startDate, "start"),
                ...getSections(end, separatedFallbackSections.endDate, "end")
            ];
        },
        getV7HiddenInputValueFromSections: (sections)=>{
            const dateRangeSections = (0, $b353ade247ebb76a$export$b0d0c72cc357b4dd)(sections);
            return (0, $f98be61bc28ae2a3$export$9e6af343db7dd2)([
                ...dateRangeSections.startDate,
                ...dateRangeSections.endDate
            ]);
        },
        getV6InputValueFromSections: (sections, localizedDigits, isRtl)=>{
            const dateRangeSections = (0, $b353ade247ebb76a$export$b0d0c72cc357b4dd)(sections);
            return (0, $f98be61bc28ae2a3$export$7ffdf006c6dc825f)([
                ...dateRangeSections.startDate,
                ...dateRangeSections.endDate
            ], localizedDigits, isRtl);
        },
        parseValueStr: (valueStr, referenceValue, parseDate)=>{
            // TODO: Improve because it would not work if some section have the same separator as the dateSeparator.
            const [startStr, endStr] = valueStr.split(dateSeparator);
            return [
                startStr,
                endStr
            ].map((dateStr, index)=>{
                if (dateStr == null) return null;
                return parseDate(dateStr.trim(), referenceValue[index]);
            });
        },
        getActiveDateManager: (utils, state, activeSection)=>{
            const index = activeSection.dateName === "start" ? 0 : 1;
            const updateDateInRange = (newDate, prevDateRange)=>index === 0 ? [
                    newDate,
                    prevDateRange[1]
                ] : [
                    prevDateRange[0],
                    newDate
                ];
            return {
                date: state.value[index],
                referenceDate: state.referenceValue[index],
                getSections: (sections)=>{
                    const dateRangeSections = (0, $b353ade247ebb76a$export$b0d0c72cc357b4dd)(sections);
                    if (index === 0) return (0, $b353ade247ebb76a$export$927f12730cacf7f9)(dateRangeSections.startDate);
                    return dateRangeSections.endDate;
                },
                getNewValuesFromNewActiveDate: (newActiveDate)=>({
                        value: updateDateInRange(newActiveDate, state.value),
                        referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : updateDateInRange(newActiveDate, state.referenceValue)
                    })
            };
        }
    });




var $2hDQc = parcelRequire("2hDQc");

var $afHYP = parcelRequire("afHYP");




var $2hDQc = parcelRequire("2hDQc");




var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




function $159c217072f91886$export$eafce1c932fd58de(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDateRangePickerToolbar", slot);
}
const $159c217072f91886$export$657d09388937f683 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDateRangePickerToolbar", [
    "root",
    "container"
]);



var $592Nh = parcelRequire("592Nh");
"use client";
const $3547aafc4cc581d5$var$_excluded = [
    "value",
    "rangePosition",
    "onRangePositionChange",
    "toolbarFormat",
    "className",
    "onViewChange",
    "view",
    "views"
];
const $3547aafc4cc581d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $159c217072f91886$export$eafce1c932fd58de), classes);
};
const $3547aafc4cc581d5$var$DateRangePickerToolbarRoot = (0, $fhlQp.default)((0, $ba48f243f78bafeb$export$eb3c4d84783d6feb), {
    name: "MuiDateRangePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $3547aafc4cc581d5$var$DateRangePickerToolbarContainer = (0, $fhlQp.default)("div", {
    name: "MuiDateRangePickerToolbar",
    slot: "Container",
    overridesResolver: (_, styles)=>styles.container
})({
    display: "flex"
});
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateRangePickerToolbar API](https://mui.com/x/api/date-pickers/date-range-picker-toolbar/)
 */ const $3547aafc4cc581d5$export$a6a90c1fe2022b58 = /*#__PURE__*/ $2hDQc.forwardRef(function DateRangePickerToolbar(inProps, ref) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateRangePickerToolbar"
    });
    const { value: [start, end], rangePosition: rangePosition, onRangePositionChange: onRangePositionChange, toolbarFormat: toolbarFormat, className: className } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $3547aafc4cc581d5$var$_excluded);
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const startDateValue = start ? utils.formatByString(start, toolbarFormat || utils.formats.shortDate) : translations.start;
    const endDateValue = end ? utils.formatByString(end, toolbarFormat || utils.formats.shortDate) : translations.end;
    const ownerState = props;
    const classes = $3547aafc4cc581d5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($3547aafc4cc581d5$var$DateRangePickerToolbarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
        toolbarTitle: translations.dateRangePickerToolbarTitle,
        isLandscape: false,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)($3547aafc4cc581d5$var$DateRangePickerToolbarContainer, {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                    variant: start !== null ? "h5" : "h6",
                    value: startDateValue,
                    selected: rangePosition === "start",
                    onClick: ()=>onRangePositionChange("start")
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
                    variant: "h5",
                    children: [
                        "\xa0",
                        "\u2013",
                        "\xa0"
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $06f07a8e6d52aac6$export$614ed940168c780c), {
                    variant: end !== null ? "h5" : "h6",
                    value: endDateValue,
                    selected: rangePosition === "end",
                    onClick: ()=>onRangePositionChange("end")
                })
            ]
        })
    }));
});


function $9acee118f13df4cd$export$b30bf963bdbf4d5b(props, name) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const themeProps = (0, $afHYP.default)({
        props: props,
        name: name
    });
    const localeText = $2hDQc.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            dateRangePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps, {
        localeText: localeText,
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            toolbar: (0, $3547aafc4cc581d5$export$a6a90c1fe2022b58)
        }, themeProps.slots)
    });
}


parcelRequire("2hDQc");



var $2hDQc = parcelRequire("2hDQc");







var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");


parcelRequire("2hDQc");


var $2hDQc = parcelRequire("2hDQc");
/* eslint-disable */ const $f338da39033cf483$var$_keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $f338da39033cf483$var$utf8Encode(str) {
    for(let n = 0; n < str.length; n++){
        const c = str.charCodeAt(n);
        if (c >= 128) throw new Error("ASCII only support");
    }
    return str;
}
const $f338da39033cf483$export$c62426fdd000a97e = (input)=>{
    let output = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while(i < input.length){
        enc1 = $f338da39033cf483$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $f338da39033cf483$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $f338da39033cf483$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $f338da39033cf483$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) output = output + String.fromCharCode(chr2);
        if (enc4 != 64) output = output + String.fromCharCode(chr3);
    }
    return output;
};
const $f338da39033cf483$export$e510a73ee562749 = (input)=>{
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = $f338da39033cf483$var$utf8Encode(input);
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output = output + $f338da39033cf483$var$_keyStr.charAt(enc1) + $f338da39033cf483$var$_keyStr.charAt(enc2) + $f338da39033cf483$var$_keyStr.charAt(enc3) + $f338da39033cf483$var$_keyStr.charAt(enc4);
    }
    return output;
};


/* eslint-disable */ // See "precomputation" in notes
const $6b0323064e610ce9$var$k = [];
let $6b0323064e610ce9$var$i = 0;
for(; $6b0323064e610ce9$var$i < 64;)$6b0323064e610ce9$var$k[$6b0323064e610ce9$var$i] = 0 | Math.sin(++$6b0323064e610ce9$var$i % Math.PI) * 4294967296;
function $6b0323064e610ce9$export$a58ec6a60c09ca72(s) {
    const words = [];
    let b, c, d, j = unescape(encodeURI(s)) + "\x80", a = j.length;
    const h = [
        b = 0x67452301,
        c = 0xefcdab89,
        ~b,
        ~c
    ];
    s = --a / 4 + 2 | 15;
    // See "Length bits" in notes
    words[--s] = a * 8;
    for(; ~a;)// a !== -1
    words[a >> 2] |= j.charCodeAt(a) << 8 * a--;
    for($6b0323064e610ce9$var$i = j = 0; $6b0323064e610ce9$var$i < s; $6b0323064e610ce9$var$i += 16){
        a = h;
        for(; j < 64; a = [
            d = a[3],
            b + ((d = a[0] + [
                b & c | ~b & d,
                d & b | ~d & c,
                b ^ c ^ d,
                c ^ (b | ~d)
            ][a = j >> 4] + $6b0323064e610ce9$var$k[j] + ~~words[$6b0323064e610ce9$var$i | [
                j,
                5 * j + 1,
                3 * j + 5,
                7 * j
            ][a] & 15]) << (a = [
                7,
                12,
                17,
                22,
                5,
                9,
                14,
                20,
                4,
                11,
                16,
                23,
                6,
                10,
                15,
                21
            ][4 * a + j++ % 4]) | d >>> -a),
            b,
            c
        ]){
            b = a[1] | 0;
            c = a[2];
        }
        // See "Integer safety" in notes
        for(j = 4; j;)h[--j] += a[j];
    // j === 0
    }
    for(s = ""; j < 32;)s += (h[j >> 3] >> (1 ^ j++) * 4 & 15).toString(16);
    return s;
}


// eslint-disable-next-line @typescript-eslint/naming-convention
let $b885a1129bb82225$export$4d5a447ae2d3c7bc = /*#__PURE__*/ function(LICENSE_STATUS) {
    LICENSE_STATUS["NotFound"] = "NotFound";
    LICENSE_STATUS["Invalid"] = "Invalid";
    LICENSE_STATUS["ExpiredAnnual"] = "ExpiredAnnual";
    LICENSE_STATUS["ExpiredAnnualGrace"] = "ExpiredAnnualGrace";
    LICENSE_STATUS["ExpiredVersion"] = "ExpiredVersion";
    LICENSE_STATUS["Valid"] = "Valid";
    LICENSE_STATUS["OutOfScope"] = "OutOfScope";
    LICENSE_STATUS["NotAvailableInInitialProPlan"] = "NotAvailableInInitialProPlan";
    return LICENSE_STATUS;
}({});


const $959ed52fc5d0a748$export$6fffcc874c4891f0 = [
    "pro",
    "premium"
];
const $959ed52fc5d0a748$export$1632eb3abf3dacd4 = [
    "initial",
    "Q3-2024"
];


const $9551d7891858539e$export$dde05de07b040648 = [
    /**
 * A license is outdated if the current version of the software was released after the expiry date of the license.
 * But the license can be used indefinitely with an older version of the software.
 */ "perpetual",
    /**
 * On development, a license is outdated if the expiry date has been reached
 * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
 */ "annual",
    /**
 * Legacy. The previous name for 'annual'.
 * Can be removed once old license keys generated with 'subscription' are no longer supported.
 * To support for a while. We need more years of backward support and we sell multi year licenses.
 */ "subscription"
];


const $b33df5ed43b2c496$var$getDefaultReleaseDate = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
function $b33df5ed43b2c496$export$4c9b7f7dacd07671(releaseDate = $b33df5ed43b2c496$var$getDefaultReleaseDate()) {
    return (0, $f338da39033cf483$export$e510a73ee562749)(releaseDate.getTime().toString());
}
function $b33df5ed43b2c496$var$isPlanScopeSufficient(packageName, planScope) {
    let acceptedScopes;
    if (packageName.includes("-pro")) acceptedScopes = [
        "pro",
        "premium"
    ];
    else if (packageName.includes("-premium")) acceptedScopes = [
        "premium"
    ];
    else acceptedScopes = [];
    return acceptedScopes.includes(planScope);
}
const $b33df5ed43b2c496$var$expiryReg = /^.*EXPIRY=([0-9]+),.*$/;
const $b33df5ed43b2c496$var$PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN = [
    "x-data-grid-pro",
    "x-date-pickers-pro"
];
/**
 * Format: ORDER:${orderNumber},EXPIRY=${expiryTimestamp},KEYVERSION=1
 */ const $b33df5ed43b2c496$var$decodeLicenseVersion1 = (license)=>{
    let expiryTimestamp;
    try {
        expiryTimestamp = parseInt(license.match($b33df5ed43b2c496$var$expiryReg)[1], 10);
        if (!expiryTimestamp || Number.isNaN(expiryTimestamp)) expiryTimestamp = null;
    } catch (err) {
        expiryTimestamp = null;
    }
    return {
        planScope: "pro",
        licenseModel: "perpetual",
        expiryTimestamp: expiryTimestamp,
        planVersion: "initial"
    };
};
/**
 * Format: O=${orderNumber},E=${expiryTimestamp},S=${planScope},LM=${licenseModel},PV=${planVersion},KV=2`;
 */ const $b33df5ed43b2c496$var$decodeLicenseVersion2 = (license)=>{
    const licenseInfo = {
        planScope: null,
        licenseModel: null,
        expiryTimestamp: null,
        planVersion: "initial"
    };
    license.split(",").map((token)=>token.split("=")).filter((el)=>el.length === 2).forEach(([key, value])=>{
        if (key === "S") licenseInfo.planScope = value;
        if (key === "LM") licenseInfo.licenseModel = value;
        if (key === "E") {
            const expiryTimestamp = parseInt(value, 10);
            if (expiryTimestamp && !Number.isNaN(expiryTimestamp)) licenseInfo.expiryTimestamp = expiryTimestamp;
        }
        if (key === "PV") licenseInfo.planVersion = value;
    });
    return licenseInfo;
};
/**
 * Decode the license based on its key version and return a version-agnostic `MuiLicense` object.
 */ const $b33df5ed43b2c496$var$decodeLicense = (encodedLicense)=>{
    const license = (0, $f338da39033cf483$export$c62426fdd000a97e)(encodedLicense);
    if (license.includes("KEYVERSION=1")) return $b33df5ed43b2c496$var$decodeLicenseVersion1(license);
    if (license.includes("KV=2")) return $b33df5ed43b2c496$var$decodeLicenseVersion2(license);
    return null;
};
function $b33df5ed43b2c496$export$65cf4e2e0f5c4c60({ releaseInfo: releaseInfo, licenseKey: licenseKey, packageName: packageName }) {
    if (!releaseInfo) throw new Error("MUI X: The release information is missing. Not able to validate license.");
    if (!licenseKey) return {
        status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).NotFound
    };
    const hash = licenseKey.substr(0, 32);
    const encoded = licenseKey.substr(32);
    if (hash !== (0, $6b0323064e610ce9$export$a58ec6a60c09ca72)(encoded)) return {
        status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid
    };
    const license = $b33df5ed43b2c496$var$decodeLicense(encoded);
    if (license == null) {
        console.error("MUI X: Error checking license. Key version not found!");
        return {
            status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.licenseModel == null || !(0, $9551d7891858539e$export$dde05de07b040648).includes(license.licenseModel)) {
        console.error("MUI X: Error checking license. Licensing model not found or invalid!");
        return {
            status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.expiryTimestamp == null) {
        console.error("MUI X: Error checking license. Expiry timestamp not found or invalid!");
        return {
            status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    license.licenseModel;
    {
        const pkgTimestamp = parseInt((0, $f338da39033cf483$export$c62426fdd000a97e)(releaseInfo), 10);
        if (Number.isNaN(pkgTimestamp)) throw new Error("MUI X: The release information is invalid. Not able to validate license.");
        if (license.expiryTimestamp < pkgTimestamp) return {
            status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredVersion
        };
    }
    if (license.planScope == null || !(0, $959ed52fc5d0a748$export$6fffcc874c4891f0).includes(license.planScope)) {
        console.error("MUI X: Error checking license. planScope not found or invalid!");
        return {
            status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (!$b33df5ed43b2c496$var$isPlanScopeSufficient(packageName, license.planScope)) return {
        status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).OutOfScope
    };
    // 'charts-pro' or 'tree-view-pro' can only be used with a newer Pro license
    if (license.planVersion === "initial" && license.planScope === "pro" && !$b33df5ed43b2c496$var$PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN.includes(packageName)) return {
        status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan
    };
    return {
        status: (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Valid
    };
}


/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $8626aaaca67d5d96$export$2e2bcd8739ae039 = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();


/**
 * @ignore - do not document.
 */ // Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
(0, $8626aaaca67d5d96$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ = (0, $8626aaaca67d5d96$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ || {
    key: undefined
};
class $37ce39b7ffc76760$export$2c56d2e2ae515eeb {
    static getLicenseInfo() {
        // eslint-disable-next-line no-underscore-dangle
        return (0, $8626aaaca67d5d96$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__;
    }
    static getLicenseKey() {
        return $37ce39b7ffc76760$export$2c56d2e2ae515eeb.getLicenseInfo().key;
    }
    static setLicenseKey(key) {
        const licenseInfo = $37ce39b7ffc76760$export$2c56d2e2ae515eeb.getLicenseInfo();
        licenseInfo.key = key;
    }
}


function $599aac072d6eccb2$var$showError(message) {
    console.error([
        "*************************************************************",
        "",
        ...message,
        "",
        "*************************************************************"
    ].join("\n"));
}
function $599aac072d6eccb2$export$e03bc902b0abb5bd() {
    $599aac072d6eccb2$var$showError([
        "MUI X: Invalid license key.",
        "",
        "Your MUI X license key format isn't valid. It could be because the license key is missing a character or has a typo.",
        "",
        "To solve the issue, you need to double check that `setLicenseKey()` is called with the right argument",
        "Please check the license key installation https://mui.com/r/x-license-key-installation."
    ]);
}
function $599aac072d6eccb2$export$d0a8365d54384f87() {
    $599aac072d6eccb2$var$showError([
        "MUI X: License key plan mismatch.",
        "",
        "Your use of MUI X is not compatible with the plan of your license key. The feature you are trying to use is not included in the plan of your license key. This happens if you try to use Data Grid Premium with a license key for the Pro plan.",
        "",
        "To solve the issue, you can upgrade your plan from Pro to Premium at https://mui.com/r/x-get-license?scope=premium.",
        "Of if you didn't intend to use Premium features, you can replace the import of `@mui/x-data-grid-premium` with `@mui/x-data-grid-pro`."
    ]);
}
function $599aac072d6eccb2$export$fa76ce5cbafe3dc5() {
    $599aac072d6eccb2$var$showError([
        "MUI X: Component not included in your license.",
        "",
        "The component you are trying to use is not included in the Pro Plan you purchased.",
        "",
        "Your license is from an old version of the Pro Plan that is only compatible with the `@mui/x-data-grid-pro` and `@mui/x-date-pickers-pro` commercial packages.",
        "",
        "To start using another Pro package, please consider reaching to our sales team to upgrade your license or visit https://mui.com/r/x-get-license to get a new license key."
    ]);
}
function $599aac072d6eccb2$export$bfbf7dff305ffa2a({ plan: plan, packageName: packageName }) {
    $599aac072d6eccb2$var$showError([
        "MUI X: Missing license key.",
        "",
        `The license key is missing. You might not be allowed to use \`${packageName}\` which is part of MUI X ${plan}.`,
        "",
        "To solve the issue, you can check the free trial conditions: https://mui.com/r/x-license-trial.",
        "If you are eligible no actions are required. If you are not eligible to the free trial, you need to purchase a license https://mui.com/r/x-get-license or stop using the software immediately."
    ]);
}
function $599aac072d6eccb2$export$242a1b9acf4255b9({ packageName: packageName }) {
    $599aac072d6eccb2$var$showError([
        "MUI X: Expired package version.",
        "",
        `You have installed a version of \`${packageName}\` that is outside of the maintenance plan of your license key. By default, commercial licenses provide access to new versions released during the first year after the purchase.`,
        "",
        "To solve the issue, you can renew your license https://mui.com/r/x-get-license or install an older version of the npm package that is compatible with your license key."
    ]);
}
function $599aac072d6eccb2$export$1ba1f66631f7b541({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    $599aac072d6eccb2$var$showError([
        "MUI X: Expired license key.",
        "",
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        "",
        "To solve the problem you can either:",
        "",
        "- Renew your license https://mui.com/r/x-get-license and use the new key",
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        "",
        "Note that your license is perpetual in production environments with any version released before your license term ends.",
        "",
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ""
    ]);
}
function $599aac072d6eccb2$export$89cdc76bbf22084e({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    throw new Error([
        "MUI X: Expired license key.",
        "",
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        "",
        "To solve the problem you can either:",
        "",
        "- Renew your license https://mui.com/r/x-get-license and use the new key",
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        "",
        "Note that your license is perpetual in production environments with any version released before your license term ends.",
        "",
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ""
    ].join("\n"));
}




var $2hDQc = parcelRequire("2hDQc");
const $eab63d66b4a00aaf$var$MuiLicenseInfoContext = /*#__PURE__*/ $2hDQc.createContext({
    key: undefined
});
var $eab63d66b4a00aaf$export$2e2bcd8739ae039 = $eab63d66b4a00aaf$var$MuiLicenseInfoContext;


const $b9a7540f3ec89ae8$export$dc1f6c076f2a5d88 = {};
function $b9a7540f3ec89ae8$export$bd780281ba7bfd9(packageName, releaseInfo) {
    const { key: contextKey } = $2hDQc.useContext((0, $eab63d66b4a00aaf$export$2e2bcd8739ae039));
    return $2hDQc.useMemo(()=>{
        const licenseKey = contextKey ?? (0, $37ce39b7ffc76760$export$2c56d2e2ae515eeb).getLicenseKey();
        // Cache the response to not trigger the error twice.
        if ($b9a7540f3ec89ae8$export$dc1f6c076f2a5d88[packageName] && $b9a7540f3ec89ae8$export$dc1f6c076f2a5d88[packageName].key === licenseKey) return $b9a7540f3ec89ae8$export$dc1f6c076f2a5d88[packageName].licenseVerifier;
        const plan = packageName.includes("premium") ? "Premium" : "Pro";
        const licenseStatus = (0, $b33df5ed43b2c496$export$65cf4e2e0f5c4c60)({
            releaseInfo: releaseInfo,
            licenseKey: licenseKey,
            packageName: packageName
        });
        const fullPackageName = `@mui/${packageName}`;
        if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Valid) ;
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid) (0, $599aac072d6eccb2$export$e03bc902b0abb5bd)();
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan) (0, $599aac072d6eccb2$export$fa76ce5cbafe3dc5)();
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).OutOfScope) (0, $599aac072d6eccb2$export$d0a8365d54384f87)();
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).NotFound) (0, $599aac072d6eccb2$export$bfbf7dff305ffa2a)({
            plan: plan,
            packageName: fullPackageName
        });
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace) (0, $599aac072d6eccb2$export$1ba1f66631f7b541)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredAnnual) (0, $599aac072d6eccb2$export$89cdc76bbf22084e)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredVersion) (0, $599aac072d6eccb2$export$242a1b9acf4255b9)({
            packageName: fullPackageName
        });
        $b9a7540f3ec89ae8$export$dc1f6c076f2a5d88[packageName] = {
            key: licenseKey,
            licenseVerifier: licenseStatus
        };
        return licenseStatus;
    }, [
        packageName,
        releaseInfo,
        contextKey
    ]);
}




var $592Nh = parcelRequire("592Nh");
function $b3920437c8128d0a$var$getLicenseErrorMessage(licenseStatus) {
    switch(licenseStatus){
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace:
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredAnnual:
            return "MUI X Expired license key";
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).ExpiredVersion:
            return "MUI X Expired package version";
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Invalid:
            return "MUI X Invalid license key";
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).OutOfScope:
            return "MUI X License key plan mismatch";
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan:
            return "MUI X Product not covered by plan";
        case (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).NotFound:
            return "MUI X Missing license key";
        default:
            throw new Error("Unhandled MUI X license status.");
    }
}
function $b3920437c8128d0a$export$e94943a72132ebdf(props) {
    const { packageName: packageName, releaseInfo: releaseInfo } = props;
    const licenseStatus = (0, $b9a7540f3ec89ae8$export$bd780281ba7bfd9)(packageName, releaseInfo);
    if (licenseStatus.status === (0, $b885a1129bb82225$export$4d5a447ae2d3c7bc).Valid) return null;
    return /*#__PURE__*/ (0, $592Nh.jsx)("div", {
        style: {
            position: "absolute",
            pointerEvents: "none",
            color: "#8282829e",
            zIndex: 100000,
            width: "100%",
            textAlign: "center",
            bottom: "50%",
            right: 0,
            letterSpacing: 5,
            fontSize: 24
        },
        children: $b3920437c8128d0a$var$getLicenseErrorMessage(licenseStatus.status)
    });
}





const $ac05367139ef9eef$export$edcd7d0b4c3818f = ()=>{
    const releaseInfo = "MTczMDQzMzYwMDAwMA==";
    return releaseInfo;
};



const $d2fbb2a5132824e3$export$9da81b5a5c4a60ca = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDateRangeCalendar", slot);
const $d2fbb2a5132824e3$export$57e995f78fa7756a = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDateRangeCalendar", [
    "root",
    "monthContainer",
    "dayDragging"
]);


const $4a84a166e9287439$export$c7f604e63318fb66 = (utils, range)=>{
    return Boolean(range && range[0] && range[1] && !utils.isBefore(range[1], range[0]));
};
const $4a84a166e9287439$export$6a645c07cf2dc9cc = (utils, day, range)=>{
    return $4a84a166e9287439$export$c7f604e63318fb66(utils, range) && utils.isWithinRange(day, range);
};
const $4a84a166e9287439$export$d63c3232b6730bf6 = (utils, day, range)=>{
    return $4a84a166e9287439$export$c7f604e63318fb66(utils, range) && utils.isSameDay(day, range[0]);
};
const $4a84a166e9287439$export$ee65fa37269ed1c8 = (utils, day, range)=>{
    return $4a84a166e9287439$export$c7f604e63318fb66(utils, range) && utils.isSameDay(day, range[1]);
};



function $58c2dddb510a7acb$export$16d220d339b0b3fb({ utils: utils, range: range, newDate: selectedDate, rangePosition: rangePosition, allowRangeFlip: allowRangeFlip = false, shouldMergeDateAndTime: shouldMergeDateAndTime = false }) {
    const [start, end] = range;
    if (shouldMergeDateAndTime && selectedDate) {
        // If there is a date already selected, then we want to keep its time
        if (start && rangePosition === "start") selectedDate = (0, $6008d551a5f07604$export$a98b123b8f29e004)(utils, selectedDate, start);
        if (end && rangePosition === "end") selectedDate = (0, $6008d551a5f07604$export$a98b123b8f29e004)(utils, selectedDate, end);
    }
    if (rangePosition === "start") {
        const truthyResult = allowRangeFlip ? {
            nextSelection: "start",
            newRange: [
                end,
                selectedDate
            ]
        } : {
            nextSelection: "end",
            newRange: [
                selectedDate,
                null
            ]
        };
        return Boolean(end) && utils.isAfter(selectedDate, end) ? truthyResult : {
            nextSelection: "end",
            newRange: [
                selectedDate,
                end
            ]
        };
    }
    const truthyResult = allowRangeFlip ? {
        nextSelection: "end",
        newRange: [
            selectedDate,
            start
        ]
    } : {
        nextSelection: "end",
        newRange: [
            selectedDate,
            null
        ]
    };
    return Boolean(start) && utils.isBeforeDay(selectedDate, start) ? truthyResult : {
        nextSelection: "start",
        newRange: [
            start,
            selectedDate
        ]
    };
}
function $58c2dddb510a7acb$export$216d2ce628eab5d7(options) {
    if (options.newDate == null) return [
        null,
        null
    ];
    const [start, end] = options.range;
    const { newRange: newRange } = $58c2dddb510a7acb$export$16d220d339b0b3fb(options);
    if (!start || !end) return newRange;
    const [previewStart, previewEnd] = newRange;
    return options.rangePosition === "end" ? [
        end,
        previewEnd
    ] : [
        previewStart,
        start
    ];
}





var $2hDQc = parcelRequire("2hDQc");




var $6KAST = parcelRequire("6KAST");
var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");




function $101e135ada607958$export$678d04f59a9a713f(slot) {
    return (0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiDateRangePickerDay", slot);
}
const $101e135ada607958$export$d983409be2282164 = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiDateRangePickerDay", [
    "root",
    "rangeIntervalDayHighlight",
    "rangeIntervalDayHighlightStart",
    "rangeIntervalDayHighlightEnd",
    "rangeIntervalPreview",
    "rangeIntervalDayPreview",
    "rangeIntervalDayPreviewStart",
    "rangeIntervalDayPreviewEnd",
    "outsideCurrentMonth",
    "startOfMonth",
    "endOfMonth",
    "firstVisibleCell",
    "lastVisibleCell",
    "hiddenDayFiller",
    "day",
    "dayOutsideRangeInterval",
    "dayInsideRangeInterval",
    "notSelectedDate"
]);




var $592Nh = parcelRequire("592Nh");
"use client";
const $6d46ba8d06001235$var$_excluded = [
    "className",
    "day",
    "outsideCurrentMonth",
    "isEndOfHighlighting",
    "isEndOfPreviewing",
    "isHighlighting",
    "isPreviewing",
    "isStartOfHighlighting",
    "isStartOfPreviewing",
    "selected",
    "isVisuallySelected",
    "sx",
    "draggable",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $6d46ba8d06001235$var$releaseInfo = (0, $ac05367139ef9eef$export$edcd7d0b4c3818f)();
const $6d46ba8d06001235$var$useUtilityClasses = (ownerState)=>{
    const { isHighlighting: isHighlighting, outsideCurrentMonth: outsideCurrentMonth, isStartOfHighlighting: isStartOfHighlighting, isStartOfMonth: isStartOfMonth, isEndOfHighlighting: isEndOfHighlighting, isEndOfMonth: isEndOfMonth, isPreviewing: isPreviewing, isStartOfPreviewing: isStartOfPreviewing, isEndOfPreviewing: isEndOfPreviewing, isFirstVisibleCell: isFirstVisibleCell, isLastVisibleCell: isLastVisibleCell, isHiddenDayFiller: isHiddenDayFiller, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isHighlighting && "rangeIntervalDayHighlight",
            isStartOfHighlighting && "rangeIntervalDayHighlightStart",
            isEndOfHighlighting && "rangeIntervalDayHighlightEnd",
            outsideCurrentMonth && "outsideCurrentMonth",
            isStartOfMonth && "startOfMonth",
            isEndOfMonth && "endOfMonth",
            isFirstVisibleCell && "firstVisibleCell",
            isLastVisibleCell && "lastVisibleCell",
            isHiddenDayFiller && "hiddenDayFiller"
        ],
        rangeIntervalPreview: [
            "rangeIntervalPreview",
            isPreviewing && "rangeIntervalDayPreview",
            (isStartOfPreviewing || isStartOfMonth) && "rangeIntervalDayPreviewStart",
            (isEndOfPreviewing || isEndOfMonth) && "rangeIntervalDayPreviewEnd"
        ],
        day: [
            "day",
            !selected && "notSelectedDate",
            !isHighlighting && "dayOutsideRangeInterval",
            !selected && isHighlighting && "dayInsideRangeInterval"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $101e135ada607958$export$678d04f59a9a713f), classes);
};
const $6d46ba8d06001235$var$endBorderStyle = {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%"
};
const $6d46ba8d06001235$var$startBorderStyle = {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%"
};
const $6d46ba8d06001235$var$DateRangePickerDayRoot = (0, $fhlQp.default)("div", {
    name: "MuiDateRangePickerDay",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayHighlight}`]: styles.rangeIntervalDayHighlight
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayHighlightStart}`]: styles.rangeIntervalDayHighlightStart
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayHighlightEnd}`]: styles.rangeIntervalDayHighlightEnd
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).firstVisibleCell}`]: styles.firstVisibleCell
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).lastVisibleCell}`]: styles.lastVisibleCell
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).startOfMonth}`]: styles.startOfMonth
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).endOfMonth}`]: styles.endOfMonth
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).outsideCurrentMonth}`]: styles.outsideCurrentMonth
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).hiddenDayFiller}`]: styles.hiddenDayFiller
            },
            styles.root
        ]
})(({ theme: theme })=>({
        variants: [
            {
                props: {
                    isHiddenDayFiller: false
                },
                style: {
                    [`&:first-of-type .${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayPreview}`]: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $6d46ba8d06001235$var$startBorderStyle, {
                        borderLeftColor: (theme.vars || theme).palette.divider
                    }),
                    [`&:last-of-type .${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayPreview}`]: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $6d46ba8d06001235$var$endBorderStyle, {
                        borderRightColor: (theme.vars || theme).palette.divider
                    })
                }
            },
            {
                props: {
                    isHiddenDayFiller: false,
                    isHighlighting: true
                },
                style: {
                    borderRadius: 0,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
                    "&:first-of-type": $6d46ba8d06001235$var$startBorderStyle,
                    "&:last-of-type": $6d46ba8d06001235$var$endBorderStyle
                }
            },
            {
                props: ({ ownerState: { isHiddenDayFiller: isHiddenDayFiller, isStartOfHighlighting: isStartOfHighlighting, isFirstVisibleCell: isFirstVisibleCell } })=>!isHiddenDayFiller && (isStartOfHighlighting || isFirstVisibleCell),
                style: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $6d46ba8d06001235$var$startBorderStyle, {
                    paddingLeft: 0
                })
            },
            {
                props: ({ ownerState: { isHiddenDayFiller: isHiddenDayFiller, isEndOfHighlighting: isEndOfHighlighting, isLastVisibleCell: isLastVisibleCell } })=>!isHiddenDayFiller && (isEndOfHighlighting || isLastVisibleCell),
                style: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, $6d46ba8d06001235$var$endBorderStyle, {
                    paddingRight: 0
                })
            }
        ]
    }));
const $6d46ba8d06001235$var$DateRangePickerDayRangeIntervalPreview = (0, $fhlQp.default)("div", {
    name: "MuiDateRangePickerDay",
    slot: "RangeIntervalPreview",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayPreview}`]: styles.rangeIntervalDayPreview
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayPreviewStart}`]: styles.rangeIntervalDayPreviewStart
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayPreviewEnd}`]: styles.rangeIntervalDayPreviewEnd
            },
            styles.rangeIntervalPreview
        ]
})(({ theme: theme })=>({
        // replace default day component margin with transparent border to avoid jumping on preview
        border: "2px solid transparent",
        variants: [
            {
                props: {
                    isPreviewing: true,
                    isHiddenDayFiller: false
                },
                style: {
                    borderRadius: 0,
                    border: `2px dashed ${(theme.vars || theme).palette.divider}`,
                    borderLeftColor: "transparent",
                    borderRightColor: "transparent"
                }
            },
            {
                props: ({ ownerState: { isPreviewing: isPreviewing, isHiddenDayFiller: isHiddenDayFiller, isStartOfPreviewing: isStartOfPreviewing, isFirstVisibleCell: isFirstVisibleCell } })=>isPreviewing && !isHiddenDayFiller && (isStartOfPreviewing || isFirstVisibleCell),
                style: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    borderLeftColor: (theme.vars || theme).palette.divider
                }, $6d46ba8d06001235$var$startBorderStyle)
            },
            {
                props: ({ ownerState: { isPreviewing: isPreviewing, isHiddenDayFiller: isHiddenDayFiller, isEndOfPreviewing: isEndOfPreviewing, isLastVisibleCell: isLastVisibleCell } })=>isPreviewing && !isHiddenDayFiller && (isEndOfPreviewing || isLastVisibleCell),
                style: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    borderRightColor: (theme.vars || theme).palette.divider
                }, $6d46ba8d06001235$var$endBorderStyle)
            }
        ]
    }));
const $6d46ba8d06001235$var$DateRangePickerDayDay = (0, $fhlQp.default)((0, $d20698e631973012$export$d7378e6e864346fa), {
    name: "MuiDateRangePickerDay",
    slot: "Day",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).dayInsideRangeInterval}`]: styles.dayInsideRangeInterval
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).dayOutsideRangeInterval}`]: styles.dayOutsideRangeInterval
            },
            {
                [`&.${(0, $101e135ada607958$export$d983409be2282164).notSelectedDate}`]: styles.notSelectedDate
            },
            styles.day
        ]
})({
    // Required to overlap preview border
    transform: "scale(1.1)",
    "& > *": {
        transform: "scale(0.9)"
    },
    variants: [
        {
            props: {
                draggable: true
            },
            style: {
                cursor: "grab",
                touchAction: "none"
            }
        }
    ]
});
const $6d46ba8d06001235$var$DateRangePickerDayRaw = /*#__PURE__*/ $2hDQc.forwardRef(function DateRangePickerDay(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateRangePickerDay"
    });
    const { className: className, day: day, outsideCurrentMonth: outsideCurrentMonth, isHighlighting: isHighlighting, isPreviewing: isPreviewing, selected: selected = false, isVisuallySelected: isVisuallySelected, sx: sx, draggable: draggable, isFirstVisibleCell: isFirstVisibleCell, isLastVisibleCell: isLastVisibleCell } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $6d46ba8d06001235$var$_excluded);
    (0, $b9a7540f3ec89ae8$export$bd780281ba7bfd9)("x-date-pickers-pro", $6d46ba8d06001235$var$releaseInfo);
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const isEndOfMonth = utils.isSameDay(day, utils.endOfMonth(day));
    const isStartOfMonth = utils.isSameDay(day, utils.startOfMonth(day));
    const shouldRenderHighlight = isHighlighting && !outsideCurrentMonth;
    const shouldRenderPreview = isPreviewing && !outsideCurrentMonth;
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        selected: selected,
        isStartOfMonth: isStartOfMonth,
        isEndOfMonth: isEndOfMonth,
        draggable: draggable,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        isHiddenDayFiller: outsideCurrentMonth && !other.showDaysOutsideCurrentMonth
    });
    const classes = $6d46ba8d06001235$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($6d46ba8d06001235$var$DateRangePickerDayRoot, {
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        sx: sx,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($6d46ba8d06001235$var$DateRangePickerDayRangeIntervalPreview, {
            className: classes.rangeIntervalPreview,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $592Nh.jsx)($6d46ba8d06001235$var$DateRangePickerDayDay, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
                ref: ref,
                disableMargin: true,
                day: day,
                selected: isVisuallySelected,
                outsideCurrentMonth: outsideCurrentMonth,
                className: classes.day,
                ownerState: ownerState,
                draggable: draggable,
                isFirstVisibleCell: isFirstVisibleCell,
                isLastVisibleCell: isLastVisibleCell
            }))
        })
    });
});
const $6d46ba8d06001235$export$5c20dcd640d30b8b = /*#__PURE__*/ $2hDQc.memo($6d46ba8d06001235$var$DateRangePickerDayRaw);





var $2hDQc = parcelRequire("2hDQc");


"use client";
const $5a7d0271a662ad2e$var$resolveDateFromTarget = (target, utils, timezone)=>{
    const timestampString = target.dataset.timestamp;
    if (!timestampString) return null;
    const timestamp = +timestampString;
    return utils.date(new Date(timestamp).toISOString(), timezone);
};
const $5a7d0271a662ad2e$var$isSameAsDraggingDate = (event)=>{
    const timestampString = event.target.dataset.timestamp;
    return timestampString === event.dataTransfer.getData("draggingDate");
};
const $5a7d0271a662ad2e$var$resolveButtonElement = (element)=>{
    if (element) {
        if (element instanceof HTMLButtonElement && !element.disabled) return element;
        if (element.children.length) return $5a7d0271a662ad2e$var$resolveButtonElement(element.children[0]);
        return null;
    }
    return element;
};
const $5a7d0271a662ad2e$var$resolveElementFromTouch = (event, ignoreTouchTarget)=>{
    // don't parse multi-touch result
    if (event.changedTouches?.length === 1 && event.touches.length <= 1) {
        const element = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
        // `elementFromPoint` could have resolved preview div or wrapping div
        // might need to recursively find the nested button
        const buttonElement = $5a7d0271a662ad2e$var$resolveButtonElement(element);
        if (ignoreTouchTarget && buttonElement === event.changedTouches[0].target) return null;
        return buttonElement;
    }
    return null;
};
const $5a7d0271a662ad2e$var$useDragRangeEvents = ({ utils: utils, setRangeDragDay: setRangeDragDay, setIsDragging: setIsDragging, isDragging: isDragging, onDatePositionChange: onDatePositionChange, onDrop: onDrop, disableDragEditing: disableDragEditing, dateRange: dateRange, timezone: timezone })=>{
    const emptyDragImgRef = $2hDQc.useRef(null);
    $2hDQc.useEffect(()=>{
        // Preload the image - required for Safari support: https://stackoverflow.com/a/40923520/3303436
        emptyDragImgRef.current = document.createElement("img");
        emptyDragImgRef.current.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    }, []);
    const isElementDraggable = (day)=>{
        if (day == null) return false;
        const shouldInitDragging = !disableDragEditing && !!dateRange[0] && !!dateRange[1];
        const isSelectedStartDate = (0, $4a84a166e9287439$export$d63c3232b6730bf6)(utils, day, dateRange);
        const isSelectedEndDate = (0, $4a84a166e9287439$export$ee65fa37269ed1c8)(utils, day, dateRange);
        return shouldInitDragging && (isSelectedStartDate || isSelectedEndDate);
    };
    const handleDragStart = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        const newDate = $5a7d0271a662ad2e$var$resolveDateFromTarget(event.target, utils, timezone);
        if (!isElementDraggable(newDate)) return;
        event.stopPropagation();
        if (emptyDragImgRef.current) event.dataTransfer.setDragImage(emptyDragImgRef.current, 0, 0);
        setRangeDragDay(newDate);
        event.dataTransfer.effectAllowed = "move";
        setIsDragging(true);
        const buttonDataset = event.target.dataset;
        if (buttonDataset.timestamp) event.dataTransfer.setData("draggingDate", buttonDataset.timestamp);
        if (buttonDataset.position) onDatePositionChange(buttonDataset.position);
    });
    const handleTouchStart = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        const target = $5a7d0271a662ad2e$var$resolveElementFromTouch(event);
        if (!target) return;
        const newDate = $5a7d0271a662ad2e$var$resolveDateFromTarget(target, utils, timezone);
        if (!isElementDraggable(newDate)) return;
        setRangeDragDay(newDate);
    });
    const handleDragEnter = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = "move";
        setRangeDragDay($5a7d0271a662ad2e$var$resolveDateFromTarget(event.target, utils, timezone));
    });
    const handleTouchMove = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        const target = $5a7d0271a662ad2e$var$resolveElementFromTouch(event);
        if (!target) return;
        const newDate = $5a7d0271a662ad2e$var$resolveDateFromTarget(target, utils, timezone);
        if (newDate) setRangeDragDay(newDate);
        // this prevents initiating drag when user starts touchmove outside and then moves over a draggable element
        const targetsAreIdentical = target === event.changedTouches[0].target;
        if (!targetsAreIdentical || !isElementDraggable(newDate)) return;
        // on mobile we should only initialize dragging state after move is detected
        setIsDragging(true);
        const button = event.target;
        const buttonDataset = button.dataset;
        if (buttonDataset.position) onDatePositionChange(buttonDataset.position);
    });
    const handleDragLeave = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
    });
    const handleDragOver = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = "move";
    });
    const handleTouchEnd = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        setRangeDragDay(null);
        setIsDragging(false);
        const target = $5a7d0271a662ad2e$var$resolveElementFromTouch(event, true);
        if (!target) return;
        // make sure the focused element is the element where touch ended
        target.focus();
        const newDate = $5a7d0271a662ad2e$var$resolveDateFromTarget(target, utils, timezone);
        if (newDate) onDrop(newDate);
    });
    const handleDragEnd = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        setRangeDragDay(null);
    });
    const handleDrop = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        setRangeDragDay(null);
        // make sure the focused element is the element where drop ended
        event.currentTarget.focus();
        if ($5a7d0271a662ad2e$var$isSameAsDraggingDate(event)) return;
        const newDate = $5a7d0271a662ad2e$var$resolveDateFromTarget(event.target, utils, timezone);
        if (newDate) onDrop(newDate);
    });
    return {
        onDragStart: handleDragStart,
        onDragEnter: handleDragEnter,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDragEnd: handleDragEnd,
        onDrop: handleDrop,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd
    };
};
const $5a7d0271a662ad2e$export$26d9b2e35f689abe = ({ disableDragEditing: disableDragEditing, utils: utils, onDatePositionChange: onDatePositionChange, onDrop: onDrop, dateRange: dateRange, timezone: timezone })=>{
    const [isDragging, setIsDragging] = $2hDQc.useState(false);
    const [rangeDragDay, setRangeDragDay] = $2hDQc.useState(null);
    const handleRangeDragDayChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((val)=>{
        if (!utils.isEqual(val, rangeDragDay)) setRangeDragDay(val);
    });
    const draggingDatePosition = $2hDQc.useMemo(()=>{
        const [start, end] = dateRange;
        if (rangeDragDay) {
            if (start && utils.isBefore(rangeDragDay, start)) return "start";
            if (end && utils.isAfter(rangeDragDay, end)) return "end";
        }
        return null;
    }, [
        dateRange,
        rangeDragDay,
        utils
    ]);
    const dragRangeEvents = $5a7d0271a662ad2e$var$useDragRangeEvents({
        utils: utils,
        onDatePositionChange: onDatePositionChange,
        onDrop: onDrop,
        setIsDragging: setIsDragging,
        isDragging: isDragging,
        setRangeDragDay: handleRangeDragDayChange,
        disableDragEditing: disableDragEditing,
        dateRange: dateRange,
        timezone: timezone
    });
    return $2hDQc.useMemo(()=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            isDragging: isDragging,
            rangeDragDay: rangeDragDay,
            draggingDatePosition: draggingDatePosition
        }, !disableDragEditing ? dragRangeEvents : {}), [
        isDragging,
        rangeDragDay,
        draggingDatePosition,
        disableDragEditing,
        dragRangeEvents
    ]);
};




const $23c0243990d3594f$export$a08461734e712d56 = (props, singleInputFieldRef)=>{
    const [rangePosition, setRangePosition] = (0, $380b9a9318603e37$export$2e2bcd8739ae039)({
        name: "useRangePosition",
        state: "rangePosition",
        controlled: props.rangePosition,
        default: props.defaultRangePosition ?? "start"
    });
    // When using a single input field,
    // we want to select the 1st section of the edited date when updating the range position.
    const syncRangePositionWithSingleInputField = (newRangePosition)=>{
        if (singleInputFieldRef?.current == null) return;
        const sections = singleInputFieldRef.current.getSections();
        const targetActiveSectionIndex = newRangePosition === "start" ? 0 : sections.length / 2;
        singleInputFieldRef.current.setSelectedSections(targetActiveSectionIndex);
    };
    const handleRangePositionChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newRangePosition)=>{
        setRangePosition(newRangePosition);
        props.onRangePositionChange?.(newRangePosition);
        syncRangePositionWithSingleInputField(newRangePosition);
    });
    return {
        rangePosition: rangePosition,
        onRangePositionChange: handleRangePositionChange
    };
};



const $b5a69e9adcea1aae$export$4e17d2fd56bdf649 = 40;
const $b5a69e9adcea1aae$export$c1e878bb226ff3de = (0, $8768610d9d8fd41e$export$f2fef360e2df0cb7) + 12 * (0, $8768610d9d8fd41e$export$dde58b009b497666);





var $2hDQc = parcelRequire("2hDQc");


var $fhlQp = parcelRequire("fhlQp");




var $592Nh = parcelRequire("592Nh");
"use client";
const $ebd4ea47e95658ff$var$_excluded = [
    "calendars",
    "month",
    "monthIndex",
    "labelId"
], $ebd4ea47e95658ff$var$_excluded2 = [
    "format",
    "slots",
    "slotProps",
    "currentMonth",
    "onMonthChange",
    "disableFuture",
    "disablePast",
    "minDate",
    "maxDate",
    "timezone",
    "reduceAnimations",
    "views",
    "view"
];
const $ebd4ea47e95658ff$var$PickersRangeCalendarHeaderContentMultipleCalendars = (0, $fhlQp.default)((0, $da6a77f421ae8723$export$597b7cbdb7b2a24c))({
    padding: "12px 16px 4px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $ebd4ea47e95658ff$export$5540b90af1b7e6d9 = /*#__PURE__*/ $2hDQc.forwardRef(function PickersRangeCalendarHeader(props, ref) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const { calendars: calendars, month: month, monthIndex: monthIndex, labelId: labelId } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $ebd4ea47e95658ff$var$_excluded);
    const { format: format, slots: slots, slotProps: slotProps, currentMonth: currentMonth, onMonthChange: onMonthChange, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, timezone: timezone } = other, otherRangeProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(other, $ebd4ea47e95658ff$var$_excluded2);
    const isNextMonthDisabled = (0, $78e4c4ab8f2469fb$export$923e8cc135843169)(currentMonth, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $78e4c4ab8f2469fb$export$3b46d38ff4932cf7)(currentMonth, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    if (calendars === 1) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $48b2c8152396d2e7$export$6801ffebb353f473), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, other, {
        labelId: labelId,
        ref: ref
    }));
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(currentMonth, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(currentMonth, -1), "right");
    return /*#__PURE__*/ (0, $592Nh.jsx)($ebd4ea47e95658ff$var$PickersRangeCalendarHeaderContentMultipleCalendars, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, otherRangeProps, {
        ref: ref,
        onGoToPrevious: selectPreviousMonth,
        onGoToNext: selectNextMonth,
        isPreviousHidden: monthIndex !== 0,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: translations.previousMonth,
        isNextHidden: monthIndex !== calendars - 1,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: translations.nextMonth,
        slots: slots,
        slotProps: slotProps,
        labelId: labelId,
        children: utils.formatByString(month, format ?? `${utils.formats.month} ${utils.formats.year}`)
    }));
});



var $592Nh = parcelRequire("592Nh");
"use client";
const $17ffa9560440c860$var$_excluded = [
    "value",
    "defaultValue",
    "referenceDate",
    "onChange",
    "className",
    "disableFuture",
    "disablePast",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "reduceAnimations",
    "onMonthChange",
    "rangePosition",
    "defaultRangePosition",
    "onRangePositionChange",
    "calendars",
    "currentMonthCalendarPosition",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "disableHighlightToday",
    "readOnly",
    "disabled",
    "showDaysOutsideCurrentMonth",
    "dayOfWeekFormatter",
    "disableAutoMonthSwitching",
    "autoFocus",
    "fixedWeekNumber",
    "disableDragEditing",
    "displayWeekNumber",
    "timezone",
    "availableRangePositions",
    "views",
    "view",
    "openTo",
    "onViewChange"
], $17ffa9560440c860$var$_excluded2 = [
    "isDragging",
    "rangeDragDay",
    "draggingDatePosition"
];
const $17ffa9560440c860$var$releaseInfo = (0, $ac05367139ef9eef$export$edcd7d0b4c3818f)();
const $17ffa9560440c860$var$DateRangeCalendarRoot = (0, $fhlQp.default)("div", {
    name: "MuiDateRangeCalendar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row"
});
const $17ffa9560440c860$var$DateRangeCalendarMonthContainer = (0, $fhlQp.default)("div", {
    name: "MuiDateRangeCalendar",
    slot: "Container",
    overridesResolver: (_, styles)=>styles.monthContainer
})(({ theme: theme })=>({
        "&:not(:last-of-type)": {
            borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
        }
    }));
const $17ffa9560440c860$var$weeksContainerHeight = ((0, $b5a69e9adcea1aae$export$4e17d2fd56bdf649) + (0, $8768610d9d8fd41e$export$dde58b009b497666) * 2) * 6;
const $17ffa9560440c860$var$InnerDayCalendarForRange = (0, $fhlQp.default)((0, $9e3690639f536c9e$export$8fb56b32a5df6314))(({ theme: theme })=>({
        minWidth: 312,
        minHeight: $17ffa9560440c860$var$weeksContainerHeight,
        [`&.${(0, $d2fbb2a5132824e3$export$57e995f78fa7756a).dayDragging}`]: {
            [`& .${(0, $101e135ada607958$export$d983409be2282164).day}`]: {
                cursor: "grabbing"
            },
            [`& .${(0, $101e135ada607958$export$d983409be2282164).root}:not(.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayHighlightStart}):not(.${(0, $101e135ada607958$export$d983409be2282164).rangeIntervalDayHighlightEnd}) .${(0, $101e135ada607958$export$d983409be2282164).day}:not(.${(0, $101e135ada607958$export$d983409be2282164).notSelectedDate})`]: {
                // we can't override `PickersDay` background color here, because it's styles take precedence
                opacity: 0.6
            }
        },
        [`&:not(.${(0, $d2fbb2a5132824e3$export$57e995f78fa7756a).dayDragging}) .${(0, $101e135ada607958$export$d983409be2282164).dayOutsideRangeInterval}`]: {
            "@media (pointer: fine)": {
                "&:hover": {
                    border: `1px solid ${(theme.vars || theme).palette.grey[500]}`
                }
            }
        }
    }));
const $17ffa9560440c860$var$DayCalendarForRange = $17ffa9560440c860$var$InnerDayCalendarForRange;
function $17ffa9560440c860$var$useDateRangeCalendarDefaultizedProps(props, name) {
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const defaultDates = (0, $404db1959acab970$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $fb3a5f9ff3173fe5$export$ce40fb97be7f02d9)();
    const themeProps = (0, $afHYP.default)({
        props: props,
        name: name
    });
    return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, themeProps, {
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $592Nh.jsx)("span", {
                children: "..."
            })),
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        loading: props.loading ?? false,
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        openTo: themeProps.openTo ?? "day",
        views: themeProps.views ?? [
            "day"
        ],
        minDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6008d551a5f07604$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        calendars: themeProps.calendars ?? 2,
        disableDragEditing: themeProps.disableDragEditing ?? false,
        availableRangePositions: themeProps.availableRangePositions ?? [
            "start",
            "end"
        ]
    });
}
const $17ffa9560440c860$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isDragging: isDragging } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthContainer: [
            "monthContainer"
        ],
        dayCalendar: [
            isDragging && "dayDragging"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, (0, $d2fbb2a5132824e3$export$9da81b5a5c4a60ca), classes);
};
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 *
 * API:
 *
 * - [DateRangeCalendar API](https://mui.com/x/api/date-pickers/date-range-calendar/)
 */ const $17ffa9560440c860$export$ee16faa35d8af1c6 = /*#__PURE__*/ $2hDQc.forwardRef(function DateRangeCalendar(inProps, ref) {
    const props = $17ffa9560440c860$var$useDateRangeCalendarDefaultizedProps(inProps, "MuiDateRangeCalendar");
    const shouldHavePreview = (0, $ef97679917c36082$export$2e2bcd8739ae039)((0, $5e6b2caee8dd3380$export$9ae5b19305db48ce), {
        defaultMatches: false
    });
    const { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, rangePosition: rangePositionProp, defaultRangePosition: inDefaultRangePosition, onRangePositionChange: inOnRangePositionChange, calendars: calendars, currentMonthCalendarPosition: currentMonthCalendarPosition = 1, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, disableAutoMonthSwitching: disableAutoMonthSwitching, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, disableDragEditing: disableDragEditing, displayWeekNumber: displayWeekNumber, timezone: timezoneProp, availableRangePositions: availableRangePositions, views: views, view: inView, openTo: openTo, onViewChange: onViewChange } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $17ffa9560440c860$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "DateRangeCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $bc86ae5cc45374b5$export$f0e1e223b0d1e9e1)
    });
    const { setValueAndGoToNextView: setValueAndGoToNextView, view: view } = (0, $2c5912d759d255cd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus
    });
    const utils = (0, $404db1959acab970$export$1163b47e39508a46)();
    const now = (0, $404db1959acab970$export$3a404aece3dff2fa)(timezone);
    const id = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const { rangePosition: rangePosition, onRangePositionChange: onRangePositionChange } = (0, $23c0243990d3594f$export$a08461734e712d56)({
        rangePosition: rangePositionProp,
        defaultRangePosition: inDefaultRangePosition,
        onRangePositionChange: inOnRangePositionChange
    });
    const handleDatePositionChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((position)=>{
        if (rangePosition !== position) onRangePositionChange(position);
    });
    const handleSelectedDayChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newDate, selectionState, allowRangeFlip = false)=>{
        const { nextSelection: nextSelection, newRange: newRange } = (0, $58c2dddb510a7acb$export$16d220d339b0b3fb)({
            newDate: newDate,
            utils: utils,
            range: value,
            rangePosition: rangePosition,
            allowRangeFlip: allowRangeFlip,
            shouldMergeDateAndTime: true
        });
        const isNextSectionAvailable = availableRangePositions.includes(nextSelection);
        if (isNextSectionAvailable) onRangePositionChange(nextSelection);
        const isFullRangeSelected = rangePosition === "end" && (0, $4a84a166e9287439$export$c7f604e63318fb66)(utils, newRange);
        setValueAndGoToNextView(newRange, isFullRangeSelected || !isNextSectionAvailable ? "finish" : "partial", view);
    });
    const handleDrop = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newDate)=>{
        handleSelectedDayChange(newDate, undefined, true);
    });
    const shouldDisableDragEditing = disableDragEditing || disabled || readOnly;
    // Range going for the start of the start day to the end of the end day.
    // This makes sure that `isWithinRange` works with any time in the start and end day.
    const valueDayRange = $2hDQc.useMemo(()=>[
            value[0] == null || !utils.isValid(value[0]) ? value[0] : utils.startOfDay(value[0]),
            value[1] == null || !utils.isValid(value[1]) ? value[1] : utils.endOfDay(value[1])
        ], [
        value,
        utils
    ]);
    const _useDragRange = (0, $5a7d0271a662ad2e$export$26d9b2e35f689abe)({
        disableDragEditing: shouldDisableDragEditing,
        onDrop: handleDrop,
        onDatePositionChange: handleDatePositionChange,
        utils: utils,
        dateRange: valueDayRange,
        timezone: timezone
    }), { isDragging: isDragging, rangeDragDay: rangeDragDay, draggingDatePosition: draggingDatePosition } = _useDragRange, dragEventHandlers = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_useDragRange, $17ffa9560440c860$var$_excluded2);
    const ownerState = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, props, {
        isDragging: isDragging
    });
    const classes = $17ffa9560440c860$var$useUtilityClasses(ownerState);
    const draggingRange = $2hDQc.useMemo(()=>{
        if (!valueDayRange[0] || !valueDayRange[1] || !rangeDragDay) return [
            null,
            null
        ];
        const newRange = (0, $58c2dddb510a7acb$export$16d220d339b0b3fb)({
            utils: utils,
            range: valueDayRange,
            newDate: rangeDragDay,
            rangePosition: rangePosition,
            allowRangeFlip: true
        }).newRange;
        return newRange[0] !== null && newRange[1] !== null ? [
            utils.startOfDay(newRange[0]),
            utils.endOfDay(newRange[1])
        ] : newRange;
    }, [
        rangePosition,
        rangeDragDay,
        utils,
        valueDayRange
    ]);
    const wrappedShouldDisableDate = $2hDQc.useMemo(()=>{
        if (!shouldDisableDate) return undefined;
        return (dayToTest)=>shouldDisableDate(dayToTest, draggingDatePosition || rangePosition);
    }, [
        shouldDisableDate,
        rangePosition,
        draggingDatePosition
    ]);
    const { calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $af942451118d86d9$export$6d095e787d2b5e1f)({
        value: value[0] || value[1],
        referenceDate: referenceDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        disableSwitchToMonthOnDayFocus: true,
        maxDate: maxDate,
        minDate: minDate,
        onMonthChange: onMonthChange,
        reduceAnimations: reduceAnimations,
        shouldDisableDate: wrappedShouldDisableDate,
        timezone: timezone
    });
    const CalendarHeader = slots?.calendarHeader ?? (0, $ebd4ea47e95658ff$export$5540b90af1b7e6d9);
    const calendarHeaderProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            calendars: calendars,
            views: [
                "day"
            ],
            view: "day",
            currentMonth: calendarState.currentMonth,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDate,
            maxDate: maxDate,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const prevValue = $2hDQc.useRef(null);
    $2hDQc.useEffect(()=>{
        const date = rangePosition === "start" ? value[0] : value[1];
        if (!date || !utils.isValid(date)) return;
        const prevDate = rangePosition === "start" ? prevValue.current?.[0] : prevValue.current?.[1];
        prevValue.current = value;
        // The current date did not change, this call comes either from a `rangePosition` change or a change in the other date.
        // In both cases, we don't want to change the visible month(s).
        if (disableAutoMonthSwitching && prevDate && utils.isEqual(prevDate, date)) return;
        const displayingMonthRange = calendars - currentMonthCalendarPosition;
        const currentMonthNumber = utils.getMonth(calendarState.currentMonth);
        const requestedMonthNumber = utils.getMonth(date);
        if (!utils.isSameYear(calendarState.currentMonth, date) || requestedMonthNumber < currentMonthNumber || requestedMonthNumber > currentMonthNumber + displayingMonthRange) {
            const newMonth = rangePosition === "start" ? date : // If need to focus end, scroll to the state when "end" is displaying in the last calendar
            utils.addMonths(date, -displayingMonthRange);
            changeMonth(newMonth);
        }
    }, [
        rangePosition,
        value
    ]); // eslint-disable-line
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled
    };
    const [rangePreviewDay, setRangePreviewDay] = $2hDQc.useState(null);
    const CalendarTransitionProps = $2hDQc.useMemo(()=>({
            onMouseLeave: ()=>setRangePreviewDay(null)
        }), []);
    const previewingRange = (0, $58c2dddb510a7acb$export$216d2ce628eab5d7)({
        utils: utils,
        range: valueDayRange,
        newDate: rangePreviewDay,
        rangePosition: rangePosition
    });
    const handleDayMouseEnter = (0, $b61557e39989b411$export$2e2bcd8739ae039)((event, newPreviewRequest)=>{
        if (!(0, $4a84a166e9287439$export$6a645c07cf2dc9cc)(utils, newPreviewRequest, valueDayRange)) setRangePreviewDay(newPreviewRequest);
        else setRangePreviewDay(null);
    });
    const slotsForDayCalendar = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        day: (0, $6d46ba8d06001235$export$5c20dcd640d30b8b)
    }, slots);
    const slotPropsForDayCalendar = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, slotProps, {
        day: (dayOwnerState)=>{
            const { day: day } = dayOwnerState;
            const isSelectedStartDate = (0, $4a84a166e9287439$export$d63c3232b6730bf6)(utils, day, valueDayRange);
            const isSelectedEndDate = (0, $4a84a166e9287439$export$ee65fa37269ed1c8)(utils, day, valueDayRange);
            const shouldInitDragging = !shouldDisableDragEditing && valueDayRange[0] && valueDayRange[1];
            const isElementDraggable = shouldInitDragging && (isSelectedStartDate || isSelectedEndDate);
            let datePosition;
            if (isSelectedStartDate) datePosition = "start";
            else if (isSelectedEndDate) datePosition = "end";
            const isStartOfHighlighting = isDragging ? (0, $4a84a166e9287439$export$d63c3232b6730bf6)(utils, day, draggingRange) : isSelectedStartDate;
            const isEndOfHighlighting = isDragging ? (0, $4a84a166e9287439$export$ee65fa37269ed1c8)(utils, day, draggingRange) : isSelectedEndDate;
            return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                isPreviewing: shouldHavePreview ? (0, $4a84a166e9287439$export$6a645c07cf2dc9cc)(utils, day, previewingRange) : false,
                isStartOfPreviewing: shouldHavePreview ? (0, $4a84a166e9287439$export$d63c3232b6730bf6)(utils, day, previewingRange) : false,
                isEndOfPreviewing: shouldHavePreview ? (0, $4a84a166e9287439$export$ee65fa37269ed1c8)(utils, day, previewingRange) : false,
                isHighlighting: (0, $4a84a166e9287439$export$6a645c07cf2dc9cc)(utils, day, isDragging ? draggingRange : valueDayRange),
                isStartOfHighlighting: isStartOfHighlighting,
                isEndOfHighlighting: isDragging ? (0, $4a84a166e9287439$export$ee65fa37269ed1c8)(utils, day, draggingRange) : isSelectedEndDate,
                onMouseEnter: shouldHavePreview ? handleDayMouseEnter : undefined,
                // apply selected styling to the dragging start or end day
                isVisuallySelected: dayOwnerState.selected || isDragging && (isStartOfHighlighting || isEndOfHighlighting),
                "data-position": datePosition
            }, dragEventHandlers, {
                draggable: isElementDraggable ? true : undefined
            }, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(slotProps?.day, dayOwnerState) ?? {});
        }
    });
    const calendarMonths = $2hDQc.useMemo(()=>Array.from({
            length: calendars
        }).map((_, index)=>index), [
        calendars
    ]);
    const visibleMonths = $2hDQc.useMemo(()=>{
        const firstMonth = utils.addMonths(calendarState.currentMonth, 1 - currentMonthCalendarPosition);
        return Array.from({
            length: calendars
        }).map((_, index)=>utils.addMonths(firstMonth, index));
    }, [
        utils,
        calendarState.currentMonth,
        calendars,
        currentMonthCalendarPosition
    ]);
    const focusedMonth = $2hDQc.useMemo(()=>{
        if (!autoFocus) return null;
        // The focus priority of the "day" view is as follows:
        // 1. Month of the `start` date
        // 2. Month of the `end` date
        // 3. Month of the current date
        // 4. First visible month
        if (value[0] != null) return visibleMonths.find((month)=>utils.isSameMonth(month, value[0]));
        if (value[1] != null) return visibleMonths.find((month)=>utils.isSameMonth(month, value[1]));
        return visibleMonths.find((month)=>utils.isSameMonth(month, now)) ?? visibleMonths[0];
    }, [
        utils,
        value,
        visibleMonths,
        autoFocus,
        now
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsxs)($17ffa9560440c860$var$DateRangeCalendarRoot, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b3920437c8128d0a$export$e94943a72132ebdf), {
                packageName: "x-date-pickers-pro",
                releaseInfo: $17ffa9560440c860$var$releaseInfo
            }),
            calendarMonths.map((monthIndex)=>{
                const month = visibleMonths[monthIndex];
                const labelId = `${id}-grid-${monthIndex}-label`;
                return /*#__PURE__*/ (0, $592Nh.jsxs)($17ffa9560440c860$var$DateRangeCalendarMonthContainer, {
                    className: classes.monthContainer,
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)(CalendarHeader, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                            month: month,
                            monthIndex: monthIndex,
                            labelId: labelId
                        })),
                        /*#__PURE__*/ (0, $592Nh.jsx)($17ffa9560440c860$var$DayCalendarForRange, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                            className: classes.dayCalendar
                        }, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: value,
                            onSelectedDaysChange: handleSelectedDayChange,
                            currentMonth: month,
                            TransitionProps: CalendarTransitionProps,
                            shouldDisableDate: wrappedShouldDisableDate,
                            showDaysOutsideCurrentMonth: calendars === 1 && showDaysOutsideCurrentMonth,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            loading: loading,
                            renderLoading: renderLoading,
                            slots: slotsForDayCalendar,
                            slotProps: slotPropsForDayCalendar,
                            autoFocus: month === focusedMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            displayWeekNumber: displayWeekNumber,
                            timezone: timezone,
                            gridLabelId: labelId
                        }))
                    ]
                }, monthIndex);
            })
        ]
    }));
});



var $592Nh = parcelRequire("592Nh");
const $e0eb3f34cf503073$export$5aac1f02b93501aa = ({ value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, rangePosition: rangePosition, defaultRangePosition: defaultRangePosition, onRangePositionChange: onRangePositionChange, calendars: calendars, currentMonthCalendarPosition: currentMonthCalendarPosition, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, disableAutoMonthSwitching: disableAutoMonthSwitching, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, disableDragEditing: disableDragEditing, displayWeekNumber: displayWeekNumber, timezone: timezone, availableRangePositions: availableRangePositions, views: views, view: view, onViewChange: onViewChange })=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $17ffa9560440c860$export$ee16faa35d8af1c6), {
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        rangePosition: rangePosition,
        defaultRangePosition: defaultRangePosition,
        onRangePositionChange: onRangePositionChange,
        calendars: calendars,
        currentMonthCalendarPosition: currentMonthCalendarPosition,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        disableAutoMonthSwitching: disableAutoMonthSwitching,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        disableDragEditing: disableDragEditing,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone,
        availableRangePositions: availableRangePositions,
        view: view,
        views: views,
        onViewChange: onViewChange
    });





var $2hDQc = parcelRequire("2hDQc");






var $fhlQp = parcelRequire("fhlQp");
var $afHYP = parcelRequire("afHYP");












"use client";
const $c987bf8f4b5107a8$export$5591b0b878c1a989 = (inProps)=>{
    const props = (0, $371ce98de234cd61$export$c04f15aa68a6177a)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $12f029ff43856ce2$export$be857fabf132acea)(props, "date");
    return (0, $35ce92a8864cc63f$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $60e2396f80eb3f46$export$2764b246aa3b75ba),
        fieldValueManager: (0, $60e2396f80eb3f46$export$b602c94f557316b4),
        validator: (0, $7ee2e31e1f24b6a5$export$ffb3d0046ef3a2),
        valueType: "date"
    });
};









const $c2fd1e0b9d0fb131$var$_excluded = [
    "shouldDisableDate"
];
const $c2fd1e0b9d0fb131$export$b3e10550232e39db = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const [start, end] = value;
    const { shouldDisableDate: shouldDisableDate } = props, otherProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $c2fd1e0b9d0fb131$var$_excluded);
    const dateValidations = [
        (0, $7ee2e31e1f24b6a5$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: start,
            timezone: timezone,
            props: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, otherProps, {
                shouldDisableDate: (day)=>!!shouldDisableDate?.(day, "start")
            })
        }),
        (0, $7ee2e31e1f24b6a5$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: end,
            timezone: timezone,
            props: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, otherProps, {
                shouldDisableDate: (day)=>!!shouldDisableDate?.(day, "end")
            })
        })
    ];
    if (dateValidations[0] || dateValidations[1]) return dateValidations;
    // for partial input
    if (start === null || end === null) return [
        null,
        null
    ];
    if (!(0, $4a84a166e9287439$export$c7f604e63318fb66)(adapter.utils, value)) return [
        "invalidRange",
        "invalidRange"
    ];
    return [
        null,
        null
    ];
};
$c2fd1e0b9d0fb131$export$b3e10550232e39db.valueManager = (0, $bc86ae5cc45374b5$export$f0e1e223b0d1e9e1);



/* TODO: remove this when a clearable behavior for multiple input range fields is implemented */ const $4d12fd8a0b14b688$export$4974089e59c6941a = (props, excludedProps)=>{
    return Object.keys(props).reduce((acc, key)=>{
        if (!excludedProps.includes(key)) acc[key] = props[key];
        return acc;
    }, {});
};



var $2hDQc = parcelRequire("2hDQc");


const $3e96d72a697b768e$export$da2976cb6f809437 = (params)=>{
    const unstableEndFieldRef = $2hDQc.useRef(null);
    const handleUnstableEndFieldRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(params.unstableEndFieldRef, unstableEndFieldRef);
    const [startSelectedSection, setStartSelectedSection] = $2hDQc.useState(params.selectedSections ?? null);
    const [endSelectedSection, setEndSelectedSection] = $2hDQc.useState(null);
    const getActiveField = ()=>{
        if (unstableEndFieldRef.current && unstableEndFieldRef.current.isFieldFocused()) return "end";
        return "start";
    };
    const handleStartSelectedSectionChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setStartSelectedSection(newSelectedSections);
        if (getActiveField() === "start") params.onSelectedSectionsChange?.(newSelectedSections);
    });
    const handleEndSelectedSectionChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setEndSelectedSection(newSelectedSections);
        if (getActiveField() === "end") params.onSelectedSectionsChange?.(newSelectedSections);
    });
    const activeField = getActiveField();
    return {
        start: {
            unstableFieldRef: params.unstableStartFieldRef,
            selectedSections: activeField === "start" && params.selectedSections !== undefined ? params.selectedSections : startSelectedSection,
            onSelectedSectionsChange: handleStartSelectedSectionChange
        },
        end: {
            unstableFieldRef: handleUnstableEndFieldRef,
            selectedSections: activeField === "end" && params.selectedSections !== undefined ? params.selectedSections : endSelectedSection,
            onSelectedSectionsChange: handleEndSelectedSectionChange
        }
    };
};


const $6ff4cedf45ebff4c$export$7bbd5fc3b71530fb = ({ sharedProps: inSharedProps, startTextFieldProps: startTextFieldProps, unstableStartFieldRef: unstableStartFieldRef, endTextFieldProps: endTextFieldProps, unstableEndFieldRef: unstableEndFieldRef })=>{
    const sharedProps = (0, $371ce98de234cd61$export$c04f15aa68a6177a)(inSharedProps);
    const { value: valueProp, defaultValue: defaultValue, format: format, formatDensity: formatDensity, shouldRespectLeadingZeros: shouldRespectLeadingZeros, onChange: onChange, disabled: disabled, readOnly: readOnly, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, autoFocus: autoFocus } = sharedProps;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $b42e00cec95bf032$export$174d749f3b4c0f49)({
        name: "useMultiInputDateRangeField",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $bc86ae5cc45374b5$export$f0e1e223b0d1e9e1)
    });
    const { validationError: validationError, getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $6dac1f43294e1bc1$export$87fe492f99f25a20)({
        props: sharedProps,
        value: value,
        timezone: timezone,
        validator: (0, $c2fd1e0b9d0fb131$export$b3e10550232e39db),
        onError: sharedProps.onError
    });
    // TODO: Maybe export utility from `useField` instead of copy/pasting the logic
    const buildChangeHandler = (index)=>{
        return (newDate, rawContext)=>{
            const newDateRange = index === 0 ? [
                newDate,
                value[1]
            ] : [
                value[0],
                newDate
            ];
            const context = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rawContext, {
                validationError: getValidationErrorForNewValue(newDateRange)
            });
            handleValueChange(newDateRange, context);
        };
    };
    const handleStartDateChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)(buildChangeHandler(0));
    const handleEndDateChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)(buildChangeHandler(1));
    const selectedSectionsResponse = (0, $3e96d72a697b768e$export$da2976cb6f809437)({
        selectedSections: selectedSections,
        onSelectedSectionsChange: onSelectedSectionsChange,
        unstableStartFieldRef: unstableStartFieldRef,
        unstableEndFieldRef: unstableEndFieldRef
    });
    const startFieldProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        error: !!validationError[0]
    }, startTextFieldProps, selectedSectionsResponse.start, {
        disabled: disabled,
        readOnly: readOnly,
        format: format,
        formatDensity: formatDensity,
        shouldRespectLeadingZeros: shouldRespectLeadingZeros,
        timezone: timezone,
        value: valueProp === undefined ? undefined : valueProp[0],
        defaultValue: defaultValue === undefined ? undefined : defaultValue[0],
        onChange: handleStartDateChange,
        enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
        autoFocus: autoFocus // Do not add on end field.
    });
    const endFieldProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        error: !!validationError[1]
    }, endTextFieldProps, selectedSectionsResponse.end, {
        format: format,
        formatDensity: formatDensity,
        shouldRespectLeadingZeros: shouldRespectLeadingZeros,
        disabled: disabled,
        readOnly: readOnly,
        timezone: timezone,
        value: valueProp === undefined ? undefined : valueProp[1],
        defaultValue: defaultValue === undefined ? undefined : defaultValue[1],
        onChange: handleEndDateChange,
        enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure
    });
    const startDateResponse = (0, $c987bf8f4b5107a8$export$5591b0b878c1a989)(startFieldProps);
    const endDateResponse = (0, $c987bf8f4b5107a8$export$5591b0b878c1a989)(endFieldProps);
    /* TODO: Undo this change when a clearable behavior for multiple input range fields is implemented */ return {
        startDate: (0, $4d12fd8a0b14b688$export$4974089e59c6941a)(startDateResponse, [
            "clearable",
            "onClear"
        ]),
        endDate: (0, $4d12fd8a0b14b688$export$4974089e59c6941a)(endDateResponse, [
            "clearable",
            "onClear"
        ])
    };
};



var $592Nh = parcelRequire("592Nh");
"use client";
const $84531527469341df$var$_excluded = [
    "slots",
    "slotProps",
    "unstableStartFieldRef",
    "unstableEndFieldRef",
    "className"
];
const $84531527469341df$export$9feaf892c0233a1e = (0, $b6d5eeabe08428a3$export$2e2bcd8739ae039)("MuiMultiInputDateRangeField", [
    "root",
    "separator"
]);
const $84531527469341df$export$1f0f295188b72722 = (slot)=>(0, $da27f637207bc43f$export$2e2bcd8739ae039)("MuiMultiInputDateRangeField", slot);
const $84531527469341df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $7b90fada85d5daeb$export$2e2bcd8739ae039)(slots, $84531527469341df$export$1f0f295188b72722, classes);
};
const $84531527469341df$var$MultiInputDateRangeFieldRoot = (0, $fhlQp.default)(/*#__PURE__*/ $2hDQc.forwardRef((props, ref)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $cc2403a042b6d76d$export$2e2bcd8739ae039), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref,
        spacing: 2,
        direction: "row",
        alignItems: "center"
    }, props))), {
    name: "MuiMultiInputDateRangeField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $84531527469341df$var$MultiInputDateRangeFieldSeparator = (0, $fhlQp.default)((0, $df1a4ec584b17f6d$export$2e2bcd8739ae039), {
    name: "MuiMultiInputDateRangeField",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    lineHeight: "1.4375em" // 23px
});
/**
 * Demos:
 *
 * - [DateRangeField](http://mui.com/x/react-date-pickers/date-range-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [MultiInputDateRangeField API](https://mui.com/x/api/multi-input-date-range-field/)
 */ const $84531527469341df$export$806f5cf21816db1e = /*#__PURE__*/ $2hDQc.forwardRef(function MultiInputDateRangeField(inProps, ref) {
    const themeProps = (0, $afHYP.default)({
        props: inProps,
        name: "MuiMultiInputDateRangeField"
    });
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $12f029ff43856ce2$export$be857fabf132acea)(themeProps, "date");
    const { slots: slots, slotProps: slotProps, unstableStartFieldRef: unstableStartFieldRef, unstableEndFieldRef: unstableEndFieldRef, className: className } = forwardedProps, otherForwardedProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(forwardedProps, $84531527469341df$var$_excluded);
    const ownerState = themeProps;
    const classes = $84531527469341df$var$useUtilityClasses(ownerState);
    const Root = slots?.root ?? $84531527469341df$var$MultiInputDateRangeFieldRoot;
    const rootProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: otherForwardedProps,
        additionalProps: {
            ref: ref
        },
        ownerState: ownerState,
        className: (0, $5cb909bd25998edc$export$2e2bcd8739ae039)(className, classes.root)
    });
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $97e36ad1d7b41ef9$export$b3e9b101d92e4d4d) : (0, $ea4b9cb15628748b$export$2e2bcd8739ae039));
    const startTextFieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, ownerState, {
            position: "start"
        })
    });
    const endTextFieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        ownerState: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, ownerState, {
            position: "end"
        })
    });
    const Separator = slots?.separator ?? $84531527469341df$var$MultiInputDateRangeFieldSeparator;
    const separatorProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Separator,
        externalSlotProps: slotProps?.separator,
        additionalProps: {
            children: ` ${internalProps.dateSeparator ?? "\u2013"} `
        },
        ownerState: ownerState,
        className: classes.separator
    });
    const fieldResponse = (0, $6ff4cedf45ebff4c$export$7bbd5fc3b71530fb)({
        sharedProps: internalProps,
        startTextFieldProps: startTextFieldProps,
        endTextFieldProps: endTextFieldProps,
        unstableStartFieldRef: unstableStartFieldRef,
        unstableEndFieldRef: unstableEndFieldRef
    });
    const startDateProps = (0, $48579f89749b710b$export$20bf15d9b24b4dad)(fieldResponse.startDate);
    const endDateProps = (0, $48579f89749b710b$export$20bf15d9b24b4dad)(fieldResponse.endDate);
    return /*#__PURE__*/ (0, $592Nh.jsxs)(Root, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)(TextField, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                fullWidth: true
            }, startDateProps)),
            /*#__PURE__*/ (0, $592Nh.jsx)(Separator, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, separatorProps)),
            /*#__PURE__*/ (0, $592Nh.jsx)(TextField, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                fullWidth: true
            }, endDateProps))
        ]
    }));
});





var $2hDQc = parcelRequire("2hDQc");







var $2hDQc = parcelRequire("2hDQc");





const $344fd4ff28f4cfa8$var$_excluded = [
    "clearable",
    "onClear"
];
const $344fd4ff28f4cfa8$var$useMultiInputFieldSlotProps = ({ wrapperVariant: wrapperVariant, open: open, actions: actions, readOnly: readOnly, labelId: labelId, disableOpenPicker: disableOpenPicker, onBlur: onBlur, rangePosition: rangePosition, onRangePositionChange: onRangePositionChange, localeText: inLocaleText, pickerSlotProps: pickerSlotProps, pickerSlots: pickerSlots, fieldProps: fieldProps, anchorRef: anchorRef, currentView: currentView, initialView: initialView, onViewChange: onViewChange, startFieldRef: startFieldRef, endFieldRef: endFieldRef })=>{
    const translations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const handleStartFieldRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(fieldProps.unstableStartFieldRef, startFieldRef);
    const handleEndFieldRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(fieldProps.unstableEndFieldRef, endFieldRef);
    const previousRangePosition = $2hDQc.useRef(rangePosition);
    $2hDQc.useEffect(()=>{
        if (!open) return;
        const currentFieldRef = rangePosition === "start" ? startFieldRef : endFieldRef;
        currentFieldRef.current?.focusField();
        if (!currentFieldRef.current || !currentView) {
            // could happen when the user is switching between the inputs
            previousRangePosition.current = rangePosition;
            return;
        }
        // bring back focus to the field
        currentFieldRef.current.setSelectedSections(// use the current view or `0` when the range position has just been swapped
        previousRangePosition.current === rangePosition ? currentView : 0);
        previousRangePosition.current = rangePosition;
    }, [
        rangePosition,
        open,
        currentView,
        startFieldRef,
        endFieldRef
    ]);
    const openRangeStartSelection = (event)=>{
        event.stopPropagation();
        onRangePositionChange("start");
        if (!readOnly && !disableOpenPicker) actions.onOpen(event);
    };
    const openRangeEndSelection = (event)=>{
        event.stopPropagation();
        onRangePositionChange("end");
        if (!readOnly && !disableOpenPicker) actions.onOpen(event);
    };
    const handleFocusStart = ()=>{
        if (open) {
            onRangePositionChange("start");
            if (previousRangePosition.current !== "start" && initialView) onViewChange?.(initialView);
        }
    };
    const handleFocusEnd = ()=>{
        if (open) {
            onRangePositionChange("end");
            if (previousRangePosition.current !== "end" && initialView) onViewChange?.(initialView);
        }
    };
    const slots = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        textField: pickerSlots?.textField,
        root: pickerSlots?.fieldRoot,
        separator: pickerSlots?.fieldSeparator
    }, fieldProps.slots);
    const slotProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps.slotProps, {
        textField: (ownerState)=>{
            const resolvedComponentProps = (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(pickerSlotProps?.textField, ownerState);
            let textFieldProps;
            let InputProps;
            if (ownerState.position === "start") {
                textFieldProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    label: inLocaleText?.start ?? translations.start,
                    onKeyDown: (0, $5e6b2caee8dd3380$export$4467fe8634707c85)(openRangeStartSelection),
                    onFocus: handleFocusStart,
                    focused: open ? rangePosition === "start" : undefined
                }, !readOnly && !fieldProps.disabled && {
                    onClick: openRangeStartSelection
                }, wrapperVariant === "mobile" && {
                    readOnly: true
                });
                if (anchorRef) InputProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, resolvedComponentProps?.InputProps, {
                    ref: anchorRef
                });
            } else {
                textFieldProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    label: inLocaleText?.end ?? translations.end,
                    onKeyDown: (0, $5e6b2caee8dd3380$export$4467fe8634707c85)(openRangeEndSelection),
                    onFocus: handleFocusEnd,
                    focused: open ? rangePosition === "end" : undefined
                }, !readOnly && !fieldProps.disabled && {
                    onClick: openRangeEndSelection
                }, wrapperVariant === "mobile" && {
                    readOnly: true
                });
                InputProps = resolvedComponentProps?.InputProps;
            }
            return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, labelId != null && {
                id: `${labelId}-${ownerState.position}`
            }, textFieldProps, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(pickerSlotProps?.textField, ownerState), {
                InputProps: InputProps
            });
        },
        root: (ownerState)=>{
            const rootProps = {
                onBlur: onBlur
            };
            return (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, rootProps, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(pickerSlotProps?.fieldRoot, ownerState));
        },
        separator: pickerSlotProps?.fieldSeparator
    });
    /* TODO: remove this when a clearable behavior for multiple input range fields is implemented */ const _ref = fieldProps, restFieldProps = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $344fd4ff28f4cfa8$var$_excluded);
    const enrichedFieldProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, restFieldProps, {
        unstableStartFieldRef: handleStartFieldRef,
        unstableEndFieldRef: handleEndFieldRef,
        slots: slots,
        slotProps: slotProps
    });
    return enrichedFieldProps;
};
const $344fd4ff28f4cfa8$var$useSingleInputFieldSlotProps = ({ wrapperVariant: wrapperVariant, open: open, actions: actions, readOnly: readOnly, labelId: labelId, disableOpenPicker: disableOpenPicker, label: label, onBlur: onBlur, rangePosition: rangePosition, onRangePositionChange: onRangePositionChange, startFieldRef: startFieldRef, endFieldRef: endFieldRef, pickerSlots: pickerSlots, pickerSlotProps: pickerSlotProps, fieldProps: fieldProps, anchorRef: anchorRef, currentView: currentView })=>{
    const handleFieldRef = (0, $7685748376ebf0ad$export$2e2bcd8739ae039)(fieldProps.unstableFieldRef, startFieldRef, endFieldRef);
    $2hDQc.useEffect(()=>{
        if (!open || !startFieldRef.current) return;
        if (startFieldRef.current.isFieldFocused()) return;
        // bring back focus to the field with the current view section selected
        if (currentView) {
            const sections = startFieldRef.current.getSections().map((section)=>section.type);
            const newSelectedSection = rangePosition === "start" ? sections.indexOf(currentView) : sections.lastIndexOf(currentView);
            startFieldRef.current?.focusField(newSelectedSection);
        }
    }, [
        rangePosition,
        open,
        currentView,
        startFieldRef
    ]);
    const updateRangePosition = ()=>{
        if (!startFieldRef.current?.isFieldFocused()) return;
        const sections = startFieldRef.current.getSections();
        const activeSectionIndex = startFieldRef.current?.getActiveSectionIndex();
        const domRangePosition = activeSectionIndex == null || activeSectionIndex < sections.length / 2 ? "start" : "end";
        if (domRangePosition != null && domRangePosition !== rangePosition) onRangePositionChange(domRangePosition);
    };
    const handleSelectedSectionsChange = (0, $b61557e39989b411$export$2e2bcd8739ae039)((selectedSection)=>{
        setTimeout(updateRangePosition);
        fieldProps.onSelectedSectionsChange?.(selectedSection);
    });
    const openPicker = (event)=>{
        event.stopPropagation();
        if (!readOnly && !disableOpenPicker) actions.onOpen(event);
    };
    const slots = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps.slots, {
        textField: pickerSlots?.textField,
        clearButton: pickerSlots?.clearButton,
        clearIcon: pickerSlots?.clearIcon
    });
    const slotProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps.slotProps, {
        textField: pickerSlotProps?.textField,
        clearButton: pickerSlots?.clearButton,
        clearIcon: pickerSlots?.clearIcon
    });
    const enrichedFieldProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, fieldProps, {
        slots: slots,
        slotProps: slotProps,
        label: label,
        unstableFieldRef: handleFieldRef,
        onKeyDown: (0, $5e6b2caee8dd3380$export$4467fe8634707c85)(openPicker, fieldProps.onKeyDown),
        onSelectedSectionsChange: handleSelectedSectionsChange,
        onBlur: onBlur,
        InputProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            ref: anchorRef
        }, fieldProps?.InputProps),
        focused: open ? true : undefined
    }, labelId != null && {
        id: labelId
    }, wrapperVariant === "mobile" && {
        readOnly: true
    }, !readOnly && !fieldProps.disabled && {
        onClick: openPicker
    });
    return enrichedFieldProps;
};
const $344fd4ff28f4cfa8$export$b25f5d250541f495 = (params)=>{
    if (params.fieldType === "multi-input") return $344fd4ff28f4cfa8$var$useMultiInputFieldSlotProps(params);
    return $344fd4ff28f4cfa8$var$useSingleInputFieldSlotProps(params);
/* eslint-enable react-hooks/rules-of-hooks */ };





var $592Nh = parcelRequire("592Nh");
const $049e3e0417930ac3$var$_excluded = [
    "props"
];
const $049e3e0417930ac3$var$releaseInfo = (0, $ac05367139ef9eef$export$edcd7d0b4c3818f)();
const $049e3e0417930ac3$export$caa24fbbedf06392 = (_ref)=>{
    let { props: props } = _ref, pickerParams = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $049e3e0417930ac3$var$_excluded);
    (0, $b9a7540f3ec89ae8$export$bd780281ba7bfd9)("x-date-pickers-pro", $049e3e0417930ac3$var$releaseInfo);
    const { slots: slots, slotProps: slotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, label: label, inputRef: inputRef, name: name, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, disableOpenPicker: disableOpenPicker, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const fieldContainerRef = $2hDQc.useRef(null);
    const anchorRef = $2hDQc.useRef(null);
    const popperRef = $2hDQc.useRef(null);
    const startFieldRef = $2hDQc.useRef(null);
    const endFieldRef = $2hDQc.useRef(null);
    const initialView = $2hDQc.useRef(props.openTo ?? null);
    const fieldType = slots.field.fieldType ?? "multi-input";
    const { rangePosition: rangePosition, onRangePositionChange: onRangePositionChange } = (0, $23c0243990d3594f$export$a08461734e712d56)(props, fieldType === "single-input" ? startFieldRef : undefined);
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $ab66e2d0db94ef47$export$fc3313977ac596c4)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        wrapperVariant: "desktop",
        autoFocusView: false,
        fieldRef: rangePosition === "start" ? startFieldRef : endFieldRef,
        additionalViewProps: {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }
    }));
    $2hDQc.useEffect(()=>{
        if (layoutProps.view) initialView.current = layoutProps.view;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleBlur = ()=>{
        (0, $5e6b2caee8dd3380$export$2e03bc8dde24716b)(()=>{
            if (fieldContainerRef.current?.contains((0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document)) || popperRef.current?.contains((0, $5e6b2caee8dd3380$export$cd4e5573fbe2b576)(document))) return;
            actions.onDismiss();
        });
    };
    const Field = slots.field;
    const fieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: slotProps?.field,
        additionalProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerFieldProps, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            autoFocus: autoFocus && !props.open,
            ref: fieldContainerRef
        }, fieldType === "single-input" ? {
            inputRef: inputRef,
            name: name
        } : {}),
        ownerState: props
    });
    const enrichedFieldProps = (0, $344fd4ff28f4cfa8$export$b25f5d250541f495)({
        wrapperVariant: "desktop",
        fieldType: fieldType,
        open: open,
        actions: actions,
        readOnly: readOnly,
        disableOpenPicker: disableOpenPicker,
        label: label,
        localeText: localeText,
        onBlur: handleBlur,
        rangePosition: rangePosition,
        onRangePositionChange: onRangePositionChange,
        pickerSlotProps: slotProps,
        pickerSlots: slots,
        fieldProps: fieldProps,
        anchorRef: anchorRef,
        startFieldRef: startFieldRef,
        endFieldRef: endFieldRef,
        currentView: layoutProps.view !== props.openTo ? layoutProps.view : undefined,
        initialView: initialView.current ?? undefined,
        onViewChange: layoutProps.onViewChange
    });
    const slotPropsForLayout = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, slotProps, {
        tabs: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, slotProps?.tabs, {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }),
        toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, slotProps?.toolbar, {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        })
    });
    const Layout = slots?.layout ?? (0, $46ae727063dcf2b3$export$647f604ea2397c05);
    const renderPicker = ()=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $99df210e1ad84f76$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)(Field, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, enrichedFieldProps)),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $84e7719119ca70fc$export$96ce8482474de8a5), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                    role: "tooltip",
                    placement: "bottom-start",
                    containerRef: popperRef,
                    anchorEl: anchorRef.current,
                    onBlur: handleBlur
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)(Layout, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotPropsForLayout,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



"use client";
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateRangePicker API](https://mui.com/x/api/date-pickers/desktop-date-range-picker/)
 */ const $8a6e773af186c581$export$55b7a82fef218f2e = /*#__PURE__*/ $2hDQc.forwardRef(function DesktopDateRangePicker(inProps, ref) {
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $9acee118f13df4cd$export$b30bf963bdbf4d5b)(inProps, "MuiDesktopDateRangePicker");
    const viewRenderers = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        day: (0, $e0eb3f34cf503073$export$5aac1f02b93501aa)
    }, defaultizedProps.viewRenderers);
    const props = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        calendars: defaultizedProps.calendars ?? 2,
        views: [
            "day"
        ],
        openTo: "day",
        slots: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            field: (0, $84531527469341df$export$806f5cf21816db1e)
        }, defaultizedProps.slots),
        slotProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $ce5f8da25e363804$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $049e3e0417930ac3$export$caa24fbbedf06392)({
        props: props,
        valueManager: (0, $bc86ae5cc45374b5$export$f0e1e223b0d1e9e1),
        valueType: "date",
        validator: (0, $c2fd1e0b9d0fb131$export$b3e10550232e39db)
    });
    return renderPicker();
});
$8a6e773af186c581$export$55b7a82fef218f2e.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The number of calendars to render on **desktop**.
   * @default 2
   */ calendars: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        1,
        2,
        3
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Position the current month is rendered in.
   * @default 1
   */ currentMonthCalendarPosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        1,
        2,
        3
    ]),
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */ defaultRangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "end",
        "start"
    ]),
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */ disableAutoMonthSwitching: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */ disableDragEditing: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */ inputRef: (0, $4d48afa0e5078fc9$export$2e2bcd8739ae039),
    /**
   * The label content.
   * Ignored if the field has several inputs.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */ onRangePositionChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */ rangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "end",
        "start"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func
    })
};




var $2hDQc = parcelRequire("2hDQc");

var $bZSVP = parcelRequire("bZSVP");










var $2hDQc = parcelRequire("2hDQc");










var $592Nh = parcelRequire("592Nh");
const $37baefd3c2050b10$var$_excluded = [
    "props"
];
const $37baefd3c2050b10$var$releaseInfo = (0, $ac05367139ef9eef$export$edcd7d0b4c3818f)();
const $37baefd3c2050b10$export$cb5e55a8cf673aad = (_ref)=>{
    let { props: props } = _ref, pickerParams = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(_ref, $37baefd3c2050b10$var$_excluded);
    (0, $b9a7540f3ec89ae8$export$bd780281ba7bfd9)("x-date-pickers-pro", $37baefd3c2050b10$var$releaseInfo);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, label: label, inputRef: inputRef, name: name, readOnly: readOnly, disabled: disabled, disableOpenPicker: disableOpenPicker, localeText: localeText } = props;
    const startFieldRef = $2hDQc.useRef(null);
    const endFieldRef = $2hDQc.useRef(null);
    const fieldType = slots.field.fieldType ?? "multi-input";
    const { rangePosition: rangePosition, onRangePositionChange: onRangePositionChange } = (0, $23c0243990d3594f$export$a08461734e712d56)(props, fieldType === "single-input" ? startFieldRef : undefined);
    const labelId = (0, $c2cd4d1945fef3ba$export$2e2bcd8739ae039)();
    const contextTranslations = (0, $802219c7e61ac159$export$3cdcc56057891b44)();
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $ab66e2d0db94ef47$export$fc3313977ac596c4)((0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        wrapperVariant: "mobile",
        autoFocusView: true,
        fieldRef: rangePosition === "start" ? startFieldRef : endFieldRef,
        additionalViewProps: {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }
    }));
    const Field = slots.field;
    const fieldProps = (0, $1543fd145b554948$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, pickerFieldProps, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone
        }, fieldType === "single-input" ? {
            inputRef: inputRef,
            name: name
        } : {}),
        ownerState: props
    });
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const enrichedFieldProps = (0, $344fd4ff28f4cfa8$export$b25f5d250541f495)({
        wrapperVariant: "mobile",
        fieldType: fieldType,
        open: open,
        actions: actions,
        readOnly: readOnly,
        labelId: labelId,
        disableOpenPicker: disableOpenPicker,
        label: label,
        localeText: localeText,
        rangePosition: rangePosition,
        onRangePositionChange: onRangePositionChange,
        pickerSlots: slots,
        pickerSlotProps: innerSlotProps,
        fieldProps: fieldProps,
        startFieldRef: startFieldRef,
        endFieldRef: endFieldRef
    });
    const slotPropsForLayout = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps, {
        tabs: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps?.tabs, {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }),
        toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId,
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        })
    });
    const Layout = slots?.layout ?? (0, $46ae727063dcf2b3$export$647f604ea2397c05);
    const finalLocaleText = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, contextTranslations, localeText);
    let labelledById = pickerParams.valueType === "date-time" ? `${labelId}-start-toolbar ${labelId}-end-toolbar` : labelId;
    if (isToolbarHidden) {
        const labels = [];
        if (fieldType === "multi-input") {
            if (finalLocaleText.start) labels.push(`${labelId}-start-label`);
            if (finalLocaleText.end) labels.push(`${labelId}-end-label`);
        } else if (label != null) labels.push(`${labelId}-label`);
        labelledById = labels.length > 0 ? labels.join(" ") : undefined;
    }
    const slotProps = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, innerSlotProps, {
        mobilePaper: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $99df210e1ad84f76$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)(Field, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, enrichedFieldProps)),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $73e8d2e22730b6dc$export$99f83c99e1491f77), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)(Layout, (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotPropsForLayout,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



"use client";
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateRangePicker API](https://mui.com/x/api/date-pickers/mobile-date-range-picker/)
 */ const $b31fe81efa18e079$export$8a80efd334695326 = /*#__PURE__*/ $2hDQc.forwardRef(function MobileDateRangePicker(inProps, ref) {
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $9acee118f13df4cd$export$b30bf963bdbf4d5b)(inProps, "MuiMobileDateRangePicker");
    const viewRenderers = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        day: (0, $e0eb3f34cf503073$export$5aac1f02b93501aa)
    }, defaultizedProps.viewRenderers);
    const props = (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        // Force one calendar on mobile to avoid layout issues
        calendars: 1,
        views: [
            "day"
        ],
        openTo: "day",
        slots: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
            field: (0, $84531527469341df$export$806f5cf21816db1e)
        }, defaultizedProps.slots),
        slotProps: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $9773b6a5491c527c$export$2e2bcd8739ae039)({}, (0, $e70b7281efcbe69a$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $ce5f8da25e363804$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $37baefd3c2050b10$export$cb5e55a8cf673aad)({
        props: props,
        valueManager: (0, $bc86ae5cc45374b5$export$f0e1e223b0d1e9e1),
        valueType: "date",
        validator: (0, $c2fd1e0b9d0fb131$export$b3e10550232e39db)
    });
    return renderPicker();
});
$b31fe81efa18e079$export$8a80efd334695326.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Position the current month is rendered in.
   * @default 1
   */ currentMonthCalendarPosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        1,
        2,
        3
    ]),
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */ defaultRangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "end",
        "start"
    ]),
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */ disableAutoMonthSwitching: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */ disableDragEditing: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */ inputRef: (0, $4d48afa0e5078fc9$export$2e2bcd8739ae039),
    /**
   * The label content.
   * Ignored if the field has several inputs.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */ onRangePositionChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */ rangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
        "end",
        "start"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).object),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bZSVP))).func
    })
};



var $592Nh = parcelRequire("592Nh");
"use client";
const $e55117dd53268a5a$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateRangePicker API](https://mui.com/x/api/date-pickers/date-range-picker/)
 */ const $e55117dd53268a5a$export$17334619f3ac2224 = /*#__PURE__*/ $2hDQc.forwardRef(function DateRangePicker(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDateRangePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = "@media (pointer: fine)" } = props, other = (0, $4236c3996bc2da77$export$2e2bcd8739ae039)(props, $e55117dd53268a5a$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $ef97679917c36082$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8a6e773af186c581$export$55b7a82fef218f2e), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $b31fe81efa18e079$export$8a80efd334695326), (0, $9773b6a5491c527c$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});






const $510d727bd2cf7233$var$BASE_URL = `${(0, $1ff9aa7c00d3fc54$export$ff0725f0ea898f41)}/reports`;
const $510d727bd2cf7233$var$getCataloguesReport = (customerIds, validFrom, validUntil)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${$510d727bd2cf7233$var$BASE_URL}/catalogues`, {
        customerIds: customerIds,
        validFrom: validFrom,
        validUntil: validUntil
    });
};
const $510d727bd2cf7233$var$getRightsReport = (customerIds, validFrom, validUntil)=>{
    return (0, $0c6c769a0b0e21f2$export$388e0302ca0d9a41).post(`${$510d727bd2cf7233$var$BASE_URL}/rights`, {
        customerIds: customerIds,
        validFrom: validFrom,
        validUntil: validUntil
    });
};
const $510d727bd2cf7233$export$3e8100f11d458d8a = {
    getCataloguesReport: $510d727bd2cf7233$var$getCataloguesReport,
    getRightsReport: $510d727bd2cf7233$var$getRightsReport
};



var $b89b2b33b5e13322$exports = {};
/* jshint node:true */ "use strict";
var $2add09ec268f5077$exports = {};
/* jshint node:true */ "use strict";
var $0269c5dfdb37c44b$exports = {};
var $fa6ab549777755a0$exports = {};
/* jshint node:true */ "use strict";

$fa6ab549777755a0$exports = (parcelRequire("gKvxL")).EOL;


var $d24fb36fc4688c6e$export$f6e2535fb5126e54;
var $d24fb36fc4688c6e$export$43bee75e5e14138e;
var $d24fb36fc4688c6e$export$a6cdc56e425d0d0a;
var $d24fb36fc4688c6e$export$844ec244b1367d54;
var $d24fb36fc4688c6e$export$7e4aa119212bc614;
var $d24fb36fc4688c6e$export$f9ce7b637dfbe238;
var $d24fb36fc4688c6e$export$871608497c498473;
"use strict";
$d24fb36fc4688c6e$export$f6e2535fb5126e54 = (fn)=>{
    var getType = {};
    return fn && getType.toString.call(fn) === "[object Function]";
};
$d24fb36fc4688c6e$export$43bee75e5e14138e = (arr)=>Array.isArray(arr);
$d24fb36fc4688c6e$export$a6cdc56e425d0d0a = (obj)=>obj instanceof Object;
$d24fb36fc4688c6e$export$844ec244b1367d54 = (str)=>typeof str === "string";
$d24fb36fc4688c6e$export$7e4aa119212bc614 = (num)=>typeof num === "number";
$d24fb36fc4688c6e$export$f9ce7b637dfbe238 = (bool)=>typeof bool === "boolean";
$d24fb36fc4688c6e$export$871608497c498473 = (date)=>date instanceof Date;


$0269c5dfdb37c44b$exports = function joinRows(rows, join) {
    if (!rows || !$d24fb36fc4688c6e$export$43bee75e5e14138e(rows)) throw new TypeError('Invalid params "rows" for joinRows. Must be an array of string.');
    //Merge all rows in a single output with the correct End of Line string
    var r = rows.join(join || $fa6ab549777755a0$exports || "\n");
    return r;
};


var $02561390981e2e84$exports = {};
/* jshint node:true */ "use strict";

class $02561390981e2e84$var$Handler {
    constructor(options){
        this._options = options;
        // an object of {typeName:(value,index,parent)=>any}
        this._options.typeHandlers = this._options.typeHandlers || {};
    }
    /**
   * Check if results needing mapping to alternate value
   *
   * @returns [{item, value}] result
   */ _setHeaders(result, item) {
        let self = this;
        if (!item) return result;
        return result.map(function(element) {
            element.item = element.item ? item + self._options.headerPathString + element.item : item;
            return element;
        });
    }
    castValue(element, item, index, parent) {
        //cast by matching constructor
        const types = this._options.typeHandlers;
        for(let type in types)if ($02561390981e2e84$var$isInstanceOfTypeName(element, type)) {
            element = types[type].call(types, element, index, parent);
            break; //first match we move on
        }
        return element;
    }
    checkComplex(element, item) {
        //Check if element is a Date
        if ($d24fb36fc4688c6e$export$871608497c498473(element)) return [
            {
                item: item,
                value: (this._options.handleDate || this._handleDate)(element, item)
            }
        ];
        else if ($d24fb36fc4688c6e$export$43bee75e5e14138e(element)) {
            var resultArray = this._handleArray(element, item);
            return this._setHeaders(resultArray, item);
        } else if ($d24fb36fc4688c6e$export$a6cdc56e425d0d0a(element)) {
            var resultObject = this._handleObject(element);
            return this._setHeaders(resultObject, item);
        }
        return [
            {
                item: item,
                value: ""
            }
        ];
    }
    /**
   * Check the element type of the element call the correct handle function
   *
   * @param element Element that will be checked
   * @param item Used to make the headers/path breadcrumb
   * @returns [{item, value}] result
   */ check(element, item, index, parent) {
        element = this.castValue(element, item, index, parent);
        // try simple value by highier performance switch
        switch(typeof element){
            case "string":
                return [
                    {
                        item: item,
                        value: this._handleString(element, item)
                    }
                ];
            case "number":
                return [
                    {
                        item: item,
                        value: this._handleNumber(element, item)
                    }
                ];
            case "boolean":
                return [
                    {
                        item: item,
                        value: this._handleBoolean.bind(this)(element, item)
                    }
                ];
        }
        return this.checkComplex(element, item);
    }
    /**
   * Handle all Objects
   *
   * @param {Object} obj
   * @returns [{item, value}] result
   */ _handleObject(obj) {
        var result = [];
        //Look every object props
        for(var prop in obj){
            var propData = obj[prop];
            //Check the propData type
            var resultCheckType = this.check(propData, prop, prop, obj);
            //Append to results aka merge results aka array-append-array
            result = result.concat(resultCheckType);
        }
        return result;
    }
    /**
   * Handle all Arrays, merges arrays with primitive types in a single value
   *
   * @param {Array} array
   * @returns [{item, value}] result
   */ _handleArray(array) {
        let self = this;
        let result = [];
        var firstElementWithoutItem;
        for(let aIndex = 0; aIndex < array.length; ++aIndex){
            let element = array[aIndex];
            //Check the propData type
            var resultCheckType = self.check(element, null, aIndex, array);
            //Check for results without itens, merge all itens with the first occurrence
            if (resultCheckType.length === 0) continue;
            var firstResult = resultCheckType[0];
            if (!firstResult.item && firstElementWithoutItem !== undefined) {
                firstElementWithoutItem.value += self._options.arrayPathString + firstResult.value;
                continue;
            } else if (resultCheckType.length > 0 && !firstResult.item && firstElementWithoutItem === undefined) firstElementWithoutItem = firstResult;
            //Append to results
            result = result.concat(resultCheckType);
        }
        return result;
    }
    /**
   * Handle all Boolean variables, can be replaced with options.handleBoolean
   *
   * @param {Boolean} boolean
   * @returns {String} result
   */ _handleBoolean(boolean) {
        var result;
        //Check for booolean options
        if (boolean) result = this._options.booleanTrueString || "true";
        else result = this._options.booleanFalseString || "false";
        return result;
    }
    /**
   * Handle all String variables, can be replaced with options.handleString
   *
   * @param {String} string
   * @returns {String} string
   */ _handleString(string) {
        return string;
    }
    /**
   * Handle all Number variables, can be replaced with options.handleNumber
   *
   * @param {Number} number
   * @returns {Number} number
   */ _handleNumber(number) {
        return number;
    }
    /**
   * Handle all Date variables, can be replaced with options.handleDate
   *
   * @param {Date} number
   * @returns {string} result
   */ _handleDate(date) {
        return date.toLocaleDateString();
    }
}
$02561390981e2e84$exports = $02561390981e2e84$var$Handler;
const $02561390981e2e84$var$globalScope = typeof window === "undefined" ? $parcel$global : window;
function $02561390981e2e84$var$isInstanceOfTypeName(element, typeName) {
    if (element instanceof $02561390981e2e84$var$globalScope[typeName]) return true; //Buffer and complex objects
    //literals in javascript cannot be checked by instance of
    switch(typeof element){
        case "string":
            return typeName === "String";
        case "boolean":
            return typeName === "Boolean";
        case "number":
            return typeName === "Number";
    }
    return false;
}




class $2add09ec268f5077$var$Parser {
    constructor(options){
        this._options = options || {};
        this._handler = new $02561390981e2e84$exports(this._options);
        this._headers = this._options.headers || [];
        this._escape = (parcelRequire("64BeW"))(this._options.textDelimiter, this._options.rowDelimiter, this._options.forceTextDelimiter);
    }
    /**
   * Generates a CSV file with optional headers based on the passed JSON,
   * with can be an Object or Array.
   *
   * @param {Object|Array} json
   * @param {Function} done(err,csv) - Callback function
   *      if error, returning error in call back.
   *      if csv is created successfully, returning csv output to callback.
   */ parse(json, done, stream) {
        if ($d24fb36fc4688c6e$export$43bee75e5e14138e(json)) return done(null, this._parseArray(json, stream));
        else if ($d24fb36fc4688c6e$export$a6cdc56e425d0d0a(json)) return done(null, this._parseObject(json));
        return done(new Error("Unable to parse the JSON object, its not an Array or Object."));
    }
    get headers() {
        let headers = this._headers;
        if (this._options.rename && this._options.rename.length > 0) headers = headers.map((header)=>this._options.rename[this._options.headers.indexOf(header)] || header);
        if (this._options.forceTextDelimiter) headers = headers.map((header)=>{
            return `${this._options.textDelimiter}${header}${this._options.textDelimiter}`;
        });
        if (this._options.mapHeaders) headers = headers.map(this._options.mapHeaders);
        return headers.join(this._options.rowDelimiter);
    }
    _checkRows(rows) {
        let lastRow = null;
        let finalRows = [];
        let fillGaps = (col, index)=>col === "" || col === undefined ? lastRow[index] : col;
        for (let row of rows){
            let missing = this._headers.length - row.length;
            if (missing > 0) row = row.concat(Array(missing).join(".").split("."));
            if (lastRow && this._options.fillGaps) row = row.map(fillGaps);
            finalRows.push(row.join(this._options.rowDelimiter));
            lastRow = row;
        }
        return finalRows;
    }
    _parseArray(json, stream) {
        let self = this;
        this._headers = this._headers || [];
        let fileRows = [];
        let outputFile;
        let fillRows;
        let getHeaderIndex = function(header) {
            var index = self._headers.indexOf(header);
            if (index === -1) {
                self._headers.push(header);
                index = self._headers.indexOf(header);
            }
            return index;
        };
        //Generate the csv output
        fillRows = function(result) {
            const rows = [];
            const fillAndPush = (row)=>rows.push(row.map((col)=>col != null ? col : ""));
            // initialize the array with empty strings to handle 'unpopular' headers
            const newRow = ()=>new Array(self._headers.length).fill(null);
            const emptyRowIndexByHeader = {};
            let currentRow = newRow();
            for (let element of result){
                let elementHeaderIndex = getHeaderIndex(element.item);
                if (currentRow[elementHeaderIndex] != undefined) {
                    fillAndPush(currentRow);
                    currentRow = newRow();
                }
                emptyRowIndexByHeader[elementHeaderIndex] = emptyRowIndexByHeader[elementHeaderIndex] || 0;
                // make sure there isn't a empty row for this header
                if (self._options.fillTopRow && emptyRowIndexByHeader[elementHeaderIndex] < rows.length) {
                    rows[emptyRowIndexByHeader[elementHeaderIndex]][elementHeaderIndex] = self._escape(element.value);
                    emptyRowIndexByHeader[elementHeaderIndex] += 1;
                    continue;
                }
                currentRow[elementHeaderIndex] = self._escape(element.value);
                emptyRowIndexByHeader[elementHeaderIndex] += 1;
            }
            // push last row
            if (currentRow.length > 0) fillAndPush(currentRow);
            fileRows = fileRows.concat(self._checkRows(rows));
        };
        for (let item of json){
            //Call checkType to list all items inside this object
            //Items are returned as a object {item: 'Prop Value, Item Name', value: 'Prop Data Value'}
            let itemResult = self._handler.check(item, self._options.mainPathItem, item, json);
            fillRows(itemResult);
        }
        if (!stream && self._options.includeHeaders) //Add the headers to the first line
        fileRows.unshift(this.headers);
        return $0269c5dfdb37c44b$exports(fileRows, self._options.endOfLine);
    }
    _parseObject(json) {
        let self = this;
        let fileRows = [];
        let parseResult = [];
        let outputFile;
        let fillRows;
        let horizontalRows = [
            [],
            []
        ];
        fillRows = function(result) {
            var value = result.value || result.value === 0 ? result.value.toString() : self._options.undefinedString;
            value = self._escape(value);
            //Type header;value
            if (self._options.verticalOutput) {
                var row = [
                    result.item,
                    value
                ];
                fileRows.push(row.join(self._options.rowDelimiter));
            } else {
                horizontalRows[0].push(result.item);
                horizontalRows[1].push(value);
            }
        };
        for(var prop in json){
            var prefix = "";
            if (this._options.mainPathItem) prefix = this._options.mainPathItem + this._options.headerPathString;
            parseResult = this._handler.check(json[prop], prefix + prop, prop, json);
            parseResult.forEach(fillRows);
        }
        if (!this._options.verticalOutput) {
            fileRows.push(horizontalRows[0].join(this._options.rowDelimiter));
            fileRows.push(horizontalRows[1].join(this._options.rowDelimiter));
        }
        return $0269c5dfdb37c44b$exports(fileRows, this._options.endOfLine);
    }
}
$2add09ec268f5077$exports = $2add09ec268f5077$var$Parser;


var $8f26084d265ba64d$exports = {};
/* jshint node:true */ "use strict";
var $d89ed4411ab773a4$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
$d89ed4411ab773a4$exports = $d89ed4411ab773a4$var$Stream;

var $61zqF = parcelRequire("61zqF");
var $d89ed4411ab773a4$require$EE = $61zqF.EventEmitter;

var $6a1gD = parcelRequire("6a1gD");
$6a1gD($d89ed4411ab773a4$var$Stream, $d89ed4411ab773a4$require$EE);

$d89ed4411ab773a4$var$Stream.Readable = (parcelRequire("lIilJ"));

$d89ed4411ab773a4$var$Stream.Writable = (parcelRequire("jee39"));

$d89ed4411ab773a4$var$Stream.Duplex = (parcelRequire("bKtym"));

$d89ed4411ab773a4$var$Stream.Transform = (parcelRequire("gULOi"));

$d89ed4411ab773a4$var$Stream.PassThrough = (parcelRequire("bjyQX"));

$d89ed4411ab773a4$var$Stream.finished = (parcelRequire("c48Is"));

$d89ed4411ab773a4$var$Stream.pipeline = (parcelRequire("fNxwk"));
// Backwards-compat with node 0.4.x
$d89ed4411ab773a4$var$Stream.Stream = $d89ed4411ab773a4$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d89ed4411ab773a4$var$Stream() {
    $d89ed4411ab773a4$require$EE.call(this);
}
$d89ed4411ab773a4$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d89ed4411ab773a4$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};


var $8f26084d265ba64d$require$Transform = $d89ed4411ab773a4$exports.Transform;
class $8f26084d265ba64d$var$Stream extends $8f26084d265ba64d$require$Transform {
    constructor(parser){
        super();
        this._parser = parser;
        this._options = parser._options;
        this._headers = this._options.headers || [];
        this._hasHeaders = false;
        this._lastError = null;
    }
    _mergeChunk(chunk) {
        let self = this;
        self._extra = self._extra || "";
        // Remove starting comma
        if (self._extra.charAt(0) == ",") self._extra = self._extra.substr(1);
        // Append extra to chunk
        chunk = self._extra + chunk.toString();
        // Clear extra memory
        if (self._extra.length > 0) self._extra = "";
        return chunk;
    }
    _wrapArray(data) {
        if (data.charAt(0) != "[") data = "[" + data;
        if (data.charAt(data.length - 1) != "]") data += "]";
        return data;
    }
    _transform(chunk, encoding, done) {
        let self = this;
        let json = null;
        // Append extra data to chunk data
        chunk = this._mergeChunk(chunk);
        if (!chunk) return done(this._lastError);
        // Split chunk in objects
        let parts = chunk.split("}");
        while(json === null && parts.length > 0)try {
            let data = self._wrapArray(parts.join("}"));
            json = JSON.parse(data);
        } catch (ex) {
            this._lastError = ex;
            let extraChunk = parts.pop();
            self._extra = extraChunk + (self._extra || "");
            if (parts.length > 0) parts[parts.length - 1] += "}";
        }
        if (!json) return done();
        this._parser.parse(json, (err, csvChunk)=>{
            if (err) return done(err);
            if (!self.hasHeaders) {
                self.hasHeaders = true;
                self.push(self._parser.headers);
            }
            self.push(self._options.endOfLine + csvChunk);
            done();
        }, true);
    }
}
$8f26084d265ba64d$exports = $8f26084d265ba64d$var$Stream;




/**
 * Main function that converts json to csv
 *
 * @param {Object|Array} json
 * @param {Object} [options]
 * @param {Function} callback(err, csv) - Callback function
 *      if error, returning error in call back.
 *      if csv is created successfully, returning csv output to callback.
 */ $b89b2b33b5e13322$exports = function() {
    const DEFAULT_OPTIONS = {
        headers: [],
        rename: [],
        headerPathString: ".",
        rowDelimiter: ",",
        textDelimiter: '"',
        arrayPathString: ";",
        undefinedString: "",
        endOfLine: $fa6ab549777755a0$exports || "\n",
        mainPathItem: null,
        booleanTrueString: null,
        booleanFalseString: null,
        includeHeaders: true,
        fillGaps: false,
        verticalOutput: true,
        forceTextDelimiter: false
    };
    // argument parsing
    let json, userOptions, callback;
    if (arguments.length === 3) [json, userOptions, callback] = arguments;
    else if (arguments.length === 2) {
        let any;
        [json, any] = arguments;
        if (typeof any === "function") callback = any;
        else if (typeof any === "object") userOptions = any;
    } else if (arguments.length === 1) {
        const [any] = arguments;
        if (typeof any === "object") {
            const defaultKeys = Object.keys(DEFAULT_OPTIONS);
            const objectKeys = Object.keys(any);
            const isOptions = objectKeys.every((key)=>defaultKeys.includes(key));
            if (objectKeys.length > 0 && isOptions) userOptions = any;
            else json = any;
        } else json = any;
    } else return new $8f26084d265ba64d$exports(new $2add09ec268f5077$exports(DEFAULT_OPTIONS));
    const options = Object.assign({}, DEFAULT_OPTIONS, userOptions);
    const parser = new $2add09ec268f5077$exports(options);
    // if no json is provided Stream API will be used
    if (!json) return new $8f26084d265ba64d$exports(parser);
    // always return an promise
    return new Promise((resolve, reject)=>{
        parser.parse(json, (err, result)=>{
            if (callback) return callback(err, result);
            if (err) return reject(err);
            if (reject) return resolve(result);
        });
    });
};




const $66918ae2d7734ad3$var$Reports = ()=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { locale: locale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const [selectedCustomerId, setSelectedCustomerId] = (0, $2hDQc.useState)("");
    const [reportType, setReportType] = (0, $2hDQc.useState)(isPermission("READ", "CATALOGUE_REPORTS") ? "LANDLORD" : "TENANT");
    const initialDateTime = (0, $f65046485b965c63$exports.DateTime).local().setLocale(locale || "fi");
    const [givenStartDate, setGivenStartDate] = (0, $2hDQc.useState)(initialDateTime.startOf("day"));
    const [givenEndDate, setGivenEndDate] = (0, $2hDQc.useState)(initialDateTime.endOf("day"));
    const queryCustomers = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$6efe1800fcda6819)
        ],
        // TODO Antti: Should be fixed later because there might be more than 500 customers.
        queryFn: ()=>(0, $fb3b91fdd894004c$export$2e2bcd8739ae039).getCustomers(false, {
                limit: 500,
                sort: "TYPE",
                direction: "ASC"
            }),
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const customers = queryCustomers.data?.data || [];
    const customerOptions = customers.map((item)=>{
        return {
            key: item.id,
            value: item.name
        };
    });
    if (customerOptions.length > 1) customerOptions.unshift({
        key: "ALL",
        value: intl.formatMessage({
            id: "page.reports.customer.all"
        })
    });
    const customerIds = selectedCustomerId === "ALL" ? customerOptions.slice(1).map((item)=>item.key) : [
        selectedCustomerId
    ];
    const successHandler = async (data)=>{
        if (!data || data.data.length == 0) {
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.reports.toast.error.emptyReport"
            }));
            return;
        }
        try {
            const result = await generateCSVReport(data);
            generateCSVFile(data.reportName, result);
        } catch (e) {
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.reports.toast.error.csvFailed"
            }), false);
        }
    };
    const cataloguesMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $510d727bd2cf7233$export$3e8100f11d458d8a).getCataloguesReport(customerIds, (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(givenStartDate), (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(givenEndDate)),
        onSuccess: (response)=>successHandler(response.data)
    });
    const rightsMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $510d727bd2cf7233$export$3e8100f11d458d8a).getRightsReport(customerIds, (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(givenStartDate), (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).toUTC(givenEndDate)),
        onSuccess: (response)=>successHandler(response.data)
    });
    (0, $2hDQc.useEffect)(()=>{
        if (queryCustomers.isSuccess && !selectedCustomerId && customerOptions.length > 0) setSelectedCustomerId(customerOptions[0].key);
    }, [
        queryCustomers.isSuccess
    ]);
    const generateCSVReport = (reportResponse)=>{
        return new Promise((resolve, reject)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($b89b2b33b5e13322$exports)))(reportResponse.data, (err, csv)=>{
                if (err) return reject(new Error("CSV generation failed"));
                resolve(csv);
            });
        });
    };
    const generateCSVFile = (reportName, result)=>{
        const startDate = givenStartDate ? (0, $4ea31e1953a3d675$export$6c3b6c09c58d6bc3).toCustomString(givenStartDate) : "";
        const endDate = givenEndDate ? (0, $4ea31e1953a3d675$export$6c3b6c09c58d6bc3).toCustomString(givenEndDate) : "";
        const filename = `${reportName}-${startDate}-${endDate}`;
        const blob = new Blob([
            result
        ], {
            type: "data:text/csv;charset=utf-8,"
        });
        const blobURL = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.download = `${filename}.csv`;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href
        ].join(":");
        anchor.click();
        // Remove URL.createObjectURL. The browser should not save the reference to the file.
        setTimeout(()=>{
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
        }, 100);
    };
    const requestReport = ()=>{
        if (!givenStartDate && !givenEndDate && !selectedCustomerId) return;
        switch(reportType){
            case "LANDLORD":
                cataloguesMutation.mutate();
                break;
            case "TENANT":
                rightsMutation.mutate();
                break;
            default:
                (0, $ee9cb80b5c23ac97$export$16bf6fe03653420f)(reportType);
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryCustomers,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.reports.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)("form", {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                container: true,
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                                                        mutation: cataloguesMutation,
                                                        errorTitleKey: "common.actions.get.error"
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                                                        mutation: rightsMutation,
                                                        errorTitleKey: "common.actions.get.error"
                                                    })
                                                ]
                                            }),
                                            (isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS")) && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b34bb119bbd6d528$export$2e2bcd8739ae039), {
                                                    value: reportType,
                                                    onChange: (event)=>setReportType(event.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                                                            sx: {
                                                                fontWeight: "bold"
                                                            },
                                                            focused: false,
                                                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                                id: "page.reports.type.radioGroup.title"
                                                            })
                                                        }),
                                                        isPermission("READ", "CATALOGUE_REPORTS") && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormRadio, {
                                                            control: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b716fe5ce517ca5d$export$2e2bcd8739ae039), {}),
                                                            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                                id: "page.reports.type.radioGroup.landlord"
                                                            }),
                                                            value: "LANDLORD"
                                                        }),
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormRadio, {
                                                            control: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b716fe5ce517ca5d$export$2e2bcd8739ae039), {}),
                                                            label: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                                id: "page.reports.type.radioGroup.tenant"
                                                            }),
                                                            value: "TENANT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                focused: false,
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.reports.customer.title"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormSelect, {
                                                    name: "customerId",
                                                    label: intl.formatMessage({
                                                        id: "page.reports.customer.label"
                                                    }),
                                                    value: selectedCustomerId,
                                                    onChange: (event)=>setSelectedCustomerId(event?.target?.value || ""),
                                                    children: customerOptions.map((item)=>{
                                                        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                                                            value: item.key,
                                                            children: item.value
                                                        }, item.key);
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormLabel, {
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                focused: false,
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "page.reports.range.title"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $df0187c1973aff1d$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $e55117dd53268a5a$export$17334619f3ac2224), {
                                                        localeText: {
                                                            start: intl.formatMessage({
                                                                id: "page.reports.daterange.start"
                                                            }),
                                                            end: intl.formatMessage({
                                                                id: "page.reports.daterange.end"
                                                            }),
                                                            toolbarTitle: intl.formatMessage({
                                                                id: "page.reports.range.title"
                                                            }),
                                                            cancelButtonLabel: intl.formatMessage({
                                                                id: "common.buttons.cancel"
                                                            }),
                                                            clearButtonLabel: intl.formatMessage({
                                                                id: "common.buttons.clear"
                                                            }),
                                                            okButtonLabel: intl.formatMessage({
                                                                id: "common.ok"
                                                            })
                                                        },
                                                        value: [
                                                            givenStartDate,
                                                            givenEndDate
                                                        ],
                                                        displayWeekNumber: true,
                                                        onAccept: (values)=>{
                                                            const startDate = values[0];
                                                            const endDate = values[1];
                                                            setGivenStartDate(startDate || initialDateTime.startOf("day"));
                                                            setGivenEndDate(endDate || initialDateTime.endOf("day"));
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: (isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS")) && /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                                    onClick: requestReport,
                                                    mutation: reportType === "LANDLORD" ? cataloguesMutation : rightsMutation,
                                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                        id: "page.reports.submit.button"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $66918ae2d7734ad3$export$2e2bcd8739ae039 = $66918ae2d7734ad3$var$Reports;



var $592Nh = parcelRequire("592Nh");




var $592Nh = parcelRequire("592Nh");

var $592Nh = parcelRequire("592Nh");


var $2hDQc = parcelRequire("2hDQc");


var $5pzCu = parcelRequire("5pzCu");


const $f5d52d00b84dc248$var$FormEditRightHolder = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const getRightHolderValues = ()=>{
        let firstName, lastName, email, phoneNumber, licensePlate = "";
        if (props.rightHolder?.type === "individual") {
            const dataIndividual = props.rightHolder;
            firstName = dataIndividual.firstName;
            lastName = dataIndividual.lastName;
            email = dataIndividual.email;
            phoneNumber = dataIndividual.phoneNumber;
        } else if (props.rightHolder?.type === "vehicle") {
            const dataVehicle = props.rightHolder;
            licensePlate = dataVehicle.licensePlate;
        }
        return {
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phoneNumber,
            licensePlate: licensePlate
        };
    };
    const getFormDefaultValues = ()=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate } = getRightHolderValues();
        return {
            firstName: firstName || "",
            lastName: lastName || "",
            email: email || "",
            phoneNumber: phoneNumber || "",
            licensePlate: licensePlate || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const schemaValidator = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            firstName: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("firstName", intl.formatMessage({
                id: "common.form.errors.empty"
            }), function(firstName) {
                return props.rightHolder?.type !== "individual" || !!firstName;
            }),
            lastName: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("lastName", intl.formatMessage({
                id: "common.form.errors.empty"
            }), function(lastName) {
                return props.rightHolder?.type !== "individual" || !!lastName;
            }),
            email: $7a5dda49dca6ae9d$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return props.rightHolder?.type !== "individual" || (0, $066f7ec5b64309d3$export$371e338370561054)(email);
            }),
            phoneNumber: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("phoneNumber", intl.formatMessage({
                id: "common.form.errors.phoneNumber"
            }), function(phoneNumber) {
                return props.rightHolder?.type !== "individual" || (0, $066f7ec5b64309d3$export$dda1dcb0216445cd)(phoneNumber);
            }),
            licensePlate: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
                id: "common.form.errors.licensePlate"
            }), function(licensePlate) {
                return props.rightHolder?.type !== "vehicle" || (0, $066f7ec5b64309d3$export$dddb845077defee2)(licensePlate);
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate } = values;
        if (props.rightHolder?.type === "individual") props.onSubmit({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            phoneNumber: phoneNumber
        });
        else props.onSubmit({
            firstName: undefined,
            lastName: undefined,
            email: undefined,
            phoneNumber: undefined,
            licensePlate: licensePlate.trim().toLocaleUpperCase()
        });
    };
    const FormIndividual = ({ values: values, handleChange: handleChange, errors: errors })=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "firstName",
                            "data-testid": "firstName",
                            value: values.firstName,
                            label: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.firstName"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.firstName"
                            }),
                            onChange: handleChange,
                            error: !!errors.firstName,
                            errorText: errors.firstName
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "lastName",
                            "data-testid": "lastName",
                            value: values.lastName,
                            label: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.lastName"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.lastName"
                            }),
                            onChange: handleChange,
                            error: !!errors.lastName,
                            errorText: errors.lastName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormBoxRow, {
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "email",
                            "data-testid": "email",
                            value: values.email,
                            label: intl.formatMessage({
                                id: "common.text.email"
                            }),
                            placeholder: intl.formatMessage({
                                id: "common.text.email"
                            }),
                            onChange: handleChange,
                            error: !!errors.email,
                            errorText: errors.email
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                            name: "phoneNumber",
                            "data-testid": "phoneNumber",
                            value: values.phoneNumber,
                            label: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber"
                            }),
                            onChange: handleChange,
                            error: !!errors.phoneNumber,
                            errorText: errors.phoneNumber
                        })
                    ]
                })
            ]
        });
    };
    const FormVehicle = ({ values: values, handleChange: handleChange, errors: errors })=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                name: "licensePlate",
                "data-testid": "licensePlate",
                value: values.licensePlate,
                label: intl.formatMessage({
                    id: "common.text.licensePlate"
                }),
                placeholder: intl.formatMessage({
                    id: "common.text.licensePlate"
                }),
                onChange: handleChange,
                error: !!errors.licensePlate,
                errorText: errors.licensePlate
            })
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: schemaValidator(),
            enableReinitialize: true,
            initialValues: getFormDefaultValues(),
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            props.rightHolder?.type === "individual" && /*#__PURE__*/ (0, $592Nh.jsx)(FormIndividual, {
                                values: values,
                                handleChange: handleChange,
                                errors: errors
                            }),
                            props.rightHolder?.type === "vehicle" && /*#__PURE__*/ (0, $592Nh.jsx)(FormVehicle, {
                                values: values,
                                handleChange: handleChange,
                                errors: errors
                            })
                        ]
                    })
                })
        })
    });
};
var $f5d52d00b84dc248$export$2e2bcd8739ae039 = $f5d52d00b84dc248$var$FormEditRightHolder;









const $e702a8166fd37bd7$var$ModalEditRightHolder = (props)=>{
    const FORM_REFERENCE = "formEditRightHolder";
    const updateRightHolderMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $6d5f4ec705c7ab18$export$2e2bcd8739ae039).updateIndividual(props.rightHolderRef, dto),
        onSuccess: (response)=>{
            const rightHolder = response.data || {};
            let name = "";
            if (rightHolder?.type === "individual") {
                const dataIndividual = rightHolder;
                name = (0, $335b32823e91bbd2$export$e49861a9373f5f25)(dataIndividual);
            } else if (rightHolder?.type === "vehicle") {
                const dataVehicle = rightHolder;
                name = (0, $335b32823e91bbd2$export$e49861a9373f5f25)(dataVehicle);
            }
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.modalEditRightHolder.actions.update",
                values: {
                    name: name
                }
            }));
            props.onSubmit(rightHolder);
        }
    });
    const updateIndividual = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber } = values;
        if (props?.rightHolder.kind === "individual") {
            const originalDTO = props.rightHolder.dto;
            const dto = {
                type: "individual",
                firstName: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(firstName, originalDTO.firstName),
                lastName: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(lastName, originalDTO.lastName),
                email: (0, $ee9cb80b5c23ac97$export$b9d2d3b623c012b1)(email, originalDTO.email),
                phoneNumber: (0, $ee9cb80b5c23ac97$export$b34d9e7bbdff763e)(phoneNumber)
            };
            updateRightHolderMutation.mutate(dto);
        } else console.error("Save prevented because there is not valid right holder type.");
    };
    const cancel = ()=>{
        updateRightHolderMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            mutation: updateRightHolderMutation,
            errorTitleKey: "common.actions.update.error",
            modalTitle: props?.rightHolder.kind === "individual" ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.modalEditRightHolder.title.individual"
            }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.modalEditRightHolder.title.vehicle"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f5d52d00b84dc248$export$2e2bcd8739ae039), {
                formReference: FORM_REFERENCE,
                rightHolder: props.rightHolder.dto,
                onSubmit: updateIndividual
            })
        })
    });
};
var $e702a8166fd37bd7$export$2e2bcd8739ae039 = $e702a8166fd37bd7$var$ModalEditRightHolder;




var $2hDQc = parcelRequire("2hDQc");




var $7a6898b55796d0b9$exports = {};
"use strict";
"use client";

Object.defineProperty($7a6898b55796d0b9$exports, "__esModule", {
    value: true
});
$7a6898b55796d0b9$exports.default = void 0;

var $7a6898b55796d0b9$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $7a6898b55796d0b9$var$_default = $7a6898b55796d0b9$exports.default = (0, $7a6898b55796d0b9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-.4 4.25-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72"
}), "MailRounded");


var $f1b89fcffbf410e8$exports = {};
"use strict";
"use client";

Object.defineProperty($f1b89fcffbf410e8$exports, "__esModule", {
    value: true
});
$f1b89fcffbf410e8$exports.default = void 0;

var $f1b89fcffbf410e8$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $f1b89fcffbf410e8$var$_default = $f1b89fcffbf410e8$exports.default = (0, $f1b89fcffbf410e8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4"
}), "PersonRounded");


var $9cafd724f10277be$exports = {};
"use strict";
"use client";

Object.defineProperty($9cafd724f10277be$exports, "__esModule", {
    value: true
});
$9cafd724f10277be$exports.default = void 0;

var $9cafd724f10277be$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $9cafd724f10277be$var$_default = $9cafd724f10277be$exports.default = (0, $9cafd724f10277be$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "m19.23 15.26-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98"
}), "PhoneRounded");




var $592Nh = parcelRequire("592Nh");







var $592Nh = parcelRequire("592Nh");


var $2hDQc = parcelRequire("2hDQc");









const $f5a4a88ddca3b87a$var$TableVehicles = (props)=>{
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const [showModalEditVehicle, setShowModalEditVehicle] = (0, $2hDQc.useState)(undefined);
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { locale: locale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const RenderVehicleData = ({ vehicle: vehicle })=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
            children: vehicle.rights.map((right)=>/*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                    onClick: ()=>navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHTS}/${right.id}`),
                    hover: true,
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                                utcDateTime: vehicle.createdAt
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                                children: vehicle.licensePlate
                            })
                        }),
                        /*#__PURE__*/ (0, $592Nh.jsx)(RenderRightData, {
                            licensePlate: vehicle.licensePlate,
                            right: right
                        })
                    ]
                }, right.id))
        });
    };
    const RenderRightData = ({ licensePlate: licensePlate, right: right })=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                    children: right.offering?.name
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                    children: right.place?.name
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                        utcDateTime: right.validityStart
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                        utcDateTime: right?.validityEnd,
                        emptyText: intl.formatMessage({
                            id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)(RenderButton, {
                    licensePlate: licensePlate,
                    right: right
                })
            ]
        });
    };
    const isEndableRight = (right)=>{
        return props.allowToEndRight && right && (!right.validityEnd || (0, $4ea31e1953a3d675$export$6ef9dbcccbc4ed7d).fromUTC(right.validityEnd, locale) > (0, $f65046485b965c63$exports.DateTime).now());
    };
    const RenderButton = ({ licensePlate: licensePlate, right: right })=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
            action: "EDIT",
            resource: "RIGHTS",
            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                children: isEndableRight(right) && /*#__PURE__*/ (0, $592Nh.jsx)((0, $7c79f74a177f653a$export$2e2bcd8739ae039), {
                    bold: true,
                    onClick: (evt)=>{
                        evt.stopPropagation();
                        setShowModalEditVehicle({
                            licensePlate: licensePlate,
                            costCenter: right.costCenter,
                            project: right.project,
                            rightId: right.id,
                            catalogueId: right.catalogueId
                        });
                    },
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                        id: "common.buttons.edit"
                    })
                })
            })
        });
    };
    const RenderGridVehicleData = ({ vehicle: vehicle })=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
            emptyTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.empty",
            errorTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.failed",
            query: props.queryRightHolder,
            children: vehicle.rights.map((right)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $aee91e5fd2415227$export$2e2bcd8739ae039), {
                    onCardClicked: ()=>navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHTS}/${right.id}`),
                    cardTitle: vehicle.licensePlate,
                    cardSecondaryTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                        utcDateTime: vehicle.createdAt
                    }),
                    cardContentList: getGridRightData(right),
                    cardMenuActions: getMenuItems(vehicle, right)
                }, vehicle.id))
        });
    };
    const getGridRightData = (right)=>{
        const getBySpace = (first, second)=>{
            return /*#__PURE__*/ (0, $592Nh.jsxs)("div", {
                children: [
                    first,
                    " ",
                    second
                ]
            });
        };
        return [
            getBySpace(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.location"
            }), right?.place?.name),
            getBySpace(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.right"
            }), /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                children: right?.offering?.name
            })),
            getBySpace(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.startRight"
            }), /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityStart
            })),
            getBySpace(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.endRight"
            }), /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityEnd,
                emptyText: intl.formatMessage({
                    id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                })
            }))
        ];
    };
    const getMenuItems = (vehicle, right)=>{
        return isEndableRight(right) ? [
            {
                itemText: intl.formatMessage({
                    id: "common.buttons.edit"
                }),
                onClick: ()=>setShowModalEditVehicle({
                        licensePlate: vehicle.licensePlate,
                        rightId: right.id,
                        catalogueId: right.catalogueId
                    })
            }
        ] : undefined;
    };
    const closeModalsAndRefresh = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$475c1d76a7297be4),
                props.rightHolderId
            ]
        });
        setShowModalEditVehicle(undefined);
        props.refreshOffering();
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $24359d10cdf7053d$export$2e2bcd8739ae039), {
                emptyTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.empty",
                errorTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.failed",
                query: props.queryRightHolder,
                children: props.vehicleRightHolders.map((row)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $2hDQc.Fragment), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)(RenderGridVehicleData, {
                            vehicle: row
                        })
                    }, row.id))
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e5d33b18908fef3d$export$2e2bcd8739ae039), {
                items: props.vehicleRightHolders,
                emptyTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.empty",
                errorTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.failed",
                query: props.queryRightHolder,
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $c2993d8c386a54e7$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $d9497b169efaceb0$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.createdAt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.text.licensePlate"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.right"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.place"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.validFrom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.validUntil"
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $561148cb39ccf91a$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $99c4caec9c67cdbd$export$2e2bcd8739ae039), {
                        "data-testid": "places-table-body",
                        children: props.vehicleRightHolders.map((row)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $2hDQc.Fragment), {
                                children: /*#__PURE__*/ (0, $592Nh.jsx)(RenderVehicleData, {
                                    vehicle: row
                                })
                            }, row.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $9c0eb4be3833c653$export$2e2bcd8739ae039), {
                open: !!showModalEditVehicle,
                rightId: showModalEditVehicle?.rightId || "",
                catalogueId: showModalEditVehicle?.catalogueId || "",
                licensePlate: showModalEditVehicle?.licensePlate || "",
                costCenter: showModalEditVehicle?.costCenter,
                project: showModalEditVehicle?.project,
                onTerminated: ()=>closeModalsAndRefresh(),
                onSubmit: ()=>{
                    closeModalsAndRefresh();
                },
                onCancel: ()=>setShowModalEditVehicle(undefined)
            })
        ]
    });
};
var $f5a4a88ddca3b87a$export$2e2bcd8739ae039 = $f5a4a88ddca3b87a$var$TableVehicles;





var $2hDQc = parcelRequire("2hDQc");
const $f3d85a458b3f4b2c$var$RightsAndVehicles = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const { place: place } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const isOfferingFetchAllowed = isPermission("READ", "OFFERING");
    const queryOfferings = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
            place.id
        ],
        queryFn: ()=>(0, $a37004fca245d806$export$2bffccb0f948be1f).getOfferingsByPlace(place.id || ""),
        enabled: false,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const offeringId = queryOfferings.data?.[0]?.id;
    (0, $2hDQc.useEffect)(()=>{
        if (offeringId) queryClient.invalidateQueries({
            queryKey: [
                (0, $1a19893cc26bc20f$export$7cf5b9f73b9b2f2d),
                offeringId
            ]
        });
    }, [
        queryOfferings.isFetched
    ]);
    const RenderVehicles = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
            children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.rightHolders.rightHolder.tab.rightsAndVehicles.title"
                        }),
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f5a4a88ddca3b87a$export$2e2bcd8739ae039), {
                            vehicleRightHolders: props.vehicles,
                            rightHolderId: props.individualRightHolder?.id || "",
                            queryRightHolder: props.queryRightHolder,
                            allowToEndRight: !!props.individualRightHolder,
                            refreshOffering: ()=>isOfferingFetchAllowed && queryClient.invalidateQueries({
                                    queryKey: [
                                        (0, $1a19893cc26bc20f$export$70a73d059c6beff0),
                                        place.id
                                    ]
                                })
                        })
                    })
                ]
            })
        });
    };
    const tabHeaders = [
        intl.formatMessage({
            id: "page.rightHolders.rightHolder.tab.rightsAndVehicles.title"
        })
    ];
    const tabPanels = [
        /*#__PURE__*/ (0, $592Nh.jsx)(RenderVehicles, {})
    ];
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $74f5dfbf7740a204$export$2e2bcd8739ae039), {
        tabKey: (0, $7bfb91130cd4d35d$export$50da30c0967674ee),
        tabHeaders: tabHeaders,
        tabPanels: tabPanels
    });
};
var $f3d85a458b3f4b2c$export$2e2bcd8739ae039 = $f3d85a458b3f4b2c$var$RightsAndVehicles;




const $994bc4410f661880$var$RightHolder = ()=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    let { rightHolderRef: rightHolderRef } = (0, $86f6846c59d1b386$export$99eaa27ddbbb95ef)();
    const queryClient = (0, $97855a2dd31730f4$export$22e77b9572c4fded)();
    const { tenant: tenant } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const { state: state } = (0, $86f6846c59d1b386$export$45d76561a5302f2b)();
    const [showModalEditRightHolder, setShowModalEditRightHolder] = (0, $2hDQc.useState)(false);
    const queryRightHolder = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$475c1d76a7297be4),
            rightHolderRef
        ],
        queryFn: ()=>(0, $6d5f4ec705c7ab18$export$2e2bcd8739ae039).getIndividualByRef(rightHolderRef || ""),
        enabled: !!rightHolderRef,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const rightHolderData = queryRightHolder.data;
    let rightHolder = {
        id: "",
        name: "-",
        email: undefined,
        phone: undefined,
        vehicles: [],
        type: rightHolderData?.type
    };
    let dataIndividual = rightHolderData?.type === "individual" ? rightHolderData : undefined;
    let dataVehicle = rightHolderData?.type === "vehicle" ? rightHolderData : undefined;
    if (dataIndividual) {
        const id = dataIndividual.id;
        const name = (0, $335b32823e91bbd2$export$e49861a9373f5f25)(dataIndividual);
        const email = dataIndividual.email;
        const phone = dataIndividual.phoneNumber;
        const vehicles = dataIndividual.vehicles;
        rightHolder = {
            id: id,
            name: name,
            email: email,
            phone: phone,
            vehicles: vehicles
        };
    } else if (dataVehicle) {
        const id = dataVehicle.id;
        const name = (0, $335b32823e91bbd2$export$e49861a9373f5f25)(dataVehicle);
        const vehicles = rightHolderData?.type === "vehicle" ? [
            rightHolderData
        ] : [];
        rightHolder = {
            id: id,
            name: name,
            vehicles: vehicles
        };
    }
    const { catalogueId: catalogueId, offeringName: offeringName, placeId: placeId, placeName: placeName } = state || {};
    const customBreadcrumbs = catalogueId && offeringName && placeId && placeName ? {
        lastBreadcrumb: rightHolder.name,
        customBreadcrumbs: tenant ? [
            {
                route: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${placeId}`,
                name: placeName
            }
        ] : [
            {
                route: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${placeId}`,
                name: placeName
            },
            {
                route: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CATALOGUES}/${catalogueId}`,
                name: offeringName
            }
        ]
    } : undefined;
    const RightHolderListItem = ({ children: children })=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                alignItems: "center"
            },
            children: children
        });
    };
    const RightHolderListItemText = ({ children: children })=>{
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
            sx: {
                pl: "10px"
            },
            children: children
        });
    };
    const showEditButton = rightHolderData?.type === "individual";
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: queryRightHolder,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                                    breadcrumbs: customBreadcrumbs,
                                    children: rightHolder.name
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.title"
                                    }),
                                    button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $7b7bd7a94688db70$export$2e2bcd8739ae039), {
                                        action: "EDIT",
                                        resource: "RIGHT_HOLDERS",
                                        visibility: showEditButton,
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                            startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac0e6f973d0bafe8$exports))), {}),
                                            onClick: ()=>setShowModalEditRightHolder(true),
                                            showAsIconButton: true,
                                            "aria-label": intl.formatMessage({
                                                id: "page.rightHolders.rightHolder.button.edit"
                                            })
                                        })
                                    }),
                                    divider: true
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $592Nh.jsxs)(RightHolderListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1b89fcffbf410e8$exports))), {}),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)(RightHolderListItemText, {
                                                        children: rightHolder.name
                                                    })
                                                ]
                                            }),
                                            rightHolder.email && /*#__PURE__*/ (0, $592Nh.jsxs)(RightHolderListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7a6898b55796d0b9$exports))), {}),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)(RightHolderListItemText, {
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $75dfa6692b16df0d$export$2e2bcd8739ae039), {
                                                            href: `mailto:${rightHolder.email}`,
                                                            children: rightHolder.email
                                                        })
                                                    })
                                                ]
                                            }),
                                            rightHolder.phone && /*#__PURE__*/ (0, $592Nh.jsxs)(RightHolderListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cafd724f10277be$exports))), {}),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)(RightHolderListItemText, {
                                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $75dfa6692b16df0d$export$2e2bcd8739ae039), {
                                                            href: `tel:${rightHolder.phone}`,
                                                            children: rightHolder.phone
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f3d85a458b3f4b2c$export$2e2bcd8739ae039), {
                                    queryRightHolder: queryRightHolder,
                                    individualRightHolder: dataIndividual,
                                    vehicles: rightHolder.vehicles
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e702a8166fd37bd7$export$2e2bcd8739ae039), {
                        open: showModalEditRightHolder,
                        rightHolderRef: rightHolderRef || "",
                        rightHolder: {
                            kind: rightHolderData?.type,
                            dto: rightHolderData
                        },
                        onSubmit: (values)=>{
                            setShowModalEditRightHolder(false);
                            queryClient.invalidateQueries({
                                queryKey: [
                                    (0, $1a19893cc26bc20f$export$475c1d76a7297be4),
                                    rightHolderRef
                                ]
                            });
                        },
                        onCancel: ()=>setShowModalEditRightHolder(false)
                    })
                ]
            })
        ]
    });
};
var $994bc4410f661880$export$2e2bcd8739ae039 = $994bc4410f661880$var$RightHolder;




var $592Nh = parcelRequire("592Nh");

parcelRequire("2hDQc");






const $47ed45c6fbf548be$var$Right = ()=>{
    const { ref: ref } = (0, $86f6846c59d1b386$export$99eaa27ddbbb95ef)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    if (!ref) return null;
    const query = (0, $b94a3cbdbee77a9d$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $1a19893cc26bc20f$export$d1676135628eec72),
            ref
        ],
        queryFn: ()=>(0, $46f3ff004257dc9a$export$2e2bcd8739ae039).getRightByRef(ref),
        enabled: !!ref,
        staleTime: (0, $1a19893cc26bc20f$export$55bcc68ad4a40abc)
    });
    const right = query.data;
    const data = [
        {
            label: intl.formatMessage({
                id: "page.right.start"
            }),
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityStart
            })
        },
        {
            label: intl.formatMessage({
                id: "page.right.end"
            }),
            value: right?.validityEnd ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $022472611720380a$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityEnd
            }) : null
        },
        {
            label: intl.formatMessage({
                id: "page.right.licensePlate"
            }),
            value: right?.vehicle?.licensePlate
        },
        {
            label: intl.formatMessage({
                id: "page.right.place"
            }),
            value: right?.place?.name
        },
        {
            label: intl.formatMessage({
                id: "page.right.catalogue"
            }),
            value: right?.catalogue?.name
        },
        {
            label: intl.formatMessage({
                id: "page.right.individual"
            }),
            value: right?.individual?.email
        },
        {
            label: intl.formatMessage({
                id: "page.right.costCenter"
            }),
            value: right?.costCenter
        },
        {
            label: intl.formatMessage({
                id: "page.right.project"
            }),
            value: right?.project
        },
        {
            label: intl.formatMessage({
                id: "page.right.endReason"
            }),
            value: right?.endReason
        },
        {
            label: intl.formatMessage({
                id: "page.right.active"
            }),
            value: intl.formatMessage({
                id: right?.active ? "common.yes" : "common.no"
            })
        }
    ].filter((item)=>item.value);
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $43fd4d081f3eea77$export$2e2bcd8739ae039), {
        query: query,
        rootPageIfNotFoundError: false,
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $5f4a92248a848f80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.right.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                                title: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "page.right.container.title"
                                }),
                                divider: true
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b05c28a9697a5f63$export$2e2bcd8739ae039), {
                                    data: data
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $47ed45c6fbf548be$export$2e2bcd8739ae039 = $47ed45c6fbf548be$var$Right;



var $592Nh = parcelRequire("592Nh");




var $2hDQc = parcelRequire("2hDQc");


var $592Nh = parcelRequire("592Nh");


var $5pzCu = parcelRequire("5pzCu");



var $2hDQc = parcelRequire("2hDQc");
const $54fb0d88b28fc4e3$var$FormPassword = (props)=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $2hDQc.useState)(false);
    const [defaultValues] = (0, $2hDQc.useState)({
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: ""
    });
    const SchemaValidation = ()=>{
        return $7a5dda49dca6ae9d$export$be5493f9613cbbe().shape({
            oldPassword: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            newPassword: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("newPassword", intl.formatMessage({
                id: "page.users.formPassword.errors.password"
            }), function(newPassword) {
                const { confirmNewPassword: confirmNewPassword } = this.parent;
                if (newPassword && confirmNewPassword) return confirmNewPassword.localeCompare(newPassword) === 0;
                return false;
            }),
            confirmNewPassword: $7a5dda49dca6ae9d$export$22b082955e083ec3().trim().test("confirmNewPassword", intl.formatMessage({
                id: "page.users.formPassword.errors.password"
            }), function(confirmNewPassword) {
                const { newPassword: newPassword } = this.parent;
                if (confirmNewPassword && newPassword) return newPassword.localeCompare(confirmNewPassword) === 0;
                return false;
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { oldPassword: oldPassword, newPassword: newPassword } = values;
        props.onSubmit({
            newPassword: newPassword.trim(),
            oldPassword: oldPassword.trim()
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $5pzCu.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: SchemaValidation(),
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $592Nh.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                type: "password",
                                name: "oldPassword",
                                "data-testid": "oldPassword",
                                value: values.oldPassword,
                                label: intl.formatMessage({
                                    id: "page.users.formPassword.label.oldPassword"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.users.formPassword.label.oldPassword"
                                }),
                                onChange: handleChange,
                                error: !!errors.oldPassword,
                                errorText: errors.oldPassword
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                type: "password",
                                name: "newPassword",
                                "data-testid": "newPassword",
                                value: values.newPassword,
                                label: intl.formatMessage({
                                    id: "page.users.formPassword.label.newPassword"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.users.formPassword.label.newPassword"
                                }),
                                onChange: handleChange,
                                error: !!errors.newPassword,
                                errorText: errors.newPassword
                            }),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b8b9780b21c9795b$export$2e2bcd8739ae039).FormTextField, {
                                type: "password",
                                name: "confirmNewPassword",
                                "data-testid": "confirmNewPassword",
                                value: values.confirmNewPassword,
                                label: intl.formatMessage({
                                    id: "page.users.formPassword.label.confirmNewPassword"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.users.formPassword.label.confirmNewPassword"
                                }),
                                onChange: handleChange,
                                error: !!errors.confirmNewPassword,
                                errorText: errors.confirmNewPassword
                            })
                        ]
                    })
                })
        })
    });
};
var $54fb0d88b28fc4e3$export$2e2bcd8739ae039 = $54fb0d88b28fc4e3$var$FormPassword;







const $b200d14c7751dbfa$var$Users = ()=>{
    // TODO Antti: Is this needed somehow? Probably not.
    //const { user } = useAuthenticator((context) => [context.user])
    const { decodedToken: decodedToken } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const [showPasswordModal, setShowPasswordModal] = (0, $2hDQc.useState)(false);
    const FORM_REFERENCE = "formChangePassword";
    const changePasswordMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $9b69f9955ab78e59$export$2e2bcd8739ae039).changePassword(dto.oldPassword, dto.newPassword),
        onSuccess: (response)=>{
            setShowPasswordModal(false);
            (0, $eaea2ba9b50fd31e$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "page.users.modalChangePassword.action.changed"
            }));
        }
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $0e37363bdf6cc6d4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $73a8034909278da5$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "page.users.label.user"
                        })
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $e83de8e31a85810a$export$2e2bcd8739ae039), {
                        title: (0, $ee9cb80b5c23ac97$export$ec6ba75237411d31)(decodedToken),
                        button: /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                            startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac0e6f973d0bafe8$exports))), {}),
                            onClick: ()=>setShowPasswordModal(true),
                            showAsIconButton: true,
                            "aria-label": intl.formatMessage({
                                id: "page.users.button.edit"
                            })
                        }),
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $3a3b2ea64f1e763a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "row",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 3,
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "common.text.email"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 9,
                                    children: decodedToken?.email
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 3,
                                    children: /*#__PURE__*/ (0, $592Nh.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                            id: "page.users.label.emailConfirmed"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 9,
                                    children: decodedToken?.email_verified ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.yes"
                                    }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                        id: "common.no"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $625d026951ac286d$export$2e2bcd8739ae039), {
                open: showPasswordModal,
                onCancel: ()=>{
                    changePasswordMutation.reset();
                    setShowPasswordModal(false);
                },
                formReference: FORM_REFERENCE,
                errorTitleKey: "common.actions.add.error",
                modalTitle: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.users.modalChangePassword.title"
                }),
                submitButtonContent: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                    id: "page.users.modalChangePassword.button.add"
                }),
                children: [
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $09ef42aa6aba452d$export$2e2bcd8739ae039), {
                        mutation: changePasswordMutation,
                        errorTitleKey: "common.actions.add.error"
                    }),
                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $54fb0d88b28fc4e3$export$2e2bcd8739ae039), {
                        onSubmit: (values)=>changePasswordMutation.mutate(values),
                        formReference: FORM_REFERENCE
                    })
                ]
            })
        ]
    });
};
var $b200d14c7751dbfa$export$2e2bcd8739ae039 = $b200d14c7751dbfa$var$Users;






var $592Nh = parcelRequire("592Nh");

var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");

var $lfMLv = parcelRequire("lfMLv");


var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $34ed81215f85ceb2$export$47a2da616e55e8e9(slot) {
    return (0, $01COD.default)("MuiAppBar", slot);
}
const $34ed81215f85ceb2$var$appBarClasses = (0, $eLydt.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $34ed81215f85ceb2$export$2e2bcd8739ae039 = $34ed81215f85ceb2$var$appBarClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $d62701f53e12a3f7$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $d62701f53e12a3f7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lfMLv.default)(color)}`,
            `position${(0, $lfMLv.default)(position)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $34ed81215f85ceb2$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $d62701f53e12a3f7$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $d62701f53e12a3f7$var$AppBarRoot = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $lfMLv.default)(ownerState.position)}`],
            styles[`color${(0, $lfMLv.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $kxIgO.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $kxIgO.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $kxIgO.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $kxIgO.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $d62701f53e12a3f7$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $d62701f53e12a3f7$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $d62701f53e12a3f7$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $d62701f53e12a3f7$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $d62701f53e12a3f7$var$AppBar = /*#__PURE__*/ $2hDQc.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $gZOiq.default)(props, $d62701f53e12a3f7$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $d62701f53e12a3f7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($d62701f53e12a3f7$var$AppBarRoot, (0, $kxIgO.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $fLRFO.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $d62701f53e12a3f7$export$2e2bcd8739ae039 = $d62701f53e12a3f7$var$AppBar;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");


var $dJnC1 = parcelRequire("dJnC1");


var $kxIgO = parcelRequire("kxIgO");

var $gZOiq = parcelRequire("gZOiq");

var $2hDQc = parcelRequire("2hDQc");









var $592Nh = parcelRequire("592Nh");
"use client";
const $6e9f6e6ebf8edf3a$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $6e9f6e6ebf8edf3a$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $9bc586e64615ae98$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $6e9f6e6ebf8edf3a$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $6e9f6e6ebf8edf3a$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $6e9f6e6ebf8edf3a$var$resolveContainer(containerProp);
    const transform = $6e9f6e6ebf8edf3a$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6e9f6e6ebf8edf3a$var$Slide = /*#__PURE__*/ $2hDQc.forwardRef(function Slide(props, ref) {
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f1775b3e9e6fc859$export$2e2bcd8739ae039) } = props, other = (0, $gZOiq.default)(props, $6e9f6e6ebf8edf3a$var$_excluded);
    const childrenRef = $2hDQc.useRef(null);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $6e9f6e6ebf8edf3a$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $1aa5c4f4ecb43caa$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $kxIgO.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $kxIgO.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1aa5c4f4ecb43caa$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $6e9f6e6ebf8edf3a$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $2hDQc.useCallback(()=>{
        if (childrenRef.current) $6e9f6e6ebf8edf3a$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $2hDQc.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $9edf6df80e9bc497$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $6e9f6e6ebf8edf3a$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $9bc586e64615ae98$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $2hDQc.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $2hDQc.cloneElement(children, (0, $kxIgO.default)({
                ref: handleRef,
                style: (0, $kxIgO.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $6e9f6e6ebf8edf3a$export$2e2bcd8739ae039 = $6e9f6e6ebf8edf3a$var$Slide;




var $lfMLv = parcelRequire("lfMLv");


var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $5da996477cfef470$export$b801318a856c9cd2(slot) {
    return (0, $01COD.default)("MuiDrawer", slot);
}
const $5da996477cfef470$var$drawerClasses = (0, $eLydt.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $5da996477cfef470$export$2e2bcd8739ae039 = $5da996477cfef470$var$drawerClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $222633694b3022bd$var$_excluded = [
    "BackdropProps"
], $222633694b3022bd$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $222633694b3022bd$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $222633694b3022bd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $lfMLv.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $lfMLv.default)(anchor)}`
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $5da996477cfef470$export$b801318a856c9cd2), classes);
};
const $222633694b3022bd$var$DrawerRoot = (0, $fhlQp.default)((0, $fecdaeba05e13765$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $222633694b3022bd$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $222633694b3022bd$var$DrawerDockedRoot = (0, $fhlQp.default)("div", {
    shouldForwardProp: (0, $fhlQp.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $222633694b3022bd$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $222633694b3022bd$var$DrawerPaper = (0, $fhlQp.default)((0, $23b78932f8a6daaa$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $lfMLv.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $lfMLv.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $222633694b3022bd$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $222633694b3022bd$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $222633694b3022bd$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $222633694b3022bd$export$2a62b49acb270576(anchor) ? $222633694b3022bd$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $222633694b3022bd$var$Drawer = /*#__PURE__*/ $2hDQc.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $6e9f6e6ebf8edf3a$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary" } = props, ModalProps = (0, $gZOiq.default)(props.ModalProps, $222633694b3022bd$var$_excluded), other = (0, $gZOiq.default)(props, $222633694b3022bd$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $2hDQc.useRef(false);
    $2hDQc.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $222633694b3022bd$export$830f4f08342d299e(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $kxIgO.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $222633694b3022bd$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $592Nh.jsx)($222633694b3022bd$var$DrawerPaper, (0, $kxIgO.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $fLRFO.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, $592Nh.jsx)($222633694b3022bd$var$DrawerDockedRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $592Nh.jsx)(TransitionComponent, (0, $kxIgO.default)({
        in: open,
        direction: $222633694b3022bd$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, $592Nh.jsx)($222633694b3022bd$var$DrawerDockedRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $592Nh.jsx)($222633694b3022bd$var$DrawerRoot, (0, $kxIgO.default)({
        BackdropProps: (0, $kxIgO.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $fLRFO.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $222633694b3022bd$export$2e2bcd8739ae039 = $222633694b3022bd$var$Drawer;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $6KAST = parcelRequire("6KAST");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");






var $592Nh = parcelRequire("592Nh");
"use client";
const $f47135850376bbc1$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $f47135850376bbc1$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $f47135850376bbc1$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $dJnC1.default)(slots, (0, $e434de5118acb2b8$export$c09531d8563c67a5), classes);
    return (0, $kxIgO.default)({}, classes, composedClasses);
};
const $f47135850376bbc1$var$ListItemButtonRoot = (0, $fhlQp.default)((0, $1379cc80d8f1a214$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $fhlQp.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $f47135850376bbc1$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $e434de5118acb2b8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $e434de5118acb2b8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $e434de5118acb2b8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6KAST.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $e434de5118acb2b8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $e434de5118acb2b8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $f47135850376bbc1$var$ListItemButton = /*#__PURE__*/ $2hDQc.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $gZOiq.default)(props, $f47135850376bbc1$var$_excluded);
    const context = $2hDQc.useContext((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039));
    const childContext = $2hDQc.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $2hDQc.useRef(null);
    (0, $4a6d2c05dc7e96d8$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kxIgO.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $f47135850376bbc1$var$useUtilityClasses(ownerState);
    const handleRef = (0, $699b323bc31c9932$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $592Nh.jsx)($f47135850376bbc1$var$ListItemButtonRoot, (0, $kxIgO.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $fLRFO.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $fLRFO.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $f47135850376bbc1$export$2e2bcd8739ae039 = $f47135850376bbc1$var$ListItemButton;


var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $fhlQp = parcelRequire("fhlQp");

var $afHYP = parcelRequire("afHYP");



var $592Nh = parcelRequire("592Nh");
"use client";
const $9c93c2295fa3f9df$var$_excluded = [
    "className"
];
const $9c93c2295fa3f9df$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $f68e01e6c6c209b4$export$81478e24460c57f2), classes);
};
const $9c93c2295fa3f9df$var$ListItemIconRoot = (0, $fhlQp.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $9c93c2295fa3f9df$var$ListItemIcon = /*#__PURE__*/ $2hDQc.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $gZOiq.default)(props, $9c93c2295fa3f9df$var$_excluded);
    const context = $2hDQc.useContext((0, $8e8f5df0158f47bd$export$2e2bcd8739ae039));
    const ownerState = (0, $kxIgO.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $9c93c2295fa3f9df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($9c93c2295fa3f9df$var$ListItemIconRoot, (0, $kxIgO.default)({
        className: (0, $fLRFO.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $9c93c2295fa3f9df$export$2e2bcd8739ae039 = $9c93c2295fa3f9df$var$ListItemIcon;


var $fhlQp = parcelRequire("fhlQp");
var $gZOiq = parcelRequire("gZOiq");

var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $fLRFO = parcelRequire("fLRFO");

var $dJnC1 = parcelRequire("dJnC1");

var $afHYP = parcelRequire("afHYP");

var $fhlQp = parcelRequire("fhlQp");

var $eLydt = parcelRequire("eLydt");

var $01COD = parcelRequire("01COD");
function $9b6039635674cfbb$export$b12cb262231eef32(slot) {
    return (0, $01COD.default)("MuiToolbar", slot);
}
const $9b6039635674cfbb$var$toolbarClasses = (0, $eLydt.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $9b6039635674cfbb$export$2e2bcd8739ae039 = $9b6039635674cfbb$var$toolbarClasses;



var $592Nh = parcelRequire("592Nh");
"use client";
const $ddac0e7b333c55e7$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ddac0e7b333c55e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $dJnC1.default)(slots, (0, $9b6039635674cfbb$export$b12cb262231eef32), classes);
};
const $ddac0e7b333c55e7$var$ToolbarRoot = (0, $fhlQp.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kxIgO.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $ddac0e7b333c55e7$var$Toolbar = /*#__PURE__*/ $2hDQc.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $gZOiq.default)(props, $ddac0e7b333c55e7$var$_excluded);
    const ownerState = (0, $kxIgO.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ddac0e7b333c55e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $592Nh.jsx)($ddac0e7b333c55e7$var$ToolbarRoot, (0, $kxIgO.default)({
        as: component,
        className: (0, $fLRFO.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ddac0e7b333c55e7$export$2e2bcd8739ae039 = $ddac0e7b333c55e7$var$Toolbar;



var $2hDQc = parcelRequire("2hDQc");

var $592Nh = parcelRequire("592Nh");


var $693be504286f63df$exports = {};
$693be504286f63df$exports = new URL("carLogo.e02ef99a.svg", import.meta.url).toString();



var $ba4363b6f9d5d0bc$exports = {};
"use strict";
"use client";

Object.defineProperty($ba4363b6f9d5d0bc$exports, "__esModule", {
    value: true
});
$ba4363b6f9d5d0bc$exports.default = void 0;

var $ba4363b6f9d5d0bc$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $ba4363b6f9d5d0bc$var$_default = $ba4363b6f9d5d0bc$exports.default = (0, $ba4363b6f9d5d0bc$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $592Nh.jsx)("path", {
        d: "M5 5h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c.55 0 1-.45 1-1s-.45-1-1-1H5z"
    }, "0"),
    /*#__PURE__*/ (0, $592Nh.jsx)("path", {
        d: "m20.65 11.65-2.79-2.79c-.32-.32-.86-.1-.86.35V11h-7c-.55 0-1 .45-1 1s.45 1 1 1h7v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7"
    }, "1")
], "LogoutRounded");


var $b57e7f32ca479cf5$exports = {};
"use strict";
"use client";

Object.defineProperty($b57e7f32ca479cf5$exports, "__esModule", {
    value: true
});
$b57e7f32ca479cf5$exports.default = void 0;

var $b57e7f32ca479cf5$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $b57e7f32ca479cf5$var$_default = $b57e7f32ca479cf5$exports.default = (0, $b57e7f32ca479cf5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu");





var $2hDQc = parcelRequire("2hDQc");






const $f9e5bd9433eac887$var$UserItem = ({ anchorElement: anchorElement, onOpenUserMenu: onOpenUserMenu, onCloseMenu: onCloseMenu, onLogout: onLogout })=>{
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const { locale: locale, setLocale: setLocale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const { isAuthenticated: isAuthenticated, usernameShort: usernameShort } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const locKeys = Object.getOwnPropertyNames((0, $d30a5fdc49293dc0$export$bc99aaabaf7b70a7));
    const locOptions = locKeys.map((key)=>{
        return {
            key: key,
            text: intl.formatMessage({
                id: `menu.user.${key}`
            })
        };
    });
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $560cc98f1d9121b1$export$2e2bcd8739ae039), {
                onClick: (event)=>onOpenUserMenu(event),
                children: usernameShort
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)((0, $655e6265c42a9c6c$export$2e2bcd8739ae039), {
                anchorEl: anchorElement,
                open: Boolean(anchorElement),
                onClose: onCloseMenu,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                children: [
                    isAuthenticated && /*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            onCloseMenu();
                            navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).USERS}`);
                        },
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                            id: "menu.user.detail"
                        })
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {}),
                    locOptions.map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setLocale(item.key);
                                onCloseMenu();
                            },
                            disabled: item.key === locale,
                            children: item.text
                        }, item.key)),
                    isAuthenticated && /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {}),
                    isAuthenticated && /*#__PURE__*/ (0, $592Nh.jsx)((0, $a34e3655834f552c$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            onLogout();
                            onCloseMenu();
                        },
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                            display: "flex",
                            gap: "5px",
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba4363b6f9d5d0bc$exports))), {}),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                    id: "menu.user.logout"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $f9e5bd9433eac887$var$AppMenuTop = ({ anchorElUser: anchorElUser, appMenuOpen: appMenuOpen, onOpenUserMenu: onOpenUserMenu, onCloseMenu: onCloseMenu, onLogout: onLogout, onClickHamburgerMenu: onClickHamburgerMenu, onClickLogo: onClickLogo })=>{
    const { isAuthenticated: isAuthenticated } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const { customerConfigured: customerConfigured } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const intl = (0, $a8df4d8b672eba1c$exports.useIntl)();
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const isMobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
            container: true,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    display: "flex",
                    justifyContent: "flex-start",
                    height: 30,
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                display: "flex",
                                cursor: "pointer"
                            },
                            onClick: onClickLogo,
                            children: /*#__PURE__*/ (0, $592Nh.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($693be504286f63df$exports)))
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0, $592Nh.jsx)("div", {
                            style: {
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                                cursor: "pointer"
                            },
                            onClick: onClickLogo,
                            children: /*#__PURE__*/ (0, $592Nh.jsx)("h2", {
                                children: (0, $cc54526a7cedf1dd$export$32ea325d92ea6082).APP_FULLNAME
                            })
                        }),
                        isAuthenticated && customerConfigured && /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                            children: appMenuOpen && isMobile ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7115a2fd0c35c547$exports))), {
                                    style: {
                                        color: "white"
                                    }
                                }),
                                onClick: onClickHamburgerMenu,
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "appMenuTop.button.closeMenu"
                                })
                            }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $234b0cbb679ba096$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b57e7f32ca479cf5$exports))), {
                                    style: {
                                        color: "white"
                                    }
                                }),
                                onClick: onClickHamburgerMenu,
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "appMenuTop.button.menu"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $15071aa7586bdd58$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    display: "flex",
                    justifyContent: "right",
                    children: /*#__PURE__*/ (0, $592Nh.jsx)($f9e5bd9433eac887$var$UserItem, {
                        anchorElement: anchorElUser,
                        onOpenUserMenu: onOpenUserMenu,
                        onCloseMenu: onCloseMenu,
                        onLogout: onLogout
                    })
                })
            ]
        })
    });
};
var $f9e5bd9433eac887$export$2e2bcd8739ae039 = $f9e5bd9433eac887$var$AppMenuTop;


var $2d4a3d6081348ef6$exports = {};
"use strict";
"use client";

Object.defineProperty($2d4a3d6081348ef6$exports, "__esModule", {
    value: true
});
$2d4a3d6081348ef6$exports.default = void 0;

var $2d4a3d6081348ef6$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $2d4a3d6081348ef6$var$_default = $2d4a3d6081348ef6$exports.default = (0, $2d4a3d6081348ef6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
}), "AssessmentOutlined");


var $1815405f65e3cb83$exports = {};
"use strict";
"use client";

Object.defineProperty($1815405f65e3cb83$exports, "__esModule", {
    value: true
});
$1815405f65e3cb83$exports.default = void 0;

var $1815405f65e3cb83$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $1815405f65e3cb83$var$_default = $1815405f65e3cb83$exports.default = (0, $1815405f65e3cb83$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $592Nh.jsx)("path", {
        d: "m21.99 14.77-1.43-4.11c-.14-.4-.52-.66-.97-.66H12.4c-.46 0-.83.26-.98.66L10 14.77v5.24c0 .55.45.99 1 .99s1-.45 1-1v-1h8v1c0 .55.45 1 1 1s.99-.44 1-.99zm-10.38-1.43.69-2c.05-.2.24-.34.46-.34h6.48c.21 0 .4.14.47.34l.69 2c.11.32-.13.66-.47.66h-7.85c-.34 0-.58-.34-.47-.66m.38 3.66c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
    }, "0"),
    /*#__PURE__*/ (0, $592Nh.jsx)("path", {
        d: "M14 4.5V9h1V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v4H3c-.55 0-1 .45-1 1v12h1V9.5c0-.28.22-.5.5-.5h4c.28 0 .5-.22.5-.5v-4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5"
    }, "1"),
    /*#__PURE__*/ (0, $592Nh.jsx)("path", {
        d: "M5 11h2v2H5zm5-6h2v2h-2zM5 15h2v2H5zm0 4h2v2H5z"
    }, "2")
], "EmojiTransportationRounded");





var $84cc67aee09256bf$exports = {};
"use strict";
"use client";

Object.defineProperty($84cc67aee09256bf$exports, "__esModule", {
    value: true
});
$84cc67aee09256bf$exports.default = void 0;

var $84cc67aee09256bf$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $84cc67aee09256bf$var$_default = $84cc67aee09256bf$exports.default = (0, $84cc67aee09256bf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M7 3v2c0 .55.45 1 1 1s1-.45 1-1V4h10v16H9v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2m2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46c-.12-.21-.38-.31-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08C9.3 7.18 9.09 7 8.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
}), "PhonelinkSetupRounded");


var $3cfbb2d534dabf36$exports = {};
"use strict";
"use client";

Object.defineProperty($3cfbb2d534dabf36$exports, "__esModule", {
    value: true
});
$3cfbb2d534dabf36$exports.default = void 0;

var $3cfbb2d534dabf36$var$_createSvgIcon = $5a628e0d34cb386c$exports((parcelRequire("hAnjf")));

var $592Nh = parcelRequire("592Nh");
var $3cfbb2d534dabf36$var$_default = $3cfbb2d534dabf36$exports.default = (0, $3cfbb2d534dabf36$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $592Nh.jsx)("path", {
    d: "M12 2c-4.2 0-8 3.22-8 8.2 0 3.18 2.45 6.92 7.34 11.23.38.33.95.33 1.33 0C17.55 17.12 20 13.38 20 10.2 20 5.22 16.2 2 12 2m0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), "PlaceRounded");







const $21caaf49acfe014f$var$StyledToolbar = (0, $fhlQp.default)((0, $ddac0e7b333c55e7$export$2e2bcd8739ae039))({
    background: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMenuBackgroundGradient
});
const $21caaf49acfe014f$var$StyledListItemIcon = (0, $fhlQp.default)((0, $9c93c2295fa3f9df$export$2e2bcd8739ae039))({
    minWidth: 16,
    paddingRight: "10px"
});
const $21caaf49acfe014f$var$drawerWidth = 280;
const $21caaf49acfe014f$var$Main = (0, $fhlQp.default)("main", {
    shouldForwardProp: (prop)=>prop !== "open" && prop !== "mobile"
})(({ theme: theme, open: open, mobile: mobile })=>({
        flexGrow: 1,
        paddingTop: 0,
        paddingBottom: 20,
        paddingLeft: 0,
        paddingRight: 0,
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: mobile ? 0 : `-${$21caaf49acfe014f$var$drawerWidth}px`,
        ...open && {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            }),
            marginLeft: 0
        },
        backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorMainBackground,
        minHeight: "100vh",
        maxHeight: "-webkit-fill-available"
    }));
const $21caaf49acfe014f$var$AppMenu = (props)=>{
    const theme = (0, $6d5944649970f6ea$export$2e2bcd8739ae039)();
    const mobile = (0, $ef97679917c36082$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const [anchorElUser, setAnchorElUser] = (0, $2hDQc.useState)(null);
    const [showSideMenu, setShowSideMenu] = (0, $2hDQc.useState)(mobile ? false : true);
    const { customer: customer, place: place, customerConfigured: customerConfigured, catalogueId: catalogueId } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const { isPermission: isPermission, isAuthenticated: isAuthenticated } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const navigate = (0, $86f6846c59d1b386$export$9770f232ac06a008)();
    const handleOpenUserMenu = (event)=>{
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseMenu = ()=>{
        setAnchorElUser(null);
    };
    const logoutMutation = (0, $f93c0904c8c05d54$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $9b69f9955ab78e59$export$2e2bcd8739ae039).logout(),
        onSuccess: ()=>{
            window.location.reload();
        }
    });
    const closeSideMenu = ()=>{
        mobile && setShowSideMenu(false);
        return true;
    };
    const menuAdminItems = [
        {
            key: (0, $c753d58728ea6715$export$61147a57d3c24ac8).INVITATIONS,
            active: location.pathname === (0, $c753d58728ea6715$export$61147a57d3c24ac8).INVITATIONS,
            onClick: ()=>closeSideMenu() && navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).INVITATIONS),
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "menu.invitations"
            }),
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84cc67aee09256bf$exports))), {}),
            visible: isPermission("READ", "LANDLORD_INVITATIONS")
        },
        {
            key: (0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES,
            active: location.pathname === (0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES,
            onClick: ()=>closeSideMenu() && navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES),
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "menu.allPlaces"
            }),
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cfbb2d534dabf36$exports))), {}),
            visible: isPermission("READ", "ADMIN_PLACES")
        }
    ];
    const showAdminMenu = menuAdminItems.filter((item)=>item.visible).length > 0;
    const isValidBasePlusOtherRoute = (appRoute)=>{
        // The route must be something else than the base route.
        // E.g. /places/0455e4b5-546c-4b21-949c-db7dc87c6c23
        return RegExp(`^${appRoute}/.`).test(location.pathname);
    };
    const menuPlaceItems = [
        {
            key: (0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES,
            active: isValidBasePlusOtherRoute((0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES) || isValidBasePlusOtherRoute((0, $c753d58728ea6715$export$61147a57d3c24ac8).CATALOGUES) || isValidBasePlusOtherRoute((0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHT_HOLDERS) || isValidBasePlusOtherRoute((0, $c753d58728ea6715$export$61147a57d3c24ac8).OFFERINGS),
            onClick: ()=>{
                closeSideMenu();
                if (isPermission("READ", "PLACES")) navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${place.id}`);
                else navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CATALOGUES}/${catalogueId}`);
            },
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "menu.places"
            }),
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cfbb2d534dabf36$exports))), {}),
            visible: isPermission("READ", "PLACES") || isPermission("READ", "CATALOGUES")
        }
    ];
    const menuCustomerItems = [
        {
            key: (0, $c753d58728ea6715$export$61147a57d3c24ac8).CUSTOMERS,
            active: location.pathname == `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CUSTOMERS}/${customer.id}`,
            onClick: ()=>closeSideMenu() && navigate(`${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CUSTOMERS}/${customer.id}`),
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "menu.customer"
            }),
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1815405f65e3cb83$exports))), {}),
            visible: true
        }
    ];
    const menuReportItems = [
        {
            key: (0, $c753d58728ea6715$export$61147a57d3c24ac8).REPORTS,
            active: location.pathname === (0, $c753d58728ea6715$export$61147a57d3c24ac8).REPORTS,
            onClick: ()=>closeSideMenu() && navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).REPORTS),
            value: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                id: "menu.reports"
            }),
            icon: /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2d4a3d6081348ef6$exports))), {}),
            visible: isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS")
        }
    ];
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).Fragment, {
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
            sx: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $d62701f53e12a3f7$export$2e2bcd8739ae039), {
                    position: "fixed",
                    sx: {
                        zIndex: (theme)=>theme.zIndex.drawer + 1
                    },
                    elevation: 0,
                    children: /*#__PURE__*/ (0, $592Nh.jsx)($21caaf49acfe014f$var$StyledToolbar, {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $f9e5bd9433eac887$export$2e2bcd8739ae039), {
                            anchorElUser: anchorElUser,
                            onOpenUserMenu: handleOpenUserMenu,
                            onCloseMenu: handleCloseMenu,
                            onLogout: ()=>logoutMutation.mutate(),
                            onClickHamburgerMenu: ()=>setShowSideMenu(!showSideMenu),
                            onClickLogo: ()=>closeSideMenu() && navigate((0, $c753d58728ea6715$export$61147a57d3c24ac8).ROOT),
                            appMenuOpen: showSideMenu
                        })
                    })
                }),
                isAuthenticated && customerConfigured && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $222633694b3022bd$export$2e2bcd8739ae039), {
                    sx: {
                        width: $21caaf49acfe014f$var$drawerWidth,
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: $21caaf49acfe014f$var$drawerWidth,
                            boxSizing: "border-box",
                            border: "none"
                        }
                    },
                    variant: mobile ? undefined : "persistent",
                    anchor: "left",
                    open: showSideMenu,
                    onClose: ()=>setShowSideMenu(false),
                    children: [
                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $ddac0e7b333c55e7$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
                            sx: {
                                overflow: "auto"
                            },
                            children: [
                                showAdminMenu && /*#__PURE__*/ (0, $592Nh.jsxs)((0, $592Nh.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
                                            subheader: /*#__PURE__*/ (0, $592Nh.jsx)((0, $864c1da0e0cdde54$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.FormattedMessage), {
                                                    id: "menu.subHeader.moovyAdmin"
                                                })
                                            }),
                                            children: menuAdminItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $f47135850376bbc1$export$2e2bcd8739ae039), {
                                                        onClick: item.onClick,
                                                        selected: item.active,
                                                        children: [
                                                            /*#__PURE__*/ (0, $592Nh.jsx)($21caaf49acfe014f$var$StyledListItemIcon, {
                                                                children: item.icon
                                                            }),
                                                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                                                                primary: item.value
                                                            })
                                                        ]
                                                    })
                                                }, item.key))
                                        }),
                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
                                    subheader: /*#__PURE__*/ (0, $592Nh.jsx)((0, $864c1da0e0cdde54$export$2e2bcd8739ae039), {
                                        children: place.name
                                    }),
                                    children: menuPlaceItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
                                            disablePadding: true,
                                            children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $f47135850376bbc1$export$2e2bcd8739ae039), {
                                                onClick: item.onClick,
                                                selected: item.active,
                                                children: [
                                                    /*#__PURE__*/ (0, $592Nh.jsx)($21caaf49acfe014f$var$StyledListItemIcon, {
                                                        children: item.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                                                        primary: item.value
                                                    })
                                                ]
                                            })
                                        }, item.key))
                                }),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $b79f77af355b16a9$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $592Nh.jsxs)((0, $e0a8f8fda2869892$export$2e2bcd8739ae039), {
                                    subheader: /*#__PURE__*/ (0, $592Nh.jsx)((0, $864c1da0e0cdde54$export$2e2bcd8739ae039), {
                                        children: customer.name
                                    }),
                                    children: [
                                        menuCustomerItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $f47135850376bbc1$export$2e2bcd8739ae039), {
                                                    onClick: item.onClick,
                                                    selected: item.active,
                                                    children: [
                                                        /*#__PURE__*/ (0, $592Nh.jsx)($21caaf49acfe014f$var$StyledListItemIcon, {
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                                                            primary: item.value
                                                        })
                                                    ]
                                                })
                                            }, item.key)),
                                        menuReportItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $592Nh.jsx)((0, $003822cb1451b251$export$2e2bcd8739ae039), {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $f47135850376bbc1$export$2e2bcd8739ae039), {
                                                    onClick: item.onClick,
                                                    selected: item.active,
                                                    children: [
                                                        /*#__PURE__*/ (0, $592Nh.jsx)($21caaf49acfe014f$var$StyledListItemIcon, {
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $592Nh.jsx)((0, $227710469f9d2c1d$export$2e2bcd8739ae039), {
                                                            primary: item.value
                                                        })
                                                    ]
                                                })
                                            }, item.key))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)($21caaf49acfe014f$var$Main, {
                    open: showSideMenu,
                    mobile: mobile,
                    children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $2b9be4f525f9526f$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $ddac0e7b333c55e7$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
                                children: props.children
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $21caaf49acfe014f$export$2e2bcd8739ae039 = $21caaf49acfe014f$var$AppMenu;




var $592Nh = parcelRequire("592Nh");

parcelRequire("2hDQc");



const $6b1d585dc0fb6610$var$MoovyRoute = ({ isProgress: isProgress = false, isAllowed: isAllowed = true, redirectPath: redirectPath = (0, $c753d58728ea6715$export$61147a57d3c24ac8).ROOT, children: children })=>{
    const { isAuthenticated: isAuthenticated } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    if (isProgress) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {});
    if (!isAuthenticated || !isAllowed) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$444b3ab0cb9aec40), {
        to: redirectPath,
        replace: true
    });
    return children ? children : /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$910ae8079b2c2852), {});
};
var $6b1d585dc0fb6610$export$2e2bcd8739ae039 = $6b1d585dc0fb6610$var$MoovyRoute;






var $592Nh = parcelRequire("592Nh");

var $2hDQc = parcelRequire("2hDQc");




var $592Nh = parcelRequire("592Nh");

var $2hDQc = parcelRequire("2hDQc");




const $c95516bc55ca8f1b$var$DevLogin = ()=>{
    const [email, setEmail] = (0, $2hDQc.useState)("");
    const [error, setError] = (0, $2hDQc.useState)("");
    const { setAuthentication: setAuthentication } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setError("");
        try {
            const token = await (0, $9b69f9955ab78e59$export$2e2bcd8739ae039).devLogin(email);
            const decoded = (0, $cd88019720f33fe3$export$fa1e2fb699b7861e)(token);
            setAuthentication({
                userGroups: decoded["cognito:groups"]?.join(","),
                token: token
            });
            (0, $9b69f9955ab78e59$export$2e2bcd8739ae039).setTokenToInterceptor(token);
        } catch (e) {
            setError(`${e.message}: ${e.response?.data?.error}`);
        }
    };
    return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $a0431259ffdfa92f$export$2e2bcd8739ae039), {
        component: "form",
        onSubmit: handleSubmit,
        sx: {
            marginTop: "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2
        },
        noValidate: true,
        autoComplete: "off",
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)("h1", {
                children: "Local development login is enabled"
            }),
            /*#__PURE__*/ (0, $592Nh.jsxs)("p", {
                style: {
                    marginTop: 0
                },
                children: [
                    "Want to enable Cognito authentication? Set environment variable",
                    " ",
                    /*#__PURE__*/ (0, $592Nh.jsx)("code", {
                        children: "DISABLE_COGNITO_AUTHENTICATION"
                    }),
                    " to false."
                ]
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $ea4b9cb15628748b$export$2e2bcd8739ae039), {
                required: true,
                id: "outlined-required",
                label: "Email",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                type: "email",
                helperText: "Email to sign in with. Include word 'admin' to sign in with admin user."
            }),
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $b439b08811d707e1$export$2e2bcd8739ae039), {
                variant: "contained",
                type: "submit",
                children: "Submit"
            }),
            error && /*#__PURE__*/ (0, $592Nh.jsx)((0, $33c2057624e26cc6$export$2e2bcd8739ae039), {
                severity: "error",
                children: error
            })
        ]
    });
};
var $c95516bc55ca8f1b$export$2e2bcd8739ae039 = $c95516bc55ca8f1b$var$DevLogin;




const $2e255c9661dafc00$var$LocalAuthenticator = ({ children: children })=>{
    const { isAuthenticated: isAuthenticated, setAuthentication: setAuthentication, token: token } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const { customer: customer } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const authenticatedAndCustomerFound = Boolean(isAuthenticated && customer.id);
    const { queryPlaces: queryPlaces, queryCustomers: queryCustomers, waitingForCustomers: waitingForCustomers, waitingForPlaces: waitingForPlaces } = (0, $52c37f2f8c911c73$export$2e2bcd8739ae039)({
        customerId: customer?.id,
        queryCataloguesEnabled: authenticatedAndCustomerFound,
        queryPlacesEnabled: authenticatedAndCustomerFound,
        queryCustomersEnabled: isAuthenticated
    });
    // Need to set user groups again from token after possible reload
    (0, $2hDQc.useEffect)(()=>{
        if (isAuthenticated) {
            const decoded = (0, $cd88019720f33fe3$export$fa1e2fb699b7861e)(token);
            const userGroups = decoded ? decoded["cognito:groups"]?.join(",") : [];
            setAuthentication({
                userGroups: userGroups,
                token: token
            });
        }
    }, [
        isAuthenticated
    ]);
    if (!isAuthenticated) return /*#__PURE__*/ (0, $592Nh.jsx)((0, $c95516bc55ca8f1b$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $592Nh.Fragment), {
        children: !isAuthenticated || waitingForCustomers || waitingForPlaces ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $4453c76d9a9c1264$export$2e2bcd8739ae039), {}) : queryPlaces.isError || queryCustomers.isError ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $0ad050a15234ec76$export$2e2bcd8739ae039), {}) : children
    });
};
var $2e255c9661dafc00$export$2e2bcd8739ae039 = $2e255c9661dafc00$var$LocalAuthenticator;


const $05214e8d6426daae$var$AppRoutes = ()=>{
    const { isPermission: isPermission } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    const { customer: customer, place: place, initialized: initialized, catalogueId: catalogueId } = (0, $d0a1f62c0ded2cbf$export$2e2bcd8739ae039)();
    const RouteHome = ()=>{
        const showLoginRoute = !customer?.id || !place?.id;
        const isRootPlaces = isPermission("READ", "ADMIN_PLACES");
        const isRootPlace = !isRootPlaces && isPermission("READ", "PLACES");
        return /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
            isProgress: !initialized,
            isAllowed: !showLoginRoute,
            redirectPath: (0, $c753d58728ea6715$export$61147a57d3c24ac8).LOGIN_STEPS,
            children: isRootPlaces ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$444b3ab0cb9aec40), {
                to: (0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES,
                replace: true
            }) : isRootPlace ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$444b3ab0cb9aec40), {
                to: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/${place.id}`,
                replace: true
            }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$444b3ab0cb9aec40), {
                to: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CATALOGUES}/${catalogueId}`,
                replace: true
            })
        });
    };
    const MoovyRouters = ()=>{
        return /*#__PURE__*/ (0, $592Nh.jsxs)((0, $86f6846c59d1b386$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)(RouteHome, {})
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: (0, $c753d58728ea6715$export$61147a57d3c24ac8).INVITATIONS,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "LANDLORD_INVITATIONS"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $bf15ae79bcdd79ca$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: (0, $c753d58728ea6715$export$61147a57d3c24ac8).LOGIN_STEPS,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $09bbf9a38ef348fb$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHT_HOLDERS}/:rightHolderRef`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "RIGHT_HOLDERS"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $994bc4410f661880$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: (0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "ADMIN_PLACES"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $bc1972822b94da20$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/:placeParentRef${(0, $c753d58728ea6715$export$25c4819f1669a599).SUB_PLACES}/:placeRef`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "PLACES"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $fd7de2136a4de36c$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).PLACES}/:placeRef`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "PLACES"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $fd7de2136a4de36c$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).OFFERINGS}/:offeringId`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "OFFERING"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $0b0cc6f98ae6eb9e$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CATALOGUES}/:catalogueRef`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $49cb6c7164a35383$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).CUSTOMERS}/:customerRef`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "CUSTOMER"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $3da4975b8ab9ba9a$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: (0, $c753d58728ea6715$export$61147a57d3c24ac8).REPORTS,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $66918ae2d7734ad3$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: (0, $c753d58728ea6715$export$61147a57d3c24ac8).USERS,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $b200d14c7751dbfa$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: `${(0, $c753d58728ea6715$export$61147a57d3c24ac8).RIGHTS}/:ref`,
                    element: /*#__PURE__*/ (0, $592Nh.jsx)((0, $6b1d585dc0fb6610$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "RIGHTS"),
                        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $47ed45c6fbf548be$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $86f6846c59d1b386$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $592Nh.jsx)(RouteHome, {})
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $944912ac1928e04f$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $21caaf49acfe014f$export$2e2bcd8739ae039), {
            children: (0, $87c980b245bbb7d9$export$c87012121925caf1) && (0, $87c980b245bbb7d9$export$a743660edcdb697b) ? /*#__PURE__*/ (0, $592Nh.jsx)((0, $2e255c9661dafc00$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)(MoovyRouters, {})
            }) : /*#__PURE__*/ (0, $592Nh.jsx)((0, $97e236a54f421b1b$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $592Nh.jsx)(MoovyRouters, {})
            })
        })
    });
};
var $05214e8d6426daae$export$2e2bcd8739ae039 = $05214e8d6426daae$var$AppRoutes;




var $kxIgO = parcelRequire("kxIgO");

var $2hDQc = parcelRequire("2hDQc");


var $afHYP = parcelRequire("afHYP");


var $592Nh = parcelRequire("592Nh");
"use client";
const $2ff436bd614d1d34$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $kxIgO.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $2ff436bd614d1d34$export$32180ef41b15b513 = (theme)=>(0, $kxIgO.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $2ff436bd614d1d34$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $kxIgO.default)({
        html: $2ff436bd614d1d34$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $kxIgO.default)({
            margin: 0
        }, $2ff436bd614d1d34$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $2ff436bd614d1d34$var$CssBaseline(inProps) {
    const props = (0, $afHYP.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $592Nh.jsxs)($2hDQc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $592Nh.jsx)((0, $1cc3ee8eb12d8b92$export$2e2bcd8739ae039), {
                styles: (theme)=>$2ff436bd614d1d34$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $2ff436bd614d1d34$export$2e2bcd8739ae039 = $2ff436bd614d1d34$var$CssBaseline;










const $cc9d09a6f2edbadb$var$App = ()=>{
    const queryClient = new (0, $4357da78055da784$export$405d0624ed55a03f)();
    const { locale: locale } = (0, $2baeba59fba86da4$export$2e2bcd8739ae039)();
    const { isAuthenticated: isAuthenticated } = (0, $be143ece6599869a$export$2e2bcd8739ae039)();
    (0, $37ce39b7ffc76760$export$2c56d2e2ae515eeb).setLicenseKey("0b8f51d13b8e3aef7b858e72e04e496fTz0xMDA3ODIsRT0xNzYxNzI3MjE0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");
    // TODO Antti:
    // Missing theme fixes:
    // * Autofill input color of login must be fixed
    const theme = (0, $gWoNj.default)({
        palette: {
            primary: {
                main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).primaryMain
            },
            secondary: {
                main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).secondaryMain
            },
            error: {
                main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).errorMain
            },
            warning: {
                main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).warningMain
            },
            info: {
                main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).infoMain
            },
            success: {
                main: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).successMain
            },
            text: {
                primary: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlack
            },
            common: {
                black: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlack,
                white: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonWhite
            }
        },
        shape: {
            borderRadius: 10
        },
        typography: {
            fontFamily: (0, $53be88aa100c8649$export$6039b89271c3de71).fontFamily
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    a: {
                        color: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlue
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: (0, $53be88aa100c8649$export$6039b89271c3de71).buttonFontWeight
                    }
                }
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        backgroundColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).colorTableHeader,
                        "& .MuiTableCell-root": {
                            fontWeight: (0, $53be88aa100c8649$export$6039b89271c3de71).tableHeadFontWeight
                        }
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& input:-webkit-autofill": {
                            WebkitTextFillColor: (0, $53be88aa100c8649$export$f86ab2f69f02b2d9).commonBlack
                        }
                    }
                }
            },
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        cursor: "pointer"
                    }
                }
            },
            MuiListItem: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "0",
                        paddingTop: "2px",
                        paddingLeft: "2px",
                        paddingRight: "0",
                        margin: "0"
                    }
                }
            },
            MuiListItemText: {
                styleOverrides: {
                    root: {
                        paddingLeft: "10px"
                    }
                }
            }
        }
    });
    (0, $2hDQc.useEffect)(()=>{
        const reloadPage = (0, $2e2f998e72251dab$export$2e2bcd8739ae039).language !== locale;
        (0, $2ffc6dafd8dc611a$export$dbe3113d60765c1a).putVocabulariesForLanguage(locale, (0, $d30a5fdc49293dc0$export$d2223424998443a9)[locale].translation);
        (0, $2ffc6dafd8dc611a$export$dbe3113d60765c1a).setLanguage(locale);
        (0, $2e2f998e72251dab$export$2e2bcd8739ae039).changeLanguage(locale);
        if (!isAuthenticated && reloadPage) // Cognito login page needs this
        window.location.reload();
    }, [
        locale,
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0, $592Nh.jsx)((0, $a8df4d8b672eba1c$exports.IntlProvider), {
        locale: locale,
        messages: (0, $d30a5fdc49293dc0$export$bc99aaabaf7b70a7)[locale].translation,
        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $97855a2dd31730f4$export$45604f0cc8ae667b), {
            client: queryClient,
            children: [
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $3b24cfd775fb7d30$export$f2815235e76a62b9), {
                    position: "top-right"
                }),
                /*#__PURE__*/ (0, $592Nh.jsx)((0, $f7223b976be2f24f$export$3d7a1e8452f884f3).Provider, {
                    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $475d001d26d8ffa6$export$2e2bcd8739ae039), {
                        theme: theme,
                        children: /*#__PURE__*/ (0, $592Nh.jsxs)((0, $cfd5de74b2d9a49e$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $4576ab8f9f2fa9de$export$e130a45610e3b3b2),
                            adapterLocale: locale || "fi",
                            children: [
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $2ff436bd614d1d34$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $592Nh.jsx)((0, $05214e8d6426daae$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $cc9d09a6f2edbadb$export$2e2bcd8739ae039 = $cc9d09a6f2edbadb$var$App;




var $2hDQc = parcelRequire("2hDQc");
var $c8a87c2a515c97a7$export$882461b6382ed46c;
var $c8a87c2a515c97a7$export$757ceba2d55c277e;
"use strict";

var $c8a87c2a515c97a7$var$i;
$c8a87c2a515c97a7$export$882461b6382ed46c = $b36a61f25d8b4314$exports.createRoot;
$c8a87c2a515c97a7$export$757ceba2d55c277e = $b36a61f25d8b4314$exports.hydrateRoot;





const $cd504686f3a003b4$export$6f57813fe9f31bf9 = (0, $b6d40e24321310a3$export$7d8a5b498da695ac)({
    reducer: {
        moovyUi: $d79f754417ba871e$export$2e2bcd8739ae039,
        moovyAuth: $7d14d2e2868bd10d$export$2e2bcd8739ae039
    }
});



var $02dc3fa6e24fa522$export$2e2bcd8739ae039 = (gtagId)=>{
    const scriptElements = [
        0,
        1
    ].map((_)=>document.createElement("script"));
    if (!/^[a-zA-Z0-9-]*$/.test(gtagId)) throw new Error(`GTAG_ID must only contain letters, numbers and hyphens (got: "${gtagId}")`);
    // first script element (loading Google Analytics)
    scriptElements[0].attributes.setNamedItem(document.createAttribute("async"));
    const srcAttribute = document.createAttribute("src");
    srcAttribute.value = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    scriptElements[0].attributes.setNamedItem(srcAttribute);
    // second script element (inline script)
    scriptElements[1].textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gtagId}');
  `;
    // inject the script elements
    scriptElements.forEach((scriptElement)=>document.getElementsByTagName("body")[0].appendChild(scriptElement));
};


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $d58394577b25a7dd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $d58394577b25a7dd$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $d58394577b25a7dd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $d58394577b25a7dd$var$isGlobalObj(window) || typeof self == "object" && $d58394577b25a7dd$var$isGlobalObj(self) || typeof $parcel$global == "object" && $d58394577b25a7dd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $d58394577b25a7dd$export$256479dc0cea61c4() {
    return $d58394577b25a7dd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $d58394577b25a7dd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $d58394577b25a7dd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $fc911ca066fa75c2$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$e6127cc7fe7395c3(wat) {
    switch($fc911ca066fa75c2$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $fc911ca066fa75c2$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$var$isBuiltin(wat, className) {
    return $fc911ca066fa75c2$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$9f9636d330b71954(wat) {
    return $fc911ca066fa75c2$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$ef9e2056653f0c8e(wat) {
    return $fc911ca066fa75c2$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$12e869b2a583f783(wat) {
    return $fc911ca066fa75c2$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$844ec244b1367d54(wat) {
    return $fc911ca066fa75c2$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$c3825b437cbdea5c(wat) {
    return wat === null || $fc911ca066fa75c2$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$53b83ca8eaab0383(wat) {
    return $fc911ca066fa75c2$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $fc911ca066fa75c2$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $fc911ca066fa75c2$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$49841c62b9eff15(wat) {
    return $fc911ca066fa75c2$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $fc911ca066fa75c2$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$bc2894c7158efbac(wat) {
    return $fc911ca066fa75c2$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $fc911ca066fa75c2$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9e806c458094fe1e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $3c4d30f0d3028b15$var$PREFIX = "Sentry Logger ";
const $3c4d30f0d3028b15$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $3c4d30f0d3028b15$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3c4d30f0d3028b15$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3c4d30f0d3028b15$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3c4d30f0d3028b15$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3c4d30f0d3028b15$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $9e806c458094fe1e$export$16a28057038b10ef) $3c4d30f0d3028b15$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3c4d30f0d3028b15$export$cda52e2a8927a2ca(()=>{
                (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).console[name](`${$3c4d30f0d3028b15$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3c4d30f0d3028b15$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $3c4d30f0d3028b15$export$af88d00dbe7f521 = $3c4d30f0d3028b15$var$makeLogger();


const $d59dd3fae5fc220e$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $d59dd3fae5fc220e$export$7740643b9eeaf0c4() {
    return Date.now() / $d59dd3fae5fc220e$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $d59dd3fae5fc220e$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $d59dd3fae5fc220e$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $d59dd3fae5fc220e$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $d59dd3fae5fc220e$export$ee52dced521e3e18 = $d59dd3fae5fc220e$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $d59dd3fae5fc220e$export$c5907b5a8838db13 = $d59dd3fae5fc220e$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $d59dd3fae5fc220e$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $d59dd3fae5fc220e$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $d59dd3fae5fc220e$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $d59dd3fae5fc220e$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $d59dd3fae5fc220e$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $d59dd3fae5fc220e$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



// eslint-disable-next-line deprecation/deprecation
const $8a18c3c2a11733c0$var$WINDOW = (0, $d58394577b25a7dd$export$256479dc0cea61c4)();
const $8a18c3c2a11733c0$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8a18c3c2a11733c0$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8a18c3c2a11733c0$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8a18c3c2a11733c0$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8a18c3c2a11733c0$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($8a18c3c2a11733c0$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $fc911ca066fa75c2$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $8a18c3c2a11733c0$export$1cfafeee2987818b() {
    try {
        return $8a18c3c2a11733c0$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8a18c3c2a11733c0$export$c660c1f3ab49225c(selector) {
    if ($8a18c3c2a11733c0$var$WINDOW.document && $8a18c3c2a11733c0$var$WINDOW.document.querySelector) return $8a18c3c2a11733c0$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8a18c3c2a11733c0$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8a18c3c2a11733c0$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $0f4ffa1af5d1985d$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $0f4ffa1af5d1985d$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0f4ffa1af5d1985d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $fc911ca066fa75c2$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $0f4ffa1af5d1985d$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $fc911ca066fa75c2$export$844ec244b1367d54)(value)) return false;
    if ((0, $fc911ca066fa75c2$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $fc911ca066fa75c2$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $0f4ffa1af5d1985d$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$0f4ffa1af5d1985d$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $2e1797501eb473e4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $2e1797501eb473e4$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $2e1797501eb473e4$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $9e806c458094fe1e$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $2e1797501eb473e4$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $2e1797501eb473e4$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $2e1797501eb473e4$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $2e1797501eb473e4$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $2e1797501eb473e4$export$62ff257738bf57f5(value) {
    if ((0, $fc911ca066fa75c2$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2e1797501eb473e4$var$getOwnProperties(value)
    };
    else if ((0, $fc911ca066fa75c2$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $2e1797501eb473e4$var$serializeEventTarget(value.target),
            currentTarget: $2e1797501eb473e4$var$serializeEventTarget(value.currentTarget),
            ...$2e1797501eb473e4$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $fc911ca066fa75c2$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $2e1797501eb473e4$var$serializeEventTarget(target) {
    try {
        return (0, $fc911ca066fa75c2$export$45a5e7f76e0caa8d)(target) ? (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $2e1797501eb473e4$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $2e1797501eb473e4$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($2e1797501eb473e4$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $0f4ffa1af5d1985d$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $0f4ffa1af5d1985d$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $2e1797501eb473e4$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $2e1797501eb473e4$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2e1797501eb473e4$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($2e1797501eb473e4$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $2e1797501eb473e4$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($2e1797501eb473e4$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $2e1797501eb473e4$var$isPojo(input) {
    if (!(0, $fc911ca066fa75c2$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $2e1797501eb473e4$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $fc911ca066fa75c2$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $db1a2eab7c136bdd$export$19f53698e68b2496() {
    const gbl = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $db1a2eab7c136bdd$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $db1a2eab7c136bdd$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $db1a2eab7c136bdd$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $db1a2eab7c136bdd$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $db1a2eab7c136bdd$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $db1a2eab7c136bdd$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $db1a2eab7c136bdd$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $db1a2eab7c136bdd$export$d364f2020ab30578(input) {
    const match = input.match($db1a2eab7c136bdd$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $db1a2eab7c136bdd$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $0f4ffa1af5d1985d$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $0f4ffa1af5d1985d$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $0f4ffa1af5d1985d$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $db1a2eab7c136bdd$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $2e1797501eb473e4$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $db1a2eab7c136bdd$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $a74f37e25e55df96$export$849dbeeeda01ae98 = "production";


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e03b200d766e19c9$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;







/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $c585f08bd631ba97$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c585f08bd631ba97$var$States || ($c585f08bd631ba97$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c585f08bd631ba97$export$1fda8aa4d135f8aa(value) {
    return new $c585f08bd631ba97$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c585f08bd631ba97$export$78e43115b553f358(reason) {
    return new $c585f08bd631ba97$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $c585f08bd631ba97$export$6f292d4960313241 {
    constructor(executor){
        $c585f08bd631ba97$export$6f292d4960313241.prototype.__init.call(this);
        $c585f08bd631ba97$export$6f292d4960313241.prototype.__init2.call(this);
        $c585f08bd631ba97$export$6f292d4960313241.prototype.__init3.call(this);
        $c585f08bd631ba97$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $c585f08bd631ba97$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $c585f08bd631ba97$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $c585f08bd631ba97$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($c585f08bd631ba97$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($c585f08bd631ba97$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $c585f08bd631ba97$var$States.PENDING) return;
            if ((0, $fc911ca066fa75c2$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $c585f08bd631ba97$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $c585f08bd631ba97$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $c585f08bd631ba97$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $9ac7155897144150$export$3c4238858b85e8ac() {
    return (0, $d58394577b25a7dd$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $9ac7155897144150$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $9ac7155897144150$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $9ac7155897144150$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $c585f08bd631ba97$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && processor.id && result === null && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $fc911ca066fa75c2$export$f5b060c2914b97c8)(result)) result.then((final)=>$9ac7155897144150$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $9ac7155897144150$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ea2f936a7221cf3c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ea2f936a7221cf3c$var$sessionToJSON(session)
    };
    if (context) $ea2f936a7221cf3c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ea2f936a7221cf3c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ea2f936a7221cf3c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ea2f936a7221cf3c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ea2f936a7221cf3c$var$sessionToJSON(session) {
    return (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $de80b4d78df58fd4$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $37635ed0fe709d12$export$9ca9946bd449ac06 = "baggage";
const $37635ed0fe709d12$export$6e69537d67fa20f = "sentry-";
const $37635ed0fe709d12$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $37635ed0fe709d12$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $37635ed0fe709d12$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $fc911ca066fa75c2$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $37635ed0fe709d12$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $37635ed0fe709d12$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($37635ed0fe709d12$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($37635ed0fe709d12$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $37635ed0fe709d12$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$37635ed0fe709d12$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $37635ed0fe709d12$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $37635ed0fe709d12$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $37635ed0fe709d12$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $37635ed0fe709d12$export$bdd844ddb2def819) {
            (0, $9e806c458094fe1e$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $c7b1128cbfbed8e5$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $c7b1128cbfbed8e5$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($c7b1128cbfbed8e5$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $c7b1128cbfbed8e5$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $c7b1128cbfbed8e5$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $37635ed0fe709d12$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
            spanId: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16),
            spanId: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $c7b1128cbfbed8e5$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $c7b1128cbfbed8e5$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $37635ed0fe709d12$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
        spanId: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16),
        spanId: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $c7b1128cbfbed8e5$export$f35d907436da45cf(traceId = (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(), spanId = (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $d07da62ed3ec9e2d$export$208d5b368507fb8b = 0x0;
const $d07da62ed3ec9e2d$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $d07da62ed3ec9e2d$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $d07da62ed3ec9e2d$export$92d8c23565496537(span);
    return (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $d07da62ed3ec9e2d$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d07da62ed3ec9e2d$export$5caecac1caaf3a71(span);
    return (0, $c7b1128cbfbed8e5$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $d07da62ed3ec9e2d$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $d07da62ed3ec9e2d$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d07da62ed3ec9e2d$var$ensureTimestampInSeconds(input.getTime());
    return (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $d07da62ed3ec9e2d$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $d07da62ed3ec9e2d$export$92d8c23565496537(span) {
    if ($d07da62ed3ec9e2d$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $d07da62ed3ec9e2d$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $d07da62ed3ec9e2d$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $d07da62ed3ec9e2d$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $c3cc587f6f15fc71$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
        environment: options.environment || (0, $a74f37e25e55df96$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $c3cc587f6f15fc71$export$a117f995597e25df(span) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $c3cc587f6f15fc71$export$366bad00d6815eed((0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).trace_id || "", client, (0, $fcd9e096f030e706$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $de80b4d78df58fd4$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $d07da62ed3ec9e2d$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $58f26fc68e398431$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $58f26fc68e398431$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $58f26fc68e398431$var$applySpanToEvent(event, span);
    $58f26fc68e398431$var$applyFingerprintToEvent(event, fingerprint);
    $58f26fc68e398431$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $58f26fc68e398431$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $58f26fc68e398431$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $58f26fc68e398431$export$b1a120a2871faa46(data, "extra", extra);
    $58f26fc68e398431$export$b1a120a2871faa46(data, "tags", tags);
    $58f26fc68e398431$export$b1a120a2871faa46(data, "user", user);
    $58f26fc68e398431$export$b1a120a2871faa46(data, "contexts", contexts);
    $58f26fc68e398431$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $58f26fc68e398431$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $58f26fc68e398431$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $2e1797501eb473e4$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $2e1797501eb473e4$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $2e1797501eb473e4$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $2e1797501eb473e4$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $58f26fc68e398431$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $58f26fc68e398431$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $58f26fc68e398431$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $d07da62ed3ec9e2d$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $de80b4d78df58fd4$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $c3cc587f6f15fc71$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $58f26fc68e398431$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $db1a2eab7c136bdd$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $a098d3fc48a1533f$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $a098d3fc48a1533f$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $a098d3fc48a1533f$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $a098d3fc48a1533f$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $a098d3fc48a1533f$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $a098d3fc48a1533f$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $ea2f936a7221cf3c$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $a098d3fc48a1533f$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $fc911ca066fa75c2$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $a098d3fc48a1533f$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $a098d3fc48a1533f$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $d59dd3fae5fc220e$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $58f26fc68e398431$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $9ac7155897144150$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $9ac7155897144150$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $a098d3fc48a1533f$export$aa55d5ab8e05984f() {
    if (!$a098d3fc48a1533f$var$globalScope) $a098d3fc48a1533f$var$globalScope = new $a098d3fc48a1533f$export$775b6bb06e53a214();
    return $a098d3fc48a1533f$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $a098d3fc48a1533f$export$c83048efd17527d6(scope) {
    $a098d3fc48a1533f$var$globalScope = scope;
}
function $a098d3fc48a1533f$var$generatePropagationContext() {
    return {
        traceId: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
        spanId: (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16)
    };
}



const $165374440ccbcb65$export$31499a9cd224b78c = "7.112.2";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $805d0d6bf1179169$export$24a86ef7798177e4 = parseFloat((0, $165374440ccbcb65$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $805d0d6bf1179169$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $805d0d6bf1179169$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $805d0d6bf1179169$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $a098d3fc48a1533f$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $a098d3fc48a1533f$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $fc911ca066fa75c2$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $805d0d6bf1179169$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $d59dd3fae5fc220e$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $3c4d30f0d3028b15$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $805d0d6bf1179169$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $805d0d6bf1179169$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $e03b200d766e19c9$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $ea2f936a7221cf3c$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $a74f37e25e55df96$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $ea2f936a7221cf3c$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $ea2f936a7221cf3c$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $805d0d6bf1179169$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $805d0d6bf1179169$export$19eade501500c6c1() {
    (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $d58394577b25a7dd$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $805d0d6bf1179169$export$4188a14ad302d1bc(hub) {
    const registry = $805d0d6bf1179169$export$19eade501500c6c1();
    const oldHub = $805d0d6bf1179169$export$bfa8a924a84a76b7(registry);
    $805d0d6bf1179169$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $805d0d6bf1179169$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $805d0d6bf1179169$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $805d0d6bf1179169$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $805d0d6bf1179169$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $805d0d6bf1179169$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $805d0d6bf1179169$var$getGlobalHub(registry = $805d0d6bf1179169$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$805d0d6bf1179169$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $805d0d6bf1179169$export$bfa8a924a84a76b7(registry).isOlderThan($805d0d6bf1179169$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $805d0d6bf1179169$export$849f05434e95d2f2(registry, new $805d0d6bf1179169$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $805d0d6bf1179169$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $805d0d6bf1179169$export$236689a79f5aa020(carrier, parent = $805d0d6bf1179169$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$805d0d6bf1179169$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $805d0d6bf1179169$export$bfa8a924a84a76b7(carrier).isOlderThan($805d0d6bf1179169$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $805d0d6bf1179169$export$849f05434e95d2f2(carrier, new $805d0d6bf1179169$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $805d0d6bf1179169$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $805d0d6bf1179169$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $805d0d6bf1179169$export$70d775fb1f267027(callback, options = {}) {
    const registry = $805d0d6bf1179169$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $805d0d6bf1179169$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $805d0d6bf1179169$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $d58394577b25a7dd$export$7e223ec222791509)("hub", ()=>new $805d0d6bf1179169$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $805d0d6bf1179169$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $e60074c6d8a82a02$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $7987c7a77a3b995a$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $7987c7a77a3b995a$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $7987c7a77a3b995a$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $797c2bd47eb6cfb1$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $797c2bd47eb6cfb1$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $797c2bd47eb6cfb1$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $797c2bd47eb6cfb1$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $797c2bd47eb6cfb1$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($797c2bd47eb6cfb1$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $797c2bd47eb6cfb1$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $797c2bd47eb6cfb1$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $797c2bd47eb6cfb1$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $797c2bd47eb6cfb1$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $797c2bd47eb6cfb1$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($797c2bd47eb6cfb1$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($797c2bd47eb6cfb1$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $797c2bd47eb6cfb1$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $797c2bd47eb6cfb1$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $797c2bd47eb6cfb1$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $797c2bd47eb6cfb1$var$defaultFunctionName;
        return fn.name || $797c2bd47eb6cfb1$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $797c2bd47eb6cfb1$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $797c2bd47eb6cfb1$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $7987c7a77a3b995a$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $359c7e66c2efdebe$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $359c7e66c2efdebe$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $359c7e66c2efdebe$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $359c7e66c2efdebe$export$a3295358bff77e(object, depth);
    if ($359c7e66c2efdebe$var$jsonSize(normalized) > maxSize) return $359c7e66c2efdebe$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $359c7e66c2efdebe$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $e60074c6d8a82a02$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $fc911ca066fa75c2$export$c9f5652083b8129d)(value)) return value;
    const stringified = $359c7e66c2efdebe$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $359c7e66c2efdebe$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $2e1797501eb473e4$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $359c7e66c2efdebe$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $359c7e66c2efdebe$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $fc911ca066fa75c2$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $fc911ca066fa75c2$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $359c7e66c2efdebe$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $359c7e66c2efdebe$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $359c7e66c2efdebe$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $359c7e66c2efdebe$var$jsonSize(value) {
    return $359c7e66c2efdebe$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $359c7e66c2efdebe$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $9fd9d491325e9f58$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $d59dd3fae5fc220e$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $9fd9d491325e9f58$var$applyClientOptions(prepared, options);
    $9fd9d491325e9f58$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $9fd9d491325e9f58$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $9fd9d491325e9f58$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $db1a2eab7c136bdd$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $a098d3fc48a1533f$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $58f26fc68e398431$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $58f26fc68e398431$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $58f26fc68e398431$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $9ac7155897144150$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $9ac7155897144150$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $9fd9d491325e9f58$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $9fd9d491325e9f58$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $9fd9d491325e9f58$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $a74f37e25e55df96$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $0f4ffa1af5d1985d$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $0f4ffa1af5d1985d$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $0f4ffa1af5d1985d$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $9fd9d491325e9f58$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $9fd9d491325e9f58$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $9fd9d491325e9f58$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $9fd9d491325e9f58$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $9fd9d491325e9f58$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $9fd9d491325e9f58$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $9fd9d491325e9f58$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $359c7e66c2efdebe$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $359c7e66c2efdebe$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $359c7e66c2efdebe$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $359c7e66c2efdebe$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $359c7e66c2efdebe$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $359c7e66c2efdebe$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $9fd9d491325e9f58$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $a098d3fc48a1533f$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $9fd9d491325e9f58$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($9fd9d491325e9f58$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($9fd9d491325e9f58$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $9fd9d491325e9f58$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $a098d3fc48a1533f$export$775b6bb06e53a214) || typeof hint === "function";
}
const $9fd9d491325e9f58$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $9fd9d491325e9f58$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$9fd9d491325e9f58$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fcd9e096f030e706$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().captureException(exception, (0, $9fd9d491325e9f58$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fcd9e096f030e706$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fcd9e096f030e706$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $fcd9e096f030e706$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $fcd9e096f030e706$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $fcd9e096f030e706$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $fcd9e096f030e706$export$9a4fed82c350c2bd(callback) {
    return (0, $805d0d6bf1179169$export$70d775fb1f267027)(()=>{
        return callback((0, $805d0d6bf1179169$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $fcd9e096f030e706$export$e57ac09b143d92a2(span, callback) {
    return $fcd9e096f030e706$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $fcd9e096f030e706$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fcd9e096f030e706$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $fcd9e096f030e706$export$c7be4b0125a10cba();
    const client = $fcd9e096f030e706$export$6bb76d6eba7e258c();
    if (!client) (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fcd9e096f030e706$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $fcd9e096f030e706$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $fcd9e096f030e706$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $fc911ca066fa75c2$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fcd9e096f030e706$export$4909b86c8034bf73(timeout) {
    const client = $fcd9e096f030e706$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fcd9e096f030e706$export$8360e631d277ea4d(timeout) {
    const client = $fcd9e096f030e706$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $fcd9e096f030e706$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $fcd9e096f030e706$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $fcd9e096f030e706$export$3f95c6f800b78024() {
    return !!$fcd9e096f030e706$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $fcd9e096f030e706$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fcd9e096f030e706$export$c0d84948cecf78d8(context) {
    const client = $fcd9e096f030e706$export$6bb76d6eba7e258c();
    const isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)();
    const currentScope = $fcd9e096f030e706$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $a74f37e25e55df96$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ea2f936a7221cf3c$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $ea2f936a7221cf3c$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $fcd9e096f030e706$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $fcd9e096f030e706$export$17a5be43989a0bc1() {
    const isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)();
    const currentScope = $fcd9e096f030e706$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ea2f936a7221cf3c$export$56521d9ba90f62ee)(session);
    $fcd9e096f030e706$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fcd9e096f030e706$var$_sendSessionUpdate() {
    const isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)();
    const currentScope = $fcd9e096f030e706$export$c7be4b0125a10cba();
    const client = $fcd9e096f030e706$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fcd9e096f030e706$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fcd9e096f030e706$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $fcd9e096f030e706$var$_sendSessionUpdate();
}








const $b7daa41624c279e2$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $b7daa41624c279e2$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $b7daa41624c279e2$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $db1a2eab7c136bdd$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $b7daa41624c279e2$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $b7daa41624c279e2$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $b7daa41624c279e2$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $b7daa41624c279e2$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $b7daa41624c279e2$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $b7daa41624c279e2$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($b7daa41624c279e2$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $9ac7155897144150$export$8e4e25f54d456511), (0, $805d0d6bf1179169$export$a07cdf6544bbd7c));
        $b7daa41624c279e2$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $b7daa41624c279e2$export$2d8f5188773bcddd(integration) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $b7daa41624c279e2$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $b7daa41624c279e2$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $b7daa41624c279e2$export$2323046b9414659f(fn) {
    return fn;
}


let $5cd3251c619fffd4$var$originalFunctionToString;
const $5cd3251c619fffd4$var$INTEGRATION_NAME = "FunctionToString";
const $5cd3251c619fffd4$var$SETUP_CLIENTS = new WeakMap();
const $5cd3251c619fffd4$var$_functionToStringIntegration = ()=>{
    return {
        name: $5cd3251c619fffd4$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $5cd3251c619fffd4$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $2e1797501eb473e4$export$e6cc1e135e2092e5)(this);
                    const context = $5cd3251c619fffd4$var$SETUP_CLIENTS.has((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $5cd3251c619fffd4$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $5cd3251c619fffd4$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $5cd3251c619fffd4$export$7918117e9202e4fb = (0, $b7daa41624c279e2$export$2323046b9414659f)($5cd3251c619fffd4$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5cd3251c619fffd4$export$da4704525c20ae79 = (0, $b7daa41624c279e2$export$afa219bf23651160)($5cd3251c619fffd4$var$INTEGRATION_NAME, $5cd3251c619fffd4$export$7918117e9202e4fb);



/** Regular expression used to parse a Dsn. */ const $9ac7cae31cb69a4b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9ac7cae31cb69a4b$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9ac7cae31cb69a4b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9ac7cae31cb69a4b$export$b892860177f70a30(str) {
    const match = $9ac7cae31cb69a4b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $3c4d30f0d3028b15$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9ac7cae31cb69a4b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9ac7cae31cb69a4b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $9ac7cae31cb69a4b$var$validateDsn(dsn) {
    if (!(0, $9e806c458094fe1e$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9ac7cae31cb69a4b$var$isValidProtocol(protocol)) {
        (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9ac7cae31cb69a4b$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $9ac7cae31cb69a4b$export$b892860177f70a30(from) : $9ac7cae31cb69a4b$var$dsnFromComponents(from);
    if (!components || !$9ac7cae31cb69a4b$var$validateDsn(components)) return undefined;
    return components;
}


const $383fb41d044050f9$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $383fb41d044050f9$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $383fb41d044050f9$var$_getIngestEndpoint(dsn) {
    return `${$383fb41d044050f9$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $383fb41d044050f9$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $2e1797501eb473e4$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $383fb41d044050f9$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $383fb41d044050f9$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$383fb41d044050f9$var$_getIngestEndpoint(dsn)}?${$383fb41d044050f9$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $383fb41d044050f9$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9ac7cae31cb69a4b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$383fb41d044050f9$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $58ba388a13cbb2ee$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $58ba388a13cbb2ee$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $58ba388a13cbb2ee$var$INTEGRATION_NAME = "InboundFilters";
const $58ba388a13cbb2ee$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $58ba388a13cbb2ee$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $58ba388a13cbb2ee$var$_mergeOptions(options, clientOptions);
            return $58ba388a13cbb2ee$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $58ba388a13cbb2ee$export$cb3c5c2ceb9818ba = (0, $b7daa41624c279e2$export$2323046b9414659f)($58ba388a13cbb2ee$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $58ba388a13cbb2ee$export$2ffbb5359dcc6be4 = (0, $b7daa41624c279e2$export$afa219bf23651160)($58ba388a13cbb2ee$var$INTEGRATION_NAME, $58ba388a13cbb2ee$export$cb3c5c2ceb9818ba);
function $58ba388a13cbb2ee$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $58ba388a13cbb2ee$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $58ba388a13cbb2ee$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $58ba388a13cbb2ee$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $58ba388a13cbb2ee$var$_isSentryError(event)) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($58ba388a13cbb2ee$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($58ba388a13cbb2ee$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($58ba388a13cbb2ee$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}.\nUrl: ${$58ba388a13cbb2ee$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$58ba388a13cbb2ee$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}.\nUrl: ${$58ba388a13cbb2ee$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $58ba388a13cbb2ee$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $58ba388a13cbb2ee$var$_getPossibleEventMessages(event).some((message)=>(0, $0f4ffa1af5d1985d$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $58ba388a13cbb2ee$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $0f4ffa1af5d1985d$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $58ba388a13cbb2ee$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $58ba388a13cbb2ee$var$_getEventFilterUrl(event);
    return !url ? false : (0, $0f4ffa1af5d1985d$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $58ba388a13cbb2ee$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $58ba388a13cbb2ee$var$_getEventFilterUrl(event);
    return !url ? true : (0, $0f4ffa1af5d1985d$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $58ba388a13cbb2ee$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $e03b200d766e19c9$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $58ba388a13cbb2ee$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $58ba388a13cbb2ee$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $58ba388a13cbb2ee$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $58ba388a13cbb2ee$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $390dfe62fd2e41ab$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $e03b200d766e19c9$export$16a28057038b10ef) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $3c4d30f0d3028b15$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $390dfe62fd2e41ab$export$ecb76f41d43c0e43(client);
    $390dfe62fd2e41ab$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $390dfe62fd2e41ab$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $390dfe62fd2e41ab$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $24895eddd73cba39$var$WINDOW = (0, $d58394577b25a7dd$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $24895eddd73cba39$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $24895eddd73cba39$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $24895eddd73cba39$var$WINDOW && !!$24895eddd73cba39$var$WINDOW.history.pushState && !!$24895eddd73cba39$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}





// We keep the handlers globally
const $7d15795f3a315afd$var$handlers = {};
const $7d15795f3a315afd$var$instrumented = {};
/** Add a handler function. */ function $7d15795f3a315afd$export$a4e09611e30da72e(type, handler) {
    $7d15795f3a315afd$var$handlers[type] = $7d15795f3a315afd$var$handlers[type] || [];
    $7d15795f3a315afd$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $7d15795f3a315afd$export$b17eab759a1cb5fe() {
    Object.keys($7d15795f3a315afd$var$handlers).forEach((key)=>{
        $7d15795f3a315afd$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $7d15795f3a315afd$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7d15795f3a315afd$var$instrumented[type]) {
        instrumentFn();
        $7d15795f3a315afd$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $7d15795f3a315afd$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7d15795f3a315afd$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $9e806c458094fe1e$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


const $ff311393fc83ca4e$var$WINDOW = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
let $ff311393fc83ca4e$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ff311393fc83ca4e$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $ff311393fc83ca4e$var$instrumentHistory);
}
function $ff311393fc83ca4e$var$instrumentHistory() {
    if (!(0, $24895eddd73cba39$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $ff311393fc83ca4e$var$WINDOW.onpopstate;
    $ff311393fc83ca4e$var$WINDOW.onpopstate = function(...args) {
        const to = $ff311393fc83ca4e$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ff311393fc83ca4e$var$lastHref;
        $ff311393fc83ca4e$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7d15795f3a315afd$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $ff311393fc83ca4e$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ff311393fc83ca4e$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7d15795f3a315afd$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)($ff311393fc83ca4e$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)($ff311393fc83ca4e$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




// eslint-disable-next-line deprecation/deprecation
const $a049f6754d311aa3$var$WINDOW = (0, $d58394577b25a7dd$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a049f6754d311aa3$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a049f6754d311aa3$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a049f6754d311aa3$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a049f6754d311aa3$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a049f6754d311aa3$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a049f6754d311aa3$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a049f6754d311aa3$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a049f6754d311aa3$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a049f6754d311aa3$export$18cf36ed71d733e7($a049f6754d311aa3$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a049f6754d311aa3$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a049f6754d311aa3$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $9e806c458094fe1e$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a049f6754d311aa3$export$531055a6c684a70a() {
    return "ReportingObserver" in $a049f6754d311aa3$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a049f6754d311aa3$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a049f6754d311aa3$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $4bcbbb4f4ba7ada3$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $165374440ccbcb65$export$31499a9cd224b78c)
            })),
        version: (0, $165374440ccbcb65$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $6d356316fc42ead6$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $6d356316fc42ead6$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $6d356316fc42ead6$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $6d356316fc42ead6$export$604a45d95a155e2b(envelope, types) {
    return $6d356316fc42ead6$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $6d356316fc42ead6$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $6d356316fc42ead6$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $6d356316fc42ead6$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $6d356316fc42ead6$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $359c7e66c2efdebe$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $6d356316fc42ead6$var$concatBuffers(parts);
}
function $6d356316fc42ead6$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $6d356316fc42ead6$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $6d356316fc42ead6$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $6d356316fc42ead6$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $6d356316fc42ead6$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $6d356316fc42ead6$export$b11169581eeaf237(type) {
    return $6d356316fc42ead6$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $6d356316fc42ead6$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $6d356316fc42ead6$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $4eda813c94a9c980$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $6243ccff12207916$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $6243ccff12207916$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6d356316fc42ead6$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $6243ccff12207916$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6d356316fc42ead6$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $6243ccff12207916$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $6d356316fc42ead6$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $c22c6d703800a853$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $2e1797501eb473e4$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $c22c6d703800a853$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $c22c6d703800a853$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $c22c6d703800a853$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $c22c6d703800a853$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $c22c6d703800a853$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $c22c6d703800a853$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $c22c6d703800a853$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $c22c6d703800a853$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $c22c6d703800a853$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $c22c6d703800a853$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $c22c6d703800a853$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $c22c6d703800a853$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $c22c6d703800a853$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $cd9e0415417a328d$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(dsn);
    const item = $cd9e0415417a328d$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $cd9e0415417a328d$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $c22c6d703800a853$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $347ebfbf3d071625$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $347ebfbf3d071625$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9ac7cae31cb69a4b$export$128827c3562ec0cb)(options.dsn);
        else (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $383fb41d044050f9$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $db1a2eab7c136bdd$export$6de4ffac6a2f1098)(exception)) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log($347ebfbf3d071625$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $fc911ca066fa75c2$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $fc911ca066fa75c2$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $db1a2eab7c136bdd$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log($347ebfbf3d071625$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ea2f936a7221cf3c$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $c585f08bd631ba97$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $b7daa41624c279e2$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $b7daa41624c279e2$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $6243ccff12207916$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $6d356316fc42ead6$export$d650323442802f6f)(env, (0, $6d356316fc42ead6$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $6243ccff12207916$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $cd9e0415417a328d$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $b7daa41624c279e2$export$51abed9797baa598)(this, integrations);
        (0, $b7daa41624c279e2$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ea2f936a7221cf3c$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $c585f08bd631ba97$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $9fd9d491325e9f58$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $c3cc587f6f15fc71$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $e03b200d766e19c9$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $347ebfbf3d071625$var$isTransactionEvent(event);
        const isError = $347ebfbf3d071625$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $c585f08bd631ba97$export$78e43115b553f358)(new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $347ebfbf3d071625$var$processBeforeSend(options, prepared, hint);
            return $347ebfbf3d071625$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $347ebfbf3d071625$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $fc911ca066fa75c2$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $fc911ca066fa75c2$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $fc911ca066fa75c2$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $347ebfbf3d071625$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($347ebfbf3d071625$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($347ebfbf3d071625$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $347ebfbf3d071625$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $347ebfbf3d071625$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $347ebfbf3d071625$export$9aac0b9f77928fbf(callback) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $379bbebb600b2bdf$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $d59dd3fae5fc220e$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $lIfzS = parcelRequire("lIfzS");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0c804cd5f2551c15$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $a53dcdf181660b5e$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $a53dcdf181660b5e$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $a53dcdf181660b5e$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $a53dcdf181660b5e$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $fc911ca066fa75c2$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $a53dcdf181660b5e$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $359c7e66c2efdebe$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $a53dcdf181660b5e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $a53dcdf181660b5e$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $a53dcdf181660b5e$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $a53dcdf181660b5e$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $a53dcdf181660b5e$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $a53dcdf181660b5e$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a53dcdf181660b5e$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($a53dcdf181660b5e$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a53dcdf181660b5e$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a53dcdf181660b5e$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a53dcdf181660b5e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $db1a2eab7c136bdd$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c585f08bd631ba97$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a53dcdf181660b5e$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a53dcdf181660b5e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c585f08bd631ba97$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $a53dcdf181660b5e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $fc911ca066fa75c2$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $a53dcdf181660b5e$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $fc911ca066fa75c2$export$ef9e2056653f0c8e)(exception) || (0, $fc911ca066fa75c2$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $a53dcdf181660b5e$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $fc911ca066fa75c2$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a53dcdf181660b5e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $db1a2eab7c136bdd$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $fc911ca066fa75c2$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $a53dcdf181660b5e$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $fc911ca066fa75c2$export$53b83ca8eaab0383)(exception) || (0, $fc911ca066fa75c2$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $a53dcdf181660b5e$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $db1a2eab7c136bdd$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a53dcdf181660b5e$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $db1a2eab7c136bdd$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $db1a2eab7c136bdd$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $a53dcdf181660b5e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a53dcdf181660b5e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $fc911ca066fa75c2$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a53dcdf181660b5e$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $2e1797501eb473e4$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $fc911ca066fa75c2$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $fc911ca066fa75c2$export$9671ea99bd126ace)(exception)) {
        const className = $a53dcdf181660b5e$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a53dcdf181660b5e$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $9bbc107c45381d5c$export$56d8a8a25bd48b81 = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
let $9bbc107c45381d5c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9bbc107c45381d5c$export$b79738ab10c590b2() {
    return $9bbc107c45381d5c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9bbc107c45381d5c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9bbc107c45381d5c$var$ignoreOnError++;
    setTimeout(()=>{
        $9bbc107c45381d5c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9bbc107c45381d5c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $2e1797501eb473e4$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9bbc107c45381d5c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9bbc107c45381d5c$export$1265a142ff5ba165();
            (0, $fcd9e096f030e706$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $db1a2eab7c136bdd$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $db1a2eab7c136bdd$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $fcd9e096f030e706$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $2e1797501eb473e4$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $2e1797501eb473e4$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $e9a08995bafb71c1$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $e9a08995bafb71c1$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $e9a08995bafb71c1$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $345a7a92cec7fc4b$export$1df9218a526d318d extends (0, $347ebfbf3d071625$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $lIfzS.getSDKSource)();
        (0, $4bcbbb4f4ba7ada3$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document) (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $a53dcdf181660b5e$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $a53dcdf181660b5e$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $e9a08995bafb71c1$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $379bbebb600b2bdf$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $bb8d3a92c0cd05d8$var$WINDOW = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
const $bb8d3a92c0cd05d8$var$DEBOUNCE_DURATION = 1000;
let $bb8d3a92c0cd05d8$var$debounceTimerID;
let $bb8d3a92c0cd05d8$var$lastCapturedEventType;
let $bb8d3a92c0cd05d8$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bb8d3a92c0cd05d8$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $bb8d3a92c0cd05d8$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $bb8d3a92c0cd05d8$export$3014bbf0af0e1d4a() {
    if (!$bb8d3a92c0cd05d8$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $7d15795f3a315afd$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $bb8d3a92c0cd05d8$var$makeDOMEventHandler(triggerDOMHandler, true);
    $bb8d3a92c0cd05d8$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $bb8d3a92c0cd05d8$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $bb8d3a92c0cd05d8$var$WINDOW[target] && $bb8d3a92c0cd05d8$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $2e1797501eb473e4$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $bb8d3a92c0cd05d8$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $2e1797501eb473e4$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $bb8d3a92c0cd05d8$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $bb8d3a92c0cd05d8$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $bb8d3a92c0cd05d8$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $bb8d3a92c0cd05d8$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $bb8d3a92c0cd05d8$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $bb8d3a92c0cd05d8$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($bb8d3a92c0cd05d8$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $2e1797501eb473e4$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $2e1797501eb473e4$export$e73679ffaf56810e)(target, "_sentryId", (0, $db1a2eab7c136bdd$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$bb8d3a92c0cd05d8$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $bb8d3a92c0cd05d8$var$lastCapturedEventType = event.type;
            $bb8d3a92c0cd05d8$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($bb8d3a92c0cd05d8$var$debounceTimerID);
        $bb8d3a92c0cd05d8$var$debounceTimerID = $bb8d3a92c0cd05d8$var$WINDOW.setTimeout(()=>{
            $bb8d3a92c0cd05d8$var$lastCapturedEventTargetId = undefined;
            $bb8d3a92c0cd05d8$var$lastCapturedEventType = undefined;
        }, $bb8d3a92c0cd05d8$var$DEBOUNCE_DURATION);
    };
}
function $bb8d3a92c0cd05d8$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16210e86107031bc$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $16210e86107031bc$var$instrumentConsole);
}
function $16210e86107031bc$var$instrumentConsole() {
    if (!("console" in (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1))) return;
    (0, $3c4d30f0d3028b15$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).console)) return;
        (0, $2e1797501eb473e4$export$9563e054e6f787fb)((0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $3c4d30f0d3028b15$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $7d15795f3a315afd$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $3c4d30f0d3028b15$export$77c4ce905194557b)[level];
                log && log.apply((0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5e15774c4f1380e3$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $5e15774c4f1380e3$var$instrumentFetch);
}
function $5e15774c4f1380e3$var$instrumentFetch() {
    if (!(0, $a049f6754d311aa3$export$c82d238e23c40b21)()) return;
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)((0, $d58394577b25a7dd$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $5e15774c4f1380e3$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $7d15795f3a315afd$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $d58394577b25a7dd$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $7d15795f3a315afd$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $7d15795f3a315afd$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $5e15774c4f1380e3$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $5e15774c4f1380e3$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($5e15774c4f1380e3$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $5e15774c4f1380e3$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $5e15774c4f1380e3$var$getUrlFromResource(url),
            method: $5e15774c4f1380e3$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $5e15774c4f1380e3$var$getUrlFromResource(arg),
        method: $5e15774c4f1380e3$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $9602c7b10ae772dd$var$WINDOW = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
const $9602c7b10ae772dd$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9602c7b10ae772dd$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $9602c7b10ae772dd$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $9602c7b10ae772dd$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$9602c7b10ae772dd$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $fc911ca066fa75c2$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $9602c7b10ae772dd$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$9602c7b10ae772dd$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$9602c7b10ae772dd$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $7d15795f3a315afd$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $2e1797501eb473e4$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $2e1797501eb473e4$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$9602c7b10ae772dd$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $fc911ca066fa75c2$export$844ec244b1367d54)(header) && (0, $fc911ca066fa75c2$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$9602c7b10ae772dd$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $7d15795f3a315afd$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $9602c7b10ae772dd$var$parseUrl(url) {
    if ((0, $fc911ca066fa75c2$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $6349c7ce4c999262$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $6349c7ce4c999262$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $6349c7ce4c999262$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $6349c7ce4c999262$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $31457d47ff251761$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $31457d47ff251761$export$e01cef29b4327697(level) {
    return $31457d47ff251761$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $31457d47ff251761$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $31457d47ff251761$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b3b1d4a4aba5c6f3$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b3b1d4a4aba5c6f3$var$INTEGRATION_NAME = "Breadcrumbs";
const $b3b1d4a4aba5c6f3$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b3b1d4a4aba5c6f3$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $16210e86107031bc$export$1d6e0d073f9e6723)($b3b1d4a4aba5c6f3$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $bb8d3a92c0cd05d8$export$5aeffd3db2cf9df7)($b3b1d4a4aba5c6f3$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $9602c7b10ae772dd$export$26ace48dd54c9aea)($b3b1d4a4aba5c6f3$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $5e15774c4f1380e3$export$f75d3c772c923df0)($b3b1d4a4aba5c6f3$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ff311393fc83ca4e$export$3f18c56c58114e75)($b3b1d4a4aba5c6f3$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $b3b1d4a4aba5c6f3$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b3b1d4a4aba5c6f3$export$c079d904b326663a = (0, $b7daa41624c279e2$export$2323046b9414659f)($b3b1d4a4aba5c6f3$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b3b1d4a4aba5c6f3$export$2dc68d50d56fbbd = (0, $b7daa41624c279e2$export$afa219bf23651160)($b3b1d4a4aba5c6f3$var$INTEGRATION_NAME, $b3b1d4a4aba5c6f3$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b3b1d4a4aba5c6f3$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client) return;
        (0, $fcd9e096f030e706$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $db1a2eab7c136bdd$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b3b1d4a4aba5c6f3$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b3b1d4a4aba5c6f3$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$b3b1d4a4aba5c6f3$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b3b1d4a4aba5c6f3$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b3b1d4a4aba5c6f3$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b3b1d4a4aba5c6f3$var$_isEvent(event) ? event.target : event;
            target = (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $8a18c3c2a11733c0$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $fcd9e096f030e706$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b3b1d4a4aba5c6f3$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $31457d47ff251761$export$d771ef054122c30a)(handlerData.level),
            message: (0, $0f4ffa1af5d1985d$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $0f4ffa1af5d1985d$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fcd9e096f030e706$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b3b1d4a4aba5c6f3$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $9602c7b10ae772dd$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $fcd9e096f030e706$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b3b1d4a4aba5c6f3$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fcd9e096f030e706$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fcd9e096f030e706$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b3b1d4a4aba5c6f3$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $6349c7ce4c999262$export$7a5253c0f62e0150)((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $6349c7ce4c999262$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $6349c7ce4c999262$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fcd9e096f030e706$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b3b1d4a4aba5c6f3$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $1d345a3673699ab2$var$INTEGRATION_NAME = "Dedupe";
const $1d345a3673699ab2$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $1d345a3673699ab2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($1d345a3673699ab2$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $1d345a3673699ab2$export$6d39aa44cd0c7567 = (0, $b7daa41624c279e2$export$2323046b9414659f)($1d345a3673699ab2$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1d345a3673699ab2$export$688d98c249d31ad3 = (0, $b7daa41624c279e2$export$afa219bf23651160)($1d345a3673699ab2$var$INTEGRATION_NAME, $1d345a3673699ab2$export$6d39aa44cd0c7567);
function $1d345a3673699ab2$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($1d345a3673699ab2$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($1d345a3673699ab2$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $1d345a3673699ab2$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$1d345a3673699ab2$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$1d345a3673699ab2$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $1d345a3673699ab2$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $1d345a3673699ab2$var$_getExceptionFromEvent(previousEvent);
    const currentException = $1d345a3673699ab2$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$1d345a3673699ab2$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$1d345a3673699ab2$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $1d345a3673699ab2$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $1d345a3673699ab2$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $1d345a3673699ab2$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $1d345a3673699ab2$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $1d345a3673699ab2$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $1d345a3673699ab2$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}





let $f573b4109f19f86c$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f573b4109f19f86c$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $f573b4109f19f86c$var$instrumentError);
}
function $f573b4109f19f86c$var$instrumentError() {
    $f573b4109f19f86c$var$_oldOnErrorHandler = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).onerror;
    (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $7d15795f3a315afd$export$b18c893e424d3127)("error", handlerData);
        if ($f573b4109f19f86c$var$_oldOnErrorHandler && !$f573b4109f19f86c$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $f573b4109f19f86c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $16a5bbb770103fb7$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16a5bbb770103fb7$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $7d15795f3a315afd$export$a4e09611e30da72e)(type, handler);
    (0, $7d15795f3a315afd$export$e18d6c5462c01368)(type, $16a5bbb770103fb7$var$instrumentUnhandledRejection);
}
function $16a5bbb770103fb7$var$instrumentUnhandledRejection() {
    $16a5bbb770103fb7$var$_oldOnUnhandledRejectionHandler = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $7d15795f3a315afd$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($16a5bbb770103fb7$var$_oldOnUnhandledRejectionHandler && !$16a5bbb770103fb7$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $16a5bbb770103fb7$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $a7de3a329e8c48b4$var$INTEGRATION_NAME = "GlobalHandlers";
const $a7de3a329e8c48b4$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $a7de3a329e8c48b4$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $a7de3a329e8c48b4$var$_installGlobalOnErrorHandler(client);
                $a7de3a329e8c48b4$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $a7de3a329e8c48b4$var$_installGlobalOnUnhandledRejectionHandler(client);
                $a7de3a329e8c48b4$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $a7de3a329e8c48b4$export$66acc70e8cf2b71a = (0, $b7daa41624c279e2$export$2323046b9414659f)($a7de3a329e8c48b4$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a7de3a329e8c48b4$export$204155decbc90e5a = (0, $b7daa41624c279e2$export$afa219bf23651160)($a7de3a329e8c48b4$var$INTEGRATION_NAME, $a7de3a329e8c48b4$export$66acc70e8cf2b71a);
function $a7de3a329e8c48b4$var$_installGlobalOnErrorHandler(client) {
    (0, $f573b4109f19f86c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a7de3a329e8c48b4$var$getOptions();
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client || (0, $9bbc107c45381d5c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $fc911ca066fa75c2$export$844ec244b1367d54)(msg) ? $a7de3a329e8c48b4$var$_eventFromIncompleteOnError(msg, url, line, column) : $a7de3a329e8c48b4$var$_enhanceEventWithInitialFrame((0, $a53dcdf181660b5e$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $fcd9e096f030e706$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $a7de3a329e8c48b4$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $16a5bbb770103fb7$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a7de3a329e8c48b4$var$getOptions();
        if ((0, $fcd9e096f030e706$export$6bb76d6eba7e258c)() !== client || (0, $9bbc107c45381d5c$export$b79738ab10c590b2)()) return;
        const error = $a7de3a329e8c48b4$var$_getUnhandledRejectionError(e);
        const event = (0, $fc911ca066fa75c2$export$c3825b437cbdea5c)(error) ? $a7de3a329e8c48b4$var$_eventFromRejectionWithPrimitive(error) : (0, $a53dcdf181660b5e$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $fcd9e096f030e706$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $a7de3a329e8c48b4$var$_getUnhandledRejectionError(error) {
    if ((0, $fc911ca066fa75c2$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $a7de3a329e8c48b4$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a7de3a329e8c48b4$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $fc911ca066fa75c2$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $a7de3a329e8c48b4$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a7de3a329e8c48b4$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $fc911ca066fa75c2$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $8a18c3c2a11733c0$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $a7de3a329e8c48b4$var$globalHandlerLog(type) {
    (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $a7de3a329e8c48b4$var$getOptions() {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $fe4cd2ceaf62bd9a$var$INTEGRATION_NAME = "HttpContext";
const $fe4cd2ceaf62bd9a$var$_httpContextIntegration = ()=>{
    return {
        name: $fe4cd2ceaf62bd9a$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).navigator && !(0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location && !(0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $fe4cd2ceaf62bd9a$export$1378794447170364 = (0, $b7daa41624c279e2$export$2323046b9414659f)($fe4cd2ceaf62bd9a$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fe4cd2ceaf62bd9a$export$5d2ee9a544b09a94 = (0, $b7daa41624c279e2$export$afa219bf23651160)($fe4cd2ceaf62bd9a$var$INTEGRATION_NAME, $fe4cd2ceaf62bd9a$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $107c2ab276ae7c61$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $fc911ca066fa75c2$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $107c2ab276ae7c61$var$truncateAggregateExceptions($107c2ab276ae7c61$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $107c2ab276ae7c61$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $fc911ca066fa75c2$export$49034edbe6b62415)(error[key], Error)) {
        $107c2ab276ae7c61$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $107c2ab276ae7c61$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $107c2ab276ae7c61$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $fc911ca066fa75c2$export$49034edbe6b62415)(childError, Error)) {
            $107c2ab276ae7c61$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $107c2ab276ae7c61$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $107c2ab276ae7c61$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $107c2ab276ae7c61$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $107c2ab276ae7c61$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $107c2ab276ae7c61$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $0f4ffa1af5d1985d$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $d6635b9ebe41be18$var$DEFAULT_KEY = "cause";
const $d6635b9ebe41be18$var$DEFAULT_LIMIT = 5;
const $d6635b9ebe41be18$var$INTEGRATION_NAME = "LinkedErrors";
const $d6635b9ebe41be18$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $d6635b9ebe41be18$var$DEFAULT_LIMIT;
    const key = options.key || $d6635b9ebe41be18$var$DEFAULT_KEY;
    return {
        name: $d6635b9ebe41be18$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $107c2ab276ae7c61$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $a53dcdf181660b5e$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $d6635b9ebe41be18$export$ebabb00eb7f3a395 = (0, $b7daa41624c279e2$export$2323046b9414659f)($d6635b9ebe41be18$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d6635b9ebe41be18$export$8d1e60aaf616fb4f = (0, $b7daa41624c279e2$export$afa219bf23651160)($d6635b9ebe41be18$var$INTEGRATION_NAME, $d6635b9ebe41be18$export$ebabb00eb7f3a395);





const $c96230d297c4a371$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $c96230d297c4a371$var$INTEGRATION_NAME = "TryCatch";
const $c96230d297c4a371$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $c96230d297c4a371$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $2e1797501eb473e4$export$9563e054e6f787fb)((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81), "setTimeout", $c96230d297c4a371$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $2e1797501eb473e4$export$9563e054e6f787fb)((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81), "setInterval", $c96230d297c4a371$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $2e1797501eb473e4$export$9563e054e6f787fb)((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81), "requestAnimationFrame", $c96230d297c4a371$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81)) (0, $2e1797501eb473e4$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $c96230d297c4a371$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $c96230d297c4a371$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($c96230d297c4a371$var$_wrapEventTarget);
            }
        }
    };
};
const $c96230d297c4a371$export$59bfe9f1c76150e = (0, $b7daa41624c279e2$export$2323046b9414659f)($c96230d297c4a371$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c96230d297c4a371$export$f1a018517668e6d3 = (0, $b7daa41624c279e2$export$afa219bf23651160)($c96230d297c4a371$var$INTEGRATION_NAME, $c96230d297c4a371$export$59bfe9f1c76150e);
function $c96230d297c4a371$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9bbc107c45381d5c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c96230d297c4a371$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9bbc107c45381d5c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $c96230d297c4a371$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $2e1797501eb473e4$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $2e1797501eb473e4$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9bbc107c45381d5c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $c96230d297c4a371$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9bbc107c45381d5c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9bbc107c45381d5c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $8c4738785e8006e7$var$UNKNOWN_FUNCTION = "?";
const $8c4738785e8006e7$var$OPERA10_PRIORITY = 10;
const $8c4738785e8006e7$var$OPERA11_PRIORITY = 20;
const $8c4738785e8006e7$var$CHROME_PRIORITY = 30;
const $8c4738785e8006e7$var$WINJS_PRIORITY = 40;
const $8c4738785e8006e7$var$GECKO_PRIORITY = 50;
function $8c4738785e8006e7$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $8c4738785e8006e7$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $8c4738785e8006e7$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $8c4738785e8006e7$var$chromeStackParserFn = (line)=>{
    const parts = $8c4738785e8006e7$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $8c4738785e8006e7$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $8c4738785e8006e7$var$extractSafariExtensionDetails(parts[1] || $8c4738785e8006e7$var$UNKNOWN_FUNCTION, parts[2]);
        return $8c4738785e8006e7$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $8c4738785e8006e7$export$263a749fff749872 = [
    $8c4738785e8006e7$var$CHROME_PRIORITY,
    $8c4738785e8006e7$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $8c4738785e8006e7$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $8c4738785e8006e7$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $8c4738785e8006e7$var$gecko = (line)=>{
    const parts = $8c4738785e8006e7$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $8c4738785e8006e7$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $8c4738785e8006e7$var$UNKNOWN_FUNCTION;
        [func, filename] = $8c4738785e8006e7$var$extractSafariExtensionDetails(func, filename);
        return $8c4738785e8006e7$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $8c4738785e8006e7$export$cdba47a5dd2804d = [
    $8c4738785e8006e7$var$GECKO_PRIORITY,
    $8c4738785e8006e7$var$gecko
];
const $8c4738785e8006e7$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $8c4738785e8006e7$var$winjs = (line)=>{
    const parts = $8c4738785e8006e7$var$winjsRegex.exec(line);
    return parts ? $8c4738785e8006e7$var$createFrame(parts[2], parts[1] || $8c4738785e8006e7$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $8c4738785e8006e7$export$179460296da408e8 = [
    $8c4738785e8006e7$var$WINJS_PRIORITY,
    $8c4738785e8006e7$var$winjs
];
const $8c4738785e8006e7$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $8c4738785e8006e7$var$opera10 = (line)=>{
    const parts = $8c4738785e8006e7$var$opera10Regex.exec(line);
    return parts ? $8c4738785e8006e7$var$createFrame(parts[2], parts[3] || $8c4738785e8006e7$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $8c4738785e8006e7$export$f892b52c880ffc7a = [
    $8c4738785e8006e7$var$OPERA10_PRIORITY,
    $8c4738785e8006e7$var$opera10
];
const $8c4738785e8006e7$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $8c4738785e8006e7$var$opera11 = (line)=>{
    const parts = $8c4738785e8006e7$var$opera11Regex.exec(line);
    return parts ? $8c4738785e8006e7$var$createFrame(parts[5], parts[3] || parts[4] || $8c4738785e8006e7$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $8c4738785e8006e7$export$af11af13f09fb0dc = [
    $8c4738785e8006e7$var$OPERA11_PRIORITY,
    $8c4738785e8006e7$var$opera11
];
const $8c4738785e8006e7$export$7197c0fe6554c079 = [
    $8c4738785e8006e7$export$263a749fff749872,
    $8c4738785e8006e7$export$cdba47a5dd2804d,
    $8c4738785e8006e7$export$179460296da408e8
];
const $8c4738785e8006e7$export$2b2b997d81bf3907 = (0, $797c2bd47eb6cfb1$export$a5739666fb2d03d4)(...$8c4738785e8006e7$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $8c4738785e8006e7$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $8c4738785e8006e7$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e6f6c6c07bc0bbc4$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e6f6c6c07bc0bbc4$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e6f6c6c07bc0bbc4$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e6f6c6c07bc0bbc4$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e6f6c6c07bc0bbc4$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $e6f6c6c07bc0bbc4$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e6f6c6c07bc0bbc4$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e6f6c6c07bc0bbc4$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $5c03f81c8d7a00df$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $c585f08bd631ba97$export$78e43115b553f358)(new (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $c585f08bd631ba97$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $c585f08bd631ba97$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $e188e82d1348bbd7$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $e188e82d1348bbd7$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $5c03f81c8d7a00df$export$85a4f67f852183e6)(options.bufferSize || $e188e82d1348bbd7$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $6d356316fc42ead6$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $6d356316fc42ead6$export$b11169581eeaf237)(type);
            if ((0, $e6f6c6c07bc0bbc4$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $e188e82d1348bbd7$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $c585f08bd631ba97$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $6d356316fc42ead6$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $6d356316fc42ead6$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $e188e82d1348bbd7$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $6d356316fc42ead6$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $6d356316fc42ead6$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $e6f6c6c07bc0bbc4$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $4eda813c94a9c980$export$5949942ba2a7c0e2)) {
                (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $c585f08bd631ba97$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $e188e82d1348bbd7$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $339d70ced736cb9e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $339d70ced736cb9e$export$8be2119ce08e3379() {
    if ($339d70ced736cb9e$var$cachedFetchImpl) return $339d70ced736cb9e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $a049f6754d311aa3$export$18cf36ed71d733e7)((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).fetch)) return $339d70ced736cb9e$var$cachedFetchImpl = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).fetch.bind((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81));
    const document = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $339d70ced736cb9e$var$cachedFetchImpl = fetchImpl.bind((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $339d70ced736cb9e$export$d499686d2dd738c6() {
    $339d70ced736cb9e$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9f5c706857edd946$export$b2311068c46d7cc8(options, nativeFetch = (0, $339d70ced736cb9e$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $339d70ced736cb9e$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $c585f08bd631ba97$export$78e43115b553f358)(e);
        }
    }
    return (0, $e188e82d1348bbd7$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $e3b724648de5ed1d$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $e3b724648de5ed1d$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $c585f08bd631ba97$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $e3b724648de5ed1d$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $e188e82d1348bbd7$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $c1dfaf77d30f13f5$export$5ef831fccfce35e5 = [
    (0, $58ba388a13cbb2ee$export$cb3c5c2ceb9818ba)(),
    (0, $5cd3251c619fffd4$export$7918117e9202e4fb)(),
    (0, $c96230d297c4a371$export$59bfe9f1c76150e)(),
    (0, $b3b1d4a4aba5c6f3$export$c079d904b326663a)(),
    (0, $a7de3a329e8c48b4$export$66acc70e8cf2b71a)(),
    (0, $d6635b9ebe41be18$export$ebabb00eb7f3a395)(),
    (0, $1d345a3673699ab2$export$6d39aa44cd0c7567)(),
    (0, $fe4cd2ceaf62bd9a$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $c1dfaf77d30f13f5$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$c1dfaf77d30f13f5$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $c1dfaf77d30f13f5$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $c1dfaf77d30f13f5$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $797c2bd47eb6cfb1$export$1d5cf88b347146d4)(options.stackParser || (0, $8c4738785e8006e7$export$2b2b997d81bf3907)),
        integrations: (0, $b7daa41624c279e2$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $a049f6754d311aa3$export$edf3cb81fd7d2a3e)() ? (0, $9f5c706857edd946$export$b2311068c46d7cc8) : (0, $e3b724648de5ed1d$export$5e1441cee30d5a39))
    };
    (0, $390dfe62fd2e41ab$export$5333c3f1c58d9bc1)((0, $345a7a92cec7fc4b$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $c1dfaf77d30f13f5$var$startSessionTracking();
}
const $c1dfaf77d30f13f5$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document) {
        (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $383fb41d044050f9$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document.head || (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $c1dfaf77d30f13f5$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $c1dfaf77d30f13f5$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c1dfaf77d30f13f5$export$4997ffc0176396a6(fn) {
    return (0, $9bbc107c45381d5c$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $c1dfaf77d30f13f5$var$startSessionTracking() {
    if (typeof (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $0c804cd5f2551c15$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $fcd9e096f030e706$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $fcd9e096f030e706$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $ff311393fc83ca4e$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $fcd9e096f030e706$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $fcd9e096f030e706$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $c1dfaf77d30f13f5$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $9a9220b1bc59c4f2$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $4bcbbb4f4ba7ada3$export$b9f95b027256052c)(opts, "react");
    (0, $c1dfaf77d30f13f5$export$2cd8252107eb640b)(opts);
}









/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $56bc6eac59929789$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $56bc6eac59929789$export$8e9a29865c0a1226 = (0, $c7b1128cbfbed8e5$export$8e9a29865c0a1226);


let $c63795b07ac9f002$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $c63795b07ac9f002$export$637857c1d87b640c() {
    if ($c63795b07ac9f002$var$errorsInstrumented) return;
    $c63795b07ac9f002$var$errorsInstrumented = true;
    (0, $f573b4109f19f86c$export$55b5c3ba2194f0c6)($c63795b07ac9f002$var$errorCallback);
    (0, $16a5bbb770103fb7$export$8bf4fc6858821a4e)($c63795b07ac9f002$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $c63795b07ac9f002$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$c63795b07ac9f002$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $84b8d18438e85d40$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $84b8d18438e85d40$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $84b8d18438e85d40$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $fc911ca066fa75c2$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $7c181fe254a28c13$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $c1ff268be949f613$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
    const scope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $c1ff268be949f613$var$normalizeContext(context);
    const activeSpan = $c1ff268be949f613$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $84b8d18438e85d40$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $c1ff268be949f613$export$a1bd95187356f372(context, callback) {
    const spanContext = $c1ff268be949f613$var$normalizeContext(context);
    return (0, $805d0d6bf1179169$export$70d775fb1f267027)(()=>{
        return (0, $fcd9e096f030e706$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $c1ff268be949f613$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $84b8d18438e85d40$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $c1ff268be949f613$export$cb9e396e6b90b703 = $c1ff268be949f613$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $c1ff268be949f613$export$c10292ad04b92aea(context, callback) {
    const spanContext = $c1ff268be949f613$var$normalizeContext(context);
    return (0, $805d0d6bf1179169$export$70d775fb1f267027)(()=>{
        return (0, $fcd9e096f030e706$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $c1ff268be949f613$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $84b8d18438e85d40$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $c1ff268be949f613$export$63dbba021a6b4047(context) {
    if (!(0, $7c181fe254a28c13$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $c1ff268be949f613$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $c1ff268be949f613$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $c1ff268be949f613$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $c1ff268be949f613$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fcd9e096f030e706$export$c7be4b0125a10cba)().getSpan();
}
const $c1ff268be949f613$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $c7b1128cbfbed8e5$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $e03b200d766e19c9$export$16a28057038b10ef) && traceparentData) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $805d0d6bf1179169$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $c1ff268be949f613$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $7c181fe254a28c13$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $c3cc587f6f15fc71$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $d07da62ed3ec9e2d$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $c1ff268be949f613$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $c1ff268be949f613$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $d07da62ed3ec9e2d$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $c1ff268be949f613$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $c1ff268be949f613$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $c1ff268be949f613$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $2e1797501eb473e4$export$e73679ffaf56810e)(span, $c1ff268be949f613$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $2e1797501eb473e4$export$e73679ffaf56810e)(span, $c1ff268be949f613$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $c1ff268be949f613$export$c08fbc656a245d03(span) {
    return {
        scope: span[$c1ff268be949f613$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$c1ff268be949f613$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $f57e64a5448d735a$var$SPAN_METRIC_SUMMARY;
function $f57e64a5448d735a$var$getMetricStorageForSpan(span) {
    return $f57e64a5448d735a$var$SPAN_METRIC_SUMMARY ? $f57e64a5448d735a$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $f57e64a5448d735a$export$2e7205e45c58797d(span) {
    const storage = $f57e64a5448d735a$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $2e1797501eb473e4$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $f57e64a5448d735a$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $c1ff268be949f613$export$1be426a8e585c83e)();
    if (span) {
        const storage = $f57e64a5448d735a$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$f57e64a5448d735a$var$SPAN_METRIC_SUMMARY) $f57e64a5448d735a$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $f57e64a5448d735a$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $b2c76ea57c95e097$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $b2c76ea57c95e097$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $b2c76ea57c95e097$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $b2c76ea57c95e097$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $b2c76ea57c95e097$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $f3015ea0974b5361$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($f3015ea0974b5361$export$beb8e6a823e89c5d || ($f3015ea0974b5361$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $f3015ea0974b5361$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $f3015ea0974b5361$export$ac65c70d78fcdb55 = $f3015ea0974b5361$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $f3015ea0974b5361$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $f3015ea0974b5361$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $f952de733b7dab74$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $f952de733b7dab74$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $b2c76ea57c95e097$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $b2c76ea57c95e097$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $b2c76ea57c95e097$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $b2c76ea57c95e097$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $b2c76ea57c95e097$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $b2c76ea57c95e097$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $d07da62ed3ec9e2d$export$eb571cd9b5d98de8) : (0, $d07da62ed3ec9e2d$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $f952de733b7dab74$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $de80b4d78df58fd4$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $e03b200d766e19c9$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $f3015ea0974b5361$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $de80b4d78df58fd4$export$c4c6a79b1260ca1b)(this);
        if ((0, $e03b200d766e19c9$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $d07da62ed3ec9e2d$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $d07da62ed3ec9e2d$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $d07da62ed3ec9e2d$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $b2c76ea57c95e097$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $b2c76ea57c95e097$export$cca8dd30f57f805e],
            _metrics_summary: (0, $f57e64a5448d735a$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $b2c76ea57c95e097$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $c164310af64af341$export$febc5573c75cefb0 extends (0, $f952de733b7dab74$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $b2c76ea57c95e097$export$d7a7d984b0791405] && {
                source: this._attributes[0, $b2c76ea57c95e097$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $b2c76ea57c95e097$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $b2c76ea57c95e097$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $b2c76ea57c95e097$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $f952de733b7dab74$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $d07da62ed3ec9e2d$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $c3cc587f6f15fc71$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $c1ff268be949f613$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $d07da62ed3ec9e2d$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $2e1797501eb473e4$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $c3cc587f6f15fc71$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $f57e64a5448d735a$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $8bf6c22df0d9c1c1$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $8bf6c22df0d9c1c1$var$FINISH_REASON_TAG = "finishReason";
const $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $8bf6c22df0d9c1c1$export$370d6113c18ba86c extends (0, $f952de733b7dab74$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $8bf6c22df0d9c1c1$export$b279e6bd7040371f extends (0, $c164310af64af341$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $8bf6c22df0d9c1c1$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $8bf6c22df0d9c1c1$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $8bf6c22df0d9c1c1$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $d07da62ed3ec9e2d$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($8bf6c22df0d9c1c1$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $e03b200d766e19c9$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $8bf6c22df0d9c1c1$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $d59dd3fae5fc220e$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $8bf6c22df0d9c1c1$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $f9c714723e552f13$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $7c181fe254a28c13$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $b2c76ea57c95e097$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $b2c76ea57c95e097$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $b2c76ea57c95e097$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $b2c76ea57c95e097$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$f9c714723e552f13$export$2603c8d332a51c42(sampleRate)) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $e03b200d766e19c9$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $d07da62ed3ec9e2d$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $f9c714723e552f13$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $fc911ca066fa75c2$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $4147aee33e8f69ed$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $d07da62ed3ec9e2d$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $4147aee33e8f69ed$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $e03b200d766e19c9$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $c164310af64af341$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $f9c714723e552f13$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $4147aee33e8f69ed$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $8bf6c22df0d9c1c1$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $f9c714723e552f13$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $4147aee33e8f69ed$export$653d0ef2bad9cdf9() {
    const carrier = (0, $805d0d6bf1179169$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $4147aee33e8f69ed$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $4147aee33e8f69ed$var$traceHeaders;
    (0, $c63795b07ac9f002$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5e18a2830ef5d7ef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $f37e8a0bcc928f27$export$56d8a8a25bd48b81 = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $b5e5d1247a1f324c$export$6f18f55521af71a1() {
    if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document) (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
        if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(activeTransaction);
            (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $39113522c4271103$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $6b68a92b46407b90$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8d7d9e9884583fb8$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $8d7d9e9884583fb8$export$6431553786c94949 = ()=>{
    if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $8d7d9e9884583fb8$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ddb09db6a89a8f59$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $8d7d9e9884583fb8$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a8f2b7e9290dfde1$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $8d7d9e9884583fb8$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.prerendering || (0, $ddb09db6a89a8f59$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $6b68a92b46407b90$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $fb9a0b0cd35b09c0$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4dd9ed7b22ab985b$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $67412680333a8f38$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $a8f2b7e9290dfde1$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $fb9a0b0cd35b09c0$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $39113522c4271103$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $4dd9ed7b22ab985b$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $ee0151b33dcfcacc$var$firstHiddenTime = -1;
const $ee0151b33dcfcacc$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.visibilityState) $ee0151b33dcfcacc$var$firstHiddenTime = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $ee0151b33dcfcacc$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $4dd9ed7b22ab985b$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $ee0151b33dcfcacc$var$firstHiddenTime = timeStamp;
    }, true);
};
const $ee0151b33dcfcacc$export$443f86b2c77012c4 = ()=>{
    if ($ee0151b33dcfcacc$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $ee0151b33dcfcacc$var$initHiddenTime();
        $ee0151b33dcfcacc$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $ee0151b33dcfcacc$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $9f0f51ae13ef1709$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $ee0151b33dcfcacc$export$443f86b2c77012c4)();
    const metric = (0, $a8f2b7e9290dfde1$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $fb9a0b0cd35b09c0$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $39113522c4271103$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $4dd9ed7b22ab985b$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $2709fb531bdc0fc0$var$interactionCountEstimate = 0;
let $2709fb531bdc0fc0$var$minKnownInteractionId = Infinity;
let $2709fb531bdc0fc0$var$maxKnownInteractionId = 0;
const $2709fb531bdc0fc0$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $2709fb531bdc0fc0$var$minKnownInteractionId = Math.min($2709fb531bdc0fc0$var$minKnownInteractionId, e.interactionId);
            $2709fb531bdc0fc0$var$maxKnownInteractionId = Math.max($2709fb531bdc0fc0$var$maxKnownInteractionId, e.interactionId);
            $2709fb531bdc0fc0$var$interactionCountEstimate = $2709fb531bdc0fc0$var$maxKnownInteractionId ? ($2709fb531bdc0fc0$var$maxKnownInteractionId - $2709fb531bdc0fc0$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $2709fb531bdc0fc0$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $2709fb531bdc0fc0$export$8a962f2683a476d1 = ()=>{
    return $2709fb531bdc0fc0$var$po ? $2709fb531bdc0fc0$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $2709fb531bdc0fc0$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $2709fb531bdc0fc0$var$po) return;
    $2709fb531bdc0fc0$var$po = (0, $fb9a0b0cd35b09c0$export$d1203567a167490e)("event", $2709fb531bdc0fc0$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $2eed16876cc05580$var$getInteractionCountForNavigation = ()=>{
    return (0, $2709fb531bdc0fc0$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $2eed16876cc05580$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $2eed16876cc05580$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $2eed16876cc05580$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $2eed16876cc05580$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $2eed16876cc05580$var$longestInteractionList[$2eed16876cc05580$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $2eed16876cc05580$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $2eed16876cc05580$var$longestInteractionList.length < $2eed16876cc05580$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $2eed16876cc05580$var$longestInteractionMap[interaction.id] = interaction;
            $2eed16876cc05580$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $2eed16876cc05580$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $2eed16876cc05580$var$longestInteractionList.splice($2eed16876cc05580$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $2eed16876cc05580$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $2eed16876cc05580$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($2eed16876cc05580$var$longestInteractionList.length - 1, Math.floor($2eed16876cc05580$var$getInteractionCountForNavigation() / 50));
    return $2eed16876cc05580$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $2eed16876cc05580$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $2709fb531bdc0fc0$export$67d90cda6b78a2eb)();
    const metric = (0, $a8f2b7e9290dfde1$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $2eed16876cc05580$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$2eed16876cc05580$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $2eed16876cc05580$var$processEntry(entry);
            }
        });
        const inp = $2eed16876cc05580$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $fb9a0b0cd35b09c0$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $39113522c4271103$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $4dd9ed7b22ab985b$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $2eed16876cc05580$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4697a1f09b4923c3$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $4697a1f09b4923c3$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $ee0151b33dcfcacc$export$443f86b2c77012c4)();
    const metric = (0, $a8f2b7e9290dfde1$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $ddb09db6a89a8f59$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $fb9a0b0cd35b09c0$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $39113522c4271103$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$4697a1f09b4923c3$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $4697a1f09b4923c3$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $4dd9ed7b22ab985b$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $894b289c1d312069$var$whenReady = (callback)=>{
    if (!(0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document) return;
    if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$894b289c1d312069$var$whenReady(callback), true);
    else if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$894b289c1d312069$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $894b289c1d312069$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $a8f2b7e9290dfde1$export$3c29b44508a0612b)("TTFB");
    const report = (0, $39113522c4271103$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $894b289c1d312069$var$whenReady(()=>{
        const navEntry = (0, $8d7d9e9884583fb8$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $ddb09db6a89a8f59$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $f01b4adf86c96a55$var$handlers = {};
const $f01b4adf86c96a55$var$instrumented = {};
let $f01b4adf86c96a55$var$_previousCls;
let $f01b4adf86c96a55$var$_previousFid;
let $f01b4adf86c96a55$var$_previousLcp;
let $f01b4adf86c96a55$var$_previousTtfb;
let $f01b4adf86c96a55$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $f01b4adf86c96a55$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $f01b4adf86c96a55$var$addMetricObserver("cls", callback, $f01b4adf86c96a55$var$instrumentCls, $f01b4adf86c96a55$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $f01b4adf86c96a55$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $f01b4adf86c96a55$var$addMetricObserver("lcp", callback, $f01b4adf86c96a55$var$instrumentLcp, $f01b4adf86c96a55$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $f01b4adf86c96a55$export$699d9529c099a797(callback) {
    return $f01b4adf86c96a55$var$addMetricObserver("ttfb", callback, $f01b4adf86c96a55$var$instrumentTtfb, $f01b4adf86c96a55$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f01b4adf86c96a55$export$2707d7471c0b918f(callback) {
    return $f01b4adf86c96a55$var$addMetricObserver("fid", callback, $f01b4adf86c96a55$var$instrumentFid, $f01b4adf86c96a55$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f01b4adf86c96a55$export$da3b76aa2022cbd7(callback) {
    return $f01b4adf86c96a55$var$addMetricObserver("inp", callback, $f01b4adf86c96a55$var$instrumentInp, $f01b4adf86c96a55$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f01b4adf86c96a55$export$69816c1a049f8db6(type, callback) {
    $f01b4adf86c96a55$var$addHandler(type, callback);
    if (!$f01b4adf86c96a55$var$instrumented[type]) {
        $f01b4adf86c96a55$var$instrumentPerformanceObserver(type);
        $f01b4adf86c96a55$var$instrumented[type] = true;
    }
    return $f01b4adf86c96a55$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $f01b4adf86c96a55$var$triggerHandlers(type, data) {
    const typeHandlers = $f01b4adf86c96a55$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $797c2bd47eb6cfb1$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $f01b4adf86c96a55$var$instrumentCls() {
    return (0, $67412680333a8f38$export$a7873055838e5ad8)((metric)=>{
        $f01b4adf86c96a55$var$triggerHandlers("cls", {
            metric: metric
        });
        $f01b4adf86c96a55$var$_previousCls = metric;
    });
}
function $f01b4adf86c96a55$var$instrumentFid() {
    return (0, $9f0f51ae13ef1709$export$39705a25c49af873)((metric)=>{
        $f01b4adf86c96a55$var$triggerHandlers("fid", {
            metric: metric
        });
        $f01b4adf86c96a55$var$_previousFid = metric;
    });
}
function $f01b4adf86c96a55$var$instrumentLcp() {
    return (0, $4697a1f09b4923c3$export$947b1626ab8d5632)((metric)=>{
        $f01b4adf86c96a55$var$triggerHandlers("lcp", {
            metric: metric
        });
        $f01b4adf86c96a55$var$_previousLcp = metric;
    });
}
function $f01b4adf86c96a55$var$instrumentTtfb() {
    return (0, $894b289c1d312069$export$33a01e6c5f2c7e33)((metric)=>{
        $f01b4adf86c96a55$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $f01b4adf86c96a55$var$_previousTtfb = metric;
    });
}
function $f01b4adf86c96a55$var$instrumentInp() {
    return (0, $2eed16876cc05580$export$7df4b36ecaed99e1)((metric)=>{
        $f01b4adf86c96a55$var$triggerHandlers("inp", {
            metric: metric
        });
        $f01b4adf86c96a55$var$_previousInp = metric;
    });
}
function $f01b4adf86c96a55$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $f01b4adf86c96a55$var$addHandler(type, callback);
    let stopListening;
    if (!$f01b4adf86c96a55$var$instrumented[type]) {
        stopListening = instrumentFn();
        $f01b4adf86c96a55$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $f01b4adf86c96a55$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $f01b4adf86c96a55$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $fb9a0b0cd35b09c0$export$d1203567a167490e)(type, (entries)=>{
        $f01b4adf86c96a55$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $f01b4adf86c96a55$var$addHandler(type, handler) {
    $f01b4adf86c96a55$var$handlers[type] = $f01b4adf86c96a55$var$handlers[type] || [];
    $f01b4adf86c96a55$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $f01b4adf86c96a55$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $f01b4adf86c96a55$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $2facab2ffcad81d6$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $9ac7cae31cb69a4b$export$44d472fbb931a776)(dsn);
    const items = spans.map($2facab2ffcad81d6$var$createSpanItem);
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)(headers, items);
}
function $2facab2ffcad81d6$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $634e9dd53c1096fe$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}







/**
 * Checks if a given value is a valid measurement value.
 */ function $53fff07b0223e4fc$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $53fff07b0223e4fc$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $95c982747d67c7e3$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $95c982747d67c7e3$var$msToSec(time) {
    return time / 1000;
}
function $95c982747d67c7e3$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81) && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).addEventListener && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance;
}
let $95c982747d67c7e3$var$_performanceCursor = 0;
let $95c982747d67c7e3$var$_measurements = {};
let $95c982747d67c7e3$var$_lcpEntry;
let $95c982747d67c7e3$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $95c982747d67c7e3$export$7c69f0412d101b88() {
    const performance = $95c982747d67c7e3$var$getBrowserPerformanceAPI();
    if (performance && (0, $d59dd3fae5fc220e$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $95c982747d67c7e3$var$_trackFID();
        const clsCallback = $95c982747d67c7e3$var$_trackCLS();
        const lcpCallback = $95c982747d67c7e3$var$_trackLCP();
        const ttfbCallback = $95c982747d67c7e3$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $95c982747d67c7e3$export$f396d19077034ad2() {
    (0, $f01b4adf86c96a55$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $95c982747d67c7e3$var$msToSec((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $95c982747d67c7e3$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $95c982747d67c7e3$export$e27543e0976315e4() {
    (0, $f01b4adf86c96a55$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $95c982747d67c7e3$var$msToSec((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $95c982747d67c7e3$var$msToSec(entry.duration);
                const span = {
                    description: (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $8a18c3c2a11733c0$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $95c982747d67c7e3$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $95c982747d67c7e3$var$getBrowserPerformanceAPI();
    if (performance && (0, $d59dd3fae5fc220e$export$baf075a948ffc0bf)) {
        const inpCallback = $95c982747d67c7e3$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $95c982747d67c7e3$var$_trackCLS() {
    return (0, $f01b4adf86c96a55$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $95c982747d67c7e3$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $95c982747d67c7e3$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $95c982747d67c7e3$var$_trackLCP() {
    return (0, $f01b4adf86c96a55$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $95c982747d67c7e3$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $95c982747d67c7e3$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $95c982747d67c7e3$var$_trackFID() {
    return (0, $f01b4adf86c96a55$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $95c982747d67c7e3$var$msToSec((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf));
        const startTime = $95c982747d67c7e3$var$msToSec(entry.startTime);
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $95c982747d67c7e3$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $95c982747d67c7e3$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $95c982747d67c7e3$var$_trackTtfb() {
    return (0, $f01b4adf86c96a55$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $95c982747d67c7e3$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $95c982747d67c7e3$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $95c982747d67c7e3$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $f01b4adf86c96a55$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $95c982747d67c7e3$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $95c982747d67c7e3$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $95c982747d67c7e3$var$msToSec((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $95c982747d67c7e3$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $f952de733b7dab74$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $95c982747d67c7e3$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $2facab2ffcad81d6$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $95c982747d67c7e3$export$5f8fa6b3467a7443(transaction) {
    const performance = $95c982747d67c7e3$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).performance.getEntries || !(0, $d59dd3fae5fc220e$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $95c982747d67c7e3$var$msToSec((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($95c982747d67c7e3$var$_performanceCursor).forEach((entry)=>{
        const startTime = $95c982747d67c7e3$var$msToSec(entry.startTime);
        const duration = $95c982747d67c7e3$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $95c982747d67c7e3$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $95c982747d67c7e3$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $ee0151b33dcfcacc$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $95c982747d67c7e3$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $95c982747d67c7e3$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $95c982747d67c7e3$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $95c982747d67c7e3$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $95c982747d67c7e3$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $95c982747d67c7e3$var$_addTtfbRequestTimeToMeasurements($95c982747d67c7e3$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$95c982747d67c7e3$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $95c982747d67c7e3$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $95c982747d67c7e3$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $95c982747d67c7e3$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $95c982747d67c7e3$var$_measurements["mark.fid"];
        if (fidMark && $95c982747d67c7e3$var$_measurements["fid"]) {
            // create span for FID
            (0, $53fff07b0223e4fc$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $95c982747d67c7e3$var$msToSec($95c982747d67c7e3$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $95c982747d67c7e3$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $95c982747d67c7e3$var$_measurements)) delete $95c982747d67c7e3$var$_measurements.cls;
        Object.keys($95c982747d67c7e3$var$_measurements).forEach((measurementName)=>{
            (0, $634e9dd53c1096fe$export$7cc31b475d33a706)(measurementName, $95c982747d67c7e3$var$_measurements[measurementName].value, $95c982747d67c7e3$var$_measurements[measurementName].unit);
        });
        $95c982747d67c7e3$var$_tagMetricInfo(transaction);
    }
    $95c982747d67c7e3$var$_lcpEntry = undefined;
    $95c982747d67c7e3$var$_clsEntry = undefined;
    $95c982747d67c7e3$var$_measurements = {};
}
/** Create measure related spans */ function $95c982747d67c7e3$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $53fff07b0223e4fc$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $95c982747d67c7e3$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $95c982747d67c7e3$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $95c982747d67c7e3$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $95c982747d67c7e3$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $95c982747d67c7e3$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $95c982747d67c7e3$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $95c982747d67c7e3$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $53fff07b0223e4fc$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $95c982747d67c7e3$var$msToSec(start),
        endTimestamp: timeOrigin + $95c982747d67c7e3$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $95c982747d67c7e3$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $53fff07b0223e4fc$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $95c982747d67c7e3$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $95c982747d67c7e3$var$msToSec(entry.responseEnd)
        });
        (0, $53fff07b0223e4fc$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $95c982747d67c7e3$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $95c982747d67c7e3$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $95c982747d67c7e3$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $6349c7ce4c999262$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $95c982747d67c7e3$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $95c982747d67c7e3$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $95c982747d67c7e3$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $53fff07b0223e4fc$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $95c982747d67c7e3$var$_trackNavigator(transaction) {
    const navigator = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $53fff07b0223e4fc$export$27169ccae1b439e3)(connection.rtt)) $95c982747d67c7e3$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $53fff07b0223e4fc$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $53fff07b0223e4fc$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $95c982747d67c7e3$var$_tagMetricInfo(transaction) {
    if ($95c982747d67c7e3$var$_lcpEntry) {
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($95c982747d67c7e3$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)($95c982747d67c7e3$var$_lcpEntry.element));
        if ($95c982747d67c7e3$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $95c982747d67c7e3$var$_lcpEntry.id);
        if ($95c982747d67c7e3$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $95c982747d67c7e3$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $95c982747d67c7e3$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($95c982747d67c7e3$var$_clsEntry && $95c982747d67c7e3$var$_clsEntry.sources) {
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $95c982747d67c7e3$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(source.node)));
    }
}
function $95c982747d67c7e3$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $95c982747d67c7e3$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $95c982747d67c7e3$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $8d7d9e9884583fb8$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $95c982747d67c7e3$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $7c181fe254a28c13$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $f9c714723e552f13$export$2603c8d332a51c42)(sampleRate)) {
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}






/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $6efb1dcf0482e87e$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $7c181fe254a28c13$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $6efb1dcf0482e87e$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $6efb1dcf0482e87e$var$getFullURL(url);
    const host = fullUrl ? (0, $6349c7ce4c999262$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $c1ff268be949f613$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $b2c76ea57c95e097$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $6efb1dcf0482e87e$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $6efb1dcf0482e87e$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $d07da62ed3ec9e2d$export$7e9f8ae9e4a328ab)(span) : (0, $c7b1128cbfbed8e5$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $37635ed0fe709d12$export$56766feef403f365)(dsc || (span ? (0, $c3cc587f6f15fc71$export$a117f995597e25df)(span) : (0, $c3cc587f6f15fc71$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $fc911ca066fa75c2$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $fc911ca066fa75c2$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $37635ed0fe709d12$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $37635ed0fe709d12$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $6efb1dcf0482e87e$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $6efb1dcf0482e87e$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $f3015ea0974b5361$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $d90e8da04f35ad9b$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $d90e8da04f35ad9b$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $d90e8da04f35ad9b$export$15bd0305d05ad07b,
    tracePropagationTargets: $d90e8da04f35ad9b$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $d90e8da04f35ad9b$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $d90e8da04f35ad9b$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $d90e8da04f35ad9b$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$d90e8da04f35ad9b$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $5e15774c4f1380e3$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $6efb1dcf0482e87e$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $d90e8da04f35ad9b$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $6349c7ce4c999262$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $d90e8da04f35ad9b$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $9602c7b10ae772dd$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $d90e8da04f35ad9b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $d90e8da04f35ad9b$var$addHTTPTimings(createdSpan);
    });
}
function $d90e8da04f35ad9b$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $d90e8da04f35ad9b$var$addHTTPTimings(span) {
    const { url: url } = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $f01b4adf86c96a55$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($d90e8da04f35ad9b$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $d90e8da04f35ad9b$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $d90e8da04f35ad9b$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $d90e8da04f35ad9b$var$getAbsoluteTime(time = 0) {
    return (((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $d90e8da04f35ad9b$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $d90e8da04f35ad9b$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $d59dd3fae5fc220e$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $d90e8da04f35ad9b$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $d90e8da04f35ad9b$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $0f4ffa1af5d1985d$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $d90e8da04f35ad9b$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $d90e8da04f35ad9b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $9602c7b10ae772dd$export$55b6bb1e45c6cf59];
    if (!(0, $7c181fe254a28c13$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $f3015ea0974b5361$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    const isolationScope = (0, $805d0d6bf1179169$export$68f3af03034c9e90)();
    const fullUrl = $d90e8da04f35ad9b$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $6349c7ce4c999262$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $c1ff268be949f613$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $b2c76ea57c95e097$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $d07da62ed3ec9e2d$export$7e9f8ae9e4a328ab)(span) : (0, $c7b1128cbfbed8e5$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $37635ed0fe709d12$export$56766feef403f365)(dsc || (span ? (0, $c3cc587f6f15fc71$export$a117f995597e25df)(span) : (0, $c3cc587f6f15fc71$export$366bad00d6815eed)(traceId, client, scope)));
        $d90e8da04f35ad9b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $d90e8da04f35ad9b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $37635ed0fe709d12$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $d90e8da04f35ad9b$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



const $c6555bd6d4dc8811$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $c6555bd6d4dc8811$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $8bf6c22df0d9c1c1$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $d90e8da04f35ad9b$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $c6555bd6d4dc8811$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $4147aee33e8f69ed$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$c6555bd6d4dc8811$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $95c982747d67c7e3$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $95c982747d67c7e3$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $95c982747d67c7e3$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $95c982747d67c7e3$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $c6555bd6d4dc8811$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $c6555bd6d4dc8811$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $c7b1128cbfbed8e5$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $4147aee33e8f69ed$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document) {
            (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $95c982747d67c7e3$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $c6555bd6d4dc8811$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $d07da62ed3ec9e2d$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $d07da62ed3ec9e2d$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) ? (0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $b2c76ea57c95e097$export$d7a7d984b0791405)]: "url"
                    }
                };
                $c6555bd6d4dc8811$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location) (0, $ff311393fc83ca4e$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $b2c76ea57c95e097$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $c6555bd6d4dc8811$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $b5e5d1247a1f324c$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $c6555bd6d4dc8811$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $c6555bd6d4dc8811$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $d90e8da04f35ad9b$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $c6555bd6d4dc8811$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $c1ff268be949f613$export$1be426a8e585c83e)();
    const op = span && (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $c6555bd6d4dc8811$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $c1ff268be949f613$export$1be426a8e585c83e)();
    const op = span && (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $c6555bd6d4dc8811$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $8a18c3c2a11733c0$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $c6555bd6d4dc8811$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $5e18a2830ef5d7ef$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $b2c76ea57c95e097$export$d7a7d984b0791405)]: latestRoute.context ? $c6555bd6d4dc8811$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $4147aee33e8f69ed$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $805d0d6bf1179169$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, $f37e8a0bcc928f27$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $c6555bd6d4dc8811$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $c6555bd6d4dc8811$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $c6555bd6d4dc8811$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $56bc6eac59929789$export$a7feb32fdd923295)();
        const currentScope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($c6555bd6d4dc8811$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $c6555bd6d4dc8811$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $c6555bd6d4dc8811$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $f01b4adf86c96a55$export$69816c1a049f8db6)("event", handleEntries);
    (0, $f01b4adf86c96a55$export$69816c1a049f8db6)("first-input", handleEntries);
}
function $c6555bd6d4dc8811$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $b2c76ea57c95e097$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $b2c76ea57c95e097$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

































/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $2a5a3bba9b8924df$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $2a5a3bba9b8924df$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $2a5a3bba9b8924df$var$checkDsn(url, dsn) || $2a5a3bba9b8924df$var$checkTunnel(url, tunnel);
}
function $2a5a3bba9b8924df$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $2a5a3bba9b8924df$var$removeTrailingSlash(url) === $2a5a3bba9b8924df$var$removeTrailingSlash(tunnel);
}
function $2a5a3bba9b8924df$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $2a5a3bba9b8924df$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $2a5a3bba9b8924df$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}













var $1a6b00567141662d$exports = {};

$parcel$export($1a6b00567141662d$exports, "FunctionToString", function () { return $5cd3251c619fffd4$export$da4704525c20ae79; });
$parcel$export($1a6b00567141662d$exports, "InboundFilters", function () { return $58ba388a13cbb2ee$export$2ffbb5359dcc6be4; });
$parcel$export($1a6b00567141662d$exports, "LinkedErrors", function () { return $3d9f79a2ec62f491$export$8d1e60aaf616fb4f; });






/**
 * Extracts stack frames from the error.stack string
 */ function $445b6de144dbf94d$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $445b6de144dbf94d$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $445b6de144dbf94d$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $445b6de144dbf94d$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $2e1797501eb473e4$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $445b6de144dbf94d$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $fc911ca066fa75c2$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $fc911ca066fa75c2$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $359c7e66c2efdebe$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $445b6de144dbf94d$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $445b6de144dbf94d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $db1a2eab7c136bdd$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $db1a2eab7c136bdd$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $445b6de144dbf94d$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $445b6de144dbf94d$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $fc911ca066fa75c2$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $3d9f79a2ec62f491$var$DEFAULT_KEY = "cause";
const $3d9f79a2ec62f491$var$DEFAULT_LIMIT = 5;
const $3d9f79a2ec62f491$var$INTEGRATION_NAME = "LinkedErrors";
const $3d9f79a2ec62f491$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $3d9f79a2ec62f491$var$DEFAULT_LIMIT;
    const key = options.key || $3d9f79a2ec62f491$var$DEFAULT_KEY;
    return {
        name: $3d9f79a2ec62f491$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $107c2ab276ae7c61$export$b91c38ed7d8ae9b2)((0, $445b6de144dbf94d$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $3d9f79a2ec62f491$export$ebabb00eb7f3a395 = (0, $b7daa41624c279e2$export$2323046b9414659f)($3d9f79a2ec62f491$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3d9f79a2ec62f491$export$8d1e60aaf616fb4f = (0, $b7daa41624c279e2$export$afa219bf23651160)($3d9f79a2ec62f491$var$INTEGRATION_NAME, $3d9f79a2ec62f491$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $787cdcef57f3a775$export$99d02219d259eb94 = $1a6b00567141662d$exports;
















var $1af1b4024ed5c8b1$exports = {};

$parcel$export($1af1b4024ed5c8b1$exports, "GlobalHandlers", function () { return $a7de3a329e8c48b4$export$204155decbc90e5a; });
$parcel$export($1af1b4024ed5c8b1$exports, "TryCatch", function () { return $c96230d297c4a371$export$f1a018517668e6d3; });
$parcel$export($1af1b4024ed5c8b1$exports, "Breadcrumbs", function () { return $b3b1d4a4aba5c6f3$export$2dc68d50d56fbbd; });
$parcel$export($1af1b4024ed5c8b1$exports, "LinkedErrors", function () { return $d6635b9ebe41be18$export$8d1e60aaf616fb4f; });
$parcel$export($1af1b4024ed5c8b1$exports, "HttpContext", function () { return $fe4cd2ceaf62bd9a$export$5d2ee9a544b09a94; });
$parcel$export($1af1b4024ed5c8b1$exports, "Dedupe", function () { return $1d345a3673699ab2$export$688d98c249d31ad3; });






 /* eslint-disable deprecation/deprecation */ 

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $0b3f6e74ba8e3d37$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $ab2b093b9f2f979d$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $dJovV = parcelRequire("dJovV");

/**
 * Returns true if we are in the browser.
 */ function $19a7a09b8ec81f15$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $dJovV.isNodeEnv)() || $19a7a09b8ec81f15$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $19a7a09b8ec81f15$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).process !== undefined && (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1).process.type === "renderer");
}




// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $dc5d1e10574edabe$var$WINDOW = (0, $d58394577b25a7dd$export$f1a6cdb1459e81d1);
const $dc5d1e10574edabe$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $dc5d1e10574edabe$var$REPLAY_EVENT_NAME = "replay_event";
const $dc5d1e10574edabe$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $dc5d1e10574edabe$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $dc5d1e10574edabe$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $dc5d1e10574edabe$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $dc5d1e10574edabe$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $dc5d1e10574edabe$var$BUFFER_CHECKOUT_TIME = 60000;
const $dc5d1e10574edabe$var$RETRY_BASE_INTERVAL = 5000;
const $dc5d1e10574edabe$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $dc5d1e10574edabe$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $dc5d1e10574edabe$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $dc5d1e10574edabe$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $dc5d1e10574edabe$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $dc5d1e10574edabe$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $dc5d1e10574edabe$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $dc5d1e10574edabe$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $dc5d1e10574edabe$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $dc5d1e10574edabe$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $dc5d1e10574edabe$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $dc5d1e10574edabe$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($dc5d1e10574edabe$var$NodeType$1 || ($dc5d1e10574edabe$var$NodeType$1 = {}));
function $dc5d1e10574edabe$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $dc5d1e10574edabe$var$isShadowRoot(n) {
    const host = $dc5d1e10574edabe$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($dc5d1e10574edabe$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $dc5d1e10574edabe$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $dc5d1e10574edabe$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $dc5d1e10574edabe$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $dc5d1e10574edabe$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $dc5d1e10574edabe$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $dc5d1e10574edabe$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $dc5d1e10574edabe$var$stringifyRule(rule) {
    let importStringified;
    if ($dc5d1e10574edabe$var$isCSSImportRule(rule)) try {
        importStringified = $dc5d1e10574edabe$var$stringifyStylesheet(rule.styleSheet) || $dc5d1e10574edabe$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($dc5d1e10574edabe$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $dc5d1e10574edabe$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $dc5d1e10574edabe$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $dc5d1e10574edabe$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $dc5d1e10574edabe$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $dc5d1e10574edabe$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $dc5d1e10574edabe$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $dc5d1e10574edabe$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $dc5d1e10574edabe$var$createMirror() {
    return new $dc5d1e10574edabe$var$Mirror();
}
function $dc5d1e10574edabe$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $dc5d1e10574edabe$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $dc5d1e10574edabe$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $dc5d1e10574edabe$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $dc5d1e10574edabe$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $dc5d1e10574edabe$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $dc5d1e10574edabe$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$dc5d1e10574edabe$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $dc5d1e10574edabe$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $dc5d1e10574edabe$var$toLowerCase(type) : null;
}
function $dc5d1e10574edabe$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $dc5d1e10574edabe$var$_id = 1;
const $dc5d1e10574edabe$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $dc5d1e10574edabe$var$IGNORED_NODE = -2;
function $dc5d1e10574edabe$var$genId() {
    return $dc5d1e10574edabe$var$_id++;
}
function $dc5d1e10574edabe$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $dc5d1e10574edabe$var$toLowerCase(element.tagName);
    if ($dc5d1e10574edabe$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $dc5d1e10574edabe$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $dc5d1e10574edabe$var$canvasService;
let $dc5d1e10574edabe$var$canvasCtx;
const $dc5d1e10574edabe$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $dc5d1e10574edabe$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $dc5d1e10574edabe$var$URL_WWW_MATCH = /^www\..*/i;
const $dc5d1e10574edabe$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $dc5d1e10574edabe$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($dc5d1e10574edabe$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($dc5d1e10574edabe$var$URL_PROTOCOL_MATCH.test(filePath) || $dc5d1e10574edabe$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($dc5d1e10574edabe$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$dc5d1e10574edabe$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $dc5d1e10574edabe$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $dc5d1e10574edabe$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $dc5d1e10574edabe$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($dc5d1e10574edabe$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($dc5d1e10574edabe$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $dc5d1e10574edabe$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $dc5d1e10574edabe$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $dc5d1e10574edabe$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $dc5d1e10574edabe$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $dc5d1e10574edabe$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $dc5d1e10574edabe$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $dc5d1e10574edabe$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $dc5d1e10574edabe$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $dc5d1e10574edabe$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $dc5d1e10574edabe$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $dc5d1e10574edabe$var$absoluteToStylesheet(value, $dc5d1e10574edabe$var$getHref());
    else if (tagName === "object" && name === "data") return $dc5d1e10574edabe$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $dc5d1e10574edabe$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $dc5d1e10574edabe$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $dc5d1e10574edabe$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $dc5d1e10574edabe$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $dc5d1e10574edabe$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $dc5d1e10574edabe$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($dc5d1e10574edabe$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $dc5d1e10574edabe$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $dc5d1e10574edabe$var$distanceToMatch(el, $dc5d1e10574edabe$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $dc5d1e10574edabe$var$distanceToMatch(el, $dc5d1e10574edabe$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $dc5d1e10574edabe$var$distanceToMatch(el, $dc5d1e10574edabe$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $dc5d1e10574edabe$var$distanceToMatch(el, $dc5d1e10574edabe$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $dc5d1e10574edabe$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $dc5d1e10574edabe$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $dc5d1e10574edabe$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $dc5d1e10574edabe$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $dc5d1e10574edabe$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $dc5d1e10574edabe$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $dc5d1e10574edabe$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $dc5d1e10574edabe$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $dc5d1e10574edabe$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $dc5d1e10574edabe$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $dc5d1e10574edabe$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $dc5d1e10574edabe$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $dc5d1e10574edabe$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($dc5d1e10574edabe$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $dc5d1e10574edabe$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $dc5d1e10574edabe$var$absoluteToStylesheet(textContent, $dc5d1e10574edabe$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $dc5d1e10574edabe$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $dc5d1e10574edabe$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $dc5d1e10574edabe$var$maskInputValue({
            isMasked: $dc5d1e10574edabe$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $dc5d1e10574edabe$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $dc5d1e10574edabe$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $dc5d1e10574edabe$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $dc5d1e10574edabe$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$dc5d1e10574edabe$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $dc5d1e10574edabe$var$transformAttribute(doc, tagName, $dc5d1e10574edabe$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $dc5d1e10574edabe$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $dc5d1e10574edabe$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $dc5d1e10574edabe$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $dc5d1e10574edabe$var$absoluteToStylesheet(cssText, $dc5d1e10574edabe$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $dc5d1e10574edabe$var$getInputType(el);
        const value = $dc5d1e10574edabe$var$getInputValue(el, $dc5d1e10574edabe$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $dc5d1e10574edabe$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $dc5d1e10574edabe$var$shouldMaskInput({
                type: type,
                tagName: $dc5d1e10574edabe$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $dc5d1e10574edabe$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$dc5d1e10574edabe$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$dc5d1e10574edabe$var$canvasService) {
            $dc5d1e10574edabe$var$canvasService = doc.createElement("canvas");
            $dc5d1e10574edabe$var$canvasCtx = $dc5d1e10574edabe$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $dc5d1e10574edabe$var$canvasService.width = image.naturalWidth;
                $dc5d1e10574edabe$var$canvasService.height = image.naturalHeight;
                $dc5d1e10574edabe$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $dc5d1e10574edabe$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $dc5d1e10574edabe$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $dc5d1e10574edabe$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $dc5d1e10574edabe$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $dc5d1e10574edabe$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $dc5d1e10574edabe$var$NodeType$1.Comment) return true;
    else if (sn.type === $dc5d1e10574edabe$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "application-name" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.rel) === "icon" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($dc5d1e10574edabe$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "robots" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "googlebot" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "author" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "generator" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "framework" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "publisher" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "progid" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "verification" || $dc5d1e10574edabe$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $dc5d1e10574edabe$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $dc5d1e10574edabe$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($dc5d1e10574edabe$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $dc5d1e10574edabe$var$IGNORED_NODE;
    else id = $dc5d1e10574edabe$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $dc5d1e10574edabe$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $dc5d1e10574edabe$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Document || serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $dc5d1e10574edabe$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($dc5d1e10574edabe$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $dc5d1e10574edabe$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $dc5d1e10574edabe$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $dc5d1e10574edabe$var$isShadowRoot(n.parentNode) && $dc5d1e10574edabe$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Element && serializedNode.tagName === "iframe") $dc5d1e10574edabe$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $dc5d1e10574edabe$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $dc5d1e10574edabe$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $dc5d1e10574edabe$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $dc5d1e10574edabe$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $dc5d1e10574edabe$var$snapshot(n, options) {
    const { mirror: mirror = new $dc5d1e10574edabe$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $dc5d1e10574edabe$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $dc5d1e10574edabe$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $dc5d1e10574edabe$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $dc5d1e10574edabe$var$_mirror = {
    map: {},
    getId () {
        console.error($dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $dc5d1e10574edabe$var$_mirror = new Proxy($dc5d1e10574edabe$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($dc5d1e10574edabe$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $dc5d1e10574edabe$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $dc5d1e10574edabe$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$dc5d1e10574edabe$var$hookSetter(target, key, original || {}, true);
}
function $dc5d1e10574edabe$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $dc5d1e10574edabe$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $dc5d1e10574edabe$var$nowTimestamp = ()=>new Date().getTime();
function $dc5d1e10574edabe$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $dc5d1e10574edabe$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $dc5d1e10574edabe$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $dc5d1e10574edabe$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $dc5d1e10574edabe$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $dc5d1e10574edabe$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $dc5d1e10574edabe$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $dc5d1e10574edabe$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $dc5d1e10574edabe$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $dc5d1e10574edabe$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (!el) return false;
    const blockedPredicate = $dc5d1e10574edabe$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $dc5d1e10574edabe$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $dc5d1e10574edabe$var$distanceToMatch(el, $dc5d1e10574edabe$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $dc5d1e10574edabe$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $dc5d1e10574edabe$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $dc5d1e10574edabe$var$IGNORED_NODE;
}
function $dc5d1e10574edabe$var$isAncestorRemoved(target, mirror) {
    if ($dc5d1e10574edabe$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $dc5d1e10574edabe$var$isAncestorRemoved(target.parentNode, mirror);
}
function $dc5d1e10574edabe$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $dc5d1e10574edabe$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $dc5d1e10574edabe$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $dc5d1e10574edabe$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $dc5d1e10574edabe$var$hasShadowRoot(n) {
    return Boolean($dc5d1e10574edabe$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $dc5d1e10574edabe$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $0b3f6e74ba8e3d37$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $dc5d1e10574edabe$var$getShadowHost(n) {
    let shadowHost = null;
    if ($dc5d1e10574edabe$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $dc5d1e10574edabe$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $dc5d1e10574edabe$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $dc5d1e10574edabe$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $dc5d1e10574edabe$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $dc5d1e10574edabe$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $dc5d1e10574edabe$var$shadowHostInDom(n);
}
let $dc5d1e10574edabe$var$cachedRequestAnimationFrameImplementation;
function $dc5d1e10574edabe$var$getRequestAnimationFrameImplementation() {
    if ($dc5d1e10574edabe$var$cachedRequestAnimationFrameImplementation) return $dc5d1e10574edabe$var$cachedRequestAnimationFrameImplementation;
    const document1 = window.document;
    let requestAnimationFrameImplementation = window.requestAnimationFrame;
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.requestAnimationFrame) requestAnimationFrameImplementation = contentWindow.requestAnimationFrame;
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $dc5d1e10574edabe$var$cachedRequestAnimationFrameImplementation = requestAnimationFrameImplementation.bind(window);
}
function $dc5d1e10574edabe$var$onRequestAnimationFrame(...rest) {
    return $dc5d1e10574edabe$var$getRequestAnimationFrameImplementation()(...rest);
}
var $dc5d1e10574edabe$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($dc5d1e10574edabe$var$EventType || {});
var $dc5d1e10574edabe$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($dc5d1e10574edabe$var$IncrementalSource || {});
var $dc5d1e10574edabe$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($dc5d1e10574edabe$var$MouseInteractions || {});
var $dc5d1e10574edabe$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($dc5d1e10574edabe$var$PointerTypes || {});
function $dc5d1e10574edabe$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $dc5d1e10574edabe$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $dc5d1e10574edabe$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $dc5d1e10574edabe$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $dc5d1e10574edabe$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $dc5d1e10574edabe$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $dc5d1e10574edabe$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $dc5d1e10574edabe$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $dc5d1e10574edabe$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $dc5d1e10574edabe$var$IGNORED_NODE;
                while(nextId === $dc5d1e10574edabe$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$dc5d1e10574edabe$var$inDom(n)) return;
                const parentId = $dc5d1e10574edabe$var$isShadowRoot(n.parentNode) ? this.mirror.getId($dc5d1e10574edabe$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $dc5d1e10574edabe$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($dc5d1e10574edabe$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($dc5d1e10574edabe$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($dc5d1e10574edabe$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($dc5d1e10574edabe$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$dc5d1e10574edabe$var$isAncestorInSet(this.droppedSet, n) && !$dc5d1e10574edabe$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($dc5d1e10574edabe$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($dc5d1e10574edabe$var$isIgnored(m.target, this.mirror)) return;
            let unattachedDoc;
            try {
                unattachedDoc = document.implementation.createHTMLDocument();
            } catch (e) {
                unattachedDoc = this.doc;
            }
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$dc5d1e10574edabe$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $dc5d1e10574edabe$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $dc5d1e10574edabe$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $dc5d1e10574edabe$var$getInputValue(target, tagName, type);
                            const isInputMasked = $dc5d1e10574edabe$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $dc5d1e10574edabe$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $dc5d1e10574edabe$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($dc5d1e10574edabe$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$dc5d1e10574edabe$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $dc5d1e10574edabe$var$transformAttribute(this.doc, $dc5d1e10574edabe$var$toLowerCase(target.tagName), $dc5d1e10574edabe$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const old = unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($dc5d1e10574edabe$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $dc5d1e10574edabe$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($dc5d1e10574edabe$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $dc5d1e10574edabe$var$isIgnored(n, this.mirror) || !$dc5d1e10574edabe$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $dc5d1e10574edabe$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($dc5d1e10574edabe$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$dc5d1e10574edabe$var$moveKey(nodeId, parentId)]) $dc5d1e10574edabe$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $dc5d1e10574edabe$var$isShadowRoot(m.target) && $dc5d1e10574edabe$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($dc5d1e10574edabe$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$dc5d1e10574edabe$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$dc5d1e10574edabe$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($dc5d1e10574edabe$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $dc5d1e10574edabe$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$dc5d1e10574edabe$var$deepDelete(addsSet, childN));
}
function $dc5d1e10574edabe$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $dc5d1e10574edabe$var$_isParentRemoved(removes, n, mirror);
}
function $dc5d1e10574edabe$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $dc5d1e10574edabe$var$_isParentRemoved(removes, parentNode, mirror);
}
function $dc5d1e10574edabe$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $dc5d1e10574edabe$var$_isAncestorInSet(set, n);
}
function $dc5d1e10574edabe$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $dc5d1e10574edabe$var$_isAncestorInSet(set, parentNode);
}
let $dc5d1e10574edabe$var$errorHandler;
function $dc5d1e10574edabe$var$registerErrorHandler(handler) {
    $dc5d1e10574edabe$var$errorHandler = handler;
}
function $dc5d1e10574edabe$var$unregisterErrorHandler() {
    $dc5d1e10574edabe$var$errorHandler = undefined;
}
const $dc5d1e10574edabe$var$callbackWrapper = (cb)=>{
    if (!$dc5d1e10574edabe$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($dc5d1e10574edabe$var$errorHandler && $dc5d1e10574edabe$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $dc5d1e10574edabe$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $dc5d1e10574edabe$var$mutationBuffers = [];
function $dc5d1e10574edabe$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $dc5d1e10574edabe$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $dc5d1e10574edabe$var$MutationBuffer();
    $dc5d1e10574edabe$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $dc5d1e10574edabe$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($dc5d1e10574edabe$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $dc5d1e10574edabe$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $dc5d1e10574edabe$var$throttle$1($dc5d1e10574edabe$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $dc5d1e10574edabe$var$callbackWrapper($dc5d1e10574edabe$var$throttle$1($dc5d1e10574edabe$var$callbackWrapper((evt)=>{
        const target = $dc5d1e10574edabe$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $dc5d1e10574edabe$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $dc5d1e10574edabe$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $dc5d1e10574edabe$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $dc5d1e10574edabe$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $dc5d1e10574edabe$var$IncrementalSource.MouseMove : $dc5d1e10574edabe$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $dc5d1e10574edabe$var$on("mousemove", updatePosition, doc),
        $dc5d1e10574edabe$var$on("touchmove", updatePosition, doc),
        $dc5d1e10574edabe$var$on("drag", updatePosition, doc)
    ];
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $dc5d1e10574edabe$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $dc5d1e10574edabe$var$getEventTarget(event);
            if ($dc5d1e10574edabe$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $dc5d1e10574edabe$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $dc5d1e10574edabe$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $dc5d1e10574edabe$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $dc5d1e10574edabe$var$PointerTypes.Touch) {
                    if ($dc5d1e10574edabe$var$MouseInteractions[eventKey] === $dc5d1e10574edabe$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($dc5d1e10574edabe$var$MouseInteractions[eventKey] === $dc5d1e10574edabe$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $dc5d1e10574edabe$var$PointerTypes.Pen;
            } else if ($dc5d1e10574edabe$var$legacy_isTouchEvent(event)) pointerType = $dc5d1e10574edabe$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $dc5d1e10574edabe$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $dc5d1e10574edabe$var$PointerTypes.Mouse) pointerType = null;
            } else if ($dc5d1e10574edabe$var$MouseInteractions[eventKey] === $dc5d1e10574edabe$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $dc5d1e10574edabe$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $dc5d1e10574edabe$var$callbackWrapper(mouseInteractionCb)({
                type: $dc5d1e10574edabe$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($dc5d1e10574edabe$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $dc5d1e10574edabe$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($dc5d1e10574edabe$var$MouseInteractions[eventKey]){
            case $dc5d1e10574edabe$var$MouseInteractions.MouseDown:
            case $dc5d1e10574edabe$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $dc5d1e10574edabe$var$MouseInteractions.TouchStart:
            case $dc5d1e10574edabe$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($dc5d1e10574edabe$var$on(eventName, handler, doc));
    });
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $dc5d1e10574edabe$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $dc5d1e10574edabe$var$callbackWrapper($dc5d1e10574edabe$var$throttle$1($dc5d1e10574edabe$var$callbackWrapper((evt)=>{
        const target = $dc5d1e10574edabe$var$getEventTarget(evt);
        if (!target || $dc5d1e10574edabe$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $dc5d1e10574edabe$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $dc5d1e10574edabe$var$on("scroll", updatePosition, doc);
}
function $dc5d1e10574edabe$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $dc5d1e10574edabe$var$callbackWrapper($dc5d1e10574edabe$var$throttle$1($dc5d1e10574edabe$var$callbackWrapper(()=>{
        const height = $dc5d1e10574edabe$var$getWindowHeight();
        const width = $dc5d1e10574edabe$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $dc5d1e10574edabe$var$on("resize", updateDimension, win);
}
const $dc5d1e10574edabe$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $dc5d1e10574edabe$var$lastInputValueMap = new WeakMap();
function $dc5d1e10574edabe$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $dc5d1e10574edabe$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $dc5d1e10574edabe$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $dc5d1e10574edabe$var$INPUT_TAGS.indexOf(tagName) < 0 || $dc5d1e10574edabe$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $dc5d1e10574edabe$var$getInputType(target);
        let text = $dc5d1e10574edabe$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $dc5d1e10574edabe$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $dc5d1e10574edabe$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $dc5d1e10574edabe$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $dc5d1e10574edabe$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $dc5d1e10574edabe$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $dc5d1e10574edabe$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $dc5d1e10574edabe$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $dc5d1e10574edabe$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$dc5d1e10574edabe$var$on(eventName, $dc5d1e10574edabe$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$dc5d1e10574edabe$var$hookSetter(p[0], p[1], {
            set () {
                $dc5d1e10574edabe$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $dc5d1e10574edabe$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($dc5d1e10574edabe$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $dc5d1e10574edabe$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $dc5d1e10574edabe$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $dc5d1e10574edabe$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $dc5d1e10574edabe$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $dc5d1e10574edabe$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($dc5d1e10574edabe$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($dc5d1e10574edabe$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($dc5d1e10574edabe$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($dc5d1e10574edabe$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$dc5d1e10574edabe$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$dc5d1e10574edabe$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $dc5d1e10574edabe$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $dc5d1e10574edabe$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $dc5d1e10574edabe$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $dc5d1e10574edabe$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($dc5d1e10574edabe$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $dc5d1e10574edabe$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $dc5d1e10574edabe$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $dc5d1e10574edabe$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId($dc5d1e10574edabe$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $dc5d1e10574edabe$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $dc5d1e10574edabe$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $dc5d1e10574edabe$var$getIdAndStyleId($dc5d1e10574edabe$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $dc5d1e10574edabe$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $dc5d1e10574edabe$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $dc5d1e10574edabe$var$callbackWrapper((type)=>$dc5d1e10574edabe$var$throttle$1($dc5d1e10574edabe$var$callbackWrapper((event)=>{
            const target = $dc5d1e10574edabe$var$getEventTarget(event);
            if (!target || $dc5d1e10574edabe$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $dc5d1e10574edabe$var$on("play", handler(0), doc),
        $dc5d1e10574edabe$var$on("pause", handler(1), doc),
        $dc5d1e10574edabe$var$on("seeked", handler(2), doc),
        $dc5d1e10574edabe$var$on("volumechange", handler(3), doc),
        $dc5d1e10574edabe$var$on("ratechange", handler(4), doc)
    ];
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $dc5d1e10574edabe$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $dc5d1e10574edabe$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($dc5d1e10574edabe$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $dc5d1e10574edabe$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $dc5d1e10574edabe$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $dc5d1e10574edabe$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $dc5d1e10574edabe$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $dc5d1e10574edabe$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $dc5d1e10574edabe$var$on("selectionchange", updateSelection);
}
function $dc5d1e10574edabe$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $dc5d1e10574edabe$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $dc5d1e10574edabe$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $dc5d1e10574edabe$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $dc5d1e10574edabe$var$initMoveObserver(o);
    const mouseInteractionHandler = $dc5d1e10574edabe$var$initMouseInteractionObserver(o);
    const scrollHandler = $dc5d1e10574edabe$var$initScrollObserver(o);
    const viewportResizeHandler = $dc5d1e10574edabe$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $dc5d1e10574edabe$var$initInputObserver(o);
    const mediaInteractionHandler = $dc5d1e10574edabe$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $dc5d1e10574edabe$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $dc5d1e10574edabe$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $dc5d1e10574edabe$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $dc5d1e10574edabe$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $dc5d1e10574edabe$var$initSelectionObserver(o);
    const customElementObserver = $dc5d1e10574edabe$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $dc5d1e10574edabe$var$callbackWrapper(()=>{
        $dc5d1e10574edabe$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $dc5d1e10574edabe$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $dc5d1e10574edabe$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $dc5d1e10574edabe$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $dc5d1e10574edabe$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $dc5d1e10574edabe$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $dc5d1e10574edabe$var$CrossOriginIframeMirror($dc5d1e10574edabe$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $dc5d1e10574edabe$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $dc5d1e10574edabe$var$CrossOriginIframeMirror($dc5d1e10574edabe$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $dc5d1e10574edabe$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $dc5d1e10574edabe$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $dc5d1e10574edabe$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $dc5d1e10574edabe$var$EventType.Meta:
            case $dc5d1e10574edabe$var$EventType.Load:
            case $dc5d1e10574edabe$var$EventType.DomContentLoaded:
                return false;
            case $dc5d1e10574edabe$var$EventType.Plugin:
                return e;
            case $dc5d1e10574edabe$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $dc5d1e10574edabe$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $dc5d1e10574edabe$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $dc5d1e10574edabe$var$IncrementalSource.Drag:
                    case $dc5d1e10574edabe$var$IncrementalSource.TouchMove:
                    case $dc5d1e10574edabe$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $dc5d1e10574edabe$var$IncrementalSource.ViewportResize:
                        return false;
                    case $dc5d1e10574edabe$var$IncrementalSource.MediaInteraction:
                    case $dc5d1e10574edabe$var$IncrementalSource.MouseInteraction:
                    case $dc5d1e10574edabe$var$IncrementalSource.Scroll:
                    case $dc5d1e10574edabe$var$IncrementalSource.CanvasMutation:
                    case $dc5d1e10574edabe$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $dc5d1e10574edabe$var$IncrementalSource.StyleSheetRule:
                    case $dc5d1e10574edabe$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $dc5d1e10574edabe$var$IncrementalSource.Font:
                        return e;
                    case $dc5d1e10574edabe$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $dc5d1e10574edabe$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $dc5d1e10574edabe$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $dc5d1e10574edabe$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $dc5d1e10574edabe$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $dc5d1e10574edabe$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$dc5d1e10574edabe$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $dc5d1e10574edabe$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($dc5d1e10574edabe$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        setTimeout(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($dc5d1e10574edabe$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($dc5d1e10574edabe$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $dc5d1e10574edabe$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $dc5d1e10574edabe$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $dc5d1e10574edabe$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $dc5d1e10574edabe$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $dc5d1e10574edabe$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $dc5d1e10574edabe$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $dc5d1e10574edabe$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
function $dc5d1e10574edabe$var$wrapEvent(e) {
    const eWithTime = e;
    eWithTime.timestamp = $dc5d1e10574edabe$var$nowTimestamp();
    return eWithTime;
}
let $dc5d1e10574edabe$var$_takeFullSnapshot;
const $dc5d1e10574edabe$var$mirror = $dc5d1e10574edabe$var$createMirror();
function $dc5d1e10574edabe$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $dc5d1e10574edabe$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $dc5d1e10574edabe$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $dc5d1e10574edabe$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    const wrappedEmit = (e, isCheckout)=>{
        if ((0, $ab2b093b9f2f979d$export$3cc482e6b02f32f7)([
            $dc5d1e10574edabe$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $dc5d1e10574edabe$var$EventType.FullSnapshot && !(e.type === $dc5d1e10574edabe$var$EventType.IncrementalSnapshot && e.data.source === $dc5d1e10574edabe$var$IncrementalSource.Mutation)) $dc5d1e10574edabe$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $ab2b093b9f2f979d$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $dc5d1e10574edabe$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $dc5d1e10574edabe$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $dc5d1e10574edabe$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
            type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
            data: {
                source: $dc5d1e10574edabe$var$IncrementalSource.Mutation,
                ...m
            }
        }));
    };
    const wrappedScrollEmit = (p)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
            type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
            data: {
                source: $dc5d1e10574edabe$var$IncrementalSource.Scroll,
                ...p
            }
        }));
    const wrappedCanvasMutationEmit = (p)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
            type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
            data: {
                source: $dc5d1e10574edabe$var$IncrementalSource.CanvasMutation,
                ...p
            }
        }));
    const wrappedAdoptedStyleSheetEmit = (a)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
            type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
            data: {
                source: $dc5d1e10574edabe$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        }));
    const stylesheetManager = new $dc5d1e10574edabe$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $dc5d1e10574edabe$var$IframeManagerNoop() : new $dc5d1e10574edabe$var$IframeManager({
        mirror: $dc5d1e10574edabe$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $dc5d1e10574edabe$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $dc5d1e10574edabe$var$ProcessedNodeManager();
    const canvasManager = $dc5d1e10574edabe$var$_getCanvasManager(getCanvasManager, {
        mirror: $dc5d1e10574edabe$var$mirror,
        win: window,
        mutationCb: (p)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                data: {
                    source: $dc5d1e10574edabe$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            })),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $dc5d1e10574edabe$var$ShadowDomManagerNoop() : new $dc5d1e10574edabe$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $dc5d1e10574edabe$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
            type: $dc5d1e10574edabe$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $dc5d1e10574edabe$var$getWindowWidth(),
                height: $dc5d1e10574edabe$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $dc5d1e10574edabe$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $dc5d1e10574edabe$var$snapshot(document, {
            mirror: $dc5d1e10574edabe$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($dc5d1e10574edabe$var$isSerializedIframe(n, $dc5d1e10574edabe$var$mirror)) iframeManager.addIframe(n);
                if ($dc5d1e10574edabe$var$isSerializedStylesheet(n, $dc5d1e10574edabe$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($dc5d1e10574edabe$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
            type: $dc5d1e10574edabe$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $dc5d1e10574edabe$var$getWindowScroll(window)
            }
        }));
        $dc5d1e10574edabe$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $dc5d1e10574edabe$var$mirror.getId(document));
    };
    $dc5d1e10574edabe$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $dc5d1e10574edabe$var$callbackWrapper($dc5d1e10574edabe$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    })),
                inputCb: (v)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.Input,
                            ...v
                        }
                    })),
                mediaInteractionCb: (p)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    })),
                styleSheetRuleCb: (r)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    })),
                styleDeclarationCb: (r)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.Font,
                            ...p
                        }
                    })),
                selectionCb: (p)=>{
                    wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.Selection,
                            ...p
                        }
                    }));
                },
                customElementCb: (c)=>{
                    wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                        type: $dc5d1e10574edabe$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $dc5d1e10574edabe$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $dc5d1e10574edabe$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $ab2b093b9f2f979d$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                                        type: $dc5d1e10574edabe$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    }))
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($dc5d1e10574edabe$var$on("DOMContentLoaded", ()=>{
                wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                    type: $dc5d1e10574edabe$var$EventType.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($dc5d1e10574edabe$var$on("load", ()=>{
                wrappedEmit($dc5d1e10574edabe$var$wrapEvent({
                    type: $dc5d1e10574edabe$var$EventType.Load,
                    data: {}
                }));
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $dc5d1e10574edabe$var$_takeFullSnapshot = undefined;
            $dc5d1e10574edabe$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $dc5d1e10574edabe$var$takeFullSnapshot(isCheckout) {
    if (!$dc5d1e10574edabe$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $dc5d1e10574edabe$var$_takeFullSnapshot(isCheckout);
}
$dc5d1e10574edabe$var$record.mirror = $dc5d1e10574edabe$var$mirror;
$dc5d1e10574edabe$var$record.takeFullSnapshot = $dc5d1e10574edabe$var$takeFullSnapshot;
function $dc5d1e10574edabe$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $dc5d1e10574edabe$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $dc5d1e10574edabe$var$CanvasManagerNoop();
    }
}
const $dc5d1e10574edabe$var$ReplayEventTypeIncrementalSnapshot = 3;
const $dc5d1e10574edabe$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $dc5d1e10574edabe$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $dc5d1e10574edabe$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $dc5d1e10574edabe$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $dc5d1e10574edabe$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $359c7e66c2efdebe$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $dc5d1e10574edabe$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $dc5d1e10574edabe$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($dc5d1e10574edabe$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $dc5d1e10574edabe$var$getClickTargetNode(event) {
    const target = $dc5d1e10574edabe$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $dc5d1e10574edabe$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $dc5d1e10574edabe$var$getTargetNode(event) {
    if ($dc5d1e10574edabe$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $dc5d1e10574edabe$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $dc5d1e10574edabe$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $dc5d1e10574edabe$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$dc5d1e10574edabe$var$handlers) {
        $dc5d1e10574edabe$var$handlers = [];
        $dc5d1e10574edabe$var$monkeyPatchWindowOpen();
    }
    $dc5d1e10574edabe$var$handlers.push(cb);
    return ()=>{
        const pos = $dc5d1e10574edabe$var$handlers ? $dc5d1e10574edabe$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $dc5d1e10574edabe$var$handlers.splice(pos, 1);
    };
}
function $dc5d1e10574edabe$var$monkeyPatchWindowOpen() {
    (0, $2e1797501eb473e4$export$9563e054e6f787fb)($dc5d1e10574edabe$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($dc5d1e10574edabe$var$handlers) try {
                $dc5d1e10574edabe$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($dc5d1e10574edabe$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $dc5d1e10574edabe$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $dc5d1e10574edabe$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $dc5d1e10574edabe$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $dc5d1e10574edabe$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $dc5d1e10574edabe$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($dc5d1e10574edabe$var$ignoreElement(node, this._ignoreSelector) || !$dc5d1e10574edabe$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $dc5d1e10574edabe$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $dc5d1e10574edabe$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $dc5d1e10574edabe$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $dc5d1e10574edabe$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $dc5d1e10574edabe$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $dc5d1e10574edabe$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $dc5d1e10574edabe$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $dc5d1e10574edabe$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $dc5d1e10574edabe$var$ignoreElement(node, ignoreSelector) {
    if (!$dc5d1e10574edabe$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $dc5d1e10574edabe$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $dc5d1e10574edabe$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $dc5d1e10574edabe$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$dc5d1e10574edabe$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $dc5d1e10574edabe$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $dc5d1e10574edabe$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($dc5d1e10574edabe$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $dc5d1e10574edabe$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $dc5d1e10574edabe$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $dc5d1e10574edabe$var$isIncrementalEvent(event) {
    return event.type === $dc5d1e10574edabe$var$ReplayEventTypeIncrementalSnapshot;
}
function $dc5d1e10574edabe$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $dc5d1e10574edabe$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $dc5d1e10574edabe$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $dc5d1e10574edabe$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($dc5d1e10574edabe$var$NodeType || ($dc5d1e10574edabe$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $dc5d1e10574edabe$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $dc5d1e10574edabe$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($dc5d1e10574edabe$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $dc5d1e10574edabe$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $dc5d1e10574edabe$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $dc5d1e10574edabe$var$handleClick(replay.clickDetector, result, $dc5d1e10574edabe$var$getClickTargetNode(handlerData.event));
        $dc5d1e10574edabe$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $dc5d1e10574edabe$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $dc5d1e10574edabe$var$record.mirror.getId(target);
    const node = nodeId && $dc5d1e10574edabe$var$record.mirror.getNode(nodeId);
    const meta = node && $dc5d1e10574edabe$var$record.mirror.getMeta(node);
    const element = meta && $dc5d1e10574edabe$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $dc5d1e10574edabe$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $dc5d1e10574edabe$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $dc5d1e10574edabe$var$handleDom(handlerData) {
    const { target: target, message: message } = $dc5d1e10574edabe$var$getDomTarget(handlerData);
    return $dc5d1e10574edabe$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$dc5d1e10574edabe$var$getBaseDomBreadcrumb(target, message)
    });
}
function $dc5d1e10574edabe$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $dc5d1e10574edabe$var$getClickTargetNode(handlerData.event) : $dc5d1e10574edabe$var$getTargetNode(handlerData.event);
        message = (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $dc5d1e10574edabe$var$isElement(node) {
    return node.type === $dc5d1e10574edabe$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $dc5d1e10574edabe$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $dc5d1e10574edabe$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $dc5d1e10574edabe$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $dc5d1e10574edabe$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $dc5d1e10574edabe$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $8a18c3c2a11733c0$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $dc5d1e10574edabe$var$getBaseDomBreadcrumb(target, message);
    return $dc5d1e10574edabe$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $dc5d1e10574edabe$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $dc5d1e10574edabe$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $dc5d1e10574edabe$var$createResourceEntry,
    paint: $dc5d1e10574edabe$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $dc5d1e10574edabe$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $dc5d1e10574edabe$var$createPerformanceEntries(entries) {
    return entries.map($dc5d1e10574edabe$var$createPerformanceEntry).filter(Boolean);
}
function $dc5d1e10574edabe$var$createPerformanceEntry(entry) {
    if (!$dc5d1e10574edabe$var$ENTRY_TYPES[entry.entryType]) return null;
    return $dc5d1e10574edabe$var$ENTRY_TYPES[entry.entryType](entry);
}
function $dc5d1e10574edabe$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $d59dd3fae5fc220e$export$baf075a948ffc0bf) || $dc5d1e10574edabe$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $dc5d1e10574edabe$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $dc5d1e10574edabe$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $dc5d1e10574edabe$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $dc5d1e10574edabe$var$getAbsoluteTime(startTime),
        end: $dc5d1e10574edabe$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $dc5d1e10574edabe$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $dc5d1e10574edabe$var$getAbsoluteTime(startTime),
        end: $dc5d1e10574edabe$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $dc5d1e10574edabe$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $dc5d1e10574edabe$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $dc5d1e10574edabe$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $dc5d1e10574edabe$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $f01b4adf86c96a55$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $f01b4adf86c96a55$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($dc5d1e10574edabe$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $dc5d1e10574edabe$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $dc5d1e10574edabe$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $dc5d1e10574edabe$var$e() {
    const e = new Blob([
        $dc5d1e10574edabe$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $dc5d1e10574edabe$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$dc5d1e10574edabe$var$DEBUG_BUILD) return;
    (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $dc5d1e10574edabe$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $dc5d1e10574edabe$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$dc5d1e10574edabe$var$DEBUG_BUILD) return;
    (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $dc5d1e10574edabe$var$addLogBreadcrumb(message);
    }, 0);
}
function $dc5d1e10574edabe$var$addLogBreadcrumb(message) {
    (0, $fcd9e096f030e706$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $dc5d1e10574edabe$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$dc5d1e10574edabe$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $dc5d1e10574edabe$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $dc5d1e10574edabe$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $dc5d1e10574edabe$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $dc5d1e10574edabe$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $dc5d1e10574edabe$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $dc5d1e10574edabe$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $dc5d1e10574edabe$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $dc5d1e10574edabe$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $dc5d1e10574edabe$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $dc5d1e10574edabe$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $dc5d1e10574edabe$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $dc5d1e10574edabe$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $dc5d1e10574edabe$var$EventBufferArray();
        this._compression = new $dc5d1e10574edabe$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $dc5d1e10574edabe$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $dc5d1e10574edabe$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $dc5d1e10574edabe$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $dc5d1e10574edabe$var$logInfo("[Replay] Using simple buffer");
    return new $dc5d1e10574edabe$var$EventBufferArray();
}
function $dc5d1e10574edabe$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $dc5d1e10574edabe$var$_getWorkerUrl();
        if (!workerUrl) return;
        $dc5d1e10574edabe$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $dc5d1e10574edabe$var$EventBufferProxy(worker);
    } catch (error) {
        $dc5d1e10574edabe$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $dc5d1e10574edabe$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $dc5d1e10574edabe$var$e();
    return "";
}
/** If sessionStorage is available. */ function $dc5d1e10574edabe$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $dc5d1e10574edabe$var$WINDOW && !!$dc5d1e10574edabe$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $dc5d1e10574edabe$var$clearSession(replay) {
    $dc5d1e10574edabe$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $dc5d1e10574edabe$var$deleteSession() {
    if (!$dc5d1e10574edabe$var$hasSessionStorage()) return;
    try {
        $dc5d1e10574edabe$var$WINDOW.sessionStorage.removeItem($dc5d1e10574edabe$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $dc5d1e10574edabe$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $dc5d1e10574edabe$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $db1a2eab7c136bdd$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $dc5d1e10574edabe$var$saveSession(session) {
    if (!$dc5d1e10574edabe$var$hasSessionStorage()) return;
    try {
        $dc5d1e10574edabe$var$WINDOW.sessionStorage.setItem($dc5d1e10574edabe$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $dc5d1e10574edabe$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $dc5d1e10574edabe$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $dc5d1e10574edabe$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $dc5d1e10574edabe$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $dc5d1e10574edabe$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $dc5d1e10574edabe$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $dc5d1e10574edabe$var$fetchSession(traceInternals) {
    if (!$dc5d1e10574edabe$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $dc5d1e10574edabe$var$WINDOW.sessionStorage.getItem($dc5d1e10574edabe$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $dc5d1e10574edabe$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $dc5d1e10574edabe$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $dc5d1e10574edabe$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $dc5d1e10574edabe$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $dc5d1e10574edabe$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $dc5d1e10574edabe$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $dc5d1e10574edabe$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$dc5d1e10574edabe$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $dc5d1e10574edabe$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $dc5d1e10574edabe$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $dc5d1e10574edabe$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $dc5d1e10574edabe$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$dc5d1e10574edabe$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $dc5d1e10574edabe$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $dc5d1e10574edabe$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $dc5d1e10574edabe$var$isCustomEvent(event) {
    return event.type === $dc5d1e10574edabe$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $dc5d1e10574edabe$var$addEventSync(replay, event, isCheckout) {
    if (!$dc5d1e10574edabe$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $dc5d1e10574edabe$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $dc5d1e10574edabe$var$addEvent(replay, event, isCheckout) {
    if (!$dc5d1e10574edabe$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $dc5d1e10574edabe$var$_addEvent(replay, event, isCheckout);
}
async function $dc5d1e10574edabe$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $dc5d1e10574edabe$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $dc5d1e10574edabe$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $dc5d1e10574edabe$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $dc5d1e10574edabe$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $dc5d1e10574edabe$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $dc5d1e10574edabe$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $dc5d1e10574edabe$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $dc5d1e10574edabe$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $dc5d1e10574edabe$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $dc5d1e10574edabe$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $dc5d1e10574edabe$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $dc5d1e10574edabe$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $dc5d1e10574edabe$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$dc5d1e10574edabe$var$isErrorEvent(event) && !$dc5d1e10574edabe$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($dc5d1e10574edabe$var$isTransactionEvent(event)) {
            $dc5d1e10574edabe$var$handleTransactionEvent(replay, event);
            return;
        }
        $dc5d1e10574edabe$var$handleErrorEvent(replay, event);
    };
}
function $dc5d1e10574edabe$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $dc5d1e10574edabe$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $dc5d1e10574edabe$var$isBaseTransportSend() {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $dc5d1e10574edabe$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$dc5d1e10574edabe$var$isErrorEvent(event)) return;
        $dc5d1e10574edabe$var$handleHydrationError(replay, event);
    };
}
function $dc5d1e10574edabe$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $dc5d1e10574edabe$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $dc5d1e10574edabe$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $dc5d1e10574edabe$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $dc5d1e10574edabe$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $dc5d1e10574edabe$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $dc5d1e10574edabe$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $dc5d1e10574edabe$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $dc5d1e10574edabe$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $dc5d1e10574edabe$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $dc5d1e10574edabe$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($dc5d1e10574edabe$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$dc5d1e10574edabe$var$isErrorEvent(event) && !$dc5d1e10574edabe$var$isTransactionEvent(event) && !$dc5d1e10574edabe$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($dc5d1e10574edabe$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $dc5d1e10574edabe$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($dc5d1e10574edabe$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $dc5d1e10574edabe$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $dc5d1e10574edabe$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $dc5d1e10574edabe$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $dc5d1e10574edabe$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $dc5d1e10574edabe$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $dc5d1e10574edabe$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $dc5d1e10574edabe$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $dc5d1e10574edabe$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($dc5d1e10574edabe$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $2a5a3bba9b8924df$export$d92e61f5600202af)(url, (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $dc5d1e10574edabe$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($dc5d1e10574edabe$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $dc5d1e10574edabe$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $dc5d1e10574edabe$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $dc5d1e10574edabe$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $dc5d1e10574edabe$var$handleFetch(handlerData);
        $dc5d1e10574edabe$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $dc5d1e10574edabe$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $9602c7b10ae772dd$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $dc5d1e10574edabe$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $dc5d1e10574edabe$var$handleXhr(handlerData);
        $dc5d1e10574edabe$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $dc5d1e10574edabe$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $dc5d1e10574edabe$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $dc5d1e10574edabe$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $dc5d1e10574edabe$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $dc5d1e10574edabe$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $dc5d1e10574edabe$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $dc5d1e10574edabe$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $2e1797501eb473e4$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $dc5d1e10574edabe$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $dc5d1e10574edabe$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $dc5d1e10574edabe$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $dc5d1e10574edabe$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $dc5d1e10574edabe$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $dc5d1e10574edabe$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $dc5d1e10574edabe$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $dc5d1e10574edabe$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $dc5d1e10574edabe$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $dc5d1e10574edabe$var$urlMatches(url, urls) {
    const fullUrl = $dc5d1e10574edabe$var$getFullUrl(url);
    return (0, $0f4ffa1af5d1985d$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $dc5d1e10574edabe$var$getFullUrl(url, baseURI = $dc5d1e10574edabe$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($dc5d1e10574edabe$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $dc5d1e10574edabe$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $dc5d1e10574edabe$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $dc5d1e10574edabe$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $dc5d1e10574edabe$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $dc5d1e10574edabe$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $dc5d1e10574edabe$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $dc5d1e10574edabe$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $dc5d1e10574edabe$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $dc5d1e10574edabe$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $dc5d1e10574edabe$var$urlMatches(url, options.networkDetailAllowUrls) && !$dc5d1e10574edabe$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $dc5d1e10574edabe$var$_getRequestInfo(options, hint.input, requestBodySize) : $dc5d1e10574edabe$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $dc5d1e10574edabe$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $dc5d1e10574edabe$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $dc5d1e10574edabe$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $dc5d1e10574edabe$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $dc5d1e10574edabe$var$getBodyString(requestBody);
    const data = $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $dc5d1e10574edabe$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $dc5d1e10574edabe$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $dc5d1e10574edabe$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $dc5d1e10574edabe$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $dc5d1e10574edabe$var$_parseFetchResponseBody(response);
    const result = $dc5d1e10574edabe$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $dc5d1e10574edabe$var$mergeWarning(result, warning);
    return result;
}
function $dc5d1e10574edabe$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $dc5d1e10574edabe$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $dc5d1e10574edabe$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $dc5d1e10574edabe$var$_parseFetchResponseBody(response) {
    const res = $dc5d1e10574edabe$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $dc5d1e10574edabe$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $dc5d1e10574edabe$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $dc5d1e10574edabe$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $dc5d1e10574edabe$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $dc5d1e10574edabe$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $dc5d1e10574edabe$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $dc5d1e10574edabe$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $dc5d1e10574edabe$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $dc5d1e10574edabe$var$getAllowedHeaders(headers, allowedHeaders);
}
function $dc5d1e10574edabe$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $dc5d1e10574edabe$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $dc5d1e10574edabe$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $dc5d1e10574edabe$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $dc5d1e10574edabe$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $dc5d1e10574edabe$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $dc5d1e10574edabe$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $dc5d1e10574edabe$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $dc5d1e10574edabe$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $dc5d1e10574edabe$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $dc5d1e10574edabe$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $dc5d1e10574edabe$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $dc5d1e10574edabe$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$dc5d1e10574edabe$var$urlMatches(url, options.networkDetailAllowUrls) || $dc5d1e10574edabe$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $dc5d1e10574edabe$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $dc5d1e10574edabe$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $9602c7b10ae772dd$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $dc5d1e10574edabe$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $dc5d1e10574edabe$var$getAllowedHeaders($dc5d1e10574edabe$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $dc5d1e10574edabe$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $dc5d1e10574edabe$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $dc5d1e10574edabe$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $dc5d1e10574edabe$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $dc5d1e10574edabe$var$mergeWarning(response, responseWarning) : response
    };
}
function $dc5d1e10574edabe$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $dc5d1e10574edabe$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $dc5d1e10574edabe$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $dc5d1e10574edabe$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $dc5d1e10574edabe$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $dc5d1e10574edabe$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $dc5d1e10574edabe$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$dc5d1e10574edabe$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $5e15774c4f1380e3$export$f75d3c772c923df0)($dc5d1e10574edabe$var$handleFetchSpanListener(replay));
            (0, $9602c7b10ae772dd$export$26ace48dd54c9aea)($dc5d1e10574edabe$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $dc5d1e10574edabe$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($dc5d1e10574edabe$var$_isXhrBreadcrumb(breadcrumb) && $dc5d1e10574edabe$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $dc5d1e10574edabe$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $dc5d1e10574edabe$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($dc5d1e10574edabe$var$_isFetchBreadcrumb(breadcrumb) && $dc5d1e10574edabe$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $dc5d1e10574edabe$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $dc5d1e10574edabe$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $dc5d1e10574edabe$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $dc5d1e10574edabe$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $dc5d1e10574edabe$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $dc5d1e10574edabe$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $dc5d1e10574edabe$var$_LAST_BREADCRUMB = null;
function $dc5d1e10574edabe$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $dc5d1e10574edabe$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $dc5d1e10574edabe$var$handleScope(scope);
        if (!result) return;
        $dc5d1e10574edabe$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $dc5d1e10574edabe$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($dc5d1e10574edabe$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $dc5d1e10574edabe$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$dc5d1e10574edabe$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $dc5d1e10574edabe$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $dc5d1e10574edabe$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $dc5d1e10574edabe$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $dc5d1e10574edabe$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $dc5d1e10574edabe$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $dc5d1e10574edabe$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $359c7e66c2efdebe$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $dc5d1e10574edabe$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $dc5d1e10574edabe$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $dc5d1e10574edabe$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $dc5d1e10574edabe$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    scope.addScopeListener($dc5d1e10574edabe$var$handleScopeListener(replay));
    (0, $bb8d3a92c0cd05d8$export$5aeffd3db2cf9df7)($dc5d1e10574edabe$var$handleDomListener(replay));
    (0, $ff311393fc83ca4e$export$3f18c56c58114e75)($dc5d1e10574edabe$var$handleHistorySpanListener(replay));
    $dc5d1e10574edabe$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $dc5d1e10574edabe$var$handleGlobalEventListener(replay, !$dc5d1e10574edabe$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $347ebfbf3d071625$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($dc5d1e10574edabe$var$hasHooks(client)) {
        client.on("beforeSendEvent", $dc5d1e10574edabe$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $dc5d1e10574edabe$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dc5d1e10574edabe$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $dc5d1e10574edabe$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($dc5d1e10574edabe$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $dc5d1e10574edabe$var$createMemoryEntry($dc5d1e10574edabe$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $dc5d1e10574edabe$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $dc5d1e10574edabe$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $dc5d1e10574edabe$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $dc5d1e10574edabe$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$dc5d1e10574edabe$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $dc5d1e10574edabe$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $dc5d1e10574edabe$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $dc5d1e10574edabe$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $dc5d1e10574edabe$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $dc5d1e10574edabe$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $dc5d1e10574edabe$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $dc5d1e10574edabe$var$addEventSync(replay, $dc5d1e10574edabe$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $dc5d1e10574edabe$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $6d356316fc42ead6$export$f93f7f385160c44e)((0, $6d356316fc42ead6$export$92b6093782fe661b)(replayEvent, (0, $6d356316fc42ead6$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $dc5d1e10574edabe$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $dc5d1e10574edabe$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $9fd9d491325e9f58$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $805d0d6bf1179169$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $dc5d1e10574edabe$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $dc5d1e10574edabe$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    const scope = (0, $fcd9e096f030e706$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $dc5d1e10574edabe$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $dc5d1e10574edabe$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $dc5d1e10574edabe$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $dc5d1e10574edabe$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($dc5d1e10574edabe$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $dc5d1e10574edabe$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $e6f6c6c07bc0bbc4$export$699aff705e0d49d4)({}, response);
    if ((0, $e6f6c6c07bc0bbc4$export$6c91fec22056810a)(rateLimits, "replay")) throw new $dc5d1e10574edabe$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $dc5d1e10574edabe$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $dc5d1e10574edabe$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $dc5d1e10574edabe$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $dc5d1e10574edabe$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $dc5d1e10574edabe$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $dc5d1e10574edabe$var$TransportStatusCodeError || err instanceof $dc5d1e10574edabe$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $fcd9e096f030e706$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($dc5d1e10574edabe$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $fcd9e096f030e706$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $dc5d1e10574edabe$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$dc5d1e10574edabe$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $dc5d1e10574edabe$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $dc5d1e10574edabe$var$THROTTLED = "__THROTTLED";
const $dc5d1e10574edabe$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dc5d1e10574edabe$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $dc5d1e10574edabe$var$SKIPPED : $dc5d1e10574edabe$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $dc5d1e10574edabe$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $dc5d1e10574edabe$var$ReplayContainer.prototype.__init.call(this);
        $dc5d1e10574edabe$var$ReplayContainer.prototype.__init2.call(this);
        $dc5d1e10574edabe$var$ReplayContainer.prototype.__init3.call(this);
        $dc5d1e10574edabe$var$ReplayContainer.prototype.__init4.call(this);
        $dc5d1e10574edabe$var$ReplayContainer.prototype.__init5.call(this);
        $dc5d1e10574edabe$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $dc5d1e10574edabe$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $dc5d1e10574edabe$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $dc5d1e10574edabe$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $dc5d1e10574edabe$var$throttle((event, isCheckout)=>$dc5d1e10574edabe$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($dc5d1e10574edabe$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $dc5d1e10574edabe$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $dc5d1e10574edabe$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $dc5d1e10574edabe$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $dc5d1e10574edabe$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        const session = $dc5d1e10574edabe$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $dc5d1e10574edabe$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $dc5d1e10574edabe$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $dc5d1e10574edabe$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $dc5d1e10574edabe$var$BUFFER_CHECKOUT_TIME
                },
                emit: $dc5d1e10574edabe$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $dc5d1e10574edabe$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $dc5d1e10574edabe$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $dc5d1e10574edabe$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $dc5d1e10574edabe$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $dc5d1e10574edabe$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $dc5d1e10574edabe$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$dc5d1e10574edabe$var$WINDOW.location.pathname}${$dc5d1e10574edabe$var$WINDOW.location.hash}${$dc5d1e10574edabe$var$WINDOW.location.search}`;
        const url = `${$dc5d1e10574edabe$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $dc5d1e10574edabe$var$THROTTLED) {
            const breadcrumb = $dc5d1e10574edabe$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$dc5d1e10574edabe$var$addEventSync(this, {
                    type: $dc5d1e10574edabe$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $fcd9e096f030e706$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $b2c76ea57c95e097$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $dc5d1e10574edabe$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay]", error);
        if ($dc5d1e10574edabe$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $fcd9e096f030e706$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $dc5d1e10574edabe$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($dc5d1e10574edabe$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $dc5d1e10574edabe$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $dc5d1e10574edabe$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $dc5d1e10574edabe$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $dc5d1e10574edabe$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $dc5d1e10574edabe$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $dc5d1e10574edabe$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $dc5d1e10574edabe$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $dc5d1e10574edabe$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $dc5d1e10574edabe$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $dc5d1e10574edabe$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($dc5d1e10574edabe$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $dc5d1e10574edabe$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $dc5d1e10574edabe$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $dc5d1e10574edabe$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $dc5d1e10574edabe$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $dc5d1e10574edabe$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $dc5d1e10574edabe$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $dc5d1e10574edabe$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($dc5d1e10574edabe$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $dc5d1e10574edabe$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $dc5d1e10574edabe$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $dc5d1e10574edabe$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $dc5d1e10574edabe$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $dc5d1e10574edabe$var$DEBUG_BUILD && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $dc5d1e10574edabe$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $dc5d1e10574edabe$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $dc5d1e10574edabe$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $3c4d30f0d3028b15$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $dc5d1e10574edabe$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $dc5d1e10574edabe$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $dc5d1e10574edabe$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $dc5d1e10574edabe$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $dc5d1e10574edabe$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $dc5d1e10574edabe$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $dc5d1e10574edabe$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $dc5d1e10574edabe$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $dc5d1e10574edabe$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $dc5d1e10574edabe$var$_initialized = false;
const $dc5d1e10574edabe$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $dc5d1e10574edabe$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $dc5d1e10574edabe$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $dc5d1e10574edabe$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $dc5d1e10574edabe$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $dc5d1e10574edabe$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $dc5d1e10574edabe$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $dc5d1e10574edabe$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $dc5d1e10574edabe$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$dc5d1e10574edabe$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $dc5d1e10574edabe$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $dc5d1e10574edabe$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $dc5d1e10574edabe$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $dc5d1e10574edabe$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $dc5d1e10574edabe$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$dc5d1e10574edabe$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $19a7a09b8ec81f15$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $dc5d1e10574edabe$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $dc5d1e10574edabe$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $19a7a09b8ec81f15$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $dc5d1e10574edabe$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $dc5d1e10574edabe$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$dc5d1e10574edabe$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $dc5d1e10574edabe$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $2e1797501eb473e4$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $3c4d30f0d3028b15$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $3c4d30f0d3028b15$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $dc5d1e10574edabe$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$dc5d1e10574edabe$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $dc5d1e10574edabe$export$81cc0d0f72285d1() {
    const client = (0, $fcd9e096f030e706$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $dc5d1e10574edabe$export$b28310b2f161456b = $dc5d1e10574edabe$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $dc5d1e10574edabe$export$d7706faf7ab354bf = $dc5d1e10574edabe$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $dc5d1e10574edabe$export$a35c789ed37ee0f7 extends $dc5d1e10574edabe$export$6b59b88de1ff9cb7 {
}









let $f84ca6d6766c17f4$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).Sentry && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).Sentry.Integrations) $f84ca6d6766c17f4$var$windowIntegrations = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $f84ca6d6766c17f4$export$99d02219d259eb94 = {
    ...$f84ca6d6766c17f4$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $787cdcef57f3a775$export$99d02219d259eb94),
    ...$1af1b4024ed5c8b1$exports
};





var $8FL51 = parcelRequire("8FL51");

var $2hDQc = parcelRequire("2hDQc");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $df779fd32582ae5d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $107f2e93047e221d$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $107f2e93047e221d$var$activeTransaction;
let $107f2e93047e221d$var$_useEffect;
let $107f2e93047e221d$var$_useLocation;
let $107f2e93047e221d$var$_useNavigationType;
let $107f2e93047e221d$var$_createRoutesFromChildren;
let $107f2e93047e221d$var$_matchRoutes;
let $107f2e93047e221d$var$_customStartTransaction;
let $107f2e93047e221d$var$_startTransactionOnLocationChange;
let $107f2e93047e221d$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $107f2e93047e221d$export$47113a480541ff59(options) {
    const integration = (0, $c6555bd6d4dc8811$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $c6555bd6d4dc8811$export$7d159749bd9969ad)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81) && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $c6555bd6d4dc8811$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $b2c76ea57c95e097$export$d7a7d984b0791405)]: "url",
                    [(0, $b2c76ea57c95e097$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $b2c76ea57c95e097$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $107f2e93047e221d$var$_useEffect = useEffect;
            $107f2e93047e221d$var$_useLocation = useLocation;
            $107f2e93047e221d$var$_useNavigationType = useNavigationType;
            $107f2e93047e221d$var$_matchRoutes = matchRoutes;
            $107f2e93047e221d$var$_createRoutesFromChildren = createRoutesFromChildren;
            $107f2e93047e221d$var$_stripBasename = stripBasename || false;
            $107f2e93047e221d$var$_customStartTransaction = startNavigationCallback;
            $107f2e93047e221d$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $107f2e93047e221d$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81) && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location && (0, $9bbc107c45381d5c$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $107f2e93047e221d$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $b2c76ea57c95e097$export$d7a7d984b0791405)]: "url",
                [(0, $b2c76ea57c95e097$export$1a413bd9a88fdb09)]: "pageload",
                [(0, $b2c76ea57c95e097$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $107f2e93047e221d$var$_useEffect = useEffect;
        $107f2e93047e221d$var$_useLocation = useLocation;
        $107f2e93047e221d$var$_useNavigationType = useNavigationType;
        $107f2e93047e221d$var$_matchRoutes = matchRoutes;
        $107f2e93047e221d$var$_createRoutesFromChildren = createRoutesFromChildren;
        $107f2e93047e221d$var$_stripBasename = stripBasename || false;
        $107f2e93047e221d$var$_customStartTransaction = customStartTransaction;
        $107f2e93047e221d$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $107f2e93047e221d$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $107f2e93047e221d$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $107f2e93047e221d$var$_stripBasename ? $107f2e93047e221d$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $107f2e93047e221d$var$_stripBasename ? $107f2e93047e221d$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $6349c7ce4c999262$export$69dd85280a8d374c)(pathBuilder) !== (0, $6349c7ce4c999262$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($107f2e93047e221d$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($107f2e93047e221d$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $107f2e93047e221d$var$_stripBasename ? $107f2e93047e221d$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $107f2e93047e221d$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $107f2e93047e221d$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $107f2e93047e221d$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $b2c76ea57c95e097$export$d7a7d984b0791405), source);
    }
}
function $107f2e93047e221d$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $107f2e93047e221d$var$_matchRoutes(routes, location, basename);
    if ($107f2e93047e221d$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($107f2e93047e221d$var$activeTransaction) $107f2e93047e221d$var$activeTransaction.end();
        const [name, source] = $107f2e93047e221d$var$getNormalizedName(routes, location, branches, basename);
        $107f2e93047e221d$var$activeTransaction = $107f2e93047e221d$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $b2c76ea57c95e097$export$d7a7d984b0791405)]: source,
                [(0, $b2c76ea57c95e097$export$1a413bd9a88fdb09)]: "navigation",
                [(0, $b2c76ea57c95e097$export$cca8dd30f57f805e)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $107f2e93047e221d$export$c6111e8561a02a8b(Routes) {
    if (!$107f2e93047e221d$var$_useEffect || !$107f2e93047e221d$var$_useLocation || !$107f2e93047e221d$var$_useNavigationType || !$107f2e93047e221d$var$_createRoutesFromChildren || !$107f2e93047e221d$var$_matchRoutes || !$107f2e93047e221d$var$_customStartTransaction) {
        (0, $df779fd32582ae5d$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$107f2e93047e221d$var$_useEffect}. useLocation: ${$107f2e93047e221d$var$_useLocation}. useNavigationType: ${$107f2e93047e221d$var$_useNavigationType}.
      createRoutesFromChildren: ${$107f2e93047e221d$var$_createRoutesFromChildren}. matchRoutes: ${$107f2e93047e221d$var$_matchRoutes}. customStartTransaction: ${$107f2e93047e221d$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $107f2e93047e221d$var$_useLocation();
        const navigationType = $107f2e93047e221d$var$_useNavigationType();
        $107f2e93047e221d$var$_useEffect(()=>{
            const routes = $107f2e93047e221d$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $107f2e93047e221d$var$updatePageloadTransaction($107f2e93047e221d$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $107f2e93047e221d$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $2hDQc.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $107f2e93047e221d$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8FL51)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $107f2e93047e221d$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$107f2e93047e221d$var$_useEffect || !$107f2e93047e221d$var$_useLocation || !$107f2e93047e221d$var$_useNavigationType || !$107f2e93047e221d$var$_matchRoutes || !$107f2e93047e221d$var$_customStartTransaction) {
        (0, $df779fd32582ae5d$export$16a28057038b10ef) && (0, $3c4d30f0d3028b15$export$af88d00dbe7f521).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $107f2e93047e221d$var$_useLocation();
        const navigationType = $107f2e93047e221d$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $107f2e93047e221d$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $107f2e93047e221d$var$updatePageloadTransaction($107f2e93047e221d$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $107f2e93047e221d$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $2hDQc.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $107f2e93047e221d$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $107f2e93047e221d$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $107f2e93047e221d$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $107f2e93047e221d$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($107f2e93047e221d$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $107f2e93047e221d$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $107f2e93047e221d$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($107f2e93047e221d$var$activeTransaction) return $107f2e93047e221d$var$activeTransaction;
    const span = (0, $c1ff268be949f613$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $de80b4d78df58fd4$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $d07da62ed3ec9e2d$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}




var $2hDQc = parcelRequire("2hDQc");

var $d8c7a2882f726c0c$export$2e2bcd8739ae039 = ()=>{
    $9a9220b1bc59c4f2$export$2cd8252107eb640b({
        dsn: (0, $87c980b245bbb7d9$export$6faa4a850bc4d0ce),
        environment: (0, $87c980b245bbb7d9$export$be46596bc6608f3b),
        debug: (0, $87c980b245bbb7d9$export$e987ec915f285263),
        release: (0, $87c980b245bbb7d9$export$d2c893bfac1da9a1),
        integrations: [
            // See docs for support of different versions of variation of react router
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            $107f2e93047e221d$export$47113a480541ff59({
                useEffect: (0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).useEffect,
                useLocation: $86f6846c59d1b386$export$45d76561a5302f2b,
                useNavigationType: $86f6846c59d1b386$export$1b3f31771c5d07c,
                createRoutesFromChildren: $86f6846c59d1b386$export$16da398f5434bdec,
                matchRoutes: $df0c76e4858f6b9a$export$2708184779ceb39d
            }),
            $dc5d1e10574edabe$export$2832a2ae028f5e28({
                // Default values, but makes it explicit for privacy reasons
                maskAllText: true,
                maskAllInputs: true,
                blockAllMedia: true
            })
        ],
        tracesSampleRate: (0, $87c980b245bbb7d9$export$934e799b0e87def5),
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: (0, $87c980b245bbb7d9$export$6229fa3b56a23727),
        // Setting these will enable the replay feature.
        // By default, all user input and text is masked with * and all media is blocked for privacy reasons
        replaysSessionSampleRate: (0, $87c980b245bbb7d9$export$d991ba28bdd15482),
        replaysOnErrorSampleRate: (0, $87c980b245bbb7d9$export$6d698ff2c1f4a0ca)
    });
};


if (0, $87c980b245bbb7d9$export$6faa4a850bc4d0ce) (0, $d8c7a2882f726c0c$export$2e2bcd8739ae039)();
(0, $730e5f1eab7dc7cb$export$11ac3725994bec7b).configure({
    Auth: {
        Cognito: {
            userPoolId: (0, $87c980b245bbb7d9$export$51eee90b2075d4e1),
            userPoolClientId: (0, $87c980b245bbb7d9$export$1c5434afbe5b51),
            loginWith: {
                email: true
            }
        }
    }
});
const $d0bb92445f8cf837$var$root = (0, $c8a87c2a515c97a7$export$882461b6382ed46c)(document.getElementById("root"));
if ((0, $87c980b245bbb7d9$export$be46596bc6608f3b) === "production" && (0, $87c980b245bbb7d9$export$c1914de753539b0b)) (0, $02dc3fa6e24fa522$export$2e2bcd8739ae039)((0, $87c980b245bbb7d9$export$c1914de753539b0b));
$d0bb92445f8cf837$var$root.render(/*#__PURE__*/ (0, $592Nh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hDQc))).StrictMode, {
    children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $131666d86e3b9233$export$2e2bcd8739ae039), {
        store: (0, $cd504686f3a003b4$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $592Nh.jsx)((0, $cc9d09a6f2edbadb$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.9ef4fc44.js.map
